/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			modules[moduleId] = moreModules[moduleId];
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		1:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + ".bundle." + "c7376181024b4c467384" + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(299);
	__webpack_require__(302);
	__webpack_require__(372);
	__webpack_require__(374);
	__webpack_require__(376);
	__webpack_require__(378);
	__webpack_require__(380);
	__webpack_require__(382);
	__webpack_require__(384);
	__webpack_require__(388);
	__webpack_require__(391);
	__webpack_require__(393);
	__webpack_require__(395);
	module.exports = __webpack_require__(396);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(300);
	module.exports = angular;


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/**
	 * @license AngularJS v1.6.1
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * Angular. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace') . Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	  return function() {
	    var SKIP_INDEXES = 2;
	
	    var templateArgs = arguments,
	      code = templateArgs[0],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      template = templateArgs[1],
	      paramPrefix, i;
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1),
	        shiftedIndex = index + SKIP_INDEXES;
	
	      if (shiftedIndex < templateArgs.length) {
	        return toDebugString(templateArgs[shiftedIndex]);
	      }
	
	      return match;
	    });
	
	    message += '\nhttp://errors.angularjs.org/1.6.1/' +
	      (module ? module + '/' : '') + code;
	
	    for (i = SKIP_INDEXES, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	      message += paramPrefix + 'p' + (i - SKIP_INDEXES) + '=' +
	        encodeURIComponent(toDebugString(templateArgs[i]));
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell ESLint what variables are being exported */
	/* exported
	  angular,
	  msie,
	  jqLite,
	  jQuery,
	  slice,
	  splice,
	  push,
	  toString,
	  ngMinErr,
	  angularModule,
	  uid,
	  REGEX_STRING_REGEXP,
	  VALIDITY_STATE_PROPERTY,
	
	  lowercase,
	  uppercase,
	  manualLowercase,
	  manualUppercase,
	  nodeName_,
	  isArrayLike,
	  forEach,
	  forEachSorted,
	  reverseParams,
	  nextUid,
	  setHashKey,
	  extend,
	  toInt,
	  inherit,
	  merge,
	  noop,
	  identity,
	  valueFn,
	  isUndefined,
	  isDefined,
	  isObject,
	  isBlankObject,
	  isString,
	  isNumber,
	  isNumberNaN,
	  isDate,
	  isArray,
	  isFunction,
	  isRegExp,
	  isWindow,
	  isScope,
	  isFile,
	  isFormData,
	  isBlob,
	  isBoolean,
	  isPromiseLike,
	  trim,
	  escapeForRegexp,
	  isElement,
	  makeMap,
	  includes,
	  arrayRemove,
	  copy,
	  equals,
	  csp,
	  jq,
	  concat,
	  sliceArgs,
	  bind,
	  toJsonReplacer,
	  toJson,
	  fromJson,
	  convertTimezoneToLocal,
	  timezoneToOffset,
	  startingTag,
	  tryDecodeURIComponent,
	  parseKeyValue,
	  toKeyValue,
	  encodeUriSegment,
	  encodeUriQuery,
	  angularInit,
	  bootstrap,
	  getTestability,
	  snake_case,
	  bindJQuery,
	  assertArg,
	  assertArgFn,
	  assertNotHasOwnProperty,
	  getter,
	  getBlockNodes,
	  hasOwnProperty,
	  createMap,
	  stringify,
	
	  NODE_TYPE_ELEMENT,
	  NODE_TYPE_ATTRIBUTE,
	  NODE_TYPE_TEXT,
	  NODE_TYPE_COMMENT,
	  NODE_TYPE_DOCUMENT,
	  NODE_TYPE_DOCUMENT_FRAGMENT
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * # ng (core module)
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 * <div doc-module-components="ng"></div>
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * @ngdoc function
	 * @name angular.lowercase
	 * @module ng
	 * @kind function
	 *
	 * @deprecated
	 * sinceVersion="1.5.0"
	 * removeVersion="1.7.0"
	 * Use [String.prototype.toLowerCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toLowerCase) instead.
	 *
	 * @description Converts the specified string to lowercase.
	 * @param {string} string String to be converted to lowercase.
	 * @returns {string} Lowercased string.
	 */
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	
	/**
	 * @ngdoc function
	 * @name angular.uppercase
	 * @module ng
	 * @kind function
	 *
	 * @deprecated
	 * sinceVersion="1.5.0"
	 * removeVersion="1.7.0"
	 * Use [String.prototype.toUpperCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toUpperCase) instead.
	 *
	 * @description Converts the specified string to uppercase.
	 * @param {string} string String to be converted to uppercase.
	 * @returns {string} Uppercased string.
	 */
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var manualLowercase = function(s) {
	  /* eslint-disable no-bitwise */
	  return isString(s)
	      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
	      : s;
	  /* eslint-enable */
	};
	var manualUppercase = function(s) {
	  /* eslint-disable no-bitwise */
	  return isString(s)
	      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
	      : s;
	  /* eslint-enable */
	};
	
	
	// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
	// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
	// with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
	if ('i' !== 'I'.toLowerCase()) {
	  lowercase = manualLowercase;
	  uppercase = manualUppercase;
	}
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	// Support: IE 9-11 only
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = 'length' in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) &&
	    (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item === 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	          baseExtend(dst[key], [src], true);
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
	  // eslint-disable-next-line no-self-compare
	  return num !== num;
	};
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`. Alias of Array.isArray.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	var isArray = Array.isArray;
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s
	    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
	    // eslint-disable-next-line no-control-regex
	    .replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) !== -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array.
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to `destination` an exception will be thrown.
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
	 *   and on `destination`) will be ignored.
	 * </div>
	 *
	 * @param {*} source The source that will be used to make a copy.
	 *                   Can be any type, including primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If
	 *     provided, must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	  <example module="copyExample" name="angular-copy">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate class="simple-form">
	          <label>Name: <input type="text" ng-model="user.name" /></label><br />
	          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
	          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
	                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
	          <button ng-click="reset()">RESET</button>
	          <button ng-click="update(user)">SAVE</button>
	        </form>
	        <pre>form = {{user | json}}</pre>
	        <pre>master = {{master | json}}</pre>
	      </div>
	    </file>
	    <file name="script.js">
	      // Module: copyExample
	      angular.
	        module('copyExample', []).
	        controller('ExampleController', ['$scope', function($scope) {
	          $scope.master = {};
	
	          $scope.reset = function() {
	            // Example with 1 argument
	            $scope.user = angular.copy($scope.master);
	          };
	
	          $scope.update = function(user) {
	            // Example with 2 arguments
	            angular.copy(user, $scope.master);
	          };
	
	          $scope.reset();
	        }]);
	    </file>
	  </example>
	 */
	function copy(source, destination) {
	  var stackSource = [];
	  var stackDest = [];
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination);
	  }
	
	  return copyElement(source);
	
	  function copyRecurse(source, destination) {
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i]));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key]);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key]);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key]);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
	
	      case '[object ArrayBuffer]':
	        // Support: IE10
	        if (!source.slice) {
	          // If we're in this case we know the environment supports ArrayBuffer
	          /* eslint-disable no-undef */
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          /* eslint-enable */
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  // eslint-disable-next-line no-self-compare
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 === t2 && t1 === 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) === o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return equals(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() === o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      // eslint-disable-next-line no-new, no-new-func
	      new Function('');
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since angular looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
	    if (el) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since angular uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // Support: IE 9-11 only, Edge 13-14+
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone();
	  try {
	    // turns out IE does not let you set .html() on elements which
	    // are not allowed to have children. So we just ignore it.
	    element.empty();
	  } catch (e) { /* empty */ }
	  var elemHtml = jqLite('<div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || '').split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query         = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	function allowAutoBootstrap(document) {
	  if (!document.currentScript) {
	    return true;
	  }
	  var src = document.currentScript.getAttribute('src');
	  var link = document.createElement('a');
	  link.href = src;
	  if (document.location.origin === link.origin) {
	    // Same-origin resources are always allowed, even for non-whitelisted schemes.
	    return true;
	  }
	  // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
	  // This is to prevent angular.js bundled with browser extensions from being used to bypass the
	  // content security policy in web pages and other browser extensions.
	  switch (link.protocol) {
	    case 'http:':
	    case 'https:':
	    case 'ftp:':
	    case 'blob:':
	    case 'file:':
	    case 'data:':
	      return true;
	    default:
	      return false;
	  }
	}
	
	// Cached as it has to run during loading so that document.currentScript is available.
	var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo" name="ng-app">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true" name="strict-di">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = 'World';
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    if (!isAutoBootstrapAllowed) {
	      window.console.error('Angular: disabling automatic bootstrap. <script> protocol indicates ' +
	          'an extension, document.location.href does not match.');
	      return;
	    }
	    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up angular application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * Angular will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of Angular try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          'App already bootstrapped with this element \'{0}\'',
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of Angular on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? __webpack_provided_window_dot_jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: JQLitePrototype.controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	
	    // All nodes removed from the DOM via various jQuery APIs like .remove()
	    // are passed through jQuery.cleanData. Monkey-patch this method to fire
	    // the $destroy event on all removed nodes.
	    originalCleanData = jQuery.cleanData;
	    jQuery.cleanData = function(elems) {
	      var events;
	      for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	        events = jQuery._data(elem, 'events');
	        if (events && events.$destroy) {
	          jQuery(elem).triggerHandler('$destroy');
	        }
	      }
	      originalCleanData(elems);
	    };
	  } else {
	    jqLite = JQLite;
	  }
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	function stringify(value) {
	  if (value == null) { // null || undefined
	    return '';
	  }
	  switch (typeof value) {
	    case 'string':
	      break;
	    case 'number':
	      value = '' + value;
	      break;
	    default:
	      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
	        value = value.toString();
	      } else {
	        value = toJson(value);
	      }
	  }
	
	  return value;
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring angular {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving Angular
	     * modules.
	     * All modules (angular core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
	             'the module name or forgot to load it. If registering a module ensure that you ' +
	             'specify the dependencies as the second argument.', name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid angular expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to register work which needs to be performed on module loading.
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method, queue) {
	          if (!queue) queue = invokeQueue;
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            queue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* global toDebugString: true */
	
	function serializeObject(obj) {
	  var seen = [];
	
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  inputDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $$IsDocumentHiddenProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $IntervalProvider,
	  $$HashMapProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $jsonpCallbacksProvider,
	  $LocationProvider,
	  $LogProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  // These placeholder strings will be replaced by grunt's `build` task.
	  // They need to be double- or single-quoted.
	  full: '1.6.1',
	  major: 1,
	  minor: 6,
	  dot: 1,
	  codeName: 'promise-rectification'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'lowercase': lowercase,
	    'uppercase': uppercase,
	    'callbacks': {$$counter: 0},
	    'getTestability': getTestability,
	    'reloadWithDebugInfo': reloadWithDebugInfo,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    '$$encodeUriSegment': encodeUriSegment,
	    '$$encodeUriQuery': encodeUriQuery,
	    '$$stringify': stringify
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $$isDocumentHidden: $$IsDocumentHiddenProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $jsonpCallbacks: $jsonpCallbacksProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$HashMap: $$HashMapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ]);
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global
	  JQLitePrototype: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * Angular to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in Angular are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## Angular's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/)
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
	 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * ## jQuery/jqLite Extras
	 * Angular also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1;
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
	var MS_HACK_REGEXP = /^-ms-/;
	var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts kebab-case to camelCase.
	 * There is also a special case for the ms prefix starting with a lowercase letter.
	 * @param name Name to normalize
	 */
	function cssKebabToCamel(name) {
	    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
	}
	
	function fnCamelCaseReplace(all, letter) {
	  return letter.toUpperCase();
	}
	
	/**
	 * Converts kebab-case to camelCase.
	 * @param name Name to normalize
	 */
	function kebabToCamel(name) {
	  return name
	    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	var wrapMap = {
	  'option': [1, '<select multiple="multiple">', '</select>'],
	
	  'thead': [1, '<table>', '</table>'],
	  'col': [2, '<table><colgroup>', '</colgroup></table>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
	  '_default': [0, '', '']
	};
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteCleanData(nodes) {
	  for (var i = 0, ii = nodes.length; i < ii; i++) {
	    jqLiteRemoveData(nodes[i]);
	  }
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = fragment.appendChild(context.createElement('div'));
	    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
	    wrap = wrapMap[tag] || wrapMap._default;
	    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, '<$1></$2>') + wrap[2];
	
	    // Descend through wrappers to the right content
	    i = wrap[0];
	    while (i--) {
	      tmp = tmp.lastChild;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = '';
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = '';
	  fragment.innerHTML = ''; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
	  // eslint-disable-next-line no-bitwise
	  return !!(this.compareDocumentPosition(arg) & 16);
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) !== '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else if (isFunction(element)) {
	    jqLiteReady(element);
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants) jqLiteRemoveData(element);
	
	  if (element.querySelectorAll) {
	    var descendants = element.querySelectorAll('*');
	    for (var i = 0, l = descendants.length; i < l; i++) {
	      jqLiteRemoveData(descendants[i]);
	    }
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        element.removeEventListener(type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        element.removeEventListener(type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	      return;
	    }
	
	    if (expandoStore.handle) {
	      if (expandoStore.events.$destroy) {
	        expandoStore.handle({}, '$destroy');
	      }
	      jqLiteOff(element);
	    }
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	    var prop;
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[kebabToCamel(key)] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[kebabToCamel(key)];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          for (prop in key) {
	            data[kebabToCamel(prop)] = key[prop];
	          }
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
	      indexOf(' ' + selector + ' ') > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    forEach(cssClasses.split(' '), function(cssClass) {
	      element.setAttribute('class', trim(
	          (' ' + (element.getAttribute('class') || '') + ' ')
	          .replace(/[\n\t]/g, ' ')
	          .replace(' ' + trim(cssClass) + ' ', ' '))
	      );
	    });
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        existingClasses += cssClass + ' ';
	      }
	    });
	
	    element.setAttribute('class', trim(existingClasses));
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType === NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	function jqLiteReady(fn) {
	  function trigger() {
	    window.document.removeEventListener('DOMContentLoaded', trigger);
	    window.removeEventListener('load', trigger);
	    fn();
	  }
	
	  // check if document is already loaded
	  if (window.document.readyState === 'complete') {
	    window.setTimeout(fn);
	  } else {
	    // We can not use jqLite since we are not done loading and jQuery could be loaded later.
	
	    // Works for modern browsers and IE9
	    window.document.addEventListener('DOMContentLoaded', trigger);
	
	    // Fallback to window.onload for others
	    window.addEventListener('load', trigger);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: jqLiteReady,
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern',
	  'ngStep': 'step'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: jqLiteCleanData
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = cssKebabToCamel(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var ret;
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
	      !element.getAttribute) {
	      return;
	    }
	
	    var lowercasedName = lowercase(name);
	    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];
	
	    if (isDefined(value)) {
	      // setter
	
	      if (value === null || (value === false && isBooleanAttr)) {
	        element.removeAttribute(name);
	      } else {
	        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
	      }
	    } else {
	      // getter
	
	      ret = element.getAttribute(name);
	
	      if (isBooleanAttr && ret !== null) {
	        ret = lowercasedName;
	      }
	      // Normalize non-existing attributes to undefined (as jQuery).
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          element.addEventListener(type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	
	    if (parent) {
	      newElement = new JQLite(newElement);
	
	      for (var i = 0, ii = newElement.length; i < ii; i++) {
	        var node = newElement[i];
	        parent.insertBefore(node, index.nextSibling);
	        index = node;
	      }
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	});
	
	// bind legacy bind/unbind to on/off
	JQLite.prototype.bind = JQLite.prototype.on;
	JQLite.prototype.unbind = JQLite.prototype.off;
	
	
	// Provider for private $$jqLite service
	/** @this */
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType === 'function' || (objType === 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	/**
	 * HashMap which can use objects as keys
	 */
	function HashMap(array, isolatedUid) {
	  if (isolatedUid) {
	    var uid = 0;
	    this.nextUid = function() {
	      return ++uid;
	    };
	  }
	  forEach(array, this.put, this);
	}
	HashMap.prototype = {
	  /**
	   * Store key value pair
	   * @param key key to store can be any type
	   * @param value value to store can be any type
	   */
	  put: function(key, value) {
	    this[hashKey(key, this.nextUid)] = value;
	  },
	
	  /**
	   * @param key
	   * @returns {Object} the value for the key
	   */
	  get: function(key) {
	    return this[hashKey(key, this.nextUid)];
	  },
	
	  /**
	   * Remove the key/value pair
	   * @param key
	   */
	  remove: function(key) {
	    var value = this[key = hashKey(key, this.nextUid)];
	    delete this[key];
	    return value;
	  }
	};
	
	var $$HashMapProvider = [/** @this */function() {
	  this.$get = [function() {
	    return HashMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running Angular app
	 * from outside Angular. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^(]+?)=>/;
	var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  // Support: Chrome 50-51 only
	  // Creating a new string by adding `' '` at the end, to hack around some bug in Chrome v50/51
	  // (See https://github.com/angular/angular.js/issues/14487.)
	  // TODO (gkalpak): Remove workaround when Chrome v52 is released
	  return Function.prototype.toString.call(fn) + ' ';
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * # Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ## Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ## `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ## Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * # Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * # The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * # The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An Angular **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new HashMap([], true),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
	    }
	    return (providerCache[name + providerSuffix] = provider_);
	  }
	
	  function enforceReturnValue(name, factory) {
	    return /** @this */ function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.put(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          // eslint-disable-next-line no-ex-assign
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          cache[serviceName] = factory(serviceName, caller);
	          return cache[serviceName];
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // Support: IE 9-11 only
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie || typeof func !== 'function') {
	        return false;
	      }
	      var result = func.$$ngIsClass;
	      if (!isBoolean(result)) {
	        // Support: Edge 12-13 only
	        // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6156135/
	        result = func.$$ngIsClass = /^(?:class\b|constructor\()/.test(stringifyFn(func));
	      }
	      return result;
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 * @this
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample" name="anchor-scroll">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      // Allow numeric hashes
	      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash === 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = /** @this */ function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = /** @this */ function() {
	  var postDigestQueue = new HashMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        if (domOperation) {
	          domOperation();
	        }
	
	        options = options || {};
	        if (options.from) {
	          element.css(options.from);
	        }
	        if (options.to) {
	          element.css(options.to);
	        }
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner();
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            if (toAdd) {
	              jqLiteAddClass(elm, toAdd);
	            }
	            if (toRemove) {
	              jqLiteRemoveClass(elm, toRemove);
	            }
	          });
	          postDigestQueue.remove(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.put(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', /** @this */ function($provide) {
	  var provider = this;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      this.$$classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (this.$$classNameFilter) {
	        var reservedRegex = new RegExp('(\\s+|\\/)' + NG_ANIMATE_CLASSNAME + '(\\s+|\\/)');
	        if (reservedRegex.test(this.$$classNameFilter.toString())) {
	          throw $animateMinErr('nongcls','$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	        }
	      }
	    }
	    return this.$$classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      if (afterElement) {
	        afterElement.after(element);
	      } else {
	        parentElement.prepend(element);
	      }
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the Angular application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation.
	       *
	       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
	       */
	      cancel: function(runner) {
	        if (runner.end) {
	          runner.end();
	        }
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        if (passed) {
	          callback();
	        } else {
	          waitForTick(callback);
	        }
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = /** @this */ function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        if ($$isDocumentHidden()) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              if (status === false) {
	                reject();
	              } else {
	                resolve();
	              }
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/* exported $CoreAnimateCssProvider */
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 * @this
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global stripHash: true */
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {};
	
	  self.isMock = false;
	
	  var outstandingRequestCount = 0;
	  var outstandingRequestCallbacks = [];
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = completeOutstandingRequest;
	  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };
	
	  /**
	   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
	   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
	   */
	  function completeOutstandingRequest(fn) {
	    try {
	      fn.apply(null, sliceArgs(arguments, 1));
	    } finally {
	      outstandingRequestCount--;
	      if (outstandingRequestCount === 0) {
	        while (outstandingRequestCallbacks.length) {
	          try {
	            outstandingRequestCallbacks.pop()();
	          } catch (e) {
	            $log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function getHash(url) {
	    var index = url.indexOf('#');
	    return index === -1 ? '' : url.substr(index);
	  }
	
	  /**
	   * @private
	   * Note: this method is used only by scenario runner
	   * TODO(vojta): prefix this method with $$ ?
	   * @param {function()} callback Function that will be called when no outstanding request
	   */
	  self.notifyWhenNoOutstandingRequests = function(callback) {
	    if (outstandingRequestCount === 0) {
	      callback();
	    } else {
	      outstandingRequestCallbacks.push(callback);
	    }
	  };
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	  lastHistoryState = cachedState;
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of location.href.
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, pushState/replaceState is used, otherwise
	   * location.href/location.replace is used.
	   * Returns its own instance to allow chaining
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state object to use with pushState/replaceState
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	        // Do the assignment again so that those two variables are referentially identical.
	        lastHistoryState = cachedState;
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
	      return pendingLocation || location.href.replace(/%27/g,'\'');
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    cacheState();
	    fireUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	    lastCachedState = cachedState;
	  }
	
	  function fireUrlChange() {
	    if (lastBrowserUrl === self.url() && lastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of angular:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in angular apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers (e.g. Opera)
	      // don't fire popstate when user change the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of Angular.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] of milliseconds to defer the function execution.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay) {
	    var timeoutId;
	    outstandingRequestCount++;
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      completeOutstandingRequest(fn);
	    }, delay || 0);
	    pendingDeferIds[timeoutId] = true;
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds[deferId]) {
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      completeOutstandingRequest(noop);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	/** @this */
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document',
	      function($window, $log, $sniffer, $document) {
	        return new Browser($window, $document, $log, $sniffer);
	      }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 * @this
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp" name="cache-factory">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $http $http} and the {@link ng.directive:script script} directive to cache
	       * templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return (caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      });
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry !== freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd === entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry !== prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 * @this
	 *
	 * @description
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, or by consuming the
	 * `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
	 * element with ng-app attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your component:
	 * ```js
	 * myApp.component('myComponent', {
	 *    templateUrl: 'templateId.html'
	 * });
	 * ```
	 *
	 * or get it via the `$templateCache` service:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 * See {@link ng.$cacheFactory $cacheFactory}.
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables like document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
	 * that defines the directive properties, or just the `postLink` function (all other properties will have
	 * the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       {@link $compile#-priority- priority}: 0,
	 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       {@link $compile#-transclude- transclude}: false,
	 *       {@link $compile#-restrict- restrict}: 'A',
	 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
	 *       {@link $compile#-scope- scope}: false,
	 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
	 *       {@link $compile#-bindtocontroller- bindToController}: false,
	 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       {@link $compile#-multielement- multiElement}: false,
	 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // {@link $compile#-link- link}: {
	 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 * ### Life-cycle hooks
	 * Directive controllers can provide the following methods that are called by Angular at points in the life-cycle of the
	 * directive:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value.
	 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
	 *   changes. Any actions that you wish to take in response to the changes that you detect must be
	 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
	 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
	 *   be detected by Angular's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
	 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 * #### Comparison with Angular 2 life-cycle hooks
	 * Angular 2 also uses life-cycle hooks for its components. While the Angular 1 life-cycle hooks are similar there are
	 * some differences that you should be aware of, especially when it comes to moving your code from Angular 1 to Angular 2:
	 *
	 * * Angular 1 hooks are prefixed with `$`, such as `$onInit`. Angular 2 hooks are prefixed with `ng`, such as `ngOnInit`.
	 * * Angular 1 hooks can be defined on the controller prototype or added to the controller inside its constructor.
	 *   In Angular 2 you can only define hooks on the prototype of the Component class.
	 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in Angular 1 than you would to
	 *   `ngDoCheck` in Angular 2
	 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
	 *   propagated throughout the application.
	 *   Angular 2 does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
	 *   error or do nothing depending upon the state of `enableProdMode()`.
	 *
	 * #### Life-cycle hook examples
	 *
	 * This example shows how you can check for mutations to a Date object even though the identity of the object
	 * has not changed.
	 *
	 * <example name="doCheckDateExample" module="do-check-module">
	 *   <file name="app.js">
	 *     angular.module('do-check-module', [])
	 *       .component('app', {
	 *         template:
	 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
	 *           'Date: {{ $ctrl.date }}' +
	 *           '<test date="$ctrl.date"></test>',
	 *         controller: function() {
	 *           this.date = new Date();
	 *           this.month = this.date.getMonth();
	 *           this.updateDate = function() {
	 *             this.date.setMonth(this.month);
	 *           };
	 *         }
	 *       })
	 *       .component('test', {
	 *         bindings: { date: '<' },
	 *         template:
	 *           '<pre>{{ $ctrl.log | json }}</pre>',
	 *         controller: function() {
	 *           var previousValue;
	 *           this.log = [];
	 *           this.$doCheck = function() {
	 *             var currentValue = this.date && this.date.valueOf();
	 *             if (previousValue !== currentValue) {
	 *               this.log.push('doCheck: date mutated: ' + this.date);
	 *               previousValue = currentValue;
	 *             }
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="index.html">
	 *     <app></app>
	 *   </file>
	 * </example>
	 *
	 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
	 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
	 * arrays or objects can have a negative impact on your application performance)
	 *
	 * <example name="doCheckArrayExample" module="do-check-module">
	 *   <file name="index.html">
	 *     <div ng-init="items = []">
	 *       <button ng-click="items.push(items.length)">Add Item</button>
	 *       <button ng-click="items = []">Reset Items</button>
	 *       <pre>{{ items }}</pre>
	 *       <test items="items"></test>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *      angular.module('do-check-module', [])
	 *        .component('test', {
	 *          bindings: { items: '<' },
	 *          template:
	 *            '<pre>{{ $ctrl.log | json }}</pre>',
	 *          controller: function() {
	 *            this.log = [];
	 *
	 *            this.$doCheck = function() {
	 *              if (this.items_ref !== this.items) {
	 *                this.log.push('doCheck: items changed');
	 *                this.items_ref = this.items;
	 *              }
	 *              if (!angular.equals(this.items_clone, this.items)) {
	 *                this.log.push('doCheck: items mutated');
	 *                this.items_clone = angular.copy(this.items);
	 *              }
	 *            };
	 *          }
	 *        });
	 *   </file>
	 * </example>
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `false`, `true`, or an object:
	 *
	 * * **`false` (default):** No scope will be created for the directive. The directive will use its
	 * parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's element. The
	 * 'isolate' scope differs from normal scope in that it does not prototypically inherit from its parent
	 * scope. This is useful when creating reusable components, which should not accidentally read or modify
	 * data in the parent scope.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
	 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
	 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
	 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
	 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * <div class="alert alert-warning">
	 * **Deprecation warning:** although bindings for non-ES6 class controllers are currently
	 * bound to `this` before the controller constructor is called, this use is now deprecated. Please place initialization
	 * code that relies upon bindings inside a `$onInit` method on the controller, instead.
	 * </div>
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkingFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default transclusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
	 * specify what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using $compile in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude` parameter of directive controllers,
	 *     see {@link ng.$compile#-controller- the controller section for details}.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
	 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample" name="compile">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects the '$compile'
	        $compileProvider.directive('compile', function($compile) {
	          // directive factory creates a link function
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                 // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // when the 'compile' expression changes
	                // assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current
	                // scope.
	                // NOTE: we only compile .childNodes so that
	                // we don't get into infinite loop compiling ourselves
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'Angular';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello Angular'.
	       expect(output.getText()).toBe('Hello Angular');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('Angular!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non html
	 *        elements (e.g. SVG elements). See also the directive.controller property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to $digest which typically is done by
	 * Angular automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = $compile('<p>{{total}}</p>')(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone via the cloneAttachFn:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>'),
	 *         scope = ....;
	 *
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       //attach the clone to DOM document at the right place
	 *     });
	 *
	 *     //now we have reference to the cloned DOM via `clonedElement`
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
	 *
	 * @knownIssue
	 *
	 * ### Double Compilation
	 *
	   Double compilation occurs when an already compiled part of the DOM gets
	   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
	   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
	   section on double compilation} for an in-depth explanation and ways to avoid it.
	 *
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	/** @this */
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*(\w*)\s*$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            'Invalid {3} for directive \'{0}\'.' +
	            ' Definition: {... {1}: \'{2}\' ...}',
	            directiveName, scopeName, definition,
	            (isController ? 'controller bindings definition' :
	            'isolate scope definition'));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (bindings.bindToController && !directive.controller) {
	      // There is no controller
	      throw $compileMinErr('noctrl',
	            'Cannot bind to controller without directive \'{0}\'s controller.',
	            directiveName);
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  function getDirectiveRestrict(restrict, name) {
	    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
	      throw $compileMinErr('badrestrict',
	          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
	          restrict,
	          name);
	    }
	
	    return restrict || 'EA';
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
	   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
	   *    names and the values are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertArg(name, 'name');
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = getDirectiveRestrict(directive.restrict, name);
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`)
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return /** @this */ function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in Angular looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `$binding` data property containing an array of the binding expressions
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#preAssignBindingsEnabled
	   *
	   * @param {boolean=} enabled update the preAssignBindingsEnabled state if provided, otherwise just return the
	   * current preAssignBindingsEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable whether directive controllers are assigned bindings before
	   * calling the controller's constructor.
	   * If enabled (true), the compiler assigns the value of each of the bindings to the
	   * properties of the controller object before the constructor of this object is called.
	   *
	   * If disabled (false), the compiler calls the constructor first before assigning bindings.
	   *
	   * The default value is true in Angular 1.5.x but will switch to false in Angular 1.6.x.
	   */
	  var preAssignBindingsEnabled = false;
	  this.preAssignBindingsEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      preAssignBindingsEnabled = enabled;
	      return this;
	    }
	    return preAssignBindingsEnabled;
	  };
	
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  var commentDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#commentDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on comments should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on comments for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check comments when looking for directives.
	   * This should however only be used if you are sure that no comment directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.commentDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      commentDirectivesEnabledConfig = value;
	      return this;
	    }
	    return commentDirectivesEnabledConfig;
	  };
	
	
	  var cssClassDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#cssClassDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on element classes should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on element classes for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check element classes when looking for directives.
	   * This should however only be used if you are sure that no class directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.cssClassDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      cssClassDirectivesEnabledConfig = value;
	      return this;
	    }
	    return cssClassDirectivesEnabledConfig;
	  };
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate,   $$sanitizeUri) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
	    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          var errors = [];
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            try {
	              onChangesQueue[i]();
	            } catch (e) {
	              errors.push(e);
	            }
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	          if (errors.length) {
	            throw errors;
	          }
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        //is set through this function since it may cause $updateClass to
	        //become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        if ((nodeName === 'a' && (key === 'href' || key === 'xlinkHref')) ||
	            (nodeName === 'img' && key === 'src')) {
	          // sanitize a[href] and img[src] values
	          this[key] = value = $$sanitizeUri(value, key === 'src');
	        } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
	          // sanitize img[srcset] values
	          var result = '';
	
	          // first check if there are spaces because it's not the same pattern
	          var trimmedSrcset = trim(value);
	          //                (   999x   ,|   999w   ,|   ,|,   )
	          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	          // split srcset into tuple of uri and descriptor except for the last item
	          var rawUris = trimmedSrcset.split(pattern);
	
	          // for each tuples
	          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	          for (var i = 0; i < nbrUrisWith2parts; i++) {
	            var innerIdx = i * 2;
	            // sanitize the uri
	            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
	            // add the descriptor
	            result += (' ' + trim(rawUris[innerIdx + 1]));
	          }
	
	          // split the last item into uri and descriptor
	          var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	          // sanitize the last uri
	          result += $$sanitizeUri(trim(lastTuple[0]), true);
	
	          // and add the last descriptor if any
	          if (lastTuple.length === 2) {
	            result += (' ' + trim(lastTuple[1]));
	          }
	          this[key] = value = result;
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              this.$$element.attr(attrName, value);
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        if ($$observers) {
	          forEach($$observers[observer], function(fn) {
	            try {
	              fn(value);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_ATTR_BINDING = /^ngAttr[A-Z]/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        if (!$compileNodes) {
	          throw $compileMinErr('multilink', 'This element has already been linked.');
	        }
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	
	        if (!cloneConnectFn) {
	          $compileNodes = compositeLinkFn = null;
	        }
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          // `nodeList` can be either an element's `.childNodes` (live NodeList)
	          // or a jqLite/jQuery collection or an array
	          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // Support: IE 11 only
	        // Workaround for #11781 and #14924
	        if (msie === 11) {
	          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
	        }
	
	        // We must always refer to `nodeList[i]` hereafter,
	        // since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i += 3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
	      var node = nodeList[idx];
	      var parent = node.parentNode;
	      var sibling;
	
	      if (node.nodeType !== NODE_TYPE_TEXT) {
	        return;
	      }
	
	      while (true) {
	        sibling = parent ? node.nextSibling : nodeList[idx + 1];
	        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
	          break;
	        }
	
	        node.nodeValue = node.nodeValue + sibling.nodeValue;
	
	        if (sibling.parentNode) {
	          sibling.parentNode.removeChild(sibling);
	        }
	        if (notLiveList && sibling === nodeList[idx + 1]) {
	          nodeList.splice(idx + 1, 1);
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          nodeName,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	
	          nodeName = nodeName_(node);
	
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = attr.value;
	
	            // support ngAttr attribute binding
	            ngAttrName = directiveNormalize(name);
	            isNgAttr = NG_ATTR_BINDING.test(ngAttrName);
	            if (isNgAttr) {
	              name = name.replace(PREFIX_REGEXP, '')
	                .substr(8).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	            }
	
	            var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
	            if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            nName = directiveNormalize(name.toLowerCase());
	            attrsMap[nName] = name;
	            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	            }
	            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                          attrEndName);
	          }
	
	          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
	            // Hidden input elements can have strange behaviour when navigating back to the page
	            // This tells the browser not to try to cache and reinstate previous values
	            node.setAttribute('autocomplete', 'off');
	          }
	
	          // use class as directive
	          if (!cssClassDirectivesEnabled) break;
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          if (!commentDirectivesEnabled) break;
	          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      // function created because of performance, try/catch disables
	      // the optimization of the whole function #14848
	      try {
	        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	        if (match) {
	          var nName = directiveNormalize(match[1]);
	          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	            attrs[nName] = trim(match[2]);
	          }
	        }
	      } catch (e) {
	        // turns out that under some circumstances IE9 throws errors when one attempts to read
	        // comment's node value.
	        // Just ignore it and continue. (Can't seem to reproduce in test case.)
	      }
	    }
	
	    /**
	     * Given a node with a directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType === NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return /** @this */ function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        directiveValue = directive.scope;
	
	        if (directiveValue) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate('\'' + directiveName + '\' controller',
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        directiveValue = directive.transclude;
	
	        if (directiveValue) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue === 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            // Support: Chrome < 50
	            // https://github.com/angular/angular.js/issues/14041
	
	            // In the versions of V8 prior to Chrome 50, the document fragment that is created
	            // in the `replaceWith` function is improperly garbage collected despite still
	            // being referenced by the `parentNode` property of all of the child nodes.  By adding
	            // a reference to the fragment via a different property, we can avoid that incorrect
	            // behavior.
	            // TODO: remove this line after Chrome 50 has been released
	            $template[0].$$parentNode = $template[0].parentNode;
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            if (!isObject(directiveValue)) {
	              $template = jqLite(jqLiteClone(compileNode)).contents();
	            } else {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = [];
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || [];
	                  slots[slotName].push(node);
	                } else {
	                  $template.push(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
	                }
	              }
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          // eslint-disable-next-line no-func-assign
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          if (preAssignBindingsEnabled) {
	            if (bindings) {
	              controller.bindingInfo =
	                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	            } else {
	              controller.bindingInfo = {};
	            }
	
	            var controllerResult = controller();
	            if (controllerResult !== controller.instance) {
	              // If the controller constructor has a return value, overwrite the instance
	              // from setupControllers
	              controller.instance = controllerResult;
	              $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
	              if (controller.bindingInfo.removeWatches) {
	                controller.bindingInfo.removeWatches();
	              }
	              controller.bindingInfo =
	                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	            }
	          } else {
	            controller.instance = controller();
	            $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
	            controller.bindingInfo =
	              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	        }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            try {
	              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            try {
	              controllerInstance.$onInit();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$doCheck)) {
	            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
	            controllerInstance.$doCheck();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        if (childLinkFn) {
	          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	        }
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	          value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller === '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	               directive.restrict.indexOf(location) !== -1) {
	            if (startAttrName) {
	              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	            }
	            if (!directive.$$bindings) {
	              var bindings = directive.$$bindings =
	                  parseDirectiveBindings(directive, directive.name);
	              if (isObject(bindings.isolateScope)) {
	                directive.$$isolateBindings = bindings.isolateScope;
	              }
	            }
	            tDirectives.push(directive);
	            match = directive;
	          }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) !== '$') {
	          if (src[key] && src[key] !== value) {
	            if (value.length) {
	              value += (key === 'style' ? ';' : ' ') + src[key];
	            } else {
	              value = src[key];
	            }
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        // Check if we already set this attribute in the loop above.
	        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	        // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
	          dst[key] = value;
	
	          if (key !== 'class' && key !== 'style') {
	            dstAttr[key] = srcAttr[key];
	          }
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node === compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        }).catch(function(error) {
	          if (error instanceof Error) {
	            $exceptionHandler(error);
	          }
	        }).catch(noop);
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedContext(node, attrNormalizedName) {
	      if (attrNormalizedName === 'srcdoc') {
	        return $sce.HTML;
	      }
	      var tag = nodeName_(node);
	      // All tags with src attributes require a RESOURCE_URL value, except for
	      // img and various html5 media tags.
	      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
	        if (['img', 'video', 'audio', 'source', 'track'].indexOf(tag) === -1) {
	          return $sce.RESOURCE_URL;
	        }
	      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
	      } else if (attrNormalizedName === 'xlinkHref' ||
	          (tag === 'form' && attrNormalizedName === 'action') ||
	          // links can be stylesheets or imports, which can run script in the current origin
	          (tag === 'link' && attrNormalizedName === 'href')
	      ) {
	        return $sce.RESOURCE_URL;
	      }
	    }
	
	
	    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
	      var trustedContext = getTrustedContext(node, name);
	      var mustHaveExpression = !isNgAttr;
	      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;
	
	      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	      if (name === 'multiple' && nodeName_(node) === 'select') {
	        throw $compileMinErr('selmulti',
	            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
	            startingTag(node));
	      }
	
	      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	        throw $compileMinErr('nodomevents',
	            'Interpolations for HTML DOM event attributes are disallowed.  Please use the ' +
	                'ng- versions (such as ng-click instead of onclick) instead.');
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue !== oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] === firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes Angular's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	
	    // Set up $watches for isolate scope and controller bindings.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, <, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              destination[scopeName] = attrs[attrName] = undefined;
	            }
	            removeWatch = attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then Angular will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              // eslint-disable-next-line no-self-compare
	              compare = function simpleCompare(a, b) { return a === b || (a !== a && b !== b); };
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              lastValue = parentValue;
	              return lastValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            var deepWatch = parentGet.literal;
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue || (deepWatch && equals(oldValue, initialValue))) {
	                  return;
	                }
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            }, deepWatch);
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && currentValue !== previousValue &&
	            // eslint-disable-next-line no-self-compare
	            (currentValue === currentValue || previousValue === previousValue)) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
	var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;
	
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return name
	    .replace(PREFIX_REGEXP, '')
	    .replace(SPECIAL_CHARS_REGEXP, fnCamelCaseReplace);
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in Angular:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token === tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT ||
	       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
	         splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @this
	 *
	 * @description
	 * The {@link ng.$controller $controller service} is used by Angular to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {},
	      globals = false;
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#allowGlobals
	   * @description If called, allows `$controller` to find controller constructors on `window`
	   *
	   * @deprecated
	   * sinceVersion="v1.3.0"
	   * removeVersion="v1.7.0"
	   * This method of finding controllers has been deprecated.
	   */
	  this.allowGlobals = function() {
	    globals = true;
	  };
	
	
	  this.$get = ['$injector', '$window', function($injector, $window) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
	     *      `window` object (deprecated, not recommended)
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            'Badly formed controller string \'{0}\'. ' +
	            'Must match `__name__ as __id__` or `__name__`.', expression);
	        }
	        constructor = match[1];
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true) ||
	                (globals ? getter($window, constructor, true) : undefined);
	
	        if (!expression) {
	          throw $controllerMinErr('ctrlreg',
	            'The controller with the name \'{0}\' is not registered.', constructor);
	        }
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        return extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 * @this
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample" name="document">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	
	/**
	 * @private
	 * @this
	 * Listens for document visibility change and makes the current status accessible.
	 */
	function $$IsDocumentHiddenProvider() {
	  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
	    var doc = $document[0];
	    var hidden = doc && doc.hidden;
	
	    $document.on('visibilitychange', changeListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('visibilitychange', changeListener);
	    });
	
	    function changeListener() {
	      hidden = doc.hidden;
	    }
	
	    return function() {
	      return hidden;
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 * @this
	 *
	 * @description
	 * Any uncaught exception in angular expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
	 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
	 * of `$log.error()`.
	 *
	 * ```js
	 *   angular.
	 *     module('exceptionOverwrite', []).
	 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
	 *       return function myExceptionHandler(exception, cause) {
	 *         logErrorsToBackend(exception, cause);
	 *         $log.warn(exception, cause);
	 *       };
	 *     }]);
	 * ```
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause Optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = /** @this */ function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
	var $httpMinErr = minErr('$http');
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	/** @this */
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   * */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	/** @this */
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   *
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   * */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (toSerialize === null || isUndefined(toSerialize)) return;
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      if ((contentType && (contentType.indexOf(APPLICATION_JSON) === 0)) || isJsonLike(tempData)) {
	        data = fromJson(tempData);
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === undefined) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @this
	 *
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 * */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
	   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
	   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
	   *
	   **/
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer',
	
	    jsonpCallbackParam: 'callback'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   **/
	  var interceptorFactories = this.interceptors = [];
	
	  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
	      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core Angular service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     * The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with the transform
	     *     functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *
	     * A response status code between 200 and 299 is considered a success status and will result in
	     * the success callback being called. Any response status code outside of that range is
	     * considered an error status and will result in the error callback being called.
	     * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
	     * aborted, e.g. using a `config.timeout`.
	     * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
	     * that the outcome (success or error) will be determined by the final response status code.
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** Angular does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * Angular provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`):
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`):
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If JSON response is detected, deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish to override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory("$http")` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. Angular comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * Angular will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * Angular will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. Angular provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
	     * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
	     * The header will not be set for cross-domain requests.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
	     * that only JavaScript running on your domain could have sent the request. The token must be
	     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
	     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
	     * or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple Angular apps share the
	     * same domain or subdomain, we recommend that each application uses unique cookie name.
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
	     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
	     *                        when the request succeeds or fails.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample" name="http-service">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
	      // We must whitelist the JSONP endpoint that we are using to show that we trust it
	      $sceDelegateProvider.resourceUrlWhitelist([
	        'self',
	        'https://angularjs.org/**'
	      ]);
	    }])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || 'Request failed';
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString($sce.valueOf(requestConfig.url))) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer,
	        jsonpCallbackParam: defaults.jsonpCallbackParam
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	          $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      $browser.$$incOutstandingRequestCount();
	
	      var requestInterceptors = [];
	      var responseInterceptors = [];
	      var promise = $q.resolve(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          responseInterceptors.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      promise = chainInterceptors(promise, requestInterceptors);
	      promise = promise.then(serverRequest);
	      promise = chainInterceptors(promise, responseInterceptors);
	      promise = promise.finally(completeOutstandingRequest);
	
	      return promise;
	
	
	      function chainInterceptors(promise, interceptors) {
	        for (var i = 0, ii = interceptors.length; i < ii;) {
	          var thenFn = interceptors[i++];
	          var rejectFn = interceptors[i++];
	
	          promise = promise.then(thenFn, rejectFn);
	        }
	
	        interceptors.length = 0;
	
	        return promise;
	      }
	
	      function completeOutstandingRequest() {
	        $browser.$$completeOutstandingRequest(noop);
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	
	      function serverRequest(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	              delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      }
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
	     * the url must be declared, via {@link $sce} as a trusted resource URL.
	     * You can trust a URL by adding it to the whitelist via
	     * {@link $sceDelegateProvider#resourceUrlWhitelist  `$sceDelegateProvider.resourceUrlWhitelist`} or
	     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
	     *
	     * JSONP requests must specify a callback to be used in the response from the server. This callback
	     * is passed as a query parameter in the request. You must specify the name of this parameter by
	     * setting the `jsonpCallbackParam` property on the request config object.
	     *
	     * ```
	     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
	     * ```
	     *
	     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
	     * Initially this is set to `'callback'`.
	     *
	     * <div class="alert alert-danger">
	     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
	     * parameter value should go.
	     * </div>
	     *
	     * If you would like to customise where and how the callbacks are stored then try overriding
	     * or decorating the {@link $jsonpCallbacks} service.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object
	      * @returns {HttpPromise} Future object
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          isJsonp = lowercase(config.method) === 'jsonp',
	          url = config.url;
	
	      if (isJsonp) {
	        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
	        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
	        url = $sce.getTrustedResourceUrl(url);
	      } else if (!isString(url)) {
	        // If it is not a string then the URL must be a $sce trusted object
	        url = $sce.valueOf(url);
	      }
	
	      url = buildUrl(url, config.paramSerializer(config.params));
	
	      if (isJsonp) {
	        // Check the url and add the JSONP callback placeholder
	        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
	      }
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	              : isObject(defaults.cache) ? defaults.cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsSameOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	
	    function sanitizeJsonpCallbackParam(url, key) {
	      if (/[&?][^=]+=JSON_CALLBACK/.test(url)) {
	        // Throw if the url already contains a reference to JSON_CALLBACK
	        throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
	      }
	
	      var callbackParamRegex = new RegExp('[&?]' + key + '=');
	      if (callbackParamRegex.test(url)) {
	        // Throw if the callback param was already provided
	        throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', key, url);
	      }
	
	      // Add in the JSON_CALLBACK callback param value
	      url += ((url.indexOf('?') === -1) ? '?' : '&') + key + '=JSON_CALLBACK';
	
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 * @this
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $jsonpCallbacks
	 * @requires $document
	 * @requires $xhrFactory
	 * @this
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    url = url || $browser.url();
	
	    if (lowercase(method) === 'jsonp') {
	      var callbackPath = callbacks.createCallback(url);
	      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
	        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
	        var response = (status === 200) && callbacks.getResponse(callbackPath);
	        completeRequest(callback, status, response, '', text);
	        callbacks.removeCallback(callbackPath);
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText);
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '');
	      };
	
	      xhr.onerror = requestError;
	      xhr.onabort = requestError;
	      xhr.ontimeout = requestError;
	
	      forEach(eventHandlers, function(value, key) {
	          xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(timeoutRequest, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(timeoutRequest);
	    }
	
	
	    function timeoutRequest() {
	      if (jsonpDone) {
	        jsonpDone();
	      }
	      if (xhr) {
	        xhr.abort();
	      }
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText);
	    }
	  };
	
	  function jsonpReq(url, callbackPath, done) {
	    url = url.replace('JSON_CALLBACK', callbackPath);
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = 'text/javascript';
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      script.removeEventListener('load', callback);
	      script.removeEventListener('error', callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = 'unknown';
	
	      if (event) {
	        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
	          event = { type: 'error' };
	        }
	        text = event.type;
	        status = event.type === 'error' ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    script.addEventListener('load', callback);
	    script.addEventListener('error', callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
	      'interpolations that concatenate multiple expressions when a trusted value is ' +
	      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an Angular
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape Angular
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    } else {
	      return startSymbol;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    } else {
	      return endSymbol;
	    }
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    // TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'Angular'})).toEqual('Hello ANGULAR!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'Angular';
	     *   expect(exp(context)).toEqual('Hello Angular!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * #### Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example name="interpolation">
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        var constantInterp;
	        if (!mustHaveExpression) {
	          var unescapedText = unescapeText(text);
	          constantInterp = valueFn(unescapedText);
	          constantInterp.exp = text;
	          constantInterp.expressions = [];
	          constantInterp.$$watchDelegate = constantWatchDelegate;
	        }
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns = [],
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [];
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          parseFns.push($parse(exp, parseStringifyInterceptor));
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push('');
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for iframe[src], object[src], etc., we ensure that the value
	      // that's used is assigned or constructed by some JS code somewhere that is more testable or
	      // make it obvious that you bound the value to some user controlled value.  This helps reduce
	      // the load when auditing for XSS issues.
	      if (trustedContext && concat.length > 1) {
	          $interpolateMinErr.throwNoconcat(text);
	      }
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	          return concat.join('');
	        };
	
	        var getValue = function(value) {
	          return trustedContext ?
	            $sce.getTrusted(trustedContext, value) :
	            $sce.valueOf(value);
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              if (isFunction(listener)) {
	                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              }
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          value = getValue(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	/** @this */
	function $IntervalProvider() {
	  this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser',
	       function($rootScope,   $window,   $q,   $$q,   $browser) {
	    var intervals = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $interval
	      *
	      * @description
	      * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	      * milliseconds.
	      *
	      * The return value of registering an interval function is a promise. This promise will be
	      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	      * run indefinitely if `count` is not defined. The value of the notification will be the
	      * number of iterations that have run.
	      * To cancel an interval, call `$interval.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	      * time.
	      *
	      * <div class="alert alert-warning">
	      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	      * with them.  In particular they are not automatically destroyed when a controller's scope or a
	      * directive's element are destroyed.
	      * You should take this into consideration and make sure to always cancel the interval at the
	      * appropriate moment.  See the example below for more details on how and when to do this.
	      * </div>
	      *
	      * @param {function()} fn A function that should be called repeatedly. If no additional arguments
	      *   are passed (see below), the function is called with the current iteration count.
	      * @param {number} delay Number of milliseconds between each function call.
	      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	      *   indefinitely.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {promise} A promise which will be notified on each iteration.
	      *
	      * @example
	      * <example module="intervalExample" name="interval-service">
	      * <file name="index.html">
	      *   <script>
	      *     angular.module('intervalExample', [])
	      *       .controller('ExampleController', ['$scope', '$interval',
	      *         function($scope, $interval) {
	      *           $scope.format = 'M/d/yy h:mm:ss a';
	      *           $scope.blood_1 = 100;
	      *           $scope.blood_2 = 120;
	      *
	      *           var stop;
	      *           $scope.fight = function() {
	      *             // Don't start a new fight if we are already fighting
	      *             if ( angular.isDefined(stop) ) return;
	      *
	      *             stop = $interval(function() {
	      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	      *                 $scope.blood_1 = $scope.blood_1 - 3;
	      *                 $scope.blood_2 = $scope.blood_2 - 4;
	      *               } else {
	      *                 $scope.stopFight();
	      *               }
	      *             }, 100);
	      *           };
	      *
	      *           $scope.stopFight = function() {
	      *             if (angular.isDefined(stop)) {
	      *               $interval.cancel(stop);
	      *               stop = undefined;
	      *             }
	      *           };
	      *
	      *           $scope.resetFight = function() {
	      *             $scope.blood_1 = 100;
	      *             $scope.blood_2 = 120;
	      *           };
	      *
	      *           $scope.$on('$destroy', function() {
	      *             // Make sure that the interval is destroyed too
	      *             $scope.stopFight();
	      *           });
	      *         }])
	      *       // Register the 'myCurrentTime' directive factory method.
	      *       // We inject $interval and dateFilter service since the factory method is DI.
	      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	      *         function($interval, dateFilter) {
	      *           // return the directive link function. (compile function not needed)
	      *           return function(scope, element, attrs) {
	      *             var format,  // date format
	      *                 stopTime; // so that we can cancel the time updates
	      *
	      *             // used to update the UI
	      *             function updateTime() {
	      *               element.text(dateFilter(new Date(), format));
	      *             }
	      *
	      *             // watch the expression, and update the UI on change.
	      *             scope.$watch(attrs.myCurrentTime, function(value) {
	      *               format = value;
	      *               updateTime();
	      *             });
	      *
	      *             stopTime = $interval(updateTime, 1000);
	      *
	      *             // listen on DOM destroy (removal) event, and cancel the next UI update
	      *             // to prevent updating time after the DOM element was removed.
	      *             element.on('$destroy', function() {
	      *               $interval.cancel(stopTime);
	      *             });
	      *           }
	      *         }]);
	      *   </script>
	      *
	      *   <div>
	      *     <div ng-controller="ExampleController">
	      *       <label>Date format: <input ng-model="format"></label> <hr/>
	      *       Current time is: <span my-current-time="format"></span>
	      *       <hr/>
	      *       Blood 1 : <font color='red'>{{blood_1}}</font>
	      *       Blood 2 : <font color='red'>{{blood_2}}</font>
	      *       <button type="button" data-ng-click="fight()">Fight</button>
	      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	      *     </div>
	      *   </div>
	      *
	      * </file>
	      * </example>
	      */
	    function interval(fn, delay, count, invokeApply) {
	      var hasParams = arguments.length > 4,
	          args = hasParams ? sliceArgs(arguments, 4) : [],
	          setInterval = $window.setInterval,
	          clearInterval = $window.clearInterval,
	          iteration = 0,
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise;
	
	      count = isDefined(count) ? count : 0;
	
	      promise.$$intervalId = setInterval(function tick() {
	        if (skipApply) {
	          $browser.defer(callback);
	        } else {
	          $rootScope.$evalAsync(callback);
	        }
	        deferred.notify(iteration++);
	
	        if (count > 0 && iteration >= count) {
	          deferred.resolve(iteration);
	          clearInterval(promise.$$intervalId);
	          delete intervals[promise.$$intervalId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	
	      }, delay);
	
	      intervals[promise.$$intervalId] = deferred;
	
	      return promise;
	
	      function callback() {
	        if (!hasParams) {
	          fn(iteration);
	        } else {
	          fn.apply(null, args);
	        }
	      }
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $interval#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`.
	      *
	      * @param {Promise=} promise returned by the `$interval` function.
	      * @returns {boolean} Returns `true` if the task was successfully canceled.
	      */
	    interval.cancel = function(promise) {
	      if (promise && promise.$$intervalId in intervals) {
	        // Interval cancels should not report as unhandled promise.
	        intervals[promise.$$intervalId].promise.catch(noop);
	        intervals[promise.$$intervalId].reject('canceled');
	        $window.clearInterval(promise.$$intervalId);
	        delete intervals[promise.$$intervalId];
	        return true;
	      }
	      return false;
	    };
	
	    return interval;
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $jsonpCallbacks
	 * @requires $window
	 * @description
	 * This service handles the lifecycle of callbacks to handle JSONP requests.
	 * Override this service if you wish to customise where the callbacks are stored and
	 * how they vary compared to the requested url.
	 */
	var $jsonpCallbacksProvider = /** @this */ function() {
	  this.$get = ['$window', function($window) {
	    var callbacks = $window.angular.callbacks;
	    var callbackMap = {};
	
	    function createCallback(callbackId) {
	      var callback = function(data) {
	        callback.data = data;
	        callback.called = true;
	      };
	      callback.id = callbackId;
	      return callback;
	    }
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#createCallback
	       * @param {string} url the url of the JSONP request
	       * @returns {string} the callback path to send to the server as part of the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
	       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
	       */
	      createCallback: function(url) {
	        var callbackId = '_' + (callbacks.$$counter++).toString(36);
	        var callbackPath = 'angular.callbacks.' + callbackId;
	        var callback = createCallback(callbackId);
	        callbackMap[callbackPath] = callbacks[callbackId] = callback;
	        return callbackPath;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#wasCalled
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
	       * @description
	       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
	       * callback that was passed in the request.
	       */
	      wasCalled: function(callbackPath) {
	        return callbackMap[callbackPath].called;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#getResponse
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {*} the data received from the response via the registered callback
	       * @description
	       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
	       * in the JSONP response.
	       */
	      getResponse: function(callbackPath) {
	        return callbackMap[callbackPath].data;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#removeCallback
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
	       * completed or timed-out.
	       */
	      removeCallback: function(callbackPath) {
	        var callback = callbackMap[callbackPath];
	        delete callbacks[callback.id];
	        delete callbackMap[callbackPath];
	      }
	    };
	  }];
	};
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various Angular components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = encodeUriSegment(segments[i]);
	  }
	
	  return segments.join('/');
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
	function parseAppUrl(url, locationObj) {
	
	  if (DOUBLE_SLASH_REGEX.test(url)) {
	    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
	  }
	
	  var prefixed = (url.charAt(0) !== '/');
	  if (prefixed) {
	    url = '/' + url;
	  }
	  var match = urlResolve(url);
	  locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ?
	      match.pathname.substring(1) : match.pathname);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(str, search) {
	  return str.slice(0, search.length) === search;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? url : url.substr(0, index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/(#.+)|#$/, '$1');
	}
	
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents a URL
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix URL path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given HTML5 (regular) URL string into properties
	   * @param {string} url HTML5 URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  /**
	   * Compose url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang URL into properties
	   * @param {string} url Hashbang URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the URL starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          this.replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of Angular, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  /**
	   * Compose hashbang URL and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) === stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase === stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    this.$$absUrl = appBase + hashPrefix + this.$$url;
	  };
	
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Ensure absolute URL is initialized.
	   * @private
	   */
	  $$absUrl:'',
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full URL representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full URL
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current URL
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current URL.
	   *
	   * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current URL.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current URL when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) === '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current URL when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the URL.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return /** @this */ function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return /** @this */ function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @this
	 *
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '!',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * The default value for the prefix is `'!'`.
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
	   *     only happen on links with an attribute that matches the given string. For example, if set
	   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
	   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
	   *     here, so `'internalLink'` will **not** match `'internal-link'`.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          '$location in HTML5 mode requires a <base> tag to be present!');
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      var rewriteLinks = html5Mode.rewriteLinks;
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the angular application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() !== $browser.url()) {
	            $rootScope.$apply();
	            // hack to work around FF6 bug 684208 when scenario runner clicks on links
	            $window.angular['ff-684208-preventDefault'] = true;
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if (trimEmptyHash($location.absUrl()) !== trimEmptyHash(initialUrl)) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (!startsWith(newUrl, appBaseNoFile)) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        newUrl = trimEmptyHash(newUrl);
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      var oldUrl = trimEmptyHash($browser.url());
	      var newUrl = trimEmptyHash($location.absUrl());
	      var oldState = $browser.state();
	      var currentReplace = $location.$$replace;
	      var urlOrStateChanged = oldUrl !== newUrl ||
	        ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	      if (initializing || urlOrStateChanged) {
	        initializing = false;
	
	        $rootScope.$evalAsync(function() {
	          var newUrl = $location.absUrl();
	          var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	              $location.$$state, oldState).defaultPrevented;
	
	          // if the location was changed by a `$locationChangeStart` handler then stop
	          // processing this location change
	          if ($location.absUrl() !== newUrl) return;
	
	          if (defaultPrevented) {
	            $location.$$parse(oldUrl);
	            $location.$$state = oldState;
	          } else {
	            if (urlOrStateChanged) {
	              setBrowserUrlWithFallback(newUrl, currentReplace,
	                                        oldState === $location.$$state ? null : $location.$$state);
	            }
	            afterLocationChange(oldUrl, oldState);
	          }
	        });
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample" name="log-service">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @this
	 *
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	    return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      })()
	    };
	
	    function formatError(arg) {
	      if (arg instanceof Error) {
	        if (arg.stack) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop,
	          hasApply = false;
	
	      // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
	      // The reason behind this is that console.log has type "object" in IE8...
	      try {
	        hasApply = !!logFn.apply;
	      } catch (e) { /* empty */ }
	
	      if (hasApply) {
	        return function() {
	          var args = [];
	          forEach(arguments, function(arg) {
	            args.push(formatError(arg));
	          });
	          return logFn.apply(console, args);
	        };
	      }
	
	      // we are IE which either doesn't have window.console => this is noop and we do nothing,
	      // or we are IE where console.log doesn't have apply so we log at least first 2 args
	      return function(arg1, arg2) {
	        logFn(arg1, arg2 == null ? '' : arg2);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	var objectValueOf = {}.constructor.prototype.valueOf;
	
	// Sandboxing Angular Expressions
	// ------------------------------
	// Angular expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
	// various means such as obtaining a reference to native JS functions like the Function constructor.
	//
	// As an example, consider the following Angular expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// It is important to realize that if you create an expression from a string that contains user provided
	// content then it is possible that your application contains a security vulnerability to an XSS style attack.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function Lexer(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === '\'') {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    // eslint-disable-next-line no-bitwise
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch === '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch === 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) === 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) === 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function AST(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    while (this.expect('|')) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      if (!isAssignable(result)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.filterChain());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError('invalid key', this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	function findConstantAndWatchExpressions(ast, $filter) {
	  var allConstants;
	  var argsToWatch;
	  var isStatelessFilter;
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter);
	    findConstantAndWatchExpressions(ast.alternate, $filter);
	    findConstantAndWatchExpressions(ast.consequent, $filter);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = [ast];
	    break;
	  case AST.CallExpression:
	    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    allConstants = isStatelessFilter;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter);
	      allConstants = allConstants && property.value.constant && !property.computed;
	      if (!property.value.constant) {
	        argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length !== 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler(astBuilder, $filter) {
	  this.astBuilder = astBuilder;
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(expression) {
	    var self = this;
	    var ast = this.astBuilder.ast(expression);
	    this.state = {
	      nextId: 0,
	      filters: {},
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push(fnKey);
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    // eslint-disable-next-line no-new-func
	    var fn = (new Function('$filter',
	        'getStringValue',
	        'ifDefined',
	        'plus',
	        fnString))(
	          this.$filter,
	          getStringValue,
	          ifDefined,
	          plusFn);
	    this.state = this.stage = undefined;
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var fns = this.state.inputs;
	    var self = this;
	    forEach(fns, function(name) {
	      result.push('var ' + name + '=' + self.generateFunction(name, 's'));
	    });
	    if (fns.length) {
	      result.push('fn.inputs=[' + fns.join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.isNull(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.computedMember(left, right);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            if (create && create !== 1) {
	              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	                args.push(argument);
	              });
	            });
	            if (left.name) {
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn(intoId || 's');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn(intoId || 'l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn(intoId || 'v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  isNull: function(expression) {
	    return expression + '==null';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter(astBuilder, $filter) {
	  this.astBuilder = astBuilder;
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(expression) {
	    var self = this;
	    var ast = this.astBuilder.ast(expression);
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      return self.identifier(ast.name, context, create);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create) :
	        this.nonComputedMember(left, right, context, create);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(args[i](scope, locals, assign, inputs));
	            }
	            value = rhs.value.apply(rhs.context, values);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = -0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && base[name] == null) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        if (create && create !== 1) {
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        if (lhs && lhs[right] == null) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	var Parser = function Parser(lexer, $filter, options) {
	  this.lexer = lexer;
	  this.$filter = $filter;
	  this.options = options;
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter(this.ast, $filter) :
	                                   new ASTCompiler(this.ast, $filter);
	};
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    return this.astCompiler.compile(text);
	  }
	};
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts Angular {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'angular'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('angular');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 * @this
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cache = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  *
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in Angular expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensively, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    return $parse;
	
	    function $parse(exp, interceptorFn) {
	      var parsedExpression, oneTime, cacheKey;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	              oneTime = true;
	              exp = exp.substring(2);
	            }
	            var lexer = new Lexer($parseOptions);
	            var parser = new Parser(lexer, $filter, $parseOptions);
	            parsedExpression = parser.parse(exp);
	            if (parsedExpression.constant) {
	              parsedExpression.$$watchDelegate = constantWatchDelegate;
	            } else if (oneTime) {
	              parsedExpression.$$watchDelegate = parsedExpression.literal ?
	                  oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
	            } else if (parsedExpression.inputs) {
	              parsedExpression.$$watchDelegate = inputsWatchDelegate;
	            }
	            cache[cacheKey] = parsedExpression;
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object') {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      // eslint-disable-next-line no-self-compare
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i]))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var unwatch, lastValue;
	      if (parsedExpression.inputs) {
	        unwatch = inputsWatchDelegate(scope, oneTimeListener, objectEquality, parsedExpression, prettyPrintExpression);
	      } else {
	        unwatch = scope.$watch(oneTimeWatch, oneTimeListener, objectEquality);
	      }
	      return unwatch;
	
	      function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }
	      function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener(value, old, scope);
	        }
	        if (isDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isDefined(lastValue)) {
	              unwatch();
	            }
	          });
	        }
	      }
	    }
	
	    function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener(value, old, scope);
	        }
	        if (isAllDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isAllDefined(lastValue)) unwatch();
	          });
	        }
	      }, objectEquality);
	
	      return unwatch;
	
	      function isAllDefined(value) {
	        var allDefined = true;
	        forEach(value, function(val) {
	          if (!isDefined(val)) allDefined = false;
	        });
	        return allDefined;
	      }
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	      var watchDelegate = parsedExpression.$$watchDelegate;
	      var useInputs = false;
	
	      var regularWatch =
	          watchDelegate !== oneTimeLiteralWatchDelegate &&
	          watchDelegate !== oneTimeWatchDelegate;
	
	      var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value, scope, locals);
	      } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
	        var value = parsedExpression(scope, locals, assign, inputs);
	        var result = interceptorFn(value, scope, locals);
	        // we only return the interceptor's result if the
	        // initial value is defined (for bind-once)
	        return isDefined(value) ? result : value;
	      };
	
	      // Propagate $$watchDelegates other then inputsWatchDelegate
	      useInputs = !parsedExpression.inputs;
	      if (parsedExpression.$$watchDelegate &&
	          parsedExpression.$$watchDelegate !== inputsWatchDelegate) {
	        fn.$$watchDelegate = parsedExpression.$$watchDelegate;
	        fn.inputs = parsedExpression.inputs;
	      } else if (!interceptorFn.$stateful) {
	        // If there is an interceptor, but no watchDelegate then treat the interceptor like
	        // we treat filters - it is assumed to be a pure function unless flagged with $stateful
	        fn.$$watchDelegate = inputsWatchDelegate;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	      }
	
	      return fn;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
	 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * # $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * # The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * # The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
	 *   arguments are optional.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * # Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * # Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in angular, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * # Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	/**
	 * @ngdoc provider
	 * @name $qProvider
	 * @this
	 *
	 * @description
	 */
	function $QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  /**
	   * @ngdoc method
	   * @name $qProvider#errorOnUnhandledRejections
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
	   * This feature is enabled by default.
	   *
	   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
	   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
	   *    chaining otherwise.
	   */
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/** @this */
	function $$QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 @ param {=boolean} errorOnUnhandledRejections Whether an error should be generated on unhandled
	 *     promises rejections.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
	  var $qMinErr = minErr('$q', TypeError);
	  var queueSize = 0;
	  var checkQueue = [];
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  function defer() {
	    return new Deferred();
	  }
	
	  function Deferred() {
	    var promise = this.promise = new Promise();
	    //Non prototype methods necessary to support unbound execution :/
	    this.resolve = function(val) { resolvePromise(promise, val); };
	    this.reject = function(reason) { rejectPromise(promise, reason); };
	    this.notify = function(progress) { notifyPromise(promise, progress); };
	  }
	
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Promise();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result;
	    },
	
	    'catch': function(callback) {
	      return this.then(null, callback);
	    },
	
	    'finally': function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, resolve, callback);
	      }, function(error) {
	        return handleCallback(error, reject, callback);
	      }, progressBack);
	    }
	  });
	
	  function processQueue(state) {
	    var fn, promise, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    try {
	      for (var i = 0, ii = pending.length; i < ii; ++i) {
	        state.pur = true;
	        promise = pending[i][0];
	        fn = pending[i][state.status];
	        try {
	          if (isFunction(fn)) {
	            resolvePromise(promise, fn(state.value));
	          } else if (state.status === 1) {
	            resolvePromise(promise, state.value);
	          } else {
	            rejectPromise(promise, state.value);
	          }
	        } catch (e) {
	          rejectPromise(promise, e);
	        }
	      }
	    } finally {
	      --queueSize;
	      if (errorOnUnhandledRejections && queueSize === 0) {
	        nextTick(processChecks);
	      }
	    }
	  }
	
	  function processChecks() {
	    // eslint-disable-next-line no-unmodified-loop-condition
	    while (!queueSize && checkQueue.length) {
	      var toCheck = checkQueue.shift();
	      if (!toCheck.pur) {
	        toCheck.pur = true;
	        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
	        if (toCheck.value instanceof Error) {
	          exceptionHandler(toCheck.value, errorMessage);
	        } else {
	          exceptionHandler(errorMessage);
	        }
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !state.pur) {
	      if (queueSize === 0 && checkQueue.length === 0) {
	        nextTick(processChecks);
	      }
	      checkQueue.push(state);
	    }
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    ++queueSize;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function resolvePromise(promise, val) {
	    if (promise.$$state.status) return;
	    if (val === promise) {
	      $$reject(promise, $qMinErr(
	        'qcycle',
	        'Expected promise to be resolved with value other than itself \'{0}\'',
	        val));
	    } else {
	      $$resolve(promise, val);
	    }
	
	  }
	
	  function $$resolve(promise, val) {
	    var then;
	    var done = false;
	    try {
	      if (isObject(val) || isFunction(val)) then = val.then;
	      if (isFunction(then)) {
	        promise.$$state.status = -1;
	        then.call(val, doResolve, doReject, doNotify);
	      } else {
	        promise.$$state.value = val;
	        promise.$$state.status = 1;
	        scheduleProcessQueue(promise.$$state);
	      }
	    } catch (e) {
	      doReject(e);
	    }
	
	    function doResolve(val) {
	      if (done) return;
	      done = true;
	      $$resolve(promise, val);
	    }
	    function doReject(val) {
	      if (done) return;
	      done = true;
	      $$reject(promise, val);
	    }
	    function doNotify(progress) {
	      notifyPromise(promise, progress);
	    }
	  }
	
	  function rejectPromise(promise, reason) {
	    if (promise.$$state.status) return;
	    $$reject(promise, reason);
	  }
	
	  function $$reject(promise, reason) {
	    promise.$$state.value = reason;
	    promise.$$state.status = 2;
	    scheduleProcessQueue(promise.$$state);
	  }
	
	  function notifyPromise(promise, progress) {
	    var callbacks = promise.$$state.pending;
	
	    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
	      nextTick(function() {
	        var callback, result;
	        for (var i = 0, ii = callbacks.length; i < ii; i++) {
	          result = callbacks[i][0];
	          callback = callbacks[i][3];
	          try {
	            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
	          } catch (e) {
	            exceptionHandler(e);
	          }
	        }
	      });
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  function reject(reason) {
	    var result = new Promise();
	    rejectPromise(result, reason);
	    return result;
	  }
	
	  function handleCallback(value, resolver, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return reject(e);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return resolver(value);
	      }, reject);
	    } else {
	      return resolver(value);
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  function when(value, callback, errback, progressBack) {
	    var result = new Promise();
	    resolvePromise(result, value);
	    return result.then(callback, errback, progressBack);
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var result = new Promise(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        results[key] = value;
	        if (!(--counter)) resolvePromise(result, results);
	      }, function(reason) {
	        rejectPromise(result, reason);
	      });
	    });
	
	    if (counter === 0) {
	      resolvePromise(result, results);
	    }
	
	    return result;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#race
	   * @kind function
	   *
	   * @description
	   * Returns a promise that resolves or rejects as soon as one of those promises
	   * resolves or rejects, with the value or reason from that promise.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
	   * resolves or rejects, with the value or reason from that promise.
	   */
	
	  function race(promises) {
	    var deferred = defer();
	
	    forEach(promises, function(promise) {
	      when(promise).then(deferred.resolve, deferred.reject);
	    });
	
	    return deferred.promise;
	  }
	
	  function $Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
	    }
	
	    var promise = new Promise();
	
	    function resolveFn(value) {
	      resolvePromise(promise, value);
	    }
	
	    function rejectFn(reason) {
	      rejectPromise(promise, reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return promise;
	  }
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	  $Q.race = race;
	
	  return $Q;
	}
	
	/** @this */
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @this
	 *
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      // Support: IE 9 only
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        if ($scope.$$childHead) {
	          cleanUpScope($scope.$$childHead);
	        }
	        if ($scope.$$nextSibling) {
	          cleanUpScope($scope.$$nextSibling);
	        }
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * # Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - This should not be used to watch for changes in objects that are
	       *   or contain [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * # Example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, listener, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: listener,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!isFunction(listener)) {
	          watcher.fn = noop;
	        }
	
	        if (!array) {
	          array = scope.$$watchers = [];
	          array.$$digestWatchIndex = -1;
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        array.$$digestWatchIndex++;
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          var index = arrayRemove(array, watcher);
	          if (index >= 0) {
	            incrementWatchersCount(scope, -1);
	            if (index < array.$$digestWatchIndex) {
	              array.$$digestWatchIndex--;
	            }
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
	       *   values are examined for changes on every call to `$digest`.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
	            newValues[i] = value;
	            oldValues[i] = oldValue;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          if (firstRun) {
	            firstRun = false;
	            listener(newValues, newValues, self);
	          } else {
	            listener(newValues, oldValues, self);
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * # Example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        $watchCollectionInterceptor.$stateful = true;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              // eslint-disable-next-line no-self-compare
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  // eslint-disable-next-line no-self-compare
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * # Example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            dirty, ttl = TTL,
	            next, current, target = this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $applyAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              asyncTask.scope.$eval(asyncTask.expression, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = current.$$watchers)) {
	              // process our watches
	              watchers.$$digestWatchIndex = watchers.length;
	              while (watchers.$$digestWatchIndex--) {
	                try {
	                  watch = watchers[watchers.$$digestWatchIndex];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (isNumberNaN(value) && isNumberNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            if (!(next = ((current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	      },
	
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating Angular
	       * expressions.
	       *
	       * # Example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          });
	        }
	
	        asyncQueue.push({scope: this, expression: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in angular from outside of the angular
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the angular framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * ## Life cycle
	       *
	       * # Pseudo-Code of `$apply()`
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            // eslint-disable-next-line no-unsafe-finally
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        if (expr) {
	          applyAsyncQueue.push($applyAsyncExpression);
	        }
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            namedListeners[indexOfListener] = null;
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            event.currentScope = null;
	            return event;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        });
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of Angular application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @this
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	  var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
	    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationWhitelist = regexp;
	      return this;
	    }
	    return aHrefSanitizationWhitelist;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationWhitelist = regexp;
	      return this;
	    }
	    return imgSrcSanitizationWhitelist;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isImage) {
	      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
	      var normalizedVal;
	      normalizedVal = urlResolve(uri).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* exported $SceProvider, $SceDelegateProvider */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  HTML: 'html',
	  CSS: 'css',
	  URL: 'url',
	  // RESOURCE_URL is a subtype of URL used in contexts where a privileged resource is sourced from a
	  // url.  (e.g. ng-include, script src, templateUrl)
	  RESOURCE_URL: 'resourceUrl',
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;
	
	function snakeToCamel(name) {
	  return name
	    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace(/\\\*\\\*/g, '.*').
	                  replace(/\\\*/g, '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @this
	 *
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate} service.  This allows one to get/set the whitelists and blacklists used to ensure
	 * that the URLs used for sourcing Angular templates are safe.  Refer {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist} and
	 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 *
	 * For the general details about this service in Angular, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var resourceUrlWhitelist = ['self'],
	      resourceUrlBlacklist = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	   *    provided.  This must be an array or null.  A snapshot of this array is used so further
	   *    changes to the array are ignored.
	   *
	   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *    allowed in this array.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** an empty whitelist array will block all URLs!
	   *    </div>
	   *
	   * @return {Array} the currently set whitelist array.
	   *
	   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	   * same origin resource requests.
	   *
	   * @description
	   * Sets/Gets the whitelist of trusted resource URLs.
	   */
	  this.resourceUrlWhitelist = function(value) {
	    if (arguments.length) {
	      resourceUrlWhitelist = adjustMatchers(value);
	    }
	    return resourceUrlWhitelist;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	   *    provided.  This must be an array or null.  A snapshot of this array is used so further
	   *    changes to the array are ignored.
	   *
	   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *    allowed in this array.
	   *
	   *    The typical usage for the blacklist is to **block
	   *    [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *    these would otherwise be trusted but actually return content from the redirected domain.
	   *
	   *    Finally, **the blacklist overrides the whitelist** and has the final say.
	   *
	   * @return {Array} the currently set blacklist array.
	   *
	   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	   * is no blacklist.)
	   *
	   * @description
	   * Sets/Gets the blacklist of trusted resource URLs.
	   */
	
	  this.resourceUrlBlacklist = function(value) {
	    if (arguments.length) {
	      resourceUrlBlacklist = adjustMatchers(value);
	    }
	    return resourceUrlBlacklist;
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the whitelist allows this url.
	      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
	        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the blacklist blocked this url.
	        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
	          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns an object that is trusted by angular for use in specified strict
	     * contextual escaping contexts (such as ng-bind-html, ng-include, any src
	     * attribute interpolation, any dom event binding attribute interpolation
	     * such as for onclick,  etc.) that uses the provided value.
	     * See {@link ng.$sce $sce} for enabling strict contextual escaping.
	     *
	     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	     *   resourceUrl, html, js and css.
	     * @param {*} value The value that that should be considered trusted/safe.
	     * @returns {*} A value that can be used to stand in for the provided `value` in places
	     * where Angular expects a $sce.trustAs() return value.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, returns it as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *      call or anything else.
	     * @returns {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Takes the result of a {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call and
	     * returns the originally supplied value if the queried context type is a supertype of the
	     * created type.  If this condition isn't satisfied, throws an exception.
	     *
	     * <div class="alert alert-danger">
	     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
	     * (XSS) vulnerability in your application.
	     * </div>
	     *
	     * @param {string} type The kind of context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call.
	     * @returns {*} The value the was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if valid in this context.  Otherwise, throws an exception.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	      // If we get here, then we may only take one of two actions.
	      // 1. sanitize the value for the requested type, or
	      // 2. throw an exception.
	      if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        return htmlSanitizer(maybeTrusted);
	      }
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @this
	 *
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * # Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS requires bindings in certain
	 * contexts to result in a value that is marked as safe to use for that context.  One example of
	 * such a context is binding arbitrary html controlled by the user via `ng-bind-html`.  We refer
	 * to these contexts as privileged or SCE contexts.
	 *
	 * As of version 1.2, Angular ships with SCE enabled by default.
	 *
	 * Note:  When enabled (the default), IE<11 in quirks mode is not supported.  In this mode, IE<11 allow
	 * one to execute arbitrary javascript by the use of the expression() syntax.  Refer
	 * <http://blogs.msdn.com/b/ie/archive/2008/10/16/ending-expressions.aspx> to learn more about them.
	 * You can ensure your document is in standards mode and not quirks mode by adding `<!doctype html>`
	 * to the top of your HTML document.
	 *
	 * SCE assists in writing code in a way that (a) is secure by default and (b) makes auditing for
	 * security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV.
	 * In a more realistic example, one may be rendering user comments, blog articles, etc. via
	 * bindings.  (HTML is just one example of a context where rendering user controlled input creates
	 * security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, you want to ensure that any such bindings are disallowed unless you can
	 * determine that something explicitly says it's safe to use a value for binding in that
	 * context.  You can then audit your code (a simple grep would do) to ensure that this is only done
	 * for those values that you can easily tell are safe - because they were received from your server,
	 * sanitized by your library, etc.  You can organize your codebase to help with this - perhaps
	 * allowing only the files in a specific directory to do this.  Ensuring that the internal API
	 * exposed by that code doesn't markup arbitrary values as safe then becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * obtain values that will be accepted by SCE / privileged contexts.
	 *
	 *
	 * ## How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs the
	 * {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ## Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, Angular only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ## This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (remember to include the `ngSanitize` module) (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works.
	 *
	 * Additionally, `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
	 * through {@link ng.$sce#getTrusted $sce.getTrusted}.  SCE doesn't play a role here.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ## What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=` and `<img src=` sanitize their urls and don't constitute an SCE context. |
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG`, `VIDEO`, `AUDIO`, `SOURCE`, and `TRACK` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
	 *
	 * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      in a whitelist.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ## Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function AppController($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
	 *           self.userComments = response.data;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE.
	   * @return {boolean} true if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the a value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way.  In some future, we
	   * may not use inheritance anymore.  That is OK because no code outside of
	   * sce.js and sceSpecs.js would need to be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Support: IE 9-11 only
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} true if SCE is enabled, false otherwise.  If you want to set the value, you
	     * have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The kind of SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.  As such,
	     * returns an object that is trusted by angular for use in specified strict contextual
	     * escaping contexts (such as ng-bind-html, ng-include, any src attribute
	     * interpolation, any dom event binding attribute interpolation such as for onclick,  etc.)
	     * that uses the provided value.  See * {@link ng.$sce $sce} for enabling strict contextual
	     * escaping.
	     *
	     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	     *   resourceUrl, html, js and css.
	     * @param {*} value The value that that should be considered trusted/safe.
	     * @returns {*} A value that can be used to stand in for the provided `value` in places
	     * where Angular expects a $sce.trustAs() return value.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedHtml
	     *     $sce.getTrustedHtml(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedUrl
	     *     $sce.getTrustedUrl(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedResourceUrl
	     *     $sce.getTrustedResourceUrl(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the return
	     *     value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedJs
	     *     $sce.getTrustedJs(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes the result of a {@link ng.$sce#trustAs `$sce.trustAs`}() call and returns the
	     * originally supplied value if the queried context type is a supertype of the created type.
	     * If this condition isn't satisfied, throws an exception.
	     *
	     * @param {string} type The kind of context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs `$sce.trustAs`}
	     *                         call.
	     * @returns {*} The value the was originally provided to
	     *              {@link ng.$sce#trustAs `$sce.trustAs`} if valid in this context.
	     *              Otherwise, throws an exception.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/* exported $SnifferProvider */
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 * @this
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`.
	        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
	        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
	        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
	        // (see https://developer.chrome.com/apps/manifest/sandbox).
	        isChromePackagedApp =
	            $window.chrome &&
	            ($window.chrome.app && $window.chrome.app.runtime ||
	                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false;
	
	    if (bodyStyle) {
	      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
	      // Mentioned browsers need a -webkit- prefix for transitions & animations.
	      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
	      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      hasEvent: function(event) {
	        // Support: IE 9-11 only
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	var $templateRequestMinErr = minErr('$compile');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @this
	 *
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
	    function($exceptionHandler, $templateCache, $http, $q, $sce) {
	
	      function handleRequestFn(tpl, ignoreRequestError) {
	        handleRequestFn.totalPendingRequests++;
	
	        // We consider the template cache holds only trusted templates, so
	        // there's no need to go through whitelisting again for keys that already
	        // are included in there. This also makes Angular accept any script
	        // directive, no matter its name. However, we still need to unwrap trusted
	        // types.
	        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	          tpl = $sce.getTrustedResourceUrl(tpl);
	        }
	
	        var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	        if (isArray(transformResponse)) {
	          transformResponse = transformResponse.filter(function(transformer) {
	            return transformer !== defaultHttpResponseTransform;
	          });
	        } else if (transformResponse === defaultHttpResponseTransform) {
	          transformResponse = null;
	        }
	
	        return $http.get(tpl, extend({
	            cache: $templateCache,
	            transformResponse: transformResponse
	          }, httpOptions))
	          .finally(function() {
	            handleRequestFn.totalPendingRequests--;
	          })
	          .then(function(response) {
	            $templateCache.put(tpl, response.data);
	            return response.data;
	          }, handleError);
	
	        function handleError(resp) {
	          if (!ignoreRequestError) {
	            resp = $templateRequestMinErr('tpload',
	                'Failed to load template: {0} (HTTP status: {1} {2})',
	                tpl, resp.status, resp.statusText);
	
	            $exceptionHandler(resp);
	          }
	
	          return $q.reject(resp);
	        }
	      }
	
	      handleRequestFn.totalPendingRequests = 0;
	
	      return handleRequestFn;
	    }
	  ];
	}
	
	/** @this */
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) !== -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when $timeout and $http requests are completed.
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	/** @this */
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $timeout
	      *
	      * @description
	      * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	      * block and delegates any exceptions to
	      * {@link ng.$exceptionHandler $exceptionHandler} service.
	      *
	      * The return value of calling `$timeout` is a promise, which will be resolved when
	      * the delay has passed and the timeout function, if provided, is executed.
	      *
	      * To cancel a timeout request, call `$timeout.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	      * synchronously flush the queue of deferred functions.
	      *
	      * If you only want a promise that will be resolved after some specified delay
	      * then you can call `$timeout` without the `fn` function.
	      *
	      * @param {function()=} fn A function, whose execution should be delayed.
	      * @param {number=} [delay=0] Delay in milliseconds.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	      *   will be resolved with the return value of the `fn` function.
	      *
	      */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        } finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay);
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $timeout#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`. As a result of this, the promise will be
	      * resolved with a rejection.
	      *
	      * @param {Promise=} promise Promise returned by the `$timeout` function.
	      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	      *   canceled.
	      */
	    timeout.cancel = function(promise) {
	      if (promise && promise.$$timeoutId in deferreds) {
	        // Timeout cancels should not report an unhandled promise.
	        deferreds[promise.$$timeoutId].promise.catch(noop);
	        deferreds[promise.$$timeoutId].reject('canceled');
	        delete deferreds[promise.$$timeoutId];
	        return $browser.defer.cancel(promise.$$timeoutId);
	      }
	      return false;
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement('a');
	var originUrl = urlResolve(window.location.href);
	
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string} url The URL to be parsed.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description    |
	 *   |---------------|----------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol including the trailing colon                              |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol
	 *   | hostname      | The hostname
	 *   | port          | The port, without ":"
	 *   | pathname      | The pathname, beginning with "/"
	 *
	 */
	function urlResolve(url) {
	  var href = url;
	
	  // Support: IE 9-11 only
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute('href', href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: urlParsingNode.hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
	  return (parsed.protocol === originUrl.protocol &&
	          parsed.host === originUrl.host);
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 * @this
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In angular we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample" name="window-service">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeGetCookie(rawDocument) {
	    try {
	      return rawDocument.cookie || '';
	    } catch (e) {
	      return '';
	    }
	  }
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = safeGetCookie(rawDocument);
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	/** @this */
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how angular filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the Angular Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * They can be used in view templates, controllers or services.Angular comes
	 * with a collection of [built-in filters](api/ng/filter), but it is easy to
	 * define your own as well.
	 *
	 * The general syntax in templates is as follows:
	 *
	 * ```html
	 * {{ expression [| filter_name[:parameter_value] ... ] }}
	 * ```
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	/** @this */
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
	 *     against any property of the object or its nested object properties. That's equivalent to the
	 *     simple substring match with a `string` as described above. The special property name can be
	 *     overwritten, using the `anyPropertyKey` parameter.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
	 *     determining if the expected value (from the filter expression) and actual value (from
	 *     the object in the array) should be considered a match.
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false`: A short hand for a function which will look for a substring match in a case
	 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
	 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 *
	 *   Defaults to `false`.
	 *
	 * @param {string} [anyPropertyKey] The special property name that matches against any property.
	 *     By default `$`.
	 *
	 * @example
	   <example name="filter-filter">
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	
	function filterFilter() {
	  return function(array, expression, comparator, anyPropertyKey) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    anyPropertyKey = anyPropertyKey || '$';
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        // falls through
	      case 'object':
	        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
	    }
	    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          if ((key.charAt(0) !== '$') && deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === anyPropertyKey;
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample" name="currency-filter">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser === 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(/\u00A4/g, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample" name="number-filter">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }
	
	  if (i === (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset === -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? '+' : '';
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))(.*)/,
	    NUMBER_STRING = /^-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example name="filter-date">
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if ((match = string.match(R_ISO8601_STR))) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example name="filter-json">
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @see angular.uppercase
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements are
	 * taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
	 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
	 * it is converted to a string.
	 *
	 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
	 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
	 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
	 *     less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample" name="limit-to-filter">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNumberNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArrayLike(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return sliceFn(input, begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return sliceFn(input, limit, input.length);
	      } else {
	        return sliceFn(input, Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	function sliceFn(input, begin, end) {
	  if (isString(input)) return input.slice(begin, end);
	
	  return slice.call(input, begin, end);
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
	 * function based on the values computed using the `expression` predicate.
	 *
	 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
	 * `[{id: 'bar'}, {id: 'foo'}]`.
	 *
	 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
	 * String, etc).
	 *
	 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
	 * for the preceding one. The `expression` is evaluated against each item and the output is used
	 * for comparing with other items.
	 *
	 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
	 * ascending order.
	 *
	 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
	 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
	 * strings alphabetically).
	 *
	 * ### Under the hood
	 *
	 * Ordering the specified `collection` happens in two phases:
	 *
	 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
	 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
	 *    through a predicate that extracts the value of the `label` property, would be transformed to:
	 *    ```
	 *    {
	 *      value: 'foo',
	 *      type: 'string',
	 *      index: ...
	 *    }
	 *    ```
	 * 2. The comparator function is used to sort the items, based on the derived values, types and
	 *    indices.
	 *
	 * If you use a custom comparator, it will be called with pairs of objects of the form
	 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
	 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
	 * second, or `1` otherwise.
	 *
	 * In order to ensure that the sorting will be deterministic across platforms, if none of the
	 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
	 * dummy predicate that returns the item's index as `value`.
	 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
	 *
	 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
	 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
	 * it to the comparator. The following rules govern the conversion:
	 *
	 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
	 *    used instead.<br />
	 *    (If the object has a `valueOf()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
	 *    returns a primitive, its return value will be used instead.<br />
	 *    (If the object has a `toString()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 3. No conversion; the object itself is used.
	 *
	 * ### The default comparator
	 *
	 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
	 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
	 * using their index in the original collection, and sorts values of different types by type.
	 *
	 * More specifically, it follows these steps to determine the relative order of items:
	 *
	 * 1. If the compared values are of different types, compare the types themselves alphabetically.
	 * 2. If both values are of type `string`, compare them alphabetically in a case- and
	 *    locale-insensitive way.
	 * 3. If both values are objects, compare their indices instead.
	 * 4. Otherwise, return:
	 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
	 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
	 *    -  `1`, otherwise.
	 *
	 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
	 *           saved as numbers and not strings.
	 * **Note:** For the purpose of sorting, `null` values are treated as the string `'null'` (i.e.
	 *           `type: 'string'`, `value: 'null'`). This may cause unexpected sort order relative to
	 *           other values.
	 *
	 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
	 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
	 *    predicates) to be used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `Function`: A getter function. This function will be called with each item as argument and
	 *      the return value will be used for sorting.
	 *    - `string`: An Angular expression. This expression will be evaluated against each item and the
	 *      result will be used for sorting. For example, use `'label'` to sort by a property called
	 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
	 *      property.<br />
	 *      (The result of a constant expression is interpreted as a property name to be used for
	 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
	 *      property called `special name`.)<br />
	 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
	 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
	 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
	 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
	 *      relative order of two items, the next predicate is used as a tie-breaker.
	 *
	 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse - If `true`, reverse the sorting order.
	 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
	 *    value pairs. If omitted, the built-in comparator will be used.
	 *
	 * @returns {Array} - The sorted array.
	 *
	 *
	 * @example
	 * ### Ordering a table with `ngRepeat`
	 *
	 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
	 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
	 * it defaults to the built-in comparator.
	 *
	   <example name="orderBy-static" module="orderByExample1">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friends">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample1', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var names = element.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by age in reverse order', function() {
	         expect(names.get(0).getText()).toBe('Adam');
	         expect(names.get(1).getText()).toBe('Julie');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('John');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Changing parameters dynamically
	 *
	 * All parameters can be changed dynamically. The next example shows how you can make the columns of
	 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
	 *
	   <example name="orderBy-dynamic" module="orderByExample2">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample2', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = friends;
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using `orderBy` inside a controller
	 *
	 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
	 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
	 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
	 *
	   <example name="orderBy-call-manually" module="orderByExample3">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="sortBy(null)">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample3', [])
	         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
	                 ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using a custom comparator
	 *
	 * If you have very specific requirements about the way items are sorted, you can pass your own
	 * comparator function. For example, you might need to compare some strings in a locale-sensitive
	 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
	 * argument - passing `false` retains the default sorting order, i.e. ascending.)
	 *
	   <example name="orderBy-custom-comparator" module="orderByExample4">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <div class="friends-container custom-comparator">
	           <h3>Locale-sensitive Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	         <div class="friends-container default-comparator">
	           <h3>Default Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample4', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   favoriteLetter: 'Ä'},
	             {name: 'Mary',   favoriteLetter: 'Ü'},
	             {name: 'Mike',   favoriteLetter: 'Ö'},
	             {name: 'Adam',   favoriteLetter: 'H'},
	             {name: 'Julie',  favoriteLetter: 'Z'}
	           ];
	
	           $scope.localeSensitiveComparator = function(v1, v2) {
	             // If we don't get strings, just compare by index
	             if (v1.type !== 'string' || v2.type !== 'string') {
	               return (v1.index < v2.index) ? -1 : 1;
	             }
	
	             // Compare strings alphabetically, taking locale into account
	             return v1.value.localeCompare(v2.value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends-container {
	         display: inline-block;
	         margin: 0 30px;
	       }
	
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var container = element(by.css('.custom-comparator'));
	       var names = container.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
	         expect(names.get(0).getText()).toBe('John');
	         expect(names.get(1).getText()).toBe('Adam');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 *
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder, compareFn) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate);
	
	    var descending = reverseOrder ? -1 : 1;
	
	    // Define the `compare()` function. Use a default comparator if none is specified.
	    var compare = isFunction(compareFn) ? compareFn : defaultCompare;
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
	      // This will be used to keep the sort stable when none of the input predicates can
	      // distinguish between two elements.
	      return {
	        value: value,
	        tieBreaker: {value: index, type: 'number', index: index},
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      for (var i = 0, ii = predicates.length; i < ii; i++) {
	        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
	        if (result) {
	          return result * predicates[i].descending * descending;
	        }
	      }
	
	      return compare(v1.tieBreaker, v2.tieBreaker) * descending;
	    }
	  };
	
	  function processPredicates(sortPredicates) {
	    return sortPredicates.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
	          descending = predicate.charAt(0) === '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return {get: get, descending: descending};
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value) {
	    // If `valueOf` is a valid function use that
	    if (isFunction(value.valueOf)) {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	
	    return value;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'string';
	      value = 'null';
	    } else if (type === 'object') {
	      value = objectValue(value);
	    }
	    return {value: value, type: type, index: index};
	  }
	
	  function defaultCompare(v1, v2) {
	    var result = 0;
	    var type1 = v1.type;
	    var type2 = v2.type;
	
	    if (type1 === type2) {
	      var value1 = v1.value;
	      var value2 = v2.value;
	
	      if (type1 === 'string') {
	        // Compare strings case-insensitively
	        value1 = value1.toLowerCase();
	        value2 = value2.toLowerCase();
	      } else if (type1 === 'object') {
	        // For basic objects, use the position of the object
	        // in the collection instead of the value
	        if (isObject(value1)) value1 = v1.index;
	        if (isObject(value2)) value2 = v2.index;
	      }
	
	      if (value1 !== value2) {
	        result = value1 < value2 ? -1 : 1;
	      }
	    } else {
	      result = type1 < type2 ? -1 : 1;
	    }
	
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html a tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * Angular has a chance to replace the `{{hash}}` markup with its
	 * value. Until Angular replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example name="ng-href">
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-disabled">
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-checked">
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="master"></label><br/>
	        <input id="checkSlave" type="checkbox" ng-checked="master" aria-label="Slave input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
	          element(by.model('master')).click();
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
	 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readonly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-readonly">
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm Angular" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * <div class="alert alert-warning">
	 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
	 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
	 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
	 *   selected options.
	 * </div>
	 *
	 * @example
	    <example name="ng-selected">
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * ## A note about browser compatibility
	 *
	 * Edge, Firefox, and Internet Explorer do not support the `details` element, it is
	 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
	 *
	 * @example
	     <example name="ng-open">
	       <file name="index.html">
	         <label>Check me check multiple: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>Show/Hide me</summary>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName === 'multiple') return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set('ngPattern', new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // Support: IE 9-11 only
	          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // We use attr[attrName] value since $set can sanitize the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  };
	});
	
	/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop
	},
	PENDING_CLASS = 'ng-pending',
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $pending True if at least one containing control or form is pending.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $error Is an object hash, containing references to controls or
	 *  forms with failing validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for given error name.
	 *
	 *  Built-in validation tokens:
	 *
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController($element, $attrs, $scope, $animate, $interpolate) {
	  this.$$controls = [];
	
	  // init state
	  this.$error = {};
	  this.$$success = {};
	  this.$pending = undefined;
	  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
	  this.$dirty = false;
	  this.$pristine = true;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$submitted = false;
	  this.$$parentForm = nullFormCtrl;
	
	  this.$$element = $element;
	  this.$$animate = $animate;
	
	  setupValidity(this);
	}
	
	FormController.prototype = {
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  $rollbackViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$commitViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  $addControl: function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    this.$$controls.push(control);
	
	    if (control.$name) {
	      this[control.$name] = control;
	    }
	
	    control.$$parentForm = this;
	  },
	
	  // Private API: rename a form control
	  $$renameControl: function(control, newName) {
	    var oldName = control.$name;
	
	    if (this[oldName] === control) {
	      delete this[oldName];
	    }
	    this[newName] = control;
	    control.$name = newName;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  $removeControl: function(control) {
	    if (control.$name && this[control.$name] === control) {
	      delete this[control.$name];
	    }
	    forEach(this.$pending, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$error, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$$success, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	
	    arrayRemove(this.$$controls, control);
	    control.$$parentForm = nullFormCtrl;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  $setDirty: function() {
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
	   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
	   * state to false.
	   *
	   * This method will also propagate to all the controls contained in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  $setPristine: function() {
	    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$submitted = false;
	    forEach(this.$$controls, function(control) {
	      control.$setPristine();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  $setUntouched: function() {
	    forEach(this.$$controls, function(control) {
	      control.$setUntouched();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its submitted state.
	   */
	  $setSubmitted: function() {
	    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
	    this.$submitted = true;
	    this.$$parentForm.$setSubmitted();
	  }
	};
	
	/**
	 * @ngdoc method
	 * @name form.FormController#$setValidity
	 *
	 * @description
	 * Sets the validity of a form control.
	 *
	 * This method will also propagate to parent forms.
	 */
	addSetValidityMethod({
	  clazz: FormController,
	  set: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      object[property] = [controller];
	    } else {
	      var index = list.indexOf(controller);
	      if (index === -1) {
	        list.push(controller);
	      }
	    }
	  },
	  unset: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      return;
	    }
	    arrayRemove(list, controller);
	    if (list.length === 0) {
	      delete object[property];
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
	 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
	 * sub-group of controls needs to be determined.
	 *
	 * Note: the purpose of `ngForm` is to group controls,
	 * but not to be a replacement for the `<form>` tag with all of its capabilities
	 * (e.g. posting to the server, ...).
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * # Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In Angular, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * Angular provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * # CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * # Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side Angular applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, Angular prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ## Animation Hooks
	 *
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              formElement[0].addEventListener('submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  formElement[0].removeEventListener('submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	
	
	// helper methods
	function setupValidity(instance) {
	  instance.$$classCache = {};
	  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
	}
	function addSetValidityMethod(context) {
	  var clazz = context.clazz,
	      set = context.set,
	      unset = context.unset;
	
	  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet(this, '$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(this.$error, validationErrorKey, controller);
	      unset(this.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(this.$error, validationErrorKey, controller);
	        set(this.$$success, validationErrorKey, controller);
	      } else {
	        set(this.$error, validationErrorKey, controller);
	        unset(this.$$success, validationErrorKey, controller);
	      }
	    }
	    if (this.$pending) {
	      cachedToggleClass(this, PENDING_CLASS, true);
	      this.$valid = this.$invalid = undefined;
	      toggleValidationCss(this, '', null);
	    } else {
	      cachedToggleClass(this, PENDING_CLASS, false);
	      this.$valid = isObjectEmpty(this.$error);
	      this.$invalid = !this.$valid;
	      toggleValidationCss(this, '', this.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in this.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (this.$pending && this.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (this.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (this.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(this, validationErrorKey, combinedState);
	    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
	  };
	
	  function createAndSet(ctrl, name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(ctrl, name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(ctrl, className, switchValue) {
	    if (switchValue && !ctrl.$$classCache[className]) {
	      ctrl.$$animate.addClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = true;
	    } else if (!switchValue && ctrl.$$classCache[className]) {
	      ctrl.$$animate.removeClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/* global
	  VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  ngModelMinErr: false
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	// eslint-disable-next-line max-len
	var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise Angular will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise Angular will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   * ## Issues with HTML5 constraint validation
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *    Can be interpolated.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *    Can be interpolated.
	   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
	   *    Can be interpolated.
	   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
	   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue Angular expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var inputs = element.all(by.model('color.name'));
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            inputs.get(0).click();
	            expect(color.getText()).toContain('red');
	
	            inputs.get(1).click();
	            expect(color.getText()).toContain('green');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[range]
	   *
	   * @description
	   * Native range input with validation and transformation.
	   *
	   * The model for the range input must always be a `Number`.
	   *
	   * IE9 and other browsers that do not support the `range` type fall back
	   * to a text input without any default values for `min`, `max` and `step`. Model binding,
	   * validation and number parsing are nevertheless supported.
	   *
	   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
	   * in a way that never allows the input to hold an invalid value. That means:
	   * - any non-numerical value is set to `(max + min) / 2`.
	   * - any numerical value that is less than the current min val, or greater than the current max val
	   * is set to the min / max val respectively.
	   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
	   * is used.
	   *
	   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
	   * for more info.
	   *
	   * This has the following consequences for Angular:
	   *
	   * Since the element value should always reflect the current model value, a range input
	   * will set the bound ngModel expression to the value that the browser has set for the
	   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
	   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
	   * Angular will then set the model to `50`, to prevent input and model value being out of sync.
	   *
	   * That means the model for range will immediately be set to `50` after `ngModel` has been
	   * initialized. It also means a range input can never have the required error.
	   *
	   * This does not only affect changes to the model value, but also to the values of the `min`,
	   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
	   * the input value, Angular will also update the model value.
	   *
	   * Automatic value adjustment also means that a range input element can never have the `required`,
	   * `min`, or `max` errors.
	   *
	   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
	   * when the step value changes dynamically - they do not adjust the element value correctly, but
	   * instead may set the `stepMismatch` error. If that's the case, the Angular will set the `step`
	   * error on the input, and set the model to `undefined`.
	   *
	   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
	   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
	   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
	   *
	   * @param {string}  ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
	   *                  than `min`. Can be interpolated.
	   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
	   *                  Can be interpolated.
	   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
	   *                  Can be interpolated.
	   * @param {string=} ngChange Angular expression to be executed when the ngModel value changes due
	   *                  to user interaction with the input element.
	   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
	   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
	   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
	   *
	   * @example
	      <example name="range-input-directive" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	
	            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   * ## Range Input with ngMin & ngMax attributes
	
	   * @example
	      <example name="range-input-directive-ng" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   */
	  'range': rangeInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputting intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', /** @this */ function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, date) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (date) {
	          map = {
	            yyyy: date.getFullYear(),
	            MM: date.getMonth() + 1,
	            dd: date.getDate(),
	            HH: date.getHours(),
	            mm: date.getMinutes(),
	            ss: date.getSeconds(),
	            sss: date.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
	    badInputChecker(scope, element, attr, ctrl);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	    var timezone = ctrl && ctrl.$options.getOption('timezone');
	    var previousDate;
	
	    ctrl.$$parserName = type;
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        var parsedDate = parseDate(value, previousDate);
	        if (timezone) {
	          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	        }
	        return parsedDate;
	      }
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        if (previousDate && timezone) {
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	        return $filter('date')(value, format, timezone);
	      } else {
	        previousDate = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal;
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
	      };
	      attr.$observe('min', function(val) {
	        minVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal;
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
	      };
	      attr.$observe('max', function(val) {
	        maxVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      return validity.badInput || validity.typeMismatch ? undefined : value;
	    });
	  }
	}
	
	function numberFormatterParser(ctrl) {
	  ctrl.$$parserName = 'number';
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	}
	
	function parseNumberAttrVal(val) {
	  if (isDefined(val) && !isNumber(val)) {
	    val = parseFloat(val);
	  }
	  return !isNumberNaN(val) ? val : undefined;
	}
	
	function isNumberInteger(num) {
	  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
	  // (minus the assumption that `num` is a number)
	
	  // eslint-disable-next-line no-bitwise
	  return (num | 0) === num;
	}
	
	function countDecimals(num) {
	  var numString = num.toString();
	  var decimalSymbolIndex = numString.indexOf('.');
	
	  if (decimalSymbolIndex === -1) {
	    if (-1 < num && num < 1) {
	      // It may be in the exponential notation format (`1e-X`)
	      var match = /e-(\d+)$/.exec(numString);
	
	      if (match) {
	        return Number(match[1]);
	      }
	    }
	
	    return 0;
	  }
	
	  return numString.length - decimalSymbolIndex - 1;
	}
	
	function isValidForStep(viewValue, stepBase, step) {
	  // At this point `stepBase` and `step` are expected to be non-NaN values
	  // and `viewValue` is expected to be a valid stringified number.
	  var value = Number(viewValue);
	
	  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
	  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
	  if (!isNumberInteger(value) || !isNumberInteger(stepBase) || !isNumberInteger(step)) {
	    var decimalCount = Math.max(countDecimals(value), countDecimals(stepBase), countDecimals(step));
	    var multiplier = Math.pow(10, decimalCount);
	
	    value = value * multiplier;
	    stepBase = stepBase * multiplier;
	    step = step * multiplier;
	  }
	
	  return (value - stepBase) % step === 0;
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var minVal;
	  var maxVal;
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    ctrl.$validators.min = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
	    };
	
	    attr.$observe('min', function(val) {
	      minVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    ctrl.$validators.max = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      maxVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.step) || attr.ngStep) {
	    var stepVal;
	    ctrl.$validators.step = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	             isValidForStep(viewValue, minVal || 0, stepVal);
	    };
	
	    attr.$observe('step', function(val) {
	      stepVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	}
	
	function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
	      minVal = supportsRange ? 0 : undefined,
	      maxVal = supportsRange ? 100 : undefined,
	      stepVal = supportsRange ? 1 : undefined,
	      validity = element[0].validity,
	      hasMinAttr = isDefined(attr.min),
	      hasMaxAttr = isDefined(attr.max),
	      hasStepAttr = isDefined(attr.step);
	
	  var originalRender = ctrl.$render;
	
	  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
	    //Browsers that implement range will set these values automatically, but reading the adjusted values after
	    //$render would cause the min / max validators to be applied with the wrong value
	    function rangeRender() {
	      originalRender();
	      ctrl.$setViewValue(element.val());
	    } :
	    originalRender;
	
	  if (hasMinAttr) {
	    ctrl.$validators.min = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMinValidator() { return true; } :
	      // non-support browsers validate the min val
	      function minValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
	      };
	
	    setInitialValueAndObserver('min', minChange);
	  }
	
	  if (hasMaxAttr) {
	    ctrl.$validators.max = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMaxValidator() { return true; } :
	      // non-support browsers validate the max val
	      function maxValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
	      };
	
	    setInitialValueAndObserver('max', maxChange);
	  }
	
	  if (hasStepAttr) {
	    ctrl.$validators.step = supportsRange ?
	      function nativeStepValidator() {
	        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
	        // input element value to a valid value). It's possible that other browsers set the stepMismatch
	        // validity error instead, so we can at least report an error in that case.
	        return !validity.stepMismatch;
	      } :
	      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
	      function stepValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	               isValidForStep(viewValue, minVal || 0, stepVal);
	      };
	
	    setInitialValueAndObserver('step', stepChange);
	  }
	
	  function setInitialValueAndObserver(htmlAttrName, changeFn) {
	    // interpolated attributes set the attribute value only after a digest, but we need the
	    // attribute value when the input is first rendered, so that the browser can adjust the
	    // input value based on the min/max value
	    element.attr(htmlAttrName, attr[htmlAttrName]);
	    attr.$observe(htmlAttrName, changeFn);
	  }
	
	  function minChange(val) {
	    minVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
	      if (minVal > elVal) {
	        elVal = minVal;
	        element.val(elVal);
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function maxChange(val) {
	    maxVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
	      if (maxVal < elVal) {
	        element.val(maxVal);
	        // IE11 and Chrome don't set the value to the minVal when max < min
	        elVal = maxVal < minVal ? minVal : maxVal;
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function stepChange(val) {
	    stepVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
	    if (supportsRange && ctrl.$viewValue !== element.val()) {
	      ctrl.$setViewValue(element.val());
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'url';
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'email';
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    var value;
	    if (element[0].checked) {
	      value = attr.value;
	      if (doTrim) {
	        value = trim(value);
	      }
	      ctrl.$setViewValue(value, ev && ev.type);
	    }
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    if (doTrim) {
	      value = trim(value);
	    }
	    element[0].checked = (value === ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with angular data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *
	 * @knownIssue
	 *
	 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
	 * insert the placeholder value as the textarea's content. If the placeholder value contains
	 * interpolation (`{{ ... }}`), an error will be logged in the console when Angular tries to update
	 * the value of the by-then-removed text node. This doesn't affect the functionality of the
	 * textarea, but can be undesirable.
	 *
	 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
	 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
	 * find more details on `ngAttr` in the
	 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
	 * Developer Guide.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 *
	 * @description
	 * Binds the given expression to the value of the element.
	 *
	 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
	 * {@link select `select`} parent element) is set to the bound value. It is especially useful
	 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * It can also be used to achieve one-way binding of a given expression to an input element
	 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
	 *
	 * @element input
	 * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
	 * and `value` property of the element.
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  /**
	   *  inputs use the value attribute as their default value if the value property is not set.
	   *  Once the value property has been set (by adding input), it will not react to changes to
	   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
	   *  makes it possible to use ngValue as a sort of one-way bind.
	   */
	  function updateElementValue(element, attr, value) {
	    element.prop('value', value);
	    attr.$set('value', value);
	  }
	
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          var value = scope.$eval(attr.ngValue);
	          updateElementValue(elm, attr, value);
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            updateElementValue(elm, attr, value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample" name="ng-bind">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = stringify(value);
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample" name="ng-bind-template">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element input
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	/* exported
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective
	*/
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  var indexWatchExpression;
	
	  return ['$parse', function($parse) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var expression = attr[name].trim();
	        var isOneTime = (expression.charAt(0) === ':') && (expression.charAt(1) === ':');
	
	        var watchInterceptor = isOneTime ? toFlatValue : toClassString;
	        var watchExpression = $parse(expression, watchInterceptor);
	        var watchAction = isOneTime ? ngClassOneTimeWatchAction : ngClassWatchAction;
	
	        var classCounts = element.data('$classCounts');
	        var oldModulo = true;
	        var oldClassString;
	
	        if (!classCounts) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          classCounts = createMap();
	          element.data('$classCounts', classCounts);
	        }
	
	        if (name !== 'ngClass') {
	          if (!indexWatchExpression) {
	            indexWatchExpression = $parse('$index', function moduloTwo($index) {
	              // eslint-disable-next-line no-bitwise
	              return $index & 1;
	            });
	          }
	
	          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
	        }
	
	        scope.$watch(watchExpression, watchAction, isOneTime);
	
	        function addClasses(classString) {
	          classString = digestClassCounts(split(classString), 1);
	          attr.$addClass(classString);
	        }
	
	        function removeClasses(classString) {
	          classString = digestClassCounts(split(classString), -1);
	          attr.$removeClass(classString);
	        }
	
	        function updateClasses(oldClassString, newClassString) {
	          var oldClassArray = split(oldClassString);
	          var newClassArray = split(newClassString);
	
	          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
	          var toAddArray = arrayDifference(newClassArray, oldClassArray);
	
	          var toRemoveString = digestClassCounts(toRemoveArray, -1);
	          var toAddString = digestClassCounts(toAddArray, 1);
	
	          attr.$addClass(toAddString);
	          attr.$removeClass(toRemoveString);
	        }
	
	        function digestClassCounts(classArray, count) {
	          var classesToUpdate = [];
	
	          forEach(classArray, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	
	          return classesToUpdate.join(' ');
	        }
	
	        function ngClassIndexWatchAction(newModulo) {
	          // This watch-action should run before the `ngClass[OneTime]WatchAction()`, thus it
	          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
	          // `ngClass[OneTime]WatchAction()` will update the classes.
	          if (newModulo === selector) {
	            addClasses(oldClassString);
	          } else {
	            removeClasses(oldClassString);
	          }
	
	          oldModulo = newModulo;
	        }
	
	        function ngClassOneTimeWatchAction(newClassValue) {
	          var newClassString = toClassString(newClassValue);
	
	          if (newClassString !== oldClassString) {
	            ngClassWatchAction(newClassString);
	          }
	        }
	
	        function ngClassWatchAction(newClassString) {
	          if (oldModulo === selector) {
	            updateClasses(oldClassString, newClassString);
	          }
	
	          oldClassString = newClassString;
	        }
	      }
	    };
	  }];
	
	  // Helpers
	  function arrayDifference(tokens1, tokens2) {
	    if (!tokens1 || !tokens1.length) return [];
	    if (!tokens2 || !tokens2.length) return tokens1;
	
	    var values = [];
	
	    outer:
	    for (var i = 0; i < tokens1.length; i++) {
	      var token = tokens1[i];
	      for (var j = 0; j < tokens2.length; j++) {
	        if (token === tokens2[j]) continue outer;
	      }
	      values.push(token);
	    }
	
	    return values;
	  }
	
	  function split(classString) {
	    return classString && classString.split(' ');
	  }
	
	  function toClassString(classValue) {
	    var classString = classValue;
	
	    if (isArray(classValue)) {
	      classString = classValue.map(toClassString).join(' ');
	    } else if (isObject(classValue)) {
	      classString = Object.keys(classValue).
	        filter(function(key) { return classValue[key]; }).
	        join(' ');
	    }
	
	    return classString;
	  }
	
	  function toFlatValue(classValue) {
	    var flatValue = classValue;
	
	    if (isArray(classValue)) {
	      flatValue = classValue.map(toFlatValue);
	    } else if (isObject(classValue)) {
	      var hasUndefined = false;
	
	      flatValue = Object.keys(classValue).filter(function(key) {
	        var value = classValue[key];
	
	        if (!hasUndefined && isUndefined(value)) {
	          hasUndefined = true;
	        }
	
	        return value;
	      });
	
	      if (hasUndefined) {
	        // Prevent the `oneTimeLiteralWatchInterceptor` from unregistering
	        // the watcher, by including at least one `undefined` value.
	        flatValue.push(undefined);
	      }
	    }
	
	    return flatValue;
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
	 * attribute, when using the `ngClass` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example Example that demonstrates basic bindings via ngClass directive.
	   <example name="ng-class">
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   ## Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	
	
	   ## ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-odd">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-even">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the Angular html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example name="ng-cloak">
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * If the current `$controllerProvider` is configured to use globals (via
	 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
	 * also be the name of a globally accessible constructor function (deprecated, not recommended).
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the angular markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the Angular community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = 'John Smith';
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'}
	 *      ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = 'John Smith';
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'}
	 *     ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @restrict A
	 * @element ANY
	 * @description
	 *
	 * Angular has some features that can conflict with certain restrictions that are applied when using
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement CSP with these rules then you must tell Angular not to use these
	 * features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following default rules in CSP affect Angular:
	 *
	 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
	 * code from strings is forbidden. Angular makes use of this in the {@link $parse} service to
	 * provide a 30% increase in the speed of evaluating Angular expressions. (This CSP rule can be
	 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
	 * weaken the protections offered by CSP.)
	 *
	 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
	 * This prevents apps from injecting custom styles directly into the document. Angular makes use of
	 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
	 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
	 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
	 * it is generally not recommended as it would weaken the protections offered by CSP.)
	 *
	 * If you do not provide `ngCsp` then Angular tries to autodetect if CSP is blocking dynamic code
	 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
	 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
	 * CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related Angular features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops Angular from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops Angular from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that Angular will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
	 * versions of Angular.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell Angular to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
	 * versions of Angular.
	 *
	 * * Specifying only `no-unsafe-eval` tells Angular that we must not use eval, but that we can
	 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells Angular that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells Angular that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	  * @example
	      <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
	      <example name="example.csp" module="cspExample" ng-csp="true">
	        <file name="index.html">
	          <div ng-controller="MainController as ctrl">
	            <div>
	              <button ng-click="ctrl.inc()" id="inc">Increment</button>
	              <span id="counter">
	                {{ctrl.counter}}
	              </span>
	            </div>
	
	            <div>
	              <button ng-click="ctrl.evil()" id="evil">Evil</button>
	              <span id="evilError">
	                {{ctrl.evilError}}
	              </span>
	            </div>
	          </div>
	        </file>
	        <file name="script.js">
	           angular.module('cspExample', [])
	             .controller('MainController', function MainController() {
	                this.counter = 0;
	                this.inc = function() {
	                  this.counter++;
	                };
	                this.evil = function() {
	                  try {
	                    eval('1+2'); // eslint-disable-line no-eval
	                  } catch (e) {
	                    this.evilError = e.message;
	                  }
	                };
	              });
	        </file>
	        <file name="protractor.js" type="protractor">
	          var util, webdriver;
	
	          var incBtn = element(by.id('inc'));
	          var counter = element(by.id('counter'));
	          var evilBtn = element(by.id('evil'));
	          var evilError = element(by.id('evilError'));
	
	          function getAndClearSevereErrors() {
	            return browser.manage().logs().get('browser').then(function(browserLog) {
	              return browserLog.filter(function(logEntry) {
	                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	              });
	            });
	          }
	
	          function clearErrors() {
	            getAndClearSevereErrors();
	          }
	
	          function expectNoErrors() {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              expect(filteredLog.length).toEqual(0);
	              if (filteredLog.length) {
	                console.log('browser console errors: ' + util.inspect(filteredLog));
	              }
	            });
	          }
	
	          function expectError(regex) {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              var found = false;
	              filteredLog.forEach(function(log) {
	                if (log.message.match(regex)) {
	                  found = true;
	                }
	              });
	              if (!found) {
	                throw new Error('expected an error that matches ' + regex);
	              }
	            });
	          }
	
	          beforeEach(function() {
	            util = require('util');
	            webdriver = require('selenium-webdriver');
	          });
	
	          // For now, we only test on Chrome,
	          // as Safari does not load the page with Protractor's injected scripts,
	          // and Firefox webdriver always disables content security policy (#6358)
	          if (browser.params.browser !== 'chrome') {
	            return;
	          }
	
	          it('should not report errors when the page is loaded', function() {
	            // clear errors so we are not dependent on previous tests
	            clearErrors();
	            // Need to reload the page as the page is already loaded when
	            // we come here
	            browser.driver.getCurrentUrl().then(function(url) {
	              browser.get(url);
	            });
	            expectNoErrors();
	          });
	
	          it('should evaluate expressions', function() {
	            expect(counter.getText()).toEqual('0');
	            incBtn.click();
	            expect(counter.getText()).toEqual('1');
	            expectNoErrors();
	          });
	
	          it('should throw and report an error when using "eval"', function() {
	            evilBtn.click();
	            expect(evilError.getText()).toMatch(/Content Security Policy/);
	            expectError(/Content Security Policy/);
	          });
	        </file>
	      </example>
	  */
	
	// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
	// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
	// fn that looks for the `ng-csp` attribute anywhere in the current doc.
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-click">
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * angular expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
	      return {
	        restrict: 'A',
	        compile: function($element, attr) {
	          // We expose the powerful $event object on the scope that provides access to the Window,
	          // etc. that isn't protected by the fast paths in $parse.  We explicitly request better
	          // checks at the cost of speed since event handler expressions are not executed as
	          // frequently as regular change detection.
	          var fn = $parse(attr[directiveName], /* interceptorFn */ null, /* expensiveChecks */ true);
	          return function ngEventHandler(scope, element) {
	            element.on(eventName, function(event) {
	              var callback = function() {
	                fn(scope, {$event:event});
	              };
	              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
	                scope.$evalAsync(callback);
	              } else {
	                scope.$apply(callback);
	              }
	            });
	          };
	        }
	      };
	    }];
	  }
	);
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example name="ng-dblclick">
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousedown">
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseup">
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseover">
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseenter">
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseleave">
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousemove">
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keydown">
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keyup">
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @element ANY
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keypress">
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 *
	 * @description
	 * Enables binding angular expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @element form
	 * @priority 0
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample" name="ng-submit">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-copy">
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-cut">
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-paste">
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).done(function(response) {
	                if (response !== false) previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
	 * ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @scope
	 * @priority 400
	 *
	 * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [{ name: 'template1.html', url: 'template1.html'},
	             { name: 'template2.html', url: 'template2.html'}];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).done(function(response) {
	              if (response !== false) previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function(response) {
	            if (response !== false && isDefined(autoScrollExp) &&
	              (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).done(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`, such as for aliasing special properties of
	 * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below; and for injecting data via
	 * server side scripting. Besides these few cases, you should use {@link guide/controller controllers}
	 * rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @priority 450
	 *
	 * @element ANY
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @example
	   <example module="initExample" name="ng-init">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * ### Example with Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Example - splitting on newline
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @element input
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      var ngList = attr.ngList || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	  PENDING_CLASS: true,
	  addSetValidityMethod: true,
	  setupValidity: true,
	  defaultModelOptions: false
	*/
	
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 *
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	       the control reads value from the DOM. The functions are called in array order, each passing
	       its return value through to the next. The last return value is forwarded to the
	       {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	`$viewValue`}.
	
	Returning `undefined` from a parser means a parse error occurred. In that case,
	no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	       the model value changes. The functions are called in reverse array order, each passing the value through to the
	       next. The last return value is used as the actual DOM value.
	       Used to format / convert values for display in the control.
	 * ```js
	 * function formatter(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(formatter);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
	 *     view value has changed. It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * Angular provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if (attrs.stripBr && html === '<br>') {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
	function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	  this.$options = defaultModelOptions;
	
	  this.$$parsedNgModel = $parse($attr.ngModel);
	  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
	  this.$$ngModelGet = this.$$parsedNgModel;
	  this.$$ngModelSet = this.$$parsedNgModelAssign;
	  this.$$pendingDebounce = null;
	  this.$$parserValid = undefined;
	
	  this.$$currentValidationRunId = 0;
	
	  this.$$scope = $scope;
	  this.$$attr = $attr;
	  this.$$element = $element;
	  this.$$animate = $animate;
	  this.$$timeout = $timeout;
	  this.$$parse = $parse;
	  this.$$q = $q;
	  this.$$exceptionHandler = $exceptionHandler;
	
	  setupValidity(this);
	  setupModelWatcher(this);
	}
	
	NgModelController.prototype = {
	  $$initGetterSetters: function() {
	    if (this.$options.getOption('getterSetter')) {
	      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
	          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');
	
	      this.$$ngModelGet = function($scope) {
	        var modelValue = this.$$parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      this.$$ngModelSet = function($scope, newValue) {
	        if (isFunction(this.$$parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          this.$$parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!this.$$parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
	          this.$$attr.ngModel, startingTag(this.$$element));
	    }
	  },
	
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  $render: noop,
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  $isEmpty: function(value) {
	    // eslint-disable-next-line no-self-compare
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  },
	
	  $$updateEmptyClasses: function(value) {
	    if (this.$isEmpty(value)) {
	      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
	    } else {
	      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  $setPristine: function() {
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
	    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  $setDirty: function() {
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  $setUntouched: function() {
	    this.$touched = false;
	    this.$untouched = true;
	    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  $setTouched: function() {
	    this.$touched = true;
	    this.$untouched = false;
	    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
	   * sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because Angular's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {value1: '', value2: ''};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode === 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *       empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                  ng-keydown="setEmpty($event, 'value1')">
	   *           value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *           <p id="inputDescription2">With $rollbackViewValue():</p>
	   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                  ng-keydown="setEmpty($event, 'value2', true)">
	   *           value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  $rollbackViewValue: function() {
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    this.$viewValue = this.$$lastCommittedViewValue;
	    this.$render();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  $validate: function() {
	    // ignore $validate before model is initialized
	    if (isNumberNaN(this.$modelValue)) {
	      return;
	    }
	
	    var viewValue = this.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = this.$$rawModelValue;
	
	    var prevValid = this.$valid;
	    var prevModelValue = this.$modelValue;
	
	    var allowInvalid = this.$options.getOption('allowInvalid');
	
	    var that = this;
	    this.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	
	        if (that.$modelValue !== prevModelValue) {
	          that.$$writeModelToScope();
	        }
	      }
	    });
	  },
	
	  $$runValidators: function(modelValue, viewValue, doneCallback) {
	    this.$$currentValidationRunId++;
	    var localValidationRunId = this.$$currentValidationRunId;
	    var that = this;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = that.$$parserName || 'parse';
	      if (isUndefined(that.$$parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!that.$$parserValid) {
	          forEach(that.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(that.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, that.$$parserValid);
	        return that.$$parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(that.$validators, function(validator, name) {
	        var result = Boolean(validator(modelValue, viewValue));
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(that.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(that.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        that.$$q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	        that.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    var viewValue = this.$viewValue;
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
	      return;
	    }
	    this.$$updateEmptyClasses(viewValue);
	    this.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (this.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  },
	
	  $$parseAndValidate: function() {
	    var viewValue = this.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    var that = this;
	
	    this.$$parserValid = isUndefined(modelValue) ? undefined : true;
	
	    if (this.$$parserValid) {
	      for (var i = 0; i < this.$parsers.length; i++) {
	        modelValue = this.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          this.$$parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumberNaN(this.$modelValue)) {
	      // this.$modelValue has not been touched yet...
	      this.$modelValue = this.$$ngModelGet(this.$$scope);
	    }
	    var prevModelValue = this.$modelValue;
	    var allowInvalid = this.$options.getOption('allowInvalid');
	    this.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      this.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (that.$modelValue !== prevModelValue) {
	        that.$$writeModelToScope();
	      }
	    }
	  },
	
	  $$writeModelToScope: function() {
	    this.$$ngModelSet(this.$$scope, this.$modelValue);
	    forEach(this.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        // eslint-disable-next-line no-invalid-this
	        this.$$exceptionHandler(e);
	      }
	    }, this);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value sent directly for processing, finally to be applied to `$modelValue` and then the
	   * **expression** specified in the `ng-model` attribute. Lastly, all the registered change listeners,
	   * in the `$viewChangeListeners` list, are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  $setViewValue: function(value, trigger) {
	    this.$viewValue = value;
	    if (this.$options.getOption('updateOnDefault')) {
	      this.$$debounceViewValueCommit(trigger);
	    }
	  },
	
	  $$debounceViewValueCommit: function(trigger) {
	    var debounceDelay = this.$options.getOption('debounce');
	
	    if (isNumber(debounceDelay[trigger])) {
	      debounceDelay = debounceDelay[trigger];
	    } else if (isNumber(debounceDelay['default'])) {
	      debounceDelay = debounceDelay['default'];
	    }
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    var that = this;
	    if (debounceDelay > 0) { // this fails if debounceDelay is an object
	      this.$$pendingDebounce = this.$$timeout(function() {
	        that.$commitViewValue();
	      }, debounceDelay);
	    } else if (this.$$scope.$root.$$phase) {
	      this.$commitViewValue();
	    } else {
	      this.$$scope.$apply(function() {
	        that.$commitViewValue();
	      });
	    }
	  }
	};
	
	function setupModelWatcher(ctrl) {
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  ctrl.$$scope.$watch(function ngModelWatch() {
	    var modelValue = ctrl.$$ngModelGet(ctrl.$$scope);
	
	    // if scope model value and ngModel value are out of sync
	    // TODO(perf): why not move this to the action fn?
	    if (modelValue !== ctrl.$modelValue &&
	       // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	        // eslint-disable-next-line no-self-compare
	       (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$modelValue = ctrl.$$rawModelValue = modelValue;
	      ctrl.$$parserValid = undefined;
	
	      var formatters = ctrl.$formatters,
	          idx = formatters.length;
	
	      var viewValue = modelValue;
	      while (idx--) {
	        viewValue = formatters[idx](viewValue);
	      }
	      if (ctrl.$viewValue !== viewValue) {
	        ctrl.$$updateEmptyClasses(viewValue);
	        ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
	        ctrl.$render();
	
	        // It is possible that model and view value have been updated during render
	        ctrl.$$runValidators(ctrl.$modelValue, ctrl.$viewValue, noop);
	      }
	    }
	
	    return modelValue;
	  });
	}
	
	/**
	 * @ngdoc method
	 * @name ngModel.NgModelController#$setValidity
	 *
	 * @description
	 * Change the validity state, and notify the form.
	 *
	 * This method can be called within $parsers/$formatters or a custom validation implementation.
	 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	 *        class and can be bound to as  `{{someForm.someControl.$error.myError}}` .
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *                          Skipped is used by Angular when validators do not run because of parse errors and
	 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	 */
	addSetValidityMethod({
	  clazz: NgModelController,
	  set: function(object, property) {
	    object[property] = true;
	  },
	  unset: function(object, property) {
	    delete object[property];
	  }
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 *
	 * @element input
	 * @priority 1
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * # Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * # CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * ## Animation Hooks
	 *
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * ## Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
	              optionsCtrl = ctrls[2];
	
	          if (optionsCtrl) {
	            modelCtrl.$options = optionsCtrl.$options;
	          }
	
	          modelCtrl.$$initGetterSetters();
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          if (modelCtrl.$options.getOption('updateOn')) {
	            element.on(modelCtrl.$options.getOption('updateOn'), function(ev) {
	              modelCtrl.$$debounceViewValueCommit(ev && ev.type);
	            });
	          }
	
	          function setTouched() {
	            modelCtrl.$setTouched();
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(setTouched);
	            } else {
	              scope.$apply(setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	/* exported defaultModelOptions */
	var defaultModelOptions;
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc type
	 * @name ModelOptions
	 * @description
	 * A container for the options set by the {@link ngModelOptions} directive
	 */
	function ModelOptions(options) {
	  this.$$options = options;
	}
	
	ModelOptions.prototype = {
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#getOption
	   * @param {string} name the name of the option to retrieve
	   * @returns {*} the value of the option
	   * @description
	   * Returns the value of the given option
	   */
	  getOption: function(name) {
	    return this.$$options[name];
	  },
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#createChild
	   * @param {Object} options a hash of options for the new child that will override the parent's options
	   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
	   */
	  createChild: function(options) {
	    var inheritAll = false;
	
	    // make a shallow copy
	    options = extend({}, options);
	
	    // Inherit options from the parent if specified by the value `"$inherit"`
	    forEach(options, /* @this */ function(option, key) {
	      if (option === '$inherit') {
	        if (key === '*') {
	          inheritAll = true;
	        } else {
	          options[key] = this.$$options[key];
	          // `updateOn` is special so we must also inherit the `updateOnDefault` option
	          if (key === 'updateOn') {
	            options.updateOnDefault = this.$$options.updateOnDefault;
	          }
	        }
	      } else {
	        if (key === 'updateOn') {
	          // If the `updateOn` property contains the `default` event then we have to remove
	          // it from the event list and set the `updateOnDefault` flag.
	          options.updateOnDefault = false;
	          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
	            options.updateOnDefault = true;
	            return ' ';
	          }));
	        }
	      }
	    }, this);
	
	    if (inheritAll) {
	      // We have a property of the form: `"*": "$inherit"`
	      delete options['*'];
	      defaults(options, this.$$options);
	    }
	
	    // Finally add in any missing defaults
	    defaults(options, defaultModelOptions.$$options);
	
	    return new ModelOptions(options);
	  }
	};
	
	
	defaultModelOptions = new ModelOptions({
	  updateOn: '',
	  updateOnDefault: true,
	  debounce: 0,
	  getterSetter: false,
	  allowInvalid: false,
	  timezone: null
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 *
	 * @description
	 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
	 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
	 * directives will use the options of their nearest `ngModelOptions` ancestor.
	 *
	 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
	 * an Angular expression. This expression should evaluate to an object, whose properties contain
	 * the settings. For example: `<div "ng-model-options"="{ debounce: 100 }"`.
	 *
	 * ## Inheriting Options
	 *
	 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
	 * directive by giving it the value of `"$inherit"`.
	 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
	 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
	 * will be used.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
	 * ```
	 *
	 * Notice that the `debounce` setting was not inherited and used the default value instead.
	 *
	 * You can specify that all undefined settings are automatically inherited from an ancestor by
	 * including a property with key of `"*"` and value of `"$inherit"`.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
	 * ```
	 *
	 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
	 *
	 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
	 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
	 *
	 *
	 * ## Triggering and debouncing model updates
	 *
	 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
	 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
	 * a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * The following example shows how to override immediate updates. Changes on the inputs within the
	 * form will update the model only when the control loses focus (blur event). If `escape` key is
	 * pressed while the input field is focused, the value is reset to the value in the current model.
	 *
	 * <example name="ngModelOptions-directive-blur" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ updateOn: 'blur' }"
	 *                  ng-keyup="cancel($event)" />
	 *         </label><br />
	 *         <label>
	 *           Other data:
	 *           <input type="text" ng-model="user.data" />
	 *         </label><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say', data: '' };
	 *
	 *         $scope.cancel = function(e) {
	 *           if (e.keyCode === 27) {
	 *             $scope.userForm.userName.$rollbackViewValue();
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var model = element(by.binding('user.name'));
	 *     var input = element(by.model('user.name'));
	 *     var other = element(by.model('user.data'));
	 *
	 *     it('should allow custom events', function() {
	 *       input.sendKeys(' hello');
	 *       input.click();
	 *       expect(model.getText()).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say hello');
	 *     });
	 *
	 *     it('should $rollbackViewValue when model changes', function() {
	 *       input.sendKeys(' hello');
	 *       expect(input.getAttribute('value')).toEqual('say hello');
	 *       input.sendKeys(protractor.Key.ESCAPE);
	 *       expect(input.getAttribute('value')).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
	 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	 *
	 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         Name:
	 *         <input type="text" name="userName"
	 *                ng-model="user.name"
	 *                ng-model-options="{ debounce: 1000 }" />
	 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say' };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 * ## Model updates and validation
	 *
	 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
	 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
	 * the model will still be updated even if the value is invalid.
	 *
	 *
	 * ## Connecting to the scope
	 *
	 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
	 * on the scope refers to a "getter/setter" function rather than the value itself.
	 *
	 * The following example shows how to bind to getter/setters:
	 *
	 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ getterSetter: true }" />
	 *         </label>
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('getterSetterExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         var _name = 'Brian';
	 *         $scope.user = {
	 *           name: function(newName) {
	 *             return angular.isDefined(newName) ? (_name = newName) : _name;
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 *
	 * ## Specifying timezones
	 *
	 * You can specify the timezone that date/time input directives expect by providing its name in the
	 * `timezone` property.
	 *
	 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
	 *   and its descendents. Valid keys are:
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging to the control.
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur',
	 *       debounce: { 'default': 500, 'blur': 0 }
	 *     }"
	 *     ```
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	 *     `ngModel` as getters/setters.
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *
	 */
	var ngModelOptionsDirective = function() {
	  NgModelOptionsController.$inject = ['$attrs', '$scope'];
	  function NgModelOptionsController($attrs, $scope) {
	    this.$$attrs = $attrs;
	    this.$$scope = $scope;
	  }
	  NgModelOptionsController.prototype = {
	    $onInit: function() {
	      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
	      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);
	
	      this.$options = parentOptions.createChild(modelOptionsDefinition);
	    }
	  };
	
	  return {
	    restrict: 'A',
	    // ngModelOptions needs to run before ngModel and input directives
	    priority: 10,
	    require: {parentCtrl: '?^^ngModelOptions'},
	    bindToController: true,
	    controller: NgModelOptionsController
	  };
	};
	
	
	// shallow copy over values from `src` that are not already specified on `dst`
	function defaults(dst, src) {
	  forEach(src, function(value, key) {
	    if (!isDefined(dst[key])) {
	      dst[key] = value;
	    }
	  });
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 *
	 * @description
	 * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
	 * DOM element. This is useful if the element contains what appears to be Angular directives and
	 * bindings but which should be ignored by Angular. This could be the case if you have a site that
	 * displays snippets of code, for instance.
	 *
	 * @element ANY
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	 * @example
	    <example name="ng-non-bindable">
	      <file name="index.html">
	        <div>Normal: {{1 + 2}}</div>
	        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	      </file>
	      <file name="protractor.js" type="protractor">
	       it('should check ng-non-bindable', function() {
	         expect(element(by.binding('1 + 2')).getText()).toContain('3');
	         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	       });
	      </file>
	    </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* exported ngOptionsDirective */
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
	 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {comprehension_expression=} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 *
	 * @example
	    <example module="selectExample" name="select">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	/* eslint-disable max-len */
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	/* eslint-enable */
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        'Expected expression in form of ' +
	        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
	        ' but got \'{0}\'. Element: {1}',
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // we can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          selectCtrl.hasEmptyOption = true;
	          selectCtrl.emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      var providedEmptyOption = !!selectCtrl.emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      // Overwrite the implementation. ngOptions doesn't use hashes
	      selectCtrl.generateUnknownOptionValue = function(val) {
	        return '?';
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          var selectedOption = options.selectValueMap[selectElement.val()];
	          var option = options.getOptionFromViewValue(value);
	
	          // Make sure to remove the selected attribute from the previously selected option
	          // Otherwise, screen readers might get confused
	          if (selectedOption) selectedOption.element.removeAttribute('selected');
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              selectCtrl.removeUnknownOption();
	              selectCtrl.unselectEmptyOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	
	            if (providedEmptyOption) {
	              selectCtrl.selectEmptyOption();
	            } else if (selectCtrl.unknownOption.parent().length) {
	              selectCtrl.updateUnknownOption(value);
	            } else {
	              selectCtrl.renderUnknownOption(value);
	            }
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            selectCtrl.unselectEmptyOption();
	            selectCtrl.removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        // FIXME: When a user selects an option, this watch will fire needlessly
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
	          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
	          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
	
	          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];
	
	          options.items.forEach(function(option) {
	            if (option.element.selected && !includes(selectedOptions, option)) {
	              option.element.selected = false;
	            }
	          });
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	      if (providedEmptyOption) {
	
	        // we need to remove it before calling selectElement.empty() because otherwise IE will
	        // remove the label from the element. wtf?
	        selectCtrl.emptyOption.remove();
	
	        // compile the element since there might be bindings in it
	        $compile(selectCtrl.emptyOption)(scope);
	
	        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
	          // This means the empty option has currently no actual DOM node, probably because
	          // it has been modified by a transclusion directive.
	          selectCtrl.hasEmptyOption = false;
	
	          // Redefine the registerOption function, which will catch
	          // options that are added by ngIf etc. (rendering of the node is async because of
	          // lazy transclusion)
	          selectCtrl.registerOption = function(optionScope, optionEl) {
	            if (optionEl.val() === '') {
	              selectCtrl.hasEmptyOption = true;
	              selectCtrl.emptyOption = optionEl;
	              selectCtrl.emptyOption.removeClass('ng-scope');
	              // This ensures the new empty option is selected if previously no option was selected
	              ngModelCtrl.$render();
	
	              optionEl.on('$destroy', function() {
	                selectCtrl.hasEmptyOption = false;
	                selectCtrl.emptyOption = undefined;
	              });
	            }
	          };
	
	        } else {
	          // remove the class, which is added automatically because we recompile the element and it
	          // becomes the compilation root
	          selectCtrl.emptyOption.removeClass('ng-scope');
	        }
	
	      }
	
	      selectElement.empty();
	
	      // We need to do this here to ensure that the options object is defined
	      // when we first hit it in writeNgOptionsValue
	      updateOptions();
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	      function getAndUpdateSelectedOption(viewValue) {
	        var option = options.getOptionFromViewValue(viewValue);
	        var element = option && option.element;
	
	        if (element && !element.selected) element.selected = true;
	
	        return option;
	      }
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // NOTE: The label must be set before the value, otherwise IE10/11/EDGE create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (isDefined(option.group)) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        // Ensure that the empty option is always there if it was explicitly provided
	        if (providedEmptyOption) {
	          selectElement.prepend(selectCtrl.emptyOption);
	        }
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              // "null" is special cased because of Safari
	              groupElement.label = option.group === null ? 'null' : option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * # Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in Angular's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * # Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * Angular expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, Angular will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * # Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample" name="ng-pluralize">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNumberNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/* exported ngRepeatDirective */
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * # Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a few limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so Angular relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by Angular for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw an error if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * # Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * The default tracking function (which tracks items by their identity) does not allow
	 * duplicate items in arrays. This is because when there are duplicates, it is not possible
	 * to maintain a one-to-one mapping between collection items and DOM elements.
	 *
	 * If you do need to repeat duplicate items, you can substitute the default tracking behavior
	 * with your own using the `track by` expression.
	 *
	 * For example, you may track items by the index of each item in the collection, using the
	 * special scope property `$index`:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * You may also use arbitrary expressions in `track by`, including references to custom functions
	 * on the scope:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * <div class="alert alert-success">
	 * If you are working with objects that have a unique identifier property, you should track
	 * by this identifier instead of the object instance. Should you reload your data later, `ngRepeat`
	 * will not have to rebuild the DOM elements for items it has already rendered, even if the
	 * JavaScript objects in the collection have been substituted for new ones. For large collections,
	 * this significantly improves rendering performance. If you don't have a unique identifier,
	 * `track by $index` can also provide a performance boost.
	 * </div>
	 *
	 * ```html
	 *    <div ng-repeat="model in collection track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 * Avoid using `track by $index` when the repeated template contains
	 * {@link guide/expression#one-time-binding one-time bindings}. In such cases, the `nth` DOM
	 * element will always be matched with the `nth` item of the array, so the bindings on that element
	 * will not be updated even when the corresponding item changes, essentially causing the view to get
	 * out-of-sync with the underlying data.
	 * </div>
	 *
	 * When no `track by` expression is provided, it is equivalent to tracking by the built-in
	 * `$id` function, which tracks items by their identity:
	 * ```html
	 *    <div ng-repeat="obj in collection track by $id(obj)">
	 *      {{obj.prop}}
	 *    </div>
	 * ```
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 * **Note:** `track by` must always be the last expression:
	 * </div>
	 * ```
	 *    <div ng-repeat="model in collection | orderBy: 'id' as filtered_result track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 *
	 * # Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     Note that the tracking expression must come last, after any filters, and the alias expression.
	 *
	 *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
	 *     will be associated by item identity in the array.
	 *
	 *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
	 *     element in the same way in the DOM.
	 *
	 *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
	 *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
	 *     property is same.
	 *
	 *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
	 *     to items in conjunction with a tracking expression.
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat micro-syntax so it can be used only at the end
	 *     (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name or by age. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true" name="ng-repeat">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length === 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // eslint-disable-next-line no-bitwise
	    scope.$odd = !(scope.$even = (index & 1) === 0);
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
	          aliasAs);
	      }
	
	      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
	      var hashFnLocals = {$id: hashKey};
	
	      if (trackByExp) {
	        trackByExpGetter = $parse(trackByExp);
	      } else {
	        trackByIdArrayFn = function(key, value) {
	          return hashKey(value);
	        };
	        trackByIdObjFn = function(key) {
	          return key;
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        if (trackByExpGetter) {
	          trackByIdExpFn = function(key, value, index) {
	            // assign key, value, and $index to the locals so that they can be used in hash functions
	            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	            hashFnLocals[valueIdentifier] = value;
	            hashFnLocals.$index = index;
	            return trackByExpGetter($scope, hashFnLocals);
	          };
	        }
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - element: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn(key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) !== nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression
	 * provided to the `ngShow` attribute. The element is shown or hidden by removing or adding
	 * the `.ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
	 * in AngularJS and sets the display style to none (using an !important flag).
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added to the class
	 * attribute on the element causing it to become hidden. When truthy, the `.ng-hide` CSS class is removed
	 * from the element causing the element not to appear hidden.
	 *
	 * ## Why is !important used?
	 *
	 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
	 * can be easily overridden by heavier selectors. For example, something as simple
	 * as changing the display style on a HTML list item would make hidden elements appear visible.
	 * This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
	 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
	 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
	 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
	 * class CSS. Note that the selector that needs to be used is actually `.ng-hide:not(.ng-hide-animate)` to cope
	 * with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; this is just another form of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the display style.
	 *
	 * ## A note about animations with `ngShow`
	 *
	 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
	 * is true and false. This system works like the animation system present with ngClass except that
	 * you must also include the !important flag to override the display property
	 * so that you can perform an animation when the element is hidden during the time of the animation.
	 *
	 * ```css
	 * //
	 * //a working example can be found at the bottom of this page
	 * //
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   /&#42; this is required as of 1.3x to properly
	 *      apply all styling in a show/hide animation &#42;/
	 *   transition: 0s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add-active,
	 * .my-element.ng-hide-remove-active {
	 *   /&#42; the transition is defined in the active class &#42;/
	 *   transition: 1s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display
	 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`  | after the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden |
	 * | {@link $animate#removeClass removeClass}  `.ng-hide`  | after the `ngShow` expression evaluates to a truthy value and just before contents are set to visible |
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy
	 *     then the element is shown or hidden respectively.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show">
	    <file name="index.html">
	      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br/>
	      <div>
	        Show:
	        <div class="check-element animate-show" ng-show="checked">
	          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
	        </div>
	      </div>
	      <div>
	        Hide:
	        <div class="check-element animate-show" ng-hide="checked">
	          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
	        </div>
	      </div>
	    </file>
	    <file name="glyphicons.css">
	      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
	    </file>
	    <file name="animations.css">
	      .animate-show {
	        line-height: 20px;
	        opacity: 1;
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	
	      .animate-show.ng-hide-add, .animate-show.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .animate-show.ng-hide {
	        line-height: 0;
	        opacity: 0;
	        padding: 0 10px;
	      }
	
	      .check-element {
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
	      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
	
	      it('should check ng-show / ng-hide', function() {
	        expect(thumbsUp.isDisplayed()).toBeFalsy();
	        expect(thumbsDown.isDisplayed()).toBeTruthy();
	
	        element(by.model('checked')).click();
	
	        expect(thumbsUp.isDisplayed()).toBeTruthy();
	        expect(thumbsDown.isDisplayed()).toBeFalsy();
	      });
	    </file>
	  </example>
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression
	 * provided to the `ngHide` attribute. The element is shown or hidden by removing or adding
	 * the `ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
	 * in AngularJS and sets the display style to none (using an !important flag).
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added to the class
	 * attribute on the element causing it to become hidden. When falsy, the `.ng-hide` CSS class is removed
	 * from the element causing the element not to appear hidden.
	 *
	 * ## Why is !important used?
	 *
	 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
	 * can be easily overridden by heavier selectors. For example, something as simple
	 * as changing the display style on a HTML list item would make hidden elements appear visible.
	 * This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
	 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
	 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
	 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
	 * class in CSS:
	 *
	 * ```css
	 * .ng-hide {
	 *   /&#42; this is just another form of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the display style.
	 *
	 * ## A note about animations with `ngHide`
	 *
	 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
	 * is true and false. This system works like the animation system present with ngClass, except that the `.ng-hide`
	 * CSS class is added and removed for you instead of your own CSS class.
	 *
	 * ```css
	 * //
	 * //a working example can be found at the bottom of this page
	 * //
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: 0.5s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display
	 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`  | after the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden |
	 * | {@link $animate#removeClass removeClass}  `.ng-hide`  | after the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible |
	 *
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy then
	 *     the element is shown or hidden respectively.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide">
	    <file name="index.html">
	      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br/>
	      <div>
	        Show:
	        <div class="check-element animate-hide" ng-show="checked">
	          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
	        </div>
	      </div>
	      <div>
	        Hide:
	        <div class="check-element animate-hide" ng-hide="checked">
	          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
	        </div>
	      </div>
	    </file>
	    <file name="glyphicons.css">
	      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
	    </file>
	    <file name="animations.css">
	      .animate-hide {
	        transition: all linear 0.5s;
	        line-height: 20px;
	        opacity: 1;
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	
	      .animate-hide.ng-hide {
	        line-height: 0;
	        opacity: 0;
	        padding: 0 10px;
	      }
	
	      .check-element {
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
	      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
	
	      it('should check ng-show / ng-hide', function() {
	        expect(thumbsUp.isDisplayed()).toBeFalsy();
	        expect(thumbsDown.isDisplayed()).toBeTruthy();
	
	        element(by.model('checked')).click();
	
	        expect(thumbsUp.isDisplayed()).toBeTruthy();
	        expect(thumbsDown.isDisplayed()).toBeFalsy();
	      });
	    </file>
	  </example>
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
	 * attribute, when using the `ngStyle` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example name="ng-style">
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, '');});
	    }
	    if (newStyles) element.css(newStyles);
	  }, true);
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed. It is possible to associate multiple values to
	 *   the same `ngSwitchWhen` by defining the optional attribute
	 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
	 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
	 *   if any of the `ngSwitch` evaluates to any of these tokens.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'options', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should change to settings via "options"', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(3).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function NgSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function(response) {
	            if (response !== false) array.splice(index, 1);
	          };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	
	        // Start with the last, in case the array is modified during the loop
	        while (previousLeaveAnimations.length) {
	          $animate.cancel(previousLeaveAnimations.pop());
	        }
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
	          runner.done(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	
	    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
	      // Filter duplicate cases
	      function(element, index, array) { return array[index - 1] !== element; }
	    );
	
	    forEach(cases, function(whenCase) {
	      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
	      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
	    });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
	 * content in the case that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}"><span>{{text}}</span></pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample" name="ng-transclude">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function() {
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = 'https://google.com';
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'EAC',
	    terminal: true,
	    compile: function ngTranscludeCompile(tElement) {
	
	      // Remove and cache any original content to act as a fallback
	      var fallbackLinkFn = $compile(tElement.contents());
	      tElement.empty();
	
	      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
	
	        if (!$transclude) {
	          throw ngTranscludeMinErr('orphan',
	          'Illegal use of ngTransclude directive in the template! ' +
	          'No parent directive that requires a transclusion found. ' +
	          'Element: {0}',
	          startingTag($element));
	        }
	
	
	        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
	        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	          $attrs.ngTransclude = '';
	        }
	        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	
	        // If the slot is required and no transclusion content is provided then this call will throw an error
	        $transclude(ngTranscludeCloneAttachFn, null, slotName);
	
	        // If the slot is optional and no transclusion content is provided then use the fallback content
	        if (slotName && !$transclude.isSlotFilled(slotName)) {
	          useFallbackContent();
	        }
	
	        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
	          if (clone.length && notWhitespace(clone)) {
	            $element.append(clone);
	          } else {
	            useFallbackContent();
	            // There is nothing linked against the transcluded scope since no content was available,
	            // so it should be safe to clean up the generated scope.
	            transcludedScope.$destroy();
	          }
	        }
	
	        function useFallbackContent() {
	          // Since this is the fallback content rather than the transcluded content,
	          // we link against the scope of this directive rather than the transcluded scope
	          fallbackLinkFn($scope, function(clone) {
	            $element.append(clone);
	          });
	        }
	
	        function notWhitespace(nodes) {
	          for (var i = 0, ii = nodes.length; i < ii; i++) {
	            var node = nodes[i];
	            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
	              return true;
	            }
	          }
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example  name="script-tag">
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type === 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	/* exported selectDirective, optionDirective */
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 * @description
	 * The controller for the `<select>` directive. This provides support for reading
	 * and writing the selected value(s) of the control and also coordinates dynamically
	 * added `<option>` elements, perhaps by an `ngRepeat` directive.
	 */
	var SelectController =
	        ['$element', '$scope', /** @this */ function($element, $scope) {
	
	  var self = this,
	      optionsMap = new HashMap();
	
	  self.selectValueMap = {}; // Keys are the hashed values, values the original values
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	  self.multiple = false;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	
	  // The empty option is an option with the value '' that te application developer can
	  // provide inside the select. When the model changes to a value that doesn't match an option,
	  // it is selected - so if an empty option is provided, no unknown option is generated.
	  // However, the empty option is not removed when the model matches an option. It is always selectable
	  // and indicates that a "null" selection has been made.
	  self.hasEmptyOption = false;
	  self.emptyOption = undefined;
	
	  self.renderUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    setOptionAsSelected(self.unknownOption);
	    $element.val(unknownVal);
	  };
	
	  self.updateUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    setOptionAsSelected(self.unknownOption);
	    $element.val(unknownVal);
	  };
	
	  self.generateUnknownOptionValue = function(val) {
	    return '? ' + hashKey(val) + ' ?';
	  };
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	  self.selectEmptyOption = function() {
	    if (self.emptyOption) {
	      $element.val('');
	      setOptionAsSelected(self.emptyOption);
	    }
	  };
	
	  self.unselectEmptyOption = function() {
	    if (self.hasEmptyOption) {
	      self.emptyOption.removeAttr('selected');
	    }
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    var val = $element.val();
	    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
	    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;
	
	    if (self.hasOption(realVal)) {
	      return realVal;
	    }
	
	    return null;
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    // Make sure to remove the selected attribute from the previously selected option
	    // Otherwise, screen readers might get confused
	    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
	    if (currentlySelectedOption) currentlySelectedOption.removeAttribute('selected');
	
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	
	      var hashedVal = hashKey(value);
	      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);
	
	      // Set selected attribute and property on selected option for screen readers
	      var selectedOption = $element[0].options[$element[0].selectedIndex];
	      setOptionAsSelected(jqLite(selectedOption));
	    } else {
	      if (value == null && self.emptyOption) {
	        self.removeUnknownOption();
	        self.selectEmptyOption();
	      } else if (self.unknownOption.parent().length) {
	        self.updateUnknownOption(value);
	      } else {
	        self.renderUnknownOption(value);
	      }
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.hasEmptyOption = true;
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.put(value, count + 1);
	    // Only render at the end of a digest. This improves render performance when many options
	    // are added during a digest and ensures all relevant options are correctly marked as selected
	    scheduleRender();
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.remove(value);
	        if (value === '') {
	          self.hasEmptyOption = false;
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.put(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	
	  var renderScheduled = false;
	  function scheduleRender() {
	    if (renderScheduled) return;
	    renderScheduled = true;
	    $scope.$$postDigest(function() {
	      renderScheduled = false;
	      self.ngModelCtrl.$render();
	    });
	  }
	
	  var updateScheduled = false;
	  function scheduleViewValueUpdate(renderAfter) {
	    if (updateScheduled) return;
	
	    updateScheduled = true;
	
	    $scope.$$postDigest(function() {
	      if ($scope.$$destroyed) return;
	
	      updateScheduled = false;
	      self.ngModelCtrl.$setViewValue(self.readValue());
	      if (renderAfter) self.ngModelCtrl.$render();
	    });
	  }
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	    if (optionAttrs.$attr.ngValue) {
	      // The value attribute is set by ngValue
	      var oldVal, hashedVal = NaN;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(hashedVal)) {
	          self.removeOption(oldVal);
	          delete self.selectValueMap[hashedVal];
	          removal = true;
	        }
	
	        hashedVal = hashKey(newVal);
	        oldVal = newVal;
	        self.selectValueMap[hashedVal] = newVal;
	        self.addOption(newVal, optionElement);
	        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
	        // from firing a second time. Other $observers on value will also get the result of the
	        // ngValue expression, not the hashed value
	        optionElement.attr('value', hashedVal);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	
	      });
	    } else if (interpolateValueFn) {
	      // The value attribute is interpolated
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        // This method is overwritten in ngOptions and has side-effects!
	        self.readValue();
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	          removal = true;
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        var previouslySelected = optionElement.prop('selected');
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	
	        if (oldVal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	
	    optionAttrs.$observe('disabled', function(newVal) {
	
	      // Since model updates will also select disabled options (like ngOptions),
	      // we only have to handle options becoming disabled, not enabled
	
	      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
	        if (self.multiple) {
	          scheduleViewValueUpdate(true);
	        } else {
	          self.ngModelCtrl.$setViewValue(null);
	          self.ngModelCtrl.$render();
	        }
	      }
	    });
	
	    optionElement.on('$destroy', function() {
	      var currentValue = self.readValue();
	      var removeValue = optionAttrs.value;
	
	      self.removeOption(removeValue);
	      self.ngModelCtrl.$render();
	
	      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
	          currentValue === removeValue
	      ) {
	        // When multiple (selected) options are destroyed at the same time, we don't want
	        // to run a model update for each of them. Instead, run a single update in the $$postDigest
	        scheduleViewValueUpdate(true);
	      }
	    });
	  };
	
	  function setOptionAsSelected(optionEl) {
	    optionEl.prop('selected', true); // needed for IE
	    optionEl.attr('selected', true);
	  }
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `select` element with angular data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * Value and textContent can be interpolated.
	 *
	 * ## Matching model and option values
	 *
	 * In general, the match between the model and an option is evaluated by strictly comparing the model
	 * value against the value of the available options.
	 *
	 * If you are setting the option value with the option's `value` attribute, or textContent, the
	 * value will always be a `string` which means that the model value must also be a string.
	 * Otherwise the `select` directive cannot match them correctly.
	 *
	 * To bind the model to a non-string value, you can use one of the following strategies:
	 * - the {@link ng.ngOptions `ngOptions`} directive
	 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
	 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
	 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
	 * - model $parsers / $formatters to convert the string value
	 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Choosing between `ngRepeat` and `ngOptions`
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * Specifically, select with repeated options slows down significantly starting at 2000 options in
	 * Chrome and Internet Explorer / Edge.
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange Angular expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1'
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="select-ngrepeat" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>model = {{data.model}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `ngValue` to bind the model to an array of objects
	 * <example name="select-ngvalue" module="ngvalueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="ngvalueselect"> ngvalue select: </label>
	 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
	 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <pre>model = {{data.model | json}}</pre><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngvalueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	           {value: 'myString', name: 'string'},
	           {value: 1, name: 'integer'},
	           {value: true, name: 'boolean'},
	           {value: null, name: 'null'},
	           {value: {prop: 'value'}, name: 'object'},
	           {value: ['a'], name: 'array'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	
	      // if ngModel is not defined, we don't need to do anything but set the registerOption
	      // function to noop, so options don't get added internally
	      if (!ngModelCtrl) {
	        selectCtrl.registerOption = noop;
	        return;
	      }
	
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        selectCtrl.removeUnknownOption();
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	        selectCtrl.multiple = true;
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected && !option.disabled) {
	              var val = option.value;
	              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          var items = new HashMap(value);
	          forEach(element.find('option'), function(option) {
	            option.selected = isDefined(items.get(option.value)) || isDefined(items.get(selectCtrl.selectValueMap[option.value]));
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      var interpolateValueFn, interpolateTextFn;
	
	      if (isDefined(attr.ngValue)) {
	        // Will be handled by registerOption
	      } else if (isDefined(attr.value)) {
	        // If the value attribute is defined, check if it contains an interpolation
	        interpolateValueFn = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the Angular expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      attr.required = true; // force truthy in case we are on non input element
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !attr.required || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function() {
	        ctrl.$validate();
	      });
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained by evaluating the Angular expression given in the
	 * `ngPattern` attribute value:
	 * * If the expression evaluates to a RegExp object, then this is used directly.
	 * * If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 * in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var regexp, patternExp = attr.ngPattern || attr.pattern;
	      attr.$observe('pattern', function(regex) {
	        if (isString(regex) && regex.length > 0) {
	          regex = new RegExp('^' + regex + '$');
	        }
	
	        if (regex && !regex.test) {
	          throw minErr('ngPattern')('noregexp',
	            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	            regex, startingTag(elm));
	        }
	
	        regexp = regex || undefined;
	        ctrl.$validate();
	      });
	
	      ctrl.$validators.pattern = function(modelValue, viewValue) {
	        // HTML5 pattern constraint validates the input value, so we validate the viewValue
	        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the Angular expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = -1;
	      attr.$observe('maxlength', function(value) {
	        var intVal = toInt(value);
	        maxlength = isNumberNaN(intVal) ? -1 : intVal;
	        ctrl.$validate();
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the Angular expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = 0;
	      attr.$observe('minlength', function(value) {
	        minlength = toInt(value) || 0;
	        ctrl.$validate();
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
	      };
	    }
	  };
	};
	
	if (window.angular.bootstrap) {
	  // AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load angular more than once.');
	  }
	  return;
	}
	
	// try to bind to jquery now so that one can write jqLite(fn)
	// but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(301)))

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v2.2.4
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-05-20T17:23Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//"use strict";
	var arr = [];
	
	var document = window.document;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		version = "2.2.4",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			var realStringObj = obj && obj.toString();
			return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
		},
	
		isPlainObject: function( obj ) {
			var key;
	
			// Not plain objects:
			// - Any object or value whose internal [[Class]] property is not "[object Object]"
			// - DOM nodes
			// - window
			if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			// Not own constructor property must be Object
			if ( obj.constructor &&
					!hasOwn.call( obj, "constructor" ) &&
					!hasOwn.call( obj.constructor.prototype || {}, "isPrototypeOf" ) ) {
				return false;
			}
	
			// Own properties are enumerated firstly, so to speed up,
			// if last one is own, then all properties are own
			for ( key in obj ) {}
	
			return key === undefined || hasOwn.call( obj, key );
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android<4.0, iOS<6 (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			var script,
				indirect = eval;
	
			code = jQuery.trim( code );
	
			if ( code ) {
	
				// If the code includes a valid, prologue position
				// strict mode pragma, execute code by injecting a
				// script tag into the document.
				if ( code.indexOf( "use strict" ) === 1 ) {
					script = document.createElement( "script" );
					script.text = code;
					document.head.appendChild( script ).parentNode.removeChild( script );
				} else {
	
					// Otherwise, avoid the DOM node creation, insertion
					// and removal by using an indirect global eval
	
					indirect( code );
				}
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE9-11+
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	// JSHint would error on this code due to the Symbol not being defined in ES5.
	// Defining this global in .jshintrc would create a danger of using the global
	// unguarded in another place, it seems safer to just disable JSHint for these
	// three lines.
	/* jshint ignore: start */
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	/* jshint ignore: end */
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.1
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-10-17
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, nidselect, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rescape, "\\$&" );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
						while ( i-- ) {
							groups[i] = nidselect + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( (parent = document.defaultView) && parent.top !== parent ) {
			// Support: IE 11
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( document.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					return m ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( (oldCache = uniqueCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i,
				len = this.length,
				ret = [],
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						// Support: Blackberry 4.6
						// gEBID returns nodes no longer in the document (#6963)
						if ( elem && elem.parentNode ) {
	
							// Inject the element directly into the jQuery object
							this.length = 1;
							this[ 0 ] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
					// Always skip document fragments
					if ( cur.nodeType < 11 && ( pos ?
						pos.index( cur ) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnotwhite = ( /\S+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
	
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this === promise ? newDefer.promise() : this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add( function() {
	
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 ||
					( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred.
				// If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// Add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.progress( updateFunc( i, progressContexts, progressValues ) )
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject );
					} else {
						--remaining;
					}
				}
			}
	
			// If we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	} );
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
	
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	} );
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called
			// after the browser event has already occurred.
			// Support: IE9-10 only
			// Older IE sometimes signals "interactive" too soon
			if ( document.readyState === "complete" ||
				( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				window.setTimeout( jQuery.ready );
	
			} else {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed );
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		/* jshint -W018 */
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		register: function( owner, initial ) {
			var value = initial || {};
	
			// If it is a node unlikely to be stringify-ed or looped over
			// use plain assignment
			if ( owner.nodeType ) {
				owner[ this.expando ] = value;
	
			// Otherwise secure it in a non-enumerable, non-writable property
			// configurability must be true to allow the property to be
			// deleted with the delete operator
			} else {
				Object.defineProperty( owner, this.expando, {
					value: value,
					writable: true,
					configurable: true
				} );
			}
			return owner[ this.expando ];
		},
		cache: function( owner ) {
	
			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( !acceptData( owner ) ) {
				return {};
			}
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			if ( typeof data === "string" ) {
				cache[ data ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ prop ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
				owner[ this.expando ] && owner[ this.expando ][ key ];
		},
		access: function( owner, key, value ) {
			var stored;
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				stored = this.get( owner, key );
	
				return stored !== undefined ?
					stored : this.get( owner, jQuery.camelCase( key ) );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i, name, camel,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key === undefined ) {
				this.register( owner );
	
			} else {
	
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
	
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = key.concat( key.map( jQuery.camelCase ) );
				} else {
					camel = jQuery.camelCase( key );
	
					// Try the string as a key before any manipulation
					if ( key in cache ) {
						name = [ key, camel ];
					} else {
	
						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						name = camel;
						name = name in cache ?
							[ name ] : ( name.match( rnotwhite ) || [] );
					}
				}
	
				i = name.length;
	
				while ( i-- ) {
					delete cache[ name[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <= 35-45+
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://code.google.com/p/chromium/issues/detail?id=378607
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
	
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data, camelKey;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// with the key as-is
					data = dataUser.get( elem, key ) ||
	
						// Try to find dashed key if it exists (gh-2779)
						// This is for 2.2.x only
						dataUser.get( elem, key.replace( rmultiDash, "-$&" ).toLowerCase() );
	
					if ( data !== undefined ) {
						return data;
					}
	
					camelKey = jQuery.camelCase( key );
	
					// Attempt to get data from the cache
					// with the key camelized
					data = dataUser.get( elem, camelKey );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, camelKey, undefined );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				camelKey = jQuery.camelCase( key );
				this.each( function() {
	
					// First, attempt to store a copy or reference of any
					// data that might've been store with a camelCased key.
					var data = dataUser.get( this, camelKey );
	
					// For HTML5 data-* attribute interop, we have to
					// store property names with dashes in a camelCase form.
					// This might not apply to all properties...*
					dataUser.set( this, camelKey, value );
	
					// *... In the case of properties that might _actually_
					// have dashes, we need to also store a copy of that
					// unchanged property.
					if ( key.indexOf( "-" ) > -1 && data !== undefined ) {
						dataUser.set( this, key, value );
					}
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
	
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" ||
				!jQuery.contains( elem.ownerDocument, elem );
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() { return tween.cur(); } :
				function() { return jQuery.css( elem, prop, "" ); },
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([\w:-]+)/ );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE9
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE9-11+
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret = typeof context.getElementsByTagName !== "undefined" ?
				context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== "undefined" ?
					context.querySelectorAll( tag || "*" ) :
				[];
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], ret ) :
			ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0-4.3, Safari<=5.1
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari<=5.1, Android<4.2
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<=11+
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE9
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Support (at least): Chrome, IE9
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			//
			// Support: Firefox<=42+
			// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
			if ( delegateCount && cur.nodeType &&
				( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push( { elem: cur, handlers: matches } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
			"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split( " " ),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: ( "button buttons clientX clientY offsetX offsetY pageX pageY " +
				"screenX screenY toElement" ).split( " " ),
			filter: function( event, original ) {
				var eventDoc, doc, body,
					button = original.button;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX +
						( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
						( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY +
						( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
						( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: Cordova 2.5 (WebKit) (#13255)
			// All events should have a target; Cordova deviceready doesn't
			if ( !event.target ) {
				event.target = document;
			}
	
			// Support: Safari 6.0+, Chrome<28
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android<4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://code.google.com/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
	
		// Support: IE 10-11, Edge 10240+
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName( "tbody" )[ 0 ] ||
				elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android<4.1, PhantomJS<2
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
	
		// Keep domManip exposed until 3.0 (gh-2225)
		domManip: domManip,
	
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: QtWebKit
				// .get() because push.apply(_, arraylike) throws
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	
	
	var iframe,
		elemdisplay = {
	
			// Support: Firefox
			// We have to pre-define these values for FF (#10227)
			HTML: "block",
			BODY: "block"
		};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			display = jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
					.appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = iframe[ 0 ].contentDocument;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var documentElement = document.documentElement;
	
	
	
	( function() {
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE9-11+
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
			div.style.cssText =
	
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
		}
	
		jQuery.extend( support, {
			pixelPosition: function() {
	
				// This test is executed only once but we still do memoizing
				// since we can use the boxSizingReliable pre-computing.
				// No need to check if the test was already performed, though.
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
	
				// Support: Android 4.0-4.3
				// We're checking for boxSizingReliableVal here instead of pixelMarginRightVal
				// since that compresses better and they're computed together anyway.
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
	
				// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return reliableMarginLeftVal;
			},
			reliableMarginRight: function() {
	
				// Support: Android 2.3
				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// This support function is only executed once so no memoizing is needed.
				var ret,
					marginDiv = div.appendChild( document.createElement( "div" ) );
	
				// Reset CSS: box-sizing; display; margin; border; padding
				marginDiv.style.cssText = div.style.cssText =
	
					// Support: Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;box-sizing:content-box;" +
					"display:block;margin:0;border:0;padding:0";
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";
				documentElement.appendChild( container );
	
				ret = !parseFloat( window.getComputedStyle( marginDiv ).marginRight );
	
				documentElement.removeChild( container );
				div.removeChild( marginDiv );
	
				return ret;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
		ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;
	
		// Support: Opera 12.1x only
		// Fall back to style even without computed
		// computed is undefined for elems on document fragments
		if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}
	
		// Support: IE9
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// http://dev.w3.org/csswg/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE9-11+
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
	
			// If we already have the right measurement, avoid augmentation
			4 :
	
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = dataPriv.get( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
	
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] = dataPriv.access(
						elem,
						"olddisplay",
						defaultDisplay( elem.nodeName )
					);
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display !== "none" || !hidden ) {
					dataPriv.set(
						elem,
						"olddisplay",
						hidden ? display : jQuery.css( elem, "display" )
					);
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// Support: IE9-11+
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					style[ name ] = value;
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
						elem.offsetWidth === 0 ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// Support: Android 2.3
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE9
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
	
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE9-10 do not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				dataPriv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
				style.display = "inline-block";
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show
					// and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", {} );
			}
	
			// Store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done( function() {
					jQuery( elem ).hide();
				} );
			}
			anim.done( function() {
				var prop;
	
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnotwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ?
			opt.duration : opt.duration in jQuery.fx.speeds ?
				jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		window.clearInterval( timerId );
	
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: iOS<=5.1, Android<=4.2+
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE<=11+
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: Android<=2.3
		// Options inside disabled selects are incorrectly marked as disabled
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE<=11+
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
	
						// Set corresponding property to false
						elem[ propName ] = false;
					}
	
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) && elem.href ?
								0 :
								-1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnotwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + getClass( elem ) + " " ).replace( rclass, " " )
						.indexOf( className ) > -1
				) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g,
		rspaces = /[\x20\t\r\n\f]+/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
	
						// Handle most common string cases
						ret.replace( rreturn, "" ) :
	
						// Handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ?
									!option.disabled : option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome, Safari
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Support: Android 2.3
	// Workaround failure to string-cast null input
	jQuery.parseJSON = function( data ) {
		return JSON.parse( data + "" );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE9
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
			// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// The jqXHR state
				state = 0,
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
	
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" ).replace( rhash, "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE8-11+
				// IE throws exception if url is malformed, e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE8-11+
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( state === 2 ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
	
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapAll( html.call( this, i ) );
				} );
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function() {
			return this.parent().each( function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			} ).end();
		}
	} );
	
	
	jQuery.expr.filters.hidden = function( elem ) {
		return !jQuery.expr.filters.visible( elem );
	};
	jQuery.expr.filters.visible = function( elem ) {
	
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		// Use OR instead of AND as the element is not visible if either is true
		// See tickets #10406 and #13132
		return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
	
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						} ) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE9
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE9
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE9
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = jQuery.trim( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win,
				elem = this[ 0 ],
				box = { top: 0, left: 0 },
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			box = elem.getBoundingClientRect();
			win = getWindow( doc );
			return {
				top: box.top + win.pageYOffset - docElem.clientTop,
				left: box.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari<7-8+, Chrome<37-44+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
		size: function() {
			return this.length;
		}
	} );
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	return jQuery;
	}));


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Main entry point for angular 1.x build
	 * @module ng1
	 */ /** */
	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	var core = __webpack_require__(303);
	exports.core = core;
	__export(__webpack_require__(303));
	__export(__webpack_require__(359));
	__export(__webpack_require__(361));
	__export(__webpack_require__(363));
	__webpack_require__(367);
	__webpack_require__(368);
	__webpack_require__(369);
	__webpack_require__(370);
	__webpack_require__(371);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = "ui.router";
	//# sourceMappingURL=index.js.map

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @coreapi
	 * @module common
	 */ /** */
	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(304));
	__export(__webpack_require__(351));
	__export(__webpack_require__(352));
	__export(__webpack_require__(353));
	__export(__webpack_require__(354));
	__export(__webpack_require__(355));
	__export(__webpack_require__(356));
	__export(__webpack_require__(357));
	__export(__webpack_require__(348));
	__export(__webpack_require__(327));
	__export(__webpack_require__(358));
	//# sourceMappingURL=index.js.map

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	/** @module common */ /** for typedoc */
	__export(__webpack_require__(305));
	__export(__webpack_require__(308));
	__export(__webpack_require__(309));
	__export(__webpack_require__(307));
	__export(__webpack_require__(306));
	__export(__webpack_require__(310));
	__export(__webpack_require__(311));
	__export(__webpack_require__(314));
	//# sourceMappingURL=index.js.map

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Random utility functions used in the UI-Router code
	 *
	 * These functions are exported, but are subject to change without notice.
	 *
	 * @preferred
	 * @module common
	 */ /** for typedoc */
	"use strict";
	var predicates_1 = __webpack_require__(306);
	var hof_1 = __webpack_require__(307);
	var coreservices_1 = __webpack_require__(308);
	var w = typeof window === 'undefined' ? {} : window;
	var angular = w.angular || {};
	exports.fromJson = angular.fromJson || JSON.parse.bind(JSON);
	exports.toJson = angular.toJson || JSON.stringify.bind(JSON);
	exports.copy = angular.copy || _copy;
	exports.forEach = angular.forEach || _forEach;
	exports.extend = angular.extend || _extend;
	exports.equals = angular.equals || _equals;
	exports.identity = function (x) { return x; };
	exports.noop = function () { return undefined; };
	/**
	 * Builds proxy functions on the `to` object which pass through to the `from` object.
	 *
	 * For each key in `fnNames`, creates a proxy function on the `to` object.
	 * The proxy function calls the real function on the `from` object.
	 *
	 *
	 * #### Example:
	 * This example creates an new class instance whose functions are prebound to the new'd object.
	 * ```js
	 * class Foo {
	 *   constructor(data) {
	 *     // Binds all functions from Foo.prototype to 'this',
	 *     // then copies them to 'this'
	 *     bindFunctions(Foo.prototype, this, this);
	 *     this.data = data;
	 *   }
	 *
	 *   log() {
	 *     console.log(this.data);
	 *   }
	 * }
	 *
	 * let myFoo = new Foo([1,2,3]);
	 * var logit = myFoo.log;
	 * logit(); // logs [1, 2, 3] from the myFoo 'this' instance
	 * ```
	 *
	 * #### Example:
	 * This example creates a bound version of a service function, and copies it to another object
	 * ```
	 *
	 * var SomeService = {
	 *   this.data = [3, 4, 5];
	 *   this.log = function() {
	 *     console.log(this.data);
	 *   }
	 * }
	 *
	 * // Constructor fn
	 * function OtherThing() {
	 *   // Binds all functions from SomeService to SomeService,
	 *   // then copies them to 'this'
	 *   bindFunctions(SomeService, this, SomeService);
	 * }
	 *
	 * let myOtherThing = new OtherThing();
	 * myOtherThing.log(); // logs [3, 4, 5] from SomeService's 'this'
	 * ```
	 *
	 * @param source A function that returns the source object which contains the original functions to be bound
	 * @param target A function that returns the target object which will receive the bound functions
	 * @param bind A function that returns the object which the functions will be bound to
	 * @param fnNames The function names which will be bound (Defaults to all the functions found on the 'from' object)
	 * @param latebind If true, the binding of the function is delayed until the first time it's invoked
	 */
	function createProxyFunctions(source, target, bind, fnNames, latebind) {
	    if (latebind === void 0) { latebind = false; }
	    var bindFunction = function (fnName) {
	        return source()[fnName].bind(bind());
	    };
	    var makeLateRebindFn = function (fnName) { return function lateRebindFunction() {
	        target[fnName] = bindFunction(fnName);
	        return target[fnName].apply(null, arguments);
	    }; };
	    fnNames = fnNames || Object.keys(source());
	    return fnNames.reduce(function (acc, name) {
	        acc[name] = latebind ? makeLateRebindFn(name) : bindFunction(name);
	        return acc;
	    }, target);
	}
	exports.createProxyFunctions = createProxyFunctions;
	/**
	 * prototypal inheritance helper.
	 * Creates a new object which has `parent` object as its prototype, and then copies the properties from `extra` onto it
	 */
	exports.inherit = function (parent, extra) {
	    return exports.extend(new (exports.extend(function () { }, { prototype: parent }))(), extra);
	};
	/**
	 * Given an arguments object, converts the arguments at index idx and above to an array.
	 * This is similar to es6 rest parameters.
	 *
	 * Optionally, the argument at index idx may itself already be an array.
	 *
	 * For example,
	 * given either:
	 *        arguments = [ obj, "foo", "bar" ]
	 * or:
	 *        arguments = [ obj, ["foo", "bar"] ]
	 * then:
	 *        restArgs(arguments, 1) == ["foo", "bar"]
	 *
	 * This allows functions like pick() to be implemented such that it allows either a bunch
	 * of string arguments (like es6 rest parameters), or a single array of strings:
	 *
	 * given:
	 *        var obj = { foo: 1, bar: 2, baz: 3 };
	 * then:
	 *        pick(obj, "foo", "bar");   // returns { foo: 1, bar: 2 }
	 *        pick(obj, ["foo", "bar"]); // returns { foo: 1, bar: 2 }
	 */
	var restArgs = function (args, idx) {
	    if (idx === void 0) { idx = 0; }
	    return Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(args, idx));
	};
	/** Given an array, returns true if the object is found in the array, (using indexOf) */
	exports.inArray = hof_1.curry(_inArray);
	function _inArray(array, obj) {
	    return array.indexOf(obj) !== -1;
	}
	exports._inArray = _inArray;
	/**
	 * Given an array, and an item, if the item is found in the array, it removes it (in-place).
	 * The same array is returned
	 */
	exports.removeFrom = hof_1.curry(_removeFrom);
	function _removeFrom(array, obj) {
	    var idx = array.indexOf(obj);
	    if (idx >= 0)
	        array.splice(idx, 1);
	    return array;
	}
	exports._removeFrom = _removeFrom;
	/** pushes a values to an array and returns the value */
	exports.pushTo = hof_1.curry(_pushTo);
	function _pushTo(arr, val) {
	    return (arr.push(val), val);
	}
	exports._pushTo = _pushTo;
	/** Given an array of (deregistration) functions, calls all functions and removes each one from the source array */
	exports.deregAll = function (functions) {
	    return functions.slice().forEach(function (fn) {
	        typeof fn === 'function' && fn();
	        exports.removeFrom(functions, fn);
	    });
	};
	/**
	 * Applies a set of defaults to an options object.  The options object is filtered
	 * to only those properties of the objects in the defaultsList.
	 * Earlier objects in the defaultsList take precedence when applying defaults.
	 */
	function defaults(opts) {
	    if (opts === void 0) { opts = {}; }
	    var defaultsList = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        defaultsList[_i - 1] = arguments[_i];
	    }
	    var defaults = merge.apply(null, [{}].concat(defaultsList));
	    return exports.extend({}, defaults, pick(opts || {}, Object.keys(defaults)));
	}
	exports.defaults = defaults;
	/**
	 * Merges properties from the list of objects to the destination object.
	 * If a property already exists in the destination object, then it is not overwritten.
	 */
	function merge(dst) {
	    var objs = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        objs[_i - 1] = arguments[_i];
	    }
	    exports.forEach(objs, function (obj) {
	        exports.forEach(obj, function (value, key) {
	            if (!dst.hasOwnProperty(key))
	                dst[key] = value;
	        });
	    });
	    return dst;
	}
	exports.merge = merge;
	/** Reduce function that merges each element of the list into a single object, using extend */
	exports.mergeR = function (memo, item) { return exports.extend(memo, item); };
	/**
	 * Finds the common ancestor path between two states.
	 *
	 * @param {Object} first The first state.
	 * @param {Object} second The second state.
	 * @return {Array} Returns an array of state names in descending order, not including the root.
	 */
	function ancestors(first, second) {
	    var path = [];
	    for (var n in first.path) {
	        if (first.path[n] !== second.path[n])
	            break;
	        path.push(first.path[n]);
	    }
	    return path;
	}
	exports.ancestors = ancestors;
	function pickOmitImpl(predicate, obj) {
	    var keys = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        keys[_i - 2] = arguments[_i];
	    }
	    var objCopy = {};
	    for (var key in obj) {
	        if (predicate(keys, key))
	            objCopy[key] = obj[key];
	    }
	    return objCopy;
	}
	/** Return a copy of the object only containing the whitelisted properties. */
	function pick(obj) {
	    return pickOmitImpl.apply(null, [exports.inArray].concat(restArgs(arguments)));
	}
	exports.pick = pick;
	/** Return a copy of the object omitting the blacklisted properties. */
	function omit(obj) {
	    var notInArray = function (array, item) { return !exports.inArray(array, item); };
	    return pickOmitImpl.apply(null, [notInArray].concat(restArgs(arguments)));
	}
	exports.omit = omit;
	/**
	 * Maps an array, or object to a property (by name)
	 */
	function pluck(collection, propName) {
	    return map(collection, hof_1.prop(propName));
	}
	exports.pluck = pluck;
	/** Filters an Array or an Object's properties based on a predicate */
	function filter(collection, callback) {
	    var arr = predicates_1.isArray(collection), result = arr ? [] : {};
	    var accept = arr ? function (x) { return result.push(x); } : function (x, key) { return result[key] = x; };
	    exports.forEach(collection, function (item, i) {
	        if (callback(item, i))
	            accept(item, i);
	    });
	    return result;
	}
	exports.filter = filter;
	/** Finds an object from an array, or a property of an object, that matches a predicate */
	function find(collection, callback) {
	    var result;
	    exports.forEach(collection, function (item, i) {
	        if (result)
	            return;
	        if (callback(item, i))
	            result = item;
	    });
	    return result;
	}
	exports.find = find;
	/** Given an object, returns a new object, where each property is transformed by the callback function */
	exports.mapObj = map;
	/** Maps an array or object properties using a callback function */
	function map(collection, callback) {
	    var result = predicates_1.isArray(collection) ? [] : {};
	    exports.forEach(collection, function (item, i) { return result[i] = callback(item, i); });
	    return result;
	}
	exports.map = map;
	/**
	 * Given an object, return its enumerable property values
	 *
	 * @example
	 * ```
	 *
	 * let foo = { a: 1, b: 2, c: 3 }
	 * let vals = values(foo); // [ 1, 2, 3 ]
	 * ```
	 */
	exports.values = function (obj) {
	    return Object.keys(obj).map(function (key) { return obj[key]; });
	};
	/**
	 * Reduce function that returns true if all of the values are truthy.
	 *
	 * @example
	 * ```
	 *
	 * let vals = [ 1, true, {}, "hello world"];
	 * vals.reduce(allTrueR, true); // true
	 *
	 * vals.push(0);
	 * vals.reduce(allTrueR, true); // false
	 * ```
	 */
	exports.allTrueR = function (memo, elem) { return memo && elem; };
	/**
	 * Reduce function that returns true if any of the values are truthy.
	 *
	 *  * @example
	 * ```
	 *
	 * let vals = [ 0, null, undefined ];
	 * vals.reduce(anyTrueR, true); // false
	 *
	 * vals.push("hello world");
	 * vals.reduce(anyTrueR, true); // true
	 * ```
	 */
	exports.anyTrueR = function (memo, elem) { return memo || elem; };
	/**
	 * Reduce function which un-nests a single level of arrays
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
	 * ```
	 */
	exports.unnestR = function (memo, elem) { return memo.concat(elem); };
	/**
	 * Reduce function which recursively un-nests all arrays
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", "double, "nested" ]
	 * ```
	 */
	exports.flattenR = function (memo, elem) {
	    return predicates_1.isArray(elem) ? memo.concat(elem.reduce(exports.flattenR, [])) : pushR(memo, elem);
	};
	/**
	 * Reduce function that pushes an object to an array, then returns the array.
	 * Mostly just for [[flattenR]] and [[uniqR]]
	 */
	function pushR(arr, obj) {
	    arr.push(obj);
	    return arr;
	}
	exports.pushR = pushR;
	/** Reduce function that filters out duplicates */
	exports.uniqR = function (acc, token) {
	    return exports.inArray(acc, token) ? acc : pushR(acc, token);
	};
	/**
	 * Return a new array with a single level of arrays unnested.
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * unnest(input) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
	 * ```
	 */
	exports.unnest = function (arr) { return arr.reduce(exports.unnestR, []); };
	/**
	 * Return a completely flattened version of an array.
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * flatten(input) // [ "a", "b", "c", "d", "double, "nested" ]
	 * ```
	 */
	exports.flatten = function (arr) { return arr.reduce(exports.flattenR, []); };
	/**
	 * Given a .filter Predicate, builds a .filter Predicate which throws an error if any elements do not pass.
	 * @example
	 * ```
	 *
	 * let isNumber = (obj) => typeof(obj) === 'number';
	 * let allNumbers = [ 1, 2, 3, 4, 5 ];
	 * allNumbers.filter(assertPredicate(isNumber)); //OK
	 *
	 * let oneString = [ 1, 2, 3, 4, "5" ];
	 * oneString.filter(assertPredicate(isNumber, "Not all numbers")); // throws Error(""Not all numbers"");
	 * ```
	 */
	exports.assertPredicate = assertFn;
	/**
	 * Given a .map function, builds a .map function which throws an error if any mapped elements do not pass a truthyness test.
	 * @example
	 * ```
	 *
	 * var data = { foo: 1, bar: 2 };
	 *
	 * let keys = [ 'foo', 'bar' ]
	 * let values = keys.map(assertMap(key => data[key], "Key not found"));
	 * // values is [1, 2]
	 *
	 * let keys = [ 'foo', 'bar', 'baz' ]
	 * let values = keys.map(assertMap(key => data[key], "Key not found"));
	 * // throws Error("Key not found")
	 * ```
	 */
	exports.assertMap = assertFn;
	function assertFn(predicateOrMap, errMsg) {
	    if (errMsg === void 0) { errMsg = "assert failure"; }
	    return function (obj) {
	        var result = predicateOrMap(obj);
	        if (!result) {
	            throw new Error(predicates_1.isFunction(errMsg) ? errMsg(obj) : errMsg);
	        }
	        return result;
	    };
	}
	exports.assertFn = assertFn;
	/**
	 * Like _.pairs: Given an object, returns an array of key/value pairs
	 *
	 * @example
	 * ```
	 *
	 * pairs({ foo: "FOO", bar: "BAR }) // [ [ "foo", "FOO" ], [ "bar": "BAR" ] ]
	 * ```
	 */
	exports.pairs = function (obj) {
	    return Object.keys(obj).map(function (key) { return [key, obj[key]]; });
	};
	/**
	 * Given two or more parallel arrays, returns an array of tuples where
	 * each tuple is composed of [ a[i], b[i], ... z[i] ]
	 *
	 * @example
	 * ```
	 *
	 * let foo = [ 0, 2, 4, 6 ];
	 * let bar = [ 1, 3, 5, 7 ];
	 * let baz = [ 10, 30, 50, 70 ];
	 * arrayTuples(foo, bar);       // [ [0, 1], [2, 3], [4, 5], [6, 7] ]
	 * arrayTuples(foo, bar, baz);  // [ [0, 1, 10], [2, 3, 30], [4, 5, 50], [6, 7, 70] ]
	 * ```
	 */
	function arrayTuples() {
	    var arrayArgs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        arrayArgs[_i] = arguments[_i];
	    }
	    if (arrayArgs.length === 0)
	        return [];
	    var length = arrayArgs.reduce(function (min, arr) { return Math.min(arr.length, min); }, 9007199254740991); // aka 2^53 − 1 aka Number.MAX_SAFE_INTEGER
	    return Array.apply(null, Array(length)).map(function (ignored, idx) { return arrayArgs.map(function (arr) { return arr[idx]; }); });
	}
	exports.arrayTuples = arrayTuples;
	/**
	 * Reduce function which builds an object from an array of [key, value] pairs.
	 *
	 * Each iteration sets the key/val pair on the memo object, then returns the memo for the next iteration.
	 *
	 * Each keyValueTuple should be an array with values [ key: string, value: any ]
	 *
	 * @example
	 * ```
	 *
	 * var pairs = [ ["fookey", "fooval"], ["barkey", "barval"] ]
	 *
	 * var pairsToObj = pairs.reduce((memo, pair) => applyPairs(memo, pair), {})
	 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
	 *
	 * // Or, more simply:
	 * var pairsToObj = pairs.reduce(applyPairs, {})
	 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
	 * ```
	 */
	function applyPairs(memo, keyValTuple) {
	    var key, value;
	    if (predicates_1.isArray(keyValTuple))
	        key = keyValTuple[0], value = keyValTuple[1];
	    if (!predicates_1.isString(key))
	        throw new Error("invalid parameters to applyPairs");
	    memo[key] = value;
	    return memo;
	}
	exports.applyPairs = applyPairs;
	/** Get the last element of an array */
	function tail(arr) {
	    return arr.length && arr[arr.length - 1] || undefined;
	}
	exports.tail = tail;
	/**
	 * shallow copy from src to dest
	 *
	 * note: This is a shallow copy, while angular.copy is a deep copy.
	 * ui-router uses `copy` only to make copies of state parameters.
	 */
	function _copy(src, dest) {
	    if (dest)
	        Object.keys(dest).forEach(function (key) { return delete dest[key]; });
	    if (!dest)
	        dest = {};
	    return exports.extend(dest, src);
	}
	/** Naive forEach implementation works with Objects or Arrays */
	function _forEach(obj, cb, _this) {
	    if (predicates_1.isArray(obj))
	        return obj.forEach(cb, _this);
	    Object.keys(obj).forEach(function (key) { return cb(obj[key], key); });
	}
	function _copyProps(to, from) {
	    Object.keys(from).forEach(function (key) { return to[key] = from[key]; });
	    return to;
	}
	function _extend(toObj) {
	    return restArgs(arguments, 1).filter(exports.identity).reduce(_copyProps, toObj);
	}
	function _equals(o1, o2) {
	    if (o1 === o2)
	        return true;
	    if (o1 === null || o2 === null)
	        return false;
	    if (o1 !== o1 && o2 !== o2)
	        return true; // NaN === NaN
	    var t1 = typeof o1, t2 = typeof o2;
	    if (t1 !== t2 || t1 !== 'object')
	        return false;
	    var tup = [o1, o2];
	    if (hof_1.all(predicates_1.isArray)(tup))
	        return _arraysEq(o1, o2);
	    if (hof_1.all(predicates_1.isDate)(tup))
	        return o1.getTime() === o2.getTime();
	    if (hof_1.all(predicates_1.isRegExp)(tup))
	        return o1.toString() === o2.toString();
	    if (hof_1.all(predicates_1.isFunction)(tup))
	        return true; // meh
	    var predicates = [predicates_1.isFunction, predicates_1.isArray, predicates_1.isDate, predicates_1.isRegExp];
	    if (predicates.map(hof_1.any).reduce(function (b, fn) { return b || !!fn(tup); }, false))
	        return false;
	    var key, keys = {};
	    for (key in o1) {
	        if (!_equals(o1[key], o2[key]))
	            return false;
	        keys[key] = true;
	    }
	    for (key in o2) {
	        if (!keys[key])
	            return false;
	    }
	    return true;
	}
	function _arraysEq(a1, a2) {
	    if (a1.length !== a2.length)
	        return false;
	    return arrayTuples(a1, a2).reduce(function (b, t) { return b && _equals(t[0], t[1]); }, true);
	}
	/**
	 * Create a sort function
	 *
	 * Creates a sort function which sorts by a numeric property.
	 *
	 * The `propFn` should return the property as a number which can be sorted.
	 *
	 * #### Example:
	 * This example returns the `priority` prop.
	 * ```js
	 * var sortfn = sortBy(obj => obj.priority)
	 * // equivalent to:
	 * var longhandSortFn = (a, b) => a.priority - b.priority;
	 * ```
	 *
	 * #### Example:
	 * This example uses [[prop]]
	 * ```js
	 * var sortfn = sortBy(prop('priority'))
	 * ```
	 *
	 * The `checkFn` can be used to exclude objects from sorting.
	 *
	 * #### Example:
	 * This example only sorts objects with type === 'FOO'
	 * ```js
	 * var sortfn = sortBy(prop('priority'), propEq('type', 'FOO'))
	 * ```
	 *
	 * @param propFn a function that returns the property (as a number)
	 * @param checkFn a predicate
	 *
	 * @return a sort function like: `(a, b) => (checkFn(a) && checkFn(b)) ? propFn(a) - propFn(b) : 0`
	 */
	exports.sortBy = function (propFn, checkFn) {
	    if (checkFn === void 0) { checkFn = hof_1.val(true); }
	    return function (a, b) {
	        return (checkFn(a) && checkFn(b)) ? propFn(a) - propFn(b) : 0;
	    };
	};
	/**
	 * Composes a list of sort functions
	 *
	 * Creates a sort function composed of multiple sort functions.
	 * Each sort function is invoked in series.
	 * The first sort function to return non-zero "wins".
	 *
	 * @param sortFns list of sort functions
	 */
	exports.composeSort = function () {
	    var sortFns = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        sortFns[_i] = arguments[_i];
	    }
	    return function (a, b) {
	        return sortFns.reduce(function (prev, fn) { return prev || fn(a, b); }, 0);
	    };
	};
	// issue #2676
	exports.silenceUncaughtInPromise = function (promise) {
	    return promise.catch(function (e) { return 0; }) && promise;
	};
	exports.silentRejection = function (error) {
	    return exports.silenceUncaughtInPromise(coreservices_1.services.$q.reject(error));
	};
	//# sourceMappingURL=common.js.map

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/** Predicates
	 *
	 * These predicates return true/false based on the input.
	 * Although these functions are exported, they are subject to change without notice.
	 *
	 * @module common_predicates
	 */ /** */
	var hof_1 = __webpack_require__(307);
	var toStr = Object.prototype.toString;
	var tis = function (t) { return function (x) { return typeof (x) === t; }; };
	exports.isUndefined = tis('undefined');
	exports.isDefined = hof_1.not(exports.isUndefined);
	exports.isNull = function (o) { return o === null; };
	exports.isNullOrUndefined = hof_1.or(exports.isNull, exports.isUndefined);
	exports.isFunction = tis('function');
	exports.isNumber = tis('number');
	exports.isString = tis('string');
	exports.isObject = function (x) { return x !== null && typeof x === 'object'; };
	exports.isArray = Array.isArray;
	exports.isDate = (function (x) { return toStr.call(x) === '[object Date]'; });
	exports.isRegExp = (function (x) { return toStr.call(x) === '[object RegExp]'; });
	/**
	 * Predicate which checks if a value is injectable
	 *
	 * A value is "injectable" if it is a function, or if it is an ng1 array-notation-style array
	 * where all the elements in the array are Strings, except the last one, which is a Function
	 */
	function isInjectable(val) {
	    if (exports.isArray(val) && val.length) {
	        var head = val.slice(0, -1), tail = val.slice(-1);
	        return !(head.filter(hof_1.not(exports.isString)).length || tail.filter(hof_1.not(exports.isFunction)).length);
	    }
	    return exports.isFunction(val);
	}
	exports.isInjectable = isInjectable;
	/**
	 * Predicate which checks if a value looks like a Promise
	 *
	 * It is probably a Promise if it's an object, and it has a `then` property which is a Function
	 */
	exports.isPromise = hof_1.and(exports.isObject, hof_1.pipe(hof_1.prop('then'), exports.isFunction));
	//# sourceMappingURL=predicates.js.map

/***/ },
/* 307 */
/***/ function(module, exports) {

	/**
	 * Higher order functions
	 *
	 * These utility functions are exported, but are subject to change without notice.
	 *
	 * @module common_hof
	 */ /** */
	"use strict";
	/**
	 * Returns a new function for [Partial Application](https://en.wikipedia.org/wiki/Partial_application) of the original function.
	 *
	 * Given a function with N parameters, returns a new function that supports partial application.
	 * The new function accepts anywhere from 1 to N parameters.  When that function is called with M parameters,
	 * where M is less than N, it returns a new function that accepts the remaining parameters.  It continues to
	 * accept more parameters until all N parameters have been supplied.
	 *
	 *
	 * This contrived example uses a partially applied function as an predicate, which returns true
	 * if an object is found in both arrays.
	 * @example
	 * ```
	 * // returns true if an object is in both of the two arrays
	 * function inBoth(array1, array2, object) {
	 *   return array1.indexOf(object) !== -1 &&
	 *          array2.indexOf(object) !== 1;
	 * }
	 * let obj1, obj2, obj3, obj4, obj5, obj6, obj7
	 * let foos = [obj1, obj3]
	 * let bars = [obj3, obj4, obj5]
	 *
	 * // A curried "copy" of inBoth
	 * let curriedInBoth = curry(inBoth);
	 * // Partially apply both the array1 and array2
	 * let inFoosAndBars = curriedInBoth(foos, bars);
	 *
	 * // Supply the final argument; since all arguments are
	 * // supplied, the original inBoth function is then called.
	 * let obj1InBoth = inFoosAndBars(obj1); // false
	 *
	 * // Use the inFoosAndBars as a predicate.
	 * // Filter, on each iteration, supplies the final argument
	 * let allObjs = [ obj1, obj2, obj3, obj4, obj5, obj6, obj7 ];
	 * let foundInBoth = allObjs.filter(inFoosAndBars); // [ obj3 ]
	 *
	 * ```
	 *
	 * Stolen from: http://stackoverflow.com/questions/4394747/javascript-curry-function
	 *
	 * @param fn
	 * @returns {*|function(): (*|any)}
	 */
	function curry(fn) {
	    var initial_args = [].slice.apply(arguments, [1]);
	    var func_args_length = fn.length;
	    function curried(args) {
	        if (args.length >= func_args_length)
	            return fn.apply(null, args);
	        return function () {
	            return curried(args.concat([].slice.apply(arguments)));
	        };
	    }
	    return curried(initial_args);
	}
	exports.curry = curry;
	/**
	 * Given a varargs list of functions, returns a function that composes the argument functions, right-to-left
	 * given: f(x), g(x), h(x)
	 * let composed = compose(f,g,h)
	 * then, composed is: f(g(h(x)))
	 */
	function compose() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function () {
	        var i = start, result = args[start].apply(this, arguments);
	        while (i--)
	            result = args[i].call(this, result);
	        return result;
	    };
	}
	exports.compose = compose;
	/**
	 * Given a varargs list of functions, returns a function that is composes the argument functions, left-to-right
	 * given: f(x), g(x), h(x)
	 * let piped = pipe(f,g,h);
	 * then, piped is: h(g(f(x)))
	 */
	function pipe() {
	    var funcs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        funcs[_i] = arguments[_i];
	    }
	    return compose.apply(null, [].slice.call(arguments).reverse());
	}
	exports.pipe = pipe;
	/**
	 * Given a property name, returns a function that returns that property from an object
	 * let obj = { foo: 1, name: "blarg" };
	 * let getName = prop("name");
	 * getName(obj) === "blarg"
	 */
	exports.prop = function (name) {
	    return function (obj) { return obj && obj[name]; };
	};
	/**
	 * Given a property name and a value, returns a function that returns a boolean based on whether
	 * the passed object has a property that matches the value
	 * let obj = { foo: 1, name: "blarg" };
	 * let getName = propEq("name", "blarg");
	 * getName(obj) === true
	 */
	exports.propEq = curry(function (name, val, obj) { return obj && obj[name] === val; });
	/**
	 * Given a dotted property name, returns a function that returns a nested property from an object, or undefined
	 * let obj = { id: 1, nestedObj: { foo: 1, name: "blarg" }, };
	 * let getName = prop("nestedObj.name");
	 * getName(obj) === "blarg"
	 * let propNotFound = prop("this.property.doesnt.exist");
	 * propNotFound(obj) === undefined
	 */
	exports.parse = function (name) {
	    return pipe.apply(null, name.split(".").map(exports.prop));
	};
	/**
	 * Given a function that returns a truthy or falsey value, returns a
	 * function that returns the opposite (falsey or truthy) value given the same inputs
	 */
	exports.not = function (fn) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return !fn.apply(null, args);
	    };
	};
	/**
	 * Given two functions that return truthy or falsey values, returns a function that returns truthy
	 * if both functions return truthy for the given arguments
	 */
	function and(fn1, fn2) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return fn1.apply(null, args) && fn2.apply(null, args);
	    };
	}
	exports.and = and;
	/**
	 * Given two functions that return truthy or falsey values, returns a function that returns truthy
	 * if at least one of the functions returns truthy for the given arguments
	 */
	function or(fn1, fn2) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return fn1.apply(null, args) || fn2.apply(null, args);
	    };
	}
	exports.or = or;
	/**
	 * Check if all the elements of an array match a predicate function
	 *
	 * @param fn1 a predicate function `fn1`
	 * @returns a function which takes an array and returns true if `fn1` is true for all elements of the array
	 */
	exports.all = function (fn1) {
	    return function (arr) { return arr.reduce(function (b, x) { return b && !!fn1(x); }, true); };
	};
	exports.any = function (fn1) {
	    return function (arr) { return arr.reduce(function (b, x) { return b || !!fn1(x); }, false); };
	};
	/** Given a class, returns a Predicate function that returns true if the object is of that class */
	exports.is = function (ctor) {
	    return function (obj) {
	        return (obj != null && obj.constructor === ctor || obj instanceof ctor);
	    };
	};
	/** Given a value, returns a Predicate function that returns true if another value is === equal to the original value */
	exports.eq = function (val) { return function (other) {
	    return val === other;
	}; };
	/** Given a value, returns a function which returns the value */
	exports.val = function (v) { return function () { return v; }; };
	function invoke(fnName, args) {
	    return function (obj) {
	        return obj[fnName].apply(obj, args);
	    };
	}
	exports.invoke = invoke;
	/**
	 * Sorta like Pattern Matching (a functional programming conditional construct)
	 *
	 * See http://c2.com/cgi/wiki?PatternMatching
	 *
	 * This is a conditional construct which allows a series of predicates and output functions
	 * to be checked and then applied.  Each predicate receives the input.  If the predicate
	 * returns truthy, then its matching output function (mapping function) is provided with
	 * the input and, then the result is returned.
	 *
	 * Each combination (2-tuple) of predicate + output function should be placed in an array
	 * of size 2: [ predicate, mapFn ]
	 *
	 * These 2-tuples should be put in an outer array.
	 *
	 * @example
	 * ```
	 *
	 * // Here's a 2-tuple where the first element is the isString predicate
	 * // and the second element is a function that returns a description of the input
	 * let firstTuple = [ angular.isString, (input) => `Heres your string ${input}` ];
	 *
	 * // Second tuple: predicate "isNumber", mapfn returns a description
	 * let secondTuple = [ angular.isNumber, (input) => `(${input}) That's a number!` ];
	 *
	 * let third = [ (input) => input === null,  (input) => `Oh, null...` ];
	 *
	 * let fourth = [ (input) => input === undefined,  (input) => `notdefined` ];
	 *
	 * let descriptionOf = pattern([ firstTuple, secondTuple, third, fourth ]);
	 *
	 * console.log(descriptionOf(undefined)); // 'notdefined'
	 * console.log(descriptionOf(55)); // '(55) That's a number!'
	 * console.log(descriptionOf("foo")); // 'Here's your string foo'
	 * ```
	 *
	 * @param struct A 2D array.  Each element of the array should be an array, a 2-tuple,
	 * with a Predicate and a mapping/output function
	 * @returns {function(any): *}
	 */
	function pattern(struct) {
	    return function (x) {
	        for (var i = 0; i < struct.length; i++) {
	            if (struct[i][0](x))
	                return struct[i][1](x);
	        }
	    };
	}
	exports.pattern = pattern;
	//# sourceMappingURL=hof.js.map

/***/ },
/* 308 */
/***/ function(module, exports) {

	"use strict";
	exports.notImplemented = function (fnname) { return function () {
	    throw new Error(fnname + "(): No coreservices implementation for UI-Router is loaded.");
	}; };
	var services = {
	    $q: undefined,
	    $injector: undefined,
	};
	exports.services = services;
	//# sourceMappingURL=coreservices.js.map

/***/ },
/* 309 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @coreapi
	 * @module core
	 */
	/**
	 * Matches state names using glob-like pattern strings.
	 *
	 * Globs can be used in specific APIs including:
	 *
	 * - [[StateService.is]]
	 * - [[StateService.includes]]
	 * - The first argument to Hook Registration functions like [[TransitionService.onStart]]
	 *    - [[HookMatchCriteria]] and [[HookMatchCriterion]]
	 *
	 * A `Glob` string is a pattern which matches state names.
	 * Nested state names are split into segments (separated by a dot) when processing.
	 * The state named `foo.bar.baz` is split into three segments ['foo', 'bar', 'baz']
	 *
	 * Globs work according to the following rules:
	 *
	 * ### Exact match:
	 *
	 * The glob `'A.B'` matches the state named exactly `'A.B'`.
	 *
	 * | Glob        |Matches states named|Does not match state named|
	 * |:------------|:--------------------|:---------------------|
	 * | `'A'`       | `'A'`               | `'B'` , `'A.C'`      |
	 * | `'A.B'`     | `'A.B'`             | `'A'` , `'A.B.C'`    |
	 * | `'foo'`     | `'foo'`             | `'FOO'` , `'foo.bar'`|
	 *
	 * ### Single star (`*`)
	 *
	 * A single star (`*`) is a wildcard that matches exactly one segment.
	 *
	 * | Glob        |Matches states named  |Does not match state named |
	 * |:------------|:---------------------|:--------------------------|
	 * | `'*'`       | `'A'` , `'Z'`        | `'A.B'` , `'Z.Y.X'`       |
	 * | `'A.*'`     | `'A.B'` , `'A.C'`    | `'A'` , `'A.B.C'`         |
	 * | `'A.*.*'`   | `'A.B.C'` , `'A.X.Y'`| `'A'`, `'A.B'` , `'Z.Y.X'`|
	 *
	 * ### Double star (`**`)
	 *
	 * A double star (`'**'`) is a wildcard that matches *zero or more segments*
	 *
	 * | Glob        |Matches states named                           |Does not match state named         |
	 * |:------------|:----------------------------------------------|:----------------------------------|
	 * | `'**'`      | `'A'` , `'A.B'`, `'Z.Y.X'`                    | (matches all states)              |
	 * | `'A.**'`    | `'A'` , `'A.B'` , `'A.C.X'`                   | `'Z.Y.X'`                         |
	 * | `'**.X'`    | `'X'` , `'A.X'` , `'Z.Y.X'`                   | `'A'` , `'A.login.Z'`             |
	 * | `'A.**.X'`  | `'A.X'` , `'A.B.X'` , `'A.B.C.X'`             | `'A'` , `'A.B.C'`                 |
	 *
	 */
	var Glob = (function () {
	    function Glob(text) {
	        this.text = text;
	        this.glob = text.split('.');
	        var regexpString = this.text.split('.')
	            .map(function (seg) {
	            if (seg === '**')
	                return '(?:|(?:\\.[^.]*)*)';
	            if (seg === '*')
	                return '\\.[^.]*';
	            return '\\.' + seg;
	        }).join('');
	        this.regexp = new RegExp("^" + regexpString + "$");
	    }
	    Glob.prototype.matches = function (name) {
	        return this.regexp.test('.' + name);
	    };
	    /** @deprecated whats the point? */
	    Glob.is = function (text) {
	        return text.indexOf('*') > -1;
	    };
	    /** @deprecated whats the point? */
	    Glob.fromString = function (text) {
	        if (!this.is(text))
	            return null;
	        return new Glob(text);
	    };
	    return Glob;
	}());
	exports.Glob = Glob;
	//# sourceMappingURL=glob.js.map

/***/ },
/* 310 */
/***/ function(module, exports) {

	/**
	 * @module common
	 */ /** for typedoc */
	"use strict";
	var Queue = (function () {
	    function Queue(_items, _limit) {
	        if (_items === void 0) { _items = []; }
	        if (_limit === void 0) { _limit = null; }
	        this._items = _items;
	        this._limit = _limit;
	    }
	    Queue.prototype.enqueue = function (item) {
	        var items = this._items;
	        items.push(item);
	        if (this._limit && items.length > this._limit)
	            items.shift();
	        return item;
	    };
	    Queue.prototype.dequeue = function () {
	        if (this.size())
	            return this._items.splice(0, 1)[0];
	    };
	    Queue.prototype.clear = function () {
	        var current = this._items;
	        this._items = [];
	        return current;
	    };
	    Queue.prototype.size = function () {
	        return this._items.length;
	    };
	    Queue.prototype.remove = function (item) {
	        var idx = this._items.indexOf(item);
	        return idx > -1 && this._items.splice(idx, 1)[0];
	    };
	    Queue.prototype.peekTail = function () {
	        return this._items[this._items.length - 1];
	    };
	    Queue.prototype.peekHead = function () {
	        if (this.size())
	            return this._items[0];
	    };
	    return Queue;
	}());
	exports.Queue = Queue;
	//# sourceMappingURL=queue.js.map

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Functions that manipulate strings
	 *
	 * Although these functions are exported, they are subject to change without notice.
	 *
	 * @module common_strings
	 */ /** */
	"use strict";
	var predicates_1 = __webpack_require__(306);
	var rejectFactory_1 = __webpack_require__(312);
	var common_1 = __webpack_require__(305);
	var hof_1 = __webpack_require__(307);
	var transition_1 = __webpack_require__(313);
	var resolvable_1 = __webpack_require__(324);
	/**
	 * Returns a string shortened to a maximum length
	 *
	 * If the string is already less than the `max` length, return the string.
	 * Else return the string, shortened to `max - 3` and append three dots ("...").
	 *
	 * @param max the maximum length of the string to return
	 * @param str the input string
	 */
	function maxLength(max, str) {
	    if (str.length <= max)
	        return str;
	    return str.substr(0, max - 3) + "...";
	}
	exports.maxLength = maxLength;
	/**
	 * Returns a string, with spaces added to the end, up to a desired str length
	 *
	 * If the string is already longer than the desired length, return the string.
	 * Else returns the string, with extra spaces on the end, such that it reaches `length` characters.
	 *
	 * @param length the desired length of the string to return
	 * @param str the input string
	 */
	function padString(length, str) {
	    while (str.length < length)
	        str += " ";
	    return str;
	}
	exports.padString = padString;
	function kebobString(camelCase) {
	    return camelCase
	        .replace(/^([A-Z])/, function ($1) { return $1.toLowerCase(); }) // replace first char
	        .replace(/([A-Z])/g, function ($1) { return "-" + $1.toLowerCase(); }); // replace rest
	}
	exports.kebobString = kebobString;
	function _toJson(obj) {
	    return JSON.stringify(obj);
	}
	function _fromJson(json) {
	    return predicates_1.isString(json) ? JSON.parse(json) : json;
	}
	function promiseToString(p) {
	    return "Promise(" + JSON.stringify(p) + ")";
	}
	function functionToString(fn) {
	    var fnStr = fnToString(fn);
	    var namedFunctionMatch = fnStr.match(/^(function [^ ]+\([^)]*\))/);
	    var toStr = namedFunctionMatch ? namedFunctionMatch[1] : fnStr;
	    var fnName = fn['name'] || "";
	    if (fnName && toStr.match(/function \(/)) {
	        return 'function ' + fnName + toStr.substr(9);
	    }
	    return toStr;
	}
	exports.functionToString = functionToString;
	function fnToString(fn) {
	    var _fn = predicates_1.isArray(fn) ? fn.slice(-1)[0] : fn;
	    return _fn && _fn.toString() || "undefined";
	}
	exports.fnToString = fnToString;
	var stringifyPatternFn = null;
	var stringifyPattern = function (value) {
	    var isTransitionRejectionPromise = rejectFactory_1.Rejection.isTransitionRejectionPromise;
	    stringifyPatternFn = stringifyPatternFn || hof_1.pattern([
	        [hof_1.not(predicates_1.isDefined), hof_1.val("undefined")],
	        [predicates_1.isNull, hof_1.val("null")],
	        [predicates_1.isPromise, hof_1.val("[Promise]")],
	        [isTransitionRejectionPromise, function (x) { return x._transitionRejection.toString(); }],
	        [hof_1.is(rejectFactory_1.Rejection), hof_1.invoke("toString")],
	        [hof_1.is(transition_1.Transition), hof_1.invoke("toString")],
	        [hof_1.is(resolvable_1.Resolvable), hof_1.invoke("toString")],
	        [predicates_1.isInjectable, functionToString],
	        [hof_1.val(true), common_1.identity]
	    ]);
	    return stringifyPatternFn(value);
	};
	function stringify(o) {
	    var seen = [];
	    function format(val) {
	        if (predicates_1.isObject(val)) {
	            if (seen.indexOf(val) !== -1)
	                return '[circular ref]';
	            seen.push(val);
	        }
	        return stringifyPattern(val);
	    }
	    return JSON.stringify(o, function (key, val) { return format(val); }).replace(/\\"/g, '"');
	}
	exports.stringify = stringify;
	/** Returns a function that splits a string on a character or substring */
	exports.beforeAfterSubstr = function (char) { return function (str) {
	    if (!str)
	        return ["", ""];
	    var idx = str.indexOf(char);
	    if (idx === -1)
	        return [str, ""];
	    return [str.substr(0, idx), str.substr(idx + 1)];
	}; };
	/**
	 * Splits on a delimiter, but returns the delimiters in the array
	 *
	 * #### Example:
	 * ```js
	 * var splitOnSlashes = splitOnDelim('/');
	 * splitOnSlashes("/foo"); // ["/", "foo"]
	 * splitOnSlashes("/foo/"); // ["/", "foo", "/"]
	 * ```
	 */
	function splitOnDelim(delim) {
	    var re = new RegExp("(" + delim + ")", "g");
	    return function (str) {
	        return str.split(re).filter(common_1.identity);
	    };
	}
	exports.splitOnDelim = splitOnDelim;
	;
	/**
	 * Reduce fn that joins neighboring strings
	 *
	 * Given an array of strings, returns a new array
	 * where all neighboring strings have been joined.
	 *
	 * #### Example:
	 * ```js
	 * let arr = ["foo", "bar", 1, "baz", "", "qux" ];
	 * arr.reduce(joinNeighborsR, []) // ["foobar", 1, "bazqux" ]
	 * ```
	 */
	function joinNeighborsR(acc, x) {
	    if (predicates_1.isString(common_1.tail(acc)) && predicates_1.isString(x))
	        return acc.slice(0, -1).concat(common_1.tail(acc) + x);
	    return common_1.pushR(acc, x);
	}
	exports.joinNeighborsR = joinNeighborsR;
	;
	//# sourceMappingURL=strings.js.map

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @coreapi
	 * @module transition
	 */ /** for typedoc */
	"use strict";
	var common_1 = __webpack_require__(305);
	var strings_1 = __webpack_require__(311);
	var RejectType;
	(function (RejectType) {
	    RejectType[RejectType["SUPERSEDED"] = 2] = "SUPERSEDED";
	    RejectType[RejectType["ABORTED"] = 3] = "ABORTED";
	    RejectType[RejectType["INVALID"] = 4] = "INVALID";
	    RejectType[RejectType["IGNORED"] = 5] = "IGNORED";
	    RejectType[RejectType["ERROR"] = 6] = "ERROR";
	})(RejectType = exports.RejectType || (exports.RejectType = {}));
	var Rejection = (function () {
	    function Rejection(type, message, detail) {
	        this.type = type;
	        this.message = message;
	        this.detail = detail;
	    }
	    Rejection.prototype.toString = function () {
	        var detailString = function (d) {
	            return d && d.toString !== Object.prototype.toString ? d.toString() : strings_1.stringify(d);
	        };
	        var type = this.type, message = this.message, detail = detailString(this.detail);
	        return "TransitionRejection(type: " + type + ", message: " + message + ", detail: " + detail + ")";
	    };
	    Rejection.prototype.toPromise = function () {
	        return common_1.extend(common_1.silentRejection(this), { _transitionRejection: this });
	    };
	    /** Returns true if the obj is a rejected promise created from the `asPromise` factory */
	    Rejection.isTransitionRejectionPromise = function (obj) {
	        return obj && (typeof obj.then === 'function') && obj._transitionRejection instanceof Rejection;
	    };
	    /** Returns a TransitionRejection due to transition superseded */
	    Rejection.superseded = function (detail, options) {
	        var message = "The transition has been superseded by a different transition";
	        var rejection = new Rejection(RejectType.SUPERSEDED, message, detail);
	        if (options && options.redirected) {
	            rejection.redirected = true;
	        }
	        return rejection;
	    };
	    /** Returns a TransitionRejection due to redirected transition */
	    Rejection.redirected = function (detail) {
	        return Rejection.superseded(detail, { redirected: true });
	    };
	    /** Returns a TransitionRejection due to invalid transition */
	    Rejection.invalid = function (detail) {
	        var message = "This transition is invalid";
	        return new Rejection(RejectType.INVALID, message, detail);
	    };
	    /** Returns a TransitionRejection due to ignored transition */
	    Rejection.ignored = function (detail) {
	        var message = "The transition was ignored";
	        return new Rejection(RejectType.IGNORED, message, detail);
	    };
	    /** Returns a TransitionRejection due to aborted transition */
	    Rejection.aborted = function (detail) {
	        // TODO think about how to encapsulate an Error() object
	        var message = "The transition has been aborted";
	        return new Rejection(RejectType.ABORTED, message, detail);
	    };
	    /** Returns a TransitionRejection due to aborted transition */
	    Rejection.errored = function (detail) {
	        // TODO think about how to encapsulate an Error() object
	        var message = "The transition errored";
	        return new Rejection(RejectType.ERROR, message, detail);
	    };
	    return Rejection;
	}());
	exports.Rejection = Rejection;
	//# sourceMappingURL=rejectFactory.js.map

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var trace_1 = __webpack_require__(314);
	var coreservices_1 = __webpack_require__(308);
	var common_1 = __webpack_require__(305);
	var predicates_1 = __webpack_require__(306);
	var hof_1 = __webpack_require__(307);
	var interface_1 = __webpack_require__(315);
	var transitionHook_1 = __webpack_require__(316);
	var hookRegistry_1 = __webpack_require__(318);
	var hookBuilder_1 = __webpack_require__(319);
	var node_1 = __webpack_require__(320);
	var pathFactory_1 = __webpack_require__(323);
	var targetState_1 = __webpack_require__(317);
	var param_1 = __webpack_require__(321);
	var resolvable_1 = __webpack_require__(324);
	var rejectFactory_1 = __webpack_require__(312);
	var resolveContext_1 = __webpack_require__(325);
	var router_1 = __webpack_require__(327);
	/** @hidden */
	var stateSelf = hof_1.prop("self");
	/**
	 * Represents a transition between two states.
	 *
	 * When navigating to a state, we are transitioning **from** the current state **to** the new state.
	 *
	 * This object contains all contextual information about the to/from states, parameters, resolves.
	 * It has information about all states being entered and exited as a result of the transition.
	 */
	var Transition = (function () {
	    /**
	     * Creates a new Transition object.
	     *
	     * If the target state is not valid, an error is thrown.
	     *
	     * @internalapi
	     *
	     * @param fromPath The path of [[PathNode]]s from which the transition is leaving.  The last node in the `fromPath`
	     *        encapsulates the "from state".
	     * @param targetState The target state and parameters being transitioned to (also, the transition options)
	     * @param router The [[UIRouter]] instance
	     */
	    function Transition(fromPath, targetState, router) {
	        var _this = this;
	        /** @hidden */
	        this._deferred = coreservices_1.services.$q.defer();
	        /**
	         * This promise is resolved or rejected based on the outcome of the Transition.
	         *
	         * When the transition is successful, the promise is resolved
	         * When the transition is unsuccessful, the promise is rejected with the [[TransitionRejection]] or javascript error
	         */
	        this.promise = this._deferred.promise;
	        /** @hidden Holds the hook registration functions such as those passed to Transition.onStart() */
	        this._registeredHooks = {};
	        /**
	         * Checks if this transition is currently active/running.
	         */
	        this.isActive = function () { return _this === _this._options.current(); };
	        this.router = router;
	        this._targetState = targetState;
	        if (!targetState.valid()) {
	            throw new Error(targetState.error());
	        }
	        // current() is assumed to come from targetState.options, but provide a naive implementation otherwise.
	        this._options = common_1.extend({ current: hof_1.val(this) }, targetState.options());
	        this.$id = router.transitionService._transitionCount++;
	        var toPath = pathFactory_1.PathFactory.buildToPath(fromPath, targetState);
	        this._treeChanges = pathFactory_1.PathFactory.treeChanges(fromPath, toPath, this._options.reloadState);
	        this.createTransitionHookRegFns();
	        var onCreateHooks = this.hookBuilder().buildHooksForPhase(interface_1.TransitionHookPhase.CREATE);
	        transitionHook_1.TransitionHook.runAllHooks(onCreateHooks);
	        this.applyViewConfigs(router);
	        this.applyRootResolvables(router);
	    }
	    /** @hidden */
	    Transition.prototype.onBefore = function (criteria, callback, options) { return; };
	    /** @inheritdoc */
	    Transition.prototype.onStart = function (criteria, callback, options) { return; };
	    /** @inheritdoc */
	    Transition.prototype.onExit = function (criteria, callback, options) { return; };
	    /** @inheritdoc */
	    Transition.prototype.onRetain = function (criteria, callback, options) { return; };
	    /** @inheritdoc */
	    Transition.prototype.onEnter = function (criteria, callback, options) { return; };
	    /** @inheritdoc */
	    Transition.prototype.onFinish = function (criteria, callback, options) { return; };
	    /** @inheritdoc */
	    Transition.prototype.onSuccess = function (criteria, callback, options) { return; };
	    /** @inheritdoc */
	    Transition.prototype.onError = function (criteria, callback, options) { return; };
	    /** @hidden
	     * Creates the transition-level hook registration functions
	     * (which can then be used to register hooks)
	     */
	    Transition.prototype.createTransitionHookRegFns = function () {
	        var _this = this;
	        this.router.transitionService._pluginapi._getEvents()
	            .filter(function (type) { return type.hookPhase !== interface_1.TransitionHookPhase.CREATE; })
	            .forEach(function (type) { return hookRegistry_1.makeEvent(_this, _this.router.transitionService, type); });
	    };
	    /** @internalapi */
	    Transition.prototype.getHooks = function (hookName) {
	        return this._registeredHooks[hookName];
	    };
	    Transition.prototype.applyViewConfigs = function (router) {
	        var enteringStates = this._treeChanges.entering.map(function (node) { return node.state; });
	        pathFactory_1.PathFactory.applyViewConfigs(router.transitionService.$view, this._treeChanges.to, enteringStates);
	    };
	    Transition.prototype.applyRootResolvables = function (router) {
	        var _this = this;
	        var rootResolvables = [
	            new resolvable_1.Resolvable(router_1.UIRouter, function () { return router; }, [], undefined, router),
	            new resolvable_1.Resolvable(Transition, function () { return _this; }, [], undefined, this),
	            new resolvable_1.Resolvable('$transition$', function () { return _this; }, [], undefined, this),
	            new resolvable_1.Resolvable('$stateParams', function () { return _this.params(); }, [], undefined, this.params())
	        ];
	        var rootNode = this._treeChanges.to[0];
	        var context = new resolveContext_1.ResolveContext(this._treeChanges.to);
	        context.addResolvables(rootResolvables, rootNode.state);
	    };
	    /**
	     * @internalapi
	     *
	     * @returns the internal from [State] object
	     */
	    Transition.prototype.$from = function () {
	        return common_1.tail(this._treeChanges.from).state;
	    };
	    /**
	     * @internalapi
	     *
	     * @returns the internal to [State] object
	     */
	    Transition.prototype.$to = function () {
	        return common_1.tail(this._treeChanges.to).state;
	    };
	    /**
	     * Returns the "from state"
	     *
	     * Returns the state that the transition is coming *from*.
	     *
	     * @returns The state declaration object for the Transition's ("from state").
	     */
	    Transition.prototype.from = function () {
	        return this.$from().self;
	    };
	    /**
	     * Returns the "to state"
	     *
	     * Returns the state that the transition is  going *from*.
	     *
	     * @returns The state declaration object for the Transition's target state ("to state").
	     */
	    Transition.prototype.to = function () {
	        return this.$to().self;
	    };
	    /**
	     * Gets the Target State
	     *
	     * A transition's [[TargetState]] encapsulates the [[to]] state, the [[params]], and the [[options]] as a single object.
	     *
	     * @returns the [[TargetState]] of this Transition
	     */
	    Transition.prototype.targetState = function () {
	        return this._targetState;
	    };
	    /**
	     * Determines whether two transitions are equivalent.
	     */
	    Transition.prototype.is = function (compare) {
	        if (compare instanceof Transition) {
	            // TODO: Also compare parameters
	            return this.is({ to: compare.$to().name, from: compare.$from().name });
	        }
	        return !((compare.to && !hookRegistry_1.matchState(this.$to(), compare.to)) ||
	            (compare.from && !hookRegistry_1.matchState(this.$from(), compare.from)));
	    };
	    Transition.prototype.params = function (pathname) {
	        if (pathname === void 0) { pathname = "to"; }
	        return Object.freeze(this._treeChanges[pathname].map(hof_1.prop("paramValues")).reduce(common_1.mergeR, {}));
	    };
	    /**
	     * Creates a [[UIInjector]] Dependency Injector
	     *
	     * Returns a Dependency Injector for the Transition's target state (to state).
	     * The injector provides resolve values which the target state has access to.
	     *
	     * The `UIInjector` can also provide values from the native root/global injector (ng1/ng2).
	     *
	     * #### Example:
	     * ```js
	     * .onEnter({ entering: 'myState' }, trans => {
	     *   var myResolveValue = trans.injector().get('myResolve');
	     *   // Inject a global service from the global/native injector (if it exists)
	     *   var MyService = trans.injector().get('MyService');
	     * })
	     * ```
	     *
	     * In some cases (such as `onBefore`), you may need access to some resolve data but it has not yet been fetched.
	     * You can use [[UIInjector.getAsync]] to get a promise for the data.
	     * #### Example:
	     * ```js
	     * .onBefore({}, trans => {
	     *   return trans.injector().getAsync('myResolve').then(myResolveValue =>
	     *     return myResolveValue !== 'ABORT';
	     *   });
	     * });
	     * ```
	     *
	     * If a `state` is provided, the injector that is returned will be limited to resolve values that the provided state has access to.
	     * This can be useful if both a parent state `foo` and a child state `foo.bar` have both defined a resolve such as `data`.
	     * #### Example:
	     * ```js
	     * .onEnter({ to: 'foo.bar' }, trans => {
	     *   // returns result of `foo` state's `data` resolve
	     *   // even though `foo.bar` also has a `data` resolve
	     *   var fooData = trans.injector('foo').get('data');
	     * });
	     * ```
	     *
	     * If you need resolve data from the exiting states, pass `'from'` as `pathName`.
	     * The resolve data from the `from` path will be returned.
	     * #### Example:
	     * ```js
	     * .onExit({ exiting: 'foo.bar' }, trans => {
	     *   // Gets the resolve value of `data` from the exiting state.
	     *   var fooData = trans.injector(null, 'foo.bar').get('data');
	     * });
	     * ```
	     *
	     *
	     * @param state Limits the resolves provided to only the resolves the provided state has access to.
	     * @param pathName Default: `'to'`: Chooses the path for which to create the injector. Use this to access resolves for `exiting` states.
	     *
	     * @returns a [[UIInjector]]
	     */
	    Transition.prototype.injector = function (state, pathName) {
	        if (pathName === void 0) { pathName = "to"; }
	        var path = this._treeChanges[pathName];
	        if (state)
	            path = pathFactory_1.PathFactory.subPath(path, function (node) { return node.state === state || node.state.name === state; });
	        return new resolveContext_1.ResolveContext(path).injector();
	    };
	    /**
	     * Gets all available resolve tokens (keys)
	     *
	     * This method can be used in conjunction with [[injector]] to inspect the resolve values
	     * available to the Transition.
	     *
	     * This returns all the tokens defined on [[StateDeclaration.resolve]] blocks, for the states
	     * in the Transition's [[TreeChanges.to]] path.
	     *
	     * #### Example:
	     * This example logs all resolve values
	     * ```js
	     * let tokens = trans.getResolveTokens();
	     * tokens.forEach(token => console.log(token + " = " + trans.injector().get(token)));
	     * ```
	     *
	     * #### Example:
	     * This example creates promises for each resolve value.
	     * This triggers fetches of resolves (if any have not yet been fetched).
	     * When all promises have all settled, it logs the resolve values.
	     * ```js
	     * let tokens = trans.getResolveTokens();
	     * let promise = tokens.map(token => trans.injector().getAsync(token));
	     * Promise.all(promises).then(values => console.log("Resolved values: " + values));
	     * ```
	     *
	     * Note: Angular 1 users whould use `$q.all()`
	     *
	     * @param pathname resolve context's path name (e.g., `to` or `from`)
	     *
	     * @returns an array of resolve tokens (keys)
	     */
	    Transition.prototype.getResolveTokens = function (pathname) {
	        if (pathname === void 0) { pathname = "to"; }
	        return new resolveContext_1.ResolveContext(this._treeChanges[pathname]).getTokens();
	    };
	    /**
	     * Dynamically adds a new [[Resolvable]] (i.e., [[StateDeclaration.resolve]]) to this transition.
	     *
	     * @param resolvable a [[ResolvableLiteral]] object (or a [[Resolvable]])
	     * @param state the state in the "to path" which should receive the new resolve (otherwise, the root state)
	     */
	    Transition.prototype.addResolvable = function (resolvable, state) {
	        if (state === void 0) { state = ""; }
	        resolvable = hof_1.is(resolvable_1.Resolvable)(resolvable) ? resolvable : new resolvable_1.Resolvable(resolvable);
	        var stateName = (typeof state === "string") ? state : state.name;
	        var topath = this._treeChanges.to;
	        var targetNode = common_1.find(topath, function (node) { return node.state.name === stateName; });
	        var resolveContext = new resolveContext_1.ResolveContext(topath);
	        resolveContext.addResolvables([resolvable], targetNode.state);
	    };
	    /**
	     * Gets the transition from which this transition was redirected.
	     *
	     * If the current transition is a redirect, this method returns the transition that was redirected.
	     *
	     * #### Example:
	     * ```js
	     * let transitionA = $state.go('A').transition
	     * transitionA.onStart({}, () => $state.target('B'));
	     * $transitions.onSuccess({ to: 'B' }, (trans) => {
	     *   trans.to().name === 'B'; // true
	     *   trans.redirectedFrom() === transitionA; // true
	     * });
	     * ```
	     *
	     * @returns The previous Transition, or null if this Transition is not the result of a redirection
	     */
	    Transition.prototype.redirectedFrom = function () {
	        return this._options.redirectedFrom || null;
	    };
	    /**
	     * Gets the original transition in a redirect chain
	     *
	     * A transition might belong to a long chain of multiple redirects.
	     * This method walks the [[redirectedFrom]] chain back to the original (first) transition in the chain.
	     *
	     * #### Example:
	     * ```js
	     * // states
	     * registry.register({ name: 'A', redirectTo: 'B' });
	     * registry.register({ name: 'B', redirectTo: 'C' });
	     * registry.register({ name: 'C', redirectTo: 'D' });
	     * registry.register({ name: 'D' });
	     *
	     * let transitionA = $state.go('A').transition
	     *
	     * $transitions.onSuccess({ to: 'D' }, (trans) => {
	     *   trans.to().name === 'D'; // true
	     *   trans.redirectedFrom().to().name === 'C'; // true
	     *   trans.originalTransition() === transitionA; // true
	     *   trans.originalTransition().to().name === 'A'; // true
	     * });
	     * ```
	     *
	     * @returns The original Transition that started a redirect chain
	     */
	    Transition.prototype.originalTransition = function () {
	        var rf = this.redirectedFrom();
	        return (rf && rf.originalTransition()) || this;
	    };
	    /**
	     * Get the transition options
	     *
	     * @returns the options for this Transition.
	     */
	    Transition.prototype.options = function () {
	        return this._options;
	    };
	    /**
	     * Gets the states being entered.
	     *
	     * @returns an array of states that will be entered during this transition.
	     */
	    Transition.prototype.entering = function () {
	        return common_1.map(this._treeChanges.entering, hof_1.prop('state')).map(stateSelf);
	    };
	    /**
	     * Gets the states being exited.
	     *
	     * @returns an array of states that will be exited during this transition.
	     */
	    Transition.prototype.exiting = function () {
	        return common_1.map(this._treeChanges.exiting, hof_1.prop('state')).map(stateSelf).reverse();
	    };
	    /**
	     * Gets the states being retained.
	     *
	     * @returns an array of states that are already entered from a previous Transition, that will not be
	     *    exited during this Transition
	     */
	    Transition.prototype.retained = function () {
	        return common_1.map(this._treeChanges.retained, hof_1.prop('state')).map(stateSelf);
	    };
	    /**
	     * Get the [[ViewConfig]]s associated with this Transition
	     *
	     * Each state can define one or more views (template/controller), which are encapsulated as `ViewConfig` objects.
	     * This method fetches the `ViewConfigs` for a given path in the Transition (e.g., "to" or "entering").
	     *
	     * @param pathname the name of the path to fetch views for:
	     *   (`'to'`, `'from'`, `'entering'`, `'exiting'`, `'retained'`)
	     * @param state If provided, only returns the `ViewConfig`s for a single state in the path
	     *
	     * @returns a list of ViewConfig objects for the given path.
	     */
	    Transition.prototype.views = function (pathname, state) {
	        if (pathname === void 0) { pathname = "entering"; }
	        var path = this._treeChanges[pathname];
	        path = !state ? path : path.filter(hof_1.propEq('state', state));
	        return path.map(hof_1.prop("views")).filter(common_1.identity).reduce(common_1.unnestR, []);
	    };
	    Transition.prototype.treeChanges = function (pathname) {
	        return pathname ? this._treeChanges[pathname] : this._treeChanges;
	    };
	    /**
	     * Creates a new transition that is a redirection of the current one.
	     *
	     * This transition can be returned from a [[TransitionService]] hook to
	     * redirect a transition to a new state and/or set of parameters.
	     *
	     * @internalapi
	     *
	     * @returns Returns a new [[Transition]] instance.
	     */
	    Transition.prototype.redirect = function (targetState) {
	        var redirects = 1, trans = this;
	        while ((trans = trans.redirectedFrom()) != null) {
	            if (++redirects > 20)
	                throw new Error("Too many consecutive Transition redirects (20+)");
	        }
	        var redirectOpts = { redirectedFrom: this, source: "redirect" };
	        // If the original transition was caused by URL sync, then use { location: 'replace' }
	        // on the new transition (unless  the target state explicitly specifies location)
	        if (this.options().source === 'url') {
	            redirectOpts.location = 'replace';
	        }
	        var newOptions = common_1.extend({}, this.options(), targetState.options(), redirectOpts);
	        targetState = new targetState_1.TargetState(targetState.identifier(), targetState.$state(), targetState.params(), newOptions);
	        var newTransition = this.router.transitionService.create(this._treeChanges.from, targetState);
	        var originalEnteringNodes = this._treeChanges.entering;
	        var redirectEnteringNodes = newTransition._treeChanges.entering;
	        // --- Re-use resolve data from original transition ---
	        // When redirecting from a parent state to a child state where the parent parameter values haven't changed
	        // (because of the redirect), the resolves fetched by the original transition are still valid in the
	        // redirected transition.
	        //
	        // This allows you to define a redirect on a parent state which depends on an async resolve value.
	        // You can wait for the resolve, then redirect to a child state based on the result.
	        // The redirected transition does not have to re-fetch the resolve.
	        // ---------------------------------------------------------
	        var nodeIsReloading = function (reloadState) { return function (node) {
	            return reloadState && node.state.includes[reloadState.name];
	        }; };
	        // Find any "entering" nodes in the redirect path that match the original path and aren't being reloaded
	        var matchingEnteringNodes = node_1.PathNode.matching(redirectEnteringNodes, originalEnteringNodes)
	            .filter(hof_1.not(nodeIsReloading(targetState.options().reloadState)));
	        // Use the existing (possibly pre-resolved) resolvables for the matching entering nodes.
	        matchingEnteringNodes.forEach(function (node, idx) {
	            node.resolvables = originalEnteringNodes[idx].resolvables;
	        });
	        return newTransition;
	    };
	    /** @hidden If a transition doesn't exit/enter any states, returns any [[Param]] whose value changed */
	    Transition.prototype._changedParams = function () {
	        var tc = this._treeChanges;
	        /** Return undefined if it's not a "dynamic" transition, for the following reasons */
	        // If user explicitly wants a reload
	        if (this._options.reload)
	            return undefined;
	        // If any states are exiting or entering
	        if (tc.exiting.length || tc.entering.length)
	            return undefined;
	        // If to/from path lengths differ
	        if (tc.to.length !== tc.from.length)
	            return undefined;
	        // If the to/from paths are different
	        var pathsDiffer = common_1.arrayTuples(tc.to, tc.from)
	            .map(function (tuple) { return tuple[0].state !== tuple[1].state; })
	            .reduce(common_1.anyTrueR, false);
	        if (pathsDiffer)
	            return undefined;
	        // Find any parameter values that differ
	        var nodeSchemas = tc.to.map(function (node) { return node.paramSchema; });
	        var _a = [tc.to, tc.from].map(function (path) { return path.map(function (x) { return x.paramValues; }); }), toValues = _a[0], fromValues = _a[1];
	        var tuples = common_1.arrayTuples(nodeSchemas, toValues, fromValues);
	        return tuples.map(function (_a) {
	            var schema = _a[0], toVals = _a[1], fromVals = _a[2];
	            return param_1.Param.changed(schema, toVals, fromVals);
	        }).reduce(common_1.unnestR, []);
	    };
	    /**
	     * Returns true if the transition is dynamic.
	     *
	     * A transition is dynamic if no states are entered nor exited, but at least one dynamic parameter has changed.
	     *
	     * @returns true if the Transition is dynamic
	     */
	    Transition.prototype.dynamic = function () {
	        var changes = this._changedParams();
	        return !changes ? false : changes.map(function (x) { return x.dynamic; }).reduce(common_1.anyTrueR, false);
	    };
	    /**
	     * Returns true if the transition is ignored.
	     *
	     * A transition is ignored if no states are entered nor exited, and no parameter values have changed.
	     *
	     * @returns true if the Transition is ignored.
	     */
	    Transition.prototype.ignored = function () {
	        var changes = this._changedParams();
	        return !changes ? false : changes.length === 0;
	    };
	    /**
	     * @hidden
	     */
	    Transition.prototype.hookBuilder = function () {
	        return new hookBuilder_1.HookBuilder(this);
	    };
	    /**
	     * Runs the transition
	     *
	     * This method is generally called from the [[StateService.transitionTo]]
	     *
	     * @internalapi
	     *
	     * @returns a promise for a successful transition.
	     */
	    Transition.prototype.run = function () {
	        var _this = this;
	        var runAllHooks = transitionHook_1.TransitionHook.runAllHooks;
	        var hookBuilder = this.hookBuilder();
	        var globals = this.router.globals;
	        globals.transitionHistory.enqueue(this);
	        var onBeforeHooks = hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.BEFORE);
	        var syncResult = transitionHook_1.TransitionHook.runOnBeforeHooks(onBeforeHooks);
	        if (rejectFactory_1.Rejection.isTransitionRejectionPromise(syncResult)) {
	            syncResult.catch(function () { return 0; }); // issue #2676
	            var rejectReason = syncResult._transitionRejection;
	            this._deferred.reject(rejectReason);
	            return this.promise;
	        }
	        if (!this.valid()) {
	            var error = new Error(this.error());
	            this._deferred.reject(error);
	            return this.promise;
	        }
	        if (this.ignored()) {
	            trace_1.trace.traceTransitionIgnored(this);
	            this._deferred.reject(rejectFactory_1.Rejection.ignored());
	            return this.promise;
	        }
	        // When the chain is complete, then resolve or reject the deferred
	        var transitionSuccess = function () {
	            trace_1.trace.traceSuccess(_this.$to(), _this);
	            _this.success = true;
	            _this._deferred.resolve(_this.to());
	            var onSuccessHooks = hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.SUCCESS);
	            runAllHooks(onSuccessHooks);
	        };
	        var transitionError = function (reason) {
	            trace_1.trace.traceError(reason, _this);
	            _this.success = false;
	            _this._deferred.reject(reason);
	            _this._error = reason;
	            var onErrorHooks = hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.ERROR);
	            runAllHooks(onErrorHooks);
	        };
	        trace_1.trace.traceTransitionStart(this);
	        // Chain the next hook off the previous
	        var appendHookToChain = function (prev, nextHook) {
	            return prev.then(function () { return nextHook.invokeHook(); });
	        };
	        // Run the hooks, then resolve or reject the overall deferred in the .then() handler
	        var asyncHooks = hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.ASYNC);
	        asyncHooks.reduce(appendHookToChain, syncResult)
	            .then(transitionSuccess, transitionError);
	        return this.promise;
	    };
	    /**
	     * Checks if the Transition is valid
	     *
	     * @returns true if the Transition is valid
	     */
	    Transition.prototype.valid = function () {
	        return !this.error() || this.success !== undefined;
	    };
	    /**
	     * The Transition error reason.
	     *
	     * If the transition is invalid (and could not be run), returns the reason the transition is invalid.
	     * If the transition was valid and ran, but was not successful, returns the reason the transition failed.
	     *
	     * @returns an error message explaining why the transition is invalid, or the reason the transition failed.
	     */
	    Transition.prototype.error = function () {
	        var state = this.$to();
	        if (state.self.abstract)
	            return "Cannot transition to abstract state '" + state.name + "'";
	        if (!param_1.Param.validates(state.parameters(), this.params()))
	            return "Param values not valid for state '" + state.name + "'";
	        if (this.success === false)
	            return this._error;
	    };
	    /**
	     * A string representation of the Transition
	     *
	     * @returns A string representation of the Transition
	     */
	    Transition.prototype.toString = function () {
	        var fromStateOrName = this.from();
	        var toStateOrName = this.to();
	        var avoidEmptyHash = function (params) {
	            return (params["#"] !== null && params["#"] !== undefined) ? params : common_1.omit(params, "#");
	        };
	        // (X) means the to state is invalid.
	        var id = this.$id, from = predicates_1.isObject(fromStateOrName) ? fromStateOrName.name : fromStateOrName, fromParams = common_1.toJson(avoidEmptyHash(this._treeChanges.from.map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}))), toValid = this.valid() ? "" : "(X) ", to = predicates_1.isObject(toStateOrName) ? toStateOrName.name : toStateOrName, toParams = common_1.toJson(avoidEmptyHash(this.params()));
	        return "Transition#" + id + "( '" + from + "'" + fromParams + " -> " + toValid + "'" + to + "'" + toParams + " )";
	    };
	    return Transition;
	}());
	/** @hidden */
	Transition.diToken = Transition;
	exports.Transition = Transition;
	//# sourceMappingURL=transition.js.map

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * UI-Router Transition Tracing
	 *
	 * Enable transition tracing to print transition information to the console,
	 * in order to help debug your application.
	 * Tracing logs detailed information about each Transition to your console.
	 *
	 * To enable tracing, import the [[Trace]] singleton and enable one or more categories.
	 *
	 * ### ES6
	 * ```js
	 * import {trace} from "ui-router-ng2"; // or "angular-ui-router"
	 * trace.enable(1, 5); // TRANSITION and VIEWCONFIG
	 * ```
	 *
	 * ### CJS
	 * ```js
	 * let trace = require("angular-ui-router").trace; // or "ui-router-ng2"
	 * trace.enable("TRANSITION", "VIEWCONFIG");
	 * ```
	 *
	 * ### Globals
	 * ```js
	 * let trace = window["angular-ui-router"].trace; // or "ui-router-ng2"
	 * trace.enable(); // Trace everything (very verbose)
	 * ```
	 *
	 * ### Angular 1:
	 * ```js
	 * app.run($trace => $trace.enable());
	 * ```
	 *
	 * @coreapi
	 * @module trace
	 */ /** for typedoc */
	var hof_1 = __webpack_require__(307);
	var predicates_1 = __webpack_require__(306);
	var strings_1 = __webpack_require__(311);
	/** @hidden */
	function uiViewString(viewData) {
	    if (!viewData)
	        return 'ui-view (defunct)';
	    return "[ui-view#" + viewData.id + " tag " +
	        ("in template from '" + (viewData.creationContext && viewData.creationContext.name || '(root)') + "' state]: ") +
	        ("fqn: '" + viewData.fqn + "', ") +
	        ("name: '" + viewData.name + "@" + viewData.creationContext + "')");
	}
	/** @hidden */
	var viewConfigString = function (viewConfig) {
	    return "[ViewConfig#" + viewConfig.$id + " from '" + (viewConfig.viewDecl.$context.name || '(root)') + "' state]: target ui-view: '" + viewConfig.viewDecl.$uiViewName + "@" + viewConfig.viewDecl.$uiViewContextAnchor + "'";
	};
	/** @hidden */
	function normalizedCat(input) {
	    return predicates_1.isNumber(input) ? Category[input] : Category[Category[input]];
	}
	/**
	 * Trace categories Enum
	 *
	 * Enable or disable a category using [[Trace.enable]] or [[Trace.disable]]
	 *
	 * `trace.enable(Category.TRANSITION)`
	 *
	 * These can also be provided using a matching string, or position ordinal
	 *
	 * `trace.enable("TRANSITION")`
	 *
	 * `trace.enable(1)`
	 */
	var Category;
	(function (Category) {
	    Category[Category["RESOLVE"] = 0] = "RESOLVE";
	    Category[Category["TRANSITION"] = 1] = "TRANSITION";
	    Category[Category["HOOK"] = 2] = "HOOK";
	    Category[Category["UIVIEW"] = 3] = "UIVIEW";
	    Category[Category["VIEWCONFIG"] = 4] = "VIEWCONFIG";
	})(Category = exports.Category || (exports.Category = {}));
	/**
	 * Prints UI-Router Transition trace information to the console.
	 */
	var Trace = (function () {
	    /** @hidden */
	    function Trace() {
	        /** @hidden */
	        this._enabled = {};
	        this.approximateDigests = 0;
	    }
	    /** @hidden */
	    Trace.prototype._set = function (enabled, categories) {
	        var _this = this;
	        if (!categories.length) {
	            categories = Object.keys(Category)
	                .map(function (k) { return parseInt(k, 10); })
	                .filter(function (k) { return !isNaN(k); })
	                .map(function (key) { return Category[key]; });
	        }
	        categories.map(normalizedCat).forEach(function (category) { return _this._enabled[category] = enabled; });
	    };
	    /**
	     * Enables a trace [[Category]]
	     *
	     * ```js
	     * trace.enable("TRANSITION");
	     * ```
	     *
	     * @param categories categories to enable. If `categories` is omitted, all categories are enabled.
	     *        Also takes strings (category name) or ordinal (category position)
	     */
	    Trace.prototype.enable = function () {
	        var categories = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            categories[_i] = arguments[_i];
	        }
	        this._set(true, categories);
	    };
	    /**
	     * Disables a trace [[Category]]
	     *
	     * ```js
	     * trace.disable("VIEWCONFIG");
	     * ```
	     *
	     * @param categories categories to disable. If `categories` is omitted, all categories are disabled.
	     *        Also takes strings (category name) or ordinal (category position)
	     */
	    Trace.prototype.disable = function () {
	        var categories = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            categories[_i] = arguments[_i];
	        }
	        this._set(false, categories);
	    };
	    /**
	     * Retrieves the enabled stateus of a [[Category]]
	     *
	     * ```js
	     * trace.enabled("VIEWCONFIG"); // true or false
	     * ```
	     *
	     * @returns boolean true if the category is enabled
	     */
	    Trace.prototype.enabled = function (category) {
	        return !!this._enabled[normalizedCat(category)];
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceTransitionStart = function (trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        var tid = trans.$id, digest = this.approximateDigests, transitionStr = strings_1.stringify(trans);
	        console.log("Transition #" + tid + " r" + trans.router.$id + ": Started  -> " + transitionStr);
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceTransitionIgnored = function (trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        var tid = trans && trans.$id, digest = this.approximateDigests, transitionStr = strings_1.stringify(trans);
	        console.log("Transition #" + tid + " r" + trans.router.$id + ": Ignored  <> " + transitionStr);
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceHookInvocation = function (step, trans, options) {
	        if (!this.enabled(Category.HOOK))
	            return;
	        var tid = hof_1.parse("transition.$id")(options), digest = this.approximateDigests, event = hof_1.parse("traceData.hookType")(options) || "internal", context = hof_1.parse("traceData.context.state.name")(options) || hof_1.parse("traceData.context")(options) || "unknown", name = strings_1.functionToString(step.registeredHook.callback);
	        console.log("Transition #" + tid + " r" + trans.router.$id + ":   Hook -> " + event + " context: " + context + ", " + strings_1.maxLength(200, name));
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceHookResult = function (hookResult, trans, transitionOptions) {
	        if (!this.enabled(Category.HOOK))
	            return;
	        var tid = hof_1.parse("transition.$id")(transitionOptions), digest = this.approximateDigests, hookResultStr = strings_1.stringify(hookResult);
	        console.log("Transition #" + tid + " r" + trans.router.$id + ":   <- Hook returned: " + strings_1.maxLength(200, hookResultStr));
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceResolvePath = function (path, when, trans) {
	        if (!this.enabled(Category.RESOLVE))
	            return;
	        var tid = trans && trans.$id, digest = this.approximateDigests, pathStr = path && path.toString();
	        console.log("Transition #" + tid + " r" + trans.router.$id + ":         Resolving " + pathStr + " (" + when + ")");
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceResolvableResolved = function (resolvable, trans) {
	        if (!this.enabled(Category.RESOLVE))
	            return;
	        var tid = trans && trans.$id, digest = this.approximateDigests, resolvableStr = resolvable && resolvable.toString(), result = strings_1.stringify(resolvable.data);
	        console.log("Transition #" + tid + " r" + trans.router.$id + ":               <- Resolved  " + resolvableStr + " to: " + strings_1.maxLength(200, result));
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceError = function (reason, trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        var tid = trans && trans.$id, digest = this.approximateDigests, transitionStr = strings_1.stringify(trans);
	        console.log("Transition #" + tid + " r" + trans.router.$id + ": <- Rejected " + transitionStr + ", reason: " + reason);
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceSuccess = function (finalState, trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        var tid = trans && trans.$id, digest = this.approximateDigests, state = finalState.name, transitionStr = strings_1.stringify(trans);
	        console.log("Transition #" + tid + " r" + trans.router.$id + ": <- Success  " + transitionStr + ", final state: " + state);
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceUIViewEvent = function (event, viewData, extra) {
	        if (extra === void 0) { extra = ""; }
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        console.log("ui-view: " + strings_1.padString(30, event) + " " + uiViewString(viewData) + extra);
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceUIViewConfigUpdated = function (viewData, context) {
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        this.traceUIViewEvent("Updating", viewData, " with ViewConfig from context='" + context + "'");
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceUIViewFill = function (viewData, html) {
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        this.traceUIViewEvent("Fill", viewData, " with: " + strings_1.maxLength(200, html));
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceViewServiceEvent = function (event, viewConfig) {
	        if (!this.enabled(Category.VIEWCONFIG))
	            return;
	        console.log("VIEWCONFIG: " + event + " " + viewConfigString(viewConfig));
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceViewServiceUIViewEvent = function (event, viewData) {
	        if (!this.enabled(Category.VIEWCONFIG))
	            return;
	        console.log("VIEWCONFIG: " + event + " " + uiViewString(viewData));
	    };
	    return Trace;
	}());
	exports.Trace = Trace;
	/**
	 * The [[Trace]] singleton
	 *
	 * #### Example:
	 * ```js
	 * import {trace} from "angular-ui-router";
	 * trace.enable(1, 5);
	 * ```
	 */
	var trace = new Trace();
	exports.trace = trace;
	//# sourceMappingURL=trace.js.map

/***/ },
/* 315 */
/***/ function(module, exports) {

	"use strict";
	var TransitionHookPhase;
	(function (TransitionHookPhase) {
	    TransitionHookPhase[TransitionHookPhase["CREATE"] = 0] = "CREATE";
	    TransitionHookPhase[TransitionHookPhase["BEFORE"] = 1] = "BEFORE";
	    TransitionHookPhase[TransitionHookPhase["ASYNC"] = 2] = "ASYNC";
	    TransitionHookPhase[TransitionHookPhase["SUCCESS"] = 3] = "SUCCESS";
	    TransitionHookPhase[TransitionHookPhase["ERROR"] = 4] = "ERROR";
	})(TransitionHookPhase = exports.TransitionHookPhase || (exports.TransitionHookPhase = {}));
	var TransitionHookScope;
	(function (TransitionHookScope) {
	    TransitionHookScope[TransitionHookScope["TRANSITION"] = 0] = "TRANSITION";
	    TransitionHookScope[TransitionHookScope["STATE"] = 1] = "STATE";
	})(TransitionHookScope = exports.TransitionHookScope || (exports.TransitionHookScope = {}));
	//# sourceMappingURL=interface.js.map

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var common_1 = __webpack_require__(305);
	var strings_1 = __webpack_require__(311);
	var predicates_1 = __webpack_require__(306);
	var hof_1 = __webpack_require__(307);
	var trace_1 = __webpack_require__(314);
	var coreservices_1 = __webpack_require__(308);
	var rejectFactory_1 = __webpack_require__(312);
	var targetState_1 = __webpack_require__(317);
	var defaultOptions = {
	    current: common_1.noop,
	    transition: null,
	    traceData: {},
	    bind: null
	};
	/** @hidden */
	var TransitionHook = (function () {
	    function TransitionHook(transition, stateContext, registeredHook, options) {
	        var _this = this;
	        this.transition = transition;
	        this.stateContext = stateContext;
	        this.registeredHook = registeredHook;
	        this.options = options;
	        this.stateService = function () { return _this.transition.router.stateService; };
	        this.rejectIfSuperseded = function () {
	            return _this.registeredHook.eventType.rejectIfSuperseded && _this.options.current() !== _this.options.transition;
	        };
	        this.options = common_1.defaults(options, defaultOptions);
	    }
	    TransitionHook.prototype.invokeHook = function () {
	        var hook = this.registeredHook;
	        if (hook._deregistered)
	            return;
	        var options = this.options;
	        trace_1.trace.traceHookInvocation(this, this.transition, options);
	        if (this.rejectIfSuperseded()) {
	            return rejectFactory_1.Rejection.superseded(options.current()).toPromise();
	        }
	        var cb = hook.callback;
	        var bind = this.options.bind;
	        var trans = this.transition;
	        var state = this.stateContext;
	        var errorHandler = hook.eventType.getErrorHandler(this);
	        var resultHandler = hook.eventType.getResultHandler(this);
	        resultHandler = resultHandler || common_1.identity;
	        if (!errorHandler) {
	            return resultHandler(cb.call(bind, trans, state));
	        }
	        try {
	            return resultHandler(cb.call(bind, trans, state));
	        }
	        catch (error) {
	            return errorHandler(error);
	        }
	    };
	    /**
	     * This method handles the return value of a Transition Hook.
	     *
	     * A hook can return false (cancel), a TargetState (redirect),
	     * or a promise (which may later resolve to false or a redirect)
	     *
	     * This also handles "transition superseded" -- when a new transition
	     * was started while the hook was still running
	     */
	    TransitionHook.prototype.handleHookResult = function (result) {
	        // This transition is no longer current.
	        // Another transition started while this hook was still running.
	        if (this.rejectIfSuperseded()) {
	            // Abort this transition
	            return rejectFactory_1.Rejection.superseded(this.options.current()).toPromise();
	        }
	        // Hook returned a promise
	        if (predicates_1.isPromise(result)) {
	            // Wait for the promise, then reprocess the resolved value
	            return result.then(this.handleHookResult.bind(this));
	        }
	        trace_1.trace.traceHookResult(result, this.transition, this.options);
	        // Hook returned false
	        if (result === false) {
	            // Abort this Transition
	            return rejectFactory_1.Rejection.aborted("Hook aborted transition").toPromise();
	        }
	        var isTargetState = hof_1.is(targetState_1.TargetState);
	        // hook returned a TargetState
	        if (isTargetState(result)) {
	            // Halt the current Transition and start a redirected Transition (to the TargetState).
	            return rejectFactory_1.Rejection.redirected(result).toPromise();
	        }
	    };
	    TransitionHook.prototype.toString = function () {
	        var _a = this, options = _a.options, registeredHook = _a.registeredHook;
	        var event = hof_1.parse("traceData.hookType")(options) || "internal", context = hof_1.parse("traceData.context.state.name")(options) || hof_1.parse("traceData.context")(options) || "unknown", name = strings_1.fnToString(registeredHook.callback);
	        return event + " context: " + context + ", " + strings_1.maxLength(200, name);
	    };
	    /**
	     * Run all TransitionHooks, ignoring their return value.
	     */
	    TransitionHook.runAllHooks = function (hooks) {
	        hooks.forEach(function (hook) { return hook.invokeHook(); });
	    };
	    /**
	     * Given an array of TransitionHooks, runs each one synchronously and sequentially.
	     * Should any hook return a Rejection synchronously, the remaining hooks will not run.
	     *
	     * Returns a promise chain composed of any promises returned from each hook.invokeStep() call
	     */
	    TransitionHook.runOnBeforeHooks = function (hooks) {
	        var results = [];
	        for (var _i = 0, hooks_1 = hooks; _i < hooks_1.length; _i++) {
	            var hook = hooks_1[_i];
	            var hookResult = hook.invokeHook();
	            if (rejectFactory_1.Rejection.isTransitionRejectionPromise(hookResult)) {
	                // Break on first thrown error or false/TargetState
	                return hookResult;
	            }
	            results.push(hookResult);
	        }
	        return results
	            .filter(predicates_1.isPromise)
	            .reduce(function (chain, promise) { return chain.then(hof_1.val(promise)); }, coreservices_1.services.$q.when());
	    };
	    return TransitionHook;
	}());
	TransitionHook.HANDLE_RESULT = function (hook) {
	    return function (result) {
	        return hook.handleHookResult(result);
	    };
	};
	TransitionHook.IGNORE_RESULT = function (hook) {
	    return function (result) { return undefined; };
	};
	TransitionHook.LOG_ERROR = function (hook) {
	    return function (error) {
	        return (hook.stateService().defaultErrorHandler()(error), undefined);
	    };
	};
	TransitionHook.REJECT_ERROR = function (hook) {
	    return function (error) {
	        return rejectFactory_1.Rejection.errored(error).toPromise();
	    };
	};
	TransitionHook.THROW_ERROR = function (hook) {
	    return undefined;
	};
	exports.TransitionHook = TransitionHook;
	//# sourceMappingURL=transitionHook.js.map

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @coreapi
	 * @module state
	 */ /** for typedoc */
	"use strict";
	var common_1 = __webpack_require__(305);
	var predicates_1 = __webpack_require__(306);
	/**
	 * Encapsulate the target (destination) state/params/options of a [[Transition]].
	 *
	 * This class is frequently used to redirect a transition to a new destination.
	 *
	 * See:
	 *
	 * - [[HookResult]]
	 * - [[TransitionHookFn]]
	 * - [[TransitionService.onStart]]
	 *
	 * To create a `TargetState`, use [[StateService.target]].
	 *
	 * ---
	 *
	 * This class wraps:
	 *
	 * 1) an identifier for a state
	 * 2) a set of parameters
	 * 3) and transition options
	 * 4) the registered state object (the [[StateDeclaration]])
	 *
	 * Many UI-Router APIs such as [[StateService.go]] take a [[StateOrName]] argument which can
	 * either be a *state object* (a [[StateDeclaration]] or [[State]]) or a *state name* (a string).
	 * The `TargetState` class normalizes those options.
	 *
	 * A `TargetState` may be valid (the state being targeted exists in the registry)
	 * or invalid (the state being targeted is not registered).
	 */
	var TargetState = (function () {
	    /**
	     * The TargetState constructor
	     *
	     * Note: Do not construct a `TargetState` manually.
	     * To create a `TargetState`, use the [[StateService.target]] factory method.
	     *
	     * @param _identifier An identifier for a state.
	     *    Either a fully-qualified state name, or the object used to define the state.
	     * @param _definition The internal state representation, if exists.
	     * @param _params Parameters for the target state
	     * @param _options Transition options.
	     *
	     * @internalapi
	     */
	    function TargetState(_identifier, _definition, _params, _options) {
	        if (_options === void 0) { _options = {}; }
	        this._identifier = _identifier;
	        this._definition = _definition;
	        this._options = _options;
	        this._params = _params || {};
	    }
	    /** The name of the state this object targets */
	    TargetState.prototype.name = function () {
	        return this._definition && this._definition.name || this._identifier;
	    };
	    /** The identifier used when creating this TargetState */
	    TargetState.prototype.identifier = function () {
	        return this._identifier;
	    };
	    /** The target parameter values */
	    TargetState.prototype.params = function () {
	        return this._params;
	    };
	    /** The internal state object (if it was found) */
	    TargetState.prototype.$state = function () {
	        return this._definition;
	    };
	    /** The internal state declaration (if it was found) */
	    TargetState.prototype.state = function () {
	        return this._definition && this._definition.self;
	    };
	    /** The target options */
	    TargetState.prototype.options = function () {
	        return this._options;
	    };
	    /** True if the target state was found */
	    TargetState.prototype.exists = function () {
	        return !!(this._definition && this._definition.self);
	    };
	    /** True if the object is valid */
	    TargetState.prototype.valid = function () {
	        return !this.error();
	    };
	    /** If the object is invalid, returns the reason why */
	    TargetState.prototype.error = function () {
	        var base = this.options().relative;
	        if (!this._definition && !!base) {
	            var stateName = base.name ? base.name : base;
	            return "Could not resolve '" + this.name() + "' from state '" + stateName + "'";
	        }
	        if (!this._definition)
	            return "No such state '" + this.name() + "'";
	        if (!this._definition.self)
	            return "State '" + this.name() + "' has an invalid definition";
	    };
	    TargetState.prototype.toString = function () {
	        return "'" + this.name() + "'" + common_1.toJson(this.params());
	    };
	    return TargetState;
	}());
	/** Returns true if the object has a state property that might be a state or state name */
	TargetState.isDef = function (obj) {
	    return obj && obj.state && (predicates_1.isString(obj.state) || predicates_1.isString(obj.state.name));
	};
	exports.TargetState = TargetState;
	//# sourceMappingURL=targetState.js.map

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @coreapi
	 * @module transition
	 */ /** for typedoc */
	var common_1 = __webpack_require__(305);
	var predicates_1 = __webpack_require__(306);
	var interface_1 = __webpack_require__(315); // has or is using
	var glob_1 = __webpack_require__(309);
	/**
	 * Determines if the given state matches the matchCriteria
	 *
	 * @hidden
	 *
	 * @param state a State Object to test against
	 * @param criterion
	 * - If a string, matchState uses the string as a glob-matcher against the state name
	 * - If an array (of strings), matchState uses each string in the array as a glob-matchers against the state name
	 *   and returns a positive match if any of the globs match.
	 * - If a function, matchState calls the function with the state and returns true if the function's result is truthy.
	 * @returns {boolean}
	 */
	function matchState(state, criterion) {
	    var toMatch = predicates_1.isString(criterion) ? [criterion] : criterion;
	    function matchGlobs(_state) {
	        var globStrings = toMatch;
	        for (var i = 0; i < globStrings.length; i++) {
	            var glob = new glob_1.Glob(globStrings[i]);
	            if ((glob && glob.matches(_state.name)) || (!glob && globStrings[i] === _state.name)) {
	                return true;
	            }
	        }
	        return false;
	    }
	    var matchFn = (predicates_1.isFunction(toMatch) ? toMatch : matchGlobs);
	    return !!matchFn(state);
	}
	exports.matchState = matchState;
	/**
	 * @hidden
	 * The registration data for a registered transition hook
	 */
	var RegisteredHook = (function () {
	    function RegisteredHook(tranSvc, eventType, callback, matchCriteria, options) {
	        if (options === void 0) { options = {}; }
	        this.tranSvc = tranSvc;
	        this.eventType = eventType;
	        this.callback = callback;
	        this.matchCriteria = matchCriteria;
	        this.priority = options.priority || 0;
	        this.bind = options.bind || null;
	        this._deregistered = false;
	    }
	    /**
	     * Given an array of PathNodes, and a HookMatchCriteria, returns an array containing
	     * the PathNodes that the criteria matches, or null if there were no matching nodes.
	     *
	     * Returning null is significant to distinguish between the default
	     * "match-all criterion value" of `true` compared to a () => true,
	     * when the nodes is an empty array.
	     *
	     * This is useful to allow a transition match criteria of `entering: true`
	     * to still match a transition, even when `entering === []`.  Contrast that
	     * with `entering: (state) => true` which only matches when a state is actually
	     * being entered.
	     */
	    RegisteredHook.prototype._matchingNodes = function (nodes, criterion) {
	        if (criterion === true)
	            return nodes;
	        var matching = nodes.filter(function (node) { return matchState(node.state, criterion); });
	        return matching.length ? matching : null;
	    };
	    /**
	     * Returns an object which has all the criteria match paths as keys and `true` as values, i.e.:
	     *
	     * { to: true, from: true, entering: true, exiting: true, retained: true }
	     */
	    RegisteredHook.prototype._getDefaultMatchCriteria = function () {
	        return common_1.map(this.tranSvc._pluginapi._getPathTypes(), function () { return true; });
	    };
	    /**
	     * Create a IMatchingNodes object from the TransitionHookTypes that basically looks like this:
	     *
	     * let matches: IMatchingNodes = {
	     *   to:       _matchingNodes([tail(treeChanges.to)],   mc.to),
	     *   from:     _matchingNodes([tail(treeChanges.from)], mc.from),
	     *   exiting:  _matchingNodes(treeChanges.exiting,      mc.exiting),
	     *   retained: _matchingNodes(treeChanges.retained,     mc.retained),
	     *   entering: _matchingNodes(treeChanges.entering,     mc.entering),
	     * };
	     */
	    RegisteredHook.prototype._getMatchingNodes = function (treeChanges) {
	        var _this = this;
	        var criteria = common_1.extend(this._getDefaultMatchCriteria(), this.matchCriteria);
	        var paths = common_1.values(this.tranSvc._pluginapi._getPathTypes());
	        return paths.reduce(function (mn, pathtype) {
	            // STATE scope criteria matches against every node in the path.
	            // TRANSITION scope criteria matches against only the last node in the path
	            var isStateHook = pathtype.scope === interface_1.TransitionHookScope.STATE;
	            var path = treeChanges[pathtype.name] || [];
	            var nodes = isStateHook ? path : [common_1.tail(path)];
	            mn[pathtype.name] = _this._matchingNodes(nodes, criteria[pathtype.name]);
	            return mn;
	        }, {});
	    };
	    /**
	     * Determines if this hook's [[matchCriteria]] match the given [[TreeChanges]]
	     *
	     * @returns an IMatchingNodes object, or null. If an IMatchingNodes object is returned, its values
	     * are the matching [[PathNode]]s for each [[HookMatchCriterion]] (to, from, exiting, retained, entering)
	     */
	    RegisteredHook.prototype.matches = function (treeChanges) {
	        var matches = this._getMatchingNodes(treeChanges);
	        // Check if all the criteria matched the TreeChanges object
	        var allMatched = common_1.values(matches).every(common_1.identity);
	        return allMatched ? matches : null;
	    };
	    return RegisteredHook;
	}());
	exports.RegisteredHook = RegisteredHook;
	/** @hidden Return a registration function of the requested type. */
	function makeEvent(registry, transitionService, eventType) {
	    // Create the object which holds the registered transition hooks.
	    var _registeredHooks = registry._registeredHooks = (registry._registeredHooks || {});
	    var hooks = _registeredHooks[eventType.name] = [];
	    // Create hook registration function on the IHookRegistry for the event
	    registry[eventType.name] = hookRegistrationFn;
	    function hookRegistrationFn(matchObject, callback, options) {
	        if (options === void 0) { options = {}; }
	        var registeredHook = new RegisteredHook(transitionService, eventType, callback, matchObject, options);
	        hooks.push(registeredHook);
	        return function deregisterEventHook() {
	            registeredHook._deregistered = true;
	            common_1.removeFrom(hooks)(registeredHook);
	        };
	    }
	    return hookRegistrationFn;
	}
	exports.makeEvent = makeEvent;
	//# sourceMappingURL=hookRegistry.js.map

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @coreapi
	 * @module transition
	 */ /** for typedoc */
	"use strict";
	var common_1 = __webpack_require__(305);
	var predicates_1 = __webpack_require__(306);
	var interface_1 = __webpack_require__(315);
	var transitionHook_1 = __webpack_require__(316);
	/**
	 * This class returns applicable TransitionHooks for a specific Transition instance.
	 *
	 * Hooks ([[RegisteredHook]]) may be registered globally, e.g., $transitions.onEnter(...), or locally, e.g.
	 * myTransition.onEnter(...).  The HookBuilder finds matching RegisteredHooks (where the match criteria is
	 * determined by the type of hook)
	 *
	 * The HookBuilder also converts RegisteredHooks objects to TransitionHook objects, which are used to run a Transition.
	 *
	 * The HookBuilder constructor is given the $transitions service and a Transition instance.  Thus, a HookBuilder
	 * instance may only be used for one specific Transition object. (side note: the _treeChanges accessor is private
	 * in the Transition class, so we must also provide the Transition's _treeChanges)
	 *
	 */
	var HookBuilder = (function () {
	    function HookBuilder(transition) {
	        this.transition = transition;
	        this.treeChanges = transition.treeChanges();
	        this.transitionOptions = transition.options();
	        this.toState = common_1.tail(this.treeChanges.to).state;
	        this.fromState = common_1.tail(this.treeChanges.from).state;
	        this.$transitions = transition.router.transitionService;
	        this.baseHookOptions = {
	            transition: transition,
	            current: transition.options().current
	        };
	    }
	    HookBuilder.prototype.buildHooksForPhase = function (phase) {
	        var _this = this;
	        return this.$transitions._pluginapi._getEvents(phase)
	            .map(function (type) { return _this.buildHooks(type); })
	            .reduce(common_1.unnestR, [])
	            .filter(common_1.identity);
	    };
	    /**
	     * Returns an array of newly built TransitionHook objects.
	     *
	     * - Finds all RegisteredHooks registered for the given `hookType` which matched the transition's [[TreeChanges]].
	     * - Finds [[PathNode]] (or `PathNode[]`) to use as the TransitionHook context(s)
	     * - For each of the [[PathNode]]s, creates a TransitionHook
	     *
	     * @param hookType the type of the hook registration function, e.g., 'onEnter', 'onFinish'.
	     */
	    HookBuilder.prototype.buildHooks = function (hookType) {
	        var _this = this;
	        // Find all the matching registered hooks for a given hook type
	        var matchingHooks = this.getMatchingHooks(hookType, this.treeChanges);
	        if (!matchingHooks)
	            return [];
	        var makeTransitionHooks = function (hook) {
	            // Fetch the Nodes that caused this hook to match.
	            var matches = hook.matches(_this.treeChanges);
	            // Select the PathNode[] that will be used as TransitionHook context objects
	            var matchingNodes = matches[hookType.criteriaMatchPath.name];
	            // Return an array of HookTuples
	            return matchingNodes.map(function (node) {
	                var _options = common_1.extend({
	                    bind: hook.bind,
	                    traceData: { hookType: hookType.name, context: node }
	                }, _this.baseHookOptions);
	                var state = hookType.criteriaMatchPath.scope === interface_1.TransitionHookScope.STATE ? node.state : null;
	                var transitionHook = new transitionHook_1.TransitionHook(_this.transition, state, hook, _options);
	                return { hook: hook, node: node, transitionHook: transitionHook };
	            });
	        };
	        return matchingHooks.map(makeTransitionHooks)
	            .reduce(common_1.unnestR, [])
	            .sort(tupleSort(hookType.reverseSort))
	            .map(function (tuple) { return tuple.transitionHook; });
	    };
	    /**
	     * Finds all RegisteredHooks from:
	     * - The Transition object instance hook registry
	     * - The TransitionService ($transitions) global hook registry
	     *
	     * which matched:
	     * - the eventType
	     * - the matchCriteria (to, from, exiting, retained, entering)
	     *
	     * @returns an array of matched [[RegisteredHook]]s
	     */
	    HookBuilder.prototype.getMatchingHooks = function (hookType, treeChanges) {
	        var isCreate = hookType.hookPhase === interface_1.TransitionHookPhase.CREATE;
	        // Instance and Global hook registries
	        var registries = isCreate ? [this.$transitions] : [this.transition, this.$transitions];
	        return registries.map(function (reg) { return reg.getHooks(hookType.name); }) // Get named hooks from registries
	            .filter(common_1.assertPredicate(predicates_1.isArray, "broken event named: " + hookType.name)) // Sanity check
	            .reduce(common_1.unnestR, []) // Un-nest RegisteredHook[][] to RegisteredHook[] array
	            .filter(function (hook) { return hook.matches(treeChanges); }); // Only those satisfying matchCriteria
	    };
	    return HookBuilder;
	}());
	exports.HookBuilder = HookBuilder;
	/**
	 * A factory for a sort function for HookTuples.
	 *
	 * The sort function first compares the PathNode depth (how deep in the state tree a node is), then compares
	 * the EventHook priority.
	 *
	 * @param reverseDepthSort a boolean, when true, reverses the sort order for the node depth
	 * @returns a tuple sort function
	 */
	function tupleSort(reverseDepthSort) {
	    if (reverseDepthSort === void 0) { reverseDepthSort = false; }
	    return function nodeDepthThenPriority(l, r) {
	        var factor = reverseDepthSort ? -1 : 1;
	        var depthDelta = (l.node.state.path.length - r.node.state.path.length) * factor;
	        return depthDelta !== 0 ? depthDelta : r.hook.priority - l.hook.priority;
	    };
	}
	//# sourceMappingURL=hookBuilder.js.map

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/** @module path */ /** for typedoc */
	var common_1 = __webpack_require__(305);
	var hof_1 = __webpack_require__(307);
	var param_1 = __webpack_require__(321);
	/**
	 * A node in a [[TreeChanges]] path
	 *
	 * For a [[TreeChanges]] path, this class holds the stateful information for a single node in the path.
	 * Each PathNode corresponds to a state being entered, exited, or retained.
	 * The stateful information includes parameter values and resolve data.
	 */
	var PathNode = (function () {
	    function PathNode(stateOrPath) {
	        if (stateOrPath instanceof PathNode) {
	            var node = stateOrPath;
	            this.state = node.state;
	            this.paramSchema = node.paramSchema.slice();
	            this.paramValues = common_1.extend({}, node.paramValues);
	            this.resolvables = node.resolvables.slice();
	            this.views = node.views && node.views.slice();
	        }
	        else {
	            var state = stateOrPath;
	            this.state = state;
	            this.paramSchema = state.parameters({ inherit: false });
	            this.paramValues = {};
	            this.resolvables = state.resolvables.map(function (res) { return res.clone(); });
	        }
	    }
	    /** Sets [[paramValues]] for the node, from the values of an object hash */
	    PathNode.prototype.applyRawParams = function (params) {
	        var getParamVal = function (paramDef) { return [paramDef.id, paramDef.value(params[paramDef.id])]; };
	        this.paramValues = this.paramSchema.reduce(function (memo, pDef) { return common_1.applyPairs(memo, getParamVal(pDef)); }, {});
	        return this;
	    };
	    /** Gets a specific [[Param]] metadata that belongs to the node */
	    PathNode.prototype.parameter = function (name) {
	        return common_1.find(this.paramSchema, hof_1.propEq("id", name));
	    };
	    /**
	     * @returns true if the state and parameter values for another PathNode are
	     * equal to the state and param values for this PathNode
	     */
	    PathNode.prototype.equals = function (node, keys) {
	        var _this = this;
	        if (keys === void 0) { keys = this.paramSchema.map(function (p) { return p.id; }); }
	        var paramValsEq = function (key) {
	            return _this.parameter(key).type.equals(_this.paramValues[key], node.paramValues[key]);
	        };
	        return this.state === node.state && keys.map(paramValsEq).reduce(common_1.allTrueR, true);
	    };
	    /** Returns a clone of the PathNode */
	    PathNode.clone = function (node) {
	        return new PathNode(node);
	    };
	    /**
	     * Returns a new path which is a subpath of the first path which matched the second path.
	     *
	     * The new path starts from root and contains any nodes that match the nodes in the second path.
	     * Nodes are compared using their state property and parameter values.
	     *
	     * @param pathA the first path
	     * @param pathB the second path
	     * @param ignoreDynamicParams don't compare dynamic parameter values
	     */
	    PathNode.matching = function (pathA, pathB, ignoreDynamicParams) {
	        if (ignoreDynamicParams === void 0) { ignoreDynamicParams = true; }
	        var matching = [];
	        for (var i = 0; i < pathA.length && i < pathB.length; i++) {
	            var a = pathA[i], b = pathB[i];
	            if (a.state !== b.state)
	                break;
	            var changedParams = param_1.Param.changed(a.paramSchema, a.paramValues, b.paramValues)
	                .filter(function (param) { return !(ignoreDynamicParams && param.dynamic); });
	            if (changedParams.length)
	                break;
	            matching.push(a);
	        }
	        return matching;
	    };
	    return PathNode;
	}());
	exports.PathNode = PathNode;
	//# sourceMappingURL=node.js.map

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @internalapi
	 * @module params
	 */ /** for typedoc */
	var common_1 = __webpack_require__(305);
	var hof_1 = __webpack_require__(307);
	var predicates_1 = __webpack_require__(306);
	var coreservices_1 = __webpack_require__(308);
	var paramType_1 = __webpack_require__(322);
	var hasOwn = Object.prototype.hasOwnProperty;
	var isShorthand = function (cfg) {
	    return ["value", "type", "squash", "array", "dynamic"].filter(hasOwn.bind(cfg || {})).length === 0;
	};
	var DefType;
	(function (DefType) {
	    DefType[DefType["PATH"] = 0] = "PATH";
	    DefType[DefType["SEARCH"] = 1] = "SEARCH";
	    DefType[DefType["CONFIG"] = 2] = "CONFIG";
	})(DefType = exports.DefType || (exports.DefType = {}));
	function unwrapShorthand(cfg) {
	    cfg = isShorthand(cfg) && { value: cfg } || cfg;
	    return common_1.extend(cfg, {
	        $$fn: predicates_1.isInjectable(cfg.value) ? cfg.value : function () { return cfg.value; }
	    });
	}
	function getType(cfg, urlType, location, id, paramTypes) {
	    if (cfg.type && urlType && urlType.name !== 'string')
	        throw new Error("Param '" + id + "' has two type configurations.");
	    if (cfg.type && urlType && urlType.name === 'string' && paramTypes.type(cfg.type))
	        return paramTypes.type(cfg.type);
	    if (urlType)
	        return urlType;
	    if (!cfg.type) {
	        var type = location === DefType.CONFIG ? "any" :
	            location === DefType.PATH ? "path" :
	                location === DefType.SEARCH ? "query" : "string";
	        return paramTypes.type(type);
	    }
	    return cfg.type instanceof paramType_1.ParamType ? cfg.type : paramTypes.type(cfg.type);
	}
	/**
	 * returns false, true, or the squash value to indicate the "default parameter url squash policy".
	 */
	function getSquashPolicy(config, isOptional, defaultPolicy) {
	    var squash = config.squash;
	    if (!isOptional || squash === false)
	        return false;
	    if (!predicates_1.isDefined(squash) || squash == null)
	        return defaultPolicy;
	    if (squash === true || predicates_1.isString(squash))
	        return squash;
	    throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
	}
	function getReplace(config, arrayMode, isOptional, squash) {
	    var replace, configuredKeys, defaultPolicy = [
	        { from: "", to: (isOptional || arrayMode ? undefined : "") },
	        { from: null, to: (isOptional || arrayMode ? undefined : "") }
	    ];
	    replace = predicates_1.isArray(config.replace) ? config.replace : [];
	    if (predicates_1.isString(squash))
	        replace.push({ from: squash, to: undefined });
	    configuredKeys = common_1.map(replace, hof_1.prop("from"));
	    return common_1.filter(defaultPolicy, function (item) { return configuredKeys.indexOf(item.from) === -1; }).concat(replace);
	}
	var Param = (function () {
	    function Param(id, type, config, location, urlMatcherFactory) {
	        config = unwrapShorthand(config);
	        type = getType(config, type, location, id, urlMatcherFactory.paramTypes);
	        var arrayMode = getArrayMode();
	        type = arrayMode ? type.$asArray(arrayMode, location === DefType.SEARCH) : type;
	        var isOptional = config.value !== undefined || location === DefType.SEARCH;
	        var dynamic = predicates_1.isDefined(config.dynamic) ? !!config.dynamic : !!type.dynamic;
	        var raw = predicates_1.isDefined(config.raw) ? !!config.raw : !!type.raw;
	        var squash = getSquashPolicy(config, isOptional, urlMatcherFactory.defaultSquashPolicy());
	        var replace = getReplace(config, arrayMode, isOptional, squash);
	        var inherit = predicates_1.isDefined(config.inherit) ? !!config.inherit : !!type.inherit;
	        // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
	        function getArrayMode() {
	            var arrayDefaults = { array: (location === DefType.SEARCH ? "auto" : false) };
	            var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
	            return common_1.extend(arrayDefaults, arrayParamNomenclature, config).array;
	        }
	        common_1.extend(this, { id: id, type: type, location: location, isOptional: isOptional, dynamic: dynamic, raw: raw, squash: squash, replace: replace, inherit: inherit, array: arrayMode, config: config, });
	    }
	    Param.prototype.isDefaultValue = function (value) {
	        return this.isOptional && this.type.equals(this.value(), value);
	    };
	    /**
	     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
	     * default value, which may be the result of an injectable function.
	     */
	    Param.prototype.value = function (value) {
	        var _this = this;
	        /**
	         * [Internal] Get the default value of a parameter, which may be an injectable function.
	         */
	        var $$getDefaultValue = function () {
	            if (!coreservices_1.services.$injector)
	                throw new Error("Injectable functions cannot be called at configuration time");
	            var defaultValue = coreservices_1.services.$injector.invoke(_this.config.$$fn);
	            if (defaultValue !== null && defaultValue !== undefined && !_this.type.is(defaultValue))
	                throw new Error("Default value (" + defaultValue + ") for parameter '" + _this.id + "' is not an instance of ParamType (" + _this.type.name + ")");
	            return defaultValue;
	        };
	        var $replace = function (val) {
	            var replacement = common_1.map(common_1.filter(_this.replace, hof_1.propEq('from', val)), hof_1.prop("to"));
	            return replacement.length ? replacement[0] : val;
	        };
	        value = $replace(value);
	        return !predicates_1.isDefined(value) ? $$getDefaultValue() : this.type.$normalize(value);
	    };
	    Param.prototype.isSearch = function () {
	        return this.location === DefType.SEARCH;
	    };
	    Param.prototype.validates = function (value) {
	        // There was no parameter value, but the param is optional
	        if ((!predicates_1.isDefined(value) || value === null) && this.isOptional)
	            return true;
	        // The value was not of the correct ParamType, and could not be decoded to the correct ParamType
	        var normalized = this.type.$normalize(value);
	        if (!this.type.is(normalized))
	            return false;
	        // The value was of the correct type, but when encoded, did not match the ParamType's regexp
	        var encoded = this.type.encode(normalized);
	        return !(predicates_1.isString(encoded) && !this.type.pattern.exec(encoded));
	    };
	    Param.prototype.toString = function () {
	        return "{Param:" + this.id + " " + this.type + " squash: '" + this.squash + "' optional: " + this.isOptional + "}";
	    };
	    Param.values = function (params, values) {
	        if (values === void 0) { values = {}; }
	        return params.map(function (param) { return [param.id, param.value(values[param.id])]; }).reduce(common_1.applyPairs, {});
	    };
	    /**
	     * Finds [[Param]] objects which have different param values
	     *
	     * Filters a list of [[Param]] objects to only those whose parameter values differ in two param value objects
	     *
	     * @param params: The list of Param objects to filter
	     * @param values1: The first set of parameter values
	     * @param values2: the second set of parameter values
	     *
	     * @returns any Param objects whose values were different between values1 and values2
	     */
	    Param.changed = function (params, values1, values2) {
	        if (values1 === void 0) { values1 = {}; }
	        if (values2 === void 0) { values2 = {}; }
	        return params.filter(function (param) { return !param.type.equals(values1[param.id], values2[param.id]); });
	    };
	    /**
	     * Checks if two param value objects are equal (for a set of [[Param]] objects)
	     *
	     * @param params The list of [[Param]] objects to check
	     * @param values1 The first set of param values
	     * @param values2 The second set of param values
	     *
	     * @returns true if the param values in values1 and values2 are equal
	     */
	    Param.equals = function (params, values1, values2) {
	        if (values1 === void 0) { values1 = {}; }
	        if (values2 === void 0) { values2 = {}; }
	        return Param.changed(params, values1, values2).length === 0;
	    };
	    /** Returns true if a the parameter values are valid, according to the Param definitions */
	    Param.validates = function (params, values) {
	        if (values === void 0) { values = {}; }
	        return params.map(function (param) { return param.validates(values[param.id]); }).reduce(common_1.allTrueR, true);
	    };
	    return Param;
	}());
	exports.Param = Param;
	//# sourceMappingURL=param.js.map

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/** @module params */ /** for typedoc */
	var common_1 = __webpack_require__(305);
	var predicates_1 = __webpack_require__(306);
	/**
	 * An internal class which implements [[ParamTypeDefinition]].
	 *
	 * A [[ParamTypeDefinition]] is a plain javascript object used to register custom parameter types.
	 * When a param type definition is registered, an instance of this class is created internally.
	 *
	 * This class has naive implementations for all the [[ParamTypeDefinition]] methods.
	 *
	 * Used by [[UrlMatcher]] when matching or formatting URLs, or comparing and validating parameter values.
	 *
	 * #### Example:
	 * ```js
	 * var paramTypeDef = {
	 *   decode: function(val) { return parseInt(val, 10); },
	 *   encode: function(val) { return val && val.toString(); },
	 *   equals: function(a, b) { return this.is(a) && a === b; },
	 *   is: function(val) { return angular.isNumber(val) && isFinite(val) && val % 1 === 0; },
	 *   pattern: /\d+/
	 * }
	 *
	 * var paramType = new ParamType(paramTypeDef);
	 * ```
	 * @internalapi
	 */
	var ParamType = (function () {
	    /**
	     * @param def  A configuration object which contains the custom type definition.  The object's
	     *        properties will override the default methods and/or pattern in `ParamType`'s public interface.
	     * @returns a new ParamType object
	     */
	    function ParamType(def) {
	        /** @inheritdoc */
	        this.pattern = /.*/;
	        /** @inheritdoc */
	        this.inherit = true;
	        common_1.extend(this, def);
	    }
	    // consider these four methods to be "abstract methods" that should be overridden
	    /** @inheritdoc */
	    ParamType.prototype.is = function (val, key) { return true; };
	    /** @inheritdoc */
	    ParamType.prototype.encode = function (val, key) { return val; };
	    /** @inheritdoc */
	    ParamType.prototype.decode = function (val, key) { return val; };
	    /** @inheritdoc */
	    ParamType.prototype.equals = function (a, b) { return a == b; };
	    ParamType.prototype.$subPattern = function () {
	        var sub = this.pattern.toString();
	        return sub.substr(1, sub.length - 2);
	    };
	    ParamType.prototype.toString = function () {
	        return "{ParamType:" + this.name + "}";
	    };
	    /** Given an encoded string, or a decoded object, returns a decoded object */
	    ParamType.prototype.$normalize = function (val) {
	        return this.is(val) ? val : this.decode(val);
	    };
	    /**
	     * Wraps an existing custom ParamType as an array of ParamType, depending on 'mode'.
	     * e.g.:
	     * - urlmatcher pattern "/path?{queryParam[]:int}"
	     * - url: "/path?queryParam=1&queryParam=2
	     * - $stateParams.queryParam will be [1, 2]
	     * if `mode` is "auto", then
	     * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
	     * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
	     */
	    ParamType.prototype.$asArray = function (mode, isSearch) {
	        if (!mode)
	            return this;
	        if (mode === "auto" && !isSearch)
	            throw new Error("'auto' array mode is for query parameters only");
	        return new ArrayType(this, mode);
	    };
	    return ParamType;
	}());
	exports.ParamType = ParamType;
	/**
	 * Wraps up a `ParamType` object to handle array values.
	 * @internalapi
	 */
	function ArrayType(type, mode) {
	    var _this = this;
	    // Wrap non-array value as array
	    function arrayWrap(val) {
	        return predicates_1.isArray(val) ? val : (predicates_1.isDefined(val) ? [val] : []);
	    }
	    // Unwrap array value for "auto" mode. Return undefined for empty array.
	    function arrayUnwrap(val) {
	        switch (val.length) {
	            case 0: return undefined;
	            case 1: return mode === "auto" ? val[0] : val;
	            default: return val;
	        }
	    }
	    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
	    function arrayHandler(callback, allTruthyMode) {
	        return function handleArray(val) {
	            if (predicates_1.isArray(val) && val.length === 0)
	                return val;
	            var arr = arrayWrap(val);
	            var result = common_1.map(arr, callback);
	            return (allTruthyMode === true) ? common_1.filter(result, function (x) { return !x; }).length === 0 : arrayUnwrap(result);
	        };
	    }
	    // Wraps type (.equals) functions to operate on each value of an array
	    function arrayEqualsHandler(callback) {
	        return function handleArray(val1, val2) {
	            var left = arrayWrap(val1), right = arrayWrap(val2);
	            if (left.length !== right.length)
	                return false;
	            for (var i = 0; i < left.length; i++) {
	                if (!callback(left[i], right[i]))
	                    return false;
	            }
	            return true;
	        };
	    }
	    ['encode', 'decode', 'equals', '$normalize'].forEach(function (name) {
	        var paramTypeFn = type[name].bind(type);
	        var wrapperFn = name === 'equals' ? arrayEqualsHandler : arrayHandler;
	        _this[name] = wrapperFn(paramTypeFn);
	    });
	    common_1.extend(this, {
	        dynamic: type.dynamic,
	        name: type.name,
	        pattern: type.pattern,
	        inherit: type.inherit,
	        is: arrayHandler(type.is.bind(type), true),
	        $arrayMode: mode
	    });
	}
	//# sourceMappingURL=paramType.js.map

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/** @module path */ /** for typedoc */
	"use strict";
	var common_1 = __webpack_require__(305);
	var hof_1 = __webpack_require__(307);
	var targetState_1 = __webpack_require__(317);
	var node_1 = __webpack_require__(320);
	/**
	 * This class contains functions which convert TargetStates, Nodes and paths from one type to another.
	 */
	var PathFactory = (function () {
	    function PathFactory() {
	    }
	    /** Given a PathNode[], create an TargetState */
	    PathFactory.makeTargetState = function (path) {
	        var state = common_1.tail(path).state;
	        return new targetState_1.TargetState(state, state, path.map(hof_1.prop("paramValues")).reduce(common_1.mergeR, {}));
	    };
	    PathFactory.buildPath = function (targetState) {
	        var toParams = targetState.params();
	        return targetState.$state().path.map(function (state) { return new node_1.PathNode(state).applyRawParams(toParams); });
	    };
	    /** Given a fromPath: PathNode[] and a TargetState, builds a toPath: PathNode[] */
	    PathFactory.buildToPath = function (fromPath, targetState) {
	        var toPath = PathFactory.buildPath(targetState);
	        if (targetState.options().inherit) {
	            return PathFactory.inheritParams(fromPath, toPath, Object.keys(targetState.params()));
	        }
	        return toPath;
	    };
	    /**
	     * Creates ViewConfig objects and adds to nodes.
	     *
	     * On each [[PathNode]], creates ViewConfig objects from the views: property of the node's state
	     */
	    PathFactory.applyViewConfigs = function ($view, path, states) {
	        // Only apply the viewConfigs to the nodes for the given states
	        path.filter(function (node) { return common_1.inArray(states, node.state); }).forEach(function (node) {
	            var viewDecls = common_1.values(node.state.views || {});
	            var subPath = PathFactory.subPath(path, function (n) { return n === node; });
	            var viewConfigs = viewDecls.map(function (view) { return $view.createViewConfig(subPath, view); });
	            node.views = viewConfigs.reduce(common_1.unnestR, []);
	        });
	    };
	    /**
	     * Given a fromPath and a toPath, returns a new to path which inherits parameters from the fromPath
	     *
	     * For a parameter in a node to be inherited from the from path:
	     * - The toPath's node must have a matching node in the fromPath (by state).
	     * - The parameter name must not be found in the toKeys parameter array.
	     *
	     * Note: the keys provided in toKeys are intended to be those param keys explicitly specified by some
	     * caller, for instance, $state.transitionTo(..., toParams).  If a key was found in toParams,
	     * it is not inherited from the fromPath.
	     */
	    PathFactory.inheritParams = function (fromPath, toPath, toKeys) {
	        if (toKeys === void 0) { toKeys = []; }
	        function nodeParamVals(path, state) {
	            var node = common_1.find(path, hof_1.propEq('state', state));
	            return common_1.extend({}, node && node.paramValues);
	        }
	        var noInherit = fromPath.map(function (node) { return node.paramSchema; })
	            .reduce(common_1.unnestR, [])
	            .filter(function (param) { return !param.inherit; })
	            .map(hof_1.prop('id'));
	        /**
	         * Given an [[PathNode]] "toNode", return a new [[PathNode]] with param values inherited from the
	         * matching node in fromPath.  Only inherit keys that aren't found in "toKeys" from the node in "fromPath""
	         */
	        function makeInheritedParamsNode(toNode) {
	            // All param values for the node (may include default key/vals, when key was not found in toParams)
	            var toParamVals = common_1.extend({}, toNode && toNode.paramValues);
	            // limited to only those keys found in toParams
	            var incomingParamVals = common_1.pick(toParamVals, toKeys);
	            toParamVals = common_1.omit(toParamVals, toKeys);
	            var fromParamVals = common_1.omit(nodeParamVals(fromPath, toNode.state) || {}, noInherit);
	            // extend toParamVals with any fromParamVals, then override any of those those with incomingParamVals
	            var ownParamVals = common_1.extend(toParamVals, fromParamVals, incomingParamVals);
	            return new node_1.PathNode(toNode.state).applyRawParams(ownParamVals);
	        }
	        // The param keys specified by the incoming toParams
	        return toPath.map(makeInheritedParamsNode);
	    };
	    /**
	     * Computes the tree changes (entering, exiting) between a fromPath and toPath.
	     */
	    PathFactory.treeChanges = function (fromPath, toPath, reloadState) {
	        var keep = 0, max = Math.min(fromPath.length, toPath.length);
	        var staticParams = function (state) {
	            return state.parameters({ inherit: false }).filter(hof_1.not(hof_1.prop('dynamic'))).map(hof_1.prop('id'));
	        };
	        var nodesMatch = function (node1, node2) {
	            return node1.equals(node2, staticParams(node1.state));
	        };
	        while (keep < max && fromPath[keep].state !== reloadState && nodesMatch(fromPath[keep], toPath[keep])) {
	            keep++;
	        }
	        /** Given a retained node, return a new node which uses the to node's param values */
	        function applyToParams(retainedNode, idx) {
	            var cloned = node_1.PathNode.clone(retainedNode);
	            cloned.paramValues = toPath[idx].paramValues;
	            return cloned;
	        }
	        var from, retained, exiting, entering, to;
	        from = fromPath;
	        retained = from.slice(0, keep);
	        exiting = from.slice(keep);
	        // Create a new retained path (with shallow copies of nodes) which have the params of the toPath mapped
	        var retainedWithToParams = retained.map(applyToParams);
	        entering = toPath.slice(keep);
	        to = (retainedWithToParams).concat(entering);
	        return { from: from, to: to, retained: retained, exiting: exiting, entering: entering };
	    };
	    /**
	     * Return a subpath of a path, which stops at the first matching node
	     *
	     * Given an array of nodes, returns a subset of the array starting from the first node,
	     * stopping when the first node matches the predicate.
	     *
	     * @param path a path of [[PathNode]]s
	     * @param predicate a [[Predicate]] fn that matches [[PathNode]]s
	     * @returns a subpath up to the matching node, or undefined if no match is found
	     */
	    PathFactory.subPath = function (path, predicate) {
	        var node = common_1.find(path, predicate);
	        var elementIdx = path.indexOf(node);
	        return elementIdx === -1 ? undefined : path.slice(0, elementIdx + 1);
	    };
	    return PathFactory;
	}());
	/** Gets the raw parameter values from a path */
	PathFactory.paramValues = function (path) { return path.reduce(function (acc, node) { return common_1.extend(acc, node.paramValues); }, {}); };
	exports.PathFactory = PathFactory;
	//# sourceMappingURL=pathFactory.js.map

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @coreapi
	 * @module resolve
	 */ /** for typedoc */
	var common_1 = __webpack_require__(305);
	var coreservices_1 = __webpack_require__(308);
	var trace_1 = __webpack_require__(314);
	var strings_1 = __webpack_require__(311);
	var predicates_1 = __webpack_require__(306);
	// TODO: explicitly make this user configurable
	exports.defaultResolvePolicy = {
	    when: "LAZY",
	    async: "WAIT"
	};
	/**
	 * The basic building block for the resolve system.
	 *
	 * Resolvables encapsulate a state's resolve's resolveFn, the resolveFn's declared dependencies, the wrapped (.promise),
	 * and the unwrapped-when-complete (.data) result of the resolveFn.
	 *
	 * Resolvable.get() either retrieves the Resolvable's existing promise, or else invokes resolve() (which invokes the
	 * resolveFn) and returns the resulting promise.
	 *
	 * Resolvable.get() and Resolvable.resolve() both execute within a context path, which is passed as the first
	 * parameter to those fns.
	 */
	var Resolvable = (function () {
	    function Resolvable(arg1, resolveFn, deps, policy, data) {
	        this.resolved = false;
	        this.promise = undefined;
	        if (arg1 instanceof Resolvable) {
	            common_1.extend(this, arg1);
	        }
	        else if (predicates_1.isFunction(resolveFn)) {
	            if (arg1 == null || arg1 == undefined)
	                throw new Error("new Resolvable(): token argument is required");
	            if (!predicates_1.isFunction(resolveFn))
	                throw new Error("new Resolvable(): resolveFn argument must be a function");
	            this.token = arg1;
	            this.policy = policy;
	            this.resolveFn = resolveFn;
	            this.deps = deps || [];
	            this.data = data;
	            this.resolved = data !== undefined;
	            this.promise = this.resolved ? coreservices_1.services.$q.when(this.data) : undefined;
	        }
	        else if (predicates_1.isObject(arg1) && arg1.token && predicates_1.isFunction(arg1.resolveFn)) {
	            var literal = arg1;
	            return new Resolvable(literal.token, literal.resolveFn, literal.deps, literal.policy, literal.data);
	        }
	    }
	    Resolvable.prototype.getPolicy = function (state) {
	        var thisPolicy = this.policy || {};
	        var statePolicy = state && state.resolvePolicy || {};
	        return {
	            when: thisPolicy.when || statePolicy.when || exports.defaultResolvePolicy.when,
	            async: thisPolicy.async || statePolicy.async || exports.defaultResolvePolicy.async,
	        };
	    };
	    /**
	     * Asynchronously resolve this Resolvable's data
	     *
	     * Given a ResolveContext that this Resolvable is found in:
	     * Wait for this Resolvable's dependencies, then invoke this Resolvable's function
	     * and update the Resolvable's state
	     */
	    Resolvable.prototype.resolve = function (resolveContext, trans) {
	        var _this = this;
	        var $q = coreservices_1.services.$q;
	        // Gets all dependencies from ResolveContext and wait for them to be resolved
	        var getResolvableDependencies = function () {
	            return $q.all(resolveContext.getDependencies(_this).map(function (r) {
	                return r.get(resolveContext, trans);
	            }));
	        };
	        // Invokes the resolve function passing the resolved dependencies as arguments
	        var invokeResolveFn = function (resolvedDeps) {
	            return _this.resolveFn.apply(null, resolvedDeps);
	        };
	        /**
	         * For RXWAIT policy:
	         *
	         * Given an observable returned from a resolve function:
	         * - enables .cache() mode (this allows multicast subscribers)
	         * - then calls toPromise() (this triggers subscribe() and thus fetches)
	         * - Waits for the promise, then return the cached observable (not the first emitted value).
	         */
	        var waitForRx = function (observable$) {
	            var cached = observable$.cache(1);
	            return cached.take(1).toPromise().then(function () { return cached; });
	        };
	        // If the resolve policy is RXWAIT, wait for the observable to emit something. otherwise pass through.
	        var node = resolveContext.findNode(this);
	        var state = node && node.state;
	        var maybeWaitForRx = this.getPolicy(state).async === "RXWAIT" ? waitForRx : common_1.identity;
	        // After the final value has been resolved, update the state of the Resolvable
	        var applyResolvedValue = function (resolvedValue) {
	            _this.data = resolvedValue;
	            _this.resolved = true;
	            trace_1.trace.traceResolvableResolved(_this, trans);
	            return _this.data;
	        };
	        // Sets the promise property first, then getsResolvableDependencies in the context of the promise chain. Always waits one tick.
	        return this.promise = $q.when()
	            .then(getResolvableDependencies)
	            .then(invokeResolveFn)
	            .then(maybeWaitForRx)
	            .then(applyResolvedValue);
	    };
	    /**
	     * Gets a promise for this Resolvable's data.
	     *
	     * Fetches the data and returns a promise.
	     * Returns the existing promise if it has already been fetched once.
	     */
	    Resolvable.prototype.get = function (resolveContext, trans) {
	        return this.promise || this.resolve(resolveContext, trans);
	    };
	    Resolvable.prototype.toString = function () {
	        return "Resolvable(token: " + strings_1.stringify(this.token) + ", requires: [" + this.deps.map(strings_1.stringify) + "])";
	    };
	    Resolvable.prototype.clone = function () {
	        return new Resolvable(this);
	    };
	    return Resolvable;
	}());
	Resolvable.fromData = function (token, data) {
	    return new Resolvable(token, function () { return data; }, null, null, data);
	};
	exports.Resolvable = Resolvable;
	//# sourceMappingURL=resolvable.js.map

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/** @module resolve */
	/** for typedoc */
	var common_1 = __webpack_require__(305);
	var hof_1 = __webpack_require__(307);
	var trace_1 = __webpack_require__(314);
	var coreservices_1 = __webpack_require__(308);
	var interface_1 = __webpack_require__(326);
	var resolvable_1 = __webpack_require__(324);
	var pathFactory_1 = __webpack_require__(323);
	var strings_1 = __webpack_require__(311);
	var when = interface_1.resolvePolicies.when;
	var ALL_WHENS = [when.EAGER, when.LAZY];
	var EAGER_WHENS = [when.EAGER];
	exports.NATIVE_INJECTOR_TOKEN = "Native Injector";
	/**
	 * Encapsulates Depenency Injection for a path of nodes
	 *
	 * UI-Router states are organized as a tree.
	 * A nested state has a path of ancestors to the root of the tree.
	 * When a state is being activated, each element in the path is wrapped as a [[PathNode]].
	 * A `PathNode` is a stateful object that holds things like parameters and resolvables for the state being activated.
	 *
	 * The ResolveContext closes over the [[PathNode]]s, and provides DI for the last node in the path.
	 */
	var ResolveContext = (function () {
	    function ResolveContext(_path) {
	        this._path = _path;
	    }
	    /** Gets all the tokens found in the resolve context, de-duplicated */
	    ResolveContext.prototype.getTokens = function () {
	        return this._path.reduce(function (acc, node) { return acc.concat(node.resolvables.map(function (r) { return r.token; })); }, []).reduce(common_1.uniqR, []);
	    };
	    /**
	     * Gets the Resolvable that matches the token
	     *
	     * Gets the last Resolvable that matches the token in this context, or undefined.
	     * Throws an error if it doesn't exist in the ResolveContext
	     */
	    ResolveContext.prototype.getResolvable = function (token) {
	        var matching = this._path.map(function (node) { return node.resolvables; })
	            .reduce(common_1.unnestR, [])
	            .filter(function (r) { return r.token === token; });
	        return common_1.tail(matching);
	    };
	    /** Returns the [[ResolvePolicy]] for the given [[Resolvable]] */
	    ResolveContext.prototype.getPolicy = function (resolvable) {
	        var node = this.findNode(resolvable);
	        return resolvable.getPolicy(node.state);
	    };
	    /**
	     * Returns a ResolveContext that includes a portion of this one
	     *
	     * Given a state, this method creates a new ResolveContext from this one.
	     * The new context starts at the first node (root) and stops at the node for the `state` parameter.
	     *
	     * #### Why
	     *
	     * When a transition is created, the nodes in the "To Path" are injected from a ResolveContext.
	     * A ResolveContext closes over a path of [[PathNode]]s and processes the resolvables.
	     * The "To State" can inject values from its own resolvables, as well as those from all its ancestor state's (node's).
	     * This method is used to create a narrower context when injecting ancestor nodes.
	     *
	     * @example
	     * `let ABCD = new ResolveContext([A, B, C, D]);`
	     *
	     * Given a path `[A, B, C, D]`, where `A`, `B`, `C` and `D` are nodes for states `a`, `b`, `c`, `d`:
	     * When injecting `D`, `D` should have access to all resolvables from `A`, `B`, `C`, `D`.
	     * However, `B` should only be able to access resolvables from `A`, `B`.
	     *
	     * When resolving for the `B` node, first take the full "To Path" Context `[A,B,C,D]` and limit to the subpath `[A,B]`.
	     * `let AB = ABCD.subcontext(a)`
	     */
	    ResolveContext.prototype.subContext = function (state) {
	        return new ResolveContext(pathFactory_1.PathFactory.subPath(this._path, function (node) { return node.state === state; }));
	    };
	    /**
	     * Adds Resolvables to the node that matches the state
	     *
	     * This adds a [[Resolvable]] (generally one created on the fly; not declared on a [[StateDeclaration.resolve]] block).
	     * The resolvable is added to the node matching the `state` parameter.
	     *
	     * These new resolvables are not automatically fetched.
	     * The calling code should either fetch them, fetch something that depends on them,
	     * or rely on [[resolvePath]] being called when some state is being entered.
	     *
	     * Note: each resolvable's [[ResolvePolicy]] is merged with the state's policy, and the global default.
	     *
	     * @param newResolvables the new Resolvables
	     * @param state Used to find the node to put the resolvable on
	     */
	    ResolveContext.prototype.addResolvables = function (newResolvables, state) {
	        var node = common_1.find(this._path, hof_1.propEq('state', state));
	        var keys = newResolvables.map(function (r) { return r.token; });
	        node.resolvables = node.resolvables.filter(function (r) { return keys.indexOf(r.token) === -1; }).concat(newResolvables);
	    };
	    /**
	     * Returns a promise for an array of resolved path Element promises
	     *
	     * @param when
	     * @param trans
	     * @returns {Promise<any>|any}
	     */
	    ResolveContext.prototype.resolvePath = function (when, trans) {
	        var _this = this;
	        if (when === void 0) { when = "LAZY"; }
	        // This option determines which 'when' policy Resolvables we are about to fetch.
	        var whenOption = common_1.inArray(ALL_WHENS, when) ? when : "LAZY";
	        // If the caller specified EAGER, only the EAGER Resolvables are fetched.
	        // if the caller specified LAZY, both EAGER and LAZY Resolvables are fetched.`
	        var matchedWhens = whenOption === interface_1.resolvePolicies.when.EAGER ? EAGER_WHENS : ALL_WHENS;
	        // get the subpath to the state argument, if provided
	        trace_1.trace.traceResolvePath(this._path, when, trans);
	        var matchesPolicy = function (acceptedVals, whenOrAsync) {
	            return function (resolvable) {
	                return common_1.inArray(acceptedVals, _this.getPolicy(resolvable)[whenOrAsync]);
	            };
	        };
	        // Trigger all the (matching) Resolvables in the path
	        // Reduce all the "WAIT" Resolvables into an array
	        var promises = this._path.reduce(function (acc, node) {
	            var nodeResolvables = node.resolvables.filter(matchesPolicy(matchedWhens, 'when'));
	            var nowait = nodeResolvables.filter(matchesPolicy(['NOWAIT'], 'async'));
	            var wait = nodeResolvables.filter(hof_1.not(matchesPolicy(['NOWAIT'], 'async')));
	            // For the matching Resolvables, start their async fetch process.
	            var subContext = _this.subContext(node.state);
	            var getResult = function (r) { return r.get(subContext, trans)
	                .then(function (value) { return ({ token: r.token, value: value }); }); };
	            nowait.forEach(getResult);
	            return acc.concat(wait.map(getResult));
	        }, []);
	        // Wait for all the "WAIT" resolvables
	        return coreservices_1.services.$q.all(promises);
	    };
	    ResolveContext.prototype.injector = function () {
	        return this._injector || (this._injector = new UIInjectorImpl(this));
	    };
	    ResolveContext.prototype.findNode = function (resolvable) {
	        return common_1.find(this._path, function (node) { return common_1.inArray(node.resolvables, resolvable); });
	    };
	    /**
	     * Gets the async dependencies of a Resolvable
	     *
	     * Given a Resolvable, returns its dependencies as a Resolvable[]
	     */
	    ResolveContext.prototype.getDependencies = function (resolvable) {
	        var _this = this;
	        var node = this.findNode(resolvable);
	        // Find which other resolvables are "visible" to the `resolvable` argument
	        // subpath stopping at resolvable's node, or the whole path (if the resolvable isn't in the path)
	        var subPath = pathFactory_1.PathFactory.subPath(this._path, function (x) { return x === node; }) || this._path;
	        var availableResolvables = subPath
	            .reduce(function (acc, node) { return acc.concat(node.resolvables); }, []) //all of subpath's resolvables
	            .filter(function (res) { return res !== resolvable; }); // filter out the `resolvable` argument
	        var getDependency = function (token) {
	            var matching = availableResolvables.filter(function (r) { return r.token === token; });
	            if (matching.length)
	                return common_1.tail(matching);
	            var fromInjector = _this.injector().getNative(token);
	            if (!fromInjector) {
	                throw new Error("Could not find Dependency Injection token: " + strings_1.stringify(token));
	            }
	            return new resolvable_1.Resolvable(token, function () { return fromInjector; }, [], fromInjector);
	        };
	        return resolvable.deps.map(getDependency);
	    };
	    return ResolveContext;
	}());
	exports.ResolveContext = ResolveContext;
	var UIInjectorImpl = (function () {
	    function UIInjectorImpl(context) {
	        this.context = context;
	        this.native = this.get(exports.NATIVE_INJECTOR_TOKEN) || coreservices_1.services.$injector;
	    }
	    UIInjectorImpl.prototype.get = function (token) {
	        var resolvable = this.context.getResolvable(token);
	        if (resolvable) {
	            if (this.context.getPolicy(resolvable).async === 'NOWAIT') {
	                return resolvable.get(this.context);
	            }
	            if (!resolvable.resolved) {
	                throw new Error("Resolvable async .get() not complete:" + strings_1.stringify(resolvable.token));
	            }
	            return resolvable.data;
	        }
	        return this.native && this.native.get(token);
	    };
	    UIInjectorImpl.prototype.getAsync = function (token) {
	        var resolvable = this.context.getResolvable(token);
	        if (resolvable)
	            return resolvable.get(this.context);
	        return coreservices_1.services.$q.when(this.native.get(token));
	    };
	    UIInjectorImpl.prototype.getNative = function (token) {
	        return this.native && this.native.get(token);
	    };
	    return UIInjectorImpl;
	}());
	//# sourceMappingURL=resolveContext.js.map

/***/ },
/* 326 */
/***/ function(module, exports) {

	"use strict";
	/** @internalapi */
	exports.resolvePolicies = {
	    when: {
	        LAZY: "LAZY",
	        EAGER: "EAGER"
	    },
	    async: {
	        WAIT: "WAIT",
	        NOWAIT: "NOWAIT",
	        RXWAIT: "RXWAIT"
	    }
	};
	//# sourceMappingURL=interface.js.map

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @coreapi
	 * @module core
	 */ /** */
	var urlMatcherFactory_1 = __webpack_require__(328);
	var urlRouter_1 = __webpack_require__(331);
	var transitionService_1 = __webpack_require__(334);
	var view_1 = __webpack_require__(342);
	var stateRegistry_1 = __webpack_require__(343);
	var stateService_1 = __webpack_require__(347);
	var globals_1 = __webpack_require__(348);
	var common_1 = __webpack_require__(305);
	var predicates_1 = __webpack_require__(306);
	var urlService_1 = __webpack_require__(350);
	/** @hidden */
	var _routerInstance = 0;
	/**
	 * The master class used to instantiate an instance of UI-Router.
	 *
	 * UI-Router (for a specific framework) will create an instance of this class during bootstrap.
	 * This class instantiates and wires the UI-Router services together.
	 *
	 * After a new instance of the UIRouter class is created, it should be configured for your app.
	 * For instance, app states should be registered with the [[stateRegistry]].
	 *
	 * Tell UI-Router to monitor the URL by calling `uiRouter.urlRouter.listen()` ([[UrlRouter.listen]])
	 */
	var UIRouter = (function () {
	    function UIRouter(locationService, locationConfig) {
	        if (locationService === void 0) { locationService = urlService_1.UrlService.locationServiceStub; }
	        if (locationConfig === void 0) { locationConfig = urlService_1.UrlService.locationConfigStub; }
	        this.locationService = locationService;
	        this.locationConfig = locationConfig;
	        /** @hidden */
	        this.$id = _routerInstance++;
	        this.viewService = new view_1.ViewService();
	        this.transitionService = new transitionService_1.TransitionService(this);
	        this.globals = new globals_1.Globals(this.transitionService);
	        this.urlMatcherFactory = new urlMatcherFactory_1.UrlMatcherFactory();
	        this.urlRouter = new urlRouter_1.UrlRouter(this);
	        this.stateRegistry = new stateRegistry_1.StateRegistry(this);
	        this.stateService = new stateService_1.StateService(this);
	        this.urlService = new urlService_1.UrlService(this);
	        this._disposables = [];
	        /** @hidden */
	        this._plugins = {};
	        this.viewService._pluginapi._rootViewContext(this.stateRegistry.root());
	        this.globals.$current = this.stateRegistry.root();
	        this.globals.current = this.globals.$current.self;
	        this.disposable(this.transitionService);
	        this.disposable(this.urlRouter);
	        this.disposable(this.stateRegistry);
	        this.disposable(locationService);
	        this.disposable(locationConfig);
	    }
	    /** Registers an object to be notified when the router is disposed */
	    UIRouter.prototype.disposable = function (disposable) {
	        this._disposables.push(disposable);
	    };
	    /**
	     * Disposes this router instance
	     *
	     * When called, clears resources retained by the router by calling `dispose(this)` on all
	     * registered [[disposable]] objects.
	     *
	     * Or, if a `disposable` object is provided, calls `dispose(this)` on that object only.
	     *
	     * @param disposable (optional) the disposable to dispose
	     */
	    UIRouter.prototype.dispose = function (disposable) {
	        var _this = this;
	        if (disposable && predicates_1.isFunction(disposable.dispose)) {
	            disposable.dispose(this);
	            return undefined;
	        }
	        this._disposables.slice().forEach(function (d) {
	            try {
	                typeof d.dispose === 'function' && d.dispose(_this);
	                common_1.removeFrom(_this._disposables, d);
	            }
	            catch (ignored) { }
	        });
	    };
	    /** Allow javascript factory function */
	    UIRouter.prototype.plugin = function (plugin, options) {
	        if (options === void 0) { options = {}; }
	        var pluginInstance = new plugin(this, options);
	        if (!pluginInstance.name)
	            throw new Error("Required property `name` missing on plugin: " + pluginInstance);
	        this._disposables.push(pluginInstance);
	        return this._plugins[pluginInstance.name] = pluginInstance;
	    };
	    UIRouter.prototype.getPlugin = function (pluginName) {
	        return pluginName ? this._plugins[pluginName] : common_1.values(this._plugins);
	    };
	    return UIRouter;
	}());
	exports.UIRouter = UIRouter;
	//# sourceMappingURL=router.js.map

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @internalapi
	 * @module url
	 */ /** for typedoc */
	var common_1 = __webpack_require__(305);
	var predicates_1 = __webpack_require__(306);
	var urlMatcher_1 = __webpack_require__(329);
	var param_1 = __webpack_require__(321);
	var paramTypes_1 = __webpack_require__(330);
	/**
	 * Factory for [[UrlMatcher]] instances.
	 *
	 * The factory is available to ng1 services as
	 * `$urlMatcherFactor` or ng1 providers as `$urlMatcherFactoryProvider`.
	 */
	var UrlMatcherFactory = (function () {
	    function UrlMatcherFactory() {
	        var _this = this;
	        /** @hidden */ this.paramTypes = new paramTypes_1.ParamTypes();
	        /** @hidden */ this._isCaseInsensitive = false;
	        /** @hidden */ this._isStrictMode = true;
	        /** @hidden */ this._defaultSquashPolicy = false;
	        /** @hidden */
	        this._getConfig = function (config) {
	            return common_1.extend({ strict: _this._isStrictMode, caseInsensitive: _this._isCaseInsensitive }, config);
	        };
	        /** @internalapi Creates a new [[Param]] for a given location (DefType) */
	        this.paramFactory = {
	            /** Creates a new [[Param]] from a CONFIG block */
	            fromConfig: function (id, type, config) {
	                return new param_1.Param(id, type, config, param_1.DefType.CONFIG, _this);
	            },
	            /** Creates a new [[Param]] from a url PATH */
	            fromPath: function (id, type, config) {
	                return new param_1.Param(id, type, config, param_1.DefType.PATH, _this);
	            },
	            /** Creates a new [[Param]] from a url SEARCH */
	            fromSearch: function (id, type, config) {
	                return new param_1.Param(id, type, config, param_1.DefType.SEARCH, _this);
	            },
	        };
	        common_1.extend(this, { UrlMatcher: urlMatcher_1.UrlMatcher, Param: param_1.Param });
	    }
	    /** @inheritdoc */
	    UrlMatcherFactory.prototype.caseInsensitive = function (value) {
	        return this._isCaseInsensitive = predicates_1.isDefined(value) ? value : this._isCaseInsensitive;
	    };
	    /** @inheritdoc */
	    UrlMatcherFactory.prototype.strictMode = function (value) {
	        return this._isStrictMode = predicates_1.isDefined(value) ? value : this._isStrictMode;
	    };
	    /** @inheritdoc */
	    UrlMatcherFactory.prototype.defaultSquashPolicy = function (value) {
	        if (predicates_1.isDefined(value) && value !== true && value !== false && !predicates_1.isString(value))
	            throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
	        return this._defaultSquashPolicy = predicates_1.isDefined(value) ? value : this._defaultSquashPolicy;
	    };
	    /**
	     * Creates a [[UrlMatcher]] for the specified pattern.
	     *
	     * @param pattern  The URL pattern.
	     * @param config  The config object hash.
	     * @returns The UrlMatcher.
	     */
	    UrlMatcherFactory.prototype.compile = function (pattern, config) {
	        return new urlMatcher_1.UrlMatcher(pattern, this.paramTypes, this.paramFactory, this._getConfig(config));
	    };
	    /**
	     * Returns true if the specified object is a [[UrlMatcher]], or false otherwise.
	     *
	     * @param object  The object to perform the type check against.
	     * @returns `true` if the object matches the `UrlMatcher` interface, by
	     *          implementing all the same methods.
	     */
	    UrlMatcherFactory.prototype.isMatcher = function (object) {
	        // TODO: typeof?
	        if (!predicates_1.isObject(object))
	            return false;
	        var result = true;
	        common_1.forEach(urlMatcher_1.UrlMatcher.prototype, function (val, name) {
	            if (predicates_1.isFunction(val))
	                result = result && (predicates_1.isDefined(object[name]) && predicates_1.isFunction(object[name]));
	        });
	        return result;
	    };
	    ;
	    /**
	     * Creates and registers a custom [[ParamType]] object
	     *
	     * A [[ParamType]] can be used to generate URLs with typed parameters.
	     *
	     * @param name  The type name.
	     * @param definition The type definition. See [[ParamTypeDefinition]] for information on the values accepted.
	     * @param definitionFn A function that is injected before the app runtime starts.
	     *        The result of this function should be a [[ParamTypeDefinition]].
	     *        The result is merged into the existing `definition`.
	     *        See [[ParamType]] for information on the values accepted.
	     *
	     * @returns - if a type was registered: the [[UrlMatcherFactory]]
	     *   - if only the `name` parameter was specified: the currently registered [[ParamType]] object, or undefined
	     *
	     * Note: Register custom types *before using them* in a state definition.
	     *
	     * See [[ParamTypeDefinition]] for examples
	     */
	    UrlMatcherFactory.prototype.type = function (name, definition, definitionFn) {
	        var type = this.paramTypes.type(name, definition, definitionFn);
	        return !predicates_1.isDefined(definition) ? type : this;
	    };
	    ;
	    /** @hidden */
	    UrlMatcherFactory.prototype.$get = function () {
	        this.paramTypes.enqueue = false;
	        this.paramTypes._flushTypeQueue();
	        return this;
	    };
	    ;
	    /** @internalapi */
	    UrlMatcherFactory.prototype.dispose = function () {
	        this.paramTypes.dispose();
	    };
	    return UrlMatcherFactory;
	}());
	exports.UrlMatcherFactory = UrlMatcherFactory;
	//# sourceMappingURL=urlMatcherFactory.js.map

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @coreapi
	 * @module url
	 */ /** for typedoc */
	var common_1 = __webpack_require__(305);
	var hof_1 = __webpack_require__(307);
	var predicates_1 = __webpack_require__(306);
	var param_1 = __webpack_require__(321);
	var strings_1 = __webpack_require__(311);
	/** @hidden */
	function quoteRegExp(string, param) {
	    var surroundPattern = ['', ''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
	    if (!param)
	        return result;
	    switch (param.squash) {
	        case false:
	            surroundPattern = ['(', ')' + (param.isOptional ? '?' : '')];
	            break;
	        case true:
	            result = result.replace(/\/$/, '');
	            surroundPattern = ['(?:\/(', ')|\/)?'];
	            break;
	        default:
	            surroundPattern = ["(" + param.squash + "|", ')?'];
	            break;
	    }
	    return result + surroundPattern[0] + param.type.pattern.source + surroundPattern[1];
	}
	/** @hidden */
	var memoizeTo = function (obj, prop, fn) {
	    return obj[prop] = obj[prop] || fn();
	};
	/**
	 * Matches URLs against patterns.
	 *
	 * Matches URLs against patterns and extracts named parameters from the path or the search
	 * part of the URL.
	 *
	 * A URL pattern consists of a path pattern, optionally followed by '?' and a list of search (query)
	 * parameters. Multiple search parameter names are separated by '&'. Search parameters
	 * do not influence whether or not a URL is matched, but their values are passed through into
	 * the matched parameters returned by [[UrlMatcher.exec]].
	 *
	 * - *Path parameters* are defined using curly brace placeholders (`/somepath/{param}`)
	 * or colon placeholders (`/somePath/:param`).
	 *
	 * - *A parameter RegExp* may be defined for a param after a colon
	 * (`/somePath/{param:[a-zA-Z0-9]+}`) in a curly brace placeholder.
	 * The regexp must match for the url to be matched.
	 * Should the regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
	 *
	 * Note: a RegExp parameter will encode its value using either [[ParamTypes.path]] or [[ParamTypes.query]].
	 *
	 * - *Custom parameter types* may also be specified after a colon (`/somePath/{param:int}`) in curly brace parameters.
	 *   See [[UrlMatcherFactory.type]] for more information.
	 *
	 * - *Catch-all parameters* are defined using an asterisk placeholder (`/somepath/*catchallparam`).
	 *   A catch-all * parameter value will contain the remainder of the URL.
	 *
	 * ---
	 *
	 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
	 * must be unique within the pattern (across both path and search parameters).
	 * A path parameter matches any number of characters other than '/'. For catch-all
	 * placeholders the path parameter matches any number of characters.
	 *
	 * Examples:
	 *
	 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
	 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
	 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
	 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
	 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
	 * * `'/user/{id:[^/]*}'` - Same as the previous example.
	 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
	 *   parameter consists of 1 to 8 hex digits.
	 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
	 *   path into the parameter 'path'.
	 * * `'/files/*path'` - ditto.
	 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
	 *   in the built-in  `date` ParamType matches `2014-11-12`) and provides a Date object in $stateParams.start
	 *
	 */
	var UrlMatcher = (function () {
	    /**
	     * @param pattern The pattern to compile into a matcher.
	     * @param paramTypes The [[ParamTypes]] registry
	     * @param config  A configuration object
	     * - `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
	     * - `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
	     */
	    function UrlMatcher(pattern, paramTypes, paramFactory, config) {
	        var _this = this;
	        this.config = config;
	        /** @hidden */
	        this._cache = { path: [this], parent: null, pattern: null };
	        /** @hidden */
	        this._children = [];
	        /** @hidden */
	        this._params = [];
	        /** @hidden */
	        this._segments = [];
	        /** @hidden */
	        this._compiled = [];
	        this.pattern = pattern;
	        this.config = common_1.defaults(this.config, {
	            params: {},
	            strict: true,
	            caseInsensitive: false,
	            paramMap: common_1.identity
	        });
	        // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
	        //   '*' name
	        //   ':' name
	        //   '{' name '}'
	        //   '{' name ':' regexp '}'
	        // The regular expression is somewhat complicated due to the need to allow curly braces
	        // inside the regular expression. The placeholder regexp breaks down as follows:
	        //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
	        //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
	        //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
	        //    [^{}\\]+                       - anything other than curly braces or backslash
	        //    \\.                            - a backslash escape
	        //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
	        var placeholder = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g, searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g, last = 0, m, patterns = [];
	        var checkParamErrors = function (id) {
	            if (!UrlMatcher.nameValidator.test(id))
	                throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
	            if (common_1.find(_this._params, hof_1.propEq('id', id)))
	                throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
	        };
	        // Split into static segments separated by path parameter placeholders.
	        // The number of segments is always 1 more than the number of parameters.
	        var matchDetails = function (m, isSearch) {
	            // IE[78] returns '' for unmatched groups instead of null
	            var id = m[2] || m[3];
	            var regexp = isSearch ? m[4] : m[4] || (m[1] === '*' ? '.*' : null);
	            var makeRegexpType = function (regexp) { return common_1.inherit(paramTypes.type(isSearch ? "query" : "path"), {
	                pattern: new RegExp(regexp, _this.config.caseInsensitive ? 'i' : undefined)
	            }); };
	            return {
	                id: id,
	                regexp: regexp,
	                cfg: _this.config.params[id],
	                segment: pattern.substring(last, m.index),
	                type: !regexp ? null : paramTypes.type(regexp) || makeRegexpType(regexp)
	            };
	        };
	        var p, segment;
	        while ((m = placeholder.exec(pattern))) {
	            p = matchDetails(m, false);
	            if (p.segment.indexOf('?') >= 0)
	                break; // we're into the search part
	            checkParamErrors(p.id);
	            this._params.push(paramFactory.fromPath(p.id, p.type, this.config.paramMap(p.cfg, false)));
	            this._segments.push(p.segment);
	            patterns.push([p.segment, common_1.tail(this._params)]);
	            last = placeholder.lastIndex;
	        }
	        segment = pattern.substring(last);
	        // Find any search parameter names and remove them from the last segment
	        var i = segment.indexOf('?');
	        if (i >= 0) {
	            var search = segment.substring(i);
	            segment = segment.substring(0, i);
	            if (search.length > 0) {
	                last = 0;
	                while ((m = searchPlaceholder.exec(search))) {
	                    p = matchDetails(m, true);
	                    checkParamErrors(p.id);
	                    this._params.push(paramFactory.fromSearch(p.id, p.type, this.config.paramMap(p.cfg, true)));
	                    last = placeholder.lastIndex;
	                }
	            }
	        }
	        this._segments.push(segment);
	        this._compiled = patterns.map(function (pattern) { return quoteRegExp.apply(null, pattern); }).concat(quoteRegExp(segment));
	    }
	    /**
	     * Creates a new concatenated UrlMatcher
	     *
	     * Builds a new UrlMatcher by appending another UrlMatcher to this one.
	     *
	     * @param url A `UrlMatcher` instance to append as a child of the current `UrlMatcher`.
	     */
	    UrlMatcher.prototype.append = function (url) {
	        this._children.push(url);
	        url._cache = {
	            path: this._cache.path.concat(url),
	            parent: this,
	            pattern: null,
	        };
	        return url;
	    };
	    /** @hidden */
	    UrlMatcher.prototype.isRoot = function () {
	        return this._cache.path[0] === this;
	    };
	    /** Returns the input pattern string */
	    UrlMatcher.prototype.toString = function () {
	        return this.pattern;
	    };
	    /**
	     * Tests the specified url/path against this matcher.
	     *
	     * Tests if the given url matches this matcher's pattern, and returns an object containing the captured
	     * parameter values.  Returns null if the path does not match.
	     *
	     * The returned object contains the values
	     * of any search parameters that are mentioned in the pattern, but their value may be null if
	     * they are not present in `search`. This means that search parameters are always treated
	     * as optional.
	     *
	     * #### Example:
	     * ```js
	     * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
	     *   x: '1', q: 'hello'
	     * });
	     * // returns { id: 'bob', q: 'hello', r: null }
	     * ```
	     *
	     * @param path    The URL path to match, e.g. `$location.path()`.
	     * @param search  URL search parameters, e.g. `$location.search()`.
	     * @param hash    URL hash e.g. `$location.hash()`.
	     * @param options
	     *
	     * @returns The captured parameter values.
	     */
	    UrlMatcher.prototype.exec = function (path, search, hash, options) {
	        var _this = this;
	        if (search === void 0) { search = {}; }
	        if (options === void 0) { options = {}; }
	        var match = memoizeTo(this._cache, 'pattern', function () {
	            return new RegExp([
	                '^',
	                common_1.unnest(_this._cache.path.map(hof_1.prop('_compiled'))).join(''),
	                _this.config.strict === false ? '\/?' : '',
	                '$'
	            ].join(''), _this.config.caseInsensitive ? 'i' : undefined);
	        }).exec(path);
	        if (!match)
	            return null;
	        //options = defaults(options, { isolate: false });
	        var allParams = this.parameters(), pathParams = allParams.filter(function (param) { return !param.isSearch(); }), searchParams = allParams.filter(function (param) { return param.isSearch(); }), nPathSegments = this._cache.path.map(function (urlm) { return urlm._segments.length - 1; }).reduce(function (a, x) { return a + x; }), values = {};
	        if (nPathSegments !== match.length - 1)
	            throw new Error("Unbalanced capture group in route '" + this.pattern + "'");
	        function decodePathArray(string) {
	            var reverseString = function (str) { return str.split("").reverse().join(""); };
	            var unquoteDashes = function (str) { return str.replace(/\\-/g, "-"); };
	            var split = reverseString(string).split(/-(?!\\)/);
	            var allReversed = common_1.map(split, reverseString);
	            return common_1.map(allReversed, unquoteDashes).reverse();
	        }
	        for (var i = 0; i < nPathSegments; i++) {
	            var param = pathParams[i];
	            var value = match[i + 1];
	            // if the param value matches a pre-replace pair, replace the value before decoding.
	            for (var j = 0; j < param.replace.length; j++) {
	                if (param.replace[j].from === value)
	                    value = param.replace[j].to;
	            }
	            if (value && param.array === true)
	                value = decodePathArray(value);
	            if (predicates_1.isDefined(value))
	                value = param.type.decode(value);
	            values[param.id] = param.value(value);
	        }
	        searchParams.forEach(function (param) {
	            var value = search[param.id];
	            for (var j = 0; j < param.replace.length; j++) {
	                if (param.replace[j].from === value)
	                    value = param.replace[j].to;
	            }
	            if (predicates_1.isDefined(value))
	                value = param.type.decode(value);
	            values[param.id] = param.value(value);
	        });
	        if (hash)
	            values["#"] = hash;
	        return values;
	    };
	    /**
	     * @hidden
	     * Returns all the [[Param]] objects of all path and search parameters of this pattern in order of appearance.
	     *
	     * @returns {Array.<Param>}  An array of [[Param]] objects. Must be treated as read-only. If the
	     *    pattern has no parameters, an empty array is returned.
	     */
	    UrlMatcher.prototype.parameters = function (opts) {
	        if (opts === void 0) { opts = {}; }
	        if (opts.inherit === false)
	            return this._params;
	        return common_1.unnest(this._cache.path.map(hof_1.prop('_params')));
	    };
	    /**
	     * @hidden
	     * Returns a single parameter from this UrlMatcher by id
	     *
	     * @param id
	     * @param opts
	     * @returns {T|Param|any|boolean|UrlMatcher|null}
	     */
	    UrlMatcher.prototype.parameter = function (id, opts) {
	        if (opts === void 0) { opts = {}; }
	        var parent = this._cache.parent;
	        return (common_1.find(this._params, hof_1.propEq('id', id)) ||
	            (opts.inherit !== false && parent && parent.parameter(id, opts)) ||
	            null);
	    };
	    /**
	     * Validates the input parameter values against this UrlMatcher
	     *
	     * Checks an object hash of parameters to validate their correctness according to the parameter
	     * types of this `UrlMatcher`.
	     *
	     * @param params The object hash of parameters to validate.
	     * @returns Returns `true` if `params` validates, otherwise `false`.
	     */
	    UrlMatcher.prototype.validates = function (params) {
	        var _this = this;
	        var validParamVal = function (param, val) {
	            return !param || param.validates(val);
	        };
	        return common_1.pairs(params || {}).map(function (_a) {
	            var key = _a[0], val = _a[1];
	            return validParamVal(_this.parameter(key), val);
	        }).reduce(common_1.allTrueR, true);
	    };
	    /**
	     * Given a set of parameter values, creates a URL from this UrlMatcher.
	     *
	     * Creates a URL that matches this pattern by substituting the specified values
	     * for the path and search parameters.
	     *
	     * #### Example:
	     * ```js
	     * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
	     * // returns '/user/bob?q=yes'
	     * ```
	     *
	     * @param values  the values to substitute for the parameters in this pattern.
	     * @returns the formatted URL (path and optionally search part).
	     */
	    UrlMatcher.prototype.format = function (values) {
	        if (values === void 0) { values = {}; }
	        if (!this.validates(values))
	            return null;
	        // Build the full path of UrlMatchers (including all parent UrlMatchers)
	        var urlMatchers = this._cache.path;
	        // Extract all the static segments and Params into an ordered array
	        var pathSegmentsAndParams = urlMatchers.map(UrlMatcher.pathSegmentsAndParams).reduce(common_1.unnestR, []);
	        // Extract the query params into a separate array
	        var queryParams = urlMatchers.map(UrlMatcher.queryParams).reduce(common_1.unnestR, []);
	        /**
	         * Given a Param,
	         * Applies the parameter value, then returns details about it
	         */
	        function getDetails(param) {
	            // Normalize to typed value
	            var value = param.value(values[param.id]);
	            var isDefaultValue = param.isDefaultValue(value);
	            // Check if we're in squash mode for the parameter
	            var squash = isDefaultValue ? param.squash : false;
	            // Allow the Parameter's Type to encode the value
	            var encoded = param.type.encode(value);
	            return { param: param, value: value, isDefaultValue: isDefaultValue, squash: squash, encoded: encoded };
	        }
	        // Build up the path-portion from the list of static segments and parameters
	        var pathString = pathSegmentsAndParams.reduce(function (acc, x) {
	            // The element is a static segment (a raw string); just append it
	            if (predicates_1.isString(x))
	                return acc + x;
	            // Otherwise, it's a Param.  Fetch details about the parameter value
	            var _a = getDetails(x), squash = _a.squash, encoded = _a.encoded, param = _a.param;
	            // If squash is === true, try to remove a slash from the path
	            if (squash === true)
	                return (acc.match(/\/$/)) ? acc.slice(0, -1) : acc;
	            // If squash is a string, use the string for the param value
	            if (predicates_1.isString(squash))
	                return acc + squash;
	            if (squash !== false)
	                return acc; // ?
	            if (encoded == null)
	                return acc;
	            // If this parameter value is an array, encode the value using encodeDashes
	            if (predicates_1.isArray(encoded))
	                return acc + common_1.map(encoded, UrlMatcher.encodeDashes).join("-");
	            // If the parameter type is "raw", then do not encodeURIComponent
	            if (param.raw)
	                return acc + encoded;
	            // Encode the value
	            return acc + encodeURIComponent(encoded);
	        }, "");
	        // Build the query string by applying parameter values (array or regular)
	        // then mapping to key=value, then flattening and joining using "&"
	        var queryString = queryParams.map(function (param) {
	            var _a = getDetails(param), squash = _a.squash, encoded = _a.encoded, isDefaultValue = _a.isDefaultValue;
	            if (encoded == null || (isDefaultValue && squash !== false))
	                return;
	            if (!predicates_1.isArray(encoded))
	                encoded = [encoded];
	            if (encoded.length === 0)
	                return;
	            if (!param.raw)
	                encoded = common_1.map(encoded, encodeURIComponent);
	            return encoded.map(function (val) { return param.id + "=" + val; });
	        }).filter(common_1.identity).reduce(common_1.unnestR, []).join("&");
	        // Concat the pathstring with the queryString (if exists) and the hashString (if exists)
	        return pathString + (queryString ? "?" + queryString : "") + (values["#"] ? "#" + values["#"] : "");
	    };
	    /** @hidden */
	    UrlMatcher.encodeDashes = function (str) {
	        return encodeURIComponent(str).replace(/-/g, function (c) { return "%5C%" + c.charCodeAt(0).toString(16).toUpperCase(); });
	    };
	    /** @hidden Given a matcher, return an array with the matcher's path segments and path params, in order */
	    UrlMatcher.pathSegmentsAndParams = function (matcher) {
	        var staticSegments = matcher._segments;
	        var pathParams = matcher._params.filter(function (p) { return p.location === param_1.DefType.PATH; });
	        return common_1.arrayTuples(staticSegments, pathParams.concat(undefined))
	            .reduce(common_1.unnestR, [])
	            .filter(function (x) { return x !== "" && predicates_1.isDefined(x); });
	    };
	    /** @hidden Given a matcher, return an array with the matcher's query params */
	    UrlMatcher.queryParams = function (matcher) {
	        return matcher._params.filter(function (p) { return p.location === param_1.DefType.SEARCH; });
	    };
	    /**
	     * Compare two UrlMatchers
	     *
	     * This comparison function converts a UrlMatcher into static and dynamic path segments.
	     * Each static path segment is a static string between a path separator (slash character).
	     * Each dynamic segment is a path parameter.
	     *
	     * The comparison function sorts static segments before dynamic ones.
	     */
	    UrlMatcher.compare = function (a, b) {
	        var splitOnSlash = strings_1.splitOnDelim('/');
	        /**
	         * Turn a UrlMatcher and all its parent matchers into an array
	         * of slash literals '/', string literals, and Param objects
	         *
	         * This example matcher matches strings like "/foo/:param/tail":
	         * var matcher = $umf.compile("/foo").append($umf.compile("/:param")).append($umf.compile("/")).append($umf.compile("tail"));
	         * var result = segments(matcher); // [ '/', 'foo', '/', Param, '/', 'tail' ]
	         *
	         */
	        var segments = function (matcher) {
	            return matcher._cache.path.map(UrlMatcher.pathSegmentsAndParams)
	                .reduce(common_1.unnestR, [])
	                .reduce(strings_1.joinNeighborsR, [])
	                .map(function (x) { return predicates_1.isString(x) ? splitOnSlash(x) : x; })
	                .reduce(common_1.unnestR, []);
	        };
	        var aSegments = segments(a), bSegments = segments(b);
	        // console.table( { aSegments, bSegments });
	        // Sort slashes first, then static strings, the Params
	        var weight = hof_1.pattern([
	            [hof_1.eq("/"), hof_1.val(1)],
	            [predicates_1.isString, hof_1.val(2)],
	            [hof_1.is(param_1.Param), hof_1.val(3)]
	        ]);
	        var pairs = common_1.arrayTuples(aSegments.map(weight), bSegments.map(weight));
	        // console.table(pairs);
	        return pairs.reduce(function (cmp, weightPair) { return cmp !== 0 ? cmp : weightPair[0] - weightPair[1]; }, 0);
	    };
	    return UrlMatcher;
	}());
	/** @hidden */
	UrlMatcher.nameValidator = /^\w+([-.]+\w+)*(?:\[\])?$/;
	exports.UrlMatcher = UrlMatcher;
	//# sourceMappingURL=urlMatcher.js.map

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @coreapi
	 * @module params
	 */ /** for typedoc */
	var common_1 = __webpack_require__(305);
	var predicates_1 = __webpack_require__(306);
	var hof_1 = __webpack_require__(307);
	var coreservices_1 = __webpack_require__(308);
	var paramType_1 = __webpack_require__(322);
	/**
	 * A registry for parameter types.
	 *
	 * This registry manages the built-in (and custom) parameter types.
	 *
	 * The built-in parameter types are:
	 *
	 * - [[string]]
	 * - [[path]]
	 * - [[query]]
	 * - [[hash]]
	 * - [[int]]
	 * - [[bool]]
	 * - [[date]]
	 * - [[json]]
	 * - [[any]]
	 */
	var ParamTypes = (function () {
	    /** @internalapi */
	    function ParamTypes() {
	        /** @hidden */
	        this.enqueue = true;
	        /** @hidden */
	        this.typeQueue = [];
	        /** @internalapi */
	        this.defaultTypes = common_1.pick(ParamTypes.prototype, "hash", "string", "query", "path", "int", "bool", "date", "json", "any");
	        // Register default types. Store them in the prototype of this.types.
	        var makeType = function (definition, name) {
	            return new paramType_1.ParamType(common_1.extend({ name: name }, definition));
	        };
	        this.types = common_1.inherit(common_1.map(this.defaultTypes, makeType), {});
	    }
	    /** @internalapi */
	    ParamTypes.prototype.dispose = function () {
	        this.types = {};
	    };
	    /**
	     * Registers a parameter type
	     *
	     * End users should call [[UrlMatcherFactory.type]], which delegates to this method.
	     */
	    ParamTypes.prototype.type = function (name, definition, definitionFn) {
	        if (!predicates_1.isDefined(definition))
	            return this.types[name];
	        if (this.types.hasOwnProperty(name))
	            throw new Error("A type named '" + name + "' has already been defined.");
	        this.types[name] = new paramType_1.ParamType(common_1.extend({ name: name }, definition));
	        if (definitionFn) {
	            this.typeQueue.push({ name: name, def: definitionFn });
	            if (!this.enqueue)
	                this._flushTypeQueue();
	        }
	        return this;
	    };
	    /** @internalapi */
	    ParamTypes.prototype._flushTypeQueue = function () {
	        while (this.typeQueue.length) {
	            var type = this.typeQueue.shift();
	            if (type.pattern)
	                throw new Error("You cannot override a type's .pattern at runtime.");
	            common_1.extend(this.types[type.name], coreservices_1.services.$injector.invoke(type.def));
	        }
	    };
	    return ParamTypes;
	}());
	exports.ParamTypes = ParamTypes;
	/** @hidden */
	function initDefaultTypes() {
	    var makeDefaultType = function (def) {
	        var valToString = function (val) {
	            return val != null ? val.toString() : val;
	        };
	        var defaultTypeBase = {
	            encode: valToString,
	            decode: valToString,
	            is: hof_1.is(String),
	            pattern: /.*/,
	            equals: function (a, b) { return a == b; },
	        };
	        return common_1.extend({}, defaultTypeBase, def);
	    };
	    // Default Parameter Type Definitions
	    common_1.extend(ParamTypes.prototype, {
	        string: makeDefaultType({}),
	        path: makeDefaultType({
	            pattern: /[^/]*/,
	        }),
	        query: makeDefaultType({}),
	        hash: makeDefaultType({
	            inherit: false,
	        }),
	        int: makeDefaultType({
	            decode: function (val) { return parseInt(val, 10); },
	            is: function (val) {
	                return !predicates_1.isNullOrUndefined(val) && this.decode(val.toString()) === val;
	            },
	            pattern: /-?\d+/,
	        }),
	        bool: makeDefaultType({
	            encode: function (val) { return val && 1 || 0; },
	            decode: function (val) { return parseInt(val, 10) !== 0; },
	            is: hof_1.is(Boolean),
	            pattern: /0|1/
	        }),
	        date: makeDefaultType({
	            encode: function (val) {
	                return !this.is(val) ? undefined : [
	                    val.getFullYear(),
	                    ('0' + (val.getMonth() + 1)).slice(-2),
	                    ('0' + val.getDate()).slice(-2)
	                ].join("-");
	            },
	            decode: function (val) {
	                if (this.is(val))
	                    return val;
	                var match = this.capture.exec(val);
	                return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
	            },
	            is: function (val) { return val instanceof Date && !isNaN(val.valueOf()); },
	            equals: function (l, r) {
	                return ['getFullYear', 'getMonth', 'getDate']
	                    .reduce(function (acc, fn) { return acc && l[fn]() === r[fn](); }, true);
	            },
	            pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
	            capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
	        }),
	        json: makeDefaultType({
	            encode: common_1.toJson,
	            decode: common_1.fromJson,
	            is: hof_1.is(Object),
	            equals: common_1.equals,
	            pattern: /[^/]*/
	        }),
	        // does not encode/decode
	        any: makeDefaultType({
	            encode: common_1.identity,
	            decode: common_1.identity,
	            is: function () { return true; },
	            equals: common_1.equals,
	        }),
	    });
	}
	initDefaultTypes();
	//# sourceMappingURL=paramTypes.js.map

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @internalapi
	 * @module url
	 */
	/** for typedoc */
	var common_1 = __webpack_require__(305);
	var predicates_1 = __webpack_require__(306);
	var urlMatcher_1 = __webpack_require__(329);
	var hof_1 = __webpack_require__(307);
	var urlRule_1 = __webpack_require__(332);
	var targetState_1 = __webpack_require__(317);
	/** @hidden */
	function appendBasePath(url, isHtml5, absolute, baseHref) {
	    if (baseHref === '/')
	        return url;
	    if (isHtml5)
	        return baseHref.slice(0, -1) + url;
	    if (absolute)
	        return baseHref.slice(1) + url;
	    return url;
	}
	/** @hidden */
	var getMatcher = hof_1.prop("urlMatcher");
	/**
	 * Default rule priority sorting function.
	 *
	 * Sorts rules by:
	 *
	 * - Explicit priority (set rule priority using [[UrlService.when]])
	 * - Rule type (STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1)
	 * - `UrlMatcher` specificity ([[UrlMatcher.compare]]): works for STATE and URLMATCHER types to pick the most specific rule.
	 * - Registration order (for rule types other than STATE and URLMATCHER)
	 *
	 * @coreapi
	 */
	var defaultRuleSortFn;
	defaultRuleSortFn = common_1.composeSort(common_1.sortBy(hof_1.pipe(hof_1.prop("priority"), function (x) { return -x; })), common_1.sortBy(hof_1.pipe(hof_1.prop("type"), function (type) { return ({ "STATE": 4, "URLMATCHER": 4, "REGEXP": 3, "RAW": 2, "OTHER": 1 })[type]; })), function (a, b) { return (getMatcher(a) && getMatcher(b)) ? urlMatcher_1.UrlMatcher.compare(getMatcher(a), getMatcher(b)) : 0; }, common_1.sortBy(hof_1.prop("$id"), common_1.inArray(["REGEXP", "RAW", "OTHER"])));
	/**
	 * Updates URL and responds to URL changes
	 *
	 * This class updates the URL when the state changes.
	 * It also responds to changes in the URL.
	 */
	var UrlRouter = (function () {
	    /** @hidden */
	    function UrlRouter(router) {
	        /** @hidden */ this._sortFn = defaultRuleSortFn;
	        /** @hidden */ this._rules = [];
	        /** @hidden */ this.interceptDeferred = false;
	        /** @hidden */ this._id = 0;
	        this._router = router;
	        this.urlRuleFactory = new urlRule_1.UrlRuleFactory(router);
	        common_1.createProxyFunctions(hof_1.val(UrlRouter.prototype), this, hof_1.val(this));
	    }
	    /** @internalapi */
	    UrlRouter.prototype.dispose = function () {
	        this.listen(false);
	        this._rules = [];
	        delete this._otherwiseFn;
	    };
	    /** @inheritdoc */
	    UrlRouter.prototype.sort = function (compareFn) {
	        this._rules.sort(this._sortFn = compareFn || this._sortFn);
	    };
	    /**
	     * Given a URL, check all rules and return the best [[MatchResult]]
	     * @param url
	     * @returns {MatchResult}
	     */
	    UrlRouter.prototype.match = function (url) {
	        var _this = this;
	        url = common_1.extend({ path: '', search: {}, hash: '' }, url);
	        var rules = this.rules();
	        if (this._otherwiseFn)
	            rules.push(this._otherwiseFn);
	        // Checks a single rule. Returns { rule: rule, match: match, weight: weight } if it matched, or undefined
	        var checkRule = function (rule) {
	            var match = rule.match(url, _this._router);
	            return match && { match: match, rule: rule, weight: rule.matchPriority(match) };
	        };
	        // The rules are pre-sorted.
	        // - Find the first matching rule.
	        // - Find any other matching rule that sorted *exactly the same*, according to `.sort()`.
	        // - Choose the rule with the highest match weight.
	        var best;
	        for (var i = 0; i < rules.length; i++) {
	            // Stop when there is a 'best' rule and the next rule sorts differently than it.
	            if (best && this._sortFn(rules[i], best.rule) !== 0)
	                break;
	            var current = checkRule(rules[i]);
	            // Pick the best MatchResult
	            best = (!best || current && current.weight > best.weight) ? current : best;
	        }
	        return best;
	    };
	    /** @inheritdoc */
	    UrlRouter.prototype.sync = function (evt) {
	        if (evt && evt.defaultPrevented)
	            return;
	        var router = this._router, $url = router.urlService, $state = router.stateService;
	        var url = {
	            path: $url.path(), search: $url.search(), hash: $url.hash()
	        };
	        var best = this.match(url);
	        var applyResult = hof_1.pattern([
	            [predicates_1.isString, function (newurl) { return $url.url(newurl); }],
	            [targetState_1.TargetState.isDef, function (def) { return $state.go(def.state, def.params, def.options); }],
	            [hof_1.is(targetState_1.TargetState), function (target) { return $state.go(target.state(), target.params(), target.options()); }],
	        ]);
	        applyResult(best && best.rule.handler(best.match, url, router));
	    };
	    /** @inheritdoc */
	    UrlRouter.prototype.listen = function (enabled) {
	        var _this = this;
	        if (enabled === false) {
	            this._stopFn && this._stopFn();
	            delete this._stopFn;
	        }
	        else {
	            return this._stopFn = this._stopFn || this._router.urlService.onChange(function (evt) { return _this.sync(evt); });
	        }
	    };
	    /**
	     * Internal API.
	     * @internalapi
	     */
	    UrlRouter.prototype.update = function (read) {
	        var $url = this._router.locationService;
	        if (read) {
	            this.location = $url.path();
	            return;
	        }
	        if ($url.path() === this.location)
	            return;
	        $url.url(this.location, true);
	    };
	    /**
	     * Internal API.
	     *
	     * Pushes a new location to the browser history.
	     *
	     * @internalapi
	     * @param urlMatcher
	     * @param params
	     * @param options
	     */
	    UrlRouter.prototype.push = function (urlMatcher, params, options) {
	        var replace = options && !!options.replace;
	        this._router.urlService.url(urlMatcher.format(params || {}), replace);
	    };
	    /**
	     * Builds and returns a URL with interpolated parameters
	     *
	     * #### Example:
	     * ```js
	     * matcher = $umf.compile("/about/:person");
	     * params = { person: "bob" };
	     * $bob = $urlRouter.href(matcher, params);
	     * // $bob == "/about/bob";
	     * ```
	     *
	     * @param urlMatcher The [[UrlMatcher]] object which is used as the template of the URL to generate.
	     * @param params An object of parameter values to fill the matcher's required parameters.
	     * @param options Options object. The options are:
	     *
	     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	     *
	     * @returns Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
	     */
	    UrlRouter.prototype.href = function (urlMatcher, params, options) {
	        if (!urlMatcher.validates(params))
	            return null;
	        var url = urlMatcher.format(params);
	        options = options || { absolute: false };
	        var cfg = this._router.urlService.config;
	        var isHtml5 = cfg.html5Mode();
	        if (!isHtml5 && url !== null) {
	            url = "#" + cfg.hashPrefix() + url;
	        }
	        url = appendBasePath(url, isHtml5, options.absolute, cfg.baseHref());
	        if (!options.absolute || !url) {
	            return url;
	        }
	        var slash = (!isHtml5 && url ? '/' : ''), port = cfg.port();
	        port = (port === 80 || port === 443 ? '' : ':' + port);
	        return [cfg.protocol(), '://', cfg.host(), port, slash, url].join('');
	    };
	    /**
	     * Manually adds a URL Rule.
	     *
	     * Usually, a url rule is added using [[StateDeclaration.url]] or [[when]].
	     * This api can be used directly for more control (to register [[RawUrlRule]], for example).
	     * Rules can be created using [[UrlRouter.ruleFactory]], or create manually as simple objects.
	     *
	     * @return a function that deregisters the rule
	     */
	    UrlRouter.prototype.rule = function (rule) {
	        var _this = this;
	        if (!urlRule_1.UrlRuleFactory.isUrlRule(rule))
	            throw new Error("invalid rule");
	        rule.$id = this._id++;
	        rule.priority = rule.priority || 0;
	        this._rules.push(rule);
	        this.sort();
	        return function () { return _this.removeRule(rule); };
	    };
	    /** @inheritdoc */
	    UrlRouter.prototype.removeRule = function (rule) {
	        common_1.removeFrom(this._rules, rule);
	        this.sort();
	    };
	    /** @inheritdoc */
	    UrlRouter.prototype.rules = function () { return this._rules.slice(); };
	    /** @inheritdoc */
	    UrlRouter.prototype.otherwise = function (handler) {
	        if (!predicates_1.isFunction(handler) && !predicates_1.isString(handler) && !hof_1.is(targetState_1.TargetState)(handler) && !targetState_1.TargetState.isDef(handler)) {
	            throw new Error("'redirectTo' must be a string, function, TargetState, or have a state: 'newtarget' property");
	        }
	        var handlerFn = predicates_1.isFunction(handler) ? handler : hof_1.val(handler);
	        this._otherwiseFn = this.urlRuleFactory.create(hof_1.val(true), handlerFn);
	        this.sort();
	    };
	    ;
	    /** @inheritdoc */
	    UrlRouter.prototype.when = function (matcher, handler, options) {
	        var rule = this.urlRuleFactory.create(matcher, handler);
	        if (predicates_1.isDefined(options && options.priority))
	            rule.priority = options.priority;
	        this.rule(rule);
	        return rule;
	    };
	    ;
	    /** @inheritdoc */
	    UrlRouter.prototype.deferIntercept = function (defer) {
	        if (defer === undefined)
	            defer = true;
	        this.interceptDeferred = defer;
	    };
	    ;
	    return UrlRouter;
	}());
	exports.UrlRouter = UrlRouter;
	//# sourceMappingURL=urlRouter.js.map

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @coreapi
	 * @module url
	 */ /** */
	var urlMatcher_1 = __webpack_require__(329);
	var predicates_1 = __webpack_require__(306);
	var common_1 = __webpack_require__(305);
	var hof_1 = __webpack_require__(307);
	var stateObject_1 = __webpack_require__(333);
	/**
	 * Creates a [[UrlRule]]
	 *
	 * Creates a [[UrlRule]] from a:
	 *
	 * - `string`
	 * - [[UrlMatcher]]
	 * - `RegExp`
	 * - [[State]]
	 * @internalapi
	 */
	var UrlRuleFactory = (function () {
	    function UrlRuleFactory(router) {
	        this.router = router;
	    }
	    UrlRuleFactory.prototype.compile = function (str) {
	        return this.router.urlMatcherFactory.compile(str);
	    };
	    UrlRuleFactory.prototype.create = function (what, handler) {
	        var _this = this;
	        var makeRule = hof_1.pattern([
	            [predicates_1.isString, function (_what) { return makeRule(_this.compile(_what)); }],
	            [hof_1.is(urlMatcher_1.UrlMatcher), function (_what) { return _this.fromUrlMatcher(_what, handler); }],
	            [hof_1.is(stateObject_1.State), function (_what) { return _this.fromState(_what, _this.router); }],
	            [hof_1.is(RegExp), function (_what) { return _this.fromRegExp(_what, handler); }],
	            [predicates_1.isFunction, function (_what) { return new BaseUrlRule(_what, handler); }],
	        ]);
	        var rule = makeRule(what);
	        if (!rule)
	            throw new Error("invalid 'what' in when()");
	        return rule;
	    };
	    /**
	     * A UrlRule which matches based on a UrlMatcher
	     *
	     * The `handler` may be either a `string`, a [[UrlRuleHandlerFn]] or another [[UrlMatcher]]
	     *
	     * ## Handler as a function
	     *
	     * If `handler` is a function, the function is invoked with:
	     *
	     * - matched parameter values ([[RawParams]] from [[UrlMatcher.exec]])
	     * - url: the current Url ([[UrlParts]])
	     * - router: the router object ([[UIRouter]])
	     *
	     * #### Example:
	     * ```js
	     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
	     * var rule = factory.fromUrlMatcher(urlMatcher, match => "/home/" + match.fooId + "/" + match.barId);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match); // '/home/123/456'
	     * ```
	     *
	     * ## Handler as UrlMatcher
	     *
	     * If `handler` is a UrlMatcher, the handler matcher is used to create the new url.
	     * The `handler` UrlMatcher is formatted using the matched param from the first matcher.
	     * The url is replaced with the result.
	     *
	     * #### Example:
	     * ```js
	     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
	     * var handler = $umf.compile("/home/:fooId/:barId");
	     * var rule = factory.fromUrlMatcher(urlMatcher, handler);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match); // '/home/123/456'
	     * ```
	     */
	    UrlRuleFactory.prototype.fromUrlMatcher = function (urlMatcher, handler) {
	        var _handler = handler;
	        if (predicates_1.isString(handler))
	            handler = this.router.urlMatcherFactory.compile(handler);
	        if (hof_1.is(urlMatcher_1.UrlMatcher)(handler))
	            _handler = function (match) { return handler.format(match); };
	        function match(url) {
	            var match = urlMatcher.exec(url.path, url.search, url.hash);
	            return urlMatcher.validates(match) && match;
	        }
	        // Prioritize URLs, lowest to highest:
	        // - Some optional URL parameters, but none matched
	        // - No optional parameters in URL
	        // - Some optional parameters, some matched
	        // - Some optional parameters, all matched
	        function matchPriority(params) {
	            var optional = urlMatcher.parameters().filter(function (param) { return param.isOptional; });
	            if (!optional.length)
	                return 0.000001;
	            var matched = optional.filter(function (param) { return params[param.id]; });
	            return matched.length / optional.length;
	        }
	        var details = { urlMatcher: urlMatcher, matchPriority: matchPriority, type: "URLMATCHER" };
	        return common_1.extend(new BaseUrlRule(match, _handler), details);
	    };
	    /**
	     * A UrlRule which matches a state by its url
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromState($state.get('foo'), router);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match);
	     * // Starts a transition to 'foo' with params: { fooId: '123', barId: '456' }
	     * ```
	     */
	    UrlRuleFactory.prototype.fromState = function (state, router) {
	        /**
	         * Handles match by transitioning to matched state
	         *
	         * First checks if the router should start a new transition.
	         * A new transition is not required if the current state's URL
	         * and the new URL are already identical
	         */
	        var handler = function (match) {
	            var $state = router.stateService;
	            var globals = router.globals;
	            if ($state.href(state, match) !== $state.href(globals.current, globals.params)) {
	                $state.transitionTo(state, match, { inherit: true, source: "url" });
	            }
	        };
	        var details = { state: state, type: "STATE" };
	        return common_1.extend(this.fromUrlMatcher(state.url, handler), details);
	    };
	    /**
	     * A UrlRule which matches based on a regular expression
	     *
	     * The `handler` may be either a [[UrlRuleHandlerFn]] or a string.
	     *
	     * ## Handler as a function
	     *
	     * If `handler` is a function, the function is invoked with:
	     *
	     * - regexp match array (from `regexp`)
	     * - url: the current Url ([[UrlParts]])
	     * - router: the router object ([[UIRouter]])
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, match => "/home/" + match[1])
	     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
	     * var result = rule.handler(match); // '/home/bar'
	     * ```
	     *
	     * ## Handler as string
	     *
	     * If `handler` is a string, the url is *replaced by the string* when the Rule is invoked.
	     * The string is first interpolated using `string.replace()` style pattern.
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, "/home/$1")
	     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
	     * var result = rule.handler(match); // '/home/bar'
	     * ```
	     */
	    UrlRuleFactory.prototype.fromRegExp = function (regexp, handler) {
	        if (regexp.global || regexp.sticky)
	            throw new Error("Rule RegExp must not be global or sticky");
	        /**
	         * If handler is a string, the url will be replaced by the string.
	         * If the string has any String.replace() style variables in it (like `$2`),
	         * they will be replaced by the captures from [[match]]
	         */
	        var redirectUrlTo = function (match) {
	            // Interpolates matched values into $1 $2, etc using a String.replace()-style pattern
	            return handler.replace(/\$(\$|\d{1,2})/, function (m, what) {
	                return match[what === '$' ? 0 : Number(what)];
	            });
	        };
	        var _handler = predicates_1.isString(handler) ? redirectUrlTo : handler;
	        var match = function (url) {
	            return regexp.exec(url.path);
	        };
	        var details = { regexp: regexp, type: "REGEXP" };
	        return common_1.extend(new BaseUrlRule(match, _handler), details);
	    };
	    return UrlRuleFactory;
	}());
	UrlRuleFactory.isUrlRule = function (obj) {
	    return obj && ['type', 'match', 'handler'].every(function (key) { return predicates_1.isDefined(obj[key]); });
	};
	exports.UrlRuleFactory = UrlRuleFactory;
	/**
	 * A base rule which calls `match`
	 *
	 * The value from the `match` function is passed through to the `handler`.
	 * @internalapi
	 */
	var BaseUrlRule = (function () {
	    function BaseUrlRule(match, handler) {
	        var _this = this;
	        this.match = match;
	        this.type = "RAW";
	        this.matchPriority = function (match) { return 0 - _this.$id; };
	        this.handler = handler || common_1.identity;
	    }
	    return BaseUrlRule;
	}());
	exports.BaseUrlRule = BaseUrlRule;
	//# sourceMappingURL=urlRule.js.map

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @coreapi
	 * @module state
	 */ /** for typedoc */
	"use strict";
	var common_1 = __webpack_require__(305);
	var hof_1 = __webpack_require__(307);
	/**
	 * Internal representation of a UI-Router state.
	 *
	 * Instances of this class are created when a [[StateDeclaration]] is registered with the [[StateRegistry]].
	 *
	 * A registered [[StateDeclaration]] is augmented with a getter ([[StateDeclaration.$$state]]) which returns the corresponding [[State]] object.
	 *
	 * This class prototypally inherits from the corresponding [[StateDeclaration]].
	 * Each of its own properties (i.e., `hasOwnProperty`) are built using builders from the [[StateBuilder]].
	 */
	var State = (function () {
	    function State(config) {
	        common_1.extend(this, config);
	        // Object.freeze(this);
	    }
	    /**
	     * Returns true if the provided parameter is the same state.
	     *
	     * Compares the identity of the state against the passed value, which is either an object
	     * reference to the actual `State` instance, the original definition object passed to
	     * `$stateProvider.state()`, or the fully-qualified name.
	     *
	     * @param ref Can be one of (a) a `State` instance, (b) an object that was passed
	     *        into `$stateProvider.state()`, (c) the fully-qualified name of a state as a string.
	     * @returns Returns `true` if `ref` matches the current `State` instance.
	     */
	    State.prototype.is = function (ref) {
	        return this === ref || this.self === ref || this.fqn() === ref;
	    };
	    /**
	     * @deprecated this does not properly handle dot notation
	     * @returns Returns a dot-separated name of the state.
	     */
	    State.prototype.fqn = function () {
	        if (!this.parent || !(this.parent instanceof this.constructor))
	            return this.name;
	        var name = this.parent.fqn();
	        return name ? name + "." + this.name : this.name;
	    };
	    /**
	     * Returns the root node of this state's tree.
	     *
	     * @returns The root of this state's tree.
	     */
	    State.prototype.root = function () {
	        return this.parent && this.parent.root() || this;
	    };
	    /**
	     * Gets the state's `Param`eters
	     *
	     * Gets [[Param]] information that is owned by the state.
	     * If `opts.inherit` is true, it also includes the ancestor states' [[Param]] information.
	     * If `opts.matchingKeys` exists, returns only `Param`s whose `id` is a key on the `matchingKeys` object
	     *
	     * @param opts options
	     */
	    State.prototype.parameters = function (opts) {
	        opts = common_1.defaults(opts, { inherit: true, matchingKeys: null });
	        var inherited = opts.inherit && this.parent && this.parent.parameters() || [];
	        return inherited.concat(common_1.values(this.params))
	            .filter(function (param) { return !opts.matchingKeys || opts.matchingKeys.hasOwnProperty(param.id); });
	    };
	    /**
	     * Returns a single [[Param]] that is owned by the state
	     *
	     * If `opts.inherit` is true, it also searches the ancestor states` [[Param]] information.
	     * @param id the name of the [[Param]] to return
	     * @param opts options
	     */
	    State.prototype.parameter = function (id, opts) {
	        if (opts === void 0) { opts = {}; }
	        return (this.url && this.url.parameter(id, opts) ||
	            common_1.find(common_1.values(this.params), hof_1.propEq('id', id)) ||
	            opts.inherit && this.parent && this.parent.parameter(id));
	    };
	    State.prototype.toString = function () {
	        return this.fqn();
	    };
	    return State;
	}());
	exports.State = State;
	//# sourceMappingURL=stateObject.js.map

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @coreapi
	 * @module transition
	 */ /** for typedoc */
	var interface_1 = __webpack_require__(315);
	var transition_1 = __webpack_require__(313);
	var hookRegistry_1 = __webpack_require__(318);
	var resolve_1 = __webpack_require__(335);
	var views_1 = __webpack_require__(336);
	var url_1 = __webpack_require__(337);
	var redirectTo_1 = __webpack_require__(338);
	var onEnterExitRetain_1 = __webpack_require__(339);
	var lazyLoad_1 = __webpack_require__(340);
	var transitionEventType_1 = __webpack_require__(341);
	var transitionHook_1 = __webpack_require__(316);
	var predicates_1 = __webpack_require__(306);
	var common_1 = __webpack_require__(305);
	var hof_1 = __webpack_require__(307);
	/**
	 * The default [[Transition]] options.
	 *
	 * Include this object when applying custom defaults:
	 * let reloadOpts = { reload: true, notify: true }
	 * let options = defaults(theirOpts, customDefaults, defaultOptions);
	 */
	exports.defaultTransOpts = {
	    location: true,
	    relative: null,
	    inherit: false,
	    notify: true,
	    reload: false,
	    custom: {},
	    current: function () { return null; },
	    source: "unknown"
	};
	/**
	 * This class provides services related to Transitions.
	 *
	 * - Most importantly, it allows global Transition Hooks to be registered.
	 * - It allows the default transition error handler to be set.
	 * - It also has a factory function for creating new [[Transition]] objects, (used internally by the [[StateService]]).
	 *
	 * At bootstrap, [[UIRouter]] creates a single instance (singleton) of this class.
	 */
	var TransitionService = (function () {
	    /** @hidden */
	    function TransitionService(_router) {
	        this._router = _router;
	        /** @hidden */
	        this._transitionCount = 0;
	        /** @hidden The transition hook types, such as `onEnter`, `onStart`, etc */
	        this._eventTypes = [];
	        /** @hidden The registered transition hooks */
	        this._registeredHooks = {};
	        /** @hidden The  paths on a criteria object */
	        this._criteriaPaths = {};
	        this.$view = _router.viewService;
	        this._deregisterHookFns = {};
	        this._pluginapi = common_1.createProxyFunctions(hof_1.val(this), {}, hof_1.val(this), [
	            '_definePathType',
	            '_defineEvent',
	            '_getPathTypes',
	            '_getEvents',
	            'getHooks',
	        ]);
	        this._defineDefaultPaths();
	        this._defineDefaultEvents();
	        this._registerDefaultTransitionHooks();
	    }
	    /**
	     * Registers a [[TransitionHookFn]], called *while a transition is being constructed*.
	     *
	     * Registers a transition lifecycle hook, which is invoked during transition construction.
	     *
	     * This low level hook should only be used by plugins.
	     * This can be a useful time for plugins to add resolves or mutate the transition as needed.
	     * The Sticky States plugin uses this hook to modify the treechanges.
	     *
	     * ### Lifecycle
	     *
	     * `onCreate` hooks are invoked *while a transition is being constructed*.
	     *
	     * ### Return value
	     *
	     * The hook's return value is ignored
	     *
	     * @internalapi
	     * @param criteria defines which Transitions the Hook should be invoked for.
	     * @param callback the hook function which will be invoked.
	     * @param options the registration options
	     * @returns a function which deregisters the hook.
	     */
	    TransitionService.prototype.onCreate = function (criteria, callback, options) { return; };
	    /** @inheritdoc */
	    TransitionService.prototype.onBefore = function (criteria, callback, options) { return; };
	    /** @inheritdoc */
	    TransitionService.prototype.onStart = function (criteria, callback, options) { return; };
	    /** @inheritdoc */
	    TransitionService.prototype.onExit = function (criteria, callback, options) { return; };
	    /** @inheritdoc */
	    TransitionService.prototype.onRetain = function (criteria, callback, options) { return; };
	    /** @inheritdoc */
	    TransitionService.prototype.onEnter = function (criteria, callback, options) { return; };
	    /** @inheritdoc */
	    TransitionService.prototype.onFinish = function (criteria, callback, options) { return; };
	    /** @inheritdoc */
	    TransitionService.prototype.onSuccess = function (criteria, callback, options) { return; };
	    /** @inheritdoc */
	    TransitionService.prototype.onError = function (criteria, callback, options) { return; };
	    /** @internalapi */
	    TransitionService.prototype.dispose = function (router) {
	        delete router.globals.transition;
	        common_1.values(this._registeredHooks).forEach(function (hooksArray) { return hooksArray.forEach(function (hook) {
	            hook._deregistered = true;
	            common_1.removeFrom(hooksArray, hook);
	        }); });
	    };
	    /**
	     * Creates a new [[Transition]] object
	     *
	     * This is a factory function for creating new Transition objects.
	     * It is used internally by the [[StateService]] and should generally not be called by application code.
	     *
	     * @param fromPath the path to the current state (the from state)
	     * @param targetState the target state (destination)
	     * @returns a Transition
	     */
	    TransitionService.prototype.create = function (fromPath, targetState) {
	        return new transition_1.Transition(fromPath, targetState, this._router);
	    };
	    /** @hidden */
	    TransitionService.prototype._defineDefaultEvents = function () {
	        var Phase = interface_1.TransitionHookPhase;
	        var TH = transitionHook_1.TransitionHook;
	        var paths = this._criteriaPaths;
	        this._defineEvent("onCreate", Phase.CREATE, 0, paths.to, false, TH.IGNORE_RESULT, TH.THROW_ERROR, false);
	        this._defineEvent("onBefore", Phase.BEFORE, 0, paths.to, false, TH.HANDLE_RESULT);
	        this._defineEvent("onStart", Phase.ASYNC, 0, paths.to);
	        this._defineEvent("onExit", Phase.ASYNC, 100, paths.exiting, true);
	        this._defineEvent("onRetain", Phase.ASYNC, 200, paths.retained);
	        this._defineEvent("onEnter", Phase.ASYNC, 300, paths.entering);
	        this._defineEvent("onFinish", Phase.ASYNC, 400, paths.to);
	        this._defineEvent("onSuccess", Phase.SUCCESS, 0, paths.to, false, TH.IGNORE_RESULT, TH.LOG_ERROR, false);
	        this._defineEvent("onError", Phase.ERROR, 0, paths.to, false, TH.IGNORE_RESULT, TH.LOG_ERROR, false);
	    };
	    /** @hidden */
	    TransitionService.prototype._defineDefaultPaths = function () {
	        var STATE = interface_1.TransitionHookScope.STATE, TRANSITION = interface_1.TransitionHookScope.TRANSITION;
	        this._definePathType("to", TRANSITION);
	        this._definePathType("from", TRANSITION);
	        this._definePathType("exiting", STATE);
	        this._definePathType("retained", STATE);
	        this._definePathType("entering", STATE);
	    };
	    /**
	     * Defines a transition hook type and returns a transition hook registration
	     * function (which can then be used to register hooks of this type).
	     * @internalapi
	     */
	    TransitionService.prototype._defineEvent = function (name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, rejectIfSuperseded) {
	        if (reverseSort === void 0) { reverseSort = false; }
	        if (getResultHandler === void 0) { getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT; }
	        if (getErrorHandler === void 0) { getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR; }
	        if (rejectIfSuperseded === void 0) { rejectIfSuperseded = true; }
	        var eventType = new transitionEventType_1.TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, rejectIfSuperseded);
	        this._eventTypes.push(eventType);
	        hookRegistry_1.makeEvent(this, this, eventType);
	    };
	    ;
	    /**
	     * @hidden
	     * Returns the known event types, such as `onBefore`
	     * If a phase argument is provided, returns only events for the given phase.
	     */
	    TransitionService.prototype._getEvents = function (phase) {
	        var transitionHookTypes = predicates_1.isDefined(phase) ?
	            this._eventTypes.filter(function (type) { return type.hookPhase === phase; }) :
	            this._eventTypes.slice();
	        return transitionHookTypes.sort(function (l, r) {
	            var cmpByPhase = l.hookPhase - r.hookPhase;
	            return cmpByPhase === 0 ? l.hookOrder - r.hookOrder : cmpByPhase;
	        });
	    };
	    /**
	     * Adds a Path to be used as a criterion against a TreeChanges path
	     *
	     * For example: the `exiting` path in [[HookMatchCriteria]] is a STATE scoped path.
	     * It was defined by calling `defineTreeChangesCriterion('exiting', TransitionHookScope.STATE)`
	     * Each state in the exiting path is checked against the criteria and returned as part of the match.
	     *
	     * Another example: the `to` path in [[HookMatchCriteria]] is a TRANSITION scoped path.
	     * It was defined by calling `defineTreeChangesCriterion('to', TransitionHookScope.TRANSITION)`
	     * Only the tail of the `to` path is checked against the criteria and returned as part of the match.
	     *
	     * @internalapi
	     */
	    TransitionService.prototype._definePathType = function (name, hookScope) {
	        this._criteriaPaths[name] = { name: name, scope: hookScope };
	    };
	    /**
	     * Gets a Path definition used as a criterion against a TreeChanges path
	     *
	     * @internalapi
	     */
	    TransitionService.prototype._getPathTypes = function () {
	        return this._criteriaPaths;
	    };
	    /** @hidden */
	    TransitionService.prototype.getHooks = function (hookName) {
	        return this._registeredHooks[hookName];
	    };
	    /** @hidden */
	    TransitionService.prototype._registerDefaultTransitionHooks = function () {
	        var fns = this._deregisterHookFns;
	        // Wire up redirectTo hook
	        fns.redirectTo = redirectTo_1.registerRedirectToHook(this);
	        // Wire up onExit/Retain/Enter state hooks
	        fns.onExit = onEnterExitRetain_1.registerOnExitHook(this);
	        fns.onRetain = onEnterExitRetain_1.registerOnRetainHook(this);
	        fns.onEnter = onEnterExitRetain_1.registerOnEnterHook(this);
	        // Wire up Resolve hooks
	        fns.eagerResolve = resolve_1.registerEagerResolvePath(this);
	        fns.lazyResolve = resolve_1.registerLazyResolveState(this);
	        // Wire up the View management hooks
	        fns.loadViews = views_1.registerLoadEnteringViews(this);
	        fns.activateViews = views_1.registerActivateViews(this);
	        // After globals.current is updated at priority: 10000
	        fns.updateUrl = url_1.registerUpdateUrl(this);
	        // Lazy load state trees
	        fns.lazyLoad = lazyLoad_1.registerLazyLoadHook(this);
	    };
	    return TransitionService;
	}());
	exports.TransitionService = TransitionService;
	//# sourceMappingURL=transitionService.js.map

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/** @module hooks */ /** for typedoc */
	var common_1 = __webpack_require__(305);
	var resolveContext_1 = __webpack_require__(325);
	var hof_1 = __webpack_require__(307);
	/**
	 * A [[TransitionHookFn]] which resolves all EAGER Resolvables in the To Path
	 *
	 * Registered using `transitionService.onStart({}, eagerResolvePath);`
	 *
	 * When a Transition starts, this hook resolves all the EAGER Resolvables, which the transition then waits for.
	 *
	 * See [[StateDeclaration.resolve]]
	 */
	var eagerResolvePath = function (trans) {
	    return new resolveContext_1.ResolveContext(trans.treeChanges().to)
	        .resolvePath("EAGER", trans)
	        .then(common_1.noop);
	};
	exports.registerEagerResolvePath = function (transitionService) {
	    return transitionService.onStart({}, eagerResolvePath, { priority: 1000 });
	};
	/**
	 * A [[TransitionHookFn]] which resolves all LAZY Resolvables for the state (and all its ancestors) in the To Path
	 *
	 * Registered using `transitionService.onEnter({ entering: () => true }, lazyResolveState);`
	 *
	 * When a State is being entered, this hook resolves all the Resolvables for this state, which the transition then waits for.
	 *
	 * See [[StateDeclaration.resolve]]
	 */
	var lazyResolveState = function (trans, state) {
	    return new resolveContext_1.ResolveContext(trans.treeChanges().to)
	        .subContext(state)
	        .resolvePath("LAZY", trans)
	        .then(common_1.noop);
	};
	exports.registerLazyResolveState = function (transitionService) {
	    return transitionService.onEnter({ entering: hof_1.val(true) }, lazyResolveState, { priority: 1000 });
	};
	//# sourceMappingURL=resolve.js.map

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/** @module hooks */ /** for typedoc */
	var common_1 = __webpack_require__(305);
	var coreservices_1 = __webpack_require__(308);
	/**
	 * A [[TransitionHookFn]] which waits for the views to load
	 *
	 * Registered using `transitionService.onStart({}, loadEnteringViews);`
	 *
	 * Allows the views to do async work in [[ViewConfig.load]] before the transition continues.
	 * In angular 1, this includes loading the templates.
	 */
	var loadEnteringViews = function (transition) {
	    var $q = coreservices_1.services.$q;
	    var enteringViews = transition.views("entering");
	    if (!enteringViews.length)
	        return;
	    return $q.all(enteringViews.map(function (view) { return $q.when(view.load()); })).then(common_1.noop);
	};
	exports.registerLoadEnteringViews = function (transitionService) {
	    return transitionService.onFinish({}, loadEnteringViews);
	};
	/**
	 * A [[TransitionHookFn]] which activates the new views when a transition is successful.
	 *
	 * Registered using `transitionService.onSuccess({}, activateViews);`
	 *
	 * After a transition is complete, this hook deactivates the old views from the previous state,
	 * and activates the new views from the destination state.
	 *
	 * See [[ViewService]]
	 */
	var activateViews = function (transition) {
	    var enteringViews = transition.views("entering");
	    var exitingViews = transition.views("exiting");
	    if (!enteringViews.length && !exitingViews.length)
	        return;
	    var $view = transition.router.viewService;
	    exitingViews.forEach(function (vc) { return $view.deactivateViewConfig(vc); });
	    enteringViews.forEach(function (vc) { return $view.activateViewConfig(vc); });
	    $view.sync();
	};
	exports.registerActivateViews = function (transitionService) {
	    return transitionService.onSuccess({}, activateViews);
	};
	//# sourceMappingURL=views.js.map

/***/ },
/* 337 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * A [[TransitionHookFn]] which updates the URL after a successful transition
	 *
	 * Registered using `transitionService.onSuccess({}, updateUrl);`
	 */
	var updateUrl = function (transition) {
	    var options = transition.options();
	    var $state = transition.router.stateService;
	    var $urlRouter = transition.router.urlRouter;
	    // Dont update the url in these situations:
	    // The transition was triggered by a URL sync (options.source === 'url')
	    // The user doesn't want the url to update (options.location === false)
	    // The destination state, and all parents have no navigable url
	    if (options.source !== 'url' && options.location && $state.$current.navigable) {
	        var urlOptions = { replace: options.location === 'replace' };
	        $urlRouter.push($state.$current.navigable.url, $state.params, urlOptions);
	    }
	    $urlRouter.update(true);
	};
	exports.registerUpdateUrl = function (transitionService) {
	    return transitionService.onSuccess({}, updateUrl, { priority: 9999 });
	};
	//# sourceMappingURL=url.js.map

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/** @module hooks */ /** */
	var predicates_1 = __webpack_require__(306);
	var coreservices_1 = __webpack_require__(308);
	var targetState_1 = __webpack_require__(317);
	/**
	 * A [[TransitionHookFn]] that redirects to a different state or params
	 *
	 * Registered using `transitionService.onStart({ to: (state) => !!state.redirectTo }, redirectHook);`
	 *
	 * See [[StateDeclaration.redirectTo]]
	 */
	var redirectToHook = function (trans) {
	    var redirect = trans.to().redirectTo;
	    if (!redirect)
	        return;
	    var $state = trans.router.stateService;
	    function handleResult(result) {
	        if (!result)
	            return;
	        if (result instanceof targetState_1.TargetState)
	            return result;
	        if (predicates_1.isString(result))
	            return $state.target(result, trans.params(), trans.options());
	        if (result['state'] || result['params'])
	            return $state.target(result['state'] || trans.to(), result['params'] || trans.params(), trans.options());
	    }
	    if (predicates_1.isFunction(redirect)) {
	        return coreservices_1.services.$q.when(redirect(trans)).then(handleResult);
	    }
	    return handleResult(redirect);
	};
	exports.registerRedirectToHook = function (transitionService) {
	    return transitionService.onStart({ to: function (state) { return !!state.redirectTo; } }, redirectToHook);
	};
	//# sourceMappingURL=redirectTo.js.map

/***/ },
/* 339 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * A factory which creates an onEnter, onExit or onRetain transition hook function
	 *
	 * The returned function invokes the (for instance) state.onEnter hook when the
	 * state is being entered.
	 *
	 * @hidden
	 */
	function makeEnterExitRetainHook(hookName) {
	    return function (transition, state) {
	        var hookFn = state[hookName];
	        return hookFn(transition, state);
	    };
	}
	/**
	 * The [[TransitionStateHookFn]] for onExit
	 *
	 * When the state is being exited, the state's .onExit function is invoked.
	 *
	 * Registered using `transitionService.onExit({ exiting: (state) => !!state.onExit }, onExitHook);`
	 *
	 * See: [[IHookRegistry.onExit]]
	 */
	var onExitHook = makeEnterExitRetainHook('onExit');
	exports.registerOnExitHook = function (transitionService) {
	    return transitionService.onExit({ exiting: function (state) { return !!state.onExit; } }, onExitHook);
	};
	/**
	 * The [[TransitionStateHookFn]] for onRetain
	 *
	 * When the state was already entered, and is not being exited or re-entered, the state's .onRetain function is invoked.
	 *
	 * Registered using `transitionService.onRetain({ retained: (state) => !!state.onRetain }, onRetainHook);`
	 *
	 * See: [[IHookRegistry.onRetain]]
	 */
	var onRetainHook = makeEnterExitRetainHook('onRetain');
	exports.registerOnRetainHook = function (transitionService) {
	    return transitionService.onRetain({ retained: function (state) { return !!state.onRetain; } }, onRetainHook);
	};
	/**
	 * The [[TransitionStateHookFn]] for onEnter
	 *
	 * When the state is being entered, the state's .onEnter function is invoked.
	 *
	 * Registered using `transitionService.onEnter({ entering: (state) => !!state.onEnter }, onEnterHook);`
	 *
	 * See: [[IHookRegistry.onEnter]]
	 */
	var onEnterHook = makeEnterExitRetainHook('onEnter');
	exports.registerOnEnterHook = function (transitionService) {
	    return transitionService.onEnter({ entering: function (state) { return !!state.onEnter; } }, onEnterHook);
	};
	//# sourceMappingURL=onEnterExitRetain.js.map

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var coreservices_1 = __webpack_require__(308);
	/**
	 * A [[TransitionHookFn]] that performs lazy loading
	 *
	 * When entering a state "abc" which has a `lazyLoad` function defined:
	 * - Invoke the `lazyLoad` function (unless it is already in process)
	 *   - Flag the hook function as "in process"
	 *   - The function should return a promise (that resolves when lazy loading is complete)
	 * - Wait for the promise to settle
	 *   - If the promise resolves to a [[LazyLoadResult]], then register those states
	 *   - Flag the hook function as "not in process"
	 * - If the hook was successful
	 *   - Remove the `lazyLoad` function from the state declaration
	 * - If all the hooks were successful
	 *   - Retry the transition (by returning a TargetState)
	 *
	 * ```
	 * .state('abc', {
	 *   component: 'fooComponent',
	 *   lazyLoad: () => System.import('./fooComponent')
	 *   });
	 * ```
	 *
	 * See [[StateDeclaration.lazyLoad]]
	 */
	var lazyLoadHook = function (transition) {
	    var router = transition.router;
	    function retryTransition() {
	        if (transition.originalTransition().options().source !== 'url') {
	            // The original transition was not triggered via url sync
	            // The lazy state should be loaded now, so re-try the original transition
	            var orig = transition.targetState();
	            return router.stateService.target(orig.identifier(), orig.params(), orig.options());
	        }
	        // The original transition was triggered via url sync
	        // Run the URL rules and find the best match
	        var $url = router.urlService;
	        var result = $url.match($url.parts());
	        var rule = result && result.rule;
	        // If the best match is a state, redirect the transition (instead
	        // of calling sync() which supersedes the current transition)
	        if (rule && rule.type === "STATE") {
	            var state = rule.state;
	            var params = result.match;
	            return router.stateService.target(state, params, transition.options());
	        }
	        // No matching state found, so let .sync() choose the best non-state match/otherwise
	        router.urlRouter.sync();
	    }
	    var promises = transition.entering()
	        .filter(function (state) { return !!state.lazyLoad; })
	        .map(function (state) { return lazyLoadState(transition, state); });
	    return coreservices_1.services.$q.all(promises).then(retryTransition);
	};
	exports.registerLazyLoadHook = function (transitionService) {
	    return transitionService.onBefore({ entering: function (state) { return !!state.lazyLoad; } }, lazyLoadHook);
	};
	/**
	 * Invokes a state's lazy load function
	 *
	 * @param transition a Transition context
	 * @param state the state to lazy load
	 * @returns A promise for the lazy load result
	 */
	function lazyLoadState(transition, state) {
	    var lazyLoadFn = state.lazyLoad;
	    // Store/get the lazy load promise on/from the hookfn so it doesn't get re-invoked
	    var promise = lazyLoadFn['_promise'];
	    if (!promise) {
	        var success = function (result) {
	            delete state.lazyLoad;
	            delete state.$$state().lazyLoad;
	            delete lazyLoadFn['_promise'];
	            return result;
	        };
	        var error = function (err) {
	            delete lazyLoadFn['_promise'];
	            return coreservices_1.services.$q.reject(err);
	        };
	        promise = lazyLoadFn['_promise'] =
	            coreservices_1.services.$q.when(lazyLoadFn(transition, state))
	                .then(updateStateRegistry)
	                .then(success, error);
	    }
	    /** Register any lazy loaded state definitions */
	    function updateStateRegistry(result) {
	        if (result && Array.isArray(result.states)) {
	            result.states.forEach(function (state) { return transition.router.stateRegistry.register(state); });
	        }
	        return result;
	    }
	    return promise;
	}
	exports.lazyLoadState = lazyLoadState;
	//# sourceMappingURL=lazyLoad.js.map

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var transitionHook_1 = __webpack_require__(316);
	/**
	 * This class defines a type of hook, such as `onBefore` or `onEnter`.
	 * Plugins can define custom hook types, such as sticky states does for `onInactive`.
	 *
	 * @interalapi
	 */
	var TransitionEventType = (function () {
	    function TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, rejectIfSuperseded) {
	        if (reverseSort === void 0) { reverseSort = false; }
	        if (getResultHandler === void 0) { getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT; }
	        if (getErrorHandler === void 0) { getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR; }
	        if (rejectIfSuperseded === void 0) { rejectIfSuperseded = true; }
	        this.name = name;
	        this.hookPhase = hookPhase;
	        this.hookOrder = hookOrder;
	        this.criteriaMatchPath = criteriaMatchPath;
	        this.reverseSort = reverseSort;
	        this.getResultHandler = getResultHandler;
	        this.getErrorHandler = getErrorHandler;
	        this.rejectIfSuperseded = rejectIfSuperseded;
	    }
	    return TransitionEventType;
	}());
	exports.TransitionEventType = TransitionEventType;
	//# sourceMappingURL=transitionEventType.js.map

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @coreapi
	 * @module view
	 */ /** for typedoc */
	var common_1 = __webpack_require__(305);
	var hof_1 = __webpack_require__(307);
	var predicates_1 = __webpack_require__(306);
	var trace_1 = __webpack_require__(314);
	/**
	 * The View service
	 *
	 * This service pairs existing `ui-view` components (which live in the DOM)
	 * with view configs (from the state declaration objects: [[StateDeclaration.views]]).
	 *
	 * - After a successful Transition, the views from the newly entered states are activated via [[activateViewConfig]].
	 *   The views from exited states are deactivated via [[deactivateViewConfig]].
	 *   (See: the [[registerActivateViews]] Transition Hook)
	 *
	 * - As `ui-view` components pop in and out of existence, they register themselves using [[registerUIView]].
	 *
	 * - When the [[sync]] function is called, the registered `ui-view`(s) ([[UIViewConfig]]
	 * are configured with the matching `ViewConfig`(s)  ([[ActiveUIView]]).
	 *
	 */
	var ViewService = (function () {
	    function ViewService() {
	        var _this = this;
	        this._uiViews = [];
	        this._viewConfigs = [];
	        this._viewConfigFactories = {};
	        this._pluginapi = {
	            _rootViewContext: this._rootViewContext.bind(this),
	            _viewConfigFactory: this._viewConfigFactory.bind(this),
	            _registeredUIViews: function () { return _this._uiViews; },
	            _activeViewConfigs: function () { return _this._viewConfigs; },
	        };
	    }
	    ViewService.prototype._rootViewContext = function (context) {
	        return this._rootContext = context || this._rootContext;
	    };
	    ;
	    ViewService.prototype._viewConfigFactory = function (viewType, factory) {
	        this._viewConfigFactories[viewType] = factory;
	    };
	    ViewService.prototype.createViewConfig = function (path, decl) {
	        var cfgFactory = this._viewConfigFactories[decl.$type];
	        if (!cfgFactory)
	            throw new Error("ViewService: No view config factory registered for type " + decl.$type);
	        var cfgs = cfgFactory(path, decl);
	        return predicates_1.isArray(cfgs) ? cfgs : [cfgs];
	    };
	    /**
	     * Deactivates a ViewConfig.
	     *
	     * This function deactivates a `ViewConfig`.
	     * After calling [[sync]], it will un-pair from any `ui-view` with which it is currently paired.
	     *
	     * @param viewConfig The ViewConfig view to deregister.
	     */
	    ViewService.prototype.deactivateViewConfig = function (viewConfig) {
	        trace_1.trace.traceViewServiceEvent("<- Removing", viewConfig);
	        common_1.removeFrom(this._viewConfigs, viewConfig);
	    };
	    ViewService.prototype.activateViewConfig = function (viewConfig) {
	        trace_1.trace.traceViewServiceEvent("-> Registering", viewConfig);
	        this._viewConfigs.push(viewConfig);
	    };
	    ViewService.prototype.sync = function () {
	        var _this = this;
	        var uiViewsByFqn = this._uiViews.map(function (uiv) { return [uiv.fqn, uiv]; }).reduce(common_1.applyPairs, {});
	        /**
	         * Given a ui-view and a ViewConfig, determines if they "match".
	         *
	         * A ui-view has a fully qualified name (fqn) and a context object.  The fqn is built from its overall location in
	         * the DOM, describing its nesting relationship to any parent ui-view tags it is nested inside of.
	         *
	         * A ViewConfig has a target ui-view name and a context anchor.  The ui-view name can be a simple name, or
	         * can be a segmented ui-view path, describing a portion of a ui-view fqn.
	         *
	         * In order for a ui-view to match ViewConfig, ui-view's $type must match the ViewConfig's $type
	         *
	         * If the ViewConfig's target ui-view name is a simple name (no dots), then a ui-view matches if:
	         * - the ui-view's name matches the ViewConfig's target name
	         * - the ui-view's context matches the ViewConfig's anchor
	         *
	         * If the ViewConfig's target ui-view name is a segmented name (with dots), then a ui-view matches if:
	         * - There exists a parent ui-view where:
	         *    - the parent ui-view's name matches the first segment (index 0) of the ViewConfig's target name
	         *    - the parent ui-view's context matches the ViewConfig's anchor
	         * - And the remaining segments (index 1..n) of the ViewConfig's target name match the tail of the ui-view's fqn
	         *
	         * Example:
	         *
	         * DOM:
	         * <div ui-view>                        <!-- created in the root context (name: "") -->
	         *   <div ui-view="foo">                <!-- created in the context named: "A"      -->
	         *     <div ui-view>                    <!-- created in the context named: "A.B"    -->
	         *       <div ui-view="bar">            <!-- created in the context named: "A.B.C"  -->
	         *       </div>
	         *     </div>
	         *   </div>
	         * </div>
	         *
	         * uiViews: [
	         *  { fqn: "$default",                  creationContext: { name: "" } },
	         *  { fqn: "$default.foo",              creationContext: { name: "A" } },
	         *  { fqn: "$default.foo.$default",     creationContext: { name: "A.B" } }
	         *  { fqn: "$default.foo.$default.bar", creationContext: { name: "A.B.C" } }
	         * ]
	         *
	         * These four view configs all match the ui-view with the fqn: "$default.foo.$default.bar":
	         *
	         * - ViewConfig1: { uiViewName: "bar",                       uiViewContextAnchor: "A.B.C" }
	         * - ViewConfig2: { uiViewName: "$default.bar",              uiViewContextAnchor: "A.B" }
	         * - ViewConfig3: { uiViewName: "foo.$default.bar",          uiViewContextAnchor: "A" }
	         * - ViewConfig4: { uiViewName: "$default.foo.$default.bar", uiViewContextAnchor: "" }
	         *
	         * Using ViewConfig3 as an example, it matches the ui-view with fqn "$default.foo.$default.bar" because:
	         * - The ViewConfig's segmented target name is: [ "foo", "$default", "bar" ]
	         * - There exists a parent ui-view (which has fqn: "$default.foo") where:
	         *    - the parent ui-view's name "foo" matches the first segment "foo" of the ViewConfig's target name
	         *    - the parent ui-view's context "A" matches the ViewConfig's anchor context "A"
	         * - And the remaining segments [ "$default", "bar" ].join("."_ of the ViewConfig's target name match
	         *   the tail of the ui-view's fqn "default.bar"
	         */
	        var matches = function (uiView) { return function (viewConfig) {
	            // Don't supply an ng1 ui-view with an ng2 ViewConfig, etc
	            if (uiView.$type !== viewConfig.viewDecl.$type)
	                return false;
	            // Split names apart from both viewConfig and uiView into segments
	            var vc = viewConfig.viewDecl;
	            var vcSegments = vc.$uiViewName.split(".");
	            var uivSegments = uiView.fqn.split(".");
	            // Check if the tails of the segment arrays match. ex, these arrays' tails match:
	            // vc: ["foo", "bar"], uiv fqn: ["$default", "foo", "bar"]
	            if (!common_1.equals(vcSegments, uivSegments.slice(0 - vcSegments.length)))
	                return false;
	            // Now check if the fqn ending at the first segment of the viewConfig matches the context:
	            // ["$default", "foo"].join(".") == "$default.foo", does the ui-view $default.foo context match?
	            var negOffset = (1 - vcSegments.length) || undefined;
	            var fqnToFirstSegment = uivSegments.slice(0, negOffset).join(".");
	            var uiViewContext = uiViewsByFqn[fqnToFirstSegment].creationContext;
	            return vc.$uiViewContextAnchor === (uiViewContext && uiViewContext.name);
	        }; };
	        // Return the number of dots in the fully qualified name
	        function uiViewDepth(uiView) {
	            return uiView.fqn.split(".").length;
	        }
	        // Return the ViewConfig's context's depth in the context tree.
	        function viewConfigDepth(config) {
	            var context = config.viewDecl.$context, count = 0;
	            while (++count && context.parent)
	                context = context.parent;
	            return count;
	        }
	        // Given a depth function, returns a compare function which can return either ascending or descending order
	        var depthCompare = hof_1.curry(function (depthFn, posNeg, left, right) { return posNeg * (depthFn(left) - depthFn(right)); });
	        var matchingConfigPair = function (uiView) {
	            var matchingConfigs = _this._viewConfigs.filter(matches(uiView));
	            if (matchingConfigs.length > 1) {
	                // This is OK.  Child states can target a ui-view that the parent state also targets (the child wins)
	                // Sort by depth and return the match from the deepest child
	                // console.log(`Multiple matching view configs for ${uiView.fqn}`, matchingConfigs);
	                matchingConfigs.sort(depthCompare(viewConfigDepth, -1)); // descending
	            }
	            return [uiView, matchingConfigs[0]];
	        };
	        var configureUIView = function (_a) {
	            var uiView = _a[0], viewConfig = _a[1];
	            // If a parent ui-view is reconfigured, it could destroy child ui-views.
	            // Before configuring a child ui-view, make sure it's still in the active uiViews array.
	            if (_this._uiViews.indexOf(uiView) !== -1)
	                uiView.configUpdated(viewConfig);
	        };
	        this._uiViews.sort(depthCompare(uiViewDepth, 1)).map(matchingConfigPair).forEach(configureUIView);
	    };
	    ;
	    /**
	     * Registers a `ui-view` component
	     *
	     * When a `ui-view` component is created, it uses this method to register itself.
	     * After registration the [[sync]] method is used to ensure all `ui-view` are configured with the proper [[ViewConfig]].
	     *
	     * Note: the `ui-view` component uses the `ViewConfig` to determine what view should be loaded inside the `ui-view`,
	     * and what the view's state context is.
	     *
	     * Note: There is no corresponding `deregisterUIView`.
	     *       A `ui-view` should hang on to the return value of `registerUIView` and invoke it to deregister itself.
	     *
	     * @param uiView The metadata for a UIView
	     * @return a de-registration function used when the view is destroyed.
	     */
	    ViewService.prototype.registerUIView = function (uiView) {
	        trace_1.trace.traceViewServiceUIViewEvent("-> Registering", uiView);
	        var uiViews = this._uiViews;
	        var fqnMatches = function (uiv) { return uiv.fqn === uiView.fqn; };
	        if (uiViews.filter(fqnMatches).length)
	            trace_1.trace.traceViewServiceUIViewEvent("!!!! duplicate uiView named:", uiView);
	        uiViews.push(uiView);
	        this.sync();
	        return function () {
	            var idx = uiViews.indexOf(uiView);
	            if (idx === -1) {
	                trace_1.trace.traceViewServiceUIViewEvent("Tried removing non-registered uiView", uiView);
	                return;
	            }
	            trace_1.trace.traceViewServiceUIViewEvent("<- Deregistering", uiView);
	            common_1.removeFrom(uiViews)(uiView);
	        };
	    };
	    ;
	    /**
	     * Returns the list of views currently available on the page, by fully-qualified name.
	     *
	     * @return {Array} Returns an array of fully-qualified view names.
	     */
	    ViewService.prototype.available = function () {
	        return this._uiViews.map(hof_1.prop("fqn"));
	    };
	    /**
	     * Returns the list of views on the page containing loaded content.
	     *
	     * @return {Array} Returns an array of fully-qualified view names.
	     */
	    ViewService.prototype.active = function () {
	        return this._uiViews.filter(hof_1.prop("$config")).map(hof_1.prop("name"));
	    };
	    /**
	     * Normalizes a view's name from a state.views configuration block.
	     *
	     * @param context the context object (state declaration) that the view belongs to
	     * @param rawViewName the name of the view, as declared in the [[StateDeclaration.views]]
	     *
	     * @returns the normalized uiViewName and uiViewContextAnchor that the view targets
	     */
	    ViewService.normalizeUIViewTarget = function (context, rawViewName) {
	        if (rawViewName === void 0) { rawViewName = ""; }
	        // TODO: Validate incoming view name with a regexp to allow:
	        // ex: "view.name@foo.bar" , "^.^.view.name" , "view.name@^.^" , "" ,
	        // "@" , "$default@^" , "!$default.$default" , "!foo.bar"
	        var viewAtContext = rawViewName.split("@");
	        var uiViewName = viewAtContext[0] || "$default"; // default to unnamed view
	        var uiViewContextAnchor = predicates_1.isString(viewAtContext[1]) ? viewAtContext[1] : "^"; // default to parent context
	        // Handle relative view-name sugar syntax.
	        // Matches rawViewName "^.^.^.foo.bar" into array: ["^.^.^.foo.bar", "^.^.^", "foo.bar"],
	        var relativeViewNameSugar = /^(\^(?:\.\^)*)\.(.*$)/.exec(uiViewName);
	        if (relativeViewNameSugar) {
	            // Clobbers existing contextAnchor (rawViewName validation will fix this)
	            uiViewContextAnchor = relativeViewNameSugar[1]; // set anchor to "^.^.^"
	            uiViewName = relativeViewNameSugar[2]; // set view-name to "foo.bar"
	        }
	        if (uiViewName.charAt(0) === '!') {
	            uiViewName = uiViewName.substr(1);
	            uiViewContextAnchor = ""; // target absolutely from root
	        }
	        // handle parent relative targeting "^.^.^"
	        var relativeMatch = /^(\^(?:\.\^)*)$/;
	        if (relativeMatch.exec(uiViewContextAnchor)) {
	            var anchor = uiViewContextAnchor.split(".").reduce((function (anchor, x) { return anchor.parent; }), context);
	            uiViewContextAnchor = anchor.name;
	        }
	        return { uiViewName: uiViewName, uiViewContextAnchor: uiViewContextAnchor };
	    };
	    return ViewService;
	}());
	exports.ViewService = ViewService;
	//# sourceMappingURL=view.js.map

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @coreapi
	 * @module state
	 */ /** for typedoc */
	"use strict";
	var stateMatcher_1 = __webpack_require__(344);
	var stateBuilder_1 = __webpack_require__(345);
	var stateQueueManager_1 = __webpack_require__(346);
	var common_1 = __webpack_require__(305);
	var hof_1 = __webpack_require__(307);
	var StateRegistry = (function () {
	    /** @internalapi */
	    function StateRegistry(_router) {
	        this._router = _router;
	        this.states = {};
	        this.listeners = [];
	        this.matcher = new stateMatcher_1.StateMatcher(this.states);
	        this.builder = new stateBuilder_1.StateBuilder(this.matcher, _router.urlMatcherFactory);
	        this.stateQueue = new stateQueueManager_1.StateQueueManager(this, _router.urlRouter, this.states, this.builder, this.listeners);
	        this._registerRoot();
	    }
	    /** @internalapi */
	    StateRegistry.prototype._registerRoot = function () {
	        var rootStateDef = {
	            name: '',
	            url: '^',
	            views: null,
	            params: {
	                '#': { value: null, type: 'hash', dynamic: true }
	            },
	            abstract: true
	        };
	        var _root = this._root = this.stateQueue.register(rootStateDef);
	        _root.navigable = null;
	    };
	    /** @internalapi */
	    StateRegistry.prototype.dispose = function () {
	        var _this = this;
	        this.stateQueue.dispose();
	        this.listeners = [];
	        this.get().forEach(function (state) { return _this.get(state) && _this.deregister(state); });
	    };
	    /**
	     * Listen for a State Registry events
	     *
	     * Adds a callback that is invoked when states are registered or deregistered with the StateRegistry.
	     *
	     * #### Example:
	     * ```js
	     * let allStates = registry.get();
	     *
	     * // Later, invoke deregisterFn() to remove the listener
	     * let deregisterFn = registry.onStatesChanged((event, states) => {
	     *   switch(event) {
	     *     case: 'registered':
	     *       states.forEach(state => allStates.push(state));
	     *       break;
	     *     case: 'deregistered':
	     *       states.forEach(state => {
	     *         let idx = allStates.indexOf(state);
	     *         if (idx !== -1) allStates.splice(idx, 1);
	     *       });
	     *       break;
	     *   }
	     * });
	     * ```
	     *
	     * @param listener a callback function invoked when the registered states changes.
	     *        The function receives two parameters, `event` and `state`.
	     *        See [[StateRegistryListener]]
	     * @return a function that deregisters the listener
	     */
	    StateRegistry.prototype.onStatesChanged = function (listener) {
	        this.listeners.push(listener);
	        return function deregisterListener() {
	            common_1.removeFrom(this.listeners)(listener);
	        }.bind(this);
	    };
	    /**
	     * Gets the implicit root state
	     *
	     * Gets the root of the state tree.
	     * The root state is implicitly created by UI-Router.
	     * Note: this returns the internal [[State]] representation, not a [[StateDeclaration]]
	     *
	     * @return the root [[State]]
	     */
	    StateRegistry.prototype.root = function () {
	        return this._root;
	    };
	    /**
	     * Adds a state to the registry
	     *
	     * Registers a [[StateDeclaration]] or queues it for registration.
	     *
	     * Note: a state will be queued if the state's parent isn't yet registered.
	     * It will also be queued if the queue is not yet in [[StateQueueManager.autoFlush]] mode.
	     *
	     * @param stateDefinition the definition of the state to register.
	     * @returns the internal [[State]] object.
	     *          If the state was successfully registered, then the object is fully built (See: [[StateBuilder]]).
	     *          If the state was only queued, then the object is not fully built.
	     */
	    StateRegistry.prototype.register = function (stateDefinition) {
	        return this.stateQueue.register(stateDefinition);
	    };
	    /** @hidden */
	    StateRegistry.prototype._deregisterTree = function (state) {
	        var _this = this;
	        var all = this.get().map(function (s) { return s.$$state(); });
	        var getChildren = function (states) {
	            var children = all.filter(function (s) { return states.indexOf(s.parent) !== -1; });
	            return children.length === 0 ? children : children.concat(getChildren(children));
	        };
	        var children = getChildren([state]);
	        var deregistered = [state].concat(children).reverse();
	        deregistered.forEach(function (state) {
	            var $ur = _this._router.urlRouter;
	            // Remove URL rule
	            $ur.rules().filter(hof_1.propEq("state", state)).forEach($ur.removeRule.bind($ur));
	            // Remove state from registry
	            delete _this.states[state.name];
	        });
	        return deregistered;
	    };
	    /**
	     * Removes a state from the registry
	     *
	     * This removes a state from the registry.
	     * If the state has children, they are are also removed from the registry.
	     *
	     * @param stateOrName the state's name or object representation
	     * @returns {State[]} a list of removed states
	     */
	    StateRegistry.prototype.deregister = function (stateOrName) {
	        var _state = this.get(stateOrName);
	        if (!_state)
	            throw new Error("Can't deregister state; not found: " + stateOrName);
	        var deregisteredStates = this._deregisterTree(_state.$$state());
	        this.listeners.forEach(function (listener) { return listener("deregistered", deregisteredStates.map(function (s) { return s.self; })); });
	        return deregisteredStates;
	    };
	    StateRegistry.prototype.get = function (stateOrName, base) {
	        var _this = this;
	        if (arguments.length === 0)
	            return Object.keys(this.states).map(function (name) { return _this.states[name].self; });
	        var found = this.matcher.find(stateOrName, base);
	        return found && found.self || null;
	    };
	    StateRegistry.prototype.decorator = function (name, func) {
	        return this.builder.builder(name, func);
	    };
	    return StateRegistry;
	}());
	exports.StateRegistry = StateRegistry;
	//# sourceMappingURL=stateRegistry.js.map

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/** @module state */ /** for typedoc */
	var predicates_1 = __webpack_require__(306);
	var glob_1 = __webpack_require__(309);
	var common_1 = __webpack_require__(305);
	var StateMatcher = (function () {
	    function StateMatcher(_states) {
	        this._states = _states;
	    }
	    StateMatcher.prototype.isRelative = function (stateName) {
	        stateName = stateName || "";
	        return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
	    };
	    StateMatcher.prototype.find = function (stateOrName, base) {
	        if (!stateOrName && stateOrName !== "")
	            return undefined;
	        var isStr = predicates_1.isString(stateOrName);
	        var name = isStr ? stateOrName : stateOrName.name;
	        if (this.isRelative(name))
	            name = this.resolvePath(name, base);
	        var state = this._states[name];
	        if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
	            return state;
	        }
	        else if (isStr) {
	            var matches = common_1.values(this._states)
	                .filter(function (state) { return new glob_1.Glob(state.name).matches(name); });
	            if (matches.length > 1) {
	                console.log("stateMatcher.find: Found multiple matches for " + name + " using glob: ", matches.map(function (match) { return match.name; }));
	            }
	            return matches[0];
	        }
	        return undefined;
	    };
	    StateMatcher.prototype.resolvePath = function (name, base) {
	        if (!base)
	            throw new Error("No reference point given for path '" + name + "'");
	        var baseState = this.find(base);
	        var splitName = name.split("."), i = 0, pathLength = splitName.length, current = baseState;
	        for (; i < pathLength; i++) {
	            if (splitName[i] === "" && i === 0) {
	                current = baseState;
	                continue;
	            }
	            if (splitName[i] === "^") {
	                if (!current.parent)
	                    throw new Error("Path '" + name + "' not valid for state '" + baseState.name + "'");
	                current = current.parent;
	                continue;
	            }
	            break;
	        }
	        var relName = splitName.slice(i).join(".");
	        return current.name + (current.name && relName ? "." : "") + relName;
	    };
	    return StateMatcher;
	}());
	exports.StateMatcher = StateMatcher;
	//# sourceMappingURL=stateMatcher.js.map

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/** @module state */ /** for typedoc */
	var common_1 = __webpack_require__(305);
	var predicates_1 = __webpack_require__(306);
	var strings_1 = __webpack_require__(311);
	var hof_1 = __webpack_require__(307);
	var resolvable_1 = __webpack_require__(324);
	var coreservices_1 = __webpack_require__(308);
	var parseUrl = function (url) {
	    if (!predicates_1.isString(url))
	        return false;
	    var root = url.charAt(0) === '^';
	    return { val: root ? url.substring(1) : url, root: root };
	};
	function nameBuilder(state) {
	    return state.name;
	}
	function selfBuilder(state) {
	    state.self.$$state = function () { return state; };
	    return state.self;
	}
	function dataBuilder(state) {
	    if (state.parent && state.parent.data) {
	        state.data = state.self.data = common_1.inherit(state.parent.data, state.data);
	    }
	    return state.data;
	}
	var getUrlBuilder = function ($urlMatcherFactoryProvider, root) {
	    return function urlBuilder(state) {
	        var stateDec = state;
	        // For future states, i.e., states whose name ends with `.**`,
	        // match anything that starts with the url prefix
	        if (stateDec && stateDec.url && stateDec.name && stateDec.name.match(/\.\*\*$/)) {
	            stateDec.url += "{remainder:any}"; // match any path (.*)
	        }
	        var parsed = parseUrl(stateDec.url), parent = state.parent;
	        var url = !parsed ? stateDec.url : $urlMatcherFactoryProvider.compile(parsed.val, {
	            params: state.params || {},
	            paramMap: function (paramConfig, isSearch) {
	                if (stateDec.reloadOnSearch === false && isSearch)
	                    paramConfig = common_1.extend(paramConfig || {}, { dynamic: true });
	                return paramConfig;
	            }
	        });
	        if (!url)
	            return null;
	        if (!$urlMatcherFactoryProvider.isMatcher(url))
	            throw new Error("Invalid url '" + url + "' in state '" + state + "'");
	        return (parsed && parsed.root) ? url : ((parent && parent.navigable) || root()).url.append(url);
	    };
	};
	var getNavigableBuilder = function (isRoot) {
	    return function navigableBuilder(state) {
	        return !isRoot(state) && state.url ? state : (state.parent ? state.parent.navigable : null);
	    };
	};
	var getParamsBuilder = function (paramFactory) {
	    return function paramsBuilder(state) {
	        var makeConfigParam = function (config, id) { return paramFactory.fromConfig(id, null, config); };
	        var urlParams = (state.url && state.url.parameters({ inherit: false })) || [];
	        var nonUrlParams = common_1.values(common_1.mapObj(common_1.omit(state.params || {}, urlParams.map(hof_1.prop('id'))), makeConfigParam));
	        return urlParams.concat(nonUrlParams).map(function (p) { return [p.id, p]; }).reduce(common_1.applyPairs, {});
	    };
	};
	function pathBuilder(state) {
	    return state.parent ? state.parent.path.concat(state) : [state];
	}
	function includesBuilder(state) {
	    var includes = state.parent ? common_1.extend({}, state.parent.includes) : {};
	    includes[state.name] = true;
	    return includes;
	}
	/**
	 * This is a [[StateBuilder.builder]] function for the `resolve:` block on a [[StateDeclaration]].
	 *
	 * When the [[StateBuilder]] builds a [[State]] object from a raw [[StateDeclaration]], this builder
	 * validates the `resolve` property and converts it to a [[Resolvable]] array.
	 *
	 * resolve: input value can be:
	 *
	 * {
	 *   // analyzed but not injected
	 *   myFooResolve: function() { return "myFooData"; },
	 *
	 *   // function.toString() parsed, "DependencyName" dep as string (not min-safe)
	 *   myBarResolve: function(DependencyName) { return DependencyName.fetchSomethingAsPromise() },
	 *
	 *   // Array split; "DependencyName" dep as string
	 *   myBazResolve: [ "DependencyName", function(dep) { return dep.fetchSomethingAsPromise() },
	 *
	 *   // Array split; DependencyType dep as token (compared using ===)
	 *   myQuxResolve: [ DependencyType, function(dep) { return dep.fetchSometingAsPromise() },
	 *
	 *   // val.$inject used as deps
	 *   // where:
	 *   //     corgeResolve.$inject = ["DependencyName"];
	 *   //     function corgeResolve(dep) { dep.fetchSometingAsPromise() }
	 *   // then "DependencyName" dep as string
	 *   myCorgeResolve: corgeResolve,
	 *
	 *  // inject service by name
	 *  // When a string is found, desugar creating a resolve that injects the named service
	 *   myGraultResolve: "SomeService"
	 * }
	 *
	 * or:
	 *
	 * [
	 *   new Resolvable("myFooResolve", function() { return "myFooData" }),
	 *   new Resolvable("myBarResolve", function(dep) { return dep.fetchSomethingAsPromise() }, [ "DependencyName" ]),
	 *   { provide: "myBazResolve", useFactory: function(dep) { dep.fetchSomethingAsPromise() }, deps: [ "DependencyName" ] }
	 * ]
	 */
	function resolvablesBuilder(state) {
	    /** convert resolve: {} and resolvePolicy: {} objects to an array of tuples */
	    var objects2Tuples = function (resolveObj, resolvePolicies) {
	        return Object.keys(resolveObj || {}).map(function (token) { return ({ token: token, val: resolveObj[token], deps: undefined, policy: resolvePolicies[token] }); });
	    };
	    /** fetch DI annotations from a function or ng1-style array */
	    var annotate = function (fn) {
	        var $injector = coreservices_1.services.$injector;
	        // ng1 doesn't have an $injector until runtime.
	        // If the $injector doesn't exist, use "deferred" literal as a
	        // marker indicating they should be annotated when runtime starts
	        return fn['$inject'] || ($injector && $injector.annotate(fn, $injector.strictDi)) || "deferred";
	    };
	    /** true if the object has both `token` and `resolveFn`, and is probably a [[ResolveLiteral]] */
	    var isResolveLiteral = function (obj) { return !!(obj.token && obj.resolveFn); };
	    /** true if the object looks like a provide literal, or a ng2 Provider */
	    var isLikeNg2Provider = function (obj) { return !!((obj.provide || obj.token) && (obj.useValue || obj.useFactory || obj.useExisting || obj.useClass)); };
	    /** true if the object looks like a tuple from obj2Tuples */
	    var isTupleFromObj = function (obj) { return !!(obj && obj.val && (predicates_1.isString(obj.val) || predicates_1.isArray(obj.val) || predicates_1.isFunction(obj.val))); };
	    /** extracts the token from a Provider or provide literal */
	    var token = function (p) { return p.provide || p.token; };
	    /** Given a literal resolve or provider object, returns a Resolvable */
	    var literal2Resolvable = hof_1.pattern([
	        [hof_1.prop('resolveFn'), function (p) { return new resolvable_1.Resolvable(token(p), p.resolveFn, p.deps, p.policy); }],
	        [hof_1.prop('useFactory'), function (p) { return new resolvable_1.Resolvable(token(p), p.useFactory, (p.deps || p.dependencies), p.policy); }],
	        [hof_1.prop('useClass'), function (p) { return new resolvable_1.Resolvable(token(p), function () { return new p.useClass(); }, [], p.policy); }],
	        [hof_1.prop('useValue'), function (p) { return new resolvable_1.Resolvable(token(p), function () { return p.useValue; }, [], p.policy, p.useValue); }],
	        [hof_1.prop('useExisting'), function (p) { return new resolvable_1.Resolvable(token(p), common_1.identity, [p.useExisting], p.policy); }],
	    ]);
	    var tuple2Resolvable = hof_1.pattern([
	        [hof_1.pipe(hof_1.prop("val"), predicates_1.isString), function (tuple) { return new resolvable_1.Resolvable(tuple.token, common_1.identity, [tuple.val], tuple.policy); }],
	        [hof_1.pipe(hof_1.prop("val"), predicates_1.isArray), function (tuple) { return new resolvable_1.Resolvable(tuple.token, common_1.tail(tuple.val), tuple.val.slice(0, -1), tuple.policy); }],
	        [hof_1.pipe(hof_1.prop("val"), predicates_1.isFunction), function (tuple) { return new resolvable_1.Resolvable(tuple.token, tuple.val, annotate(tuple.val), tuple.policy); }],
	    ]);
	    var item2Resolvable = hof_1.pattern([
	        [hof_1.is(resolvable_1.Resolvable), function (r) { return r; }],
	        [isResolveLiteral, literal2Resolvable],
	        [isLikeNg2Provider, literal2Resolvable],
	        [isTupleFromObj, tuple2Resolvable],
	        [hof_1.val(true), function (obj) { throw new Error("Invalid resolve value: " + strings_1.stringify(obj)); }]
	    ]);
	    // If resolveBlock is already an array, use it as-is.
	    // Otherwise, assume it's an object and convert to an Array of tuples
	    var decl = state.resolve;
	    var items = predicates_1.isArray(decl) ? decl : objects2Tuples(decl, state.resolvePolicy || {});
	    return items.map(item2Resolvable);
	}
	exports.resolvablesBuilder = resolvablesBuilder;
	/**
	 * @internalapi A internal global service
	 *
	 * StateBuilder is a factory for the internal [[State]] objects.
	 *
	 * When you register a state with the [[StateRegistry]], you register a plain old javascript object which
	 * conforms to the [[StateDeclaration]] interface.  This factory takes that object and builds the corresponding
	 * [[State]] object, which has an API and is used internally.
	 *
	 * Custom properties or API may be added to the internal [[State]] object by registering a decorator function
	 * using the [[builder]] method.
	 */
	var StateBuilder = (function () {
	    function StateBuilder(matcher, urlMatcherFactory) {
	        this.matcher = matcher;
	        var self = this;
	        var root = function () { return matcher.find(""); };
	        var isRoot = function (state) { return state.name === ""; };
	        function parentBuilder(state) {
	            if (isRoot(state))
	                return null;
	            return matcher.find(self.parentName(state)) || root();
	        }
	        this.builders = {
	            name: [nameBuilder],
	            self: [selfBuilder],
	            parent: [parentBuilder],
	            data: [dataBuilder],
	            // Build a URLMatcher if necessary, either via a relative or absolute URL
	            url: [getUrlBuilder(urlMatcherFactory, root)],
	            // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
	            navigable: [getNavigableBuilder(isRoot)],
	            params: [getParamsBuilder(urlMatcherFactory.paramFactory)],
	            // Each framework-specific ui-router implementation should define its own `views` builder
	            // e.g., src/ng1/statebuilders/views.ts
	            views: [],
	            // Keep a full path from the root down to this state as this is needed for state activation.
	            path: [pathBuilder],
	            // Speed up $state.includes() as it's used a lot
	            includes: [includesBuilder],
	            resolvables: [resolvablesBuilder]
	        };
	    }
	    /**
	     * Registers a [[BuilderFunction]] for a specific [[State]] property (e.g., `parent`, `url`, or `path`).
	     * More than one BuilderFunction can be registered for a given property.
	     *
	     * The BuilderFunction(s) will be used to define the property on any subsequently built [[State]] objects.
	     *
	     * @param name The name of the State property being registered for.
	     * @param fn The BuilderFunction which will be used to build the State property
	     * @returns a function which deregisters the BuilderFunction
	     */
	    StateBuilder.prototype.builder = function (name, fn) {
	        var builders = this.builders;
	        var array = builders[name] || [];
	        // Backwards compat: if only one builder exists, return it, else return whole arary.
	        if (predicates_1.isString(name) && !predicates_1.isDefined(fn))
	            return array.length > 1 ? array : array[0];
	        if (!predicates_1.isString(name) || !predicates_1.isFunction(fn))
	            return;
	        builders[name] = array;
	        builders[name].push(fn);
	        return function () { return builders[name].splice(builders[name].indexOf(fn, 1)) && null; };
	    };
	    /**
	     * Builds all of the properties on an essentially blank State object, returning a State object which has all its
	     * properties and API built.
	     *
	     * @param state an uninitialized State object
	     * @returns the built State object
	     */
	    StateBuilder.prototype.build = function (state) {
	        var _a = this, matcher = _a.matcher, builders = _a.builders;
	        var parent = this.parentName(state);
	        if (parent && !matcher.find(parent))
	            return null;
	        for (var key in builders) {
	            if (!builders.hasOwnProperty(key))
	                continue;
	            var chain = builders[key].reduce(function (parentFn, step) { return function (_state) { return step(_state, parentFn); }; }, common_1.noop);
	            state[key] = chain(state);
	        }
	        return state;
	    };
	    StateBuilder.prototype.parentName = function (state) {
	        var name = state.name || "";
	        var segments = name.split('.');
	        if (segments.length > 1) {
	            if (state.parent) {
	                throw new Error("States that specify the 'parent:' property should not have a '.' in their name (" + name + ")");
	            }
	            var lastSegment = segments.pop();
	            if (lastSegment === '**')
	                segments.pop();
	            return segments.join(".");
	        }
	        if (!state.parent)
	            return "";
	        return predicates_1.isString(state.parent) ? state.parent : state.parent.name;
	    };
	    StateBuilder.prototype.name = function (state) {
	        var name = state.name;
	        if (name.indexOf('.') !== -1 || !state.parent)
	            return name;
	        var parentName = predicates_1.isString(state.parent) ? state.parent : state.parent.name;
	        return parentName ? parentName + "." + name : name;
	    };
	    return StateBuilder;
	}());
	exports.StateBuilder = StateBuilder;
	//# sourceMappingURL=stateBuilder.js.map

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/** @module state */ /** for typedoc */
	var common_1 = __webpack_require__(305);
	var predicates_1 = __webpack_require__(306);
	var stateObject_1 = __webpack_require__(333);
	/** @internalapi */
	var StateQueueManager = (function () {
	    function StateQueueManager($registry, $urlRouter, states, builder, listeners) {
	        this.$registry = $registry;
	        this.$urlRouter = $urlRouter;
	        this.states = states;
	        this.builder = builder;
	        this.listeners = listeners;
	        this.queue = [];
	    }
	    /** @internalapi */
	    StateQueueManager.prototype.dispose = function () {
	        this.queue = [];
	    };
	    StateQueueManager.prototype.register = function (config) {
	        var _a = this, states = _a.states, queue = _a.queue;
	        // Wrap a new object around the state so we can store our private details easily.
	        // @TODO: state = new State(extend({}, config, { ... }))
	        var state = common_1.inherit(new stateObject_1.State(), common_1.extend({}, config, {
	            self: config,
	            resolve: config.resolve || [],
	            toString: function () { return config.name; }
	        }));
	        if (!predicates_1.isString(state.name))
	            throw new Error("State must have a valid name");
	        if (states.hasOwnProperty(state.name) || common_1.pluck(queue, 'name').indexOf(state.name) !== -1)
	            throw new Error("State '" + state.name + "' is already defined");
	        queue.push(state);
	        this.flush();
	        return state;
	    };
	    StateQueueManager.prototype.flush = function () {
	        var _a = this, queue = _a.queue, states = _a.states, builder = _a.builder;
	        var registered = [], // states that got registered
	        orphans = [], // states that don't yet have a parent registered
	        previousQueueLength = {}; // keep track of how long the queue when an orphan was first encountered
	        while (queue.length > 0) {
	            var state = queue.shift();
	            var result = builder.build(state);
	            var orphanIdx = orphans.indexOf(state);
	            if (result) {
	                var existingState = this.$registry.get(state.name);
	                if (existingState && existingState.name === state.name) {
	                    throw new Error("State '" + state.name + "' is already defined");
	                }
	                if (existingState && existingState.name === state.name + ".**") {
	                    // Remove future state of the same name
	                    this.$registry.deregister(existingState);
	                }
	                states[state.name] = state;
	                this.attachRoute(state);
	                if (orphanIdx >= 0)
	                    orphans.splice(orphanIdx, 1);
	                registered.push(state);
	                continue;
	            }
	            var prev = previousQueueLength[state.name];
	            previousQueueLength[state.name] = queue.length;
	            if (orphanIdx >= 0 && prev === queue.length) {
	                // Wait until two consecutive iterations where no additional states were dequeued successfully.
	                // throw new Error(`Cannot register orphaned state '${state.name}'`);
	                queue.push(state);
	                return states;
	            }
	            else if (orphanIdx < 0) {
	                orphans.push(state);
	            }
	            queue.push(state);
	        }
	        if (registered.length) {
	            this.listeners.forEach(function (listener) { return listener("registered", registered.map(function (s) { return s.self; })); });
	        }
	        return states;
	    };
	    StateQueueManager.prototype.attachRoute = function (state) {
	        if (state.abstract || !state.url)
	            return;
	        this.$urlRouter.rule(this.$urlRouter.urlRuleFactory.create(state));
	    };
	    return StateQueueManager;
	}());
	exports.StateQueueManager = StateQueueManager;
	//# sourceMappingURL=stateQueueManager.js.map

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @coreapi
	 * @module state
	 */ /** */
	var common_1 = __webpack_require__(305);
	var predicates_1 = __webpack_require__(306);
	var queue_1 = __webpack_require__(310);
	var coreservices_1 = __webpack_require__(308);
	var pathFactory_1 = __webpack_require__(323);
	var node_1 = __webpack_require__(320);
	var transitionService_1 = __webpack_require__(334);
	var rejectFactory_1 = __webpack_require__(312);
	var targetState_1 = __webpack_require__(317);
	var param_1 = __webpack_require__(321);
	var glob_1 = __webpack_require__(309);
	var resolveContext_1 = __webpack_require__(325);
	var lazyLoad_1 = __webpack_require__(340);
	var hof_1 = __webpack_require__(307);
	/**
	 * Provides state related service functions
	 *
	 * This class provides services related to ui-router states.
	 * An instance of this class is located on the global [[UIRouter]] object.
	 */
	var StateService = (function () {
	    /** @internalapi */
	    function StateService(router) {
	        this.router = router;
	        /** @internalapi */
	        this.invalidCallbacks = [];
	        /** @hidden */
	        this._defaultErrorHandler = function $defaultErrorHandler($error$) {
	            if ($error$ instanceof Error && $error$.stack) {
	                console.error($error$);
	                console.error($error$.stack);
	            }
	            else if ($error$ instanceof rejectFactory_1.Rejection) {
	                console.error($error$.toString());
	                if ($error$.detail && $error$.detail.stack)
	                    console.error($error$.detail.stack);
	            }
	            else {
	                console.error($error$);
	            }
	        };
	        var getters = ['current', '$current', 'params', 'transition'];
	        var boundFns = Object.keys(StateService.prototype).filter(hof_1.not(common_1.inArray(getters)));
	        common_1.createProxyFunctions(hof_1.val(StateService.prototype), this, hof_1.val(this), boundFns);
	    }
	    Object.defineProperty(StateService.prototype, "transition", {
	        /**
	         * The [[Transition]] currently in progress (or null)
	         *
	         * This is a passthrough through to [[UIRouterGlobals.transition]]
	         */
	        get: function () { return this.router.globals.transition; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "params", {
	        /**
	         * The latest successful state parameters
	         *
	         * This is a passthrough through to [[UIRouterGlobals.params]]
	         */
	        get: function () { return this.router.globals.params; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "current", {
	        /**
	         * The current [[StateDeclaration]]
	         *
	         * This is a passthrough through to [[UIRouterGlobals.current]]
	         */
	        get: function () { return this.router.globals.current; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "$current", {
	        /**
	         * The current [[State]]
	         *
	         * This is a passthrough through to [[UIRouterGlobals.$current]]
	         */
	        get: function () { return this.router.globals.$current; },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internalapi */
	    StateService.prototype.dispose = function () {
	        this.defaultErrorHandler(common_1.noop);
	        this.invalidCallbacks = [];
	    };
	    /**
	     * Handler for when [[transitionTo]] is called with an invalid state.
	     *
	     * Invokes the [[onInvalid]] callbacks, in natural order.
	     * Each callback's return value is checked in sequence until one of them returns an instance of TargetState.
	     * The results of the callbacks are wrapped in $q.when(), so the callbacks may return promises.
	     *
	     * If a callback returns an TargetState, then it is used as arguments to $state.transitionTo() and the result returned.
	     *
	     * @internalapi
	     */
	    StateService.prototype._handleInvalidTargetState = function (fromPath, toState) {
	        var _this = this;
	        var fromState = pathFactory_1.PathFactory.makeTargetState(fromPath);
	        var globals = this.router.globals;
	        var latestThing = function () { return globals.transitionHistory.peekTail(); };
	        var latest = latestThing();
	        var callbackQueue = new queue_1.Queue(this.invalidCallbacks.slice());
	        var injector = new resolveContext_1.ResolveContext(fromPath).injector();
	        var checkForRedirect = function (result) {
	            if (!(result instanceof targetState_1.TargetState)) {
	                return;
	            }
	            var target = result;
	            // Recreate the TargetState, in case the state is now defined.
	            target = _this.target(target.identifier(), target.params(), target.options());
	            if (!target.valid())
	                return rejectFactory_1.Rejection.invalid(target.error()).toPromise();
	            if (latestThing() !== latest)
	                return rejectFactory_1.Rejection.superseded().toPromise();
	            return _this.transitionTo(target.identifier(), target.params(), target.options());
	        };
	        function invokeNextCallback() {
	            var nextCallback = callbackQueue.dequeue();
	            if (nextCallback === undefined)
	                return rejectFactory_1.Rejection.invalid(toState.error()).toPromise();
	            var callbackResult = coreservices_1.services.$q.when(nextCallback(toState, fromState, injector));
	            return callbackResult.then(checkForRedirect).then(function (result) { return result || invokeNextCallback(); });
	        }
	        return invokeNextCallback();
	    };
	    /**
	     * Registers an Invalid State handler
	     *
	     * Registers a [[OnInvalidCallback]] function to be invoked when [[StateService.transitionTo]]
	     * has been called with an invalid state reference parameter
	     *
	     * Example:
	     * ```js
	     * stateService.onInvalid(function(to, from, injector) {
	     *   if (to.name() === 'foo') {
	     *     let lazyLoader = injector.get('LazyLoadService');
	     *     return lazyLoader.load('foo')
	     *         .then(() => stateService.target('foo'));
	     *   }
	     * });
	     * ```
	     *
	     * @param {function} callback invoked when the toState is invalid
	     *   This function receives the (invalid) toState, the fromState, and an injector.
	     *   The function may optionally return a [[TargetState]] or a Promise for a TargetState.
	     *   If one is returned, it is treated as a redirect.
	     *
	     * @returns a function which deregisters the callback
	     */
	    StateService.prototype.onInvalid = function (callback) {
	        this.invalidCallbacks.push(callback);
	        return function deregisterListener() {
	            common_1.removeFrom(this.invalidCallbacks)(callback);
	        }.bind(this);
	    };
	    /**
	     * Reloads the current state
	     *
	     * A method that force reloads the current state, or a partial state hierarchy.
	     * All resolves are re-resolved, and components reinstantiated.
	     *
	     * #### Example:
	     * ```js
	     * let app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     $state.reload();
	     *   }
	     * });
	     * ```
	     *
	     * Note: `reload()` is just an alias for:
	     *
	     * ```js
	     * $state.transitionTo($state.current, $state.params, {
	     *   reload: true, inherit: false
	     * });
	     * ```
	     *
	     * @param reloadState A state name or a state object.
	     *    If present, this state and all its children will be reloaded, but ancestors will not reload.
	     *
	     * #### Example:
	     * ```js
	     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item'
	     * //and current state is 'contacts.detail.item'
	     * let app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     //will reload 'contact.detail' and nested 'contact.detail.item' states
	     *     $state.reload('contact.detail');
	     *   }
	     * });
	     * ```
	     *
	     * @returns A promise representing the state of the new transition. See [[StateService.go]]
	     */
	    StateService.prototype.reload = function (reloadState) {
	        return this.transitionTo(this.current, this.params, {
	            reload: predicates_1.isDefined(reloadState) ? reloadState : true,
	            inherit: false,
	            notify: false
	        });
	    };
	    ;
	    /**
	     * Transition to a different state or parameters
	     *
	     * Convenience method for transitioning to a new state.
	     *
	     * `$state.go` calls `$state.transitionTo` internally but automatically sets options to
	     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`.
	     * This allows you to easily use an absolute or relative to path and specify
	     * only the parameters you'd like to update (while letting unspecified parameters
	     * inherit from the currently active ancestor states).
	     *
	     * #### Example:
	     * ```js
	     * let app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.go('contact.detail');
	     *   };
	     * });
	     * ```
	     *
	     *
	     * @param to Absolute state name, state object, or relative state path. Some examples:
	     *
	     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
	     * - `$state.go('^')` - will go to a parent state
	     * - `$state.go('^.sibling')` - will go to a sibling state
	     * - `$state.go('.child.grandchild')` - will go to grandchild state
	     *
	     * @param params A map of the parameters that will be sent to the state, will populate $stateParams.
	     *
	     *    Any parameters that are not specified will be inherited from currently defined parameters (because of `inherit: true`).
	     *    This allows, for example, going to a sibling state that shares parameters specified in a parent state.
	     *
	     *    Parameter inheritance only works between common ancestor states, I.e.
	     *    transitioning to a sibling will get you the parameters for all parents, transitioning to a child
	     *    will get you all current parameters, etc.
	     *
	     * @param options Transition options
	     *
	     * @returns {promise} A promise representing the state of the new transition.
	     *
	     * - Possible success values:
	     *    - $state.current
	     *
	     * - Possible rejection reasons:
	     *   - transition superseded - when a newer transition has been started after this one
	     *   - transition aborted - when the transition is cancelled by a Transition Hook returning `false`
	     *   - transition failed - when a transition hook errors
	     *   - resolve error - when a resolve has errored or rejected
	     *
	     */
	    StateService.prototype.go = function (to, params, options) {
	        var defautGoOpts = { relative: this.$current, inherit: true };
	        var transOpts = common_1.defaults(options, defautGoOpts, transitionService_1.defaultTransOpts);
	        return this.transitionTo(to, params, transOpts);
	    };
	    ;
	    /**
	     * Creates a [[TargetState]]
	     *
	     * This is a factory method for creating a TargetState
	     *
	     * This may be returned from a Transition Hook to redirect a transition, for example.
	     */
	    StateService.prototype.target = function (identifier, params, options) {
	        if (options === void 0) { options = {}; }
	        // If we're reloading, find the state object to reload from
	        if (predicates_1.isObject(options.reload) && !options.reload.name)
	            throw new Error('Invalid reload state object');
	        var reg = this.router.stateRegistry;
	        options.reloadState = options.reload === true ? reg.root() : reg.matcher.find(options.reload, options.relative);
	        if (options.reload && !options.reloadState)
	            throw new Error("No such reload state '" + (predicates_1.isString(options.reload) ? options.reload : options.reload.name) + "'");
	        var stateDefinition = reg.matcher.find(identifier, options.relative);
	        return new targetState_1.TargetState(identifier, stateDefinition, params, options);
	    };
	    ;
	    StateService.prototype.getCurrentPath = function () {
	        var _this = this;
	        var globals = this.router.globals;
	        var latestSuccess = globals.successfulTransitions.peekTail();
	        var rootPath = function () { return [new node_1.PathNode(_this.router.stateRegistry.root())]; };
	        return latestSuccess ? latestSuccess.treeChanges().to : rootPath();
	    };
	    /**
	     * Low-level method for transitioning to a new state.
	     *
	     * The [[go]] method (which uses `transitionTo` internally) is recommended in most situations.
	     *
	     * #### Example:
	     * ```js
	     * let app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.transitionTo('contact.detail');
	     *   };
	     * });
	     * ```
	     *
	     * @param to State name or state object.
	     * @param toParams A map of the parameters that will be sent to the state,
	     *      will populate $stateParams.
	     * @param options Transition options
	     *
	     * @returns A promise representing the state of the new transition. See [[go]]
	     */
	    StateService.prototype.transitionTo = function (to, toParams, options) {
	        var _this = this;
	        if (toParams === void 0) { toParams = {}; }
	        if (options === void 0) { options = {}; }
	        var router = this.router;
	        var globals = router.globals;
	        var transHistory = globals.transitionHistory;
	        options = common_1.defaults(options, transitionService_1.defaultTransOpts);
	        options = common_1.extend(options, { current: transHistory.peekTail.bind(transHistory) });
	        var ref = this.target(to, toParams, options);
	        var currentPath = this.getCurrentPath();
	        if (!ref.exists())
	            return this._handleInvalidTargetState(currentPath, ref);
	        if (!ref.valid())
	            return common_1.silentRejection(ref.error());
	        /**
	         * Special handling for Ignored, Aborted, and Redirected transitions
	         *
	         * The semantics for the transition.run() promise and the StateService.transitionTo()
	         * promise differ. For instance, the run() promise may be rejected because it was
	         * IGNORED, but the transitionTo() promise is resolved because from the user perspective
	         * no error occurred.  Likewise, the transition.run() promise may be rejected because of
	         * a Redirect, but the transitionTo() promise is chained to the new Transition's promise.
	         */
	        var rejectedTransitionHandler = function (transition) { return function (error) {
	            if (error instanceof rejectFactory_1.Rejection) {
	                if (error.type === rejectFactory_1.RejectType.IGNORED) {
	                    // Consider ignored `Transition.run()` as a successful `transitionTo`
	                    router.urlRouter.update();
	                    return coreservices_1.services.$q.when(globals.current);
	                }
	                var detail = error.detail;
	                if (error.type === rejectFactory_1.RejectType.SUPERSEDED && error.redirected && detail instanceof targetState_1.TargetState) {
	                    // If `Transition.run()` was redirected, allow the `transitionTo()` promise to resolve successfully
	                    // by returning the promise for the new (redirect) `Transition.run()`.
	                    var redirect = transition.redirect(detail);
	                    return redirect.run().catch(rejectedTransitionHandler(redirect));
	                }
	                if (error.type === rejectFactory_1.RejectType.ABORTED) {
	                    router.urlRouter.update();
	                }
	            }
	            var errorHandler = _this.defaultErrorHandler();
	            errorHandler(error);
	            return coreservices_1.services.$q.reject(error);
	        }; };
	        var transition = this.router.transitionService.create(currentPath, ref);
	        var transitionToPromise = transition.run().catch(rejectedTransitionHandler(transition));
	        common_1.silenceUncaughtInPromise(transitionToPromise); // issue #2676
	        // Return a promise for the transition, which also has the transition object on it.
	        return common_1.extend(transitionToPromise, { transition: transition });
	    };
	    ;
	    /**
	     * Checks if the current state *is* the provided state
	     *
	     * Similar to [[includes]] but only checks for the full state name.
	     * If params is supplied then it will be tested for strict equality against the current
	     * active params object, so all params must match with none missing and no extras.
	     *
	     * #### Example:
	     * ```js
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // absolute name
	     * $state.is('contact.details.item'); // returns true
	     * $state.is(contactDetailItemStateObject); // returns true
	     * ```
	     *
	     * // relative name (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * ```html
	     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
	     * ```
	     *
	     * @param stateOrName The state name (absolute or relative) or state object you'd like to check.
	     * @param params A param object, e.g. `{sectionId: section.id}`, that you'd like
	     * to test against the current active state.
	     * @param options An options object. The options are:
	     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     *     test relative to `options.relative` state (or name).
	     *
	     * @returns Returns true if it is the state.
	     */
	    StateService.prototype.is = function (stateOrName, params, options) {
	        options = common_1.defaults(options, { relative: this.$current });
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
	        if (!predicates_1.isDefined(state))
	            return undefined;
	        if (this.$current !== state)
	            return false;
	        if (!params)
	            return true;
	        var schema = state.parameters({ inherit: true, matchingKeys: params });
	        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
	    };
	    ;
	    /**
	     * Checks if the current state *includes* the provided state
	     *
	     * A method to determine if the current active state is equal to or is the child of the
	     * state stateName. If any params are passed then they will be tested for a match as well.
	     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
	     *
	     * #### Example when `$state.$current.name === 'contacts.details.item'`
	     * ```js
	     * // Using partial names
	     * $state.includes("contacts"); // returns true
	     * $state.includes("contacts.details"); // returns true
	     * $state.includes("contacts.details.item"); // returns true
	     * $state.includes("contacts.list"); // returns false
	     * $state.includes("about"); // returns false
	     * ```
	     *
	     * #### Glob Examples when `* $state.$current.name === 'contacts.details.item.url'`:
	     * ```js
	     * $state.includes("*.details.*.*"); // returns true
	     * $state.includes("*.details.**"); // returns true
	     * $state.includes("**.item.**"); // returns true
	     * $state.includes("*.details.item.url"); // returns true
	     * $state.includes("*.details.*.url"); // returns true
	     * $state.includes("*.details.*"); // returns false
	     * $state.includes("item.**"); // returns false
	     * ```
	     *
	     * @param stateOrName A partial name, relative name, glob pattern,
	     *   or state object to be searched for within the current state name.
	     * @param params A param object, e.g. `{sectionId: section.id}`,
	     *   that you'd like to test against the current active state.
	     * @param options An options object. The options are:
	     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     *     test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it does include the state
	     */
	    StateService.prototype.includes = function (stateOrName, params, options) {
	        options = common_1.defaults(options, { relative: this.$current });
	        var glob = predicates_1.isString(stateOrName) && glob_1.Glob.fromString(stateOrName);
	        if (glob) {
	            if (!glob.matches(this.$current.name))
	                return false;
	            stateOrName = this.$current.name;
	        }
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative), include = this.$current.includes;
	        if (!predicates_1.isDefined(state))
	            return undefined;
	        if (!predicates_1.isDefined(include[state.name]))
	            return false;
	        if (!params)
	            return true;
	        var schema = state.parameters({ inherit: true, matchingKeys: params });
	        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
	    };
	    ;
	    /**
	     * Generates a URL for a state and parameters
	     *
	     * Returns the url for the given state populated with the given params.
	     *
	     * #### Example:
	     * ```js
	     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
	     * ```
	     *
	     * @param stateOrName The state name or state object you'd like to generate a url from.
	     * @param params An object of parameter values to fill the state's required parameters.
	     * @param options Options object. The options are:
	     *
	     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
	     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
	     *    ancestor with a valid url).
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'),
	     *    defines which state to be relative from.
	     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	     *
	     * @returns {string} compiled state url
	     */
	    StateService.prototype.href = function (stateOrName, params, options) {
	        var defaultHrefOpts = {
	            lossy: true,
	            inherit: true,
	            absolute: false,
	            relative: this.$current
	        };
	        options = common_1.defaults(options, defaultHrefOpts);
	        params = params || {};
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
	        if (!predicates_1.isDefined(state))
	            return null;
	        if (options.inherit)
	            params = this.params.$inherit(params, this.$current, state);
	        var nav = (state && options.lossy) ? state.navigable : state;
	        if (!nav || nav.url === undefined || nav.url === null) {
	            return null;
	        }
	        return this.router.urlRouter.href(nav.url, param_1.Param.values(state.parameters(), params), {
	            absolute: options.absolute
	        });
	    };
	    ;
	    /**
	     * Sets or gets the default [[transitionTo]] error handler.
	     *
	     * The error handler is called when a [[Transition]] is rejected or when any error occurred during the Transition.
	     * This includes errors caused by resolves and transition hooks.
	     *
	     * Note:
	     * This handler does not receive certain Transition rejections.
	     * Redirected and Ignored Transitions are not considered to be errors by [[StateService.transitionTo]].
	     *
	     * The built-in default error handler logs the error to the console.
	     *
	     * You can provide your own custom handler.
	     *
	     * #### Example:
	     * ```js
	     * stateService.defaultErrorHandler(function() {
	     *   // Do not log transitionTo errors
	     * });
	     * ```
	     *
	     * @param handler a global error handler function
	     * @returns the current global error handler
	     */
	    StateService.prototype.defaultErrorHandler = function (handler) {
	        return this._defaultErrorHandler = handler || this._defaultErrorHandler;
	    };
	    StateService.prototype.get = function (stateOrName, base) {
	        var reg = this.router.stateRegistry;
	        if (arguments.length === 0)
	            return reg.get();
	        return reg.get(stateOrName, base || this.$current);
	    };
	    /**
	     * Lazy loads a state
	     *
	     * Explicitly runs a state's [[StateDeclaration.lazyLoad]] function.
	     *
	     * @param stateOrName the state that should be lazy loaded
	     * @param transition the optional Transition context to use (if the lazyLoad function requires an injector, etc)
	     * Note: If no transition is provided, a noop transition is created using the from the current state to the current state.
	     * This noop transition is not actually run.
	     *
	     * @returns a promise to lazy load
	     */
	    StateService.prototype.lazyLoad = function (stateOrName, transition) {
	        var state = this.get(stateOrName);
	        if (!state || !state.lazyLoad)
	            throw new Error("Can not lazy load " + stateOrName);
	        var currentPath = this.getCurrentPath();
	        var target = pathFactory_1.PathFactory.makeTargetState(currentPath);
	        transition = transition || this.router.transitionService.create(currentPath, target);
	        return lazyLoad_1.lazyLoadState(transition, state);
	    };
	    return StateService;
	}());
	exports.StateService = StateService;
	//# sourceMappingURL=stateService.js.map

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @coreapi
	 * @module core
	 */ /** */
	var stateParams_1 = __webpack_require__(349);
	var queue_1 = __webpack_require__(310);
	var common_1 = __webpack_require__(305);
	/**
	 * Global mutable state
	 */
	var Globals = (function () {
	    function Globals(transitionService) {
	        var _this = this;
	        this.params = new stateParams_1.StateParams();
	        this.transitionHistory = new queue_1.Queue([], 1);
	        this.successfulTransitions = new queue_1.Queue([], 1);
	        var beforeNewTransition = function ($transition$) {
	            _this.transition = $transition$;
	            _this.transitionHistory.enqueue($transition$);
	            var updateGlobalState = function () {
	                _this.successfulTransitions.enqueue($transition$);
	                _this.$current = $transition$.$to();
	                _this.current = _this.$current.self;
	                common_1.copy($transition$.params(), _this.params);
	            };
	            $transition$.onSuccess({}, updateGlobalState, { priority: 10000 });
	            var clearCurrentTransition = function () { if (_this.transition === $transition$)
	                _this.transition = null; };
	            $transition$.promise.then(clearCurrentTransition, clearCurrentTransition);
	        };
	        transitionService.onBefore({}, beforeNewTransition);
	    }
	    return Globals;
	}());
	exports.Globals = Globals;
	//# sourceMappingURL=globals.js.map

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/** @module params */ /** for typedoc */
	var common_1 = __webpack_require__(305);
	var StateParams = (function () {
	    function StateParams(params) {
	        if (params === void 0) { params = {}; }
	        common_1.extend(this, params);
	    }
	    /**
	     * Merges a set of parameters with all parameters inherited between the common parents of the
	     * current state and a given destination state.
	     *
	     * @param {Object} newParams The set of parameters which will be composited with inherited params.
	     * @param {Object} $current Internal definition of object representing the current state.
	     * @param {Object} $to Internal definition of object representing state to transition to.
	     */
	    StateParams.prototype.$inherit = function (newParams, $current, $to) {
	        var parents = common_1.ancestors($current, $to), parentParams, inherited = {}, inheritList = [];
	        for (var i in parents) {
	            if (!parents[i] || !parents[i].params)
	                continue;
	            parentParams = Object.keys(parents[i].params);
	            if (!parentParams.length)
	                continue;
	            for (var j in parentParams) {
	                if (inheritList.indexOf(parentParams[j]) >= 0)
	                    continue;
	                inheritList.push(parentParams[j]);
	                inherited[parentParams[j]] = this[parentParams[j]];
	            }
	        }
	        return common_1.extend({}, inherited, newParams);
	    };
	    ;
	    return StateParams;
	}());
	exports.StateParams = StateParams;
	//# sourceMappingURL=stateParams.js.map

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @coreapi
	 * @module url
	 */ /** */
	"use strict";
	var coreservices_1 = __webpack_require__(308);
	var common_1 = __webpack_require__(305);
	/** @hidden */
	var makeStub = function (keys) {
	    return keys.reduce(function (acc, key) { return (acc[key] = coreservices_1.notImplemented(key), acc); }, { dispose: common_1.noop });
	};
	/** @hidden */ var locationServicesFns = ["url", "path", "search", "hash", "onChange"];
	/** @hidden */ var locationConfigFns = ["port", "protocol", "host", "baseHref", "html5Mode", "hashPrefix"];
	/** @hidden */ var umfFns = ["type", "caseInsensitive", "strictMode", "defaultSquashPolicy"];
	/** @hidden */ var rulesFns = ["sort", "when", "otherwise", "rules", "rule", "removeRule"];
	/** @hidden */ var syncFns = ["deferIntercept", "listen", "sync", "match"];
	/**
	 * API for URL management
	 */
	var UrlService = (function () {
	    /** @hidden */
	    function UrlService(router, lateBind) {
	        if (lateBind === void 0) { lateBind = true; }
	        this.router = router;
	        this.rules = {};
	        this.config = {};
	        // proxy function calls from UrlService to the LocationService/LocationConfig
	        var locationServices = function () { return router.locationService; };
	        common_1.createProxyFunctions(locationServices, this, locationServices, locationServicesFns, lateBind);
	        var locationConfig = function () { return router.locationConfig; };
	        common_1.createProxyFunctions(locationConfig, this.config, locationConfig, locationConfigFns, lateBind);
	        var umf = function () { return router.urlMatcherFactory; };
	        common_1.createProxyFunctions(umf, this.config, umf, umfFns);
	        var urlRouter = function () { return router.urlRouter; };
	        common_1.createProxyFunctions(urlRouter, this.rules, urlRouter, rulesFns);
	        common_1.createProxyFunctions(urlRouter, this, urlRouter, syncFns);
	    }
	    UrlService.prototype.url = function (newurl, replace, state) { return; };
	    ;
	    /** @inheritdoc */
	    UrlService.prototype.path = function () { return; };
	    ;
	    /** @inheritdoc */
	    UrlService.prototype.search = function () { return; };
	    ;
	    /** @inheritdoc */
	    UrlService.prototype.hash = function () { return; };
	    ;
	    /** @inheritdoc */
	    UrlService.prototype.onChange = function (callback) { return; };
	    ;
	    /**
	     * Returns the current URL parts
	     *
	     * This method returns the current URL components as a [[UrlParts]] object.
	     *
	     * @returns the current url parts
	     */
	    UrlService.prototype.parts = function () {
	        return { path: this.path(), search: this.search(), hash: this.hash() };
	    };
	    UrlService.prototype.dispose = function () { };
	    /** @inheritdoc */
	    UrlService.prototype.sync = function (evt) { return; };
	    /** @inheritdoc */
	    UrlService.prototype.listen = function (enabled) { return; };
	    ;
	    /** @inheritdoc */
	    UrlService.prototype.deferIntercept = function (defer) { return; };
	    /** @inheritdoc */
	    UrlService.prototype.match = function (urlParts) { return; };
	    return UrlService;
	}());
	/** @hidden */
	UrlService.locationServiceStub = makeStub(locationServicesFns);
	/** @hidden */
	UrlService.locationConfigStub = makeStub(locationConfigFns);
	exports.UrlService = UrlService;
	//# sourceMappingURL=urlService.js.map

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(321));
	__export(__webpack_require__(330));
	__export(__webpack_require__(349));
	__export(__webpack_require__(322));
	//# sourceMappingURL=index.js.map

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	/** @module path */ /** for typedoc */
	__export(__webpack_require__(320));
	__export(__webpack_require__(323));
	//# sourceMappingURL=index.js.map

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	/** @module resolve */ /** for typedoc */
	__export(__webpack_require__(326));
	__export(__webpack_require__(324));
	__export(__webpack_require__(325));
	//# sourceMappingURL=index.js.map

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(345));
	__export(__webpack_require__(333));
	__export(__webpack_require__(344));
	__export(__webpack_require__(346));
	__export(__webpack_require__(343));
	__export(__webpack_require__(347));
	__export(__webpack_require__(317));
	//# sourceMappingURL=index.js.map

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	/**
	 * This module contains APIs related to a Transition.
	 *
	 * See:
	 * - [[TransitionService]]
	 * - [[Transition]]
	 * - [[HookFn]], [[TransitionHookFn]], [[TransitionStateHookFn]], [[HookMatchCriteria]], [[HookResult]]
	 *
	 * @coreapi
	 * @preferred
	 * @module transition
	 */ /** for typedoc */
	__export(__webpack_require__(315));
	__export(__webpack_require__(319));
	__export(__webpack_require__(318));
	__export(__webpack_require__(312));
	__export(__webpack_require__(313));
	__export(__webpack_require__(316));
	__export(__webpack_require__(341));
	__export(__webpack_require__(334));
	//# sourceMappingURL=index.js.map

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(329));
	__export(__webpack_require__(328));
	__export(__webpack_require__(331));
	__export(__webpack_require__(332));
	__export(__webpack_require__(350));
	//# sourceMappingURL=index.js.map

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(342));
	//# sourceMappingURL=index.js.map

/***/ },
/* 358 */
/***/ function(module, exports) {

	/**
	 * Core classes and interfaces
	 *
	 * The classes and interfaces that are core to ui-router and do not belong
	 * to a more specific subsystem (such as resolve).
	 *
	 * @coreapi
	 * @preferred
	 * @module core
	 */ /** for typedoc */
	"use strict";
	var UIRouterPluginBase = (function () {
	    function UIRouterPluginBase() {
	    }
	    UIRouterPluginBase.prototype.dispose = function (router) { };
	    return UIRouterPluginBase;
	}());
	exports.UIRouterPluginBase = UIRouterPluginBase;
	//# sourceMappingURL=interface.js.map

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * # UI-Router for Angular 1
	 *
	 * - Provides an implementation for the [[CoreServices]] API, based on angular 1 services.
	 * - Also registers some services with the angular 1 injector.
	 * - Creates and bootstraps a new [[UIRouter]] object.  Ties it to the the angular 1 lifecycle.
	 *
	 * @module ng1
	 * @preferred
	 */
	/** for typedoc */
	var angular_1 = __webpack_require__(360);
	var ui_router_core_1 = __webpack_require__(303);
	var views_1 = __webpack_require__(361);
	var templateFactory_1 = __webpack_require__(362);
	var stateProvider_1 = __webpack_require__(363);
	var onEnterExitRetain_1 = __webpack_require__(364);
	var locationServices_1 = __webpack_require__(365);
	var urlRouterProvider_1 = __webpack_require__(366);
	angular_1.ng.module("ui.router.angular1", []);
	var mod_init = angular_1.ng.module('ui.router.init', []);
	var mod_util = angular_1.ng.module('ui.router.util', ['ng', 'ui.router.init']);
	var mod_rtr = angular_1.ng.module('ui.router.router', ['ui.router.util']);
	var mod_state = angular_1.ng.module('ui.router.state', ['ui.router.router', 'ui.router.util', 'ui.router.angular1']);
	var mod_main = angular_1.ng.module('ui.router', ['ui.router.init', 'ui.router.state', 'ui.router.angular1']);
	var mod_cmpt = angular_1.ng.module('ui.router.compat', ['ui.router']);
	var router = null;
	$uiRouter.$inject = ['$locationProvider'];
	/** This angular 1 provider instantiates a Router and exposes its services via the angular injector */
	function $uiRouter($locationProvider) {
	    // Create a new instance of the Router when the $uiRouterProvider is initialized
	    router = this.router = new ui_router_core_1.UIRouter();
	    router.stateProvider = new stateProvider_1.StateProvider(router.stateRegistry, router.stateService);
	    // Apply ng1 specific StateBuilder code for `views`, `resolve`, and `onExit/Retain/Enter` properties
	    router.stateRegistry.decorator("views", views_1.ng1ViewsBuilder);
	    router.stateRegistry.decorator("onExit", onEnterExitRetain_1.getStateHookBuilder("onExit"));
	    router.stateRegistry.decorator("onRetain", onEnterExitRetain_1.getStateHookBuilder("onRetain"));
	    router.stateRegistry.decorator("onEnter", onEnterExitRetain_1.getStateHookBuilder("onEnter"));
	    router.viewService._pluginapi._viewConfigFactory('ng1', views_1.getNg1ViewConfigFactory());
	    var ng1LocationService = router.locationService = router.locationConfig = new locationServices_1.Ng1LocationServices($locationProvider);
	    locationServices_1.Ng1LocationServices.monkeyPatchPathParameterType(router);
	    // backwards compat: also expose router instance as $uiRouterProvider.router
	    router['router'] = router;
	    router['$get'] = $get;
	    $get.$inject = ['$location', '$browser', '$sniffer', '$rootScope', '$http', '$templateCache'];
	    function $get($location, $browser, $sniffer, $rootScope, $http, $templateCache) {
	        ng1LocationService._runtimeServices($rootScope, $location, $sniffer, $browser);
	        delete router['router'];
	        delete router['$get'];
	        return router;
	    }
	    return router;
	}
	var getProviderFor = function (serviceName) { return ['$uiRouterProvider', function ($urp) {
	        var service = $urp.router[serviceName];
	        service["$get"] = function () { return service; };
	        return service;
	    }]; };
	// This effectively calls $get() on `$uiRouterProvider` to trigger init (when ng enters runtime)
	runBlock.$inject = ['$injector', '$q', '$uiRouter'];
	function runBlock($injector, $q, $uiRouter) {
	    ui_router_core_1.services.$injector = $injector;
	    ui_router_core_1.services.$q = $q;
	    // The $injector is now available.
	    // Find any resolvables that had dependency annotation deferred
	    $uiRouter.stateRegistry.get()
	        .map(function (x) { return x.$$state().resolvables; })
	        .reduce(ui_router_core_1.unnestR, [])
	        .filter(function (x) { return x.deps === "deferred"; })
	        .forEach(function (resolvable) { return resolvable.deps = $injector.annotate(resolvable.resolveFn); });
	}
	// $urlRouter service and $urlRouterProvider
	var getUrlRouterProvider = function (router) {
	    return router.urlRouterProvider = new urlRouterProvider_1.UrlRouterProvider(router);
	};
	// $state service and $stateProvider
	// $urlRouter service and $urlRouterProvider
	var getStateProvider = function () {
	    return ui_router_core_1.extend(router.stateProvider, { $get: function () { return router.stateService; } });
	};
	watchDigests.$inject = ['$rootScope'];
	function watchDigests($rootScope) {
	    $rootScope.$watch(function () { ui_router_core_1.trace.approximateDigests++; });
	}
	exports.watchDigests = watchDigests;
	mod_init.provider("$uiRouter", $uiRouter);
	mod_rtr.provider('$urlRouter', ['$uiRouterProvider', getUrlRouterProvider]);
	mod_util.provider('$urlService', getProviderFor('urlService'));
	mod_util.provider('$urlMatcherFactory', ['$uiRouterProvider', function () { return router.urlMatcherFactory; }]);
	mod_util.provider('$templateFactory', function () { return new templateFactory_1.TemplateFactory(); });
	mod_state.provider('$stateRegistry', getProviderFor('stateRegistry'));
	mod_state.provider('$uiRouterGlobals', getProviderFor('globals'));
	mod_state.provider('$transitions', getProviderFor('transitionService'));
	mod_state.provider('$state', ['$uiRouterProvider', getStateProvider]);
	mod_state.factory('$stateParams', ['$uiRouter', function ($uiRouter) { return $uiRouter.globals.params; }]);
	mod_main.factory('$view', function () { return router.viewService; });
	mod_main.service("$trace", function () { return ui_router_core_1.trace; });
	mod_main.run(watchDigests);
	mod_util.run(['$urlMatcherFactory', function ($urlMatcherFactory) { }]);
	mod_state.run(['$state', function ($state) { }]);
	mod_rtr.run(['$urlRouter', function ($urlRouter) { }]);
	mod_init.run(runBlock);
	/** @hidden TODO: find a place to move this */
	exports.getLocals = function (ctx) {
	    var tokens = ctx.getTokens().filter(ui_router_core_1.isString);
	    var tuples = tokens.map(function (key) {
	        var resolvable = ctx.getResolvable(key);
	        var waitPolicy = ctx.getPolicy(resolvable).async;
	        return [key, waitPolicy === 'NOWAIT' ? resolvable.promise : resolvable.data];
	    });
	    return tuples.reduce(ui_router_core_1.applyPairs, {});
	};
	//# sourceMappingURL=services.js.map

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ng_from_import = __webpack_require__(299);
	var ng_from_global = angular;
	exports.ng = (ng_from_import && ng_from_import.module) ? ng_from_import : ng_from_global;
	//# sourceMappingURL=angular.js.map

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ui_router_core_1 = __webpack_require__(303);
	function getNg1ViewConfigFactory() {
	    var templateFactory = null;
	    return function (path, view) {
	        templateFactory = templateFactory || ui_router_core_1.services.$injector.get("$templateFactory");
	        return [new Ng1ViewConfig(path, view, templateFactory)];
	    };
	}
	exports.getNg1ViewConfigFactory = getNg1ViewConfigFactory;
	var hasAnyKey = function (keys, obj) {
	    return keys.reduce(function (acc, key) { return acc || ui_router_core_1.isDefined(obj[key]); }, false);
	};
	/**
	 * This is a [[StateBuilder.builder]] function for angular1 `views`.
	 *
	 * When the [[StateBuilder]] builds a [[State]] object from a raw [[StateDeclaration]], this builder
	 * handles the `views` property with logic specific to angular-ui-router (ng1).
	 *
	 * If no `views: {}` property exists on the [[StateDeclaration]], then it creates the `views` object
	 * and applies the state-level configuration to a view named `$default`.
	 */
	function ng1ViewsBuilder(state) {
	    // Do not process root state
	    if (!state.parent)
	        return {};
	    var tplKeys = ['templateProvider', 'templateUrl', 'template', 'notify', 'async'], ctrlKeys = ['controller', 'controllerProvider', 'controllerAs', 'resolveAs'], compKeys = ['component', 'bindings', 'componentProvider'], nonCompKeys = tplKeys.concat(ctrlKeys), allKeys = compKeys.concat(nonCompKeys);
	    var views = {}, viewsObject = state.views || { "$default": ui_router_core_1.pick(state, allKeys) };
	    ui_router_core_1.forEach(viewsObject, function (config, name) {
	        // Account for views: { "": { template... } }
	        name = name || "$default";
	        // Account for views: { header: "headerComponent" }
	        if (ui_router_core_1.isString(config))
	            config = { component: config };
	        if (hasAnyKey(compKeys, config) && hasAnyKey(nonCompKeys, config)) {
	            throw new Error("Cannot combine: " + compKeys.join("|") + " with: " + nonCompKeys.join("|") + " in stateview: '" + name + "@" + state.name + "'");
	        }
	        config.resolveAs = config.resolveAs || '$resolve';
	        config.$type = "ng1";
	        config.$context = state;
	        config.$name = name;
	        var normalized = ui_router_core_1.ViewService.normalizeUIViewTarget(config.$context, config.$name);
	        config.$uiViewName = normalized.uiViewName;
	        config.$uiViewContextAnchor = normalized.uiViewContextAnchor;
	        views[name] = config;
	    });
	    return views;
	}
	exports.ng1ViewsBuilder = ng1ViewsBuilder;
	var id = 0;
	var Ng1ViewConfig = (function () {
	    function Ng1ViewConfig(path, viewDecl, factory) {
	        var _this = this;
	        this.path = path;
	        this.viewDecl = viewDecl;
	        this.factory = factory;
	        this.$id = id++;
	        this.loaded = false;
	        this.getTemplate = function (uiView, context) {
	            return _this.component ? _this.factory.makeComponentTemplate(uiView, context, _this.component, _this.viewDecl.bindings) : _this.template;
	        };
	    }
	    Ng1ViewConfig.prototype.load = function () {
	        var _this = this;
	        var $q = ui_router_core_1.services.$q;
	        var context = new ui_router_core_1.ResolveContext(this.path);
	        var params = this.path.reduce(function (acc, node) { return ui_router_core_1.extend(acc, node.paramValues); }, {});
	        var promises = {
	            template: $q.when(this.factory.fromConfig(this.viewDecl, params, context)),
	            controller: $q.when(this.getController(context))
	        };
	        return $q.all(promises).then(function (results) {
	            ui_router_core_1.trace.traceViewServiceEvent("Loaded", _this);
	            _this.controller = results.controller;
	            ui_router_core_1.extend(_this, results.template); // Either { template: "tpl" } or { component: "cmpName" }
	            return _this;
	        });
	    };
	    /**
	     * Gets the controller for a view configuration.
	     *
	     * @returns {Function|Promise.<Function>} Returns a controller, or a promise that resolves to a controller.
	     */
	    Ng1ViewConfig.prototype.getController = function (context) {
	        var provider = this.viewDecl.controllerProvider;
	        if (!ui_router_core_1.isInjectable(provider))
	            return this.viewDecl.controller;
	        var deps = ui_router_core_1.services.$injector.annotate(provider);
	        var providerFn = ui_router_core_1.isArray(provider) ? ui_router_core_1.tail(provider) : provider;
	        var resolvable = new ui_router_core_1.Resolvable("", providerFn, deps);
	        return resolvable.get(context);
	    };
	    return Ng1ViewConfig;
	}());
	exports.Ng1ViewConfig = Ng1ViewConfig;
	//# sourceMappingURL=views.js.map

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/** @module view */
	/** for typedoc */
	var angular_1 = __webpack_require__(360);
	var ui_router_core_1 = __webpack_require__(303);
	/**
	 * Service which manages loading of templates from a ViewConfig.
	 */
	var TemplateFactory = (function () {
	    function TemplateFactory() {
	        var _this = this;
	        /** @hidden */ this._useHttp = angular_1.ng.version.minor < 3;
	        /** @hidden */ this.$get = ['$http', '$templateCache', '$injector', function ($http, $templateCache, $injector) {
	                _this.$templateRequest = $injector.has && $injector.has('$templateRequest') && $injector.get('$templateRequest');
	                _this.$http = $http;
	                _this.$templateCache = $templateCache;
	                return _this;
	            }];
	    }
	    /** @hidden */
	    TemplateFactory.prototype.useHttpService = function (value) {
	        this._useHttp = value;
	    };
	    ;
	    /**
	     * Creates a template from a configuration object.
	     *
	     * @param config Configuration object for which to load a template.
	     * The following properties are search in the specified order, and the first one
	     * that is defined is used to create the template:
	     *
	     * @param params  Parameters to pass to the template function.
	     * @param context The resolve context associated with the template's view
	     *
	     * @return {string|object}  The template html as a string, or a promise for
	     * that string,or `null` if no template is configured.
	     */
	    TemplateFactory.prototype.fromConfig = function (config, params, context) {
	        var defaultTemplate = "<ui-view></ui-view>";
	        var asTemplate = function (result) { return ui_router_core_1.services.$q.when(result).then(function (str) { return ({ template: str }); }); };
	        var asComponent = function (result) { return ui_router_core_1.services.$q.when(result).then(function (str) { return ({ component: str }); }); };
	        return (ui_router_core_1.isDefined(config.template) ? asTemplate(this.fromString(config.template, params)) :
	            ui_router_core_1.isDefined(config.templateUrl) ? asTemplate(this.fromUrl(config.templateUrl, params)) :
	                ui_router_core_1.isDefined(config.templateProvider) ? asTemplate(this.fromProvider(config.templateProvider, params, context)) :
	                    ui_router_core_1.isDefined(config.component) ? asComponent(config.component) :
	                        ui_router_core_1.isDefined(config.componentProvider) ? asComponent(this.fromComponentProvider(config.componentProvider, params, context)) :
	                            asTemplate(defaultTemplate));
	    };
	    ;
	    /**
	     * Creates a template from a string or a function returning a string.
	     *
	     * @param template html template as a string or function that returns an html template as a string.
	     * @param params Parameters to pass to the template function.
	     *
	     * @return {string|object} The template html as a string, or a promise for that
	     * string.
	     */
	    TemplateFactory.prototype.fromString = function (template, params) {
	        return ui_router_core_1.isFunction(template) ? template(params) : template;
	    };
	    ;
	    /**
	     * Loads a template from the a URL via `$http` and `$templateCache`.
	     *
	     * @param {string|Function} url url of the template to load, or a function
	     * that returns a url.
	     * @param {Object} params Parameters to pass to the url function.
	     * @return {string|Promise.<string>} The template html as a string, or a promise
	     * for that string.
	     */
	    TemplateFactory.prototype.fromUrl = function (url, params) {
	        if (ui_router_core_1.isFunction(url))
	            url = url(params);
	        if (url == null)
	            return null;
	        if (this._useHttp) {
	            return this.$http.get(url, { cache: this.$templateCache, headers: { Accept: 'text/html' } })
	                .then(function (response) { return response.data; });
	        }
	        return this.$templateRequest(url);
	    };
	    ;
	    /**
	     * Creates a template by invoking an injectable provider function.
	     *
	     * @param provider Function to invoke via `locals`
	     * @param {Function} injectFn a function used to invoke the template provider
	     * @return {string|Promise.<string>} The template html as a string, or a promise
	     * for that string.
	     */
	    TemplateFactory.prototype.fromProvider = function (provider, params, context) {
	        var deps = ui_router_core_1.services.$injector.annotate(provider);
	        var providerFn = ui_router_core_1.isArray(provider) ? ui_router_core_1.tail(provider) : provider;
	        var resolvable = new ui_router_core_1.Resolvable("", providerFn, deps);
	        return resolvable.get(context);
	    };
	    ;
	    /**
	     * Creates a component's template by invoking an injectable provider function.
	     *
	     * @param provider Function to invoke via `locals`
	     * @param {Function} injectFn a function used to invoke the template provider
	     * @return {string} The template html as a string: "<component-name input1='::$resolve.foo'></component-name>".
	     */
	    TemplateFactory.prototype.fromComponentProvider = function (provider, params, context) {
	        var deps = ui_router_core_1.services.$injector.annotate(provider);
	        var providerFn = ui_router_core_1.isArray(provider) ? ui_router_core_1.tail(provider) : provider;
	        var resolvable = new ui_router_core_1.Resolvable("", providerFn, deps);
	        return resolvable.get(context);
	    };
	    ;
	    /**
	     * Creates a template from a component's name
	     *
	     * This implements route-to-component.
	     * It works by retrieving the component (directive) metadata from the injector.
	     * It analyses the component's bindings, then constructs a template that instantiates the component.
	     * The template wires input and output bindings to resolves or from the parent component.
	     *
	     * @param uiView {object} The parent ui-view (for binding outputs to callbacks)
	     * @param context The ResolveContext (for binding outputs to callbacks returned from resolves)
	     * @param component {string} Component's name in camel case.
	     * @param bindings An object defining the component's bindings: {foo: '<'}
	     * @return {string} The template as a string: "<component-name input1='::$resolve.foo'></component-name>".
	     */
	    TemplateFactory.prototype.makeComponentTemplate = function (uiView, context, component, bindings) {
	        bindings = bindings || {};
	        // Bind once prefix
	        var prefix = angular_1.ng.version.minor >= 3 ? "::" : "";
	        var attributeTpl = function (input) {
	            var name = input.name, type = input.type;
	            var attrName = ui_router_core_1.kebobString(name);
	            // If the ui-view has an attribute which matches a binding on the routed component
	            // then pass that attribute through to the routed component template.
	            // Prefer ui-view wired mappings to resolve data, unless the resolve was explicitly bound using `bindings:`
	            if (uiView.attr(attrName) && !bindings[name])
	                return attrName + "='" + uiView.attr(attrName) + "'";
	            var resolveName = bindings[name] || name;
	            // Pre-evaluate the expression for "@" bindings by enclosing in {{ }}
	            // some-attr="{{ ::$resolve.someResolveName }}"
	            if (type === '@')
	                return attrName + "='{{" + prefix + "$resolve." + resolveName + "}}'";
	            // Wire "&" callbacks to resolves that return a callback function
	            // Get the result of the resolve (should be a function) and annotate it to get its arguments.
	            // some-attr="$resolve.someResolveResultName(foo, bar)"
	            if (type === '&') {
	                var res = context.getResolvable(resolveName);
	                var fn = res && res.data;
	                var args = fn && ui_router_core_1.services.$injector.annotate(fn) || [];
	                // account for array style injection, i.e., ['foo', function(foo) {}]
	                var arrayIdxStr = ui_router_core_1.isArray(fn) ? "[" + (fn.length - 1) + "]" : '';
	                return attrName + "='$resolve." + resolveName + arrayIdxStr + "(" + args.join(",") + ")'";
	            }
	            // some-attr="::$resolve.someResolveName"
	            return attrName + "='" + prefix + "$resolve." + resolveName + "'";
	        };
	        var attrs = getComponentBindings(component).map(attributeTpl).join(" ");
	        var kebobName = ui_router_core_1.kebobString(component);
	        return "<" + kebobName + " " + attrs + "></" + kebobName + ">";
	    };
	    ;
	    return TemplateFactory;
	}());
	exports.TemplateFactory = TemplateFactory;
	// Gets all the directive(s)' inputs ('@', '=', and '<') and outputs ('&')
	function getComponentBindings(name) {
	    var cmpDefs = ui_router_core_1.services.$injector.get(name + "Directive"); // could be multiple
	    if (!cmpDefs || !cmpDefs.length)
	        throw new Error("Unable to find component named '" + name + "'");
	    return cmpDefs.map(getBindings).reduce(ui_router_core_1.unnestR, []);
	}
	// Given a directive definition, find its object input attributes
	// Use different properties, depending on the type of directive (component, bindToController, normal)
	var getBindings = function (def) {
	    if (ui_router_core_1.isObject(def.bindToController))
	        return scopeBindings(def.bindToController);
	    return scopeBindings(def.scope);
	};
	// for ng 1.2 style, process the scope: { input: "=foo" }
	// for ng 1.3 through ng 1.5, process the component's bindToController: { input: "=foo" } object
	var scopeBindings = function (bindingsObj) { return Object.keys(bindingsObj || {})
	    .map(function (key) { return [key, /^([=<@&])[?]?(.*)/.exec(bindingsObj[key])]; })
	    .filter(function (tuple) { return ui_router_core_1.isDefined(tuple) && ui_router_core_1.isArray(tuple[1]); })
	    .map(function (tuple) { return ({ name: tuple[1][2] || tuple[0], type: tuple[1][1] }); }); };
	//# sourceMappingURL=templateFactory.js.map

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/** @module ng1 */ /** for typedoc */
	var ui_router_core_1 = __webpack_require__(303);
	/**
	 * @ngdoc object
	 * @name ui.router.state.$stateProvider
	 *
	 * @requires ui.router.router.$urlRouterProvider
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 *
	 * @description
	 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	 * on state.
	 *
	 * A state corresponds to a "place" in the application in terms of the overall UI and
	 * navigation. A state describes (via the controller / template / view properties) what
	 * the UI looks like and does at that place.
	 *
	 * States often have things in common, and the primary way of factoring out these
	 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	 * nested states.
	 *
	 * The `$stateProvider` provides interfaces to declare these states for your app.
	 */
	var StateProvider = (function () {
	    function StateProvider(stateRegistry, stateService) {
	        this.stateRegistry = stateRegistry;
	        this.stateService = stateService;
	        ui_router_core_1.createProxyFunctions(ui_router_core_1.val(StateProvider.prototype), this, ui_router_core_1.val(this));
	    }
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$stateProvider#decorator
	     * @methodOf ui.router.state.$stateProvider
	     *
	     * @description
	     * Allows you to extend (carefully) or override (at your own peril) the
	     * `stateBuilder` object used internally by `$stateProvider`. This can be used
	     * to add custom functionality to ui-router, for example inferring templateUrl
	     * based on the state name.
	     *
	     * When passing only a name, it returns the current (original or decorated) builder
	     * function that matches `name`.
	     *
	     * The builder functions that can be decorated are listed below. Though not all
	     * necessarily have a good use case for decoration, that is up to you to decide.
	     *
	     * In addition, users can attach custom decorators, which will generate new
	     * properties within the state's internal definition. There is currently no clear
	     * use-case for this beyond accessing internal states (i.e. $state.$current),
	     * however, expect this to become increasingly relevant as we introduce additional
	     * meta-programming features.
	     *
	     * **Warning**: Decorators should not be interdependent because the order of
	     * execution of the builder functions in non-deterministic. Builder functions
	     * should only be dependent on the state definition object and super function.
	     *
	     *
	     * Existing builder functions and current return values:
	     *
	     * - **parent** `{object}` - returns the parent state object.
	     * - **data** `{object}` - returns state data, including any inherited data that is not
	     *   overridden by own values (if any).
	     * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	     *   or `null`.
	     * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is
	     *   navigable).
	     * - **params** `{object}` - returns an array of state params that are ensured to
	     *   be a super-set of parent's params.
	     * - **views** `{object}` - returns a views object where each key is an absolute view
	     *   name (i.e. "viewName@stateName") and each value is the config object
	     *   (template, controller) for the view. Even when you don't use the views object
	     *   explicitly on a state config, one is still created for you internally.
	     *   So by decorating this builder function you have access to decorating template
	     *   and controller properties.
	     * - **ownParams** `{object}` - returns an array of params that belong to the state,
	     *   not including any params defined by ancestor states.
	     * - **path** `{string}` - returns the full path from the root down to this state.
	     *   Needed for state activation.
	     * - **includes** `{object}` - returns an object that includes every state that
	     *   would pass a `$state.includes()` test.
	     *
	     * @example
	     * <pre>
	     * // Override the internal 'views' builder with a function that takes the state
	     * // definition, and a reference to the internal function being overridden:
	     * $stateProvider.decorator('views', function (state, parent) {
	     *   let result = {},
	     *       views = parent(state);
	     *
	     *   angular.forEach(views, function (config, name) {
	     *     let autoName = (state.name + '.' + name).replace('.', '/');
	     *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	     *     result[name] = config;
	     *   });
	     *   return result;
	     * });
	     *
	     * $stateProvider.state('home', {
	     *   views: {
	     *     'contact.list': { controller: 'ListController' },
	     *     'contact.item': { controller: 'ItemController' }
	     *   }
	     * });
	     *
	     * // ...
	     *
	     * $state.go('home');
	     * // Auto-populates list and item views with /partials/home/contact/list.html,
	     * // and /partials/home/contact/item.html, respectively.
	     * </pre>
	     *
	     * @param {string} name The name of the builder function to decorate.
	     * @param {object} func A function that is responsible for decorating the original
	     * builder function. The function receives two parameters:
	     *
	     *   - `{object}` - state - The state config object.
	     *   - `{object}` - super - The original builder function.
	     *
	     * @return {object} $stateProvider - $stateProvider instance
	     */
	    StateProvider.prototype.decorator = function (name, func) {
	        return this.stateRegistry.decorator(name, func) || this;
	    };
	    StateProvider.prototype.state = function (name, definition) {
	        if (ui_router_core_1.isObject(name)) {
	            definition = name;
	        }
	        else {
	            definition.name = name;
	        }
	        this.stateRegistry.register(definition);
	        return this;
	    };
	    /**
	     * Registers an invalid state handler
	     *
	     * This is a passthrough to [[StateService.onInvalid]] for ng1.
	     */
	    StateProvider.prototype.onInvalid = function (callback) {
	        return this.stateService.onInvalid(callback);
	    };
	    return StateProvider;
	}());
	exports.StateProvider = StateProvider;
	//# sourceMappingURL=stateProvider.js.map

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/** @module ng1 */ /** */
	var ui_router_core_1 = __webpack_require__(303);
	var services_1 = __webpack_require__(359);
	/**
	 * This is a [[StateBuilder.builder]] function for angular1 `onEnter`, `onExit`,
	 * `onRetain` callback hooks on a [[Ng1StateDeclaration]].
	 *
	 * When the [[StateBuilder]] builds a [[State]] object from a raw [[StateDeclaration]], this builder
	 * ensures that those hooks are injectable for angular-ui-router (ng1).
	 */
	exports.getStateHookBuilder = function (hookName) {
	    return function stateHookBuilder(state, parentFn) {
	        var hook = state[hookName];
	        var pathname = hookName === 'onExit' ? 'from' : 'to';
	        function decoratedNg1Hook(trans, state) {
	            var resolveContext = new ui_router_core_1.ResolveContext(trans.treeChanges(pathname));
	            var locals = ui_router_core_1.extend(services_1.getLocals(resolveContext), { $state$: state, $transition$: trans });
	            return ui_router_core_1.services.$injector.invoke(hook, this, locals);
	        }
	        return hook ? decoratedNg1Hook : undefined;
	    };
	};
	//# sourceMappingURL=onEnterExitRetain.js.map

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ui_router_core_1 = __webpack_require__(303);
	/**
	 * Implements UI-Router LocationServices and LocationConfig using Angular 1's $location service
	 */
	var Ng1LocationServices = (function () {
	    function Ng1LocationServices($locationProvider) {
	        // .onChange() registry
	        this._urlListeners = [];
	        this.$locationProvider = $locationProvider;
	        var _lp = ui_router_core_1.val($locationProvider);
	        ui_router_core_1.createProxyFunctions(_lp, this, _lp, ['hashPrefix']);
	    }
	    Ng1LocationServices.prototype.dispose = function () { };
	    Ng1LocationServices.prototype.onChange = function (callback) {
	        var _this = this;
	        this._urlListeners.push(callback);
	        return function () { return ui_router_core_1.removeFrom(_this._urlListeners)(callback); };
	    };
	    Ng1LocationServices.prototype.html5Mode = function () {
	        var html5Mode = this.$locationProvider.html5Mode();
	        html5Mode = ui_router_core_1.isObject(html5Mode) ? html5Mode.enabled : html5Mode;
	        return html5Mode && this.$sniffer.history;
	    };
	    Ng1LocationServices.prototype.url = function (newUrl, replace, state) {
	        if (replace === void 0) { replace = false; }
	        if (newUrl)
	            this.$location.url(newUrl);
	        if (replace)
	            this.$location.replace();
	        if (state)
	            this.$location.state(state);
	        return this.$location.url();
	    };
	    Ng1LocationServices.prototype._runtimeServices = function ($rootScope, $location, $sniffer, $browser) {
	        var _this = this;
	        this.$location = $location;
	        this.$sniffer = $sniffer;
	        // Bind $locationChangeSuccess to the listeners registered in LocationService.onChange
	        $rootScope.$on("$locationChangeSuccess", function (evt) { return _this._urlListeners.forEach(function (fn) { return fn(evt); }); });
	        var _loc = ui_router_core_1.val($location);
	        var _browser = ui_router_core_1.val($browser);
	        // Bind these LocationService functions to $location
	        ui_router_core_1.createProxyFunctions(_loc, this, _loc, ["replace", "path", "search", "hash"]);
	        // Bind these LocationConfig functions to $location
	        ui_router_core_1.createProxyFunctions(_loc, this, _loc, ['port', 'protocol', 'host']);
	        // Bind these LocationConfig functions to $browser
	        ui_router_core_1.createProxyFunctions(_browser, this, _browser, ['baseHref']);
	    };
	    /**
	     * Applys ng1-specific path parameter encoding
	     *
	     * The Angular 1 `$location` service is a bit weird.
	     * It doesn't allow slashes to be encoded/decoded bi-directionally.
	     *
	     * See the writeup at https://github.com/angular-ui/ui-router/issues/2598
	     *
	     * This code patches the `path` parameter type so it encoded/decodes slashes as ~2F
	     *
	     * @param router
	     */
	    Ng1LocationServices.monkeyPatchPathParameterType = function (router) {
	        var pathType = router.urlMatcherFactory.type('path');
	        pathType.encode = function (val) {
	            return val != null ? val.toString().replace(/(~|\/)/g, function (m) { return ({ '~': '~~', '/': '~2F' }[m]); }) : val;
	        };
	        pathType.decode = function (val) {
	            return val != null ? val.toString().replace(/(~~|~2F)/g, function (m) { return ({ '~~': '~', '~2F': '/' }[m]); }) : val;
	        };
	    };
	    return Ng1LocationServices;
	}());
	exports.Ng1LocationServices = Ng1LocationServices;
	//# sourceMappingURL=locationServices.js.map

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/** @module url */ /** */
	var ui_router_core_1 = __webpack_require__(303);
	var ui_router_core_2 = __webpack_require__(303);
	/**
	 * Manages rules for client-side URL
	 *
	 * This class manages the router rules for what to do when the URL changes.
	 *
	 * ## Deprecation warning
	 *
	 * Use [[UrlService]]
	 *
	 * This provider remains for backwards compatibility.
	 */
	var UrlRouterProvider = (function () {
	    /** @hidden */
	    function UrlRouterProvider(router) {
	        this._router = router;
	        this._urlRouter = router.urlRouter;
	    }
	    /** @hidden */
	    UrlRouterProvider.prototype.$get = function () {
	        var urlRouter = this._urlRouter;
	        urlRouter.update(true);
	        if (!urlRouter.interceptDeferred)
	            urlRouter.listen();
	        return urlRouter;
	    };
	    /**
	     * Registers a url handler function.
	     *
	     * Registers a low level url handler (a `rule`).
	     * A rule detects specific URL patterns and returns a redirect, or performs some action.
	     *
	     * If a rule returns a string, the URL is replaced with the string, and all rules are fired again.
	     *
	     * #### Example:
	     * ```js
	     * var app = angular.module('app', ['ui.router.router']);
	     *
	     * app.config(function ($urlRouterProvider) {
	     *   // Here's an example of how you might allow case insensitive urls
	     *   $urlRouterProvider.rule(function ($injector, $location) {
	     *     var path = $location.path(),
	     *         normalized = path.toLowerCase();
	     *
	     *     if (path !== normalized) {
	     *       return normalized;
	     *     }
	     *   });
	     * });
	     * ```
	     *
	     * @param ruleFn
	     * Handler function that takes `$injector` and `$location` services as arguments.
	     * You can use them to detect a url and return a different url as a string.
	     *
	     * @return [[UrlRouterProvider]] (`this`)
	     */
	    UrlRouterProvider.prototype.rule = function (ruleFn) {
	        var _this = this;
	        if (!ui_router_core_2.isFunction(ruleFn))
	            throw new Error("'rule' must be a function");
	        var match = function () {
	            return ruleFn(ui_router_core_2.services.$injector, _this._router.locationService);
	        };
	        var rule = new ui_router_core_1.BaseUrlRule(match, ui_router_core_2.identity);
	        this._urlRouter.rule(rule);
	        return this;
	    };
	    ;
	    /**
	     * Defines the path or behavior to use when no url can be matched.
	     *
	     * #### Example:
	     * ```js
	     * var app = angular.module('app', ['ui.router.router']);
	     *
	     * app.config(function ($urlRouterProvider) {
	     *   // if the path doesn't match any of the urls you configured
	     *   // otherwise will take care of routing the user to the
	     *   // specified url
	     *   $urlRouterProvider.otherwise('/index');
	     *
	     *   // Example of using function rule as param
	     *   $urlRouterProvider.otherwise(function ($injector, $location) {
	     *     return '/a/valid/url';
	     *   });
	     * });
	     * ```
	     *
	     * @param rule
	     * The url path you want to redirect to or a function rule that returns the url path or performs a `$state.go()`.
	     * The function version is passed two params: `$injector` and `$location` services, and should return a url string.
	     *
	     * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	     */
	    UrlRouterProvider.prototype.otherwise = function (rule) {
	        var _this = this;
	        var urlRouter = this._urlRouter;
	        if (ui_router_core_2.isString(rule)) {
	            urlRouter.otherwise(rule);
	        }
	        else if (ui_router_core_2.isFunction(rule)) {
	            urlRouter.otherwise(function () { return rule(ui_router_core_2.services.$injector, _this._router.locationService); });
	        }
	        else {
	            throw new Error("'rule' must be a string or function");
	        }
	        return this;
	    };
	    ;
	    /**
	     * Registers a handler for a given url matching.
	     *
	     * If the handler is a string, it is
	     * treated as a redirect, and is interpolated according to the syntax of match
	     * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	     *
	     * If the handler is a function, it is injectable.
	     * It gets invoked if `$location` matches.
	     * You have the option of inject the match object as `$match`.
	     *
	     * The handler can return
	     *
	     * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	     *   will continue trying to find another one that matches.
	     * - **string** which is treated as a redirect and passed to `$location.url()`
	     * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	     *
	     * @example
	     * ```js
	     *
	     * var app = angular.module('app', ['ui.router.router']);
	     *
	     * app.config(function ($urlRouterProvider) {
	     *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	     *     if ($state.$current.navigable !== state ||
	     *         !equalForKeys($match, $stateParams) {
	     *      $state.transitionTo(state, $match, false);
	     *     }
	     *   });
	     * });
	     * ```
	     *
	     * @param what A pattern string to match, compiled as a [[UrlMatcher]].
	     * @param handler The path (or function that returns a path) that you want to redirect your user to.
	     * @param ruleCallback [optional] A callback that receives the `rule` registered with [[UrlMatcher.rule]]
	     *
	     * Note: the handler may also invoke arbitrary code, such as `$state.go()`
	     */
	    UrlRouterProvider.prototype.when = function (what, handler) {
	        if (ui_router_core_2.isArray(handler) || ui_router_core_2.isFunction(handler)) {
	            handler = UrlRouterProvider.injectableHandler(this._router, handler);
	        }
	        this._urlRouter.when(what, handler);
	        return this;
	    };
	    ;
	    UrlRouterProvider.injectableHandler = function (router, handler) {
	        return function (match) {
	            return ui_router_core_2.services.$injector.invoke(handler, null, { $match: match, $stateParams: router.globals.params });
	        };
	    };
	    /**
	     * Disables monitoring of the URL.
	     *
	     * Call this method before UI-Router has bootstrapped.
	     * It will stop UI-Router from performing the initial url sync.
	     *
	     * This can be useful to perform some asynchronous initialization before the router starts.
	     * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
	     *
	     * #### Example:
	     * ```js
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.config(function ($urlRouterProvider) {
	     *   // Prevent $urlRouter from automatically intercepting URL changes;
	     *   $urlRouterProvider.deferIntercept();
	     * })
	     *
	     * app.run(function (MyService, $urlRouter, $http) {
	     *   $http.get("/stuff").then(function(resp) {
	     *     MyService.doStuff(resp.data);
	     *     $urlRouter.listen();
	     *     $urlRouter.sync();
	     *   });
	     * });
	     * ```
	     *
	     * @param defer Indicates whether to defer location change interception.
	     *        Passing no parameter is equivalent to `true`.
	     */
	    UrlRouterProvider.prototype.deferIntercept = function (defer) {
	        this._urlRouter.deferIntercept(defer);
	    };
	    ;
	    return UrlRouterProvider;
	}());
	exports.UrlRouterProvider = UrlRouterProvider;
	//# sourceMappingURL=urlRouterProvider.js.map

/***/ },
/* 367 */
/***/ function(module, exports) {

	/**
	 * # Angular 1 injectable services
	 *
	 * This is a list of the objects which can be injected using angular's injector.
	 *
	 * There are three different kind of injectable objects:
	 *
	 * ## **Provider** objects
	 * #### injectable into a `.config()` block during configtime
	 *
	 * - [[$uiRouterProvider]]: The UI-Router instance
	 * - [[$stateProvider]]: State registration
	 * - [[$transitionsProvider]]: Transition hooks
	 * - [[$urlServiceProvider]]: All URL related public APIs
	 *
	 * - [[$uiViewScrollProvider]]: Disable ui-router view scrolling
	 * - [[$urlRouterProvider]]: (deprecated) Url matching rules
	 * - [[$urlMatcherFactoryProvider]]: (deprecated) Url parsing config
	 *
	 * ## **Service** objects
	 * #### injectable globally during runtime
	 *
	 * - [[$uiRouter]]: The UI-Router instance
	 * - [[$trace]]: Enable transition trace/debug
	 * - [[$transitions]]: Transition hooks
	 * - [[$state]]: Imperative state related APIs
	 * - [[$stateRegistry]]: State registration
	 * - [[$urlService]]: All URL related public APIs
	 * - [[$uiRouterGlobals]]: Global variables
	 * - [[$uiViewScroll]]: Scroll an element into view
	 *
	 * - [[$stateParams]]: (deprecated) Global state param values
	 * - [[$urlRouter]]: (deprecated) URL synchronization
	 * - [[$urlMatcherFactory]]: (deprecated) URL parsing config
	 *
	 * ## **Per-Transition** objects
	 *
	 * - These kind of objects are injectable into:
	 *   - Resolves ([[Ng1StateDeclaration.resolve]]),
	 *   - Transition Hooks ([[TransitionService.onStart]], etc),
	 *   - Routed Controllers ([[Ng1ViewDeclaration.controller]])
	 *
	 * #### Different instances are injected based on the [[Transition]]
	 *
	 * - [[$transition$]]: The current Transition object
	 * - [[$stateParams]]: State param values for pending Transition (deprecated)
	 * - Any resolve data defined using [[Ng1StateDeclaration.resolve]]
	 *
	 * @ng1api
	 * @preferred
	 * @module injectables
	 */ /** */
	"use strict";
	/**
	 * The current (or pending) State Parameters
	 *
	 * An injectable global **Service Object** which holds the state parameters for the latest **SUCCESSFUL** transition.
	 *
	 * The values are not updated until *after* a `Transition` successfully completes.
	 *
	 * **Also:** an injectable **Per-Transition Object** object which holds the pending state parameters for the pending `Transition` currently running.
	 *
	 * ## Deprecation warning:
	 *
	 * The value injected for `$stateParams` is different depending on where it is injected.
	 *
	 * - When injected into an angular service, the object injected is the global **Service Object** with the parameter values for the latest successful `Transition`.
	 * - When injected into transition hooks, resolves, or view controllers, the object is the **Per-Transition Object** with the parameter values for the running `Transition`.
	 *
	 * Because of these confusing details, this service is deprecated.
	 *
	 * @deprecated Instead of using the global `$stateParams` service object,
	 * inject [[$uiRouterGlobals]] and use [[UIRouterGlobals.params]]
	 *
	 * ```js
	 * MyService.$inject = ['$uiRouterGlobals'];
	 * function MyService($uiRouterGlobals) {
	 *   return {
	 *     paramValues: function () {
	 *       return $uiRouterGlobals.params;
	 *     }
	 *   }
	 * }
	 * ```
	 *
	 * @deprecated Instead of using the per-transition `$stateParams` object,
	 * inject the current `Transition` (as [[$transition$]]) and use [[Transition.params]]
	 *
	 * ```js
	 * MyController.$inject = ['$transition$'];
	 * function MyController($transition$) {
	 *   var username = $transition$.params().username;
	 *   // .. do something with username
	 * }
	 * ```
	 *
	 * ---
	 *
	 * This object can be injected into other services.
	 *
	 * #### Deprecated Example:
	 * ```js
	 * SomeService.$inject = ['$http', '$stateParams'];
	 * function SomeService($http, $stateParams) {
	 *   return {
	 *     getUser: function() {
	 *       return $http.get('/api/users/' + $stateParams.username);
	 *     }
	 *   }
	 * };
	 * angular.service('SomeService', SomeService);
	 * ```
	 */
	var $stateParams;
	/**
	 * Global UI-Router variables
	 *
	 * The router global state as a **Service Object** (injectable during runtime).
	 *
	 * This object contains globals such as the current state and current parameter values.
	 */
	var $uiRouterGlobals;
	/**
	 * The UI-Router instance
	 *
	 * The [[UIRouter]] singleton (the router instance) as a **Service Object** (injectable during runtime).
	 *
	 * This object is the UI-Router singleton instance, created by angular dependency injection during application bootstrap.
	 * It has references to the other UI-Router services
	 *
	 * #### Note: This object is also exposed as [[$uiRouterProvider]] for injection during angular config time.
	 */
	var $uiRouter;
	/**
	 * The UI-Router instance
	 *
	 * The [[UIRouter]] singleton (the router instance) as a **Provider Object** (injectable during config phase).
	 *
	 * This object is the UI-Router singleton instance, created by angular dependency injection during application bootstrap.
	 * It has references to the other UI-Router services
	 *
	 * #### Note: This object is also exposed as [[$uiRouter]] for injection during runtime.
	 */
	var $uiRouterProvider;
	/**
	 * Transition debug/tracing
	 *
	 * The [[Trace]] singleton as a **Service Object** (injectable during runtime).
	 *
	 * Enables or disables Transition tracing which can help to debug issues.
	 */
	var $trace;
	/**
	 * The Transition Service
	 *
	 * The [[TransitionService]] singleton as a **Service Object** (injectable during runtime).
	 *
	 * This angular service exposes the [[TransitionService]] singleton, which is primarily
	 * used to register global transition hooks.
	 *
	 * #### Note: This object is also exposed as [[$transitionsProvider]] for injection during the config phase.
	 */
	var $transitions;
	/**
	 * The Transition Service
	 *
	 * The [[TransitionService]] singleton as a **Provider Object** (injectable during config phase)
	 *
	 * This angular service exposes the [[TransitionService]] singleton, which is primarily
	 * used to register global transition hooks.
	 *
	 * #### Note: This object is also exposed as [[$transitions]] for injection during runtime.
	 */
	var $transitionsProvider;
	/**
	 * The current [[Transition]] object
	 *
	 * The current [[Transition]] object as a **Per-Transition Object** (injectable into Resolve, Hooks, Controllers)
	 *
	 * This object returns information about the current transition, including:
	 *
	 * - To/from states
	 * - To/from parameters
	 * - Transition options
	 * - States being entered, exited, and retained
	 * - Resolve data
	 * - A Promise for the transition
	 * - Any transition failure information
	 * - An injector for both Service and Per-Transition Objects
	 */
	var $transition$;
	/**
	 * The State Service
	 *
	 * The [[StateService]] singleton as a **Service Object** (injectable during runtime).
	 *
	 * This service used to manage and query information on registered states.
	 * It exposes state related APIs including:
	 *
	 * - Start a [[Transition]]
	 * - Imperatively lazy load states
	 * - Check if a state is currently active
	 * - Look up states by name
	 * - Build URLs for a state+parameters
	 * - Configure the global Transition error handler
	 *
	 * This angular service exposes the [[StateService]] singleton.
	 */
	var $state;
	/**
	 * The State Registry
	 *
	 * The [[StateRegistry]] singleton as a **Service Object** (injectable during runtime).
	 *
	 * This service is used to register/deregister states.
	 * It has state registration related APIs including:
	 *
	 * - Register/deregister states
	 * - Listen for state registration/deregistration
	 * - Get states by name
	 * - Add state decorators (to customize the state creation process)
	 *
	 * #### Note: This object is also exposed as [[$stateRegistryProvider]] for injection during the config phase.
	 */
	var $stateRegistry;
	/**
	 * The State Registry
	 *
	 * The [[StateRegistry]] singleton as a **Provider Object** (injectable during config time).
	 *
	 * This service is used to register/deregister states.
	 * It has state registration related APIs including:
	 *
	 * - Register/deregister states
	 * - Listen for state registration/deregistration
	 * - Get states by name
	 * - Add state decorators (to customize the state creation process)
	 *
	 * #### Note: This object is also exposed as [[$stateRegistry]] for injection during runtime.
	 */
	var $stateRegistryProvider;
	/**
	 * The View Scroll provider
	 *
	 * The [[UIViewScrollProvider]] as a **Provider Object** (injectable during config time).
	 *
	 * This angular service exposes the [[UIViewScrollProvider]] singleton and is
	 * used to disable UI-Router's scroll behavior.
	 */
	var $uiViewScrollProvider;
	/**
	 * The View Scroll function
	 *
	 * The View Scroll function as a **Service Object** (injectable during runtime).
	 *
	 * This is a function that scrolls an element into view.
	 * The element is scrolled after a `$timeout` so the DOM has time to refresh.
	 *
	 * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
	 * this can be enabled by calling [[UIViewScrollProvider.useAnchorScroll]].
	 *
	 * Note: this function is used by the [[uiView]] when the `autoscroll` expression evaluates to true.
	 */
	var $uiViewScroll;
	/**
	 * The StateProvider
	 *
	 * An angular1-only [[StateProvider]] as a **Provider Object** (injectable during config time).
	 *
	 * This angular service exposes the [[StateProvider]] singleton.
	 *
	 * The `StateProvider` is primarily used to register states or add custom state decorators.
	 *
	 * ##### Note: This provider is a ng1 vestige.
	 * It is a passthrough to [[$stateRegistry]] and [[$state]].
	 */
	var $stateProvider;
	/**
	 * The URL Service Provider
	 *
	 * The [[UrlService]] singleton as a **Provider Object** (injectable during the angular config phase).
	 *
	 * A service used to configure and interact with the URL.
	 * It has URL related APIs including:
	 *
	 * - add URL rules [[UrlService.rules.when]]
	 * - configure behavior when no url matches [[UrlService.rules.otherwise]]
	 * - delay initial URL synchronization [[UrlService.deferIntercept]].
	 * - get or set the current url: [[UrlService.url]]
	 *
	 * ##### Note: This service can also be injected during runtime as [[$urlService]].
	 */
	var $urlServiceProvider;
	/**
	 * The URL Service
	 *
	 * The [[UrlService]] singleton as a **Service Object** (injectable during runtime).
	 *
	 * Note: This service can also be injected during the config phase as [[$urlServiceProvider]].
	 *
	 * Used to configure the URL.
	 * It has URL related APIs including:
	 *
	 * - register custom Parameter types [[UrlService.rules.when]]
	 * - add URL rules [[UrlService.rules.when]]
	 * - configure behavior when no url matches [[UrlService.rules.otherwise]]
	 * - delay initial URL synchronization [[UrlService.deferIntercept]].
	 * - get or set the current url: [[UrlService.url]]
	 *
	 * ##### Note: This service can also be injected during the config phase as [[$urlServiceProvider]].
	 */
	var $urlService;
	/**
	 * The URL Router Provider
	 *
	 * The [[UrlRouter]] singleton as a **Provider Object** (injectable during config time).
	 *
	 * #### Note: This object is also exposed as [[$urlRouter]] for injection during runtime.
	 *
	 * @deprecated This object is now considered internal. Use [[$urlServiceProvider]] instead.
	 */
	var $urlRouterProvider;
	/**
	 * The Url Router
	 *
	 * The [[UrlRouter]] singleton as a **Service Object** (injectable during runtime).
	 *
	 * #### Note: This object is also exposed as [[$urlRouterProvider]] for injection during angular config time.
	 *
	 * @deprecated This object is now considered internal. Use [[$urlService]] instead.
	 */
	var $urlRouter;
	/**
	 * The URL Matcher Factory
	 *
	 * The [[UrlMatcherFactory]] singleton as a **Service Object** (injectable during runtime).
	 *
	 * This service is used to set url mapping options, define custom parameter types, and create [[UrlMatcher]] objects.
	 *
	 * #### Note: This object is also exposed as [[$urlMatcherFactoryProvider]] for injection during angular config time.
	 *
	 * @deprecated This object is now considered internal. Use [[$urlService]] instead.
	 */
	var $urlMatcherFactory;
	/**
	 * The URL Matcher Factory
	 *
	 * The [[UrlMatcherFactory]] singleton as a **Provider Object** (injectable during config time).
	 *
	 * This service is used to set url mapping options, define custom parameter types, and create [[UrlMatcher]] objects.
	 *
	 * #### Note: This object is also exposed as [[$urlMatcherFactory]] for injection during runtime.
	 *
	 * @deprecated This object is now considered internal. Use [[$urlService]] instead.
	 */
	var $urlMatcherFactoryProvider;
	//# sourceMappingURL=injectables.js.map

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * These are the UI-Router angular 1 directives.
	 *
	 * These directives are used in templates to create viewports and navigate to states
	 *
	 * @ng1api
	 * @preferred
	 * @module directives
	 */ /** for typedoc */
	var angular_1 = __webpack_require__(360);
	var ui_router_core_1 = __webpack_require__(303);
	/** @hidden */
	function parseStateRef(ref) {
	    var paramsOnly = ref.match(/^\s*({[^}]*})\s*$/), parsed;
	    if (paramsOnly)
	        ref = '(' + paramsOnly[1] + ')';
	    parsed = ref.replace(/\n/g, " ").match(/^\s*([^(]*?)\s*(\((.*)\))?\s*$/);
	    if (!parsed || parsed.length !== 4)
	        throw new Error("Invalid state ref '" + ref + "'");
	    return { state: parsed[1] || null, paramExpr: parsed[3] || null };
	}
	/** @hidden */
	function stateContext(el) {
	    var $uiView = el.parent().inheritedData('$uiView');
	    var path = ui_router_core_1.parse('$cfg.path')($uiView);
	    return path ? ui_router_core_1.tail(path).state.name : undefined;
	}
	/** @hidden */
	function processedDef($state, $element, def) {
	    var uiState = def.uiState || $state.current.name;
	    var uiStateOpts = ui_router_core_1.extend(defaultOpts($element, $state), def.uiStateOpts || {});
	    var href = $state.href(uiState, def.uiStateParams, uiStateOpts);
	    return { uiState: uiState, uiStateParams: def.uiStateParams, uiStateOpts: uiStateOpts, href: href };
	}
	/** @hidden */
	function getTypeInfo(el) {
	    // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	    var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
	    var isForm = el[0].nodeName === "FORM";
	    return {
	        attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
	        isAnchor: el.prop("tagName").toUpperCase() === "A",
	        clickable: !isForm
	    };
	}
	/** @hidden */
	function clickHook(el, $state, $timeout, type, getDef) {
	    return function (e) {
	        var button = e.which || e.button, target = getDef();
	        if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
	            // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	            var transition = $timeout(function () {
	                $state.go(target.uiState, target.uiStateParams, target.uiStateOpts);
	            });
	            e.preventDefault();
	            // if the state has no URL, ignore one preventDefault from the <a> directive.
	            var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1 : 0;
	            e.preventDefault = function () {
	                if (ignorePreventDefaultCount-- <= 0)
	                    $timeout.cancel(transition);
	            };
	        }
	    };
	}
	/** @hidden */
	function defaultOpts(el, $state) {
	    return {
	        relative: stateContext(el) || $state.$current,
	        inherit: true,
	        source: "sref"
	    };
	}
	/**
	 * `ui-sref`: A directive for linking to a state
	 *
	 * A directive which links to a state (and optionally, parameters).
	 * When clicked, this directive activates the linked state with the supplied parameter values.
	 *
	 * ### Linked State
	 * The attribute value of the `ui-sref` is the name of the state to link to.
	 *
	 * #### Example:
	 * This will activate the `home` state when the link is clicked.
	 * <a ui-sref="home">Home</a>
	 *
	 * ### Relative Links
	 * You can also use relative state paths within `ui-sref`, just like a relative path passed to `$state.go()` ([[StateService.go]]).
	 * You just need to be aware that the path is relative to the state that *created* the link.
	 * This allows a state to create a relative `ui-sref` which always targets the same destination.
	 *
	 * #### Example:
	 * Both these links are relative to the parent state, even when a child state is currently active.
	 * ```html
	 * <a ui-sref=".child1">child 1 state</a>
	 * <a ui-sref=".child2">child 2 state</a>
	 * ```
	 *
	 * This link activates the parent class.
	 * ```html
	 * <a ui-sref="^">Return</a>
	 * ```
	 *
	 * ### hrefs
	 * If the linked state has a URL, the directive will automatically generate and
	 * update the `href` attribute (using the [[StateService.href]]  method).
	 *
	 * #### Example:
	 * Assuming the `users` state has a url of `/users/`
	 * ```html
	 * <a ui-sref="users" href="/users/">Users</a>
	 * ```
	 *
	 * ### Parameter Values
	 * In addition to the state name, a `ui-sref` can include parameter values which are applied when activating the state.
	 * Param values can be provided in the `ui-sref` value after the state name, enclosed by parentheses.
	 * The content inside the parentheses is an expression, evaluated to the parameter values.
	 *
	 * #### Example:
	 * This example renders a list of links to users.
	 * The state's `userId` parameter value comes from each user's `user.id` property.
	 * ```html
	 * <li ng-repeat="user in users">
	 *   <a ui-sref="users.detail({ userId: user.id })">{{ user.displayName }}</a>
	 * </li>
	 * ```
	 *
	 * Note:
	 * The parameter values expression is `$watch`ed for updates.
	 *
	 * ### Transition Options
	 * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-sref-opts` attribute.
	 * Options are restricted to `location`, `inherit`, and `reload`.
	 *
	 * #### Example:
	 * ```html
	 * <a ui-sref="home" ui-sref-opts="{ reload: true }">Home</a>
	 * ```
	 *
	 * ### Highlighting the active link
	 * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
	 *
	 * ### Examples
	 * If you have the following template:
	 *
	 * ```html
	 * <a ui-sref="home">Home</a>
	 * <a ui-sref="about">About</a>
	 * <a ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	 *     </li>
	 * </ul>
	 * ```
	 *
	 * Then (assuming the current state is `contacts`) the rendered html including hrefs would be:
	 *
	 * ```html
	 * <a href="#/home" ui-sref="home">Home</a>
	 * <a href="#/about" ui-sref="about">About</a>
	 * <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	 *     </li>
	 * </ul>
	 *
	 * <a href="#/home" ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	 * ```
	 *
	 * ### Notes
	 *
	 * - You can use `ui-sref` to change **only the parameter values** by omitting the state name and parentheses.
	 * #### Example:
	 * Sets the `lang` parameter to `en` and remains on the same state.
	 *
	 * ```html
	 * <a ui-sref="{ lang: 'en' }">English</a>
	 * ```
	 *
	 * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
	 *
	 * - Unlike the parameter values expression, the state name is not `$watch`ed (for performance reasons).
	 * If you need to dynamically update the state being linked to, use the fully dynamic [[uiState]] directive.
	 */
	var uiSref;
	uiSref = ['$uiRouter', '$timeout',
	    function $StateRefDirective($uiRouter, $timeout) {
	        var $state = $uiRouter.stateService;
	        return {
	            restrict: 'A',
	            require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	            link: function (scope, element, attrs, uiSrefActive) {
	                var type = getTypeInfo(element);
	                var active = uiSrefActive[1] || uiSrefActive[0];
	                var unlinkInfoFn = null;
	                var hookFn;
	                var rawDef = {};
	                var getDef = function () { return processedDef($state, element, rawDef); };
	                var ref = parseStateRef(attrs.uiSref);
	                rawDef.uiState = ref.state;
	                rawDef.uiStateOpts = attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {};
	                function update() {
	                    var def = getDef();
	                    if (unlinkInfoFn)
	                        unlinkInfoFn();
	                    if (active)
	                        unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
	                    if (def.href != null)
	                        attrs.$set(type.attr, def.href);
	                }
	                if (ref.paramExpr) {
	                    scope.$watch(ref.paramExpr, function (val) {
	                        rawDef.uiStateParams = angular_1.ng.copy(val);
	                        update();
	                    }, true);
	                    rawDef.uiStateParams = angular_1.ng.copy(scope.$eval(ref.paramExpr));
	                }
	                update();
	                scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
	                scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
	                if (!type.clickable)
	                    return;
	                hookFn = clickHook(element, $state, $timeout, type, getDef);
	                element[element.on ? 'on' : 'bind']("click", hookFn);
	                scope.$on('$destroy', function () {
	                    element[element.off ? 'off' : 'unbind']("click", hookFn);
	                });
	            }
	        };
	    }];
	/**
	 * `ui-state`: A fully dynamic directive for linking to a state
	 *
	 * A directive which links to a state (and optionally, parameters).
	 * When clicked, this directive activates the linked state with the supplied parameter values.
	 *
	 * **This directive is very similar to [[uiSref]], but it `$observe`s and `$watch`es/evaluates all its inputs.**
	 *
	 * A directive which links to a state (and optionally, parameters).
	 * When clicked, this directive activates the linked state with the supplied parameter values.
	 *
	 * ### Linked State
	 * The attribute value of `ui-state` is an expression which is `$watch`ed and evaluated as the state to link to.
	 * **This is in contrast with `ui-sref`, which takes a state name as a string literal.**
	 *
	 * #### Example:
	 * Create a list of links.
	 * ```html
	 * <li ng-repeat="link in navlinks">
	 *   <a ui-sref="link.state">{{ link.displayName }}</a>
	 * </li>
	 *
	 * ### Relative Links
	 * If the expression evaluates to a relative path, it is processed like [[uiSref]].
	 * You just need to be aware that the path is relative to the state that *created* the link.
	 * This allows a state to create relative `ui-state` which always targets the same destination.
	 *
	 * ### hrefs
	 * If the linked state has a URL, the directive will automatically generate and
	 * update the `href` attribute (using the [[StateService.href]]  method).
	 *
	 * ### Parameter Values
	 * In addition to the state name expression, a `ui-state` can include parameter values which are applied when activating the state.
	 * Param values should be provided using the `ui-state-params` attribute.
	 * The `ui-state-params` attribute value is `$watch`ed and evaluated as an expression.
	 *
	 * #### Example:
	 * This example renders a list of links with param values.
	 * The state's `userId` parameter value comes from each user's `user.id` property.
	 * ```html
	 * <li ng-repeat="link in navlinks">
	 *   <a ui-state="link.state" ui-state-params="link.params">{{ link.displayName }}</a>
	 * </li>
	 * ```
	 *
	 * ### Transition Options
	 * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-state-opts` attribute.
	 * Options are restricted to `location`, `inherit`, and `reload`.
	 * The value of the `ui-state-opts` is `$watch`ed and evaluated as an expression.
	 *
	 * #### Example:
	 * ```html
	 * <a ui-state="returnto.state" ui-state-opts="{ reload: true }">Home</a>
	 * ```
	 *
	 * ### Highlighting the active link
	 * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
	 *
	 * ### Notes
	 *
	 * - You can use `ui-params` to change **only the parameter values** by omitting the state name and supplying only `ui-state-params`.
	 *   However, it might be simpler to use [[uiSref]] parameter-only links.
	 *
	 * #### Example:
	 * Sets the `lang` parameter to `en` and remains on the same state.
	 *
	 * ```html
	 * <a ui-state="" ui-state-params="{ lang: 'en' }">English</a>
	 * ```
	 *
	 * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
	 * ```
	 */
	var uiState;
	uiState = ['$uiRouter', '$timeout',
	    function $StateRefDynamicDirective($uiRouter, $timeout) {
	        var $state = $uiRouter.stateService;
	        return {
	            restrict: 'A',
	            require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	            link: function (scope, element, attrs, uiSrefActive) {
	                var type = getTypeInfo(element);
	                var active = uiSrefActive[1] || uiSrefActive[0];
	                var unlinkInfoFn = null;
	                var hookFn;
	                var rawDef = {};
	                var getDef = function () { return processedDef($state, element, rawDef); };
	                var inputAttrs = ['uiState', 'uiStateParams', 'uiStateOpts'];
	                var watchDeregFns = inputAttrs.reduce(function (acc, attr) { return (acc[attr] = ui_router_core_1.noop, acc); }, {});
	                function update() {
	                    var def = getDef();
	                    if (unlinkInfoFn)
	                        unlinkInfoFn();
	                    if (active)
	                        unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
	                    if (def.href != null)
	                        attrs.$set(type.attr, def.href);
	                }
	                inputAttrs.forEach(function (field) {
	                    rawDef[field] = attrs[field] ? scope.$eval(attrs[field]) : null;
	                    attrs.$observe(field, function (expr) {
	                        watchDeregFns[field]();
	                        watchDeregFns[field] = scope.$watch(expr, function (newval) {
	                            rawDef[field] = newval;
	                            update();
	                        }, true);
	                    });
	                });
	                update();
	                scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
	                scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
	                if (!type.clickable)
	                    return;
	                hookFn = clickHook(element, $state, $timeout, type, getDef);
	                element[element.on ? 'on' : 'bind']("click", hookFn);
	                scope.$on('$destroy', function () {
	                    element[element.off ? 'off' : 'unbind']("click", hookFn);
	                });
	            }
	        };
	    }];
	/**
	 * `ui-sref-active` and `ui-sref-active-eq`: A directive that adds a CSS class when a `ui-sref` is active
	 *
	 * A directive working alongside [[uiSref]] and [[uiState]] to add classes to an element when the
	 * related directive's state is active (and remove them when it is inactive).
	 *
	 * The primary use-case is to highlight the active link in navigation menus,
	 * distinguishing it from the inactive menu items.
	 *
	 * ### Linking to a `ui-sref` or `ui-state`
	 * `ui-sref-active` can live on the same element as `ui-sref`/`ui-state`, or it can be on a parent element.
	 * If a `ui-sref-active` is a parent to more than one `ui-sref`/`ui-state`, it will apply the CSS class when **any of the links are active**.
	 *
	 * ### Matching
	 *
	 * The `ui-sref-active` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state **or any child state is active**.
	 * This is a "fuzzy match" which uses [[StateService.includes]].
	 *
	 * The `ui-sref-active-eq` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state is directly active (not when child states are active).
	 * This is an "exact match" which uses [[StateService.is]].
	 *
	 * ### Parameter values
	 * If the `ui-sref`/`ui-state` includes parameter values, the current parameter values must match the link's values for the link to be highlighted.
	 * This allows a list of links to the same state with different parameters to be rendered, and the correct one highlighted.
	 *
	 * #### Example:
	 * ```html
	 * <li ng-repeat="user in users" ui-sref-active="active">
	 *   <a ui-sref="user.details({ userId: user.id })">{{ user.lastName }}</a>
	 * </li>
	 * ```
	 *
	 * ### Examples
	 *
	 * Given the following template:
	 * @example
	 * ```html
	 * <ul>
	 *   <li ui-sref-active="active" class="item">
	 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * ```
	 *
	 * When the app state is `app.user` (or any child state),
	 * and contains the state parameter "user" with value "bilbobaggins",
	 * the resulting HTML will appear as (note the 'active' class):
	 *
	 * ```html
	 * <ul>
	 *   <li ui-sref-active="active" class="item active">
	 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * ```
	 *
	 * ### Glob mode
	 *
	 * It is possible to pass `ui-sref-active` an expression that evaluates to an object.
	 * The objects keys represent active class names and values represent the respective state names/globs.
	 * `ui-sref-active` will match if the current active state **includes** any of
	 * the specified state names/globs, even the abstract ones.
	 *
	 * #### Example:
	 * Given the following template, with "admin" being an abstract state:
	 * ```html
	 * <div ui-sref-active="{'active': 'admin.**'}">
	 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	 * </div>
	 * ```
	 *
	 * When the current state is "admin.roles" the "active" class will be applied to both the <div> and <a> elements.
	 * It is important to note that the state names/globs passed to `ui-sref-active` override any state provided by a linked `ui-sref`.
	 *
	 * ### Notes:
	 *
	 * - The class name is interpolated **once** during the directives link time (any further changes to the
	 * interpolated value are ignored).
	 *
	 * - Multiple classes may be specified in a space-separated format: `ui-sref-active='class1 class2 class3'`
	 */
	var uiSrefActive;
	uiSrefActive = ['$state', '$stateParams', '$interpolate', '$uiRouter',
	    function $StateRefActiveDirective($state, $stateParams, $interpolate, $uiRouter) {
	        return {
	            restrict: "A",
	            controller: ['$scope', '$element', '$attrs',
	                function ($scope, $element, $attrs) {
	                    var states = [], activeEqClass, uiSrefActive;
	                    // There probably isn't much point in $observing this
	                    // uiSrefActive and uiSrefActiveEq share the same directive object with some
	                    // slight difference in logic routing
	                    activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
	                    try {
	                        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
	                    }
	                    catch (e) {
	                    }
	                    uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
	                    if (ui_router_core_1.isObject(uiSrefActive)) {
	                        ui_router_core_1.forEach(uiSrefActive, function (stateOrName, activeClass) {
	                            if (ui_router_core_1.isString(stateOrName)) {
	                                var ref = parseStateRef(stateOrName);
	                                addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
	                            }
	                        });
	                    }
	                    // Allow uiSref to communicate with uiSrefActive[Equals]
	                    this.$$addStateInfo = function (newState, newParams) {
	                        // we already got an explicit state provided by ui-sref-active, so we
	                        // shadow the one that comes from ui-sref
	                        if (ui_router_core_1.isObject(uiSrefActive) && states.length > 0) {
	                            return;
	                        }
	                        var deregister = addState(newState, newParams, uiSrefActive);
	                        update();
	                        return deregister;
	                    };
	                    function updateAfterTransition(trans) {
	                        trans.promise.then(update);
	                    }
	                    $scope.$on('$stateChangeSuccess', update);
	                    $scope.$on('$destroy', $uiRouter.transitionService.onStart({}, updateAfterTransition));
	                    if ($uiRouter.globals.transition) {
	                        updateAfterTransition($uiRouter.globals.transition);
	                    }
	                    function addState(stateName, stateParams, activeClass) {
	                        var state = $state.get(stateName, stateContext($element));
	                        var stateInfo = {
	                            state: state || { name: stateName },
	                            params: stateParams,
	                            activeClass: activeClass
	                        };
	                        states.push(stateInfo);
	                        return function removeState() {
	                            ui_router_core_1.removeFrom(states)(stateInfo);
	                        };
	                    }
	                    // Update route state
	                    function update() {
	                        var splitClasses = function (str) {
	                            return str.split(/\s/).filter(ui_router_core_1.identity);
	                        };
	                        var getClasses = function (stateList) {
	                            return stateList.map(function (x) { return x.activeClass; }).map(splitClasses).reduce(ui_router_core_1.unnestR, []);
	                        };
	                        var allClasses = getClasses(states).concat(splitClasses(activeEqClass)).reduce(ui_router_core_1.uniqR, []);
	                        var fuzzyClasses = getClasses(states.filter(function (x) { return $state.includes(x.state.name, x.params); }));
	                        var exactlyMatchesAny = !!states.filter(function (x) { return $state.is(x.state.name, x.params); }).length;
	                        var exactClasses = exactlyMatchesAny ? splitClasses(activeEqClass) : [];
	                        var addClasses = fuzzyClasses.concat(exactClasses).reduce(ui_router_core_1.uniqR, []);
	                        var removeClasses = allClasses.filter(function (cls) { return !ui_router_core_1.inArray(addClasses, cls); });
	                        $scope.$evalAsync(function () {
	                            addClasses.forEach(function (className) { return $element.addClass(className); });
	                            removeClasses.forEach(function (className) { return $element.removeClass(className); });
	                        });
	                    }
	                    update();
	                }]
	        };
	    }];
	angular_1.ng.module('ui.router.state')
	    .directive('uiSref', uiSref)
	    .directive('uiSrefActive', uiSrefActive)
	    .directive('uiSrefActiveEq', uiSrefActive)
	    .directive('uiState', uiState);
	//# sourceMappingURL=stateDirectives.js.map

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	/** @module state */ /** for typedoc */
	"use strict";
	var angular_1 = __webpack_require__(360);
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:isState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
	 */
	$IsStateFilter.$inject = ['$state'];
	function $IsStateFilter($state) {
	    var isFilter = function (state, params, options) {
	        return $state.is(state, params, options);
	    };
	    isFilter.$stateful = true;
	    return isFilter;
	}
	exports.$IsStateFilter = $IsStateFilter;
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:includedByState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
	 */
	$IncludedByStateFilter.$inject = ['$state'];
	function $IncludedByStateFilter($state) {
	    var includesFilter = function (state, params, options) {
	        return $state.includes(state, params, options);
	    };
	    includesFilter.$stateful = true;
	    return includesFilter;
	}
	exports.$IncludedByStateFilter = $IncludedByStateFilter;
	angular_1.ng.module('ui.router.state')
	    .filter('isState', $IsStateFilter)
	    .filter('includedByState', $IncludedByStateFilter);
	//# sourceMappingURL=stateFilters.js.map

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @ng1api
	 * @module directives
	 */ /** for typedoc */
	var angular_1 = __webpack_require__(360);
	var angular_2 = __webpack_require__(299);
	var ui_router_core_1 = __webpack_require__(303);
	var views_1 = __webpack_require__(361);
	var services_1 = __webpack_require__(359);
	/**
	 * `ui-view`: A viewport directive which is filled in by a view from the active state.
	 *
	 * ### Attributes
	 *
	 * - `name`: (Optional) A view name.
	 *   The name should be unique amongst the other views in the same state.
	 *   You can have views of the same name that live in different states.
	 *   The ui-view can be targeted in a View using the name ([[Ng1StateDeclaration.views]]).
	 *
	 * - `autoscroll`: an expression. When it evaluates to true, the `ui-view` will be scrolled into view when it is activated.
	 *   Uses [[$uiViewScroll]] to do the scrolling.
	 *
	 * - `onload`: Expression to evaluate whenever the view updates.
	 *
	 * A view can be unnamed or named.
	 * @example
	 * ```html
	 *
	 * <!-- Unnamed -->
	 * <div ui-view></div>
	 *
	 * <!-- Named -->
	 * <div ui-view="viewName"></div>
	 *
	 * <!-- Named (different style) -->
	 * <ui-view name="viewName"></ui-view>
	 * ```
	 *
	 * You can only have one unnamed view within any template (or root html). If you are only using a
	 * single view and it is unnamed then you can populate it like so:
	 * ```
	 *
	 * <div ui-view></div>
	 * $stateProvider.state("home", {
	 *   template: "<h1>HELLO!</h1>"
	 * })
	 * ```
	 *
	 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#views `views`}
	 * config property, by name, in this case an empty name:
	 * ```js
	 *
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }
	 * })
	 * ```
	 *
	 * But typically you'll only use the views property if you name your view or have more than one view
	 * in the same template. There's not really a compelling reason to name a view if its the only one,
	 * but you could if you wanted, like so:
	 *
	 * ```html
	 *
	 * <div ui-view="main"></div>
	 * ```
	 *
	 * ```js
	 *
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "main": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }
	 * })
	 * ```
	 *
	 * Really though, you'll use views to set up multiple views:
	 * ```html
	 *
	 * <div ui-view></div>
	 * <div ui-view="chart"></div>
	 * <div ui-view="data"></div>
	 * ```
	 *
	 * ```js
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     },
	 *     "chart": {
	 *       template: "<chart_thing/>"
	 *     },
	 *     "data": {
	 *       template: "<data_thing/>"
	 *     }
	 *   }
	 * })
	 * ```
	 *
	 * Examples for `autoscroll`:
	 *
	 * ```html
	 *
	 * <!-- If autoscroll present with no expression,
	 *      then scroll ui-view into view -->
	 * <ui-view autoscroll/>
	 *
	 * <!-- If autoscroll present with valid expression,
	 *      then scroll ui-view into view if expression evaluates to true -->
	 * <ui-view autoscroll='true'/>
	 * <ui-view autoscroll='false'/>
	 * <ui-view autoscroll='scopeVariable'/>
	 * ```
	 *
	 * Resolve data:
	 *
	 * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
	 * can be customized using [[ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
	 *
	 * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
	 * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
	 * depends on `$resolve` data.
	 *
	 * #### Example:
	 * ```js
	 * $stateProvider.state('home', {
	 *   template: '<my-component user="$resolve.user"></my-component>',
	 *   resolve: {
	 *     user: function(UserService) { return UserService.fetchUser(); }
	 *   }
	 * });
	 * ```
	 */
	var uiView;
	uiView = ['$view', '$animate', '$uiViewScroll', '$interpolate', '$q',
	    function $ViewDirective($view, $animate, $uiViewScroll, $interpolate, $q) {
	        function getRenderer(attrs, scope) {
	            return {
	                enter: function (element, target, cb) {
	                    if (angular_1.ng.version.minor > 2) {
	                        $animate.enter(element, null, target).then(cb);
	                    }
	                    else {
	                        $animate.enter(element, null, target, cb);
	                    }
	                },
	                leave: function (element, cb) {
	                    if (angular_1.ng.version.minor > 2) {
	                        $animate.leave(element).then(cb);
	                    }
	                    else {
	                        $animate.leave(element, cb);
	                    }
	                }
	            };
	        }
	        function configsEqual(config1, config2) {
	            return config1 === config2;
	        }
	        var rootData = {
	            $cfg: { viewDecl: { $context: $view._pluginapi._rootViewContext() } },
	            $uiView: {}
	        };
	        var directive = {
	            count: 0,
	            restrict: 'ECA',
	            terminal: true,
	            priority: 400,
	            transclude: 'element',
	            compile: function (tElement, tAttrs, $transclude) {
	                return function (scope, $element, attrs) {
	                    var previousEl, currentEl, currentScope, unregister, onloadExp = attrs['onload'] || '', autoScrollExp = attrs['autoscroll'], renderer = getRenderer(attrs, scope), viewConfig = undefined, inherited = $element.inheritedData('$uiView') || rootData, name = $interpolate(attrs['uiView'] || attrs['name'] || '')(scope) || '$default';
	                    var activeUIView = {
	                        $type: 'ng1',
	                        id: directive.count++,
	                        name: name,
	                        fqn: inherited.$uiView.fqn ? inherited.$uiView.fqn + "." + name : name,
	                        config: null,
	                        configUpdated: configUpdatedCallback,
	                        get creationContext() {
	                            return ui_router_core_1.parse('$cfg.viewDecl.$context')(inherited);
	                        }
	                    };
	                    ui_router_core_1.trace.traceUIViewEvent("Linking", activeUIView);
	                    function configUpdatedCallback(config) {
	                        if (config && !(config instanceof views_1.Ng1ViewConfig))
	                            return;
	                        if (configsEqual(viewConfig, config))
	                            return;
	                        ui_router_core_1.trace.traceUIViewConfigUpdated(activeUIView, config && config.viewDecl && config.viewDecl.$context);
	                        viewConfig = config;
	                        updateView(config);
	                    }
	                    $element.data('$uiView', { $uiView: activeUIView });
	                    updateView();
	                    unregister = $view.registerUIView(activeUIView);
	                    scope.$on("$destroy", function () {
	                        ui_router_core_1.trace.traceUIViewEvent("Destroying/Unregistering", activeUIView);
	                        unregister();
	                    });
	                    function cleanupLastView() {
	                        if (previousEl) {
	                            ui_router_core_1.trace.traceUIViewEvent("Removing (previous) el", previousEl.data('$uiView'));
	                            previousEl.remove();
	                            previousEl = null;
	                        }
	                        if (currentScope) {
	                            ui_router_core_1.trace.traceUIViewEvent("Destroying scope", activeUIView);
	                            currentScope.$destroy();
	                            currentScope = null;
	                        }
	                        if (currentEl) {
	                            var _viewData_1 = currentEl.data('$uiViewAnim');
	                            ui_router_core_1.trace.traceUIViewEvent("Animate out", _viewData_1);
	                            renderer.leave(currentEl, function () {
	                                _viewData_1.$$animLeave.resolve();
	                                previousEl = null;
	                            });
	                            previousEl = currentEl;
	                            currentEl = null;
	                        }
	                    }
	                    function updateView(config) {
	                        var newScope = scope.$new();
	                        var animEnter = $q.defer(), animLeave = $q.defer();
	                        var $uiViewData = {
	                            $cfg: config,
	                            $uiView: activeUIView,
	                        };
	                        var $uiViewAnim = {
	                            $animEnter: animEnter.promise,
	                            $animLeave: animLeave.promise,
	                            $$animLeave: animLeave
	                        };
	                        /**
	                         * @ngdoc event
	                         * @name ui.router.state.directive:ui-view#$viewContentLoading
	                         * @eventOf ui.router.state.directive:ui-view
	                         * @eventType emits on ui-view directive scope
	                         * @description
	                         *
	                         * Fired once the view **begins loading**, *before* the DOM is rendered.
	                         *
	                         * @param {Object} event Event object.
	                         * @param {string} viewName Name of the view.
	                         */
	                        newScope.$emit('$viewContentLoading', name);
	                        var cloned = $transclude(newScope, function (clone) {
	                            clone.data('$uiViewAnim', $uiViewAnim);
	                            clone.data('$uiView', $uiViewData);
	                            renderer.enter(clone, $element, function onUIViewEnter() {
	                                animEnter.resolve();
	                                if (currentScope)
	                                    currentScope.$emit('$viewContentAnimationEnded');
	                                if (ui_router_core_1.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
	                                    $uiViewScroll(clone);
	                                }
	                            });
	                            cleanupLastView();
	                        });
	                        currentEl = cloned;
	                        currentScope = newScope;
	                        /**
	                         * @ngdoc event
	                         * @name ui.router.state.directive:ui-view#$viewContentLoaded
	                         * @eventOf ui.router.state.directive:ui-view
	                         * @eventType emits on ui-view directive scope
	                         * @description           *
	                         * Fired once the view is **loaded**, *after* the DOM is rendered.
	                         *
	                         * @param {Object} event Event object.
	                         */
	                        currentScope.$emit('$viewContentLoaded', config || viewConfig);
	                        currentScope.$eval(onloadExp);
	                    }
	                };
	            }
	        };
	        return directive;
	    }];
	$ViewDirectiveFill.$inject = ['$compile', '$controller', '$transitions', '$view', '$timeout'];
	/** @hidden */
	function $ViewDirectiveFill($compile, $controller, $transitions, $view, $timeout) {
	    var getControllerAs = ui_router_core_1.parse('viewDecl.controllerAs');
	    var getResolveAs = ui_router_core_1.parse('viewDecl.resolveAs');
	    return {
	        restrict: 'ECA',
	        priority: -400,
	        compile: function (tElement) {
	            var initial = tElement.html();
	            tElement.empty();
	            return function (scope, $element) {
	                var data = $element.data('$uiView');
	                if (!data) {
	                    $element.html(initial);
	                    $compile($element.contents())(scope);
	                    return;
	                }
	                var cfg = data.$cfg || { viewDecl: {}, getTemplate: angular_2.noop };
	                var resolveCtx = cfg.path && new ui_router_core_1.ResolveContext(cfg.path);
	                $element.html(cfg.getTemplate($element, resolveCtx) || initial);
	                ui_router_core_1.trace.traceUIViewFill(data.$uiView, $element.html());
	                var link = $compile($element.contents());
	                var controller = cfg.controller;
	                var controllerAs = getControllerAs(cfg);
	                var resolveAs = getResolveAs(cfg);
	                var locals = resolveCtx && services_1.getLocals(resolveCtx);
	                scope[resolveAs] = locals;
	                if (controller) {
	                    var controllerInstance = $controller(controller, ui_router_core_1.extend({}, locals, { $scope: scope, $element: $element }));
	                    if (controllerAs) {
	                        scope[controllerAs] = controllerInstance;
	                        scope[controllerAs][resolveAs] = locals;
	                    }
	                    // TODO: Use $view service as a central point for registering component-level hooks
	                    // Then, when a component is created, tell the $view service, so it can invoke hooks
	                    // $view.componentLoaded(controllerInstance, { $scope: scope, $element: $element });
	                    // scope.$on('$destroy', () => $view.componentUnloaded(controllerInstance, { $scope: scope, $element: $element }));
	                    $element.data('$ngControllerController', controllerInstance);
	                    $element.children().data('$ngControllerController', controllerInstance);
	                    registerControllerCallbacks($transitions, controllerInstance, scope, cfg);
	                }
	                // Wait for the component to appear in the DOM
	                if (ui_router_core_1.isString(cfg.viewDecl.component)) {
	                    var cmp_1 = cfg.viewDecl.component;
	                    var kebobName_1 = ui_router_core_1.kebobString(cmp_1);
	                    var getComponentController = function () {
	                        var directiveEl = [].slice.call($element[0].children)
	                            .filter(function (el) { return el && el.tagName && el.tagName.toLowerCase() === kebobName_1; });
	                        return directiveEl && angular_1.ng.element(directiveEl).data("$" + cmp_1 + "Controller");
	                    };
	                    var deregisterWatch_1 = scope.$watch(getComponentController, function (ctrlInstance) {
	                        if (!ctrlInstance)
	                            return;
	                        registerControllerCallbacks($transitions, ctrlInstance, scope, cfg);
	                        deregisterWatch_1();
	                    });
	                }
	                link(scope);
	            };
	        }
	    };
	}
	/** @hidden */
	var hasComponentImpl = typeof angular_1.ng.module('ui.router')['component'] === 'function';
	/** @hidden TODO: move these callbacks to $view and/or `/hooks/components.ts` or something */
	function registerControllerCallbacks($transitions, controllerInstance, $scope, cfg) {
	    // Call $onInit() ASAP
	    if (ui_router_core_1.isFunction(controllerInstance.$onInit) && !(cfg.viewDecl.component && hasComponentImpl))
	        controllerInstance.$onInit();
	    var viewState = ui_router_core_1.tail(cfg.path).state.self;
	    var hookOptions = { bind: controllerInstance };
	    // Add component-level hook for onParamsChange
	    if (ui_router_core_1.isFunction(controllerInstance.uiOnParamsChanged)) {
	        var resolveContext = new ui_router_core_1.ResolveContext(cfg.path);
	        var viewCreationTrans_1 = resolveContext.getResolvable('$transition$').data;
	        // Fire callback on any successful transition
	        var paramsUpdated = function ($transition$) {
	            // Exit early if the $transition$ is the same as the view was created within.
	            // Exit early if the $transition$ will exit the state the view is for.
	            if ($transition$ === viewCreationTrans_1 || $transition$.exiting().indexOf(viewState) !== -1)
	                return;
	            var toParams = $transition$.params("to");
	            var fromParams = $transition$.params("from");
	            var toSchema = $transition$.treeChanges().to.map(function (node) { return node.paramSchema; }).reduce(ui_router_core_1.unnestR, []);
	            var fromSchema = $transition$.treeChanges().from.map(function (node) { return node.paramSchema; }).reduce(ui_router_core_1.unnestR, []);
	            // Find the to params that have different values than the from params
	            var changedToParams = toSchema.filter(function (param) {
	                var idx = fromSchema.indexOf(param);
	                return idx === -1 || !fromSchema[idx].type.equals(toParams[param.id], fromParams[param.id]);
	            });
	            // Only trigger callback if a to param has changed or is new
	            if (changedToParams.length) {
	                var changedKeys_1 = changedToParams.map(function (x) { return x.id; });
	                // Filter the params to only changed/new to params.  `$transition$.params()` may be used to get all params.
	                var newValues = ui_router_core_1.filter(toParams, function (val, key) { return changedKeys_1.indexOf(key) !== -1; });
	                controllerInstance.uiOnParamsChanged(newValues, $transition$);
	            }
	        };
	        $scope.$on('$destroy', $transitions.onSuccess({}, paramsUpdated, hookOptions));
	    }
	    // Add component-level hook for uiCanExit
	    if (ui_router_core_1.isFunction(controllerInstance.uiCanExit)) {
	        var criteria = { exiting: viewState.name };
	        $scope.$on('$destroy', $transitions.onBefore(criteria, controllerInstance.uiCanExit, hookOptions));
	    }
	}
	angular_1.ng.module('ui.router.state').directive('uiView', uiView);
	angular_1.ng.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
	//# sourceMappingURL=viewDirective.js.map

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/** @module ng1 */ /** */
	var angular_1 = __webpack_require__(360);
	/** @hidden */
	function $ViewScrollProvider() {
	    var useAnchorScroll = false;
	    this.useAnchorScroll = function () {
	        useAnchorScroll = true;
	    };
	    this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
	            if (useAnchorScroll) {
	                return $anchorScroll;
	            }
	            return function ($element) {
	                return $timeout(function () {
	                    $element[0].scrollIntoView();
	                }, 0, false);
	            };
	        }];
	}
	angular_1.ng.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
	//# sourceMappingURL=viewScroll.js.map

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(373);
	module.exports = 'ngSanitize';


/***/ },
/* 373 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.6.1
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	var bind;
	var extend;
	var forEach;
	var isDefined;
	var lowercase;
	var noop;
	var htmlParser;
	var htmlSanitizeWriter;
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * # ngSanitize
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 *
	 * <div doc-module-components="ngSanitize"></div>
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   Sanitizes an html string by stripping all potentially dangerous tokens.
	 *
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	 *   then serialized back to properly escaped html string. This means that no unsafe input can make
	 *   it into the returned string.
	 *
	 *   The whitelist for URL sanitization of attribute values is configured using the functions
	 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider
	 *   `$compileProvider`}.
	 *
	 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $sanitizeProvider
	 * @this
	 *
	 * @description
	 * Creates and configures {@link $sanitize} instance.
	 */
	function $SanitizeProvider() {
	  var svgEnabled = false;
	
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    if (svgEnabled) {
	      extend(validElements, svgElements);
	    }
	    return function(html) {
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#enableSvg
	   * @kind function
	   *
	   * @description
	   * Enables a subset of svg to be supported by the sanitizer.
	   *
	   * <div class="alert alert-warning">
	   *   <p>By enabling this setting without taking other precautions, you might expose your
	   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
	   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
	   *   link). Such behavior can then result in phishing incidents.</p>
	   *
	   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
	   *   tags within the sanitized content:</p>
	   *
	   *   <br>
	   *
	   *   <pre><code>
	   *   .rootOfTheIncludedContent svg {
	   *     overflow: hidden !important;
	   *   }
	   *   </code></pre>
	   * </div>
	   *
	   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
	   * @returns {boolean|ng.$sanitizeProvider} Returns the currently configured value if called
	   *    without an argument or self for chaining otherwise.
	   */
	  this.enableSvg = function(enableSvg) {
	    if (isDefined(enableSvg)) {
	      svgEnabled = enableSvg;
	      return this;
	    } else {
	      return svgEnabled;
	    }
	  };
	
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	  // Private stuff
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	
	  bind = angular.bind;
	  extend = angular.extend;
	  forEach = angular.forEach;
	  isDefined = angular.isDefined;
	  lowercase = angular.lowercase;
	  noop = angular.noop;
	
	  htmlParser = htmlParserImpl;
	  htmlSanitizeWriter = htmlSanitizeWriterImpl;
	
	  // Regular Expressions for parsing tags and attributes
	  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	    // Match everything outside of normal chars and " (quote character)
	    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;
	
	
	  // Good source of info about elements and attributes
	  // http://dev.w3.org/html5/spec/Overview.html#semantics
	  // http://simon.html5.org/html-elements
	
	  // Safe Void Elements - HTML5
	  // http://dev.w3.org/html5/spec/Overview.html#void-elements
	  var voidElements = toMap('area,br,col,hr,img,wbr');
	
	  // Elements that you can, intentionally, leave open (and which close themselves)
	  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
	  var optionalEndTagBlockElements = toMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
	      optionalEndTagInlineElements = toMap('rp,rt'),
	      optionalEndTagElements = extend({},
	                                              optionalEndTagInlineElements,
	                                              optionalEndTagBlockElements);
	
	  // Safe Block Elements - HTML5
	  var blockElements = extend({}, optionalEndTagBlockElements, toMap('address,article,' +
	          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
	          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));
	
	  // Inline Elements - HTML5
	  var inlineElements = extend({}, optionalEndTagInlineElements, toMap('a,abbr,acronym,b,' +
	          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
	          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));
	
	  // SVG Elements
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
	  // They can potentially allow for arbitrary javascript to be executed. See #11290
	  var svgElements = toMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
	          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
	          'radialGradient,rect,stop,svg,switch,text,title,tspan');
	
	  // Blocked Elements (will be stripped)
	  var blockedElements = toMap('script,style');
	
	  var validElements = extend({},
	                                     voidElements,
	                                     blockElements,
	                                     inlineElements,
	                                     optionalEndTagElements);
	
	  //Attributes that have href and hence need to be sanitized
	  var uriAttrs = toMap('background,cite,href,longdesc,src,xlink:href');
	
	  var htmlAttrs = toMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
	      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
	      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
	      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
	      'valign,value,vspace,width');
	
	  // SVG attributes (without "id" and "name" attributes)
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	  var svgAttrs = toMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
	      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
	      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
	      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
	      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
	      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
	      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
	      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
	      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
	      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
	      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
	      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
	      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
	      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);
	
	  var validAttrs = extend({},
	                                  uriAttrs,
	                                  svgAttrs,
	                                  htmlAttrs);
	
	  function toMap(str, lowercaseKeys) {
	    var obj = {}, items = str.split(','), i;
	    for (i = 0; i < items.length; i++) {
	      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
	    }
	    return obj;
	  }
	
	  var inertBodyElement;
	  (function(window) {
	    var doc;
	    if (window.document && window.document.implementation) {
	      doc = window.document.implementation.createHTMLDocument('inert');
	    } else {
	      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
	    }
	    var docElement = doc.documentElement || doc.getDocumentElement();
	    var bodyElements = docElement.getElementsByTagName('body');
	
	    // usually there should be only one body element in the document, but IE doesn't have any, so we need to create one
	    if (bodyElements.length === 1) {
	      inertBodyElement = bodyElements[0];
	    } else {
	      var html = doc.createElement('html');
	      inertBodyElement = doc.createElement('body');
	      html.appendChild(inertBodyElement);
	      doc.appendChild(html);
	    }
	  })(window);
	
	  /**
	   * @example
	   * htmlParser(htmlString, {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * });
	   *
	   * @param {string} html string
	   * @param {object} handler
	   */
	  function htmlParserImpl(html, handler) {
	    if (html === null || html === undefined) {
	      html = '';
	    } else if (typeof html !== 'string') {
	      html = '' + html;
	    }
	    inertBodyElement.innerHTML = html;
	
	    //mXSS protection
	    var mXSSAttempts = 5;
	    do {
	      if (mXSSAttempts === 0) {
	        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
	      }
	      mXSSAttempts--;
	
	      // strip custom-namespaced attributes on IE<=11
	      if (window.document.documentMode) {
	        stripCustomNsAttrs(inertBodyElement);
	      }
	      html = inertBodyElement.innerHTML; //trigger mXSS
	      inertBodyElement.innerHTML = html;
	    } while (html !== inertBodyElement.innerHTML);
	
	    var node = inertBodyElement.firstChild;
	    while (node) {
	      switch (node.nodeType) {
	        case 1: // ELEMENT_NODE
	          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
	          break;
	        case 3: // TEXT NODE
	          handler.chars(node.textContent);
	          break;
	      }
	
	      var nextNode;
	      if (!(nextNode = node.firstChild)) {
	        if (node.nodeType === 1) {
	          handler.end(node.nodeName.toLowerCase());
	        }
	        nextNode = node.nextSibling;
	        if (!nextNode) {
	          while (nextNode == null) {
	            node = node.parentNode;
	            if (node === inertBodyElement) break;
	            nextNode = node.nextSibling;
	            if (node.nodeType === 1) {
	              handler.end(node.nodeName.toLowerCase());
	            }
	          }
	        }
	      }
	      node = nextNode;
	    }
	
	    while ((node = inertBodyElement.firstChild)) {
	      inertBodyElement.removeChild(node);
	    }
	  }
	
	  function attrToMap(attrs) {
	    var map = {};
	    for (var i = 0, ii = attrs.length; i < ii; i++) {
	      var attr = attrs[i];
	      map[attr.name] = attr.value;
	    }
	    return map;
	  }
	
	
	  /**
	   * Escapes all potentially dangerous characters, so that the
	   * resulting string can be safely inserted into attribute or
	   * element text.
	   * @param value
	   * @returns {string} escaped text
	   */
	  function encodeEntities(value) {
	    return value.
	      replace(/&/g, '&amp;').
	      replace(SURROGATE_PAIR_REGEXP, function(value) {
	        var hi = value.charCodeAt(0);
	        var low = value.charCodeAt(1);
	        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	      }).
	      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	        return '&#' + value.charCodeAt(0) + ';';
	      }).
	      replace(/</g, '&lt;').
	      replace(/>/g, '&gt;');
	  }
	
	  /**
	   * create an HTML/XML writer which writes to buffer
	   * @param {Array} buf use buf.join('') to get out sanitized html string
	   * @returns {object} in the form of {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * }
	   */
	  function htmlSanitizeWriterImpl(buf, uriValidator) {
	    var ignoreCurrentElement = false;
	    var out = bind(buf, buf.push);
	    return {
	      start: function(tag, attrs) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && blockedElements[tag]) {
	          ignoreCurrentElement = tag;
	        }
	        if (!ignoreCurrentElement && validElements[tag] === true) {
	          out('<');
	          out(tag);
	          forEach(attrs, function(value, key) {
	            var lkey = lowercase(key);
	            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
	            if (validAttrs[lkey] === true &&
	              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	              out(' ');
	              out(key);
	              out('="');
	              out(encodeEntities(value));
	              out('"');
	            }
	          });
	          out('>');
	        }
	      },
	      end: function(tag) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        // eslint-disable-next-line eqeqeq
	        if (tag == ignoreCurrentElement) {
	          ignoreCurrentElement = false;
	        }
	      },
	      chars: function(chars) {
	        if (!ignoreCurrentElement) {
	          out(encodeEntities(chars));
	        }
	      }
	    };
	  }
	
	
	  /**
	   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
	   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
	   * to allow any of these custom attributes. This method strips them all.
	   *
	   * @param node Root element to process
	   */
	  function stripCustomNsAttrs(node) {
	    while (node) {
	      if (node.nodeType === window.Node.ELEMENT_NODE) {
	        var attrs = node.attributes;
	        for (var i = 0, l = attrs.length; i < l; i++) {
	          var attrNode = attrs[i];
	          var attrName = attrNode.name.toLowerCase();
	          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
	            node.removeAttributeNode(attrNode);
	            i--;
	            l--;
	          }
	        }
	      }
	
	      var nextNode = node.firstChild;
	      if (nextNode) {
	        stripCustomNsAttrs(nextNode);
	      }
	
	      node = node.nextSibling;
	    }
	  }
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports `http/https/ftp/mailto` and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} target Window (`_blank|_self|_parent|_top`) or named frame to open links in.
	 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
	 *
	 *    Can be one of:
	 *
	 *    - `object`: A map of attributes
	 *    - `function`: Takes the url as a parameter and returns a map of attributes
	 *
	 *    If the map of attributes contains a value for `target`, it overrides the value of
	 *    the target parameter.
	 *
	 *
	 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <th>Filter</th>
	           <th>Source</th>
	           <th>Rendered</th>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="linky-custom-attributes">
	          <td>linky custom attributes</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="script.js">
	       angular.module('linkyExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.snippet =
	             'Pretty text with some links:\n' +
	             'http://angularjs.org/,\n' +
	             'mailto:us@somewhere.org,\n' +
	             'another@somewhere.org,\n' +
	             'and one more: ftp://127.0.0.1/.';
	           $scope.snippetWithSingleURL = 'http://angularjs.org/';
	         }]);
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	
	       it('should optionally add custom attributes', function() {
	        expect(element(by.id('linky-custom-attributes')).
	            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
	      MAILTO_REGEXP = /^mailto:/i;
	
	  var linkyMinErr = angular.$$minErr('linky');
	  var isDefined = angular.isDefined;
	  var isFunction = angular.isFunction;
	  var isObject = angular.isObject;
	  var isString = angular.isString;
	
	  return function(text, target, attributes) {
	    if (text == null || text === '') return text;
	    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);
	
	    var attributesFn =
	      isFunction(attributes) ? attributes :
	      isObject(attributes) ? function getAttributesObject() {return attributes;} :
	      function getEmptyAttributesObject() {return {};};
	
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      var key, linkAttributes = attributesFn(url);
	      html.push('<a ');
	
	      for (key in linkAttributes) {
	        html.push(key + '="' + linkAttributes[key] + '" ');
	      }
	
	      if (isDefined(target) && !('target' in linkAttributes)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(375);
	module.exports = 'LocalStorageModule';


/***/ },
/* 375 */
/***/ function(module, exports) {

	/**
	 * An Angular module that gives you access to the browsers local storage
	 * @version v0.5.0 - 2016-08-29
	 * @link https://github.com/grevory/angular-local-storage
	 * @author grevory <greg@gregpike.ca>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function (window, angular) {
	var isDefined = angular.isDefined,
	  isUndefined = angular.isUndefined,
	  isNumber = angular.isNumber,
	  isObject = angular.isObject,
	  isArray = angular.isArray,
	  extend = angular.extend,
	  toJson = angular.toJson;
	
	angular
	  .module('LocalStorageModule', [])
	  .provider('localStorageService', function() {
	    // You should set a prefix to avoid overwriting any local storage variables from the rest of your app
	    // e.g. localStorageServiceProvider.setPrefix('yourAppName');
	    // With provider you can use config as this:
	    // myApp.config(function (localStorageServiceProvider) {
	    //    localStorageServiceProvider.prefix = 'yourAppName';
	    // });
	    this.prefix = 'ls';
	
	    // You could change web storage type localstorage or sessionStorage
	    this.storageType = 'localStorage';
	
	    // Cookie options (usually in case of fallback)
	    // expiry = Number of days before cookies expire // 0 = Does not expire
	    // path = The web path the cookie represents
	    // secure = Wether the cookies should be secure (i.e only sent on HTTPS requests)
	    this.cookie = {
	      expiry: 30,
	      path: '/',
	      secure: false
	    };
	
	    // Decides wether we should default to cookies if localstorage is not supported.
	    this.defaultToCookie = true;
	
	    // Send signals for each of the following actions?
	    this.notify = {
	      setItem: true,
	      removeItem: false
	    };
	
	    // Setter for the prefix
	    this.setPrefix = function(prefix) {
	      this.prefix = prefix;
	      return this;
	    };
	
	    // Setter for the storageType
	    this.setStorageType = function(storageType) {
	      this.storageType = storageType;
	      return this;
	    };
	    // Setter for defaultToCookie value, default is true.
	    this.setDefaultToCookie = function (shouldDefault) {
	      this.defaultToCookie = !!shouldDefault; // Double-not to make sure it's a bool value.
	      return this;
	    };
	    // Setter for cookie config
	    this.setStorageCookie = function(exp, path, secure) {
	      this.cookie.expiry = exp;
	      this.cookie.path = path;
	      this.cookie.secure = secure;
	      return this;
	    };
	
	    // Setter for cookie domain
	    this.setStorageCookieDomain = function(domain) {
	      this.cookie.domain = domain;
	      return this;
	    };
	
	    // Setter for notification config
	    // itemSet & itemRemove should be booleans
	    this.setNotify = function(itemSet, itemRemove) {
	      this.notify = {
	        setItem: itemSet,
	        removeItem: itemRemove
	      };
	      return this;
	    };
	
	    this.$get = ['$rootScope', '$window', '$document', '$parse','$timeout', function($rootScope, $window, $document, $parse, $timeout) {
	      var self = this;
	      var prefix = self.prefix;
	      var cookie = self.cookie;
	      var notify = self.notify;
	      var storageType = self.storageType;
	      var webStorage;
	
	      // When Angular's $document is not available
	      if (!$document) {
	        $document = document;
	      } else if ($document[0]) {
	        $document = $document[0];
	      }
	
	      // If there is a prefix set in the config lets use that with an appended period for readability
	      if (prefix.substr(-1) !== '.') {
	        prefix = !!prefix ? prefix + '.' : '';
	      }
	      var deriveQualifiedKey = function(key) {
	        return prefix + key;
	      };
	
	      // Removes prefix from the key.
	      var underiveQualifiedKey = function (key) {
	        return key.replace(new RegExp('^' + prefix, 'g'), '');
	      };
	
	      // Check if the key is within our prefix namespace.
	      var isKeyPrefixOurs = function (key) {
	        return key.indexOf(prefix) === 0;
	      };
	
	      // Checks the browser to see if local storage is supported
	      var checkSupport = function () {
	        try {
	          var supported = (storageType in $window && $window[storageType] !== null);
	
	          // When Safari (OS X or iOS) is in private browsing mode, it appears as though localStorage
	          // is available, but trying to call .setItem throws an exception.
	          //
	          // "QUOTA_EXCEEDED_ERR: DOM Exception 22: An attempt was made to add something to storage
	          // that exceeded the quota."
	          var key = deriveQualifiedKey('__' + Math.round(Math.random() * 1e7));
	          if (supported) {
	            webStorage = $window[storageType];
	            webStorage.setItem(key, '');
	            webStorage.removeItem(key);
	          }
	
	          return supported;
	        } catch (e) {
	          // Only change storageType to cookies if defaulting is enabled.
	          if (self.defaultToCookie)
	            storageType = 'cookie';
	          $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	          return false;
	        }
	      };
	      var browserSupportsLocalStorage = checkSupport();
	
	      // Directly adds a value to local storage
	      // If local storage is not available in the browser use cookies
	      // Example use: localStorageService.add('library','angular');
	      var addToLocalStorage = function (key, value, type) {
	        setStorageType(type);
	
	        // Let's convert undefined values to null to get the value consistent
	        if (isUndefined(value)) {
	          value = null;
	        } else {
	          value = toJson(value);
	        }
	
	        // If this browser does not support local storage use cookies
	        if (!browserSupportsLocalStorage && self.defaultToCookie || self.storageType === 'cookie') {
	          if (!browserSupportsLocalStorage) {
	            $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
	          }
	
	          if (notify.setItem) {
	            $rootScope.$broadcast('LocalStorageModule.notification.setitem', {key: key, newvalue: value, storageType: 'cookie'});
	          }
	          return addToCookies(key, value);
	        }
	
	        try {
	          if (webStorage) {
	            webStorage.setItem(deriveQualifiedKey(key), value);
	          }
	          if (notify.setItem) {
	            $rootScope.$broadcast('LocalStorageModule.notification.setitem', {key: key, newvalue: value, storageType: self.storageType});
	          }
	        } catch (e) {
	          $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	          return addToCookies(key, value);
	        }
	        return true;
	      };
	
	      // Directly get a value from local storage
	      // Example use: localStorageService.get('library'); // returns 'angular'
	      var getFromLocalStorage = function (key, type) {
	        setStorageType(type);
	
	        if (!browserSupportsLocalStorage && self.defaultToCookie  || self.storageType === 'cookie') {
	          if (!browserSupportsLocalStorage) {
	            $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
	          }
	
	          return getFromCookies(key);
	        }
	
	        var item = webStorage ? webStorage.getItem(deriveQualifiedKey(key)) : null;
	        // angular.toJson will convert null to 'null', so a proper conversion is needed
	        // FIXME not a perfect solution, since a valid 'null' string can't be stored
	        if (!item || item === 'null') {
	          return null;
	        }
	
	        try {
	          return JSON.parse(item);
	        } catch (e) {
	          return item;
	        }
	      };
	
	      // Remove an item from local storage
	      // Example use: localStorageService.remove('library'); // removes the key/value pair of library='angular'
	      //
	      // This is var-arg removal, check the last argument to see if it is a storageType
	      // and set type accordingly before removing.
	      //
	      var removeFromLocalStorage = function () {
	        // can't pop on arguments, so we do this
	        var consumed = 0;
	        if (arguments.length >= 1 &&
	            (arguments[arguments.length - 1] === 'localStorage' ||
	             arguments[arguments.length - 1] === 'sessionStorage')) {
	          consumed = 1;
	          setStorageType(arguments[arguments.length - 1]);
	        }
	
	        var i, key;
	        for (i = 0; i < arguments.length - consumed; i++) {
	          key = arguments[i];
	          if (!browserSupportsLocalStorage && self.defaultToCookie || self.storageType === 'cookie') {
	            if (!browserSupportsLocalStorage) {
	              $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
	            }
	
	            if (notify.removeItem) {
	              $rootScope.$broadcast('LocalStorageModule.notification.removeitem', {key: key, storageType: 'cookie'});
	            }
	            removeFromCookies(key);
	          }
	          else {
	            try {
	              webStorage.removeItem(deriveQualifiedKey(key));
	              if (notify.removeItem) {
	                $rootScope.$broadcast('LocalStorageModule.notification.removeitem', {
	                  key: key,
	                  storageType: self.storageType
	                });
	              }
	            } catch (e) {
	              $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	              removeFromCookies(key);
	            }
	          }
	        }
	      };
	
	      // Return array of keys for local storage
	      // Example use: var keys = localStorageService.keys()
	      var getKeysForLocalStorage = function (type) {
	        setStorageType(type);
	
	        if (!browserSupportsLocalStorage) {
	          $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
	          return [];
	        }
	
	        var prefixLength = prefix.length;
	        var keys = [];
	        for (var key in webStorage) {
	          // Only return keys that are for this app
	          if (key.substr(0, prefixLength) === prefix) {
	            try {
	              keys.push(key.substr(prefixLength));
	            } catch (e) {
	              $rootScope.$broadcast('LocalStorageModule.notification.error', e.Description);
	              return [];
	            }
	          }
	        }
	        return keys;
	      };
	
	      // Remove all data for this app from local storage
	      // Also optionally takes a regular expression string and removes the matching key-value pairs
	      // Example use: localStorageService.clearAll();
	      // Should be used mostly for development purposes
	      var clearAllFromLocalStorage = function (regularExpression, type) {
	        setStorageType(type);
	
	        // Setting both regular expressions independently
	        // Empty strings result in catchall RegExp
	        var prefixRegex = !!prefix ? new RegExp('^' + prefix) : new RegExp();
	        var testRegex = !!regularExpression ? new RegExp(regularExpression) : new RegExp();
	
	        if (!browserSupportsLocalStorage && self.defaultToCookie  || self.storageType === 'cookie') {
	          if (!browserSupportsLocalStorage) {
	            $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
	          }
	          return clearAllFromCookies();
	        }
	        if (!browserSupportsLocalStorage && !self.defaultToCookie)
	          return false;
	        var prefixLength = prefix.length;
	
	        for (var key in webStorage) {
	          // Only remove items that are for this app and match the regular expression
	          if (prefixRegex.test(key) && testRegex.test(key.substr(prefixLength))) {
	            try {
	              removeFromLocalStorage(key.substr(prefixLength));
	            } catch (e) {
	              $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	              return clearAllFromCookies();
	            }
	          }
	        }
	        return true;
	      };
	
	      // Checks the browser to see if cookies are supported
	      var browserSupportsCookies = (function() {
	        try {
	          return $window.navigator.cookieEnabled ||
	          ("cookie" in $document && ($document.cookie.length > 0 ||
	            ($document.cookie = "test").indexOf.call($document.cookie, "test") > -1));
	          } catch (e) {
	            $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	            return false;
	          }
	        }());
	
	        // Directly adds a value to cookies
	        // Typically used as a fallback if local storage is not available in the browser
	        // Example use: localStorageService.cookie.add('library','angular');
	        var addToCookies = function (key, value, daysToExpiry, secure) {
	
	          if (isUndefined(value)) {
	            return false;
	          } else if(isArray(value) || isObject(value)) {
	            value = toJson(value);
	          }
	
	          if (!browserSupportsCookies) {
	            $rootScope.$broadcast('LocalStorageModule.notification.error', 'COOKIES_NOT_SUPPORTED');
	            return false;
	          }
	
	          try {
	            var expiry = '',
	            expiryDate = new Date(),
	            cookieDomain = '';
	
	            if (value === null) {
	              // Mark that the cookie has expired one day ago
	              expiryDate.setTime(expiryDate.getTime() + (-1 * 24 * 60 * 60 * 1000));
	              expiry = "; expires=" + expiryDate.toGMTString();
	              value = '';
	            } else if (isNumber(daysToExpiry) && daysToExpiry !== 0) {
	              expiryDate.setTime(expiryDate.getTime() + (daysToExpiry * 24 * 60 * 60 * 1000));
	              expiry = "; expires=" + expiryDate.toGMTString();
	            } else if (cookie.expiry !== 0) {
	              expiryDate.setTime(expiryDate.getTime() + (cookie.expiry * 24 * 60 * 60 * 1000));
	              expiry = "; expires=" + expiryDate.toGMTString();
	            }
	            if (!!key) {
	              var cookiePath = "; path=" + cookie.path;
	              if (cookie.domain) {
	                cookieDomain = "; domain=" + cookie.domain;
	              }
	              /* Providing the secure parameter always takes precedence over config
	               * (allows developer to mix and match secure + non-secure) */
	              if (typeof secure === 'boolean') {
	                  if (secure === true) {
	                      /* We've explicitly specified secure,
	                       * add the secure attribute to the cookie (after domain) */
	                      cookieDomain += "; secure";
	                  }
	                  // else - secure has been supplied but isn't true - so don't set secure flag, regardless of what config says
	              }
	              else if (cookie.secure === true) {
	                  // secure parameter wasn't specified, get default from config
	                  cookieDomain += "; secure";
	              }
	              $document.cookie = deriveQualifiedKey(key) + "=" + encodeURIComponent(value) + expiry + cookiePath + cookieDomain;
	            }
	          } catch (e) {
	            $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	            return false;
	          }
	          return true;
	        };
	
	        // Directly get a value from a cookie
	        // Example use: localStorageService.cookie.get('library'); // returns 'angular'
	        var getFromCookies = function (key) {
	          if (!browserSupportsCookies) {
	            $rootScope.$broadcast('LocalStorageModule.notification.error', 'COOKIES_NOT_SUPPORTED');
	            return false;
	          }
	
	          var cookies = $document.cookie && $document.cookie.split(';') || [];
	          for(var i=0; i < cookies.length; i++) {
	            var thisCookie = cookies[i];
	            while (thisCookie.charAt(0) === ' ') {
	              thisCookie = thisCookie.substring(1,thisCookie.length);
	            }
	            if (thisCookie.indexOf(deriveQualifiedKey(key) + '=') === 0) {
	              var storedValues = decodeURIComponent(thisCookie.substring(prefix.length + key.length + 1, thisCookie.length));
	              try {
	                return JSON.parse(storedValues);
	              } catch(e) {
	                return storedValues;
	              }
	            }
	          }
	          return null;
	        };
	
	        var removeFromCookies = function (key) {
	          addToCookies(key,null);
	        };
	
	        var clearAllFromCookies = function () {
	          var thisCookie = null;
	          var prefixLength = prefix.length;
	          var cookies = $document.cookie.split(';');
	          for(var i = 0; i < cookies.length; i++) {
	            thisCookie = cookies[i];
	
	            while (thisCookie.charAt(0) === ' ') {
	              thisCookie = thisCookie.substring(1, thisCookie.length);
	            }
	
	            var key = thisCookie.substring(prefixLength, thisCookie.indexOf('='));
	            removeFromCookies(key);
	          }
	        };
	
	        var getStorageType = function() {
	          return storageType;
	        };
	
	        var setStorageType = function(type) {
	          if (type && storageType !== type) {
	            storageType = type;
	            browserSupportsLocalStorage = checkSupport();
	          }
	          return browserSupportsLocalStorage;
	        };
	
	        // Add a listener on scope variable to save its changes to local storage
	        // Return a function which when called cancels binding
	        var bindToScope = function(scope, key, def, lsKey, type) {
	          lsKey = lsKey || key;
	          var value = getFromLocalStorage(lsKey, type);
	
	          if (value === null && isDefined(def)) {
	            value = def;
	          } else if (isObject(value) && isObject(def)) {
	            value = extend(value, def);
	          }
	
	          $parse(key).assign(scope, value);
	
	          return scope.$watch(key, function(newVal) {
	            addToLocalStorage(lsKey, newVal, type);
	          }, isObject(scope[key]));
	        };
	
	        // Add listener to local storage, for update callbacks.
	        if (browserSupportsLocalStorage) {
	            if ($window.addEventListener) {
	                $window.addEventListener("storage", handleStorageChangeCallback, false);
	                $rootScope.$on('$destroy', function() {
	                    $window.removeEventListener("storage", handleStorageChangeCallback);
	                });
	            } else if($window.attachEvent){
	                // attachEvent and detachEvent are proprietary to IE v6-10
	                $window.attachEvent("onstorage", handleStorageChangeCallback);
	                $rootScope.$on('$destroy', function() {
	                    $window.detachEvent("onstorage", handleStorageChangeCallback);
	                });
	            }
	        }
	
	        // Callback handler for storage changed.
	        function handleStorageChangeCallback(e) {
	            if (!e) { e = $window.event; }
	            if (notify.setItem) {
	                if (isKeyPrefixOurs(e.key)) {
	                    var key = underiveQualifiedKey(e.key);
	                    // Use timeout, to avoid using $rootScope.$apply.
	                    $timeout(function () {
	                        $rootScope.$broadcast('LocalStorageModule.notification.changed', { key: key, newvalue: e.newValue, storageType: self.storageType });
	                    });
	                }
	            }
	        }
	
	        // Return localStorageService.length
	        // ignore keys that not owned
	        var lengthOfLocalStorage = function(type) {
	          setStorageType(type);
	
	          var count = 0;
	          var storage = $window[storageType];
	          for(var i = 0; i < storage.length; i++) {
	            if(storage.key(i).indexOf(prefix) === 0 ) {
	              count++;
	            }
	          }
	          return count;
	        };
	
	        return {
	          isSupported: browserSupportsLocalStorage,
	          getStorageType: getStorageType,
	          setStorageType: setStorageType,
	          set: addToLocalStorage,
	          add: addToLocalStorage, //DEPRECATED
	          get: getFromLocalStorage,
	          keys: getKeysForLocalStorage,
	          remove: removeFromLocalStorage,
	          clearAll: clearAllFromLocalStorage,
	          bind: bindToScope,
	          deriveKey: deriveQualifiedKey,
	          underiveKey: underiveQualifiedKey,
	          length: lengthOfLocalStorage,
	          defaultToCookie: this.defaultToCookie,
	          cookie: {
	            isSupported: browserSupportsCookies,
	            set: addToCookies,
	            add: addToCookies, //DEPRECATED
	            get: getFromCookies,
	            remove: removeFromCookies,
	            clearAll: clearAllFromCookies
	          }
	        };
	      }];
	  });
	})(window, window.angular);

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(377);
	module.exports = 'ngAnimate';


/***/ },
/* 377 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.6.1
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var ELEMENT_NODE = 1;
	var COMMENT_NODE = 8;
	
	var ADD_CLASS_SUFFIX = '-add';
	var REMOVE_CLASS_SUFFIX = '-remove';
	var EVENT_CLASS_PREFIX = 'ng-';
	var ACTIVE_CLASS_SUFFIX = '-active';
	var PREPARE_CLASS_SUFFIX = '-prepare';
	
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';
	
	// Detect proper transitionend/animationend event names.
	var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;
	
	// If unprefixed events are not supported but webkit-prefixed are, use the latter.
	// Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
	// Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
	// but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
	// Register both events in case `window.onanimationend` is not supported because of that,
	// do the same for `transitionend` as Safari is likely to exhibit similar behavior.
	// Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
	// therefore there is no reason to test anymore for other vendor prefixes:
	// http://caniuse.com/#search=transition
	if ((window.ontransitionend === undefined) && (window.onwebkittransitionend !== undefined)) {
	  CSS_PREFIX = '-webkit-';
	  TRANSITION_PROP = 'WebkitTransition';
	  TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
	} else {
	  TRANSITION_PROP = 'transition';
	  TRANSITIONEND_EVENT = 'transitionend';
	}
	
	if ((window.onanimationend === undefined) && (window.onwebkitanimationend !== undefined)) {
	  CSS_PREFIX = '-webkit-';
	  ANIMATION_PROP = 'WebkitAnimation';
	  ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
	} else {
	  ANIMATION_PROP = 'animation';
	  ANIMATIONEND_EVENT = 'animationend';
	}
	
	var DURATION_KEY = 'Duration';
	var PROPERTY_KEY = 'Property';
	var DELAY_KEY = 'Delay';
	var TIMING_KEY = 'TimingFunction';
	var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
	var ANIMATION_PLAYSTATE_KEY = 'PlayState';
	var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;
	
	var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
	var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
	var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
	var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;
	
	var ngMinErr = angular.$$minErr('ng');
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function packageStyles(options) {
	  var styles = {};
	  if (options && (options.to || options.from)) {
	    styles.to = options.to;
	    styles.from = options.from;
	  }
	  return styles;
	}
	
	function pendClasses(classes, fix, isPrefix) {
	  var className = '';
	  classes = isArray(classes)
	      ? classes
	      : classes && isString(classes) && classes.length
	          ? classes.split(/\s+/)
	          : [];
	  forEach(classes, function(klass, i) {
	    if (klass && klass.length > 0) {
	      className += (i > 0) ? ' ' : '';
	      className += isPrefix ? fix + klass
	                            : klass + fix;
	    }
	  });
	  return className;
	}
	
	function removeFromArray(arr, val) {
	  var index = arr.indexOf(val);
	  if (val >= 0) {
	    arr.splice(index, 1);
	  }
	}
	
	function stripCommentsFromElement(element) {
	  if (element instanceof jqLite) {
	    switch (element.length) {
	      case 0:
	        return element;
	
	      case 1:
	        // there is no point of stripping anything if the element
	        // is the only element within the jqLite wrapper.
	        // (it's important that we retain the element instance.)
	        if (element[0].nodeType === ELEMENT_NODE) {
	          return element;
	        }
	        break;
	
	      default:
	        return jqLite(extractElementNode(element));
	    }
	  }
	
	  if (element.nodeType === ELEMENT_NODE) {
	    return jqLite(element);
	  }
	}
	
	function extractElementNode(element) {
	  if (!element[0]) return element;
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function $$addClass($$jqLite, element, className) {
	  forEach(element, function(elm) {
	    $$jqLite.addClass(elm, className);
	  });
	}
	
	function $$removeClass($$jqLite, element, className) {
	  forEach(element, function(elm) {
	    $$jqLite.removeClass(elm, className);
	  });
	}
	
	function applyAnimationClassesFactory($$jqLite) {
	  return function(element, options) {
	    if (options.addClass) {
	      $$addClass($$jqLite, element, options.addClass);
	      options.addClass = null;
	    }
	    if (options.removeClass) {
	      $$removeClass($$jqLite, element, options.removeClass);
	      options.removeClass = null;
	    }
	  };
	}
	
	function prepareAnimationOptions(options) {
	  options = options || {};
	  if (!options.$$prepared) {
	    var domOperation = options.domOperation || noop;
	    options.domOperation = function() {
	      options.$$domOperationFired = true;
	      domOperation();
	      domOperation = noop;
	    };
	    options.$$prepared = true;
	  }
	  return options;
	}
	
	function applyAnimationStyles(element, options) {
	  applyAnimationFromStyles(element, options);
	  applyAnimationToStyles(element, options);
	}
	
	function applyAnimationFromStyles(element, options) {
	  if (options.from) {
	    element.css(options.from);
	    options.from = null;
	  }
	}
	
	function applyAnimationToStyles(element, options) {
	  if (options.to) {
	    element.css(options.to);
	    options.to = null;
	  }
	}
	
	function mergeAnimationDetails(element, oldAnimation, newAnimation) {
	  var target = oldAnimation.options || {};
	  var newOptions = newAnimation.options || {};
	
	  var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
	  var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
	  var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);
	
	  if (newOptions.preparationClasses) {
	    target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
	    delete newOptions.preparationClasses;
	  }
	
	  // noop is basically when there is no callback; otherwise something has been set
	  var realDomOperation = target.domOperation !== noop ? target.domOperation : null;
	
	  extend(target, newOptions);
	
	  // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
	  if (realDomOperation) {
	    target.domOperation = realDomOperation;
	  }
	
	  if (classes.addClass) {
	    target.addClass = classes.addClass;
	  } else {
	    target.addClass = null;
	  }
	
	  if (classes.removeClass) {
	    target.removeClass = classes.removeClass;
	  } else {
	    target.removeClass = null;
	  }
	
	  oldAnimation.addClass = target.addClass;
	  oldAnimation.removeClass = target.removeClass;
	
	  return target;
	}
	
	function resolveElementClasses(existing, toAdd, toRemove) {
	  var ADD_CLASS = 1;
	  var REMOVE_CLASS = -1;
	
	  var flags = {};
	  existing = splitClassesToLookup(existing);
	
	  toAdd = splitClassesToLookup(toAdd);
	  forEach(toAdd, function(value, key) {
	    flags[key] = ADD_CLASS;
	  });
	
	  toRemove = splitClassesToLookup(toRemove);
	  forEach(toRemove, function(value, key) {
	    flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
	  });
	
	  var classes = {
	    addClass: '',
	    removeClass: ''
	  };
	
	  forEach(flags, function(val, klass) {
	    var prop, allow;
	    if (val === ADD_CLASS) {
	      prop = 'addClass';
	      allow = !existing[klass] || existing[klass + REMOVE_CLASS_SUFFIX];
	    } else if (val === REMOVE_CLASS) {
	      prop = 'removeClass';
	      allow = existing[klass] || existing[klass + ADD_CLASS_SUFFIX];
	    }
	    if (allow) {
	      if (classes[prop].length) {
	        classes[prop] += ' ';
	      }
	      classes[prop] += klass;
	    }
	  });
	
	  function splitClassesToLookup(classes) {
	    if (isString(classes)) {
	      classes = classes.split(' ');
	    }
	
	    var obj = {};
	    forEach(classes, function(klass) {
	      // sometimes the split leaves empty string values
	      // incase extra spaces were applied to the options
	      if (klass.length) {
	        obj[klass] = true;
	      }
	    });
	    return obj;
	  }
	
	  return classes;
	}
	
	function getDomNode(element) {
	  return (element instanceof jqLite) ? element[0] : element;
	}
	
	function applyGeneratedPreparationClasses(element, event, options) {
	  var classes = '';
	  if (event) {
	    classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
	  }
	  if (options.addClass) {
	    classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
	  }
	  if (options.removeClass) {
	    classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
	  }
	  if (classes.length) {
	    options.preparationClasses = classes;
	    element.addClass(classes);
	  }
	}
	
	function clearGeneratedClasses(element, options) {
	  if (options.preparationClasses) {
	    element.removeClass(options.preparationClasses);
	    options.preparationClasses = null;
	  }
	  if (options.activeClasses) {
	    element.removeClass(options.activeClasses);
	    options.activeClasses = null;
	  }
	}
	
	function blockTransitions(node, duration) {
	  // we use a negative delay value since it performs blocking
	  // yet it doesn't kill any existing transitions running on the
	  // same element which makes this safe for class-based animations
	  var value = duration ? '-' + duration + 's' : '';
	  applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
	  return [TRANSITION_DELAY_PROP, value];
	}
	
	function blockKeyframeAnimations(node, applyBlock) {
	  var value = applyBlock ? 'paused' : '';
	  var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
	  applyInlineStyle(node, [key, value]);
	  return [key, value];
	}
	
	function applyInlineStyle(node, styleTuple) {
	  var prop = styleTuple[0];
	  var value = styleTuple[1];
	  node.style[prop] = value;
	}
	
	function concatWithSpace(a,b) {
	  if (!a) return b;
	  if (!b) return a;
	  return a + ' ' + b;
	}
	
	var $$rAFSchedulerFactory = ['$$rAF', function($$rAF) {
	  var queue, cancelFn;
	
	  function scheduler(tasks) {
	    // we make a copy since RAFScheduler mutates the state
	    // of the passed in array variable and this would be difficult
	    // to track down on the outside code
	    queue = queue.concat(tasks);
	    nextTick();
	  }
	
	  queue = scheduler.queue = [];
	
	  /* waitUntilQuiet does two things:
	   * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
	   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
	   *
	   * The motivation here is that animation code can request more time from the scheduler
	   * before the next wave runs. This allows for certain DOM properties such as classes to
	   * be resolved in time for the next animation to run.
	   */
	  scheduler.waitUntilQuiet = function(fn) {
	    if (cancelFn) cancelFn();
	
	    cancelFn = $$rAF(function() {
	      cancelFn = null;
	      fn();
	      nextTick();
	    });
	  };
	
	  return scheduler;
	
	  function nextTick() {
	    if (!queue.length) return;
	
	    var items = queue.shift();
	    for (var i = 0; i < items.length; i++) {
	      items[i]();
	    }
	
	    if (!cancelFn) {
	      $$rAF(function() {
	        if (!cancelFn) nextTick();
	      });
	    }
	  }
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngAnimateChildren
	 * @restrict AE
	 * @element ANY
	 *
	 * @description
	 *
	 * ngAnimateChildren allows you to specify that children of this element should animate even if any
	 * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
	 * (structural) animation, child elements that also have an active structural animation are not animated.
	 *
	 * Note that even if `ngAnimateChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
	 *
	 *
	 * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
	 *     then child animations are allowed. If the value is `false`, child animations are not allowed.
	 *
	 * @example
	 * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
	     <file name="index.html">
	       <div ng-controller="MainController as main">
	         <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
	         <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
	         <hr>
	         <div ng-animate-children="{{main.animateChildren}}">
	           <div ng-if="main.enterElement" class="container">
	             List of items:
	             <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
	           </div>
	         </div>
	       </div>
	     </file>
	     <file name="animations.css">
	
	      .container.ng-enter,
	      .container.ng-leave {
	        transition: all ease 1.5s;
	      }
	
	      .container.ng-enter,
	      .container.ng-leave-active {
	        opacity: 0;
	      }
	
	      .container.ng-leave,
	      .container.ng-enter-active {
	        opacity: 1;
	      }
	
	      .item {
	        background: firebrick;
	        color: #FFF;
	        margin-bottom: 10px;
	      }
	
	      .item.ng-enter,
	      .item.ng-leave {
	        transition: transform 1.5s ease;
	      }
	
	      .item.ng-enter {
	        transform: translateX(50px);
	      }
	
	      .item.ng-enter-active {
	        transform: translateX(0);
	      }
	    </file>
	    <file name="script.js">
	      angular.module('ngAnimateChildren', ['ngAnimate'])
	        .controller('MainController', function MainController() {
	          this.animateChildren = false;
	          this.enterElement = false;
	        });
	    </file>
	  </example>
	 */
	var $$AnimateChildrenDirective = ['$interpolate', function($interpolate) {
	  return {
	    link: function(scope, element, attrs) {
	      var val = attrs.ngAnimateChildren;
	      if (isString(val) && val.length === 0) { //empty attribute
	        element.data(NG_ANIMATE_CHILDREN_DATA, true);
	      } else {
	        // Interpolate and set the value, so that it is available to
	        // animations that run right after compilation
	        setData($interpolate(val)(scope));
	        attrs.$observe('ngAnimateChildren', setData);
	      }
	
	      function setData(value) {
	        value = value === 'on' || value === 'true';
	        element.data(NG_ANIMATE_CHILDREN_DATA, value);
	      }
	    }
	  };
	}];
	
	/* exported $AnimateCssProvider */
	
	var ANIMATE_TIMER_KEY = '$$animateCss';
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 *
	 * @description
	 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
	 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
	 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
	 * directives to create more complex animations that can be purely driven using CSS code.
	 *
	 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
	 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
	 *
	 * ## Usage
	 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
	 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
	 * any automatic control over cancelling animations and/or preventing animations from being run on
	 * child elements will not be handled by Angular. For this to work as expected, please use `$animate` to
	 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
	 * the CSS animation.
	 *
	 * The example below shows how we can create a folding animation on an element using `ng-if`:
	 *
	 * ```html
	 * <!-- notice the `fold-animation` CSS class -->
	 * <div ng-if="onOff" class="fold-animation">
	 *   This element will go BOOM
	 * </div>
	 * <button ng-click="onOff=true">Fold In</button>
	 * ```
	 *
	 * Now we create the **JavaScript animation** that will trigger the CSS transition:
	 *
	 * ```js
	 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       var height = element[0].offsetHeight;
	 *       return $animateCss(element, {
	 *         from: { height:'0px' },
	 *         to: { height:height + 'px' },
	 *         duration: 1 // one second
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ## More Advanced Uses
	 *
	 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
	 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
	 *
	 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
	 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
	 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
	 * to provide a working animation that will run in CSS.
	 *
	 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
	 *
	 * ```js
	 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       var height = element[0].offsetHeight;
	 *       return $animateCss(element, {
	 *         addClass: 'red large-text pulse-twice',
	 *         easing: 'ease-out',
	 *         from: { height:'0px' },
	 *         to: { height:height + 'px' },
	 *         duration: 1 // one second
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
	 *
	 * ```css
	 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
	 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
	 * .red { background:red; }
	 * .large-text { font-size:20px; }
	 *
	 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
	 * .pulse-twice {
	 *   animation: 0.5s pulse linear 2;
	 *   -webkit-animation: 0.5s pulse linear 2;
	 * }
	 *
	 * @keyframes pulse {
	 *   from { transform: scale(0.5); }
	 *   to { transform: scale(1.5); }
	 * }
	 *
	 * @-webkit-keyframes pulse {
	 *   from { -webkit-transform: scale(0.5); }
	 *   to { -webkit-transform: scale(1.5); }
	 * }
	 * ```
	 *
	 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
	 *
	 * ## How the Options are handled
	 *
	 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
	 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
	 * styles using the `from` and `to` properties.
	 *
	 * ```js
	 * var animator = $animateCss(element, {
	 *   from: { background:'red' },
	 *   to: { background:'blue' }
	 * });
	 * animator.start();
	 * ```
	 *
	 * ```css
	 * .rotating-animation {
	 *   animation:0.5s rotate linear;
	 *   -webkit-animation:0.5s rotate linear;
	 * }
	 *
	 * @keyframes rotate {
	 *   from { transform: rotate(0deg); }
	 *   to { transform: rotate(360deg); }
	 * }
	 *
	 * @-webkit-keyframes rotate {
	 *   from { -webkit-transform: rotate(0deg); }
	 *   to { -webkit-transform: rotate(360deg); }
	 * }
	 * ```
	 *
	 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
	 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
	 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
	 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
	 * and spread across the transition and keyframe animation.
	 *
	 * ## What is returned
	 *
	 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
	 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
	 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
	 *
	 * ```js
	 * var animator = $animateCss(element, { ... });
	 * ```
	 *
	 * Now what do the contents of our `animator` variable look like:
	 *
	 * ```js
	 * {
	 *   // starts the animation
	 *   start: Function,
	 *
	 *   // ends (aborts) the animation
	 *   end: Function
	 * }
	 * ```
	 *
	 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
	 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
	 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
	 * and that changing them will not reconfigure the parameters of the animation.
	 *
	 * ### runner.done() vs runner.then()
	 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
	 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
	 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
	 * unless you really need a digest to kick off afterwards.
	 *
	 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
	 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
	 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
	 *
	 * @param {DOMElement} element the element that will be animated
	 * @param {object} options the animation-related options that will be applied during the animation
	 *
	 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
	 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
	 * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
	 * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
	 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
	 * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
	 * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
	 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
	 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
	 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
	 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
	 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
	 * is provided then the animation will be skipped entirely.
	 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
	 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
	 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
	 * CSS delay value.
	 * * `stagger` - A numeric time value representing the delay between successively animated elements
	 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
	 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
	 *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
	 * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
	 * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
	 *    the animation is closed. This is useful for when the styles are used purely for the sake of
	 *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
	 *    By default this value is set to `false`.
	 *
	 * @return {object} an object with start and end methods and details about the animation.
	 *
	 * * `start` - The method to start the animation. This will return a `Promise` when called.
	 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
	 */
	var ONE_SECOND = 1000;
	
	var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
	var CLOSING_TIME_BUFFER = 1.5;
	
	var DETECT_CSS_PROPERTIES = {
	  transitionDuration:      TRANSITION_DURATION_PROP,
	  transitionDelay:         TRANSITION_DELAY_PROP,
	  transitionProperty:      TRANSITION_PROP + PROPERTY_KEY,
	  animationDuration:       ANIMATION_DURATION_PROP,
	  animationDelay:          ANIMATION_DELAY_PROP,
	  animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
	};
	
	var DETECT_STAGGER_CSS_PROPERTIES = {
	  transitionDuration:      TRANSITION_DURATION_PROP,
	  transitionDelay:         TRANSITION_DELAY_PROP,
	  animationDuration:       ANIMATION_DURATION_PROP,
	  animationDelay:          ANIMATION_DELAY_PROP
	};
	
	function getCssKeyframeDurationStyle(duration) {
	  return [ANIMATION_DURATION_PROP, duration + 's'];
	}
	
	function getCssDelayStyle(delay, isKeyframeAnimation) {
	  var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
	  return [prop, delay + 's'];
	}
	
	function computeCssStyles($window, element, properties) {
	  var styles = Object.create(null);
	  var detectedStyles = $window.getComputedStyle(element) || {};
	  forEach(properties, function(formalStyleName, actualStyleName) {
	    var val = detectedStyles[formalStyleName];
	    if (val) {
	      var c = val.charAt(0);
	
	      // only numerical-based values have a negative sign or digit as the first value
	      if (c === '-' || c === '+' || c >= 0) {
	        val = parseMaxTime(val);
	      }
	
	      // by setting this to null in the event that the delay is not set or is set directly as 0
	      // then we can still allow for negative values to be used later on and not mistake this
	      // value for being greater than any other negative value.
	      if (val === 0) {
	        val = null;
	      }
	      styles[actualStyleName] = val;
	    }
	  });
	
	  return styles;
	}
	
	function parseMaxTime(str) {
	  var maxValue = 0;
	  var values = str.split(/\s*,\s*/);
	  forEach(values, function(value) {
	    // it's always safe to consider only second values and omit `ms` values since
	    // getComputedStyle will always handle the conversion for us
	    if (value.charAt(value.length - 1) === 's') {
	      value = value.substring(0, value.length - 1);
	    }
	    value = parseFloat(value) || 0;
	    maxValue = maxValue ? Math.max(value, maxValue) : value;
	  });
	  return maxValue;
	}
	
	function truthyTimingValue(val) {
	  return val === 0 || val != null;
	}
	
	function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
	  var style = TRANSITION_PROP;
	  var value = duration + 's';
	  if (applyOnlyDuration) {
	    style += DURATION_KEY;
	  } else {
	    value += ' linear all';
	  }
	  return [style, value];
	}
	
	function createLocalCacheLookup() {
	  var cache = Object.create(null);
	  return {
	    flush: function() {
	      cache = Object.create(null);
	    },
	
	    count: function(key) {
	      var entry = cache[key];
	      return entry ? entry.total : 0;
	    },
	
	    get: function(key) {
	      var entry = cache[key];
	      return entry && entry.value;
	    },
	
	    put: function(key, value) {
	      if (!cache[key]) {
	        cache[key] = { total: 1, value: value };
	      } else {
	        cache[key].total++;
	      }
	    }
	  };
	}
	
	// we do not reassign an already present style value since
	// if we detect the style property value again we may be
	// detecting styles that were added via the `from` styles.
	// We make use of `isDefined` here since an empty string
	// or null value (which is what getPropertyValue will return
	// for a non-existing style) will still be marked as a valid
	// value for the style (a falsy value implies that the style
	// is to be removed at the end of the animation). If we had a simple
	// "OR" statement then it would not be enough to catch that.
	function registerRestorableStyles(backup, node, properties) {
	  forEach(properties, function(prop) {
	    backup[prop] = isDefined(backup[prop])
	        ? backup[prop]
	        : node.style.getPropertyValue(prop);
	  });
	}
	
	var $AnimateCssProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  var gcsLookup = createLocalCacheLookup();
	  var gcsStaggerLookup = createLocalCacheLookup();
	
	  this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout',
	               '$$forceReflow', '$sniffer', '$$rAFScheduler', '$$animateQueue',
	       function($window,   $$jqLite,   $$AnimateRunner,   $timeout,
	                $$forceReflow,   $sniffer,   $$rAFScheduler, $$animateQueue) {
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    var parentCounter = 0;
	    function gcsHashFn(node, extraClasses) {
	      var KEY = '$$ngAnimateParentKey';
	      var parentNode = node.parentNode;
	      var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
	      return parentID + '-' + node.getAttribute('class') + '-' + extraClasses;
	    }
	
	    function computeCachedCssStyles(node, className, cacheKey, properties) {
	      var timings = gcsLookup.get(cacheKey);
	
	      if (!timings) {
	        timings = computeCssStyles($window, node, properties);
	        if (timings.animationIterationCount === 'infinite') {
	          timings.animationIterationCount = 1;
	        }
	      }
	
	      // we keep putting this in multiple times even though the value and the cacheKey are the same
	      // because we're keeping an internal tally of how many duplicate animations are detected.
	      gcsLookup.put(cacheKey, timings);
	      return timings;
	    }
	
	    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
	      var stagger;
	
	      // if we have one or more existing matches of matching elements
	      // containing the same parent + CSS styles (which is how cacheKey works)
	      // then staggering is possible
	      if (gcsLookup.count(cacheKey) > 0) {
	        stagger = gcsStaggerLookup.get(cacheKey);
	
	        if (!stagger) {
	          var staggerClassName = pendClasses(className, '-stagger');
	
	          $$jqLite.addClass(node, staggerClassName);
	
	          stagger = computeCssStyles($window, node, properties);
	
	          // force the conversion of a null value to zero incase not set
	          stagger.animationDuration = Math.max(stagger.animationDuration, 0);
	          stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);
	
	          $$jqLite.removeClass(node, staggerClassName);
	
	          gcsStaggerLookup.put(cacheKey, stagger);
	        }
	      }
	
	      return stagger || {};
	    }
	
	    var rafWaitQueue = [];
	    function waitUntilQuiet(callback) {
	      rafWaitQueue.push(callback);
	      $$rAFScheduler.waitUntilQuiet(function() {
	        gcsLookup.flush();
	        gcsStaggerLookup.flush();
	
	        // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
	        // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
	        var pageWidth = $$forceReflow();
	
	        // we use a for loop to ensure that if the queue is changed
	        // during this looping then it will consider new requests
	        for (var i = 0; i < rafWaitQueue.length; i++) {
	          rafWaitQueue[i](pageWidth);
	        }
	        rafWaitQueue.length = 0;
	      });
	    }
	
	    function computeTimings(node, className, cacheKey) {
	      var timings = computeCachedCssStyles(node, className, cacheKey, DETECT_CSS_PROPERTIES);
	      var aD = timings.animationDelay;
	      var tD = timings.transitionDelay;
	      timings.maxDelay = aD && tD
	          ? Math.max(aD, tD)
	          : (aD || tD);
	      timings.maxDuration = Math.max(
	          timings.animationDuration * timings.animationIterationCount,
	          timings.transitionDuration);
	
	      return timings;
	    }
	
	    return function init(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = prepareAnimationOptions(copy(options));
	      }
	
	      var restoreStyles = {};
	      var node = getDomNode(element);
	      if (!node
	          || !node.parentNode
	          || !$$animateQueue.enabled()) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var temporaryStyles = [];
	      var classes = element.attr('class');
	      var styles = packageStyles(options);
	      var animationClosed;
	      var animationPaused;
	      var animationCompleted;
	      var runner;
	      var runnerHost;
	      var maxDelay;
	      var maxDelayTime;
	      var maxDuration;
	      var maxDurationTime;
	      var startTime;
	      var events = [];
	
	      if (options.duration === 0 || (!$sniffer.animations && !$sniffer.transitions)) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var method = options.event && isArray(options.event)
	            ? options.event.join(' ')
	            : options.event;
	
	      var isStructural = method && options.structural;
	      var structuralClassName = '';
	      var addRemoveClassName = '';
	
	      if (isStructural) {
	        structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
	      } else if (method) {
	        structuralClassName = method;
	      }
	
	      if (options.addClass) {
	        addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
	      }
	
	      if (options.removeClass) {
	        if (addRemoveClassName.length) {
	          addRemoveClassName += ' ';
	        }
	        addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
	      }
	
	      // there may be a situation where a structural animation is combined together
	      // with CSS classes that need to resolve before the animation is computed.
	      // However this means that there is no explicit CSS code to block the animation
	      // from happening (by setting 0s none in the class name). If this is the case
	      // we need to apply the classes before the first rAF so we know to continue if
	      // there actually is a detected transition or keyframe animation
	      if (options.applyClassesEarly && addRemoveClassName.length) {
	        applyAnimationClasses(element, options);
	      }
	
	      var preparationClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
	      var fullClassName = classes + ' ' + preparationClasses;
	      var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);
	      var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
	      var containsKeyframeAnimation = (options.keyframeStyle || '').length > 0;
	
	      // there is no way we can trigger an animation if no styles and
	      // no classes are being applied which would then trigger a transition,
	      // unless there a is raw keyframe value that is applied to the element.
	      if (!containsKeyframeAnimation
	           && !hasToStyles
	           && !preparationClasses) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var cacheKey, stagger;
	      if (options.stagger > 0) {
	        var staggerVal = parseFloat(options.stagger);
	        stagger = {
	          transitionDelay: staggerVal,
	          animationDelay: staggerVal,
	          transitionDuration: 0,
	          animationDuration: 0
	        };
	      } else {
	        cacheKey = gcsHashFn(node, fullClassName);
	        stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
	      }
	
	      if (!options.$$skipPreparationClasses) {
	        $$jqLite.addClass(element, preparationClasses);
	      }
	
	      var applyOnlyDuration;
	
	      if (options.transitionStyle) {
	        var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
	        applyInlineStyle(node, transitionStyle);
	        temporaryStyles.push(transitionStyle);
	      }
	
	      if (options.duration >= 0) {
	        applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
	        var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);
	
	        // we set the duration so that it will be picked up by getComputedStyle later
	        applyInlineStyle(node, durationStyle);
	        temporaryStyles.push(durationStyle);
	      }
	
	      if (options.keyframeStyle) {
	        var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
	        applyInlineStyle(node, keyframeStyle);
	        temporaryStyles.push(keyframeStyle);
	      }
	
	      var itemIndex = stagger
	          ? options.staggerIndex >= 0
	              ? options.staggerIndex
	              : gcsLookup.count(cacheKey)
	          : 0;
	
	      var isFirst = itemIndex === 0;
	
	      // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
	      // without causing any combination of transitions to kick in. By adding a negative delay value
	      // it forces the setup class' transition to end immediately. We later then remove the negative
	      // transition delay to allow for the transition to naturally do it's thing. The beauty here is
	      // that if there is no transition defined then nothing will happen and this will also allow
	      // other transitions to be stacked on top of each other without any chopping them out.
	      if (isFirst && !options.skipBlocking) {
	        blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
	      }
	
	      var timings = computeTimings(node, fullClassName, cacheKey);
	      var relativeDelay = timings.maxDelay;
	      maxDelay = Math.max(relativeDelay, 0);
	      maxDuration = timings.maxDuration;
	
	      var flags = {};
	      flags.hasTransitions          = timings.transitionDuration > 0;
	      flags.hasAnimations           = timings.animationDuration > 0;
	      flags.hasTransitionAll        = flags.hasTransitions && timings.transitionProperty === 'all';
	      flags.applyTransitionDuration = hasToStyles && (
	                                        (flags.hasTransitions && !flags.hasTransitionAll)
	                                         || (flags.hasAnimations && !flags.hasTransitions));
	      flags.applyAnimationDuration  = options.duration && flags.hasAnimations;
	      flags.applyTransitionDelay    = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
	      flags.applyAnimationDelay     = truthyTimingValue(options.delay) && flags.hasAnimations;
	      flags.recalculateTimingStyles = addRemoveClassName.length > 0;
	
	      if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
	        maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;
	
	        if (flags.applyTransitionDuration) {
	          flags.hasTransitions = true;
	          timings.transitionDuration = maxDuration;
	          applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
	          temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
	        }
	
	        if (flags.applyAnimationDuration) {
	          flags.hasAnimations = true;
	          timings.animationDuration = maxDuration;
	          temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
	        }
	      }
	
	      if (maxDuration === 0 && !flags.recalculateTimingStyles) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      if (options.delay != null) {
	        var delayStyle;
	        if (typeof options.delay !== 'boolean') {
	          delayStyle = parseFloat(options.delay);
	          // number in options.delay means we have to recalculate the delay for the closing timeout
	          maxDelay = Math.max(delayStyle, 0);
	        }
	
	        if (flags.applyTransitionDelay) {
	          temporaryStyles.push(getCssDelayStyle(delayStyle));
	        }
	
	        if (flags.applyAnimationDelay) {
	          temporaryStyles.push(getCssDelayStyle(delayStyle, true));
	        }
	      }
	
	      // we need to recalculate the delay value since we used a pre-emptive negative
	      // delay value and the delay value is required for the final event checking. This
	      // property will ensure that this will happen after the RAF phase has passed.
	      if (options.duration == null && timings.transitionDuration > 0) {
	        flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
	      }
	
	      maxDelayTime = maxDelay * ONE_SECOND;
	      maxDurationTime = maxDuration * ONE_SECOND;
	      if (!options.skipBlocking) {
	        flags.blockTransition = timings.transitionDuration > 0;
	        flags.blockKeyframeAnimation = timings.animationDuration > 0 &&
	                                       stagger.animationDelay > 0 &&
	                                       stagger.animationDuration === 0;
	      }
	
	      if (options.from) {
	        if (options.cleanupStyles) {
	          registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
	        }
	        applyAnimationFromStyles(element, options);
	      }
	
	      if (flags.blockTransition || flags.blockKeyframeAnimation) {
	        applyBlocking(maxDuration);
	      } else if (!options.skipBlocking) {
	        blockTransitions(node, false);
	      }
	
	      // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
	      return {
	        $$willAnimate: true,
	        end: endFn,
	        start: function() {
	          if (animationClosed) return;
	
	          runnerHost = {
	            end: endFn,
	            cancel: cancelFn,
	            resume: null, //this will be set during the start() phase
	            pause: null
	          };
	
	          runner = new $$AnimateRunner(runnerHost);
	
	          waitUntilQuiet(start);
	
	          // we don't have access to pause/resume the animation
	          // since it hasn't run yet. AnimateRunner will therefore
	          // set noop functions for resume and pause and they will
	          // later be overridden once the animation is triggered
	          return runner;
	        }
	      };
	
	      function endFn() {
	        close();
	      }
	
	      function cancelFn() {
	        close(true);
	      }
	
	      function close(rejected) {
	        // if the promise has been called already then we shouldn't close
	        // the animation again
	        if (animationClosed || (animationCompleted && animationPaused)) return;
	        animationClosed = true;
	        animationPaused = false;
	
	        if (!options.$$skipPreparationClasses) {
	          $$jqLite.removeClass(element, preparationClasses);
	        }
	        $$jqLite.removeClass(element, activeClasses);
	
	        blockKeyframeAnimations(node, false);
	        blockTransitions(node, false);
	
	        forEach(temporaryStyles, function(entry) {
	          // There is only one way to remove inline style properties entirely from elements.
	          // By using `removeProperty` this works, but we need to convert camel-cased CSS
	          // styles down to hyphenated values.
	          node.style[entry[0]] = '';
	        });
	
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	
	        if (Object.keys(restoreStyles).length) {
	          forEach(restoreStyles, function(value, prop) {
	            if (value) {
	              node.style.setProperty(prop, value);
	            } else {
	              node.style.removeProperty(prop);
	            }
	          });
	        }
	
	        // the reason why we have this option is to allow a synchronous closing callback
	        // that is fired as SOON as the animation ends (when the CSS is removed) or if
	        // the animation never takes off at all. A good example is a leave animation since
	        // the element must be removed just after the animation is over or else the element
	        // will appear on screen for one animation frame causing an overbearing flicker.
	        if (options.onDone) {
	          options.onDone();
	        }
	
	        if (events && events.length) {
	          // Remove the transitionend / animationend listener(s)
	          element.off(events.join(' '), onAnimationProgress);
	        }
	
	        //Cancel the fallback closing timeout and remove the timer data
	        var animationTimerData = element.data(ANIMATE_TIMER_KEY);
	        if (animationTimerData) {
	          $timeout.cancel(animationTimerData[0].timer);
	          element.removeData(ANIMATE_TIMER_KEY);
	        }
	
	        // if the preparation function fails then the promise is not setup
	        if (runner) {
	          runner.complete(!rejected);
	        }
	      }
	
	      function applyBlocking(duration) {
	        if (flags.blockTransition) {
	          blockTransitions(node, duration);
	        }
	
	        if (flags.blockKeyframeAnimation) {
	          blockKeyframeAnimations(node, !!duration);
	        }
	      }
	
	      function closeAndReturnNoopAnimator() {
	        runner = new $$AnimateRunner({
	          end: endFn,
	          cancel: cancelFn
	        });
	
	        // should flush the cache animation
	        waitUntilQuiet(noop);
	        close();
	
	        return {
	          $$willAnimate: false,
	          start: function() {
	            return runner;
	          },
	          end: endFn
	        };
	      }
	
	      function onAnimationProgress(event) {
	        event.stopPropagation();
	        var ev = event.originalEvent || event;
	
	        // we now always use `Date.now()` due to the recent changes with
	        // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
	        var timeStamp = ev.$manualTimeStamp || Date.now();
	
	        /* Firefox (or possibly just Gecko) likes to not round values up
	         * when a ms measurement is used for the animation */
	        var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));
	
	        /* $manualTimeStamp is a mocked timeStamp value which is set
	         * within browserTrigger(). This is only here so that tests can
	         * mock animations properly. Real events fallback to event.timeStamp,
	         * or, if they don't, then a timeStamp is automatically created for them.
	         * We're checking to see if the timeStamp surpasses the expected delay,
	         * but we're using elapsedTime instead of the timeStamp on the 2nd
	         * pre-condition since animationPauseds sometimes close off early */
	        if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
	          // we set this flag to ensure that if the transition is paused then, when resumed,
	          // the animation will automatically close itself since transitions cannot be paused.
	          animationCompleted = true;
	          close();
	        }
	      }
	
	      function start() {
	        if (animationClosed) return;
	        if (!node.parentNode) {
	          close();
	          return;
	        }
	
	        // even though we only pause keyframe animations here the pause flag
	        // will still happen when transitions are used. Only the transition will
	        // not be paused since that is not possible. If the animation ends when
	        // paused then it will not complete until unpaused or cancelled.
	        var playPause = function(playAnimation) {
	          if (!animationCompleted) {
	            animationPaused = !playAnimation;
	            if (timings.animationDuration) {
	              var value = blockKeyframeAnimations(node, animationPaused);
	              if (animationPaused) {
	                temporaryStyles.push(value);
	              } else {
	                removeFromArray(temporaryStyles, value);
	              }
	            }
	          } else if (animationPaused && playAnimation) {
	            animationPaused = false;
	            close();
	          }
	        };
	
	        // checking the stagger duration prevents an accidentally cascade of the CSS delay style
	        // being inherited from the parent. If the transition duration is zero then we can safely
	        // rely that the delay value is an intentional stagger delay style.
	        var maxStagger = itemIndex > 0
	                         && ((timings.transitionDuration && stagger.transitionDuration === 0) ||
	                            (timings.animationDuration && stagger.animationDuration === 0))
	                         && Math.max(stagger.animationDelay, stagger.transitionDelay);
	        if (maxStagger) {
	          $timeout(triggerAnimationStart,
	                   Math.floor(maxStagger * itemIndex * ONE_SECOND),
	                   false);
	        } else {
	          triggerAnimationStart();
	        }
	
	        // this will decorate the existing promise runner with pause/resume methods
	        runnerHost.resume = function() {
	          playPause(true);
	        };
	
	        runnerHost.pause = function() {
	          playPause(false);
	        };
	
	        function triggerAnimationStart() {
	          // just incase a stagger animation kicks in when the animation
	          // itself was cancelled entirely
	          if (animationClosed) return;
	
	          applyBlocking(false);
	
	          forEach(temporaryStyles, function(entry) {
	            var key = entry[0];
	            var value = entry[1];
	            node.style[key] = value;
	          });
	
	          applyAnimationClasses(element, options);
	          $$jqLite.addClass(element, activeClasses);
	
	          if (flags.recalculateTimingStyles) {
	            fullClassName = node.getAttribute('class') + ' ' + preparationClasses;
	            cacheKey = gcsHashFn(node, fullClassName);
	
	            timings = computeTimings(node, fullClassName, cacheKey);
	            relativeDelay = timings.maxDelay;
	            maxDelay = Math.max(relativeDelay, 0);
	            maxDuration = timings.maxDuration;
	
	            if (maxDuration === 0) {
	              close();
	              return;
	            }
	
	            flags.hasTransitions = timings.transitionDuration > 0;
	            flags.hasAnimations = timings.animationDuration > 0;
	          }
	
	          if (flags.applyAnimationDelay) {
	            relativeDelay = typeof options.delay !== 'boolean' && truthyTimingValue(options.delay)
	                  ? parseFloat(options.delay)
	                  : relativeDelay;
	
	            maxDelay = Math.max(relativeDelay, 0);
	            timings.animationDelay = relativeDelay;
	            delayStyle = getCssDelayStyle(relativeDelay, true);
	            temporaryStyles.push(delayStyle);
	            node.style[delayStyle[0]] = delayStyle[1];
	          }
	
	          maxDelayTime = maxDelay * ONE_SECOND;
	          maxDurationTime = maxDuration * ONE_SECOND;
	
	          if (options.easing) {
	            var easeProp, easeVal = options.easing;
	            if (flags.hasTransitions) {
	              easeProp = TRANSITION_PROP + TIMING_KEY;
	              temporaryStyles.push([easeProp, easeVal]);
	              node.style[easeProp] = easeVal;
	            }
	            if (flags.hasAnimations) {
	              easeProp = ANIMATION_PROP + TIMING_KEY;
	              temporaryStyles.push([easeProp, easeVal]);
	              node.style[easeProp] = easeVal;
	            }
	          }
	
	          if (timings.transitionDuration) {
	            events.push(TRANSITIONEND_EVENT);
	          }
	
	          if (timings.animationDuration) {
	            events.push(ANIMATIONEND_EVENT);
	          }
	
	          startTime = Date.now();
	          var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
	          var endTime = startTime + timerTime;
	
	          var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
	          var setupFallbackTimer = true;
	          if (animationsData.length) {
	            var currentTimerData = animationsData[0];
	            setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
	            if (setupFallbackTimer) {
	              $timeout.cancel(currentTimerData.timer);
	            } else {
	              animationsData.push(close);
	            }
	          }
	
	          if (setupFallbackTimer) {
	            var timer = $timeout(onAnimationExpired, timerTime, false);
	            animationsData[0] = {
	              timer: timer,
	              expectedEndTime: endTime
	            };
	            animationsData.push(close);
	            element.data(ANIMATE_TIMER_KEY, animationsData);
	          }
	
	          if (events.length) {
	            element.on(events.join(' '), onAnimationProgress);
	          }
	
	          if (options.to) {
	            if (options.cleanupStyles) {
	              registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
	            }
	            applyAnimationToStyles(element, options);
	          }
	        }
	
	        function onAnimationExpired() {
	          var animationsData = element.data(ANIMATE_TIMER_KEY);
	
	          // this will be false in the event that the element was
	          // removed from the DOM (via a leave animation or something
	          // similar)
	          if (animationsData) {
	            for (var i = 1; i < animationsData.length; i++) {
	              animationsData[i]();
	            }
	            element.removeData(ANIMATE_TIMER_KEY);
	          }
	        }
	      }
	    };
	  }];
	}];
	
	var $$AnimateCssDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
	  $$animationProvider.drivers.push('$$animateCssDriver');
	
	  var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
	  var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';
	
	  var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
	  var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';
	
	  function isDocumentFragment(node) {
	    return node.parentNode && node.parentNode.nodeType === 11;
	  }
	
	  this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$sniffer', '$$jqLite', '$document',
	       function($animateCss,   $rootScope,   $$AnimateRunner,   $rootElement,   $sniffer,   $$jqLite,   $document) {
	
	    // only browsers that support these properties can render animations
	    if (!$sniffer.animations && !$sniffer.transitions) return noop;
	
	    var bodyNode = $document[0].body;
	    var rootNode = getDomNode($rootElement);
	
	    var rootBodyElement = jqLite(
	      // this is to avoid using something that exists outside of the body
	      // we also special case the doc fragment case because our unit test code
	      // appends the $rootElement to the body after the app has been bootstrapped
	      isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode
	    );
	
	    return function initDriverFn(animationDetails) {
	      return animationDetails.from && animationDetails.to
	          ? prepareFromToAnchorAnimation(animationDetails.from,
	                                         animationDetails.to,
	                                         animationDetails.classes,
	                                         animationDetails.anchors)
	          : prepareRegularAnimation(animationDetails);
	    };
	
	    function filterCssClasses(classes) {
	      //remove all the `ng-` stuff
	      return classes.replace(/\bng-\S+\b/g, '');
	    }
	
	    function getUniqueValues(a, b) {
	      if (isString(a)) a = a.split(' ');
	      if (isString(b)) b = b.split(' ');
	      return a.filter(function(val) {
	        return b.indexOf(val) === -1;
	      }).join(' ');
	    }
	
	    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
	      var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
	      var startingClasses = filterCssClasses(getClassVal(clone));
	
	      outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
	      inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
	
	      clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);
	
	      rootBodyElement.append(clone);
	
	      var animatorIn, animatorOut = prepareOutAnimation();
	
	      // the user may not end up using the `out` animation and
	      // only making use of the `in` animation or vice-versa.
	      // In either case we should allow this and not assume the
	      // animation is over unless both animations are not used.
	      if (!animatorOut) {
	        animatorIn = prepareInAnimation();
	        if (!animatorIn) {
	          return end();
	        }
	      }
	
	      var startingAnimator = animatorOut || animatorIn;
	
	      return {
	        start: function() {
	          var runner;
	
	          var currentAnimation = startingAnimator.start();
	          currentAnimation.done(function() {
	            currentAnimation = null;
	            if (!animatorIn) {
	              animatorIn = prepareInAnimation();
	              if (animatorIn) {
	                currentAnimation = animatorIn.start();
	                currentAnimation.done(function() {
	                  currentAnimation = null;
	                  end();
	                  runner.complete();
	                });
	                return currentAnimation;
	              }
	            }
	            // in the event that there is no `in` animation
	            end();
	            runner.complete();
	          });
	
	          runner = new $$AnimateRunner({
	            end: endFn,
	            cancel: endFn
	          });
	
	          return runner;
	
	          function endFn() {
	            if (currentAnimation) {
	              currentAnimation.end();
	            }
	          }
	        }
	      };
	
	      function calculateAnchorStyles(anchor) {
	        var styles = {};
	
	        var coords = getDomNode(anchor).getBoundingClientRect();
	
	        // we iterate directly since safari messes up and doesn't return
	        // all the keys for the coords object when iterated
	        forEach(['width','height','top','left'], function(key) {
	          var value = coords[key];
	          switch (key) {
	            case 'top':
	              value += bodyNode.scrollTop;
	              break;
	            case 'left':
	              value += bodyNode.scrollLeft;
	              break;
	          }
	          styles[key] = Math.floor(value) + 'px';
	        });
	        return styles;
	      }
	
	      function prepareOutAnimation() {
	        var animator = $animateCss(clone, {
	          addClass: NG_OUT_ANCHOR_CLASS_NAME,
	          delay: true,
	          from: calculateAnchorStyles(outAnchor)
	        });
	
	        // read the comment within `prepareRegularAnimation` to understand
	        // why this check is necessary
	        return animator.$$willAnimate ? animator : null;
	      }
	
	      function getClassVal(element) {
	        return element.attr('class') || '';
	      }
	
	      function prepareInAnimation() {
	        var endingClasses = filterCssClasses(getClassVal(inAnchor));
	        var toAdd = getUniqueValues(endingClasses, startingClasses);
	        var toRemove = getUniqueValues(startingClasses, endingClasses);
	
	        var animator = $animateCss(clone, {
	          to: calculateAnchorStyles(inAnchor),
	          addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
	          removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
	          delay: true
	        });
	
	        // read the comment within `prepareRegularAnimation` to understand
	        // why this check is necessary
	        return animator.$$willAnimate ? animator : null;
	      }
	
	      function end() {
	        clone.remove();
	        outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
	        inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
	      }
	    }
	
	    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
	      var fromAnimation = prepareRegularAnimation(from, noop);
	      var toAnimation = prepareRegularAnimation(to, noop);
	
	      var anchorAnimations = [];
	      forEach(anchors, function(anchor) {
	        var outElement = anchor['out'];
	        var inElement = anchor['in'];
	        var animator = prepareAnchoredAnimation(classes, outElement, inElement);
	        if (animator) {
	          anchorAnimations.push(animator);
	        }
	      });
	
	      // no point in doing anything when there are no elements to animate
	      if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;
	
	      return {
	        start: function() {
	          var animationRunners = [];
	
	          if (fromAnimation) {
	            animationRunners.push(fromAnimation.start());
	          }
	
	          if (toAnimation) {
	            animationRunners.push(toAnimation.start());
	          }
	
	          forEach(anchorAnimations, function(animation) {
	            animationRunners.push(animation.start());
	          });
	
	          var runner = new $$AnimateRunner({
	            end: endFn,
	            cancel: endFn // CSS-driven animations cannot be cancelled, only ended
	          });
	
	          $$AnimateRunner.all(animationRunners, function(status) {
	            runner.complete(status);
	          });
	
	          return runner;
	
	          function endFn() {
	            forEach(animationRunners, function(runner) {
	              runner.end();
	            });
	          }
	        }
	      };
	    }
	
	    function prepareRegularAnimation(animationDetails) {
	      var element = animationDetails.element;
	      var options = animationDetails.options || {};
	
	      if (animationDetails.structural) {
	        options.event = animationDetails.event;
	        options.structural = true;
	        options.applyClassesEarly = true;
	
	        // we special case the leave animation since we want to ensure that
	        // the element is removed as soon as the animation is over. Otherwise
	        // a flicker might appear or the element may not be removed at all
	        if (animationDetails.event === 'leave') {
	          options.onDone = options.domOperation;
	        }
	      }
	
	      // We assign the preparationClasses as the actual animation event since
	      // the internals of $animateCss will just suffix the event token values
	      // with `-active` to trigger the animation.
	      if (options.preparationClasses) {
	        options.event = concatWithSpace(options.event, options.preparationClasses);
	      }
	
	      var animator = $animateCss(element, options);
	
	      // the driver lookup code inside of $$animation attempts to spawn a
	      // driver one by one until a driver returns a.$$willAnimate animator object.
	      // $animateCss will always return an object, however, it will pass in
	      // a flag as a hint as to whether an animation was detected or not
	      return animator.$$willAnimate ? animator : null;
	    }
	  }];
	}];
	
	// TODO(matsko): use caching here to speed things up for detection
	// TODO(matsko): add documentation
	//  by the time...
	
	var $$AnimateJsProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  this.$get = ['$injector', '$$AnimateRunner', '$$jqLite',
	       function($injector,   $$AnimateRunner,   $$jqLite) {
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	         // $animateJs(element, 'enter');
	    return function(element, event, classes, options) {
	      var animationClosed = false;
	
	      // the `classes` argument is optional and if it is not used
	      // then the classes will be resolved from the element's className
	      // property as well as options.addClass/options.removeClass.
	      if (arguments.length === 3 && isObject(classes)) {
	        options = classes;
	        classes = null;
	      }
	
	      options = prepareAnimationOptions(options);
	      if (!classes) {
	        classes = element.attr('class') || '';
	        if (options.addClass) {
	          classes += ' ' + options.addClass;
	        }
	        if (options.removeClass) {
	          classes += ' ' + options.removeClass;
	        }
	      }
	
	      var classesToAdd = options.addClass;
	      var classesToRemove = options.removeClass;
	
	      // the lookupAnimations function returns a series of animation objects that are
	      // matched up with one or more of the CSS classes. These animation objects are
	      // defined via the module.animation factory function. If nothing is detected then
	      // we don't return anything which then makes $animation query the next driver.
	      var animations = lookupAnimations(classes);
	      var before, after;
	      if (animations.length) {
	        var afterFn, beforeFn;
	        if (event === 'leave') {
	          beforeFn = 'leave';
	          afterFn = 'afterLeave'; // TODO(matsko): get rid of this
	        } else {
	          beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
	          afterFn = event;
	        }
	
	        if (event !== 'enter' && event !== 'move') {
	          before = packageAnimations(element, event, options, animations, beforeFn);
	        }
	        after  = packageAnimations(element, event, options, animations, afterFn);
	      }
	
	      // no matching animations
	      if (!before && !after) return;
	
	      function applyOptions() {
	        options.domOperation();
	        applyAnimationClasses(element, options);
	      }
	
	      function close() {
	        animationClosed = true;
	        applyOptions();
	        applyAnimationStyles(element, options);
	      }
	
	      var runner;
	
	      return {
	        $$willAnimate: true,
	        end: function() {
	          if (runner) {
	            runner.end();
	          } else {
	            close();
	            runner = new $$AnimateRunner();
	            runner.complete(true);
	          }
	          return runner;
	        },
	        start: function() {
	          if (runner) {
	            return runner;
	          }
	
	          runner = new $$AnimateRunner();
	          var closeActiveAnimations;
	          var chain = [];
	
	          if (before) {
	            chain.push(function(fn) {
	              closeActiveAnimations = before(fn);
	            });
	          }
	
	          if (chain.length) {
	            chain.push(function(fn) {
	              applyOptions();
	              fn(true);
	            });
	          } else {
	            applyOptions();
	          }
	
	          if (after) {
	            chain.push(function(fn) {
	              closeActiveAnimations = after(fn);
	            });
	          }
	
	          runner.setHost({
	            end: function() {
	              endAnimations();
	            },
	            cancel: function() {
	              endAnimations(true);
	            }
	          });
	
	          $$AnimateRunner.chain(chain, onComplete);
	          return runner;
	
	          function onComplete(success) {
	            close(success);
	            runner.complete(success);
	          }
	
	          function endAnimations(cancelled) {
	            if (!animationClosed) {
	              (closeActiveAnimations || noop)(cancelled);
	              onComplete(cancelled);
	            }
	          }
	        }
	      };
	
	      function executeAnimationFn(fn, element, event, options, onDone) {
	        var args;
	        switch (event) {
	          case 'animate':
	            args = [element, options.from, options.to, onDone];
	            break;
	
	          case 'setClass':
	            args = [element, classesToAdd, classesToRemove, onDone];
	            break;
	
	          case 'addClass':
	            args = [element, classesToAdd, onDone];
	            break;
	
	          case 'removeClass':
	            args = [element, classesToRemove, onDone];
	            break;
	
	          default:
	            args = [element, onDone];
	            break;
	        }
	
	        args.push(options);
	
	        var value = fn.apply(fn, args);
	        if (value) {
	          if (isFunction(value.start)) {
	            value = value.start();
	          }
	
	          if (value instanceof $$AnimateRunner) {
	            value.done(onDone);
	          } else if (isFunction(value)) {
	            // optional onEnd / onCancel callback
	            return value;
	          }
	        }
	
	        return noop;
	      }
	
	      function groupEventedAnimations(element, event, options, animations, fnName) {
	        var operations = [];
	        forEach(animations, function(ani) {
	          var animation = ani[fnName];
	          if (!animation) return;
	
	          // note that all of these animations will run in parallel
	          operations.push(function() {
	            var runner;
	            var endProgressCb;
	
	            var resolved = false;
	            var onAnimationComplete = function(rejected) {
	              if (!resolved) {
	                resolved = true;
	                (endProgressCb || noop)(rejected);
	                runner.complete(!rejected);
	              }
	            };
	
	            runner = new $$AnimateRunner({
	              end: function() {
	                onAnimationComplete();
	              },
	              cancel: function() {
	                onAnimationComplete(true);
	              }
	            });
	
	            endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
	              var cancelled = result === false;
	              onAnimationComplete(cancelled);
	            });
	
	            return runner;
	          });
	        });
	
	        return operations;
	      }
	
	      function packageAnimations(element, event, options, animations, fnName) {
	        var operations = groupEventedAnimations(element, event, options, animations, fnName);
	        if (operations.length === 0) {
	          var a, b;
	          if (fnName === 'beforeSetClass') {
	            a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
	            b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
	          } else if (fnName === 'setClass') {
	            a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
	            b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
	          }
	
	          if (a) {
	            operations = operations.concat(a);
	          }
	          if (b) {
	            operations = operations.concat(b);
	          }
	        }
	
	        if (operations.length === 0) return;
	
	        // TODO(matsko): add documentation
	        return function startAnimation(callback) {
	          var runners = [];
	          if (operations.length) {
	            forEach(operations, function(animateFn) {
	              runners.push(animateFn());
	            });
	          }
	
	          if (runners.length) {
	            $$AnimateRunner.all(runners, callback);
	          }  else {
	            callback();
	          }
	
	          return function endFn(reject) {
	            forEach(runners, function(runner) {
	              if (reject) {
	                runner.cancel();
	              } else {
	                runner.end();
	              }
	            });
	          };
	        };
	      }
	    };
	
	    function lookupAnimations(classes) {
	      classes = isArray(classes) ? classes : classes.split(' ');
	      var matches = [], flagMap = {};
	      for (var i = 0; i < classes.length; i++) {
	        var klass = classes[i],
	            animationFactory = $animateProvider.$$registeredAnimations[klass];
	        if (animationFactory && !flagMap[klass]) {
	          matches.push($injector.get(animationFactory));
	          flagMap[klass] = true;
	        }
	      }
	      return matches;
	    }
	  }];
	}];
	
	var $$AnimateJsDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
	  $$animationProvider.drivers.push('$$animateJsDriver');
	  this.$get = ['$$animateJs', '$$AnimateRunner', function($$animateJs, $$AnimateRunner) {
	    return function initDriverFn(animationDetails) {
	      if (animationDetails.from && animationDetails.to) {
	        var fromAnimation = prepareAnimation(animationDetails.from);
	        var toAnimation = prepareAnimation(animationDetails.to);
	        if (!fromAnimation && !toAnimation) return;
	
	        return {
	          start: function() {
	            var animationRunners = [];
	
	            if (fromAnimation) {
	              animationRunners.push(fromAnimation.start());
	            }
	
	            if (toAnimation) {
	              animationRunners.push(toAnimation.start());
	            }
	
	            $$AnimateRunner.all(animationRunners, done);
	
	            var runner = new $$AnimateRunner({
	              end: endFnFactory(),
	              cancel: endFnFactory()
	            });
	
	            return runner;
	
	            function endFnFactory() {
	              return function() {
	                forEach(animationRunners, function(runner) {
	                  // at this point we cannot cancel animations for groups just yet. 1.5+
	                  runner.end();
	                });
	              };
	            }
	
	            function done(status) {
	              runner.complete(status);
	            }
	          }
	        };
	      } else {
	        return prepareAnimation(animationDetails);
	      }
	    };
	
	    function prepareAnimation(animationDetails) {
	      // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
	      var element = animationDetails.element;
	      var event = animationDetails.event;
	      var options = animationDetails.options;
	      var classes = animationDetails.classes;
	      return $$animateJs(element, event, classes, options);
	    }
	  }];
	}];
	
	var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
	var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
	var $$AnimateQueueProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  var PRE_DIGEST_STATE = 1;
	  var RUNNING_STATE = 2;
	  var ONE_SPACE = ' ';
	
	  var rules = this.rules = {
	    skip: [],
	    cancel: [],
	    join: []
	  };
	
	  function makeTruthyCssClassMap(classString) {
	    if (!classString) {
	      return null;
	    }
	
	    var keys = classString.split(ONE_SPACE);
	    var map = Object.create(null);
	
	    forEach(keys, function(key) {
	      map[key] = true;
	    });
	    return map;
	  }
	
	  function hasMatchingClasses(newClassString, currentClassString) {
	    if (newClassString && currentClassString) {
	      var currentClassMap = makeTruthyCssClassMap(currentClassString);
	      return newClassString.split(ONE_SPACE).some(function(className) {
	        return currentClassMap[className];
	      });
	    }
	  }
	
	  function isAllowed(ruleType, element, currentAnimation, previousAnimation) {
	    return rules[ruleType].some(function(fn) {
	      return fn(element, currentAnimation, previousAnimation);
	    });
	  }
	
	  function hasAnimationClasses(animation, and) {
	    var a = (animation.addClass || '').length > 0;
	    var b = (animation.removeClass || '').length > 0;
	    return and ? a && b : a || b;
	  }
	
	  rules.join.push(function(element, newAnimation, currentAnimation) {
	    // if the new animation is class-based then we can just tack that on
	    return !newAnimation.structural && hasAnimationClasses(newAnimation);
	  });
	
	  rules.skip.push(function(element, newAnimation, currentAnimation) {
	    // there is no need to animate anything if no classes are being added and
	    // there is no structural animation that will be triggered
	    return !newAnimation.structural && !hasAnimationClasses(newAnimation);
	  });
	
	  rules.skip.push(function(element, newAnimation, currentAnimation) {
	    // why should we trigger a new structural animation if the element will
	    // be removed from the DOM anyway?
	    return currentAnimation.event === 'leave' && newAnimation.structural;
	  });
	
	  rules.skip.push(function(element, newAnimation, currentAnimation) {
	    // if there is an ongoing current animation then don't even bother running the class-based animation
	    return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
	  });
	
	  rules.cancel.push(function(element, newAnimation, currentAnimation) {
	    // there can never be two structural animations running at the same time
	    return currentAnimation.structural && newAnimation.structural;
	  });
	
	  rules.cancel.push(function(element, newAnimation, currentAnimation) {
	    // if the previous animation is already running, but the new animation will
	    // be triggered, but the new animation is structural
	    return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
	  });
	
	  rules.cancel.push(function(element, newAnimation, currentAnimation) {
	    // cancel the animation if classes added / removed in both animation cancel each other out,
	    // but only if the current animation isn't structural
	
	    if (currentAnimation.structural) return false;
	
	    var nA = newAnimation.addClass;
	    var nR = newAnimation.removeClass;
	    var cA = currentAnimation.addClass;
	    var cR = currentAnimation.removeClass;
	
	    // early detection to save the global CPU shortage :)
	    if ((isUndefined(nA) && isUndefined(nR)) || (isUndefined(cA) && isUndefined(cR))) {
	      return false;
	    }
	
	    return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
	  });
	
	  this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$HashMap',
	               '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite', '$$forceReflow',
	               '$$isDocumentHidden',
	       function($$rAF,   $rootScope,   $rootElement,   $document,   $$HashMap,
	                $$animation,   $$AnimateRunner,   $templateRequest,   $$jqLite,   $$forceReflow,
	                $$isDocumentHidden) {
	
	    var activeAnimationsLookup = new $$HashMap();
	    var disabledElementsLookup = new $$HashMap();
	    var animationsEnabled = null;
	
	    function postDigestTaskFactory() {
	      var postDigestCalled = false;
	      return function(fn) {
	        // we only issue a call to postDigest before
	        // it has first passed. This prevents any callbacks
	        // from not firing once the animation has completed
	        // since it will be out of the digest cycle.
	        if (postDigestCalled) {
	          fn();
	        } else {
	          $rootScope.$$postDigest(function() {
	            postDigestCalled = true;
	            fn();
	          });
	        }
	      };
	    }
	
	    // Wait until all directive and route-related templates are downloaded and
	    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
	    // all of the remote templates being currently downloaded. If there are no
	    // templates currently downloading then the watcher will still fire anyway.
	    var deregisterWatch = $rootScope.$watch(
	      function() { return $templateRequest.totalPendingRequests === 0; },
	      function(isEmpty) {
	        if (!isEmpty) return;
	        deregisterWatch();
	
	        // Now that all templates have been downloaded, $animate will wait until
	        // the post digest queue is empty before enabling animations. By having two
	        // calls to $postDigest calls we can ensure that the flag is enabled at the
	        // very end of the post digest queue. Since all of the animations in $animate
	        // use $postDigest, it's important that the code below executes at the end.
	        // This basically means that the page is fully downloaded and compiled before
	        // any animations are triggered.
	        $rootScope.$$postDigest(function() {
	          $rootScope.$$postDigest(function() {
	            // we check for null directly in the event that the application already called
	            // .enabled() with whatever arguments that it provided it with
	            if (animationsEnabled === null) {
	              animationsEnabled = true;
	            }
	          });
	        });
	      }
	    );
	
	    var callbackRegistry = Object.create(null);
	
	    // remember that the classNameFilter is set during the provider/config
	    // stage therefore we can optimize here and setup a helper function
	    var classNameFilter = $animateProvider.classNameFilter();
	    var isAnimatableClassName = !classNameFilter
	              ? function() { return true; }
	              : function(className) {
	                return classNameFilter.test(className);
	              };
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    function normalizeAnimationDetails(element, animation) {
	      return mergeAnimationDetails(element, animation, {});
	    }
	
	    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	    var contains = window.Node.prototype.contains || /** @this */ function(arg) {
	      // eslint-disable-next-line no-bitwise
	      return this === arg || !!(this.compareDocumentPosition(arg) & 16);
	    };
	
	    function findCallbacks(parent, element, event) {
	      var targetNode = getDomNode(element);
	      var targetParentNode = getDomNode(parent);
	
	      var matches = [];
	      var entries = callbackRegistry[event];
	      if (entries) {
	        forEach(entries, function(entry) {
	          if (contains.call(entry.node, targetNode)) {
	            matches.push(entry.callback);
	          } else if (event === 'leave' && contains.call(entry.node, targetParentNode)) {
	            matches.push(entry.callback);
	          }
	        });
	      }
	
	      return matches;
	    }
	
	    function filterFromRegistry(list, matchContainer, matchCallback) {
	      var containerNode = extractElementNode(matchContainer);
	      return list.filter(function(entry) {
	        var isMatch = entry.node === containerNode &&
	                        (!matchCallback || entry.callback === matchCallback);
	        return !isMatch;
	      });
	    }
	
	    function cleanupEventListeners(phase, element) {
	      if (phase === 'close' && !element[0].parentNode) {
	        // If the element is not attached to a parentNode, it has been removed by
	        // the domOperation, and we can safely remove the event callbacks
	        $animate.off(element);
	      }
	    }
	
	    var $animate = {
	      on: function(event, container, callback) {
	        var node = extractElementNode(container);
	        callbackRegistry[event] = callbackRegistry[event] || [];
	        callbackRegistry[event].push({
	          node: node,
	          callback: callback
	        });
	
	        // Remove the callback when the element is removed from the DOM
	        jqLite(container).on('$destroy', function() {
	          var animationDetails = activeAnimationsLookup.get(node);
	
	          if (!animationDetails) {
	            // If there's an animation ongoing, the callback calling code will remove
	            // the event listeners. If we'd remove here, the callbacks would be removed
	            // before the animation ends
	            $animate.off(event, container, callback);
	          }
	        });
	      },
	
	      off: function(event, container, callback) {
	        if (arguments.length === 1 && !isString(arguments[0])) {
	          container = arguments[0];
	          for (var eventType in callbackRegistry) {
	            callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
	          }
	
	          return;
	        }
	
	        var entries = callbackRegistry[event];
	        if (!entries) return;
	
	        callbackRegistry[event] = arguments.length === 1
	            ? null
	            : filterFromRegistry(entries, container, callback);
	      },
	
	      pin: function(element, parentElement) {
	        assertArg(isElement(element), 'element', 'not an element');
	        assertArg(isElement(parentElement), 'parentElement', 'not an element');
	        element.data(NG_ANIMATE_PIN_DATA, parentElement);
	      },
	
	      push: function(element, event, options, domOperation) {
	        options = options || {};
	        options.domOperation = domOperation;
	        return queueAnimation(element, event, options);
	      },
	
	      // this method has four signatures:
	      //  () - global getter
	      //  (bool) - global setter
	      //  (element) - element getter
	      //  (element, bool) - element setter<F37>
	      enabled: function(element, bool) {
	        var argCount = arguments.length;
	
	        if (argCount === 0) {
	          // () - Global getter
	          bool = !!animationsEnabled;
	        } else {
	          var hasElement = isElement(element);
	
	          if (!hasElement) {
	            // (bool) - Global setter
	            bool = animationsEnabled = !!element;
	          } else {
	            var node = getDomNode(element);
	
	            if (argCount === 1) {
	              // (element) - Element getter
	              bool = !disabledElementsLookup.get(node);
	            } else {
	              // (element, bool) - Element setter
	              disabledElementsLookup.put(node, !bool);
	            }
	          }
	        }
	
	        return bool;
	      }
	    };
	
	    return $animate;
	
	    function queueAnimation(element, event, initialOptions) {
	      // we always make a copy of the options since
	      // there should never be any side effects on
	      // the input data when running `$animateCss`.
	      var options = copy(initialOptions);
	
	      var node, parent;
	      element = stripCommentsFromElement(element);
	      if (element) {
	        node = getDomNode(element);
	        parent = element.parent();
	      }
	
	      options = prepareAnimationOptions(options);
	
	      // we create a fake runner with a working promise.
	      // These methods will become available after the digest has passed
	      var runner = new $$AnimateRunner();
	
	      // this is used to trigger callbacks in postDigest mode
	      var runInNextPostDigestOrNow = postDigestTaskFactory();
	
	      if (isArray(options.addClass)) {
	        options.addClass = options.addClass.join(' ');
	      }
	
	      if (options.addClass && !isString(options.addClass)) {
	        options.addClass = null;
	      }
	
	      if (isArray(options.removeClass)) {
	        options.removeClass = options.removeClass.join(' ');
	      }
	
	      if (options.removeClass && !isString(options.removeClass)) {
	        options.removeClass = null;
	      }
	
	      if (options.from && !isObject(options.from)) {
	        options.from = null;
	      }
	
	      if (options.to && !isObject(options.to)) {
	        options.to = null;
	      }
	
	      // there are situations where a directive issues an animation for
	      // a jqLite wrapper that contains only comment nodes... If this
	      // happens then there is no way we can perform an animation
	      if (!node) {
	        close();
	        return runner;
	      }
	
	      var className = [node.getAttribute('class'), options.addClass, options.removeClass].join(' ');
	      if (!isAnimatableClassName(className)) {
	        close();
	        return runner;
	      }
	
	      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
	
	      var documentHidden = $$isDocumentHidden();
	
	      // this is a hard disable of all animations for the application or on
	      // the element itself, therefore  there is no need to continue further
	      // past this point if not enabled
	      // Animations are also disabled if the document is currently hidden (page is not visible
	      // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
	      var skipAnimations = !animationsEnabled || documentHidden || disabledElementsLookup.get(node);
	      var existingAnimation = (!skipAnimations && activeAnimationsLookup.get(node)) || {};
	      var hasExistingAnimation = !!existingAnimation.state;
	
	      // there is no point in traversing the same collection of parent ancestors if a followup
	      // animation will be run on the same element that already did all that checking work
	      if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state !== PRE_DIGEST_STATE)) {
	        skipAnimations = !areAnimationsAllowed(element, parent, event);
	      }
	
	      if (skipAnimations) {
	        // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
	        if (documentHidden) notifyProgress(runner, event, 'start');
	        close();
	        if (documentHidden) notifyProgress(runner, event, 'close');
	        return runner;
	      }
	
	      if (isStructural) {
	        closeChildAnimations(element);
	      }
	
	      var newAnimation = {
	        structural: isStructural,
	        element: element,
	        event: event,
	        addClass: options.addClass,
	        removeClass: options.removeClass,
	        close: close,
	        options: options,
	        runner: runner
	      };
	
	      if (hasExistingAnimation) {
	        var skipAnimationFlag = isAllowed('skip', element, newAnimation, existingAnimation);
	        if (skipAnimationFlag) {
	          if (existingAnimation.state === RUNNING_STATE) {
	            close();
	            return runner;
	          } else {
	            mergeAnimationDetails(element, existingAnimation, newAnimation);
	            return existingAnimation.runner;
	          }
	        }
	        var cancelAnimationFlag = isAllowed('cancel', element, newAnimation, existingAnimation);
	        if (cancelAnimationFlag) {
	          if (existingAnimation.state === RUNNING_STATE) {
	            // this will end the animation right away and it is safe
	            // to do so since the animation is already running and the
	            // runner callback code will run in async
	            existingAnimation.runner.end();
	          } else if (existingAnimation.structural) {
	            // this means that the animation is queued into a digest, but
	            // hasn't started yet. Therefore it is safe to run the close
	            // method which will call the runner methods in async.
	            existingAnimation.close();
	          } else {
	            // this will merge the new animation options into existing animation options
	            mergeAnimationDetails(element, existingAnimation, newAnimation);
	
	            return existingAnimation.runner;
	          }
	        } else {
	          // a joined animation means that this animation will take over the existing one
	          // so an example would involve a leave animation taking over an enter. Then when
	          // the postDigest kicks in the enter will be ignored.
	          var joinAnimationFlag = isAllowed('join', element, newAnimation, existingAnimation);
	          if (joinAnimationFlag) {
	            if (existingAnimation.state === RUNNING_STATE) {
	              normalizeAnimationDetails(element, newAnimation);
	            } else {
	              applyGeneratedPreparationClasses(element, isStructural ? event : null, options);
	
	              event = newAnimation.event = existingAnimation.event;
	              options = mergeAnimationDetails(element, existingAnimation, newAnimation);
	
	              //we return the same runner since only the option values of this animation will
	              //be fed into the `existingAnimation`.
	              return existingAnimation.runner;
	            }
	          }
	        }
	      } else {
	        // normalization in this case means that it removes redundant CSS classes that
	        // already exist (addClass) or do not exist (removeClass) on the element
	        normalizeAnimationDetails(element, newAnimation);
	      }
	
	      // when the options are merged and cleaned up we may end up not having to do
	      // an animation at all, therefore we should check this before issuing a post
	      // digest callback. Structural animations will always run no matter what.
	      var isValidAnimation = newAnimation.structural;
	      if (!isValidAnimation) {
	        // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
	        isValidAnimation = (newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0)
	                            || hasAnimationClasses(newAnimation);
	      }
	
	      if (!isValidAnimation) {
	        close();
	        clearElementAnimationState(element);
	        return runner;
	      }
	
	      // the counter keeps track of cancelled animations
	      var counter = (existingAnimation.counter || 0) + 1;
	      newAnimation.counter = counter;
	
	      markElementAnimationState(element, PRE_DIGEST_STATE, newAnimation);
	
	      $rootScope.$$postDigest(function() {
	        var animationDetails = activeAnimationsLookup.get(node);
	        var animationCancelled = !animationDetails;
	        animationDetails = animationDetails || {};
	
	        // if addClass/removeClass is called before something like enter then the
	        // registered parent element may not be present. The code below will ensure
	        // that a final value for parent element is obtained
	        var parentElement = element.parent() || [];
	
	        // animate/structural/class-based animations all have requirements. Otherwise there
	        // is no point in performing an animation. The parent node must also be set.
	        var isValidAnimation = parentElement.length > 0
	                                && (animationDetails.event === 'animate'
	                                    || animationDetails.structural
	                                    || hasAnimationClasses(animationDetails));
	
	        // this means that the previous animation was cancelled
	        // even if the follow-up animation is the same event
	        if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
	          // if another animation did not take over then we need
	          // to make sure that the domOperation and options are
	          // handled accordingly
	          if (animationCancelled) {
	            applyAnimationClasses(element, options);
	            applyAnimationStyles(element, options);
	          }
	
	          // if the event changed from something like enter to leave then we do
	          // it, otherwise if it's the same then the end result will be the same too
	          if (animationCancelled || (isStructural && animationDetails.event !== event)) {
	            options.domOperation();
	            runner.end();
	          }
	
	          // in the event that the element animation was not cancelled or a follow-up animation
	          // isn't allowed to animate from here then we need to clear the state of the element
	          // so that any future animations won't read the expired animation data.
	          if (!isValidAnimation) {
	            clearElementAnimationState(element);
	          }
	
	          return;
	        }
	
	        // this combined multiple class to addClass / removeClass into a setClass event
	        // so long as a structural event did not take over the animation
	        event = !animationDetails.structural && hasAnimationClasses(animationDetails, true)
	            ? 'setClass'
	            : animationDetails.event;
	
	        markElementAnimationState(element, RUNNING_STATE);
	        var realRunner = $$animation(element, event, animationDetails.options);
	
	        // this will update the runner's flow-control events based on
	        // the `realRunner` object.
	        runner.setHost(realRunner);
	        notifyProgress(runner, event, 'start', {});
	
	        realRunner.done(function(status) {
	          close(!status);
	          var animationDetails = activeAnimationsLookup.get(node);
	          if (animationDetails && animationDetails.counter === counter) {
	            clearElementAnimationState(getDomNode(element));
	          }
	          notifyProgress(runner, event, 'close', {});
	        });
	      });
	
	      return runner;
	
	      function notifyProgress(runner, event, phase, data) {
	        runInNextPostDigestOrNow(function() {
	          var callbacks = findCallbacks(parent, element, event);
	          if (callbacks.length) {
	            // do not optimize this call here to RAF because
	            // we don't know how heavy the callback code here will
	            // be and if this code is buffered then this can
	            // lead to a performance regression.
	            $$rAF(function() {
	              forEach(callbacks, function(callback) {
	                callback(element, phase, data);
	              });
	              cleanupEventListeners(phase, element);
	            });
	          } else {
	            cleanupEventListeners(phase, element);
	          }
	        });
	        runner.progress(event, phase, data);
	      }
	
	      function close(reject) {
	        clearGeneratedClasses(element, options);
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	        options.domOperation();
	        runner.complete(!reject);
	      }
	    }
	
	    function closeChildAnimations(element) {
	      var node = getDomNode(element);
	      var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
	      forEach(children, function(child) {
	        var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME), 10);
	        var animationDetails = activeAnimationsLookup.get(child);
	        if (animationDetails) {
	          switch (state) {
	            case RUNNING_STATE:
	              animationDetails.runner.end();
	              /* falls through */
	            case PRE_DIGEST_STATE:
	              activeAnimationsLookup.remove(child);
	              break;
	          }
	        }
	      });
	    }
	
	    function clearElementAnimationState(element) {
	      var node = getDomNode(element);
	      node.removeAttribute(NG_ANIMATE_ATTR_NAME);
	      activeAnimationsLookup.remove(node);
	    }
	
	    function isMatchingElement(nodeOrElmA, nodeOrElmB) {
	      return getDomNode(nodeOrElmA) === getDomNode(nodeOrElmB);
	    }
	
	    /**
	     * This fn returns false if any of the following is true:
	     * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
	     * b) a parent element has an ongoing structural animation, and animateChildren is false
	     * c) the element is not a child of the body
	     * d) the element is not a child of the $rootElement
	     */
	    function areAnimationsAllowed(element, parentElement, event) {
	      var bodyElement = jqLite($document[0].body);
	      var bodyElementDetected = isMatchingElement(element, bodyElement) || element[0].nodeName === 'HTML';
	      var rootElementDetected = isMatchingElement(element, $rootElement);
	      var parentAnimationDetected = false;
	      var animateChildren;
	      var elementDisabled = disabledElementsLookup.get(getDomNode(element));
	
	      var parentHost = jqLite.data(element[0], NG_ANIMATE_PIN_DATA);
	      if (parentHost) {
	        parentElement = parentHost;
	      }
	
	      parentElement = getDomNode(parentElement);
	
	      while (parentElement) {
	        if (!rootElementDetected) {
	          // angular doesn't want to attempt to animate elements outside of the application
	          // therefore we need to ensure that the rootElement is an ancestor of the current element
	          rootElementDetected = isMatchingElement(parentElement, $rootElement);
	        }
	
	        if (parentElement.nodeType !== ELEMENT_NODE) {
	          // no point in inspecting the #document element
	          break;
	        }
	
	        var details = activeAnimationsLookup.get(parentElement) || {};
	        // either an enter, leave or move animation will commence
	        // therefore we can't allow any animations to take place
	        // but if a parent animation is class-based then that's ok
	        if (!parentAnimationDetected) {
	          var parentElementDisabled = disabledElementsLookup.get(parentElement);
	
	          if (parentElementDisabled === true && elementDisabled !== false) {
	            // disable animations if the user hasn't explicitly enabled animations on the
	            // current element
	            elementDisabled = true;
	            // element is disabled via parent element, no need to check anything else
	            break;
	          } else if (parentElementDisabled === false) {
	            elementDisabled = false;
	          }
	          parentAnimationDetected = details.structural;
	        }
	
	        if (isUndefined(animateChildren) || animateChildren === true) {
	          var value = jqLite.data(parentElement, NG_ANIMATE_CHILDREN_DATA);
	          if (isDefined(value)) {
	            animateChildren = value;
	          }
	        }
	
	        // there is no need to continue traversing at this point
	        if (parentAnimationDetected && animateChildren === false) break;
	
	        if (!bodyElementDetected) {
	          // we also need to ensure that the element is or will be a part of the body element
	          // otherwise it is pointless to even issue an animation to be rendered
	          bodyElementDetected = isMatchingElement(parentElement, bodyElement);
	        }
	
	        if (bodyElementDetected && rootElementDetected) {
	          // If both body and root have been found, any other checks are pointless,
	          // as no animation data should live outside the application
	          break;
	        }
	
	        if (!rootElementDetected) {
	          // If no rootElement is detected, check if the parentElement is pinned to another element
	          parentHost = jqLite.data(parentElement, NG_ANIMATE_PIN_DATA);
	          if (parentHost) {
	            // The pin target element becomes the next parent element
	            parentElement = getDomNode(parentHost);
	            continue;
	          }
	        }
	
	        parentElement = parentElement.parentNode;
	      }
	
	      var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
	      return allowAnimation && rootElementDetected && bodyElementDetected;
	    }
	
	    function markElementAnimationState(element, state, details) {
	      details = details || {};
	      details.state = state;
	
	      var node = getDomNode(element);
	      node.setAttribute(NG_ANIMATE_ATTR_NAME, state);
	
	      var oldValue = activeAnimationsLookup.get(node);
	      var newValue = oldValue
	          ? extend(oldValue, details)
	          : details;
	      activeAnimationsLookup.put(node, newValue);
	    }
	  }];
	}];
	
	/* exported $$AnimationProvider */
	
	var $$AnimationProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';
	
	  var drivers = this.drivers = [];
	
	  var RUNNER_STORAGE_KEY = '$$animationRunner';
	
	  function setRunner(element, runner) {
	    element.data(RUNNER_STORAGE_KEY, runner);
	  }
	
	  function removeRunner(element) {
	    element.removeData(RUNNER_STORAGE_KEY);
	  }
	
	  function getRunner(element) {
	    return element.data(RUNNER_STORAGE_KEY);
	  }
	
	  this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$HashMap', '$$rAFScheduler',
	       function($$jqLite,   $rootScope,   $injector,   $$AnimateRunner,   $$HashMap,   $$rAFScheduler) {
	
	    var animationQueue = [];
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    function sortAnimations(animations) {
	      var tree = { children: [] };
	      var i, lookup = new $$HashMap();
	
	      // this is done first beforehand so that the hashmap
	      // is filled with a list of the elements that will be animated
	      for (i = 0; i < animations.length; i++) {
	        var animation = animations[i];
	        lookup.put(animation.domNode, animations[i] = {
	          domNode: animation.domNode,
	          fn: animation.fn,
	          children: []
	        });
	      }
	
	      for (i = 0; i < animations.length; i++) {
	        processNode(animations[i]);
	      }
	
	      return flatten(tree);
	
	      function processNode(entry) {
	        if (entry.processed) return entry;
	        entry.processed = true;
	
	        var elementNode = entry.domNode;
	        var parentNode = elementNode.parentNode;
	        lookup.put(elementNode, entry);
	
	        var parentEntry;
	        while (parentNode) {
	          parentEntry = lookup.get(parentNode);
	          if (parentEntry) {
	            if (!parentEntry.processed) {
	              parentEntry = processNode(parentEntry);
	            }
	            break;
	          }
	          parentNode = parentNode.parentNode;
	        }
	
	        (parentEntry || tree).children.push(entry);
	        return entry;
	      }
	
	      function flatten(tree) {
	        var result = [];
	        var queue = [];
	        var i;
	
	        for (i = 0; i < tree.children.length; i++) {
	          queue.push(tree.children[i]);
	        }
	
	        var remainingLevelEntries = queue.length;
	        var nextLevelEntries = 0;
	        var row = [];
	
	        for (i = 0; i < queue.length; i++) {
	          var entry = queue[i];
	          if (remainingLevelEntries <= 0) {
	            remainingLevelEntries = nextLevelEntries;
	            nextLevelEntries = 0;
	            result.push(row);
	            row = [];
	          }
	          row.push(entry.fn);
	          entry.children.forEach(function(childEntry) {
	            nextLevelEntries++;
	            queue.push(childEntry);
	          });
	          remainingLevelEntries--;
	        }
	
	        if (row.length) {
	          result.push(row);
	        }
	
	        return result;
	      }
	    }
	
	    // TODO(matsko): document the signature in a better way
	    return function(element, event, options) {
	      options = prepareAnimationOptions(options);
	      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
	
	      // there is no animation at the current moment, however
	      // these runner methods will get later updated with the
	      // methods leading into the driver's end/cancel methods
	      // for now they just stop the animation from starting
	      var runner = new $$AnimateRunner({
	        end: function() { close(); },
	        cancel: function() { close(true); }
	      });
	
	      if (!drivers.length) {
	        close();
	        return runner;
	      }
	
	      setRunner(element, runner);
	
	      var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
	      var tempClasses = options.tempClasses;
	      if (tempClasses) {
	        classes += ' ' + tempClasses;
	        options.tempClasses = null;
	      }
	
	      var prepareClassName;
	      if (isStructural) {
	        prepareClassName = 'ng-' + event + PREPARE_CLASS_SUFFIX;
	        $$jqLite.addClass(element, prepareClassName);
	      }
	
	      animationQueue.push({
	        // this data is used by the postDigest code and passed into
	        // the driver step function
	        element: element,
	        classes: classes,
	        event: event,
	        structural: isStructural,
	        options: options,
	        beforeStart: beforeStart,
	        close: close
	      });
	
	      element.on('$destroy', handleDestroyedElement);
	
	      // we only want there to be one function called within the post digest
	      // block. This way we can group animations for all the animations that
	      // were apart of the same postDigest flush call.
	      if (animationQueue.length > 1) return runner;
	
	      $rootScope.$$postDigest(function() {
	        var animations = [];
	        forEach(animationQueue, function(entry) {
	          // the element was destroyed early on which removed the runner
	          // form its storage. This means we can't animate this element
	          // at all and it already has been closed due to destruction.
	          if (getRunner(entry.element)) {
	            animations.push(entry);
	          } else {
	            entry.close();
	          }
	        });
	
	        // now any future animations will be in another postDigest
	        animationQueue.length = 0;
	
	        var groupedAnimations = groupAnimations(animations);
	        var toBeSortedAnimations = [];
	
	        forEach(groupedAnimations, function(animationEntry) {
	          toBeSortedAnimations.push({
	            domNode: getDomNode(animationEntry.from ? animationEntry.from.element : animationEntry.element),
	            fn: function triggerAnimationStart() {
	              // it's important that we apply the `ng-animate` CSS class and the
	              // temporary classes before we do any driver invoking since these
	              // CSS classes may be required for proper CSS detection.
	              animationEntry.beforeStart();
	
	              var startAnimationFn, closeFn = animationEntry.close;
	
	              // in the event that the element was removed before the digest runs or
	              // during the RAF sequencing then we should not trigger the animation.
	              var targetElement = animationEntry.anchors
	                  ? (animationEntry.from.element || animationEntry.to.element)
	                  : animationEntry.element;
	
	              if (getRunner(targetElement)) {
	                var operation = invokeFirstDriver(animationEntry);
	                if (operation) {
	                  startAnimationFn = operation.start;
	                }
	              }
	
	              if (!startAnimationFn) {
	                closeFn();
	              } else {
	                var animationRunner = startAnimationFn();
	                animationRunner.done(function(status) {
	                  closeFn(!status);
	                });
	                updateAnimationRunners(animationEntry, animationRunner);
	              }
	            }
	          });
	        });
	
	        // we need to sort each of the animations in order of parent to child
	        // relationships. This ensures that the child classes are applied at the
	        // right time.
	        $$rAFScheduler(sortAnimations(toBeSortedAnimations));
	      });
	
	      return runner;
	
	      // TODO(matsko): change to reference nodes
	      function getAnchorNodes(node) {
	        var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
	        var items = node.hasAttribute(NG_ANIMATE_REF_ATTR)
	              ? [node]
	              : node.querySelectorAll(SELECTOR);
	        var anchors = [];
	        forEach(items, function(node) {
	          var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
	          if (attr && attr.length) {
	            anchors.push(node);
	          }
	        });
	        return anchors;
	      }
	
	      function groupAnimations(animations) {
	        var preparedAnimations = [];
	        var refLookup = {};
	        forEach(animations, function(animation, index) {
	          var element = animation.element;
	          var node = getDomNode(element);
	          var event = animation.event;
	          var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
	          var anchorNodes = animation.structural ? getAnchorNodes(node) : [];
	
	          if (anchorNodes.length) {
	            var direction = enterOrMove ? 'to' : 'from';
	
	            forEach(anchorNodes, function(anchor) {
	              var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
	              refLookup[key] = refLookup[key] || {};
	              refLookup[key][direction] = {
	                animationID: index,
	                element: jqLite(anchor)
	              };
	            });
	          } else {
	            preparedAnimations.push(animation);
	          }
	        });
	
	        var usedIndicesLookup = {};
	        var anchorGroups = {};
	        forEach(refLookup, function(operations, key) {
	          var from = operations.from;
	          var to = operations.to;
	
	          if (!from || !to) {
	            // only one of these is set therefore we can't have an
	            // anchor animation since all three pieces are required
	            var index = from ? from.animationID : to.animationID;
	            var indexKey = index.toString();
	            if (!usedIndicesLookup[indexKey]) {
	              usedIndicesLookup[indexKey] = true;
	              preparedAnimations.push(animations[index]);
	            }
	            return;
	          }
	
	          var fromAnimation = animations[from.animationID];
	          var toAnimation = animations[to.animationID];
	          var lookupKey = from.animationID.toString();
	          if (!anchorGroups[lookupKey]) {
	            var group = anchorGroups[lookupKey] = {
	              structural: true,
	              beforeStart: function() {
	                fromAnimation.beforeStart();
	                toAnimation.beforeStart();
	              },
	              close: function() {
	                fromAnimation.close();
	                toAnimation.close();
	              },
	              classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
	              from: fromAnimation,
	              to: toAnimation,
	              anchors: [] // TODO(matsko): change to reference nodes
	            };
	
	            // the anchor animations require that the from and to elements both have at least
	            // one shared CSS class which effectively marries the two elements together to use
	            // the same animation driver and to properly sequence the anchor animation.
	            if (group.classes.length) {
	              preparedAnimations.push(group);
	            } else {
	              preparedAnimations.push(fromAnimation);
	              preparedAnimations.push(toAnimation);
	            }
	          }
	
	          anchorGroups[lookupKey].anchors.push({
	            'out': from.element, 'in': to.element
	          });
	        });
	
	        return preparedAnimations;
	      }
	
	      function cssClassesIntersection(a,b) {
	        a = a.split(' ');
	        b = b.split(' ');
	        var matches = [];
	
	        for (var i = 0; i < a.length; i++) {
	          var aa = a[i];
	          if (aa.substring(0,3) === 'ng-') continue;
	
	          for (var j = 0; j < b.length; j++) {
	            if (aa === b[j]) {
	              matches.push(aa);
	              break;
	            }
	          }
	        }
	
	        return matches.join(' ');
	      }
	
	      function invokeFirstDriver(animationDetails) {
	        // we loop in reverse order since the more general drivers (like CSS and JS)
	        // may attempt more elements, but custom drivers are more particular
	        for (var i = drivers.length - 1; i >= 0; i--) {
	          var driverName = drivers[i];
	          var factory = $injector.get(driverName);
	          var driver = factory(animationDetails);
	          if (driver) {
	            return driver;
	          }
	        }
	      }
	
	      function beforeStart() {
	        element.addClass(NG_ANIMATE_CLASSNAME);
	        if (tempClasses) {
	          $$jqLite.addClass(element, tempClasses);
	        }
	        if (prepareClassName) {
	          $$jqLite.removeClass(element, prepareClassName);
	          prepareClassName = null;
	        }
	      }
	
	      function updateAnimationRunners(animation, newRunner) {
	        if (animation.from && animation.to) {
	          update(animation.from.element);
	          update(animation.to.element);
	        } else {
	          update(animation.element);
	        }
	
	        function update(element) {
	          var runner = getRunner(element);
	          if (runner) runner.setHost(newRunner);
	        }
	      }
	
	      function handleDestroyedElement() {
	        var runner = getRunner(element);
	        if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
	          runner.end();
	        }
	      }
	
	      function close(rejected) {
	        element.off('$destroy', handleDestroyedElement);
	        removeRunner(element);
	
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	        options.domOperation();
	
	        if (tempClasses) {
	          $$jqLite.removeClass(element, tempClasses);
	        }
	
	        element.removeClass(NG_ANIMATE_CLASSNAME);
	        runner.complete(!rejected);
	      }
	    };
	  }];
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngAnimateSwap
	 * @restrict A
	 * @scope
	 *
	 * @description
	 *
	 * ngAnimateSwap is a animation-oriented directive that allows for the container to
	 * be removed and entered in whenever the associated expression changes. A
	 * common usecase for this directive is a rotating banner or slider component which
	 * contains one image being present at a time. When the active image changes
	 * then the old image will perform a `leave` animation and the new element
	 * will be inserted via an `enter` animation.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|--------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
	 * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
	 *
	 * @example
	 * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
	 *          deps="angular-animate.js"
	 *          animations="true" fixBase="true">
	 *   <file name="index.html">
	 *     <div class="container" ng-controller="AppCtrl">
	 *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
	 *         {{ number }}
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="script.js">
	 *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
	 *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
	 *         $scope.number = 0;
	 *         $interval(function() {
	 *           $scope.number++;
	 *         }, 1000);
	 *
	 *         var colors = ['red','blue','green','yellow','orange'];
	 *         $scope.colorClass = function(number) {
	 *           return colors[number % colors.length];
	 *         };
	 *       }]);
	 *   </file>
	 *  <file name="animations.css">
	 *  .container {
	 *    height:250px;
	 *    width:250px;
	 *    position:relative;
	 *    overflow:hidden;
	 *    border:2px solid black;
	 *  }
	 *  .container .cell {
	 *    font-size:150px;
	 *    text-align:center;
	 *    line-height:250px;
	 *    position:absolute;
	 *    top:0;
	 *    left:0;
	 *    right:0;
	 *    border-bottom:2px solid black;
	 *  }
	 *  .swap-animation.ng-enter, .swap-animation.ng-leave {
	 *    transition:0.5s linear all;
	 *  }
	 *  .swap-animation.ng-enter {
	 *    top:-250px;
	 *  }
	 *  .swap-animation.ng-enter-active {
	 *    top:0px;
	 *  }
	 *  .swap-animation.ng-leave {
	 *    top:0px;
	 *  }
	 *  .swap-animation.ng-leave-active {
	 *    top:250px;
	 *  }
	 *  .red { background:red; }
	 *  .green { background:green; }
	 *  .blue { background:blue; }
	 *  .yellow { background:yellow; }
	 *  .orange { background:orange; }
	 *  </file>
	 * </example>
	 */
	var ngAnimateSwapDirective = ['$animate', '$rootScope', function($animate, $rootScope) {
	  return {
	    restrict: 'A',
	    transclude: 'element',
	    terminal: true,
	    priority: 600, // we use 600 here to ensure that the directive is caught before others
	    link: function(scope, $element, attrs, ctrl, $transclude) {
	      var previousElement, previousScope;
	      scope.$watchCollection(attrs.ngAnimateSwap || attrs['for'], function(value) {
	        if (previousElement) {
	          $animate.leave(previousElement);
	        }
	        if (previousScope) {
	          previousScope.$destroy();
	          previousScope = null;
	        }
	        if (value || value === 0) {
	          previousScope = scope.$new();
	          $transclude(previousScope, function(element) {
	            previousElement = element;
	            $animate.enter(element, null, $element);
	          });
	        }
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc module
	 * @name ngAnimate
	 * @description
	 *
	 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
	 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an Angular app.
	 *
	 * <div doc-module-components="ngAnimate"></div>
	 *
	 * # Usage
	 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
	 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
	 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
	 * the HTML element that the animation will be triggered on.
	 *
	 * ## Directive Support
	 * The following directives are "animation aware":
	 *
	 * | Directive                                                                                                | Supported Animations                                                     |
	 * |----------------------------------------------------------------------------------------------------------|--------------------------------------------------------------------------|
	 * | {@link ng.directive:ngRepeat#animations ngRepeat}                                                        | enter, leave and move                                                    |
	 * | {@link ngRoute.directive:ngView#animations ngView}                                                       | enter and leave                                                          |
	 * | {@link ng.directive:ngInclude#animations ngInclude}                                                      | enter and leave                                                          |
	 * | {@link ng.directive:ngSwitch#animations ngSwitch}                                                        | enter and leave                                                          |
	 * | {@link ng.directive:ngIf#animations ngIf}                                                                | enter and leave                                                          |
	 * | {@link ng.directive:ngClass#animations ngClass}                                                          | add and remove (the CSS class(es) present)                               |
	 * | {@link ng.directive:ngShow#animations ngShow} & {@link ng.directive:ngHide#animations ngHide}            | add and remove (the ng-hide class value)                                 |
	 * | {@link ng.directive:form#animation-hooks form} & {@link ng.directive:ngModel#animation-hooks ngModel}    | add and remove (dirty, pristine, valid, invalid & all other validations) |
	 * | {@link module:ngMessages#animations ngMessages}                                                          | add and remove (ng-active & ng-inactive)                                 |
	 * | {@link module:ngMessages#animations ngMessage}                                                           | enter and leave                                                          |
	 *
	 * (More information can be found by visiting each the documentation associated with each directive.)
	 *
	 * ## CSS-based Animations
	 *
	 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
	 * and CSS code we can create an animation that will be picked up by Angular when an underlying directive performs an operation.
	 *
	 * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
	 *
	 * ```html
	 * <div ng-if="bool" class="fade">
	 *    Fade me in out
	 * </div>
	 * <button ng-click="bool=true">Fade In!</button>
	 * <button ng-click="bool=false">Fade Out!</button>
	 * ```
	 *
	 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
	 *
	 * ```css
	 * /&#42; The starting CSS styles for the enter animation &#42;/
	 * .fade.ng-enter {
	 *   transition:0.5s linear all;
	 *   opacity:0;
	 * }
	 *
	 * /&#42; The finishing CSS styles for the enter animation &#42;/
	 * .fade.ng-enter.ng-enter-active {
	 *   opacity:1;
	 * }
	 * ```
	 *
	 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
	 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
	 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
	 *
	 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
	 *
	 * ```css
	 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
	 * .fade.ng-leave {
	 *   transition:0.5s linear all;
	 *   opacity:1;
	 * }
	 * .fade.ng-leave.ng-leave-active {
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
	 *
	 * ```css
	 * /&#42; there is no need to define anything inside of the destination
	 * CSS class since the keyframe will take charge of the animation &#42;/
	 * .fade.ng-leave {
	 *   animation: my_fade_animation 0.5s linear;
	 *   -webkit-animation: my_fade_animation 0.5s linear;
	 * }
	 *
	 * @keyframes my_fade_animation {
	 *   from { opacity:1; }
	 *   to { opacity:0; }
	 * }
	 *
	 * @-webkit-keyframes my_fade_animation {
	 *   from { opacity:1; }
	 *   to { opacity:0; }
	 * }
	 * ```
	 *
	 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
	 *
	 * ### CSS Class-based Animations
	 *
	 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
	 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
	 * and removed.
	 *
	 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
	 *
	 * ```html
	 * <div ng-show="bool" class="fade">
	 *   Show and hide me
	 * </div>
	 * <button ng-click="bool=!bool">Toggle</button>
	 *
	 * <style>
	 * .fade.ng-hide {
	 *   transition:0.5s linear all;
	 *   opacity:0;
	 * }
	 * </style>
	 * ```
	 *
	 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
	 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
	 *
	 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
	 * with CSS styles.
	 *
	 * ```html
	 * <div ng-class="{on:onOff}" class="highlight">
	 *   Highlight this box
	 * </div>
	 * <button ng-click="onOff=!onOff">Toggle</button>
	 *
	 * <style>
	 * .highlight {
	 *   transition:0.5s linear all;
	 * }
	 * .highlight.on-add {
	 *   background:white;
	 * }
	 * .highlight.on {
	 *   background:yellow;
	 * }
	 * .highlight.on-remove {
	 *   background:black;
	 * }
	 * </style>
	 * ```
	 *
	 * We can also make use of CSS keyframes by placing them within the CSS classes.
	 *
	 *
	 * ### CSS Staggering Animations
	 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
	 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
	 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
	 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
	 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
	 *
	 * ```css
	 * .my-animation.ng-enter {
	 *   /&#42; standard transition code &#42;/
	 *   transition: 1s linear all;
	 *   opacity:0;
	 * }
	 * .my-animation.ng-enter-stagger {
	 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
	 *   transition-delay: 0.1s;
	 *
	 *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
	 *     to not accidentally inherit a delay property from another CSS class &#42;/
	 *   transition-duration: 0s;
	 * }
	 * .my-animation.ng-enter.ng-enter-active {
	 *   /&#42; standard transition styles &#42;/
	 *   opacity:1;
	 * }
	 * ```
	 *
	 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
	 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
	 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
	 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
	 *
	 * The following code will issue the **ng-leave-stagger** event on the element provided:
	 *
	 * ```js
	 * var kids = parent.children();
	 *
	 * $animate.leave(kids[0]); //stagger index=0
	 * $animate.leave(kids[1]); //stagger index=1
	 * $animate.leave(kids[2]); //stagger index=2
	 * $animate.leave(kids[3]); //stagger index=3
	 * $animate.leave(kids[4]); //stagger index=4
	 *
	 * window.requestAnimationFrame(function() {
	 *   //stagger has reset itself
	 *   $animate.leave(kids[5]); //stagger index=0
	 *   $animate.leave(kids[6]); //stagger index=1
	 *
	 *   $scope.$digest();
	 * });
	 * ```
	 *
	 * Stagger animations are currently only supported within CSS-defined animations.
	 *
	 * ### The `ng-animate` CSS class
	 *
	 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
	 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
	 *
	 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
	 *
	 * ```css
	 * .zipper.ng-animate {
	 *   transition:0.5s linear all;
	 * }
	 * .zipper.ng-enter {
	 *   opacity:0;
	 * }
	 * .zipper.ng-enter.ng-enter-active {
	 *   opacity:1;
	 * }
	 * .zipper.ng-leave {
	 *   opacity:1;
	 * }
	 * .zipper.ng-leave.ng-leave-active {
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
	 * the CSS class once an animation has completed.)
	 *
	 *
	 * ### The `ng-[event]-prepare` class
	 *
	 * This is a special class that can be used to prevent unwanted flickering / flash of content before
	 * the actual animation starts. The class is added as soon as an animation is initialized, but removed
	 * before the actual animation starts (after waiting for a $digest).
	 * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
	 *
	 * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
	 * into elements that have class-based animations such as `ngClass`.
	 *
	 * ```html
	 * <div ng-class="{red: myProp}">
	 *   <div ng-class="{blue: myProp}">
	 *     <div class="message" ng-if="myProp"></div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
	 * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
	 *
	 * ```css
	 * .message.ng-enter-prepare {
	 *   opacity: 0;
	 * }
	 *
	 * ```
	 *
	 * ## JavaScript-based Animations
	 *
	 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
	 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
	 * `module.animation()` module function we can register the animation.
	 *
	 * Let's see an example of a enter/leave animation using `ngRepeat`:
	 *
	 * ```html
	 * <div ng-repeat="item in items" class="slide">
	 *   {{ item }}
	 * </div>
	 * ```
	 *
	 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
	 *
	 * ```js
	 * myModule.animation('.slide', [function() {
	 *   return {
	 *     // make note that other events (like addClass/removeClass)
	 *     // have different function input parameters
	 *     enter: function(element, doneFn) {
	 *       jQuery(element).fadeIn(1000, doneFn);
	 *
	 *       // remember to call doneFn so that angular
	 *       // knows that the animation has concluded
	 *     },
	 *
	 *     move: function(element, doneFn) {
	 *       jQuery(element).fadeIn(1000, doneFn);
	 *     },
	 *
	 *     leave: function(element, doneFn) {
	 *       jQuery(element).fadeOut(1000, doneFn);
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
	 * greensock.js and velocity.js.
	 *
	 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
	 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
	 *
	 * ```html
	 * <div ng-class="color" class="colorful">
	 *   this box is moody
	 * </div>
	 * <button ng-click="color='red'">Change to red</button>
	 * <button ng-click="color='blue'">Change to blue</button>
	 * <button ng-click="color='green'">Change to green</button>
	 * ```
	 *
	 * ```js
	 * myModule.animation('.colorful', [function() {
	 *   return {
	 *     addClass: function(element, className, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     },
	 *     removeClass: function(element, className, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     },
	 *     setClass: function(element, addedClass, removedClass, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ## CSS + JS Animations Together
	 *
	 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of Angular,
	 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
	 * charge of the animation**:
	 *
	 * ```html
	 * <div ng-if="bool" class="slide">
	 *   Slide in and out
	 * </div>
	 * ```
	 *
	 * ```js
	 * myModule.animation('.slide', [function() {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       jQuery(element).slideIn(1000, doneFn);
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ```css
	 * .slide.ng-enter {
	 *   transition:0.5s linear all;
	 *   transform:translateY(-100px);
	 * }
	 * .slide.ng-enter.ng-enter-active {
	 *   transform:translateY(0);
	 * }
	 * ```
	 *
	 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
	 * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
	 * our own JS-based animation code:
	 *
	 * ```js
	 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element) {
	*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
	 *       return $animateCss(element, {
	 *         event: 'enter',
	 *         structural: true
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
	 *
	 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
	 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
	 * data into `$animateCss` directly:
	 *
	 * ```js
	 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element) {
	 *       return $animateCss(element, {
	 *         event: 'enter',
	 *         structural: true,
	 *         addClass: 'maroon-setting',
	 *         from: { height:0 },
	 *         to: { height: 200 }
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * Now we can fill in the rest via our transition CSS code:
	 *
	 * ```css
	 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
	 * .slide.ng-enter { transition:0.5s linear all; }
	 *
	 * /&#42; this extra CSS class will be absorbed into the transition
	 * since the $animateCss code is adding the class &#42;/
	 * .maroon-setting { background:red; }
	 * ```
	 *
	 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
	 *
	 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
	 *
	 * ## Animation Anchoring (via `ng-animate-ref`)
	 *
	 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
	 * structural areas of an application (like views) by pairing up elements using an attribute
	 * called `ng-animate-ref`.
	 *
	 * Let's say for example we have two views that are managed by `ng-view` and we want to show
	 * that there is a relationship between two components situated in within these views. By using the
	 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
	 * can then attach an animation, which is triggered when the view changes.
	 *
	 * Say for example we have the following template code:
	 *
	 * ```html
	 * <!-- index.html -->
	 * <div ng-view class="view-animation">
	 * </div>
	 *
	 * <!-- home.html -->
	 * <a href="#/banner-page">
	 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
	 * </a>
	 *
	 * <!-- banner-page.html -->
	 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
	 * ```
	 *
	 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
	 * HTML contents to see if there is a match reference between any components in the view
	 * that is leaving and the view that is entering. It will scan both the view which is being
	 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
	 * contain a matching ref value.
	 *
	 * The two images match since they share the same ref value. ngAnimate will now create a
	 * transport element (which is a clone of the first image element) and it will then attempt
	 * to animate to the position of the second image element in the next view. For the animation to
	 * work a special CSS class called `ng-anchor` will be added to the transported element.
	 *
	 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
	 * ngAnimate will handle the entire transition for us as well as the addition and removal of
	 * any changes of CSS classes between the elements:
	 *
	 * ```css
	 * .banner.ng-anchor {
	 *   /&#42; this animation will last for 1 second since there are
	 *          two phases to the animation (an `in` and an `out` phase) &#42;/
	 *   transition:0.5s linear all;
	 * }
	 * ```
	 *
	 * We also **must** include animations for the views that are being entered and removed
	 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
	 *
	 * ```css
	 * .view-animation.ng-enter, .view-animation.ng-leave {
	 *   transition:0.5s linear all;
	 *   position:fixed;
	 *   left:0;
	 *   top:0;
	 *   width:100%;
	 * }
	 * .view-animation.ng-enter {
	 *   transform:translateX(100%);
	 * }
	 * .view-animation.ng-leave,
	 * .view-animation.ng-enter.ng-enter-active {
	 *   transform:translateX(0%);
	 * }
	 * .view-animation.ng-leave.ng-leave-active {
	 *   transform:translateX(-100%);
	 * }
	 * ```
	 *
	 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
	 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
	 * from its origin. Once that animation is over then the `in` stage occurs which animates the
	 * element to its destination. The reason why there are two animations is to give enough time
	 * for the enter animation on the new element to be ready.
	 *
	 * The example above sets up a transition for both the in and out phases, but we can also target the out or
	 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
	 *
	 * ```css
	 * .banner.ng-anchor-out {
	 *   transition: 0.5s linear all;
	 *
	 *   /&#42; the scale will be applied during the out animation,
	 *          but will be animated away when the in animation runs &#42;/
	 *   transform: scale(1.2);
	 * }
	 *
	 * .banner.ng-anchor-in {
	 *   transition: 1s linear all;
	 * }
	 * ```
	 *
	 *
	 *
	 *
	 * ### Anchoring Demo
	 *
	  <example module="anchoringExample"
	           name="anchoringExample"
	           id="anchoringExample"
	           deps="angular-animate.js;angular-route.js"
	           animations="true">
	    <file name="index.html">
	      <a href="#!/">Home</a>
	      <hr />
	      <div class="view-container">
	        <div ng-view class="view"></div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
	        .config(['$routeProvider', function($routeProvider) {
	          $routeProvider.when('/', {
	            templateUrl: 'home.html',
	            controller: 'HomeController as home'
	          });
	          $routeProvider.when('/profile/:id', {
	            templateUrl: 'profile.html',
	            controller: 'ProfileController as profile'
	          });
	        }])
	        .run(['$rootScope', function($rootScope) {
	          $rootScope.records = [
	            { id: 1, title: 'Miss Beulah Roob' },
	            { id: 2, title: 'Trent Morissette' },
	            { id: 3, title: 'Miss Ava Pouros' },
	            { id: 4, title: 'Rod Pouros' },
	            { id: 5, title: 'Abdul Rice' },
	            { id: 6, title: 'Laurie Rutherford Sr.' },
	            { id: 7, title: 'Nakia McLaughlin' },
	            { id: 8, title: 'Jordon Blanda DVM' },
	            { id: 9, title: 'Rhoda Hand' },
	            { id: 10, title: 'Alexandrea Sauer' }
	          ];
	        }])
	        .controller('HomeController', [function() {
	          //empty
	        }])
	        .controller('ProfileController', ['$rootScope', '$routeParams',
	            function ProfileController($rootScope, $routeParams) {
	          var index = parseInt($routeParams.id, 10);
	          var record = $rootScope.records[index - 1];
	
	          this.title = record.title;
	          this.id = record.id;
	        }]);
	    </file>
	    <file name="home.html">
	      <h2>Welcome to the home page</h1>
	      <p>Please click on an element</p>
	      <a class="record"
	         ng-href="#!/profile/{{ record.id }}"
	         ng-animate-ref="{{ record.id }}"
	         ng-repeat="record in records">
	        {{ record.title }}
	      </a>
	    </file>
	    <file name="profile.html">
	      <div class="profile record" ng-animate-ref="{{ profile.id }}">
	        {{ profile.title }}
	      </div>
	    </file>
	    <file name="animations.css">
	      .record {
	        display:block;
	        font-size:20px;
	      }
	      .profile {
	        background:black;
	        color:white;
	        font-size:100px;
	      }
	      .view-container {
	        position:relative;
	      }
	      .view-container > .view.ng-animate {
	        position:absolute;
	        top:0;
	        left:0;
	        width:100%;
	        min-height:500px;
	      }
	      .view.ng-enter, .view.ng-leave,
	      .record.ng-anchor {
	        transition:0.5s linear all;
	      }
	      .view.ng-enter {
	        transform:translateX(100%);
	      }
	      .view.ng-enter.ng-enter-active, .view.ng-leave {
	        transform:translateX(0%);
	      }
	      .view.ng-leave.ng-leave-active {
	        transform:translateX(-100%);
	      }
	      .record.ng-anchor-out {
	        background:red;
	      }
	    </file>
	  </example>
	 *
	 * ### How is the element transported?
	 *
	 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
	 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
	 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
	 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
	 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
	 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
	 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
	 * will become visible since the shim class will be removed.
	 *
	 * ### How is the morphing handled?
	 *
	 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
	 * what CSS classes differ between the starting element and the destination element. These different CSS classes
	 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
	 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
	 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
	 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
	 * the cloned element is placed inside of root element which is likely close to the body element).
	 *
	 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
	 *
	 *
	 * ## Using $animate in your directive code
	 *
	 * So far we've explored how to feed in animations into an Angular application, but how do we trigger animations within our own directives in our application?
	 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
	 * imagine we have a greeting box that shows and hides itself when the data changes
	 *
	 * ```html
	 * <greeting-box active="onOrOff">Hi there</greeting-box>
	 * ```
	 *
	 * ```js
	 * ngModule.directive('greetingBox', ['$animate', function($animate) {
	 *   return function(scope, element, attrs) {
	 *     attrs.$observe('active', function(value) {
	 *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
	 *     });
	 *   });
	 * }]);
	 * ```
	 *
	 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
	 * in our HTML code then we can trigger a CSS or JS animation to happen.
	 *
	 * ```css
	 * /&#42; normally we would create a CSS class to reference on the element &#42;/
	 * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
	 * ```
	 *
	 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
	 * possible be sure to visit the {@link ng.$animate $animate service API page}.
	 *
	 *
	 * ## Callbacks and Promises
	 *
	 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
	 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
	 * ended by chaining onto the returned promise that animation method returns.
	 *
	 * ```js
	 * // somewhere within the depths of the directive
	 * $animate.enter(element, parent).then(function() {
	 *   //the animation has completed
	 * });
	 * ```
	 *
	 * (Note that earlier versions of Angular prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
	 * anymore.)
	 *
	 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
	 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
	 * routing controller to hook into that:
	 *
	 * ```js
	 * ngModule.controller('HomePageController', ['$animate', function($animate) {
	 *   $animate.on('enter', ngViewElement, function(element) {
	 *     // the animation for this route has completed
	 *   }]);
	 * }])
	 * ```
	 *
	 * (Note that you will need to trigger a digest within the callback to get angular to notice any scope-related changes.)
	 */
	
	var copy;
	var extend;
	var forEach;
	var isArray;
	var isDefined;
	var isElement;
	var isFunction;
	var isObject;
	var isString;
	var isUndefined;
	var jqLite;
	var noop;
	
	/**
	 * @ngdoc service
	 * @name $animate
	 * @kind object
	 *
	 * @description
	 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
	 *
	 * Click here {@link ng.$animate to learn more about animations with `$animate`}.
	 */
	angular.module('ngAnimate', [], function initAngularHelpers() {
	  // Access helpers from angular core.
	  // Do it inside a `config` block to ensure `window.angular` is available.
	  noop        = angular.noop;
	  copy        = angular.copy;
	  extend      = angular.extend;
	  jqLite      = angular.element;
	  forEach     = angular.forEach;
	  isArray     = angular.isArray;
	  isString    = angular.isString;
	  isObject    = angular.isObject;
	  isUndefined = angular.isUndefined;
	  isDefined   = angular.isDefined;
	  isFunction  = angular.isFunction;
	  isElement   = angular.isElement;
	})
	  .directive('ngAnimateSwap', ngAnimateSwapDirective)
	
	  .directive('ngAnimateChildren', $$AnimateChildrenDirective)
	  .factory('$$rAFScheduler', $$rAFSchedulerFactory)
	
	  .provider('$$animateQueue', $$AnimateQueueProvider)
	  .provider('$$animation', $$AnimationProvider)
	
	  .provider('$animateCss', $AnimateCssProvider)
	  .provider('$$animateCssDriver', $$AnimateCssDriverProvider)
	
	  .provider('$$animateJs', $$AnimateJsProvider)
	  .provider('$$animateJsDriver', $$AnimateJsDriverProvider);
	
	
	})(window, window.angular);


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(379);
	module.exports = 'ngAria';


/***/ },
/* 379 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.6.1
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngAria
	 * @description
	 *
	 * The `ngAria` module provides support for common
	 * [<abbr title="Accessible Rich Internet Applications">ARIA</abbr>](http://www.w3.org/TR/wai-aria/)
	 * attributes that convey state or semantic information about the application for users
	 * of assistive technologies, such as screen readers.
	 *
	 * <div doc-module-components="ngAria"></div>
	 *
	 * ## Usage
	 *
	 * For ngAria to do its magic, simply include the module `ngAria` as a dependency. The following
	 * directives are supported:
	 * `ngModel`, `ngChecked`, `ngReadonly`, `ngRequired`, `ngValue`, `ngDisabled`, `ngShow`, `ngHide`, `ngClick`,
	 * `ngDblClick`, and `ngMessages`.
	 *
	 * Below is a more detailed breakdown of the attributes handled by ngAria:
	 *
	 * | Directive                                   | Supported Attributes                                                                                |
	 * |---------------------------------------------|-----------------------------------------------------------------------------------------------------|
	 * | {@link ng.directive:ngModel ngModel}        | aria-checked, aria-valuemin, aria-valuemax, aria-valuenow, aria-invalid, aria-required, input roles |
	 * | {@link ng.directive:ngDisabled ngDisabled}  | aria-disabled                                                                                       |
	 * | {@link ng.directive:ngRequired ngRequired}  | aria-required                                                                                       |
	 * | {@link ng.directive:ngChecked ngChecked}    | aria-checked                                                                                        |
	 * | {@link ng.directive:ngReadonly ngReadonly}  | aria-readonly                                                                                       |
	 * | {@link ng.directive:ngValue ngValue}        | aria-checked                                                                                        |
	 * | {@link ng.directive:ngShow ngShow}          | aria-hidden                                                                                         |
	 * | {@link ng.directive:ngHide ngHide}          | aria-hidden                                                                                         |
	 * | {@link ng.directive:ngDblclick ngDblclick}  | tabindex                                                                                            |
	 * | {@link module:ngMessages ngMessages}        | aria-live                                                                                           |
	 * | {@link ng.directive:ngClick ngClick}        | tabindex, keydown event, button role                                                                |
	 *
	 * Find out more information about each directive by reading the
	 * {@link guide/accessibility ngAria Developer Guide}.
	 *
	 * ## Example
	 * Using ngDisabled with ngAria:
	 * ```html
	 * <md-checkbox ng-disabled="disabled">
	 * ```
	 * Becomes:
	 * ```html
	 * <md-checkbox ng-disabled="disabled" aria-disabled="true">
	 * ```
	 *
	 * ## Disabling Attributes
	 * It's possible to disable individual attributes added by ngAria with the
	 * {@link ngAria.$ariaProvider#config config} method. For more details, see the
	 * {@link guide/accessibility Developer Guide}.
	 */
	var ngAriaModule = angular.module('ngAria', ['ng']).
	                        provider('$aria', $AriaProvider);
	
	/**
	* Internal Utilities
	*/
	var nodeBlackList = ['BUTTON', 'A', 'INPUT', 'TEXTAREA', 'SELECT', 'DETAILS', 'SUMMARY'];
	
	var isNodeOneOf = function(elem, nodeTypeArray) {
	  if (nodeTypeArray.indexOf(elem[0].nodeName) !== -1) {
	    return true;
	  }
	};
	/**
	 * @ngdoc provider
	 * @name $ariaProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the ARIA attributes injected and managed by ngAria.
	 *
	 * ```js
	 * angular.module('myApp', ['ngAria'], function config($ariaProvider) {
	 *   $ariaProvider.config({
	 *     ariaValue: true,
	 *     tabindex: false
	 *   });
	 * });
	 *```
	 *
	 * ## Dependencies
	 * Requires the {@link ngAria} module to be installed.
	 *
	 */
	function $AriaProvider() {
	  var config = {
	    ariaHidden: true,
	    ariaChecked: true,
	    ariaReadonly: true,
	    ariaDisabled: true,
	    ariaRequired: true,
	    ariaInvalid: true,
	    ariaValue: true,
	    tabindex: true,
	    bindKeydown: true,
	    bindRoleForClick: true
	  };
	
	  /**
	   * @ngdoc method
	   * @name $ariaProvider#config
	   *
	   * @param {object} config object to enable/disable specific ARIA attributes
	   *
	   *  - **ariaHidden** – `{boolean}` – Enables/disables aria-hidden tags
	   *  - **ariaChecked** – `{boolean}` – Enables/disables aria-checked tags
	   *  - **ariaReadonly** – `{boolean}` – Enables/disables aria-readonly tags
	   *  - **ariaDisabled** – `{boolean}` – Enables/disables aria-disabled tags
	   *  - **ariaRequired** – `{boolean}` – Enables/disables aria-required tags
	   *  - **ariaInvalid** – `{boolean}` – Enables/disables aria-invalid tags
	   *  - **ariaValue** – `{boolean}` – Enables/disables aria-valuemin, aria-valuemax and
	   *    aria-valuenow tags
	   *  - **tabindex** – `{boolean}` – Enables/disables tabindex tags
	   *  - **bindKeydown** – `{boolean}` – Enables/disables keyboard event binding on non-interactive
	   *    elements (such as `div` or `li`) using ng-click, making them more accessible to users of
	   *    assistive technologies
	   *  - **bindRoleForClick** – `{boolean}` – Adds role=button to non-interactive elements (such as
	   *    `div` or `li`) using ng-click, making them more accessible to users of assistive
	   *    technologies
	   *
	   * @description
	   * Enables/disables various ARIA attributes
	   */
	  this.config = function(newConfig) {
	    config = angular.extend(config, newConfig);
	  };
	
	  function watchExpr(attrName, ariaAttr, nodeBlackList, negate) {
	    return function(scope, elem, attr) {
	      var ariaCamelName = attr.$normalize(ariaAttr);
	      if (config[ariaCamelName] && !isNodeOneOf(elem, nodeBlackList) && !attr[ariaCamelName]) {
	        scope.$watch(attr[attrName], function(boolVal) {
	          // ensure boolean value
	          boolVal = negate ? !boolVal : !!boolVal;
	          elem.attr(ariaAttr, boolVal);
	        });
	      }
	    };
	  }
	  /**
	   * @ngdoc service
	   * @name $aria
	   *
	   * @description
	   * @priority 200
	   *
	   * The $aria service contains helper methods for applying common
	   * [ARIA](http://www.w3.org/TR/wai-aria/) attributes to HTML directives.
	   *
	   * ngAria injects common accessibility attributes that tell assistive technologies when HTML
	   * elements are enabled, selected, hidden, and more. To see how this is performed with ngAria,
	   * let's review a code snippet from ngAria itself:
	   *
	   *```js
	   * ngAriaModule.directive('ngDisabled', ['$aria', function($aria) {
	   *   return $aria.$$watchExpr('ngDisabled', 'aria-disabled', nodeBlackList, false);
	   * }])
	   *```
	   * Shown above, the ngAria module creates a directive with the same signature as the
	   * traditional `ng-disabled` directive. But this ngAria version is dedicated to
	   * solely managing accessibility attributes on custom elements. The internal `$aria` service is
	   * used to watch the boolean attribute `ngDisabled`. If it has not been explicitly set by the
	   * developer, `aria-disabled` is injected as an attribute with its value synchronized to the
	   * value in `ngDisabled`.
	   *
	   * Because ngAria hooks into the `ng-disabled` directive, developers do not have to do
	   * anything to enable this feature. The `aria-disabled` attribute is automatically managed
	   * simply as a silent side-effect of using `ng-disabled` with the ngAria module.
	   *
	   * The full list of directives that interface with ngAria:
	   * * **ngModel**
	   * * **ngChecked**
	   * * **ngReadonly**
	   * * **ngRequired**
	   * * **ngDisabled**
	   * * **ngValue**
	   * * **ngShow**
	   * * **ngHide**
	   * * **ngClick**
	   * * **ngDblclick**
	   * * **ngMessages**
	   *
	   * Read the {@link guide/accessibility ngAria Developer Guide} for a thorough explanation of each
	   * directive.
	   *
	   *
	   * ## Dependencies
	   * Requires the {@link ngAria} module to be installed.
	   */
	  this.$get = function() {
	    return {
	      config: function(key) {
	        return config[key];
	      },
	      $$watchExpr: watchExpr
	    };
	  };
	}
	
	
	ngAriaModule.directive('ngShow', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngShow', 'aria-hidden', [], true);
	}])
	.directive('ngHide', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngHide', 'aria-hidden', [], false);
	}])
	.directive('ngValue', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngValue', 'aria-checked', nodeBlackList, false);
	}])
	.directive('ngChecked', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngChecked', 'aria-checked', nodeBlackList, false);
	}])
	.directive('ngReadonly', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngReadonly', 'aria-readonly', nodeBlackList, false);
	}])
	.directive('ngRequired', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngRequired', 'aria-required', nodeBlackList, false);
	}])
	.directive('ngModel', ['$aria', function($aria) {
	
	  function shouldAttachAttr(attr, normalizedAttr, elem, allowBlacklistEls) {
	    return $aria.config(normalizedAttr) && !elem.attr(attr) && (allowBlacklistEls || !isNodeOneOf(elem, nodeBlackList));
	  }
	
	  function shouldAttachRole(role, elem) {
	    // if element does not have role attribute
	    // AND element type is equal to role (if custom element has a type equaling shape) <-- remove?
	    // AND element is not in nodeBlackList
	    return !elem.attr('role') && (elem.attr('type') === role) && !isNodeOneOf(elem, nodeBlackList);
	  }
	
	  function getShape(attr, elem) {
	    var type = attr.type,
	        role = attr.role;
	
	    return ((type || role) === 'checkbox' || role === 'menuitemcheckbox') ? 'checkbox' :
	           ((type || role) === 'radio'    || role === 'menuitemradio') ? 'radio' :
	           (type === 'range'              || role === 'progressbar' || role === 'slider') ? 'range' : '';
	  }
	
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    priority: 200, //Make sure watches are fired after any other directives that affect the ngModel value
	    compile: function(elem, attr) {
	      var shape = getShape(attr, elem);
	
	      return {
	        post: function(scope, elem, attr, ngModel) {
	          var needsTabIndex = shouldAttachAttr('tabindex', 'tabindex', elem, false);
	
	          function ngAriaWatchModelValue() {
	            return ngModel.$modelValue;
	          }
	
	          function getRadioReaction(newVal) {
	            // Strict comparison would cause a BC
	            // eslint-disable-next-line eqeqeq
	            var boolVal = (attr.value == ngModel.$viewValue);
	            elem.attr('aria-checked', boolVal);
	          }
	
	          function getCheckboxReaction() {
	            elem.attr('aria-checked', !ngModel.$isEmpty(ngModel.$viewValue));
	          }
	
	          switch (shape) {
	            case 'radio':
	            case 'checkbox':
	              if (shouldAttachRole(shape, elem)) {
	                elem.attr('role', shape);
	              }
	              if (shouldAttachAttr('aria-checked', 'ariaChecked', elem, false)) {
	                scope.$watch(ngAriaWatchModelValue, shape === 'radio' ?
	                    getRadioReaction : getCheckboxReaction);
	              }
	              if (needsTabIndex) {
	                elem.attr('tabindex', 0);
	              }
	              break;
	            case 'range':
	              if (shouldAttachRole(shape, elem)) {
	                elem.attr('role', 'slider');
	              }
	              if ($aria.config('ariaValue')) {
	                var needsAriaValuemin = !elem.attr('aria-valuemin') &&
	                    (attr.hasOwnProperty('min') || attr.hasOwnProperty('ngMin'));
	                var needsAriaValuemax = !elem.attr('aria-valuemax') &&
	                    (attr.hasOwnProperty('max') || attr.hasOwnProperty('ngMax'));
	                var needsAriaValuenow = !elem.attr('aria-valuenow');
	
	                if (needsAriaValuemin) {
	                  attr.$observe('min', function ngAriaValueMinReaction(newVal) {
	                    elem.attr('aria-valuemin', newVal);
	                  });
	                }
	                if (needsAriaValuemax) {
	                  attr.$observe('max', function ngAriaValueMinReaction(newVal) {
	                    elem.attr('aria-valuemax', newVal);
	                  });
	                }
	                if (needsAriaValuenow) {
	                  scope.$watch(ngAriaWatchModelValue, function ngAriaValueNowReaction(newVal) {
	                    elem.attr('aria-valuenow', newVal);
	                  });
	                }
	              }
	              if (needsTabIndex) {
	                elem.attr('tabindex', 0);
	              }
	              break;
	          }
	
	          if (!attr.hasOwnProperty('ngRequired') && ngModel.$validators.required
	            && shouldAttachAttr('aria-required', 'ariaRequired', elem, false)) {
	            // ngModel.$error.required is undefined on custom controls
	            attr.$observe('required', function() {
	              elem.attr('aria-required', !!attr['required']);
	            });
	          }
	
	          if (shouldAttachAttr('aria-invalid', 'ariaInvalid', elem, true)) {
	            scope.$watch(function ngAriaInvalidWatch() {
	              return ngModel.$invalid;
	            }, function ngAriaInvalidReaction(newVal) {
	              elem.attr('aria-invalid', !!newVal);
	            });
	          }
	        }
	      };
	    }
	  };
	}])
	.directive('ngDisabled', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngDisabled', 'aria-disabled', nodeBlackList, false);
	}])
	.directive('ngMessages', function() {
	  return {
	    restrict: 'A',
	    require: '?ngMessages',
	    link: function(scope, elem, attr, ngMessages) {
	      if (!elem.attr('aria-live')) {
	        elem.attr('aria-live', 'assertive');
	      }
	    }
	  };
	})
	.directive('ngClick',['$aria', '$parse', function($aria, $parse) {
	  return {
	    restrict: 'A',
	    compile: function(elem, attr) {
	      var fn = $parse(attr.ngClick, /* interceptorFn */ null, /* expensiveChecks */ true);
	      return function(scope, elem, attr) {
	
	        if (!isNodeOneOf(elem, nodeBlackList)) {
	
	          if ($aria.config('bindRoleForClick') && !elem.attr('role')) {
	            elem.attr('role', 'button');
	          }
	
	          if ($aria.config('tabindex') && !elem.attr('tabindex')) {
	            elem.attr('tabindex', 0);
	          }
	
	          if ($aria.config('bindKeydown') && !attr.ngKeydown && !attr.ngKeypress && !attr.ngKeyup) {
	            elem.on('keydown', function(event) {
	              var keyCode = event.which || event.keyCode;
	              if (keyCode === 32 || keyCode === 13) {
	                scope.$apply(callback);
	              }
	
	              function callback() {
	                fn(scope, { $event: event });
	              }
	            });
	          }
	        }
	      };
	    }
	  };
	}])
	.directive('ngDblclick', ['$aria', function($aria) {
	  return function(scope, elem, attr) {
	    if ($aria.config('tabindex') && !elem.attr('tabindex') && !isNodeOneOf(elem, nodeBlackList)) {
	      elem.attr('tabindex', 0);
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	// Should already be required, here for clarity
	__webpack_require__(299);
	
	// Load Angular and dependent libs
	__webpack_require__(376);
	__webpack_require__(378);
	
	// Now load Angular Material
	__webpack_require__(381);
	
	// Export namespace
	module.exports = 'ngMaterial';


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/*!
	 * AngularJS Material Design
	 * https://github.com/angular/material
	 * @license MIT
	 * v1.1.24
	 */
	(function( window, angular, undefined ){
	"use strict";
	
	(function(){
	"use strict";
	
	angular.module('ngMaterial', ["ng","ngAnimate","ngAria","material.core","material.core.animate","material.core.gestures","material.core.interaction","material.core.layout","material.core.meta","material.core.theming.palette","material.core.theming","material.components.autocomplete","material.components.backdrop","material.components.bottomSheet","material.components.button","material.components.card","material.components.checkbox","material.components.chips","material.components.colors","material.components.content","material.components.datepicker","material.components.dialog","material.components.divider","material.components.fabActions","material.components.fabShared","material.components.fabSpeedDial","material.components.fabToolbar","material.components.gridList","material.components.icon","material.components.input","material.components.list","material.components.menu","material.components.menuBar","material.components.navBar","material.components.panel","material.components.progressCircular","material.components.progressLinear","material.components.radioButton","material.components.select","material.components.showHide","material.components.sidenav","material.components.slider","material.components.sticky","material.components.subheader","material.components.swipe","material.components.switch","material.components.tabs","material.components.toast","material.components.toolbar","material.components.tooltip","material.components.truncate","material.components.virtualRepeat","material.components.whiteframe"]);
	})();
	(function(){
	"use strict";
	
	/**
	 * Initialization function that validates environment
	 * requirements.
	 */
	DetectNgTouch.$inject = ["$log", "$injector"];
	MdCoreConfigure.$inject = ["$provide", "$mdThemingProvider"];
	rAFDecorator.$inject = ["$delegate"];
	qDecorator.$inject = ["$delegate"];
	angular
	  .module('material.core', [
	    'ngAnimate',
	    'material.core.animate',
	    'material.core.layout',
	    'material.core.interaction',
	    'material.core.gestures',
	    'material.core.theming'
	  ])
	  .config(MdCoreConfigure)
	  .run(DetectNgTouch);
	
	
	/**
	 * Detect if the ng-Touch module is also being used.
	 * Warn if detected.
	 * @ngInject
	 */
	function DetectNgTouch($log, $injector) {
	  if ($injector.has('$swipe')) {
	    var msg = "" +
	      "You are using the ngTouch module. \n" +
	      "AngularJS Material already has mobile click, tap, and swipe support... \n" +
	      "ngTouch is not supported with AngularJS Material!";
	    $log.warn(msg);
	  }
	}
	
	/**
	 * @ngInject
	 */
	function MdCoreConfigure($provide, $mdThemingProvider) {
	
	  $provide.decorator('$$rAF', ['$delegate', rAFDecorator]);
	  $provide.decorator('$q', ['$delegate', qDecorator]);
	
	  $mdThemingProvider.theme('default')
	    .primaryPalette('indigo')
	    .accentPalette('pink')
	    .warnPalette('deep-orange')
	    .backgroundPalette('grey');
	}
	
	/**
	 * @ngInject
	 */
	function rAFDecorator($delegate) {
	  /**
	   * Use this to throttle events that come in often.
	   * The throttled function will always use the *last* invocation before the
	   * coming frame.
	   *
	   * For example, window resize events that fire many times a second:
	   * If we set to use an raf-throttled callback on window resize, then
	   * our callback will only be fired once per frame, with the last resize
	   * event that happened before that frame.
	   *
	   * @param {function} callback function to debounce
	   */
	  $delegate.throttle = function(cb) {
	    var queuedArgs, alreadyQueued, queueCb, context;
	    return function debounced() {
	      queuedArgs = arguments;
	      context = this;
	      queueCb = cb;
	      if (!alreadyQueued) {
	        alreadyQueued = true;
	        $delegate(function() {
	          queueCb.apply(context, Array.prototype.slice.call(queuedArgs));
	          alreadyQueued = false;
	        });
	      }
	    };
	  };
	  return $delegate;
	}
	
	/**
	 * @ngInject
	 */
	function qDecorator($delegate) {
	  /**
	   * Adds a shim for $q.resolve for AngularJS version that don't have it,
	   * so we don't have to think about it.
	   *
	   * via https://github.com/angular/angular.js/pull/11987
	   */
	
	  // TODO(crisbeto): this won't be necessary once we drop AngularJS 1.3
	  if (!$delegate.resolve) {
	    $delegate.resolve = $delegate.when;
	  }
	  return $delegate;
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdAutofocusDirective.$inject = ["$parse"];angular.module('material.core')
	  .directive('mdAutofocus', MdAutofocusDirective)
	
	  // Support the deprecated md-auto-focus and md-sidenav-focus as well
	  .directive('mdAutoFocus', MdAutofocusDirective)
	  .directive('mdSidenavFocus', MdAutofocusDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdAutofocus
	 * @module material.core.util
	 *
	 * @description
	 *
	 * `[md-autofocus]` provides an optional way to identify the focused element when a `$mdDialog`,
	 * `$mdBottomSheet`, `$mdMenu` or `$mdSidenav` opens or upon page load for input-like elements.
	 *
	 * When one of these opens, it will find the first nested element with the `[md-autofocus]`
	 * attribute directive and optional expression. An expression may be specified as the directive
	 * value to enable conditional activation of the autofocus.
	 *
	 * @usage
	 *
	 * ### Dialog
	 * <hljs lang="html">
	 * <md-dialog>
	 *   <form>
	 *     <md-input-container>
	 *       <label for="testInput">Label</label>
	 *       <input id="testInput" type="text" md-autofocus>
	 *     </md-input-container>
	 *   </form>
	 * </md-dialog>
	 * </hljs>
	 *
	 * ### Bottomsheet
	 * <hljs lang="html">
	 * <md-bottom-sheet class="md-list md-has-header">
	 *  <md-subheader>Comment Actions</md-subheader>
	 *  <md-list>
	 *    <md-list-item ng-repeat="item in items">
	 *
	 *      <md-button md-autofocus="$index == 2">
	 *        <md-icon md-svg-src="{{item.icon}}"></md-icon>
	 *        <span class="md-inline-list-icon-label">{{ item.name }}</span>
	 *      </md-button>
	 *
	 *    </md-list-item>
	 *  </md-list>
	 * </md-bottom-sheet>
	 * </hljs>
	 *
	 * ### Autocomplete
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-autofocus
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 *
	 * ### Sidenav
	 * <hljs lang="html">
	 * <div layout="row" ng-controller="MyController">
	 *   <md-sidenav md-component-id="left" class="md-sidenav-left">
	 *     Left Nav!
	 *   </md-sidenav>
	 *
	 *   <md-content>
	 *     Center Content
	 *     <md-button ng-click="openLeftMenu()">
	 *       Open Left Menu
	 *     </md-button>
	 *   </md-content>
	 *
	 *   <md-sidenav md-component-id="right"
	 *     md-is-locked-open="$mdMedia('min-width: 333px')"
	 *     class="md-sidenav-right">
	 *     <form>
	 *       <md-input-container>
	 *         <label for="testInput">Test input</label>
	 *         <input id="testInput" type="text"
	 *                ng-model="data" md-autofocus>
	 *       </md-input-container>
	 *     </form>
	 *   </md-sidenav>
	 * </div>
	 * </hljs>
	 **/
	function MdAutofocusDirective($parse) {
	  return {
	    restrict: 'A',
	    link: {
	      pre: preLink
	    }
	  };
	
	  function preLink(scope, element, attr) {
	    var attrExp = attr.mdAutoFocus || attr.mdAutofocus || attr.mdSidenavFocus;
	
	    // Initially update the expression by manually parsing the expression as per $watch source.
	    updateExpression($parse(attrExp)(scope));
	
	    // Only watch the expression if it is not empty.
	    if (attrExp) {
	      scope.$watch(attrExp, updateExpression);
	    }
	
	    /**
	     * Updates the autofocus class which is used to determine whether the attribute
	     * expression evaluates to true or false.
	     * @param {string|boolean} value Attribute Value
	     */
	    function updateExpression(value) {
	
	      // Rather than passing undefined to the jqLite toggle class function we explicitly set the
	      // value to true. Otherwise the class will be just toggled instead of being forced.
	      if (angular.isUndefined(value)) {
	        value = true;
	      }
	
	      element.toggleClass('md-autofocus', !!value);
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.colorUtil
	 * @description
	 * Color Util
	 */
	angular
	  .module('material.core')
	  .factory('$mdColorUtil', ColorUtilFactory);
	
	function ColorUtilFactory() {
	  /**
	   * Converts hex value to RGBA string
	   * @param color {string}
	   * @returns {string}
	   */
	  function hexToRgba (color) {
	    var hex   = color[ 0 ] === '#' ? color.substr(1) : color,
	      dig   = hex.length / 3,
	      red   = hex.substr(0, dig),
	      green = hex.substr(dig, dig),
	      blue  = hex.substr(dig * 2);
	    if (dig === 1) {
	      red += red;
	      green += green;
	      blue += blue;
	    }
	    return 'rgba(' + parseInt(red, 16) + ',' + parseInt(green, 16) + ',' + parseInt(blue, 16) + ',0.1)';
	  }
	
	  /**
	   * Converts rgba value to hex string
	   * @param {string} color
	   * @returns {string}
	   */
	  function rgbaToHex(color) {
	    color = color.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
	
	    var hex = (color && color.length === 4) ? "#" +
	    ("0" + parseInt(color[1],10).toString(16)).slice(-2) +
	    ("0" + parseInt(color[2],10).toString(16)).slice(-2) +
	    ("0" + parseInt(color[3],10).toString(16)).slice(-2) : '';
	
	    return hex.toUpperCase();
	  }
	
	  /**
	   * Converts an RGB color to RGBA
	   * @param {string} color
	   * @returns {string}
	   */
	  function rgbToRgba (color) {
	    return color.replace(')', ', 0.1)').replace('(', 'a(');
	  }
	
	  /**
	   * Converts an RGBA color to RGB
	   * @param {string} color
	   * @returns {string}
	   */
	  function rgbaToRgb (color) {
	    return color
	      ? color.replace('rgba', 'rgb').replace(/,[^),]+\)/, ')')
	      : 'rgb(0,0,0)';
	  }
	
	  return {
	    rgbaToHex: rgbaToHex,
	    hexToRgba: hexToRgba,
	    rgbToRgba: rgbToRgba,
	    rgbaToRgb: rgbaToRgb
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	angular.module('material.core')
	.factory('$mdConstant', MdConstantFactory);
	
	/**
	 * Factory function that creates the grab-bag $mdConstant service.
	 * @ngInject
	 */
	function MdConstantFactory() {
	
	  var prefixTestEl = document.createElement('div');
	  var vendorPrefix = getVendorPrefix(prefixTestEl);
	  var isWebkit = /webkit/i.test(vendorPrefix);
	  var SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g;
	
	  /**
	   * @param {string} name CSS property name
	   * @return {string} the property name supported by the browser
	   */
	  function vendorProperty(name) {
	    // Add a dash between the prefix and name, to be able to transform the string into camelcase.
	    var prefixedName = vendorPrefix + '-' + name;
	    var ucPrefix = camelCase(prefixedName);
	    var lcPrefix = ucPrefix.charAt(0).toLowerCase() + ucPrefix.substring(1);
	
	    return hasStyleProperty(prefixTestEl, name)     ? name     :       // The current browser supports the un-prefixed property
	           hasStyleProperty(prefixTestEl, ucPrefix) ? ucPrefix :       // The current browser only supports the prefixed property.
	           hasStyleProperty(prefixTestEl, lcPrefix) ? lcPrefix : name; // Some browsers are only supporting the prefix in lowercase.
	  }
	
	  function hasStyleProperty(testElement, property) {
	    return angular.isDefined(testElement.style[property]);
	  }
	
	  /**
	   * @param {!string} input value to convert to camelCase
	   * @return {string} camelCased version of the input string
	   */
	  function camelCase(input) {
	    return input.replace(SPECIAL_CHARS_REGEXP, function(matches, separator, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    });
	  }
	
	  function getVendorPrefix(testElement) {
	    var prop, match;
	    var vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/;
	
	    for (prop in testElement.style) {
	      if (match = vendorRegex.exec(prop)) {
	        return match[0];
	      }
	    }
	  }
	
	  var self = {
	    isInputKey : function(e) { return (e.keyCode >= 31 && e.keyCode <= 90); },
	    isNumPadKey : function(e) { return (3 === e.location && e.keyCode >= 97 && e.keyCode <= 105); },
	    isMetaKey: function(e) { return (e.keyCode >= 91 && e.keyCode <= 93); },
	    isFnLockKey: function(e) { return (e.keyCode >= 112 && e.keyCode <= 145); },
	    isNavigationKey : function(e) {
	      var kc = self.KEY_CODE, NAVIGATION_KEYS =  [kc.SPACE, kc.ENTER, kc.UP_ARROW, kc.DOWN_ARROW];
	      return (NAVIGATION_KEYS.indexOf(e.keyCode) != -1);
	    },
	    hasModifierKey: function(e) {
	      return e.ctrlKey || e.metaKey || e.altKey;
	    },
	
	    /**
	     * Maximum size, in pixels, that can be explicitly set to an element. The actual value varies
	     * between browsers, but IE11 has the very lowest size at a mere 1,533,917px. Ideally we could
	     * compute this value, but Firefox always reports an element to have a size of zero if it
	     * goes over the max, meaning that we'd have to binary search for the value.
	     */
	    ELEMENT_MAX_PIXELS: 1533917,
	
	    /**
	     * Priority for a directive that should run before the directives from ngAria.
	     */
	    BEFORE_NG_ARIA: 210,
	
	    /**
	     * Common Keyboard actions and their associated keycode.
	     */
	    KEY_CODE: {
	      COMMA: 188,
	      SEMICOLON : 186,
	      ENTER: 13,
	      ESCAPE: 27,
	      SPACE: 32,
	      PAGE_UP: 33,
	      PAGE_DOWN: 34,
	      END: 35,
	      HOME: 36,
	      LEFT_ARROW : 37,
	      UP_ARROW : 38,
	      RIGHT_ARROW : 39,
	      DOWN_ARROW : 40,
	      TAB : 9,
	      BACKSPACE: 8,
	      DELETE: 46
	    },
	
	    /**
	     * Vendor prefixed CSS properties to be used to support the given functionality in older browsers
	     * as well.
	     */
	    CSS: {
	      /* Constants */
	      TRANSITIONEND: 'transitionend' + (isWebkit ? ' webkitTransitionEnd' : ''),
	      ANIMATIONEND: 'animationend' + (isWebkit ? ' webkitAnimationEnd' : ''),
	
	      TRANSFORM: vendorProperty('transform'),
	      TRANSFORM_ORIGIN: vendorProperty('transformOrigin'),
	      TRANSITION: vendorProperty('transition'),
	      TRANSITION_DURATION: vendorProperty('transitionDuration'),
	      ANIMATION_PLAY_STATE: vendorProperty('animationPlayState'),
	      ANIMATION_DURATION: vendorProperty('animationDuration'),
	      ANIMATION_NAME: vendorProperty('animationName'),
	      ANIMATION_TIMING: vendorProperty('animationTimingFunction'),
	      ANIMATION_DIRECTION: vendorProperty('animationDirection')
	    },
	
	    /**
	     * As defined in core/style/_variables.scss
	     *
	     * $layout-breakpoint-xs:     600px !default;
	     * $layout-breakpoint-sm:     960px !default;
	     * $layout-breakpoint-md:     1280px !default;
	     * $layout-breakpoint-lg:     1920px !default;
	     *
	     */
	    MEDIA: {
	      'xs'        : '(max-width: 599px)'                         ,
	      'gt-xs'     : '(min-width: 600px)'                         ,
	      'sm'        : '(min-width: 600px) and (max-width: 959px)'  ,
	      'gt-sm'     : '(min-width: 960px)'                         ,
	      'md'        : '(min-width: 960px) and (max-width: 1279px)' ,
	      'gt-md'     : '(min-width: 1280px)'                        ,
	      'lg'        : '(min-width: 1280px) and (max-width: 1919px)',
	      'gt-lg'     : '(min-width: 1920px)'                        ,
	      'xl'        : '(min-width: 1920px)'                        ,
	      'landscape' : '(orientation: landscape)'                   ,
	      'portrait'  : '(orientation: portrait)'                    ,
	      'print' : 'print'
	    },
	
	    MEDIA_PRIORITY: [
	      'xl',
	      'gt-lg',
	      'lg',
	      'gt-md',
	      'md',
	      'gt-sm',
	      'sm',
	      'gt-xs',
	      'xs',
	      'landscape',
	      'portrait',
	      'print'
	    ]
	  };
	
	  return self;
	}
	
	})();
	(function(){
	"use strict";
	
	  angular
	    .module('material.core')
	    .config(["$provide", function($provide){
	       $provide.decorator('$mdUtil', ['$delegate', function ($delegate){
	           /**
	            * Inject the iterator facade to easily support iteration and accessors
	            * @see iterator below
	            */
	           $delegate.iterator = MdIterator;
	
	           return $delegate;
	         }
	       ]);
	     }]);
	
	  /**
	   * iterator is a list facade to easily support iteration and accessors
	   *
	   * @param items Array list which this iterator will enumerate
	   * @param reloop Boolean enables iterator to consider the list as an endless reloop
	   */
	  function MdIterator(items, reloop) {
	    var trueFn = function() { return true; };
	
	    if (items && !angular.isArray(items)) {
	      items = Array.prototype.slice.call(items);
	    }
	
	    reloop = !!reloop;
	    var _items = items || [];
	
	    // Published API
	    return {
	      items: getItems,
	      count: count,
	
	      inRange: inRange,
	      contains: contains,
	      indexOf: indexOf,
	      itemAt: itemAt,
	
	      findBy: findBy,
	
	      add: add,
	      remove: remove,
	
	      first: first,
	      last: last,
	      next: angular.bind(null, findSubsequentItem, false),
	      previous: angular.bind(null, findSubsequentItem, true),
	
	      hasPrevious: hasPrevious,
	      hasNext: hasNext
	
	    };
	
	    /**
	     * Publish copy of the enumerable set
	     * @returns {Array|*}
	     */
	    function getItems() {
	      return [].concat(_items);
	    }
	
	    /**
	     * Determine length of the list
	     * @returns {Array.length|*|number}
	     */
	    function count() {
	      return _items.length;
	    }
	
	    /**
	     * Is the index specified valid
	     * @param index
	     * @returns {Array.length|*|number|boolean}
	     */
	    function inRange(index) {
	      return _items.length && (index > -1) && (index < _items.length);
	    }
	
	    /**
	     * Can the iterator proceed to the next item in the list; relative to
	     * the specified item.
	     *
	     * @param item
	     * @returns {Array.length|*|number|boolean}
	     */
	    function hasNext(item) {
	      return item ? inRange(indexOf(item) + 1) : false;
	    }
	
	    /**
	     * Can the iterator proceed to the previous item in the list; relative to
	     * the specified item.
	     *
	     * @param item
	     * @returns {Array.length|*|number|boolean}
	     */
	    function hasPrevious(item) {
	      return item ? inRange(indexOf(item) - 1) : false;
	    }
	
	    /**
	     * Get item at specified index/position
	     * @param index
	     * @returns {*}
	     */
	    function itemAt(index) {
	      return inRange(index) ? _items[index] : null;
	    }
	
	    /**
	     * Find all elements matching the key/value pair
	     * otherwise return null
	     *
	     * @param val
	     * @param key
	     *
	     * @return array
	     */
	    function findBy(key, val) {
	      return _items.filter(function(item) {
	        return item[key] === val;
	      });
	    }
	
	    /**
	     * Add item to list
	     * @param item
	     * @param index
	     * @returns {*}
	     */
	    function add(item, index) {
	      if (!item) return -1;
	
	      if (!angular.isNumber(index)) {
	        index = _items.length;
	      }
	
	      _items.splice(index, 0, item);
	
	      return indexOf(item);
	    }
	
	    /**
	     * Remove item from list...
	     * @param item
	     */
	    function remove(item) {
	      if (contains(item)){
	        _items.splice(indexOf(item), 1);
	      }
	    }
	
	    /**
	     * Get the zero-based index of the target item
	     * @param item
	     * @returns {*}
	     */
	    function indexOf(item) {
	      return _items.indexOf(item);
	    }
	
	    /**
	     * Boolean existence check
	     * @param item
	     * @returns {boolean}
	     */
	    function contains(item) {
	      return item && (indexOf(item) > -1);
	    }
	
	    /**
	     * Return first item in the list
	     * @returns {*}
	     */
	    function first() {
	      return _items.length ? _items[0] : null;
	    }
	
	    /**
	     * Return last item in the list...
	     * @returns {*}
	     */
	    function last() {
	      return _items.length ? _items[_items.length - 1] : null;
	    }
	
	    /**
	     * Find the next item. If reloop is true and at the end of the list, it will go back to the
	     * first item. If given, the `validate` callback will be used to determine whether the next item
	     * is valid. If not valid, it will try to find the next item again.
	     *
	     * @param {boolean} backwards Specifies the direction of searching (forwards/backwards)
	     * @param {*} item The item whose subsequent item we are looking for
	     * @param {Function=} validate The `validate` function
	     * @param {integer=} limit The recursion limit
	     *
	     * @returns {*} The subsequent item or null
	     */
	    function findSubsequentItem(backwards, item, validate, limit) {
	      validate = validate || trueFn;
	
	      var curIndex = indexOf(item);
	      while (true) {
	        if (!inRange(curIndex)) return null;
	
	        var nextIndex = curIndex + (backwards ? -1 : 1);
	        var foundItem = null;
	        if (inRange(nextIndex)) {
	          foundItem = _items[nextIndex];
	        } else if (reloop) {
	          foundItem = backwards ? last() : first();
	          nextIndex = indexOf(foundItem);
	        }
	
	        if ((foundItem === null) || (nextIndex === limit)) return null;
	        if (validate(foundItem)) return foundItem;
	
	        if (angular.isUndefined(limit)) limit = nextIndex;
	
	        curIndex = nextIndex;
	      }
	    }
	  }
	
	
	})();
	(function(){
	"use strict";
	
	
	mdMediaFactory.$inject = ["$mdConstant", "$rootScope", "$window"];angular.module('material.core')
	.factory('$mdMedia', mdMediaFactory);
	
	/**
	 * @ngdoc service
	 * @name $mdMedia
	 * @module material.core
	 *
	 * @description
	 * `$mdMedia` is used to evaluate whether a given media query is true or false given the
	 * current device's screen / window size. The media query will be re-evaluated on resize, allowing
	 * you to register a watch.
	 *
	 * `$mdMedia` also has pre-programmed support for media queries that match the layout breakpoints:
	 *
	 *  <table class="md-api-table">
	 *    <thead>
	 *    <tr>
	 *      <th>Breakpoint</th>
	 *      <th>mediaQuery</th>
	 *    </tr>
	 *    </thead>
	 *    <tbody>
	 *    <tr>
	 *      <td>xs</td>
	 *      <td>(max-width: 599px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-xs</td>
	 *      <td>(min-width: 600px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>sm</td>
	 *      <td>(min-width: 600px) and (max-width: 959px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-sm</td>
	 *      <td>(min-width: 960px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>md</td>
	 *      <td>(min-width: 960px) and (max-width: 1279px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-md</td>
	 *      <td>(min-width: 1280px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>lg</td>
	 *      <td>(min-width: 1280px) and (max-width: 1919px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-lg</td>
	 *      <td>(min-width: 1920px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>xl</td>
	 *      <td>(min-width: 1920px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>landscape</td>
	 *      <td>landscape</td>
	 *    </tr>
	 *    <tr>
	 *      <td>portrait</td>
	 *      <td>portrait</td>
	 *    </tr>
	 *    <tr>
	 *      <td>print</td>
	 *      <td>print</td>
	 *    </tr>
	 *    </tbody>
	 *  </table>
	 *
	 *  See Material Design's <a href="https://material.google.com/layout/responsive-ui.html">Layout - Adaptive UI</a> for more details.
	 *
	 *  <a href="https://material.io/archive/guidelines/layout/responsive-ui.html#">
	 *  <img src="https://material-design.storage.googleapis.com/publish/material_v_4/material_ext_publish/0B8olV15J7abPSGFxemFiQVRtb1k/layout_adaptive_breakpoints_01.png" width="100%" height="100%"></img>
	 *  </a>
	 *
	 * @returns {boolean} a boolean representing whether or not the given media query is true or false.
	 *
	 * @usage
	 * <hljs lang="js">
	 * app.controller('MyController', function($mdMedia, $scope) {
	 *   $scope.$watch(function() { return $mdMedia('lg'); }, function(big) {
	 *     $scope.bigScreen = big;
	 *   });
	 *
	 *   $scope.screenIsSmall = $mdMedia('sm');
	 *   $scope.customQuery = $mdMedia('(min-width: 1234px)');
	 *   $scope.anotherCustom = $mdMedia('max-width: 300px');
	 * });
	 * </hljs>
	 */
	
	/* @ngInject */
	function mdMediaFactory($mdConstant, $rootScope, $window) {
	  var queries = {};
	  var mqls = {};
	  var results = {};
	  var normalizeCache = {};
	
	  $mdMedia.getResponsiveAttribute = getResponsiveAttribute;
	  $mdMedia.getQuery = getQuery;
	  $mdMedia.watchResponsiveAttributes = watchResponsiveAttributes;
	
	  return $mdMedia;
	
	  function $mdMedia(query) {
	    var validated = queries[query];
	    if (angular.isUndefined(validated)) {
	      validated = queries[query] = validate(query);
	    }
	
	    var result = results[validated];
	    if (angular.isUndefined(result)) {
	      result = add(validated);
	    }
	
	    return result;
	  }
	
	  function validate(query) {
	    return $mdConstant.MEDIA[query] ||
	           ((query.charAt(0) !== '(') ? ('(' + query + ')') : query);
	  }
	
	  function add(query) {
	    var result = mqls[query];
	    if (!result) {
	      result = mqls[query] = $window.matchMedia(query);
	    }
	
	    result.addListener(onQueryChange);
	    return (results[result.media] = !!result.matches);
	  }
	
	  function onQueryChange(query) {
	    $rootScope.$evalAsync(function() {
	      results[query.media] = !!query.matches;
	    });
	  }
	
	  function getQuery(name) {
	    return mqls[name];
	  }
	
	  function getResponsiveAttribute(attrs, attrName) {
	    for (var i = 0; i < $mdConstant.MEDIA_PRIORITY.length; i++) {
	      var mediaName = $mdConstant.MEDIA_PRIORITY[i];
	      if (!mqls[queries[mediaName]].matches) {
	        continue;
	      }
	
	      var normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
	      if (attrs[normalizedName]) {
	        return attrs[normalizedName];
	      }
	    }
	
	    // fallback on unprefixed
	    return attrs[getNormalizedName(attrs, attrName)];
	  }
	
	  function watchResponsiveAttributes(attrNames, attrs, watchFn) {
	    var unwatchFns = [];
	    attrNames.forEach(function(attrName) {
	      var normalizedName = getNormalizedName(attrs, attrName);
	      if (angular.isDefined(attrs[normalizedName])) {
	        unwatchFns.push(
	            attrs.$observe(normalizedName, angular.bind(void 0, watchFn, null)));
	      }
	
	      for (var mediaName in $mdConstant.MEDIA) {
	        normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
	        if (angular.isDefined(attrs[normalizedName])) {
	          unwatchFns.push(
	              attrs.$observe(normalizedName, angular.bind(void 0, watchFn, mediaName)));
	        }
	      }
	    });
	
	    return function unwatch() {
	      unwatchFns.forEach(function(fn) { fn(); });
	    };
	  }
	
	  // Improves performance dramatically
	  function getNormalizedName(attrs, attrName) {
	    return normalizeCache[attrName] ||
	        (normalizeCache[attrName] = attrs.$normalize(attrName));
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	angular
	  .module('material.core')
	  .config(["$provide", function($provide) {
	    $provide.decorator('$mdUtil', ['$delegate', function ($delegate) {
	
	      // Inject the prefixer into our original $mdUtil service.
	      $delegate.prefixer = MdPrefixer;
	
	      return $delegate;
	    }]);
	  }]);
	
	function MdPrefixer(initialAttributes, buildSelector) {
	  var PREFIXES = ['data', 'x'];
	
	  if (initialAttributes) {
	    // The prefixer also accepts attributes as a parameter, and immediately builds a list or selector for
	    // the specified attributes.
	    return buildSelector ? _buildSelector(initialAttributes) : _buildList(initialAttributes);
	  }
	
	  return {
	    buildList: _buildList,
	    buildSelector: _buildSelector,
	    hasAttribute: _hasAttribute,
	    removeAttribute: _removeAttribute
	  };
	
	  function _buildList(attributes) {
	    attributes = angular.isArray(attributes) ? attributes : [attributes];
	
	    attributes.forEach(function(item) {
	      PREFIXES.forEach(function(prefix) {
	        attributes.push(prefix + '-' + item);
	      });
	    });
	
	    return attributes;
	  }
	
	  function _buildSelector(attributes) {
	    attributes = angular.isArray(attributes) ? attributes : [attributes];
	
	    return _buildList(attributes)
	      .map(function(item) {
	        return '[' + item + ']';
	      })
	      .join(',');
	  }
	
	  function _hasAttribute(element, attribute) {
	    element = _getNativeElement(element);
	
	    if (!element) {
	      return false;
	    }
	
	    var prefixedAttrs = _buildList(attribute);
	
	    for (var i = 0; i < prefixedAttrs.length; i++) {
	      if (element.hasAttribute(prefixedAttrs[i])) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	
	  function _removeAttribute(element, attribute) {
	    element = _getNativeElement(element);
	
	    if (!element) {
	      return;
	    }
	
	    _buildList(attribute).forEach(function(prefixedAttribute) {
	      element.removeAttribute(prefixedAttribute);
	    });
	  }
	
	  /**
	   * Transforms a jqLite or DOM element into a HTML element.
	   * This is useful when supporting jqLite elements and DOM elements at
	   * same time.
	   * @param element {JQLite|Element} Element to be parsed
	   * @returns {HTMLElement} Parsed HTMLElement
	   */
	  function _getNativeElement(element) {
	    element =  element[0] || element;
	
	    if (element.nodeType) {
	      return element;
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/*
	 * This var has to be outside the angular factory, otherwise when
	 * there are multiple material apps on the same page, each app
	 * will create its own instance of this array and the app's IDs
	 * will not be unique.
	 */
	UtilFactory.$inject = ["$document", "$timeout", "$compile", "$rootScope", "$$mdAnimate", "$interpolate", "$log", "$rootElement", "$window", "$$rAF"];
	var nextUniqueId = 0, isIos, isAndroid;
	
	// Support material-tools builds.
	if (window.navigator) {
	  var userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
	  isIos = userAgent.match(/ipad|iphone|ipod/i);
	  isAndroid = userAgent.match(/android/i);
	}
	
	/**
	 * @ngdoc module
	 * @name material.core.util
	 * @description
	 * Util
	 */
	angular
	.module('material.core')
	.factory('$mdUtil', UtilFactory);
	
	/**
	 * @ngInject
	 */
	function UtilFactory($document, $timeout, $compile, $rootScope, $$mdAnimate, $interpolate, $log,
	                     $rootElement, $window, $$rAF) {
	  // Setup some core variables for the processTemplate method
	  var startSymbol = $interpolate.startSymbol(),
	    endSymbol = $interpolate.endSymbol(),
	    usesStandardSymbols = ((startSymbol === '{{') && (endSymbol === '}}'));
	
	  // Polyfill document.contains for IE11.
	  document.contains || (document.contains = function (node) {
	    return document.body.contains(node);
	  });
	
	  /**
	   * Checks if the target element has the requested style by key
	   * @param {DOMElement|JQLite} target Target element
	   * @param {string} key Style key
	   * @param {string=} expectedVal Optional expected value
	   * @returns {boolean} Whether the target element has the style or not
	   */
	  var hasComputedStyle = function (target, key, expectedVal) {
	    var hasValue = false;
	
	    if (target && target.length) {
	      var computedStyles = $window.getComputedStyle(target[0]);
	      hasValue = angular.isDefined(computedStyles[key]) &&
	        (expectedVal ? computedStyles[key] == expectedVal : true);
	    }
	
	    return hasValue;
	  };
	
	  function validateCssValue(value) {
	    return !value ? '0' :
	      hasPx(value) || hasPercent(value) ? value : value + 'px';
	  }
	
	  function hasPx(value) {
	    return String(value).indexOf('px') > -1;
	  }
	
	  function hasPercent(value) {
	    return String(value).indexOf('%') > -1;
	  }
	
	  var $mdUtil = {
	    dom: {},
	    isIos: isIos,
	    isAndroid: isAndroid,
	    now: window.performance && window.performance.now ?
	      angular.bind(window.performance, window.performance.now) : Date.now || function() {
	      return new Date().getTime();
	    },
	
	    /**
	     * Cross-version compatibility method to retrieve an option of a ngModel controller,
	     * which supports the breaking changes in the AngularJS snapshot (SHA 87a2ff76af5d0a9268d8eb84db5755077d27c84c).
	     * @param {!ngModel.NgModelController} ngModelCtrl
	     * @param {!string} optionName
	     * @returns {string|number|boolean|Object|undefined}
	     */
	    getModelOption: function (ngModelCtrl, optionName) {
	      if (!ngModelCtrl.$options) {
	        return;
	      }
	
	      var $options = ngModelCtrl.$options;
	
	      // The newer versions of AngularJS introduced a getOption function and made the option values
	      // no longer visible on the $options object.
	      return $options.getOption ? $options.getOption(optionName) : $options[optionName];
	    },
	
	    /**
	     * Determines the current 'dir'ectional value based on the value of 'dir'
	     * attribute of the element. If that is not defined, it will try to use
	     * a 'dir' attribute of the body or html tag.
	     *
	     * @param {Object=} attrs a hash object with key-value pairs of normalized
	     *     attribute names and their corresponding attribute values.
	     * @returns {boolean} true if the element's passed in attributes,
	     *     the document, or the body indicates RTL mode, false otherwise.
	     */
	    isRtl: function(attrs) {
	      var dir = angular.isDefined(attrs) && attrs.hasOwnProperty('dir') && attrs.dir;
	
	      switch (dir) {
	        case 'ltr':
	          return false;
	
	        case 'rtl':
	          return true;
	      }
	
	      return ($document[0].dir === 'rtl' || $document[0].body.dir === 'rtl');
	    },
	
	    /**
	     * Bi-directional accessor/mutator used to easily update an element's
	     * property based on the current 'dir'ectional value.
	     */
	    bidi: function(element, property, lValue, rValue) {
	      var ltr = !this.isRtl();
	
	      // If accessor
	      if (arguments.length == 0) return ltr ? 'ltr' : 'rtl';
	
	      // If mutator
	      var elem = angular.element(element);
	
	      if (ltr && angular.isDefined(lValue)) {
	        elem.css(property, validateCssValue(lValue));
	      }
	      else if (!ltr && angular.isDefined(rValue)) {
	        elem.css(property, validateCssValue(rValue));
	      }
	    },
	
	    bidiProperty: function (element, lProperty, rProperty, value) {
	      var ltr = !this.isRtl();
	
	      var elem = angular.element(element);
	
	      if (ltr && angular.isDefined(lProperty)) {
	        elem.css(lProperty, validateCssValue(value));
	        elem.css(rProperty, '');
	      }
	      else if (!ltr && angular.isDefined(rProperty)) {
	        elem.css(rProperty, validateCssValue(value));
	        elem.css(lProperty, '');
	      }
	    },
	
	    clientRect: function(element, offsetParent, isOffsetRect) {
	      var node = getNode(element);
	      offsetParent = getNode(offsetParent || node.offsetParent || document.body);
	      var nodeRect = node.getBoundingClientRect();
	
	      // The user can ask for an offsetRect: a rect relative to the offsetParent,
	      // or a clientRect: a rect relative to the page
	      var offsetRect = isOffsetRect ?
	        offsetParent.getBoundingClientRect() :
	        {left: 0, top: 0, width: 0, height: 0};
	      return {
	        left: nodeRect.left - offsetRect.left,
	        top: nodeRect.top - offsetRect.top,
	        width: nodeRect.width,
	        height: nodeRect.height
	      };
	    },
	    offsetRect: function(element, offsetParent) {
	      return $mdUtil.clientRect(element, offsetParent, true);
	    },
	
	    /**
	     * Annoying method to copy nodes to an array, thanks to IE.
	     * @param nodes
	     * @return {Array}
	     */
	    nodesToArray: function(nodes) {
	      var results = [], i;
	      nodes = nodes || [];
	
	      for (i = 0; i < nodes.length; ++i) {
	        results.push(nodes.item(i));
	      }
	      return results;
	    },
	
	    /**
	     * Determines the absolute position of the viewport.
	     * Useful when making client rectangles absolute.
	     * @returns {number}
	     */
	    getViewportTop: function() {
	      // If body scrolling is disabled, then use the cached viewport top value, otherwise get it
	      // fresh from the $window.
	      if ($mdUtil.disableScrollAround._count && $mdUtil.disableScrollAround._viewPortTop) {
	        return $mdUtil.disableScrollAround._viewPortTop;
	      } else {
	        return $window.scrollY || $window.pageYOffset || 0;
	      }
	    },
	
	    /**
	     * Finds the proper focus target by searching the DOM.
	     *
	     * @param containerEl
	     * @param attributeVal
	     * @returns {*}
	     */
	    findFocusTarget: function(containerEl, attributeVal) {
	      var AUTO_FOCUS = this.prefixer('md-autofocus', true);
	      var elToFocus;
	
	      elToFocus = scanForFocusable(containerEl, attributeVal || AUTO_FOCUS);
	
	      if (!elToFocus && attributeVal != AUTO_FOCUS) {
	        // Scan for deprecated attribute
	        elToFocus = scanForFocusable(containerEl, this.prefixer('md-auto-focus', true));
	
	        if (!elToFocus) {
	          // Scan for fallback to 'universal' API
	          elToFocus = scanForFocusable(containerEl, AUTO_FOCUS);
	        }
	      }
	
	      return elToFocus;
	
	      /**
	       * Can target and nested children for specified Selector (attribute)
	       * whose value may be an expression that evaluates to True/False.
	       */
	      function scanForFocusable(target, selector) {
	        var elFound, items = target[0].querySelectorAll(selector);
	
	        // Find the last child element with the focus attribute
	        if (items && items.length){
	          items.length && angular.forEach(items, function(it) {
	            it = angular.element(it);
	
	            // Check the element for the md-autofocus class to ensure any associated expression
	            // evaluated to true.
	            var isFocusable = it.hasClass('md-autofocus');
	            if (isFocusable) elFound = it;
	          });
	        }
	        return elFound;
	      }
	    },
	
	    /**
	     * Disables scroll around the passed parent element.
	     * @param {Element|angular.JQLite=} element Origin Element (not used)
	     * @param {Element|angular.JQLite=} parent Element to disable scrolling within.
	     *   Defaults to body if none supplied.
	     * @param {Object=} options Object of options to modify functionality
	     *   - disableScrollMask Boolean of whether or not to create a scroll mask element or
	     *     use the passed parent element.
	     */
	    disableScrollAround: function(element, parent, options) {
	      options = options || {};
	
	      $mdUtil.disableScrollAround._count = Math.max(0, $mdUtil.disableScrollAround._count || 0);
	      $mdUtil.disableScrollAround._count++;
	
	      if ($mdUtil.disableScrollAround._restoreScroll) {
	        return $mdUtil.disableScrollAround._restoreScroll;
	      }
	
	      var body = $document[0].body;
	      var restoreBody = disableBodyScroll();
	      var restoreElement = disableElementScroll(parent, options);
	
	      return $mdUtil.disableScrollAround._restoreScroll = function() {
	        if (--$mdUtil.disableScrollAround._count <= 0) {
	          delete $mdUtil.disableScrollAround._viewPortTop;
	          restoreBody();
	          restoreElement();
	          delete $mdUtil.disableScrollAround._restoreScroll;
	        }
	      };
	
	      /**
	       * Creates a virtual scrolling mask to prevent touchmove, keyboard, scrollbar clicking,
	       * and wheel events.
	       * @param {!Element|!angular.JQLite} elementToDisable
	       * @param {Object=} scrollMaskOptions Object of options to modify functionality
	       *   - disableScrollMask Boolean of whether or not to create a scroll mask element or
	       *     use the passed parent element.
	       * @returns {Function}
	       */
	      function disableElementScroll(elementToDisable, scrollMaskOptions) {
	        var scrollMask;
	        var wrappedElementToDisable = angular.element(elementToDisable || body);
	
	        if (scrollMaskOptions.disableScrollMask) {
	          scrollMask = wrappedElementToDisable;
	        } else {
	          scrollMask = angular.element(
	            '<div class="md-scroll-mask">' +
	            '  <div class="md-scroll-mask-bar"></div>' +
	            '</div>');
	          wrappedElementToDisable.append(scrollMask);
	        }
	
	        /**
	         * @param {Event} $event
	         */
	        function preventDefault($event) {
	          $event.preventDefault();
	        }
	
	        scrollMask.on('wheel touchmove', preventDefault);
	
	        return function restoreElementScroll() {
	          scrollMask.off('wheel touchmove', preventDefault);
	
	          if (!scrollMaskOptions.disableScrollMask && scrollMask[0].parentNode) {
	            scrollMask[0].parentNode.removeChild(scrollMask[0]);
	          }
	        };
	      }
	
	      // Converts the body to a position fixed block and translate it to the proper scroll position
	      function disableBodyScroll() {
	        var documentElement = $document[0].documentElement;
	
	        var prevDocumentStyle = documentElement.style.cssText || '';
	        var prevBodyStyle = body.style.cssText || '';
	
	        var viewportTop = $mdUtil.getViewportTop();
	        $mdUtil.disableScrollAround._viewPortTop = viewportTop;
	        var clientWidth = body.clientWidth;
	        var hasVerticalScrollbar = body.scrollHeight > body.clientHeight + 1;
	
	        // Scroll may be set on <html> element (for example by overflow-y: scroll)
	        // but Chrome is reporting the scrollTop position always on <body>.
	        // scrollElement will allow to restore the scrollTop position to proper target.
	        var scrollElement = documentElement.scrollTop > 0 ? documentElement : body;
	
	        if (hasVerticalScrollbar) {
	          angular.element(body).css({
	            position: 'fixed',
	            width: '100%',
	            top: -viewportTop + 'px'
	          });
	        }
	
	        if (body.clientWidth < clientWidth) {
	          body.style.overflow = 'hidden';
	        }
	
	        return function restoreScroll() {
	          // Reset the inline style CSS to the previous.
	          body.style.cssText = prevBodyStyle;
	          documentElement.style.cssText = prevDocumentStyle;
	
	          // The scroll position while being fixed
	          scrollElement.scrollTop = viewportTop;
	        };
	      }
	
	    },
	
	    enableScrolling: function() {
	      var restoreFn = this.disableScrollAround._restoreScroll;
	      restoreFn && restoreFn();
	    },
	
	    floatingScrollbars: function() {
	      if (this.floatingScrollbars.cached === undefined) {
	        var tempNode = angular.element('<div><div></div></div>').css({
	          width: '100%',
	          'z-index': -1,
	          position: 'absolute',
	          height: '35px',
	          'overflow-y': 'scroll'
	        });
	        tempNode.children().css('height', '60px');
	
	        $document[0].body.appendChild(tempNode[0]);
	        this.floatingScrollbars.cached = (tempNode[0].offsetWidth == tempNode[0].childNodes[0].offsetWidth);
	        tempNode.remove();
	      }
	      return this.floatingScrollbars.cached;
	    },
	
	    /**
	     * Mobile safari only allows you to set focus in click event listeners.
	     * @param {Element|angular.JQLite} element to focus
	     */
	    forceFocus: function(element) {
	      var node = element[0] || element;
	
	      document.addEventListener('click', function focusOnClick(ev) {
	        if (ev.target === node && ev.$focus) {
	          node.focus();
	          ev.stopImmediatePropagation();
	          ev.preventDefault();
	          node.removeEventListener('click', focusOnClick);
	        }
	      }, true);
	
	      var newEvent = document.createEvent('MouseEvents');
	      newEvent.initMouseEvent('click', false, true, window, {}, 0, 0, 0, 0,
	        false, false, false, false, 0, null);
	      newEvent.$material = true;
	      newEvent.$focus = true;
	      node.dispatchEvent(newEvent);
	    },
	
	    /**
	     * facade to build md-backdrop element with desired styles
	     * NOTE: Use $compile to trigger backdrop postLink function
	     */
	    createBackdrop: function(scope, addClass) {
	      return $compile($mdUtil.supplant('<md-backdrop class="{0}">', [addClass]))(scope);
	    },
	
	    /**
	     * supplant() method from Crockford's `Remedial Javascript`
	     * Equivalent to use of $interpolate; without dependency on
	     * interpolation symbols and scope. Note: the '{<token>}' can
	     * be property names, property chains, or array indices.
	     */
	    supplant: function(template, values, pattern) {
	      pattern = pattern || /\{([^{}]*)\}/g;
	      return template.replace(pattern, function(a, b) {
	        var p = b.split('.'),
	          r = values;
	        try {
	          for (var s in p) {
	            if (p.hasOwnProperty(s)) {
	              r = r[p[s]];
	            }
	          }
	        } catch (e) {
	          r = a;
	        }
	        return (typeof r === 'string' || typeof r === 'number') ? r : a;
	      });
	    },
	
	    fakeNgModel: function() {
	      return {
	        $fake: true,
	        $setTouched: angular.noop,
	        $setViewValue: function(value) {
	          this.$viewValue = value;
	          this.$render(value);
	          this.$viewChangeListeners.forEach(function(cb) {
	            cb();
	          });
	        },
	        $isEmpty: function(value) {
	          return ('' + value).length === 0;
	        },
	        $parsers: [],
	        $formatters: [],
	        $viewChangeListeners: [],
	        $render: angular.noop
	      };
	    },
	
	    /**
	     * @param {Function} func original function to be debounced
	     * @param {number} wait number of milliseconds to delay (since last debounce reset).
	     *  Default value 10 msecs.
	     * @param {Object} scope in which to apply the function after debouncing ends
	     * @param {boolean} invokeApply should the $timeout trigger $digest() dirty checking
	     * @return {Function} A function, that, as long as it continues to be invoked, will not be
	     *  triggered. The function will be called after it stops being called for N milliseconds.
	     */
	    debounce: function(func, wait, scope, invokeApply) {
	      var timer;
	
	      return function debounced() {
	        var context = scope,
	            args = Array.prototype.slice.call(arguments);
	
	        $timeout.cancel(timer);
	        timer = $timeout(function() {
	
	          timer = undefined;
	          func.apply(context, args);
	
	        }, wait || 10, invokeApply);
	      };
	    },
	
	    /**
	     * The function will not be called unless it has been more than `delay` milliseconds since the
	     * last call.
	     * @param {Function} func original function to throttle
	     * @param {number} delay number of milliseconds to delay
	     * @return {Function} a function that can only be triggered every `delay` milliseconds.
	     */
	    throttle: function throttle(func, delay) {
	      var recent;
	      return function throttled() {
	        var context = this;
	        var args = arguments;
	        var now = $mdUtil.now();
	
	        if (!recent || (now - recent > delay)) {
	          func.apply(context, args);
	          recent = now;
	        }
	      };
	    },
	
	    /**
	     * Measures the number of milliseconds taken to run the provided callback
	     * function. Uses a high-precision timer if available.
	     */
	    time: function time(cb) {
	      var start = $mdUtil.now();
	      cb();
	      return $mdUtil.now() - start;
	    },
	
	    /**
	     * Create an implicit getter that caches its `getter()`
	     * lookup value
	     */
	    valueOnUse : function (scope, key, getter) {
	      var value = null, args = Array.prototype.slice.call(arguments);
	      var params = (args.length > 3) ? args.slice(3) : [];
	
	      Object.defineProperty(scope, key, {
	        get: function () {
	          if (value === null) value = getter.apply(scope, params);
	          return value;
	        }
	      });
	    },
	
	    /**
	     * Get a unique ID.
	     *
	     * @returns {string} an unique numeric string
	     */
	    nextUid: function() {
	      return '' + nextUniqueId++;
	    },
	
	    /**
	     * Stop watchers and events from firing on a scope without destroying it,
	     * by disconnecting it from its parent and its siblings' linked lists.
	     * @param {Object} scope to disconnect
	     */
	    disconnectScope: function disconnectScope(scope) {
	      if (!scope) return;
	
	      // we can't destroy the root scope or a scope that has been already destroyed
	      if (scope.$root === scope) return;
	      if (scope.$$destroyed) return;
	
	      var parent = scope.$parent;
	      scope.$$disconnected = true;
	
	      // See Scope.$destroy
	      if (parent.$$childHead === scope) parent.$$childHead = scope.$$nextSibling;
	      if (parent.$$childTail === scope) parent.$$childTail = scope.$$prevSibling;
	      if (scope.$$prevSibling) scope.$$prevSibling.$$nextSibling = scope.$$nextSibling;
	      if (scope.$$nextSibling) scope.$$nextSibling.$$prevSibling = scope.$$prevSibling;
	
	      scope.$$nextSibling = scope.$$prevSibling = null;
	
	    },
	
	    /**
	     * Undo the effects of disconnectScope().
	     * @param {Object} scope to reconnect
	     */
	    reconnectScope: function reconnectScope(scope) {
	      if (!scope) return;
	
	      // we can't disconnect the root node or scope already disconnected
	      if (scope.$root === scope) return;
	      if (!scope.$$disconnected) return;
	
	      var child = scope;
	
	      var parent = child.$parent;
	      child.$$disconnected = false;
	      // See Scope.$new for this logic...
	      child.$$prevSibling = parent.$$childTail;
	      if (parent.$$childHead) {
	        parent.$$childTail.$$nextSibling = child;
	        parent.$$childTail = child;
	      } else {
	        parent.$$childHead = parent.$$childTail = child;
	      }
	    },
	
	    /**
	     * Get an element's siblings matching a given tag name.
	     *
	     * @param {JQLite|angular.element|HTMLElement} element Element to start walking the DOM from
	     * @param {string} tagName HTML tag name to match against
	     * @returns {Object[]} JQLite
	     */
	    getSiblings: function getSiblings(element, tagName) {
	      var upperCasedTagName = tagName.toUpperCase();
	      if (element instanceof angular.element) {
	        element = element[0];
	      }
	      var siblings = Array.prototype.filter.call(element.parentNode.children, function(node) {
	        return element !== node && node.tagName.toUpperCase() === upperCasedTagName;
	      });
	      return siblings.map(function (sibling) {
	        return angular.element(sibling);
	      });
	    },
	
	    /*
	     * getClosest replicates jQuery.closest() to walk up the DOM tree until it finds a matching nodeName
	     *
	     * @param {Node} el Element to start walking the DOM from
	     * @param {string|function} validateWith If a string is passed, it will be evaluated against
	     * each of the parent nodes' tag name. If a function is passed, the loop will call it with each
	     * of the parents and will use the return value to determine whether the node is a match.
	     * @param {boolean=} onlyParent Only start checking from the parent element, not `el`.
	     * @returns {Node|null} closest matching parent Node or null if not found
	     */
	    getClosest: function getClosest(el, validateWith, onlyParent) {
	      if (angular.isString(validateWith)) {
	        var tagName = validateWith.toUpperCase();
	        validateWith = function(el) {
	          return el.nodeName.toUpperCase() === tagName;
	        };
	      }
	
	      if (el instanceof angular.element) el = el[0];
	      if (onlyParent) el = el.parentNode;
	      if (!el) return null;
	
	      do {
	        if (validateWith(el)) {
	          return el;
	        }
	      } while (el = el.parentNode);
	
	      return null;
	    },
	
	    /**
	     * Build polyfill for the Node.contains feature (if needed)
	     * @param {Node} node
	     * @param {Node} child
	     * @returns {Node}
	     */
	    elementContains: function(node, child) {
	      var hasContains = (window.Node && window.Node.prototype && Node.prototype.contains);
	      var findFn = hasContains ? angular.bind(node, node.contains) : angular.bind(node, function(arg) {
	        // compares the positions of two nodes and returns a bitmask
	        return (node === child) || !!(this.compareDocumentPosition(arg) & 16);
	      });
	
	      return findFn(child);
	    },
	
	    /**
	     * Functional equivalent for $element.filter(‘md-bottom-sheet’)
	     * useful with interimElements where the element and its container are important...
	     *
	     * @param {angular.JQLite} element to scan
	     * @param {string} nodeName of node to find (e.g. 'md-dialog')
	     * @param {boolean=} scanDeep optional flag to allow deep scans; defaults to 'false'.
	     * @param {boolean=} warnNotFound optional flag to enable log warnings; defaults to false
	     */
	    extractElementByName: function(element, nodeName, scanDeep, warnNotFound) {
	      var found = scanTree(element);
	      if (!found && !!warnNotFound) {
	        $log.warn($mdUtil.supplant("Unable to find node '{0}' in element '{1}'.",[nodeName, element[0].outerHTML]));
	      }
	
	      return angular.element(found || element);
	
	      /**
	       * Breadth-First tree scan for element with matching `nodeName`
	       */
	      function scanTree(element) {
	        return scanLevel(element) || (scanDeep ? scanChildren(element) : null);
	      }
	
	      /**
	       * Case-insensitive scan of current elements only (do not descend).
	       */
	      function scanLevel(element) {
	        if (element) {
	          for (var i = 0, len = element.length; i < len; i++) {
	            if (element[i].nodeName.toLowerCase() === nodeName) {
	              return element[i];
	            }
	          }
	        }
	        return null;
	      }
	
	      /**
	       * Scan children of specified node
	       */
	      function scanChildren(element) {
	        var found;
	        if (element) {
	          for (var i = 0, len = element.length; i < len; i++) {
	            var target = element[i];
	            if (!found) {
	              for (var j = 0, numChild = target.childNodes.length; j < numChild; j++) {
	                found = found || scanTree([target.childNodes[j]]);
	              }
	            }
	          }
	        }
	        return found;
	      }
	
	    },
	
	    /**
	     * Give optional properties with no value a boolean true if attr provided or false otherwise
	     */
	    initOptionalProperties: function(scope, attr, defaults) {
	      defaults = defaults || {};
	      angular.forEach(scope.$$isolateBindings, function(binding, key) {
	        if (binding.optional && angular.isUndefined(scope[key])) {
	          var attrIsDefined = angular.isDefined(attr[binding.attrName]);
	          scope[key] = angular.isDefined(defaults[key]) ? defaults[key] : attrIsDefined;
	        }
	      });
	    },
	
	    /**
	     * Alternative to $timeout calls with 0 delay.
	     * nextTick() coalesces all calls within a single frame
	     * to minimize $digest thrashing
	     *
	     * @param {Function} callback function to be called after the tick
	     * @param {boolean=} digest true to call $rootScope.$digest() after callback
	     * @param {Object=} scope associated with callback. If the scope is destroyed, the callback will
	     *  be skipped.
	     * @returns {*}
	     */
	    nextTick: function(callback, digest, scope) {
	      // grab function reference for storing state details
	      var nextTick = $mdUtil.nextTick;
	      var timeout = nextTick.timeout;
	      var queue = nextTick.queue || [];
	
	      // add callback to the queue
	      queue.push({scope: scope, callback: callback});
	
	      // set default value for digest
	      if (digest == null) digest = true;
	
	      // store updated digest/queue values
	      nextTick.digest = nextTick.digest || digest;
	      nextTick.queue = queue;
	
	      // either return existing timeout or create a new one
	      return timeout || (nextTick.timeout = $timeout(processQueue, 0, false));
	
	      /**
	       * Grab a copy of the current queue
	       * Clear the queue for future use
	       * Process the existing queue
	       * Trigger digest if necessary
	       */
	      function processQueue() {
	        var queue = nextTick.queue;
	        var digest = nextTick.digest;
	
	        nextTick.queue = [];
	        nextTick.timeout = null;
	        nextTick.digest = false;
	
	        queue.forEach(function(queueItem) {
	          var skip = queueItem.scope && queueItem.scope.$$destroyed;
	          if (!skip) {
	            queueItem.callback();
	          }
	        });
	
	        if (digest) $rootScope.$digest();
	      }
	    },
	
	    /**
	     * Processes a template and replaces the start/end symbols if the application has
	     * overridden them.
	     *
	     * @param template The template to process whose start/end tags may be replaced.
	     * @returns {*}
	     */
	    processTemplate: function(template) {
	      if (usesStandardSymbols) {
	        return template;
	      } else {
	        if (!template || !angular.isString(template)) return template;
	        return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	      }
	    },
	
	    /**
	     * Scan up dom hierarchy for enabled parent;
	     */
	    getParentWithPointerEvents: function (element) {
	      var parent = element.parent();
	
	      // jqLite might return a non-null, but still empty, parent; so check for parent and length
	      while (hasComputedStyle(parent, 'pointer-events', 'none')) {
	        parent = parent.parent();
	      }
	
	      return parent;
	    },
	
	    getNearestContentElement: function (element) {
	      var current = element.parent()[0];
	      // Look for the nearest parent md-content, stopping at the rootElement.
	      while (current && current !== $rootElement[0] && current !== document.body && current.nodeName.toUpperCase() !== 'MD-CONTENT') {
	        current = current.parentNode;
	      }
	      return current;
	    },
	
	    /**
	     * Checks if the current browser is natively supporting the `sticky` position.
	     * @returns {string} supported sticky property name
	     */
	    checkStickySupport: function() {
	      var stickyProp;
	      var testEl = angular.element('<div>');
	      $document[0].body.appendChild(testEl[0]);
	
	      var stickyProps = ['sticky', '-webkit-sticky'];
	      for (var i = 0; i < stickyProps.length; ++i) {
	        testEl.css({
	          position: stickyProps[i],
	          top: 0,
	          'z-index': 2
	        });
	
	        if (testEl.css('position') == stickyProps[i]) {
	          stickyProp = stickyProps[i];
	          break;
	        }
	      }
	
	      testEl.remove();
	
	      return stickyProp;
	    },
	
	    /**
	     * Parses an attribute value, mostly a string.
	     * By default checks for negated values and returns `false´ if present.
	     * Negated values are: (native falsy) and negative strings like:
	     * `false` or `0`.
	     * @param value Attribute value which should be parsed.
	     * @param negatedCheck When set to false, won't check for negated values.
	     * @returns {boolean}
	     */
	    parseAttributeBoolean: function(value, negatedCheck) {
	      return value === '' || !!value && (negatedCheck === false || value !== 'false' && value !== '0');
	    },
	
	    hasComputedStyle: hasComputedStyle,
	
	    /**
	     * Returns true if the parent form of the element has been submitted.
	     * @param element An AngularJS or HTML5 element.
	     * @returns {boolean}
	     */
	    isParentFormSubmitted: function(element) {
	      var parent = $mdUtil.getClosest(element, 'form');
	      var form = parent ? angular.element(parent).controller('form') : null;
	
	      return form ? form.$submitted : false;
	    },
	
	    /**
	     * Animate the requested element's scrollTop to the requested scrollPosition with basic easing.
	     * @param {!Element} element The element to scroll.
	     * @param {number} scrollEnd The new/final scroll position.
	     * @param {number=} duration Duration of the scroll. Default is 1000ms.
	     */
	    animateScrollTo: function(element, scrollEnd, duration) {
	      var scrollStart = element.scrollTop;
	      var scrollChange = scrollEnd - scrollStart;
	      var scrollingDown = scrollStart < scrollEnd;
	      var startTime = $mdUtil.now();
	
	      $$rAF(scrollChunk);
	
	      function scrollChunk() {
	        var newPosition = calculateNewPosition();
	
	        element.scrollTop = newPosition;
	
	        if (scrollingDown ? newPosition < scrollEnd : newPosition > scrollEnd) {
	          $$rAF(scrollChunk);
	        }
	      }
	
	      function calculateNewPosition() {
	        var easeDuration = duration || 1000;
	        var currentTime = $mdUtil.now() - startTime;
	
	        return ease(currentTime, scrollStart, scrollChange, easeDuration);
	      }
	
	      function ease(currentTime, start, change, duration) {
	        // If the duration has passed (which can occur if our app loses focus due to $$rAF), jump
	        // straight to the proper position
	        if (currentTime > duration) {
	          return start + change;
	        }
	
	        var ts = (currentTime /= duration) * currentTime;
	        var tc = ts * currentTime;
	
	        return start + change * (-2 * tc + 3 * ts);
	      }
	    },
	
	    /**
	     * Provides an easy mechanism for removing duplicates from an array.
	     *
	     *    var myArray = [1, 2, 2, 3, 3, 3, 4, 4, 4, 4];
	     *
	     *    $mdUtil.uniq(myArray) => [1, 2, 3, 4]
	     *
	     * @param {Array} array The array whose unique values should be returned.
	     * @returns {Array|void} A copy of the array containing only unique values.
	     */
	    uniq: function(array) {
	      if (!array) { return; }
	
	      return array.filter(function(value, index, self) {
	        return self.indexOf(value) === index;
	      });
	    },
	
	    /**
	     * Gets the inner HTML content of the given HTMLElement.
	     * Only intended for use with SVG or Symbol elements in IE11.
	     * @param {Element} element
	     * @returns {string} the inner HTML of the element passed in
	     */
	    getInnerHTML: function(element) {
	      // For SVG or Symbol elements, innerHTML returns `undefined` in IE.
	      // Reference: https://stackoverflow.com/q/28129956/633107
	      // The XMLSerializer API is supported on IE11 and is the recommended workaround.
	      var serializer = new XMLSerializer();
	
	      return Array.prototype.map.call(element.childNodes, function (child) {
	        return serializer.serializeToString(child);
	      }).join('');
	    },
	
	    /**
	     * Gets the outer HTML content of the given HTMLElement.
	     * Only intended for use with SVG or Symbol elements in IE11.
	     * @param {Element} element
	     * @returns {string} the outer HTML of the element passed in
	     */
	    getOuterHTML: function(element) {
	      // For SVG or Symbol elements, outerHTML returns `undefined` in IE.
	      // Reference: https://stackoverflow.com/q/29888050/633107
	      // The XMLSerializer API is supported on IE11 and is the recommended workaround.
	      var serializer = new XMLSerializer();
	      return serializer.serializeToString(element);
	    },
	
	    /**
	     * Support: IE 9-11 only
	     * documentMode is an IE-only property
	     * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	     */
	    msie: window.document.documentMode,
	
	    getTouchAction: function() {
	      var testEl = document.createElement('div');
	      var vendorPrefixes = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
	
	      for (var i = 0; i < vendorPrefixes.length; i++) {
	        var prefix = vendorPrefixes[i];
	        var property = prefix ? prefix + 'TouchAction' : 'touchAction';
	        if (angular.isDefined(testEl.style[property])) {
	          return property;
	        }
	      }
	    },
	
	    /**
	     * @param {Event} event the event to calculate the bubble path for
	     * @return {EventTarget[]} the set of nodes that this event could bubble up to
	     */
	    getEventPath: function(event) {
	      var path = [];
	      var currentTarget = event.target;
	      while (currentTarget) {
	        path.push(currentTarget);
	        currentTarget = currentTarget.parentElement;
	      }
	      if (path.indexOf(window) === -1 && path.indexOf(document) === -1)
	        path.push(document);
	      if (path.indexOf(window) === -1)
	        path.push(window);
	      return path;
	    },
	
	    /**
	     * Gets the string the user has entered and removes Regex identifiers
	     * @param {string} term
	     * @returns {string} sanitized string
	     */
	    sanitize: function(term) {
	      if (!term) return term;
	      return term.replace(/[\\^$*+?.()|{}[]/g, '\\$&');
	    }
	  };
	
	  // Instantiate other namespace utility methods
	
	  $mdUtil.dom.animator = $$mdAnimate($mdUtil);
	
	  return $mdUtil;
	
	  function getNode(el) {
	    return el[0] || el;
	  }
	}
	
	/**
	 * Since removing jQuery from the demos, some code that uses `element.focus()` is broken.
	 * We need to add `element.focus()`, because it's testable unlike `element[0].focus`.
	 */
	angular.element.prototype.focus = angular.element.prototype.focus || function() {
	  if (this.length) {
	    this[0].focus();
	  }
	  return this;
	};
	
	angular.element.prototype.blur = angular.element.prototype.blur || function() {
	  if (this.length) {
	    this[0].blur();
	  }
	  return this;
	};
	
	})();
	(function(){
	"use strict";
	
	// Polyfill angular < 1.4 (provide $animateCss)
	angular
	  .module('material.core')
	  .factory('$$mdAnimate', ["$q", "$timeout", "$mdConstant", "$animateCss", function($q, $timeout, $mdConstant, $animateCss){
	
	     // Since $$mdAnimate is injected into $mdUtil... use a wrapper function
	     // to subsequently inject $mdUtil as an argument to the AnimateDomUtils
	
	     return function($mdUtil) {
	       return AnimateDomUtils($mdUtil, $q, $timeout, $mdConstant, $animateCss);
	     };
	   }]);
	
	/**
	 * Factory function that requires special injections
	 */
	function AnimateDomUtils($mdUtil, $q, $timeout, $mdConstant, $animateCss) {
	  var self;
	  return self = {
	    /**
	     *
	     */
	    translate3d : function(target, from, to, options) {
	      return $animateCss(target, {
	        from: from,
	        to: to,
	        addClass: options.transitionInClass,
	        removeClass: options.transitionOutClass,
	        duration: options.duration
	      })
	      .start()
	      .then(function() {
	          // Resolve with reverser function...
	          return reverseTranslate;
	      });
	
	      /**
	       * Specific reversal of the request translate animation above...
	       */
	      function reverseTranslate (newFrom) {
	        return $animateCss(target, {
	           to: newFrom || from,
	           addClass: options.transitionOutClass,
	           removeClass: options.transitionInClass,
	           duration: options.duration
	        }).start();
	
	      }
	    },
	
	    /**
	     * Listen for transitionEnd event (with optional timeout)
	     * Announce completion or failure via promise handlers
	     */
	    waitTransitionEnd: function (element, opts) {
	      var TIMEOUT = 3000; // fallback is 3 secs
	
	      return $q(function(resolve, reject){
	        opts = opts || { };
	
	        // If there is no transition is found, resolve immediately
	        //
	        // NOTE: using $mdUtil.nextTick() causes delays/issues
	        if (noTransitionFound(opts.cachedTransitionStyles)) {
	          TIMEOUT = 0;
	        }
	
	        var timer = $timeout(finished, opts.timeout || TIMEOUT);
	        element.on($mdConstant.CSS.TRANSITIONEND, finished);
	
	        /**
	         * Upon timeout or transitionEnd, reject or resolve (respectively) this promise.
	         * NOTE: Make sure this transitionEnd didn't bubble up from a child
	         */
	        function finished(ev) {
	          if (ev && ev.target !== element[0]) return;
	
	          if (ev) $timeout.cancel(timer);
	          element.off($mdConstant.CSS.TRANSITIONEND, finished);
	
	          // Never reject since ngAnimate may cause timeouts due missed transitionEnd events
	          resolve();
	
	        }
	
	        /**
	         * Checks whether or not there is a transition.
	         *
	         * @param styles The cached styles to use for the calculation. If null, getComputedStyle()
	         * will be used.
	         *
	         * @returns {boolean} True if there is no transition/duration; false otherwise.
	         */
	        function noTransitionFound(styles) {
	          styles = styles || window.getComputedStyle(element[0]);
	
	          return styles.transitionDuration == '0s' || (!styles.transition && !styles.transitionProperty);
	        }
	
	      });
	    },
	
	    calculateTransformValues: function (element, originator) {
	      var origin = originator.element;
	      var bounds = originator.bounds;
	
	      if (origin || bounds) {
	        var originBnds = origin ? self.clientRect(origin) || currentBounds() : self.copyRect(bounds);
	        var dialogRect = self.copyRect(element[0].getBoundingClientRect());
	        var dialogCenterPt = self.centerPointFor(dialogRect);
	        var originCenterPt = self.centerPointFor(originBnds);
	
	        return {
	          centerX: originCenterPt.x - dialogCenterPt.x,
	          centerY: originCenterPt.y - dialogCenterPt.y,
	          scaleX: Math.round(100 * Math.min(0.5, originBnds.width / dialogRect.width)) / 100,
	          scaleY: Math.round(100 * Math.min(0.5, originBnds.height / dialogRect.height)) / 100
	        };
	      }
	      return {centerX: 0, centerY: 0, scaleX: 0.5, scaleY: 0.5};
	
	      /**
	       * This is a fallback if the origin information is no longer valid, then the
	       * origin bounds simply becomes the current bounds for the dialogContainer's parent
	       */
	      function currentBounds() {
	        var cntr = element ? element.parent() : null;
	        var parent = cntr ? cntr.parent() : null;
	
	        return parent ? self.clientRect(parent) : null;
	      }
	    },
	
	    /**
	     * Calculate the zoom transform from dialog to origin.
	     *
	     * We use this to set the dialog position immediately;
	     * then the md-transition-in actually translates back to
	     * `translate3d(0,0,0) scale(1.0)`...
	     *
	     * NOTE: all values are rounded to the nearest integer
	     */
	    calculateZoomToOrigin: function (element, originator) {
	      var zoomTemplate = "translate3d( {centerX}px, {centerY}px, 0 ) scale( {scaleX}, {scaleY} )";
	      var buildZoom = angular.bind(null, $mdUtil.supplant, zoomTemplate);
	
	      return buildZoom(self.calculateTransformValues(element, originator));
	    },
	
	    /**
	     * Calculate the slide transform from panel to origin.
	     * NOTE: all values are rounded to the nearest integer
	     */
	    calculateSlideToOrigin: function (element, originator) {
	      var slideTemplate = "translate3d( {centerX}px, {centerY}px, 0 )";
	      var buildSlide = angular.bind(null, $mdUtil.supplant, slideTemplate);
	
	      return buildSlide(self.calculateTransformValues(element, originator));
	    },
	
	    /**
	     * Enhance raw values to represent valid css stylings...
	     */
	    toCss : function(raw) {
	      var css = { };
	      var lookups = 'left top right bottom width height x y min-width min-height max-width max-height';
	
	      angular.forEach(raw, function(value,key) {
	        if (angular.isUndefined(value)) return;
	
	        if (lookups.indexOf(key) >= 0) {
	          css[key] = value + 'px';
	        } else {
	          switch (key) {
	            case 'transition':
	              convertToVendor(key, $mdConstant.CSS.TRANSITION, value);
	              break;
	            case 'transform':
	              convertToVendor(key, $mdConstant.CSS.TRANSFORM, value);
	              break;
	            case 'transformOrigin':
	              convertToVendor(key, $mdConstant.CSS.TRANSFORM_ORIGIN, value);
	              break;
	            case 'font-size':
	              css['font-size'] = value; // font sizes aren't always in px
	              break;
	          }
	        }
	      });
	
	      return css;
	
	      function convertToVendor(key, vendor, value) {
	        angular.forEach(vendor.split(' '), function (key) {
	          css[key] = value;
	        });
	      }
	    },
	
	    /**
	     * Convert the translate CSS value to key/value pair(s).
	     * @param {string} transform
	     * @param {boolean=} addTransition
	     * @param {string=} transition
	     * @return {Object} object containing CSS translate key/value pair(s)
	     */
	    toTransformCss: function (transform, addTransition, transition) {
	      var css = {};
	      angular.forEach($mdConstant.CSS.TRANSFORM.split(' '), function (key) {
	        css[key] = transform;
	      });
	
	      if (addTransition) {
	        transition = transition || "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1) !important";
	        css.transition = transition;
	      }
	
	      return css;
	    },
	
	    /**
	     *  Clone the Rect and calculate the height/width if needed
	     */
	    copyRect: function (source, destination) {
	      if (!source) return null;
	
	      destination = destination || {};
	
	      angular.forEach('left top right bottom width height'.split(' '), function (key) {
	        destination[key] = Math.round(source[key]);
	      });
	
	      destination.width = destination.width || (destination.right - destination.left);
	      destination.height = destination.height || (destination.bottom - destination.top);
	
	      return destination;
	    },
	
	    /**
	     * Calculate ClientRect of element; return null if hidden or zero size
	     */
	    clientRect: function (element) {
	      var bounds = angular.element(element)[0].getBoundingClientRect();
	      var isPositiveSizeClientRect = function (rect) {
	        return rect && (rect.width > 0) && (rect.height > 0);
	      };
	
	      // If the event origin element has zero size, it has probably been hidden.
	      return isPositiveSizeClientRect(bounds) ? self.copyRect(bounds) : null;
	    },
	
	    /**
	     *  Calculate 'rounded' center point of Rect
	     */
	    centerPointFor: function (targetRect) {
	      return targetRect ? {
	        x: Math.round(targetRect.left + (targetRect.width / 2)),
	        y: Math.round(targetRect.top + (targetRect.height / 2))
	      } : { x : 0, y : 0 };
	    }
	
	  };
	}
	
	
	})();
	(function(){
	"use strict";
	
	if (angular.version.minor >= 4) {
	  angular.module('material.core.animate', []);
	} else {
	(function() {
	  "use strict";
	
	  var forEach = angular.forEach;
	
	  var WEBKIT = angular.isDefined(document.documentElement.style.WebkitAppearance);
	  var TRANSITION_PROP = WEBKIT ? 'WebkitTransition' : 'transition';
	  var ANIMATION_PROP = WEBKIT ? 'WebkitAnimation' : 'animation';
	  var PREFIX = WEBKIT ? '-webkit-' : '';
	
	  var TRANSITION_EVENTS = (WEBKIT ? 'webkitTransitionEnd ' : '') + 'transitionend';
	  var ANIMATION_EVENTS = (WEBKIT ? 'webkitAnimationEnd ' : '') + 'animationend';
	
	  var $$ForceReflowFactory = ['$document', function($document) {
	    return function() {
	      return $document[0].body.clientWidth + 1;
	    };
	  }];
	
	  var $$rAFMutexFactory = ['$$rAF', function($$rAF) {
	    return function() {
	      var passed = false;
	      $$rAF(function() {
	        passed = true;
	      });
	      return function(fn) {
	        passed ? fn() : $$rAF(fn);
	      };
	    };
	  }];
	
	  var $$AnimateRunnerFactory = ['$q', '$$rAFMutex', function($q, $$rAFMutex) {
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      this._doneCallbacks = [];
	      this._runInAnimationFrame = $$rAFMutex();
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: angular.noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              status === false ? reject() : resolve();
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._runInAnimationFrame(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    // Polyfill AnimateRunner.all which is used by input animations
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	
	  angular
	    .module('material.core.animate', [])
	    .factory('$$forceReflow', $$ForceReflowFactory)
	    .factory('$$AnimateRunner', $$AnimateRunnerFactory)
	    .factory('$$rAFMutex', $$rAFMutexFactory)
	    .factory('$animateCss', ['$window', '$$rAF', '$$AnimateRunner', '$$forceReflow', '$$jqLite', '$timeout', '$animate',
	                     function($window,   $$rAF,   $$AnimateRunner,   $$forceReflow,   $$jqLite,   $timeout, $animate) {
	
	      function init(element, options) {
	
	        var temporaryStyles = [];
	        var node = getDomNode(element);
	        var areAnimationsAllowed = node && $animate.enabled();
	
	        var hasCompleteStyles = false;
	        var hasCompleteClasses = false;
	
	        if (areAnimationsAllowed) {
	          if (options.transitionStyle) {
	            temporaryStyles.push([PREFIX + 'transition', options.transitionStyle]);
	          }
	
	          if (options.keyframeStyle) {
	            temporaryStyles.push([PREFIX + 'animation', options.keyframeStyle]);
	          }
	
	          if (options.delay) {
	            temporaryStyles.push([PREFIX + 'transition-delay', options.delay + 's']);
	          }
	
	          if (options.duration) {
	            temporaryStyles.push([PREFIX + 'transition-duration', options.duration + 's']);
	          }
	
	          hasCompleteStyles = options.keyframeStyle ||
	              (options.to && (options.duration > 0 || options.transitionStyle));
	          hasCompleteClasses = !!options.addClass || !!options.removeClass;
	
	          blockTransition(element, true);
	        }
	
	        var hasCompleteAnimation = areAnimationsAllowed && (hasCompleteStyles || hasCompleteClasses);
	
	        applyAnimationFromStyles(element, options);
	
	        var animationClosed = false;
	        var events, eventFn;
	
	        return {
	          close: $window.close,
	          start: function() {
	            var runner = new $$AnimateRunner();
	            waitUntilQuiet(function() {
	              blockTransition(element, false);
	              if (!hasCompleteAnimation) {
	                return close();
	              }
	
	              forEach(temporaryStyles, function(entry) {
	                var key = entry[0];
	                var value = entry[1];
	                node.style[camelCase(key)] = value;
	              });
	
	              applyClasses(element, options);
	
	              var timings = computeTimings(element);
	              if (timings.duration === 0) {
	                return close();
	              }
	
	              var moreStyles = [];
	
	              if (options.easing) {
	                if (timings.transitionDuration) {
	                  moreStyles.push([PREFIX + 'transition-timing-function', options.easing]);
	                }
	                if (timings.animationDuration) {
	                  moreStyles.push([PREFIX + 'animation-timing-function', options.easing]);
	                }
	              }
	
	              if (options.delay && timings.animationDelay) {
	                moreStyles.push([PREFIX + 'animation-delay', options.delay + 's']);
	              }
	
	              if (options.duration && timings.animationDuration) {
	                moreStyles.push([PREFIX + 'animation-duration', options.duration + 's']);
	              }
	
	              forEach(moreStyles, function(entry) {
	                var key = entry[0];
	                var value = entry[1];
	                node.style[camelCase(key)] = value;
	                temporaryStyles.push(entry);
	              });
	
	              var maxDelay = timings.delay;
	              var maxDelayTime = maxDelay * 1000;
	              var maxDuration = timings.duration;
	              var maxDurationTime = maxDuration * 1000;
	              var startTime = Date.now();
	
	              events = [];
	              if (timings.transitionDuration) {
	                events.push(TRANSITION_EVENTS);
	              }
	              if (timings.animationDuration) {
	                events.push(ANIMATION_EVENTS);
	              }
	              events = events.join(' ');
	              eventFn = function(event) {
	                event.stopPropagation();
	                var ev = event.originalEvent || event;
	                var timeStamp = ev.timeStamp || Date.now();
	                var elapsedTime = parseFloat(ev.elapsedTime.toFixed(3));
	                if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
	                  close();
	                }
	              };
	              element.on(events, eventFn);
	
	              applyAnimationToStyles(element, options);
	
	              $timeout(close, maxDelayTime + maxDurationTime * 1.5, false);
	            });
	
	            return runner;
	
	            function close() {
	              if (animationClosed) return;
	              animationClosed = true;
	
	              if (events && eventFn) {
	                element.off(events, eventFn);
	              }
	              applyClasses(element, options);
	              applyAnimationStyles(element, options);
	              forEach(temporaryStyles, function(entry) {
	                node.style[camelCase(entry[0])] = '';
	              });
	              runner.complete(true);
	              return runner;
	            }
	          }
	        };
	      }
	
	      function applyClasses(element, options) {
	        if (options.addClass) {
	          $$jqLite.addClass(element, options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          $$jqLite.removeClass(element, options.removeClass);
	          options.removeClass = null;
	        }
	      }
	
	      function computeTimings(element) {
	        var node = getDomNode(element);
	        var cs = $window.getComputedStyle(node);
	        var tdr = parseMaxTime(cs[prop('transitionDuration')]);
	        var adr = parseMaxTime(cs[prop('animationDuration')]);
	        var tdy = parseMaxTime(cs[prop('transitionDelay')]);
	        var ady = parseMaxTime(cs[prop('animationDelay')]);
	
	        adr *= (parseInt(cs[prop('animationIterationCount')], 10) || 1);
	        var duration = Math.max(adr, tdr);
	        var delay = Math.max(ady, tdy);
	
	        return {
	          duration: duration,
	          delay: delay,
	          animationDuration: adr,
	          transitionDuration: tdr,
	          animationDelay: ady,
	          transitionDelay: tdy
	        };
	
	        function prop(key) {
	          return WEBKIT ? 'Webkit' + key.charAt(0).toUpperCase() + key.substr(1)
	                        : key;
	        }
	      }
	
	      function parseMaxTime(str) {
	        var maxValue = 0;
	        var values = (str || "").split(/\s*,\s*/);
	        forEach(values, function(value) {
	          // it's always safe to consider only second values and omit `ms` values since
	          // getComputedStyle will always handle the conversion for us
	          if (value.charAt(value.length - 1) == 's') {
	            value = value.substring(0, value.length - 1);
	          }
	          value = parseFloat(value) || 0;
	          maxValue = maxValue ? Math.max(value, maxValue) : value;
	        });
	        return maxValue;
	      }
	
	      var cancelLastRAFRequest;
	      var rafWaitQueue = [];
	      function waitUntilQuiet(callback) {
	        if (cancelLastRAFRequest) {
	          cancelLastRAFRequest(); // cancels the request
	        }
	        rafWaitQueue.push(callback);
	        cancelLastRAFRequest = $$rAF(function() {
	          cancelLastRAFRequest = null;
	
	          // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
	          // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
	          var pageWidth = $$forceReflow();
	
	          // we use a for loop to ensure that if the queue is changed
	          // during this looping then it will consider new requests
	          for (var i = 0; i < rafWaitQueue.length; i++) {
	            rafWaitQueue[i](pageWidth);
	          }
	          rafWaitQueue.length = 0;
	        });
	      }
	
	      function applyAnimationStyles(element, options) {
	        applyAnimationFromStyles(element, options);
	        applyAnimationToStyles(element, options);
	      }
	
	      function applyAnimationFromStyles(element, options) {
	        if (options.from) {
	          element.css(options.from);
	          options.from = null;
	        }
	      }
	
	      function applyAnimationToStyles(element, options) {
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	
	      function getDomNode(element) {
	        for (var i = 0; i < element.length; i++) {
	          if (element[i].nodeType === 1) return element[i];
	        }
	      }
	
	      function blockTransition(element, bool) {
	        var node = getDomNode(element);
	        var key = camelCase(PREFIX + 'transition-delay');
	        node.style[key] = bool ? '-9999s' : '';
	      }
	
	      return init;
	    }]);
	
	  /**
	   * Older browsers [FF31] expect camelCase
	   * property keys.
	   * e.g.
	   *  animation-duration --> animationDuration
	   */
	  function camelCase(str) {
	    return str.replace(/-[a-z]/g, function(str) {
	      return str.charAt(1).toUpperCase();
	    });
	  }
	
	})();
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.aria
	 * @description
	 * Aria Expectations for AngularJS Material components.
	 */
	MdAriaService.$inject = ["$$rAF", "$log", "$window", "$interpolate"];
	angular
	  .module('material.core')
	  .provider('$mdAria', MdAriaProvider);
	
	/**
	 * @ngdoc service
	 * @name $mdAriaProvider
	 * @module material.core.aria
	 *
	 * @description
	 *
	 * Modify options of the `$mdAria` service, which will be used by most of the AngularJS Material
	 * components.
	 *
	 * You are able to disable `$mdAria` warnings, by using the following markup.
	 *
	 * <hljs lang="js">
	 *   app.config(function($mdAriaProvider) {
	 *     // Globally disables all ARIA warnings.
	 *     $mdAriaProvider.disableWarnings();
	 *   });
	 * </hljs>
	 *
	 */
	function MdAriaProvider() {
	
	  var config = {
	    /** Whether we should show ARIA warnings in the console if labels are missing on the element */
	    showWarnings: true
	  };
	
	  return {
	    disableWarnings: disableWarnings,
	    $get: ["$$rAF", "$log", "$window", "$interpolate", function($$rAF, $log, $window, $interpolate) {
	      return MdAriaService.apply(config, arguments);
	    }]
	  };
	
	  /**
	   * @ngdoc method
	   * @name $mdAriaProvider#disableWarnings
	   * @description Disables all ARIA warnings generated by AngularJS Material.
	   */
	  function disableWarnings() {
	    config.showWarnings = false;
	  }
	}
	
	/*
	 * @ngInject
	 */
	function MdAriaService($$rAF, $log, $window, $interpolate) {
	
	  // Load the showWarnings option from the current context and store it inside of a scope variable,
	  // because the context will be probably lost in some function calls.
	  var showWarnings = this.showWarnings;
	
	  return {
	    expect: expect,
	    expectAsync: expectAsync,
	    expectWithText: expectWithText,
	    expectWithoutText: expectWithoutText,
	    getText: getText,
	    hasAriaLabel: hasAriaLabel,
	    parentHasAriaLabel: parentHasAriaLabel
	  };
	
	  /**
	   * Check if expected attribute has been specified on the target element or child
	   * @param element
	   * @param attrName
	   * @param {optional} defaultValue What to set the attr to if no value is found
	   */
	  function expect(element, attrName, defaultValue) {
	
	    var node = angular.element(element)[0] || element;
	
	    // if node exists and neither it nor its children have the attribute
	    if (node &&
	       ((!node.hasAttribute(attrName) ||
	        node.getAttribute(attrName).length === 0) &&
	        !childHasAttribute(node, attrName))) {
	
	      defaultValue = angular.isString(defaultValue) ? defaultValue.trim() : '';
	      if (defaultValue.length) {
	        element.attr(attrName, defaultValue);
	      } else if (showWarnings) {
	        $log.warn('ARIA: Attribute "', attrName, '", required for accessibility, is missing on node:', node);
	      }
	
	    }
	  }
	
	  function expectAsync(element, attrName, defaultValueGetter) {
	    // Problem: when retrieving the element's contents synchronously to find the label,
	    // the text may not be defined yet in the case of a binding.
	    // There is a higher chance that a binding will be defined if we wait one frame.
	    $$rAF(function() {
	        expect(element, attrName, defaultValueGetter());
	    });
	  }
	
	  function expectWithText(element, attrName) {
	    var content = getText(element) || "";
	    var hasBinding = content.indexOf($interpolate.startSymbol()) > -1;
	
	    if (hasBinding) {
	      expectAsync(element, attrName, function() {
	        return getText(element);
	      });
	    } else {
	      expect(element, attrName, content);
	    }
	  }
	
	  function expectWithoutText(element, attrName) {
	    var content = getText(element);
	    var hasBinding = content.indexOf($interpolate.startSymbol()) > -1;
	
	    if (!hasBinding && !content) {
	      expect(element, attrName, content);
	    }
	  }
	
	  function getText(element) {
	    element = element[0] || element;
	    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
	    var text = '';
	
	    var node;
	    while (node = walker.nextNode()) {
	      if (!isAriaHiddenNode(node)) {
	        text += node.textContent;
	      }
	    }
	
	    return text.trim() || '';
	
	    function isAriaHiddenNode(node) {
	      while (node.parentNode && (node = node.parentNode) !== element) {
	        if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
	          return true;
	        }
	      }
	    }
	  }
	
	  function childHasAttribute(node, attrName) {
	    var hasChildren = node.hasChildNodes(),
	        hasAttr = false;
	
	    function isHidden(el) {
	      var style = el.currentStyle ? el.currentStyle : $window.getComputedStyle(el);
	      return (style.display === 'none');
	    }
	
	    if (hasChildren) {
	      var children = node.childNodes;
	      for (var i=0; i < children.length; i++) {
	        var child = children[i];
	        if (child.nodeType === 1 && child.hasAttribute(attrName)) {
	          if (!isHidden(child)) {
	            hasAttr = true;
	          }
	        }
	      }
	    }
	    return hasAttr;
	  }
	
	  /**
	   * Check if expected element has aria label attribute
	   * @param element
	   */
	  function hasAriaLabel(element) {
	    var node = angular.element(element)[0] || element;
	
	    /* Check if compatible node type (ie: not HTML Document node) */
	    if (!node.hasAttribute) {
	      return false;
	    }
	
	    /* Check label or description attributes */
	    return node.hasAttribute('aria-label') || node.hasAttribute('aria-labelledby') || node.hasAttribute('aria-describedby');
	  }
	
	  /**
	   * Check if expected element's parent has aria label attribute and has valid role and tagName
	   * @param element
	   * @param {optional} level Number of levels deep search should be performed
	   */
	  function parentHasAriaLabel(element, level) {
	    level = level || 1;
	    var node = angular.element(element)[0] || element;
	    if (!node.parentNode) {
	      return false;
	    }
	    if (performCheck(node.parentNode)) {
	      return true;
	    }
	    level--;
	    if (level) {
	      return parentHasAriaLabel(node.parentNode, level);
	    }
	    return false;
	
	    function performCheck(parentNode) {
	      if (!hasAriaLabel(parentNode)) {
	        return false;
	      }
	      /* Perform role blacklist check */
	      if (parentNode.hasAttribute('role')) {
	        switch (parentNode.getAttribute('role').toLowerCase()) {
	          case 'command':
	          case 'definition':
	          case 'directory':
	          case 'grid':
	          case 'list':
	          case 'listitem':
	          case 'log':
	          case 'marquee':
	          case 'menu':
	          case 'menubar':
	          case 'note':
	          case 'presentation':
	          case 'separator':
	          case 'scrollbar':
	          case 'status':
	          case 'tablist':
	            return false;
	        }
	      }
	      /* Perform tagName blacklist check */
	      switch (parentNode.tagName.toLowerCase()) {
	        case 'abbr':
	        case 'acronym':
	        case 'address':
	        case 'applet':
	        case 'audio':
	        case 'b':
	        case 'bdi':
	        case 'bdo':
	        case 'big':
	        case 'blockquote':
	        case 'br':
	        case 'canvas':
	        case 'caption':
	        case 'center':
	        case 'cite':
	        case 'code':
	        case 'col':
	        case 'data':
	        case 'dd':
	        case 'del':
	        case 'dfn':
	        case 'dir':
	        case 'div':
	        case 'dl':
	        case 'em':
	        case 'embed':
	        case 'fieldset':
	        case 'figcaption':
	        case 'font':
	        case 'h1':
	        case 'h2':
	        case 'h3':
	        case 'h4':
	        case 'h5':
	        case 'h6':
	        case 'hgroup':
	        case 'html':
	        case 'i':
	        case 'ins':
	        case 'isindex':
	        case 'kbd':
	        case 'keygen':
	        case 'label':
	        case 'legend':
	        case 'li':
	        case 'map':
	        case 'mark':
	        case 'menu':
	        case 'object':
	        case 'ol':
	        case 'output':
	        case 'pre':
	        case 'presentation':
	        case 'q':
	        case 'rt':
	        case 'ruby':
	        case 'samp':
	        case 'small':
	        case 'source':
	        case 'span':
	        case 'status':
	        case 'strike':
	        case 'strong':
	        case 'sub':
	        case 'sup':
	        case 'svg':
	        case 'tbody':
	        case 'td':
	        case 'th':
	        case 'thead':
	        case 'time':
	        case 'tr':
	        case 'track':
	        case 'tt':
	        case 'ul':
	        case 'var':
	          return false;
	      }
	      return true;
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.compiler
	 * @description
	 * AngularJS Material template and element compiler.
	 */
	angular
	  .module('material.core')
	  .provider('$mdCompiler', MdCompilerProvider);
	
	/**
	 * @ngdoc service
	 * @name $mdCompilerProvider
	 * @module material.core.compiler
	 * @description
	 * The `$mdCompiler` is able to respect the AngularJS `$compileProvider.preAssignBindingsEnabled`
	 * state when using AngularJS versions greater than or equal to 1.5.10 and less than 1.7.0.
	 * See the [AngularJS documentation for `$compileProvider.preAssignBindingsEnabled`
	 * ](https://code.angularjs.org/1.6.10/docs/api/ng/provider/$compileProvider#preAssignBindingsEnabled)
	 * for more information.
	 *
	 * To enable/disable whether the controllers of dynamic AngularJS Material components
	 * (i.e. dialog, panel, toast, bottomsheet) respect the AngularJS
	 * `$compileProvider.preAssignBindingsEnabled` flag, call the AngularJS Material method:
	 * `$mdCompilerProvider.respectPreAssignBindingsEnabled(boolean)`.
	 *
	 * This AngularJS Material *flag* doesn't affect directives/components created via regular
	 * AngularJS methods. These constitute the majority of AngularJS Material and user-created
	 * components. Only dynamic construction of elements such as Dialogs, Panels, Toasts, BottomSheets,
	 * etc. may be affected. Invoking `$mdCompilerProvider.respectPreAssignBindingsEnabled(true)`
	 * will effect **bindings** in controllers created by AngularJS Material's services like
	 * `$mdDialog`, `$mdPanel`, `$mdToast`, or `$mdBottomSheet`.
	 *
	 * See
	 * <a ng-href="#mdcompilerprovider-respectpreassignbindingsenabled-respected">
	 *   $mdCompilerProvider.respectPreAssignBindingsEnabled
	 * </a>
	 * for the details of how the different versions and settings of AngularJS affect this behavior.
	 *
	 * @usage
	 *
	 * Respect the AngularJS Compiler Setting
	 *
	 * <hljs lang="js">
	 *   app.config(function($mdCompilerProvider) {
	 *     $mdCompilerProvider.respectPreAssignBindingsEnabled(true);
	 *   });
	 * </hljs>
	 *
	 * @example
	 * Using the default (backwards compatible) values for AngularJS 1.6
	 * - AngularJS' `$compileProvider.preAssignBindingsEnabled(false)`
	 * - AngularJS Material's `$mdCompilerProvider.respectPreAssignBindingsEnabled(false)`
	 * <br><br>
	 *
	 * <hljs lang="js">
	 * $mdDialog.show({
	 *   locals: {
	 *     myVar: true
	 *   },
	 *   controller: MyController,
	 *   bindToController: true
	 * }
	 *
	 * function MyController() {
	 *   // Locals from Angular Material are available. e.g myVar is true.
	 * }
	 *
	 * MyController.prototype.$onInit = function() {
	 *   // Bindings are also available in the $onInit lifecycle hook.
	 * }
	 * </hljs>
	 *
	 * Recommended Settings for AngularJS 1.6
	 * - AngularJS' `$compileProvider.preAssignBindingsEnabled(false)`
	 * - AngularJS Material's `$mdCompilerProvider.respectPreAssignBindingsEnabled(true)`
	 * <br><br>
	 *
	 * <hljs lang="js">
	 * $mdDialog.show({
	 *   locals: {
	 *     myVar: true
	 *   },
	 *   controller: MyController,
	 *   bindToController: true
	 * }
	 *
	 * function MyController() {
	 *   // No locals from Angular Material are available. e.g myVar is undefined.
	 * }
	 *
	 * MyController.prototype.$onInit = function() {
	 *   // Bindings are now available in the $onInit lifecycle hook.
	 * }
	 * </hljs>
	 *
	 */
	MdCompilerProvider.$inject = ['$compileProvider'];
	function MdCompilerProvider($compileProvider) {
	
	  var provider = this;
	
	  /**
	   * @ngdoc method
	   * @name $mdCompilerProvider#respectPreAssignBindingsEnabled
	   *
	   * @param {boolean=} respected update the `respectPreAssignBindingsEnabled` state if provided,
	   *  otherwise just return the current Material `respectPreAssignBindingsEnabled` state.
	   * @returns {boolean|MdCompilerProvider} current value, if used as a getter, or itself (chaining)
	   *  if used as a setter.
	   *
	   * @description
	   * Call this method to enable/disable whether Material-specific (dialog/panel/toast/bottomsheet)
	   * controllers respect the AngularJS `$compileProvider.preAssignBindingsEnabled` flag. Note that
	   * this doesn't affect directives/components created via regular AngularJS methods which
	   * constitute most Material and user-created components.
	   *
	   * If disabled (`false`), the compiler assigns the value of each of the bindings to the
	   * properties of the controller object before the constructor of this object is called.
	   * The ability to disable this settings is **deprecated** and will be removed in
	   * AngularJS Material 1.2.0.
	   *
	   * If enabled (`true`) the behavior depends on the AngularJS version used:
	   *
	   * - `<1.5.10`
	   *  - Bindings are pre-assigned.
	   * - `>=1.5.10 <1.7`
	   *  - Respects whatever `$compileProvider.preAssignBindingsEnabled()` reports. If the
	   *    `preAssignBindingsEnabled` flag wasn't set manually, it defaults to pre-assigning bindings
	   *    with AngularJS `1.5` and to calling the constructor first with AngularJS `1.6`.
	   * - `>=1.7`
	   *  - The compiler calls the constructor first before assigning bindings and
	   *    `$compileProvider.preAssignBindingsEnabled()` no longer exists.
	   *
	   * Defaults
	   * - The default value is `false` in AngularJS 1.6 and earlier.
	   *  - It is planned to fix this value to `true` and not allow the `false` value in
	   *    AngularJS Material 1.2.0.
	   *
	   * It is recommended to set this flag to `true` when using AngularJS Material 1.1.x with
	   * AngularJS versions >= 1.5.10. The only reason it's not set that way by default is backwards
	   * compatibility.
	   *
	   * By not setting the flag to `true` when AngularJS' `$compileProvider.preAssignBindingsEnabled()`
	   * is set to `false` (i.e. default behavior in AngularJS 1.6 or newer), unit testing of
	   * Material Dialog/Panel/Toast/BottomSheet controllers using the `$controller` helper
	   * is problematic as it always follows AngularJS' `$compileProvider.preAssignBindingsEnabled()`
	   * value.
	   */
	  var respectPreAssignBindingsEnabled = false;
	  this.respectPreAssignBindingsEnabled = function(respected) {
	    if (angular.isDefined(respected)) {
	      respectPreAssignBindingsEnabled = respected;
	      return this;
	    }
	
	    return respectPreAssignBindingsEnabled;
	  };
	
	  /**
	   * @private
	   * @description
	   * This function returns `true` if AngularJS Material-specific (dialog/panel/toast/bottomsheet)
	   * controllers have bindings pre-assigned in controller constructors and `false` otherwise.
	   *
	   * Note that this doesn't affect directives/components created via regular AngularJS methods
	   * which constitute most Material and user-created components; their behavior can be checked via
	   * `$compileProvider.preAssignBindingsEnabled()` in AngularJS `>=1.5.10 <1.7.0`.
	   *
	   * @returns {*} current preAssignBindingsEnabled state
	   */
	  function getPreAssignBindingsEnabled() {
	    if (!respectPreAssignBindingsEnabled) {
	      // respectPreAssignBindingsEnabled === false
	      // We're ignoring the AngularJS `$compileProvider.preAssignBindingsEnabled()` value in this case.
	      return true;
	    }
	
	    // respectPreAssignBindingsEnabled === true
	
	    // This check is needed because $compileProvider.preAssignBindingsEnabled does not exist prior
	    // to AngularJS 1.5.10, is deprecated in AngularJS 1.6.x, and removed in AngularJS 1.7.x.
	    if (typeof $compileProvider.preAssignBindingsEnabled === 'function') {
	      return $compileProvider.preAssignBindingsEnabled();
	    }
	
	    // Flag respected but not present => apply logic based on AngularJS version used.
	    if (angular.version.major === 1 && angular.version.minor < 6) {
	      // AngularJS <1.5.10
	      return true;
	    }
	
	    // AngularJS >=1.7.0
	    return false;
	  }
	
	  this.$get = ["$q", "$templateRequest", "$injector", "$compile", "$controller",
	    function($q, $templateRequest, $injector, $compile, $controller) {
	      return new MdCompilerService($q, $templateRequest, $injector, $compile, $controller);
	    }];
	
	  /**
	   * @ngdoc service
	   * @name $mdCompiler
	   * @module material.core.compiler
	   * @description
	   * The $mdCompiler service is an abstraction of AngularJS's compiler, that allows developers
	   * to easily compile an element with options like in a Directive Definition Object.
	   *
	   * > The compiler powers a lot of components inside of AngularJS Material.
	   * > Like the `$mdPanel` or `$mdDialog`.
	   *
	   * @usage
	   *
	   * Basic Usage with a template
	   *
	   * <hljs lang="js">
	   *   $mdCompiler.compile({
	   *     templateUrl: 'modal.html',
	   *     controller: 'ModalCtrl',
	   *     locals: {
	   *       modal: myModalInstance;
	   *     }
	   *   }).then(function (compileData) {
	   *     compileData.element; // Compiled DOM element
	   *     compileData.link(myScope); // Instantiate controller and link element to scope.
	   *   });
	   * </hljs>
	   *
	   * Example with a content element
	   *
	   * <hljs lang="js">
	   *
	   *   // Create a virtual element and link it manually.
	   *   // The compiler doesn't need to recompile the element each time.
	   *   var myElement = $compile('<span>Test</span>')(myScope);
	   *
	   *   $mdCompiler.compile({
	   *     contentElement: myElement
	   *   }).then(function (compileData) {
	   *     compileData.element // Content Element (same as above)
	   *     compileData.link // This does nothing when using a contentElement.
	   *   });
	   * </hljs>
	   *
	   * > Content Element is a significant performance improvement when the developer already knows that the
	   * > compiled element will be always the same and the scope will not change either.
	   *
	   * The `contentElement` option also supports DOM elements which will be temporary removed and restored
	   * at its old position.
	   *
	   * <hljs lang="js">
	   *   var domElement = document.querySelector('#myElement');
	   *
	   *   $mdCompiler.compile({
	   *     contentElement: myElement
	   *   }).then(function (compileData) {
	   *     compileData.element // Content Element (same as above)
	   *     compileData.link // This does nothing when using a contentElement.
	   *   });
	   * </hljs>
	   *
	   * The `$mdCompiler` can also query for the element in the DOM itself.
	   *
	   * <hljs lang="js">
	   *   $mdCompiler.compile({
	   *     contentElement: '#myElement'
	   *   }).then(function (compileData) {
	   *     compileData.element // Content Element (same as above)
	   *     compileData.link // This does nothing when using a contentElement.
	   *   });
	   * </hljs>
	   *
	   */
	  function MdCompilerService($q, $templateRequest, $injector, $compile, $controller) {
	
	    /**
	     * @private @const
	     * @type {!IQService}
	     */
	    this.$q = $q;
	
	    /**
	     * @private @const
	     * @type {!ITemplateRequestService}
	     */
	    this.$templateRequest = $templateRequest;
	
	    /**
	     * @private @const
	     * @type {!IInjectorService}
	     */
	    this.$injector = $injector;
	
	    /**
	     * @private @const
	     * @type{!ICompileService}
	     */
	    this.$compile = $compile;
	
	    /**
	     * @private @const
	     * @type {!IControllerService}
	     */
	    this.$controller = $controller;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $mdCompiler#compile
	   * @description
	   *
	   * A method to compile a HTML template with the AngularJS compiler.
	   * The `$mdCompiler` is wrapper around the AngularJS compiler and provides extra functionality
	   * like controller instantiation or async resolves.
	   *
	   * @param {!Object} options An options object, with the following properties:
	   *
	   *    - `controller` - `{string|function}` Controller fn that should be associated with
	   *         newly created scope or the name of a registered controller if passed as a string.
	   *    - `controllerAs` - `{string=}` A controller alias name. If present the controller will be
	   *         published to scope under the `controllerAs` name.
	   *    - `contentElement` - `{string|Element}`: Instead of using a template, which will be
	   *         compiled each time, you can also use a DOM element.<br/>
	   *    - `template` - `{string=}` An html template as a string.
	   *    - `templateUrl` - `{string=}` A path to an html template.
	   *    - `transformTemplate` - `{function(template)=}` A function which transforms the template after
	   *        it is loaded. It will be given the template string as a parameter, and should
	   *        return a a new string representing the transformed template.
	   *    - `resolve` - `{Object.<string, function>=}` - An optional map of dependencies which should
	   *        be injected into the controller. If any of these dependencies are promises, the compiler
	   *        will wait for them all to be resolved, or if one is rejected before the controller is
	   *        instantiated `compile()` will fail..
	   *      * `key` - `{string}`: a name of a dependency to be injected into the controller.
	   *      * `factory` - `{string|function}`: If `string` then it is an alias for a service.
	   *        Otherwise if function, then it is injected and the return value is treated as the
	   *        dependency. If the result is a promise, it is resolved before its value is
	   *        injected into the controller.
	   *
	   * @returns {Object} promise A promise, which will be resolved with a `compileData` object.
	   * `compileData` has the following properties:
	   *
	   *   - `element` - `{Element}`: an uncompiled element matching the provided template.
	   *   - `link` - `{function(scope)}`: A link function, which, when called, will compile
	   *     the element and instantiate the provided controller (if given).
	   *   - `locals` - `{Object}`: The locals which will be passed into the controller once `link` is
	   *     called. If `bindToController` is true, they will be copied to the ctrl instead
	   */
	  MdCompilerService.prototype.compile = function(options) {
	
	    if (options.contentElement) {
	      return this._prepareContentElement(options);
	    } else {
	      return this._compileTemplate(options);
	    }
	
	  };
	
	  /**
	   * Instead of compiling any template, the compiler just fetches an existing HTML element from the DOM and
	   * provides a restore function to put the element back it old DOM position.
	   * @param {!Object} options Options to be used for the compiler.
	   */
	  MdCompilerService.prototype._prepareContentElement = function(options) {
	
	    var contentElement = this._fetchContentElement(options);
	
	    return this.$q.resolve({
	      element: contentElement.element,
	      cleanup: contentElement.restore,
	      locals: {},
	      link: function() {
	        return contentElement.element;
	      }
	    });
	
	  };
	
	  /**
	   * Compiles a template by considering all options and waiting for all resolves to be ready.
	   * @param {!Object} options Compile options
	   * @returns {!Object} Compile data with link function.
	   */
	  MdCompilerService.prototype._compileTemplate = function(options) {
	
	    var self = this;
	    var templateUrl = options.templateUrl;
	    var template = options.template || '';
	    var resolve = angular.extend({}, options.resolve);
	    var locals = angular.extend({}, options.locals);
	    var transformTemplate = options.transformTemplate || angular.identity;
	
	    // Take resolve values and invoke them.
	    // Resolves can either be a string (value: 'MyRegisteredAngularConst'),
	    // or an invokable 'factory' of sorts: (value: function ValueGetter($dependency) {})
	    angular.forEach(resolve, function(value, key) {
	      if (angular.isString(value)) {
	        resolve[key] = self.$injector.get(value);
	      } else {
	        resolve[key] = self.$injector.invoke(value);
	      }
	    });
	
	    // Add the locals, which are just straight values to inject
	    // eg locals: { three: 3 }, will inject three into the controller
	    angular.extend(resolve, locals);
	
	    if (templateUrl) {
	      resolve.$$ngTemplate = this.$templateRequest(templateUrl);
	    } else {
	      resolve.$$ngTemplate = this.$q.when(template);
	    }
	
	
	    // Wait for all the resolves to finish if they are promises
	    return this.$q.all(resolve).then(function(locals) {
	
	      var template = transformTemplate(locals.$$ngTemplate, options);
	      var element = options.element || angular.element('<div>').html(template.trim()).contents();
	
	      return self._compileElement(locals, element, options);
	    });
	
	  };
	
	  /**
	   * Method to compile an element with the given options.
	   * @param {!Object} locals Locals to be injected to the controller if present
	   * @param {!JQLite} element Element to be compiled and linked
	   * @param {!Object} options Options to be used for linking.
	   * @returns {!Object} Compile data with link function.
	   */
	  MdCompilerService.prototype._compileElement = function(locals, element, options) {
	    var self = this;
	    var ngLinkFn = this.$compile(element);
	
	    var compileData = {
	      element: element,
	      cleanup: element.remove.bind(element),
	      locals: locals,
	      link: linkFn
	    };
	
	    function linkFn(scope) {
	      locals.$scope = scope;
	
	      // Instantiate controller if the developer provided one.
	      if (options.controller) {
	
	        var injectLocals = angular.extend({}, locals, {
	          $element: element
	        });
	
	        // Create the specified controller instance.
	        var ctrl = self._createController(options, injectLocals, locals);
	
	        // Registering extra $destroy listeners should be avoided.
	        // Only register the listener if the controller implements a $onDestroy hook.
	        if (angular.isFunction(ctrl.$onDestroy)) {
	          scope.$on('$destroy', function() {
	            // Call the $onDestroy hook if it's present on the controller.
	            angular.isFunction(ctrl.$onDestroy) && ctrl.$onDestroy();
	          });
	        }
	
	        // Unique identifier for AngularJS Route ngView controllers.
	        element.data('$ngControllerController', ctrl);
	        element.children().data('$ngControllerController', ctrl);
	
	        // Expose the instantiated controller to the compile data
	        compileData.controller = ctrl;
	      }
	
	      // Invoke the AngularJS $compile link function.
	      return ngLinkFn(scope);
	    }
	
	    return compileData;
	
	  };
	
	  /**
	   * Creates and instantiates a new controller with the specified options.
	   * @param {!Object} options Options that include the controller function or string.
	   * @param {!Object} injectLocals Locals to to be provided in the controller DI.
	   * @param {!Object} locals Locals to be injected to the controller.
	   * @returns {!Object} Created controller instance.
	   */
	  MdCompilerService.prototype._createController = function(options, injectLocals, locals) {
	    var ctrl;
	    var preAssignBindingsEnabled = getPreAssignBindingsEnabled();
	    // The third argument to $controller is considered private and undocumented:
	    // https://github.com/angular/angular.js/blob/v1.6.10/src/ng/controller.js#L102-L109.
	    // TODO remove the use of this third argument in AngularJS Material 1.2.0.
	    // Passing `true` as the third argument causes `$controller` to return a function that
	    // gets the controller instance instead of returning the instance directly. When the
	    // controller is defined as a function, `invokeCtrl.instance` is the *same instance* as
	    // `invokeCtrl()`. However, when the controller is an ES6 class, `invokeCtrl.instance` is a
	    // *different instance* from `invokeCtrl()`.
	    if (preAssignBindingsEnabled) {
	      var invokeCtrl = this.$controller(options.controller, injectLocals, true);
	
	      if (options.bindToController) {
	        angular.extend(invokeCtrl.instance, locals);
	      }
	
	      // Use the private API callback to instantiate and initialize the specified controller.
	      ctrl = invokeCtrl();
	    } else {
	      // If we don't need to pre-assign bindings, avoid using the private API third argument and
	      // related callback.
	      ctrl = this.$controller(options.controller, injectLocals);
	
	      if (options.bindToController) {
	        angular.extend(ctrl, locals);
	      }
	    }
	
	    if (options.controllerAs) {
	      injectLocals.$scope[options.controllerAs] = ctrl;
	    }
	
	    // Call the $onInit hook if it's present on the controller.
	    angular.isFunction(ctrl.$onInit) && ctrl.$onInit();
	
	    return ctrl;
	  };
	
	  /**
	   * Fetches an element removing it from the DOM and using it temporary for the compiler.
	   * Elements which were fetched will be restored after use.
	   * @param {!Object} options Options to be used for the compilation.
	   * @returns {{element: !JQLite, restore: !function}}
	   */
	  MdCompilerService.prototype._fetchContentElement = function(options) {
	    var contentEl = options.contentElement;
	    var restoreFn = null;
	
	    if (angular.isString(contentEl)) {
	      contentEl = document.querySelector(contentEl);
	      restoreFn = createRestoreFn(contentEl);
	    } else {
	      contentEl = contentEl[0] || contentEl;
	
	      // When the element is visible in the DOM, then we restore it at close of the dialog.
	      // Otherwise it will be removed from the DOM after close.
	      if (document.contains(contentEl)) {
	        restoreFn = createRestoreFn(contentEl);
	      } else {
	        restoreFn = function() {
	          if (contentEl.parentNode) {
	            contentEl.parentNode.removeChild(contentEl);
	          }
	        };
	      }
	    }
	
	    return {
	      element: angular.element(contentEl),
	      restore: restoreFn
	    };
	
	    function createRestoreFn(element) {
	      var parent = element.parentNode;
	      var nextSibling = element.nextElementSibling;
	
	      return function() {
	        if (!nextSibling) {
	          // When the element didn't had any sibling, then it can be simply appended to the
	          // parent, because it plays no role, which index it had before.
	          parent.appendChild(element);
	        } else {
	          // When the element had a sibling, which marks the previous position of the element
	          // in the DOM, we insert it correctly before the sibling, to have the same index as
	          // before.
	          parent.insertBefore(element, nextSibling);
	        }
	      };
	    }
	  };
	}
	
	
	})();
	(function(){
	"use strict";
	
	
	MdGesture.$inject = ["$$MdGestureHandler", "$$rAF", "$timeout", "$mdUtil"];
	attachToDocument.$inject = ["$mdGesture", "$$MdGestureHandler", "$mdUtil"];var HANDLERS = {};
	
	/**
	 * The state of the current 'pointer'. The pointer represents the state of the current touch.
	 * It contains normalized x and y coordinates from DOM events,
	 * as well as other information abstracted from the DOM.
	 */
	var pointer, lastPointer, maxClickDistance = 6;
	var forceSkipClickHijack = false, disableAllGestures = false;
	
	/**
	 * The position of the most recent click if that click was on a label element.
	 * @type {{x: number, y: number}|null}
	 */
	var lastLabelClickPos = null;
	
	/**
	 * Used to attach event listeners once when multiple ng-apps are running.
	 * @type {boolean}
	 */
	var isInitialized = false;
	
	/**
	 * @ngdoc module
	 * @name material.core.gestures
	 * @description
	 * AngularJS Material Gesture handling for touch devices.
	 * This module replaced the usage of the HammerJS library.
	 */
	angular
	  .module('material.core.gestures', [])
	  .provider('$mdGesture', MdGestureProvider)
	  .factory('$$MdGestureHandler', MdGestureHandler)
	  .run(attachToDocument);
	
	/**
	 * @ngdoc service
	 * @name $mdGestureProvider
	 * @module material.core.gestures
	 *
	 * @description
	 * In some scenarios on mobile devices (without jQuery), the click events should NOT be hijacked.
	 * `$mdGestureProvider` is used to configure the Gesture module to ignore or skip click hijacking
	 * on mobile devices.
	 *
	 * You can also change the max click distance, `6px` by default, if you have issues on some touch
	 * screens.
	 *
	 * <hljs lang="js">
	 *   app.config(function($mdGestureProvider) {
	 *
	 *     // For mobile devices without jQuery loaded, do not
	 *     // intercept click events during the capture phase.
	 *     $mdGestureProvider.skipClickHijack();
	 *
	 *     // If hijacking clicks, you may want to change the default click distance
	 *     $mdGestureProvider.setMaxClickDistance(12);
	 *   });
	 * </hljs>
	 *
	 */
	function MdGestureProvider() { }
	
	MdGestureProvider.prototype = {
	
	  /**
	   * @ngdoc method
	   * @name $mdGestureProvider#disableAll
	   *
	   * @description
	   * Disable all gesture detection. This can be beneficial to application performance
	   * and memory usage.
	   */
	  disableAll: function () {
	    disableAllGestures = true;
	  },
	
	  // Publish access to setter to configure a variable BEFORE the
	  // $mdGesture service is instantiated...
	  /**
	   * @ngdoc method
	   * @name $mdGestureProvider#skipClickHijack
	   *
	   * @description
	   * Tell the AngularJS Material Gesture module to skip (or ignore) click hijacking on mobile devices.
	   */
	  skipClickHijack: function() {
	    return forceSkipClickHijack = true;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $mdGestureProvider#setMaxClickDistance
	   * @param clickDistance {string} Distance in pixels. I.e. `12px`.
	   * @description
	   * Set the max distance from the origin of the touch event to trigger touch handlers.
	   */
	  setMaxClickDistance: function(clickDistance) {
	    maxClickDistance = parseInt(clickDistance);
	  },
	
	  /**
	   * $get is used to build an instance of $mdGesture
	   * @ngInject
	   */
	  $get : ["$$MdGestureHandler", "$$rAF", "$timeout", "$mdUtil", function($$MdGestureHandler, $$rAF, $timeout, $mdUtil) {
	       return new MdGesture($$MdGestureHandler, $$rAF, $timeout, $mdUtil);
	  }]
	};
	
	
	
	/**
	 * MdGesture factory construction function
	 * @ngInject
	 */
	function MdGesture($$MdGestureHandler, $$rAF, $timeout, $mdUtil) {
	  var touchActionProperty = $mdUtil.getTouchAction();
	  var hasJQuery = (typeof __webpack_provided_window_dot_jQuery !== 'undefined') && (angular.element === __webpack_provided_window_dot_jQuery);
	
	  var self = {
	    handler: addHandler,
	    register: register,
	    isAndroid: $mdUtil.isAndroid,
	    isIos: $mdUtil.isIos,
	    // On mobile w/out jQuery, we normally intercept clicks. Should we skip that?
	    isHijackingClicks: ($mdUtil.isIos || $mdUtil.isAndroid) && !hasJQuery && !forceSkipClickHijack
	  };
	
	  if (self.isHijackingClicks) {
	    self.handler('click', {
	      options: {
	        maxDistance: maxClickDistance
	      },
	      onEnd: checkDistanceAndEmit('click')
	    });
	
	    self.handler('focus', {
	      options: {
	        maxDistance: maxClickDistance
	      },
	      onEnd: function(ev, pointer) {
	        if (pointer.distance < this.state.options.maxDistance && canFocus(ev.target)) {
	          this.dispatchEvent(ev, 'focus', pointer);
	          ev.target.focus();
	        }
	      }
	    });
	
	    self.handler('mouseup', {
	      options: {
	        maxDistance: maxClickDistance
	      },
	      onEnd: checkDistanceAndEmit('mouseup')
	    });
	
	    self.handler('mousedown', {
	      onStart: function(ev) {
	        this.dispatchEvent(ev, 'mousedown');
	      }
	    });
	  }
	
	  function checkDistanceAndEmit(eventName) {
	    return function(ev, pointer) {
	      if (pointer.distance < this.state.options.maxDistance) {
	        this.dispatchEvent(ev, eventName, pointer);
	      }
	    };
	  }
	
	  /**
	   * Register an element to listen for a handler.
	   * This allows an element to override the default options for a handler.
	   * Additionally, some handlers like drag and hold only dispatch events if
	   * the domEvent happens inside an element that's registered to listen for these events.
	   *
	   * @see GestureHandler for how overriding of default options works.
	   * @example $mdGesture.register(myElement, 'drag', { minDistance: 20, horizontal: false })
	   */
	  function register(element, handlerName, options) {
	    var handler = HANDLERS[handlerName.replace(/^\$md./, '')];
	    if (!handler) {
	      throw new Error('Failed to register element with handler ' + handlerName + '. ' +
	      'Available handlers: ' + Object.keys(HANDLERS).join(', '));
	    }
	    return handler.registerElement(element, options);
	  }
	
	  /*
	   * add a handler to $mdGesture. see below.
	   */
	  function addHandler(name, definition) {
	    var handler = new $$MdGestureHandler(name);
	    angular.extend(handler, definition);
	    HANDLERS[name] = handler;
	
	    return self;
	  }
	
	  /**
	   * Register handlers. These listen to touch/start/move events, interpret them,
	   * and dispatch gesture events depending on options & conditions. These are all
	   * instances of GestureHandler.
	   * @see GestureHandler
	   */
	  return self
	    /*
	     * The press handler dispatches an event on touchdown/touchend.
	     * It's a simple abstraction of touch/mouse/pointer start and end.
	     */
	    .handler('press', {
	      onStart: function (ev, pointer) {
	        this.dispatchEvent(ev, '$md.pressdown');
	      },
	      onEnd: function (ev, pointer) {
	        this.dispatchEvent(ev, '$md.pressup');
	      }
	    })
	
	    /*
	     * The hold handler dispatches an event if the user keeps their finger within
	     * the same <maxDistance> area for <delay> ms.
	     * The hold handler will only run if a parent of the touch target is registered
	     * to listen for hold events through $mdGesture.register()
	     */
	    .handler('hold', {
	      options: {
	        maxDistance: 6,
	        delay: 500
	      },
	      onCancel: function () {
	        $timeout.cancel(this.state.timeout);
	      },
	      onStart: function (ev, pointer) {
	        // For hold, require a parent to be registered with $mdGesture.register()
	        // Because we prevent scroll events, this is necessary.
	        if (!this.state.registeredParent) return this.cancel();
	
	        this.state.pos = {x: pointer.x, y: pointer.y};
	        this.state.timeout = $timeout(angular.bind(this, function holdDelayFn() {
	          this.dispatchEvent(ev, '$md.hold');
	          this.cancel(); // we're done!
	        }), this.state.options.delay, false);
	      },
	      onMove: function (ev, pointer) {
	        // Don't scroll while waiting for hold.
	        // If we don't preventDefault touchmove events here, Android will assume we don't
	        // want to listen to anymore touch events. It will start scrolling and stop sending
	        // touchmove events.
	        if (!touchActionProperty && ev.type === 'touchmove') ev.preventDefault();
	
	        // If the user moves greater than <maxDistance> pixels, stop the hold timer
	        // set in onStart
	        var dx = this.state.pos.x - pointer.x;
	        var dy = this.state.pos.y - pointer.y;
	        if (Math.sqrt(dx * dx + dy * dy) > this.options.maxDistance) {
	          this.cancel();
	        }
	      },
	      onEnd: function () {
	        this.onCancel();
	      }
	    })
	
	    /*
	     * The drag handler dispatches a drag event if the user holds and moves his finger greater than
	     * <minDistance> px in the x or y direction, depending on options.horizontal.
	     * The drag will be cancelled if the user moves his finger greater than <minDistance>*<cancelMultiplier> in
	     * the perpendicular direction. Eg if the drag is horizontal and the user moves his finger <minDistance>*<cancelMultiplier>
	     * pixels vertically, this handler won't consider the move part of a drag.
	     */
	    .handler('drag', {
	      options: {
	        minDistance: 6,
	        horizontal: true,
	        cancelMultiplier: 1.5
	      },
	      /**
	       * @param {angular.JQLite} element where touch action styles need to be adjusted
	       * @param {{horizontal: boolean}=} options object whose horizontal property can specify to
	       *  apply 'pan-y' or 'pan-x' touch actions.
	       */
	      onSetup: function(element, options) {
	        if (touchActionProperty) {
	          // We check for horizontal to be false, because otherwise we would overwrite the default opts.
	          this.oldTouchAction = element[0].style[touchActionProperty];
	          element[0].style[touchActionProperty] = options.horizontal ? 'pan-y' : 'pan-x';
	        }
	      },
	      /**
	       * @param {angular.JQLite} element where styles need to be cleaned up
	       */
	      onCleanup: function(element) {
	        if (this.oldTouchAction) {
	          element[0].style[touchActionProperty] = this.oldTouchAction;
	        } else {
	          element[0].style[touchActionProperty] = null;
	        }
	      },
	      onStart: function (ev) {
	        // For drag, require a parent to be registered with $mdGesture.register()
	        if (!this.state.registeredParent) this.cancel();
	      },
	      onMove: function (ev, pointer) {
	        var shouldStartDrag, shouldCancel;
	        // Don't scroll while deciding if this touchmove qualifies as a drag event.
	        // If we don't preventDefault touchmove events here, Android will assume we don't
	        // want to listen to anymore touch events. It will start scrolling and stop sending
	        // touchmove events.
	        if (!touchActionProperty && ev.type === 'touchmove') ev.preventDefault();
	
	        if (!this.state.dragPointer) {
	          if (this.state.options.horizontal) {
	            shouldStartDrag = Math.abs(pointer.distanceX) > this.state.options.minDistance;
	            shouldCancel = Math.abs(pointer.distanceY) > this.state.options.minDistance * this.state.options.cancelMultiplier;
	          } else {
	            shouldStartDrag = Math.abs(pointer.distanceY) > this.state.options.minDistance;
	            shouldCancel = Math.abs(pointer.distanceX) > this.state.options.minDistance * this.state.options.cancelMultiplier;
	          }
	
	          if (shouldStartDrag) {
	            // Create a new pointer representing this drag, starting at this point where the drag started.
	            this.state.dragPointer = makeStartPointer(ev);
	            updatePointerState(ev, this.state.dragPointer);
	            this.dispatchEvent(ev, '$md.dragstart', this.state.dragPointer);
	
	          } else if (shouldCancel) {
	            this.cancel();
	          }
	        } else {
	          this.dispatchDragMove(ev);
	        }
	      },
	      // Only dispatch dragmove events every frame; any more is unnecessary
	      dispatchDragMove: $$rAF.throttle(function (ev) {
	        // Make sure the drag didn't stop while waiting for the next frame
	        if (this.state.isRunning) {
	          updatePointerState(ev, this.state.dragPointer);
	          this.dispatchEvent(ev, '$md.drag', this.state.dragPointer);
	        }
	      }),
	      onEnd: function (ev, pointer) {
	        if (this.state.dragPointer) {
	          updatePointerState(ev, this.state.dragPointer);
	          this.dispatchEvent(ev, '$md.dragend', this.state.dragPointer);
	        }
	      }
	    })
	
	    /*
	     * The swipe handler will dispatch a swipe event if, on the end of a touch,
	     * the velocity and distance were high enough.
	     */
	    .handler('swipe', {
	      options: {
	        minVelocity: 0.65,
	        minDistance: 10
	      },
	      onEnd: function (ev, pointer) {
	        var eventType;
	
	        if (Math.abs(pointer.velocityX) > this.state.options.minVelocity &&
	          Math.abs(pointer.distanceX) > this.state.options.minDistance) {
	          eventType = pointer.directionX == 'left' ? '$md.swipeleft' : '$md.swiperight';
	          this.dispatchEvent(ev, eventType);
	        }
	        else if (Math.abs(pointer.velocityY) > this.state.options.minVelocity &&
	          Math.abs(pointer.distanceY) > this.state.options.minDistance) {
	          eventType = pointer.directionY == 'up' ? '$md.swipeup' : '$md.swipedown';
	          this.dispatchEvent(ev, eventType);
	        }
	      }
	    });
	}
	
	/**
	 * MdGestureHandler
	 * A GestureHandler is an object which is able to dispatch custom dom events
	 * based on native dom {touch,pointer,mouse}{start,move,end} events.
	 *
	 * A gesture will manage its lifecycle through the start,move,end, and cancel
	 * functions, which are called by native dom events.
	 *
	 * A gesture has the concept of 'options' (eg. a swipe's required velocity), which can be
	 * overridden by elements registering through $mdGesture.register().
	 */
	function GestureHandler (name) {
	  this.name = name;
	  this.state = {};
	}
	
	function MdGestureHandler() {
	  var hasJQuery =  (typeof __webpack_provided_window_dot_jQuery !== 'undefined') && (angular.element === __webpack_provided_window_dot_jQuery);
	
	  GestureHandler.prototype = {
	    options: {},
	    // jQuery listeners don't work with custom DOMEvents, so we have to dispatch events
	    // differently when jQuery is loaded
	    dispatchEvent: hasJQuery ?  jQueryDispatchEvent : nativeDispatchEvent,
	
	    // These are overridden by the registered handler
	    onSetup: angular.noop,
	    onCleanup: angular.noop,
	    onStart: angular.noop,
	    onMove: angular.noop,
	    onEnd: angular.noop,
	    onCancel: angular.noop,
	
	    // onStart sets up a new state for the handler, which includes options from the
	    // nearest registered parent element of ev.target.
	    start: function (ev, pointer) {
	      if (this.state.isRunning) return;
	      var parentTarget = this.getNearestParent(ev.target);
	      // Get the options from the nearest registered parent
	      var parentTargetOptions = parentTarget && parentTarget.$mdGesture[this.name] || {};
	
	      this.state = {
	        isRunning: true,
	        // Override the default options with the nearest registered parent's options
	        options: angular.extend({}, this.options, parentTargetOptions),
	        // Pass in the registered parent node to the state so the onStart listener can use
	        registeredParent: parentTarget
	      };
	      this.onStart(ev, pointer);
	    },
	    move: function (ev, pointer) {
	      if (!this.state.isRunning) return;
	      this.onMove(ev, pointer);
	    },
	    end: function (ev, pointer) {
	      if (!this.state.isRunning) return;
	      this.state.isRunning = false;
	      this.onEnd(ev, pointer);
	    },
	    cancel: function (ev, pointer) {
	      this.onCancel(ev, pointer);
	      this.state = {};
	    },
	
	    // Find and return the nearest parent element that has been registered to
	    // listen for this handler via $mdGesture.register(element, 'handlerName').
	    getNearestParent: function (node) {
	      var current = node;
	      while (current) {
	        if ((current.$mdGesture || {})[this.name]) {
	          return current;
	        }
	        current = current.parentNode;
	      }
	      return null;
	    },
	
	    // Called from $mdGesture.register when an element registers itself with a handler.
	    // Store the options the user gave on the DOMElement itself. These options will
	    // be retrieved with getNearestParent when the handler starts.
	    registerElement: function (element, options) {
	      var self = this;
	      element[0].$mdGesture = element[0].$mdGesture || {};
	      element[0].$mdGesture[this.name] = options || {};
	      element.on('$destroy', onDestroy);
	
	      self.onSetup(element, options || {});
	
	      return onDestroy;
	
	      function onDestroy() {
	        delete element[0].$mdGesture[self.name];
	        element.off('$destroy', onDestroy);
	
	        self.onCleanup(element, options || {});
	      }
	    }
	  };
	
	  return GestureHandler;
	
	  /**
	   * Dispatch an event with jQuery
	   * TODO: Make sure this sends bubbling events
	   *
	   * @param srcEvent the original DOM touch event that started this.
	   * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
	   * @param eventPointer the pointer object that matches this event.
	   */
	  function jQueryDispatchEvent(srcEvent, eventType, eventPointer) {
	    eventPointer = eventPointer || pointer;
	    var eventObj = new angular.element.Event(eventType);
	
	    eventObj.$material = true;
	    eventObj.pointer = eventPointer;
	    eventObj.srcEvent = srcEvent;
	
	    angular.extend(eventObj, {
	      clientX: eventPointer.x,
	      clientY: eventPointer.y,
	      screenX: eventPointer.x,
	      screenY: eventPointer.y,
	      pageX: eventPointer.x,
	      pageY: eventPointer.y,
	      ctrlKey: srcEvent.ctrlKey,
	      altKey: srcEvent.altKey,
	      shiftKey: srcEvent.shiftKey,
	      metaKey: srcEvent.metaKey
	    });
	    angular.element(eventPointer.target).trigger(eventObj);
	  }
	
	  /**
	   * NOTE: nativeDispatchEvent is very performance sensitive.
	   * @param srcEvent the original DOM touch event that started this.
	   * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
	   * @param eventPointer the pointer object that matches this event.
	   */
	  function nativeDispatchEvent(srcEvent, eventType, eventPointer) {
	    eventPointer = eventPointer || pointer;
	    var eventObj;
	
	    if (eventType === 'click' || eventType === 'mouseup' || eventType === 'mousedown') {
	      if (typeof window.MouseEvent === "function") {
	        eventObj = new MouseEvent(eventType, {
	          bubbles: true,
	          cancelable: true,
	          screenX: Number(srcEvent.screenX),
	          screenY: Number(srcEvent.screenY),
	          clientX: Number(eventPointer.x),
	          clientY: Number(eventPointer.y),
	          ctrlKey: srcEvent.ctrlKey,
	          altKey: srcEvent.altKey,
	          shiftKey: srcEvent.shiftKey,
	          metaKey: srcEvent.metaKey,
	          button: srcEvent.button,
	          buttons: srcEvent.buttons,
	          relatedTarget: srcEvent.relatedTarget || null
	        });
	      } else {
	        eventObj = document.createEvent('MouseEvents');
	        // This has been deprecated
	        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/initMouseEvent
	        eventObj.initMouseEvent(
	          eventType, true, true, window, srcEvent.detail,
	          eventPointer.x, eventPointer.y, eventPointer.x, eventPointer.y,
	          srcEvent.ctrlKey, srcEvent.altKey, srcEvent.shiftKey, srcEvent.metaKey,
	          srcEvent.button, srcEvent.relatedTarget || null
	        );
	      }
	    } else {
	      if (typeof window.CustomEvent === "function") {
	        eventObj = new CustomEvent(eventType, {
	          bubbles: true,
	          cancelable: true,
	          detail: {}
	        });
	      } else {
	        // This has been deprecated
	        // https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/initCustomEvent
	        eventObj = document.createEvent('CustomEvent');
	        eventObj.initCustomEvent(eventType, true, true, {});
	      }
	    }
	    eventObj.$material = true;
	    eventObj.pointer = eventPointer;
	    eventObj.srcEvent = srcEvent;
	    eventPointer.target.dispatchEvent(eventObj);
	  }
	}
	
	/**
	 * Attach Gestures: hook document and check shouldHijack clicks
	 * @ngInject
	 */
	function attachToDocument($mdGesture, $$MdGestureHandler, $mdUtil) {
	  if (disableAllGestures) {
	    return;
	  }
	
	  if (!isInitialized && $mdGesture.isHijackingClicks) {
	    /*
	     * If hijack clicks is true, we preventDefault any click that wasn't
	     * sent by AngularJS Material. This is because on older Android & iOS, a false, or 'ghost',
	     * click event will be sent ~400ms after a touchend event happens.
	     * The only way to know if this click is real is to prevent any normal
	     * click events, and add a flag to events sent by material so we know not to prevent those.
	     *
	     * Two exceptions to click events that should be prevented are:
	     *  - click events sent by the keyboard (eg form submit)
	     *  - events that originate from an Ionic app
	     */
	    document.addEventListener('click'    , clickHijacker     , true);
	    document.addEventListener('mouseup'  , mouseInputHijacker, true);
	    document.addEventListener('mousedown', mouseInputHijacker, true);
	    document.addEventListener('focus'    , mouseInputHijacker, true);
	
	    isInitialized = true;
	  }
	
	  function mouseInputHijacker(ev) {
	    var isKeyClick = !ev.clientX && !ev.clientY;
	
	    if (
	      !isKeyClick &&
	      !ev.$material &&
	      !ev.isIonicTap &&
	      !isInputEventFromLabelClick(ev) &&
	      (ev.type !== 'mousedown' || (!canFocus(ev.target) && !canFocus(document.activeElement)))
	    ) {
	      ev.preventDefault();
	      ev.stopPropagation();
	    }
	  }
	
	  /**
	   * Ignore click events that don't come from AngularJS Material, Ionic, Input Label clicks,
	   * or key presses that generate click events. This helps to ignore the ghost tap events on
	   * older mobile browsers that get sent after a 300-400ms delay.
	   * @param ev MouseEvent or modified MouseEvent with $material, pointer, and other fields
	   */
	  function clickHijacker(ev) {
	    var isKeyClick;
	    if ($mdUtil.isIos) {
	      isKeyClick = angular.isDefined(ev.webkitForce) && ev.webkitForce === 0;
	    } else {
	      isKeyClick = ev.clientX === 0 && ev.clientY === 0;
	    }
	    if (!isKeyClick && !ev.$material && !ev.isIonicTap && !isInputEventFromLabelClick(ev)) {
	      ev.preventDefault();
	      ev.stopPropagation();
	      lastLabelClickPos = null;
	    } else {
	      lastLabelClickPos = null;
	      if (ev.target.tagName.toLowerCase() === 'label') {
	        lastLabelClickPos = {x: ev.x, y: ev.y};
	      }
	    }
	  }
	
	
	  // Listen to all events to cover all platforms.
	  var START_EVENTS = 'mousedown touchstart pointerdown';
	  var MOVE_EVENTS = 'mousemove touchmove pointermove';
	  var END_EVENTS = 'mouseup mouseleave touchend touchcancel pointerup pointercancel';
	
	  angular.element(document)
	    .on(START_EVENTS, gestureStart)
	    .on(MOVE_EVENTS, gestureMove)
	    .on(END_EVENTS, gestureEnd)
	    // For testing
	    .on('$$mdGestureReset', function gestureClearCache () {
	      lastPointer = pointer = null;
	    });
	
	  /**
	   * When a DOM event happens, run all registered gesture handlers' lifecycle
	   * methods which match the DOM event.
	   * Eg. when a 'touchstart' event happens, runHandlers('start') will call and
	   * run `handler.cancel()` and `handler.start()` on all registered handlers.
	   */
	  function runHandlers(handlerEvent, event) {
	    var handler;
	    for (var name in HANDLERS) {
	      handler = HANDLERS[name];
	      if (handler instanceof $$MdGestureHandler) {
	
	        if (handlerEvent === 'start') {
	          // Run cancel to reset any handlers' state
	          handler.cancel();
	        }
	        handler[handlerEvent](event, pointer);
	      }
	    }
	  }
	
	  /*
	   * gestureStart vets if a start event is legitimate (and not part of a 'ghost click' from iOS/Android)
	   * If it is legitimate, we initiate the pointer state and mark the current pointer's type
	   * For example, for a touchstart event, mark the current pointer as a 'touch' pointer, so mouse events
	   * won't effect it.
	   */
	  function gestureStart(ev) {
	    // If we're already touched down, abort
	    if (pointer) return;
	
	    var now = +Date.now();
	
	    // iOS & old android bug: after a touch event, a click event is sent 350 ms later.
	    // If <400ms have passed, don't allow an event of a different type than the previous event
	    if (lastPointer && !typesMatch(ev, lastPointer) && (now - lastPointer.endTime < 1500)) {
	      return;
	    }
	
	    pointer = makeStartPointer(ev);
	
	    runHandlers('start', ev);
	  }
	
	  /**
	   * If a move event happens of the right type, update the pointer and run all the move handlers.
	   * "of the right type": if a mousemove happens but our pointer started with a touch event, do
	   * nothing.
	   */
	  function gestureMove(ev) {
	    if (!pointer || !typesMatch(ev, pointer)) return;
	
	    updatePointerState(ev, pointer);
	    runHandlers('move', ev);
	  }
	
	  /**
	   * If an end event happens of the right type, update the pointer, run endHandlers, and save the
	   * pointer as 'lastPointer'.
	   */
	  function gestureEnd(ev) {
	    if (!pointer || !typesMatch(ev, pointer)) return;
	
	    updatePointerState(ev, pointer);
	    pointer.endTime = +Date.now();
	
	    if (ev.type !== 'pointercancel') {
	      runHandlers('end', ev);
	    }
	
	    lastPointer = pointer;
	    pointer = null;
	  }
	
	}
	
	// ********************
	// Module Functions
	// ********************
	
	/*
	 * Initiate the pointer. x, y, and the pointer's type.
	 */
	function makeStartPointer(ev) {
	  var point = getEventPoint(ev);
	  var startPointer = {
	    startTime: +Date.now(),
	    target: ev.target,
	    // 'p' for pointer events, 'm' for mouse, 't' for touch
	    type: ev.type.charAt(0)
	  };
	  startPointer.startX = startPointer.x = point.pageX;
	  startPointer.startY = startPointer.y = point.pageY;
	  return startPointer;
	}
	
	/*
	 * return whether the pointer's type matches the event's type.
	 * Eg if a touch event happens but the pointer has a mouse type, return false.
	 */
	function typesMatch(ev, pointer) {
	  return ev && pointer && ev.type.charAt(0) === pointer.type;
	}
	
	/**
	 * Gets whether the given event is an input event that was caused by clicking on an
	 * associated label element.
	 *
	 * This is necessary because the browser will, upon clicking on a label element, fire an
	 * *extra* click event on its associated input (if any). mdGesture is able to flag the label
	 * click as with `$material` correctly, but not the second input click.
	 *
	 * In order to determine whether an input event is from a label click, we compare the (x, y) for
	 * the event to the (x, y) for the most recent label click (which is cleared whenever a non-label
	 * click occurs). Unfortunately, there are no event properties that tie the input and the label
	 * together (such as relatedTarget).
	 *
	 * @param {MouseEvent} event
	 * @returns {boolean}
	 */
	function isInputEventFromLabelClick(event) {
	  return lastLabelClickPos
	      && lastLabelClickPos.x === event.x
	      && lastLabelClickPos.y === event.y;
	}
	
	/*
	 * Update the given pointer based upon the given DOMEvent.
	 * Distance, velocity, direction, duration, etc
	 */
	function updatePointerState(ev, pointer) {
	  var point = getEventPoint(ev);
	  var x = pointer.x = point.pageX;
	  var y = pointer.y = point.pageY;
	
	  pointer.distanceX = x - pointer.startX;
	  pointer.distanceY = y - pointer.startY;
	  pointer.distance = Math.sqrt(
	    pointer.distanceX * pointer.distanceX + pointer.distanceY * pointer.distanceY
	  );
	
	  pointer.directionX = pointer.distanceX > 0 ? 'right' : pointer.distanceX < 0 ? 'left' : '';
	  pointer.directionY = pointer.distanceY > 0 ? 'down' : pointer.distanceY < 0 ? 'up' : '';
	
	  pointer.duration = +Date.now() - pointer.startTime;
	  pointer.velocityX = pointer.distanceX / pointer.duration;
	  pointer.velocityY = pointer.distanceY / pointer.duration;
	}
	
	/**
	 * Normalize the point where the DOM event happened whether it's touch or mouse.
	 * @returns point event obj with pageX and pageY on it.
	 */
	function getEventPoint(ev) {
	  ev = ev.originalEvent || ev; // support jQuery events
	  return (ev.touches && ev.touches[0]) ||
	    (ev.changedTouches && ev.changedTouches[0]) ||
	    ev;
	}
	
	/** Checks whether an element can be focused. */
	function canFocus(element) {
	  return (
	    !!element &&
	    element.getAttribute('tabindex') !== '-1' &&
	    !element.hasAttribute('disabled') &&
	    (
	      element.hasAttribute('tabindex') ||
	      element.hasAttribute('href') ||
	      element.isContentEditable ||
	      ['INPUT', 'SELECT', 'BUTTON', 'TEXTAREA', 'VIDEO', 'AUDIO'].indexOf(element.nodeName) !== -1
	    )
	  );
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.interaction
	 * @description
	 * User interaction detection to provide proper accessibility.
	 */
	MdInteractionService.$inject = ["$timeout", "$mdUtil", "$rootScope"];
	angular
	  .module('material.core.interaction', [])
	  .service('$mdInteraction', MdInteractionService);
	
	
	/**
	 * @ngdoc service
	 * @name $mdInteraction
	 * @module material.core.interaction
	 *
	 * @description
	 *
	 * Service which keeps track of the last interaction type and validates them for several browsers.
	 * The service hooks into the document's body and listens for touch, mouse and keyboard events.
	 *
	 * The most recent interaction type can be retrieved by calling the `getLastInteractionType` method.
	 *
	 * Here is an example markup for using the interaction service.
	 *
	 * <hljs lang="js">
	 *   var lastType = $mdInteraction.getLastInteractionType();
	 *
	 *   if (lastType === 'keyboard') {
	 *     // We only restore the focus for keyboard users.
	 *     restoreFocus();
	 *   }
	 * </hljs>
	 *
	 */
	function MdInteractionService($timeout, $mdUtil, $rootScope) {
	  this.$timeout = $timeout;
	  this.$mdUtil = $mdUtil;
	  this.$rootScope = $rootScope;
	
	  // IE browsers can also trigger pointer events, which also leads to an interaction.
	  this.pointerEvent = 'MSPointerEvent' in window ? 'MSPointerDown' : 'PointerEvent' in window ? 'pointerdown' : null;
	  this.bodyElement = angular.element(document.body);
	  this.isBuffering = false;
	  this.bufferTimeout = null;
	  this.lastInteractionType = null;
	  this.lastInteractionTime = null;
	  this.inputHandler = this.onInputEvent.bind(this);
	  this.bufferedInputHandler = this.onBufferInputEvent.bind(this);
	
	  // Type Mappings for the different events
	  // There will be three three interaction types
	  // `keyboard`, `mouse` and `touch`
	  // type `pointer` will be evaluated in `pointerMap` for IE Browser events
	  this.inputEventMap = {
	    'keydown': 'keyboard',
	    'mousedown': 'mouse',
	    'mouseenter': 'mouse',
	    'touchstart': 'touch',
	    'pointerdown': 'pointer',
	    'MSPointerDown': 'pointer'
	  };
	
	  // IE PointerDown events will be validated in `touch` or `mouse`
	  // Index numbers referenced here: https://msdn.microsoft.com/library/windows/apps/hh466130.aspx
	  this.iePointerMap = {
	    2: 'touch',
	    3: 'touch',
	    4: 'mouse'
	  };
	
	  this.initializeEvents();
	  this.$rootScope.$on('$destroy', this.deregister.bind(this));
	}
	
	/**
	 * Removes all event listeners created by $mdInteration on the
	 * body element.
	 */
	MdInteractionService.prototype.deregister = function() {
	
	    this.bodyElement.off('keydown mousedown', this.inputHandler);
	
	    if ('ontouchstart' in document.documentElement) {
	      this.bodyElement.off('touchstart', this.bufferedInputHandler);
	    }
	
	    if (this.pointerEvent) {
	      this.bodyElement.off(this.pointerEvent, this.inputHandler);
	    }
	
	};
	
	/**
	 * Initializes the interaction service, by registering all interaction events to the
	 * body element.
	 */
	MdInteractionService.prototype.initializeEvents = function() {
	
	  this.bodyElement.on('keydown mousedown', this.inputHandler);
	
	  if ('ontouchstart' in document.documentElement) {
	    this.bodyElement.on('touchstart', this.bufferedInputHandler);
	  }
	
	  if (this.pointerEvent) {
	    this.bodyElement.on(this.pointerEvent, this.inputHandler);
	  }
	
	};
	
	/**
	 * Event listener for normal interaction events, which should be tracked.
	 * @param event {MouseEvent|KeyboardEvent|PointerEvent|TouchEvent}
	 */
	MdInteractionService.prototype.onInputEvent = function(event) {
	  if (this.isBuffering) {
	    return;
	  }
	
	  var type = this.inputEventMap[event.type];
	
	  if (type === 'pointer') {
	    type = this.iePointerMap[event.pointerType] || event.pointerType;
	  }
	
	  this.lastInteractionType = type;
	  this.lastInteractionTime = this.$mdUtil.now();
	};
	
	/**
	 * Event listener for interaction events which should be buffered (touch events).
	 * @param event {TouchEvent}
	 */
	MdInteractionService.prototype.onBufferInputEvent = function(event) {
	  this.$timeout.cancel(this.bufferTimeout);
	
	  this.onInputEvent(event);
	  this.isBuffering = true;
	
	  // The timeout of 650ms is needed to delay the touchstart, because otherwise the touch will call
	  // the `onInput` function multiple times.
	  this.bufferTimeout = this.$timeout(function() {
	    this.isBuffering = false;
	  }.bind(this), 650, false);
	
	};
	
	/**
	 * @ngdoc method
	 * @name $mdInteraction#getLastInteractionType
	 * @description Retrieves the last interaction type triggered in body.
	 * @returns {string|null} Last interaction type.
	 */
	MdInteractionService.prototype.getLastInteractionType = function() {
	  return this.lastInteractionType;
	};
	
	/**
	 * @ngdoc method
	 * @name $mdInteraction#isUserInvoked
	 * @description Method to detect whether any interaction happened recently or not.
	 * @param {number=} checkDelay Time to check for any interaction to have been triggered.
	 * @returns {boolean} Whether there was any interaction or not.
	 */
	MdInteractionService.prototype.isUserInvoked = function(checkDelay) {
	  var delay = angular.isNumber(checkDelay) ? checkDelay : 15;
	
	  // Check for any interaction to be within the specified check time.
	  return this.lastInteractionTime >= this.$mdUtil.now() - delay;
	};
	
	})();
	(function(){
	"use strict";
	
	angular.module('material.core')
	  .provider('$$interimElement', InterimElementProvider);
	
	/**
	 * @ngdoc service
	 * @name $$interimElementProvider
	 * @module material.core.interimElement
	 *
	 * @description
	 *
	 * Factory that constructs `$$interimElement.$service` services.
	 * Used internally in material design for elements that appear on screen temporarily.
	 * The service provides a promise-like API for interacting with the temporary
	 * elements.
	 *
	 * <hljs lang="js">
	 *   app.service('$mdToast', function($$interimElement) {
	 *     var $mdToast = $$interimElement(toastDefaultOptions);
	 *     return $mdToast;
	 *   });
	 * </hljs>
	 *
	 * @param {object=} defaultOptions Options used by default for the `show` method on the service.
	 *
	 * @returns {$$interimElement.$service}
	 */
	
	function InterimElementProvider() {
	  InterimElementFactory.$inject = ["$document", "$q", "$rootScope", "$timeout", "$rootElement", "$animate", "$mdUtil", "$mdCompiler", "$mdTheming", "$injector", "$exceptionHandler"];
	  createInterimElementProvider.$get = InterimElementFactory;
	  return createInterimElementProvider;
	
	  /**
	   * Returns a new provider which allows configuration of a new interimElement
	   * service. Allows configuration of default options & methods for options,
	   * as well as configuration of 'preset' methods (eg dialog.basic(): basic is a preset method)
	   */
	  function createInterimElementProvider(interimFactoryName) {
	    factory.$inject = ["$$interimElement", "$injector"];
	    var EXPOSED_METHODS = ['onHide', 'onShow', 'onRemove'];
	
	    var customMethods = {};
	    var providerConfig = {
	      presets: {}
	    };
	
	    var provider = {
	      setDefaults: setDefaults,
	      addPreset: addPreset,
	      addMethod: addMethod,
	      $get: factory
	    };
	
	    /**
	     * all interim elements will come with the 'build' preset
	     */
	    provider.addPreset('build', {
	      methods: ['controller', 'controllerAs', 'resolve', 'multiple',
	        'template', 'templateUrl', 'themable', 'transformTemplate', 'parent', 'contentElement']
	    });
	
	    return provider;
	
	    /**
	     * Save the configured defaults to be used when the factory is instantiated
	     */
	    function setDefaults(definition) {
	      providerConfig.optionsFactory = definition.options;
	      providerConfig.methods = (definition.methods || []).concat(EXPOSED_METHODS);
	      return provider;
	    }
	
	    /**
	     * Add a method to the factory that isn't specific to any interim element operations
	     */
	    function addMethod(name, fn) {
	      customMethods[name] = fn;
	      return provider;
	    }
	
	    /**
	     * Save the configured preset to be used when the factory is instantiated
	     */
	    function addPreset(name, definition) {
	      definition = definition || {};
	      definition.methods = definition.methods || [];
	      definition.options = definition.options || function() { return {}; };
	
	      if (/^cancel|hide|show$/.test(name)) {
	        throw new Error("Preset '" + name + "' in " + interimFactoryName + " is reserved!");
	      }
	      if (definition.methods.indexOf('_options') > -1) {
	        throw new Error("Method '_options' in " + interimFactoryName + " is reserved!");
	      }
	      providerConfig.presets[name] = {
	        methods: definition.methods.concat(EXPOSED_METHODS),
	        optionsFactory: definition.options,
	        argOption: definition.argOption
	      };
	      return provider;
	    }
	
	    function addPresetMethod(presetName, methodName, method) {
	      providerConfig.presets[presetName][methodName] = method;
	    }
	
	    /**
	     * Create a factory that has the given methods & defaults implementing interimElement
	     */
	    /* @ngInject */
	    function factory($$interimElement, $injector) {
	      var defaultMethods;
	      var defaultOptions;
	      var interimElementService = $$interimElement();
	
	      /*
	       * publicService is what the developer will be using.
	       * It has methods hide(), cancel(), show(), build(), and any other
	       * presets which were set during the config phase.
	       */
	      var publicService = {
	        hide: interimElementService.hide,
	        cancel: interimElementService.cancel,
	        show: showInterimElement,
	
	        // Special internal method to destroy an interim element without animations
	        // used when navigation changes causes a $scope.$destroy() action
	        destroy : destroyInterimElement
	      };
	
	
	      defaultMethods = providerConfig.methods || [];
	      // This must be invoked after the publicService is initialized
	      defaultOptions = invokeFactory(providerConfig.optionsFactory, {});
	
	      // Copy over the simple custom methods
	      angular.forEach(customMethods, function(fn, name) {
	        publicService[name] = fn;
	      });
	
	      angular.forEach(providerConfig.presets, function(definition, name) {
	        var presetDefaults = invokeFactory(definition.optionsFactory, {});
	        var presetMethods = (definition.methods || []).concat(defaultMethods);
	
	        // Every interimElement built with a preset has a field called `$type`,
	        // which matches the name of the preset.
	        // Eg in preset 'confirm', options.$type === 'confirm'
	        angular.extend(presetDefaults, { $type: name });
	
	        // This creates a preset class which has setter methods for every
	        // method given in the `.addPreset()` function, as well as every
	        // method given in the `.setDefaults()` function.
	        //
	        // @example
	        // .setDefaults({
	        //   methods: ['hasBackdrop', 'clickOutsideToClose', 'escapeToClose', 'targetEvent'],
	        //   options: dialogDefaultOptions
	        // })
	        // .addPreset('alert', {
	        //   methods: ['title', 'ok'],
	        //   options: alertDialogOptions
	        // })
	        //
	        // Set values will be passed to the options when interimElement.show() is called.
	        function Preset(opts) {
	          this._options = angular.extend({}, presetDefaults, opts);
	        }
	        angular.forEach(presetMethods, function(name) {
	          Preset.prototype[name] = function(value) {
	            this._options[name] = value;
	            return this;
	          };
	        });
	
	        // Create shortcut method for one-linear methods
	        if (definition.argOption) {
	          var methodName = 'show' + name.charAt(0).toUpperCase() + name.slice(1);
	          publicService[methodName] = function(arg) {
	            var config = publicService[name](arg);
	            return publicService.show(config);
	          };
	        }
	
	        // eg $mdDialog.alert() will return a new alert preset
	        publicService[name] = function(arg) {
	          // If argOption is supplied, eg `argOption: 'content'`, then we assume
	          // if the argument is not an options object then it is the `argOption` option.
	          //
	          // @example `$mdToast.simple('hello')` // sets options.content to hello
	          //                                     // because argOption === 'content'
	          if (arguments.length && definition.argOption &&
	              !angular.isObject(arg) && !angular.isArray(arg))  {
	
	            return (new Preset())[definition.argOption](arg);
	
	          } else {
	            return new Preset(arg);
	          }
	
	        };
	      });
	
	      return publicService;
	
	      /**
	       *
	       */
	      function showInterimElement(opts) {
	        // opts is either a preset which stores its options on an _options field,
	        // or just an object made up of options
	        opts = opts || { };
	        if (opts._options) opts = opts._options;
	
	        return interimElementService.show(
	          angular.extend({}, defaultOptions, opts)
	        );
	      }
	
	      /**
	       *  Special method to hide and destroy an interimElement WITHOUT
	       *  any 'leave` or hide animations ( an immediate force hide/remove )
	       *
	       *  NOTE: This calls the onRemove() subclass method for each component...
	       *  which must have code to respond to `options.$destroy == true`
	       */
	      function destroyInterimElement(opts) {
	          return interimElementService.destroy(opts);
	      }
	
	      /**
	       * Helper to call $injector.invoke with a local of the factory name for
	       * this provider.
	       * If an $mdDialog is providing options for a dialog and tries to inject
	       * $mdDialog, a circular dependency error will happen.
	       * We get around that by manually injecting $mdDialog as a local.
	       */
	      function invokeFactory(factory, defaultVal) {
	        var locals = {};
	        locals[interimFactoryName] = publicService;
	        return $injector.invoke(factory || function() { return defaultVal; }, {}, locals);
	      }
	    }
	  }
	
	  /* @ngInject */
	  function InterimElementFactory($document, $q, $rootScope, $timeout, $rootElement, $animate,
	                                 $mdUtil, $mdCompiler, $mdTheming, $injector, $exceptionHandler) {
	    return function createInterimElementService() {
	      var SHOW_CANCELLED = false;
	
	      /**
	       * @ngdoc service
	       * @name $$interimElementProvider.$service
	       *
	       * @description
	       * A service used to control inserting and removing of an element from the DOM.
	       * It is used by $mdBottomSheet, $mdDialog, $mdToast, $mdMenu, $mdPanel, and $mdSelect.
	       */
	      var service;
	
	      var showPromises = []; // Promises for the interim's which are currently opening.
	      var hidePromises = []; // Promises for the interim's which are currently hiding.
	      var showingInterims = []; // Interim elements which are currently showing up.
	
	      // Publish instance $$interimElement service;
	      return service = {
	        show: show,
	        hide: waitForInterim(hide),
	        cancel: waitForInterim(cancel),
	        destroy : destroy,
	        $injector_: $injector
	      };
	
	      /**
	       * @ngdoc method
	       * @name $$interimElementProvider.$service#show
	       * @kind function
	       *
	       * @description
	       * Adds the `$interimElement` to the DOM and returns a special promise that will be resolved
	       * or rejected with hide or cancel, respectively.
	       *
	       * @param {object} options map of options and values
	       * @returns {Promise} a Promise that will be resolved when hide() is called or rejected when
	       *  cancel() is called.
	       */
	      function show(options) {
	        options = options || {};
	        var interimElement = new InterimElement(options || {});
	
	        // When an interim element is currently showing, we have to cancel it.
	        // Just hiding it, will resolve the InterimElement's promise, the promise should be
	        // rejected instead.
	        var hideAction = options.multiple ? $q.resolve() : $q.all(showPromises);
	
	        if (!options.multiple) {
	          // Wait for all opening interim's to finish their transition.
	          hideAction = hideAction.then(function() {
	            // Wait for all closing and showing interim's to be completely closed.
	            var promiseArray = hidePromises.concat(showingInterims.map(service.cancel));
	            return $q.all(promiseArray);
	          });
	        }
	
	        var showAction = hideAction.then(function() {
	
	          return interimElement
	            .show()
	            .then(function () {
	              showingInterims.push(interimElement);
	            })
	            .catch(function (reason) {
	              return reason;
	            })
	            .finally(function() {
	              showPromises.splice(showPromises.indexOf(showAction), 1);
	            });
	
	        });
	
	        showPromises.push(showAction);
	
	        // In AngularJS 1.6+, exceptions inside promises will cause a rejection. We need to handle
	        // the rejection and only log it if it's an error.
	        interimElement.deferred.promise.catch(function(fault) {
	          if (fault instanceof Error) {
	            $exceptionHandler(fault);
	          }
	
	          return fault;
	        });
	
	        // Return a promise that will be resolved when the interim
	        // element is hidden or cancelled...
	        return interimElement.deferred.promise;
	      }
	
	      /**
	       * @ngdoc method
	       * @name $$interimElementProvider.$service#hide
	       * @kind function
	       *
	       * @description
	       * Removes the `$interimElement` from the DOM and resolves the Promise returned from `show()`.
	       *
	       * @param {*} reason Data used to resolve the Promise
	       * @param {object} options map of options and values
	       * @returns {Promise} a Promise that will be resolved after the element has been removed
	       *  from the DOM.
	       */
	      function hide(reason, options) {
	        options = options || {};
	
	        if (options.closeAll) {
	          // We have to make a shallow copy of the array, because otherwise the map will break.
	          return $q.all(showingInterims.slice().reverse().map(closeElement));
	        } else if (options.closeTo !== undefined) {
	          return $q.all(showingInterims.slice(options.closeTo).map(closeElement));
	        }
	
	        // Hide the latest showing interim element.
	        return closeElement(showingInterims[showingInterims.length - 1]);
	
	        /**
	         * @param {InterimElement} interim element to close
	         * @returns {Promise<InterimElement>}
	         */
	        function closeElement(interim) {
	          if (!interim) {
	            return $q.when(reason);
	          }
	
	          var hideAction = interim
	            .remove(reason, false, options || { })
	            .catch(function(reason) { return reason; })
	            .finally(function() {
	              hidePromises.splice(hidePromises.indexOf(hideAction), 1);
	            });
	
	          showingInterims.splice(showingInterims.indexOf(interim), 1);
	          hidePromises.push(hideAction);
	
	          return interim.deferred.promise;
	        }
	      }
	
	      /**
	       * @ngdoc method
	       * @name $$interimElementProvider.$service#cancel
	       * @kind function
	       *
	       * @description
	       * Removes the `$interimElement` from the DOM and rejects the Promise returned from `show()`.
	       *
	       * @param {*} reason Data used to resolve the Promise
	       * @param {object} options map of options and values
	       * @returns {Promise} Promise that will be resolved after the element has been removed
	       *  from the DOM.
	       */
	      function cancel(reason, options) {
	        var interim = showingInterims.pop();
	        if (!interim) {
	          return $q.when(reason);
	        }
	
	        var cancelAction = interim
	          .remove(reason, true, options || {})
	          .catch(function(reason) { return reason; })
	          .finally(function() {
	            hidePromises.splice(hidePromises.indexOf(cancelAction), 1);
	          });
	
	        hidePromises.push(cancelAction);
	
	        // Since AngularJS 1.6.7, promises will be logged to $exceptionHandler when the promise
	        // is not handling the rejection. We create a pseudo catch handler, which will prevent the
	        // promise from being logged to the $exceptionHandler.
	        return interim.deferred.promise.catch(angular.noop);
	      }
	
	      /**
	       * Creates a function to wait for at least one interim element to be available.
	       * @param callbackFn Function to be used as callback
	       * @returns {Function}
	       */
	      function waitForInterim(callbackFn) {
	        return function() {
	          var fnArguments = arguments;
	
	          if (!showingInterims.length) {
	            // When there are still interim's opening, then wait for the first interim element to
	            // finish its open animation.
	            if (showPromises.length) {
	              return showPromises[0].finally(function () {
	                return callbackFn.apply(service, fnArguments);
	              });
	            }
	
	            return $q.when("No interim elements currently showing up.");
	          }
	
	          return callbackFn.apply(service, fnArguments);
	        };
	      }
	
	      /**
	       * @ngdoc method
	       * @name $$interimElementProvider.$service#destroy
	       * @kind function
	       *
	       * Special method to quick-remove the interim element without running animations. This is
	       * useful when the parent component has been or is being destroyed.
	       *
	       * Note: interim elements are in "interim containers".
	       */
	      function destroy(targetEl) {
	        var interim = !targetEl ? showingInterims.shift() : null;
	
	        var parentEl = angular.element(targetEl).length && angular.element(targetEl)[0].parentNode;
	
	        if (parentEl) {
	          // Try to find the interim in the stack which corresponds to the supplied DOM element.
	          var filtered = showingInterims.filter(function(entry) {
	            return entry.options.element[0] === parentEl;
	          });
	
	          // Note: This function might be called when the element already has been removed,
	          // in which case we won't find any matches.
	          if (filtered.length) {
	            interim = filtered[0];
	            showingInterims.splice(showingInterims.indexOf(interim), 1);
	          }
	        }
	
	        return interim ? interim.remove(SHOW_CANCELLED, false, { '$destroy': true }) :
	                         $q.when(SHOW_CANCELLED);
	      }
	
	      /*
	       * Internal Interim Element Object
	       * Used internally to manage the DOM element and related data
	       */
	      function InterimElement(options) {
	        var self, element, showAction = $q.when(true);
	
	        options = configureScopeAndTransitions(options);
	
	        return self = {
	          options : options,
	          deferred: $q.defer(),
	          show    : createAndTransitionIn,
	          remove  : transitionOutAndRemove
	        };
	
	        /**
	         * Compile, link, and show this interim element
	         * Use optional autoHided and transition-in effects
	         */
	        function createAndTransitionIn() {
	          return $q(function(resolve, reject) {
	
	            // Trigger onCompiling callback before the compilation starts.
	            // This is useful, when modifying options, which can be influenced by developers.
	            options.onCompiling && options.onCompiling(options);
	
	            compileElement(options)
	              .then(function(compiledData) {
	                element = linkElement(compiledData, options);
	
	                // Expose the cleanup function from the compiler.
	                options.cleanupElement = compiledData.cleanup;
	
	                showAction = showElement(element, options, compiledData.controller)
	                  .then(resolve, rejectAll);
	              }).catch(rejectAll);
	
	            function rejectAll(fault) {
	              // Force the '$md<xxx>.show()' promise to reject
	              self.deferred.reject(fault);
	
	              // Continue rejection propagation
	              reject(fault);
	            }
	          });
	        }
	
	        /**
	         * After the show process has finished/rejected:
	         * - announce 'removing',
	         * - perform the transition-out, and
	         * - perform optional clean up scope.
	         */
	        function transitionOutAndRemove(response, isCancelled, opts) {
	
	          // abort if the show() and compile failed
	          if (!element) return $q.when(false);
	
	          options = angular.extend(options || {}, opts || {});
	          options.cancelAutoHide && options.cancelAutoHide();
	          options.element.triggerHandler('$mdInterimElementRemove');
	
	          if (options.$destroy === true) {
	
	            return hideElement(options.element, options).then(function(){
	              (isCancelled && rejectAll(response)) || resolveAll(response);
	            });
	
	          } else {
	            $q.when(showAction).finally(function() {
	              hideElement(options.element, options).then(function() {
	                isCancelled ? rejectAll(response) : resolveAll(response);
	              }, rejectAll);
	            });
	
	            return self.deferred.promise;
	          }
	
	
	          /**
	           * The `show()` returns a promise that will be resolved when the interim
	           * element is hidden or cancelled...
	           */
	          function resolveAll(response) {
	            self.deferred.resolve(response);
	          }
	
	          /**
	           * Force the '$md<xxx>.show()' promise to reject
	           */
	          function rejectAll(fault) {
	            self.deferred.reject(fault);
	          }
	        }
	
	        /**
	         * Prepare optional isolated scope and prepare $animate with default enter and leave
	         * transitions for the new element instance.
	         */
	        function configureScopeAndTransitions(options) {
	          options = options || { };
	          if (options.template) {
	            options.template = $mdUtil.processTemplate(options.template);
	          }
	
	          return angular.extend({
	            preserveScope: false,
	            cancelAutoHide : angular.noop,
	            scope: options.scope || $rootScope.$new(options.isolateScope),
	
	            /**
	             * Default usage to enable $animate to transition-in; can be easily overridden via 'options'
	             */
	            onShow: function transitionIn(scope, element, options) {
	              return $animate.enter(element, options.parent);
	            },
	
	            /**
	             * Default usage to enable $animate to transition-out; can be easily overridden via 'options'
	             */
	            onRemove: function transitionOut(scope, element) {
	              // Element could be undefined if a new element is shown before
	              // the old one finishes compiling.
	              return element && $animate.leave(element) || $q.when();
	            }
	          }, options);
	
	        }
	
	        /**
	         * Compile an element with a templateUrl, controller, and locals
	         */
	        function compileElement(options) {
	
	          var compiled = !options.skipCompile ? $mdCompiler.compile(options) : null;
	
	          return compiled || $q(function (resolve) {
	              resolve({
	                locals: {},
	                link: function () {
	                  return options.element;
	                }
	              });
	            });
	        }
	
	        /**
	         *  Link an element with compiled configuration
	         */
	        function linkElement(compileData, options){
	          angular.extend(compileData.locals, options);
	
	          var element = compileData.link(options.scope);
	
	          // Search for parent at insertion time, if not specified
	          options.element = element;
	          options.parent = findParent(element, options);
	          if (options.themable) $mdTheming(element);
	
	          return element;
	        }
	
	        /**
	         * Search for parent at insertion time, if not specified
	         */
	        function findParent(element, options) {
	          var parent = options.parent;
	
	          // Search for parent at insertion time, if not specified
	          if (angular.isFunction(parent)) {
	            parent = parent(options.scope, element, options);
	          } else if (angular.isString(parent)) {
	            parent = angular.element($document[0].querySelector(parent));
	          } else {
	            parent = angular.element(parent);
	          }
	
	          // If parent querySelector/getter function fails, or it's just null,
	          // find a default.
	          if (!(parent || {}).length) {
	            var el;
	            if ($rootElement[0] && $rootElement[0].querySelector) {
	              el = $rootElement[0].querySelector(':not(svg) > body');
	            }
	            if (!el) el = $rootElement[0];
	            if (el.nodeName == '#comment') {
	              el = $document[0].body;
	            }
	            return angular.element(el);
	          }
	
	          return parent;
	        }
	
	        /**
	         * If auto-hide is enabled, start timer and prepare cancel function
	         */
	        function startAutoHide() {
	          var autoHideTimer, cancelAutoHide = angular.noop;
	
	          if (options.hideDelay) {
	            autoHideTimer = $timeout(service.hide, options.hideDelay) ;
	            cancelAutoHide = function() {
	              $timeout.cancel(autoHideTimer);
	            };
	          }
	
	          // Cache for subsequent use
	          options.cancelAutoHide = function() {
	            cancelAutoHide();
	            options.cancelAutoHide = undefined;
	          };
	        }
	
	        /**
	         * Show the element ( with transitions), notify complete and start
	         * optional auto-Hide
	         */
	        function showElement(element, options, controller) {
	          // Trigger onShowing callback before the `show()` starts
	          var notifyShowing = options.onShowing || angular.noop;
	          // Trigger onComplete callback when the `show()` finishes
	          var notifyComplete = options.onComplete || angular.noop;
	
	          // Necessary for consistency between AngularJS 1.5 and 1.6.
	          try {
	            notifyShowing(options.scope, element, options, controller);
	          } catch (e) {
	            return $q.reject(e);
	          }
	
	          return $q(function (resolve, reject) {
	            try {
	              // Start transitionIn
	              $q.when(options.onShow(options.scope, element, options, controller))
	                .then(function () {
	                  notifyComplete(options.scope, element, options);
	                  startAutoHide();
	
	                  resolve(element);
	                }, reject);
	
	            } catch (e) {
	              reject(e.message);
	            }
	          });
	        }
	
	        function hideElement(element, options) {
	          var announceRemoving = options.onRemoving || angular.noop;
	
	          return $q(function (resolve, reject) {
	            try {
	              // Start transitionIn
	              var action = $q.when(options.onRemove(options.scope, element, options) || true);
	
	              // Trigger callback *before* the remove operation starts
	              announceRemoving(element, action);
	
	              if (options.$destroy) {
	                // For $destroy, onRemove should be synchronous
	                resolve(element);
	
	                if (!options.preserveScope && options.scope) {
	                  // scope destroy should still be be done after the current digest is done
	                  action.then(function() { options.scope.$destroy(); });
	                }
	              } else {
	                // Wait until transition-out is done
	                action.then(function () {
	                  if (!options.preserveScope && options.scope) {
	                    options.scope.$destroy();
	                  }
	
	                  resolve(element);
	                }, reject);
	              }
	            } catch (e) {
	              reject(e.message);
	            }
	          });
	        }
	
	      }
	    };
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  var $mdUtil, $interpolate, $log;
	
	  var SUFFIXES = /(-gt)?-(sm|md|lg|print)/g;
	  var WHITESPACE = /\s+/g;
	
	  var FLEX_OPTIONS = ['grow', 'initial', 'auto', 'none', 'noshrink', 'nogrow'];
	  var LAYOUT_OPTIONS = ['row', 'column'];
	  var ALIGNMENT_MAIN_AXIS= ["", "start", "center", "end", "stretch", "space-around", "space-between"];
	  var ALIGNMENT_CROSS_AXIS= ["", "start", "center", "end", "stretch"];
	
	  var config = {
	    /**
	     * Enable directive attribute-to-class conversions
	     * Developers can use `<body md-layout-css />` to quickly
	     * disable the Layout directives and prohibit the injection of Layout classNames
	     */
	    enabled: true,
	
	    /**
	     * List of mediaQuery breakpoints and associated suffixes
	     *
	     *   [
	     *    { suffix: "sm", mediaQuery: "screen and (max-width: 599px)" },
	     *    { suffix: "md", mediaQuery: "screen and (min-width: 600px) and (max-width: 959px)" }
	     *   ]
	     */
	    breakpoints: []
	  };
	
	  registerLayoutAPI(angular.module('material.core.layout', ['ng']));
	
	  /**
	   *   registerLayoutAPI()
	   *
	   *   The original AngularJS Material Layout solution used attribute selectors and CSS.
	   *
	   *  ```html
	   *  <div layout="column"> My Content </div>
	   *  ```
	   *
	   *  ```css
	   *  [layout] {
	   *    box-sizing: border-box;
	   *    display:flex;
	   *  }
	   *  [layout=column] {
	   *    flex-direction : column
	   *  }
	   *  ```
	   *
	   *  Use of attribute selectors creates significant performance impacts in some
	   *  browsers... mainly IE.
	   *
	   *  This module registers directives that allow the same layout attributes to be
	   *  interpreted and converted to class selectors. The directive will add equivalent classes to each element that
	   *  contains a Layout directive.
	   *
	   * ```html
	   *   <div layout="column" class="layout layout-column"> My Content </div>
	   *```
	   *
	   *  ```css
	   *  .layout {
	   *    box-sizing: border-box;
	   *    display:flex;
	   *  }
	   *  .layout-column {
	   *    flex-direction : column
	   *  }
	   *  ```
	   */
	  function registerLayoutAPI(module){
	    var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
	    var SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g;
	
	    // NOTE: these are also defined in constants::MEDIA_PRIORITY and constants::MEDIA
	    var BREAKPOINTS     = ["", "xs", "gt-xs", "sm", "gt-sm", "md", "gt-md", "lg", "gt-lg", "xl", "print"];
	    var API_WITH_VALUES = ["layout", "flex", "flex-order", "flex-offset", "layout-align"];
	    var API_NO_VALUES   = ["show", "hide", "layout-padding", "layout-margin"];
	
	
	    // Build directive registration functions for the standard Layout API... for all breakpoints.
	    angular.forEach(BREAKPOINTS, function(mqb) {
	
	      // Attribute directives with expected, observable value(s)
	      angular.forEach(API_WITH_VALUES, function(name){
	        var fullName = mqb ? name + "-" + mqb : name;
	        module.directive(directiveNormalize(fullName), attributeWithObserve(fullName));
	      });
	
	      // Attribute directives with no expected value(s)
	      angular.forEach(API_NO_VALUES, function(name){
	        var fullName = mqb ? name + "-" + mqb : name;
	        module.directive(directiveNormalize(fullName), attributeWithoutValue(fullName));
	      });
	
	    });
	
	    // Register other, special directive functions for the Layout features:
	    module
	
	      .provider('$$mdLayout'     , function() {
	        // Publish internal service for Layouts
	        return {
	          $get : angular.noop,
	          validateAttributeValue : validateAttributeValue,
	          validateAttributeUsage : validateAttributeUsage,
	          /**
	           * Easy way to disable/enable the Layout API.
	           * When disabled, this stops all attribute-to-classname generations
	           */
	          disableLayouts  : function(isDisabled) {
	            config.enabled =  (isDisabled !== true);
	          }
	        };
	      })
	
	      .directive('mdLayoutCss'        , disableLayoutDirective)
	      .directive('ngCloak'            , buildCloakInterceptor('ng-cloak'))
	
	      .directive('layoutWrap'   , attributeWithoutValue('layout-wrap'))
	      .directive('layoutNowrap' , attributeWithoutValue('layout-nowrap'))
	      .directive('layoutNoWrap' , attributeWithoutValue('layout-no-wrap'))
	      .directive('layoutFill'   , attributeWithoutValue('layout-fill'))
	
	      // !! Deprecated attributes: use the `-lt` (aka less-than) notations
	
	      .directive('layoutLtMd'     , warnAttrNotSupported('layout-lt-md', true))
	      .directive('layoutLtLg'     , warnAttrNotSupported('layout-lt-lg', true))
	      .directive('flexLtMd'       , warnAttrNotSupported('flex-lt-md', true))
	      .directive('flexLtLg'       , warnAttrNotSupported('flex-lt-lg', true))
	
	      .directive('layoutAlignLtMd', warnAttrNotSupported('layout-align-lt-md'))
	      .directive('layoutAlignLtLg', warnAttrNotSupported('layout-align-lt-lg'))
	      .directive('flexOrderLtMd'  , warnAttrNotSupported('flex-order-lt-md'))
	      .directive('flexOrderLtLg'  , warnAttrNotSupported('flex-order-lt-lg'))
	      .directive('offsetLtMd'     , warnAttrNotSupported('flex-offset-lt-md'))
	      .directive('offsetLtLg'     , warnAttrNotSupported('flex-offset-lt-lg'))
	
	      .directive('hideLtMd'       , warnAttrNotSupported('hide-lt-md'))
	      .directive('hideLtLg'       , warnAttrNotSupported('hide-lt-lg'))
	      .directive('showLtMd'       , warnAttrNotSupported('show-lt-md'))
	      .directive('showLtLg'       , warnAttrNotSupported('show-lt-lg'))
	
	      // Determine if
	      .config(detectDisabledLayouts);
	
	    /**
	     * Converts snake_case to camelCase.
	     * Also there is special case for Moz prefix starting with upper case letter.
	     * @param name Name to normalize
	     */
	    function directiveNormalize(name) {
	      return name
	        .replace(PREFIX_REGEXP, '')
	        .replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	          return offset ? letter.toUpperCase() : letter;
	        });
	    }
	
	  }
	
	
	  /**
	    * Detect if any of the HTML tags has a [md-layouts-disabled] attribute;
	    * If yes, then immediately disable all layout API features
	    *
	    * Note: this attribute should be specified on either the HTML or BODY tags
	    */
	   /**
	    * @ngInject
	    */
	   function detectDisabledLayouts() {
	     var isDisabled = !!document.querySelector('[md-layouts-disabled]');
	     config.enabled = !isDisabled;
	   }
	
	  /**
	   * Special directive that will disable ALL Layout conversions of layout
	   * attribute(s) to classname(s).
	   *
	   * <link rel="stylesheet" href="angular-material.min.css">
	   * <link rel="stylesheet" href="angular-material.layout.css">
	   *
	   * <body md-layout-css>
	   *  ...
	   * </body>
	   *
	   * Note: Using md-layout-css directive requires the developer to load the Material
	   * Layout Attribute stylesheet (which only uses attribute selectors):
	   *
	   *       `angular-material.layout.css`
	   *
	   * Another option is to use the LayoutProvider to configure and disable the attribute
	   * conversions; this would obviate the use of the `md-layout-css` directive
	   *
	   */
	  function disableLayoutDirective() {
	    // Return a 1x-only, first-match attribute directive
	    config.enabled = false;
	
	    return {
	      restrict : 'A',
	      priority : '900'
	    };
	  }
	
	  /**
	   * Tail-hook ngCloak to delay the uncloaking while Layout transformers
	   * finish processing. Eliminates flicker with Material.Layouts
	   */
	  function buildCloakInterceptor(className) {
	    return ['$timeout', function($timeout){
	      return {
	        restrict : 'A',
	        priority : -10,   // run after normal ng-cloak
	        compile  : function(element) {
	          if (!config.enabled) return angular.noop;
	
	          // Re-add the cloak
	          element.addClass(className);
	
	          return function(scope, element) {
	            // Wait while layout injectors configure, then uncloak
	            // NOTE: $rAF does not delay enough... and this is a 1x-only event,
	            //       $timeout is acceptable.
	            $timeout(function(){
	              element.removeClass(className);
	            }, 10, false);
	          };
	        }
	      };
	    }];
	  }
	
	
	  // *********************************************************************************
	  //
	  // These functions create registration functions for AngularJS Material Layout attribute directives
	  // This provides easy translation to switch AngularJS Material attribute selectors to
	  // CLASS selectors and directives; which has huge performance implications
	  // for IE Browsers
	  //
	  // *********************************************************************************
	
	  /**
	   * Creates a directive registration function where a possible dynamic attribute
	   * value will be observed/watched.
	   * @param {string} className attribute name; eg `layout-gt-md` with value ="row"
	   */
	  function attributeWithObserve(className) {
	
	    return ['$mdUtil', '$interpolate', "$log", function(_$mdUtil_, _$interpolate_, _$log_) {
	      $mdUtil = _$mdUtil_;
	      $interpolate = _$interpolate_;
	      $log = _$log_;
	
	      return {
	        restrict: 'A',
	        compile: function(element, attr) {
	          var linkFn;
	          if (config.enabled) {
	            // immediately replace static (non-interpolated) invalid values...
	
	            validateAttributeUsage(className, attr, element, $log);
	
	            validateAttributeValue(className,
	              getNormalizedAttrValue(className, attr, ""),
	              buildUpdateFn(element, className, attr)
	            );
	
	            linkFn = translateWithValueToCssClass;
	          }
	
	          // Use for postLink to account for transforms after ng-transclude.
	          return linkFn || angular.noop;
	        }
	      };
	    }];
	
	    /**
	     * Add as transformed class selector(s), then
	     * remove the deprecated attribute selector
	     */
	    function translateWithValueToCssClass(scope, element, attrs) {
	      var updateFn = updateClassWithValue(element, className, attrs);
	      var unwatch = attrs.$observe(attrs.$normalize(className), updateFn);
	
	      updateFn(getNormalizedAttrValue(className, attrs, ""));
	      scope.$on("$destroy", function() { unwatch(); });
	    }
	  }
	
	  /**
	   * Creates a registration function for AngularJS Material Layout attribute directive.
	   * This is a `simple` transpose of attribute usage to class usage; where we ignore
	   * any attribute value
	   */
	  function attributeWithoutValue(className) {
	    return ['$mdUtil', '$interpolate', "$log", function(_$mdUtil_, _$interpolate_, _$log_) {
	      $mdUtil = _$mdUtil_;
	      $interpolate = _$interpolate_;
	      $log = _$log_;
	
	      return {
	        restrict: 'A',
	        compile: function(element, attr) {
	          var linkFn;
	          if (config.enabled) {
	            // immediately replace static (non-interpolated) invalid values...
	
	            validateAttributeValue(className,
	              getNormalizedAttrValue(className, attr, ""),
	              buildUpdateFn(element, className, attr)
	            );
	
	            translateToCssClass(null, element);
	
	            // Use for postLink to account for transforms after ng-transclude.
	            linkFn = translateToCssClass;
	          }
	
	          return linkFn || angular.noop;
	        }
	      };
	    }];
	
	    /**
	     * Add as transformed class selector, then
	     * remove the deprecated attribute selector
	     */
	    function translateToCssClass(scope, element) {
	      element.addClass(className);
	    }
	  }
	
	
	
	  /**
	   * After link-phase, do NOT remove deprecated layout attribute selector.
	   * Instead watch the attribute so interpolated data-bindings to layout
	   * selectors will continue to be supported.
	   *
	   * $observe() the className and update with new class (after removing the last one)
	   *
	   * e.g. `layout="{{layoutDemo.direction}}"` will update...
	   *
	   * NOTE: The value must match one of the specified styles in the CSS.
	   * For example `flex-gt-md="{{size}}`  where `scope.size == 47` will NOT work since
	   * only breakpoints for 0, 5, 10, 15... 100, 33, 34, 66, 67 are defined.
	   *
	   */
	  function updateClassWithValue(element, className) {
	    var lastClass;
	
	    return function updateClassFn(newValue) {
	      var value = validateAttributeValue(className, newValue || "");
	      if (angular.isDefined(value)) {
	        if (lastClass) element.removeClass(lastClass);
	        lastClass = !value ? className : className + "-" + value.trim().replace(WHITESPACE, "-");
	        element.addClass(lastClass);
	      }
	    };
	  }
	
	  /**
	   * Provide console warning that this layout attribute has been deprecated
	   *
	   */
	  function warnAttrNotSupported(className) {
	    var parts = className.split("-");
	    return ["$log", function($log) {
	      $log.warn(className + "has been deprecated. Please use a `" + parts[0] + "-gt-<xxx>` variant.");
	      return angular.noop;
	    }];
	  }
	
	  /**
	   * Centralize warnings for known flexbox issues (especially IE-related issues)
	   */
	  function validateAttributeUsage(className, attr, element, $log){
	    var message, usage, url;
	    var nodeName = element[0].nodeName.toLowerCase();
	
	    switch (className.replace(SUFFIXES,"")) {
	      case "flex":
	        if ((nodeName == "md-button") || (nodeName == "fieldset")){
	          // @see https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers
	          // Use <div flex> wrapper inside (preferred) or outside
	
	          usage = "<" + nodeName + " " + className + "></" + nodeName + ">";
	          url = "https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers";
	          message = "Markup '{0}' may not work as expected in IE Browsers. Consult '{1}' for details.";
	
	          $log.warn($mdUtil.supplant(message, [usage, url]));
	        }
	    }
	
	  }
	
	
	  /**
	   * For the Layout attribute value, validate or replace with default
	   * fallback value
	   */
	  function validateAttributeValue(className, value, updateFn) {
	    var origValue = value;
	
	    if (!needsInterpolation(value)) {
	      switch (className.replace(SUFFIXES,"")) {
	        case 'layout'        :
	          if (!findIn(value, LAYOUT_OPTIONS)) {
	            value = LAYOUT_OPTIONS[0];    // 'row';
	          }
	          break;
	
	        case 'flex'          :
	          if (!findIn(value, FLEX_OPTIONS)) {
	            if (isNaN(value)) {
	              value = '';
	            }
	          }
	          break;
	
	        case 'flex-offset' :
	        case 'flex-order'    :
	          if (!value || isNaN(+value)) {
	            value = '0';
	          }
	          break;
	
	        case 'layout-align'  :
	          var axis = extractAlignAxis(value);
	          value = $mdUtil.supplant("{main}-{cross}",axis);
	          break;
	
	        case 'layout-padding' :
	        case 'layout-margin'  :
	        case 'layout-fill'    :
	        case 'layout-wrap'    :
	        case 'layout-nowrap' :
	          value = '';
	          break;
	      }
	
	      if (value != origValue) {
	        (updateFn || angular.noop)(value);
	      }
	    }
	
	    return value ? value.trim() : "";
	  }
	
	  /**
	   * Replace current attribute value with fallback value
	   */
	  function buildUpdateFn(element, className, attrs) {
	    return function updateAttrValue(fallback) {
	      if (!needsInterpolation(fallback)) {
	        // Do not modify the element's attribute value; so
	        // uses '<ui-layout layout="/api/sidebar.html" />' will not
	        // be affected. Just update the attrs value.
	        attrs[attrs.$normalize(className)] = fallback;
	      }
	    };
	  }
	
	  /**
	   * See if the original value has interpolation symbols:
	   * e.g.  flex-gt-md="{{triggerPoint}}"
	   */
	  function needsInterpolation(value) {
	    return (value || "").indexOf($interpolate.startSymbol()) > -1;
	  }
	
	  function getNormalizedAttrValue(className, attrs, defaultVal) {
	    var normalizedAttr = attrs.$normalize(className);
	    return attrs[normalizedAttr] ? attrs[normalizedAttr].trim().replace(WHITESPACE, "-") : defaultVal || null;
	  }
	
	  function findIn(item, list, replaceWith) {
	    item = replaceWith && item ? item.replace(WHITESPACE, replaceWith) : item;
	
	    var found = false;
	    if (item) {
	      list.forEach(function(it) {
	        it = replaceWith ? it.replace(WHITESPACE, replaceWith) : it;
	        found = found || (it === item);
	      });
	    }
	    return found;
	  }
	
	  function extractAlignAxis(attrValue) {
	    var axis = {
	      main : "start",
	      cross: "stretch"
	    }, values;
	
	    attrValue = (attrValue || "");
	
	    if (attrValue.indexOf("-") === 0 || attrValue.indexOf(" ") === 0) {
	      // For missing main-axis values
	      attrValue = "none" + attrValue;
	    }
	
	    values = attrValue.toLowerCase().trim().replace(WHITESPACE, "-").split("-");
	    if (values.length && (values[0] === "space")) {
	      // for main-axis values of "space-around" or "space-between"
	      values = [values[0]+"-"+values[1],values[2]];
	    }
	
	    if (values.length > 0) axis.main  = values[0] || axis.main;
	    if (values.length > 1) axis.cross = values[1] || axis.cross;
	
	    if (ALIGNMENT_MAIN_AXIS.indexOf(axis.main) < 0)   axis.main = "start";
	    if (ALIGNMENT_CROSS_AXIS.indexOf(axis.cross) < 0) axis.cross = "stretch";
	
	    return axis;
	  }
	
	
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.liveannouncer
	 * @description
	 * AngularJS Material Live Announcer to provide accessibility for Voice Readers.
	 */
	MdLiveAnnouncer.$inject = ["$timeout"];
	angular
	  .module('material.core')
	  .service('$mdLiveAnnouncer', MdLiveAnnouncer);
	
	/**
	 * @ngdoc service
	 * @name $mdLiveAnnouncer
	 * @module material.core.liveannouncer
	 *
	 * @description
	 *
	 * Service to announce messages to supported screenreaders.
	 *
	 * > The `$mdLiveAnnouncer` service is internally used for components to provide proper accessibility.
	 *
	 * <hljs lang="js">
	 *   module.controller('AppCtrl', function($mdLiveAnnouncer) {
	 *     // Basic announcement (Polite Mode)
	 *     $mdLiveAnnouncer.announce('Hey Google');
	 *
	 *     // Custom announcement (Assertive Mode)
	 *     $mdLiveAnnouncer.announce('Hey Google', 'assertive');
	 *   });
	 * </hljs>
	 *
	 */
	function MdLiveAnnouncer($timeout) {
	  /** @private @const @type {!angular.$timeout} */
	  this._$timeout = $timeout;
	
	  /** @private @const @type {!HTMLElement} */
	  this._liveElement = this._createLiveElement();
	
	  /** @private @const @type {!number} */
	  this._announceTimeout = 100;
	}
	
	/**
	 * @ngdoc method
	 * @name $mdLiveAnnouncer#announce
	 * @description Announces messages to supported screenreaders.
	 * @param {string} message Message to be announced to the screenreader
	 * @param {'off'|'polite'|'assertive'} politeness The politeness of the announcer element.
	 */
	MdLiveAnnouncer.prototype.announce = function(message, politeness) {
	  if (!politeness) {
	    politeness = 'polite';
	  }
	
	  var self = this;
	
	  self._liveElement.textContent = '';
	  self._liveElement.setAttribute('aria-live', politeness);
	
	  // This 100ms timeout is necessary for some browser + screen-reader combinations:
	  // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
	  // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
	  //   second time without clearing and then using a non-zero delay.
	  // (using JAWS 17 at time of this writing).
	  self._$timeout(function() {
	    self._liveElement.textContent = message;
	  }, self._announceTimeout, false);
	};
	
	/**
	 * Creates a live announcer element, which listens for DOM changes and announces them
	 * to the screenreaders.
	 * @returns {!HTMLElement}
	 * @private
	 */
	MdLiveAnnouncer.prototype._createLiveElement = function() {
	  var liveEl = document.createElement('div');
	
	  liveEl.classList.add('md-visually-hidden');
	  liveEl.setAttribute('role', 'status');
	  liveEl.setAttribute('aria-atomic', 'true');
	  liveEl.setAttribute('aria-live', 'polite');
	
	  document.body.appendChild(liveEl);
	
	  return liveEl;
	};
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc service
	 * @name $$mdMeta
	 * @module material.core.meta
	 *
	 * @description
	 *
	 * A provider and a service that simplifies meta tags access
	 *
	 * Note: This is intended only for use with dynamic meta tags such as browser color and title.
	 * Tags that are only processed when the page is rendered (such as `charset`, and `http-equiv`)
	 * will not work since `$$mdMeta` adds the tags after the page has already been loaded.
	 *
	 * ```js
	 * app.config(function($$mdMetaProvider) {
	 *   var removeMeta = $$mdMetaProvider.setMeta('meta-name', 'content');
	 *   var metaValue  = $$mdMetaProvider.getMeta('meta-name'); // -> 'content'
	 *
	 *   removeMeta();
	 * });
	 *
	 * app.controller('myController', function($$mdMeta) {
	 *   var removeMeta = $$mdMeta.setMeta('meta-name', 'content');
	 *   var metaValue  = $$mdMeta.getMeta('meta-name'); // -> 'content'
	 *
	 *   removeMeta();
	 * });
	 * ```
	 *
	 * @returns {$$mdMeta.$service}
	 *
	 */
	angular.module('material.core.meta', [])
	  .provider('$$mdMeta', function () {
	    var head = angular.element(document.head);
	    var metaElements = {};
	
	    /**
	     * Checks if the requested element was written manually and maps it
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @returns {boolean} returns true if there is an element with the requested name
	     */
	    function mapExistingElement(name) {
	      if (metaElements[name]) {
	        return true;
	      }
	
	      var element = document.getElementsByName(name)[0];
	
	      if (!element) {
	        return false;
	      }
	
	      metaElements[name] = angular.element(element);
	
	      return true;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $$mdMeta#setMeta
	     *
	     * @description
	     * Creates meta element with the 'name' and 'content' attributes,
	     * if the meta tag is already created than we replace the 'content' value
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @param {string} content meta tag 'content' attribute value
	     * @returns {function} remove function
	     *
	     */
	    function setMeta(name, content) {
	      mapExistingElement(name);
	
	      if (!metaElements[name]) {
	        var newMeta = angular.element('<meta name="' + name + '" content="' + content + '"/>');
	        head.append(newMeta);
	        metaElements[name] = newMeta;
	      }
	      else {
	        metaElements[name].attr('content', content);
	      }
	
	      return function () {
	        metaElements[name].attr('content', '');
	        metaElements[name].remove();
	        delete metaElements[name];
	      };
	    }
	
	    /**
	     * @ngdoc method
	     * @name $$mdMeta#getMeta
	     *
	     * @description
	     * Gets the 'content' attribute value of the wanted meta element
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @returns {string} content attribute value
	     */
	    function getMeta(name) {
	      if (!mapExistingElement(name)) {
	        throw Error('$$mdMeta: could not find a meta tag with the name \'' + name + '\'');
	      }
	
	      return metaElements[name].attr('content');
	    }
	
	    var module = {
	      setMeta: setMeta,
	      getMeta: getMeta
	    };
	
	    return angular.extend({}, module, {
	      $get: function () {
	        return module;
	      }
	    });
	  });
	})();
	(function(){
	"use strict";
	
	  /**
	   * @ngdoc module
	   * @name material.core.componentRegistry
	   *
	   * @description
	   * A component instance registration service.
	   * Note: currently this as a private service in the SideNav component.
	   */
	  ComponentRegistry.$inject = ["$log", "$q"];
	  angular.module('material.core')
	    .factory('$mdComponentRegistry', ComponentRegistry);
	
	  /*
	   * @private
	   * @ngdoc factory
	   * @name ComponentRegistry
	   * @module material.core.componentRegistry
	   *
	   */
	  function ComponentRegistry($log, $q) {
	
	    var self;
	    var instances = [];
	    var pendings = { };
	
	    return self = {
	      /**
	       * Used to print an error when an instance for a handle isn't found.
	       */
	      notFoundError: function(handle, msgContext) {
	        $log.error((msgContext || "") + 'No instance found for handle', handle);
	      },
	      /**
	       * Return all registered instances as an array.
	       */
	      getInstances: function() {
	        return instances;
	      },
	
	      /**
	       * Get a registered instance.
	       * @param handle the String handle to look up for a registered instance.
	       */
	      get: function(handle) {
	        if (!isValidID(handle)) return null;
	
	        var i, j, instance;
	        for (i = 0, j = instances.length; i < j; i++) {
	          instance = instances[i];
	          if (instance.$$mdHandle === handle) {
	            return instance;
	          }
	        }
	        return null;
	      },
	
	      /**
	       * Register an instance.
	       * @param instance the instance to register
	       * @param handle the handle to identify the instance under.
	       */
	      register: function(instance, handle) {
	        if (!handle) return angular.noop;
	
	        instance.$$mdHandle = handle;
	        instances.push(instance);
	        resolveWhen();
	
	        return deregister;
	
	        /**
	         * Remove registration for an instance
	         */
	        function deregister() {
	          var index = instances.indexOf(instance);
	          if (index !== -1) {
	            instances.splice(index, 1);
	          }
	        }
	
	        /**
	         * Resolve any pending promises for this instance
	         */
	        function resolveWhen() {
	          var dfd = pendings[handle];
	          if (dfd) {
	            dfd.forEach(function (promise) {
	              promise.resolve(instance);
	            });
	            delete pendings[handle];
	          }
	        }
	      },
	
	      /**
	       * Async accessor to registered component instance
	       * If not available then a promise is created to notify
	       * all listeners when the instance is registered.
	       */
	      when : function(handle) {
	        if (isValidID(handle)) {
	          var deferred = $q.defer();
	          var instance = self.get(handle);
	
	          if (instance)  {
	            deferred.resolve(instance);
	          } else {
	            if (pendings[handle] === undefined) {
	              pendings[handle] = [];
	            }
	            pendings[handle].push(deferred);
	          }
	
	          return deferred.promise;
	        }
	        return $q.reject("Invalid `md-component-id` value.");
	      }
	
	    };
	
	    function isValidID(handle){
	      return handle && (handle !== "");
	    }
	
	  }
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc service
	   * @name $mdButtonInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-button.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the default ripple configuration
	   */
	
	  MdButtonInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdButtonInkRipple', MdButtonInkRipple);
	
	  function MdButtonInkRipple($mdInkRipple) {
	    return {
	      attach: function attachRipple(scope, element, options) {
	        options = angular.extend(optionsForElement(element), options);
	
	        return $mdInkRipple.attach(scope, element, options);
	      }
	    };
	
	    function optionsForElement(element) {
	      if (element.hasClass('md-icon-button')) {
	        return {
	          isMenuItem: element.hasClass('md-menu-item'),
	          fitRipple: true,
	          center: true
	        };
	      } else {
	        return {
	          isMenuItem: element.hasClass('md-menu-item'),
	          dimBackground: true
	        };
	      }
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	    /**
	   * @ngdoc service
	   * @name $mdCheckboxInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-checkbox.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */
	
	  MdCheckboxInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdCheckboxInkRipple', MdCheckboxInkRipple);
	
	  function MdCheckboxInkRipple($mdInkRipple) {
	    return {
	      attach: attach
	    };
	
	    function attach(scope, element, options) {
	      return $mdInkRipple.attach(scope, element, angular.extend({
	        center: true,
	        dimBackground: false,
	        fitRipple: true
	      }, options));
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc service
	   * @name $mdListInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-list.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */
	
	  MdListInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdListInkRipple', MdListInkRipple);
	
	  function MdListInkRipple($mdInkRipple) {
	    return {
	      attach: attach
	    };
	
	    function attach(scope, element, options) {
	      return $mdInkRipple.attach(scope, element, angular.extend({
	        center: false,
	        dimBackground: true,
	        outline: false,
	        rippleSize: 'full'
	      }, options));
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.ripple
	 * @description
	 * Ripple
	 */
	InkRippleCtrl.$inject = ["$scope", "$element", "rippleOptions", "$window", "$timeout", "$mdUtil", "$mdColorUtil"];
	InkRippleDirective.$inject = ["$mdButtonInkRipple", "$mdCheckboxInkRipple"];
	angular.module('material.core')
	    .provider('$mdInkRipple', InkRippleProvider)
	    .directive('mdInkRipple', InkRippleDirective)
	    .directive('mdNoInk', attrNoDirective)
	    .directive('mdNoBar', attrNoDirective)
	    .directive('mdNoStretch', attrNoDirective);
	
	var DURATION = 450;
	
	/**
	 * @ngdoc directive
	 * @name mdInkRipple
	 * @module material.core.ripple
	 *
	 * @description
	 * The `md-ink-ripple` directive allows you to specify the ripple color or if a ripple is allowed.
	 *
	 * @param {string|boolean} md-ink-ripple A color string `#FF0000` or boolean (`false` or `0`) for
	 *  preventing ripple
	 *
	 * @usage
	 * ### String values
	 * <hljs lang="html">
	 *   <ANY md-ink-ripple="#FF0000">
	 *     Ripples in red
	 *   </ANY>
	 *
	 *   <ANY md-ink-ripple="false">
	 *     Not rippling
	 *   </ANY>
	 * </hljs>
	 *
	 * ### Interpolated values
	 * <hljs lang="html">
	 *   <ANY md-ink-ripple="{{ randomColor() }}">
	 *     Ripples with the return value of 'randomColor' function
	 *   </ANY>
	 *
	 *   <ANY md-ink-ripple="{{ canRipple() }}">
	 *     Ripples if 'canRipple' function return value is not 'false' or '0'
	 *   </ANY>
	 * </hljs>
	 */
	function InkRippleDirective ($mdButtonInkRipple, $mdCheckboxInkRipple) {
	  return {
	    controller: angular.noop,
	    link:       function (scope, element, attr) {
	      attr.hasOwnProperty('mdInkRippleCheckbox')
	          ? $mdCheckboxInkRipple.attach(scope, element)
	          : $mdButtonInkRipple.attach(scope, element);
	    }
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $mdInkRipple
	 * @module material.core.ripple
	 *
	 * @description
	 * `$mdInkRipple` is a service for adding ripples to any element.
	 *
	 * @usage
	 * <hljs lang="js">
	 * app.factory('$myElementInkRipple', function($mdInkRipple) {
	 *   return {
	 *     attach: function (scope, element, options) {
	 *       return $mdInkRipple.attach(scope, element, angular.extend({
	 *         center: false,
	 *         dimBackground: true
	 *       }, options));
	 *     }
	 *   };
	 * });
	 *
	 * app.controller('myController', function ($scope, $element, $myElementInkRipple) {
	 *   $scope.onClick = function (ev) {
	 *     $myElementInkRipple.attach($scope, angular.element(ev.target), { center: true });
	 *   }
	 * });
	 * </hljs>
	 */
	
	/**
	 * @ngdoc service
	 * @name $mdInkRippleProvider
	 * @module material.core.ripple
	 *
	 * @description
	  * If you want to disable ink ripples globally, for all components, you can call the
	 * `disableInkRipple` method in your app's config.
	 *
	 *
	 * @usage
	 * <hljs lang="js">
	 * app.config(function ($mdInkRippleProvider) {
	 *   $mdInkRippleProvider.disableInkRipple();
	 * });
	 * </hljs>
	 */
	
	function InkRippleProvider () {
	  var isDisabledGlobally = false;
	
	  return {
	    disableInkRipple: disableInkRipple,
	    $get: ["$injector", function($injector) {
	      return { attach: attach };
	
	      /**
	       * @ngdoc method
	       * @name $mdInkRipple#attach
	       *
	       * @description
	       * Attaching given scope, element and options to inkRipple controller
	       *
	       * @param {object=} scope Scope within the current context
	       * @param {object=} element The element the ripple effect should be applied to
	       * @param {object=} options (Optional) Configuration options to override the defaultRipple configuration
	       * * `center` -  Whether the ripple should start from the center of the container element
	       * * `dimBackground` - Whether the background should be dimmed with the ripple color
	       * * `colorElement` - The element the ripple should take its color from, defined by css property `color`
	       * * `fitRipple` - Whether the ripple should fill the element
	       */
	      function attach (scope, element, options) {
	        if (isDisabledGlobally || element.controller('mdNoInk')) return angular.noop;
	        return $injector.instantiate(InkRippleCtrl, {
	          $scope:        scope,
	          $element:      element,
	          rippleOptions: options
	        });
	      }
	    }]
	  };
	
	  /**
	   * @ngdoc method
	   * @name $mdInkRippleProvider#disableInkRipple
	   *
	   * @description
	   * A config-time method that, when called, disables ripples globally.
	   */
	  function disableInkRipple () {
	    isDisabledGlobally = true;
	  }
	}
	
	/**
	 * Controller used by the ripple service in order to apply ripples
	 * @ngInject
	 */
	function InkRippleCtrl ($scope, $element, rippleOptions, $window, $timeout, $mdUtil, $mdColorUtil) {
	  this.$window    = $window;
	  this.$timeout   = $timeout;
	  this.$mdUtil    = $mdUtil;
	  this.$mdColorUtil    = $mdColorUtil;
	  this.$scope     = $scope;
	  this.$element   = $element;
	  this.options    = rippleOptions;
	  this.mousedown  = false;
	  this.ripples    = [];
	  this.timeout    = null; // Stores a reference to the most-recent ripple timeout
	  this.lastRipple = null;
	
	  $mdUtil.valueOnUse(this, 'container', this.createContainer);
	
	  this.$element.addClass('md-ink-ripple');
	
	  // attach method for unit tests
	  ($element.controller('mdInkRipple') || {}).createRipple = angular.bind(this, this.createRipple);
	  ($element.controller('mdInkRipple') || {}).setColor = angular.bind(this, this.color);
	
	  this.bindEvents();
	}
	
	
	/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
	 * mouseup or mouseleave event)
	 */
	function autoCleanup (self, cleanupFn) {
	  if (self.mousedown || self.lastRipple) {
	    self.mousedown = false;
	    self.$mdUtil.nextTick(angular.bind(self, cleanupFn), false);
	  }
	}
	
	
	/**
	 * Returns the color that the ripple should be (either based on CSS or hard-coded)
	 * @returns {string}
	 */
	InkRippleCtrl.prototype.color = function (value) {
	  var self = this;
	
	  // If assigning a color value, apply it to background and the ripple color
	  if (angular.isDefined(value)) {
	    self._color = self._parseColor(value);
	  }
	
	  // If color lookup, use assigned, defined, or inherited
	  return self._color || self._parseColor(self.inkRipple()) || self._parseColor(getElementColor());
	
	  /**
	   * Finds the color element and returns its text color for use as default ripple color
	   * @returns {string}
	   */
	  function getElementColor () {
	    var items = self.options && self.options.colorElement ? self.options.colorElement : [];
	    var elem =  items.length ? items[ 0 ] : self.$element[ 0 ];
	
	    return elem ? self.$window.getComputedStyle(elem).color : 'rgb(0,0,0)';
	  }
	};
	
	/**
	 * Updating the ripple colors based on the current inkRipple value
	 * or the element's computed style color
	 */
	InkRippleCtrl.prototype.calculateColor = function () {
	  return this.color();
	};
	
	
	/**
	 * Takes a string color and converts it to RGBA format
	 * @param {string} color
	 * @param {number} multiplier
	 * @returns {string}
	 */
	InkRippleCtrl.prototype._parseColor = function parseColor (color, multiplier) {
	  multiplier = multiplier || 1;
	  var colorUtil = this.$mdColorUtil;
	
	  if (!color) return;
	  if (color.indexOf('rgba') === 0) return color.replace(/\d?\.?\d*\s*\)\s*$/, (0.1 * multiplier).toString() + ')');
	  if (color.indexOf('rgb') === 0) return colorUtil.rgbToRgba(color);
	  if (color.indexOf('#') === 0) return colorUtil.hexToRgba(color);
	
	};
	
	/**
	 * Binds events to the root element for
	 */
	InkRippleCtrl.prototype.bindEvents = function () {
	  this.$element.on('mousedown', angular.bind(this, this.handleMousedown));
	  this.$element.on('mouseup touchend', angular.bind(this, this.handleMouseup));
	  this.$element.on('mouseleave', angular.bind(this, this.handleMouseup));
	  this.$element.on('touchmove', angular.bind(this, this.handleTouchmove));
	};
	
	/**
	 * Create a new ripple on every mousedown event from the root element
	 * @param event {MouseEvent}
	 */
	InkRippleCtrl.prototype.handleMousedown = function (event) {
	  if (this.mousedown) return;
	
	  // When jQuery is loaded, we have to get the original event
	  if (event.hasOwnProperty('originalEvent')) event = event.originalEvent;
	  this.mousedown = true;
	  if (this.options.center) {
	    this.createRipple(this.container.prop('clientWidth') / 2, this.container.prop('clientWidth') / 2);
	  } else {
	
	    // We need to calculate the relative coordinates if the target is a sublayer of the ripple element
	    if (event.srcElement !== this.$element[0]) {
	      var layerRect = this.$element[0].getBoundingClientRect();
	      var layerX = event.clientX - layerRect.left;
	      var layerY = event.clientY - layerRect.top;
	
	      this.createRipple(layerX, layerY);
	    } else {
	      this.createRipple(event.offsetX, event.offsetY);
	    }
	  }
	};
	
	/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
	 * mouseup, touchend or mouseleave event)
	 */
	InkRippleCtrl.prototype.handleMouseup = function () {
	  this.$timeout(function () {
	    autoCleanup(this, this.clearRipples);
	  }.bind(this));
	};
	
	/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (by
	 * touchmove)
	 */
	InkRippleCtrl.prototype.handleTouchmove = function () {
	  autoCleanup(this, this.deleteRipples);
	};
	
	/**
	 * Cycles through all ripples and attempts to remove them.
	 */
	InkRippleCtrl.prototype.deleteRipples = function () {
	  for (var i = 0; i < this.ripples.length; i++) {
	    this.ripples[ i ].remove();
	  }
	};
	
	/**
	 * Cycles through all ripples and attempts to remove them with fade.
	 * Depending on logic within `fadeInComplete`, some removals will be postponed.
	 */
	InkRippleCtrl.prototype.clearRipples = function () {
	  for (var i = 0; i < this.ripples.length; i++) {
	    this.fadeInComplete(this.ripples[ i ]);
	  }
	};
	
	/**
	 * Creates the ripple container element
	 * @returns {*}
	 */
	InkRippleCtrl.prototype.createContainer = function () {
	  var container = angular.element('<div class="md-ripple-container"></div>');
	  this.$element.append(container);
	  return container;
	};
	
	InkRippleCtrl.prototype.clearTimeout = function () {
	  if (this.timeout) {
	    this.$timeout.cancel(this.timeout);
	    this.timeout = null;
	  }
	};
	
	InkRippleCtrl.prototype.isRippleAllowed = function () {
	  var element = this.$element[0];
	  do {
	    if (!element.tagName || element.tagName === 'BODY') break;
	
	    if (element && angular.isFunction(element.hasAttribute)) {
	      if (element.hasAttribute('disabled')) return false;
	      if (this.inkRipple() === 'false' || this.inkRipple() === '0') return false;
	    }
	
	  } while (element = element.parentNode);
	  return true;
	};
	
	/**
	 * The attribute `md-ink-ripple` may be a static or interpolated
	 * color value OR a boolean indicator (used to disable ripples)
	 */
	InkRippleCtrl.prototype.inkRipple = function () {
	  return this.$element.attr('md-ink-ripple');
	};
	
	/**
	 * Creates a new ripple and adds it to the container.  Also tracks ripple in `this.ripples`.
	 * @param left
	 * @param top
	 */
	InkRippleCtrl.prototype.createRipple = function (left, top) {
	  if (!this.isRippleAllowed()) return;
	
	  var ctrl        = this;
	  var colorUtil   = ctrl.$mdColorUtil;
	  var ripple      = angular.element('<div class="md-ripple"></div>');
	  var width       = this.$element.prop('clientWidth');
	  var height      = this.$element.prop('clientHeight');
	  var x           = Math.max(Math.abs(width - left), left) * 2;
	  var y           = Math.max(Math.abs(height - top), top) * 2;
	  var size        = getSize(this.options.fitRipple, x, y);
	  var color       = this.calculateColor();
	
	  ripple.css({
	    left:            left + 'px',
	    top:             top + 'px',
	    background:      'black',
	    width:           size + 'px',
	    height:          size + 'px',
	    backgroundColor: colorUtil.rgbaToRgb(color),
	    borderColor:     colorUtil.rgbaToRgb(color)
	  });
	  this.lastRipple = ripple;
	
	  // we only want one timeout to be running at a time
	  this.clearTimeout();
	  this.timeout    = this.$timeout(function () {
	    ctrl.clearTimeout();
	    if (!ctrl.mousedown) ctrl.fadeInComplete(ripple);
	  }, DURATION * 0.35, false);
	
	  if (this.options.dimBackground) this.container.css({ backgroundColor: color });
	  this.container.append(ripple);
	  this.ripples.push(ripple);
	  ripple.addClass('md-ripple-placed');
	
	  this.$mdUtil.nextTick(function () {
	
	    ripple.addClass('md-ripple-scaled md-ripple-active');
	    ctrl.$timeout(function () {
	      ctrl.clearRipples();
	    }, DURATION, false);
	
	  }, false);
	
	  function getSize (fit, x, y) {
	    return fit
	        ? Math.max(x, y)
	        : Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
	  }
	};
	
	
	
	/**
	 * After fadeIn finishes, either kicks off the fade-out animation or queues the element for removal on mouseup
	 * @param ripple
	 */
	InkRippleCtrl.prototype.fadeInComplete = function (ripple) {
	  if (this.lastRipple === ripple) {
	    if (!this.timeout && !this.mousedown) {
	      this.removeRipple(ripple);
	    }
	  } else {
	    this.removeRipple(ripple);
	  }
	};
	
	/**
	 * Kicks off the animation for removing a ripple
	 * @param ripple {Element}
	 */
	InkRippleCtrl.prototype.removeRipple = function (ripple) {
	  var ctrl  = this;
	  var index = this.ripples.indexOf(ripple);
	  if (index < 0) return;
	  this.ripples.splice(this.ripples.indexOf(ripple), 1);
	  ripple.removeClass('md-ripple-active');
	  ripple.addClass('md-ripple-remove');
	  if (this.ripples.length === 0) this.container.css({ backgroundColor: '' });
	  // use a 2-second timeout in order to allow for the animation to finish
	  // we don't actually care how long the animation takes
	  this.$timeout(function () {
	    ctrl.fadeOutComplete(ripple);
	  }, DURATION, false);
	};
	
	/**
	 * Removes the provided ripple from the DOM
	 * @param ripple
	 */
	InkRippleCtrl.prototype.fadeOutComplete = function (ripple) {
	  ripple.remove();
	  this.lastRipple = null;
	};
	
	/**
	 * Used to create an empty directive.  This is used to track flag-directives whose children may have
	 * functionality based on them.
	 *
	 * Example: `md-no-ink` will potentially be used by all child directives.
	 */
	function attrNoDirective () {
	  return { controller: angular.noop };
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	    /**
	   * @ngdoc service
	   * @name $mdTabInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-tabs.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */
	
	  MdTabInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdTabInkRipple', MdTabInkRipple);
	
	  function MdTabInkRipple($mdInkRipple) {
	    return {
	      attach: attach
	    };
	
	    function attach(scope, element, options) {
	      return $mdInkRipple.attach(scope, element, angular.extend({
	        center: false,
	        dimBackground: true,
	        outline: false,
	        rippleSize: 'full'
	      }, options));
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	angular.module('material.core.theming.palette', [])
	.constant('$mdColorPalette', {
	  'red': {
	    '50': '#ffebee',
	    '100': '#ffcdd2',
	    '200': '#ef9a9a',
	    '300': '#e57373',
	    '400': '#ef5350',
	    '500': '#f44336',
	    '600': '#e53935',
	    '700': '#d32f2f',
	    '800': '#c62828',
	    '900': '#b71c1c',
	    'A100': '#ff8a80',
	    'A200': '#ff5252',
	    'A400': '#ff1744',
	    'A700': '#d50000',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 A100',
	    'contrastStrongLightColors': '400 500 600 700 A200 A400 A700'
	  },
	  'pink': {
	    '50': '#fce4ec',
	    '100': '#f8bbd0',
	    '200': '#f48fb1',
	    '300': '#f06292',
	    '400': '#ec407a',
	    '500': '#e91e63',
	    '600': '#d81b60',
	    '700': '#c2185b',
	    '800': '#ad1457',
	    '900': '#880e4f',
	    'A100': '#ff80ab',
	    'A200': '#ff4081',
	    'A400': '#f50057',
	    'A700': '#c51162',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100',
	    'contrastStrongLightColors': '500 600 A200 A400 A700'
	  },
	  'purple': {
	    '50': '#f3e5f5',
	    '100': '#e1bee7',
	    '200': '#ce93d8',
	    '300': '#ba68c8',
	    '400': '#ab47bc',
	    '500': '#9c27b0',
	    '600': '#8e24aa',
	    '700': '#7b1fa2',
	    '800': '#6a1b9a',
	    '900': '#4a148c',
	    'A100': '#ea80fc',
	    'A200': '#e040fb',
	    'A400': '#d500f9',
	    'A700': '#aa00ff',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100',
	    'contrastStrongLightColors': '300 400 A200 A400 A700'
	  },
	  'deep-purple': {
	    '50': '#ede7f6',
	    '100': '#d1c4e9',
	    '200': '#b39ddb',
	    '300': '#9575cd',
	    '400': '#7e57c2',
	    '500': '#673ab7',
	    '600': '#5e35b1',
	    '700': '#512da8',
	    '800': '#4527a0',
	    '900': '#311b92',
	    'A100': '#b388ff',
	    'A200': '#7c4dff',
	    'A400': '#651fff',
	    'A700': '#6200ea',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100',
	    'contrastStrongLightColors': '300 400 A200'
	  },
	  'indigo': {
	    '50': '#e8eaf6',
	    '100': '#c5cae9',
	    '200': '#9fa8da',
	    '300': '#7986cb',
	    '400': '#5c6bc0',
	    '500': '#3f51b5',
	    '600': '#3949ab',
	    '700': '#303f9f',
	    '800': '#283593',
	    '900': '#1a237e',
	    'A100': '#8c9eff',
	    'A200': '#536dfe',
	    'A400': '#3d5afe',
	    'A700': '#304ffe',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100',
	    'contrastStrongLightColors': '300 400 A200 A400'
	  },
	  'blue': {
	    '50': '#e3f2fd',
	    '100': '#bbdefb',
	    '200': '#90caf9',
	    '300': '#64b5f6',
	    '400': '#42a5f5',
	    '500': '#2196f3',
	    '600': '#1e88e5',
	    '700': '#1976d2',
	    '800': '#1565c0',
	    '900': '#0d47a1',
	    'A100': '#82b1ff',
	    'A200': '#448aff',
	    'A400': '#2979ff',
	    'A700': '#2962ff',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 400 A100',
	    'contrastStrongLightColors': '500 600 700 A200 A400 A700'
	  },
	  'light-blue': {
	    '50': '#e1f5fe',
	    '100': '#b3e5fc',
	    '200': '#81d4fa',
	    '300': '#4fc3f7',
	    '400': '#29b6f6',
	    '500': '#03a9f4',
	    '600': '#039be5',
	    '700': '#0288d1',
	    '800': '#0277bd',
	    '900': '#01579b',
	    'A100': '#80d8ff',
	    'A200': '#40c4ff',
	    'A400': '#00b0ff',
	    'A700': '#0091ea',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '600 700 800 900 A700',
	    'contrastStrongLightColors': '600 700 800 A700'
	  },
	  'cyan': {
	    '50': '#e0f7fa',
	    '100': '#b2ebf2',
	    '200': '#80deea',
	    '300': '#4dd0e1',
	    '400': '#26c6da',
	    '500': '#00bcd4',
	    '600': '#00acc1',
	    '700': '#0097a7',
	    '800': '#00838f',
	    '900': '#006064',
	    'A100': '#84ffff',
	    'A200': '#18ffff',
	    'A400': '#00e5ff',
	    'A700': '#00b8d4',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '700 800 900',
	    'contrastStrongLightColors': '700 800 900'
	  },
	  'teal': {
	    '50': '#e0f2f1',
	    '100': '#b2dfdb',
	    '200': '#80cbc4',
	    '300': '#4db6ac',
	    '400': '#26a69a',
	    '500': '#009688',
	    '600': '#00897b',
	    '700': '#00796b',
	    '800': '#00695c',
	    '900': '#004d40',
	    'A100': '#a7ffeb',
	    'A200': '#64ffda',
	    'A400': '#1de9b6',
	    'A700': '#00bfa5',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '500 600 700 800 900',
	    'contrastStrongLightColors': '500 600 700'
	  },
	  'green': {
	    '50': '#e8f5e9',
	    '100': '#c8e6c9',
	    '200': '#a5d6a7',
	    '300': '#81c784',
	    '400': '#66bb6a',
	    '500': '#4caf50',
	    '600': '#43a047',
	    '700': '#388e3c',
	    '800': '#2e7d32',
	    '900': '#1b5e20',
	    'A100': '#b9f6ca',
	    'A200': '#69f0ae',
	    'A400': '#00e676',
	    'A700': '#00c853',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '500 600 700 800 900',
	    'contrastStrongLightColors': '500 600 700'
	  },
	  'light-green': {
	    '50': '#f1f8e9',
	    '100': '#dcedc8',
	    '200': '#c5e1a5',
	    '300': '#aed581',
	    '400': '#9ccc65',
	    '500': '#8bc34a',
	    '600': '#7cb342',
	    '700': '#689f38',
	    '800': '#558b2f',
	    '900': '#33691e',
	    'A100': '#ccff90',
	    'A200': '#b2ff59',
	    'A400': '#76ff03',
	    'A700': '#64dd17',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '700 800 900',
	    'contrastStrongLightColors': '700 800 900'
	  },
	  'lime': {
	    '50': '#f9fbe7',
	    '100': '#f0f4c3',
	    '200': '#e6ee9c',
	    '300': '#dce775',
	    '400': '#d4e157',
	    '500': '#cddc39',
	    '600': '#c0ca33',
	    '700': '#afb42b',
	    '800': '#9e9d24',
	    '900': '#827717',
	    'A100': '#f4ff81',
	    'A200': '#eeff41',
	    'A400': '#c6ff00',
	    'A700': '#aeea00',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '900',
	    'contrastStrongLightColors': '900'
	  },
	  'yellow': {
	    '50': '#fffde7',
	    '100': '#fff9c4',
	    '200': '#fff59d',
	    '300': '#fff176',
	    '400': '#ffee58',
	    '500': '#ffeb3b',
	    '600': '#fdd835',
	    '700': '#fbc02d',
	    '800': '#f9a825',
	    '900': '#f57f17',
	    'A100': '#ffff8d',
	    'A200': '#ffff00',
	    'A400': '#ffea00',
	    'A700': '#ffd600',
	    'contrastDefaultColor': 'dark'
	  },
	  'amber': {
	    '50': '#fff8e1',
	    '100': '#ffecb3',
	    '200': '#ffe082',
	    '300': '#ffd54f',
	    '400': '#ffca28',
	    '500': '#ffc107',
	    '600': '#ffb300',
	    '700': '#ffa000',
	    '800': '#ff8f00',
	    '900': '#ff6f00',
	    'A100': '#ffe57f',
	    'A200': '#ffd740',
	    'A400': '#ffc400',
	    'A700': '#ffab00',
	    'contrastDefaultColor': 'dark'
	  },
	  'orange': {
	    '50': '#fff3e0',
	    '100': '#ffe0b2',
	    '200': '#ffcc80',
	    '300': '#ffb74d',
	    '400': '#ffa726',
	    '500': '#ff9800',
	    '600': '#fb8c00',
	    '700': '#f57c00',
	    '800': '#ef6c00',
	    '900': '#e65100',
	    'A100': '#ffd180',
	    'A200': '#ffab40',
	    'A400': '#ff9100',
	    'A700': '#ff6d00',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '800 900',
	    'contrastStrongLightColors': '800 900'
	  },
	  'deep-orange': {
	    '50': '#fbe9e7',
	    '100': '#ffccbc',
	    '200': '#ffab91',
	    '300': '#ff8a65',
	    '400': '#ff7043',
	    '500': '#ff5722',
	    '600': '#f4511e',
	    '700': '#e64a19',
	    '800': '#d84315',
	    '900': '#bf360c',
	    'A100': '#ff9e80',
	    'A200': '#ff6e40',
	    'A400': '#ff3d00',
	    'A700': '#dd2c00',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 400 A100 A200',
	    'contrastStrongLightColors': '500 600 700 800 900 A400 A700'
	  },
	  'brown': {
	    '50': '#efebe9',
	    '100': '#d7ccc8',
	    '200': '#bcaaa4',
	    '300': '#a1887f',
	    '400': '#8d6e63',
	    '500': '#795548',
	    '600': '#6d4c41',
	    '700': '#5d4037',
	    '800': '#4e342e',
	    '900': '#3e2723',
	    'A100': '#d7ccc8',
	    'A200': '#bcaaa4',
	    'A400': '#8d6e63',
	    'A700': '#5d4037',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100 A200',
	    'contrastStrongLightColors': '300 400'
	  },
	  'grey': {
	    '50': '#fafafa',
	    '100': '#f5f5f5',
	    '200': '#eeeeee',
	    '300': '#e0e0e0',
	    '400': '#bdbdbd',
	    '500': '#9e9e9e',
	    '600': '#757575',
	    '700': '#616161',
	    '800': '#424242',
	    '900': '#212121',
	    'A100': '#ffffff',
	    'A200': '#000000',
	    'A400': '#303030',
	    'A700': '#616161',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '600 700 800 900 A200 A400 A700'
	  },
	  'blue-grey': {
	    '50': '#eceff1',
	    '100': '#cfd8dc',
	    '200': '#b0bec5',
	    '300': '#90a4ae',
	    '400': '#78909c',
	    '500': '#607d8b',
	    '600': '#546e7a',
	    '700': '#455a64',
	    '800': '#37474f',
	    '900': '#263238',
	    'A100': '#cfd8dc',
	    'A200': '#b0bec5',
	    'A400': '#78909c',
	    'A700': '#455a64',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 A100 A200',
	    'contrastStrongLightColors': '400 500 700'
	  }
	});
	
	})();
	(function(){
	"use strict";
	
	(function(angular) {
	  'use strict';
	/**
	 * @ngdoc module
	 * @name material.core.theming
	 * @description
	 * Theming
	 */
	detectDisabledThemes.$inject = ["$mdThemingProvider"];
	ThemingDirective.$inject = ["$mdTheming", "$interpolate", "$parse", "$mdUtil", "$q", "$log"];
	ThemableDirective.$inject = ["$mdTheming"];
	ThemingProvider.$inject = ["$mdColorPalette", "$$mdMetaProvider"];
	generateAllThemes.$inject = ["$injector", "$mdTheming"];
	angular.module('material.core.theming', ['material.core.theming.palette', 'material.core.meta'])
	  .directive('mdTheme', ThemingDirective)
	  .directive('mdThemable', ThemableDirective)
	  .directive('mdThemesDisabled', disableThemesDirective)
	  .provider('$mdTheming', ThemingProvider)
	  .config(detectDisabledThemes)
	  .run(generateAllThemes);
	
	/**
	 * Detect if the HTML or the BODY tags has a [md-themes-disabled] attribute
	 * If yes, then immediately disable all theme stylesheet generation and DOM injection
	 */
	/**
	 * @ngInject
	 */
	function detectDisabledThemes($mdThemingProvider) {
	  var isDisabled = !!document.querySelector('[md-themes-disabled]');
	  $mdThemingProvider.disableTheming(isDisabled);
	}
	
	/**
	 * @ngdoc service
	 * @name $mdThemingProvider
	 * @module material.core.theming
	 *
	 * @description Provider to configure the `$mdTheming` service.
	 *
	 * ### Default Theme
	 * The `$mdThemingProvider` uses by default the following theme configuration:
	 *
	 * - Primary Palette: `Blue`
	 * - Accent Palette: `Pink`
	 * - Warn Palette: `Deep-Orange`
	 * - Background Palette: `Grey`
	 *
	 * If you don't want to use the `md-theme` directive on the elements itself, you may want to overwrite
	 * the default theme.<br/>
	 * This can be done by using the following markup.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     $mdThemingProvider
	 *       .theme('default')
	 *       .primaryPalette('blue')
	 *       .accentPalette('teal')
	 *       .warnPalette('red')
	 *       .backgroundPalette('grey');
	 *   });
	 * </hljs>
	 *
	
	 * ### Dynamic Themes
	 *
	 * By default, if you change a theme at runtime, the `$mdTheming` service will not detect those changes.<br/>
	 * If you have an application, which changes its theme on runtime, you have to enable theme watching.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Enable theme watching.
	 *     $mdThemingProvider.alwaysWatchTheme(true);
	 *   });
	 * </hljs>
	 *
	 * ### Custom Theme Styles
	 *
	 * Sometimes you may want to use your own theme styles for some custom components.<br/>
	 * You are able to register your own styles by using the following markup.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Register our custom stylesheet into the theming provider.
	 *     $mdThemingProvider.registerStyles(STYLESHEET);
	 *   });
	 * </hljs>
	 *
	 * The `registerStyles` method only accepts strings as value, so you're actually not able to load an external
	 * stylesheet file into the `$mdThemingProvider`.
	 *
	 * If it's necessary to load an external stylesheet, we suggest using a bundler, which supports including raw content,
	 * like [raw-loader](https://github.com/webpack/raw-loader) for `webpack`.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Register your custom stylesheet into the theming provider.
	 *     $mdThemingProvider.registerStyles(require('../styles/my-component.theme.css'));
	 *   });
	 * </hljs>
	 *
	 * ### Browser color
	 *
	 * Enables browser header coloring
	 * for more info please visit:
	 * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
	 *
	 * Options parameter: <br/>
	 * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
	 * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
	 *             'accent', 'background' and 'warn'. Default is `primary`. <br/>
	 * `hue`     - The hue from the selected palette. Default is `800`<br/>
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Enable browser color
	 *     $mdThemingProvider.enableBrowserColor({
	 *       theme: 'myTheme', // Default is 'default'
	 *       palette: 'accent', // Default is 'primary', any basic material palette and extended palettes are available
	 *       hue: '200' // Default is '800'
	 *     });
	 *   });
	 * </hljs>
	 */
	
	/**
	 * Some Example Valid Theming Expressions
	 * =======================================
	 *
	 * Intention group expansion: (valid for primary, accent, warn, background)
	 *
	 * {{primary-100}} - grab shade 100 from the primary palette
	 * {{primary-100-0.7}} - grab shade 100, apply opacity of 0.7
	 * {{primary-100-contrast}} - grab shade 100's contrast color
	 * {{primary-hue-1}} - grab the shade assigned to hue-1 from the primary palette
	 * {{primary-hue-1-0.7}} - apply 0.7 opacity to primary-hue-1
	 * {{primary-color}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured shades set for each hue
	 * {{primary-color-0.7}} - Apply 0.7 opacity to each of the above rules
	 * {{primary-contrast}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured contrast (ie. text) color shades set for each hue
	 * {{primary-contrast-0.7}} - Apply 0.7 opacity to each of the above rules
	 *
	 * Foreground expansion: Applies rgba to black/white foreground text
	 *
	 * {{foreground-1}} - used for primary text
	 * {{foreground-2}} - used for secondary text/divider
	 * {{foreground-3}} - used for disabled text
	 * {{foreground-4}} - used for dividers
	 */
	
	// In memory generated CSS rules; registered by theme.name
	var GENERATED = { };
	
	// In memory storage of defined themes and color palettes (both loaded by CSS, and user specified)
	var PALETTES;
	
	// Text Colors on light and dark backgrounds
	// @see https://material.io/archive/guidelines/style/color.html#color-usability
	var DARK_FOREGROUND = {
	  name: 'dark',
	  '1': 'rgba(0,0,0,0.87)',
	  '2': 'rgba(0,0,0,0.54)',
	  '3': 'rgba(0,0,0,0.38)',
	  '4': 'rgba(0,0,0,0.12)'
	};
	var LIGHT_FOREGROUND = {
	  name: 'light',
	  '1': 'rgba(255,255,255,1.0)',
	  '2': 'rgba(255,255,255,0.7)',
	  '3': 'rgba(255,255,255,0.5)',
	  '4': 'rgba(255,255,255,0.12)'
	};
	
	var DARK_SHADOW = '1px 1px 0px rgba(0,0,0,0.4), -1px -1px 0px rgba(0,0,0,0.4)';
	var LIGHT_SHADOW = '';
	
	var DARK_CONTRAST_COLOR = colorToRgbaArray('rgba(0,0,0,0.87)');
	var LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgba(255,255,255,0.87)');
	var STRONG_LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgb(255,255,255)');
	
	var THEME_COLOR_TYPES = ['primary', 'accent', 'warn', 'background'];
	var DEFAULT_COLOR_TYPE = 'primary';
	
	// A color in a theme will use these hues by default, if not specified by user.
	var LIGHT_DEFAULT_HUES = {
	  'accent': {
	    'default': 'A200',
	    'hue-1': 'A100',
	    'hue-2': 'A400',
	    'hue-3': 'A700'
	  },
	  'background': {
	    'default': '50',
	    'hue-1': 'A100',
	    'hue-2': '100',
	    'hue-3': '300'
	  }
	};
	
	var DARK_DEFAULT_HUES = {
	  'background': {
	    'default': 'A400',
	    'hue-1': '800',
	    'hue-2': '900',
	    'hue-3': 'A200'
	  }
	};
	THEME_COLOR_TYPES.forEach(function(colorType) {
	  // Color types with unspecified default hues will use these default hue values
	  var defaultDefaultHues = {
	    'default': '500',
	    'hue-1': '300',
	    'hue-2': '800',
	    'hue-3': 'A100'
	  };
	  if (!LIGHT_DEFAULT_HUES[colorType]) LIGHT_DEFAULT_HUES[colorType] = defaultDefaultHues;
	  if (!DARK_DEFAULT_HUES[colorType]) DARK_DEFAULT_HUES[colorType] = defaultDefaultHues;
	});
	
	var VALID_HUE_VALUES = [
	  '50', '100', '200', '300', '400', '500', '600',
	  '700', '800', '900', 'A100', 'A200', 'A400', 'A700'
	];
	
	var themeConfig = {
	  disableTheming : false,   // Generate our themes at run time; also disable stylesheet DOM injection
	  generateOnDemand : false, // Whether or not themes are to be generated on-demand (vs. eagerly).
	  registeredStyles : [],    // Custom styles registered to be used in the theming of custom components.
	  nonce : null              // Nonce to be added as an attribute to the generated themes style tags.
	};
	
	/**
	 *
	 */
	function ThemingProvider($mdColorPalette, $$mdMetaProvider) {
	  ThemingService.$inject = ["$rootScope", "$mdUtil", "$q", "$log"];
	  PALETTES = { };
	  var THEMES = { };
	
	  var themingProvider;
	
	  var alwaysWatchTheme = false;
	  var defaultTheme = 'default';
	
	  // Load JS Defined Palettes
	  angular.extend(PALETTES, $mdColorPalette);
	
	  // Default theme defined in core.js
	
	  /**
	   * Adds `theme-color` and `msapplication-navbutton-color` meta tags with the color parameter
	   * @param {string} color Hex value of the wanted browser color
	   * @returns {function} Remove function of the meta tags
	   */
	  var setBrowserColor = function (color) {
	    // Chrome, Firefox OS and Opera
	    var removeChrome = $$mdMetaProvider.setMeta('theme-color', color);
	    // Windows Phone
	    var removeWindows = $$mdMetaProvider.setMeta('msapplication-navbutton-color', color);
	
	    return function () {
	      removeChrome();
	      removeWindows();
	    };
	  };
	
	  /**
	   * @ngdoc method
	   * @name $mdThemingProvider#enableBrowserColor
	   * @description
	   * Enables browser header coloring. For more info please visit
	   * <a href="https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color">
	   *   Web Fundamentals</a>.
	   * @param {object=} options Options for the browser color, which include:<br/>
	   * - `theme` - `{string}`: A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
	   * - `palette` - `{string}`:  Can be any one of the basic material design palettes, extended defined palettes, or `primary`,
	   *  `accent`, `background`, and `warn`. Default is `primary`.<br/>
	   * - `hue` -  `{string}`: The hue from the selected palette. Default is `800`.<br/>
	   * @returns {function} Function that removes the browser coloring when called.
	   */
	  var enableBrowserColor = function (options) {
	    options = angular.isObject(options) ? options : {};
	
	    var theme = options.theme || 'default';
	    var hue = options.hue || '800';
	
	    var palette = PALETTES[options.palette] ||
	      PALETTES[THEMES[theme].colors[options.palette || 'primary'].name];
	
	    var color = angular.isObject(palette[hue]) ? palette[hue].hex : palette[hue];
	    if (color.substr(0, 1) !== '#') color = '#' + color;
	
	    return setBrowserColor(color);
	  };
	
	  return themingProvider = {
	    definePalette: definePalette,
	    extendPalette: extendPalette,
	    theme: registerTheme,
	
	    /**
	     * return a read-only clone of the current theme configuration
	     */
	    configuration : function() {
	      return angular.extend({ }, themeConfig, {
	        defaultTheme : defaultTheme,
	        alwaysWatchTheme : alwaysWatchTheme,
	        registeredStyles : [].concat(themeConfig.registeredStyles)
	      });
	    },
	
	    /**
	     * @ngdoc method
	     * @name $mdThemingProvider#disableTheming
	     * @description
	     * An easier way to disable theming without having to use `.constant("$MD_THEME_CSS","");`.
	     * This disables all dynamic theme style sheet generations and injections.
	     * @param {boolean=} isDisabled Disable all dynamic theme style sheet generations and injections
	     *  if `true` or `undefined`.
	     */
	    disableTheming: function(isDisabled) {
	      themeConfig.disableTheming = angular.isUndefined(isDisabled) || !!isDisabled;
	    },
	
	    /**
	     * @ngdoc method
	     * @name $mdThemingProvider#registerStyles
	     * @param {string} styles The styles to be appended to AngularJS Material's built in theme CSS.
	     */
	    registerStyles: function(styles) {
	      themeConfig.registeredStyles.push(styles);
	    },
	
	    /**
	     * @ngdoc method
	     * @name $mdThemingProvider#setNonce
	     * @param {string} nonceValue The nonce to be added as an attribute to the theme style tags.
	     * Setting a value allows the use of CSP policy without using the `'unsafe-inline'` directive.
	     * The string must already be base64 encoded. You can use `btoa(string)` to do this encoding.
	     * In your CSP's `style-src`, you would then add an entry for `'nonce-nonceValue'`.
	     */
	    setNonce: function(nonceValue) {
	      themeConfig.nonce = nonceValue;
	    },
	
	    generateThemesOnDemand: function(onDemand) {
	      themeConfig.generateOnDemand = onDemand;
	    },
	
	    /**
	     * @ngdoc method
	     * @name $mdThemingProvider#setDefaultTheme
	     * @param {string} theme Default theme name to be applied to elements. Default value is `default`.
	     */
	    setDefaultTheme: function(theme) {
	      defaultTheme = theme;
	    },
	
	    /**
	     * @ngdoc method
	     * @name $mdThemingProvider#alwaysWatchTheme
	     * @param {boolean} alwaysWatch Whether or not to always watch themes for changes and re-apply
	     * classes when they change. Default is `false`. Enabling can reduce performance.
	     */
	    alwaysWatchTheme: function(alwaysWatch) {
	      alwaysWatchTheme = alwaysWatch;
	    },
	
	    enableBrowserColor: enableBrowserColor,
	
	    $get: ThemingService,
	    _LIGHT_DEFAULT_HUES: LIGHT_DEFAULT_HUES,
	    _DARK_DEFAULT_HUES: DARK_DEFAULT_HUES,
	    _PALETTES: PALETTES,
	    _THEMES: THEMES,
	    _parseRules: parseRules,
	    _rgba: rgba
	  };
	
	  /**
	   * @ngdoc method
	   * @name $mdThemingProvider#definePalette
	   * @description
	   * In the event that you need to define a custom color palette, you can use this function to
	   * make it available to your theme for use in its intention groups.<br>
	   * Note that you must specify all hues in the definition map.
	   * @param {string} name Name of palette being defined
	   * @param {object} map Palette definition that includes hue definitions and contrast colors:
	   * - `'50'` - `{string}`: HEX color
	   * - `'100'` - `{string}`: HEX color
	   * - `'200'` - `{string}`: HEX color
	   * - `'300'` - `{string}`: HEX color
	   * - `'400'` - `{string}`: HEX color
	   * - `'500'` - `{string}`: HEX color
	   * - `'600'` - `{string}`: HEX color
	   * - `'700'` - `{string}`: HEX color
	   * - `'800'` - `{string}`: HEX color
	   * - `'900'` - `{string}`: HEX color
	   * - `'A100'` - `{string}`: HEX color
	   * - `'A200'` - `{string}`: HEX color
	   * - `'A400'` - `{string}`: HEX color
	   * - `'A700'` - `{string}`: HEX color
	   * - `'contrastDefaultColor'` - `{string}`: `light` or `dark`
	   * - `'contrastDarkColors'` - `{string[]}`: Hues which should use dark contrast colors (i.e. raised button text).
	   *  For example: `['50', '100', '200', '300', '400', 'A100']`.
	   * - `'contrastLightColors'` - `{string[]}`: Hues which should use light contrast colors (i.e. raised button text).
	   *  For example: `['500', '600', '700', '800', '900', 'A200', 'A400', 'A700']`.
	   */
	  function definePalette(name, map) {
	    map = map || {};
	    PALETTES[name] = checkPaletteValid(name, map);
	    return themingProvider;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $mdThemingProvider#extendPalette
	   * @description
	   * Sometimes it is easier to extend an existing color palette and then change a few properties,
	   * rather than defining a whole new palette.
	   * @param {string} name Name of palette being extended
	   * @param {object} map Palette definition that includes optional hue definitions and contrast colors:
	   * - `'50'` - `{string}`: HEX color
	   * - `'100'` - `{string}`: HEX color
	   * - `'200'` - `{string}`: HEX color
	   * - `'300'` - `{string}`: HEX color
	   * - `'400'` - `{string}`: HEX color
	   * - `'500'` - `{string}`: HEX color
	   * - `'600'` - `{string}`: HEX color
	   * - `'700'` - `{string}`: HEX color
	   * - `'800'` - `{string}`: HEX color
	   * - `'900'` - `{string}`: HEX color
	   * - `'A100'` - `{string}`: HEX color
	   * - `'A200'` - `{string}`: HEX color
	   * - `'A400'` - `{string}`: HEX color
	   * - `'A700'` - `{string}`: HEX color
	   * - `'contrastDefaultColor'` - `{string}`: `light` or `dark`
	   * - `'contrastDarkColors'` - `{string[]}`: Hues which should use dark contrast colors (i.e. raised button text).
	   *  For example: `['50', '100', '200', '300', '400', 'A100']`.
	   * - `'contrastLightColors'` - `{string[]}`: Hues which should use light contrast colors (i.e. raised button text).
	   *  For example: `['500', '600', '700', '800', '900', 'A200', 'A400', 'A700']`.
	   *  @returns {object} A new object which is a copy of the given palette, `name`,
	   *    with variables from `map` overwritten.
	   */
	  function extendPalette(name, map) {
	    return checkPaletteValid(name,  angular.extend({}, PALETTES[name] || {}, map));
	  }
	
	  // Make sure that palette has all required hues
	  function checkPaletteValid(name, map) {
	    var missingColors = VALID_HUE_VALUES.filter(function(field) {
	      return !map[field];
	    });
	    if (missingColors.length) {
	      throw new Error("Missing colors %1 in palette %2!"
	                      .replace('%1', missingColors.join(', '))
	                      .replace('%2', name));
	    }
	
	    return map;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $mdThemingProvider#theme
	   * @description
	   * Register a theme (which is a collection of color palettes); i.e. `warn`, `accent`,
	   * `background`, and `primary`.<br>
	   * Optionally inherit from an existing theme.
	   * @param {string} name Name of theme being registered
	   * @param {string=} inheritFrom Existing theme name to inherit from
	   */
	  function registerTheme(name, inheritFrom) {
	    if (THEMES[name]) return THEMES[name];
	
	    inheritFrom = inheritFrom || 'default';
	
	    var parentTheme = typeof inheritFrom === 'string' ? THEMES[inheritFrom] : inheritFrom;
	    var theme = new Theme(name);
	
	    if (parentTheme) {
	      angular.forEach(parentTheme.colors, function(color, colorType) {
	        theme.colors[colorType] = {
	          name: color.name,
	          // Make sure a COPY of the hues is given to the child color,
	          // not the same reference.
	          hues: angular.extend({}, color.hues)
	        };
	      });
	    }
	    THEMES[name] = theme;
	
	    return theme;
	  }
	
	  function Theme(name) {
	    var self = this;
	    self.name = name;
	    self.colors = {};
	
	    self.dark = setDark;
	    setDark(false);
	
	    function setDark(isDark) {
	      isDark = arguments.length === 0 ? true : !!isDark;
	
	      // If no change, abort
	      if (isDark === self.isDark) return;
	
	      self.isDark = isDark;
	
	      self.foregroundPalette = self.isDark ? LIGHT_FOREGROUND : DARK_FOREGROUND;
	      self.foregroundShadow = self.isDark ? DARK_SHADOW : LIGHT_SHADOW;
	
	      // Light and dark themes have different default hues.
	      // Go through each existing color type for this theme, and for every
	      // hue value that is still the default hue value from the previous light/dark setting,
	      // set it to the default hue value from the new light/dark setting.
	      var newDefaultHues = self.isDark ? DARK_DEFAULT_HUES : LIGHT_DEFAULT_HUES;
	      var oldDefaultHues = self.isDark ? LIGHT_DEFAULT_HUES : DARK_DEFAULT_HUES;
	      angular.forEach(newDefaultHues, function(newDefaults, colorType) {
	        var color = self.colors[colorType];
	        var oldDefaults = oldDefaultHues[colorType];
	        if (color) {
	          for (var hueName in color.hues) {
	            if (color.hues[hueName] === oldDefaults[hueName]) {
	              color.hues[hueName] = newDefaults[hueName];
	            }
	          }
	        }
	      });
	
	      return self;
	    }
	
	    THEME_COLOR_TYPES.forEach(function(colorType) {
	      var defaultHues = (self.isDark ? DARK_DEFAULT_HUES : LIGHT_DEFAULT_HUES)[colorType];
	      self[colorType + 'Palette'] = function setPaletteType(paletteName, hues) {
	        var color = self.colors[colorType] = {
	          name: paletteName,
	          hues: angular.extend({}, defaultHues, hues)
	        };
	
	        Object.keys(color.hues).forEach(function(name) {
	          if (!defaultHues[name]) {
	            throw new Error("Invalid hue name '%1' in theme %2's %3 color %4. Available hue names: %4"
	              .replace('%1', name)
	              .replace('%2', self.name)
	              .replace('%3', paletteName)
	              .replace('%4', Object.keys(defaultHues).join(', '))
	            );
	          }
	        });
	        Object.keys(color.hues).map(function(key) {
	          return color.hues[key];
	        }).forEach(function(hueValue) {
	          if (VALID_HUE_VALUES.indexOf(hueValue) == -1) {
	            throw new Error("Invalid hue value '%1' in theme %2's %3 color %4. Available hue values: %5"
	              .replace('%1', hueValue)
	              .replace('%2', self.name)
	              .replace('%3', colorType)
	              .replace('%4', paletteName)
	              .replace('%5', VALID_HUE_VALUES.join(', '))
	            );
	          }
	        });
	        return self;
	      };
	
	      self[colorType + 'Color'] = function() {
	        var args = Array.prototype.slice.call(arguments);
	        // eslint-disable-next-line no-console
	        console.warn('$mdThemingProviderTheme.' + colorType + 'Color() has been deprecated. ' +
	                     'Use $mdThemingProviderTheme.' + colorType + 'Palette() instead.');
	        return self[colorType + 'Palette'].apply(self, args);
	      };
	    });
	  }
	
	  /**
	   * @ngdoc service
	   * @name $mdTheming
	   * @module material.core.theming
	   * @description
	   * Service that makes an element apply theming related <b>classes</b> to itself.
	   *
	   * For more information on the hue objects, their default values, as well as valid hue values, please visit <a ng-href="Theming/03_configuring_a_theme#specifying-custom-hues-for-color-intentions">the custom hues section of Configuring a Theme</a>.
	   *
	   * <hljs lang="js">
	   * // Example component directive that we want to apply theming classes to.
	   * app.directive('myFancyDirective', function($mdTheming) {
	   *   return {
	   *     restrict: 'AE',
	   *     link: function(scope, element, attrs) {
	   *       // Initialize the service using our directive's element
	   *       $mdTheming(element);
	   *
	   *       $mdTheming.defineTheme('myTheme', {
	   *         primary: 'blue',
	   *         primaryHues: {
	   *           default: '500',
	   *           hue-1: '300',
	   *           hue-2: '900',
	   *           hue-3: 'A100'
	   *         },
	   *         accent: 'pink',
	   *         accentHues: {
	   *           default: '600',
	   *           hue-1: '300',
	   *           hue-2: '200',
	   *           hue-3: 'A500'
	   *         },
	   *         warn: 'red',
	   *         // It's not necessary to specify all hues in the object.
	   *         warnHues: {
	   *           default: '200',
	   *           hue-3: 'A100'
	   *         },
	   *         // It's not necessary to specify custom hues at all.
	   *         background: 'grey',
	   *         dark: true
	   *       });
	   *       // Your directive's custom code here.
	   *     }
	   *   };
	   * });
	   * </hljs>
	   * @param {element=} element Element that will have theming classes applied to it.
	   */
	
	  /**
	   * @ngdoc property
	   * @name $mdTheming#THEMES
	   * @description
	   * Property to get all the themes defined
	   * @returns {object} All the themes defined with their properties.
	   */
	
	  /**
	   * @ngdoc property
	   * @name $mdTheming#PALETTES
	   * @description
	   * Property to get all the palettes defined
	   * @returns {object} All the palettes defined with their colors.
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#registered
	   * @description
	   * Determine is specified theme name is a valid, registered theme
	   * @param {string} themeName the theme to check if registered
	   * @returns {boolean} whether the theme is registered or not
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#defaultTheme
	   * @description
	   * Returns the default theme
	   * @returns {string} The default theme
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#generateTheme
	   * @description
	   * Lazy generate themes - by default, every theme is generated when defined.
	   * You can disable this in the configuration section using the
	   * `$mdThemingProvider.generateThemesOnDemand(true);`
	   *
	   * The theme name that is passed in must match the name of the theme that was defined as part of
	   * the configuration block.
	   *
	   * @param {string} name theme name to generate
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#setBrowserColor
	   * @description
	   * Enables browser header coloring. For more info please visit
	   * <a href="https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color">
	   *   Web Fundamentals</a>.
	   * @param {object=} options Options for the browser color, which include:<br/>
	   * - `theme` - `{string}`: A defined theme via `$mdThemeProvider` to use the palettes from.
	   *    Default is `default` theme. <br/>
	   * - `palette` - `{string}`:  Can be any one of the basic material design palettes, extended
	   *    defined palettes, or `primary`, `accent`, `background`, and `warn`. Default is `primary`.
	   * <br/>
	   * - `hue` -  `{string}`: The hue from the selected palette. Default is `800`.<br/>
	   * @returns {function} Function that removes the browser coloring when called.
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#defineTheme
	   * @description
	   * Dynamically define a theme by using an options object that contains palette names.
	   *
	   * @param {string} name Theme name to define
	   * @param {object} options Theme definition options
	   *
	   * Options are:<br/>
	   * - `primary` - `{string}`: The name of the primary palette to use in the theme.<br/>
	   * - `primaryHues` - `{object=}`: Override hues for primary palette.<br/>
	   * - `accent` - `{string}`: The name of the accent palette to use in the theme.<br/>
	   * - `accentHues` - `{object=}`: Override hues for accent palette.<br/>
	   * - `warn` - `{string}`: The name of the warn palette to use in the theme.<br/>
	   * - `warnHues` - `{object=}`: Override hues for warn palette.<br/>
	   * - `background` - `{string}`: The name of the background palette to use in the theme.<br/>
	   * - `backgroundHues` - `{object=}`: Override hues for background palette.<br/>
	   * - `dark` - `{boolean}`: Indicates if it's a dark theme.<br/>
	   * @returns {Promise<string>} A resolved promise with the new theme name.
	   */
	
	  /* @ngInject */
	  function ThemingService($rootScope, $mdUtil, $q, $log) {
	    // Allow us to be invoked via a linking function signature.
	    var applyTheme = function (scope, el) {
	      if (el === undefined) { el = scope; scope = undefined; }
	      if (scope === undefined) { scope = $rootScope; }
	      applyTheme.inherit(el, el);
	    };
	
	    Object.defineProperty(applyTheme, 'THEMES', {
	      get: function () {
	        return angular.extend({}, THEMES);
	      }
	    });
	    Object.defineProperty(applyTheme, 'PALETTES', {
	      get: function () {
	        return angular.extend({}, PALETTES);
	      }
	    });
	    Object.defineProperty(applyTheme, 'ALWAYS_WATCH', {
	      get: function () {
	        return alwaysWatchTheme;
	      }
	    });
	    applyTheme.inherit = inheritTheme;
	    applyTheme.registered = registered;
	    applyTheme.defaultTheme = function() { return defaultTheme; };
	    applyTheme.generateTheme = function(name) { generateTheme(THEMES[name], name, themeConfig.nonce); };
	    applyTheme.defineTheme = function(name, options) {
	      options = options || {};
	
	      var theme = registerTheme(name);
	
	      if (options.primary) {
	        theme.primaryPalette(options.primary, options.primaryHues);
	      }
	      if (options.accent) {
	        theme.accentPalette(options.accent, options.accentHues);
	      }
	      if (options.warn) {
	        theme.warnPalette(options.warn, options.warnHues);
	      }
	      if (options.background) {
	        theme.backgroundPalette(options.background, options.backgroundHues);
	      }
	      if (options.dark){
	        theme.dark();
	      }
	
	      this.generateTheme(name);
	
	      return $q.resolve(name);
	    };
	    applyTheme.setBrowserColor = enableBrowserColor;
	
	    return applyTheme;
	
	    /**
	     * Determine is specified theme name is a valid, registered theme
	     */
	    function registered(themeName) {
	      if (themeName === undefined || themeName === '') return true;
	      return applyTheme.THEMES[themeName] !== undefined;
	    }
	
	    /**
	     * Get theme name for the element, then update with Theme CSS class
	     */
	    function inheritTheme (el, parent) {
	      var ctrl = parent.controller('mdTheme') || el.data('$mdThemeController');
	      var scope = el.scope();
	
	      updateThemeClass(lookupThemeName());
	
	      if (ctrl) {
	        var watchTheme = alwaysWatchTheme ||
	                         ctrl.$shouldWatch ||
	                         $mdUtil.parseAttributeBoolean(el.attr('md-theme-watch'));
	
	        if (watchTheme || ctrl.isAsyncTheme) {
	          var clearNameWatcher = function () {
	            if (unwatch) {
	              unwatch();
	              unwatch = undefined;
	            }
	          };
	
	          var unwatch = ctrl.registerChanges(function(name) {
	            updateThemeClass(name);
	
	            if (!watchTheme) {
	              clearNameWatcher();
	            }
	          });
	
	          if (scope) {
	            scope.$on('$destroy', clearNameWatcher);
	          } else {
	            el.on('$destroy', clearNameWatcher);
	          }
	        }
	      }
	
	      /**
	       * Find the theme name from the parent controller or element data
	       */
	      function lookupThemeName() {
	        // As a few components (dialog) add their controllers later, we should also watch for a controller init.
	        return ctrl && ctrl.$mdTheme || (defaultTheme === 'default' ? '' : defaultTheme);
	      }
	
	      /**
	       * Remove old theme class and apply a new one
	       * NOTE: if not a valid theme name, then the current name is not changed
	       */
	      function updateThemeClass(theme) {
	        if (!theme) return;
	        if (!registered(theme)) {
	          $log.warn('Attempted to use unregistered theme \'' + theme + '\'. ' +
	                    'Register it with $mdThemingProvider.theme().');
	        }
	
	        var oldTheme = el.data('$mdThemeName');
	        if (oldTheme) el.removeClass('md-' + oldTheme +'-theme');
	        el.addClass('md-' + theme + '-theme');
	        el.data('$mdThemeName', theme);
	        if (ctrl) {
	          el.data('$mdThemeController', ctrl);
	        }
	      }
	    }
	
	  }
	}
	
	function ThemingDirective($mdTheming, $interpolate, $parse, $mdUtil, $q, $log) {
	  return {
	    priority: 101, // has to be more than 100 to be before interpolation (issue on IE)
	    link: {
	      pre: function(scope, el, attrs) {
	        var registeredCallbacks = [];
	
	        var startSymbol = $interpolate.startSymbol();
	        var endSymbol = $interpolate.endSymbol();
	
	        var theme = attrs.mdTheme.trim();
	
	        var hasInterpolation =
	          theme.substr(0, startSymbol.length) === startSymbol &&
	          theme.lastIndexOf(endSymbol) === theme.length - endSymbol.length;
	
	        var oneTimeOperator = '::';
	        var oneTimeBind = attrs.mdTheme
	            .split(startSymbol).join('')
	            .split(endSymbol).join('')
	            .trim()
	            .substr(0, oneTimeOperator.length) === oneTimeOperator;
	
	        var getTheme = function () {
	          var interpolation = $interpolate(attrs.mdTheme)(scope);
	          return $parse(interpolation)(scope) || interpolation;
	        };
	
	        var ctrl = {
	          isAsyncTheme: angular.isFunction(getTheme()) || angular.isFunction(getTheme().then),
	          registerChanges: function (cb, context) {
	            if (context) {
	              cb = angular.bind(context, cb);
	            }
	
	            registeredCallbacks.push(cb);
	
	            return function () {
	              var index = registeredCallbacks.indexOf(cb);
	
	              if (index > -1) {
	                registeredCallbacks.splice(index, 1);
	              }
	            };
	          },
	          $setTheme: function (theme) {
	            if (!$mdTheming.registered(theme)) {
	              $log.warn('attempted to use unregistered theme \'' + theme + '\'');
	            }
	
	            ctrl.$mdTheme = theme;
	
	            // Iterating backwards to support unregistering during iteration
	            // http://stackoverflow.com/a/9882349/890293
	            // we don't use `reverse()` of array because it mutates the array and we don't want it
	            // to get re-indexed
	            for (var i = registeredCallbacks.length; i--;) {
	              registeredCallbacks[i](theme);
	            }
	          },
	          $shouldWatch: $mdUtil.parseAttributeBoolean(el.attr('md-theme-watch')) ||
	                        $mdTheming.ALWAYS_WATCH ||
	                        (hasInterpolation && !oneTimeBind)
	        };
	
	        el.data('$mdThemeController', ctrl);
	
	        var setParsedTheme = function (theme) {
	          if (typeof theme === 'string') {
	            return ctrl.$setTheme(theme);
	          }
	
	          $q.when(angular.isFunction(theme) ?  theme() : theme)
	            .then(function(name) {
	              ctrl.$setTheme(name);
	            });
	        };
	
	        setParsedTheme(getTheme());
	
	        var unwatch = scope.$watch(getTheme, function(theme) {
	          if (theme) {
	            setParsedTheme(theme);
	
	            if (!ctrl.$shouldWatch) {
	              unwatch();
	            }
	          }
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Special directive that will disable ALL runtime Theme style generation and DOM injection
	 *
	 * <link rel="stylesheet" href="angular-material.min.css">
	 * <link rel="stylesheet" href="angular-material.themes.css">
	 *
	 * <body md-themes-disabled>
	 *  ...
	 * </body>
	 *
	 * Note: Using md-themes-css directive requires the developer to load external
	 * theme stylesheets; e.g. custom themes from Material-Tools:
	 *
	 *       `angular-material.themes.css`
	 *
	 * Another option is to use the ThemingProvider to configure and disable the attribute
	 * conversions; this would obviate the use of the `md-themes-css` directive
	 *
	 */
	function disableThemesDirective() {
	  themeConfig.disableTheming = true;
	
	  // Return a 1x-only, first-match attribute directive
	  return {
	    restrict : 'A',
	    priority : '900'
	  };
	}
	
	function ThemableDirective($mdTheming) {
	  return $mdTheming;
	}
	
	function parseRules(theme, colorType, rules) {
	  checkValidPalette(theme, colorType);
	
	  rules = rules.replace(/THEME_NAME/g, theme.name);
	  var themeNameRegex = new RegExp('\\.md-' + theme.name + '-theme', 'g');
	  var simpleVariableRegex = /'?"?\{\{\s*([a-zA-Z]+)-(A?\d+|hue-[0-3]|shadow|default)-?(\d\.?\d*)?(contrast)?\s*\}\}'?"?/g;
	
	  // find and replace simple variables where we use a specific hue, not an entire palette
	  // eg. "{{primary-100}}"
	  // \(' + THEME_COLOR_TYPES.join('\|') + '\)'
	  rules = rules.replace(simpleVariableRegex, function(match, colorType, hue, opacity, contrast) {
	    if (colorType === 'foreground') {
	      if (hue == 'shadow') {
	        return theme.foregroundShadow;
	      } else {
	        return theme.foregroundPalette[hue] || theme.foregroundPalette['1'];
	      }
	    }
	
	    // `default` is also accepted as a hue-value, because the background palettes are
	    // using it as a name for the default hue.
	    if (hue.indexOf('hue') === 0 || hue === 'default') {
	      hue = theme.colors[colorType].hues[hue];
	    }
	
	    return rgba((PALETTES[ theme.colors[colorType].name ][hue] || '')[contrast ? 'contrast' : 'value'], opacity);
	  });
	
	  // Matches '{{ primary-color }}', etc
	  var hueRegex = new RegExp('(\'|")?{{\\s*([a-zA-Z]+)-(color|contrast)-?(\\d\\.?\\d*)?\\s*}}("|\')?','g');
	  var generatedRules = [];
	
	  // For each type, generate rules for each hue (ie. default, md-hue-1, md-hue-2, md-hue-3)
	  angular.forEach(['default', 'hue-1', 'hue-2', 'hue-3'], function(hueName) {
	    var newRule = rules
	      .replace(hueRegex, function(match, _, matchedColorType, hueType, opacity) {
	        var color = theme.colors[matchedColorType];
	        var palette = PALETTES[color.name];
	        var hueValue = color.hues[hueName];
	        return rgba(palette[hueValue][hueType === 'color' ? 'value' : 'contrast'], opacity);
	      });
	    if (hueName !== 'default') {
	      newRule = newRule.replace(themeNameRegex, '.md-' + theme.name + '-theme.md-' + hueName);
	    }
	
	    // Don't apply a selector rule to the default theme, making it easier to override
	    // styles of the base-component
	    if (theme.name == 'default') {
	      var themeRuleRegex = /((?:\s|>|\.|\w|-|:|\(|\)|\[|\]|"|'|=)*)\.md-default-theme((?:\s|>|\.|\w|-|:|\(|\)|\[|\]|"|'|=)*)/g;
	
	      newRule = newRule.replace(themeRuleRegex, function(match, start, end) {
	        return match + ', ' + start + end;
	      });
	    }
	    generatedRules.push(newRule);
	  });
	
	  return generatedRules;
	}
	
	var rulesByType = {};
	
	// Generate our themes at run time given the state of THEMES and PALETTES
	function generateAllThemes($injector, $mdTheming) {
	  var head = document.head;
	  var firstChild = head ? head.firstElementChild : null;
	  var themeCss = !themeConfig.disableTheming && $injector.has('$MD_THEME_CSS') ? $injector.get('$MD_THEME_CSS') : '';
	
	  // Append our custom registered styles to the theme stylesheet.
	  themeCss += themeConfig.registeredStyles.join('');
	
	  if (!firstChild) return;
	  if (themeCss.length === 0) return; // no rules, so no point in running this expensive task
	
	  // Expose contrast colors for palettes to ensure that text is always readable
	  angular.forEach(PALETTES, sanitizePalette);
	
	  // MD_THEME_CSS is a string generated by the build process that includes all the themable
	  // components as templates
	
	  // Break the CSS into individual rules
	  var rules = themeCss
	                  .split(/\}(?!(\}|'|"|;))/)
	                  .filter(function(rule) { return rule && rule.trim().length; })
	                  .map(function(rule) { return rule.trim() + '}'; });
	
	  THEME_COLOR_TYPES.forEach(function(type) {
	    rulesByType[type] = '';
	  });
	
	  // Sort the rules based on type, allowing us to do color substitution on a per-type basis
	  rules.forEach(function(rule) {
	    // First: test that if the rule has '.md-accent', it goes into the accent set of rules
	    for (var i = 0, type; type = THEME_COLOR_TYPES[i]; i++) {
	      if (rule.indexOf('.md-' + type) > -1) {
	        return rulesByType[type] += rule;
	      }
	    }
	
	    // If no eg 'md-accent' class is found, try to just find 'accent' in the rule and guess from
	    // there
	    for (i = 0; type = THEME_COLOR_TYPES[i]; i++) {
	      if (rule.indexOf(type) > -1) {
	        return rulesByType[type] += rule;
	      }
	    }
	
	    // Default to the primary array
	    return rulesByType[DEFAULT_COLOR_TYPE] += rule;
	  });
	
	  // If themes are being generated on-demand, quit here. The user will later manually
	  // call generateTheme to do this on a theme-by-theme basis.
	  if (themeConfig.generateOnDemand) return;
	
	  angular.forEach($mdTheming.THEMES, function(theme) {
	    if (!GENERATED[theme.name] && !($mdTheming.defaultTheme() !== 'default' && theme.name === 'default')) {
	      generateTheme(theme, theme.name, themeConfig.nonce);
	    }
	  });
	
	
	  // *************************
	  // Internal functions
	  // *************************
	
	  // The user specifies a 'default' contrast color as either light or dark,
	  // then explicitly lists which hues are the opposite contrast (eg. A100 has dark, A200 has light)
	  function sanitizePalette(palette, name) {
	    var defaultContrast = palette.contrastDefaultColor;
	    var lightColors = palette.contrastLightColors || [];
	    var strongLightColors = palette.contrastStrongLightColors || [];
	    var darkColors = palette.contrastDarkColors || [];
	
	    // These colors are provided as space-separated lists
	    if (typeof lightColors === 'string') lightColors = lightColors.split(' ');
	    if (typeof strongLightColors === 'string') strongLightColors = strongLightColors.split(' ');
	    if (typeof darkColors === 'string') darkColors = darkColors.split(' ');
	
	    // Cleanup after ourselves
	    delete palette.contrastDefaultColor;
	    delete palette.contrastLightColors;
	    delete palette.contrastStrongLightColors;
	    delete palette.contrastDarkColors;
	
	    // Change { 'A100': '#fffeee' } to { 'A100': { value: '#fffeee', contrast:DARK_CONTRAST_COLOR }
	    angular.forEach(palette, function(hueValue, hueName) {
	      if (angular.isObject(hueValue)) return; // Already converted
	      // Map everything to rgb colors
	      var rgbValue = colorToRgbaArray(hueValue);
	      if (!rgbValue) {
	        throw new Error("Color %1, in palette %2's hue %3, is invalid. Hex or rgb(a) color expected."
	                        .replace('%1', hueValue)
	                        .replace('%2', palette.name)
	                        .replace('%3', hueName));
	      }
	
	      palette[hueName] = {
	        hex: palette[hueName],
	        value: rgbValue,
	        contrast: getContrastColor()
	      };
	      function getContrastColor() {
	        if (defaultContrast === 'light') {
	          if (darkColors.indexOf(hueName) > -1) {
	            return DARK_CONTRAST_COLOR;
	          } else {
	            return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR
	              : LIGHT_CONTRAST_COLOR;
	          }
	        } else {
	          if (lightColors.indexOf(hueName) > -1) {
	            return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR
	              : LIGHT_CONTRAST_COLOR;
	          } else {
	            return DARK_CONTRAST_COLOR;
	          }
	        }
	      }
	    });
	  }
	}
	
	function generateTheme(theme, name, nonce) {
	  var head = document.head;
	  var firstChild = head ? head.firstElementChild : null;
	
	  if (!GENERATED[name]) {
	    // For each theme, use the color palettes specified for
	    // `primary`, `warn` and `accent` to generate CSS rules.
	    THEME_COLOR_TYPES.forEach(function(colorType) {
	      var styleStrings = parseRules(theme, colorType, rulesByType[colorType]);
	      while (styleStrings.length) {
	        var styleContent = styleStrings.shift();
	        if (styleContent) {
	          var style = document.createElement('style');
	          style.setAttribute('md-theme-style', '');
	          if (nonce) {
	            style.setAttribute('nonce', nonce);
	          }
	          style.appendChild(document.createTextNode(styleContent));
	          head.insertBefore(style, firstChild);
	        }
	      }
	    });
	
	    GENERATED[theme.name] = true;
	  }
	
	}
	
	
	function checkValidPalette(theme, colorType) {
	  // If theme attempts to use a palette that doesnt exist, throw error
	  if (!PALETTES[ (theme.colors[colorType] || {}).name ]) {
	    throw new Error(
	      "You supplied an invalid color palette for theme %1's %2 palette. Available palettes: %3"
	                    .replace('%1', theme.name)
	                    .replace('%2', colorType)
	                    .replace('%3', Object.keys(PALETTES).join(', '))
	    );
	  }
	}
	
	function colorToRgbaArray(clr) {
	  if (angular.isArray(clr) && clr.length == 3) return clr;
	  if (/^rgb/.test(clr)) {
	    return clr.replace(/(^\s*rgba?\(|\)\s*$)/g, '').split(',').map(function(value, i) {
	      return i == 3 ? parseFloat(value, 10) : parseInt(value, 10);
	    });
	  }
	  if (clr.charAt(0) == '#') clr = clr.substring(1);
	  if (!/^([a-fA-F0-9]{3}){1,2}$/g.test(clr)) return;
	
	  var dig = clr.length / 3;
	  var red = clr.substr(0, dig);
	  var grn = clr.substr(dig, dig);
	  var blu = clr.substr(dig * 2);
	  if (dig === 1) {
	    red += red;
	    grn += grn;
	    blu += blu;
	  }
	  return [parseInt(red, 16), parseInt(grn, 16), parseInt(blu, 16)];
	}
	
	function rgba(rgbArray, opacity) {
	  if (!rgbArray) return "rgb('0,0,0')";
	
	  if (rgbArray.length == 4) {
	    rgbArray = angular.copy(rgbArray);
	    opacity ? rgbArray.pop() : opacity = rgbArray.pop();
	  }
	  return opacity && (typeof opacity == 'number' || (typeof opacity == 'string' && opacity.length)) ?
	    'rgba(' + rgbArray.join(',') + ',' + opacity + ')' :
	    'rgb(' + rgbArray.join(',') + ')';
	}
	
	
	})(window.angular);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.autocomplete
	 */
	/*
	 * @see js folder for autocomplete implementation
	 */
	angular.module('material.components.autocomplete', [
	  'material.core',
	  'material.components.icon',
	  'material.components.virtualRepeat'
	]);
	
	})();
	(function(){
	"use strict";
	
	
	MdAutocompleteCtrl.$inject = ["$scope", "$element", "$mdUtil", "$mdConstant", "$mdTheming", "$window", "$animate", "$rootElement", "$attrs", "$q", "$log", "$mdLiveAnnouncer"];angular
	    .module('material.components.autocomplete')
	    .controller('MdAutocompleteCtrl', MdAutocompleteCtrl);
	
	var ITEM_HEIGHT   = 48,
	    MAX_ITEMS     = 5,
	    MENU_PADDING  = 8,
	    INPUT_PADDING = 2, // Padding provided by `md-input-container`
	    MODE_STANDARD = 'standard',
	    MODE_VIRTUAL = 'virtual';
	
	function MdAutocompleteCtrl ($scope, $element, $mdUtil, $mdConstant, $mdTheming, $window,
	                             $animate, $rootElement, $attrs, $q, $log, $mdLiveAnnouncer) {
	
	  // Internal Variables.
	  var ctrl                 = this,
	      itemParts            = $scope.itemsExpr.split(/ in /i),
	      itemExpr             = itemParts[ 1 ],
	      elements             = null,
	      cache                = {},
	      noBlur               = false,
	      selectedItemWatchers = [],
	      hasFocus             = false,
	      fetchesInProgress    = 0,
	      enableWrapScroll     = null,
	      inputModelCtrl       = null,
	      debouncedOnResize    = $mdUtil.debounce(onWindowResize),
	      mode                 = MODE_VIRTUAL; // default
	
	  /**
	   * The root document element. This is used for attaching a top-level click handler to
	   * close the options panel when a click outside said panel occurs. We use `documentElement`
	   * instead of body because, when scrolling is disabled, some browsers consider the body element
	   * to be completely off the screen and propagate events directly to the html element.
	   * @type {!Object} angular.JQLite
	   */
	  ctrl.documentElement = angular.element(document.documentElement);
	
	  // Public Exported Variables with handlers
	  defineProperty('hidden', handleHiddenChange, true);
	
	  // Public Exported Variables
	  ctrl.scope = $scope;
	  ctrl.parent = $scope.$parent;
	  ctrl.itemName = itemParts[0];
	  ctrl.matches = [];
	  ctrl.loading = false;
	  ctrl.hidden = true;
	  ctrl.index = -1;
	  ctrl.activeOption = null;
	  ctrl.id = $mdUtil.nextUid();
	  ctrl.isDisabled = null;
	  ctrl.isRequired = null;
	  ctrl.isReadonly = null;
	  ctrl.hasNotFound = false;
	  ctrl.selectedMessage = $scope.selectedMessage || 'selected';
	
	  // Public Exported Methods
	  ctrl.keydown = keydown;
	  ctrl.blur = blur;
	  ctrl.focus = focus;
	  ctrl.clear = clearValue;
	  ctrl.select = select;
	  ctrl.listEnter = onListEnter;
	  ctrl.listLeave = onListLeave;
	  ctrl.focusInput = focusInputElement;
	  ctrl.getCurrentDisplayValue = getCurrentDisplayValue;
	  ctrl.registerSelectedItemWatcher = registerSelectedItemWatcher;
	  ctrl.unregisterSelectedItemWatcher = unregisterSelectedItemWatcher;
	  ctrl.notFoundVisible = notFoundVisible;
	  ctrl.loadingIsVisible = loadingIsVisible;
	  ctrl.positionDropdown = positionDropdown;
	
	  /**
	   * Report types to be used for the $mdLiveAnnouncer
	   * @enum {number} Unique flag id.
	   */
	  var ReportType = {
	    Count: 1,
	    Selected: 2
	  };
	
	  return init();
	
	  // initialization methods
	
	  /**
	   * Initialize the controller, setup watchers, gather elements
	   */
	  function init () {
	
	    $mdUtil.initOptionalProperties($scope, $attrs, {
	      searchText: '',
	      selectedItem: null,
	      clearButton: false,
	      disableVirtualRepeat: false,
	    });
	
	    $mdTheming($element);
	    configureWatchers();
	    $mdUtil.nextTick(function () {
	
	      gatherElements();
	      moveDropdown();
	
	      // Touch devices often do not send a click event on tap. We still want to focus the input
	      // and open the options pop-up in these cases.
	      $element.on('touchstart', focusInputElement);
	
	      // Forward all focus events to the input element when autofocus is enabled
	      if ($scope.autofocus) {
	        $element.on('focus', focusInputElement);
	      }
	      if ($scope.inputAriaDescribedBy) {
	        elements.input.setAttribute('aria-describedby', $scope.inputAriaDescribedBy);
	      }
	      if (!$scope.floatingLabel) {
	        if ($scope.inputAriaLabel) {
	          elements.input.setAttribute('aria-label', $scope.inputAriaLabel);
	        } else if ($scope.inputAriaLabelledBy) {
	          elements.input.setAttribute('aria-labelledby', $scope.inputAriaLabelledBy);
	        } else if ($scope.placeholder) {
	          // If no aria-label or aria-labelledby references are defined, then just label using the
	          // placeholder.
	          elements.input.setAttribute('aria-label', $scope.placeholder);
	        }
	      }
	    });
	  }
	
	  function updateModelValidators() {
	    if (!$scope.requireMatch || !inputModelCtrl) return;
	
	    inputModelCtrl.$setValidity('md-require-match', !!$scope.selectedItem || !$scope.searchText);
	  }
	
	  /**
	   * Calculates the dropdown's position and applies the new styles to the menu element
	   * @returns {*}
	   */
	  function positionDropdown () {
	    if (!elements) {
	      return $mdUtil.nextTick(positionDropdown, false, $scope);
	    }
	
	    var dropdownHeight = ($scope.dropdownItems || MAX_ITEMS) * ITEM_HEIGHT;
	    var hrect  = elements.wrap.getBoundingClientRect(),
	        vrect  = elements.snap.getBoundingClientRect(),
	        root   = elements.root.getBoundingClientRect(),
	        top    = vrect.bottom - root.top,
	        bot    = root.bottom - vrect.top,
	        left   = hrect.left - root.left,
	        width  = hrect.width,
	        offset = getVerticalOffset(),
	        position = $scope.dropdownPosition,
	        styles, enoughBottomSpace, enoughTopSpace;
	    var bottomSpace = root.bottom - vrect.bottom - MENU_PADDING + $mdUtil.getViewportTop();
	    var topSpace = vrect.top - MENU_PADDING;
	
	    // Automatically determine dropdown placement based on available space in viewport.
	    if (!position) {
	      enoughTopSpace = topSpace > dropdownHeight;
	      enoughBottomSpace = bottomSpace > dropdownHeight;
	      if (enoughBottomSpace) {
	        position = 'bottom';
	      } else if (enoughTopSpace) {
	        position = 'top';
	      } else {
	        position = topSpace > bottomSpace ? 'top' : 'bottom';
	      }
	    }
	    // Adjust the width to account for the padding provided by `md-input-container`
	    if ($attrs.mdFloatingLabel) {
	      left += INPUT_PADDING;
	      width -= INPUT_PADDING * 2;
	    }
	    styles = {
	      left:     left + 'px',
	      minWidth: width + 'px',
	      maxWidth: Math.max(hrect.right - root.left, root.right - hrect.left) - MENU_PADDING + 'px'
	    };
	
	    if (position === 'top') {
	      styles.top       = 'auto';
	      styles.bottom    = bot + 'px';
	      styles.maxHeight = Math.min(dropdownHeight, topSpace) + 'px';
	    } else {
	      bottomSpace = root.bottom - hrect.bottom - MENU_PADDING + $mdUtil.getViewportTop();
	
	      styles.top       = (top - offset) + 'px';
	      styles.bottom    = 'auto';
	      styles.maxHeight = Math.min(dropdownHeight, bottomSpace) + 'px';
	    }
	
	    elements.$.scrollContainer.css(styles);
	    $mdUtil.nextTick(correctHorizontalAlignment, false, $scope);
	
	    /**
	     * Calculates the vertical offset for floating label examples to account for ngMessages
	     * @returns {number}
	     */
	    function getVerticalOffset () {
	      var offset = 0;
	      var inputContainer = $element.find('md-input-container');
	      if (inputContainer.length) {
	        var input = inputContainer.find('input');
	        offset = inputContainer.prop('offsetHeight');
	        offset -= input.prop('offsetTop');
	        offset -= input.prop('offsetHeight');
	        // add in the height left up top for the floating label text
	        offset += inputContainer.prop('offsetTop');
	      }
	      return offset;
	    }
	
	    /**
	     * Makes sure that the menu doesn't go off of the screen on either side.
	     */
	    function correctHorizontalAlignment () {
	      var dropdown = elements.scrollContainer.getBoundingClientRect(),
	          styles   = {};
	      if (dropdown.right > root.right) {
	        styles.left = (hrect.right - dropdown.width) + 'px';
	      }
	      elements.$.scrollContainer.css(styles);
	    }
	  }
	
	  /**
	   * Moves the dropdown menu to the body tag in order to avoid z-index and overflow issues.
	   */
	  function moveDropdown () {
	    if (!elements.$.root.length) return;
	    $mdTheming(elements.$.scrollContainer);
	    elements.$.scrollContainer.detach();
	    elements.$.root.append(elements.$.scrollContainer);
	    if ($animate.pin) $animate.pin(elements.$.scrollContainer, $rootElement);
	  }
	
	  /**
	   * Sends focus to the input element.
	   */
	  function focusInputElement () {
	    elements.input.focus();
	  }
	
	  /**
	   * Update the activeOption based on the selected item in the listbox.
	   * The activeOption is used in the template to set the aria-activedescendant attribute, which
	   * enables screen readers to properly handle visual focus within the listbox and announce the
	   * item's place in the list. I.e. "List item 3 of 50". Anytime that `ctrl.index` changes, this
	   * function needs to be called to update the activeOption.
	   */
	  function updateActiveOption() {
	    var selectedOption = elements.scroller.querySelector('.selected');
	    if (selectedOption) {
	      ctrl.activeOption = selectedOption.id;
	    } else {
	      ctrl.activeOption = null;
	    }
	  }
	
	  /**
	   * Sets up any watchers used by autocomplete
	   */
	  function configureWatchers () {
	    var wait = parseInt($scope.delay, 10) || 0;
	
	    $attrs.$observe('disabled', function (value) { ctrl.isDisabled = $mdUtil.parseAttributeBoolean(value, false); });
	    $attrs.$observe('required', function (value) { ctrl.isRequired = $mdUtil.parseAttributeBoolean(value, false); });
	    $attrs.$observe('readonly', function (value) { ctrl.isReadonly = $mdUtil.parseAttributeBoolean(value, false); });
	
	    $scope.$watch('searchText', wait ? $mdUtil.debounce(handleSearchText, wait) : handleSearchText);
	    $scope.$watch('selectedItem', selectedItemChange);
	
	    angular.element($window).on('resize', debouncedOnResize);
	
	    $scope.$on('$destroy', cleanup);
	  }
	
	  /**
	   * Removes any events or leftover elements created by this controller
	   */
	  function cleanup () {
	    if (!ctrl.hidden) {
	      $mdUtil.enableScrolling();
	    }
	
	    angular.element($window).off('resize', debouncedOnResize);
	
	    if (elements){
	      var items = ['ul', 'scroller', 'scrollContainer', 'input'];
	      angular.forEach(items, function(key){
	        elements.$[key].remove();
	      });
	    }
	  }
	
	  /**
	   * Event handler to be called whenever the window resizes.
	   */
	  function onWindowResize() {
	    if (!ctrl.hidden) {
	      positionDropdown();
	    }
	  }
	
	  /**
	   * Gathers all of the elements needed for this controller
	   */
	  function gatherElements () {
	
	    var snapWrap = gatherSnapWrap();
	
	    elements = {
	      main:  $element[0],
	      scrollContainer: $element[0].querySelector('.md-virtual-repeat-container, .md-standard-list-container'),
	      scroller: $element[0].querySelector('.md-virtual-repeat-scroller, .md-standard-list-scroller'),
	      ul:    $element.find('ul')[0],
	      input: $element.find('input')[0],
	      wrap:  snapWrap.wrap,
	      snap:  snapWrap.snap,
	      root:  document.body,
	    };
	
	    elements.li   = elements.ul.getElementsByTagName('li');
	    elements.$    = getAngularElements(elements);
	    mode = elements.scrollContainer.classList.contains('md-standard-list-container') ? MODE_STANDARD : MODE_VIRTUAL;
	    inputModelCtrl = elements.$.input.controller('ngModel');
	  }
	
	  /**
	   * Gathers the snap and wrap elements
	   *
	   */
	  function gatherSnapWrap() {
	    var element;
	    var value;
	    for (element = $element; element.length; element = element.parent()) {
	      value = element.attr('md-autocomplete-snap');
	      if (angular.isDefined(value)) break;
	    }
	
	    if (element.length) {
	      return {
	        snap: element[0],
	        wrap: (value.toLowerCase() === 'width') ? element[0] : $element.find('md-autocomplete-wrap')[0]
	      };
	    }
	
	    var wrap = $element.find('md-autocomplete-wrap')[0];
	    return {
	      snap: wrap,
	      wrap: wrap
	    };
	  }
	
	  /**
	   * Gathers angular-wrapped versions of each element
	   * @param elements
	   * @returns {{}}
	   */
	  function getAngularElements (elements) {
	    var obj = {};
	    for (var key in elements) {
	      if (elements.hasOwnProperty(key)) obj[ key ] = angular.element(elements[ key ]);
	    }
	    return obj;
	  }
	
	  // event/change handlers
	
	  /**
	   * @param {Event} $event
	   */
	  function preventDefault($event) {
	    $event.preventDefault();
	  }
	
	  /**
	   * @param {Event} $event
	   */
	  function stopPropagation($event) {
	    $event.stopPropagation();
	  }
	
	  /**
	   * Handles changes to the `hidden` property.
	   * @param {boolean} hidden true to hide the options pop-up, false to show it.
	   * @param {boolean} oldHidden the previous value of hidden
	   */
	  function handleHiddenChange (hidden, oldHidden) {
	    var scrollContainerElement;
	
	    if (elements) {
	      scrollContainerElement = angular.element(elements.scrollContainer);
	    }
	    if (!hidden && oldHidden) {
	      positionDropdown();
	
	      // Report in polite mode, because the screen reader should finish the default description of
	      // the input element.
	      reportMessages(true, ReportType.Count | ReportType.Selected);
	
	      if (elements) {
	        $mdUtil.disableScrollAround(elements.scrollContainer);
	        enableWrapScroll = disableElementScrollEvents(elements.wrap);
	        if ($mdUtil.isIos) {
	          ctrl.documentElement.on('touchend', handleTouchOutsidePanel);
	          if (scrollContainerElement) {
	            scrollContainerElement.on('touchstart touchmove touchend', stopPropagation);
	          }
	        }
	        ctrl.index = getDefaultIndex();
	        $mdUtil.nextTick(function() {
	          updateActiveOption();
	          updateScroll();
	        });
	      }
	    } else if (hidden && !oldHidden) {
	      if ($mdUtil.isIos) {
	        ctrl.documentElement.off('touchend', handleTouchOutsidePanel);
	        if (scrollContainerElement) {
	          scrollContainerElement.off('touchstart touchmove touchend', stopPropagation);
	        }
	      }
	      $mdUtil.enableScrolling();
	
	      if (enableWrapScroll) {
	        enableWrapScroll();
	        enableWrapScroll = null;
	      }
	    }
	  }
	
	  /**
	   * Handling touch events that bubble up to the document is required for closing the dropdown
	   * panel on touch outside of the options pop-up panel on iOS.
	   * @param {Event} $event
	   */
	  function handleTouchOutsidePanel($event) {
	    ctrl.hidden = true;
	    // iOS does not blur the pop-up for touches on the scroll mask, so we have to do it.
	    doBlur(true);
	  }
	
	  /**
	   * Disables scrolling for a specific element.
	   * @param {!string|!DOMElement} element to disable scrolling
	   * @return {Function} function to call to re-enable scrolling for the element
	   */
	  function disableElementScrollEvents(element) {
	    var elementToDisable = angular.element(element);
	    elementToDisable.on('wheel touchmove', preventDefault);
	
	    return function() {
	      elementToDisable.off('wheel touchmove', preventDefault);
	    };
	  }
	
	  /**
	   * When the user mouses over the dropdown menu, ignore blur events.
	   */
	  function onListEnter () {
	    noBlur = true;
	  }
	
	  /**
	   * When the user's mouse leaves the menu, blur events may hide the menu again.
	   */
	  function onListLeave () {
	    if (!hasFocus && !ctrl.hidden) elements.input.focus();
	    noBlur = false;
	    ctrl.hidden = shouldHide();
	  }
	
	  /**
	   * Handles changes to the selected item.
	   * @param selectedItem
	   * @param previousSelectedItem
	   */
	  function selectedItemChange (selectedItem, previousSelectedItem) {
	
	    updateModelValidators();
	
	    if (selectedItem) {
	      getDisplayValue(selectedItem).then(function (val) {
	        $scope.searchText = val;
	        handleSelectedItemChange(selectedItem, previousSelectedItem);
	      });
	    } else if (previousSelectedItem && $scope.searchText) {
	      getDisplayValue(previousSelectedItem).then(function(displayValue) {
	        // Clear the searchText, when the selectedItem is set to null.
	        // Do not clear the searchText, when the searchText isn't matching with the previous
	        // selected item.
	        if (angular.isString($scope.searchText)
	          && displayValue.toString().toLowerCase() === $scope.searchText.toLowerCase()) {
	          $scope.searchText = '';
	        }
	      });
	    }
	
	    if (selectedItem !== previousSelectedItem) {
	      announceItemChange();
	    }
	  }
	
	  /**
	   * Use the user-defined expression to announce changes each time a new item is selected
	   */
	  function announceItemChange () {
	    angular.isFunction($scope.itemChange) &&
	      $scope.itemChange(getItemAsNameVal($scope.selectedItem));
	  }
	
	  /**
	   * Use the user-defined expression to announce changes each time the search text is changed
	   */
	  function announceTextChange () {
	    angular.isFunction($scope.textChange) && $scope.textChange();
	  }
	
	  /**
	   * Calls any external watchers listening for the selected item.  Used in conjunction with
	   * `registerSelectedItemWatcher`.
	   * @param selectedItem
	   * @param previousSelectedItem
	   */
	  function handleSelectedItemChange (selectedItem, previousSelectedItem) {
	    selectedItemWatchers.forEach(function (watcher) {
	      watcher(selectedItem, previousSelectedItem);
	    });
	  }
	
	  /**
	   * Register a function to be called when the selected item changes.
	   * @param cb
	   */
	  function registerSelectedItemWatcher (cb) {
	    if (selectedItemWatchers.indexOf(cb) === -1) {
	      selectedItemWatchers.push(cb);
	    }
	  }
	
	  /**
	   * Unregister a function previously registered for selected item changes.
	   * @param cb
	   */
	  function unregisterSelectedItemWatcher (cb) {
	    var i = selectedItemWatchers.indexOf(cb);
	    if (i !== -1) {
	      selectedItemWatchers.splice(i, 1);
	    }
	  }
	
	  /**
	   * Handles changes to the searchText property.
	   * @param {string} searchText
	   * @param {string} previousSearchText
	   */
	  function handleSearchText (searchText, previousSearchText) {
	    ctrl.index = getDefaultIndex();
	
	    // do nothing on init
	    if (searchText === previousSearchText) return;
	
	    updateModelValidators();
	
	    getDisplayValue($scope.selectedItem).then(function (val) {
	      // clear selected item if search text no longer matches it
	      if (searchText !== val) {
	        $scope.selectedItem = null;
	
	        // trigger change event if available
	        if (searchText !== previousSearchText) {
	          announceTextChange();
	        }
	
	        // cancel results if search text is not long enough
	        if (!isMinLengthMet()) {
	          ctrl.matches = [];
	
	          setLoading(false);
	          reportMessages(true, ReportType.Count);
	
	        } else {
	          handleQuery();
	        }
	      }
	    });
	
	  }
	
	  /**
	   * Handles input blur event, determines if the dropdown should hide.
	   */
	  function blur($event) {
	    hasFocus = false;
	
	    if (!noBlur) {
	      ctrl.hidden = shouldHide();
	      evalAttr('ngBlur', { $event: $event });
	    }
	  }
	
	  /**
	   * Force blur on input element
	   * @param {boolean} forceBlur
	   */
	  function doBlur(forceBlur) {
	    if (forceBlur) {
	      noBlur = false;
	      hasFocus = false;
	    }
	    elements.input.blur();
	  }
	
	  /**
	   * Handles input focus event, determines if the dropdown should show.
	   */
	  function focus($event) {
	    hasFocus = true;
	
	    if (isSearchable() && isMinLengthMet()) {
	      handleQuery();
	    }
	
	    ctrl.hidden = shouldHide();
	
	    evalAttr('ngFocus', { $event: $event });
	  }
	
	  /**
	   * Handles keyboard input.
	   * @param event
	   */
	  function keydown (event) {
	    switch (event.keyCode) {
	      case $mdConstant.KEY_CODE.DOWN_ARROW:
	        if (ctrl.loading || hasSelection()) return;
	        event.stopPropagation();
	        event.preventDefault();
	        ctrl.index = ctrl.index + 1 > ctrl.matches.length - 1 ? 0 : Math.min(ctrl.index + 1, ctrl.matches.length - 1);
	        $mdUtil.nextTick(updateActiveOption);
	        updateScroll();
	        break;
	      case $mdConstant.KEY_CODE.UP_ARROW:
	        if (ctrl.loading || hasSelection()) return;
	        event.stopPropagation();
	        event.preventDefault();
	        ctrl.index = ctrl.index - 1 < 0 ? ctrl.matches.length - 1 : Math.max(0, ctrl.index - 1);
	        $mdUtil.nextTick(updateActiveOption);
	        updateScroll();
	        break;
	      case $mdConstant.KEY_CODE.TAB:
	        // If we hit tab, assume that we've left the list so it will close
	        onListLeave();
	
	        if (ctrl.hidden || ctrl.loading || ctrl.index < 0 || ctrl.matches.length < 1) return;
	        select(ctrl.index);
	        break;
	      case $mdConstant.KEY_CODE.ENTER:
	        if (ctrl.hidden || ctrl.loading || ctrl.index < 0 || ctrl.matches.length < 1) return;
	        if (hasSelection()) return;
	        event.stopImmediatePropagation();
	        event.preventDefault();
	        select(ctrl.index);
	        break;
	      case $mdConstant.KEY_CODE.ESCAPE:
	        event.preventDefault(); // Prevent browser from always clearing input
	        if (!shouldProcessEscape()) return;
	        event.stopPropagation();
	
	        clearSelectedItem();
	        if ($scope.searchText && hasEscapeOption('clear')) {
	          clearSearchText();
	        }
	
	        // Manually hide (needed for mdNotFound support)
	        ctrl.hidden = true;
	
	        if (hasEscapeOption('blur')) {
	          // Force the component to blur if they hit escape
	          doBlur(true);
	        }
	
	        break;
	      default:
	    }
	  }
	
	  // getters
	
	  /**
	   * Returns the minimum length needed to display the dropdown.
	   * @returns {*}
	   */
	  function getMinLength () {
	    return angular.isNumber($scope.minLength) ? $scope.minLength : 1;
	  }
	
	  /**
	   * Returns the display value for an item.
	   * @param {*} item
	   * @returns {*}
	   */
	  function getDisplayValue (item) {
	    return $q.when(getItemText(item) || item).then(function(itemText) {
	      if (itemText && !angular.isString(itemText)) {
	        $log.warn('md-autocomplete: Could not resolve display value to a string. ' +
	          'Please check the `md-item-text` attribute.');
	      }
	
	      return itemText;
	    });
	
	    /**
	     * Getter function to invoke user-defined expression (in the directive)
	     * to convert your object to a single string.
	     * @param {*} item
	     * @returns {string|null}
	     */
	    function getItemText (item) {
	      return (item && $scope.itemText) ? $scope.itemText(getItemAsNameVal(item)) : null;
	    }
	  }
	
	  /**
	   * Returns the locals object for compiling item templates.
	   * @param {*} item
	   * @returns {Object|undefined}
	   */
	  function getItemAsNameVal (item) {
	    if (!item) {
	      return undefined;
	    }
	
	    var locals = {};
	    if (ctrl.itemName) {
	      locals[ ctrl.itemName ] = item;
	    }
	
	    return locals;
	  }
	
	  /**
	   * Returns the default index based on whether or not autoselect is enabled.
	   * @returns {number} 0 if autoselect is enabled, -1 if not.
	   */
	  function getDefaultIndex () {
	    return $scope.autoselect ? 0 : -1;
	  }
	
	  /**
	   * Sets the loading parameter and updates the hidden state.
	   * @param value {boolean} Whether or not the component is currently loading.
	   */
	  function setLoading(value) {
	    if (ctrl.loading !== value) {
	      ctrl.loading = value;
	    }
	
	    // Always refresh the hidden variable as something else might have changed
	    ctrl.hidden = shouldHide();
	  }
	
	  /**
	   * Determines if the menu should be hidden.
	   * @returns {boolean} true if the menu should be hidden
	   */
	  function shouldHide () {
	    return !shouldShow();
	  }
	
	  /**
	   * Determines whether the autocomplete is able to query within the current state.
	   * @returns {boolean} true if the query can be run
	   */
	  function isSearchable() {
	    if (ctrl.loading && !hasMatches()) {
	      // No query when query is in progress.
	      return false;
	    } else if (hasSelection()) {
	      // No query if there is already a selection
	      return false;
	    }
	    else if (!hasFocus) {
	      // No query if the input does not have focus
	      return false;
	    }
	    return true;
	  }
	
	  /**
	   * @returns {boolean} if the escape keydown should be processed, return true.
	   *  Otherwise return false.
	   */
	  function shouldProcessEscape() {
	    return hasEscapeOption('blur') || !ctrl.hidden || ctrl.loading || hasEscapeOption('clear') && $scope.searchText;
	  }
	
	  /**
	   * @param {string} option check if this option is set
	   * @returns {boolean} if the specified escape option is set, return true. Return false otherwise.
	   */
	  function hasEscapeOption(option) {
	    return !$scope.escapeOptions || $scope.escapeOptions.toLowerCase().indexOf(option) !== -1;
	  }
	
	  /**
	   * Determines if the menu should be shown.
	   * @returns {boolean} true if the menu should be shown
	   */
	  function shouldShow() {
	    if (ctrl.isReadonly) {
	      // Don't show if read only is set
	      return false;
	    } else if (!isSearchable()) {
	      // Don't show if a query is in progress, there is already a selection,
	      // or the input is not focused.
	      return false;
	    }
	    return (isMinLengthMet() && hasMatches()) || notFoundVisible();
	  }
	
	  /**
	   * @returns {boolean} true if the search text has matches.
	   */
	  function hasMatches() {
	    return ctrl.matches.length ? true : false;
	  }
	
	  /**
	   * @returns {boolean} true if the autocomplete has a valid selection.
	   */
	  function hasSelection() {
	    return ctrl.scope.selectedItem ? true : false;
	  }
	
	  /**
	   * @returns {boolean} true if the loading indicator is, or should be, visible.
	   */
	  function loadingIsVisible() {
	    return ctrl.loading && !hasSelection();
	  }
	
	  /**
	   * @returns {*} the display value of the current item.
	   */
	  function getCurrentDisplayValue () {
	    return getDisplayValue(ctrl.matches[ ctrl.index ]);
	  }
	
	  /**
	   * Determines if the minimum length is met by the search text.
	   * @returns {*} true if the minimum length is met by the search text
	   */
	  function isMinLengthMet () {
	    return ($scope.searchText || '').length >= getMinLength();
	  }
	
	  // actions
	
	  /**
	   * Defines a public property with a handler and a default value.
	   * @param {string} key
	   * @param {Function} handler function
	   * @param {*} defaultValue default value
	   */
	  function defineProperty (key, handler, defaultValue) {
	    Object.defineProperty(ctrl, key, {
	      get: function () { return defaultValue; },
	      set: function (newValue) {
	        var oldValue = defaultValue;
	        defaultValue        = newValue;
	        handler(newValue, oldValue);
	      }
	    });
	  }
	
	  /**
	   * Selects the item at the given index.
	   * @param {number} index to select
	   */
	  function select (index) {
	    // force form to update state for validation
	    $mdUtil.nextTick(function () {
	      getDisplayValue(ctrl.matches[ index ]).then(function (val) {
	        var ngModel = elements.$.input.controller('ngModel');
	        $mdLiveAnnouncer.announce(val + ' ' + ctrl.selectedMessage, 'assertive');
	        ngModel.$setViewValue(val);
	        ngModel.$render();
	      }).finally(function () {
	        $scope.selectedItem = ctrl.matches[ index ];
	        setLoading(false);
	      });
	    }, false);
	  }
	
	  /**
	   * Clears the searchText value and selected item.
	   * @param {Event} $event
	   */
	  function clearValue ($event) {
	    if ($event) {
	      $event.stopPropagation();
	    }
	    clearSelectedItem();
	    clearSearchText();
	  }
	
	  /**
	   * Clears the selected item
	   */
	  function clearSelectedItem () {
	    // Reset our variables
	    ctrl.index = -1;
	    $mdUtil.nextTick(updateActiveOption);
	    ctrl.matches = [];
	  }
	
	  /**
	   * Clears the searchText value
	   */
	  function clearSearchText () {
	    // Set the loading to true so we don't see flashes of content.
	    // The flashing will only occur when an async request is running.
	    // So the loading process will stop when the results had been retrieved.
	    setLoading(true);
	
	    $scope.searchText = '';
	
	    // Normally, triggering the change / input event is unnecessary, because the browser detects it properly.
	    // But some browsers are not detecting it properly, which means that we have to trigger the event.
	    // Using the `input` is not working properly, because for example IE11 is not supporting the `input` event.
	    // The `change` event is a good alternative and is supported by all supported browsers.
	    var eventObj = document.createEvent('CustomEvent');
	    eventObj.initCustomEvent('change', true, true, { value: '' });
	    elements.input.dispatchEvent(eventObj);
	
	    // For some reason, firing the above event resets the value of $scope.searchText if
	    // $scope.searchText has a space character at the end, so we blank it one more time and then
	    // focus.
	    elements.input.blur();
	    $scope.searchText = '';
	    elements.input.focus();
	  }
	
	  /**
	   * Fetches the results for the provided search text.
	   * @param searchText
	   */
	  function fetchResults (searchText) {
	    var items = $scope.$parent.$eval(itemExpr),
	        term  = searchText.toLowerCase(),
	        isList = angular.isArray(items),
	        isPromise = !!items.then; // Every promise should contain a `then` property
	
	    if (isList) onResultsRetrieved(items);
	    else if (isPromise) handleAsyncResults(items);
	
	    function handleAsyncResults(items) {
	      if (!items) return;
	
	      items = $q.when(items);
	      fetchesInProgress++;
	      setLoading(true);
	
	      $mdUtil.nextTick(function () {
	          items
	            .then(onResultsRetrieved)
	            .finally(function(){
	              if (--fetchesInProgress === 0) {
	                setLoading(false);
	              }
	            });
	      },true, $scope);
	    }
	
	    function onResultsRetrieved(matches) {
	      cache[term] = matches;
	
	      // Just cache the results if the request is now outdated.
	      // The request becomes outdated, when the new searchText has changed during the result fetching.
	      if ((searchText || '') !== ($scope.searchText || '')) {
	        return;
	      }
	
	      handleResults(matches);
	    }
	  }
	
	
	  /**
	   * Reports given message types to supported screen readers.
	   * @param {boolean} isPolite Whether the announcement should be polite.
	   * @param {!number} types Message flags to be reported to the screen reader.
	   */
	  function reportMessages(isPolite, types) {
	    var politeness = isPolite ? 'polite' : 'assertive';
	    var messages = [];
	
	    if (types & ReportType.Selected && ctrl.index !== -1) {
	      messages.push(getCurrentDisplayValue());
	    }
	
	    if (types & ReportType.Count) {
	      messages.push($q.resolve(getCountMessage()));
	    }
	
	    $q.all(messages).then(function(data) {
	      $mdLiveAnnouncer.announce(data.join(' '), politeness);
	    });
	  }
	
	  /**
	   * @returns {string} the ARIA message for how many results match the current query.
	   */
	  function getCountMessage () {
	    switch (ctrl.matches.length) {
	      case 0:
	        return 'There are no matches available.';
	      case 1:
	        return 'There is 1 match available.';
	      default:
	        return 'There are ' + ctrl.matches.length + ' matches available.';
	    }
	  }
	
	  /**
	   * Makes sure that the focused element is within view.
	   */
	  function updateScroll () {
	    if (!elements.li[0]) return;
	    if (mode === MODE_STANDARD) {
	      updateStandardScroll();
	    } else {
	      updateVirtualScroll();
	    }
	  }
	
	  function updateVirtualScroll() {
	    // elements in virtual scroll have consistent heights
	    var optionHeight = elements.li[0].offsetHeight,
	        top = optionHeight * Math.max(0, ctrl.index),
	        bottom = top + optionHeight,
	        containerHeight = elements.scroller.clientHeight,
	        scrollTop = elements.scroller.scrollTop;
	
	    if (top < scrollTop) {
	      scrollTo(top);
	    } else if (bottom > scrollTop + containerHeight) {
	      scrollTo(bottom - containerHeight);
	    }
	  }
	
	  function updateStandardScroll() {
	    // elements in standard scroll have variable heights
	    var selected =  elements.li[Math.max(0, ctrl.index)];
	    var containerHeight = elements.scrollContainer.offsetHeight,
	        top = selected && selected.offsetTop || 0,
	        bottom = top + selected.clientHeight,
	        scrollTop = elements.scrollContainer.scrollTop;
	
	    if (top < scrollTop) {
	      scrollTo(top);
	    } else if (bottom > scrollTop + containerHeight) {
	      scrollTo(bottom - containerHeight);
	    }
	  }
	
	  function isPromiseFetching() {
	    return fetchesInProgress !== 0;
	  }
	
	  function scrollTo (offset) {
	    if (mode === MODE_STANDARD) {
	      elements.scrollContainer.scrollTop = offset;
	    } else {
	      elements.$.scrollContainer.controller('mdVirtualRepeatContainer').scrollTo(offset);
	    }
	  }
	
	  function notFoundVisible () {
	    var textLength = (ctrl.scope.searchText || '').length;
	
	    return ctrl.hasNotFound && !hasMatches() && (!ctrl.loading || isPromiseFetching()) && textLength >= getMinLength() && (hasFocus || noBlur) && !hasSelection();
	  }
	
	  /**
	   * Starts the query to gather the results for the current searchText.  Attempts to return cached
	   * results first, then forwards the process to `fetchResults` if necessary.
	   */
	  function handleQuery () {
	    var searchText = $scope.searchText || '';
	    var term = searchText.toLowerCase();
	
	    // If caching is enabled and the current searchText is stored in the cache
	    if (!$scope.noCache && cache[term]) {
	      // The results should be handled as same as a normal un-cached request does.
	      handleResults(cache[term]);
	    } else {
	      fetchResults(searchText);
	    }
	
	    ctrl.hidden = shouldHide();
	  }
	
	  /**
	   * Handles the retrieved results by showing them in the autocompletes dropdown.
	   * @param results Retrieved results
	   */
	  function handleResults(results) {
	    ctrl.matches = results;
	    ctrl.hidden  = shouldHide();
	
	    // If loading is in progress, then we'll end the progress. This is needed for example,
	    // when the `clear` button was clicked, because there we always show the loading process, to prevent flashing.
	    if (ctrl.loading) setLoading(false);
	
	    if ($scope.selectOnMatch) selectItemOnMatch();
	
	    positionDropdown();
	    reportMessages(true, ReportType.Count);
	  }
	
	  /**
	   * If there is only one matching item and the search text matches its display value exactly,
	   * automatically select that item.  Note: This function is only called if the user uses the
	   * `md-select-on-match` flag.
	   */
	  function selectItemOnMatch () {
	    var searchText = $scope.searchText,
	        matches    = ctrl.matches,
	        item       = matches[ 0 ];
	    if (matches.length === 1) getDisplayValue(item).then(function (displayValue) {
	      var isMatching = searchText === displayValue;
	      if ($scope.matchInsensitive && !isMatching) {
	        isMatching = searchText.toLowerCase() === displayValue.toLowerCase();
	      }
	
	      if (isMatching) {
	        select(0);
	      }
	    });
	  }
	
	  /**
	   * Evaluates an attribute expression against the parent scope.
	   * @param {String} attr Name of the attribute to be evaluated.
	   * @param {Object?} locals Properties to be injected into the evaluation context.
	   */
	 function evalAttr(attr, locals) {
	    if ($attrs[attr]) {
	      $scope.$parent.$eval($attrs[attr], locals || {});
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdAutocomplete.$inject = ["$$mdSvgRegistry"];angular
	    .module('material.components.autocomplete')
	    .directive('mdAutocomplete', MdAutocomplete);
	
	/**
	 * @ngdoc directive
	 * @name mdAutocomplete
	 * @module material.components.autocomplete
	 *
	 * @description
	 * `<md-autocomplete>` is a special input component with a drop-down of all possible matches to a
	 *     custom query. This component allows you to provide real-time suggestions as the user types
	 *     in the input area.
	 *
	 * To start, you will need to specify the required parameters and provide a template for your
	 *     results. The content inside `md-autocomplete` will be treated as a template.
	 *
	 * In more complex cases, you may want to include other content such as a message to display when
	 *     no matches were found.  You can do this by wrapping your template in `md-item-template` and
	 *     adding a tag for `md-not-found`.  An example of this is shown below.
	 *
	 * To reset the displayed value you must clear both values for `md-search-text` and
	 * `md-selected-item`.
	 *
	 * ### Validation
	 *
	 * You can use `ng-messages` to include validation the same way that you would normally validate;
	 *     however, if you want to replicate a standard input with a floating label, you will have to
	 *     do the following:
	 *
	 * - Make sure that your template is wrapped in `md-item-template`
	 * - Add your `ng-messages` code inside of `md-autocomplete`
	 * - Add your validation properties to `md-autocomplete` (ie. `required`)
	 * - Add a `name` to `md-autocomplete` (to be used on the generated `input`)
	 *
	 * There is an example below of how this should look.
	 *
	 * ### Snapping Drop-Down
	 *
	 * You can cause the autocomplete drop-down to snap to an ancestor element by applying the
	 *     `md-autocomplete-snap` attribute to that element. You can also snap to the width of
	 *     the `md-autocomplete-snap` element by setting the attribute's value to `width`
	 *     (ie. `md-autocomplete-snap="width"`).
	 *
	 * ### Notes
	 *
	 * **Autocomplete Dropdown Items Rendering**
	 *
	 * The `md-autocomplete` uses the the <a ng-href="api/directive/mdVirtualRepeat">
	 *   mdVirtualRepeat</a> directive for displaying the results inside of the dropdown.<br/>
	 *
	 * > When encountering issues regarding the item template please take a look at the
	 *   <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> documentation.
	 *
	 * **Autocomplete inside of a Virtual Repeat**
	 *
	 * When using the `md-autocomplete` directive inside of a
	 * <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> the dropdown items
	 * might not update properly, because caching of the results is enabled by default.
	 *
	 * The autocomplete will then show invalid dropdown items, because the Virtual Repeat only updates
	 * the scope bindings rather than re-creating the `md-autocomplete`. This means that the previous
	 * cached results will be used.
	 *
	 * > To avoid such problems, ensure that the autocomplete does not cache any results via
	 * `md-no-cache="true"`:
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-no-cache="true"
	 *       md-selected-item="selectedItem"
	 *       md-items="item in items"
	 *       md-search-text="searchText"
	 *       md-item-text="item.display">
	 *     <span>{{ item.display }}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 *
	 *
	 * @param {expression} md-items An expression in the format of `item in results` to iterate over
	 *     matches for your search.<br/><br/>
	 *     The `results` expression can be also a function, which returns the results synchronously
	 *     or asynchronously (per Promise).
	 * @param {expression=} md-selected-item-change An expression to be run each time a new item is
	 *     selected.
	 * @param {expression=} md-search-text-change An expression to be run each time the search text
	 *     updates.
	 * @param {expression=} md-search-text A model to bind the search query text to.
	 * @param {object=} md-selected-item A model to bind the selected item to.
	 * @param {expression=} md-item-text An expression that will convert your object to a single string.
	 * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	 * @param {boolean=} md-no-cache Disables the internal caching that happens in autocomplete.
	 * @param {boolean=} ng-disabled Determines whether or not to disable the input field.
	 * @param {boolean=} md-require-match When set to true, the autocomplete will add a validator,
	 *     which will evaluate to false, when no item is currently selected.
	 * @param {number=} md-min-length Specifies the minimum length of text before autocomplete will
	 *     make suggestions.
	 * @param {number=} md-delay Specifies the amount of time (in milliseconds) to wait before looking
	 *     for results.
	 * @param {boolean=} md-clear-button Whether the clear button for the autocomplete input should show
	 *     up or not. When `md-floating-label` is set, defaults to false, defaults to true otherwise.
	 * @param {boolean=} md-autofocus If true, the autocomplete will be automatically focused when a
	 *     `$mdDialog`, `$mdBottomsheet` or `$mdSidenav`, which contains the autocomplete, is opening.
	 *     <br/><br/>
	 *     Also the autocomplete will immediately focus the input element.
	 * @param {boolean=} md-no-asterisk When present, asterisk will not be appended to the floating
	 *     label.
	 * @param {boolean=} md-autoselect If set to true, the first item will be automatically selected
	 *     in the dropdown upon open.
	 * @param {string=} md-input-name The name attribute given to the input element to be used with
	 *     FormController.
	 * @param {string=} md-menu-class This class will be applied to the dropdown menu for styling.
	 * @param {string=} md-menu-container-class This class will be applied to the parent container
	 *     of the dropdown panel.
	 * @param {string=} md-input-class This will be applied to the input for styling. This attribute
	 *     is only valid when a `md-floating-label` is defined.
	 * @param {string=} md-floating-label This will add a floating label to autocomplete and wrap it in
	 *     `md-input-container`.
	 * @param {string=} md-select-on-focus When present the input's text will be automatically selected
	 *     on focus.
	 * @param {string=} md-input-id An ID to be added to the input element.
	 * @param {number=} md-input-minlength The minimum length for the input's value for validation.
	 * @param {number=} md-input-maxlength The maximum length for the input's value for validation.
	 * @param {boolean=} md-select-on-match When set, autocomplete will automatically select
	 *     the item if the search text is an exact match. <br/><br/>
	 *     An exact match is when only one match is displayed.
	 * @param {boolean=} md-match-case-insensitive When set and using `md-select-on-match`, autocomplete
	 *     will select on case-insensitive match.
	 * @param {string=} md-escape-options Override escape key logic. Default is `blur clear`.<br/>
	 *     Options: `blur`, `clear`, `none`.
	 * @param {string=} md-dropdown-items Specifies the maximum amount of items to be shown in
	 *     the dropdown.<br/><br/>
	 *     When the dropdown doesn't fit into the viewport, the dropdown will shrink
	 *     as much as possible.
	 * @param {string=} md-dropdown-position Overrides the default dropdown position. Options: `top`,
	 *    `bottom`.
	 * @param {string=} input-aria-describedby A space-separated list of element IDs. This should
	 *     contain the IDs of any elements that describe this autocomplete. Screen readers will read the
	 *     content of these elements at the end of announcing that the autocomplete has been selected
	 *     and describing its current state. The descriptive elements do not need to be visible on the
	 *     page.
	 * @param {string=} input-aria-labelledby A space-separated list of element IDs. The ideal use case
	 *     is that this would contain the ID of a `<label>` element that is associated with this
	 *     autocomplete. This will only have affect when `md-floating-label` is not defined.<br><br>
	 *     For `<label id="state">US State</label>`, you would set this to
	 *     `input-aria-labelledby="state"`.
	 * @param {string=} input-aria-label A label that will be applied to the autocomplete's input.
	 *    This will be announced by screen readers before the placeholder.
	 *    This will only have affect when `md-floating-label` is not defined. If you define both
	 *    `input-aria-label` and `input-aria-labelledby`, then `input-aria-label` will take precedence.
	 * @param {string=} md-selected-message Attribute to specify the text that the screen reader will
	 *    announce after a value is selected. Default is: "selected". If `Alaska` is selected in the
	 *    options panel, it will read "Alaska selected". You will want to override this when your app
	 *    is running in a non-English locale.
	 * @param {boolean=} ng-trim If set to false, the search text will be not trimmed automatically.
	 *     Defaults to true.
	 * @param {string=} ng-pattern Adds the pattern validator to the ngModel of the search text.
	 *     See the [ngPattern Directive](https://docs.angularjs.org/api/ng/directive/ngPattern)
	 *     for more details.
	 * @param {string=} md-mode Specify the repeat mode for suggestion lists. Acceptable values include
	 *     `virtual` (md-virtual-repeat) and `standard` (ng-repeat). See the
	 *     `Specifying Repeat Mode` example for mode details. Default is `virtual`.
	 *
	 * @usage
	 * ### Basic Example
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 *
	 * ### Example with "not found" message
	 * <hljs lang="html">
	 * <md-autocomplete
	 *     md-selected-item="selectedItem"
	 *     md-search-text="searchText"
	 *     md-items="item in getMatches(searchText)"
	 *     md-item-text="item.display">
	 *   <md-item-template>
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-item-template>
	 *   <md-not-found>
	 *     No matches found.
	 *   </md-not-found>
	 * </md-autocomplete>
	 * </hljs>
	 *
	 * In this example, our code utilizes `md-item-template` and `md-not-found` to specify the
	 *     different parts that make up our component.
	 *
	 * ### Clear button for the input
	 * By default, the clear button is displayed when there is input. This aligns with the spec's
	 * [Search Pattern](https://material.io/archive/guidelines/patterns/search.html#search-in-app-search).
	 * In floating label mode, when `md-floating-label="My Label"` is applied, the clear button is not
	 * displayed by default (see the spec's
	 * [Autocomplete Text Field](https://material.io/archive/guidelines/components/text-fields.html#text-fields-layout)).
	 *
	 * Nevertheless, developers are able to explicitly toggle the clear button for all autocomplete
	 * components with `md-clear-button`.
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete ... md-clear-button="true"></md-autocomplete>
	 *   <md-autocomplete ... md-clear-button="false"></md-autocomplete>
	 * </hljs>
	 *
	 * In previous versions, the clear button was always hidden when the component was disabled.
	 * This changed in `1.1.5` to give the developer control of this behavior. This example
	 * will hide the clear button only when the component is disabled.
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete ... ng-disabled="disabled" md-clear-button="!disabled"></md-autocomplete>
	 * </hljs>
	 *
	 * ### Example with validation
	 * <hljs lang="html">
	 * <form name="autocompleteForm">
	 *   <md-autocomplete
	 *       required
	 *       md-input-name="autocomplete"
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <md-item-template>
	 *       <span md-highlight-text="searchText">{{item.display}}</span>
	 *     </md-item-template>
	 *     <div ng-messages="autocompleteForm.autocomplete.$error">
	 *       <div ng-message="required">This field is required</div>
	 *     </div>
	 *   </md-autocomplete>
	 * </form>
	 * </hljs>
	 *
	 * In this example, our code utilizes `md-item-template` and `ng-messages` to specify
	 *     input validation for the field.
	 *
	 * ### Asynchronous Results
	 * The autocomplete items expression also supports promises, which will resolve with the query
	 * results.
	 *
	 * <hljs lang="js">
	 *   function AppController($scope, $http) {
	 *     $scope.query = function(searchText) {
	 *       return $http
	 *         .get(BACKEND_URL + '/items/' + searchText)
	 *         .then(function(data) {
	 *           // Map the response object to the data object.
	 *           return data;
	 *         });
	 *     };
	 *   }
	 * </hljs>
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in query(searchText)">
	 *     <md-item-template>
	 *       <span md-highlight-text="searchText">{{item}}</span>
	 *     </md-item-template>
	 * </md-autocomplete>
	 * </hljs>
	 *
	 * ### Specifying Repeat Mode
	 * You can use `md-mode` to specify whether to use standard or virtual lists for
	 * rendering autocomplete options.
	 * The `md-mode` accepts two values:
	 * - `virtual` (default) Uses `md-virtual-repeat` to render list items. Virtual
	 *    mode requires you to have consistent heights for all suggestions.
	 * - `standard` uses `ng-repeat` to render list items. This allows you to have
	 *    options of varying heights.
	 *
	 * Note that using 'standard' mode will require you to address any list
	 * performance issues (e.g. pagination) separately within your application.
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display"
	 *       md-mode="standard">
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 */
	function MdAutocomplete ($$mdSvgRegistry) {
	  var REPEAT_STANDARD = 'standard';
	  var REPEAT_VIRTUAL = 'virtual';
	  var REPEAT_MODES = [REPEAT_STANDARD, REPEAT_VIRTUAL];
	
	  /** get a valid repeat mode from an md-mode attribute string. */
	  function getRepeatMode(modeStr) {
	    if (!modeStr) { return REPEAT_VIRTUAL; }
	    modeStr = modeStr.toLowerCase();
	    return  REPEAT_MODES.indexOf(modeStr) > -1 ? modeStr : REPEAT_VIRTUAL;
	  }
	
	  return {
	    controller:   'MdAutocompleteCtrl',
	    controllerAs: '$mdAutocompleteCtrl',
	    scope:        {
	      inputName:          '@mdInputName',
	      inputMinlength:     '@mdInputMinlength',
	      inputMaxlength:     '@mdInputMaxlength',
	      searchText:         '=?mdSearchText',
	      selectedItem:       '=?mdSelectedItem',
	      itemsExpr:          '@mdItems',
	      itemText:           '&mdItemText',
	      placeholder:        '@placeholder',
	      inputAriaDescribedBy: '@?inputAriaDescribedby',
	      inputAriaLabelledBy: '@?inputAriaLabelledby',
	      inputAriaLabel:     '@?inputAriaLabel',
	      noCache:            '=?mdNoCache',
	      requireMatch:       '=?mdRequireMatch',
	      selectOnMatch:      '=?mdSelectOnMatch',
	      matchInsensitive:   '=?mdMatchCaseInsensitive',
	      itemChange:         '&?mdSelectedItemChange',
	      textChange:         '&?mdSearchTextChange',
	      minLength:          '=?mdMinLength',
	      delay:              '=?mdDelay',
	      autofocus:          '=?mdAutofocus',
	      floatingLabel:      '@?mdFloatingLabel',
	      autoselect:         '=?mdAutoselect',
	      menuClass:          '@?mdMenuClass',
	      menuContainerClass: '@?mdMenuContainerClass',
	      inputClass:         '@?mdInputClass',
	      inputId:            '@?mdInputId',
	      escapeOptions:      '@?mdEscapeOptions',
	      dropdownItems:      '=?mdDropdownItems',
	      dropdownPosition:   '@?mdDropdownPosition',
	      clearButton:        '=?mdClearButton',
	      selectedMessage:    '@?mdSelectedMessage',
	      mdMode: '=?mdMode'
	    },
	    compile: function(tElement, tAttrs) {
	      var attributes = ['md-select-on-focus', 'md-no-asterisk', 'ng-trim', 'ng-pattern'];
	      var input = tElement.find('input');
	
	      attributes.forEach(function(attribute) {
	        var attrValue = tAttrs[tAttrs.$normalize(attribute)];
	
	        if (attrValue !== null) {
	          input.attr(attribute, attrValue);
	        }
	      });
	
	      return function(scope, element, attrs, ctrl) {
	        // Retrieve the state of using a md-not-found template by using our attribute, which will
	        // be added to the element in the template function.
	        ctrl.hasNotFound = !!element.attr('md-has-not-found');
	
	        // By default the inset autocomplete should show the clear button when not explicitly
	        // overwritten or in floating label mode.
	        if (!angular.isDefined(attrs.mdClearButton) && !scope.floatingLabel) {
	          scope.clearButton = true;
	        }
	
	        scope.mdMode = getRepeatMode(attrs.mdMode);
	
	        // Stop click events from bubbling up to the document and triggering a flicker of the
	        // options panel while still supporting ng-click to be placed on md-autocomplete.
	        element.on('click touchstart touchend', function(event) {
	          event.stopPropagation();
	        });
	      };
	    },
	    template: function (element, attr) {
	      var noItemsTemplate = getNoItemsTemplate(),
	          itemTemplate    = getItemTemplate(),
	          leftover        = element.html(),
	          tabindex        = attr.tabindex;
	
	      // Set our attribute for the link function above which runs later.
	      // We will set an attribute, because otherwise the stored variables will be trashed when
	      // removing the element is hidden while retrieving the template. For example when using ngIf.
	      if (noItemsTemplate) element.attr('md-has-not-found', true);
	
	      // Always set our tabindex of the autocomplete directive to -1, because our input
	      // will hold the actual tabindex.
	      element.attr('tabindex', '-1');
	
	      return '\
	        <md-autocomplete-wrap\
	            ng-class="{ \'md-whiteframe-z1\': !floatingLabel, \
	                        \'md-menu-showing\': !$mdAutocompleteCtrl.hidden, \
	                        \'md-show-clear-button\': !!clearButton }">\
	          ' + getInputElement() + '\
	          ' + getClearButton() + '\
	          <md-progress-linear\
	              class="' + (attr.mdFloatingLabel ? 'md-inline' : '') + '"\
	              ng-if="$mdAutocompleteCtrl.loadingIsVisible()"\
	              md-mode="indeterminate"></md-progress-linear>\
	          ' + getContainer(attr.mdMenuContainerClass, attr.mdMode) + '\
	            <ul class="md-autocomplete-suggestions"\
	                ng-class="::menuClass"\
	                id="ul-{{$mdAutocompleteCtrl.id}}"\
	                ng-mouseup="$mdAutocompleteCtrl.focusInput()"\
	                role="listbox">\
	              <li class="md-autocomplete-suggestion" ' + getRepeatType(attr.mdMode) + ' ="item in $mdAutocompleteCtrl.matches"\
	                  ng-class="{ selected: $index === $mdAutocompleteCtrl.index }"\
	                  ng-attr-id="{{\'md-option-\' + $mdAutocompleteCtrl.id + \'-\' + $index}}"\
	                  ng-click="$mdAutocompleteCtrl.select($index)"\
	                  role="option"\
	                  aria-setsize="{{$mdAutocompleteCtrl.matches.length}}"\
	                  aria-posinset="{{$index+1}}"\
	                  aria-selected="{{$index === $mdAutocompleteCtrl.index ? true : false}}" \
	                  md-extra-name="$mdAutocompleteCtrl.itemName">\
	                  ' + itemTemplate + '\
	                  </li>' + noItemsTemplate + '\
	            </ul>\
	          '  + getContainerClosingTags(attr.mdMode) + '\
	        </md-autocomplete-wrap>';
	
	      function getItemTemplate() {
	        var templateTag = element.find('md-item-template').detach(),
	            html = templateTag.length ? templateTag.html() : element.html();
	        if (!templateTag.length) element.empty();
	        return '<md-autocomplete-parent-scope md-autocomplete-replace>' + html +
	               '</md-autocomplete-parent-scope>';
	      }
	
	      function getNoItemsTemplate() {
	        var templateTag = element.find('md-not-found').detach(),
	            template = templateTag.length ? templateTag.html() : '';
	        return template
	            ? '<li ng-if="$mdAutocompleteCtrl.notFoundVisible()" class="md-autocomplete-suggestion"\
	                         md-autocomplete-parent-scope>' + template + '</li>'
	            : '';
	      }
	
	      function getContainer(menuContainerClass, repeatMode) {
	        // prepend a space if needed
	        menuContainerClass = menuContainerClass ? ' ' + menuContainerClass : '';
	
	        if (isVirtualRepeatDisabled(repeatMode)) {
	          return '\
	            <div \
	                ng-hide="$mdAutocompleteCtrl.hidden"\
	                class="md-standard-list-container md-autocomplete-suggestions-container md-whiteframe-z1' + menuContainerClass + '"\
	                ng-class="{ \'md-not-found\': $mdAutocompleteCtrl.notFoundVisible() }"\
	                ng-mouseenter="$mdAutocompleteCtrl.listEnter()"\
	                ng-mouseleave="$mdAutocompleteCtrl.listLeave()"\
	                role="presentation">\
	              <div class="md-standard-list-scroller" role="presentation">';
	        }
	
	        return '\
	          <md-virtual-repeat-container\
	              md-auto-shrink\
	              md-auto-shrink-min="1"\
	              ng-hide="$mdAutocompleteCtrl.hidden"\
	              class="md-virtual-repeat-container md-autocomplete-suggestions-container md-whiteframe-z1' + menuContainerClass + '"\
	              ng-class="{ \'md-not-found\': $mdAutocompleteCtrl.notFoundVisible() }"\
	              ng-mouseenter="$mdAutocompleteCtrl.listEnter()"\
	              ng-mouseleave="$mdAutocompleteCtrl.listLeave()"\
	              role="presentation">';
	      }
	
	      function getContainerClosingTags(repeatMode) {
	        return isVirtualRepeatDisabled(repeatMode) ?
	            '   </div>\
	              </div>\
	            </div>' : '</md-virtual-repeat-container>';
	      }
	
	      function getRepeatType(repeatMode) {
	        return isVirtualRepeatDisabled(repeatMode)  ?
	          'ng-repeat' : 'md-virtual-repeat';
	      }
	
	      function isVirtualRepeatDisabled(repeatMode) {
	        // ensure we have a valid repeat mode
	        var correctedRepeatMode = getRepeatMode(repeatMode);
	        return correctedRepeatMode !== REPEAT_VIRTUAL;
	      }
	
	      function getInputElement () {
	        if (attr.mdFloatingLabel) {
	          return '\
	            <md-input-container ng-if="floatingLabel">\
	              <label>{{floatingLabel}}</label>\
	              <input type="text"\
	                ' + (tabindex != null ? 'tabindex="' + tabindex + '"' : '') + '\
	                id="{{inputId || \'fl-input-\' + $mdAutocompleteCtrl.id}}"\
	                name="{{inputName || \'fl-input-\' + $mdAutocompleteCtrl.id }}"\
	                ng-class="::inputClass"\
	                autocomplete="off"\
	                ng-required="$mdAutocompleteCtrl.isRequired"\
	                ng-readonly="$mdAutocompleteCtrl.isReadonly"\
	                ng-minlength="inputMinlength"\
	                ng-maxlength="inputMaxlength"\
	                ng-disabled="$mdAutocompleteCtrl.isDisabled"\
	                ng-model="$mdAutocompleteCtrl.scope.searchText"\
	                ng-model-options="{ allowInvalid: true }"\
	                ng-mousedown="$mdAutocompleteCtrl.focusInput()"\
	                ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
	                ng-blur="$mdAutocompleteCtrl.blur($event)"\
	                ng-focus="$mdAutocompleteCtrl.focus($event)"\
	                aria-label="{{floatingLabel}}"\
	                ng-attr-aria-autocomplete="{{$mdAutocompleteCtrl.isDisabled ? undefined : \'list\'}}"\
	                ng-attr-role="{{$mdAutocompleteCtrl.isDisabled ? undefined : \'combobox\'}}"\
	                aria-haspopup="{{!$mdAutocompleteCtrl.isDisabled}}"\
	                aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"\
	                ng-attr-aria-owns="{{$mdAutocompleteCtrl.hidden || $mdAutocompleteCtrl.isDisabled ? undefined : \'ul-\' + $mdAutocompleteCtrl.id}}"\
	                ng-attr-aria-activedescendant="{{!$mdAutocompleteCtrl.hidden && $mdAutocompleteCtrl.activeOption ? $mdAutocompleteCtrl.activeOption : undefined}}">\
	              <div md-autocomplete-parent-scope md-autocomplete-replace>' + leftover + '</div>\
	            </md-input-container>';
	        } else {
	          return '\
	            <input type="text"\
	              ' + (tabindex != null ? 'tabindex="' + tabindex + '"' : '') + '\
	              id="{{inputId || \'input-\' + $mdAutocompleteCtrl.id}}"\
	              name="{{inputName || \'input-\' + $mdAutocompleteCtrl.id }}"\
	              ng-class="::inputClass"\
	              ng-if="!floatingLabel"\
	              autocomplete="off"\
	              ng-required="$mdAutocompleteCtrl.isRequired"\
	              ng-disabled="$mdAutocompleteCtrl.isDisabled"\
	              ng-readonly="$mdAutocompleteCtrl.isReadonly"\
	              ng-minlength="inputMinlength"\
	              ng-maxlength="inputMaxlength"\
	              ng-model="$mdAutocompleteCtrl.scope.searchText"\
	              ng-mousedown="$mdAutocompleteCtrl.focusInput()"\
	              ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
	              ng-blur="$mdAutocompleteCtrl.blur($event)"\
	              ng-focus="$mdAutocompleteCtrl.focus($event)"\
	              placeholder="{{placeholder}}"\
	              aria-label="{{placeholder}}"\
	              ng-attr-aria-autocomplete="{{$mdAutocompleteCtrl.isDisabled ? undefined : \'list\'}}"\
	              ng-attr-role="{{$mdAutocompleteCtrl.isDisabled ? undefined : \'combobox\'}}"\
	              aria-haspopup="{{!$mdAutocompleteCtrl.isDisabled}}"\
	              aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"\
	              ng-attr-aria-owns="{{$mdAutocompleteCtrl.hidden || $mdAutocompleteCtrl.isDisabled ? undefined : \'ul-\' + $mdAutocompleteCtrl.id}}"\
	              ng-attr-aria-activedescendant="{{!$mdAutocompleteCtrl.hidden && $mdAutocompleteCtrl.activeOption ? $mdAutocompleteCtrl.activeOption : undefined}}">';
	        }
	      }
	
	      function getClearButton() {
	        return '' +
	          '<button ' +
	              'type="button" ' +
	              'aria-label="Clear Input" ' +
	              'tabindex="0" ' +
	              'ng-if="clearButton && $mdAutocompleteCtrl.scope.searchText" ' +
	              'ng-click="$mdAutocompleteCtrl.clear($event)">' +
	            '<md-icon md-svg-src="' + $$mdSvgRegistry.mdClose + '"></md-icon>' +
	          '</button>';
	        }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdAutocompleteItemScopeDirective.$inject = ["$compile", "$mdUtil"];angular
	  .module('material.components.autocomplete')
	  .directive('mdAutocompleteParentScope', MdAutocompleteItemScopeDirective);
	
	function MdAutocompleteItemScopeDirective($compile, $mdUtil) {
	  return {
	    restrict: 'AE',
	    compile: compile,
	    terminal: true,
	    transclude: 'element'
	  };
	
	  function compile(tElement, tAttr, transclude) {
	    return function postLink(scope, element, attr) {
	      var ctrl = scope.$mdAutocompleteCtrl;
	      var newScope = ctrl.parent.$new();
	      var itemName = ctrl.itemName;
	
	      // Watch for changes to our scope's variables and copy them to the new scope
	      watchVariable('$index', '$index');
	      watchVariable('item', itemName);
	
	      // Ensure that $digest calls on our scope trigger $digest on newScope.
	      connectScopes();
	
	      // Link the element against newScope.
	      transclude(newScope, function(clone) {
	        element.after(clone);
	      });
	
	      /**
	       * Creates a watcher for variables that are copied from the parent scope
	       * @param variable
	       * @param alias
	       */
	      function watchVariable(variable, alias) {
	        newScope[alias] = scope[variable];
	
	        scope.$watch(variable, function(value) {
	          $mdUtil.nextTick(function() {
	            newScope[alias] = value;
	          });
	        });
	      }
	
	      /**
	       * Creates watchers on scope and newScope that ensure that for any
	       * $digest of scope, newScope is also $digested.
	       */
	      function connectScopes() {
	        var scopeDigesting = false;
	        var newScopeDigesting = false;
	
	        scope.$watch(function() {
	          if (newScopeDigesting || scopeDigesting) {
	            return;
	          }
	
	          scopeDigesting = true;
	          scope.$$postDigest(function() {
	            if (!newScopeDigesting) {
	              newScope.$digest();
	            }
	
	            scopeDigesting = newScopeDigesting = false;
	          });
	        });
	
	        newScope.$watch(function() {
	          newScopeDigesting = true;
	        });
	      }
	    };
	  }
	}
	})();
	(function(){
	"use strict";
	
	
	MdHighlightCtrl.$inject = ["$scope", "$element", "$attrs", "$mdUtil"];angular
	    .module('material.components.autocomplete')
	    .controller('MdHighlightCtrl', MdHighlightCtrl);
	
	function MdHighlightCtrl ($scope, $element, $attrs, $mdUtil) {
	  this.$scope = $scope;
	  this.$element = $element;
	  this.$attrs = $attrs;
	  this.$mdUtil = $mdUtil;
	
	  // Cache the Regex to avoid rebuilding each time.
	  this.regex = null;
	}
	
	MdHighlightCtrl.prototype.init = function(unsafeTermFn, unsafeContentFn) {
	
	  this.flags = this.$attrs.mdHighlightFlags || '';
	
	  this.unregisterFn = this.$scope.$watch(function($scope) {
	    return {
	      term: unsafeTermFn($scope),
	      contentText: unsafeContentFn($scope)
	    };
	  }.bind(this), this.onRender.bind(this), true);
	
	  this.$element.on('$destroy', this.unregisterFn);
	};
	
	/**
	 * Triggered once a new change has been recognized and the highlighted
	 * text needs to be updated.
	 */
	MdHighlightCtrl.prototype.onRender = function(state, prevState) {
	
	  var contentText = state.contentText;
	
	  /* Update the regex if it's outdated, because we don't want to rebuilt it constantly. */
	  if (this.regex === null || state.term !== prevState.term) {
	    this.regex = this.createRegex(state.term, this.flags);
	  }
	
	  /* If a term is available apply the regex to the content */
	  if (state.term) {
	    this.applyRegex(contentText);
	  } else {
	    this.$element.text(contentText);
	  }
	
	};
	
	/**
	 * Decomposes the specified text into different tokens (whether match or not).
	 * Breaking down the string guarantees proper XSS protection due to the native browser
	 * escaping of unsafe text.
	 */
	MdHighlightCtrl.prototype.applyRegex = function(text) {
	  var tokens = this.resolveTokens(text);
	
	  this.$element.empty();
	
	  tokens.forEach(function (token) {
	
	    if (token.isMatch) {
	      var tokenEl = angular.element('<span class="highlight">').text(token.text);
	
	      this.$element.append(tokenEl);
	    } else {
	      this.$element.append(document.createTextNode(token));
	    }
	
	  }.bind(this));
	
	};
	
	  /**
	 * Decomposes the specified text into different tokens by running the regex against the text.
	 */
	MdHighlightCtrl.prototype.resolveTokens = function(string) {
	  var tokens = [];
	  var lastIndex = 0;
	
	  // Use replace here, because it supports global and single regular expressions at same time.
	  string.replace(this.regex, function(match, index) {
	    appendToken(lastIndex, index);
	
	    tokens.push({
	      text: match,
	      isMatch: true
	    });
	
	    lastIndex = index + match.length;
	  });
	
	  // Append the missing text as a token.
	  appendToken(lastIndex);
	
	  return tokens;
	
	  function appendToken(from, to) {
	    var targetText = string.slice(from, to);
	    targetText && tokens.push(targetText);
	  }
	};
	
	/** Creates a regex for the specified text with the given flags. */
	MdHighlightCtrl.prototype.createRegex = function(term, flags) {
	  var startFlag = '', endFlag = '';
	  var regexTerm = this.$mdUtil.sanitize(term);
	
	  if (flags.indexOf('^') >= 0) startFlag = '^';
	  if (flags.indexOf('$') >= 0) endFlag = '$';
	
	  return new RegExp(startFlag + regexTerm + endFlag, flags.replace(/[$^]/g, ''));
	};
	
	})();
	(function(){
	"use strict";
	
	
	MdHighlight.$inject = ["$interpolate", "$parse"];angular
	    .module('material.components.autocomplete')
	    .directive('mdHighlightText', MdHighlight);
	
	/**
	 * @ngdoc directive
	 * @name mdHighlightText
	 * @module material.components.autocomplete
	 *
	 * @description
	 * The `md-highlight-text` directive allows you to specify text that should be highlighted within
	 *     an element.  Highlighted text will be wrapped in `<span class="highlight"></span>` which can
	 *     be styled through CSS.  Please note that child elements may not be used with this directive.
	 *
	 * @param {string} md-highlight-text A model to be searched for
	 * @param {string=} md-highlight-flags A list of flags (loosely based on JavaScript RexExp flags).
	 * #### **Supported flags**:
	 * - `g`: Find all matches within the provided text
	 * - `i`: Ignore case when searching for matches
	 * - `$`: Only match if the text ends with the search term
	 * - `^`: Only match if the text begins with the search term
	 *
	 * @usage
	 * <hljs lang="html">
	 * <input placeholder="Enter a search term..." ng-model="searchTerm" type="text" />
	 * <ul>
	 *   <li ng-repeat="result in results" md-highlight-text="searchTerm" md-highlight-flags="i">
	 *     {{result.text}}
	 *   </li>
	 * </ul>
	 * </hljs>
	 */
	
	function MdHighlight ($interpolate, $parse) {
	  return {
	    terminal: true,
	    controller: 'MdHighlightCtrl',
	    compile: function mdHighlightCompile(tElement, tAttr) {
	      var termExpr = $parse(tAttr.mdHighlightText);
	      var unsafeContentExpr = $interpolate(tElement.html());
	
	      return function mdHighlightLink(scope, element, attr, ctrl) {
	        ctrl.init(termExpr, unsafeContentExpr);
	      };
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/*
	 * @ngdoc module
	 * @name material.components.backdrop
	 * @description Backdrop
	 */
	
	/**
	 * @ngdoc directive
	 * @name mdBackdrop
	 * @module material.components.backdrop
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-backdrop>` is a backdrop element used by other components, such as dialog and bottom sheet.
	 * Apply class `opaque` to make the backdrop use the theme backdrop color.
	 *
	 */
	
	angular
	  .module('material.components.backdrop', ['material.core'])
	  .directive('mdBackdrop', ["$mdTheming", "$mdUtil", "$animate", "$rootElement", "$window", "$log", "$$rAF", "$document", function BackdropDirective($mdTheming, $mdUtil, $animate, $rootElement, $window, $log, $$rAF, $document) {
	    var ERROR_CSS_POSITION = '<md-backdrop> may not work properly in a scrolled, static-positioned parent container.';
	
	    return {
	      restrict: 'E',
	      link: postLink
	    };
	
	    function postLink(scope, element, attrs) {
	      // backdrop may be outside the $rootElement, tell ngAnimate to animate regardless
	      if ($animate.pin) $animate.pin(element, $rootElement);
	
	      var bodyStyles;
	
	      $$rAF(function() {
	        // If body scrolling has been disabled using mdUtil.disableBodyScroll(),
	        // adjust the 'backdrop' height to account for the fixed 'body' top offset.
	        // Note that this can be pretty expensive and is better done inside the $$rAF.
	        bodyStyles = $window.getComputedStyle($document[0].body);
	
	        if (bodyStyles.position === 'fixed') {
	          var resizeHandler = $mdUtil.debounce(function(){
	            bodyStyles = $window.getComputedStyle($document[0].body);
	            resize();
	          }, 60, null, false);
	
	          resize();
	          angular.element($window).on('resize', resizeHandler);
	
	          scope.$on('$destroy', function() {
	            angular.element($window).off('resize', resizeHandler);
	          });
	        }
	
	        // Often $animate.enter() is used to append the backDrop element
	        // so let's wait until $animate is done...
	        var parent = element.parent();
	
	        if (parent.length) {
	          if (parent[0].nodeName === 'BODY') {
	            element.css('position', 'fixed');
	          }
	
	          var styles = $window.getComputedStyle(parent[0]);
	
	          if (styles.position === 'static') {
	            // backdrop uses position:absolute and will not work properly with parent position:static (default)
	            $log.warn(ERROR_CSS_POSITION);
	          }
	
	          // Only inherit the parent if the backdrop has a parent.
	          $mdTheming.inherit(element, parent);
	        }
	      });
	
	      function resize() {
	        var viewportHeight = parseInt(bodyStyles.height, 10) + Math.abs(parseInt(bodyStyles.top, 10));
	        element.css('height', viewportHeight + 'px');
	      }
	    }
	
	  }]);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.bottomSheet
	 * @description
	 * BottomSheet
	 */
	MdBottomSheetDirective.$inject = ["$mdBottomSheet"];
	MdBottomSheetProvider.$inject = ["$$interimElementProvider"];
	angular
	  .module('material.components.bottomSheet', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .directive('mdBottomSheet', MdBottomSheetDirective)
	  .provider('$mdBottomSheet', MdBottomSheetProvider);
	
	/* @ngInject */
	function MdBottomSheetDirective($mdBottomSheet) {
	  return {
	    restrict: 'E',
	    link : function postLink(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      // When navigation force destroys an interimElement, then
	      // listen and $destroy() that interim instance...
	      scope.$on('$destroy', function() {
	        $mdBottomSheet.destroy();
	      });
	    }
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $mdBottomSheet
	 * @module material.components.bottomSheet
	 *
	 * @description
	 * `$mdBottomSheet` opens a bottom sheet over the app and provides a simple promise API.
	 *
	 * ## Restrictions
	 *
	 * - The bottom sheet's template must have an outer `<md-bottom-sheet>` element.
	 * - Add the `md-grid` class to the bottom sheet for a grid layout.
	 * - Add the `md-list` class to the bottom sheet for a list layout.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div ng-controller="MyController">
	 *   <md-button ng-click="openBottomSheet()">
	 *     Open a Bottom Sheet!
	 *   </md-button>
	 * </div>
	 * </hljs>
	 * <hljs lang="js">
	 * var app = angular.module('app', ['ngMaterial']);
	 * app.controller('MyController', function($scope, $mdBottomSheet) {
	 *   $scope.openBottomSheet = function() {
	 *     $mdBottomSheet.show({
	 *       template: '<md-bottom-sheet>' +
	 *       'Hello! <md-button ng-click="closeBottomSheet()">Close</md-button>' +
	 *       '</md-bottom-sheet>'
	 *     })
	 *
	 *     // Fires when the hide() method is used
	 *     .then(function() {
	 *       console.log('You clicked the button to close the bottom sheet!');
	 *     })
	 *
	 *     // Fires when the cancel() method is used
	 *     .catch(function() {
	 *       console.log('You hit escape or clicked the backdrop to close.');
	 *     });
	 *   };
	 *
	 *   $scope.closeBottomSheet = function($scope, $mdBottomSheet) {
	 *     $mdBottomSheet.hide();
	 *   }
	 *
	 * });
	 * </hljs>
	 *
	 * ### Custom Presets
	 * Developers are also able to create their own preset, which can be easily used without repeating
	 * their options each time.
	 *
	 * <hljs lang="js">
	 *   $mdBottomSheetProvider.addPreset('testPreset', {
	 *     options: function() {
	 *       return {
	 *         template:
	 *           '<md-bottom-sheet>' +
	 *             'This is a custom preset' +
	 *           '</md-bottom-sheet>',
	 *         controllerAs: 'bottomSheet',
	 *         bindToController: true,
	 *         clickOutsideToClose: true,
	 *         escapeToClose: true
	 *       };
	 *     }
	 *   });
	 * </hljs>
	 *
	 * After you create your preset during the config phase, you can easily access it.
	 *
	 * <hljs lang="js">
	 *   $mdBottomSheet.show(
	 *     $mdBottomSheet.testPreset()
	 *   );
	 * </hljs>
	 */
	
	 /**
	 * @ngdoc method
	 * @name $mdBottomSheet#show
	 *
	 * @description
	 * Show a bottom sheet with the specified options.
	 *
	 * <em><b>Note:</b> You should <b>always</b> provide a `.catch()` method in case the user hits the
	 * `esc` key or clicks the background to close. In this case, the `cancel()` method will
	 * automatically be called on the bottom sheet which will `reject()` the promise. See the @usage
	 * section above for an example.
	 *
	 * Newer versions of Angular will throw a `Possibly unhandled rejection` exception if you forget
	 * this.</em>
	 *
	 * @param {object} optionsOrPreset Either provide an `$mdBottomSheetPreset` defined during the config phase or
	 * an options object, with the following properties:
	 *
	 *   - `templateUrl` - `{string=}`: The url of an html template file that will
	 *   be used as the content of the bottom sheet. Restrictions: the template must
	 *   have an outer `md-bottom-sheet` element.
	 *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
	 *   template string.
	 *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified, it will create a new child scope.
	 *     This scope will be destroyed when the bottom sheet is removed unless `preserveScope` is set to true.
	 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
	 *   - `controller` - `{string=}`: The controller to associate with this bottom sheet.
	 *   - `locals` - `{string=}`: An object containing key/value pairs. The keys will
	 *   be used as names of values to inject into the controller. For example,
	 *   `locals: {three: 3}` would inject `three` into the controller with the value
	 *   of 3.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the bottom sheet to
	 *     close it. Default true.
	 *   - `bindToController` - `{boolean=}`: When set to true, the locals will be bound to the controller instance.
	 *   - `disableBackdrop` - `{boolean=}`: When set to true, the bottomsheet will not show a backdrop.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the bottom sheet.
	 *     Default true.
	 *   - `isLockedOpen` - `{boolean=}`: Disables all default ways of closing the bottom sheet. **Note:** this will override
	 *     the `clickOutsideToClose` and `escapeToClose` options, leaving only the `hide` and `cancel`
	 *     methods as ways of closing the bottom sheet. Defaults to false.
	 *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values
	 *   and the bottom sheet will not open until the promises resolve.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	 *   - `parent` - `{element=}`: The element to append the bottom sheet to. The `parent` may be a `function`, `string`,
	 *   `object`, or null. Defaults to appending to the body of the root element (or the root element) of the application.
	 *   e.g. angular.element(document.getElementById('content')) or "#content"
	 *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the bottom sheet is open.
	 *     Default true.
	 *
	 * @returns {promise} A promise that can be resolved with `$mdBottomSheet.hide()` or
	 * rejected with `$mdBottomSheet.cancel()`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdBottomSheet#hide
	 *
	 * @description
	 * Hide the existing bottom sheet and resolve the promise returned from
	 * `$mdBottomSheet.show()`. This call will close the most recently opened/current bottom sheet (if
	 * any).
	 *
	 * <em><b>Note:</b> Use a `.then()` on your `.show()` to handle this callback.</em>
	 *
	 * @param {*=} response An argument for the resolved promise.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdBottomSheet#cancel
	 *
	 * @description
	 * Hide the existing bottom sheet and reject the promise returned from
	 * `$mdBottomSheet.show()`.
	 *
	 * <em><b>Note:</b> Use a `.catch()` on your `.show()` to handle this callback.</em>
	 *
	 * @param {*=} response An argument for the rejected promise.
	 *
	 */
	
	function MdBottomSheetProvider($$interimElementProvider) {
	  // how fast we need to flick down to close the sheet, pixels/ms
	  bottomSheetDefaults.$inject = ["$animate", "$mdConstant", "$mdUtil", "$mdTheming", "$mdBottomSheet", "$rootElement", "$mdGesture", "$log"];
	  var CLOSING_VELOCITY = 0.5;
	  var PADDING = 80; // same as css
	
	  return $$interimElementProvider('$mdBottomSheet')
	    .setDefaults({
	      methods: ['disableParentScroll', 'escapeToClose', 'clickOutsideToClose'],
	      options: bottomSheetDefaults
	    });
	
	  /* @ngInject */
	  function bottomSheetDefaults($animate, $mdConstant, $mdUtil, $mdTheming, $mdBottomSheet, $rootElement,
	                               $mdGesture, $log) {
	    var backdrop;
	
	    return {
	      themable: true,
	      onShow: onShow,
	      onRemove: onRemove,
	      disableBackdrop: false,
	      escapeToClose: true,
	      clickOutsideToClose: true,
	      disableParentScroll: true,
	      isLockedOpen: false
	    };
	
	
	    function onShow(scope, element, options, controller) {
	
	      element = $mdUtil.extractElementByName(element, 'md-bottom-sheet');
	
	      // prevent tab focus or click focus on the bottom-sheet container
	      element.attr('tabindex', '-1');
	
	      // Once the md-bottom-sheet has `ng-cloak` applied on his template the opening animation will not work properly.
	      // This is a very common problem, so we have to notify the developer about this.
	      if (element.hasClass('ng-cloak')) {
	        var message = '$mdBottomSheet: using `<md-bottom-sheet ng-cloak>` will affect the bottom-sheet opening animations.';
	        $log.warn(message, element[0]);
	      }
	
	      if (options.isLockedOpen) {
	        options.clickOutsideToClose = false;
	        options.escapeToClose = false;
	      } else {
	        options.cleanupGestures = registerGestures(element, options.parent);
	      }
	
	      if (!options.disableBackdrop) {
	        // Add a backdrop that will close on click
	        backdrop = $mdUtil.createBackdrop(scope, "md-bottom-sheet-backdrop md-opaque");
	
	        // Prevent mouse focus on backdrop; ONLY programmatic focus allowed.
	        // This allows clicks on backdrop to propagate to the $rootElement and
	        // ESC key events to be detected properly.
	        backdrop[0].tabIndex = -1;
	
	        if (options.clickOutsideToClose) {
	          backdrop.on('click', function() {
	            $mdUtil.nextTick($mdBottomSheet.cancel, true);
	          });
	        }
	
	        $mdTheming.inherit(backdrop, options.parent);
	
	        $animate.enter(backdrop, options.parent, null);
	      }
	
	      $mdTheming.inherit(element, options.parent);
	
	      if (options.disableParentScroll) {
	        options.restoreScroll = $mdUtil.disableScrollAround(element, options.parent);
	      }
	
	      return $animate.enter(element, options.parent, backdrop)
	        .then(function() {
	          var focusable = $mdUtil.findFocusTarget(element) || angular.element(
	            element[0].querySelector('button') ||
	            element[0].querySelector('a') ||
	            element[0].querySelector($mdUtil.prefixer('ng-click', true))
	          ) || backdrop;
	
	          if (options.escapeToClose) {
	            options.rootElementKeyupCallback = function(e) {
	              if (e.keyCode === $mdConstant.KEY_CODE.ESCAPE) {
	                $mdUtil.nextTick($mdBottomSheet.cancel, true);
	              }
	            };
	
	            $rootElement.on('keyup', options.rootElementKeyupCallback);
	            focusable && focusable.focus();
	          }
	        });
	
	    }
	
	    function onRemove(scope, element, options) {
	      if (!options.disableBackdrop) $animate.leave(backdrop);
	
	      return $animate.leave(element).then(function() {
	        if (options.disableParentScroll) {
	          options.restoreScroll();
	          delete options.restoreScroll;
	        }
	
	        options.cleanupGestures && options.cleanupGestures();
	      });
	    }
	
	    /**
	     * Adds the drag gestures to the bottom sheet.
	     * @param {angular.JQLite} element where CSS transitions will be applied
	     * @param {angular.JQLite} parent used for registering gesture listeners
	     * @return {Function} function that removes gesture listeners that were set up by
	     *  registerGestures()
	     */
	    function registerGestures(element, parent) {
	      var deregister = $mdGesture.register(parent, 'drag', { horizontal: false });
	      parent.on('$md.dragstart', onDragStart)
	        .on('$md.drag', onDrag)
	        .on('$md.dragend', onDragEnd);
	
	      return function cleanupGestures() {
	        deregister();
	        parent.off('$md.dragstart', onDragStart);
	        parent.off('$md.drag', onDrag);
	        parent.off('$md.dragend', onDragEnd);
	      };
	
	      function onDragStart() {
	        // Disable transitions on transform so that it feels fast
	        element.css($mdConstant.CSS.TRANSITION_DURATION, '0ms');
	      }
	
	      function onDrag(ev) {
	        var transform = ev.pointer.distanceY;
	        if (transform < 5) {
	          // Slow down drag when trying to drag up, and stop after PADDING
	          transform = Math.max(-PADDING, transform / 2);
	        }
	        element.css($mdConstant.CSS.TRANSFORM, 'translate3d(0,' + (PADDING + transform) + 'px,0)');
	      }
	
	      function onDragEnd(ev) {
	        if (ev.pointer.distanceY > 0 &&
	            (ev.pointer.distanceY > 20 || Math.abs(ev.pointer.velocityY) > CLOSING_VELOCITY)) {
	          var distanceRemaining = element.prop('offsetHeight') - ev.pointer.distanceY;
	          var transitionDuration = Math.min(distanceRemaining / ev.pointer.velocityY * 0.75, 500);
	          element.css($mdConstant.CSS.TRANSITION_DURATION, transitionDuration + 'ms');
	          $mdUtil.nextTick($mdBottomSheet.cancel, true);
	        } else {
	          element.css($mdConstant.CSS.TRANSITION_DURATION, '');
	          element.css($mdConstant.CSS.TRANSFORM, '');
	        }
	      }
	    }
	
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.button
	 * @description
	 *
	 * Button
	 */
	MdButtonDirective.$inject = ["$mdButtonInkRipple", "$mdTheming", "$mdAria", "$mdInteraction"];
	MdAnchorDirective.$inject = ["$mdTheming"];
	angular
	    .module('material.components.button', ['material.core'])
	    .directive('mdButton', MdButtonDirective)
	    .directive('a', MdAnchorDirective);
	
	
	/**
	 * @private
	 * @restrict E
	 *
	 * @description
	 * `a` is an anchor directive used to inherit theme colors for md-primary, md-accent, etc.
	 *
	 * @usage
	 *
	 * <hljs lang="html">
	 *  <md-content md-theme="myTheme">
	 *    <a href="#chapter1" class="md-accent"></a>
	 *  </md-content>
	 * </hljs>
	 */
	function MdAnchorDirective($mdTheming) {
	  return {
	    restrict : 'E',
	    link : function postLink(scope, element) {
	      // Make sure to inherit theme so stand-alone anchors
	      // support theme colors for md-primary, md-accent, etc.
	      $mdTheming(element);
	    }
	  };
	}
	
	
	/**
	 * @ngdoc directive
	 * @name mdButton
	 * @module material.components.button
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-button>` is a button directive with optional ink ripples (default enabled).
	 *
	 * If you supply a `href` or `ng-href` attribute, it will become an `<a>` element. Otherwise, it
	 * will become a `<button>` element. As per the
	 * [Material Design specifications](https://material.google.com/style/color.html#color-color-palette)
	 * the FAB button background is filled with the accent color [by default]. The primary color palette
	 * may be used with the `md-primary` class.
	 *
	 * Developers can also change the color palette of the button, by using the following classes
	 * - `md-primary`
	 * - `md-accent`
	 * - `md-warn`
	 *
	 * See for example
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-primary">Primary Button</md-button>
	 * </hljs>
	 *
	 * Button can be also raised, which means that they will use the current color palette to fill the button.
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-accent md-raised">Raised and Accent Button</md-button>
	 * </hljs>
	 *
	 * It is also possible to disable the focus effect on the button, by using the following markup.
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-no-focus">No Focus Style</md-button>
	 * </hljs>
	 *
	 * @param {string=} aria-label Adds alternative text to button for accessibility, useful for icon buttons.
	 * If no default text is found, a warning will be logged.
	 * @param {boolean=} md-no-ink If present, disable ink ripple effects.
	 * @param {string=} md-ripple-size Overrides the default ripple size logic. Options: `full`, `partial`, `auto`.
	 * @param {expression=} ng-disabled Disable the button when the expression is truthy.
	 * @param {expression=} ng-blur Expression evaluated when focus is removed from the button.
	 *
	 * @usage
	 *
	 * Regular buttons:
	 *
	 * <hljs lang="html">
	 *  <md-button> Flat Button </md-button>
	 *  <md-button href="http://google.com"> Flat link </md-button>
	 *  <md-button class="md-raised"> Raised Button </md-button>
	 *  <md-button ng-disabled="true"> Disabled Button </md-button>
	 *  <md-button>
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *    Register Now
	 *  </md-button>
	 * </hljs>
	 *
	 * FAB buttons:
	 *
	 * <hljs lang="html">
	 *  <md-button class="md-fab" aria-label="FAB">
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *  </md-button>
	 *  <!-- mini-FAB -->
	 *  <md-button class="md-fab md-mini" aria-label="Mini FAB">
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *  </md-button>
	 *  <!-- Button with SVG Icon -->
	 *  <md-button class="md-icon-button" aria-label="Custom Icon Button">
	 *    <md-icon md-svg-icon="path/to/your.svg"></md-icon>
	 *  </md-button>
	 * </hljs>
	 */
	function MdButtonDirective($mdButtonInkRipple, $mdTheming, $mdAria, $mdInteraction) {
	
	  return {
	    restrict: 'EA',
	    replace: true,
	    transclude: true,
	    template: getTemplate,
	    link: postLink
	  };
	
	  function isAnchor(attr) {
	    return angular.isDefined(attr.href) || angular.isDefined(attr.ngHref) || angular.isDefined(attr.ngLink) || angular.isDefined(attr.uiSref);
	  }
	
	  function getTemplate(element, attr) {
	    if (isAnchor(attr)) {
	      return '<a class="md-button" ng-transclude></a>';
	    } else {
	      // If buttons don't have type="button", they will submit forms automatically.
	      var btnType = (typeof attr.type === 'undefined') ? 'button' : attr.type;
	      return '<button class="md-button" type="' + btnType + '" ng-transclude></button>';
	    }
	  }
	
	  function postLink(scope, element, attr) {
	    $mdTheming(element);
	    $mdButtonInkRipple.attach(scope, element);
	
	    // Use async expect to support possible bindings in the button label
	    $mdAria.expectWithoutText(element, 'aria-label');
	
	    // For anchor elements, we have to set tabindex manually when the element is disabled.
	    // We don't do this for md-nav-bar anchors as the component manages its own tabindex values.
	    if (isAnchor(attr) && angular.isDefined(attr.ngDisabled) &&
	        !element.hasClass('_md-nav-button')) {
	      scope.$watch(attr.ngDisabled, function(isDisabled) {
	        element.attr('tabindex', isDisabled ? -1 : 0);
	      });
	    }
	
	    // disabling click event when disabled is true
	    element.on('click', function(e){
	      if (attr.disabled === true) {
	        e.preventDefault();
	        e.stopImmediatePropagation();
	      }
	    });
	
	    if (!element.hasClass('md-no-focus')) {
	
	      element.on('focus', function() {
	
	        // Only show the focus effect when being focused through keyboard interaction or programmatically
	        if (!$mdInteraction.isUserInvoked() || $mdInteraction.getLastInteractionType() === 'keyboard') {
	          element.addClass('md-focused');
	        }
	
	      });
	
	      element.on('blur', function() {
	        element.removeClass('md-focused');
	      });
	    }
	
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.card
	 *
	 * @description
	 * Card components.
	 */
	mdCardDirective.$inject = ["$mdTheming"];
	angular.module('material.components.card', [
	    'material.core'
	  ])
	  .directive('mdCard', mdCardDirective);
	
	
	/**
	 * @ngdoc directive
	 * @name mdCard
	 * @module material.components.card
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-card>` directive is a container element used within `<md-content>` containers.
	 *
	 * An image included as a direct descendant will fill the card's width. If you want to avoid this,
	 * you can add the `md-image-no-fill` class to the parent element. The `<md-card-content>`
	 * container will wrap text content and provide padding. An `<md-card-footer>` element can be
	 * optionally included to put content flush against the bottom edge of the card.
	 *
	 * Action buttons can be included in an `<md-card-actions>` element, similar to `<md-dialog-actions>`.
	 * You can then position buttons using layout attributes.
	 *
	 * Card is built with:
	 * * `<md-card-header>` - Header for the card, holds avatar, text and squared image
	 *  - `<md-card-avatar>` - Card avatar
	 *    - `md-user-avatar` - Class for user image
	 *    - `<md-icon>`
	 *  - `<md-card-header-text>` - Contains elements for the card description
	 *    - `md-title` - Class for the card title
	 *    - `md-subhead` - Class for the card sub header
	 * * `<img>` - Image for the card
	 * * `<md-card-title>` - Card content title
	 *  - `<md-card-title-text>`
	 *    - `md-headline` - Class for the card content title
	 *    - `md-subhead` - Class for the card content sub header
	 *  - `<md-card-title-media>` - Squared image within the title
	 *    - `md-media-sm` - Class for small image
	 *    - `md-media-md` - Class for medium image
	 *    - `md-media-lg` - Class for large image
	 *    - `md-media-xl` - Class for extra large image
	 * * `<md-card-content>` - Card content
	 * * `<md-card-actions>` - Card actions
	 *  - `<md-card-icon-actions>` - Icon actions
	 *
	 * Cards have constant width and variable heights; where the maximum height is limited to what can
	 * fit within a single view on a platform, but it can temporarily expand as needed.
	 *
	 * @usage
	 * ### Card with optional footer
	 * <hljs lang="html">
	 * <md-card>
	 *  <img src="card-image.png" class="md-card-image" alt="image caption">
	 *  <md-card-content>
	 *    <h2>Card headline</h2>
	 *    <p>Card content</p>
	 *  </md-card-content>
	 *  <md-card-footer>
	 *    Card footer
	 *  </md-card-footer>
	 * </md-card>
	 * </hljs>
	 *
	 * ### Card with actions
	 * <hljs lang="html">
	 * <md-card>
	 *  <img src="card-image.png" class="md-card-image" alt="image caption">
	 *  <md-card-content>
	 *    <h2>Card headline</h2>
	 *    <p>Card content</p>
	 *  </md-card-content>
	 *  <md-card-actions layout="row" layout-align="end center">
	 *    <md-button>Action 1</md-button>
	 *    <md-button>Action 2</md-button>
	 *  </md-card-actions>
	 * </md-card>
	 * </hljs>
	 *
	 * ### Card with header, image, title actions and content
	 * <hljs lang="html">
	 * <md-card>
	 *   <md-card-header>
	 *     <md-card-avatar>
	 *       <img class="md-user-avatar" src="avatar.png"/>
	 *     </md-card-avatar>
	 *     <md-card-header-text>
	 *       <span class="md-title">Title</span>
	 *       <span class="md-subhead">Sub header</span>
	 *     </md-card-header-text>
	 *   </md-card-header>
	 *   <img ng-src="card-image.png" class="md-card-image" alt="image caption">
	 *   <md-card-title>
	 *     <md-card-title-text>
	 *       <span class="md-headline">Card headline</span>
	 *       <span class="md-subhead">Card subheader</span>
	 *     </md-card-title-text>
	 *   </md-card-title>
	 *   <md-card-actions layout="row" layout-align="start center">
	 *     <md-button>Action 1</md-button>
	 *     <md-button>Action 2</md-button>
	 *     <md-card-icon-actions>
	 *       <md-button class="md-icon-button" aria-label="icon">
	 *         <md-icon md-svg-icon="icon"></md-icon>
	 *       </md-button>
	 *     </md-card-icon-actions>
	 *   </md-card-actions>
	 *   <md-card-content>
	 *     <p>
	 *      Card content
	 *     </p>
	 *   </md-card-content>
	 * </md-card>
	 * </hljs>
	 */
	function mdCardDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    link: function ($scope, $element, attr) {
	      $element.addClass('_md');     // private md component indicator for styling
	      $mdTheming($element);
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.checkbox
	 * @description Checkbox module!
	 */
	MdCheckboxDirective.$inject = ["inputDirective", "$mdAria", "$mdConstant", "$mdTheming", "$mdUtil", "$mdInteraction"];
	angular
	  .module('material.components.checkbox', ['material.core'])
	  .directive('mdCheckbox', MdCheckboxDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdCheckbox
	 * @module material.components.checkbox
	 * @restrict E
	 *
	 * @description
	 * The checkbox directive is used like the normal
	 * [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
	 *
	 * As per the [Material Design spec](https://material.io/archive/guidelines/style/color.html#color-color-palette)
	 * the checkbox is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * @param {expression} ng-model Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {expression=} ng-true-value The value to which the expression should be set when selected.
	 * @param {expression=} ng-false-value The value to which the expression should be set when not
	 *    selected.
	 * @param {expression=} ng-change Expression to be executed when the model value changes.
	 * @param {boolean=} md-no-ink If present, disable ink ripple effects.
	 * @param {string=} aria-label Adds label to checkbox for accessibility.
	 *    Defaults to checkbox's text. If no default text is found, a warning will be logged.
	 * @param {expression=} md-indeterminate This determines when the checkbox should be rendered as
	 *    'indeterminate'. If a truthy expression or no value is passed in the checkbox renders in the
	 *    md-indeterminate state. If falsy expression is passed in it just looks like a normal unchecked
	 *    checkbox. The indeterminate, checked, and unchecked states are mutually exclusive. A box
	 *    cannot be in any two states at the same time. Adding the 'md-indeterminate' attribute
	 *    overrides any checked/unchecked rendering logic. When using the 'md-indeterminate' attribute
	 *    use 'ng-checked' to define rendering logic instead of using 'ng-model'.
	 * @param {expression=} ng-checked If this expression evaluates as truthy, the 'md-checked' css
	 *    class is added to the checkbox and it will appear checked.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-checkbox ng-model="isChecked" aria-label="Finished?">
	 *   Finished ?
	 * </md-checkbox>
	 *
	 * <md-checkbox md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
	 *   No Ink Effects
	 * </md-checkbox>
	 *
	 * <md-checkbox ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
	 *   Disabled
	 * </md-checkbox>
	 *
	 * </hljs>
	 *
	 */
	function MdCheckboxDirective(inputDirective, $mdAria, $mdConstant, $mdTheming, $mdUtil, $mdInteraction) {
	  inputDirective = inputDirective[0];
	
	  return {
	    restrict: 'E',
	    transclude: true,
	    require: ['^?mdInputContainer', '?ngModel', '?^form'],
	    priority: $mdConstant.BEFORE_NG_ARIA,
	    template:
	      '<div class="md-container" md-ink-ripple md-ink-ripple-checkbox>' +
	        '<div class="md-icon"></div>' +
	      '</div>' +
	      '<div ng-transclude class="md-label"></div>',
	    compile: compile
	  };
	
	  // **********************************************************
	  // Private Methods
	  // **********************************************************
	
	  function compile (tElement, tAttrs) {
	    tAttrs.$set('tabindex', tAttrs.tabindex || '0');
	    tAttrs.$set('type', 'checkbox');
	    tAttrs.$set('role', tAttrs.type);
	
	    return  {
	      pre: function(scope, element) {
	        // Attach a click handler during preLink, in order to immediately stop propagation
	        // (especially for ng-click) when the checkbox is disabled.
	        element.on('click', function(e) {
	          if (this.hasAttribute('disabled')) {
	            e.stopImmediatePropagation();
	          }
	        });
	      },
	      post: postLink
	    };
	
	    function postLink(scope, element, attr, ctrls) {
	      var isIndeterminate;
	      var containerCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
	      var formCtrl = ctrls[2];
	
	      if (containerCtrl) {
	        var isErrorGetter = containerCtrl.isErrorGetter || function() {
	          return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (formCtrl && formCtrl.$submitted));
	        };
	
	        containerCtrl.input = element;
	
	        scope.$watch(isErrorGetter, containerCtrl.setInvalid);
	      }
	
	      $mdTheming(element);
	
	      // Redirect focus events to the root element, because IE11 is always focusing the container element instead
	      // of the md-checkbox element. This causes issues when using ngModelOptions: `updateOnBlur`
	      element.children().on('focus', function() {
	        element.focus();
	      });
	
	      if ($mdUtil.parseAttributeBoolean(attr.mdIndeterminate)) {
	        setIndeterminateState();
	        scope.$watch(attr.mdIndeterminate, setIndeterminateState);
	      }
	
	      if (attr.ngChecked) {
	        scope.$watch(scope.$eval.bind(scope, attr.ngChecked), function(value) {
	          ngModelCtrl.$setViewValue(value);
	          ngModelCtrl.$render();
	        });
	      }
	
	      $$watchExpr('ngDisabled', 'tabindex', {
	        true: '-1',
	        false: attr.tabindex
	      });
	
	      $mdAria.expectWithText(element, 'aria-label');
	
	      // Reuse the original input[type=checkbox] directive from AngularJS core.
	      // This is a bit hacky as we need our own event listener and own render
	      // function.
	      inputDirective.link.pre(scope, {
	        on: angular.noop,
	        0: {}
	      }, attr, [ngModelCtrl]);
	
	      element.on('click', listener)
	        .on('keypress', keypressHandler)
	        .on('focus', function() {
	          if ($mdInteraction.getLastInteractionType() === 'keyboard') {
	            element.addClass('md-focused');
	          }
	        })
	        .on('blur', function() {
	          element.removeClass('md-focused');
	        });
	
	      ngModelCtrl.$render = render;
	
	      function $$watchExpr(expr, htmlAttr, valueOpts) {
	        if (attr[expr]) {
	          scope.$watch(attr[expr], function(val) {
	            if (valueOpts[val]) {
	              element.attr(htmlAttr, valueOpts[val]);
	            }
	          });
	        }
	      }
	
	      /**
	       * @param {KeyboardEvent} ev 'keypress' event to handle
	       */
	      function keypressHandler(ev) {
	        var keyCode = ev.which || ev.keyCode;
	        var submit, form;
	
	        ev.preventDefault();
	        switch (keyCode) {
	          case $mdConstant.KEY_CODE.SPACE:
	            element.addClass('md-focused');
	            listener(ev);
	            break;
	          case $mdConstant.KEY_CODE.ENTER:
	            // Match the behavior of the native <input type="checkbox">.
	            // When the enter key is pressed while focusing a native checkbox inside a form,
	            // the browser will trigger a `click` on the first non-disabled submit button/input
	            // in the form. Note that this is different from text inputs, which
	            // will directly submit the form without needing a submit button/input to be present.
	            form = $mdUtil.getClosest(ev.target, 'form');
	            if (form) {
	              submit = form.querySelector('button[type="submit"]:enabled, input[type="submit"]:enabled');
	              if (submit) {
	                submit.click();
	              }
	            }
	            break;
	        }
	      }
	
	      function listener(ev) {
	        // skipToggle boolean is used by the switch directive to prevent the click event
	        // when releasing the drag. There will be always a click if releasing the drag over the checkbox
	        if (element[0].hasAttribute('disabled') || scope.skipToggle) {
	          return;
	        }
	
	        scope.$apply(function() {
	          // Toggle the checkbox value...
	          var viewValue = attr.ngChecked && attr.ngClick ? attr.checked : !ngModelCtrl.$viewValue;
	
	          ngModelCtrl.$setViewValue(viewValue, ev && ev.type);
	          ngModelCtrl.$render();
	        });
	      }
	
	      function render() {
	        // Cast the $viewValue to a boolean since it could be undefined
	        element.toggleClass('md-checked', !!ngModelCtrl.$viewValue && !isIndeterminate);
	      }
	
	      function setIndeterminateState(newValue) {
	        isIndeterminate = newValue !== false;
	        if (isIndeterminate) {
	          element.attr('aria-checked', 'mixed');
	        }
	        element.toggleClass('md-indeterminate', isIndeterminate);
	      }
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.chips
	 */
	/*
	 * @see js folder for chips implementation
	 */
	angular.module('material.components.chips', [
	  'material.core',
	  'material.components.autocomplete'
	]);
	
	})();
	(function(){
	"use strict";
	
	
	MdChipCtrl.$inject = ["$scope", "$element", "$mdConstant", "$timeout", "$mdUtil"];angular
	  .module('material.components.chips')
	  .controller('MdChipCtrl', MdChipCtrl);
	
	/**
	 * Controller for the MdChip component. Responsible for handling keyboard
	 * events and editing the chip if needed.
	 *
	 * @param $scope
	 * @param $element
	 * @param $mdConstant
	 * @param $timeout
	 * @param $mdUtil
	 * @constructor
	 */
	function MdChipCtrl ($scope, $element, $mdConstant, $timeout, $mdUtil) {
	  /**
	   * @type {$scope}
	   */
	  this.$scope = $scope;
	
	  /**
	   * @type {$element}
	   */
	  this.$element = $element;
	
	  /**
	   * @type {$mdConstant}
	   */
	  this.$mdConstant = $mdConstant;
	
	  /**
	   * @type {$timeout}
	   */
	  this.$timeout = $timeout;
	
	  /**
	   * @type {$mdUtil}
	   */
	  this.$mdUtil = $mdUtil;
	
	  /**
	   * @type {boolean}
	   */
	  this.isEditing = false;
	
	  /**
	   * @type {MdChipsCtrl}
	   */
	  this.parentController = undefined;
	
	  /**
	   * @type {boolean}
	   */
	  this.enableChipEdit = false;
	}
	
	
	/**
	 * @param {MdChipsCtrl} controller
	 */
	MdChipCtrl.prototype.init = function(controller) {
	  this.parentController = controller;
	  this.enableChipEdit = this.parentController.enableChipEdit;
	
	  if (this.enableChipEdit) {
	    this.$element.on('keydown', this.chipKeyDown.bind(this));
	    this.$element.on('dblclick', this.chipMouseDoubleClick.bind(this));
	    this.getChipContent().addClass('_md-chip-content-edit-is-enabled');
	  }
	};
	
	
	/**
	 * @return {Object} first element with the md-chip-content class
	 */
	MdChipCtrl.prototype.getChipContent = function() {
	  var chipContents = this.$element[0].getElementsByClassName('md-chip-content');
	  return angular.element(chipContents[0]);
	};
	
	
	/**
	 * When editing the chip, if the user modifies the existing contents, we'll get a span back and
	 * need to ignore text elements as they only contain blank space.
	 * `children()` ignores text elements.
	 *
	 * When editing the chip, if the user deletes the contents and then enters some new content
	 * we'll only get a text element back.
	 * @return {Object} jQuery object representing the content element of the chip
	 */
	MdChipCtrl.prototype.getContentElement = function() {
	  var contentElement = angular.element(this.getChipContent().children()[0]);
	  if (!contentElement || contentElement.length === 0) {
	    contentElement = angular.element(this.getChipContent().contents()[0]);
	  }
	  return contentElement;
	};
	
	
	/**
	 * @return {number} index of this chip
	 */
	MdChipCtrl.prototype.getChipIndex = function() {
	  return parseInt(this.$element.attr('index'));
	};
	
	
	/**
	 * Update the chip's contents, focus the chip if it's selected, and exit edit mode.
	 * If the contents were updated to be empty, remove the chip and re-focus the input element.
	 */
	MdChipCtrl.prototype.goOutOfEditMode = function() {
	  if (!this.isEditing) {
	    return;
	  }
	
	  this.isEditing = false;
	  this.$element.removeClass('_md-chip-editing');
	  this.getChipContent()[0].contentEditable = 'false';
	  var chipIndex = this.getChipIndex();
	
	  var content = this.getContentElement().text();
	  if (content) {
	    this.parentController.updateChipContents(chipIndex, content);
	
	    this.$mdUtil.nextTick(function() {
	      if (this.parentController.selectedChip === chipIndex) {
	        this.parentController.focusChip(chipIndex);
	      }
	    }.bind(this));
	  } else {
	    this.parentController.removeChipAndFocusInput(chipIndex);
	  }
	};
	
	
	/**
	 * Given an HTML element. Selects contents of it.
	 * @param {Element} node
	 */
	MdChipCtrl.prototype.selectNodeContents = function(node) {
	  var range, selection;
	  if (document.body.createTextRange) {
	    range = document.body.createTextRange();
	    range.moveToElementText(node);
	    range.select();
	  } else if (window.getSelection) {
	    selection = window.getSelection();
	    range = document.createRange();
	    range.selectNodeContents(node);
	    selection.removeAllRanges();
	    selection.addRange(range);
	  }
	};
	
	
	/**
	 * Presents an input element to edit the contents of the chip.
	 */
	MdChipCtrl.prototype.goInEditMode = function() {
	  this.isEditing = true;
	  this.$element.addClass('_md-chip-editing');
	  this.getChipContent()[0].contentEditable = 'true';
	  this.getChipContent().on('blur', function() {
	    this.goOutOfEditMode();
	  }.bind(this));
	
	  this.selectNodeContents(this.getChipContent()[0]);
	};
	
	
	/**
	 * Handles the keydown event on the chip element. If enable-chip-edit attribute is
	 * set to true, space or enter keys can trigger going into edit mode. Enter can also
	 * trigger submitting if the chip is already being edited.
	 * @param {KeyboardEvent} event
	 */
	MdChipCtrl.prototype.chipKeyDown = function(event) {
	  if (!this.isEditing &&
	    (event.keyCode === this.$mdConstant.KEY_CODE.ENTER ||
	      event.keyCode === this.$mdConstant.KEY_CODE.SPACE)) {
	    event.preventDefault();
	    this.goInEditMode();
	  } else if (this.isEditing && event.keyCode === this.$mdConstant.KEY_CODE.ENTER) {
	    event.preventDefault();
	    this.goOutOfEditMode();
	  }
	};
	
	
	/**
	 * Enter edit mode if we're not already editing and the enable-chip-edit attribute is enabled.
	 */
	MdChipCtrl.prototype.chipMouseDoubleClick = function() {
	  if (this.enableChipEdit && !this.isEditing) {
	    this.goInEditMode();
	  }
	};
	
	})();
	(function(){
	"use strict";
	
	
	MdChip.$inject = ["$mdTheming", "$mdUtil", "$compile", "$timeout"];angular
	  .module('material.components.chips')
	  .directive('mdChip', MdChip);
	
	/**
	 * @ngdoc directive
	 * @name mdChip
	 * @module material.components.chips
	 *
	 * @description
	 * `<md-chip>` is a component used within `<md-chips>`. It is responsible for rendering an
	 * individual chip.
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-chips>
	 *     <md-chip>{{$chip}}</md-chip>
	 *   </md-chips>
	 * </hljs>
	 *
	 */
	
	/**
	 * MDChip Directive Definition
	 *
	 * @param $mdTheming
	 * @param $mdUtil
	 * @param $compile
	 * @param $timeout
	 * @ngInject
	 */
	function MdChip($mdTheming, $mdUtil, $compile, $timeout) {
	  return {
	    restrict: 'E',
	    require: ['^?mdChips', 'mdChip'],
	    link: postLink,
	    controller: 'MdChipCtrl'
	  };
	
	  function postLink(scope, element, attr, ctrls) {
	    var chipsController = ctrls.shift();
	    var chipController = ctrls.shift();
	    var chipContentElement = angular.element(element[0].querySelector('.md-chip-content'));
	
	    $mdTheming(element);
	
	    if (chipsController) {
	      chipController.init(chipsController);
	
	      // When a chip is blurred, make sure to unset (or reset) the selected chip so that tabbing
	      // through elements works properly
	      chipContentElement.on('blur', function() {
	        chipsController.resetSelectedChip();
	        chipsController.$scope.$applyAsync();
	      });
	    }
	
	    // Use $timeout to ensure we run AFTER the element has been added to the DOM so we can focus it.
	    $timeout(function() {
	      if (!chipsController) {
	        return;
	      }
	
	      if (chipsController.shouldFocusLastChip) {
	        chipsController.focusLastChipThenInput();
	      }
	    });
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdChipRemove.$inject = ["$timeout"];angular
	    .module('material.components.chips')
	    .directive('mdChipRemove', MdChipRemove);
	
	/**
	 * @ngdoc directive
	 * @name mdChipRemove
	 * @restrict A
	 * @module material.components.chips
	 *
	 * @description
	 * Indicates that the associated element should be used as the delete button template for all chips.
	 * The associated element must be a child of `md-chips`.
	 *
	 * The provided button template will be appended to each chip and will remove the associated chip
	 * on click.
	 *
	 * The button is not styled or themed based on the theme set on the `md-chips` component. A theme
	 * class and custom icon can be specified in your template.
	 *
	 * You can also specify the `type` of the button in your template.
	 *
	 * @usage
	 * ### With Standard Chips
	 * <hljs lang="html">
	 *   <md-chips ...>
	 *     <button md-chip-remove class="md-primary" type="button" aria-label="Remove {{$chip}}">
	 *       <md-icon md-svg-icon="md-close"></md-icon>
	 *     </button>
	 *   </md-chips>
	 * </hljs>
	 *
	 * ### With Object Chips
	 * <hljs lang="html">
	 *   <md-chips ...>
	 *     <button md-chip-remove class="md-primary" type="button" aria-label="Remove {{$chip.name}}">
	 *       <md-icon md-svg-icon="md-close"></md-icon>
	 *     </button>
	 *   </md-chips>
	 * </hljs>
	 */
	
	
	/**
	 * MdChipRemove Directive Definition.
	 *
	 * @param $timeout
	 * @returns {{restrict: string, require: string[], link: Function, scope: boolean}}
	 * @constructor
	 */
	function MdChipRemove ($timeout) {
	  return {
	    restrict: 'A',
	    require: '^mdChips',
	    scope: false,
	    link: postLink
	  };
	
	  function postLink(scope, element, attr, ctrl) {
	    element.on('click', function(event) {
	      scope.$apply(function() {
	        ctrl.removeChip(scope.$$replacedScope.$index);
	      });
	    });
	
	    // Child elements aren't available until after a $timeout tick as they are hidden by an
	    // `ng-if`. see http://goo.gl/zIWfuw
	    $timeout(function() {
	      element.attr({ 'tabindex': '-1', 'aria-hidden': 'true' });
	      element.find('button').attr('tabindex', '-1');
	    });
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdChipTransclude.$inject = ["$compile"];angular
	    .module('material.components.chips')
	    .directive('mdChipTransclude', MdChipTransclude);
	
	function MdChipTransclude ($compile) {
	  return {
	    restrict: 'EA',
	    terminal: true,
	    link: link,
	    scope: false
	  };
	  function link (scope, element, attr) {
	    var ctrl = scope.$parent.$mdChipsCtrl,
	        newScope = ctrl.parent.$new(false, ctrl.parent);
	    newScope.$$replacedScope = scope;
	    newScope.$chip = scope.$chip;
	    newScope.$index = scope.$index;
	    newScope.$mdChipsCtrl = ctrl;
	
	    var newHtml = ctrl.$scope.$eval(attr.mdChipTransclude);
	
	    element.html(newHtml);
	    $compile(element.contents())(newScope);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * The default chip append delay.
	 *
	 * @type {number}
	 */
	MdChipsCtrl.$inject = ["$scope", "$attrs", "$mdConstant", "$log", "$element", "$timeout", "$mdUtil", "$mdLiveAnnouncer", "$exceptionHandler"];
	var DEFAULT_CHIP_APPEND_DELAY = 300;
	
	angular
	    .module('material.components.chips')
	    .controller('MdChipsCtrl', MdChipsCtrl);
	
	/**
	 * Controller for the MdChips component. Responsible for adding to and
	 * removing from the list of chips, marking chips as selected, and binding to
	 * the models of various input components.
	 *
	 * @param $scope
	 * @param $attrs
	 * @param $mdConstant
	 * @param $log
	 * @param $element
	 * @param $timeout
	 * @param $mdUtil
	 * @param $mdLiveAnnouncer
	 * @param $exceptionHandler
	 * @constructor
	 */
	function MdChipsCtrl ($scope, $attrs, $mdConstant, $log, $element, $timeout, $mdUtil,
	                      $mdLiveAnnouncer, $exceptionHandler) {
	  /** @type {Function} **/
	  this.$timeout = $timeout;
	
	  /** @type {Object} */
	  this.$mdConstant = $mdConstant;
	
	  /** @type {angular.$scope} */
	  this.$scope = $scope;
	
	  /** @type {angular.$scope} */
	  this.parent = $scope.$parent;
	
	  /** @type {$mdUtil} */
	  this.$mdUtil = $mdUtil;
	
	  /** @type {$log} */
	  this.$log = $log;
	
	  /** @type {$mdLiveAnnouncer} */
	  this.$mdLiveAnnouncer = $mdLiveAnnouncer;
	
	  /** @type {$exceptionHandler} */
	  this.$exceptionHandler = $exceptionHandler;
	
	  /** @type {$element} */
	  this.$element = $element;
	
	  /** @type {$attrs} */
	  this.$attrs = $attrs;
	
	  /** @type {angular.NgModelController} */
	  this.ngModelCtrl = null;
	
	  /** @type {angular.NgModelController} */
	  this.userInputNgModelCtrl = null;
	
	  /** @type {MdAutocompleteCtrl} */
	  this.autocompleteCtrl = null;
	
	  /** @type {Element} */
	  this.userInputElement = null;
	
	  /** @type {Array.<Object>} */
	  this.items = [];
	
	  /** @type {number} */
	  this.selectedChip = -1;
	
	  /** @type {string} */
	  this.enableChipEdit = $mdUtil.parseAttributeBoolean($attrs.mdEnableChipEdit);
	
	  /** @type {string} */
	  this.addOnBlur = $mdUtil.parseAttributeBoolean($attrs.mdAddOnBlur);
	
	  /**
	   * The text to be used as the aria-label for the input.
	   * @type {string}
	   */
	  this.inputAriaLabel = 'Chips input.';
	
	  /**
	   * Label text to describe the chips container. Used to give context and instructions to screen
	   * reader users when the chips container is selected.
	   * @type {string}
	   */
	  this.containerHint = 'Chips container. Use arrow keys to select chips.';
	
	  /**
	   * Label text to describe the chips container when it is empty. Used to give context and
	   * instructions to screen reader users when the chips container is selected and it contains
	   * no chips.
	   * @type {string}
	   */
	  this.containerEmptyHint =
	    'Chips container. Enter the text area, then type text, and press enter to add a chip.';
	
	  /**
	   * Hidden hint text for how to delete a chip. Used to give context to screen readers.
	   * @type {string}
	   */
	  this.deleteHint = 'Press delete to remove this chip.';
	
	  /**
	   * Hidden label for the delete button. Used to give context to screen readers.
	   * @type {string}
	   */
	  this.deleteButtonLabel = 'Remove';
	
	  /**
	   * Model used by the input element.
	   * @type {string}
	   */
	  this.chipBuffer = '';
	
	  /**
	   * Whether to use the transformChip expression to transform the chip buffer
	   * before appending it to the list.
	   * @type {boolean}
	   */
	  this.useTransformChip = false;
	
	  /**
	   * Whether to use the onAdd expression to notify of chip additions.
	   * @type {boolean}
	   */
	  this.useOnAdd = false;
	
	  /**
	   * Whether to use the onRemove expression to notify of chip removals.
	   * @type {boolean}
	   */
	  this.useOnRemove = false;
	
	  /**
	   * The ID of the chips wrapper which is used to build unique IDs for the chips and the aria-owns
	   * attribute.
	   *
	   * Defaults to '_md-chips-wrapper-' plus a unique number.
	   *
	   * @type {string}
	   */
	  this.wrapperId = '';
	
	  /**
	   * Array of unique numbers which will be auto-generated any time the items change, and is used to
	   * create unique IDs for the aria-owns attribute.
	   *
	   * @type {Array<number>}
	   */
	  this.contentIds = [];
	
	  /**
	   * The index of the chip that should have it's `tabindex` property set to `0` so it is selectable
	   * via the keyboard.
	   *
	   * @type {number|null}
	   */
	  this.ariaTabIndex = null;
	
	  /**
	   * After appending a chip, the chip will be focused for this number of milliseconds before the
	   * input is refocused.
	   *
	   * **Note:** This is **required** for compatibility with certain screen readers in order for
	   * them to properly allow keyboard access.
	   *
	   * @type {number}
	   */
	  this.chipAppendDelay = DEFAULT_CHIP_APPEND_DELAY;
	
	  /**
	   * Collection of functions to call to un-register watchers
	   *
	   * @type {Array}
	   */
	  this.deRegister = [];
	
	  /**
	   * The screen reader will announce the chip content followed by this message when a chip is added.
	   * @type {string}
	   */
	  this.addedMessage = 'added';
	
	  /**
	   * The screen reader will announce the chip content followed by this message when a chip is
	   * removed.
	   * @type {string}
	   */
	  this.removedMessage = 'removed';
	
	  this.init();
	}
	
	/**
	 * Initializes variables and sets up watchers
	 */
	MdChipsCtrl.prototype.init = function() {
	  var ctrl = this;
	
	  // Set the wrapper ID
	  this.wrapperId = '_md-chips-wrapper-' + this.$mdUtil.nextUid();
	
	  // If we're using static chips, then we need to initialize a few things.
	  if (!this.$element.attr('ng-model')) {
	    this.setupStaticChips();
	  }
	
	  // Setup a watcher which manages the role and aria-owns attributes.
	  // This is never called for static chips since items is not defined.
	  this.deRegister.push(
	    this.$scope.$watchCollection('$mdChipsCtrl.items', function() {
	      // Make sure our input and wrapper have the correct ARIA attributes
	      ctrl.setupInputAria();
	      ctrl.setupWrapperAria();
	    })
	  );
	
	  this.deRegister.push(
	    this.$attrs.$observe('mdChipAppendDelay', function(newValue) {
	      ctrl.chipAppendDelay = parseInt(newValue) || DEFAULT_CHIP_APPEND_DELAY;
	    })
	  );
	};
	
	/**
	 * Destructor for cleanup
	 */
	MdChipsCtrl.prototype.$onDestroy = function $onDestroy() {
	  var $destroyFn;
	  while (($destroyFn = this.deRegister.pop())) {
	    $destroyFn.call(this);
	  }
	};
	
	/**
	 * If we have an input, ensure it has the appropriate ARIA attributes.
	 */
	MdChipsCtrl.prototype.setupInputAria = function() {
	  var input = this.$element.find('input');
	
	  // If we have no input, just return
	  if (!input) {
	    return;
	  }
	
	  input.attr('role', 'textbox');
	  input.attr('aria-multiline', true);
	  if (this.inputAriaDescribedBy) {
	    input.attr('aria-describedby', this.inputAriaDescribedBy);
	  }
	  if (this.inputAriaLabelledBy) {
	    input.attr('aria-labelledby', this.inputAriaLabelledBy);
	    input.removeAttr('aria-label');
	  } else {
	    input.attr('aria-label', this.inputAriaLabel);
	  }
	};
	
	/**
	 * Ensure our wrapper has the appropriate ARIA attributes.
	 */
	MdChipsCtrl.prototype.setupWrapperAria = function() {
	  var ctrl = this,
	      wrapper = this.$element.find('md-chips-wrap');
	
	  if (this.items && this.items.length) {
	    // Dynamically add the listbox role on every change because it must be removed when there are
	    // no items.
	    wrapper.attr('role', 'listbox');
	
	    // Generate some random (but unique) IDs for each chip
	    this.contentIds = this.items.map(function() {
	      return ctrl.wrapperId + '-chip-' + ctrl.$mdUtil.nextUid();
	    });
	
	    // Use the contentIDs above to generate the aria-owns attribute
	    wrapper.attr('aria-owns', this.contentIds.join(' '));
	    wrapper.attr('aria-label', this.containerHint);
	  } else {
	    // If we have no items, then the role and aria-owns attributes MUST be removed
	    wrapper.removeAttr('role');
	    wrapper.removeAttr('aria-owns');
	    wrapper.attr('aria-label', this.containerEmptyHint);
	  }
	};
	
	/**
	 * Apply specific roles and aria attributes for static chips
	 */
	MdChipsCtrl.prototype.setupStaticChips = function() {
	  var ctrl = this, i, staticChips;
	  var wrapper = this.$element.find('md-chips-wrap');
	
	  this.$timeout(function() {
	    wrapper.attr('role', 'list');
	    staticChips = wrapper[0].children;
	    for (i = 0; i < staticChips.length; i++) {
	      staticChips[i].setAttribute('role', 'listitem');
	      staticChips[i].setAttribute('aria-setsize', staticChips.length);
	    }
	    if (ctrl.inputAriaDescribedBy) {
	      wrapper.attr('aria-describedby', ctrl.inputAriaDescribedBy);
	    }
	    if (ctrl.inputAriaLabelledBy) {
	      wrapper.attr('aria-labelledby', ctrl.inputAriaLabelledBy);
	      wrapper.removeAttr('aria-label');
	    } else {
	      wrapper.attr('aria-label', ctrl.inputAriaLabel);
	    }
	  }, 10);
	};
	
	/**
	 * Handles the keydown event on the input element: by default <enter> appends
	 * the buffer to the chip list, while backspace removes the last chip in the
	 * list if the current buffer is empty.
	 * @param {jQuery.Event|KeyboardEvent} event
	 */
	MdChipsCtrl.prototype.inputKeydown = function(event) {
	  var chipBuffer = this.getChipBuffer();
	
	  // If we have an autocomplete, and it handled the event, we have nothing to do
	  if (this.autocompleteCtrl && event.isDefaultPrevented && event.isDefaultPrevented()) {
	    return;
	  }
	
	  if (event.keyCode === this.$mdConstant.KEY_CODE.BACKSPACE) {
	    // Only select and focus the previous chip, if the current caret position of the
	    // input element is at the beginning.
	    if (this.getCursorPosition(event.target) !== 0) {
	      return;
	    }
	
	    event.preventDefault();
	    event.stopPropagation();
	
	    if (this.items.length) {
	      this.selectAndFocusChipSafe(this.items.length - 1);
	    }
	
	    return;
	  }
	
	  // By default <enter> appends the buffer to the chip list.
	  if (!this.separatorKeys || this.separatorKeys.length < 1) {
	    this.separatorKeys = [this.$mdConstant.KEY_CODE.ENTER];
	  }
	
	  // Support additional separator key codes in an array of `md-separator-keys`.
	  if (this.separatorKeys.indexOf(event.keyCode) !== -1) {
	    if ((this.autocompleteCtrl && this.requireMatch) || !chipBuffer) return;
	    event.preventDefault();
	
	    // Only append the chip and reset the chip buffer if the max chips limit isn't reached.
	    if (this.hasMaxChipsReached()) return;
	
	    this.appendChip(chipBuffer.trim());
	    this.resetChipBuffer();
	
	    return false;
	  }
	};
	
	/**
	 * Returns the cursor position of the specified input element.
	 * @param {HTMLInputElement} element relevant input element
	 * @returns {Number} Cursor Position of the input.
	 */
	MdChipsCtrl.prototype.getCursorPosition = function(element) {
	  /*
	   * Figure out whether the current input for the chips buffer is valid for using
	   * the selectionStart / end property to retrieve the cursor position.
	   * Some browsers do not allow the use of those attributes, on different input types.
	   */
	  try {
	    if (element.selectionStart === element.selectionEnd) {
	      return element.selectionStart;
	    }
	  } catch (e) {
	    if (!element.value) {
	      return 0;
	    }
	  }
	};
	
	
	/**
	 * Updates the content of the chip at given index
	 * @param {number} chipIndex
	 * @param {string} chipContents
	 */
	MdChipsCtrl.prototype.updateChipContents = function(chipIndex, chipContents) {
	  if (chipIndex >= 0 && chipIndex < this.items.length) {
	    this.items[chipIndex] = chipContents;
	    this.updateNgModel(true);
	  }
	};
	
	
	/**
	 * @return {boolean} true if a chip is currently being edited. False otherwise.
	 */
	MdChipsCtrl.prototype.isEditingChip = function() {
	  return !!this.$element[0].querySelector('._md-chip-editing');
	};
	
	/**
	 * @param {string|Object} chip contents of a single chip
	 * @returns {boolean} true if the chip is an Object, false otherwise.
	 * @private
	 */
	MdChipsCtrl.prototype._isChipObject = function(chip) {
	  return angular.isObject(chip);
	};
	
	/**
	 * @returns {boolean} true if chips can be removed, false otherwise.
	 */
	MdChipsCtrl.prototype.isRemovable = function() {
	  // Return false if we have static chips
	  if (!this.ngModelCtrl) {
	    return false;
	  }
	
	  return this.readonly ? this.removable :
	         angular.isDefined(this.removable) ? this.removable : true;
	};
	
	/**
	 * Handles the keydown event on the chip elements: backspace removes the selected chip, arrow
	 * keys switch which chip is active.
	 * @param {KeyboardEvent} event
	 */
	MdChipsCtrl.prototype.chipKeydown = function (event) {
	  if (this.getChipBuffer()) return;
	  if (this.isEditingChip()) return;
	
	  switch (event.keyCode) {
	    case this.$mdConstant.KEY_CODE.BACKSPACE:
	    case this.$mdConstant.KEY_CODE.DELETE:
	      if (this.selectedChip < 0) return;
	      event.preventDefault();
	      // Cancel the delete action only after the event cancel. Otherwise the page will go back.
	      if (!this.isRemovable()) return;
	      this.removeAndSelectAdjacentChip(this.selectedChip, event);
	      break;
	    case this.$mdConstant.KEY_CODE.LEFT_ARROW:
	      event.preventDefault();
	      // By default, allow selection of -1 which will focus the input; if we're readonly, don't go
	      // below 0.
	      if (this.selectedChip < 0 || (this.readonly && this.selectedChip === 0)) {
	        this.selectedChip = this.items.length;
	      }
	      if (this.items.length) this.selectAndFocusChipSafe(this.selectedChip - 1);
	      break;
	    case this.$mdConstant.KEY_CODE.RIGHT_ARROW:
	      event.preventDefault();
	      this.selectAndFocusChipSafe(this.selectedChip + 1);
	      break;
	    case this.$mdConstant.KEY_CODE.ESCAPE:
	    case this.$mdConstant.KEY_CODE.TAB:
	      if (this.selectedChip < 0) return;
	      event.preventDefault();
	      this.onFocus();
	      break;
	  }
	};
	
	/**
	 * Get the input's placeholder - uses `placeholder` when list is empty and `secondary-placeholder`
	 * when the list is non-empty. If `secondary-placeholder` is not provided, `placeholder` is used
	 * always.
	 * @returns {string}
	 */
	MdChipsCtrl.prototype.getPlaceholder = function() {
	  // Allow `secondary-placeholder` to be blank.
	  var useSecondary = (this.items && this.items.length &&
	      (this.secondaryPlaceholder === '' || this.secondaryPlaceholder));
	  return useSecondary ? this.secondaryPlaceholder : this.placeholder;
	};
	
	/**
	 * Removes chip at {@code index} and selects the adjacent chip.
	 * @param {number} index adjacent chip to select
	 * @param {Event=} event
	 */
	MdChipsCtrl.prototype.removeAndSelectAdjacentChip = function(index, event) {
	  var self = this;
	  var selIndex = self.getAdjacentChipIndex(index);
	  var wrap = this.$element[0].querySelector('md-chips-wrap');
	  var chip = this.$element[0].querySelector('md-chip[index="' + index + '"]');
	
	  self.removeChip(index, event);
	
	  // The double-timeout is currently necessary to ensure that the DOM has finalized and the select()
	  // will find the proper chip since the selection is index-based.
	  //
	  // TODO: Investigate calling from within chip $scope.$on('$destroy') to reduce/remove timeouts
	  self.$timeout(function() {
	    self.$timeout(function() {
	      self.selectAndFocusChipSafe(selIndex);
	    });
	  });
	};
	
	/**
	 * Sets the selected chip index to -1.
	 */
	MdChipsCtrl.prototype.resetSelectedChip = function() {
	  this.selectedChip = -1;
	  this.ariaTabIndex = null;
	};
	
	/**
	 * Gets the index of an adjacent chip to select after deletion. Adjacency is
	 * determined as the next chip in the list, unless the target chip is the
	 * last in the list, then it is the chip immediately preceding the target. If
	 * there is only one item in the list, -1 is returned (select none).
	 * The number returned is the index to select AFTER the target has been removed.
	 * If the current chip is not selected, then -1 is returned to select none.
	 * @param {number} index
	 * @returns {number}
	 */
	MdChipsCtrl.prototype.getAdjacentChipIndex = function(index) {
	  var len = this.items.length - 1;
	  return (len === 0) ? -1 :
	      (index === len) ? index - 1 : index;
	};
	
	/**
	 * Append the contents of the buffer to the chip list. This method will first
	 * call out to the md-transform-chip method, if provided.
	 * @param {string} newChip chip buffer contents that will be used to create the new chip
	 */
	MdChipsCtrl.prototype.appendChip = function(newChip) {
	  this.shouldFocusLastChip = !this.addOnBlur;
	  if (this.useTransformChip && this.transformChip) {
	    var transformedChip = this.transformChip({'$chip': newChip});
	
	    // Check to make sure the chip is defined before assigning it, otherwise, we'll just assume
	    // they want the string version.
	    if (angular.isDefined(transformedChip)) {
	      newChip = transformedChip;
	    }
	  }
	
	  // If items contains an identical object to newChip, do not append
	  if (angular.isObject(newChip)) {
	    var identical = this.items.some(function(item) {
	      return angular.equals(newChip, item);
	    });
	    if (identical) return;
	  }
	
	  // Check for a null (but not undefined), or existing chip and cancel appending
	  if (newChip == null || this.items.indexOf(newChip) + 1) return;
	
	  // Append the new chip onto our list
	  var length = this.items.push(newChip);
	  var index = length - 1;
	
	  this.updateNgModel();
	
	  // Tell screen reader users that the chip was successfully added.
	  // TODO add a way for developers to specify which field of the object should be announced here.
	  var chipContent = angular.isObject(newChip) ? '' : newChip;
	  this.$mdLiveAnnouncer.announce(chipContent + ' ' + this.addedMessage, 'assertive');
	
	  // If the md-on-add attribute is specified, send a chip addition event
	  if (this.useOnAdd && this.onAdd) {
	    this.onAdd({ '$chip': newChip, '$index': index });
	  }
	};
	
	/**
	 * Sets whether to use the md-transform-chip expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code transformChip}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useTransformChipExpression = function() {
	  this.useTransformChip = true;
	};
	
	/**
	 * Sets whether to use the md-on-add expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onAdd}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useOnAddExpression = function() {
	  this.useOnAdd = true;
	};
	
	/**
	 * Sets whether to use the md-on-remove expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onRemove}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useOnRemoveExpression = function() {
	  this.useOnRemove = true;
	};
	
	/**
	 * Sets whether to use the md-on-select expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onSelect}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useOnSelectExpression = function() {
	  this.useOnSelect = true;
	};
	
	/**
	 * Gets the input buffer. The input buffer can be the model bound to the
	 * default input item {@code this.chipBuffer}, the {@code selectedItem}
	 * model of an {@code md-autocomplete}, or, through some magic, the model
	 * bound to any input or text area element found within a
	 * {@code md-input-container} element.
	 * @return {string} the input buffer
	 */
	MdChipsCtrl.prototype.getChipBuffer = function() {
	  var chipBuffer =  !this.userInputElement ? this.chipBuffer :
	                     this.userInputNgModelCtrl ? this.userInputNgModelCtrl.$viewValue :
	                     this.userInputElement[0].value;
	
	  // Ensure that the chip buffer is always a string. For example, the input element buffer
	  // might be falsy.
	  return angular.isString(chipBuffer) ? chipBuffer : '';
	};
	
	/**
	 * Resets the input buffer for either the internal input or user provided input element.
	 */
	MdChipsCtrl.prototype.resetChipBuffer = function() {
	  if (this.userInputElement) {
	    if (this.userInputNgModelCtrl) {
	      this.userInputNgModelCtrl.$setViewValue('');
	      this.userInputNgModelCtrl.$render();
	    } else {
	      this.userInputElement[0].value = '';
	    }
	  } else {
	    this.chipBuffer = '';
	  }
	};
	
	/**
	 * @returns {boolean} true if the max chips limit has been reached, false otherwise.
	 */
	MdChipsCtrl.prototype.hasMaxChipsReached = function() {
	  if (angular.isString(this.maxChips)) this.maxChips = parseInt(this.maxChips, 10) || 0;
	
	  return this.maxChips > 0 && this.items.length >= this.maxChips;
	};
	
	/**
	 * Updates the validity properties for the ngModel.
	 *
	 * TODO add the md-max-chips validator to this.ngModelCtrl.validators so that the validation will
	 * be performed automatically.
	 */
	MdChipsCtrl.prototype.validateModel = function() {
	  this.ngModelCtrl.$setValidity('md-max-chips', !this.hasMaxChipsReached());
	  this.ngModelCtrl.$validate(); // rerun any registered validators
	};
	
	/**
	 * Function to handle updating the model, validation, and change notification when a chip
	 * is added, removed, or changed.
	 * @param {boolean=} skipValidation true to skip calling validateModel()
	 */
	MdChipsCtrl.prototype.updateNgModel = function(skipValidation) {
	  if (!skipValidation) {
	    this.validateModel();
	  }
	  // This will trigger ng-change to fire, even in cases where $setViewValue() would not.
	  angular.forEach(this.ngModelCtrl.$viewChangeListeners, function(listener) {
	    try {
	      listener();
	    } catch (e) {
	      this.$exceptionHandler(e);
	    }
	  });
	};
	
	/**
	 * Removes the chip at the given index.
	 * @param {number} index of chip to remove
	 * @param {Event=} event optionally passed to the onRemove callback
	 */
	MdChipsCtrl.prototype.removeChip = function(index, event) {
	  var removed = this.items.splice(index, 1);
	
	  this.updateNgModel();
	  this.ngModelCtrl.$setDirty();
	
	  // Tell screen reader users that the chip was successfully removed.
	  // TODO add a way for developers to specify which field of the object should be announced here.
	  var chipContent = angular.isObject(removed[0]) ? '' : removed[0];
	  this.$mdLiveAnnouncer.announce(chipContent + ' ' + this.removedMessage, 'assertive');
	
	  if (removed && removed.length && this.useOnRemove && this.onRemove) {
	    this.onRemove({ '$chip': removed[0], '$index': index, '$event': event });
	  }
	};
	
	/**
	 * @param {number} index location of chip to remove
	 * @param {Event=} $event
	 */
	MdChipsCtrl.prototype.removeChipAndFocusInput = function (index, $event) {
	  this.removeChip(index, $event);
	
	  if (this.autocompleteCtrl) {
	    // Always hide the autocomplete dropdown before focusing the autocomplete input.
	    // Wait for the input to move horizontally, because the chip was removed.
	    // This can lead to an incorrect dropdown position.
	    this.autocompleteCtrl.hidden = true;
	    this.$mdUtil.nextTick(this.onFocus.bind(this));
	  } else {
	    this.onFocus();
	  }
	
	};
	/**
	 * Selects the chip at `index`,
	 * @param {number} index location of chip to select and focus
	 */
	MdChipsCtrl.prototype.selectAndFocusChipSafe = function(index) {
	  // If we have no chips, or are asked to select a chip before the first, just focus the input
	  if (!this.items.length || index === -1) {
	    return this.focusInput();
	  }
	
	  // If we are asked to select a chip greater than the number of chips...
	  if (index >= this.items.length) {
	    if (this.readonly) {
	      // If we are readonly, jump back to the start (because we have no input)
	      index = 0;
	    } else {
	      // If we are not readonly, we should attempt to focus the input
	      return this.onFocus();
	    }
	  }
	
	  index = Math.max(index, 0);
	  index = Math.min(index, this.items.length - 1);
	
	  this.selectChip(index);
	  this.focusChip(index);
	};
	
	/**
	 * Focus last chip, then focus the input. This is needed for screen reader support.
	 */
	MdChipsCtrl.prototype.focusLastChipThenInput = function() {
	  var ctrl = this;
	
	  ctrl.shouldFocusLastChip = false;
	
	  ctrl.focusChip(this.items.length - 1);
	
	  ctrl.$timeout(function() {
	    ctrl.focusInput();
	  }, ctrl.chipAppendDelay);
	};
	
	/**
	 * Focus the input element.
	 */
	MdChipsCtrl.prototype.focusInput = function() {
	  this.selectChip(-1);
	  this.onFocus();
	};
	
	/**
	 * Marks the chip at the given index as selected.
	 * @param {number} index location of chip to select
	 */
	MdChipsCtrl.prototype.selectChip = function(index) {
	  if (index >= -1 && index <= this.items.length) {
	    this.selectedChip = index;
	
	    // Fire the onSelect if provided
	    if (this.useOnSelect && this.onSelect) {
	      this.onSelect({'$chip': this.items[index] });
	    }
	  } else {
	    this.$log.warn('Selected Chip index out of bounds; ignoring.');
	  }
	};
	
	/**
	 * Selects the chip at {@code index} and gives it focus.
	 * @param {number} index location of chip to select and focus
	 * @deprecated use MdChipsCtrl.selectAndFocusChipSafe. Will be removed in 1.2.
	 */
	MdChipsCtrl.prototype.selectAndFocusChip = function(index) {
	  this.selectChip(index);
	  if (index !== -1) {
	    this.focusChip(index);
	  }
	};
	
	/**
	 * Call {@code focus()} on the chip at {@code index}
	 * @param {number} index location of chip to focus
	 */
	MdChipsCtrl.prototype.focusChip = function(index) {
	  var chipContent = this.$element[0].querySelector(
	    'md-chip[index="' + index + '"] .md-chip-content'
	  );
	
	  this.ariaTabIndex = index;
	
	  chipContent.focus();
	};
	
	/**
	 * Configures the required interactions with the ngModel Controller.
	 * Specifically, set {@code this.items} to the {@code NgModelController#$viewValue}.
	 * @param {NgModelController} ngModelCtrl
	 */
	MdChipsCtrl.prototype.configureNgModel = function(ngModelCtrl) {
	  this.ngModelCtrl = ngModelCtrl;
	
	  var self = this;
	
	  // in chips the meaning of $isEmpty changes
	  ngModelCtrl.$isEmpty = function(value) {
	    return !value || value.length === 0;
	  };
	
	  ngModelCtrl.$render = function() {
	    // model is updated. do something.
	    self.items = self.ngModelCtrl.$viewValue;
	  };
	};
	
	MdChipsCtrl.prototype.onFocus = function () {
	  var input = this.$element[0].querySelector('input');
	  input && input.focus();
	  this.resetSelectedChip();
	};
	
	MdChipsCtrl.prototype.onInputFocus = function () {
	  this.inputHasFocus = true;
	
	  // Make sure we have the appropriate ARIA attributes
	  this.setupInputAria();
	
	  // Make sure we don't have any chips selected
	  this.resetSelectedChip();
	};
	
	MdChipsCtrl.prototype.onInputBlur = function () {
	  this.inputHasFocus = false;
	
	  if (this.shouldAddOnBlur()) {
	    this.appendChip(this.getChipBuffer().trim());
	    this.resetChipBuffer();
	  }
	};
	
	/**
	 * Configure event bindings on input element.
	 * @param {angular.element} inputElement
	 */
	MdChipsCtrl.prototype.configureInput = function configureInput(inputElement) {
	  // Find the NgModelCtrl for the input element
	  var ngModelCtrl = inputElement.controller('ngModel');
	  var ctrl = this;
	
	  if (ngModelCtrl) {
	
	    // sync touched-state from inner input to chips-element
	    this.deRegister.push(
	      this.$scope.$watch(
	        function() {
	          return ngModelCtrl.$touched;
	        },
	        function(isTouched) {
	          isTouched && ctrl.ngModelCtrl.$setTouched();
	        }
	      )
	    );
	
	    // sync dirty-state from inner input to chips-element
	    this.deRegister.push(
	      this.$scope.$watch(
	        function() {
	          return ngModelCtrl.$dirty;
	        },
	        function(isDirty) {
	          isDirty && ctrl.ngModelCtrl.$setDirty();
	        }
	      )
	    );
	  }
	};
	
	/**
	 * Configure event bindings on a user-provided input element.
	 * @param {angular.element} inputElement
	 */
	MdChipsCtrl.prototype.configureUserInput = function(inputElement) {
	  this.userInputElement = inputElement;
	
	  // Find the NgModelCtrl for the input element
	  var ngModelCtrl = inputElement.controller('ngModel');
	  // `.controller` will look in the parent as well.
	  if (ngModelCtrl !== this.ngModelCtrl) {
	    this.userInputNgModelCtrl = ngModelCtrl;
	  }
	
	  var scope = this.$scope;
	  var ctrl = this;
	
	  // Run all of the events using evalAsync because a focus may fire a blur in the same digest loop
	  var scopeApplyFn = function(event, fn) {
	    scope.$evalAsync(angular.bind(ctrl, fn, event));
	  };
	
	  // Bind to keydown and focus events of input
	  inputElement
	      .attr({ tabindex: 0 })
	      .on('keydown', function(event) { scopeApplyFn(event, ctrl.inputKeydown); })
	      .on('focus', function(event) { scopeApplyFn(event, ctrl.onInputFocus); })
	      .on('blur', function(event) { scopeApplyFn(event, ctrl.onInputBlur); });
	};
	
	/**
	 * @param {MdAutocompleteCtrl} ctrl controller from the autocomplete component
	 */
	MdChipsCtrl.prototype.configureAutocomplete = function(ctrl) {
	  if (ctrl) {
	    this.autocompleteCtrl = ctrl;
	    // Update the default container empty hint when we're inside of an autocomplete.
	    if (!this.$element.attr('container-empty-hint')) {
	      this.containerEmptyHint = 'Chips container with autocompletion. Enter the text area, ' +
	        'type text to search, and then use the up and down arrow keys to select an option. ' +
	        'Press enter to add the selected option as a chip.';
	      this.setupWrapperAria();
	    }
	
	    ctrl.registerSelectedItemWatcher(angular.bind(this, function (item) {
	      if (item) {
	        // Only append the chip and reset the chip buffer if the max chips limit isn't reached.
	        if (this.hasMaxChipsReached()) return;
	
	        this.appendChip(item);
	        this.resetChipBuffer();
	      }
	    }));
	
	    this.$element.find('input')
	        .on('focus',angular.bind(this, this.onInputFocus))
	        .on('blur', angular.bind(this, this.onInputBlur));
	  }
	};
	
	/**
	 * @returns {boolean} Whether the current chip buffer should be added on input blur or not.
	 */
	MdChipsCtrl.prototype.shouldAddOnBlur = function() {
	
	  // Update the custom ngModel validators from the chips component.
	  this.validateModel();
	
	  var chipBuffer = this.getChipBuffer().trim();
	  // If the model value is empty and required is set on the element, then the model will be invalid.
	  // In that case, we still want to allow adding the chip. The main (but not only) case we want
	  // to disallow is adding a chip on blur when md-max-chips validation fails.
	  var isModelValid = this.ngModelCtrl.$isEmpty(this.ngModelCtrl.$modelValue) ||
	    this.ngModelCtrl.$valid;
	  var isAutocompleteShowing = this.autocompleteCtrl && !this.autocompleteCtrl.hidden;
	
	  if (this.userInputNgModelCtrl) {
	    isModelValid = isModelValid && this.userInputNgModelCtrl.$valid;
	  }
	
	  return this.addOnBlur && !this.requireMatch && chipBuffer && isModelValid &&
	    !isAutocompleteShowing;
	};
	
	/**
	 * @returns {boolean} true if the input or a chip is focused. False otherwise.
	 */
	MdChipsCtrl.prototype.hasFocus = function () {
	  return this.inputHasFocus || this.selectedChip >= 0;
	};
	
	/**
	 * @param {number} index location of content id
	 * @returns {number} unique id for the aria-owns attribute
	 */
	MdChipsCtrl.prototype.contentIdFor = function(index) {
	  return this.contentIds[index];
	};
	
	})();
	(function(){
	"use strict";
	
	  
	  MdChips.$inject = ["$mdTheming", "$mdUtil", "$compile", "$log", "$timeout", "$$mdSvgRegistry"];angular
	      .module('material.components.chips')
	      .directive('mdChips', MdChips);
	
	  /**
	   * @ngdoc directive
	   * @name mdChips
	   * @module material.components.chips
	   *
	   * @description
	   * `<md-chips>` is an input component for building lists of strings or objects. The list items are
	   * displayed as 'chips'. This component can make use of an `<input>` element or an
	   * `<md-autocomplete>` element.
	   *
	   * ### Custom templates
	   * A custom template may be provided to render the content of each chip. This is achieved by
	   * specifying an `<md-chip-template>` element containing the custom content as a child of
	   * `<md-chips>`.
	   *
	   * Note: Any attributes on
	   * `<md-chip-template>` will be dropped as only the innerHTML is used for the chip template. The
	   * variables `$chip` and `$index` are available in the scope of `<md-chip-template>`, representing
	   * the chip object and its index in the list of chips, respectively.
	   * To override the chip delete control, include an element (ideally a button) with the attribute
	   * `md-chip-remove`. A click listener to remove the chip will be added automatically. The element
	   * is also placed as a sibling to the chip content (on which there are also click listeners) to
	   * avoid a nested ng-click situation.
	   *
	   * <!-- Note: We no longer want to include this in the site docs; but it should remain here for
	   * future developers and those looking at the documentation.
	   *
	   * <h3> Pending Features </h3>
	   * <ul style="padding-left:20px;">
	   *
	   *   <ul>Style
	   *     <li>Colours for hover, press states (ripple?).</li>
	   *   </ul>
	   *
	   *   <ul>Validation
	   *     <li>allow a validation callback</li>
	   *     <li>highlighting style for invalid chips</li>
	   *   </ul>
	   *
	   *   <ul>Item mutation
	   *     <li>Support `
	   *       <md-chip-edit>` template, show/hide the edit element on tap/click? double tap/double
	   *       click?
	   *     </li>
	   *   </ul>
	   *
	   *   <ul>Truncation and Disambiguation (?)
	   *     <li>Truncate chip text where possible, but do not truncate entries such that two are
	   *     indistinguishable.</li>
	   *   </ul>
	   *
	   *   <ul>Drag and Drop
	   *     <li>Drag and drop chips between related `<md-chips>` elements.
	   *     </li>
	   *   </ul>
	   * </ul>
	   *
	   * //-->
	   *
	   * Sometimes developers want to limit the amount of possible chips.<br/>
	   * You can specify the maximum amount of chips by using the following markup.
	   *
	   * <hljs lang="html">
	   *   <md-chips
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       md-max-chips="5">
	   *   </md-chips>
	   * </hljs>
	   *
	   * In some cases, you have an autocomplete inside of the `md-chips`.<br/>
	   * When the maximum amount of chips has been reached, you can also disable the autocomplete
	   * selection.<br/>
	   * Here is an example markup.
	   *
	   * <hljs lang="html">
	   *   <md-chips ng-model="myItems" md-max-chips="5">
	   *     <md-autocomplete ng-hide="myItems.length > 5" ...></md-autocomplete>
	   *   </md-chips>
	   * </hljs>
	   *
	   * ### Accessibility
	   *
	   * The `md-chips` component supports keyboard and screen reader users since Version 1.1.2. In
	   * order to achieve this, we modified the chips behavior to select newly appended chips for
	   * `300ms` before re-focusing the input and allowing the user to type.
	   *
	   * For most users, this delay is small enough that it will not be noticeable but allows certain
	   * screen readers to function properly (JAWS and NVDA in particular).
	   *
	   * We introduced a new `md-chip-append-delay` option to allow developers to better control this
	   * behavior.
	   *
	   * Please refer to the documentation of this option (below) for more information.
	   *
	   * @param {expression} ng-model Assignable AngularJS expression to be data-bound to the list of
	   *    chips. The expression should evaluate to a `string` or `Object` Array. The type of this
	   *    array should align with the return value of `md-transform-chip`.
	   * @param {expression=} ng-change AngularJS expression to be executed on chip addition, removal,
	   *    or content change.
	   * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	   * @param {string=} secondary-placeholder Placeholder text that will be forwarded to the input,
	   *    displayed when there is at least one item in the list
	   * @param {boolean=} md-removable Enables or disables the deletion of chips through the
	   *    removal icon or the Delete/Backspace key. Defaults to true.
	   * @param {boolean=} readonly Disables list manipulation (deleting or adding list items), hiding
	   *    the input and delete buttons. If no `ng-model` is provided, the chips will automatically be
	   *    marked as readonly.<br/><br/>
	   *    When `md-removable` is not defined, the `md-remove` behavior will be overwritten and
	   *    disabled.
	   * @param {boolean=} md-enable-chip-edit Set this to `"true"` to enable editing of chip contents.
	   *    The user can go into edit mode by pressing the `space` or `enter` keys, or by double
	   *    clicking on the chip. Chip editing is only supported for chips using the basic template.
	   *    **Note:** This attribute is only evaluated once; it is not watched.
	   * @param {boolean=} ng-required Whether ng-model is allowed to be empty or not.
	   * @param {number=} md-max-chips The maximum number of chips allowed to add through user input.
	   *    <br/><br/>The validation property `md-max-chips` can be used when the max chips
	   *    amount is reached.
	   * @param {boolean=} md-add-on-blur When set to `"true"`, the remaining text inside of the input
	   *    will be converted into a new chip on blur.
	   *    **Note:** This attribute is only evaluated once; it is not watched.
	   * @param {expression} md-transform-chip An expression of form `myFunction($chip)` that when
	   *    called expects one of the following return values:
	   *    - an object representing the `$chip` input string
	   *    - `undefined` to simply add the `$chip` input string, or
	   *    - `null` to prevent the chip from being appended
	   * @param {expression=} md-on-add An expression which will be called when a chip has been
	   *    added with `$chip` and `$index` available as parameters.
	   * @param {expression=} md-on-remove An expression which will be called when a chip has been
	   *    removed with `$chip`, `$index`, and `$event` available as parameters.
	   * @param {expression=} md-on-select An expression which will be called when a chip is selected.
	   * @param {boolean=} md-require-match If true, and the chips template contains an autocomplete,
	   *    only allow selection of pre-defined chips (i.e. you cannot add new ones).
	   * @param {string=} input-aria-describedby A space-separated list of element IDs. This should
	   *     contain the IDs of any elements that describe this autocomplete. Screen readers will read
	   *     the content of these elements at the end of announcing that the chips input has been
	   *     selected and describing its current state. The descriptive elements do not need to be
	   *     visible on the page.
	   * @param {string=} input-aria-labelledby A space-separated list of element IDs. The ideal use
	   *    case is that this would contain the ID of a `<label>` element that is associated with these
	   *    chips.<br><br>
	   *    For `<label id="state">US State</label>`, you would set this to
	   *    `input-aria-labelledby="state"`.
	   * @param {string=} input-aria-label A string read by screen readers to identify the input.
	   *    For static chips, this will be applied to the chips container.
	   * @param {string=} container-hint A string read by screen readers informing users of how to
	   *    navigate the chips when there are chips. Only applies when `ng-model` is defined.
	   * @param {string=} container-empty-hint A string read by screen readers informing users of how to
	   *    add chips when there are no chips. You will want to use this to override the default when
	   *    in a non-English locale. Only applies when `ng-model` is defined.
	   * @param {string=} delete-hint A string read by screen readers instructing users that pressing
	   *    the delete key will remove the chip. You will want to use this to override the default when
	   *    in a non-English locale.
	   * @param {string=} delete-button-label <strong>Deprecated</strong> A label for the delete button.
	   *    Used to be read by screen readers.
	   * @param {string=} md-removed-message Screen readers will announce this message following the
	   *    chips contents. The default is `"removed"`. If a chip with the content of "Apple" was
	   *    removed, the screen reader would read "Apple removed". You will want to use this to override
	   *    the default when in a non-English locale.
	   * @param {string=} md-added-message Screen readers will announce this message following the
	   *    chips contents. The default is `"added"`. If a chip with the content of "Apple" was
	   *    created, the screen reader would read "Apple added". You will want to use this to override
	   *    the default when in a non-English locale.
	   * @param {expression=} md-separator-keys An array of key codes used to separate chips.
	   * @param {string=} md-chip-append-delay The number of milliseconds that the component will select
	   *    a newly appended chip before allowing a user to type into the input. This is **necessary**
	   *    for keyboard accessibility for screen readers. It defaults to 300ms and any number less than
	   *    300 can cause issues with screen readers (particularly JAWS and sometimes NVDA).
	   *
	   *    _Available since Version 1.1.2._
	   *
	   *    **Note:** You can safely set this to `0` in one of the following two instances:
	   *
	   *    1. You are targeting an iOS or Safari-only application (where users would use VoiceOver) or
	   *    only ChromeVox users.
	   *
	   *    2. If you have utilized the `md-separator-keys` to disable the `enter` keystroke in
	   *    favor of another one (such as `,` or `;`).
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <md-chips
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       readonly="isReadOnly">
	   *   </md-chips>
	   * </hljs>
	   *
	   * <h3>Validation</h3>
	   * When using [ngMessages](https://docs.angularjs.org/api/ngMessages), you can show errors based
	   * on our custom validators.
	   * <hljs lang="html">
	   *   <form name="userForm">
	   *     <md-chips
	   *       name="fruits"
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       md-max-chips="5">
	   *     </md-chips>
	   *     <div ng-messages="userForm.fruits.$error" ng-if="userForm.$dirty">
	   *       <div ng-message="md-max-chips">You reached the maximum amount of chips</div>
	   *    </div>
	   *   </form>
	   * </hljs>
	   *
	   */
	
	  // TODO add a way for developers to specify which field of the object should used in the
	  // aria-label.
	  var MD_CHIPS_TEMPLATE = '\
	      <md-chips-wrap\
	          id="{{$mdChipsCtrl.wrapperId}}"\
	          tabindex="{{$mdChipsCtrl.readonly ? 0 : -1}}"\
	          ng-keydown="$mdChipsCtrl.chipKeydown($event)"\
	          ng-class="{ \'md-focused\': $mdChipsCtrl.hasFocus(), \
	                      \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly,\
	                      \'md-removable\': $mdChipsCtrl.isRemovable() }"\
	          class="md-chips">\
	        <md-chip ng-repeat="$chip in $mdChipsCtrl.items"\
	            index="{{$index}}" \
	            ng-class="{\'md-focused\': $mdChipsCtrl.selectedChip == $index, \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly}">\
	          <div class="md-chip-content"\
	              tabindex="{{$mdChipsCtrl.ariaTabIndex === $index ? 0 : -1}}"\
	              id="{{$mdChipsCtrl.contentIdFor($index)}}"\
	              role="option"\
	              aria-selected="{{$mdChipsCtrl.selectedChip === $index}}"\
	              aria-setsize="{{$mdChipsCtrl.items.length}}"\
	              aria-posinset="{{$index+1}}"\
	              ng-click="!$mdChipsCtrl.readonly && $mdChipsCtrl.focusChip($index)"\
	              aria-label="{{$mdChipsCtrl._isChipObject($chip) ? \'\' : $chip + \'. \'}}{{$mdChipsCtrl.isRemovable() ? \'\' + $mdChipsCtrl.deleteHint : \'\'}}" \
	              ng-focus="!$mdChipsCtrl.readonly && $mdChipsCtrl.selectChip($index)"\
	              md-chip-transclude="$mdChipsCtrl.chipContentsTemplate"></div>\
	          <div ng-if="$mdChipsCtrl.isRemovable()"\
	               class="md-chip-remove-container"\
	               tabindex="-1"\
	               md-chip-transclude="$mdChipsCtrl.chipRemoveTemplate"></div>\
	        </md-chip>\
	        <div class="md-chip-input-container" ng-if="!$mdChipsCtrl.readonly && $mdChipsCtrl.ngModelCtrl">\
	          <div md-chip-transclude="$mdChipsCtrl.chipInputTemplate"></div>\
	        </div>\
	      </md-chips-wrap>';
	
	  var CHIP_INPUT_TEMPLATE = '\
	        <input\
	            class="md-input"\
	            tabindex="0"\
	            aria-label="{{$mdChipsCtrl.inputAriaLabel}}"\
	            placeholder="{{$mdChipsCtrl.getPlaceholder()}}"\
	            ng-model="$mdChipsCtrl.chipBuffer"\
	            ng-focus="$mdChipsCtrl.onInputFocus()"\
	            ng-blur="$mdChipsCtrl.onInputBlur()"\
	            ng-keydown="$mdChipsCtrl.inputKeydown($event)">';
	
	  var CHIP_DEFAULT_TEMPLATE = '\
	      <span>{{$chip}}</span>';
	
	  var CHIP_REMOVE_TEMPLATE = '\
	      <button\
	          class="md-chip-remove"\
	          ng-if="$mdChipsCtrl.isRemovable()"\
	          ng-click="$mdChipsCtrl.removeChipAndFocusInput($$replacedScope.$index, $event)"\
	          type="button"\
	          tabindex="-1"\
	          aria-label="{{$mdChipsCtrl.deleteButtonLabel}}{{$mdChipsCtrl._isChipObject($chip) ? \'\' : \' \' + $chip}}">\
	        <md-icon md-svg-src="{{$mdChipsCtrl.mdCloseIcon}}" aria-hidden="true"></md-icon>\
	      </button>';
	
	  /**
	   * MDChips Directive Definition
	   */
	  function MdChips ($mdTheming, $mdUtil, $compile, $log, $timeout, $$mdSvgRegistry) {
	    // Run our templates through $mdUtil.processTemplate() to allow custom start/end symbols
	    var templates = getTemplates();
	
	    return {
	      template: function(element, attrs) {
	        // Clone the element into an attribute. By prepending the attribute
	        // name with '$', AngularJS won't write it into the DOM. The cloned
	        // element propagates to the link function via the attrs argument,
	        // where various contained-elements can be consumed.
	        attrs['$mdUserTemplate'] = element.clone();
	        return templates.chips;
	      },
	      require: ['mdChips'],
	      restrict: 'E',
	      controller: 'MdChipsCtrl',
	      controllerAs: '$mdChipsCtrl',
	      bindToController: true,
	      compile: compile,
	      scope: {
	        readonly: '=?readonly',
	        removable: '=?mdRemovable',
	        placeholder: '@?',
	        secondaryPlaceholder: '@?',
	        maxChips: '@?mdMaxChips',
	        transformChip: '&mdTransformChip',
	        onAppend: '&?mdOnAppend',
	        onAdd: '&?mdOnAdd',
	        onRemove: '&?mdOnRemove',
	        addedMessage: '@?mdAddedMessage',
	        removedMessage: '@?mdRemovedMessage',
	        onSelect: '&?mdOnSelect',
	        inputAriaDescribedBy: '@?inputAriaDescribedby',
	        inputAriaLabelledBy: '@?inputAriaLabelledby',
	        inputAriaLabel: '@?',
	        containerHint: '@?',
	        containerEmptyHint: '@?',
	        deleteHint: '@?',
	        deleteButtonLabel: '@?',
	        separatorKeys: '=?mdSeparatorKeys',
	        requireMatch: '=?mdRequireMatch',
	        chipAppendDelayString: '@?mdChipAppendDelay',
	        ngChange: '&?'
	      }
	    };
	
	    /**
	     * Builds the final template for `md-chips` and returns the postLink function.
	     *
	     * Building the template involves 3 key components:
	     * static chips
	     * chip template
	     * input control
	     *
	     * If no `ng-model` is provided, only the static chip work needs to be done.
	     *
	     * If no user-passed `md-chip-template` exists, the default template is used. This resulting
	     * template is appended to the chip content element.
	     *
	     * The remove button may be overridden by passing an element with an md-chip-remove attribute.
	     *
	     * If an `input` or `md-autocomplete` element is provided by the caller, it is set aside for
	     * transclusion later. The transclusion happens in `postLink` as the parent scope is required.
	     * If no user input is provided, a default one is appended to the input container node in the
	     * template.
	     *
	     * Static Chips (i.e. `md-chip` elements passed from the caller) are gathered and set aside for
	     * transclusion in the `postLink` function.
	     *
	     *
	     * @param element
	     * @param attr
	     * @returns {Function}
	     */
	    function compile(element, attr) {
	      // Grab the user template from attr and reset the attribute to null.
	      var userTemplate = attr['$mdUserTemplate'];
	      attr['$mdUserTemplate'] = null;
	
	      var chipTemplate = getTemplateByQuery('md-chips>md-chip-template');
	
	      var chipRemoveSelector = $mdUtil
	        .prefixer()
	        .buildList('md-chip-remove')
	        .map(function(attr) {
	          return 'md-chips>*[' + attr + ']';
	        })
	        .join(',');
	
	      // Set the chip remove, chip contents and chip input templates. The link function will put
	      // them on the scope for transclusion later.
	      var chipRemoveTemplate   = getTemplateByQuery(chipRemoveSelector) || templates.remove,
	          chipContentsTemplate = chipTemplate || templates.default,
	          chipInputTemplate    = getTemplateByQuery('md-chips>md-autocomplete')
	              || getTemplateByQuery('md-chips>input')
	              || templates.input,
	          staticChips = userTemplate.find('md-chip');
	
	      // Warn of malformed template. See #2545
	      if (userTemplate[0].querySelector('md-chip-template>*[md-chip-remove]')) {
	        $log.warn('invalid placement of md-chip-remove within md-chip-template.');
	      }
	
	      function getTemplateByQuery (query) {
	        if (!attr.ngModel) return;
	        var element = userTemplate[0].querySelector(query);
	        return element && element.outerHTML;
	      }
	
	      /**
	       * Configures controller and transcludes.
	       */
	      return function postLink(scope, element, attrs, controllers) {
	        $mdUtil.initOptionalProperties(scope, attr);
	
	        $mdTheming(element);
	        var mdChipsCtrl = controllers[0];
	        if (chipTemplate) {
	          // Chip editing functionality assumes we are using the default chip template.
	          mdChipsCtrl.enableChipEdit = false;
	        }
	
	        mdChipsCtrl.chipContentsTemplate = chipContentsTemplate;
	        mdChipsCtrl.chipRemoveTemplate   = chipRemoveTemplate;
	        mdChipsCtrl.chipInputTemplate    = chipInputTemplate;
	
	        mdChipsCtrl.mdCloseIcon = $$mdSvgRegistry.mdClose;
	
	        element
	            .attr({ tabindex: -1 })
	            .on('focus', function () { mdChipsCtrl.onFocus(); })
	            .on('click', function () {
	              if (!mdChipsCtrl.readonly && mdChipsCtrl.selectedChip === -1) {
	                mdChipsCtrl.onFocus();
	              }
	            });
	
	        if (attr.ngModel) {
	          mdChipsCtrl.configureNgModel(element.controller('ngModel'));
	
	          // If an `md-transform-chip` attribute was set, tell the controller to use the expression
	          // before appending chips.
	          if (attrs.mdTransformChip) mdChipsCtrl.useTransformChipExpression();
	
	          // If an `md-on-append` attribute was set, tell the controller to use the expression
	          // when appending chips.
	          //
	          // TODO: Remove this now that 1.0 is long since released
	          // DEPRECATED: Will remove in official 1.0 release
	          if (attrs.mdOnAppend) mdChipsCtrl.useOnAppendExpression();
	
	          // If an `md-on-add` attribute was set, tell the controller to use the expression
	          // when adding chips.
	          if (attrs.mdOnAdd) mdChipsCtrl.useOnAddExpression();
	
	          // If an `md-on-remove` attribute was set, tell the controller to use the expression
	          // when removing chips.
	          if (attrs.mdOnRemove) mdChipsCtrl.useOnRemoveExpression();
	
	          // If an `md-on-select` attribute was set, tell the controller to use the expression
	          // when selecting chips.
	          if (attrs.mdOnSelect) mdChipsCtrl.useOnSelectExpression();
	
	          // The md-autocomplete and input elements won't be compiled until after this directive
	          // is complete (due to their nested nature). Wait a tick before looking for them to
	          // configure the controller.
	          if (chipInputTemplate !== templates.input) {
	            // The autocomplete will not appear until the readonly attribute is not true (i.e.
	            // false or undefined), so we have to watch the readonly and then on the next tick
	            // after the chip transclusion has run, we can configure the autocomplete and user
	            // input.
	            scope.$watch('$mdChipsCtrl.readonly', function(readonly) {
	              if (!readonly) {
	
	                $mdUtil.nextTick(function(){
	
	                  if (chipInputTemplate.indexOf('<md-autocomplete') === 0) {
	                    var autocompleteEl = element.find('md-autocomplete');
	                    mdChipsCtrl.configureAutocomplete(autocompleteEl.controller('mdAutocomplete'));
	                  }
	
	                  mdChipsCtrl.configureUserInput(element.find('input'));
	                });
	              }
	            });
	          }
	
	          // At the next tick, if we find an input, make sure it has the md-input class
	          $mdUtil.nextTick(function() {
	            var input = element.find('input');
	
	            if (input) {
	              mdChipsCtrl.configureInput(input);
	              input.toggleClass('md-input', true);
	            }
	          });
	        }
	
	        // Compile with the parent's scope and prepend any static chips to the wrapper.
	        if (staticChips.length > 0) {
	          var compiledStaticChips = $compile(staticChips.clone())(scope.$parent);
	          $timeout(function() { element.find('md-chips-wrap').prepend(compiledStaticChips); });
	        }
	      };
	    }
	
	    function getTemplates() {
	      return {
	        chips: $mdUtil.processTemplate(MD_CHIPS_TEMPLATE),
	        input: $mdUtil.processTemplate(CHIP_INPUT_TEMPLATE),
	        default: $mdUtil.processTemplate(CHIP_DEFAULT_TEMPLATE),
	        remove: $mdUtil.processTemplate(CHIP_REMOVE_TEMPLATE)
	      };
	    }
	  }
	
	})();
	(function(){
	"use strict";
	
	
	MdContactChipsCtrl.$inject = ["$attrs", "$element", "$timeout"];angular
	    .module('material.components.chips')
	    .controller('MdContactChipsCtrl', MdContactChipsCtrl);
	
	/**
	 * Controller for the MdContactChips component
	 * @constructor
	 */
	function MdContactChipsCtrl ($attrs, $element, $timeout) {
	  /** @type {$element} */
	  this.$element = $element;
	
	  /** @type {$attrs} */
	  this.$attrs = $attrs;
	
	  /** @type {Function} */
	  this.$timeout = $timeout;
	
	  /** @type {Object} */
	  this.selectedItem = null;
	
	  /** @type {string} */
	  this.searchText = '';
	
	  /**
	   * Collection of functions to call to un-register watchers
	   * @type {Array}
	   */
	  this.deRegister = [];
	
	  this.init();
	}
	
	MdContactChipsCtrl.prototype.init = function() {
	  var ctrl = this;
	  var deRegister = this.deRegister;
	  var element = this.$element;
	
	  // Setup a watcher which manages chips a11y messages and autocomplete aria.
	  // Timeout required to allow the child elements to be compiled.
	  this.$timeout(function() {
	    deRegister.push(
	      element.find('md-chips').controller('mdChips').$scope.$watchCollection('$mdChipsCtrl.items', function() {
	        // Make sure our input and wrapper have the correct ARIA attributes
	        ctrl.setupChipsAria();
	        ctrl.setupAutocompleteAria();
	      })
	    );
	  });
	};
	
	MdContactChipsCtrl.prototype.setupChipsAria = function() {
	  var chips = this.$element.find('md-chips');
	  var chipsCtrl = chips.controller('mdChips');
	
	  // Configure MdChipsCtrl
	  if (this.removedMessage) {
	    chipsCtrl.removedMessage = this.removedMessage;
	  }
	  if (this.containerHint) {
	    chipsCtrl.containerHint = this.containerHint;
	  }
	  if (this.containerEmptyHint) {
	    // Apply attribute to avoid the hint being overridden by MdChipsCtrl.configureAutocomplete()
	    chips.attr('container-empty-hint', this.containerEmptyHint);
	    chipsCtrl.containerEmptyHint = this.containerEmptyHint;
	  }
	  if (this.deleteHint) {
	    chipsCtrl.deleteHint = this.deleteHint;
	  }
	  if (this.inputAriaLabel) {
	    chipsCtrl.inputAriaLabel = this.inputAriaLabel;
	  }
	};
	
	MdContactChipsCtrl.prototype.setupAutocompleteAria = function() {
	  var autocompleteInput = this.$element.find('md-chips-wrap').find('md-autocomplete').find('input');
	
	  // Set attributes on the input of the md-autocomplete
	  if (this.inputAriaDescribedBy) {
	    autocompleteInput.attr('aria-describedby', this.inputAriaDescribedBy);
	  }
	  if (this.inputAriaLabelledBy) {
	    autocompleteInput.removeAttr('aria-label');
	    autocompleteInput.attr('aria-labelledby', this.inputAriaLabelledBy);
	  }
	};
	
	MdContactChipsCtrl.prototype.queryContact = function(searchText) {
	  return this.contactQuery({'$query': searchText});
	};
	
	MdContactChipsCtrl.prototype.inputKeydown = function(event) {
	  if (!this.separatorKeys || this.separatorKeys.indexOf(event.keyCode) < 0) {
	    return;
	  }
	
	  event.stopPropagation();
	  event.preventDefault();
	
	  var autocompleteCtrl = angular.element(event.target).controller('mdAutocomplete');
	  autocompleteCtrl.select(autocompleteCtrl.index);
	};
	
	MdContactChipsCtrl.prototype.itemName = function(item) {
	  return item[this.contactName];
	};
	
	/**
	 * Destructor for cleanup
	 */
	MdContactChipsCtrl.prototype.$onDestroy = function $onDestroy() {
	  var $destroyFn;
	  while (($destroyFn = this.deRegister.pop())) {
	    $destroyFn.call(this);
	  }
	};
	
	})();
	(function(){
	"use strict";
	
	
	MdContactChips.$inject = ["$mdTheming", "$mdUtil"];angular
	  .module('material.components.chips')
	  .directive('mdContactChips', MdContactChips);
	
	/**
	 * @ngdoc directive
	 * @name mdContactChips
	 * @module material.components.chips
	 *
	 * @description
	 * `<md-contact-chips>` is an input component based on `md-chips` and makes use of an
	 * `md-autocomplete` element. The component allows the caller to supply a query expression which
	 * returns  a list of possible contacts. The user can select one of these and add it to the list of
	 * chips.
	 *
	 * You may also use the <a ng-href="api/directive/mdHighlightText">md-highlight-flags</a> attribute
	 * along with its parameters to control the appearance of the matched text inside of the contacts'
	 * autocomplete popup.
	 *
	 * @param {expression} ng-model Assignable AngularJS expression to be data-bound to the list of
	 *    contact chips. The expression should evaluate to an `Object` Array.
	 * @param {expression=} ng-change AngularJS expression to be executed on chip addition, removal,
	 *    or content change.
	 * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	 * @param {string=} secondary-placeholder Placeholder text that will be forwarded to the input,
	 *    displayed when there is at least on item in the list
	 * @param {expression} md-contacts An expression expected to return contacts matching the search
	 *    test, `$query`. If this expression involves a promise, a loading bar is displayed while
	 *    waiting for it to resolve.
	 * @param {string} md-contact-name The field name of the contact object representing the
	 *    contact's name.
	 * @param {string} md-contact-email The field name of the contact object representing the
	 *    contact's email address.
	 * @param {string} md-contact-image The field name of the contact object representing the
	 *    contact's image.
	 * @param {number=} md-min-length Specifies the minimum length of text before autocomplete will
	 *    make suggestions
	 * @param {string=} input-aria-describedby A space-separated list of element IDs. This should
	 *     contain the IDs of any elements that describe this autocomplete. Screen readers will read
	 *     the content of these elements at the end of announcing that the chips input has been
	 *     selected and describing its current state. The descriptive elements do not need to be
	 *     visible on the page.
	 * @param {string=} input-aria-labelledby A space-separated list of element IDs. The ideal use
	 *    case is that this would contain the ID of a `<label>` element that is associated with these
	 *    chips.<br><br>
	 *    For `<label id="state">US State</label>`, you would set this to
	 *    `input-aria-labelledby="state"`.
	 * @param {string=} input-aria-label A string read by screen readers to identify the input.
	 *    For static chips, this will be applied to the chips container.
	 * @param {string=} container-hint A string read by screen readers informing users of how to
	 *    navigate the chips when there are chips.
	 * @param {string=} container-empty-hint A string read by screen readers informing users of how to
	 *    add chips when there are no chips. You will want to use this to override the default when
	 *    in a non-English locale.
	 * @param {string=} delete-hint A string read by screen readers instructing users that pressing
	 *    the delete key will remove the chip. You will want to use this to override the default when
	 *    in a non-English locale.
	 * @param {string=} md-removed-message Screen readers will announce this message following the
	 *    chips contents. The default is `"removed"`. If a chip with the content of "Apple" was
	 *    removed, the screen reader would read "Apple removed". You will want to use this to override
	 *    the default when in a non-English locale.
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-contact-chips
	 *       ng-model="ctrl.contacts"
	 *       md-contacts="ctrl.querySearch($query)"
	 *       md-contact-name="name"
	 *       md-contact-image="image"
	 *       md-contact-email="email"
	 *       placeholder="To">
	 *   </md-contact-chips>
	 * </hljs>
	 *
	 */
	
	
	var MD_CONTACT_CHIPS_TEMPLATE = '\
	      <md-chips class="md-contact-chips"\
	          ng-model="$mdContactChipsCtrl.contacts"\
	          ng-change="$mdContactChipsCtrl.ngChange($mdContactChipsCtrl.contacts)"\
	          md-require-match="$mdContactChipsCtrl.requireMatch"\
	          md-chip-append-delay="{{$mdContactChipsCtrl.chipAppendDelay}}"\
	          md-separator-keys="$mdContactChipsCtrl.separatorKeys"\
	          md-autocomplete-snap>\
	          <md-autocomplete\
	              md-menu-class="md-contact-chips-suggestions"\
	              md-selected-item="$mdContactChipsCtrl.selectedItem"\
	              md-search-text="$mdContactChipsCtrl.searchText"\
	              md-items="item in $mdContactChipsCtrl.queryContact($mdContactChipsCtrl.searchText)"\
	              md-item-text="$mdContactChipsCtrl.itemName(item)"\
	              md-no-cache="true"\
	              md-min-length="$mdContactChipsCtrl.minLength"\
	              md-autoselect\
	              ng-keydown="$mdContactChipsCtrl.inputKeydown($event)"\
	              placeholder="{{$mdContactChipsCtrl.contacts.length === 0 ?\
	                  $mdContactChipsCtrl.placeholder : $mdContactChipsCtrl.secondaryPlaceholder}}">\
	            <div class="md-contact-suggestion">\
	              <img \
	                  ng-src="{{item[$mdContactChipsCtrl.contactImage]}}"\
	                  alt="{{item[$mdContactChipsCtrl.contactName]}}"\
	                  ng-if="item[$mdContactChipsCtrl.contactImage]" />\
	              <span class="md-contact-name" md-highlight-text="$mdContactChipsCtrl.searchText"\
	                    md-highlight-flags="{{$mdContactChipsCtrl.highlightFlags}}">\
	                {{item[$mdContactChipsCtrl.contactName]}}\
	              </span>\
	              <span class="md-contact-email" >{{item[$mdContactChipsCtrl.contactEmail]}}</span>\
	            </div>\
	          </md-autocomplete>\
	          <md-chip-template>\
	            <div class="md-contact-avatar">\
	              <img \
	                  ng-src="{{$chip[$mdContactChipsCtrl.contactImage]}}"\
	                  alt="{{$chip[$mdContactChipsCtrl.contactName]}}"\
	                  ng-if="$chip[$mdContactChipsCtrl.contactImage]" />\
	            </div>\
	            <div class="md-contact-name">\
	              {{$chip[$mdContactChipsCtrl.contactName]}}\
	            </div>\
	          </md-chip-template>\
	      </md-chips>';
	
	
	/**
	 * MDContactChips Directive Definition
	 *
	 * @param $mdTheming
	 * @param $mdUtil
	 * @returns {*}
	 * @ngInject
	 */
	function MdContactChips($mdTheming, $mdUtil) {
	  return {
	    template: function(element, attrs) {
	      return MD_CONTACT_CHIPS_TEMPLATE;
	    },
	    restrict: 'E',
	    controller: 'MdContactChipsCtrl',
	    controllerAs: '$mdContactChipsCtrl',
	    bindToController: true,
	    compile: compile,
	    scope: {
	      contactQuery: '&mdContacts',
	      placeholder: '@?',
	      secondaryPlaceholder: '@?',
	      contactName: '@mdContactName',
	      contactImage: '@mdContactImage',
	      contactEmail: '@mdContactEmail',
	      contacts: '=ngModel',
	      ngChange: '&?',
	      requireMatch: '=?mdRequireMatch',
	      minLength: '=?mdMinLength',
	      highlightFlags: '@?mdHighlightFlags',
	      chipAppendDelay: '@?mdChipAppendDelay',
	      separatorKeys: '=?mdSeparatorKeys',
	      removedMessage: '@?mdRemovedMessage',
	      inputAriaDescribedBy: '@?inputAriaDescribedby',
	      inputAriaLabelledBy: '@?inputAriaLabelledby',
	      inputAriaLabel: '@?',
	      containerHint: '@?',
	      containerEmptyHint: '@?',
	      deleteHint: '@?'
	    }
	  };
	
	  function compile(element, attr) {
	    return function postLink(scope, element, attrs, controllers) {
	      var contactChipsController = controllers;
	
	      $mdUtil.initOptionalProperties(scope, attr);
	      $mdTheming(element);
	
	      element.attr('tabindex', '-1');
	
	      attrs.$observe('mdChipAppendDelay', function(newValue) {
	        contactChipsController.chipAppendDelay = newValue;
	      });
	    };
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	(function () {
	  "use strict";
	
	  /**
	   *  Use a RegExp to check if the `md-colors="<expression>"` is static string
	   *  or one that should be observed and dynamically interpolated.
	   */
	  MdColorsDirective.$inject = ["$mdColors", "$mdUtil", "$log", "$parse"];
	  MdColorsService.$inject = ["$mdTheming", "$mdUtil", "$log"];
	  var STATIC_COLOR_EXPRESSION = /^{((\s|,)*?["'a-zA-Z-]+?\s*?:\s*?('|")[a-zA-Z0-9-.]*('|"))+\s*}$/;
	  var colorPalettes = null;
	
	  /**
	   * @ngdoc module
	   * @name material.components.colors
	   *
	   * @description
	   * Define $mdColors service and a `md-colors=""` attribute directive
	   */
	  angular
	    .module('material.components.colors', ['material.core'])
	    .directive('mdColors', MdColorsDirective)
	    .service('$mdColors', MdColorsService);
	
	  /**
	   * @ngdoc service
	   * @name $mdColors
	   * @module material.components.colors
	   *
	   * @description
	   * By default, defining a theme does not make its colors available for applying to non AngularJS
	   * Material elements. The `$mdColors` service is used by the `md-color` directive to convert a
	   * set of color expressions to RGBA values and then apply those values to the element as CSS
	   * property values.
	   *
	   * @usage
	   * Getting a color based on a theme
	   *
	   *  <hljs lang="js">
	   *    angular.controller('myCtrl', function ($mdColors) {
	   *      var color = $mdColors.getThemeColor('myTheme-primary-900-0.5');
	   *      ...
	   *    });
	   *  </hljs>
	   *
	   * Applying a color from a palette to an element
	   * <hljs lang="js">
	   *   app.directive('myDirective', function($mdColors) {
	   *     return {
	   *       ...
	   *       link: function (scope, elem) {
	   *         $mdColors.applyThemeColors(elem, {color: 'red-A200-0.2'});
	   *       }
	   *    }
	   *   });
	   * </hljs>
	   */
	  function MdColorsService($mdTheming, $mdUtil, $log) {
	    colorPalettes = colorPalettes || Object.keys($mdTheming.PALETTES);
	
	    // Publish service instance
	    return {
	      applyThemeColors: applyThemeColors,
	      getThemeColor: getThemeColor,
	      hasTheme: hasTheme
	    };
	
	    // ********************************************
	    // Internal Methods
	    // ********************************************
	
	    /**
	     * @ngdoc method
	     * @name $mdColors#applyThemeColors
	     *
	     * @description
	     * Lookup a set of colors by hue, theme, and palette, then apply those colors
	     * with the provided opacity (via `rgba()`) to the specified CSS property.
	     *
	     * @param {angular.element} element the element to apply the styles to
	     * @param {Object} colorExpression Keys are CSS properties and values are strings representing
	     * the `theme-palette-hue-opacity` of the desired color. For example:
	     * `{'color': 'red-A200-0.3', 'background-color': 'myTheme-primary-700-0.8'}`. Theme, hue, and
	     * opacity are optional.
	     */
	    function applyThemeColors(element, colorExpression) {
	      try {
	        if (colorExpression) {
	          // Assign the calculate RGBA color values directly as inline CSS
	          element.css(interpolateColors(colorExpression));
	        }
	      } catch (e) {
	        $log.error(e.message);
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $mdColors#getThemeColor
	     *
	     * @description
	     * Get a parsed RGBA color using a string representing the `theme-palette-hue-opacity` of the
	     * desired color.
	     *
	     * @param {string} expression color expression like `'red-A200-0.3'` or
	     *  `'myTheme-primary-700-0.8'`. Theme, hue, and opacity are optional.
	     * @returns {string} a CSS color value like `rgba(211, 47, 47, 0.8)`
	     */
	    function getThemeColor(expression) {
	      var color = extractColorOptions(expression);
	
	      return parseColor(color);
	    }
	
	    /**
	     * Return the parsed color
	     * @param {{hue: *, theme: any, palette: *, opacity: (*|string|number)}} color hash map of color
	     *  definitions
	     * @param {boolean=} contrast whether use contrast color for foreground. Defaults to false.
	     * @returns {string} rgba color string
	     */
	    function parseColor(color, contrast) {
	      contrast = contrast || false;
	      var rgbValues = $mdTheming.PALETTES[color.palette][color.hue];
	
	      rgbValues = contrast ? rgbValues.contrast : rgbValues.value;
	
	      return $mdUtil.supplant('rgba({0}, {1}, {2}, {3})',
	        [rgbValues[0], rgbValues[1], rgbValues[2], rgbValues[3] || color.opacity]
	      );
	    }
	
	    /**
	     * Convert the color expression into an object with scope-interpolated values
	     * Then calculate the rgba() values based on the theme color parts
	     * @param {Object} themeColors json object, keys are css properties and values are string of
	     * the wanted color, for example: `{color: 'red-A200-0.3'}`.
	     * @return {Object} Hashmap of CSS properties with associated `rgba()` string values
	     */
	    function interpolateColors(themeColors) {
	      var rgbColors = {};
	
	      var hasColorProperty = themeColors.hasOwnProperty('color');
	
	      angular.forEach(themeColors, function (value, key) {
	        var color = extractColorOptions(value);
	        var hasBackground = key.indexOf('background') > -1;
	
	        rgbColors[key] = parseColor(color);
	        if (hasBackground && !hasColorProperty) {
	          rgbColors.color = parseColor(color, true);
	        }
	      });
	
	      return rgbColors;
	    }
	
	    /**
	     * Check if expression has defined theme
	     * For instance:
	     *   'myTheme-primary' => true
	     *   'red-800' => false
	     * @param {string} expression color expression like 'red-800', 'red-A200-0.3',
	     *   'myTheme-primary', or 'myTheme-primary-400'
	     * @return {boolean} true if the expression has a theme part, false otherwise.
	     */
	    function hasTheme(expression) {
	      return angular.isDefined($mdTheming.THEMES[expression.split('-')[0]]);
	    }
	
	    /**
	     * For the evaluated expression, extract the color parts into a hash map
	     * @param {string} expression color expression like 'red-800', 'red-A200-0.3',
	     *   'myTheme-primary', or 'myTheme-primary-400'
	     * @returns {{hue: *, theme: any, palette: *, opacity: (*|string|number)}}
	     */
	    function extractColorOptions(expression) {
	      var parts = expression.split('-');
	      var hasTheme = angular.isDefined($mdTheming.THEMES[parts[0]]);
	      var theme = hasTheme ? parts.splice(0, 1)[0] : $mdTheming.defaultTheme();
	
	      return {
	        theme: theme,
	        palette: extractPalette(parts, theme),
	        hue: extractHue(parts, theme),
	        opacity: parts[2] || 1
	      };
	    }
	
	    /**
	     * Calculate the theme palette name
	     * @param {Array} parts
	     * @param {string} theme name
	     * @return {string}
	     */
	    function extractPalette(parts, theme) {
	      // If the next section is one of the palettes we assume it's a two word palette
	      // Two word palette can be also written in camelCase, forming camelCase to dash-case
	
	      var isTwoWord = parts.length > 1 && colorPalettes.indexOf(parts[1]) !== -1;
	      var palette = parts[0].replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
	
	      if (isTwoWord)  palette = parts[0] + '-' + parts.splice(1, 1);
	
	      if (colorPalettes.indexOf(palette) === -1) {
	        // If the palette is not in the palette list it's one of primary/accent/warn/background
	        var scheme = $mdTheming.THEMES[theme].colors[palette];
	        if (!scheme) {
	          throw new Error($mdUtil.supplant(
	            'mdColors: couldn\'t find \'{palette}\' in the palettes.',
	            {palette: palette}));
	        }
	        palette = scheme.name;
	      }
	
	      return palette;
	    }
	
	    /**
	     * @param {Array} parts
	     * @param {string} theme name
	     * @return {*}
	     */
	    function extractHue(parts, theme) {
	      var themeColors = $mdTheming.THEMES[theme].colors;
	
	      if (parts[1] === 'hue') {
	        var hueNumber = parseInt(parts.splice(2, 1)[0], 10);
	
	        if (hueNumber < 1 || hueNumber > 3) {
	          throw new Error($mdUtil.supplant(
	            'mdColors: \'hue-{hueNumber}\' is not a valid hue, can be only \'hue-1\', \'hue-2\' and \'hue-3\'',
	            {hueNumber: hueNumber}));
	        }
	        parts[1] = 'hue-' + hueNumber;
	
	        if (!(parts[0] in themeColors)) {
	          throw new Error($mdUtil.supplant(
	            'mdColors: \'hue-x\' can only be used with [{availableThemes}], but was used with \'{usedTheme}\'',
	            {
	            availableThemes: Object.keys(themeColors).join(', '),
	            usedTheme: parts[0]
	          }));
	        }
	
	        return themeColors[parts[0]].hues[parts[1]];
	      }
	
	      return parts[1] || themeColors[parts[0] in themeColors ? parts[0] : 'primary'].hues['default'];
	    }
	  }
	
	  /**
	   * @ngdoc directive
	   * @name mdColors
	   * @module material.components.colors
	   *
	   * @restrict A
	   *
	   * @description
	   * `mdColors` directive will apply the theme-based color expression as RGBA CSS style values.
	   *
	   *   The format will be similar to the colors defined in the Sass files:
	   *
	   *   ## `[?theme]-[palette]-[?hue]-[?opacity]`
	   *   - [theme]    - default value is the default theme
	   *   - [palette]  - can be either palette name or primary/accent/warn/background
	   *   - [hue]      - default is 500 (hue-x can be used with primary/accent/warn/background)
	   *   - [opacity]  - default is 1
	   *
	   *
	   *   > `?` indicates optional parameter
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <div md-colors="{background: 'myTheme-accent-900-0.43'}">
	   *     <div md-colors="{color: 'red-A100', 'border-color': 'primary-600'}">
	   *       <span>Color demo</span>
	   *     </div>
	   *   </div>
	   * </hljs>
	   *
	   * The `mdColors` directive will automatically watch for changes in the expression if it recognizes
	   * an interpolation expression or a function. For performance options, you can use `::` prefix to
	   * the `md-colors` expression to indicate a one-time data binding.
	   *
	   * <hljs lang="html">
	   *   <md-card md-colors="::{background: '{{theme}}-primary-700'}">
	   *   </md-card>
	   * </hljs>
	   */
	  function MdColorsDirective($mdColors, $mdUtil, $log, $parse) {
	    return {
	      restrict: 'A',
	      require: ['^?mdTheme'],
	      compile: function (tElem, tAttrs) {
	        var shouldWatch = shouldColorsWatch();
	
	        return function (scope, element, attrs, ctrl) {
	          var mdThemeController = ctrl[0];
	
	          var lastColors = {};
	
	          /**
	           * @param {string=} theme
	           * @return {Object} colors found in the specified theme
	           */
	          var parseColors = function (theme) {
	            if (typeof theme !== 'string') {
	              theme = '';
	            }
	
	            if (!attrs.mdColors) {
	              attrs.mdColors = '{}';
	            }
	
	            /**
	             * Json.parse() does not work because the keys are not quoted;
	             * use $parse to convert to a hash map
	             */
	            var colors = $parse(attrs.mdColors)(scope);
	
	            /**
	             * If mdTheme is defined higher up the DOM tree,
	             * we add mdTheme's theme to the colors which don't specify a theme.
	             *
	             * @example
	             * <hljs lang="html">
	             *   <div md-theme="myTheme">
	             *     <div md-colors="{background: 'primary-600'}">
	             *       <span md-colors="{background: 'mySecondTheme-accent-200'}">Color demo</span>
	             *     </div>
	             *   </div>
	             * </hljs>
	             *
	             * 'primary-600' will be changed to 'myTheme-primary-600',
	             * but 'mySecondTheme-accent-200' will not be changed since it has a theme defined.
	             */
	            if (mdThemeController) {
	              Object.keys(colors).forEach(function (prop) {
	                var color = colors[prop];
	                if (!$mdColors.hasTheme(color)) {
	                  colors[prop] = (theme || mdThemeController.$mdTheme) + '-' + color;
	                }
	              });
	            }
	
	            cleanElement(colors);
	
	            return colors;
	          };
	
	          /**
	           * @param {Object} colors
	           */
	          var cleanElement = function (colors) {
	            if (!angular.equals(colors, lastColors)) {
	              var keys = Object.keys(lastColors);
	
	              if (lastColors.background && !keys.color) {
	                keys.push('color');
	              }
	
	              keys.forEach(function (key) {
	                element.css(key, '');
	              });
	            }
	
	            lastColors = colors;
	          };
	
	          /**
	           * Registering for mgTheme changes and asking mdTheme controller run our callback whenever
	           * a theme changes.
	           */
	          var unregisterChanges = angular.noop;
	
	          if (mdThemeController) {
	            unregisterChanges = mdThemeController.registerChanges(function (theme) {
	              $mdColors.applyThemeColors(element, parseColors(theme));
	            });
	          }
	
	          scope.$on('$destroy', function () {
	            unregisterChanges();
	          });
	
	          try {
	            if (shouldWatch) {
	              scope.$watch(parseColors, angular.bind(this,
	                $mdColors.applyThemeColors, element
	              ), true);
	            }
	            else {
	              $mdColors.applyThemeColors(element, parseColors());
	            }
	
	          }
	          catch (e) {
	            $log.error(e.message);
	          }
	
	        };
	
	        /**
	         * @return {boolean}
	         */
	        function shouldColorsWatch() {
	          // Simulate 1x binding and mark mdColorsWatch == false
	          var rawColorExpression = tAttrs.mdColors;
	          var bindOnce = rawColorExpression.indexOf('::') > -1;
	          var isStatic = bindOnce ? true : STATIC_COLOR_EXPRESSION.test(tAttrs.mdColors);
	
	          // Remove it for the postLink...
	          tAttrs.mdColors = rawColorExpression.replace('::', '');
	
	          var hasWatchAttr = angular.isDefined(tAttrs.mdColorsWatch);
	
	          return (bindOnce || isStatic) ? false :
	            hasWatchAttr ? $mdUtil.parseAttributeBoolean(tAttrs.mdColorsWatch) : true;
	        }
	      }
	    };
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.content
	 *
	 * @description
	 * Scrollable content
	 */
	mdContentDirective.$inject = ["$mdTheming"];
	angular.module('material.components.content', [
	  'material.core'
	])
	  .directive('mdContent', mdContentDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdContent
	 * @module material.components.content
	 *
	 * @restrict E
	 *
	 * @description
	 *
	 * The `<md-content>` directive is a container element useful for scrollable content. It achieves
	 * this by setting the CSS `overflow` property to `auto` so that content can properly scroll.
	 *
	 * In general, `<md-content>` components are not designed to be nested inside one another. If
	 * possible, it is better to make them siblings. This often results in a better user experience as
	 * having nested scrollbars may confuse the user.
	 *
	 * ## Troubleshooting
	 *
	 * In some cases, you may wish to apply the `md-no-momentum` class to ensure that Safari's
	 * momentum scrolling is disabled. Momentum scrolling can cause flickering issues while scrolling
	 * SVG icons and some other components.
	 *
	 * Additionally, we now also offer the `md-no-flicker` class which can be applied to any element
	 * and uses a Webkit-specific filter of `blur(0px)` that forces GPU rendering of all elements
	 * inside (which eliminates the flicker on iOS devices).
	 *
	 * _<b>Note:</b> Forcing an element to render on the GPU can have unintended side-effects, especially
	 * related to the z-index of elements. Please use with caution and only on the elements needed._
	 *
	 * @usage
	 *
	 * Add the `[layout-padding]` attribute to make the content padded.
	 *
	 * <hljs lang="html">
	 *  <md-content layout-padding>
	 *      Lorem ipsum dolor sit amet, ne quod novum mei.
	 *  </md-content>
	 * </hljs>
	 */
	
	function mdContentDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    controller: ['$scope', '$element', ContentController],
	    link: function(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      $mdTheming(element);
	      scope.$broadcast('$mdContentLoaded', element);
	
	      iosScrollFix(element[0]);
	    }
	  };
	
	  function ContentController($scope, $element) {
	    this.$scope = $scope;
	    this.$element = $element;
	  }
	}
	
	function iosScrollFix(node) {
	  // IOS FIX:
	  // If we scroll where there is no more room for the webview to scroll,
	  // by default the webview itself will scroll up and down, this looks really
	  // bad.  So if we are scrolling to the very top or bottom, add/subtract one
	  angular.element(node).on('$md.pressdown', function(ev) {
	    // Only touch events
	    if (ev.pointer.type !== 't') return;
	    // Don't let a child content's touchstart ruin it for us.
	    if (ev.$materialScrollFixed) return;
	    ev.$materialScrollFixed = true;
	
	    if (node.scrollTop === 0) {
	      node.scrollTop = 1;
	    } else if (node.scrollHeight === node.scrollTop + node.offsetHeight) {
	      node.scrollTop -= 1;
	    }
	  });
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.datepicker
	 * @description Module for the datepicker component.
	 */
	
	angular.module('material.components.datepicker', [
	  'material.core',
	  'material.components.icon',
	  'material.components.virtualRepeat'
	]);
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc directive
	   * @name mdCalendar
	   * @module material.components.datepicker
	   *
	   * @param {Date} ng-model The component's model. Should be a Date object.
	   * @param {Object=} ng-model-options Allows tuning of the way in which `ng-model` is being
	   *  updated. Also allows for a timezone to be specified.
	   *  <a href="https://docs.angularjs.org/api/ng/directive/ngModelOptions#usage">Read more at the
	   *  ngModelOptions docs.</a>
	   * @param {Date=} md-min-date Expression representing the minimum date.
	   * @param {Date=} md-max-date Expression representing the maximum date.
	   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a
	   *  boolean whether it can be selected in "day" mode or not.
	   * @param {(function(Date): boolean)=} md-month-filter Function expecting a date and returning a
	   *  boolean whether it can be selected in "month" mode or not.
	   * @param {String=} md-current-view Current view of the calendar. Can be either "month" or "year".
	   * @param {String=} md-mode Restricts the user to only selecting a value from a particular view.
	   *  This option can be used if the user is only supposed to choose from a certain date type
	   *  (e.g. only selecting the month). Can be either "month" or "day". **Note** that this will
	   *  overwrite the `md-current-view` value.
	   *
	   * @description
	   * `<md-calendar>` is a component that renders a calendar that can be used to select a date.
	   * It is a part of the `<md-datepicker>` pane, however it can also be used on it's own.
	   *
	   * @usage
	   *
	   * <hljs lang="html">
	   *   <md-calendar ng-model="birthday"></md-calendar>
	   * </hljs>
	   */
	  CalendarCtrl.$inject = ["$element", "$scope", "$$mdDateUtil", "$mdUtil", "$mdConstant", "$mdTheming", "$$rAF", "$attrs", "$mdDateLocale", "$filter"];
	  calendarDirective.$inject = ["inputDirective"];
	  angular.module('material.components.datepicker')
	    .directive('mdCalendar', calendarDirective);
	
	  // TODO(jelbourn): Mac Cmd + left / right == Home / End
	  // TODO(jelbourn): Refactor month element creation to use cloneNode (performance).
	  // TODO(jelbourn): Define virtual scrolling constants (compactness) users can override.
	  // TODO(jelbourn): Animated month transition on ng-model change (virtual-repeat)
	  // TODO(jelbourn): Scroll snapping (virtual repeat)
	  // TODO(jelbourn): Remove superfluous row from short months (virtual-repeat)
	  // TODO(jelbourn): Month headers stick to top when scrolling.
	  // TODO(jelbourn): Previous month opacity is lowered when partially scrolled out of view.
	  // TODO(jelbourn): Support md-calendar standalone on a page (as a tabstop w/ aria-live
	  //     announcement and key handling).
	  // TODO Read-only calendar (not just date-picker).
	
	  function calendarDirective(inputDirective) {
	    return {
	      template: function(tElement, tAttr) {
	        // This allows the calendar to work, without a datepicker. This ensures that the virtual
	        // repeater scrolls to the proper place on load by deferring the execution until the next
	        // digest. It's necessary only if the calendar is used without a datepicker, otherwise it's
	        // already wrapped in an ngIf.
	        var extraAttrs = tAttr.hasOwnProperty('ngIf') ? '' : 'ng-if="calendarCtrl.isInitialized"';
	        return '' +
	          '<div ng-switch="calendarCtrl.currentView" ' + extraAttrs + '>' +
	            '<md-calendar-year ng-switch-when="year"></md-calendar-year>' +
	            '<md-calendar-month ng-switch-default></md-calendar-month>' +
	          '</div>';
	      },
	      scope: {
	        minDate: '=mdMinDate',
	        maxDate: '=mdMaxDate',
	        dateFilter: '=mdDateFilter',
	        monthFilter: '=mdMonthFilter',
	
	        // These need to be prefixed, because Angular resets
	        // any changes to the value due to bindToController.
	        _mode: '@mdMode',
	        _currentView: '@mdCurrentView'
	      },
	      require: ['ngModel', 'mdCalendar'],
	      controller: CalendarCtrl,
	      controllerAs: 'calendarCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var ngModelCtrl = controllers[0];
	        var mdCalendarCtrl = controllers[1];
	        mdCalendarCtrl.configureNgModel(ngModelCtrl, inputDirective);
	      }
	    };
	  }
	
	  /**
	   * Occasionally the hideVerticalScrollbar method might read an element's
	   * width as 0, because it hasn't been laid out yet. This value will be used
	   * as a fallback, in order to prevent scenarios where the element's width
	   * would otherwise have been set to 0. This value is the "usual" width of a
	   * calendar within a floating calendar pane.
	   */
	  var FALLBACK_WIDTH = 340;
	
	  /** Next identifier for calendar instance. */
	  var nextUniqueId = 0;
	
	  /** Maps the `md-mode` values to their corresponding calendar views. */
	  var MODE_MAP = {
	    day: 'month',
	    month: 'year'
	  };
	
	  /**
	   * Controller for the mdCalendar component.
	   * @ngInject @constructor
	   */
	  function CalendarCtrl($element, $scope, $$mdDateUtil, $mdUtil,
	    $mdConstant, $mdTheming, $$rAF, $attrs, $mdDateLocale, $filter) {
	
	    $mdTheming($element);
	
	    /**
	     * @final
	     * @type {!JQLite}
	     */
	    this.$element = $element;
	
	    /**
	     * @final
	     * @type {!angular.Scope}
	     */
	    this.$scope = $scope;
	
	    /**
	     * @final
	     * @type {!angular.$attrs} Current attributes object for the element
	     */
	    this.$attrs = $attrs;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.$mdUtil = $mdUtil;
	
	    /** @final */
	    this.keyCode = $mdConstant.KEY_CODE;
	
	    /** @final */
	    this.$$rAF = $$rAF;
	
	    /** @final */
	    this.$mdDateLocale = $mdDateLocale;
	
	    /** @final The built-in Angular date filter. */
	    this.ngDateFilter = $filter('date');
	
	    /**
	     * @final
	     * @type {Date}
	     */
	    this.today = this.dateUtil.createDateAtMidnight();
	
	    /** @type {!ngModel.NgModelController} */
	    this.ngModelCtrl = undefined;
	
	    /** @type {string} Class applied to the selected date cell. */
	    this.SELECTED_DATE_CLASS = 'md-calendar-selected-date';
	
	    /** @type {string} Class applied to the cell for today. */
	    this.TODAY_CLASS = 'md-calendar-date-today';
	
	    /** @type {string} Class applied to the focused cell. */
	    this.FOCUSED_DATE_CLASS = 'md-focus';
	
	    /**
	     * @final
	     * @type {number} Unique ID for this calendar instance.
	     */
	    this.id = nextUniqueId++;
	
	    /**
	     * The date that is currently focused or showing in the calendar. This will initially be set
	     * to the ng-model value if set, otherwise to today. It will be updated as the user navigates
	     * to other months. The cell corresponding to the displayDate does not necesarily always have
	     * focus in the document (such as for cases when the user is scrolling the calendar).
	     * @type {Date}
	     */
	    this.displayDate = null;
	
	    /**
	     * Allows restricting the calendar to only allow selecting a month or a day.
	     * @type {'month'|'day'|null}
	     */
	    this.mode = null;
	
	    /**
	     * The selected date. Keep track of this separately from the ng-model value so that we
	     * can know, when the ng-model value changes, what the previous value was before it's updated
	     * in the component's UI.
	     *
	     * @type {Date}
	     */
	    this.selectedDate = null;
	
	    /**
	     * The first date that can be rendered by the calendar. The default is taken
	     * from the mdDateLocale provider and is limited by the mdMinDate.
	     * @type {Date}
	     */
	    this.firstRenderableDate = null;
	
	    /**
	     * The last date that can be rendered by the calendar. The default comes
	     * from the mdDateLocale provider and is limited by the maxDate.
	     * @type {Date}
	     */
	    this.lastRenderableDate = null;
	
	    /**
	     * Used to toggle initialize the root element in the next digest.
	     * @type {boolean}
	     */
	    this.isInitialized = false;
	
	    /**
	     * Cache for the  width of the element without a scrollbar. Used to hide the scrollbar later on
	     * and to avoid extra reflows when switching between views.
	     * @type {number}
	     */
	    this.width = 0;
	
	    /**
	     * Caches the width of the scrollbar in order to be used when hiding it and to avoid extra reflows.
	     * @type {number}
	     */
	    this.scrollbarWidth = 0;
	
	    // Unless the user specifies so, the calendar should not be a tab stop.
	    // This is necessary because ngAria might add a tabindex to anything with an ng-model
	    // (based on whether or not the user has turned that particular feature on/off).
	    if (!$attrs.tabindex) {
	      $element.attr('tabindex', '-1');
	    }
	
	    var boundKeyHandler = angular.bind(this, this.handleKeyEvent);
	
	    // If use the md-calendar directly in the body without datepicker,
	    // handleKeyEvent will disable other inputs on the page.
	    // So only apply the handleKeyEvent on the body when the md-calendar inside datepicker,
	    // otherwise apply on the calendar element only.
	
	    var handleKeyElement;
	    if ($element.parent().hasClass('md-datepicker-calendar')) {
	      handleKeyElement = angular.element(document.body);
	    } else {
	      handleKeyElement = $element;
	    }
	
	    // Bind the keydown handler to the body, in order to handle cases where the focused
	    // element gets removed from the DOM and stops propagating click events.
	    handleKeyElement.on('keydown', boundKeyHandler);
	
	    $scope.$on('$destroy', function() {
	      handleKeyElement.off('keydown', boundKeyHandler);
	    });
	
	    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	    // manually call the $onInit hook.
	    if (angular.version.major === 1 && angular.version.minor <= 4) {
	      this.$onInit();
	    }
	  }
	
	  /**
	   * AngularJS Lifecycle hook for newer AngularJS versions.
	   * Bindings are not guaranteed to have been assigned in the controller, but they are in the
	   * $onInit hook.
	   */
	  CalendarCtrl.prototype.$onInit = function() {
	    /**
	     * The currently visible calendar view. Note the prefix on the scope value,
	     * which is necessary, because the datepicker seems to reset the real one value if the
	     * calendar is open, but the `currentView` on the datepicker's scope is empty.
	     * @type {String}
	     */
	    if (this._mode && MODE_MAP.hasOwnProperty(this._mode)) {
	      this.currentView = MODE_MAP[this._mode];
	      this.mode = this._mode;
	    } else {
	      this.currentView = this._currentView || 'month';
	      this.mode = null;
	    }
	
	    if (this.minDate && this.minDate > this.$mdDateLocale.firstRenderableDate) {
	      this.firstRenderableDate = this.minDate;
	    } else {
	      this.firstRenderableDate = this.$mdDateLocale.firstRenderableDate;
	    }
	
	    if (this.maxDate && this.maxDate < this.$mdDateLocale.lastRenderableDate) {
	      this.lastRenderableDate = this.maxDate;
	    } else {
	      this.lastRenderableDate = this.$mdDateLocale.lastRenderableDate;
	    }
	  };
	
	  /**
	   * Sets up the controller's reference to ngModelController.
	   * @param {!ngModel.NgModelController} ngModelCtrl Instance of the ngModel controller.
	   * @param {Object} inputDirective Config for Angular's `input` directive.
	   */
	  CalendarCtrl.prototype.configureNgModel = function(ngModelCtrl, inputDirective) {
	    var self = this;
	    self.ngModelCtrl = ngModelCtrl;
	
	    // The component needs to be [type="date"] in order to be picked up by AngularJS.
	    this.$attrs.$set('type', 'date');
	
	    // Invoke the `input` directive link function, adding a stub for the element.
	    // This allows us to re-use AngularJS' logic for setting the timezone via ng-model-options.
	    // It works by calling the link function directly which then adds the proper `$parsers` and
	    // `$formatters` to the NgModelController.
	    inputDirective[0].link.pre(this.$scope, {
	      on: angular.noop,
	      val: angular.noop,
	      0: {}
	    }, this.$attrs, [ngModelCtrl]);
	
	    ngModelCtrl.$render = function() {
	      var value = this.$viewValue, convertedDate;
	
	      // In the case where a conversion is needed, the $viewValue here will be a string like
	      // "2020-05-10" instead of a Date object.
	      if (!self.dateUtil.isValidDate(value)) {
	        convertedDate = self.dateUtil.removeLocalTzAndReparseDate(new Date(this.$viewValue));
	        if (self.dateUtil.isValidDate(convertedDate)) {
	          value = convertedDate;
	        }
	      }
	
	      // Notify the child scopes of any changes.
	      self.$scope.$broadcast('md-calendar-parent-changed', value);
	
	      // Set up the selectedDate if it hasn't been already.
	      if (!self.selectedDate) {
	        self.selectedDate = value;
	      }
	
	      // Also set up the displayDate.
	      if (!self.displayDate) {
	        self.displayDate = self.selectedDate || self.today;
	      }
	    };
	
	    self.$mdUtil.nextTick(function() {
	      self.isInitialized = true;
	    });
	  };
	
	  /**
	   * Sets the ng-model value for the calendar and emits a change event.
	   * @param {Date} date new value for the calendar
	   */
	  CalendarCtrl.prototype.setNgModelValue = function(date) {
	    var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, 'timezone');
	    var value = this.dateUtil.createDateAtMidnight(date);
	    this.focusDate(value);
	    this.$scope.$emit('md-calendar-change', value);
	    this.ngModelCtrl.$setViewValue(this.ngDateFilter(value, 'yyyy-MM-dd', timezone), 'default');
	    this.ngModelCtrl.$render();
	    return value;
	  };
	
	  /**
	   * Sets the current view that should be visible in the calendar
	   * @param {string} newView View name to be set.
	   * @param {number|Date} time Date object or a timestamp for the new display date.
	   */
	  CalendarCtrl.prototype.setCurrentView = function(newView, time) {
	    var self = this;
	
	    self.$mdUtil.nextTick(function() {
	      self.currentView = newView;
	
	      if (time) {
	        self.displayDate = angular.isDate(time) ? time : new Date(time);
	      }
	    });
	  };
	
	  /**
	   * Focus the cell corresponding to the given date.
	   * @param {Date=} date The date to be focused.
	   */
	  CalendarCtrl.prototype.focusDate = function(date) {
	    if (this.dateUtil.isValidDate(date)) {
	      var previousFocus = this.$element[0].querySelector('.' + this.FOCUSED_DATE_CLASS);
	      if (previousFocus) {
	        previousFocus.classList.remove(this.FOCUSED_DATE_CLASS);
	      }
	
	      var cellId = this.getDateId(date, this.currentView);
	      var cell = document.getElementById(cellId);
	      if (cell) {
	        cell.classList.add(this.FOCUSED_DATE_CLASS);
	        cell.focus();
	        this.displayDate = date;
	      }
	    } else {
	      var rootElement = this.$element[0].querySelector('[ng-switch]');
	
	      if (rootElement) {
	        rootElement.focus();
	      }
	    }
	  };
	
	  /**
	   * Highlights a date cell on the calendar and changes the selected date.
	   * @param {Date=} date Date to be marked as selected.
	   */
	  CalendarCtrl.prototype.changeSelectedDate = function(date) {
	    var selectedDateClass = this.SELECTED_DATE_CLASS;
	    var prevDateCell = this.$element[0].querySelector('.' + selectedDateClass);
	
	    // Remove the selected class from the previously selected date, if any.
	    if (prevDateCell) {
	      prevDateCell.classList.remove(selectedDateClass);
	      prevDateCell.setAttribute('aria-selected', 'false');
	    }
	
	    // Apply the select class to the new selected date if it is set.
	    if (date) {
	      var dateCell = document.getElementById(this.getDateId(date, this.currentView));
	      if (dateCell) {
	        dateCell.classList.add(selectedDateClass);
	        dateCell.setAttribute('aria-selected', 'true');
	      }
	    }
	
	    this.selectedDate = date;
	  };
	
	  /**
	   * Normalizes the key event into an action name. The action will be broadcast
	   * to the child controllers.
	   * @param {KeyboardEvent} event
	   * @returns {String} The action that should be taken, or null if the key
	   * does not match a calendar shortcut.
	   */
	  CalendarCtrl.prototype.getActionFromKeyEvent = function(event) {
	    var keyCode = this.keyCode;
	
	    switch (event.which) {
	      case keyCode.ENTER: return 'select';
	
	      case keyCode.RIGHT_ARROW: return 'move-right';
	      case keyCode.LEFT_ARROW: return 'move-left';
	
	      case keyCode.DOWN_ARROW: return event.metaKey ? 'move-page-down' : 'move-row-down';
	      case keyCode.UP_ARROW: return event.metaKey ? 'move-page-up' : 'move-row-up';
	
	      case keyCode.PAGE_DOWN: return 'move-page-down';
	      case keyCode.PAGE_UP: return 'move-page-up';
	
	      case keyCode.HOME: return 'start';
	      case keyCode.END: return 'end';
	
	      default: return null;
	    }
	  };
	
	  /**
	   * Handles a key event in the calendar with the appropriate action. The action will either
	   * be to select the focused date or to navigate to focus a new date.
	   * @param {KeyboardEvent} event
	   */
	  CalendarCtrl.prototype.handleKeyEvent = function(event) {
	    var self = this;
	
	    this.$scope.$apply(function() {
	      // Capture escape and emit back up so that a wrapping component
	      // (such as a date-picker) can decide to close.
	      if (event.which === self.keyCode.ESCAPE || event.which === self.keyCode.TAB) {
	        self.$scope.$emit('md-calendar-close');
	
	        if (event.which === self.keyCode.TAB) {
	          event.preventDefault();
	        }
	
	        return;
	      }
	
	      // Broadcast the action that any child controllers should take.
	      var action = self.getActionFromKeyEvent(event);
	      if (action) {
	        event.preventDefault();
	        event.stopPropagation();
	        self.$scope.$broadcast('md-calendar-parent-action', action);
	      }
	    });
	  };
	
	  /**
	   * Hides the vertical scrollbar on the calendar scroller of a child controller by
	   * setting the width on the calendar scroller and the `overflow: hidden` wrapper
	   * around the scroller, and then setting a padding-right on the scroller equal
	   * to the width of the browser's scrollbar.
	   *
	   * This will cause a reflow.
	   *
	   * @param {object} childCtrl The child controller whose scrollbar should be hidden.
	   */
	  CalendarCtrl.prototype.hideVerticalScrollbar = function(childCtrl) {
	    var self = this;
	    var element = childCtrl.$element[0];
	    var scrollMask = element.querySelector('.md-calendar-scroll-mask');
	
	    if (self.width > 0) {
	      setWidth();
	    } else {
	      self.$$rAF(function() {
	        var scroller = childCtrl.calendarScroller;
	
	        self.scrollbarWidth = scroller.offsetWidth - scroller.clientWidth;
	        self.width = element.querySelector('table').offsetWidth;
	        setWidth();
	      });
	    }
	
	    function setWidth() {
	      var width = self.width || FALLBACK_WIDTH;
	      var scrollbarWidth = self.scrollbarWidth;
	      var scroller = childCtrl.calendarScroller;
	
	      scrollMask.style.width = width + 'px';
	      scroller.style.width = (width + scrollbarWidth) + 'px';
	      scroller.style.paddingRight = scrollbarWidth + 'px';
	    }
	  };
	
	  /**
	   * Gets an identifier for a date unique to the calendar instance for internal
	   * purposes. Not to be displayed.
	   * @param {Date} date The date for which the id is being generated
	   * @param {string} namespace Namespace for the id. (month, year etc.)
	   * @returns {string}
	   */
	  CalendarCtrl.prototype.getDateId = function(date, namespace) {
	    if (!namespace) {
	      throw new Error('A namespace for the date id has to be specified.');
	    }
	
	    return [
	      'md',
	      this.id,
	      namespace,
	      date.getFullYear(),
	      date.getMonth(),
	      date.getDate()
	    ].join('-');
	  };
	
	  /**
	   * Util to trigger an extra digest on a parent scope, in order to to ensure that
	   * any child virtual repeaters have updated. This is necessary, because the virtual
	   * repeater doesn't update the $index the first time around since the content isn't
	   * in place yet. The case, in which this is an issue, is when the repeater has less
	   * than a page of content (e.g. a month or year view has a min or max date).
	   */
	  CalendarCtrl.prototype.updateVirtualRepeat = function() {
	    var scope = this.$scope;
	    var virtualRepeatResizeListener = scope.$on('$md-resize-enable', function() {
	      if (!scope.$$phase) {
	        scope.$apply();
	      }
	
	      virtualRepeatResizeListener();
	    });
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  CalendarMonthCtrl.$inject = ["$element", "$scope", "$animate", "$q", "$$mdDateUtil", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	    .directive('mdCalendarMonth', calendarDirective);
	
	  /**
	   * Height of one calendar month tbody. This must be made known to the virtual-repeat and is
	   * subsequently used for scrolling to specific months.
	   */
	  var TBODY_HEIGHT = 265;
	
	  /**
	   * Height of a calendar month with a single row. This is needed to calculate the offset for
	   * rendering an extra month in virtual-repeat that only contains one row.
	   */
	  var TBODY_SINGLE_ROW_HEIGHT = 45;
	
	  /** Private directive that represents a list of months inside the calendar. */
	  function calendarDirective() {
	    return {
	      template:
	        '<table aria-hidden="true" class="md-calendar-day-header"><thead></thead></table>' +
	        '<div class="md-calendar-scroll-mask">' +
	        '<md-virtual-repeat-container class="md-calendar-scroll-container" ' +
	              'md-offset-size="' + (TBODY_SINGLE_ROW_HEIGHT - TBODY_HEIGHT) + '">' +
	            '<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">' +
	              '<tbody ' +
	                  'md-calendar-month-body ' +
	                  'role="rowgroup" ' +
	                  'md-virtual-repeat="i in monthCtrl.items" ' +
	                  'md-month-offset="$index" ' +
	                  'class="md-calendar-month" ' +
	                  'md-start-index="monthCtrl.getSelectedMonthIndex()" ' +
	                  'md-item-size="' + TBODY_HEIGHT + '">' +
	
	                // The <tr> ensures that the <tbody> will always have the
	                // proper height, even if it's empty. If it's content is
	                // compiled, the <tr> will be overwritten.
	                '<tr aria-hidden="true" md-force-height="\'' + TBODY_HEIGHT + 'px\'"></tr>' +
	              '</tbody>' +
	            '</table>' +
	          '</md-virtual-repeat-container>' +
	        '</div>',
	      require: ['^^mdCalendar', 'mdCalendarMonth'],
	      controller: CalendarMonthCtrl,
	      controllerAs: 'monthCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var monthCtrl = controllers[1];
	        monthCtrl.initialize(calendarCtrl);
	      }
	    };
	  }
	
	  /**
	   * Controller for the calendar month component.
	   * @ngInject @constructor
	   */
	  function CalendarMonthCtrl($element, $scope, $animate, $q,
	    $$mdDateUtil, $mdDateLocale) {
	
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final {!angular.Scope} */
	    this.$scope = $scope;
	
	    /** @final {!angular.$animate} */
	    this.$animate = $animate;
	
	    /** @final {!angular.$q} */
	    this.$q = $q;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.dateLocale = $mdDateLocale;
	
	    /** @final {HTMLElement} */
	    this.calendarScroller = $element[0].querySelector('.md-virtual-repeat-scroller');
	
	    /** @type {boolean} */
	    this.isInitialized = false;
	
	    /** @type {boolean} */
	    this.isMonthTransitionInProgress = false;
	
	    var self = this;
	
	    /**
	     * Handles a click event on a date cell.
	     * Created here so that every cell can use the same function instance.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */
	    this.cellClickHandler = function() {
	      var timestamp = $$mdDateUtil.getTimestampFromNode(this);
	      self.$scope.$apply(function() {
	        // The timestamp has to be converted to a valid date.
	        self.calendarCtrl.setNgModelValue(new Date(timestamp));
	      });
	    };
	
	    /**
	     * Handles click events on the month headers. Switches
	     * the calendar to the year view.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */
	    this.headerClickHandler = function() {
	      self.calendarCtrl.setCurrentView('year', $$mdDateUtil.getTimestampFromNode(this));
	    };
	  }
	
	  /** Initialization **/
	
	  /**
	   * Initialize the controller by saving a reference to the calendar and
	   * setting up the object that will be iterated by the virtual repeater.
	   */
	  CalendarMonthCtrl.prototype.initialize = function(calendarCtrl) {
	    /**
	     * Dummy array-like object for virtual-repeat to iterate over. The length is the total
	     * number of months that can be viewed. We add 2 months: one to include the current month
	     * and one for the last dummy month.
	     *
	     * This is shorter than ideal because of a (potential) Firefox bug
	     * https://bugzilla.mozilla.org/show_bug.cgi?id=1181658.
	     */
	
	    this.items = {
	      length: this.dateUtil.getMonthDistance(
	        calendarCtrl.firstRenderableDate,
	        calendarCtrl.lastRenderableDate
	      ) + 2
	    };
	
	    this.calendarCtrl = calendarCtrl;
	    this.attachScopeListeners();
	    calendarCtrl.updateVirtualRepeat();
	
	    // Fire the initial render, since we might have missed it the first time it fired.
	    calendarCtrl.ngModelCtrl && calendarCtrl.ngModelCtrl.$render();
	  };
	
	  /**
	   * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
	   * @returns {number} the "index" of the currently selected date
	   */
	  CalendarMonthCtrl.prototype.getSelectedMonthIndex = function() {
	    var calendarCtrl = this.calendarCtrl;
	
	    return this.dateUtil.getMonthDistance(
	      calendarCtrl.firstRenderableDate,
	      calendarCtrl.displayDate || calendarCtrl.selectedDate || calendarCtrl.today
	    );
	  };
	
	  /**
	   * Change the date that is being shown in the calendar. If the given date is in a different
	   * month, the displayed month will be transitioned.
	   * @param {Date} date
	   */
	  CalendarMonthCtrl.prototype.changeDisplayDate = function(date) {
	    // Initialization is deferred until this function is called because we want to reflect
	    // the starting value of ngModel.
	    if (!this.isInitialized) {
	      this.buildWeekHeader();
	      this.calendarCtrl.hideVerticalScrollbar(this);
	      this.isInitialized = true;
	      return this.$q.when();
	    }
	
	    // If trying to show an invalid date or a transition is in progress, do nothing.
	    if (!this.dateUtil.isValidDate(date) || this.isMonthTransitionInProgress) {
	      return this.$q.when();
	    }
	
	    this.isMonthTransitionInProgress = true;
	    var animationPromise = this.animateDateChange(date);
	
	    this.calendarCtrl.displayDate = date;
	
	    var self = this;
	    animationPromise.then(function() {
	      self.isMonthTransitionInProgress = false;
	    });
	
	    return animationPromise;
	  };
	
	  /**
	   * Animates the transition from the calendar's current month to the given month.
	   * @param {Date} date
	   * @returns {angular.$q.Promise} The animation promise.
	   */
	  CalendarMonthCtrl.prototype.animateDateChange = function(date) {
	    if (this.dateUtil.isValidDate(date)) {
	      var monthDistance = this.dateUtil.getMonthDistance(this.calendarCtrl.firstRenderableDate, date);
	      this.calendarScroller.scrollTop = monthDistance * TBODY_HEIGHT;
	    }
	
	    return this.$q.when();
	  };
	
	  /**
	   * Builds and appends a day-of-the-week header to the calendar.
	   * This should only need to be called once during initialization.
	   */
	  CalendarMonthCtrl.prototype.buildWeekHeader = function() {
	    var firstDayOfWeek = this.dateLocale.firstDayOfWeek;
	    var shortDays = this.dateLocale.shortDays;
	
	    var row = document.createElement('tr');
	    for (var i = 0; i < 7; i++) {
	      var th = document.createElement('th');
	      th.textContent = shortDays[(i + firstDayOfWeek) % 7];
	      row.appendChild(th);
	    }
	
	    this.$element.find('thead').append(row);
	  };
	
	  /**
	   * Attaches listeners for the scope events that are broadcast by the calendar.
	   */
	  CalendarMonthCtrl.prototype.attachScopeListeners = function() {
	    var self = this;
	
	    self.$scope.$on('md-calendar-parent-changed', function(event, value) {
	      self.calendarCtrl.changeSelectedDate(value);
	      self.changeDisplayDate(value);
	    });
	
	    self.$scope.$on('md-calendar-parent-action', angular.bind(this, this.handleKeyEvent));
	  };
	
	  /**
	   * Handles the month-specific keyboard interactions.
	   * @param {Object} event Scope event object passed by the calendar.
	   * @param {String} action Action, corresponding to the key that was pressed.
	   */
	  CalendarMonthCtrl.prototype.handleKeyEvent = function(event, action) {
	    var calendarCtrl = this.calendarCtrl;
	    var displayDate = calendarCtrl.displayDate;
	
	    if (action === 'select') {
	      calendarCtrl.setNgModelValue(displayDate);
	    } else {
	      var date = null;
	      var dateUtil = this.dateUtil;
	
	      switch (action) {
	        case 'move-right': date = dateUtil.incrementDays(displayDate, 1); break;
	        case 'move-left': date = dateUtil.incrementDays(displayDate, -1); break;
	
	        case 'move-page-down': date = dateUtil.incrementMonths(displayDate, 1); break;
	        case 'move-page-up': date = dateUtil.incrementMonths(displayDate, -1); break;
	
	        case 'move-row-down': date = dateUtil.incrementDays(displayDate, 7); break;
	        case 'move-row-up': date = dateUtil.incrementDays(displayDate, -7); break;
	
	        case 'start': date = dateUtil.getFirstDateOfMonth(displayDate); break;
	        case 'end': date = dateUtil.getLastDateOfMonth(displayDate); break;
	      }
	
	      if (date) {
	        date = this.dateUtil.clampDate(date, calendarCtrl.minDate, calendarCtrl.maxDate);
	
	        this.changeDisplayDate(date).then(function() {
	          calendarCtrl.focusDate(date);
	        });
	      }
	    }
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  mdCalendarMonthBodyDirective.$inject = ["$compile", "$$mdSvgRegistry"];
	  CalendarMonthBodyCtrl.$inject = ["$element", "$$mdDateUtil", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	      .directive('mdCalendarMonthBody', mdCalendarMonthBodyDirective);
	
	  /**
	   * Private directive consumed by md-calendar-month. Having this directive lets the calender use
	   * md-virtual-repeat and also cleanly separates the month DOM construction functions from
	   * the rest of the calendar controller logic.
	   * @ngInject
	   */
	  function mdCalendarMonthBodyDirective($compile, $$mdSvgRegistry) {
	    var ARROW_ICON = $compile('<md-icon md-svg-src="' +
	      $$mdSvgRegistry.mdTabsArrow + '"></md-icon>')({})[0];
	
	    return {
	      require: ['^^mdCalendar', '^^mdCalendarMonth', 'mdCalendarMonthBody'],
	      scope: { offset: '=mdMonthOffset' },
	      controller: CalendarMonthBodyCtrl,
	      controllerAs: 'mdMonthBodyCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var monthCtrl = controllers[1];
	        var monthBodyCtrl = controllers[2];
	
	        monthBodyCtrl.calendarCtrl = calendarCtrl;
	        monthBodyCtrl.monthCtrl = monthCtrl;
	        monthBodyCtrl.arrowIcon = ARROW_ICON.cloneNode(true);
	
	        // The virtual-repeat re-uses the same DOM elements, so there are only a limited number
	        // of repeated items that are linked, and then those elements have their bindings updated.
	        // Since the months are not generated by bindings, we simply regenerate the entire thing
	        // when the binding (offset) changes.
	        scope.$watch(function() { return monthBodyCtrl.offset; }, function(offset) {
	          if (angular.isNumber(offset)) {
	            monthBodyCtrl.generateContent();
	          }
	        });
	      }
	    };
	  }
	
	  /**
	   * Controller for a single calendar month.
	   * @ngInject @constructor
	   */
	  function CalendarMonthBodyCtrl($element, $$mdDateUtil, $mdDateLocale) {
	    /**
	     * @final
	     * @type {!JQLite}
	     */
	    this.$element = $element;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.dateLocale = $mdDateLocale;
	
	    /** @type {Object} Reference to the month view. */
	    this.monthCtrl = null;
	
	    /** @type {Object} Reference to the calendar. */
	    this.calendarCtrl = null;
	
	    /**
	     * Number of months from the start of the month "items" that the currently rendered month
	     * occurs. Set via angular data binding.
	     * @type {number|null}
	     */
	    this.offset = null;
	
	    /**
	     * Date cell to focus after appending the month to the document.
	     * @type {HTMLElement}
	     */
	    this.focusAfterAppend = null;
	  }
	
	  /** Generate and append the content for this month to the directive element. */
	  CalendarMonthBodyCtrl.prototype.generateContent = function() {
	    var date = this.dateUtil.incrementMonths(this.calendarCtrl.firstRenderableDate, this.offset);
	
	    this.$element
	      .empty()
	      .append(this.buildCalendarForMonth(date));
	
	    if (this.focusAfterAppend) {
	      this.focusAfterAppend.classList.add(this.calendarCtrl.FOCUSED_DATE_CLASS);
	      this.focusAfterAppend = null;
	    }
	  };
	
	  /**
	   * Creates a single cell to contain a date in the calendar with all appropriate
	   * attributes and classes added. If a date is given, the cell content will be set
	   * based on the date.
	   * @param {Date=} opt_date
	   * @returns {HTMLElement}
	   */
	  CalendarMonthBodyCtrl.prototype.buildDateCell = function(opt_date) {
	    var monthCtrl = this.monthCtrl;
	    var calendarCtrl = this.calendarCtrl;
	
	    // TODO(jelbourn): cloneNode is likely a faster way of doing this.
	    var cell = document.createElement('td');
	    cell.tabIndex = -1;
	    cell.classList.add('md-calendar-date');
	    cell.setAttribute('role', 'gridcell');
	
	    if (opt_date) {
	      cell.setAttribute('tabindex', '-1');
	      cell.setAttribute('aria-label', this.dateLocale.longDateFormatter(opt_date));
	      cell.id = calendarCtrl.getDateId(opt_date, 'month');
	
	      // Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
	      cell.setAttribute('data-timestamp', opt_date.getTime());
	
	      // TODO(jelourn): Doing these comparisons for class addition during generation might be slow.
	      // It may be better to finish the construction and then query the node and add the class.
	      if (this.dateUtil.isSameDay(opt_date, calendarCtrl.today)) {
	        cell.classList.add(calendarCtrl.TODAY_CLASS);
	      }
	
	      if (this.dateUtil.isValidDate(calendarCtrl.selectedDate) &&
	          this.dateUtil.isSameDay(opt_date, calendarCtrl.selectedDate)) {
	        cell.classList.add(calendarCtrl.SELECTED_DATE_CLASS);
	        cell.setAttribute('aria-selected', 'true');
	      }
	
	      var cellText = this.dateLocale.dates[opt_date.getDate()];
	
	      if (this.isDateEnabled(opt_date)) {
	        // Add a indicator for select, hover, and focus states.
	        var selectionIndicator = document.createElement('span');
	        selectionIndicator.classList.add('md-calendar-date-selection-indicator');
	        selectionIndicator.textContent = cellText;
	        cell.appendChild(selectionIndicator);
	        cell.addEventListener('click', monthCtrl.cellClickHandler);
	
	        if (calendarCtrl.displayDate && this.dateUtil.isSameDay(opt_date, calendarCtrl.displayDate)) {
	          this.focusAfterAppend = cell;
	        }
	      } else {
	        cell.classList.add('md-calendar-date-disabled');
	        cell.textContent = cellText;
	      }
	    }
	
	    return cell;
	  };
	
	  /**
	   * Check whether date is in range and enabled
	   * @param {Date=} opt_date
	   * @return {boolean} Whether the date is enabled.
	   */
	  CalendarMonthBodyCtrl.prototype.isDateEnabled = function(opt_date) {
	    return this.dateUtil.isDateWithinRange(opt_date,
	          this.calendarCtrl.minDate, this.calendarCtrl.maxDate) &&
	          (!angular.isFunction(this.calendarCtrl.dateFilter)
	           || this.calendarCtrl.dateFilter(opt_date));
	  };
	
	  /**
	   * Builds a `tr` element for the calendar grid.
	   * @param rowNumber The week number within the month.
	   * @returns {HTMLElement}
	   */
	  CalendarMonthBodyCtrl.prototype.buildDateRow = function(rowNumber) {
	    var row = document.createElement('tr');
	    row.setAttribute('role', 'row');
	
	    // Because of an NVDA bug (with Firefox), the row needs an aria-label in order
	    // to prevent the entire row being read aloud when the user moves between rows.
	    // See http://community.nvda-project.org/ticket/4643.
	    row.setAttribute('aria-label', this.dateLocale.weekNumberFormatter(rowNumber));
	
	    return row;
	  };
	
	  /**
	   * Builds the <tbody> content for the given date's month.
	   * @param {Date=} opt_dateInMonth
	   * @returns {DocumentFragment} A document fragment containing the <tr> elements.
	   */
	  CalendarMonthBodyCtrl.prototype.buildCalendarForMonth = function(opt_dateInMonth) {
	    var date = this.dateUtil.isValidDate(opt_dateInMonth) ? opt_dateInMonth : new Date();
	
	    var firstDayOfMonth = this.dateUtil.getFirstDateOfMonth(date);
	    var firstDayOfTheWeek = this.getLocaleDay_(firstDayOfMonth);
	    var numberOfDaysInMonth = this.dateUtil.getNumberOfDaysInMonth(date);
	
	    // Store rows for the month in a document fragment so that we can append them all at once.
	    var monthBody = document.createDocumentFragment();
	
	    var rowNumber = 1;
	    var row = this.buildDateRow(rowNumber);
	    monthBody.appendChild(row);
	
	    // If this is the final month in the list of items, only the first week should render,
	    // so we should return immediately after the first row is complete and has been
	    // attached to the body.
	    var isFinalMonth = this.offset === this.monthCtrl.items.length - 1;
	
	    // Add a label for the month. If the month starts on a Sun/Mon/Tues, the month label
	    // goes on a row above the first of the month. Otherwise, the month label takes up the first
	    // two cells of the first row.
	    var blankCellOffset = 0;
	    var monthLabelCell = document.createElement('td');
	    var monthLabelCellContent = document.createElement('span');
	    var calendarCtrl = this.calendarCtrl;
	
	    monthLabelCellContent.textContent = this.dateLocale.monthHeaderFormatter(date);
	    monthLabelCell.appendChild(monthLabelCellContent);
	    monthLabelCell.classList.add('md-calendar-month-label');
	    // If the entire month is after the max date, render the label as a disabled state.
	    if (calendarCtrl.maxDate && firstDayOfMonth > calendarCtrl.maxDate) {
	      monthLabelCell.classList.add('md-calendar-month-label-disabled');
	    // If the user isn't supposed to be able to change views, render the
	    // label as usual, but disable the clicking functionality.
	    } else if (!calendarCtrl.mode) {
	      monthLabelCell.addEventListener('click', this.monthCtrl.headerClickHandler);
	      monthLabelCell.setAttribute('data-timestamp', firstDayOfMonth.getTime());
	      monthLabelCell.setAttribute('aria-label', this.dateLocale.monthFormatter(date));
	      monthLabelCell.classList.add('md-calendar-label-clickable');
	      monthLabelCell.appendChild(this.arrowIcon.cloneNode(true));
	    }
	
	    if (firstDayOfTheWeek <= 2) {
	      monthLabelCell.setAttribute('colspan', '7');
	
	      var monthLabelRow = this.buildDateRow();
	      monthLabelRow.appendChild(monthLabelCell);
	      monthBody.insertBefore(monthLabelRow, row);
	
	      if (isFinalMonth) {
	        return monthBody;
	      }
	    } else {
	      blankCellOffset = 3;
	      monthLabelCell.setAttribute('colspan', '3');
	      row.appendChild(monthLabelCell);
	    }
	
	    // Add a blank cell for each day of the week that occurs before the first of the month.
	    // For example, if the first day of the month is a Tuesday, add blank cells for Sun and Mon.
	    // The blankCellOffset is needed in cases where the first N cells are used by the month label.
	    for (var i = blankCellOffset; i < firstDayOfTheWeek; i++) {
	      row.appendChild(this.buildDateCell());
	    }
	
	    // Add a cell for each day of the month, keeping track of the day of the week so that
	    // we know when to start a new row.
	    var dayOfWeek = firstDayOfTheWeek;
	    var iterationDate = firstDayOfMonth;
	    for (var d = 1; d <= numberOfDaysInMonth; d++) {
	      // If we've reached the end of the week, start a new row.
	      if (dayOfWeek === 7) {
	        // We've finished the first row, so we're done if this is the final month.
	        if (isFinalMonth) {
	          return monthBody;
	        }
	        dayOfWeek = 0;
	        rowNumber++;
	        row = this.buildDateRow(rowNumber);
	        monthBody.appendChild(row);
	      }
	
	      iterationDate.setDate(d);
	      var cell = this.buildDateCell(iterationDate);
	      row.appendChild(cell);
	
	      dayOfWeek++;
	    }
	
	    // Ensure that the last row of the month has 7 cells.
	    while (row.childNodes.length < 7) {
	      row.appendChild(this.buildDateCell());
	    }
	
	    // Ensure that all months have 6 rows. This is necessary for now because the virtual-repeat
	    // requires that all items have exactly the same height.
	    while (monthBody.childNodes.length < 6) {
	      var whitespaceRow = this.buildDateRow();
	      for (var j = 0; j < 7; j++) {
	        whitespaceRow.appendChild(this.buildDateCell());
	      }
	      monthBody.appendChild(whitespaceRow);
	    }
	
	    return monthBody;
	  };
	
	  /**
	   * Gets the day-of-the-week index for a date for the current locale.
	   * @private
	   * @param {Date} date
	   * @returns {number} The column index of the date in the calendar.
	   */
	  CalendarMonthBodyCtrl.prototype.getLocaleDay_ = function(date) {
	    return (date.getDay() + (7 - this.dateLocale.firstDayOfWeek)) % 7;
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  CalendarYearCtrl.$inject = ["$element", "$scope", "$animate", "$q", "$$mdDateUtil", "$mdUtil"];
	  angular.module('material.components.datepicker')
	    .directive('mdCalendarYear', calendarDirective);
	
	  /**
	   * Height of one calendar year tbody. This must be made known to the virtual-repeat and is
	   * subsequently used for scrolling to specific years.
	   */
	  var TBODY_HEIGHT = 88;
	
	  /** Private component, representing a list of years in the calendar. */
	  function calendarDirective() {
	    return {
	      template:
	        '<div class="md-calendar-scroll-mask">' +
	          '<md-virtual-repeat-container class="md-calendar-scroll-container">' +
	            '<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">' +
	              '<tbody ' +
	                  'md-calendar-year-body ' +
	                  'role="rowgroup" ' +
	                  'md-virtual-repeat="i in yearCtrl.items" ' +
	                  'md-year-offset="$index" class="md-calendar-year" ' +
	                  'md-start-index="yearCtrl.getFocusedYearIndex()" ' +
	                  'md-item-size="' + TBODY_HEIGHT + '">' +
	                // The <tr> ensures that the <tbody> will have the proper
	                // height, even though it may be empty.
	                '<tr aria-hidden="true" md-force-height="\'' + TBODY_HEIGHT + 'px\'"></tr>' +
	              '</tbody>' +
	            '</table>' +
	          '</md-virtual-repeat-container>' +
	        '</div>',
	      require: ['^^mdCalendar', 'mdCalendarYear'],
	      controller: CalendarYearCtrl,
	      controllerAs: 'yearCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var yearCtrl = controllers[1];
	        yearCtrl.initialize(calendarCtrl);
	      }
	    };
	  }
	
	  /**
	   * Controller for the mdCalendar component.
	   * @ngInject @constructor
	   */
	  function CalendarYearCtrl($element, $scope, $animate, $q, $$mdDateUtil, $mdUtil) {
	
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final {!angular.Scope} */
	    this.$scope = $scope;
	
	    /** @final {!angular.$animate} */
	    this.$animate = $animate;
	
	    /** @final {!angular.$q} */
	    this.$q = $q;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final {HTMLElement} */
	    this.calendarScroller = $element[0].querySelector('.md-virtual-repeat-scroller');
	
	    /** @type {boolean} */
	    this.isInitialized = false;
	
	    /** @type {boolean} */
	    this.isMonthTransitionInProgress = false;
	
	    /** @final */
	    this.$mdUtil = $mdUtil;
	
	    var self = this;
	
	    /**
	     * Handles a click event on a date cell.
	     * Created here so that every cell can use the same function instance.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */
	    this.cellClickHandler = function() {
	      self.onTimestampSelected($$mdDateUtil.getTimestampFromNode(this));
	    };
	  }
	
	  /**
	   * Initialize the controller by saving a reference to the calendar and
	   * setting up the object that will be iterated by the virtual repeater.
	   */
	  CalendarYearCtrl.prototype.initialize = function(calendarCtrl) {
	    /**
	     * Dummy array-like object for virtual-repeat to iterate over. The length is the total
	     * number of years that can be viewed. We add 1 extra in order to include the current year.
	     */
	
	    this.items = {
	      length: this.dateUtil.getYearDistance(
	        calendarCtrl.firstRenderableDate,
	        calendarCtrl.lastRenderableDate
	      ) + 1
	    };
	
	    this.calendarCtrl = calendarCtrl;
	    this.attachScopeListeners();
	    calendarCtrl.updateVirtualRepeat();
	
	    // Fire the initial render, since we might have missed it the first time it fired.
	    calendarCtrl.ngModelCtrl && calendarCtrl.ngModelCtrl.$render();
	  };
	
	  /**
	   * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
	   * @returns {number}
	   */
	  CalendarYearCtrl.prototype.getFocusedYearIndex = function() {
	    var calendarCtrl = this.calendarCtrl;
	
	    return this.dateUtil.getYearDistance(
	      calendarCtrl.firstRenderableDate,
	      calendarCtrl.displayDate || calendarCtrl.selectedDate || calendarCtrl.today
	    );
	  };
	
	  /**
	   * Change the date that is highlighted in the calendar.
	   * @param {Date} date
	   */
	  CalendarYearCtrl.prototype.changeDate = function(date) {
	    // Initialization is deferred until this function is called because we want to reflect
	    // the starting value of ngModel.
	    if (!this.isInitialized) {
	      this.calendarCtrl.hideVerticalScrollbar(this);
	      this.isInitialized = true;
	      return this.$q.when();
	    } else if (this.dateUtil.isValidDate(date) && !this.isMonthTransitionInProgress) {
	      var self = this;
	      var animationPromise = this.animateDateChange(date);
	
	      self.isMonthTransitionInProgress = true;
	      self.calendarCtrl.displayDate = date;
	
	      return animationPromise.then(function() {
	        self.isMonthTransitionInProgress = false;
	      });
	    }
	  };
	
	  /**
	   * Animates the transition from the calendar's current month to the given month.
	   * @param {Date} date
	   * @returns {angular.$q.Promise} The animation promise.
	   */
	  CalendarYearCtrl.prototype.animateDateChange = function(date) {
	    if (this.dateUtil.isValidDate(date)) {
	      var monthDistance = this.dateUtil.getYearDistance(this.calendarCtrl.firstRenderableDate, date);
	      this.calendarScroller.scrollTop = monthDistance * TBODY_HEIGHT;
	    }
	
	    return this.$q.when();
	  };
	
	  /**
	   * Handles the year-view-specific keyboard interactions.
	   * @param {Object} event Scope event object passed by the calendar.
	   * @param {String} action Action, corresponding to the key that was pressed.
	   */
	  CalendarYearCtrl.prototype.handleKeyEvent = function(event, action) {
	    var self = this;
	    var calendarCtrl = self.calendarCtrl;
	    var displayDate = calendarCtrl.displayDate;
	
	    if (action === 'select') {
	      self.changeDate(displayDate).then(function() {
	        self.onTimestampSelected(displayDate);
	      });
	    } else {
	      var date = null;
	      var dateUtil = self.dateUtil;
	
	      switch (action) {
	        case 'move-right': date = dateUtil.incrementMonths(displayDate, 1); break;
	        case 'move-left': date = dateUtil.incrementMonths(displayDate, -1); break;
	
	        case 'move-row-down': date = dateUtil.incrementMonths(displayDate, 6); break;
	        case 'move-row-up': date = dateUtil.incrementMonths(displayDate, -6); break;
	      }
	
	      if (date) {
	        var min = calendarCtrl.minDate ? dateUtil.getFirstDateOfMonth(calendarCtrl.minDate) : null;
	        var max = calendarCtrl.maxDate ? dateUtil.getFirstDateOfMonth(calendarCtrl.maxDate) : null;
	        date = dateUtil.getFirstDateOfMonth(self.dateUtil.clampDate(date, min, max));
	
	        self.changeDate(date).then(function() {
	          calendarCtrl.focusDate(date);
	        });
	      }
	    }
	  };
	
	  /**
	   * Attaches listeners for the scope events that are broadcast by the calendar.
	   */
	  CalendarYearCtrl.prototype.attachScopeListeners = function() {
	    var self = this;
	
	    self.$scope.$on('md-calendar-parent-changed', function(event, value) {
	      self.calendarCtrl.changeSelectedDate(value ? self.dateUtil.getFirstDateOfMonth(value) : value);
	      self.changeDate(value);
	    });
	
	    self.$scope.$on('md-calendar-parent-action', angular.bind(self, self.handleKeyEvent));
	  };
	
	  /**
	   * Handles the behavior when a date is selected. Depending on the `mode`
	   * of the calendar, this can either switch back to the calendar view or
	   * set the model value.
	   * @param {number} timestamp The selected timestamp.
	   */
	  CalendarYearCtrl.prototype.onTimestampSelected = function(timestamp) {
	    var calendarCtrl = this.calendarCtrl;
	
	    if (calendarCtrl.mode) {
	      this.$mdUtil.nextTick(function() {
	        // The timestamp has to be converted to a valid date.
	        calendarCtrl.setNgModelValue(new Date(timestamp));
	      });
	    } else {
	      calendarCtrl.setCurrentView('month', timestamp);
	    }
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  CalendarYearBodyCtrl.$inject = ["$element", "$$mdDateUtil", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	      .directive('mdCalendarYearBody', mdCalendarYearDirective);
	
	  /**
	   * Private component, consumed by the md-calendar-year, which separates the DOM construction logic
	   * and allows for the year view to use md-virtual-repeat.
	   */
	  function mdCalendarYearDirective() {
	    return {
	      require: ['^^mdCalendar', '^^mdCalendarYear', 'mdCalendarYearBody'],
	      scope: { offset: '=mdYearOffset' },
	      controller: CalendarYearBodyCtrl,
	      controllerAs: 'mdYearBodyCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var yearCtrl = controllers[1];
	        var yearBodyCtrl = controllers[2];
	
	        yearBodyCtrl.calendarCtrl = calendarCtrl;
	        yearBodyCtrl.yearCtrl = yearCtrl;
	
	        scope.$watch(function() { return yearBodyCtrl.offset; }, function(offset) {
	          if (angular.isNumber(offset)) {
	            yearBodyCtrl.generateContent();
	          }
	        });
	      }
	    };
	  }
	
	  /**
	   * Controller for a single year.
	   * @ngInject @constructor
	   */
	  function CalendarYearBodyCtrl($element, $$mdDateUtil, $mdDateLocale) {
	    /**
	     * @final
	     * @type {!JQLite}
	     */
	    this.$element = $element;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.dateLocale = $mdDateLocale;
	
	    /** @type {Object} Reference to the calendar. */
	    this.calendarCtrl = null;
	
	    /** @type {Object} Reference to the year view. */
	    this.yearCtrl = null;
	
	    /**
	     * Number of months from the start of the month "items" that the currently rendered month
	     * occurs. Set via angular data binding.
	     * @type {number|null}
	     */
	    this.offset = null;
	
	    /**
	     * Date cell to focus after appending the month to the document.
	     * @type {HTMLElement}
	     */
	    this.focusAfterAppend = null;
	  }
	
	  /** Generate and append the content for this year to the directive element. */
	  CalendarYearBodyCtrl.prototype.generateContent = function() {
	    var date = this.dateUtil.incrementYears(this.calendarCtrl.firstRenderableDate, this.offset);
	
	    this.$element
	      .empty()
	      .append(this.buildCalendarForYear(date));
	
	    if (this.focusAfterAppend) {
	      this.focusAfterAppend.classList.add(this.calendarCtrl.FOCUSED_DATE_CLASS);
	      this.focusAfterAppend = null;
	    }
	  };
	
	  /**
	   * Creates a single cell to contain a year in the calendar.
	   * @param {number} year Four-digit year.
	   * @param {number} month Zero-indexed month.
	   * @returns {HTMLElement}
	   */
	  CalendarYearBodyCtrl.prototype.buildMonthCell = function(year, month) {
	    var calendarCtrl = this.calendarCtrl;
	    var yearCtrl = this.yearCtrl;
	    var cell = this.buildBlankCell();
	
	    // Represent this month/year as a date.
	    var firstOfMonth = new Date(year, month, 1);
	    cell.setAttribute('aria-label', this.dateLocale.monthFormatter(firstOfMonth));
	    cell.id = calendarCtrl.getDateId(firstOfMonth, 'year');
	
	    // Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
	    cell.setAttribute('data-timestamp', String(firstOfMonth.getTime()));
	
	    if (this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.today)) {
	      cell.classList.add(calendarCtrl.TODAY_CLASS);
	    }
	
	    if (this.dateUtil.isValidDate(calendarCtrl.selectedDate) &&
	        this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.selectedDate)) {
	      cell.classList.add(calendarCtrl.SELECTED_DATE_CLASS);
	      cell.setAttribute('aria-selected', 'true');
	    }
	
	    var cellText = this.dateLocale.shortMonths[month];
	
	    if (this.dateUtil.isMonthWithinRange(
	          firstOfMonth, calendarCtrl.minDate, calendarCtrl.maxDate) &&
	      (!angular.isFunction(calendarCtrl.monthFilter) ||
	        calendarCtrl.monthFilter(firstOfMonth))) {
	      var selectionIndicator = document.createElement('span');
	      selectionIndicator.classList.add('md-calendar-date-selection-indicator');
	      selectionIndicator.textContent = cellText;
	      cell.appendChild(selectionIndicator);
	      cell.addEventListener('click', yearCtrl.cellClickHandler);
	
	      if (calendarCtrl.displayDate &&
	          this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.displayDate)) {
	        this.focusAfterAppend = cell;
	      }
	    } else {
	      cell.classList.add('md-calendar-date-disabled');
	      cell.textContent = cellText;
	    }
	
	    return cell;
	  };
	
	  /**
	   * Builds a blank cell.
	   * @return {HTMLElement}
	   */
	  CalendarYearBodyCtrl.prototype.buildBlankCell = function() {
	    var cell = document.createElement('td');
	    cell.tabIndex = -1;
	    cell.classList.add('md-calendar-date');
	    cell.setAttribute('role', 'gridcell');
	
	    cell.setAttribute('tabindex', '-1');
	    return cell;
	  };
	
	  /**
	   * Builds the <tbody> content for the given year.
	   * @param {Date} date Date for which the content should be built.
	   * @returns {DocumentFragment} A document fragment containing the months within the year.
	   */
	  CalendarYearBodyCtrl.prototype.buildCalendarForYear = function(date) {
	    // Store rows for the month in a document fragment so that we can append them all at once.
	    var year = date.getFullYear();
	    var yearBody = document.createDocumentFragment();
	
	    var monthCell, i;
	    // First row contains label and Jan-Jun.
	    var firstRow = document.createElement('tr');
	    var labelCell = document.createElement('td');
	    labelCell.className = 'md-calendar-month-label';
	    labelCell.textContent = String(year);
	    firstRow.appendChild(labelCell);
	
	    for (i = 0; i < 6; i++) {
	      firstRow.appendChild(this.buildMonthCell(year, i));
	    }
	    yearBody.appendChild(firstRow);
	
	    // Second row contains a blank cell and Jul-Dec.
	    var secondRow = document.createElement('tr');
	    secondRow.appendChild(this.buildBlankCell());
	    for (i = 6; i < 12; i++) {
	      secondRow.appendChild(this.buildMonthCell(year, i));
	    }
	    yearBody.appendChild(secondRow);
	
	    return yearBody;
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc service
	   * @name $mdDateLocaleProvider
	   * @module material.components.datepicker
	   *
	   * @description
	   * The `$mdDateLocaleProvider` is the provider that creates the `$mdDateLocale` service.
	   * This provider that allows the user to specify messages, formatters, and parsers for date
	   * internationalization. The `$mdDateLocale` service itself is consumed by AngularJS Material
	   * components that deal with dates
	   * (i.e. <a ng-href="api/directive/mdDatepicker">mdDatepicker</a>).
	   *
	   * @property {Array<string>} months Array of month names (in order).
	   * @property {Array<string>} shortMonths Array of abbreviated month names.
	   * @property {Array<string>} days Array of the days of the week (in order).
	   * @property {Array<string>} shortDays Array of abbreviated days of the week.
	   * @property {Array<string>} dates Array of dates of the month. Only necessary for locales
	   *  using a numeral system other than [1, 2, 3...].
	   * @property {Array<string>} firstDayOfWeek The first day of the week. Sunday = 0, Monday = 1,
	   *  etc.
	   * @property {function(string): Date} parseDate Function that converts a date string to a Date
	   *  object (the date portion).
	   * @property {function(Date, string): string} formatDate Function to format a date object to a
	   *  string. The datepicker directive also provides the time zone, if it was specified.
	   * @property {function(Date): string} monthHeaderFormatter Function that returns the label for
	   *  a month given a date.
	   * @property {function(Date): string} monthFormatter Function that returns the full name of a month
	   *  for a given date.
	   * @property {function(number): string} weekNumberFormatter Function that returns a label for
	   *  a week given the week number.
	   * @property {function(Date): string} longDateFormatter Function that formats a date into a long
	   *  `aria-label` that is read by the screen reader when the focused date changes.
	   * @property {string} msgCalendar Translation of the label "Calendar" for the current locale.
	   * @property {string} msgOpenCalendar Translation of the button label "Open calendar" for the
	   *  current locale.
	   * @property {Date} firstRenderableDate The date from which the datepicker calendar will begin
	   *  rendering. Note that this will be ignored if a minimum date is set.
	   *  Defaults to January 1st 1880.
	   * @property {Date} lastRenderableDate The last date that will be rendered by the datepicker
	   *  calendar. Note that this will be ignored if a maximum date is set.
	   *  Defaults to January 1st 2130.
	   * @property {function(string): boolean} isDateComplete Function to determine whether a string
	   *  makes sense to be parsed to a `Date` object. Returns `true` if the date appears to be complete
	   *  and parsing should occur. By default, this checks for 3 groups of text or numbers separated
	   *  by delimiters. This means that by default, date strings must include a month, day, and year
	   *  to be parsed and for the model to be updated.
	   *
	   * @usage
	   * <hljs lang="js">
	   * myAppModule.config(function($mdDateLocaleProvider) {
	   *
	   *     // Example of a French localization.
	   *     $mdDateLocaleProvider.months = ['janvier', 'février', 'mars', ...];
	   *     $mdDateLocaleProvider.shortMonths = ['janv', 'févr', 'mars', ...];
	   *     $mdDateLocaleProvider.days = ['dimanche', 'lundi', 'mardi', ...];
	   *     $mdDateLocaleProvider.shortDays = ['Di', 'Lu', 'Ma', ...];
	   *
	   *     // Can change week display to start on Monday.
	   *     $mdDateLocaleProvider.firstDayOfWeek = 1;
	   *
	   *     // Optional.
	   *     $mdDateLocaleProvider.dates = [1, 2, 3, 4, 5, 6, ...];
	   *
	   *     // Example uses moment.js to parse and format dates.
	   *     $mdDateLocaleProvider.parseDate = function(dateString) {
	   *       var m = moment(dateString, 'L', true);
	   *       return m.isValid() ? m.toDate() : new Date(NaN);
	   *     };
	   *
	   *     $mdDateLocaleProvider.formatDate = function(date) {
	   *       var m = moment(date);
	   *       return m.isValid() ? m.format('L') : '';
	   *     };
	   *
	   *     // Allow only a day and month to be specified.
	   *     // This is required if using the 'M/D' format with moment.js.
	   *     $mdDateLocaleProvider.isDateComplete = function(dateString) {
	   *       dateString = dateString.trim();
	   *
	   *       // Look for two chunks of content (either numbers or text) separated by delimiters.
	   *       var re = /^(([a-zA-Z]{3,}|[0-9]{1,4})([ .,]+|[/-]))([a-zA-Z]{3,}|[0-9]{1,4})/;
	   *       return re.test(dateString);
	   *     };
	   *
	   *     $mdDateLocaleProvider.monthHeaderFormatter = function(date) {
	   *       return myShortMonths[date.getMonth()] + ' ' + date.getFullYear();
	   *     };
	   *
	   *     // In addition to date display, date components also need localized messages
	   *     // for aria-labels for screen-reader users.
	   *
	   *     $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
	   *       return 'Semaine ' + weekNumber;
	   *     };
	   *
	   *     $mdDateLocaleProvider.msgCalendar = 'Calendrier';
	   *     $mdDateLocaleProvider.msgOpenCalendar = 'Ouvrir le calendrier';
	   *
	   *     // You can also set when your calendar begins and ends.
	   *     $mdDateLocaleProvider.firstRenderableDate = new Date(1776, 6, 4);
	   *     $mdDateLocaleProvider.lastRenderableDate = new Date(2012, 11, 21);
	   * });
	   * </hljs>
	   *
	   */
	  angular.module('material.components.datepicker').config(["$provide", function($provide) {
	    // TODO(jelbourn): Assert provided values are correctly formatted. Need assertions.
	
	    /** @constructor */
	    function DateLocaleProvider() {
	      /** Array of full month names. E.g., ['January', 'February', ...] */
	      this.months = null;
	
	      /** Array of abbreviated month names. E.g., ['Jan', 'Feb', ...] */
	      this.shortMonths = null;
	
	      /** Array of full day of the week names. E.g., ['Monday', 'Tuesday', ...] */
	      this.days = null;
	
	      /** Array of abbreviated dat of the week names. E.g., ['M', 'T', ...] */
	      this.shortDays = null;
	
	      /** Array of dates of a month (1 - 31). Characters might be different in some locales. */
	      this.dates = null;
	
	      /** Index of the first day of the week. 0 = Sunday, 1 = Monday, etc. */
	      this.firstDayOfWeek = 0;
	
	      /**
	       * Function that converts the date portion of a Date to a string.
	       * @type {(function(Date): string)}
	       */
	      this.formatDate = null;
	
	      /**
	       * Function that converts a date string to a Date object (the date portion)
	       * @type {function(string): Date}
	       */
	      this.parseDate = null;
	
	      /**
	       * Function that formats a Date into a month header string.
	       * @type {function(Date): string}
	       */
	      this.monthHeaderFormatter = null;
	
	      /**
	       * Function that formats a week number into a label for the week.
	       * @type {function(number): string}
	       */
	      this.weekNumberFormatter = null;
	
	      /**
	       * Function that formats a date into a long aria-label that is read
	       * when the focused date changes.
	       * @type {function(Date): string}
	       */
	      this.longDateFormatter = null;
	
	      /**
	       * Function to determine whether a string makes sense to be
	       * parsed to a Date object.
	       * @type {function(string): boolean}
	       */
	      this.isDateComplete = null;
	
	      /**
	       * ARIA label for the calendar "dialog" used in the datepicker.
	       * @type {string}
	       */
	      this.msgCalendar = '';
	
	      /**
	       * ARIA label for the datepicker's "Open calendar" buttons.
	       * @type {string}
	       */
	      this.msgOpenCalendar = '';
	    }
	
	    /**
	     * Factory function that returns an instance of the dateLocale service.
	     * @ngInject
	     * @param $locale
	     * @param $filter
	     * @returns {DateLocale}
	     */
	    DateLocaleProvider.prototype.$get = function($locale, $filter) {
	      /**
	       * Default date-to-string formatting function.
	       * @param {!Date} date
	       * @param {string=} timezone
	       * @returns {string}
	       */
	      function defaultFormatDate(date, timezone) {
	        if (!date) {
	          return '';
	        }
	
	        // All of the dates created through ng-material *should* be set to midnight.
	        // If we encounter a date where the localeTime shows at 11pm instead of midnight,
	        // we have run into an issue with DST where we need to increment the hour by one:
	        // var d = new Date(1992, 9, 8, 0, 0, 0);
	        // d.toLocaleString(); // == "10/7/1992, 11:00:00 PM"
	        var localeTime = date.toLocaleTimeString();
	        var formatDate = date;
	        if (date.getHours() === 0 &&
	            (localeTime.indexOf('11:') !== -1 || localeTime.indexOf('23:') !== -1)) {
	          formatDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 1, 0, 0);
	        }
	
	        return $filter('date')(formatDate, 'M/d/yyyy', timezone);
	      }
	
	      /**
	       * Default string-to-date parsing function.
	       * @param {string|number} dateString
	       * @returns {!Date}
	       */
	      function defaultParseDate(dateString) {
	        return new Date(dateString);
	      }
	
	      /**
	       * Default function to determine whether a string makes sense to be
	       * parsed to a Date object.
	       *
	       * This is very permissive and is just a basic sanity check to ensure that
	       * things like single integers aren't able to be parsed into dates.
	       * @param {string} dateString
	       * @returns {boolean}
	       */
	      function defaultIsDateComplete(dateString) {
	        dateString = dateString.trim();
	
	        // Looks for three chunks of content (either numbers or text) separated
	        // by delimiters.
	        var re = /^(([a-zA-Z]{3,}|[0-9]{1,4})([ .,]+|[/-])){2}([a-zA-Z]{3,}|[0-9]{1,4})$/;
	        return re.test(dateString);
	      }
	
	      /**
	       * Default date-to-string formatter to get a month header.
	       * @param {!Date} date
	       * @returns {string}
	       */
	      function defaultMonthHeaderFormatter(date) {
	        return service.shortMonths[date.getMonth()] + ' ' + date.getFullYear();
	      }
	
	      /**
	       * Default formatter for a month.
	       * @param {!Date} date
	       * @returns {string}
	       */
	      function defaultMonthFormatter(date) {
	        return service.months[date.getMonth()] + ' ' + date.getFullYear();
	      }
	
	      /**
	       * Default week number formatter.
	       * @param number
	       * @returns {string}
	       */
	      function defaultWeekNumberFormatter(number) {
	        return 'Week ' + number;
	      }
	
	      /**
	       * Default formatter for date cell aria-labels.
	       * @param {!Date} date
	       * @returns {string}
	       */
	      function defaultLongDateFormatter(date) {
	        // Example: 'Thursday June 18 2015'
	        return [
	          service.days[date.getDay()],
	          service.months[date.getMonth()],
	          service.dates[date.getDate()],
	          date.getFullYear()
	        ].join(' ');
	      }
	
	      // The default "short" day strings are the first character of each day,
	      // e.g., "Monday" => "M".
	      var defaultShortDays = $locale.DATETIME_FORMATS.SHORTDAY.map(function(day) {
	        return day.substring(0, 1);
	      });
	
	      // The default dates are simply the numbers 1 through 31.
	      var defaultDates = Array(32);
	      for (var i = 1; i <= 31; i++) {
	        defaultDates[i] = i;
	      }
	
	      // Default ARIA messages are in English (US).
	      var defaultMsgCalendar = 'Calendar';
	      var defaultMsgOpenCalendar = 'Open calendar';
	
	      // Default start/end dates that are rendered in the calendar.
	      var defaultFirstRenderableDate = new Date(1880, 0, 1);
	      var defaultLastRendereableDate = new Date(defaultFirstRenderableDate.getFullYear() + 250, 0, 1);
	
	      var service = {
	        months: this.months || $locale.DATETIME_FORMATS.MONTH,
	        shortMonths: this.shortMonths || $locale.DATETIME_FORMATS.SHORTMONTH,
	        days: this.days || $locale.DATETIME_FORMATS.DAY,
	        shortDays: this.shortDays || defaultShortDays,
	        dates: this.dates || defaultDates,
	        firstDayOfWeek: this.firstDayOfWeek || 0,
	        formatDate: this.formatDate || defaultFormatDate,
	        parseDate: this.parseDate || defaultParseDate,
	        isDateComplete: this.isDateComplete || defaultIsDateComplete,
	        monthHeaderFormatter: this.monthHeaderFormatter || defaultMonthHeaderFormatter,
	        monthFormatter: this.monthFormatter || defaultMonthFormatter,
	        weekNumberFormatter: this.weekNumberFormatter || defaultWeekNumberFormatter,
	        longDateFormatter: this.longDateFormatter || defaultLongDateFormatter,
	        msgCalendar: this.msgCalendar || defaultMsgCalendar,
	        msgOpenCalendar: this.msgOpenCalendar || defaultMsgOpenCalendar,
	        firstRenderableDate: this.firstRenderableDate || defaultFirstRenderableDate,
	        lastRenderableDate: this.lastRenderableDate || defaultLastRendereableDate
	      };
	
	      return service;
	    };
	    DateLocaleProvider.prototype.$get.$inject = ["$locale", "$filter"];
	
	    $provide.provider('$mdDateLocale', new DateLocaleProvider());
	  }]);
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * Utility for performing date calculations to facilitate operation of the calendar and
	   * datepicker.
	   */
	  angular.module('material.components.datepicker').factory('$$mdDateUtil', ["$mdDateLocale", function($mdDateLocale) {
	    return {
	      getFirstDateOfMonth: getFirstDateOfMonth,
	      getNumberOfDaysInMonth: getNumberOfDaysInMonth,
	      getDateInNextMonth: getDateInNextMonth,
	      getDateInPreviousMonth: getDateInPreviousMonth,
	      isInNextMonth: isInNextMonth,
	      isInPreviousMonth: isInPreviousMonth,
	      getDateMidpoint: getDateMidpoint,
	      isSameMonthAndYear: isSameMonthAndYear,
	      getWeekOfMonth: getWeekOfMonth,
	      incrementDays: incrementDays,
	      incrementMonths: incrementMonths,
	      getLastDateOfMonth: getLastDateOfMonth,
	      isSameDay: isSameDay,
	      getMonthDistance: getMonthDistance,
	      isValidDate: isValidDate,
	      setDateTimeToMidnight: setDateTimeToMidnight,
	      createDateAtMidnight: createDateAtMidnight,
	      isDateWithinRange: isDateWithinRange,
	      incrementYears: incrementYears,
	      getYearDistance: getYearDistance,
	      clampDate: clampDate,
	      getTimestampFromNode: getTimestampFromNode,
	      isMonthWithinRange: isMonthWithinRange,
	      removeLocalTzAndReparseDate: removeLocalTzAndReparseDate
	    };
	
	    /**
	     * Gets the first day of the month for the given date's month.
	     * @param {Date} date
	     * @returns {Date}
	     */
	    function getFirstDateOfMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth(), 1);
	    }
	
	    /**
	     * Gets the number of days in the month for the given date's month.
	     * @param date
	     * @returns {number}
	     */
	    function getNumberOfDaysInMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
	    }
	
	    /**
	     * Get an arbitrary date in the month after the given date's month.
	     * @param date
	     * @returns {Date}
	     */
	    function getDateInNextMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth() + 1, 1);
	    }
	
	    /**
	     * Get an arbitrary date in the month before the given date's month.
	     * @param date
	     * @returns {Date}
	     */
	    function getDateInPreviousMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth() - 1, 1);
	    }
	
	    /**
	     * Gets whether two dates have the same month and year.
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {boolean}
	     */
	    function isSameMonthAndYear(d1, d2) {
	      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth();
	    }
	
	    /**
	     * Gets whether two dates are the same day (not not necessarily the same time).
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {boolean}
	     */
	    function isSameDay(d1, d2) {
	      return d1.getDate() == d2.getDate() && isSameMonthAndYear(d1, d2);
	    }
	
	    /**
	     * Gets whether a date is in the month immediately after some date.
	     * @param {Date} startDate The date from which to compare.
	     * @param {Date} endDate The date to check.
	     * @returns {boolean}
	     */
	    function isInNextMonth(startDate, endDate) {
	      var nextMonth = getDateInNextMonth(startDate);
	      return isSameMonthAndYear(nextMonth, endDate);
	    }
	
	    /**
	     * Gets whether a date is in the month immediately before some date.
	     * @param {Date} startDate The date from which to compare.
	     * @param {Date} endDate The date to check.
	     * @returns {boolean}
	     */
	    function isInPreviousMonth(startDate, endDate) {
	      var previousMonth = getDateInPreviousMonth(startDate);
	      return isSameMonthAndYear(endDate, previousMonth);
	    }
	
	    /**
	     * Gets the midpoint between two dates.
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {Date}
	     */
	    function getDateMidpoint(d1, d2) {
	      return createDateAtMidnight((d1.getTime() + d2.getTime()) / 2);
	    }
	
	    /**
	     * Gets the week of the month that a given date occurs in.
	     * @param {Date} date
	     * @returns {number} Index of the week of the month (zero-based).
	     */
	    function getWeekOfMonth(date) {
	      var firstDayOfMonth = getFirstDateOfMonth(date);
	      return Math.floor((firstDayOfMonth.getDay() + date.getDate() - 1) / 7);
	    }
	
	    /**
	     * Gets a new date incremented by the given number of days. Number of days can be negative.
	     * @param {Date} date
	     * @param {number} numberOfDays
	     * @returns {Date}
	     */
	    function incrementDays(date, numberOfDays) {
	      return new Date(date.getFullYear(), date.getMonth(), date.getDate() + numberOfDays);
	    }
	
	    /**
	     * Gets a new date incremented by the given number of months. Number of months can be negative.
	     * If the date of the given month does not match the target month, the date will be set to the
	     * last day of the month.
	     * @param {Date} date
	     * @param {number} numberOfMonths
	     * @returns {Date}
	     */
	    function incrementMonths(date, numberOfMonths) {
	      // If the same date in the target month does not actually exist, the Date object will
	      // automatically advance *another* month by the number of missing days.
	      // For example, if you try to go from Jan. 30 to Feb. 30, you'll end up on March 2.
	      // So, we check if the month overflowed and go to the last day of the target month instead.
	      var dateInTargetMonth = new Date(date.getFullYear(), date.getMonth() + numberOfMonths, 1);
	      var numberOfDaysInMonth = getNumberOfDaysInMonth(dateInTargetMonth);
	      if (numberOfDaysInMonth < date.getDate()) {
	        dateInTargetMonth.setDate(numberOfDaysInMonth);
	      } else {
	        dateInTargetMonth.setDate(date.getDate());
	      }
	
	      return dateInTargetMonth;
	    }
	
	    /**
	     * Get the integer distance between two months. This *only* considers the month and year
	     * portion of the Date instances.
	     *
	     * @param {Date} start
	     * @param {Date} end
	     * @returns {number} Number of months between `start` and `end`. If `end` is before `start`
	     *     chronologically, this number will be negative.
	     */
	    function getMonthDistance(start, end) {
	      return (12 * (end.getFullYear() - start.getFullYear())) + (end.getMonth() - start.getMonth());
	    }
	
	    /**
	     * Gets the last day of the month for the given date.
	     * @param {Date} date
	     * @returns {Date}
	     */
	    function getLastDateOfMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth(), getNumberOfDaysInMonth(date));
	    }
	
	    /**
	     * Checks whether a date is valid.
	     * @param {Date} date
	     * @return {boolean} Whether the date is a valid Date.
	     */
	    function isValidDate(date) {
	      return date && date.getTime && !isNaN(date.getTime());
	    }
	
	    /**
	     * Sets a date's time to midnight.
	     * @param {Date} date
	     */
	    function setDateTimeToMidnight(date) {
	      if (isValidDate(date)) {
	        date.setHours(0, 0, 0, 0);
	      }
	    }
	
	    /**
	     * Creates a date with the time set to midnight.
	     * Drop-in replacement for two forms of the Date constructor via opt_value.
	     * @param {number|Date=} opt_value Leave undefined for a Date representing now. Or use a
	     *  single value representing the number of seconds since the Unix Epoch or a Date object.
	     * @return {Date} New date with time set to midnight.
	     */
	    function createDateAtMidnight(opt_value) {
	      var date;
	      if (angular.isDate(opt_value)) {
	        date = opt_value;
	      } else if (angular.isNumber(opt_value)) {
	        date = new Date(opt_value);
	      } else {
	        date = new Date();
	      }
	      setDateTimeToMidnight(date);
	      return date;
	    }
	
	     /**
	      * Checks if a date is within a min and max range, ignoring the time component.
	      * If minDate or maxDate are not dates, they are ignored.
	      * @param {Date} date
	      * @param {Date} minDate
	      * @param {Date} maxDate
	      */
	     function isDateWithinRange(date, minDate, maxDate) {
	       var dateAtMidnight = createDateAtMidnight(date);
	       var minDateAtMidnight = isValidDate(minDate) ? createDateAtMidnight(minDate) : null;
	       var maxDateAtMidnight = isValidDate(maxDate) ? createDateAtMidnight(maxDate) : null;
	       return (!minDateAtMidnight || minDateAtMidnight <= dateAtMidnight) &&
	           (!maxDateAtMidnight || maxDateAtMidnight >= dateAtMidnight);
	     }
	
	    /**
	     * Gets a new date incremented by the given number of years. Number of years can be negative.
	     * See `incrementMonths` for notes on overflow for specific dates.
	     * @param {Date} date
	     * @param {number} numberOfYears
	     * @returns {Date}
	     */
	     function incrementYears(date, numberOfYears) {
	       return incrementMonths(date, numberOfYears * 12);
	     }
	
	     /**
	      * Get the integer distance between two years. This *only* considers the year portion of the
	      * Date instances.
	      *
	      * @param {Date} start
	      * @param {Date} end
	      * @returns {number} Number of months between `start` and `end`. If `end` is before `start`
	      *     chronologically, this number will be negative.
	      */
	     function getYearDistance(start, end) {
	       return end.getFullYear() - start.getFullYear();
	     }
	
	     /**
	      * Clamps a date between a minimum and a maximum date.
	      * @param {Date} date Date to be clamped
	      * @param {Date=} minDate Minimum date
	      * @param {Date=} maxDate Maximum date
	      * @return {Date}
	      */
	     function clampDate(date, minDate, maxDate) {
	       var boundDate = date;
	       if (minDate && date < minDate) {
	         boundDate = new Date(minDate.getTime());
	       }
	       if (maxDate && date > maxDate) {
	         boundDate = new Date(maxDate.getTime());
	       }
	       return boundDate;
	     }
	
	     /**
	      * Extracts and parses the timestamp from a DOM node.
	      * @param  {HTMLElement} node Node from which the timestamp will be extracted.
	      * @return {number} Time since epoch.
	      */
	     function getTimestampFromNode(node) {
	       if (node && node.hasAttribute('data-timestamp')) {
	         return Number(node.getAttribute('data-timestamp'));
	       }
	     }
	
	     /**
	      * Checks if a month is within a min and max range, ignoring the date and time components.
	      * If minDate or maxDate are not dates, they are ignored.
	      * @param {Date} date
	      * @param {Date} minDate
	      * @param {Date} maxDate
	      */
	     function isMonthWithinRange(date, minDate, maxDate) {
	       var month = date.getMonth();
	       var year = date.getFullYear();
	
	       return (!minDate || minDate.getFullYear() < year || minDate.getMonth() <= month) &&
	        (!maxDate || maxDate.getFullYear() > year || maxDate.getMonth() >= month);
	     }
	
	    /**
	     * @param {Date} value
	     * @return {boolean|boolean}
	     */
	    function removeLocalTzAndReparseDate(value) {
	      var dateValue, formattedDate;
	      // Remove the local timezone offset before calling formatDate.
	      dateValue = new Date(value.getTime() + 60000 * value.getTimezoneOffset());
	      formattedDate = $mdDateLocale.formatDate(dateValue);
	      // parseDate only works with a date formatted by formatDate when using Moment validation.
	      return $mdDateLocale.parseDate(formattedDate);
	    }
	  }]);
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  // TODO(jelbourn): forward more attributes to the internal input (required, autofocus, etc.)
	  // TODO(jelbourn): something better for mobile (calendar panel takes up entire screen?)
	  // TODO(jelbourn): input behavior (masking? auto-complete?)
	
	  DatePickerCtrl.$inject = ["$scope", "$element", "$attrs", "$window", "$mdConstant", "$mdTheming", "$mdUtil", "$mdDateLocale", "$$mdDateUtil", "$$rAF", "$filter", "$timeout"];
	  datePickerDirective.$inject = ["$$mdSvgRegistry", "$mdUtil", "$mdAria", "inputDirective"];
	  angular.module('material.components.datepicker')
	      .directive('mdDatepicker', datePickerDirective);
	
	  /**
	   * @ngdoc directive
	   * @name mdDatepicker
	   * @module material.components.datepicker
	   *
	   * @param {Date} ng-model The component's model. Expects either a JavaScript Date object or a
	   *  value that can be parsed into one (e.g. a ISO 8601 string).
	   * @param {Object=} ng-model-options Allows tuning of the way in which `ng-model` is being
	   *  updated. Also allows for a timezone to be specified.
	   *  <a href="https://docs.angularjs.org/api/ng/directive/ngModelOptions#usage">
	   *    Read more at the ngModelOptions docs.</a>
	   * @param {expression=} ng-change Expression evaluated when the model value changes.
	   * @param {expression=} ng-focus Expression evaluated when the input is focused or the calendar
	   *  is opened.
	   * @param {expression=} ng-blur Expression evaluated when focus is removed from the input or the
	   *  calendar is closed.
	   * @param {boolean=} ng-disabled Whether the datepicker is disabled.
	   * @param {boolean=} ng-required Whether a value is required for the datepicker.
	   * @param {Date=} md-min-date Expression representing a min date (inclusive).
	   * @param {Date=} md-max-date Expression representing a max date (inclusive).
	   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a
	   *  boolean whether it can be selected in "day" mode or not. Returning false will also trigger a
	   *  `filtered` model validation error.
	   * @param {(function(Date): boolean)=} md-month-filter Function expecting a date and returning a
	   *  boolean whether it can be selected in "month" mode or not. Returning false will also trigger a
	   *  `filtered` model validation error.
	   * @param {String=} md-placeholder The date input placeholder value.
	   * @param {String=} md-open-on-focus When present, the calendar will be opened when the input
	   *  is focused.
	   * @param {Boolean=} md-is-open Expression that can be used to open the datepicker's calendar
	   *  on-demand.
	   * @param {String=} md-current-view Default open view of the calendar pane. Can be either
	   *  "month" or "year".
	   * @param {String=} md-mode Restricts the user to only selecting a value from a particular view.
	   *  This option can be used if the user is only supposed to choose from a certain date type
	   *  (e.g. only selecting the month).
	   * Can be either "month" or "day". **Note** that this will overwrite the `md-current-view` value.
	   *
	   * @param {String=} md-hide-icons Determines which datepicker icons should be hidden. Note that
	   *  this may cause the datepicker to not align properly with other components.
	   *  **Use at your own risk.** Possible values are:
	   * * `"all"` - Hides all icons.
	   * * `"calendar"` - Only hides the calendar icon.
	   * * `"triangle"` - Only hides the triangle icon.
	   * @param {Object=} md-date-locale Allows for the values from the `$mdDateLocaleProvider` to be
	   * overwritten on a per-element basis (e.g. `msgOpenCalendar` can be overwritten with
	   * `md-date-locale="{ msgOpenCalendar: 'Open a special calendar' }"`).
	   *
	   * @description
	   * `<md-datepicker>` is a component used to select a single date.
	   * For information on how to configure internationalization for the date picker,
	   * see <a ng-href="api/service/$mdDateLocaleProvider">$mdDateLocaleProvider</a>.
	   *
	   * This component supports
	   * [ngMessages](https://docs.angularjs.org/api/ngMessages/directive/ngMessages).
	   * Supported attributes are:
	   * * `required`: whether a required date is not set.
	   * * `mindate`: whether the selected date is before the minimum allowed date.
	   * * `maxdate`: whether the selected date is after the maximum allowed date.
	   * * `debounceInterval`: ms to delay input processing (since last debounce reset);
	   *    default value 500ms
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <md-datepicker ng-model="birthday"></md-datepicker>
	   * </hljs>
	   *
	   */
	
	  function datePickerDirective($$mdSvgRegistry, $mdUtil, $mdAria, inputDirective) {
	    return {
	      template: function(tElement, tAttrs) {
	        // Buttons are not in the tab order because users can open the calendar via keyboard
	        // interaction on the text input, and multiple tab stops for one component (picker)
	        // may be confusing.
	        var hiddenIcons = tAttrs.mdHideIcons;
	        var ariaLabelValue = tAttrs.ariaLabel || tAttrs.mdPlaceholder;
	        var ngModelOptions = tAttrs.ngModelOptions;
	
	        var calendarButton = (hiddenIcons === 'all' || hiddenIcons === 'calendar') ? '' :
	          '<md-button class="md-datepicker-button md-icon-button" type="button" ' +
	              'tabindex="-1" aria-hidden="true" ' +
	              'ng-click="ctrl.openCalendarPane($event)">' +
	            '<md-icon class="md-datepicker-calendar-icon" aria-label="md-calendar" ' +
	                     'md-svg-src="' + $$mdSvgRegistry.mdCalendar + '"></md-icon>' +
	          '</md-button>';
	
	        var triangleButton = '';
	
	        if (hiddenIcons !== 'all' && hiddenIcons !== 'triangle') {
	          triangleButton = '' +
	            '<md-button type="button" md-no-ink ' +
	              'class="md-datepicker-triangle-button md-icon-button" ' +
	              'ng-click="ctrl.openCalendarPane($event)" ' +
	              'aria-label="{{::ctrl.locale.msgOpenCalendar}}">' +
	            '<div class="md-datepicker-expand-triangle"></div>' +
	          '</md-button>';
	
	          tElement.addClass(HAS_TRIANGLE_ICON_CLASS);
	        }
	
	        return calendarButton +
	        '<div class="md-datepicker-input-container" ng-class="{\'md-datepicker-focused\': ctrl.isFocused}">' +
	          '<input ' +
	            (ariaLabelValue ? 'aria-label="' + ariaLabelValue + '" ' : '') +
	            'class="md-datepicker-input" ' +
	            'aria-haspopup="dialog" ' +
	            'ng-focus="ctrl.setFocused(true)" ' +
	            'ng-blur="ctrl.setFocused(false)"> ' +
	            triangleButton +
	        '</div>' +
	
	        // This pane will be detached from here and re-attached to the document body.
	        '<div class="md-datepicker-calendar-pane md-whiteframe-z1" id="{{::ctrl.calendarPaneId}}">' +
	          '<div class="md-datepicker-input-mask">' +
	            '<div class="md-datepicker-input-mask-opaque"></div>' +
	          '</div>' +
	          '<div class="md-datepicker-calendar">' +
	            '<md-calendar role="dialog" aria-label="{{::ctrl.locale.msgCalendar}}" ' +
	                'md-current-view="{{::ctrl.currentView}}" ' +
	                'md-mode="{{::ctrl.mode}}" ' +
	                'md-min-date="ctrl.minDate" ' +
	                'md-max-date="ctrl.maxDate" ' +
	                'md-date-filter="ctrl.dateFilter" ' +
	                'md-month-filter="ctrl.monthFilter" ' +
	                (ngModelOptions ? 'ng-model-options="' + ngModelOptions + '" ' : '') +
	                'ng-model="ctrl.date" ng-if="ctrl.isCalendarOpen">' +
	            '</md-calendar>' +
	          '</div>' +
	        '</div>';
	      },
	      require: ['ngModel', 'mdDatepicker', '?^mdInputContainer', '?^form'],
	      scope: {
	        minDate: '=mdMinDate',
	        maxDate: '=mdMaxDate',
	        placeholder: '@mdPlaceholder',
	        currentView: '@mdCurrentView',
	        mode: '@mdMode',
	        dateFilter: '=mdDateFilter',
	        monthFilter: '=mdMonthFilter',
	        isOpen: '=?mdIsOpen',
	        debounceInterval: '=mdDebounceInterval',
	        dateLocale: '=mdDateLocale'
	      },
	      controller: DatePickerCtrl,
	      controllerAs: 'ctrl',
	      bindToController: true,
	      link: function(scope, element, attr, controllers) {
	        var ngModelCtrl = controllers[0];
	        var mdDatePickerCtrl = controllers[1];
	        var mdInputContainer = controllers[2];
	        var parentForm = controllers[3];
	        var mdNoAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);
	
	        mdDatePickerCtrl.configureNgModel(ngModelCtrl, mdInputContainer, inputDirective);
	
	        if (mdInputContainer) {
	          // We need to move the spacer after the datepicker itself,
	          // because md-input-container adds it after the
	          // md-datepicker-input by default. The spacer gets wrapped in a
	          // div, because it floats and gets aligned next to the datepicker.
	          // There are easier ways of working around this with CSS (making the
	          // datepicker 100% wide, change the `display` etc.), however they
	          // break the alignment with any other form controls.
	          var spacer = element[0].querySelector('.md-errors-spacer');
	
	          if (spacer) {
	            element.after(angular.element('<div>').append(spacer));
	          }
	
	          mdInputContainer.setHasPlaceholder(attr.mdPlaceholder);
	          mdInputContainer.input = element;
	          mdInputContainer.element
	            .addClass(INPUT_CONTAINER_CLASS)
	            .toggleClass(HAS_CALENDAR_ICON_CLASS,
	              attr.mdHideIcons !== 'calendar' && attr.mdHideIcons !== 'all');
	
	          if (!mdInputContainer.label) {
	            $mdAria.expect(element, 'aria-label', attr.mdPlaceholder);
	          } else if (!mdNoAsterisk) {
	            attr.$observe('required', function(value) {
	              mdInputContainer.label.toggleClass('md-required', !!value);
	            });
	          }
	
	          scope.$watch(mdInputContainer.isErrorGetter || function() {
	            return ngModelCtrl.$invalid && (ngModelCtrl.$touched ||
	              (parentForm && parentForm.$submitted));
	          }, mdInputContainer.setInvalid);
	        } else if (parentForm) {
	          // If invalid, highlights the input when the parent form is submitted.
	          var parentSubmittedWatcher = scope.$watch(function() {
	            return parentForm.$submitted;
	          }, function(isSubmitted) {
	            if (isSubmitted) {
	              mdDatePickerCtrl.updateErrorState();
	              parentSubmittedWatcher();
	            }
	          });
	        }
	      }
	    };
	  }
	
	  /** Additional offset for the input's `size` attribute, which is updated based on its content. */
	  var EXTRA_INPUT_SIZE = 3;
	
	  /** Class applied to the container if the date is invalid. */
	  var INVALID_CLASS = 'md-datepicker-invalid';
	
	  /** Class applied to the datepicker when it's open. */
	  var OPEN_CLASS = 'md-datepicker-open';
	
	  /** Class applied to the md-input-container, if a datepicker is placed inside it */
	  var INPUT_CONTAINER_CLASS = '_md-datepicker-floating-label';
	
	  /** Class to be applied when the calendar icon is enabled. */
	  var HAS_CALENDAR_ICON_CLASS = '_md-datepicker-has-calendar-icon';
	
	  /** Class to be applied when the triangle icon is enabled. */
	  var HAS_TRIANGLE_ICON_CLASS = '_md-datepicker-has-triangle-icon';
	
	  /** Default time in ms to debounce input event by. */
	  var DEFAULT_DEBOUNCE_INTERVAL = 500;
	
	  /**
	   * Height of the calendar pane used to check if the pane is going outside the boundary of
	   * the viewport. See calendar.scss for how $md-calendar-height is computed; an extra 20px is
	   * also added to space the pane away from the exact edge of the screen.
	   *
	   *  This is computed statically now, but can be changed to be measured if the circumstances
	   *  of calendar sizing are changed.
	   */
	  var CALENDAR_PANE_HEIGHT = 368;
	
	  /**
	   * Width of the calendar pane used to check if the pane is going outside the boundary of
	   * the viewport. See calendar.scss for how $md-calendar-width is computed; an extra 20px is
	   * also added to space the pane away from the exact edge of the screen.
	   *
	   *  This is computed statically now, but can be changed to be measured if the circumstances
	   *  of calendar sizing are changed.
	   */
	  var CALENDAR_PANE_WIDTH = 360;
	
	  /** Used for checking whether the current user agent is on iOS or Android. */
	  var IS_MOBILE_REGEX = /ipad|iphone|ipod|android/i;
	
	  /**
	   * Controller for md-datepicker.
	   *
	   * @ngInject @constructor
	   */
	  function DatePickerCtrl($scope, $element, $attrs, $window, $mdConstant, $mdTheming, $mdUtil,
	                          $mdDateLocale, $$mdDateUtil, $$rAF, $filter, $timeout) {
	
	    /** @final */
	    this.$window = $window;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.$mdConstant = $mdConstant;
	
	    /** @final */
	    this.$mdUtil = $mdUtil;
	
	    /** @final */
	    this.$$rAF = $$rAF;
	
	    /** @final */
	    this.$mdDateLocale = $mdDateLocale;
	
	    /** @final */
	    this.$timeout = $timeout;
	
	    /**
	     * The root document element. This is used for attaching a top-level click handler to
	     * close the calendar panel when a click outside said panel occurs. We use `documentElement`
	     * instead of body because, when scrolling is disabled, some browsers consider the body element
	     * to be completely off the screen and propagate events directly to the html element.
	     * @type {!JQLite}
	     */
	    this.documentElement = angular.element(document.documentElement);
	
	    /** @type {!ngModel.NgModelController} */
	    this.ngModelCtrl = null;
	
	    /** @type {HTMLInputElement} */
	    this.inputElement = $element[0].querySelector('input');
	
	    /**
	     * @final
	     * @type {!JQLite}
	     */
	    this.ngInputElement = angular.element(this.inputElement);
	
	    /** @type {HTMLElement} */
	    this.inputContainer = $element[0].querySelector('.md-datepicker-input-container');
	
	    /** @type {HTMLElement} Floating calendar pane. */
	    this.calendarPane = $element[0].querySelector('.md-datepicker-calendar-pane');
	
	    /** @type {HTMLElement} Calendar icon button. */
	    this.calendarButton = $element[0].querySelector('.md-datepicker-button');
	
	    /**
	     * Element covering everything but the input in the top of the floating calendar pane.
	     * @type {!JQLite}
	     */
	    this.inputMask = angular.element($element[0].querySelector('.md-datepicker-input-mask-opaque'));
	
	    /**
	     * @final
	     * @type {!JQLite}
	     */
	    this.$element = $element;
	
	    /**
	     * @final
	     * @type {!angular.Attributes}
	     */
	    this.$attrs = $attrs;
	
	    /**
	     * @final
	     * @type {!angular.Scope}
	     */
	    this.$scope = $scope;
	
	    /** @type {Date} */
	    this.date = null;
	
	    /** @type {boolean} */
	    this.isFocused = false;
	
	    /** @type {boolean} */
	    this.isDisabled = undefined;
	    this.setDisabled($element[0].disabled || angular.isString($attrs.disabled));
	
	    /** @type {boolean} Whether the date-picker's calendar pane is open. */
	    this.isCalendarOpen = false;
	
	    /** @type {boolean} Whether the calendar should open when the input is focused. */
	    this.openOnFocus = $attrs.hasOwnProperty('mdOpenOnFocus');
	
	    /** @type {Object} Instance of the mdInputContainer controller */
	    this.mdInputContainer = null;
	
	    /**
	     * Element from which the calendar pane was opened. Keep track of this so that we can return
	     * focus to it when the pane is closed.
	     * @type {HTMLElement}
	     */
	    this.calendarPaneOpenedFrom = null;
	
	    /** @type {String} Unique id for the calendar pane. */
	    this.calendarPaneId = 'md-date-pane-' + $mdUtil.nextUid();
	
	    /** Pre-bound click handler is saved so that the event listener can be removed. */
	    this.bodyClickHandler = angular.bind(this, this.handleBodyClick);
	
	    /**
	     * Name of the event that will trigger a close. Necessary to sniff the browser, because
	     * the resize event doesn't make sense on mobile and can have a negative impact since it
	     * triggers whenever the browser zooms in on a focused input.
	     */
	    this.windowEventName = IS_MOBILE_REGEX.test(
	      navigator.userAgent || navigator.vendor || window.opera
	    ) ? 'orientationchange' : 'resize';
	
	    /** Pre-bound close handler so that the event listener can be removed. */
	    this.windowEventHandler = $mdUtil.debounce(angular.bind(this, this.closeCalendarPane), 100);
	
	    /** Pre-bound handler for the window blur event. Allows for it to be removed later. */
	    this.windowBlurHandler = angular.bind(this, this.handleWindowBlur);
	
	    /** The built-in AngularJS date filter. */
	    this.ngDateFilter = $filter('date');
	
	    /** @type {Number} Extra margin for the left side of the floating calendar pane. */
	    this.leftMargin = 20;
	
	    /** @type {Number} Extra margin for the top of the floating calendar. Gets determined on the first open. */
	    this.topMargin = null;
	
	    // Unless the user specifies so, the datepicker should not be a tab stop.
	    // This is necessary because ngAria might add a tabindex to anything with an ng-model
	    // (based on whether or not the user has turned that particular feature on/off).
	    if ($attrs.tabindex) {
	      this.ngInputElement.attr('tabindex', $attrs.tabindex);
	      $attrs.$set('tabindex', null);
	    } else {
	      $attrs.$set('tabindex', '-1');
	    }
	
	    $attrs.$set('aria-owns', this.calendarPaneId);
	
	    $mdTheming($element);
	    $mdTheming(angular.element(this.calendarPane));
	
	    var self = this;
	
	    $scope.$on('$destroy', function() {
	      self.detachCalendarPane();
	    });
	
	    if ($attrs.mdIsOpen) {
	      $scope.$watch('ctrl.isOpen', function(shouldBeOpen) {
	        if (shouldBeOpen) {
	          self.openCalendarPane({
	            target: self.inputElement
	          });
	        } else {
	          self.closeCalendarPane();
	        }
	      });
	    }
	
	    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are
	    // pre-assigned, manually call the $onInit hook.
	    if (angular.version.major === 1 && angular.version.minor <= 4) {
	      this.$onInit();
	    }
	  }
	
	  /**
	   * AngularJS Lifecycle hook for newer AngularJS versions.
	   * Bindings are not guaranteed to have been assigned in the controller, but they are in the
	   * $onInit hook.
	   */
	  DatePickerCtrl.prototype.$onInit = function() {
	
	    /**
	     * Holds locale-specific formatters, parsers, labels etc. Allows
	     * the user to override specific ones from the $mdDateLocale provider.
	     * @type {!Object}
	     */
	    this.locale = this.dateLocale ? angular.extend({}, this.$mdDateLocale, this.dateLocale)
	      : this.$mdDateLocale;
	
	    this.installPropertyInterceptors();
	    this.attachChangeListeners();
	    this.attachInteractionListeners();
	  };
	
	  /**
	   * Sets up the controller's reference to ngModelController and
	   * applies AngularJS's `input[type="date"]` directive.
	   * @param {!angular.NgModelController} ngModelCtrl Instance of the ngModel controller.
	   * @param {Object} mdInputContainer Instance of the mdInputContainer controller.
	   * @param {Object} inputDirective Config for AngularJS's `input` directive.
	   */
	  DatePickerCtrl.prototype.configureNgModel = function(ngModelCtrl, mdInputContainer, inputDirective) {
	    this.ngModelCtrl = ngModelCtrl;
	    this.mdInputContainer = mdInputContainer;
	
	    // The input needs to be [type="date"] in order to be picked up by AngularJS.
	    this.$attrs.$set('type', 'date');
	
	    // Invoke the `input` directive link function, adding a stub for the element.
	    // This allows us to re-use AngularJS's logic for setting the timezone via ng-model-options.
	    // It works by calling the link function directly which then adds the proper `$parsers` and
	    // `$formatters` to the ngModel controller.
	    inputDirective[0].link.pre(this.$scope, {
	      on: angular.noop,
	      val: angular.noop,
	      0: {}
	    }, this.$attrs, [ngModelCtrl]);
	
	    var self = this;
	
	    // Responds to external changes to the model value.
	    self.ngModelCtrl.$formatters.push(function(value) {
	      var parsedValue = angular.isDefined(value) ? value : null;
	
	      if (!(value instanceof Date)) {
	        parsedValue = Date.parse(value);
	
	        // `parsedValue` is the time since epoch if valid or `NaN` if invalid.
	        if (!isNaN(parsedValue) && angular.isNumber(parsedValue)) {
	          value = new Date(parsedValue);
	        }
	
	        if (value && !(value instanceof Date)) {
	          throw Error(
	            'The ng-model for md-datepicker must be a Date instance or a value ' +
	              'that can be parsed into a date. Currently the model is of type: ' + typeof value
	          );
	        }
	      }
	
	      self.onExternalChange(value);
	
	      return value;
	    });
	
	    // Responds to external error state changes (e.g. ng-required based on another input).
	    ngModelCtrl.$viewChangeListeners.unshift(angular.bind(this, this.updateErrorState));
	
	    // Forwards any events from the input to the root element. This is necessary to get `updateOn`
	    // working for events that don't bubble (e.g. 'blur') since AngularJS binds the handlers to
	    // the `<md-datepicker>`.
	    var updateOn = self.$mdUtil.getModelOption(ngModelCtrl, 'updateOn');
	
	    if (updateOn) {
	      this.ngInputElement.on(
	        updateOn,
	        angular.bind(this.$element, this.$element.triggerHandler, updateOn)
	      );
	    }
	  };
	
	  /**
	   * Attach event listeners for both the text input and the md-calendar.
	   * Events are used instead of ng-model so that updates don't infinitely update the other
	   * on a change. This should also be more performant than using a $watch.
	   */
	  DatePickerCtrl.prototype.attachChangeListeners = function() {
	    var self = this;
	
	    self.$scope.$on('md-calendar-change', function(event, date) {
	      self.setModelValue(date);
	      self.onExternalChange(date);
	      self.closeCalendarPane();
	    });
	
	    self.ngInputElement.on('input', angular.bind(self, self.resizeInputElement));
	
	    var debounceInterval = angular.isDefined(this.debounceInterval) ?
	        this.debounceInterval : DEFAULT_DEBOUNCE_INTERVAL;
	    self.ngInputElement.on('input', self.$mdUtil.debounce(self.handleInputEvent,
	        debounceInterval, self));
	  };
	
	  /** Attach event listeners for user interaction. */
	  DatePickerCtrl.prototype.attachInteractionListeners = function() {
	    var self = this;
	    var $scope = this.$scope;
	    var keyCodes = this.$mdConstant.KEY_CODE;
	
	    // Add event listener through angular so that we can triggerHandler in unit tests.
	    self.ngInputElement.on('keydown', function(event) {
	      if (event.altKey && event.keyCode === keyCodes.DOWN_ARROW) {
	        self.openCalendarPane(event);
	        $scope.$digest();
	      }
	    });
	
	    if (self.openOnFocus) {
	      self.ngInputElement.on('focus', angular.bind(self, self.openCalendarPane));
	      self.ngInputElement.on('click', function(event) {
	        event.stopPropagation();
	      });
	      self.ngInputElement.on('pointerdown',function(event) {
	        if (event.target && event.target.setPointerCapture) {
	          event.target.setPointerCapture(event.pointerId);
	        }
	      });
	
	      angular.element(self.$window).on('blur', self.windowBlurHandler);
	
	      $scope.$on('$destroy', function() {
	        angular.element(self.$window).off('blur', self.windowBlurHandler);
	      });
	    }
	
	    $scope.$on('md-calendar-close', function() {
	      self.closeCalendarPane();
	    });
	  };
	
	  /**
	   * Capture properties set to the date-picker and imperatively handle internal changes.
	   * This is done to avoid setting up additional $watches.
	   */
	  DatePickerCtrl.prototype.installPropertyInterceptors = function() {
	    var self = this;
	
	    if (this.$attrs.ngDisabled) {
	      // The expression is to be evaluated against the directive element's scope and not
	      // the directive's isolate scope.
	      var scope = this.$scope.$parent;
	
	      if (scope) {
	        scope.$watch(this.$attrs.ngDisabled, function(isDisabled) {
	          self.setDisabled(isDisabled);
	        });
	      }
	    }
	
	    Object.defineProperty(this, 'placeholder', {
	      get: function() { return self.inputElement.placeholder; },
	      set: function(value) { self.inputElement.placeholder = value || ''; }
	    });
	  };
	
	  /**
	   * Sets whether the date-picker is disabled.
	   * @param {boolean} isDisabled
	   */
	  DatePickerCtrl.prototype.setDisabled = function(isDisabled) {
	    this.isDisabled = isDisabled;
	    this.inputElement.disabled = isDisabled;
	
	    if (this.calendarButton) {
	      this.calendarButton.disabled = isDisabled;
	    }
	  };
	
	  /**
	   * Sets the custom ngModel.$error flags to be consumed by ngMessages. Flags are:
	   *   - mindate: whether the selected date is before the minimum date.
	   *   - maxdate: whether the selected flag is after the maximum date.
	   *   - filtered: whether the selected date is allowed by the custom filtering function.
	   *   - valid: whether the entered text input is a valid date
	   *
	   * The 'required' flag is handled automatically by ngModel.
	   *
	   * @param {Date=} opt_date Date to check. If not given, defaults to the datepicker's model value.
	   */
	  DatePickerCtrl.prototype.updateErrorState = function(opt_date) {
	    var date = opt_date || this.date;
	
	    // Clear any existing errors to get rid of anything that's no longer relevant.
	    this.clearErrorState();
	
	    if (this.dateUtil.isValidDate(date)) {
	      // Force all dates to midnight in order to ignore the time portion.
	      date = this.dateUtil.createDateAtMidnight(date);
	
	      if (this.dateUtil.isValidDate(this.minDate)) {
	        var minDate = this.dateUtil.createDateAtMidnight(this.minDate);
	        this.ngModelCtrl.$setValidity('mindate', date >= minDate);
	      }
	
	      if (this.dateUtil.isValidDate(this.maxDate)) {
	        var maxDate = this.dateUtil.createDateAtMidnight(this.maxDate);
	        this.ngModelCtrl.$setValidity('maxdate', date <= maxDate);
	      }
	
	      if (angular.isFunction(this.dateFilter)) {
	        this.ngModelCtrl.$setValidity('filtered', this.dateFilter(date));
	      }
	
	      if (angular.isFunction(this.monthFilter)) {
	        this.ngModelCtrl.$setValidity('filtered', this.monthFilter(date));
	      }
	    } else {
	      // The date is seen as "not a valid date" if there is *something* set
	      // (i.e.., not null or undefined), but that something isn't a valid date.
	      this.ngModelCtrl.$setValidity('valid', date == null);
	    }
	
	    var input = this.inputElement.value;
	    var parsedDate = this.locale.parseDate(input);
	
	    if (!this.isInputValid(input, parsedDate) && this.ngModelCtrl.$valid) {
	      this.ngModelCtrl.$setValidity('valid', date == null);
	    }
	
	    angular.element(this.inputContainer).toggleClass(INVALID_CLASS,
	      this.ngModelCtrl.$invalid && (this.ngModelCtrl.$touched || this.ngModelCtrl.$submitted));
	  };
	
	  /**
	   * Check to see if the input is valid, as the validation should fail if the model is invalid.
	   *
	   * @param {string} inputString
	   * @param {Date} parsedDate
	   * @return {boolean} Whether the input is valid
	   */
	  DatePickerCtrl.prototype.isInputValid = function (inputString, parsedDate) {
	    return inputString === '' || (
	      this.dateUtil.isValidDate(parsedDate) &&
	      this.locale.isDateComplete(inputString) &&
	      this.isDateEnabled(parsedDate)
	    );
	  };
	
	  /** Clears any error flags set by `updateErrorState`. */
	  DatePickerCtrl.prototype.clearErrorState = function() {
	    this.inputContainer.classList.remove(INVALID_CLASS);
	    ['mindate', 'maxdate', 'filtered', 'valid'].forEach(function(field) {
	      this.ngModelCtrl.$setValidity(field, true);
	    }, this);
	  };
	
	  /** Resizes the input element based on the size of its content. */
	  DatePickerCtrl.prototype.resizeInputElement = function() {
	    this.inputElement.size = this.inputElement.value.length + EXTRA_INPUT_SIZE;
	  };
	
	  /**
	   * Sets the model value if the user input is a valid date.
	   * Adds an invalid class to the input element if not.
	   */
	  DatePickerCtrl.prototype.handleInputEvent = function() {
	    var inputString = this.inputElement.value;
	    var parsedDate = inputString ? this.locale.parseDate(inputString) : null;
	    this.dateUtil.setDateTimeToMidnight(parsedDate);
	
	    // An input string is valid if it is either empty (representing no date)
	    // or if it parses to a valid date that the user is allowed to select.
	    var isValidInput = this.isInputValid(inputString, parsedDate);
	
	    // The datepicker's model is only updated when there is a valid input.
	    if (isValidInput) {
	      this.setModelValue(parsedDate);
	      this.date = parsedDate;
	    }
	
	    this.updateErrorState(parsedDate);
	  };
	
	  /**
	   * Check whether date is in range and enabled
	   * @param {Date=} opt_date
	   * @return {boolean} Whether the date is enabled.
	   */
	  DatePickerCtrl.prototype.isDateEnabled = function(opt_date) {
	    return this.dateUtil.isDateWithinRange(opt_date, this.minDate, this.maxDate) &&
	          (!angular.isFunction(this.dateFilter) || this.dateFilter(opt_date)) &&
	          (!angular.isFunction(this.monthFilter) || this.monthFilter(opt_date));
	  };
	
	  /** Position and attach the floating calendar to the document. */
	  DatePickerCtrl.prototype.attachCalendarPane = function() {
	    var calendarPane = this.calendarPane;
	    var body = document.body;
	
	    calendarPane.style.transform = '';
	    this.$element.addClass(OPEN_CLASS);
	    this.mdInputContainer && this.mdInputContainer.element.addClass(OPEN_CLASS);
	    angular.element(body).addClass('md-datepicker-is-showing');
	
	    var elementRect = this.inputContainer.getBoundingClientRect();
	    var bodyRect = body.getBoundingClientRect();
	
	    if (!this.topMargin || this.topMargin < 0) {
	      this.topMargin =
	        (this.inputMask.parent().prop('clientHeight')
	          - this.ngInputElement.prop('clientHeight')) / 2;
	    }
	
	    // Check to see if the calendar pane would go off the screen. If so, adjust position
	    // accordingly to keep it within the viewport.
	    var paneTop = elementRect.top - bodyRect.top - this.topMargin;
	    var paneLeft = elementRect.left - bodyRect.left - this.leftMargin;
	
	    // If ng-material has disabled body scrolling (for example, if a dialog is open),
	    // then it's possible that the already-scrolled body has a negative top/left. In this case,
	    // we want to treat the "real" top as (0 - bodyRect.top). In a normal scrolling situation,
	    // though, the top of the viewport should just be the body's scroll position.
	    var viewportTop = (bodyRect.top < 0 && document.body.scrollTop === 0) ?
	        -bodyRect.top :
	        document.body.scrollTop;
	
	    var viewportLeft = (bodyRect.left < 0 && document.body.scrollLeft === 0) ?
	        -bodyRect.left :
	        document.body.scrollLeft;
	
	    var viewportBottom = viewportTop + this.$window.innerHeight;
	    var viewportRight = viewportLeft + this.$window.innerWidth;
	
	    // Creates an overlay with a hole the same size as element. We remove a pixel or two
	    // on each end to make it overlap slightly. The overlay's background is added in
	    // the theme in the form of a box-shadow with a huge spread.
	    this.inputMask.css({
	      position: 'absolute',
	      left: this.leftMargin + 'px',
	      top: this.topMargin + 'px',
	      width: (elementRect.width - 1) + 'px',
	      height: (elementRect.height - 2) + 'px'
	    });
	
	    // If the right edge of the pane would be off the screen and shifting it left by the
	    // difference would not go past the left edge of the screen. If the calendar pane is too
	    // big to fit on the screen at all, move it to the left of the screen and scale the entire
	    // element down to fit.
	    if (paneLeft + CALENDAR_PANE_WIDTH > viewportRight) {
	      if (viewportRight - CALENDAR_PANE_WIDTH > 0) {
	        paneLeft = viewportRight - CALENDAR_PANE_WIDTH;
	      } else {
	        paneLeft = viewportLeft;
	        var scale = this.$window.innerWidth / CALENDAR_PANE_WIDTH;
	        calendarPane.style.transform = 'scale(' + scale + ')';
	      }
	
	      calendarPane.classList.add('md-datepicker-pos-adjusted');
	    }
	
	    // If the bottom edge of the pane would be off the screen and shifting it up by the
	    // difference would not go past the top edge of the screen.
	    if (paneTop + CALENDAR_PANE_HEIGHT > viewportBottom &&
	        viewportBottom - CALENDAR_PANE_HEIGHT > viewportTop) {
	      paneTop = viewportBottom - CALENDAR_PANE_HEIGHT;
	      calendarPane.classList.add('md-datepicker-pos-adjusted');
	    }
	
	    calendarPane.style.left = paneLeft + 'px';
	    calendarPane.style.top = paneTop + 'px';
	    document.body.appendChild(calendarPane);
	
	    // Add CSS class after one frame to trigger open animation.
	    this.$$rAF(function() {
	      calendarPane.classList.add('md-pane-open');
	    });
	  };
	
	  /** Detach the floating calendar pane from the document. */
	  DatePickerCtrl.prototype.detachCalendarPane = function() {
	    this.$element.removeClass(OPEN_CLASS);
	    this.mdInputContainer && this.mdInputContainer.element.removeClass(OPEN_CLASS);
	    angular.element(document.body).removeClass('md-datepicker-is-showing');
	    this.calendarPane.classList.remove('md-pane-open');
	    this.calendarPane.classList.remove('md-datepicker-pos-adjusted');
	
	    if (this.isCalendarOpen) {
	      this.$mdUtil.enableScrolling();
	    }
	
	    if (this.calendarPane.parentNode) {
	      // Use native DOM removal because we do not want any of the
	      // angular state of this element to be disposed.
	      this.calendarPane.parentNode.removeChild(this.calendarPane);
	    }
	  };
	
	  /**
	   * Open the floating calendar pane.
	   * @param {Event} event
	   */
	  DatePickerCtrl.prototype.openCalendarPane = function(event) {
	    if (!this.isCalendarOpen && !this.isDisabled && !this.inputFocusedOnWindowBlur) {
	      this.isCalendarOpen = this.isOpen = true;
	      this.calendarPaneOpenedFrom = event.target;
	
	      // Because the calendar pane is attached directly to the body, it is possible that the
	      // rest of the component (input, etc) is in a different scrolling container, such as
	      // an md-content. This means that, if the container is scrolled, the pane would remain
	      // stationary. To remedy this, we disable scrolling while the calendar pane is open, which
	      // also matches the native behavior for things like `<select>` on Mac and Windows.
	      this.$mdUtil.disableScrollAround(this.calendarPane);
	
	      this.attachCalendarPane();
	      this.focusCalendar();
	      this.evalAttr('ngFocus');
	
	      // Attach click listener inside of a timeout because, if this open call was triggered by a
	      // click, we don't want it to be immediately propagated up to the body and handled.
	      var self = this;
	      this.$mdUtil.nextTick(function() {
	        // Use 'touchstart` in addition to click in order to work on iOS Safari, where click
	        // events aren't propagated under most circumstances.
	        // See http://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
	        self.documentElement.on('click touchstart', self.bodyClickHandler);
	      }, false);
	
	      window.addEventListener(this.windowEventName, this.windowEventHandler);
	    } else if (this.inputFocusedOnWindowBlur) {
	      this.resetInputFocused();
	    }
	  };
	
	  /** Close the floating calendar pane. */
	  DatePickerCtrl.prototype.closeCalendarPane = function() {
	    if (this.isCalendarOpen) {
	      var self = this;
	
	      self.detachCalendarPane();
	      self.ngModelCtrl.$setTouched();
	      self.evalAttr('ngBlur');
	
	      self.documentElement.off('click touchstart', self.bodyClickHandler);
	      window.removeEventListener(self.windowEventName, self.windowEventHandler);
	
	      self.calendarPaneOpenedFrom.focus();
	      self.calendarPaneOpenedFrom = null;
	
	      if (self.openOnFocus) {
	        // Ensures that all focus events have fired before resetting
	        // the calendar. Prevents the calendar from reopening immediately
	        // in IE when md-open-on-focus is set. Also it needs to trigger
	        // a digest, in order to prevent issues where the calendar wasn't
	        // showing up on the next open.
	        self.$timeout(reset);
	      } else {
	        reset();
	      }
	    }
	
	    function reset(){
	      self.isCalendarOpen = self.isOpen = false;
	    }
	  };
	
	  /** Gets the controller instance for the calendar in the floating pane. */
	  DatePickerCtrl.prototype.getCalendarCtrl = function() {
	    return angular.element(this.calendarPane.querySelector('md-calendar')).controller('mdCalendar');
	  };
	
	  /** Focus the calendar in the floating pane. */
	  DatePickerCtrl.prototype.focusCalendar = function() {
	    // Use a timeout in order to allow the calendar to be rendered, as it is gated behind an ng-if.
	    var self = this;
	    this.$mdUtil.nextTick(function() {
	      self.getCalendarCtrl().focusDate();
	    }, false);
	  };
	
	  /**
	   * Sets whether the input is currently focused.
	   * @param {boolean} isFocused
	   */
	  DatePickerCtrl.prototype.setFocused = function(isFocused) {
	    if (!isFocused) {
	      this.ngModelCtrl.$setTouched();
	    }
	
	    // The ng* expressions shouldn't be evaluated when mdOpenOnFocus is on,
	    // because they also get called when the calendar is opened/closed.
	    if (!this.openOnFocus) {
	      this.evalAttr(isFocused ? 'ngFocus' : 'ngBlur');
	    }
	
	    this.isFocused = isFocused;
	  };
	
	  /**
	   * Handles a click on the document body when the floating calendar pane is open.
	   * Closes the floating calendar pane if the click is not inside of it.
	   * @param {MouseEvent} event
	   */
	  DatePickerCtrl.prototype.handleBodyClick = function(event) {
	    if (this.isCalendarOpen) {
	      var isInCalendar = this.$mdUtil.getClosest(event.target, 'md-calendar');
	
	      if (!isInCalendar) {
	        this.closeCalendarPane();
	      }
	
	      this.$scope.$digest();
	    }
	  };
	
	  /**
	   * Handles the event when the user navigates away from the current tab. Keeps track of
	   * whether the input was focused when the event happened, in order to prevent the calendar
	   * from re-opening.
	   */
	  DatePickerCtrl.prototype.handleWindowBlur = function() {
	    this.inputFocusedOnWindowBlur = document.activeElement === this.inputElement;
	  };
	
	  /**
	   * Reset the flag inputFocusedOnWindowBlur to default state, to permit user to open calendar
	   * again when he back to tab with calendar focused.
	   */
	  DatePickerCtrl.prototype.resetInputFocused = function() {
	    this.inputFocusedOnWindowBlur = false;
	  };
	
	  /**
	   * Evaluates an attribute expression against the parent scope.
	   * @param {String} attr Name of the attribute to be evaluated.
	   */
	  DatePickerCtrl.prototype.evalAttr = function(attr) {
	    if (this.$attrs[attr]) {
	      this.$scope.$parent.$eval(this.$attrs[attr]);
	    }
	  };
	
	  /**
	   * Sets the ng-model value by first converting the date object into a string. Converting it
	   * is necessary, in order to pass AngularJS's `input[type="date"]` validations. AngularJS turns
	   * the value into a Date object afterwards, before setting it on the model.
	   * @param {Date=} value Date to be set as the model value.
	   */
	  DatePickerCtrl.prototype.setModelValue = function(value) {
	    var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, 'timezone');
	    this.ngModelCtrl.$setViewValue(this.ngDateFilter(value, 'yyyy-MM-dd', timezone), 'default');
	  };
	
	  /**
	   * Updates the datepicker when a model change occurred externally.
	   * @param {Date=} value Value that was set to the model.
	   */
	  DatePickerCtrl.prototype.onExternalChange = function(value) {
	    var self = this;
	    var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, 'timezone');
	
	    if (this.dateUtil.isValidDate(value)) {
	      this.date = this.dateUtil.removeLocalTzAndReparseDate(value);
	    } else {
	      this.date = value;
	    }
	    this.inputElement.value = this.locale.formatDate(value, timezone);
	    this.mdInputContainer && this.mdInputContainer.setHasValue(!!value);
	    this.resizeInputElement();
	    // This is often called from the $formatters section of the $validators pipeline.
	    // In that case, we need to delay to let $render and $validate run, so that the checks for
	    // error state are accurate.
	    this.$mdUtil.nextTick(function() {self.updateErrorState();}, false, self.$scope);
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.dialog
	 */
	MdDialogDirective.$inject = ["$$rAF", "$mdTheming", "$mdDialog"];
	MdDialogProvider.$inject = ["$$interimElementProvider"];
	angular
	  .module('material.components.dialog', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .directive('mdDialog', MdDialogDirective)
	  .provider('$mdDialog', MdDialogProvider);
	
	/**
	 * @ngdoc directive
	 * @name mdDialog
	 * @module material.components.dialog
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-dialog>` - The dialog's template must be inside this element.
	 *
	 * Inside, use an `<md-dialog-content>` element for the dialog's content, and use
	 * an `<md-dialog-actions>` element for the dialog's actions.
	 *
	 * ## CSS
	 * - `.md-dialog-content` - class that sets the padding on the content as the spec file
	 *
	 * ## Notes
	 * - If you specify an `id` for the `<md-dialog>`, the `<md-dialog-content>` will have the same `id`
	 * prefixed with `dialogContent_`.
	 *
	 * @usage
	 * ### Dialog template
	 * <hljs lang="html">
	 * <md-dialog aria-label="List dialog">
	 *   <md-dialog-content>
	 *     <md-list>
	 *       <md-list-item ng-repeat="item in items">
	 *         <p>Number {{item}}</p>
	 *       </md-list-item>
	 *     </md-list>
	 *   </md-dialog-content>
	 *   <md-dialog-actions>
	 *     <md-button ng-click="closeDialog()" class="md-primary">Close Dialog</md-button>
	 *   </md-dialog-actions>
	 * </md-dialog>
	 * </hljs>
	 */
	function MdDialogDirective($$rAF, $mdTheming, $mdDialog) {
	  return {
	    restrict: 'E',
	    link: function(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      $mdTheming(element);
	      $$rAF(function() {
	        var images;
	        var content = element[0].querySelector('md-dialog-content');
	
	        if (content) {
	          images = content.getElementsByTagName('img');
	          addOverflowClass();
	          // delayed image loading may impact scroll height, check after images are loaded
	          angular.element(images).on('load', addOverflowClass);
	        }
	
	        scope.$on('$destroy', function() {
	          $mdDialog.destroy(element);
	        });
	
	        /**
	         *
	         */
	        function addOverflowClass() {
	          element.toggleClass('md-content-overflow', content.scrollHeight > content.clientHeight);
	        }
	
	
	      });
	    }
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $mdDialog
	 * @module material.components.dialog
	 *
	 * @description
	 * `$mdDialog` opens a dialog over the app to inform users about critical information or require
	 *  them to make decisions. There are two approaches for setup: a simple promise API
	 *  and regular object syntax.
	 *
	 * ## Restrictions
	 *
	 * - The dialog is always given an isolate scope.
	 * - The dialog's template must have an outer `<md-dialog>` element.
	 *   Inside, use an `<md-dialog-content>` element for the dialog's content, and use
	 *   an `<md-dialog-actions>` element for the dialog's actions.
	 * - Dialogs must cover the entire application to keep interactions inside of them.
	 * Use the `parent` option to change where dialogs are appended.
	 *
	 * ## Sizing
	 * - Complex dialogs can be sized with `flex="percentage"`, i.e. `flex="66"`.
	 * - Default max-width is 80% of the `rootElement` or `parent`.
	 *
	 * ## CSS
	 * - `.md-dialog-content` - class that sets the padding on the content as the spec file
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div  ng-app="demoApp" ng-controller="EmployeeController">
	 *   <div>
	 *     <md-button ng-click="showAlert()" class="md-raised md-warn">
	 *       Employee Alert!
	 *       </md-button>
	 *   </div>
	 *   <div>
	 *     <md-button ng-click="showDialog($event)" class="md-raised">
	 *       Custom Dialog
	 *       </md-button>
	 *   </div>
	 *   <div>
	 *     <md-button ng-click="closeAlert()" ng-disabled="!hasAlert()" class="md-raised">
	 *       Close Alert
	 *     </md-button>
	 *   </div>
	 *   <div>
	 *     <md-button ng-click="showGreeting($event)" class="md-raised md-primary" >
	 *       Greet Employee
	 *       </md-button>
	 *   </div>
	 * </div>
	 * </hljs>
	 *
	 * ### JavaScript: object syntax
	 * <hljs lang="js">
	 * (function(angular, undefined){
	 *   "use strict";
	 *
	 *   angular
	 *    .module('demoApp', ['ngMaterial'])
	 *    .controller('AppCtrl', AppController);
	 *
	 *   function AppController($scope, $mdDialog) {
	 *     var alert;
	 *     $scope.showAlert = showAlert;
	 *     $scope.showDialog = showDialog;
	 *     $scope.items = [1, 2, 3];
	 *
	 *     // Internal method
	 *     function showAlert() {
	 *       alert = $mdDialog.alert({
	 *         title: 'Attention',
	 *         textContent: 'This is an example of how easy dialogs can be!',
	 *         ok: 'Close'
	 *       });
	 *
	 *       $mdDialog
	 *         .show( alert )
	 *         .finally(function() {
	 *           alert = undefined;
	 *         });
	 *     }
	 *
	 *     function showDialog($event) {
	 *        var parentEl = angular.element(document.body);
	 *        $mdDialog.show({
	 *          parent: parentEl,
	 *          targetEvent: $event,
	 *          template:
	 *            '<md-dialog aria-label="List dialog">' +
	 *            '  <md-dialog-content>'+
	 *            '    <md-list>'+
	 *            '      <md-list-item ng-repeat="item in items">'+
	 *            '       <p>Number {{item}}</p>' +
	 *            '      </md-item>'+
	 *            '    </md-list>'+
	 *            '  </md-dialog-content>' +
	 *            '  <md-dialog-actions>' +
	 *            '    <md-button ng-click="closeDialog()" class="md-primary">' +
	 *            '      Close Dialog' +
	 *            '    </md-button>' +
	 *            '  </md-dialog-actions>' +
	 *            '</md-dialog>',
	 *          locals: {
	 *            items: $scope.items
	 *          },
	 *          controller: DialogController
	 *       });
	 *       function DialogController($scope, $mdDialog, items) {
	 *         $scope.items = items;
	 *         $scope.closeDialog = function() {
	 *           $mdDialog.hide();
	 *         }
	 *       }
	 *     }
	 *   }
	 * })(angular);
	 * </hljs>
	 *
	 * ### Multiple Dialogs
	 * Using the `multiple` option for the `$mdDialog` service allows developers to show multiple dialogs
	 * at the same time.
	 *
	 * <hljs lang="js">
	 *   // From plain options
	 *   $mdDialog.show({
	 *     multiple: true
	 *   });
	 *
	 *   // From a dialog preset
	 *   $mdDialog.show(
	 *     $mdDialog
	 *       .alert()
	 *       .multiple(true)
	 *   );
	 *
	 * </hljs>
	 *
	 * ### Pre-Rendered Dialogs
	 * By using the `contentElement` option, it is possible to use an already existing element in the DOM.
	 *
	 * > Pre-rendered dialogs will be not linked to any scope and will not instantiate any new controller.<br/>
	 * > You can manually link the elements to a scope or instantiate a controller from the template (`ng-controller`)
	 *
	 * <hljs lang="js">
	 *   $scope.showPrerenderedDialog = function() {
	 *     $mdDialog.show({
	 *       contentElement: '#myStaticDialog',
	 *       parent: angular.element(document.body)
	 *     });
	 *   };
	 * </hljs>
	 *
	 * When using a string as value, `$mdDialog` will automatically query the DOM for the specified CSS selector.
	 *
	 * <hljs lang="html">
	 *   <div style="visibility: hidden">
	 *     <div class="md-dialog-container" id="myStaticDialog">
	 *       <md-dialog>
	 *         This is a pre-rendered dialog.
	 *       </md-dialog>
	 *     </div>
	 *   </div>
	 * </hljs>
	 *
	 * **Notice**: It is important, to use the `.md-dialog-container` as the content element, otherwise the dialog
	 * will not show up.
	 *
	 * It also possible to use a DOM element for the `contentElement` option.
	 * - `contentElement: document.querySelector('#myStaticDialog')`
	 * - `contentElement: angular.element(TEMPLATE)`
	 *
	 * When using a `template` as content element, it will be not compiled upon open.
	 * This allows you to compile the element yourself and use it each time the dialog opens.
	 *
	 * ### Custom Presets
	 * Developers are also able to create their own preset, which can be easily used without repeating
	 * their options each time.
	 *
	 * <hljs lang="js">
	 *   $mdDialogProvider.addPreset('testPreset', {
	 *     options: function() {
	 *       return {
	 *         template:
	 *           '<md-dialog>' +
	 *             'This is a custom preset' +
	 *           '</md-dialog>',
	 *         controllerAs: 'dialog',
	 *         bindToController: true,
	 *         clickOutsideToClose: true,
	 *         escapeToClose: true
	 *       };
	 *     }
	 *   });
	 * </hljs>
	 *
	 * After you created your preset at config phase, you can easily access it.
	 *
	 * <hljs lang="js">
	 *   $mdDialog.show(
	 *     $mdDialog.testPreset()
	 *   );
	 * </hljs>
	 *
	 * ### JavaScript: promise API syntax, custom dialog template
	 * <hljs lang="js">
	 * (function(angular, undefined){
	 *   "use strict";
	 *
	 *   angular
	 *     .module('demoApp', ['ngMaterial'])
	 *     .controller('EmployeeController', EmployeeEditor)
	 *     .controller('GreetingController', GreetingController);
	 *
	 *   // Fictitious Employee Editor to show how to use simple and complex dialogs.
	 *
	 *   function EmployeeEditor($scope, $mdDialog) {
	 *     var alert;
	 *
	 *     $scope.showAlert = showAlert;
	 *     $scope.closeAlert = closeAlert;
	 *     $scope.showGreeting = showCustomGreeting;
	 *
	 *     $scope.hasAlert = function() { return !!alert };
	 *     $scope.userName = $scope.userName || 'Bobby';
	 *
	 *     // Dialog #1 - Show simple alert dialog and cache
	 *     // reference to dialog instance
	 *
	 *     function showAlert() {
	 *       alert = $mdDialog.alert()
	 *         .title('Attention, ' + $scope.userName)
	 *         .textContent('This is an example of how easy dialogs can be!')
	 *         .ok('Close');
	 *
	 *       $mdDialog
	 *           .show( alert )
	 *           .finally(function() {
	 *             alert = undefined;
	 *           });
	 *     }
	 *
	 *     // Close the specified dialog instance and resolve with 'finished' flag
	 *     // Normally this is not needed, just use '$mdDialog.hide()' to close
	 *     // the most recent dialog popup.
	 *
	 *     function closeAlert() {
	 *       $mdDialog.hide( alert, "finished" );
	 *       alert = undefined;
	 *     }
	 *
	 *     // Dialog #2 - Demonstrate more complex dialogs construction and popup.
	 *
	 *     function showCustomGreeting($event) {
	 *         $mdDialog.show({
	 *           targetEvent: $event,
	 *           template:
	 *             '<md-dialog>' +
	 *
	 *             '  <md-dialog-content>Hello {{ employee }}!</md-dialog-content>' +
	 *
	 *             '  <md-dialog-actions>' +
	 *             '    <md-button ng-click="closeDialog()" class="md-primary">' +
	 *             '      Close Greeting' +
	 *             '    </md-button>' +
	 *             '  </md-dialog-actions>' +
	 *             '</md-dialog>',
	 *           controller: 'GreetingController',
	 *           onComplete: afterShowAnimation,
	 *           locals: { employee: $scope.userName }
	 *         });
	 *
	 *         // When the 'enter' animation finishes...
	 *
	 *         function afterShowAnimation(scope, element, options) {
	 *            // post-show code here: DOM element focus, etc.
	 *         }
	 *     }
	 *
	 *     // Dialog #3 - Demonstrate use of ControllerAs and passing $scope to dialog
	 *     //             Here we used ng-controller="GreetingController as vm" and
	 *     //             $scope.vm === <controller instance>
	 *
	 *     function showCustomGreeting() {
	 *
	 *        $mdDialog.show({
	 *           clickOutsideToClose: true,
	 *
	 *           scope: $scope,        // use parent scope in template
	 *           preserveScope: true,  // do not forget this if use parent scope
	
	 *           // Since GreetingController is instantiated with ControllerAs syntax
	 *           // AND we are passing the parent '$scope' to the dialog, we MUST
	 *           // use 'vm.<xxx>' in the template markup
	 *
	 *           template: '<md-dialog>' +
	 *                     '  <md-dialog-content>' +
	 *                     '     Hi There {{vm.employee}}' +
	 *                     '  </md-dialog-content>' +
	 *                     '</md-dialog>',
	 *
	 *           controller: function DialogController($scope, $mdDialog) {
	 *             $scope.closeDialog = function() {
	 *               $mdDialog.hide();
	 *             }
	 *           }
	 *        });
	 *     }
	 *
	 *   }
	 *
	 *   // Greeting controller used with the more complex 'showCustomGreeting()' custom dialog
	 *
	 *   function GreetingController($scope, $mdDialog, employee) {
	 *     // Assigned from construction <code>locals</code> options...
	 *     $scope.employee = employee;
	 *
	 *     $scope.closeDialog = function() {
	 *       // Easily hides most recent dialog shown...
	 *       // no specific instance reference is needed.
	 *       $mdDialog.hide();
	 *     };
	 *   }
	 *
	 * })(angular);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#alert
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message.
	 *
	 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
	 *
	 * - $mdDialogPreset#title(string) - Sets the alert title.
	 * - $mdDialogPreset#textContent(string) - Sets the alert message.
	 * - $mdDialogPreset#htmlContent(string) - Sets the alert message as HTML. Requires ngSanitize
	 *     module to be loaded. HTML is not run through Angular's compiler.
	 * - $mdDialogPreset#ok(string) - Sets the alert "Okay" button text.
	 * - $mdDialogPreset#theme(string) - Sets the theme of the alert dialog.
	 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#confirm
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message. You can call show and the promise
	 * returned will be resolved if the user clicks the confirm action on the dialog. The promise will
	 * be rejected if the user clicks the cancel action or dismisses the dialog.
	 *
	 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
	 *
	 * Additionally, it supports the following methods:
	 *
	 * - $mdDialogPreset#title(string) - Sets the confirm title.
	 * - $mdDialogPreset#textContent(string) - Sets the confirm message.
	 * - $mdDialogPreset#htmlContent(string) - Sets the confirm message as HTML. Requires ngSanitize
	 *     module to be loaded. HTML is not run through Angular's compiler.
	 * - $mdDialogPreset#ok(string) - Sets the confirm "Okay" button text.
	 * - $mdDialogPreset#cancel(string) - Sets the confirm "Cancel" button text.
	 * - $mdDialogPreset#theme(string) - Sets the theme of the confirm dialog.
	 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#prompt
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message and input box. You can call show and the
	 * promise returned will be resolved, if the user clicks the prompt action on the dialog, passing
	 * the input value as the first argument. The promise will be rejected if the user clicks the cancel
	 * action or dismisses the dialog.
	 *
	 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
	 *
	 * Additionally, it supports the following methods:
	 *
	 * - $mdDialogPreset#title(string) - Sets the prompt title.
	 * - $mdDialogPreset#textContent(string) - Sets the prompt message.
	 * - $mdDialogPreset#htmlContent(string) - Sets the prompt message as HTML. Requires ngSanitize
	 *     module to be loaded. HTML is not run through Angular's compiler.
	 * - $mdDialogPreset#placeholder(string) - Sets the placeholder text for the input.
	 * - $mdDialogPreset#required(boolean) - Sets the input required value.
	 * - $mdDialogPreset#initialValue(string) - Sets the initial value for the prompt input.
	 * - $mdDialogPreset#ok(string) - Sets the prompt "Okay" button text.
	 * - $mdDialogPreset#cancel(string) - Sets the prompt "Cancel" button text.
	 * - $mdDialogPreset#theme(string) - Sets the theme of the prompt dialog.
	 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#show
	 *
	 * @description
	 * Show a dialog with the specified options.
	 *
	 * @param {object} optionsOrPreset Either provide an `$mdDialogPreset` returned from `alert()`, and
	 * `confirm()`, or an options object with the following properties:
	 *   - `templateUrl` - `{string=}`: The url of a template that will be used as the content
	 *   of the dialog.
	 *   - `template` - `{string=}`: HTML template to show in the dialog. This **must** be trusted HTML
	 *      with respect to Angular's [$sce service](https://docs.angularjs.org/api/ng/service/$sce).
	 *      This template should **never** be constructed with any kind of user input or user data.
	 *   - `contentElement` - `{string|Element}`: Instead of using a template, which will be compiled each time a
	 *     dialog opens, you can also use a DOM element.<br/>
	 *     * When specifying an element, which is present on the DOM, `$mdDialog` will temporary fetch the element into
	 *       the dialog and restores it at the old DOM position upon close.
	 *     * When specifying a string, the string be used as a CSS selector, to lookup for the element in the DOM.
	 *   - `autoWrap` - `{boolean=}`: Whether or not to automatically wrap the template with a
	 *     `<md-dialog>` tag if one is not provided. Defaults to true. Can be disabled if you provide a
	 *     custom dialog directive.
	 *   - `targetEvent` - `{DOMClickEvent=}`: A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *   - `openFrom` - `{string|Element|object}`: The query selector, DOM element or the Rect object
	 *     that is used to determine the bounds (top, left, height, width) from which the Dialog will
	 *     originate.
	 *   - `closeTo` - `{string|Element|object}`: The query selector, DOM element or the Rect object
	 *     that is used to determine the bounds (top, left, height, width) to which the Dialog will
	 *     target.
	 *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified,
	 *     it will create a new isolate scope.
	 *     This scope will be destroyed when the dialog is removed unless `preserveScope` is set to true.
	 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
	 *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the dialog is open.
	 *     Default true.
	 *   - `hasBackdrop` - `{boolean=}`: Whether there should be an opaque backdrop behind the dialog.
	 *     Default true.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the dialog to
	 *     close it. Default false.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the dialog.
	 *     Default true.
	 *   - `focusOnOpen` - `{boolean=}`: An option to override focus behavior on open. Only disable if
	 *     focusing some other way, as focus management is required for dialogs to be accessible.
	 *     Defaults to true.
	 *   - `controller` - `{function|string=}`: The controller to associate with the dialog. The controller
	 *     will be injected with the local `$mdDialog`, which passes along a scope for the dialog.
	 *   - `locals` - `{object=}`: An object containing key/value pairs. The keys will be used as names
	 *     of values to inject into the controller. For example, `locals: {three: 3}` would inject
	 *     `three` into the controller, with the value 3. If `bindToController` is true, they will be
	 *     copied to the controller instead.
	 *   - `bindToController` - `bool`: bind the locals to the controller, instead of passing them in.
	 *   - `resolve` - `{function=}`: Similar to locals, except it takes as values functions that return promises, and the
	 *      dialog will not open until all of the promises resolve.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	 *   - `parent` - `{element=}`: The element to append the dialog to. Defaults to appending
	 *     to the root element of the application.
	 *   - `onShowing` - `function(scope, element)`: Callback function used to announce the show() action is
	 *     starting.
	 *   - `onComplete` - `function(scope, element)`: Callback function used to announce when the show() action is
	 *     finished.
	 *   - `onRemoving` - `function(element, removePromise)`: Callback function used to announce the
	 *      close/hide() action is starting. This allows developers to run custom animations
	 *      in parallel with the close animations.
	 *   - `fullscreen` `{boolean=}`: An option to toggle whether the dialog should show in fullscreen
	 *      or not. Defaults to `false`.
	 *   - `multiple` `{boolean=}`: An option to allow this dialog to display over one that's currently open.
	 * @returns {promise} A promise that can be resolved with `$mdDialog.hide()` or
	 * rejected with `$mdDialog.cancel()`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#hide
	 *
	 * @description
	 * Hide an existing dialog and resolve the promise returned from `$mdDialog.show()`.
	 *
	 * @param {*=} response An argument for the resolved promise.
	 *
	 * @returns {promise} A promise that is resolved when the dialog has been closed.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#cancel
	 *
	 * @description
	 * Hide an existing dialog and reject the promise returned from `$mdDialog.show()`.
	 *
	 * @param {*=} response An argument for the rejected promise.
	 *
	 * @returns {promise} A promise that is resolved when the dialog has been closed.
	 */
	
	function MdDialogProvider($$interimElementProvider) {
	  // Elements to capture and redirect focus when the user presses tab at the dialog boundary.
	  MdDialogController.$inject = ["$mdDialog", "$mdConstant"];
	  dialogDefaultOptions.$inject = ["$mdDialog", "$mdAria", "$mdUtil", "$mdConstant", "$animate", "$document", "$window", "$rootElement", "$log", "$injector", "$mdTheming", "$interpolate", "$mdInteraction"];
	  var topFocusTrap, bottomFocusTrap;
	
	  return $$interimElementProvider('$mdDialog')
	    .setDefaults({
	      methods: ['disableParentScroll', 'hasBackdrop', 'clickOutsideToClose', 'escapeToClose',
	          'targetEvent', 'closeTo', 'openFrom', 'parent', 'fullscreen', 'multiple'],
	      options: dialogDefaultOptions
	    })
	    .addPreset('alert', {
	      methods: ['title', 'htmlContent', 'textContent', 'content', 'ariaLabel', 'ok', 'theme',
	          'css'],
	      options: advancedDialogOptions
	    })
	    .addPreset('confirm', {
	      methods: ['title', 'htmlContent', 'textContent', 'content', 'ariaLabel', 'ok', 'cancel',
	          'theme', 'css'],
	      options: advancedDialogOptions
	    })
	    .addPreset('prompt', {
	      methods: ['title', 'htmlContent', 'textContent', 'initialValue', 'content', 'placeholder', 'ariaLabel',
	          'ok', 'cancel', 'theme', 'css', 'required'],
	      options: advancedDialogOptions
	    });
	
	  /* @ngInject */
	  function advancedDialogOptions() {
	    return {
	      template: [
	        '<md-dialog md-theme="{{ dialog.theme || dialog.defaultTheme }}" aria-label="{{ dialog.ariaLabel }}" ng-class="dialog.css">',
	        '  <md-dialog-content class="md-dialog-content" role="document" tabIndex="-1">',
	        '    <h2 class="md-title">{{ dialog.title }}</h2>',
	        '    <div ng-if="::dialog.mdHtmlContent" class="md-dialog-content-body" ',
	        '        ng-bind-html="::dialog.mdHtmlContent"></div>',
	        '    <div ng-if="::!dialog.mdHtmlContent" class="md-dialog-content-body">',
	        '      <p>{{::dialog.mdTextContent}}</p>',
	        '    </div>',
	        '    <md-input-container md-no-float ng-if="::dialog.$type == \'prompt\'" class="md-prompt-input-container">',
	        '      <input ng-keypress="dialog.keypress($event)" md-autofocus ng-model="dialog.result" ' +
	        '             placeholder="{{::dialog.placeholder}}" ng-required="dialog.required">',
	        '    </md-input-container>',
	        '  </md-dialog-content>',
	        '  <md-dialog-actions>',
	        '    <md-button ng-if="dialog.$type === \'confirm\' || dialog.$type === \'prompt\'"' +
	        '               ng-click="dialog.abort()" class="md-primary md-cancel-button">',
	        '      {{ dialog.cancel }}',
	        '    </md-button>',
	        '    <md-button ng-click="dialog.hide()" class="md-primary md-confirm-button" md-autofocus="dialog.$type===\'alert\'"' +
	        '               ng-disabled="dialog.required && !dialog.result">',
	        '      {{ dialog.ok }}',
	        '    </md-button>',
	        '  </md-dialog-actions>',
	        '</md-dialog>'
	      ].join('').replace(/\s\s+/g, ''),
	      controller: MdDialogController,
	      controllerAs: 'dialog',
	      bindToController: true,
	    };
	  }
	
	  /**
	   * Controller for the md-dialog interim elements
	   * @ngInject
	   */
	  function MdDialogController($mdDialog, $mdConstant) {
	    // For compatibility with AngularJS 1.6+, we should always use the $onInit hook in
	    // interimElements. The $mdCompiler simulates the $onInit hook for all versions.
	    this.$onInit = function() {
	      var isPrompt = this.$type == 'prompt';
	
	      if (isPrompt && this.initialValue) {
	        this.result = this.initialValue;
	      }
	
	      this.hide = function() {
	        $mdDialog.hide(isPrompt ? this.result : true);
	      };
	      this.abort = function() {
	        $mdDialog.cancel();
	      };
	      this.keypress = function($event) {
	        var invalidPrompt = isPrompt && this.required && !angular.isDefined(this.result);
	
	        if ($event.keyCode === $mdConstant.KEY_CODE.ENTER && !invalidPrompt) {
	          $mdDialog.hide(this.result);
	        }
	      };
	    };
	  }
	
	  /* @ngInject */
	  function dialogDefaultOptions($mdDialog, $mdAria, $mdUtil, $mdConstant, $animate, $document, $window, $rootElement,
	                                $log, $injector, $mdTheming, $interpolate, $mdInteraction) {
	
	    return {
	      hasBackdrop: true,
	      isolateScope: true,
	      onCompiling: beforeCompile,
	      onShow: onShow,
	      onShowing: beforeShow,
	      onRemove: onRemove,
	      clickOutsideToClose: false,
	      escapeToClose: true,
	      targetEvent: null,
	      closeTo: null,
	      openFrom: null,
	      focusOnOpen: true,
	      disableParentScroll: true,
	      autoWrap: true,
	      fullscreen: false,
	      transformTemplate: function(template, options) {
	        // Make the dialog container focusable, because otherwise the focus will be always redirected to
	        // an element outside of the container, and the focus trap won't work probably..
	        // Also the tabindex is needed for the `escapeToClose` functionality, because
	        // the keyDown event can't be triggered when the focus is outside of the container.
	        var startSymbol = $interpolate.startSymbol();
	        var endSymbol = $interpolate.endSymbol();
	        var theme = startSymbol + (options.themeWatch ? '' : '::') + 'theme' + endSymbol;
	        var themeAttr = (options.hasTheme) ? 'md-theme="'+theme+'"': '';
	        return '<div class="md-dialog-container" tabindex="-1" ' + themeAttr + '>' + validatedTemplate(template) + '</div>';
	
	        /**
	         * The specified template should contain a <md-dialog> wrapper element....
	         */
	        function validatedTemplate(template) {
	          if (options.autoWrap && !/<\/md-dialog>/g.test(template)) {
	            return '<md-dialog>' + (template || '') + '</md-dialog>';
	          } else {
	            return template || '';
	          }
	        }
	      }
	    };
	
	    function beforeCompile(options) {
	      // Automatically apply the theme, if the user didn't specify a theme explicitly.
	      // Those option changes need to be done, before the compilation has started, because otherwise
	      // the option changes will be not available in the $mdCompilers locales.
	      options.defaultTheme = $mdTheming.defaultTheme();
	
	      detectTheming(options);
	    }
	
	    function beforeShow(scope, element, options, controller) {
	
	      if (controller) {
	        var mdHtmlContent = controller.htmlContent || options.htmlContent || '';
	        var mdTextContent = controller.textContent || options.textContent ||
	            controller.content || options.content || '';
	
	        if (mdHtmlContent && !$injector.has('$sanitize')) {
	          throw Error('The ngSanitize module must be loaded in order to use htmlContent.');
	        }
	
	        if (mdHtmlContent && mdTextContent) {
	          throw Error('md-dialog cannot have both `htmlContent` and `textContent`');
	        }
	
	        // Only assign the content if nothing throws, otherwise it'll still be compiled.
	        controller.mdHtmlContent = mdHtmlContent;
	        controller.mdTextContent = mdTextContent;
	      }
	    }
	
	    /** Show method for dialogs */
	    function onShow(scope, element, options, controller) {
	      angular.element($document[0].body).addClass('md-dialog-is-showing');
	
	      var dialogElement = element.find('md-dialog');
	
	      // Once a dialog has `ng-cloak` applied on his template the dialog animation will not work properly.
	      // This is a very common problem, so we have to notify the developer about this.
	      if (dialogElement.hasClass('ng-cloak')) {
	        var message = '$mdDialog: using `<md-dialog ng-cloak>` will affect the dialog opening animations.';
	        $log.warn(message, element[0]);
	      }
	
	      captureParentAndFromToElements(options);
	      configureAria(dialogElement, options);
	      showBackdrop(scope, element, options);
	      activateListeners(element, options);
	
	      return dialogPopIn(element, options)
	        .then(function() {
	          lockScreenReader(element, options);
	          warnDeprecatedActions();
	          focusOnOpen();
	        });
	
	      /**
	       * Check to see if they used the deprecated .md-actions class and log a warning
	       */
	      function warnDeprecatedActions() {
	        if (element[0].querySelector('.md-actions')) {
	          $log.warn('Using a class of md-actions is deprecated, please use <md-dialog-actions>.');
	        }
	      }
	
	      /**
	       * For alerts, focus on content... otherwise focus on
	       * the close button (or equivalent)
	       */
	      function focusOnOpen() {
	        if (options.focusOnOpen) {
	          var target = $mdUtil.findFocusTarget(element) || findCloseButton() || dialogElement;
	          target.focus();
	        }
	
	        /**
	         * If no element with class dialog-close, try to find the last
	         * button child in md-actions and assume it is a close button.
	         *
	         * If we find no actions at all, log a warning to the console.
	         */
	        function findCloseButton() {
	          return element[0].querySelector('.dialog-close, md-dialog-actions button:last-child');
	        }
	      }
	    }
	
	    /**
	     * Remove function for all dialogs
	     */
	    function onRemove(scope, element, options) {
	      options.deactivateListeners();
	      options.unlockScreenReader();
	      options.hideBackdrop(options.$destroy);
	
	      // Remove the focus traps that we added earlier for keeping focus within the dialog.
	      if (topFocusTrap && topFocusTrap.parentNode) {
	        topFocusTrap.parentNode.removeChild(topFocusTrap);
	      }
	
	      if (bottomFocusTrap && bottomFocusTrap.parentNode) {
	        bottomFocusTrap.parentNode.removeChild(bottomFocusTrap);
	      }
	
	      // For navigation $destroy events, do a quick, non-animated removal,
	      // but for normal closes (from clicks, etc) animate the removal
	      return options.$destroy ? detachAndClean() : animateRemoval().then(detachAndClean);
	
	      /**
	       * For normal closes, animate the removal.
	       * For forced closes (like $destroy events), skip the animations
	       */
	      function animateRemoval() {
	        return dialogPopOut(element, options);
	      }
	
	      /**
	       * Detach the element
	       */
	      function detachAndClean() {
	        angular.element($document[0].body).removeClass('md-dialog-is-showing');
	
	        // Reverse the container stretch if using a content element.
	        if (options.contentElement) {
	          options.reverseContainerStretch();
	        }
	
	        // Exposed cleanup function from the $mdCompiler.
	        options.cleanupElement();
	
	        // Restores the focus to the origin element if the last interaction upon opening was a keyboard.
	        if (!options.$destroy && options.originInteraction === 'keyboard') {
	          options.origin.focus();
	        }
	      }
	    }
	
	    function detectTheming(options) {
	      // Once the user specifies a targetEvent, we will automatically try to find the correct
	      // nested theme.
	      var targetEl;
	      if (options.targetEvent && options.targetEvent.target) {
	        targetEl = angular.element(options.targetEvent.target);
	      }
	
	      var themeCtrl = targetEl && targetEl.controller('mdTheme');
	
	      options.hasTheme = (!!themeCtrl);
	
	      if (!options.hasTheme) {
	        return;
	      }
	
	      options.themeWatch = themeCtrl.$shouldWatch;
	
	      var theme = options.theme || themeCtrl.$mdTheme;
	
	      if (theme) {
	        options.scope.theme = theme;
	      }
	
	      var unwatch = themeCtrl.registerChanges(function (newTheme) {
	        options.scope.theme = newTheme;
	
	        if (!options.themeWatch) {
	          unwatch();
	        }
	      });
	    }
	
	    /**
	     * Capture originator/trigger/from/to element information (if available)
	     * and the parent container for the dialog; defaults to the $rootElement
	     * unless overridden in the options.parent
	     */
	    function captureParentAndFromToElements(options) {
	          options.origin = angular.extend({
	            element: null,
	            bounds: null,
	            focus: angular.noop
	          }, options.origin || {});
	
	          options.parent   = getDomElement(options.parent, $rootElement);
	          options.closeTo  = getBoundingClientRect(getDomElement(options.closeTo));
	          options.openFrom = getBoundingClientRect(getDomElement(options.openFrom));
	
	          if (options.targetEvent) {
	            options.origin = getBoundingClientRect(options.targetEvent.target, options.origin);
	            options.originInteraction = $mdInteraction.getLastInteractionType();
	          }
	
	
	          /**
	           * Identify the bounding RECT for the target element
	           *
	           */
	          function getBoundingClientRect (element, orig) {
	            var source = angular.element((element || {}));
	            if (source && source.length) {
	              // Compute and save the target element's bounding rect, so that if the
	              // element is hidden when the dialog closes, we can shrink the dialog
	              // back to the same position it expanded from.
	              //
	              // Checking if the source is a rect object or a DOM element
	              var bounds = {top:0,left:0,height:0,width:0};
	              var hasFn = angular.isFunction(source[0].getBoundingClientRect);
	
	              return angular.extend(orig || {}, {
	                  element : hasFn ? source : undefined,
	                  bounds  : hasFn ? source[0].getBoundingClientRect() : angular.extend({}, bounds, source[0]),
	                  focus   : angular.bind(source, source.focus),
	              });
	            }
	          }
	
	          /**
	           * If the specifier is a simple string selector, then query for
	           * the DOM element.
	           */
	          function getDomElement(element, defaultElement) {
	            if (angular.isString(element)) {
	              element = $document[0].querySelector(element);
	            }
	
	            // If we have a reference to a raw dom element, always wrap it in jqLite
	            return angular.element(element || defaultElement);
	          }
	
	        }
	
	    /**
	     * Listen for escape keys and outside clicks to auto close
	     */
	    function activateListeners(element, options) {
	      var window = angular.element($window);
	      var onWindowResize = $mdUtil.debounce(function() {
	        stretchDialogContainerToViewport(element, options);
	      }, 60);
	
	      var removeListeners = [];
	      var smartClose = function() {
	        // Only 'confirm' dialogs have a cancel button... escape/clickOutside will
	        // cancel or fallback to hide.
	        var closeFn = (options.$type == 'alert') ? $mdDialog.hide : $mdDialog.cancel;
	        $mdUtil.nextTick(closeFn, true);
	      };
	
	      if (options.escapeToClose) {
	        var parentTarget = options.parent;
	        var keyHandlerFn = function(ev) {
	          if (ev.keyCode === $mdConstant.KEY_CODE.ESCAPE) {
	            ev.stopImmediatePropagation();
	            ev.preventDefault();
	
	            smartClose();
	          }
	        };
	
	        // Add keydown listeners
	        element.on('keydown', keyHandlerFn);
	        parentTarget.on('keydown', keyHandlerFn);
	
	        // Queue remove listeners function
	        removeListeners.push(function() {
	
	          element.off('keydown', keyHandlerFn);
	          parentTarget.off('keydown', keyHandlerFn);
	
	        });
	      }
	
	      // Register listener to update dialog on window resize
	      window.on('resize', onWindowResize);
	
	      removeListeners.push(function() {
	        window.off('resize', onWindowResize);
	      });
	
	      if (options.clickOutsideToClose) {
	        var target = element;
	        var sourceElem;
	
	        // Keep track of the element on which the mouse originally went down
	        // so that we can only close the backdrop when the 'click' started on it.
	        // A simple 'click' handler does not work,
	        // it sets the target object as the element the mouse went down on.
	        var mousedownHandler = function(ev) {
	          sourceElem = ev.target;
	        };
	
	        // We check if our original element and the target is the backdrop
	        // because if the original was the backdrop and the target was inside the dialog
	        // we don't want to dialog to close.
	        var mouseupHandler = function(ev) {
	          if (sourceElem === target[0] && ev.target === target[0]) {
	            ev.stopPropagation();
	            ev.preventDefault();
	
	            smartClose();
	          }
	        };
	
	        // Add listeners
	        target.on('mousedown', mousedownHandler);
	        target.on('mouseup', mouseupHandler);
	
	        // Queue remove listeners function
	        removeListeners.push(function() {
	          target.off('mousedown', mousedownHandler);
	          target.off('mouseup', mouseupHandler);
	        });
	      }
	
	      // Attach specific `remove` listener handler
	      options.deactivateListeners = function() {
	        removeListeners.forEach(function(removeFn) {
	          removeFn();
	        });
	        options.deactivateListeners = null;
	      };
	    }
	
	    /**
	     * Show modal backdrop element...
	     */
	    function showBackdrop(scope, element, options) {
	
	      if (options.disableParentScroll) {
	        // !! DO this before creating the backdrop; since disableScrollAround()
	        //    configures the scroll offset; which is used by mdBackDrop postLink()
	        options.restoreScroll = $mdUtil.disableScrollAround(element, options.parent);
	      }
	
	      if (options.hasBackdrop) {
	        options.backdrop = $mdUtil.createBackdrop(scope, "md-dialog-backdrop md-opaque");
	        $animate.enter(options.backdrop, options.parent);
	      }
	
	      /**
	       * Hide modal backdrop element...
	       */
	      options.hideBackdrop = function hideBackdrop($destroy) {
	        if (options.backdrop) {
	          if ($destroy) options.backdrop.remove();
	          else              $animate.leave(options.backdrop);
	        }
	
	
	        if (options.disableParentScroll) {
	          options.restoreScroll && options.restoreScroll();
	          delete options.restoreScroll;
	        }
	
	        options.hideBackdrop = null;
	      };
	    }
	
	    /**
	     * Inject ARIA-specific attributes appropriate for Dialogs
	     */
	    function configureAria(element, options) {
	
	      var role = (options.$type === 'alert') ? 'alertdialog' : 'dialog';
	      var dialogContent = element.find('md-dialog-content');
	      var existingDialogId = element.attr('id');
	      var dialogContentId = 'dialogContent_' + (existingDialogId || $mdUtil.nextUid());
	
	      element.attr({
	        'role': role,
	        'tabIndex': '-1'
	      });
	
	      if (dialogContent.length === 0) {
	        dialogContent = element;
	        // If the dialog element already had an ID, don't clobber it.
	        if (existingDialogId) {
	          dialogContentId = existingDialogId;
	        }
	      }
	
	      dialogContent.attr('id', dialogContentId);
	      element.attr('aria-describedby', dialogContentId);
	
	      if (options.ariaLabel) {
	        $mdAria.expect(element, 'aria-label', options.ariaLabel);
	      }
	      else {
	        $mdAria.expectAsync(element, 'aria-label', function() {
	          // If dialog title is specified, set aria-label with it
	          // See https://github.com/angular/material/issues/10582
	          if (options.title) {
	            return options.title;
	          } else {
	            var words = dialogContent.text().split(/\s+/);
	            if (words.length > 3) words = words.slice(0, 3).concat('...');
	            return words.join(' ');
	          }
	        });
	      }
	
	      // Set up elements before and after the dialog content to capture focus and
	      // redirect back into the dialog.
	      topFocusTrap = document.createElement('div');
	      topFocusTrap.classList.add('md-dialog-focus-trap');
	      topFocusTrap.tabIndex = 0;
	
	      bottomFocusTrap = topFocusTrap.cloneNode(false);
	
	      // When focus is about to move out of the dialog, we want to intercept it and redirect it
	      // back to the dialog element.
	      var focusHandler = function() {
	        element.focus();
	      };
	      topFocusTrap.addEventListener('focus', focusHandler);
	      bottomFocusTrap.addEventListener('focus', focusHandler);
	
	      // The top focus trap inserted immeidately before the md-dialog element (as a sibling).
	      // The bottom focus trap is inserted at the very end of the md-dialog element (as a child).
	      element[0].parentNode.insertBefore(topFocusTrap, element[0]);
	      element.after(bottomFocusTrap);
	    }
	
	    /**
	     * Prevents screen reader interaction behind modal window
	     * on swipe interfaces
	     */
	    function lockScreenReader(element, options) {
	      var isHidden = true;
	
	      // get raw DOM node
	      walkDOM(element[0]);
	
	      options.unlockScreenReader = function () {
	        isHidden = false;
	        walkDOM(element[0]);
	
	        options.unlockScreenReader = null;
	      };
	
	      /**
	       * Get all of an element's parent elements up the DOM tree
	       * @return {Array} The parent elements
	       */
	      function getParents(element) {
	        var parents = [];
	        while (element.parentNode) {
	          if (element === document.body) {
	            return parents;
	          }
	          var children = element.parentNode.children;
	          for (var i = 0; i < children.length; i++) {
	            // skip over child if it is an ascendant of the dialog
	            // a script or style tag, or a live region.
	            if (element !== children[i] &&
	                !isNodeOneOf(children[i], ['SCRIPT', 'STYLE']) &&
	                !children[i].hasAttribute('aria-live')) {
	              parents.push(children[i]);
	            }
	          }
	          element = element.parentNode;
	        }
	        return parents;
	      }
	
	      /**
	       * Walk DOM to apply or remove aria-hidden on sibling nodes
	       * and parent sibling nodes
	       */
	      function walkDOM(element) {
	        var elements = getParents(element);
	        for (var i = 0; i < elements.length; i++) {
	          elements[i].setAttribute('aria-hidden', isHidden);
	        }
	      }
	    }
	
	    /**
	     * Ensure the dialog container fill-stretches to the viewport
	     */
	    function stretchDialogContainerToViewport(container, options) {
	      var isFixed = $window.getComputedStyle($document[0].body).position == 'fixed';
	      var backdrop = options.backdrop ? $window.getComputedStyle(options.backdrop[0]) : null;
	      var height = backdrop ? Math.min($document[0].body.clientHeight, Math.ceil(Math.abs(parseInt(backdrop.height, 10)))) : 0;
	
	      var previousStyles = {
	        top: container.css('top'),
	        height: container.css('height')
	      };
	
	      // If the body is fixed, determine the distance to the viewport in relative from the parent.
	      var parentTop = Math.abs(options.parent[0].getBoundingClientRect().top);
	
	      container.css({
	        top: (isFixed ? parentTop : 0) + 'px',
	        height: height ? height + 'px' : '100%'
	      });
	
	      return function() {
	        // Reverts the modified styles back to the previous values.
	        // This is needed for contentElements, which should have the same styles after close
	        // as before.
	        container.css(previousStyles);
	      };
	    }
	
	    /**
	     *  Dialog open and pop-in animation
	     */
	    function dialogPopIn(container, options) {
	      // Add the `md-dialog-container` to the DOM
	      options.parent.append(container);
	      options.reverseContainerStretch = stretchDialogContainerToViewport(container, options);
	
	      var dialogEl = container.find('md-dialog');
	      var animator = $mdUtil.dom.animator;
	      var buildTranslateToOrigin = animator.calculateZoomToOrigin;
	      var translateOptions = {transitionInClass: 'md-transition-in', transitionOutClass: 'md-transition-out'};
	      var from = animator.toTransformCss(buildTranslateToOrigin(dialogEl, options.openFrom || options.origin));
	      var to = animator.toTransformCss("");  // defaults to center display (or parent or $rootElement)
	
	      dialogEl.toggleClass('md-dialog-fullscreen', !!options.fullscreen);
	
	      return animator
	        .translate3d(dialogEl, from, to, translateOptions)
	        .then(function(animateReversal) {
	
	          // Build a reversal translate function synced to this translation...
	          options.reverseAnimate = function() {
	            delete options.reverseAnimate;
	
	            if (options.closeTo) {
	              // Using the opposite classes to create a close animation to the closeTo element
	              translateOptions = {transitionInClass: 'md-transition-out', transitionOutClass: 'md-transition-in'};
	              from = to;
	              to = animator.toTransformCss(buildTranslateToOrigin(dialogEl, options.closeTo));
	
	              return animator
	                .translate3d(dialogEl, from, to,translateOptions);
	            }
	
	            return animateReversal(
	              to = animator.toTransformCss(
	                // in case the origin element has moved or is hidden,
	                // let's recalculate the translateCSS
	                buildTranslateToOrigin(dialogEl, options.origin)
	              )
	            );
	
	          };
	
	          // Function to revert the generated animation styles on the dialog element.
	          // Useful when using a contentElement instead of a template.
	          options.clearAnimate = function() {
	            delete options.clearAnimate;
	
	            // Remove the transition classes, added from $animateCSS, since those can't be removed
	            // by reversely running the animator.
	            dialogEl.removeClass([
	              translateOptions.transitionOutClass,
	              translateOptions.transitionInClass
	            ].join(' '));
	
	            // Run the animation reversely to remove the previous added animation styles.
	            return animator.translate3d(dialogEl, to, animator.toTransformCss(''), {});
	          };
	
	          return true;
	        });
	    }
	
	    /**
	     * Dialog close and pop-out animation
	     */
	    function dialogPopOut(container, options) {
	      return options.reverseAnimate().then(function() {
	        if (options.contentElement) {
	          // When we use a contentElement, we want the element to be the same as before.
	          // That means, that we have to clear all the animation properties, like transform.
	          options.clearAnimate();
	        }
	      });
	    }
	
	    /**
	     * Utility function to filter out raw DOM nodes
	     */
	    function isNodeOneOf(elem, nodeTypeArray) {
	      if (nodeTypeArray.indexOf(elem.nodeName) !== -1) {
	        return true;
	      }
	    }
	
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.divider
	 * @description Divider module!
	 */
	MdDividerDirective.$inject = ["$mdTheming"];
	angular.module('material.components.divider', [
	  'material.core'
	])
	  .directive('mdDivider', MdDividerDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdDivider
	 * @module material.components.divider
	 * @restrict E
	 *
	 * @description
	 * Dividers group and separate content within lists and page layouts using strong visual and spatial distinctions. This divider is a thin rule, lightweight enough to not distract the user from content.
	 *
	 * @param {boolean=} md-inset Add this attribute to activate the inset divider style.
	 * @usage
	 * <hljs lang="html">
	 * <md-divider></md-divider>
	 *
	 * <md-divider md-inset></md-divider>
	 * </hljs>
	 *
	 */
	function MdDividerDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    link: $mdTheming
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc module
	   * @name material.components.fabActions
	   */
	  MdFabActionsDirective.$inject = ["$mdUtil"];
	  angular
	    .module('material.components.fabActions', ['material.core'])
	    .directive('mdFabActions', MdFabActionsDirective);
	
	  /**
	   * @ngdoc directive
	   * @name mdFabActions
	   * @module material.components.fabActions
	   *
	   * @restrict E
	   *
	   * @description
	   * The `<md-fab-actions>` directive is used inside of a `<md-fab-speed-dial>` or
	   * `<md-fab-toolbar>` directive to mark an element (or elements) as the actions and setup the
	   * proper event listeners.
	   *
	   * @usage
	   * See the `<md-fab-speed-dial>` or `<md-fab-toolbar>` directives for example usage.
	   */
	  function MdFabActionsDirective($mdUtil) {
	    return {
	      restrict: 'E',
	
	      require: ['^?mdFabSpeedDial', '^?mdFabToolbar'],
	
	      compile: function(element, attributes) {
	        var children = element.children();
	
	        var hasNgRepeat = $mdUtil.prefixer().hasAttribute(children, 'ng-repeat');
	
	        // Support both ng-repeat and static content
	        if (hasNgRepeat) {
	          children.addClass('md-fab-action-item');
	        } else {
	          // Wrap every child in a new div and add a class that we can scale/fling independently
	          children.wrap('<div class="md-fab-action-item">');
	        }
	      }
	    };
	  }
	
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  MdFabController.$inject = ["$scope", "$element", "$animate", "$mdUtil", "$mdConstant", "$timeout"];
	  angular.module('material.components.fabShared', ['material.core'])
	    .controller('MdFabController', MdFabController);
	
	  function MdFabController($scope, $element, $animate, $mdUtil, $mdConstant, $timeout) {
	    var vm = this;
	    var initialAnimationAttempts = 0;
	
	    // NOTE: We use async eval(s) below to avoid conflicts with any existing digest loops
	
	    vm.open = function() {
	      $scope.$evalAsync("vm.isOpen = true");
	    };
	
	    vm.close = function() {
	      // Async eval to avoid conflicts with existing digest loops
	      $scope.$evalAsync("vm.isOpen = false");
	
	      // Focus the trigger when the element closes so users can still tab to the next item
	      $element.find('md-fab-trigger')[0].focus();
	    };
	
	    // Toggle the open/close state when the trigger is clicked
	    vm.toggle = function() {
	      $scope.$evalAsync("vm.isOpen = !vm.isOpen");
	    };
	
	    /*
	     * AngularJS Lifecycle hook for newer AngularJS versions.
	     * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
	     */
	    vm.$onInit = function() {
	      setupDefaults();
	      setupListeners();
	      setupWatchers();
	
	      fireInitialAnimations();
	    };
	
	    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	    // manually call the $onInit hook.
	    if (angular.version.major === 1 && angular.version.minor <= 4) {
	      this.$onInit();
	    }
	
	    function setupDefaults() {
	      // Set the default direction to 'down' if none is specified
	      vm.direction = vm.direction || 'down';
	
	      // Set the default to be closed
	      vm.isOpen = vm.isOpen || false;
	
	      // Start the keyboard interaction at the first action
	      resetActionIndex();
	
	      // Add an animations waiting class so we know not to run
	      $element.addClass('md-animations-waiting');
	    }
	
	    function setupListeners() {
	      var eventTypes = [
	        'click', 'focusin', 'focusout'
	      ];
	
	      // Add our listeners
	      angular.forEach(eventTypes, function(eventType) {
	        $element.on(eventType, parseEvents);
	      });
	
	      // Remove our listeners when destroyed
	      $scope.$on('$destroy', function() {
	        angular.forEach(eventTypes, function(eventType) {
	          $element.off(eventType, parseEvents);
	        });
	
	        // remove any attached keyboard handlers in case element is removed while
	        // speed dial is open
	        disableKeyboard();
	      });
	    }
	
	    var closeTimeout;
	    function parseEvents(event) {
	      // If the event is a click, just handle it
	      if (event.type == 'click') {
	        handleItemClick(event);
	      }
	
	      // If we focusout, set a timeout to close the element
	      if (event.type == 'focusout' && !closeTimeout) {
	        closeTimeout = $timeout(function() {
	          vm.close();
	        }, 100, false);
	      }
	
	      // If we see a focusin and there is a timeout about to run, cancel it so we stay open
	      if (event.type == 'focusin' && closeTimeout) {
	        $timeout.cancel(closeTimeout);
	        closeTimeout = null;
	      }
	    }
	
	    function resetActionIndex() {
	      vm.currentActionIndex = -1;
	    }
	
	    function setupWatchers() {
	      // Watch for changes to the direction and update classes/attributes
	      $scope.$watch('vm.direction', function(newDir, oldDir) {
	        // Add the appropriate classes so we can target the direction in the CSS
	        $animate.removeClass($element, 'md-' + oldDir);
	        $animate.addClass($element, 'md-' + newDir);
	
	        // Reset the action index since it may have changed
	        resetActionIndex();
	      });
	
	      var trigger, actions;
	
	      // Watch for changes to md-open
	      $scope.$watch('vm.isOpen', function(isOpen) {
	        // Reset the action index since it may have changed
	        resetActionIndex();
	
	        // We can't get the trigger/actions outside of the watch because the component hasn't been
	        // linked yet, so we wait until the first watch fires to cache them.
	        if (!trigger || !actions) {
	          trigger = getTriggerElement();
	          actions = getActionsElement();
	        }
	
	        if (isOpen) {
	          enableKeyboard();
	        } else {
	          disableKeyboard();
	        }
	
	        var toAdd = isOpen ? 'md-is-open' : '';
	        var toRemove = isOpen ? '' : 'md-is-open';
	
	        // Set the proper ARIA attributes
	        trigger.attr('aria-haspopup', true);
	        trigger.attr('aria-expanded', isOpen);
	        actions.attr('aria-hidden', !isOpen);
	
	        // Animate the CSS classes
	        $animate.setClass($element, toAdd, toRemove);
	      });
	    }
	
	    function fireInitialAnimations() {
	      // If the element is actually visible on the screen
	      if ($element[0].scrollHeight > 0) {
	        // Fire our animation
	        $animate.addClass($element, '_md-animations-ready').then(function() {
	          // Remove the waiting class
	          $element.removeClass('md-animations-waiting');
	        });
	      }
	
	      // Otherwise, try for up to 1 second before giving up
	      else if (initialAnimationAttempts < 10) {
	        $timeout(fireInitialAnimations, 100);
	
	        // Increment our counter
	        initialAnimationAttempts = initialAnimationAttempts + 1;
	      }
	    }
	
	    function enableKeyboard() {
	      $element.on('keydown', keyPressed);
	
	      // On the next tick, setup a check for outside clicks; we do this on the next tick to avoid
	      // clicks/touches that result in the isOpen attribute changing (e.g. a bound radio button)
	      $mdUtil.nextTick(function() {
	        angular.element(document).on('click touchend', checkForOutsideClick);
	      });
	
	      // TODO: On desktop, we should be able to reset the indexes so you cannot tab through, but
	      // this breaks accessibility, especially on mobile, since you have no arrow keys to press
	      // resetActionTabIndexes();
	    }
	
	    function disableKeyboard() {
	      $element.off('keydown', keyPressed);
	      angular.element(document).off('click touchend', checkForOutsideClick);
	    }
	
	    function checkForOutsideClick(event) {
	      if (event.target) {
	        var closestTrigger = $mdUtil.getClosest(event.target, 'md-fab-trigger');
	        var closestActions = $mdUtil.getClosest(event.target, 'md-fab-actions');
	
	        if (!closestTrigger && !closestActions) {
	          vm.close();
	        }
	      }
	    }
	
	    function keyPressed(event) {
	      switch (event.which) {
	        case $mdConstant.KEY_CODE.ESCAPE: vm.close(); event.preventDefault(); return false;
	        case $mdConstant.KEY_CODE.LEFT_ARROW: doKeyLeft(event); return false;
	        case $mdConstant.KEY_CODE.UP_ARROW: doKeyUp(event); return false;
	        case $mdConstant.KEY_CODE.RIGHT_ARROW: doKeyRight(event); return false;
	        case $mdConstant.KEY_CODE.DOWN_ARROW: doKeyDown(event); return false;
	      }
	    }
	
	    function doActionPrev(event) {
	      focusAction(event, -1);
	    }
	
	    function doActionNext(event) {
	      focusAction(event, 1);
	    }
	
	    function focusAction(event, direction) {
	      var actions = resetActionTabIndexes();
	
	      // Increment/decrement the counter with restrictions
	      vm.currentActionIndex = vm.currentActionIndex + direction;
	      vm.currentActionIndex = Math.min(actions.length - 1, vm.currentActionIndex);
	      vm.currentActionIndex = Math.max(0, vm.currentActionIndex);
	
	      // Focus the element
	      var focusElement =  angular.element(actions[vm.currentActionIndex]).children()[0];
	      angular.element(focusElement).attr('tabindex', 0);
	      focusElement.focus();
	
	      // Make sure the event doesn't bubble and cause something else
	      event.preventDefault();
	      event.stopImmediatePropagation();
	    }
	
	    function resetActionTabIndexes() {
	      // Grab all of the actions
	      var actions = getActionsElement()[0].querySelectorAll('.md-fab-action-item');
	
	      // Disable all other actions for tabbing
	      angular.forEach(actions, function(action) {
	        angular.element(angular.element(action).children()[0]).attr('tabindex', -1);
	      });
	
	      return actions;
	    }
	
	    function doKeyLeft(event) {
	      if (vm.direction === 'left') {
	        doActionNext(event);
	      } else {
	        doActionPrev(event);
	      }
	    }
	
	    function doKeyUp(event) {
	      if (vm.direction === 'down') {
	        doActionPrev(event);
	      } else {
	        doActionNext(event);
	      }
	    }
	
	    function doKeyRight(event) {
	      if (vm.direction === 'left') {
	        doActionPrev(event);
	      } else {
	        doActionNext(event);
	      }
	    }
	
	    function doKeyDown(event) {
	      if (vm.direction === 'up') {
	        doActionPrev(event);
	      } else {
	        doActionNext(event);
	      }
	    }
	
	    function isTrigger(element) {
	      return $mdUtil.getClosest(element, 'md-fab-trigger');
	    }
	
	    function isAction(element) {
	      return $mdUtil.getClosest(element, 'md-fab-actions');
	    }
	
	    function handleItemClick(event) {
	      if (isTrigger(event.target)) {
	        vm.toggle();
	      }
	
	      if (isAction(event.target)) {
	        vm.close();
	      }
	    }
	
	    function getTriggerElement() {
	      return $element.find('md-fab-trigger');
	    }
	
	    function getActionsElement() {
	      return $element.find('md-fab-actions');
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * The duration of the CSS animation in milliseconds.
	   *
	   * @type {number}
	   */
	  MdFabSpeedDialFlingAnimation.$inject = ["$timeout"];
	  MdFabSpeedDialScaleAnimation.$inject = ["$timeout"];
	  var cssAnimationDuration = 300;
	
	  /**
	   * @ngdoc module
	   * @name material.components.fabSpeedDial
	   */
	  angular
	    // Declare our module
	    .module('material.components.fabSpeedDial', [
	      'material.core',
	      'material.components.fabShared',
	      'material.components.fabActions'
	    ])
	
	    // Register our directive
	    .directive('mdFabSpeedDial', MdFabSpeedDialDirective)
	
	    // Register our custom animations
	    .animation('.md-fling', MdFabSpeedDialFlingAnimation)
	    .animation('.md-scale', MdFabSpeedDialScaleAnimation)
	
	    // Register a service for each animation so that we can easily inject them into unit tests
	    .service('mdFabSpeedDialFlingAnimation', MdFabSpeedDialFlingAnimation)
	    .service('mdFabSpeedDialScaleAnimation', MdFabSpeedDialScaleAnimation);
	
	  /**
	   * @ngdoc directive
	   * @name mdFabSpeedDial
	   * @module material.components.fabSpeedDial
	   *
	   * @restrict E
	   *
	   * @description
	   * The `<md-fab-speed-dial>` directive is used to present a series of popup elements (usually
	   * `<md-button>`s) for quick access to common actions.
	   *
	   * There are currently two animations available by applying one of the following classes to
	   * the component:
	   *
	   *  - `md-fling` - The speed dial items appear from underneath the trigger and move into their
	   *    appropriate positions.
	   *  - `md-scale` - The speed dial items appear in their proper places by scaling from 0% to 100%.
	   *
	   * You may also easily position the trigger by applying one one of the following classes to the
	   * `<md-fab-speed-dial>` element:
	   *  - `md-fab-top-left`
	   *  - `md-fab-top-right`
	   *  - `md-fab-bottom-left`
	   *  - `md-fab-bottom-right`
	   *
	   * These CSS classes use `position: absolute`, so you need to ensure that the container element
	   * also uses `position: absolute` or `position: relative` in order for them to work.
	   *
	   * Additionally, you may use the standard `ng-mouseenter` and `ng-mouseleave` directives to
	   * open or close the speed dial. However, if you wish to allow users to hover over the empty
	   * space where the actions will appear, you must also add the `md-hover-full` class to the speed
	   * dial element. Without this, the hover effect will only occur on top of the trigger.
	   *
	   * See the demos for more information.
	   *
	   * ## Troubleshooting
	   *
	   * If your speed dial shows the closing animation upon launch, you may need to use `ng-cloak` on
	   * the parent container to ensure that it is only visible once ready. We have plans to remove this
	   * necessity in the future.
	   *
	   * @usage
	   * <hljs lang="html">
	   * <md-fab-speed-dial md-direction="up" class="md-fling">
	   *   <md-fab-trigger>
	   *     <md-button aria-label="Add..."><md-icon md-svg-src="/img/icons/plus.svg"></md-icon></md-button>
	   *   </md-fab-trigger>
	   *
	   *   <md-fab-actions>
	   *     <md-button aria-label="Add User">
	   *       <md-icon md-svg-src="/img/icons/user.svg"></md-icon>
	   *     </md-button>
	   *
	   *     <md-button aria-label="Add Group">
	   *       <md-icon md-svg-src="/img/icons/group.svg"></md-icon>
	   *     </md-button>
	   *   </md-fab-actions>
	   * </md-fab-speed-dial>
	   * </hljs>
	   *
	   * @param {string} md-direction From which direction you would like the speed dial to appear
	   * relative to the trigger element.
	   * @param {expression=} md-open Programmatically control whether or not the speed-dial is visible.
	   */
	  function MdFabSpeedDialDirective() {
	    return {
	      restrict: 'E',
	
	      scope: {
	        direction: '@?mdDirection',
	        isOpen: '=?mdOpen'
	      },
	
	      bindToController: true,
	      controller: 'MdFabController',
	      controllerAs: 'vm',
	
	      link: FabSpeedDialLink
	    };
	
	    function FabSpeedDialLink(scope, element) {
	      // Prepend an element to hold our CSS variables so we can use them in the animations below
	      element.prepend('<div class="_md-css-variables"></div>');
	    }
	  }
	
	  function MdFabSpeedDialFlingAnimation($timeout) {
	    function delayDone(done) { $timeout(done, cssAnimationDuration, false); }
	
	    function runAnimation(element) {
	      // Don't run if we are still waiting and we are not ready
	      if (element.hasClass('md-animations-waiting') && !element.hasClass('_md-animations-ready')) {
	        return;
	      }
	
	      var el = element[0];
	      var ctrl = element.controller('mdFabSpeedDial');
	      var items = el.querySelectorAll('.md-fab-action-item');
	
	      // Grab our trigger element
	      var triggerElement = el.querySelector('md-fab-trigger');
	
	      // Grab our element which stores CSS variables
	      var variablesElement = el.querySelector('._md-css-variables');
	
	      // Setup JS variables based on our CSS variables
	      var startZIndex = parseInt(window.getComputedStyle(variablesElement).zIndex);
	
	      // Always reset the items to their natural position/state
	      angular.forEach(items, function(item, index) {
	        var styles = item.style;
	
	        styles.transform = styles.webkitTransform = '';
	        styles.transitionDelay = '';
	        styles.opacity = 1;
	
	        // Make the items closest to the trigger have the highest z-index
	        styles.zIndex = (items.length - index) + startZIndex;
	      });
	
	      // Set the trigger to be above all of the actions so they disappear behind it.
	      triggerElement.style.zIndex = startZIndex + items.length + 1;
	
	      // If the control is closed, hide the items behind the trigger
	      if (!ctrl.isOpen) {
	        angular.forEach(items, function(item, index) {
	          var newPosition, axis;
	          var styles = item.style;
	
	          // Make sure to account for differences in the dimensions of the trigger verses the items
	          // so that we can properly center everything; this helps hide the item's shadows behind
	          // the trigger.
	          var triggerItemHeightOffset = (triggerElement.clientHeight - item.clientHeight) / 2;
	          var triggerItemWidthOffset = (triggerElement.clientWidth - item.clientWidth) / 2;
	
	          switch (ctrl.direction) {
	            case 'up':
	              newPosition = (item.scrollHeight * (index + 1) + triggerItemHeightOffset);
	              axis = 'Y';
	              break;
	            case 'down':
	              newPosition = -(item.scrollHeight * (index + 1) + triggerItemHeightOffset);
	              axis = 'Y';
	              break;
	            case 'left':
	              newPosition = (item.scrollWidth * (index + 1) + triggerItemWidthOffset);
	              axis = 'X';
	              break;
	            case 'right':
	              newPosition = -(item.scrollWidth * (index + 1) + triggerItemWidthOffset);
	              axis = 'X';
	              break;
	          }
	
	          var newTranslate = 'translate' + axis + '(' + newPosition + 'px)';
	
	          styles.transform = styles.webkitTransform = newTranslate;
	        });
	      }
	    }
	
	    return {
	      addClass: function(element, className, done) {
	        if (element.hasClass('md-fling')) {
	          runAnimation(element);
	          delayDone(done);
	        } else {
	          done();
	        }
	      },
	      removeClass: function(element, className, done) {
	        runAnimation(element);
	        delayDone(done);
	      }
	    };
	  }
	
	  function MdFabSpeedDialScaleAnimation($timeout) {
	    function delayDone(done) { $timeout(done, cssAnimationDuration, false); }
	
	    var delay = 65;
	
	    function runAnimation(element) {
	      var el = element[0];
	      var ctrl = element.controller('mdFabSpeedDial');
	      var items = el.querySelectorAll('.md-fab-action-item');
	
	      // Grab our element which stores CSS variables
	      var variablesElement = el.querySelector('._md-css-variables');
	
	      // Setup JS variables based on our CSS variables
	      var startZIndex = parseInt(window.getComputedStyle(variablesElement).zIndex);
	
	      // Always reset the items to their natural position/state
	      angular.forEach(items, function(item, index) {
	        var styles = item.style,
	          offsetDelay = index * delay;
	
	        styles.opacity = ctrl.isOpen ? 1 : 0;
	        styles.transform = styles.webkitTransform = ctrl.isOpen ? 'scale(1)' : 'scale(0)';
	        styles.transitionDelay = (ctrl.isOpen ? offsetDelay : (items.length - offsetDelay)) + 'ms';
	
	        // Make the items closest to the trigger have the highest z-index
	        styles.zIndex = (items.length - index) + startZIndex;
	      });
	    }
	
	    return {
	      addClass: function(element, className, done) {
	        runAnimation(element);
	        delayDone(done);
	      },
	
	      removeClass: function(element, className, done) {
	        runAnimation(element);
	        delayDone(done);
	      }
	    };
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc module
	   * @name material.components.fabToolbar
	   */
	  angular
	    // Declare our module
	    .module('material.components.fabToolbar', [
	      'material.core',
	      'material.components.fabShared',
	      'material.components.fabActions'
	    ])
	
	    // Register our directive
	    .directive('mdFabToolbar', MdFabToolbarDirective)
	
	    // Register our custom animations
	    .animation('.md-fab-toolbar', MdFabToolbarAnimation)
	
	    // Register a service for the animation so that we can easily inject it into unit tests
	    .service('mdFabToolbarAnimation', MdFabToolbarAnimation);
	
	  /**
	   * @ngdoc directive
	   * @name mdFabToolbar
	   * @module material.components.fabToolbar
	   *
	   * @restrict E
	   *
	   * @description
	   *
	   * The `<md-fab-toolbar>` directive is used to present a toolbar of elements (usually `<md-button>`s)
	   * for quick access to common actions when a floating action button is activated (via click or
	   * keyboard navigation).
	   *
	   * You may also easily position the trigger by applying one one of the following classes to the
	   * `<md-fab-toolbar>` element:
	   *  - `md-fab-top-left`
	   *  - `md-fab-top-right`
	   *  - `md-fab-bottom-left`
	   *  - `md-fab-bottom-right`
	   *
	   * These CSS classes use `position: absolute`, so you need to ensure that the container element
	   * also uses `position: absolute` or `position: relative` in order for them to work.
	   *
	   * @usage
	   *
	   * <hljs lang="html">
	   * <md-fab-toolbar md-direction='left'>
	   *   <md-fab-trigger>
	   *     <md-button aria-label="Add..."><md-icon md-svg-src="/img/icons/plus.svg"></md-icon></md-button>
	   *   </md-fab-trigger>
	   *
	   *   <md-toolbar>
	   *    <md-fab-actions>
	   *      <md-button aria-label="Add User">
	   *        <md-icon md-svg-src="/img/icons/user.svg"></md-icon>
	   *      </md-button>
	   *
	   *      <md-button aria-label="Add Group">
	   *        <md-icon md-svg-src="/img/icons/group.svg"></md-icon>
	   *      </md-button>
	   *    </md-fab-actions>
	   *   </md-toolbar>
	   * </md-fab-toolbar>
	   * </hljs>
	   *
	   * @param {string} md-direction From which direction you would like the toolbar items to appear
	   * relative to the trigger element. Supports `left` and `right` directions.
	   * @param {expression=} md-open Programmatically control whether or not the toolbar is visible.
	   */
	  function MdFabToolbarDirective() {
	    return {
	      restrict: 'E',
	      transclude: true,
	      template: '<div class="md-fab-toolbar-wrapper">' +
	      '  <div class="md-fab-toolbar-content" ng-transclude></div>' +
	      '</div>',
	
	      scope: {
	        direction: '@?mdDirection',
	        isOpen: '=?mdOpen'
	      },
	
	      bindToController: true,
	      controller: 'MdFabController',
	      controllerAs: 'vm',
	
	      link: link
	    };
	
	    function link(scope, element, attributes) {
	      // Add the base class for animations
	      element.addClass('md-fab-toolbar');
	
	      // Prepend the background element to the trigger's button
	      element.find('md-fab-trigger').find('button')
	        .prepend('<div class="md-fab-toolbar-background"></div>');
	    }
	  }
	
	  function MdFabToolbarAnimation() {
	
	    function runAnimation(element, className, done) {
	      // If no className was specified, don't do anything
	      if (!className) {
	        return;
	      }
	
	      var el = element[0];
	      var ctrl = element.controller('mdFabToolbar');
	
	      // Grab the relevant child elements
	      var backgroundElement = el.querySelector('.md-fab-toolbar-background');
	      var triggerElement = el.querySelector('md-fab-trigger button');
	      var toolbarElement = el.querySelector('md-toolbar');
	      var iconElement = el.querySelector('md-fab-trigger button md-icon');
	      var actions = element.find('md-fab-actions').children();
	
	      // If we have both elements, use them to position the new background
	      if (triggerElement && backgroundElement) {
	        // Get our variables
	        var color = window.getComputedStyle(triggerElement).getPropertyValue('background-color');
	        var width = el.offsetWidth;
	        var height = el.offsetHeight;
	
	        // Make it twice as big as it should be since we scale from the center
	        var scale = 2 * (width / triggerElement.offsetWidth);
	
	        // Set some basic styles no matter what animation we're doing
	        backgroundElement.style.backgroundColor = color;
	        backgroundElement.style.borderRadius = width + 'px';
	
	        // If we're open
	        if (ctrl.isOpen) {
	          // Turn on toolbar pointer events when closed
	          toolbarElement.style.pointerEvents = 'inherit';
	
	          backgroundElement.style.width = triggerElement.offsetWidth + 'px';
	          backgroundElement.style.height = triggerElement.offsetHeight + 'px';
	          backgroundElement.style.transform = 'scale(' + scale + ')';
	
	          // Set the next close animation to have the proper delays
	          backgroundElement.style.transitionDelay = '0ms';
	          iconElement && (iconElement.style.transitionDelay = '.3s');
	
	          // Apply a transition delay to actions
	          angular.forEach(actions, function(action, index) {
	            action.style.transitionDelay = (actions.length - index) * 25 + 'ms';
	          });
	        } else {
	          // Turn off toolbar pointer events when closed
	          toolbarElement.style.pointerEvents = 'none';
	
	          // Scale it back down to the trigger's size
	          backgroundElement.style.transform = 'scale(1)';
	
	          // Reset the position
	          backgroundElement.style.top = '0';
	
	          if (element.hasClass('md-right')) {
	            backgroundElement.style.left = '0';
	            backgroundElement.style.right = null;
	          }
	
	          if (element.hasClass('md-left')) {
	            backgroundElement.style.right = '0';
	            backgroundElement.style.left = null;
	          }
	
	          // Set the next open animation to have the proper delays
	          backgroundElement.style.transitionDelay = '200ms';
	          iconElement && (iconElement.style.transitionDelay = '0ms');
	
	          // Apply a transition delay to actions
	          angular.forEach(actions, function(action, index) {
	            action.style.transitionDelay = 200 + (index * 25) + 'ms';
	          });
	        }
	      }
	    }
	
	    return {
	      addClass: function(element, className, done) {
	        runAnimation(element, className, done);
	        done();
	      },
	
	      removeClass: function(element, className, done) {
	        runAnimation(element, className, done);
	        done();
	      }
	    };
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.gridList
	 */
	GridListController.$inject = ["$mdUtil"];
	GridLayoutFactory.$inject = ["$mdUtil"];
	GridListDirective.$inject = ["$interpolate", "$mdConstant", "$mdGridLayout", "$mdMedia", "$mdUtil"];
	GridTileDirective.$inject = ["$mdMedia"];
	angular.module('material.components.gridList', ['material.core'])
	       .directive('mdGridList', GridListDirective)
	       .directive('mdGridTile', GridTileDirective)
	       .directive('mdGridTileFooter', GridTileCaptionDirective)
	       .directive('mdGridTileHeader', GridTileCaptionDirective)
	       .factory('$mdGridLayout', GridLayoutFactory);
	
	/**
	 * @ngdoc directive
	 * @name mdGridList
	 * @module material.components.gridList
	 * @restrict E
	 * @description
	 * Grid lists are an alternative to standard list views. Grid lists are distinct
	 * from grids used for layouts and other visual presentations.
	 *
	 * A grid list is best suited to presenting a homogenous data type, typically
	 * images, and is optimized for visual comprehension and differentiating between
	 * like data types.
	 *
	 * A grid list is a continuous element consisting of tessellated, regular
	 * subdivisions called cells that contain tiles (`md-grid-tile`).
	 *
	 * <img src="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7OVlEaXZ5YmU1Xzg/components_grids_usage2.png"
	 *    style="width: 300px; height: auto; margin-right: 16px;" alt="Concept of grid explained visually">
	 * <img src="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7VGhsOE5idWlJWXM/components_grids_usage3.png"
	 *    style="width: 300px; height: auto;" alt="Grid concepts legend">
	 *
	 * Cells are arrayed vertically and horizontally within the grid.
	 *
	 * Tiles hold content and can span one or more cells vertically or horizontally.
	 *
	 * ### Responsive Attributes
	 *
	 * The `md-grid-list` directive supports "responsive" attributes, which allow
	 * different `md-cols`, `md-gutter` and `md-row-height` values depending on the
	 * currently matching media query.
	 *
	 * In order to set a responsive attribute, first define the fallback value with
	 * the standard attribute name, then add additional attributes with the
	 * following convention: `{base-attribute-name}-{media-query-name}="{value}"`
	 * (ie. `md-cols-lg="8"`)
	 *
	 * @param {number} md-cols Number of columns in the grid.
	 * @param {string} md-row-height One of
	 * <ul>
	 *   <li>CSS length - Fixed height rows (eg. `8px` or `1rem`)</li>
	 *   <li>`{width}:{height}` - Ratio of width to height (eg.
	 *   `md-row-height="16:9"`)</li>
	 *   <li>`"fit"` - Height will be determined by subdividing the available
	 *   height by the number of rows</li>
	 * </ul>
	 * @param {string=} md-gutter The amount of space between tiles in CSS units
	 *     (default 1px)
	 * @param {expression=} md-on-layout Expression to evaluate after layout. Event
	 *     object is available as `$event`, and contains performance information.
	 *
	 * @usage
	 * Basic:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="5" md-gutter="1em" md-row-height="4:3">
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Fixed-height rows:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="4" md-row-height="200px" ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Fit rows:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="4" md-row-height="fit" style="height: 400px;" ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Using responsive attributes:
	 * <hljs lang="html">
	 * <md-grid-list
	 *     md-cols-sm="2"
	 *     md-cols-md="4"
	 *     md-cols-lg="8"
	 *     md-cols-gt-lg="12"
	 *     ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 */
	function GridListDirective($interpolate, $mdConstant, $mdGridLayout, $mdMedia, $mdUtil) {
	  return {
	    restrict: 'E',
	    controller: GridListController,
	    scope: {
	      mdOnLayout: '&'
	    },
	    link: postLink
	  };
	
	  function postLink(scope, element, attrs, ctrl) {
	    element.addClass('_md');     // private md component indicator for styling
	
	    // Apply semantics
	    element.attr('role', 'list');
	
	    // Provide the controller with a way to trigger layouts.
	    ctrl.layoutDelegate = layoutDelegate;
	
	    var invalidateLayout = angular.bind(ctrl, ctrl.invalidateLayout),
	        unwatchAttrs = watchMedia();
	      scope.$on('$destroy', unwatchMedia);
	
	    /**
	     * Watches for changes in media, invalidating layout as necessary.
	     */
	    function watchMedia() {
	      for (var mediaName in $mdConstant.MEDIA) {
	        $mdMedia(mediaName); // initialize
	        $mdMedia.getQuery($mdConstant.MEDIA[mediaName])
	            .addListener(invalidateLayout);
	      }
	      return $mdMedia.watchResponsiveAttributes(
	          ['md-cols', 'md-row-height', 'md-gutter'], attrs, layoutIfMediaMatch);
	    }
	
	    function unwatchMedia() {
	      ctrl.layoutDelegate = angular.noop;
	
	      unwatchAttrs();
	      for (var mediaName in $mdConstant.MEDIA) {
	        $mdMedia.getQuery($mdConstant.MEDIA[mediaName])
	            .removeListener(invalidateLayout);
	      }
	    }
	
	    /**
	     * Performs grid layout if the provided mediaName matches the currently
	     * active media type.
	     */
	    function layoutIfMediaMatch(mediaName) {
	      if (mediaName == null) {
	        // TODO(shyndman): It would be nice to only layout if we have
	        // instances of attributes using this media type
	        ctrl.invalidateLayout();
	      } else if ($mdMedia(mediaName)) {
	        ctrl.invalidateLayout();
	      }
	    }
	
	    var lastLayoutProps;
	
	    /**
	     * Invokes the layout engine, and uses its results to lay out our
	     * tile elements.
	     *
	     * @param {boolean} tilesInvalidated Whether tiles have been
	     *    added/removed/moved since the last layout. This is to avoid situations
	     *    where tiles are replaced with properties identical to their removed
	     *    counterparts.
	     */
	    function layoutDelegate(tilesInvalidated) {
	      var tiles = getTileElements();
	      var props = {
	        tileSpans: getTileSpans(tiles),
	        colCount: getColumnCount(),
	        rowMode: getRowMode(),
	        rowHeight: getRowHeight(),
	        gutter: getGutter()
	      };
	
	      if (!tilesInvalidated && angular.equals(props, lastLayoutProps)) {
	        return;
	      }
	
	      var performance =
	        $mdGridLayout(props.colCount, props.tileSpans, tiles)
	          .map(function(tilePositions, rowCount) {
	            return {
	              grid: {
	                element: element,
	                style: getGridStyle(props.colCount, rowCount,
	                    props.gutter, props.rowMode, props.rowHeight)
	              },
	              tiles: tilePositions.map(function(ps, i) {
	                return {
	                  element: angular.element(tiles[i]),
	                  style: getTileStyle(ps.position, ps.spans,
	                      props.colCount, rowCount,
	                      props.gutter, props.rowMode, props.rowHeight)
	                };
	              })
	            };
	          })
	          .reflow()
	          .performance();
	
	      // Report layout
	      scope.mdOnLayout({
	        $event: {
	          performance: performance
	        }
	      });
	
	      lastLayoutProps = props;
	    }
	
	    // Use $interpolate to do some simple string interpolation as a convenience.
	
	    var startSymbol = $interpolate.startSymbol();
	    var endSymbol = $interpolate.endSymbol();
	
	    // Returns an expression wrapped in the interpolator's start and end symbols.
	    function expr(exprStr) {
	      return startSymbol + exprStr + endSymbol;
	    }
	
	    // The amount of space a single 1x1 tile would take up (either width or height), used as
	    // a basis for other calculations. This consists of taking the base size percent (as would be
	    // if evenly dividing the size between cells), and then subtracting the size of one gutter.
	    // However, since there are no gutters on the edges, each tile only uses a fration
	    // (gutterShare = numGutters / numCells) of the gutter size. (Imagine having one gutter per
	    // tile, and then breaking up the extra gutter on the edge evenly among the cells).
	    var UNIT = $interpolate(expr('share') + '% - (' + expr('gutter') + ' * ' + expr('gutterShare') + ')');
	
	    // The horizontal or vertical position of a tile, e.g., the 'top' or 'left' property value.
	    // The position comes the size of a 1x1 tile plus gutter for each previous tile in the
	    // row/column (offset).
	    var POSITION  = $interpolate('calc((' + expr('unit') + ' + ' + expr('gutter') + ') * ' + expr('offset') + ')');
	
	    // The actual size of a tile, e.g., width or height, taking rowSpan or colSpan into account.
	    // This is computed by multiplying the base unit by the rowSpan/colSpan, and then adding back
	    // in the space that the gutter would normally have used (which was already accounted for in
	    // the base unit calculation).
	    var DIMENSION = $interpolate('calc((' + expr('unit') + ') * ' + expr('span') + ' + (' + expr('span') + ' - 1) * ' + expr('gutter') + ')');
	
	    /**
	     * Gets the styles applied to a tile element described by the given parameters.
	     * @param {{row: number, col: number}} position The row and column indices of the tile.
	     * @param {{row: number, col: number}} spans The rowSpan and colSpan of the tile.
	     * @param {number} colCount The number of columns.
	     * @param {number} rowCount The number of rows.
	     * @param {string} gutter The amount of space between tiles. This will be something like
	     *     '5px' or '2em'.
	     * @param {string} rowMode The row height mode. Can be one of:
	     *     'fixed': all rows have a fixed size, given by rowHeight,
	     *     'ratio': row height defined as a ratio to width, or
	     *     'fit': fit to the grid-list element height, divinding evenly among rows.
	     * @param {string|number} rowHeight The height of a row. This is only used for 'fixed' mode and
	     *     for 'ratio' mode. For 'ratio' mode, this is the *ratio* of width-to-height (e.g., 0.75).
	     * @returns {Object} Map of CSS properties to be applied to the style element. Will define
	     *     values for top, left, width, height, marginTop, and paddingTop.
	     */
	    function getTileStyle(position, spans, colCount, rowCount, gutter, rowMode, rowHeight) {
	      // TODO(shyndman): There are style caching opportunities here.
	
	      // Percent of the available horizontal space that one column takes up.
	      var hShare = (1 / colCount) * 100;
	
	      // Fraction of the gutter size that each column takes up.
	      var hGutterShare = (colCount - 1) / colCount;
	
	      // Base horizontal size of a column.
	      var hUnit = UNIT({share: hShare, gutterShare: hGutterShare, gutter: gutter});
	
	      // The width and horizontal position of each tile is always calculated the same way, but the
	      // height and vertical position depends on the rowMode.
	      var style = (!$mdUtil.isRtl(attrs)) ? {
	          left: POSITION({ unit: hUnit, offset: position.col, gutter: gutter }),
	          width: DIMENSION({ unit: hUnit, span: spans.col, gutter: gutter }),
	          // resets
	          paddingTop: '',
	          marginTop: '',
	          top: '',
	          height: ''
	        } : {
	        right: POSITION({ unit: hUnit, offset: position.col, gutter: gutter }),
	        width: DIMENSION({ unit: hUnit, span: spans.col, gutter: gutter }),
	        // resets
	        paddingTop: '',
	        marginTop: '',
	        top: '',
	        height: ''
	      };
	
	      switch (rowMode) {
	        case 'fixed':
	          // In fixed mode, simply use the given rowHeight.
	          style.top = POSITION({ unit: rowHeight, offset: position.row, gutter: gutter });
	          style.height = DIMENSION({ unit: rowHeight, span: spans.row, gutter: gutter });
	          break;
	
	        case 'ratio':
	          // Percent of the available vertical space that one row takes up. Here, rowHeight holds
	          // the ratio value. For example, if the width:height ratio is 4:3, rowHeight = 1.333.
	          var vShare = hShare / rowHeight;
	
	          // Base veritcal size of a row.
	          var vUnit = UNIT({ share: vShare, gutterShare: hGutterShare, gutter: gutter });
	
	          // padidngTop and marginTop are used to maintain the given aspect ratio, as
	          // a percentage-based value for these properties is applied to the *width* of the
	          // containing block. See http://www.w3.org/TR/CSS2/box.html#margin-properties
	          style.paddingTop = DIMENSION({ unit: vUnit, span: spans.row, gutter: gutter});
	          style.marginTop = POSITION({ unit: vUnit, offset: position.row, gutter: gutter });
	          break;
	
	        case 'fit':
	          // Fraction of the gutter size that each column takes up.
	          var vGutterShare = (rowCount - 1) / rowCount;
	
	          // Percent of the available vertical space that one row takes up.
	          vShare = (1 / rowCount) * 100;
	
	          // Base vertical size of a row.
	          vUnit = UNIT({share: vShare, gutterShare: vGutterShare, gutter: gutter});
	
	          style.top = POSITION({unit: vUnit, offset: position.row, gutter: gutter});
	          style.height = DIMENSION({unit: vUnit, span: spans.row, gutter: gutter});
	          break;
	      }
	
	      return style;
	    }
	
	    function getGridStyle(colCount, rowCount, gutter, rowMode, rowHeight) {
	      var style = {};
	
	      switch (rowMode) {
	        case 'fixed':
	          style.height = DIMENSION({ unit: rowHeight, span: rowCount, gutter: gutter });
	          style.paddingBottom = '';
	          break;
	
	        case 'ratio':
	          // rowHeight is width / height
	          var hGutterShare = colCount === 1 ? 0 : (colCount - 1) / colCount,
	              hShare = (1 / colCount) * 100,
	              vShare = hShare * (1 / rowHeight),
	              vUnit = UNIT({ share: vShare, gutterShare: hGutterShare, gutter: gutter });
	
	          style.height = '';
	          style.paddingBottom = DIMENSION({ unit: vUnit, span: rowCount, gutter: gutter});
	          break;
	
	        case 'fit':
	          // noop, as the height is user set
	          break;
	      }
	
	      return style;
	    }
	
	    function getTileElements() {
	      return [].filter.call(element.children(), function(ele) {
	        return ele.tagName == 'MD-GRID-TILE' && !ele.$$mdDestroyed;
	      });
	    }
	
	    /**
	     * Gets an array of objects containing the rowspan and colspan for each tile.
	     * @returns {Array<{row: number, col: number}>}
	     */
	    function getTileSpans(tileElements) {
	      return [].map.call(tileElements, function(ele) {
	        var ctrl = angular.element(ele).controller('mdGridTile');
	        return {
	          row: parseInt(
	              $mdMedia.getResponsiveAttribute(ctrl.$attrs, 'md-rowspan'), 10) || 1,
	          col: parseInt(
	              $mdMedia.getResponsiveAttribute(ctrl.$attrs, 'md-colspan'), 10) || 1
	        };
	      });
	    }
	
	    function getColumnCount() {
	      var colCount = parseInt($mdMedia.getResponsiveAttribute(attrs, 'md-cols'), 10);
	      if (isNaN(colCount)) {
	        throw 'md-grid-list: md-cols attribute was not found, or contained a non-numeric value';
	      }
	      return colCount;
	    }
	
	    function getGutter() {
	      return applyDefaultUnit($mdMedia.getResponsiveAttribute(attrs, 'md-gutter') || 1);
	    }
	
	    function getRowHeight() {
	      var rowHeight = $mdMedia.getResponsiveAttribute(attrs, 'md-row-height');
	      if (!rowHeight) {
	        throw 'md-grid-list: md-row-height attribute was not found';
	      }
	
	      switch (getRowMode()) {
	        case 'fixed':
	          return applyDefaultUnit(rowHeight);
	        case 'ratio':
	          var whRatio = rowHeight.split(':');
	          return parseFloat(whRatio[0]) / parseFloat(whRatio[1]);
	        case 'fit':
	          return 0; // N/A
	      }
	    }
	
	    function getRowMode() {
	      var rowHeight = $mdMedia.getResponsiveAttribute(attrs, 'md-row-height');
	      if (!rowHeight) {
	        throw 'md-grid-list: md-row-height attribute was not found';
	      }
	
	      if (rowHeight == 'fit') {
	        return 'fit';
	      } else if (rowHeight.indexOf(':') !== -1) {
	        return 'ratio';
	      } else {
	        return 'fixed';
	      }
	    }
	
	    function applyDefaultUnit(val) {
	      return /\D$/.test(val) ? val : val + 'px';
	    }
	  }
	}
	
	/* @ngInject */
	function GridListController($mdUtil) {
	  this.layoutInvalidated = false;
	  this.tilesInvalidated = false;
	  this.$timeout_ = $mdUtil.nextTick;
	  this.layoutDelegate = angular.noop;
	}
	
	GridListController.prototype = {
	  invalidateTiles: function() {
	    this.tilesInvalidated = true;
	    this.invalidateLayout();
	  },
	
	  invalidateLayout: function() {
	    if (this.layoutInvalidated) {
	      return;
	    }
	    this.layoutInvalidated = true;
	    this.$timeout_(angular.bind(this, this.layout));
	  },
	
	  layout: function() {
	    try {
	      this.layoutDelegate(this.tilesInvalidated);
	    } finally {
	      this.layoutInvalidated = false;
	      this.tilesInvalidated = false;
	    }
	  }
	};
	
	
	/* @ngInject */
	function GridLayoutFactory($mdUtil) {
	  var defaultAnimator = GridTileAnimator;
	
	  /**
	   * Set the reflow animator callback
	   */
	  GridLayout.animateWith = function(customAnimator) {
	    defaultAnimator = !angular.isFunction(customAnimator) ? GridTileAnimator : customAnimator;
	  };
	
	  return GridLayout;
	
	  /**
	   * Publish layout function
	   */
	  function GridLayout(colCount, tileSpans) {
	      var self, layoutInfo, gridStyles, layoutTime, mapTime, reflowTime;
	
	      layoutTime = $mdUtil.time(function() {
	        layoutInfo = calculateGridFor(colCount, tileSpans);
	      });
	
	      return self = {
	
	        /**
	         * An array of objects describing each tile's position in the grid.
	         */
	        layoutInfo: function() {
	          return layoutInfo;
	        },
	
	        /**
	         * Maps grid positioning to an element and a set of styles using the
	         * provided updateFn.
	         */
	        map: function(updateFn) {
	          mapTime = $mdUtil.time(function() {
	            var info = self.layoutInfo();
	            gridStyles = updateFn(info.positioning, info.rowCount);
	          });
	          return self;
	        },
	
	        /**
	         * Default animator simply sets the element.css( <styles> ). An alternate
	         * animator can be provided as an argument. The function has the following
	         * signature:
	         *
	         *    function({grid: {element: JQLite, style: Object}, tiles: Array<{element: JQLite, style: Object}>)
	         */
	        reflow: function(animatorFn) {
	          reflowTime = $mdUtil.time(function() {
	            var animator = animatorFn || defaultAnimator;
	            animator(gridStyles.grid, gridStyles.tiles);
	          });
	          return self;
	        },
	
	        /**
	         * Timing for the most recent layout run.
	         */
	        performance: function() {
	          return {
	            tileCount: tileSpans.length,
	            layoutTime: layoutTime,
	            mapTime: mapTime,
	            reflowTime: reflowTime,
	            totalTime: layoutTime + mapTime + reflowTime
	          };
	        }
	      };
	    }
	
	  /**
	   * Default Gridlist animator simple sets the css for each element;
	   * NOTE: any transitions effects must be manually set in the CSS.
	   * e.g.
	   *
	   *  md-grid-tile {
	   *    transition: all 700ms ease-out 50ms;
	   *  }
	   *
	   */
	  function GridTileAnimator(grid, tiles) {
	    grid.element.css(grid.style);
	    tiles.forEach(function(t) {
	      t.element.css(t.style);
	    });
	  }
	
	  /**
	   * Calculates the positions of tiles.
	   *
	   * The algorithm works as follows:
	   *    An Array<Number> with length colCount (spaceTracker) keeps track of
	   *    available tiling positions, where elements of value 0 represents an
	   *    empty position. Space for a tile is reserved by finding a sequence of
	   *    0s with length <= than the tile's colspan. When such a space has been
	   *    found, the occupied tile positions are incremented by the tile's
	   *    rowspan value, as these positions have become unavailable for that
	   *    many rows.
	   *
	   *    If the end of a row has been reached without finding space for the
	   *    tile, spaceTracker's elements are each decremented by 1 to a minimum
	   *    of 0. Rows are searched in this fashion until space is found.
	   */
	  function calculateGridFor(colCount, tileSpans) {
	    var curCol = 0,
	        curRow = 0,
	        spaceTracker = newSpaceTracker();
	
	    return {
	      positioning: tileSpans.map(function(spans, i) {
	        return {
	          spans: spans,
	          position: reserveSpace(spans, i)
	        };
	      }),
	      rowCount: curRow + Math.max.apply(Math, spaceTracker)
	    };
	
	    function reserveSpace(spans, i) {
	      if (spans.col > colCount) {
	        throw 'md-grid-list: Tile at position ' + i + ' has a colspan ' +
	            '(' + spans.col + ') that exceeds the column count ' +
	            '(' + colCount + ')';
	      }
	
	      var start = 0,
	          end = 0;
	
	      // TODO(shyndman): This loop isn't strictly necessary if you can
	      // determine the minimum number of rows before a space opens up. To do
	      // this, recognize that you've iterated across an entire row looking for
	      // space, and if so fast-forward by the minimum rowSpan count. Repeat
	      // until the required space opens up.
	      while (end - start < spans.col) {
	        if (curCol >= colCount) {
	          nextRow();
	          continue;
	        }
	
	        start = spaceTracker.indexOf(0, curCol);
	        if (start === -1 || (end = findEnd(start + 1)) === -1) {
	          start = end = 0;
	          nextRow();
	          continue;
	        }
	
	        curCol = end + 1;
	      }
	
	      adjustRow(start, spans.col, spans.row);
	      curCol = start + spans.col;
	
	      return {
	        col: start,
	        row: curRow
	      };
	    }
	
	    function nextRow() {
	      curCol = 0;
	      curRow++;
	      adjustRow(0, colCount, -1); // Decrement row spans by one
	    }
	
	    function adjustRow(from, cols, by) {
	      for (var i = from; i < from + cols; i++) {
	        spaceTracker[i] = Math.max(spaceTracker[i] + by, 0);
	      }
	    }
	
	    function findEnd(start) {
	      var i;
	      for (i = start; i < spaceTracker.length; i++) {
	        if (spaceTracker[i] !== 0) {
	          return i;
	        }
	      }
	
	      if (i === spaceTracker.length) {
	        return i;
	      }
	    }
	
	    function newSpaceTracker() {
	      var tracker = [];
	      for (var i = 0; i < colCount; i++) {
	        tracker.push(0);
	      }
	      return tracker;
	    }
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name mdGridTile
	 * @module material.components.gridList
	 * @restrict E
	 * @description
	 * Tiles contain the content of an `md-grid-list`. They span one or more grid
	 * cells vertically or horizontally, and use `md-grid-tile-{footer,header}` to
	 * display secondary content.
	 *
	 * ### Responsive Attributes
	 *
	 * The `md-grid-tile` directive supports "responsive" attributes, which allow
	 * different `md-rowspan` and `md-colspan` values depending on the currently
	 * matching media query.
	 *
	 * In order to set a responsive attribute, first define the fallback value with
	 * the standard attribute name, then add additional attributes with the
	 * following convention: `{base-attribute-name}-{media-query-name}="{value}"`
	 * (ie. `md-colspan-sm="4"`)
	 *
	 * @param {number=} md-colspan The number of columns to span (default 1). Cannot
	 *    exceed the number of columns in the grid. Supports interpolation.
	 * @param {number=} md-rowspan The number of rows to span (default 1). Supports
	 *     interpolation.
	 *
	 * @usage
	 * With header:
	 * <hljs lang="html">
	 * <md-grid-tile>
	 *   <md-grid-tile-header>
	 *     <h3>This is a header</h3>
	 *   </md-grid-tile-header>
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * With footer:
	 * <hljs lang="html">
	 * <md-grid-tile>
	 *   <md-grid-tile-footer>
	 *     <h3>This is a footer</h3>
	 *   </md-grid-tile-footer>
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * Spanning multiple rows/columns:
	 * <hljs lang="html">
	 * <md-grid-tile md-colspan="2" md-rowspan="3">
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * Responsive attributes:
	 * <hljs lang="html">
	 * <md-grid-tile md-colspan="1" md-colspan-sm="3" md-colspan-md="5">
	 * </md-grid-tile>
	 * </hljs>
	 */
	function GridTileDirective($mdMedia) {
	  return {
	    restrict: 'E',
	    require: '^mdGridList',
	    template: '<figure ng-transclude></figure>',
	    transclude: true,
	    scope: {},
	    // Simple controller that exposes attributes to the grid directive
	    controller: ["$attrs", function($attrs) {
	      this.$attrs = $attrs;
	    }],
	    link: postLink
	  };
	
	  function postLink(scope, element, attrs, gridCtrl) {
	    // Apply semantics
	    element.attr('role', 'listitem');
	
	    // If our colspan or rowspan changes, trigger a layout
	    var unwatchAttrs = $mdMedia.watchResponsiveAttributes(['md-colspan', 'md-rowspan'],
	        attrs, angular.bind(gridCtrl, gridCtrl.invalidateLayout));
	
	    // Tile registration/deregistration
	    gridCtrl.invalidateTiles();
	    scope.$on('$destroy', function() {
	      // Mark the tile as destroyed so it is no longer considered in layout,
	      // even if the DOM element sticks around (like during a leave animation)
	      element[0].$$mdDestroyed = true;
	      unwatchAttrs();
	      gridCtrl.invalidateLayout();
	    });
	
	    if (angular.isDefined(scope.$parent.$index)) {
	      scope.$watch(function() { return scope.$parent.$index; },
	        function indexChanged(newIdx, oldIdx) {
	          if (newIdx === oldIdx) {
	            return;
	          }
	          gridCtrl.invalidateTiles();
	        });
	    }
	  }
	}
	
	
	function GridTileCaptionDirective() {
	  return {
	    template: '<figcaption ng-transclude></figcaption>',
	    transclude: true
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.icon
	 * @description
	 * Icon
	 */
	angular.module('material.components.icon', ['material.core']);
	
	})();
	(function(){
	"use strict";
	
	angular
	  .module('material.components.icon')
	  .directive('mdIcon', ['$mdIcon', '$mdTheming', '$mdAria', '$sce', mdIconDirective]);
	
	/**
	 * @ngdoc directive
	 * @name mdIcon
	 * @module material.components.icon
	 *
	 * @restrict E
	 *
	 * @description
	 * The `md-icon` directive makes it easier to use vector-based icons in your app (as opposed to
	 * raster-based icons types like PNG). The directive supports both icon fonts and SVG icons.
	 *
	 * Icons should be considered view-only elements that should not be used directly as buttons; instead nest a `<md-icon>`
	 * inside a `md-button` to add hover and click features.
	 *
	 * ### Icon fonts
	 * Icon fonts are a technique in which you use a font where the glyphs in the font are
	 * your icons instead of text. Benefits include a straightforward way to bundle everything into a
	 * single HTTP request, simple scaling, easy color changing, and more.
	 *
	 * `md-icon` lets you consume an icon font by letting you reference specific icons in that font
	 * by name rather than character code.
	 *
	 * When using font-icons, developers must follow three (3) simple steps:
	 *
	 * <ol>
	 * <li>Load the font library. e.g.<br/>
	 *    `<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">`
	 * </li>
	 * <li>
	 *   Use either (a) font-icon class names or (b) a fontset and a font ligature to render the font glyph by
	 *   using its textual name _or_ numerical character reference. Note that `material-icons` is the default fontset when
	 *   none is specified.
	 * </li>
	 * <li> Use any of the following templates: <br/>
	 *   <ul>
	 *     <li>`<md-icon md-font-icon="classname"></md-icon>`</li>
	 *     <li>`<md-icon md-font-set="font library classname or alias">textual_name</md-icon>`</li>
	 *     <li>`<md-icon> numerical_character_reference </md-icon>`</li>
	 *     <li>`<md-icon ng_bind="'textual_name'"></md-icon>`</li>
	 *     <li>`<md-icon ng-bind="scopeVariable"></md-icon>`</li>
	 *   </ul>
	 * </li>
	 * </ol>
	 *
	 * Full details for these steps can be found in the
	 * <a href="http://google.github.io/material-design-icons/#icon-font-for-the-web" target="_blank">
	 * Material Design Icon font for the web docs</a>.
	 *
	 * You can browse and search the Material Design icon style <code>.material-icons</code>
	 * in the <a href="https://material.io/tools/icons/" target="_blank">Material Design Icons tool</a>.
	 *
	 * ### SVG
	 * For SVGs, the problem with using `<img>` or a CSS `background-image` is that you can't take
	 * advantage of some SVG features, such as styling specific parts of the icon with CSS or SVG
	 * animation.
	 *
	 * `md-icon` makes it easier to use SVG icons by *inlining* the SVG into an `<svg>` element in the
	 * document. The most straightforward way of referencing an SVG icon is via URL, just like a
	 * traditional `<img>`. `$mdIconProvider`, as a convenience, lets you _name_ an icon so you can
	 * reference it by name instead of URL throughout your templates.
	 *
	 * Additionally, you may not want to make separate HTTP requests for every icon, so you can bundle
	 * your SVG icons together and pre-load them with `$mdIconProvider` as an icon set. An icon set can
	 * also be given a name, which acts as a namespace for individual icons, so you can reference them
	 * like `"social:cake"`.
	 *
	 * When using SVGs, both external SVGs (via URLs) or sets of SVGs (from icon sets) can be
	 * easily loaded and used.
	 *
	 * ### Localization
	 *
	 * Because an `md-icon` element's text content is not intended to be translated, it is recommended
	 * to declare the text content for an `md-icon` element in its start tag. Instead of using the HTML
	 * text content, consider using `ng-bind` with a scope variable or literal string.
	 *
	 * Examples:
	 *
	 * <ul>
	 *   <li>`<md-icon ng-bind="myIconVariable"></md-icon>`</li>
	 *   <li>`<md-icon ng-bind="'menu'"></md-icon>`
	 * </ul>
	 *
	 * <h2 id="material_design_icons">Material Design Icons tool</h2>
	 * Using the Material Design Icons tool, developers can easily and quickly search for a specific
	 * open source Material Design icon. The search is in the top left. Below search, you can select
	 * from the new icon themes or filter by icon category.
	 *
	 * <a href="https://material.io/tools/icons/" target="_blank" style="border-bottom:none;">
	 * <img src="https://user-images.githubusercontent.com/3506071/41942584-ef0695d0-796d-11e8-9436-44f25023a111.png"
	 *      aria-label="Material Design Icons tool" style="max-width:95%">
	 * </a>
	 *
	 * <div class="md-caption" style="text-align: center; margin-bottom: 24px">
	 *  Click on the image above to open the
	 *  <a href="https://material.io/tools/icons/" target="_blank">Material Design Icons tool</a>.
	 * </div>
	 *
	 * Click on any icon, then click on the "Selected Icon" chevron to see the slide-up
	 * information panel with details regarding a SVG download and information on the font-icon's
	 * textual name. This panel also allows you to select a black on transparent or white on transparent
	 * icon and to change the icon size. These settings only affect the downloaded icons.
	 *
	 * @param {string} md-font-icon String name of CSS icon associated with the font-face will be used
	 * to render the icon. Requires the fonts and the named CSS styles to be preloaded.
	 * @param {string} md-font-set CSS style name associated with the font library; which will be assigned as
	 * the class for the font-icon ligature. This value may also be an alias that is used to lookup the classname;
	 * internally use `$mdIconProvider.fontSet(<alias>)` to determine the style name.
	 * @param {string} md-svg-src String URL (or expression) used to load, cache, and display an
	 *     external SVG.
	 * @param {string} md-svg-icon md-svg-icon String name used for lookup of the icon from the internal cache;
	 *     interpolated strings or expressions may also be used. Specific set names can be used with
	 *     the syntax `<set name>:<icon name>`.<br/><br/>
	 * To use icon sets, developers are required to pre-register the sets using the `$mdIconProvider` service.
	 * @param {string=} aria-label Labels icon for accessibility. If an empty string is provided, icon
	 * will be hidden from accessibility layer with `aria-hidden="true"`. If there's no aria-label on the icon
	 * nor a label on the parent element, a warning will be logged to the console.
	 * @param {string=} alt Labels icon for accessibility. If an empty string is provided, icon
	 * will be hidden from accessibility layer with `aria-hidden="true"`. If there's no alt on the icon
	 * nor a label on the parent element, a warning will be logged to the console.
	 *
	 * @usage
	 * When using SVGs:
	 * <hljs lang="html">
	 *
	 *<!-- Icon ID; may contain optional icon set prefix.
	 *     Icons must be registered using $mdIconProvider. -->
	 *<md-icon md-svg-icon="social:android"    aria-label="android " ></md-icon>
	 *
	 *<!-- Icon urls; may be preloaded in templateCache -->
	 *<md-icon md-svg-src="/android.svg"       aria-label="android " ></md-icon>
	 *<md-icon md-svg-src="{{ getAndroid() }}" aria-label="android " ></md-icon>
	 *
	 * </hljs>
	 *
	 * Use the <code>$mdIconProvider</code> to configure your application with
	 * SVG icon sets.
	 *
	 * <hljs lang="js">
	 * angular.module('appSvgIconSets', ['ngMaterial'])
	 *   .controller('DemoCtrl', function($scope) {})
	 *   .config(function($mdIconProvider) {
	 *     $mdIconProvider
	 *       .iconSet('social', 'img/icons/sets/social-icons.svg', 24)
	 *       .defaultIconSet('img/icons/sets/core-icons.svg', 24);
	 *    });
	 * </hljs>
	 *
	 *
	 * When using Font Icons with classnames:
	 * <hljs lang="html">
	 *
	 * <md-icon md-font-icon="android" aria-label="android" ></md-icon>
	 * <md-icon class="icon_home" aria-label="Home"></md-icon>
	 *
	 * </hljs>
	 *
	 * When using Material Font Icons with ligatures:
	 * <hljs lang="html">
	 *  <!--
	 *  For Material Design Icons
	 *  The class '.material-icons' is auto-added if a style has NOT been specified
	 *  since `material-icons` is the default fontset. So your markup:
	 *  -->
	 *  <md-icon> face </md-icon>
	 *  <!-- becomes this at runtime: -->
	 *  <md-icon md-font-set="material-icons"> face </md-icon>
	 *  <!-- If the fontset does not support ligature names, then we need to use the ligature unicode.-->
	 *  <md-icon> &#xE87C; </md-icon>
	 *  <!-- The class '.material-icons' must be manually added if other styles are also specified-->
	 *  <md-icon class="material-icons md-light md-48"> face </md-icon>
	 * </hljs>
	 *
	 * When using other Font-Icon libraries:
	 *
	 * <hljs lang="js">
	 *  // Specify a font-icon style alias
	 *  angular.config(function($mdIconProvider) {
	 *    $mdIconProvider.fontSet('md', 'material-icons');
	 *  });
	 * </hljs>
	 *
	 * <hljs lang="html">
	 *  <md-icon md-font-set="md">favorite</md-icon>
	 * </hljs>
	 *
	 */
	function mdIconDirective($mdIcon, $mdTheming, $mdAria, $sce) {
	
	  return {
	    restrict: 'E',
	    link : postLink
	  };
	
	
	  /**
	   * Directive postLink
	   * Supports embedded SVGs, font-icons, & external SVGs
	   */
	  function postLink(scope, element, attr) {
	    $mdTheming(element);
	    var lastFontIcon = attr.mdFontIcon;
	    var lastFontSet = $mdIcon.fontSet(attr.mdFontSet);
	
	    prepareForFontIcon();
	
	    attr.$observe('mdFontIcon', fontIconChanged);
	    attr.$observe('mdFontSet', fontIconChanged);
	
	    // Keep track of the content of the svg src so we can compare against it later to see if the
	    // attribute is static (and thus safe).
	    var originalSvgSrc = element[0].getAttribute(attr.$attr.mdSvgSrc);
	
	    // If using a font-icon, then the textual name of the icon itself
	    // provides the aria-label.
	
	    var attrName = attr.$normalize(attr.$attr.mdSvgIcon || attr.$attr.mdSvgSrc || '');
	
	    /* Provide a default accessibility role of img */
	    if (!attr.role) {
	      $mdAria.expect(element, 'role', 'img');
	      /* manually update attr variable */
	      attr.role = 'img';
	    }
	
	    /* Don't process ARIA if already valid */
	    if (attr.role === "img" && !attr.ariaHidden && !$mdAria.hasAriaLabel(element)) {
	      var iconName;
	      if (attr.alt) {
	        /* Use alt text by default if available */
	        $mdAria.expect(element, 'aria-label', attr.alt);
	      } else if ($mdAria.parentHasAriaLabel(element, 2)) {
	        /* Parent has ARIA so we will assume it will describe the image */
	        $mdAria.expect(element, 'aria-hidden', 'true');
	      } else if (iconName = (attr.mdFontIcon || attr.mdSvgIcon || element.text())) {
	        /* Use icon name as aria-label */
	        $mdAria.expect(element, 'aria-label', iconName);
	      } else {
	        /* No label found */
	        $mdAria.expect(element, 'aria-hidden', 'true');
	      }
	    }
	
	    if (attrName) {
	      // Use either pre-configured SVG or URL source, respectively.
	      attr.$observe(attrName, function(attrVal) {
	        element.empty();
	        if (attrVal) {
	          $mdIcon(attrVal)
	            .then(function(svg) {
	            element.empty();
	            element.append(svg);
	          });
	        }
	      });
	    }
	
	    function prepareForFontIcon() {
	      if (!attr.mdSvgIcon && !attr.mdSvgSrc) {
	        if (attr.mdFontIcon) {
	          element.addClass('md-font ' + attr.mdFontIcon);
	        }
	
	        element.addClass(lastFontSet);
	      }
	    }
	
	    function fontIconChanged() {
	      if (!attr.mdSvgIcon && !attr.mdSvgSrc) {
	        if (attr.mdFontIcon) {
	          element.removeClass(lastFontIcon);
	          element.addClass(attr.mdFontIcon);
	
	          lastFontIcon = attr.mdFontIcon;
	        }
	
	        var fontSet = $mdIcon.fontSet(attr.mdFontSet);
	
	        if (lastFontSet !== fontSet) {
	          element.removeClass(lastFontSet);
	          element.addClass(fontSet);
	
	          lastFontSet = fontSet;
	        }
	      }
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	  
	MdIconService.$inject = ["config", "$templateRequest", "$q", "$log", "$mdUtil", "$sce"];angular
	    .module('material.components.icon')
	    .constant('$$mdSvgRegistry', {
	        'mdTabsArrow':   'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwb2x5Z29uIHBvaW50cz0iMTUuNCw3LjQgMTQsNiA4LDEyIDE0LDE4IDE1LjQsMTYuNiAxMC44LDEyICIvPjwvZz48L3N2Zz4=',
	        'mdClose':       'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xOSA2LjQxbC0xLjQxLTEuNDEtNS41OSA1LjU5LTUuNTktNS41OS0xLjQxIDEuNDEgNS41OSA1LjU5LTUuNTkgNS41OSAxLjQxIDEuNDEgNS41OS01LjU5IDUuNTkgNS41OSAxLjQxLTEuNDEtNS41OS01LjU5eiIvPjwvZz48L3N2Zz4=',
	        'mdCancel':      'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xMiAyYy01LjUzIDAtMTAgNC40Ny0xMCAxMHM0LjQ3IDEwIDEwIDEwIDEwLTQuNDcgMTAtMTAtNC40Ny0xMC0xMC0xMHptNSAxMy41OWwtMS40MSAxLjQxLTMuNTktMy41OS0zLjU5IDMuNTktMS40MS0xLjQxIDMuNTktMy41OS0zLjU5LTMuNTkgMS40MS0xLjQxIDMuNTkgMy41OSAzLjU5LTMuNTkgMS40MSAxLjQxLTMuNTkgMy41OSAzLjU5IDMuNTl6Ii8+PC9nPjwvc3ZnPg==',
	        'mdMenu':        'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0zLDZIMjFWOEgzVjZNMywxMUgyMVYxM0gzVjExTTMsMTZIMjFWMThIM1YxNloiIC8+PC9zdmc+',
	        'mdToggleArrow': 'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNDggNDgiPjxwYXRoIGQ9Ik0yNCAxNmwtMTIgMTIgMi44MyAyLjgzIDkuMTctOS4xNyA5LjE3IDkuMTcgMi44My0yLjgzeiIvPjxwYXRoIGQ9Ik0wIDBoNDh2NDhoLTQ4eiIgZmlsbD0ibm9uZSIvPjwvc3ZnPg==',
	        'mdCalendar':    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTkgM2gtMVYxaC0ydjJIOFYxSDZ2Mkg1Yy0xLjExIDAtMS45OS45LTEuOTkgMkwzIDE5YzAgMS4xLjg5IDIgMiAyaDE0YzEuMSAwIDItLjkgMi0yVjVjMC0xLjEtLjktMi0yLTJ6bTAgMTZINVY4aDE0djExek03IDEwaDV2NUg3eiIvPjwvc3ZnPg==',
	        'mdChecked':     'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik05IDE2LjE3TDQuODMgMTJsLTEuNDIgMS40MUw5IDE5IDIxIDdsLTEuNDEtMS40MXoiLz48L2c+PC9zdmc+'
	    })
	    .provider('$mdIcon', MdIconProvider);
	
	/**
	 * @ngdoc service
	 * @name $mdIconProvider
	 * @module material.components.icon
	 *
	 * @description
	 * `$mdIconProvider` is used only to register icon IDs with URLs. These configuration features allow
	 * icons and icon sets to be pre-registered and associated with source URLs **before** the `<md-icon />`
	 * directives are compiled.
	 *
	 * If using font-icons, the developer is responsible for loading the fonts.
	 *
	 * If using SVGs, loading of the actual svg files are deferred to on-demand requests and are loaded
	 * internally by the `$mdIcon` service using the `$templateRequest` service. When an SVG is
	 * requested by name/ID, the `$mdIcon` service searches its registry for the associated source URL;
	 * that URL is used to on-demand load and parse the SVG dynamically.
	 *
	 * The `$templateRequest` service expects the icons source to be loaded over trusted URLs.<br/>
	 * This means, when loading icons from an external URL, you have to trust the URL in the `$sceDelegateProvider`.
	 *
	 * <hljs lang="js">
	 *   app.config(function($sceDelegateProvider) {
	 *     $sceDelegateProvider.resourceUrlWhitelist([
	 *       // Adding 'self' to the whitelist, will allow requests from the current origin.
	 *       'self',
	 *       // Using double asterisks here, will allow all URLs to load.
	 *       // We recommend to only specify the given domain you want to allow.
	 *       '**'
	 *     ]);
	 *   });
	 * </hljs>
	 *
	 * Read more about the [$sceDelegateProvider](https://docs.angularjs.org/api/ng/provider/$sceDelegateProvider).
	 *
	 * **Notice:** Most font-icons libraries do not support ligatures (for example `fontawesome`).<br/>
	 *  In such cases you are not able to use the icon's ligature name - Like so:
	 *
	 *  <hljs lang="html">
	 *    <md-icon md-font-set="fa">fa-bell</md-icon>
	 *  </hljs>
	 *
	 * You should instead use the given unicode, instead of the ligature name.
	 *
	 * <p ng-hide="true"> ##// Notice we can't use a hljs element here, because the characters will be escaped.</p>
	 *  ```html
	 *    <md-icon md-font-set="fa">&#xf0f3</md-icon>
	 *  ```
	 *
	 * All unicode ligatures are prefixed with the `&#x` string.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .defaultFontSet( 'fa' )                   // This sets our default fontset className.
	    *          .defaultIconSet('my/app/icons.svg')       // Register a default set of SVG icons
	    *          .iconSet('social', 'my/app/social.svg')   // Register a named icon set of SVGs
	    *          .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
	    *          .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
	    *   });
	 * </hljs>
	 *
	 * SVG icons and icon sets can be easily pre-loaded and cached using either (a) a build process or (b) a runtime
	 * **startup** process (shown below):
	 *
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Register a default set of SVG icon definitions
	    *     $mdIconProvider.defaultIconSet('my/app/icons.svg')
	    *
	    *   })
	 *   .run(function($templateRequest){
	    *
	    *     // Pre-fetch icons sources by URL and cache in the $templateCache...
	    *     // subsequent $templateRequest calls will look there first.
	    *
	    *     var urls = [ 'imy/app/icons.svg', 'img/icons/android.svg'];
	    *
	    *     angular.forEach(urls, function(url) {
	    *       $templateRequest(url);
	    *     });
	    *
	    *   });
	 *
	 * </hljs>
	 *
	 * > <b>Note:</b> The loaded SVG data is subsequently cached internally for future requests.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#icon
	 *
	 * @description
	 * Register a source URL for a specific icon name; the name may include optional 'icon set' name prefix.
	 * These icons  will later be retrieved from the cache using `$mdIcon( <icon name> )`
	 *
	 * @param {string} id Icon name/id used to register the icon
	 * @param {string} url specifies the external location for the data file. Used internally by
	 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 * was configured.
	 * @param {number=} viewBoxSize Sets the width and height the icon's viewBox.
	 * It is ignored for icons with an existing viewBox. Default size is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
	    *          .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
	    *   });
	 * </hljs>
	 *
	 */
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#iconSet
	 *
	 * @description
	 * Register a source URL for a 'named' set of icons; group of SVG definitions where each definition
	 * has an icon id. Individual icons can be subsequently retrieved from this cached set using
	 * `$mdIcon(<icon set name>:<icon name>)`
	 *
	 * @param {string} id Icon name/id used to register the iconset
	 * @param {string} url specifies the external location for the data file. Used internally by
	 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 * was configured.
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
	 * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size.
	 * Default value is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .iconSet('social', 'my/app/social.svg')   // Register a named icon set
	    *   });
	 * </hljs>
	 *
	 */
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultIconSet
	 *
	 * @description
	 * Register a source URL for the default 'named' set of icons. Unless explicitly registered,
	 * subsequent lookups of icons will failover to search this 'default' icon set.
	 * Icon can be retrieved from this cached, default set using `$mdIcon(<name>)`
	 *
	 * @param {string} url specifies the external location for the data file. Used internally by
	 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 * was configured.
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
	 * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size.
	 * Default value is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .defaultIconSet( 'my/app/social.svg' )   // Register a default icon set
	    *   });
	 * </hljs>
	 *
	 */
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultFontSet
	 *
	 * @description
	 * When using Font-Icons, AngularJS Material assumes the the Material Design icons will be used and automatically
	 * configures the default font-set == 'material-icons'. Note that the font-set references the font-icon library
	 * class style that should be applied to the `<md-icon>`.
	 *
	 * Configuring the default means that the attributes
	 * `md-font-set="material-icons"` or `class="material-icons"` do not need to be explicitly declared on the
	 * `<md-icon>` markup. For example:
	 *
	 *  `<md-icon> face </md-icon>`
	 *  will render as
	 *  `<span class="material-icons"> face </span>`, and
	 *
	 *  `<md-icon md-font-set="fa"> face </md-icon>`
	 *  will render as
	 *  `<span class="fa"> face </span>`
	 *
	 * @param {string} name of the font-library style that should be applied to the md-icon DOM element
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	   *     $mdIconProvider.defaultFontSet( 'fa' );
	   *   });
	 * </hljs>
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#fontSet
	 *
	 * @description
	 * When using a font set for `<md-icon>` you must specify the correct font classname in the `md-font-set`
	 * attribute. If the fonset className is really long, your markup may become cluttered... an easy
	 * solution is to define an `alias` for your fontset:
	 *
	 * @param {string} alias of the specified fontset.
	 * @param {string} className of the fontset.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	   *     // In this case, we set an alias for the `material-icons` fontset.
	   *     $mdIconProvider.fontSet('md', 'material-icons');
	   *   });
	 * </hljs>
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultViewBoxSize
	 *
	 * @description
	 * While `<md-icon />` markup can also be style with sizing CSS, this method configures
	 * the default width **and** height used for all icons; unless overridden by specific CSS.
	 * The default sizing is (24px, 24px).
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox for an icon or an icon set.
	 * All icons in a set should be the same size. The default value is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .defaultViewBoxSize(36)   // Register a default icon size (width == height)
	    *   });
	 * </hljs>
	 *
	 */
	
	var config = {
	  defaultViewBoxSize: 24,
	  defaultFontSet: 'material-icons',
	  fontSets: []
	};
	
	function MdIconProvider() {
	}
	
	MdIconProvider.prototype = {
	  icon: function(id, url, viewBoxSize) {
	    if (id.indexOf(':') == -1) id = '$default:' + id;
	
	    config[id] = new ConfigurationItem(url, viewBoxSize);
	    return this;
	  },
	
	  iconSet: function(id, url, viewBoxSize) {
	    config[id] = new ConfigurationItem(url, viewBoxSize);
	    return this;
	  },
	
	  defaultIconSet: function(url, viewBoxSize) {
	    var setName = '$default';
	
	    if (!config[setName]) {
	      config[setName] = new ConfigurationItem(url, viewBoxSize);
	    }
	
	    config[setName].viewBoxSize = viewBoxSize || config.defaultViewBoxSize;
	
	    return this;
	  },
	
	  defaultViewBoxSize: function(viewBoxSize) {
	    config.defaultViewBoxSize = viewBoxSize;
	    return this;
	  },
	
	  /**
	   * Register an alias name associated with a font-icon library style ;
	   */
	  fontSet: function fontSet(alias, className) {
	    config.fontSets.push({
	      alias: alias,
	      fontSet: className || alias
	    });
	    return this;
	  },
	
	  /**
	   * Specify a default style name associated with a font-icon library
	   * fallback to Material Icons.
	   *
	   */
	  defaultFontSet: function defaultFontSet(className) {
	    config.defaultFontSet = !className ? '' : className;
	    return this;
	  },
	
	  defaultIconSize: function defaultIconSize(iconSize) {
	    config.defaultIconSize = iconSize;
	    return this;
	  },
	
	  $get: ['$templateRequest', '$q', '$log', '$mdUtil', '$sce', function($templateRequest, $q, $log, $mdUtil, $sce) {
	    return MdIconService(config, $templateRequest, $q, $log, $mdUtil, $sce);
	  }]
	};
	
	  /**
	   * Configuration item stored in the Icon registry; used for lookups
	   * to load if not already cached in the `loaded` cache
	   * @param {string} url
	   * @param {=number} viewBoxSize
	   * @constructor
	   */
	  function ConfigurationItem(url, viewBoxSize) {
	    this.url = url;
	    this.viewBoxSize = viewBoxSize || config.defaultViewBoxSize;
	  }
	
	/**
	 * @ngdoc service
	 * @name $mdIcon
	 * @module material.components.icon
	 *
	 * @description
	 * The `$mdIcon` service is a function used to lookup SVG icons.
	 *
	 * @param {string} id Query value for a unique Id or URL. If the argument is a URL, then the service will retrieve the icon element
	 * from its internal cache or load the icon and cache it first. If the value is not a URL-type string, then an ID lookup is
	 * performed. The Id may be a unique icon ID or may include an iconSet ID prefix.
	 *
	 * For the **id** query to work properly, this means that all id-to-URL mappings must have been previously configured
	 * using the `$mdIconProvider`.
	 *
	 * @returns {angular.$q.Promise} A promise that gets resolved to a clone of the initial SVG DOM element; which was
	 * created from the SVG markup in the SVG data file. If an error occurs (e.g. the icon cannot be found) the promise
	 * will get rejected.
	 *
	 * @usage
	 * <hljs lang="js">
	 * function SomeDirective($mdIcon) {
	  *
	  *   // See if the icon has already been loaded, if not
	  *   // then lookup the icon from the registry cache, load and cache
	  *   // it for future requests.
	  *   // NOTE: ID queries require configuration with $mdIconProvider
	  *
	  *   $mdIcon('android').then(function(iconEl)    { element.append(iconEl); });
	  *   $mdIcon('work:chair').then(function(iconEl) { element.append(iconEl); });
	  *
	  *   // Load and cache the external SVG using a URL
	  *
	  *   $mdIcon('img/icons/android.svg').then(function(iconEl) {
	  *     element.append(iconEl);
	  *   });
	  * };
	 * </hljs>
	 *
	 * > <b>Note:</b> The `<md-icon>` directive internally uses the `$mdIcon` service to query, load,
	 *   and instantiate SVG DOM elements.
	 */
	
	/* @ngInject */
	function MdIconService(config, $templateRequest, $q, $log, $mdUtil, $sce) {
	  var iconCache = {};
	  var svgCache = {};
	  var urlRegex = /[-\w@:%+.~#?&//=]{2,}\.[a-z]{2,4}\b(\/[-\w@:%+.~#?&//=]*)?/i;
	  var dataUrlRegex = /^data:image\/svg\+xml[\s*;\w\-=]*?(base64)?,(.*)$/i;
	
	  Icon.prototype = {clone: cloneSVG, prepare: prepareAndStyle};
	  getIcon.fontSet = findRegisteredFontSet;
	
	  // Publish service...
	  return getIcon;
	
	  /**
	   * Actual $mdIcon service is essentially a lookup function
	   * @param {*} id $sce trust wrapper over a URL string, URL, icon registry id, or icon set id
	   * @returns {angular.$q.Promise}
	   */
	  function getIcon(id) {
	    id = id || '';
	
	    // If the "id" provided is not a string, the only other valid value is a $sce trust wrapper
	    // over a URL string. If the value is not trusted, this will intentionally throw an error
	    // because the user is attempted to use an unsafe URL, potentially opening themselves up
	    // to an XSS attack.
	    if (!angular.isString(id)) {
	      id = $sce.getTrustedUrl(id);
	    }
	
	    // If already loaded and cached, use a clone of the cached icon.
	    // Otherwise either load by URL, or lookup in the registry and then load by URL, and cache.
	
	    if (iconCache[id]) {
	      return $q.when(transformClone(iconCache[id]));
	    }
	
	    if (urlRegex.test(id) || dataUrlRegex.test(id)) {
	      return loadByURL(id).then(cacheIcon(id));
	    }
	
	    if (id.indexOf(':') === -1) {
	      id = '$default:' + id;
	    }
	
	    var load = config[id] ? loadByID : loadFromIconSet;
	    return load(id)
	      .then(cacheIcon(id));
	  }
	
	  /**
	   * Lookup a registered fontSet style using its alias.
	   * @param {string} alias used to lookup the alias in the array of fontSets
	   * @returns {*} matching fontSet or the defaultFontSet if that alias does not match
	   */
	  function findRegisteredFontSet(alias) {
	    var useDefault = angular.isUndefined(alias) || !(alias && alias.length);
	    if (useDefault) {
	      return config.defaultFontSet;
	    }
	
	    var result = alias;
	    angular.forEach(config.fontSets, function(fontSet) {
	      if (fontSet.alias === alias) {
	        result = fontSet.fontSet || result;
	      }
	    });
	
	    return result;
	  }
	
	  /**
	   * @param {!Icon} cacheElement cached icon from the iconCache
	   * @returns {Icon} cloned Icon element with unique ids
	   */
	  function transformClone(cacheElement) {
	    var clone = cacheElement.clone();
	    var newUid = $mdUtil.nextUid();
	    var cacheSuffix, svgUrlQuerySelector, i, xlinkHrefValue;
	    // These are SVG attributes that can reference element ids.
	    var svgUrlAttributes = [
	      'clip-path', 'color-profile', 'cursor', 'fill', 'filter', 'href', 'marker-start',
	      'marker-mid', 'marker-end', 'mask', 'stroke', 'style', 'vector-effect'
	    ];
	    var isIeSvg = clone.innerHTML === undefined;
	
	    // Verify that the newUid only contains a number and not some XSS content.
	    if (!isFinite(Number(newUid))) {
	      throw new Error('Unsafe and unexpected non-number result from $mdUtil.nextUid().');
	    }
	    cacheSuffix = '_cache' + newUid;
	
	    // For each cached icon, we need to modify the id attributes and references.
	    // This is needed because SVG ids are treated as normal DOM ids and should not be duplicated on
	    // the page.
	    if (clone.id) {
	      clone.id += cacheSuffix;
	    }
	
	    // Do as much as possible with querySelectorAll as it provides much greater performance
	    // than RegEx against serialized DOM.
	    angular.forEach(clone.querySelectorAll('[id]'), function(descendantElem) {
	      svgUrlQuerySelector = '';
	      for (i = 0; i < svgUrlAttributes.length; i++) {
	        svgUrlQuerySelector += '[' + svgUrlAttributes[i] + '="url(#' + descendantElem.id + ')"]';
	        if (i + 1 < svgUrlAttributes.length) {
	          svgUrlQuerySelector += ', ';
	        }
	      }
	      // Append the cacheSuffix to references of the element's id within url(#id) calls.
	      angular.forEach(clone.querySelectorAll(svgUrlQuerySelector), function(refItem) {
	        updateSvgIdReferences(descendantElem, refItem, isIeSvg, newUid);
	      });
	      // Handle usages of url(#id) in the SVG's stylesheets
	      angular.forEach(clone.querySelectorAll('style'), function(refItem) {
	        updateSvgIdReferences(descendantElem, refItem, isIeSvg, newUid);
	      });
	
	      // Update ids referenced by the deprecated (in SVG v2) xlink:href XML attribute. The now
	      // preferred href attribute is handled above. However, this non-standard XML namespaced
	      // attribute cannot be handled in the same way. Explanation of this query selector here:
	      // https://stackoverflow.com/q/23034283/633107.
	      angular.forEach(clone.querySelectorAll('[*|href]:not([href])'), function(refItem) {
	        xlinkHrefValue = refItem.getAttribute('xlink:href');
	        if (xlinkHrefValue) {
	          xlinkHrefValue = xlinkHrefValue.replace("#" + descendantElem.id, "#" + descendantElem.id + cacheSuffix);
	          refItem.setAttribute('xlink:href', xlinkHrefValue);
	        }
	      });
	
	      descendantElem.id += cacheSuffix;
	    });
	
	    return clone;
	  }
	
	  /**
	   * @param {Element} referencedElement element w/ id that needs to be updated
	   * @param {Element} referencingElement element that references the original id
	   * @param {boolean} isIeSvg true if we're dealing with an SVG in IE11, false otherwise
	   * @param {string} newUid the cache id to add as part of the cache suffix
	   */
	  function updateSvgIdReferences(referencedElement, referencingElement, isIeSvg, newUid) {
	    var svgElement, cacheSuffix;
	
	    // Verify that the newUid only contains a number and not some XSS content.
	    if (!isFinite(Number(newUid))) {
	      throw new Error('Unsafe and unexpected non-number result for newUid.');
	    }
	    cacheSuffix = '_cache' + newUid;
	
	    // outerHTML of SVG elements is not supported by IE11
	    if (isIeSvg) {
	      svgElement = $mdUtil.getOuterHTML(referencingElement);
	      svgElement = svgElement.replace("url(#" + referencedElement.id + ")",
	        "url(#" + referencedElement.id + cacheSuffix + ")");
	      referencingElement.textContent = angular.element(svgElement)[0].innerHTML;
	    } else {
	      // This use of outerHTML should be safe from XSS attack since we are only injecting the
	      // cacheSuffix with content from $mdUtil.nextUid which we verify is a finite number above.
	      referencingElement.outerHTML = referencingElement.outerHTML.replace(
	        "url(#" + referencedElement.id + ")",
	        "url(#" + referencedElement.id + cacheSuffix + ")");
	    }
	  }
	
	  /**
	   * Prepare and cache the loaded icon for the specified `id`.
	   * @param {string} id icon cache id
	   * @returns {function(*=): *}
	   */
	  function cacheIcon(id) {
	
	    return function updateCache(icon) {
	      iconCache[id] = isIcon(icon) ? icon : new Icon(icon, config[id]);
	
	      return transformClone(iconCache[id]);
	    };
	  }
	
	  /**
	   * Lookup the configuration in the registry, if !registered throw an error
	   * otherwise load the icon [on-demand] using the registered URL.
	   * @param {string} id icon registry id
	   * @returns {angular.$q.Promise}
	   */
	  function loadByID(id) {
	    var iconConfig = config[id];
	    return loadByURL(iconConfig.url).then(function(icon) {
	      return new Icon(icon, iconConfig);
	    });
	  }
	
	  /**
	   * Loads the file as XML and uses querySelector( <id> ) to find the desired node...
	   * @param {string} id icon id in icon set
	   * @returns {angular.$q.Promise}
	   */
	  function loadFromIconSet(id) {
	    var setName = id.substring(0, id.lastIndexOf(':')) || '$default';
	    var iconSetConfig = config[setName];
	
	    return !iconSetConfig ? announceIdNotFound(id) : loadByURL(iconSetConfig.url).then(extractFromSet);
	
	    function extractFromSet(set) {
	      var iconName = id.slice(id.lastIndexOf(':') + 1);
	      var icon = set.querySelector('#' + iconName);
	      return icon ? new Icon(icon, iconSetConfig) : announceIdNotFound(id);
	    }
	
	    function announceIdNotFound(id) {
	      var msg = 'icon ' + id + ' not found';
	      $log.warn(msg);
	
	      return $q.reject(msg || id);
	    }
	  }
	
	  /**
	   * Load the icon by URL (may use the $templateCache).
	   * Extract the data for later conversion to Icon
	   * @param {string} url icon URL
	   * @returns {angular.$q.Promise}
	   */
	  function loadByURL(url) {
	    /* Load the icon from embedded data URL. */
	    function loadByDataUrl(url) {
	      var results = dataUrlRegex.exec(url);
	      var isBase64 = /base64/i.test(url);
	      var data = isBase64 ? window.atob(results[2]) : results[2];
	
	      return $q.when(angular.element(data)[0]);
	    }
	
	    /* Load the icon by URL using HTTP. */
	    function loadByHttpUrl(url) {
	      return $q(function(resolve, reject) {
	        // Catch HTTP or generic errors not related to incorrect icon IDs.
	        var announceAndReject = function(err) {
	            var msg = angular.isString(err) ? err : (err.message || err.data || err.statusText);
	            $log.warn(msg);
	            reject(err);
	          },
	          extractSvg = function(response) {
	            if (!svgCache[url]) {
	              svgCache[url] = angular.element('<div>').append(response)[0].querySelector('svg');
	            }
	            resolve(svgCache[url]);
	          };
	
	        $templateRequest(url, true).then(extractSvg, announceAndReject);
	      });
	    }
	
	    return dataUrlRegex.test(url)
	      ? loadByDataUrl(url)
	      : loadByHttpUrl(url);
	  }
	
	  /**
	   * Check target signature to see if it is an Icon instance.
	   * @param {Icon|Element} target
	   * @returns {boolean} true if the specified target is an Icon object, false otherwise.
	   */
	  function isIcon(target) {
	    return angular.isDefined(target.element) && angular.isDefined(target.config);
	  }
	
	  /**
	   * Define the Icon class
	   * @param {Element} el
	   * @param {=ConfigurationItem} config
	   * @constructor
	   */
	  function Icon(el, config) {
	    // If the node is a <symbol>, it won't be rendered so we have to convert it into <svg>.
	    if (el && el.tagName.toLowerCase() === 'symbol') {
	      var viewbox = el.getAttribute('viewBox');
	      // // Check if innerHTML is supported as IE11 does not support innerHTML on SVG elements.
	      if (el.innerHTML) {
	        el = angular.element('<svg xmlns="http://www.w3.org/2000/svg">')
	          .html(el.innerHTML)[0];
	      } else {
	        el = angular.element('<svg xmlns="http://www.w3.org/2000/svg">')
	          .append($mdUtil.getInnerHTML(el))[0];
	      }
	      if (viewbox) el.setAttribute('viewBox', viewbox);
	    }
	
	    if (el && el.tagName.toLowerCase() !== 'svg') {
	      el = angular.element(
	        '<svg xmlns="http://www.w3.org/2000/svg">').append(el.cloneNode(true))[0];
	    }
	
	    // Inject the namespace if not available...
	    if (!el.getAttribute('xmlns')) {
	      el.setAttribute('xmlns', "http://www.w3.org/2000/svg");
	    }
	
	    this.element = el;
	    this.config = config;
	    this.prepare();
	  }
	
	  /**
	   *  Prepare the DOM element that will be cached in the
	   *  loaded iconCache store.
	   */
	  function prepareAndStyle() {
	    var viewBoxSize = this.config ? this.config.viewBoxSize : config.defaultViewBoxSize;
	    angular.forEach({
	      'fit': '',
	      'height': '100%',
	      'width': '100%',
	      'preserveAspectRatio': 'xMidYMid meet',
	      'viewBox': this.element.getAttribute('viewBox') || ('0 0 ' + viewBoxSize + ' ' + viewBoxSize),
	      'focusable': false // Disable IE11s default behavior to make SVGs focusable
	    }, function(val, attr) {
	      this.element.setAttribute(attr, val);
	    }, this);
	  }
	
	  /**
	   * Clone the Icon DOM element.
	   */
	  function cloneSVG() {
	    // If the element or any of its children have a style attribute, then a CSP policy without
	    // 'unsafe-inline' in the style-src directive, will result in a violation.
	    return this.element.cloneNode(true);
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.input
	 */
	mdInputContainerDirective.$inject = ["$mdTheming", "$parse", "$$rAF"];
	inputTextareaDirective.$inject = ["$mdUtil", "$window", "$mdAria", "$timeout", "$mdGesture"];
	mdMaxlengthDirective.$inject = ["$animate", "$mdUtil"];
	placeholderDirective.$inject = ["$compile"];
	ngMessageDirective.$inject = ["$mdUtil"];
	mdSelectOnFocusDirective.$inject = ["$document", "$timeout"];
	mdInputInvalidMessagesAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil"];
	ngMessagesAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil"];
	ngMessageAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil", "$log"];
	var inputModule = angular.module('material.components.input', [
	    'material.core'
	  ])
	  .directive('mdInputContainer', mdInputContainerDirective)
	  .directive('label', labelDirective)
	  .directive('input', inputTextareaDirective)
	  .directive('textarea', inputTextareaDirective)
	  .directive('mdMaxlength', mdMaxlengthDirective)
	  .directive('placeholder', placeholderDirective)
	  .directive('ngMessages', ngMessagesDirective)
	  .directive('ngMessage', ngMessageDirective)
	  .directive('ngMessageExp', ngMessageDirective)
	  .directive('mdSelectOnFocus', mdSelectOnFocusDirective)
	
	  .animation('.md-input-invalid', mdInputInvalidMessagesAnimation)
	  .animation('.md-input-messages-animation', ngMessagesAnimation)
	  .animation('.md-input-message-animation', ngMessageAnimation);
	
	// If we are running inside of tests; expose some extra services so that we can test them
	if (window._mdMocksIncluded) {
	  inputModule.service('$$mdInput', function() {
	    return {
	      // special accessor to internals... useful for testing
	      messages: {
	        getElement  : getMessagesElement
	      }
	    };
	  })
	
	  // Register a service for each animation so that we can easily inject them into unit tests
	  .service('mdInputInvalidAnimation', mdInputInvalidMessagesAnimation)
	  .service('mdInputMessagesAnimation', ngMessagesAnimation)
	  .service('mdInputMessageAnimation', ngMessageAnimation);
	}
	
	/**
	 * @ngdoc directive
	 * @name mdInputContainer
	 * @module material.components.input
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-input-container>` is the parent of any input or textarea element. It can also optionally
	 * wrap `<md-select>` elements so that they will be formatted for use in a form.
	 *
	 * Input and textarea elements will not behave properly unless the md-input-container parent is
	 * provided.
	 *
	 * A single `<md-input-container>` should contain only one `<input>` or `<md-select>` element,
	 * otherwise it will throw an error.
	 *
	 * <b>Exception:</b> Hidden inputs (`<input type="hidden" />`) are ignored and will not throw an
	 * error, so you may combine these with other inputs.
	 *
	 * <b>Note:</b> When using `ngMessages` with your input element, make sure the message and container
	 * elements are *block* elements, otherwise animations applied to the messages will not look as
	 * intended. Either use a `div` and apply the `ng-message` and `ng-messages` classes respectively,
	 * or use the `md-block` class on your element.
	 *
	 * @param {expression=} md-is-error When the given expression evaluates to `true`, the input
	 *   container will go into the error state. Defaults to erroring if the input has been touched and
	 *   is invalid.
	 * @param {boolean=} md-no-float When present, `placeholder` attributes on the input will not be
	 *   converted to floating labels.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-input-container>
	 *   <label>Username</label>
	 *   <input type="text" ng-model="user.name">
	 * </md-input-container>
	 *
	 * <md-input-container>
	 *   <label>Description</label>
	 *   <textarea ng-model="user.description"></textarea>
	 * </md-input-container>
	 *
	 * <md-input-container>
	 *   <md-select ng-model="user.state" placeholder="State of Residence">
	 *     <md-option ng-value="state" ng-repeat="state in states">{{ state }}</md-option>
	 *   </md-select>
	 * </md-input-container>
	 * </hljs>
	 *
	 * <h3>When disabling floating labels</h3>
	 * <hljs lang="html">
	 *
	 * <md-input-container md-no-float>
	 *   <input type="text" placeholder="Non-Floating Label">
	 * </md-input-container>
	 * </hljs>
	 */
	function mdInputContainerDirective($mdTheming, $parse, $$rAF) {
	
	  ContainerCtrl.$inject = ["$scope", "$element", "$attrs", "$animate"];
	  var INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT', 'MD-SELECT'];
	
	  var LEFT_SELECTORS = INPUT_TAGS.reduce(function(selectors, isel) {
	    return selectors.concat(['md-icon ~ ' + isel, '.md-icon ~ ' + isel]);
	  }, []).join(",");
	
	  var RIGHT_SELECTORS = INPUT_TAGS.reduce(function(selectors, isel) {
	    return selectors.concat([isel + ' ~ md-icon', isel + ' ~ .md-icon']);
	  }, []).join(",");
	
	  return {
	    restrict: 'E',
	    compile: compile,
	    controller: ContainerCtrl
	  };
	
	  function compile(tElement) {
	    // Check for both a left & right icon
	    var hasLeftIcon = tElement[0].querySelector(LEFT_SELECTORS);
	    var hasRightIcon = tElement[0].querySelector(RIGHT_SELECTORS);
	
	    return function postLink(scope, element) {
	      $mdTheming(element);
	
	      if (hasLeftIcon || hasRightIcon) {
	        // When accessing the element's contents synchronously, they may not be defined yet because
	        // of the use of ng-if. If we wait one frame, then the element should be there if the ng-if
	        // resolves to true.
	        $$rAF(function() {
	          // Handle the case where the md-icon element is initially hidden via ng-if from #9529.
	          // We don't want to preserve the space for the icon in the case of ng-if, like we do for
	          // ng-show.
	          // Note that we can't use the same selectors from above because the elements are no longer
	          // siblings for textareas at this point due to the insertion of the md-resize-wrapper.
	          var iconNotRemoved = element[0].querySelector('md-icon') ||
	            element[0].querySelector('.md-icon');
	          if (hasLeftIcon && iconNotRemoved) {
	            element.addClass('md-icon-left');
	          }
	          if (hasRightIcon && iconNotRemoved) {
	            element.addClass('md-icon-right');
	          }
	        });
	      }
	    };
	  }
	
	  function ContainerCtrl($scope, $element, $attrs, $animate) {
	    var self = this;
	
	    self.isErrorGetter = $attrs.mdIsError && $parse($attrs.mdIsError);
	
	    self.delegateClick = function() {
	      self.input.focus();
	    };
	    self.element = $element;
	    self.setFocused = function(isFocused) {
	      $element.toggleClass('md-input-focused', !!isFocused);
	    };
	    self.setHasValue = function(hasValue) {
	      $element.toggleClass('md-input-has-value', !!hasValue);
	    };
	    self.setHasPlaceholder = function(hasPlaceholder) {
	      $element.toggleClass('md-input-has-placeholder', !!hasPlaceholder);
	    };
	    self.setInvalid = function(isInvalid) {
	      if (isInvalid) {
	        $animate.addClass($element, 'md-input-invalid');
	      } else {
	        $animate.removeClass($element, 'md-input-invalid');
	      }
	    };
	    $scope.$watch(function() {
	      return self.label && self.input;
	    }, function(hasLabelAndInput) {
	      if (hasLabelAndInput && !self.label.attr('for')) {
	        self.label.attr('for', self.input.attr('id'));
	      }
	    });
	  }
	}
	
	function labelDirective() {
	  return {
	    restrict: 'E',
	    require: '^?mdInputContainer',
	    link: function(scope, element, attr, containerCtrl) {
	      if (!containerCtrl || attr.mdNoFloat || element.hasClass('md-container-ignore')) return;
	
	      containerCtrl.label = element;
	      scope.$on('$destroy', function() {
	        containerCtrl.label = null;
	      });
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name mdInput
	 * @restrict E
	 * @module material.components.input
	 *
	 * @description
	 * You can use any `<input>` or `<textarea>` element as a child of an `<md-input-container>`. This
	 * allows you to build complex forms for data entry.
	 *
	 * When the input is required and uses a floating label, then the label will automatically contain
	 * an asterisk (`*`).<br/>
	 * This behavior can be disabled by using the `md-no-asterisk` attribute.
	 *
	 * @param {number=} md-maxlength The maximum number of characters allowed in this input. If this is
	 *   specified, a character counter will be shown underneath the input.<br/><br/>
	 *   The purpose of **`md-maxlength`** is exactly to show the max length counter text. If you don't
	 *   want the counter text and only need "plain" validation, you can use the "simple" `ng-maxlength`
	 *   or maxlength attributes.<br/><br/>
	 * @param {boolean=} ng-trim If set to false, the input text will be not trimmed automatically.
	 *     Defaults to true.
	 * @param {string=} aria-label Aria-label is required when no label is present.  A warning message
	 *   will be logged in the console if not present.
	 * @param {string=} placeholder An alternative approach to using aria-label when the label is not
	 *   PRESENT. The placeholder text is copied to the aria-label attribute.
	 * @param {boolean=} md-no-autogrow When present, textareas will not grow automatically.
	 * @param {boolean=} md-no-asterisk When present, an asterisk will not be appended to the inputs
	 *   floating label.
	 * @param {boolean=} md-no-resize Disables the textarea resize handle.
	 * @param {number=} max-rows The maximum amount of rows for a textarea.
	 * @param {boolean=} md-detect-hidden When present, textareas will be sized properly when they are
	 *   revealed after being hidden. This is off by default for performance reasons because it
	 *   guarantees a reflow every digest cycle.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-input-container>
	 *   <label>Color</label>
	 *   <input type="text" ng-model="color" required md-maxlength="10">
	 * </md-input-container>
	 * </hljs>
	 *
	 * <h3>With Errors</h3>
	 *
	 * `md-input-container` also supports errors using the standard `ng-messages` directives and
	 * animates the messages when they become visible using from the `ngEnter`/`ngLeave` events or
	 * the `ngShow`/`ngHide` events.
	 *
	 * By default, the messages will be hidden until the input is in an error state. This is based off
	 * of the `md-is-error` expression of the `md-input-container`. This gives the user a chance to
	 * fill out the form before the errors become visible.
	 *
	 * <hljs lang="html">
	 * <form name="colorForm">
	 *   <md-input-container>
	 *     <label>Favorite Color</label>
	 *     <input name="favoriteColor" ng-model="favoriteColor" required>
	 *     <div ng-messages="colorForm.favoriteColor.$error">
	 *       <div ng-message="required">This is required!</div>
	 *     </div>
	 *   </md-input-container>
	 * </form>
	 * </hljs>
	 *
	 * We automatically disable this auto-hiding functionality if you provide any of the following
	 * visibility directives on the `ng-messages` container:
	 *
	 *  - `ng-if`
	 *  - `ng-show`/`ng-hide`
	 *  - `ng-switch-when`/`ng-switch-default`
	 *
	 * You can also disable this functionality manually by adding the `md-auto-hide="false"` expression
	 * to the `ng-messages` container. This may be helpful if you always want to see the error messages
	 * or if you are building your own visibility directive.
	 *
	 * _<b>Note:</b> The `md-auto-hide` attribute is a static string that is  only checked upon
	 * initialization of the `ng-messages` directive to see if it equals the string `false`._
	 *
	 * <hljs lang="html">
	 * <form name="userForm">
	 *   <md-input-container>
	 *     <label>Last Name</label>
	 *     <input name="lastName" ng-model="lastName" required md-maxlength="10" minlength="4">
	 *     <div ng-messages="userForm.lastName.$error" ng-show="userForm.lastName.$dirty">
	 *       <div ng-message="required">This is required!</div>
	 *       <div ng-message="md-maxlength">That's too long!</div>
	 *       <div ng-message="minlength">That's too short!</div>
	 *     </div>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <label>Biography</label>
	 *     <textarea name="bio" ng-model="biography" required md-maxlength="150"></textarea>
	 *     <div ng-messages="userForm.bio.$error" ng-show="userForm.bio.$dirty">
	 *       <div ng-message="required">This is required!</div>
	 *       <div ng-message="md-maxlength">That's too long!</div>
	 *     </div>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <input aria-label='title' ng-model='title'>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <input placeholder='title' ng-model='title'>
	 *   </md-input-container>
	 * </form>
	 * </hljs>
	 *
	 * <h3>Notes</h3>
	 *
	 * - Requires [ngMessages](https://docs.angularjs.org/api/ngMessages).
	 * - Behaves like the [AngularJS input directive](https://docs.angularjs.org/api/ng/directive/input).
	 *
	 * The `md-input` and `md-input-container` directives use very specific positioning to achieve the
	 * error animation effects. Therefore, it is *not* advised to use the Layout system inside of the
	 * `<md-input-container>` tags. Instead, use relative or absolute positioning.
	 *
	 *
	 * <h3>Textarea directive</h3>
	 * The `textarea` element within a `md-input-container` has the following specific behavior:
	 * - By default the `textarea` grows as the user types. This can be disabled via the `md-no-autogrow`
	 * attribute.
	 * - If a `textarea` has the `rows` attribute, it will treat the `rows` as the minimum height and will
	 * continue growing as the user types. For example a textarea with `rows="3"` will be 3 lines of text
	 * high initially. If no rows are specified, the directive defaults to 1.
	 * - The textarea's height gets set on initialization, as well as while the user is typing. In certain situations
	 * (e.g. while animating) the directive might have been initialized, before the element got it's final height. In
	 * those cases, you can trigger a resize manually by broadcasting a `md-resize-textarea` event on the scope.
	 * - If you want a `textarea` to stop growing at a certain point, you can specify the `max-rows` attribute.
	 * - The textarea's bottom border acts as a handle which users can drag, in order to resize the element vertically.
	 * Once the user has resized a `textarea`, the autogrowing functionality becomes disabled. If you don't want a
	 * `textarea` to be resizeable by the user, you can add the `md-no-resize` attribute.
	 */
	
	function inputTextareaDirective($mdUtil, $window, $mdAria, $timeout, $mdGesture) {
	  return {
	    restrict: 'E',
	    require: ['^?mdInputContainer', '?ngModel', '?^form'],
	    link: postLink
	  };
	
	  function postLink(scope, element, attr, ctrls) {
	
	    var containerCtrl = ctrls[0];
	    var hasNgModel = !!ctrls[1];
	    var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
	    var parentForm = ctrls[2];
	    var isReadonly = angular.isDefined(attr.readonly);
	    var mdNoAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);
	    var tagName = element[0].tagName.toLowerCase();
	
	
	    if (!containerCtrl) return;
	    if (attr.type === 'hidden') {
	      element.attr('aria-hidden', 'true');
	      return;
	    } else if (containerCtrl.input) {
	      if (containerCtrl.input[0].contains(element[0])) {
	        return;
	      } else {
	        throw new Error("<md-input-container> can only have *one* <input>, <textarea> or <md-select> child element!");
	      }
	    }
	    containerCtrl.input = element;
	
	    setupAttributeWatchers();
	
	    // Add an error spacer div after our input to provide space for the char counter and any ng-messages
	    var errorsSpacer = angular.element('<div class="md-errors-spacer">');
	    element.after(errorsSpacer);
	
	    var placeholderText = angular.isString(attr.placeholder) ? attr.placeholder.trim() : '';
	    if (!containerCtrl.label && !placeholderText.length) {
	      $mdAria.expect(element, 'aria-label');
	    }
	
	    element.addClass('md-input');
	    if (!element.attr('id')) {
	      element.attr('id', 'input_' + $mdUtil.nextUid());
	    }
	
	    // This works around a Webkit issue where number inputs, placed in a flexbox, that have
	    // a `min` and `max` will collapse to about 1/3 of their proper width. Please check #7349
	    // for more info. Also note that we don't override the `step` if the user has specified it,
	    // in order to prevent some unexpected behaviour.
	    if (tagName === 'input' && attr.type === 'number' && attr.min && attr.max && !attr.step) {
	      element.attr('step', 'any');
	    } else if (tagName === 'textarea') {
	      setupTextarea();
	    }
	
	    // If the input doesn't have an ngModel, it may have a static value. For that case,
	    // we have to do one initial check to determine if the container should be in the
	    // "has a value" state.
	    if (!hasNgModel) {
	      inputCheckValue();
	    }
	
	    var isErrorGetter = containerCtrl.isErrorGetter || function() {
	      return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (parentForm && parentForm.$submitted));
	    };
	
	    scope.$watch(isErrorGetter, containerCtrl.setInvalid);
	
	    // When the developer uses the ngValue directive for the input, we have to observe the attribute, because
	    // AngularJS's ngValue directive is just setting the `value` attribute.
	    if (attr.ngValue) {
	      attr.$observe('value', inputCheckValue);
	    }
	
	    ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);
	    ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);
	
	    element.on('input', inputCheckValue);
	
	    if (!isReadonly) {
	      element
	        .on('focus', function(ev) {
	          $mdUtil.nextTick(function() {
	            containerCtrl.setFocused(true);
	          });
	        })
	        .on('blur', function(ev) {
	          $mdUtil.nextTick(function() {
	            containerCtrl.setFocused(false);
	            inputCheckValue();
	          });
	        });
	    }
	
	    scope.$on('$destroy', function() {
	      containerCtrl.setFocused(false);
	      containerCtrl.setHasValue(false);
	      containerCtrl.input = null;
	    });
	
	    /** Gets run through ngModel's pipeline and set the `has-value` class on the container. */
	    function ngModelPipelineCheckValue(arg) {
	      containerCtrl.setHasValue(!ngModelCtrl.$isEmpty(arg));
	      return arg;
	    }
	
	    function setupAttributeWatchers() {
	      if (containerCtrl.label) {
	        attr.$observe('required', function (value) {
	          // We don't need to parse the required value, it's always a boolean because of angular's
	          // required directive.
	          containerCtrl.label.toggleClass('md-required', value && !mdNoAsterisk);
	        });
	      }
	    }
	
	    function inputCheckValue() {
	      // An input's value counts if its length > 0,
	      // or if the input's validity state says it has bad input (eg string in a number input)
	      containerCtrl.setHasValue(element.val().length > 0 || (element[0].validity || {}).badInput);
	    }
	
	    function setupTextarea() {
	      var isAutogrowing = !attr.hasOwnProperty('mdNoAutogrow');
	
	      attachResizeHandle();
	
	      if (!isAutogrowing) return;
	
	      // Can't check if height was or not explicity set,
	      // so rows attribute will take precedence if present
	      var minRows = attr.hasOwnProperty('rows') ? parseInt(attr.rows) : NaN;
	      var maxRows = attr.hasOwnProperty('maxRows') ? parseInt(attr.maxRows) : NaN;
	      var scopeResizeListener = scope.$on('md-resize-textarea', growTextarea);
	      var lineHeight = null;
	      var node = element[0];
	
	      // This timeout is necessary, because the browser needs a little bit
	      // of time to calculate the `clientHeight` and `scrollHeight`.
	      $timeout(function() {
	        $mdUtil.nextTick(growTextarea);
	      }, 10, false);
	
	      // We could leverage ngModel's $parsers here, however it
	      // isn't reliable, because AngularJS trims the input by default,
	      // which means that growTextarea won't fire when newlines and
	      // spaces are added.
	      element.on('input', growTextarea);
	
	      // We should still use the $formatters, because they fire when
	      // the value was changed from outside the textarea.
	      if (hasNgModel) {
	        ngModelCtrl.$formatters.push(formattersListener);
	      }
	
	      if (!minRows) {
	        element.attr('rows', 1);
	      }
	
	      angular.element($window).on('resize', growTextarea);
	      scope.$on('$destroy', disableAutogrow);
	
	      function growTextarea() {
	        // temporarily disables element's flex so its height 'runs free'
	        element
	          .attr('rows', 1)
	          .css('height', 'auto')
	          .addClass('md-no-flex');
	
	        var height = getHeight();
	
	        if (!lineHeight) {
	          // offsetHeight includes padding which can throw off our value
	          var originalPadding = element[0].style.padding || '';
	          lineHeight = element.css('padding', 0).prop('offsetHeight');
	          element[0].style.padding = originalPadding;
	        }
	
	        if (minRows && lineHeight) {
	          height = Math.max(height, lineHeight * minRows);
	        }
	
	        if (maxRows && lineHeight) {
	          var maxHeight = lineHeight * maxRows;
	
	          if (maxHeight < height) {
	            element.attr('md-no-autogrow', '');
	            height = maxHeight;
	          } else {
	            element.removeAttr('md-no-autogrow');
	          }
	        }
	
	        if (lineHeight) {
	          element.attr('rows', Math.round(height / lineHeight));
	        }
	
	        element
	          .css('height', height + 'px')
	          .removeClass('md-no-flex');
	      }
	
	      function getHeight() {
	        var offsetHeight = node.offsetHeight;
	        var line = node.scrollHeight - offsetHeight;
	        return offsetHeight + Math.max(line, 0);
	      }
	
	      function formattersListener(value) {
	        $mdUtil.nextTick(growTextarea);
	        return value;
	      }
	
	      function disableAutogrow() {
	        if (!isAutogrowing) return;
	
	        isAutogrowing = false;
	        angular.element($window).off('resize', growTextarea);
	        scopeResizeListener && scopeResizeListener();
	        element
	          .attr('md-no-autogrow', '')
	          .off('input', growTextarea);
	
	        if (hasNgModel) {
	          var listenerIndex = ngModelCtrl.$formatters.indexOf(formattersListener);
	
	          if (listenerIndex > -1) {
	            ngModelCtrl.$formatters.splice(listenerIndex, 1);
	          }
	        }
	      }
	
	      function attachResizeHandle() {
	        if (attr.hasOwnProperty('mdNoResize')) return;
	
	        var handle = angular.element('<div class="md-resize-handle"></div>');
	        var isDragging = false;
	        var dragStart = null;
	        var startHeight = 0;
	        var container = containerCtrl.element;
	        var dragGestureHandler = $mdGesture.register(handle, 'drag', { horizontal: false });
	
	
	        element.wrap('<div class="md-resize-wrapper">').after(handle);
	        handle.on('mousedown', onMouseDown);
	
	        container
	          .on('$md.dragstart', onDragStart)
	          .on('$md.drag', onDrag)
	          .on('$md.dragend', onDragEnd);
	
	        scope.$on('$destroy', function() {
	          handle
	            .off('mousedown', onMouseDown)
	            .remove();
	
	          container
	            .off('$md.dragstart', onDragStart)
	            .off('$md.drag', onDrag)
	            .off('$md.dragend', onDragEnd);
	
	          dragGestureHandler();
	          handle = null;
	          container = null;
	          dragGestureHandler = null;
	        });
	
	        function onMouseDown(ev) {
	          ev.preventDefault();
	          isDragging = true;
	          dragStart = ev.clientY;
	          startHeight = parseFloat(element.css('height')) || element.prop('offsetHeight');
	        }
	
	        function onDragStart(ev) {
	          if (!isDragging) return;
	          ev.preventDefault();
	          disableAutogrow();
	          container.addClass('md-input-resized');
	        }
	
	        function onDrag(ev) {
	          if (!isDragging) return;
	
	          element.css('height', (startHeight + ev.pointer.distanceY) + 'px');
	        }
	
	        function onDragEnd(ev) {
	          if (!isDragging) return;
	          isDragging = false;
	          container.removeClass('md-input-resized');
	        }
	      }
	
	      // Attach a watcher to detect when the textarea gets shown.
	      if (attr.hasOwnProperty('mdDetectHidden')) {
	
	        var handleHiddenChange = function() {
	          var wasHidden = false;
	
	          return function() {
	            var isHidden = node.offsetHeight === 0;
	
	            if (isHidden === false && wasHidden === true) {
	              growTextarea();
	            }
	
	            wasHidden = isHidden;
	          };
	        }();
	
	        // Check every digest cycle whether the visibility of the textarea has changed.
	        // Queue up to run after the digest cycle is complete.
	        scope.$watch(function() {
	          $mdUtil.nextTick(handleHiddenChange, false);
	          return true;
	        });
	      }
	    }
	  }
	}
	
	function mdMaxlengthDirective($animate, $mdUtil) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^mdInputContainer'],
	    link: postLink
	  };
	
	  function postLink(scope, element, attr, ctrls) {
	    var maxlength = parseInt(attr.mdMaxlength);
	    if (isNaN(maxlength)) maxlength = -1;
	    var ngModelCtrl = ctrls[0];
	    var containerCtrl = ctrls[1];
	    var charCountEl, errorsSpacer;
	    var ngTrim = angular.isDefined(attr.ngTrim) ? $mdUtil.parseAttributeBoolean(attr.ngTrim) : true;
	    var isPasswordInput = attr.type === 'password';
	
	    scope.$watch(attr.mdMaxlength, function(value) {
	      maxlength = value;
	    });
	
	    ngModelCtrl.$validators['md-maxlength'] = function(modelValue, viewValue) {
	      if (!angular.isNumber(maxlength) || maxlength < 0) {
	        return true;
	      }
	
	      // We always update the char count, when the modelValue has changed.
	      // Using the $validators for triggering the update works very well.
	      renderCharCount();
	
	      var elementVal = element.val() || viewValue;
	      if (elementVal === undefined || elementVal === null) {
	        elementVal = '';
	      }
	      elementVal = ngTrim && !isPasswordInput && angular.isString(elementVal) ? elementVal.trim() : elementVal;
	      // Force the value into a string since it may be a number,
	      // which does not have a length property.
	      return String(elementVal).length <= maxlength;
	    };
	
	    /**
	     * Override the default NgModelController $isEmpty check to take ng-trim, password inputs,
	     * etc. into account.
	     * @param value {*} the input's value
	     * @returns {boolean} true if the input's value should be considered empty, false otherwise
	     */
	    ngModelCtrl.$isEmpty = function(value) {
	      return calculateInputValueLength(value) === 0;
	    };
	
	    // Wait until the next tick to ensure that the input has setup the errors spacer where we will
	    // append our counter
	    $mdUtil.nextTick(function() {
	      errorsSpacer = angular.element(containerCtrl.element[0].querySelector('.md-errors-spacer'));
	      charCountEl = angular.element('<div class="md-char-counter">');
	
	      // Append our character counter inside the errors spacer
	      errorsSpacer.append(charCountEl);
	
	      attr.$observe('ngTrim', function (value) {
	        ngTrim = angular.isDefined(value) ? $mdUtil.parseAttributeBoolean(value) : true;
	      });
	
	      scope.$watch(attr.mdMaxlength, function(value) {
	        if (angular.isNumber(value) && value > 0) {
	          if (!charCountEl.parent().length) {
	            $animate.enter(charCountEl, errorsSpacer);
	          }
	          renderCharCount();
	        } else {
	          $animate.leave(charCountEl);
	        }
	      });
	    });
	
	    /**
	     * Calculate the input value's length after coercing it to a string
	     * and trimming it if appropriate.
	     * @param value {*} the input's value
	     * @returns {number} calculated length of the input's value
	     */
	    function calculateInputValueLength(value) {
	      value = ngTrim && !isPasswordInput && angular.isString(value) ? value.trim() : value;
	      if (value === undefined || value === null) {
	        value = '';
	      }
	      return String(value).length;
	    }
	
	    function renderCharCount() {
	      // If we have not been initialized or appended to the body yet; do not render.
	      if (!charCountEl || !charCountEl.parent()) {
	        return;
	      }
	      // Force the value into a string since it may be a number,
	      // which does not have a length property.
	      charCountEl.text(calculateInputValueLength(element.val()) + ' / ' + maxlength);
	    }
	  }
	}
	
	function placeholderDirective($compile) {
	  return {
	    restrict: 'A',
	    require: '^^?mdInputContainer',
	    priority: 200,
	    link: {
	      // Note that we need to do this in the pre-link, as opposed to the post link, if we want to
	      // support data bindings in the placeholder. This is necessary, because we have a case where
	      // we transfer the placeholder value to the `<label>` and we remove it from the original `<input>`.
	      // If we did this in the post-link, AngularJS would have set up the observers already and would be
	      // re-adding the attribute, even though we removed it from the element.
	      pre: preLink
	    }
	  };
	
	  function preLink(scope, element, attr, inputContainer) {
	    // If there is no input container, just return
	    if (!inputContainer) return;
	
	    var label = inputContainer.element.find('label');
	    var noFloat = inputContainer.element.attr('md-no-float');
	
	    // If we have a label, or they specify the md-no-float attribute, just return
	    if ((label && label.length) || noFloat === '' || scope.$eval(noFloat)) {
	      // Add a placeholder class so we can target it in the CSS
	      inputContainer.setHasPlaceholder(true);
	      return;
	    }
	
	    // md-select handles placeholders on it's own
	    if (element[0].nodeName !== 'MD-SELECT') {
	      // Move the placeholder expression to the label
	      var newLabel = angular.element(
	        '<label ng-click="delegateClick()" tabindex="-1" aria-hidden="true">' + attr.placeholder +
	        '</label>');
	
	      // Note that we unset it via `attr`, in order to get AngularJS
	      // to remove any observers that it might have set up. Otherwise
	      // the attribute will be added on the next digest.
	      attr.$set('placeholder', null);
	
	      // We need to compile the label manually in case it has any bindings.
	      // A gotcha here is that we first add the element to the DOM and we compile
	      // it later. This is necessary, because if we compile the element beforehand,
	      // it won't be able to find the `mdInputContainer` controller.
	      inputContainer.element
	        .addClass('md-icon-float')
	        .prepend(newLabel);
	
	      $compile(newLabel)(scope);
	    }
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name mdSelectOnFocus
	 * @module material.components.input
	 *
	 * @restrict A
	 *
	 * @description
	 * The `md-select-on-focus` directive allows you to automatically select the element's input text on focus.
	 *
	 * <h3>Notes</h3>
	 * - The use of `md-select-on-focus` is restricted to `<input>` and `<textarea>` elements.
	 *
	 * @usage
	 * <h3>Using with an Input</h3>
	 * <hljs lang="html">
	 *
	 * <md-input-container>
	 *   <label>Auto Select</label>
	 *   <input type="text" md-select-on-focus>
	 * </md-input-container>
	 * </hljs>
	 *
	 * <h3>Using with a Textarea</h3>
	 * <hljs lang="html">
	 *
	 * <md-input-container>
	 *   <label>Auto Select</label>
	 *   <textarea md-select-on-focus>This text will be selected on focus.</textarea>
	 * </md-input-container>
	 *
	 * </hljs>
	 */
	function mdSelectOnFocusDirective($document, $timeout) {
	
	  return {
	    restrict: 'A',
	    link: postLink
	  };
	
	  function postLink(scope, element, attr) {
	    if (element[0].nodeName !== 'INPUT' && element[0].nodeName !== "TEXTAREA") return;
	
	    var preventMouseUp = false;
	
	    element
	      .on('focus', onFocus)
	      .on('mouseup', onMouseUp);
	
	    scope.$on('$destroy', function() {
	      element
	        .off('focus', onFocus)
	        .off('mouseup', onMouseUp);
	    });
	
	    function onFocus() {
	      preventMouseUp = true;
	
	      $timeout(function() {
	
	        // Use HTMLInputElement#select to fix firefox select issues.
	        // The debounce is here for Edge's sake, otherwise the selection doesn't work.
	        // Since focus may already have been lost on the input (and because `select()`
	        // will re-focus), make sure the element is still active before applying.
	        if ($document[0].activeElement === element[0]) {
	          element[0].select();
	        }
	
	        // This should be reset from inside the `focus`, because the event might
	        // have originated from something different than a click, e.g. a keyboard event.
	        preventMouseUp = false;
	      }, 1, false);
	    }
	
	    // Prevents the default action of the first `mouseup` after a focus.
	    // This is necessary, because browsers fire a `mouseup` right after the element
	    // has been focused. In some browsers (Firefox in particular) this can clear the
	    // selection. There are examples of the problem in issue #7487.
	    function onMouseUp(event) {
	      if (preventMouseUp) {
	        event.preventDefault();
	      }
	    }
	  }
	}
	
	var visibilityDirectives = ['ngIf', 'ngShow', 'ngHide', 'ngSwitchWhen', 'ngSwitchDefault'];
	function ngMessagesDirective() {
	  return {
	    restrict: 'EA',
	    link: postLink,
	
	    // This is optional because we don't want target *all* ngMessage instances, just those inside of
	    // mdInputContainer.
	    require: '^^?mdInputContainer'
	  };
	
	  function postLink(scope, element, attrs, inputContainer) {
	    // If we are not a child of an input container, don't do anything
	    if (!inputContainer) return;
	
	    // Add our animation class
	    element.toggleClass('md-input-messages-animation', true);
	
	    // Add our md-auto-hide class to automatically hide/show messages when container is invalid
	    element.toggleClass('md-auto-hide', true);
	
	    // If we see some known visibility directives, remove the md-auto-hide class
	    if (attrs.mdAutoHide == 'false' || hasVisibiltyDirective(attrs)) {
	      element.toggleClass('md-auto-hide', false);
	    }
	  }
	
	  function hasVisibiltyDirective(attrs) {
	    return visibilityDirectives.some(function(attr) {
	      return attrs[attr];
	    });
	  }
	}
	
	function ngMessageDirective($mdUtil) {
	  return {
	    restrict: 'EA',
	    compile: compile,
	    priority: 100
	  };
	
	  function compile(tElement) {
	    if (!isInsideInputContainer(tElement)) {
	
	      // When the current element is inside of a document fragment, then we need to check for an input-container
	      // in the postLink, because the element will be later added to the DOM and is currently just in a temporary
	      // fragment, which causes the input-container check to fail.
	      if (isInsideFragment()) {
	        return function (scope, element) {
	          if (isInsideInputContainer(element)) {
	            // Inside of the postLink function, a ngMessage directive will be a comment element, because it's
	            // currently hidden. To access the shown element, we need to use the element from the compile function.
	            initMessageElement(tElement);
	          }
	        };
	      }
	    } else {
	      initMessageElement(tElement);
	    }
	
	    function isInsideFragment() {
	      var nextNode = tElement[0];
	      while (nextNode = nextNode.parentNode) {
	        if (nextNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    function isInsideInputContainer(element) {
	      return !!$mdUtil.getClosest(element, "md-input-container");
	    }
	
	    function initMessageElement(element) {
	      // Add our animation class
	      element.toggleClass('md-input-message-animation', true);
	    }
	  }
	}
	
	var $$AnimateRunner, $animateCss, $mdUtil;
	
	function mdInputInvalidMessagesAnimation($$AnimateRunner, $animateCss, $mdUtil) {
	  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil);
	
	  return {
	    addClass: function(element, className, done) {
	      showInputMessages(element, done);
	    }
	
	    // NOTE: We do not need the removeClass method, because the message ng-leave animation will fire
	  };
	}
	
	function ngMessagesAnimation($$AnimateRunner, $animateCss, $mdUtil) {
	  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil);
	
	  return {
	    enter: function(element, done) {
	      showInputMessages(element, done);
	    },
	
	    leave: function(element, done) {
	      hideInputMessages(element, done);
	    },
	
	    addClass: function(element, className, done) {
	      if (className == "ng-hide") {
	        hideInputMessages(element, done);
	      } else {
	        done();
	      }
	    },
	
	    removeClass: function(element, className, done) {
	      if (className == "ng-hide") {
	        showInputMessages(element, done);
	      } else {
	        done();
	      }
	    }
	  };
	}
	
	function ngMessageAnimation($$AnimateRunner, $animateCss, $mdUtil, $log) {
	  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil, $log);
	
	  return {
	    enter: function(element, done) {
	      var animator = showMessage(element);
	
	      animator.start().done(done);
	    },
	
	    leave: function(element, done) {
	      var animator = hideMessage(element);
	
	      animator.start().done(done);
	    }
	  };
	}
	
	function showInputMessages(element, done) {
	  var animators = [], animator;
	  var messages = getMessagesElement(element);
	  var children = messages.children();
	
	  if (messages.length == 0 || children.length == 0) {
	    done();
	    return;
	  }
	
	  angular.forEach(children, function(child) {
	    animator = showMessage(angular.element(child));
	
	    animators.push(animator.start());
	  });
	
	  $$AnimateRunner.all(animators, done);
	}
	
	function hideInputMessages(element, done) {
	  var animators = [], animator;
	  var messages = getMessagesElement(element);
	  var children = messages.children();
	
	  if (messages.length == 0 || children.length == 0) {
	    done();
	    return;
	  }
	
	  angular.forEach(children, function(child) {
	    animator = hideMessage(angular.element(child));
	
	    animators.push(animator.start());
	  });
	
	  $$AnimateRunner.all(animators, done);
	}
	
	function showMessage(element) {
	  var height = parseInt(window.getComputedStyle(element[0]).height);
	  var topMargin = parseInt(window.getComputedStyle(element[0]).marginTop);
	
	  var messages = getMessagesElement(element);
	  var container = getInputElement(element);
	
	  // Check to see if the message is already visible so we can skip
	  var alreadyVisible = (topMargin > -height);
	
	  // If we have the md-auto-hide class, the md-input-invalid animation will fire, so we can skip
	  if (alreadyVisible || (messages.hasClass('md-auto-hide') && !container.hasClass('md-input-invalid'))) {
	    return $animateCss(element, {});
	  }
	
	  return $animateCss(element, {
	    event: 'enter',
	    structural: true,
	    from: {"opacity": 0, "margin-top": -height + "px"},
	    to: {"opacity": 1, "margin-top": "0"},
	    duration: 0.3
	  });
	}
	
	function hideMessage(element) {
	  var height = element[0].offsetHeight;
	  var styles = window.getComputedStyle(element[0]);
	
	  // If we are already hidden, just return an empty animation
	  if (parseInt(styles.opacity) === 0) {
	    return $animateCss(element, {});
	  }
	
	  // Otherwise, animate
	  return $animateCss(element, {
	    event: 'leave',
	    structural: true,
	    from: {"opacity": 1, "margin-top": 0},
	    to: {"opacity": 0, "margin-top": -height + "px"},
	    duration: 0.3
	  });
	}
	
	function getInputElement(element) {
	  var inputContainer = element.controller('mdInputContainer');
	
	  return inputContainer.element;
	}
	
	function getMessagesElement(element) {
	  // If we ARE the messages element, just return ourself
	  if (element.hasClass('md-input-messages-animation')) {
	    return element;
	  }
	
	  // If we are a ng-message element, we need to traverse up the DOM tree
	  if (element.hasClass('md-input-message-animation')) {
	    return angular.element($mdUtil.getClosest(element, function(node) {
	      return node.classList.contains('md-input-messages-animation');
	    }));
	  }
	
	  // Otherwise, we can traverse down
	  return angular.element(element[0].querySelector('.md-input-messages-animation'));
	}
	
	function saveSharedServices(_$$AnimateRunner_, _$animateCss_, _$mdUtil_) {
	  $$AnimateRunner = _$$AnimateRunner_;
	  $animateCss = _$animateCss_;
	  $mdUtil = _$mdUtil_;
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.list
	 * @description
	 * List module
	 */
	MdListController.$inject = ["$scope", "$element", "$mdListInkRipple"];
	mdListDirective.$inject = ["$mdTheming"];
	mdListItemDirective.$inject = ["$mdAria", "$mdConstant", "$mdUtil", "$timeout"];
	angular.module('material.components.list', [
	  'material.core'
	])
	  .controller('MdListController', MdListController)
	  .directive('mdList', mdListDirective)
	  .directive('mdListItem', mdListItemDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdList
	 * @module material.components.list
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-list>` directive is a list container for 1..n `<md-list-item>` tags.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-list>
	 *   <md-list-item class="md-2-line" ng-repeat="item in todos">
	 *     <md-checkbox ng-model="item.done"></md-checkbox>
	 *     <div class="md-list-item-text">
	 *       <h3>{{item.title}}</h3>
	 *       <p>{{item.description}}</p>
	 *     </div>
	 *   </md-list-item>
	 * </md-list>
	 * </hljs>
	 */
	
	function mdListDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    compile: function(tEl) {
	      tEl[0].setAttribute('role', 'list');
	      return $mdTheming;
	    }
	  };
	}
	/**
	 * @ngdoc directive
	 * @name mdListItem
	 * @module material.components.list
	 *
	 * @restrict E
	 *
	 * @description
	 * A `md-list-item` element can be used to represent some information in a row.<br/>
	 *
	 * @usage
	 * ### Single Row Item
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Multiple Lines
	 * By using the following markup, you will be able to have two lines inside of one `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-2-line">
	 *     <div class="md-list-item-text" layout="column">
	 *       <p>First Line</p>
	 *       <p>Second Line</p>
	 *     </div>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * It is also possible to have three lines inside of one list item.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-3-line">
	 *     <div class="md-list-item-text" layout="column">
	 *       <p>First Line</p>
	 *       <p>Second Line</p>
	 *       <p>Third Line</p>
	 *     </div>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Secondary Items
	 * Secondary items are elements which will be aligned at the end of the `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *     <md-button class="md-secondary">
	 *       Secondary Button
	 *     </md-button>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * It also possible to have multiple secondary items inside of one `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *     <md-button class="md-secondary">First Button</md-button>
	 *     <md-button class="md-secondary">Second Button</md-button>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Proxy Item
	 * Proxies are elements, which will execute their specific action on click<br/>
	 * Currently supported proxy items are
	 * - `md-checkbox` (Toggle)
	 * - `md-switch` (Toggle)
	 * - `md-menu` (Open)
	 *
	 * This means, when using a supported proxy item inside of `md-list-item`, the list item will
	 * automatically become clickable and executes the associated action of the proxy element on click.
	 *
	 * It is possible to disable this behavior by applying the `md-no-proxy` class to the list item.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-no-proxy">
	 *     <span>No Proxy List</span>
	 *     <md-checkbox class="md-secondary"></md-checkbox>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * Here are a few examples of proxy elements inside of a list item.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>First Line</span>
	 *     <md-checkbox class="md-secondary"></md-checkbox>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The `md-checkbox` element will be automatically detected as a proxy element and will toggle on
	 * click.
	 *
	 * If not provided, an `aria-label` will be applied using the text of the list item.
	 * In this case, the following will be applied to the `md-checkbox`:
	 * `aria-label="Toggle First Line"`.
	 * When localizing your application, you should supply a localized `aria-label`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>First Line</span>
	 *     <md-switch class="md-secondary"></md-switch>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The recognized `md-switch` will toggle its state, when the user clicks on the `md-list-item`.
	 *
	 * It is also possible to have a `md-menu` inside of a `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <p>Click anywhere to fire the secondary action</p>
	 *     <md-menu class="md-secondary">
	 *       <md-button class="md-icon-button">
	 *         <md-icon md-svg-icon="communication:message"></md-icon>
	 *       </md-button>
	 *       <md-menu-content width="4">
	 *         <md-menu-item>
	 *           <md-button>
	 *             Redial
	 *           </md-button>
	 *         </md-menu-item>
	 *         <md-menu-item>
	 *           <md-button>
	 *             Check voicemail
	 *           </md-button>
	 *         </md-menu-item>
	 *         <md-menu-divider></md-menu-divider>
	 *         <md-menu-item>
	 *           <md-button>
	 *             Notifications
	 *           </md-button>
	 *         </md-menu-item>
	 *       </md-menu-content>
	 *     </md-menu>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The menu will automatically open, when the users clicks on the `md-list-item`.<br/>
	 *
	 * If the developer didn't specify any position mode on the menu, the `md-list-item` will
	 * automatically detect the position mode and apply it to the `md-menu`.
	 *
	 * ### Avatars
	 * Sometimes you may want to have avatars inside of the `md-list-item `.<br/>
	 * You are able to create an optimized icon for the list item, by applying the `.md-avatar` class on
	 * the `<img>` element.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <img src="my-avatar.png" class="md-avatar">
	 *     <span>Alan Turing</span>
	 * </hljs>
	 *
	 * When using `<md-icon>` for an avatar, you have to use the `.md-avatar-icon` class.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <md-icon class="md-avatar-icon" md-svg-icon="social:person"></md-icon>
	 *     <span>Timothy Kopra</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * In cases where you have a `md-list-item`, which doesn't have an avatar,
	 * but you want to align it with the other avatar items, you need to use the `.md-offset` class.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-offset">
	 *     <span>Jon Doe</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### DOM modification
	 * The `md-list-item` component automatically detects if the list item should be clickable.
	 *
	 * ---
	 * If the `md-list-item` is clickable, we wrap all content inside of a `<div>` and create
	 * an overlaying button, which will will execute the given actions (like `ng-href`, `ng-click`).
	 *
	 * We create an overlaying button, instead of wrapping all content inside of the button,
	 * because otherwise some elements may not be clickable inside of the button.
	 *
	 * ---
	 * When using a secondary item inside of your list item, the `md-list-item` component will
	 * automatically create a secondary container at the end of the `md-list-item`, which contains all
	 * secondary items.
	 *
	 * The secondary item container is not static, because that would cause issues with the overflow
	 * of the list item.
	 */
	function mdListItemDirective($mdAria, $mdConstant, $mdUtil, $timeout) {
	  var proxiedTypes = ['md-checkbox', 'md-switch', 'md-menu'];
	  return {
	    restrict: 'E',
	    controller: 'MdListController',
	
	    compile: function(tElement, tAttrs) {
	
	      // Check for proxy controls (no ng-click on parent, and a control inside)
	      var secondaryItems = tElement[0].querySelectorAll('.md-secondary');
	      var hasProxiedElement;
	      var proxyElement;
	      var itemContainer = tElement;
	
	      tElement[0].setAttribute('role', 'listitem');
	
	      if (tAttrs.ngClick || tAttrs.ngDblclick ||  tAttrs.ngHref || tAttrs.href || tAttrs.uiSref || tAttrs.ngAttrUiSref) {
	        wrapIn('button');
	      } else if (!tElement.hasClass('md-no-proxy')) {
	
	        for (var i = 0, type; i < proxiedTypes.length; ++i) {
	          proxyElement = tElement[0].querySelector(proxiedTypes[i]);
	          if (proxyElement !== null) {
	            hasProxiedElement = true;
	            break;
	          }
	        }
	
	        if (hasProxiedElement) {
	          wrapIn('div');
	        } else {
	          tElement.addClass('md-no-proxy');
	        }
	      }
	
	      wrapSecondaryItems();
	      setupToggleAria();
	
	      if (hasProxiedElement && proxyElement.nodeName === "MD-MENU") {
	        setupProxiedMenu();
	      }
	
	      function setupToggleAria() {
	        var toggleTypes = ['md-switch', 'md-checkbox'];
	        var toggle;
	
	        for (var i = 0, toggleType; i < toggleTypes.length; ++i) {
	          toggle = tElement.find(toggleTypes[i])[0];
	          if (toggle) {
	            if (!toggle.hasAttribute('aria-label')) {
	              var labelElement = tElement.find('p')[0];
	              if (!labelElement) {
	                labelElement = tElement.find('span')[0];
	              }
	              if (!labelElement) return;
	              toggle.setAttribute('aria-label', 'Toggle ' + labelElement.textContent);
	            }
	          }
	        }
	      }
	
	      function setupProxiedMenu() {
	        var menuEl = angular.element(proxyElement);
	
	        var isEndAligned = menuEl.parent().hasClass('md-secondary-container') ||
	                           proxyElement.parentNode.firstElementChild !== proxyElement;
	
	        var xAxisPosition = 'left';
	
	        if (isEndAligned) {
	          // When the proxy item is aligned at the end of the list, we have to set the origin to the end.
	          xAxisPosition = 'right';
	        }
	
	        // Set the position mode / origin of the proxied menu.
	        if (!menuEl.attr('md-position-mode')) {
	          menuEl.attr('md-position-mode', xAxisPosition + ' target');
	        }
	
	        // Apply menu open binding to menu button
	        var menuOpenButton = menuEl.children().eq(0);
	        if (!hasClickEvent(menuOpenButton[0])) {
	          menuOpenButton.attr('ng-click', '$mdMenu.open($event)');
	        }
	
	        if (!menuOpenButton.attr('aria-label')) {
	          menuOpenButton.attr('aria-label', 'Open List Menu');
	        }
	      }
	
	      /**
	       * @param {'div'|'button'} type
	       */
	      function wrapIn(type) {
	        if (type === 'div') {
	          itemContainer = angular.element('<div class="md-no-style md-list-item-inner">');
	          itemContainer.append(tElement.contents());
	          tElement.addClass('md-proxy-focus');
	        } else {
	          // Element which holds the default list-item content.
	          itemContainer = angular.element(
	            '<div class="md-button md-no-style">' +
	            '   <div class="md-list-item-inner"></div>' +
	            '</div>'
	          );
	
	          // Button which shows ripple and executes primary action.
	          var buttonWrap = angular.element(
	            '<md-button class="md-no-style"></md-button>'
	          );
	
	          moveAttributes(tElement[0], buttonWrap[0]);
	
	          // If there is no aria-label set on the button (previously copied over if present)
	          // we determine the label from the content and copy it to the button.
	          if (!buttonWrap.attr('aria-label')) {
	            buttonWrap.attr('aria-label', $mdAria.getText(tElement));
	          }
	
	          // We allow developers to specify the `md-no-focus` class, to disable the focus style
	          // on the button executor. Once more classes should be forwarded, we should probably make
	          // the class forward more generic.
	          if (tElement.hasClass('md-no-focus')) {
	            buttonWrap.addClass('md-no-focus');
	          }
	
	          // Append the button wrap before our list-item content, because it will overlay in
	          // relative.
	          itemContainer.prepend(buttonWrap);
	          itemContainer.children().eq(1).append(tElement.contents());
	
	          tElement.addClass('_md-button-wrap');
	        }
	
	        tElement[0].setAttribute('tabindex', '-1');
	        tElement.append(itemContainer);
	      }
	
	      function wrapSecondaryItems() {
	        var secondaryItemsWrapper = angular.element('<div class="md-secondary-container">');
	
	        angular.forEach(secondaryItems, function(secondaryItem) {
	          wrapSecondaryItem(secondaryItem, secondaryItemsWrapper);
	        });
	
	        itemContainer.append(secondaryItemsWrapper);
	      }
	
	      /**
	       * @param {HTMLElement} secondaryItem
	       * @param container
	       */
	      function wrapSecondaryItem(secondaryItem, container) {
	        // If the current secondary item is not a button, but contains a ng-click attribute,
	        // the secondary item will be automatically wrapped inside of a button.
	        if (secondaryItem && !isButton(secondaryItem) && secondaryItem.hasAttribute('ng-click')) {
	
	          $mdAria.expect(secondaryItem, 'aria-label');
	          var buttonWrapper = angular.element('<md-button class="md-secondary md-icon-button">');
	
	          // Move the attributes from the secondary item to the generated button.
	          // We also support some additional attributes from the secondary item,
	          // because some developers may use a ngIf, ngHide, ngShow on their item.
	          moveAttributes(secondaryItem, buttonWrapper[0], ['ng-if', 'ng-hide', 'ng-show']);
	
	          secondaryItem.setAttribute('tabindex', '-1');
	          buttonWrapper.append(secondaryItem);
	
	          secondaryItem = buttonWrapper[0];
	        }
	
	        if (secondaryItem &&
	            (!hasClickEvent(secondaryItem) ||
	              (!tAttrs.ngClick && isProxiedElement(secondaryItem)))) {
	          // In this case we remove the secondary class, so we can identify it later, when searching
	          // for the proxy items.
	          angular.element(secondaryItem).removeClass('md-secondary');
	        }
	
	        tElement.addClass('md-with-secondary');
	        container.append(secondaryItem);
	      }
	
	      /**
	       * Moves attributes from a source element to the destination element.
	       * By default, the function will copy the most necessary attributes, supported
	       * by the button executor for clickable list items.
	       * @param source Element with the specified attributes
	       * @param destination Element which will receive the attributes
	       * @param extraAttrs Additional attributes, which will be moved over
	       */
	      function moveAttributes(source, destination, extraAttrs) {
	        var copiedAttrs = $mdUtil.prefixer([
	          'ng-if', 'ng-click', 'ng-dblclick', 'aria-label', 'ng-disabled', 'ui-sref',
	          'href', 'ng-href', 'rel', 'target', 'ng-attr-ui-sref', 'ui-sref-opts', 'download'
	        ]);
	
	        if (extraAttrs) {
	          copiedAttrs = copiedAttrs.concat($mdUtil.prefixer(extraAttrs));
	        }
	
	        angular.forEach(copiedAttrs, function(attr) {
	          if (source.hasAttribute(attr)) {
	            destination.setAttribute(attr, source.getAttribute(attr));
	            source.removeAttribute(attr);
	          }
	        });
	      }
	
	      /**
	       * @param {HTMLElement} element
	       * @return {boolean} true if the element has one of the proxied tags, false otherwise
	       */
	      function isProxiedElement(element) {
	        return proxiedTypes.indexOf(element.nodeName.toLowerCase()) !== -1;
	      }
	
	      /**
	       * @param {HTMLElement} element
	       * @return {boolean} true if the element is a button or md-button, false otherwise
	       */
	      function isButton(element) {
	        var nodeName = element.nodeName.toUpperCase();
	
	        return nodeName === "MD-BUTTON" || nodeName === "BUTTON";
	      }
	
	      /**
	       * @param {Element} element
	       * @return {boolean} true if the element has an ng-click attribute, false otherwise
	       */
	      function hasClickEvent(element) {
	        var attr = element.attributes;
	        for (var i = 0; i < attr.length; i++) {
	          if (tAttrs.$normalize(attr[i].name) === 'ngClick') {
	            return true;
	          }
	        }
	        return false;
	      }
	
	      return postLink;
	
	      function postLink($scope, $element, $attr, ctrl) {
	        $element.addClass('_md');     // private md component indicator for styling
	
	        var proxies       = [],
	            firstElement  = $element[0].firstElementChild,
	            isButtonWrap  = $element.hasClass('_md-button-wrap'),
	            clickChild    = isButtonWrap ? firstElement.firstElementChild : firstElement,
	            hasClick      = clickChild && hasClickEvent(clickChild),
	            noProxies     = $element.hasClass('md-no-proxy');
	
	        computeProxies();
	        computeClickable();
	
	        if (proxies.length) {
	          angular.forEach(proxies, function(proxy) {
	            proxy = angular.element(proxy);
	
	            $scope.mouseActive = false;
	            proxy.on('mousedown', function() {
	              $scope.mouseActive = true;
	              $timeout(function() {
	                $scope.mouseActive = false;
	              }, 100);
	            })
	            .on('focus', function() {
	              if ($scope.mouseActive === false) { $element.addClass('md-focused'); }
	              proxy.on('blur', function proxyOnBlur() {
	                $element.removeClass('md-focused');
	                proxy.off('blur', proxyOnBlur);
	              });
	            });
	          });
	        }
	
	        function computeProxies() {
	          if (firstElement && firstElement.children && !hasClick && !noProxies) {
	
	            angular.forEach(proxiedTypes, function(type) {
	              // All elements which are not capable of being used as a proxy have the .md-secondary
	              // class applied. These items were identified in the secondary wrap function.
	              angular.forEach(firstElement.querySelectorAll(type + ':not(.md-secondary)'), function(child) {
	                proxies.push(child);
	              });
	            });
	          }
	        }
	
	        function computeClickable() {
	          if (proxies.length === 1 || hasClick) {
	            $element.addClass('md-clickable');
	
	            if (!hasClick) {
	              ctrl.attachRipple($scope, angular.element($element[0].querySelector('.md-no-style')));
	            }
	          }
	        }
	
	        /**
	         * @param {MouseEvent} event
	         * @return {boolean}
	         */
	        function isEventFromControl(event) {
	          var forbiddenControls = ['md-slider'];
	          var eventBubblePath = $mdUtil.getEventPath(event);
	
	          // If there is no bubble path, then the event was not bubbled.
	          if (!eventBubblePath || eventBubblePath.length === 0) {
	            return forbiddenControls.indexOf(event.target.tagName.toLowerCase()) !== -1;
	          }
	
	          // We iterate the event bubble path up and check for a possible component.
	          // Our maximum index to search, is the list item root.
	          var maxPath = eventBubblePath.indexOf($element.children()[0]);
	
	          for (var i = 0; i < maxPath; i++) {
	            if (forbiddenControls.indexOf(eventBubblePath[i].tagName.toLowerCase()) !== -1) {
	              return true;
	            }
	          }
	          return false;
	        }
	
	        /**
	         * @param {KeyboardEvent} keypressEvent
	         */
	        var clickChildKeypressListener = function(keypressEvent) {
	          if (keypressEvent.target.nodeName !== 'INPUT' &&
	              keypressEvent.target.nodeName !== 'TEXTAREA' &&
	              !keypressEvent.target.isContentEditable) {
	            var keyCode = keypressEvent.which || keypressEvent.keyCode;
	            if (keyCode === $mdConstant.KEY_CODE.SPACE) {
	              if (clickChild) {
	                clickChild.click();
	                keypressEvent.preventDefault();
	                keypressEvent.stopPropagation();
	              }
	            }
	          }
	        };
	
	        if (!hasClick && !proxies.length) {
	          clickChild && clickChild.addEventListener('keypress', clickChildKeypressListener);
	        }
	
	        $element.off('click');
	        $element.off('keypress');
	        // Disable ng-aria's "helpful" keydown event that causes our ng-click handlers to be called
	        // twice.
	        $element.off('keydown');
	
	        if (proxies.length === 1 && clickChild) {
	          $element.children().eq(0).on('click', function(clickEvent) {
	            // When the event is coming from a control and it should not trigger the proxied element
	            // then we are skipping.
	            if (isEventFromControl(clickEvent)) return;
	
	            var parentButton = $mdUtil.getClosest(clickEvent.target, 'BUTTON');
	            if (!parentButton && clickChild.contains(clickEvent.target)) {
	              angular.forEach(proxies, function(proxy) {
	                if (clickEvent.target !== proxy && !proxy.contains(clickEvent.target)) {
	                  if (proxy.nodeName === 'MD-MENU') {
	                    proxy = proxy.children[0];
	                  }
	                  angular.element(proxy).triggerHandler('click');
	                }
	              });
	            }
	          });
	        }
	
	        $scope.$on('$destroy', function () {
	          clickChild && clickChild.removeEventListener('keypress', clickChildKeypressListener);
	        });
	      }
	    }
	  };
	}
	
	/*
	 * @private
	 * @ngdoc controller
	 * @name MdListController
	 * @module material.components.list
	 */
	function MdListController($scope, $element, $mdListInkRipple) {
	  var ctrl = this;
	  ctrl.attachRipple = attachRipple;
	
	  function attachRipple (scope, element) {
	    var options = {};
	    $mdListInkRipple.attach(scope, element, options);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.menu
	 */
	
	angular.module('material.components.menu', [
	  'material.core',
	  'material.components.backdrop'
	]);
	
	})();
	(function(){
	"use strict";
	
	
	
	MenuController.$inject = ["$mdMenu", "$attrs", "$element", "$scope", "$mdUtil", "$timeout", "$rootScope", "$q", "$log"];
	angular
	    .module('material.components.menu')
	    .controller('mdMenuCtrl', MenuController);
	
	/**
	 * @ngInject
	 */
	function MenuController($mdMenu, $attrs, $element, $scope, $mdUtil, $timeout, $rootScope, $q, $log) {
	
	  var prefixer = $mdUtil.prefixer();
	  var menuContainer;
	  var self = this;
	  var triggerElement;
	
	  this.nestLevel = parseInt($attrs.mdNestLevel, 10) || 0;
	
	  /**
	   * Called by our linking fn to provide access to the menu-content
	   * element removed during link
	   */
	  this.init = function init(setMenuContainer, opts) {
	    opts = opts || {};
	    menuContainer = setMenuContainer;
	
	    // Default element for ARIA attributes has the ngClick or ngMouseenter expression
	    triggerElement = $element[0].querySelector(prefixer.buildSelector(['ng-click', 'ng-mouseenter']));
	    triggerElement.setAttribute('aria-expanded', 'false');
	
	    this.isInMenuBar = opts.isInMenuBar;
	    this.mdMenuBarCtrl = opts.mdMenuBarCtrl;
	    this.nestedMenus = $mdUtil.nodesToArray(menuContainer[0].querySelectorAll('.md-nested-menu'));
	
	    menuContainer.on('$mdInterimElementRemove', function() {
	      self.isOpen = false;
	      $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	    });
	    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	
	    var menuContainerId = 'menu_container_' + $mdUtil.nextUid();
	    menuContainer.attr('id', menuContainerId);
	    angular.element(triggerElement).attr({
	      'aria-owns': menuContainerId,
	      'aria-haspopup': 'true'
	    });
	
	    $scope.$on('$destroy', angular.bind(this, function() {
	      this.disableHoverListener();
	      $mdMenu.destroy();
	    }));
	
	    menuContainer.on('$destroy', function() {
	      $mdMenu.destroy();
	    });
	  };
	
	  var openMenuTimeout, menuItems, deregisterScopeListeners = [];
	  this.enableHoverListener = function() {
	    deregisterScopeListeners.push($rootScope.$on('$mdMenuOpen', function(event, el) {
	      if (menuContainer[0].contains(el[0])) {
	        self.currentlyOpenMenu = el.controller('mdMenu');
	        self.isAlreadyOpening = false;
	        self.currentlyOpenMenu.registerContainerProxy(self.triggerContainerProxy.bind(self));
	      }
	    }));
	    deregisterScopeListeners.push($rootScope.$on('$mdMenuClose', function(event, el) {
	      if (menuContainer[0].contains(el[0])) {
	        self.currentlyOpenMenu = undefined;
	      }
	    }));
	    menuItems = angular.element($mdUtil.nodesToArray(menuContainer[0].children[0].children));
	    menuItems.on('mouseenter', self.handleMenuItemHover);
	    menuItems.on('mouseleave', self.handleMenuItemMouseLeave);
	  };
	
	  this.disableHoverListener = function() {
	    while (deregisterScopeListeners.length) {
	      deregisterScopeListeners.shift()();
	    }
	    menuItems && menuItems.off('mouseenter', self.handleMenuItemHover);
	    menuItems && menuItems.off('mouseleave', self.handleMenuItemMouseLeave);
	  };
	
	  this.handleMenuItemHover = function(event) {
	    if (self.isAlreadyOpening) return;
	    var nestedMenu = (
	      event.target.querySelector('md-menu')
	        || $mdUtil.getClosest(event.target, 'MD-MENU')
	    );
	    openMenuTimeout = $timeout(function() {
	      if (nestedMenu) {
	        nestedMenu = angular.element(nestedMenu).controller('mdMenu');
	      }
	
	      if (self.currentlyOpenMenu && self.currentlyOpenMenu != nestedMenu) {
	        var closeTo = self.nestLevel + 1;
	        self.currentlyOpenMenu.close(true, { closeTo: closeTo });
	        self.isAlreadyOpening = !!nestedMenu;
	        nestedMenu && nestedMenu.open();
	      } else if (nestedMenu && !nestedMenu.isOpen && nestedMenu.open) {
	        self.isAlreadyOpening = !!nestedMenu;
	        nestedMenu && nestedMenu.open();
	      }
	    }, nestedMenu ? 100 : 250);
	    var focusableTarget = event.currentTarget.querySelector('.md-button:not([disabled])');
	    focusableTarget && focusableTarget.focus();
	  };
	
	  this.handleMenuItemMouseLeave = function() {
	    if (openMenuTimeout) {
	      $timeout.cancel(openMenuTimeout);
	      openMenuTimeout = undefined;
	    }
	  };
	
	
	  /**
	   * Uses the $mdMenu interim element service to open the menu contents
	   */
	  this.open = function openMenu(ev) {
	    ev && ev.stopPropagation();
	    ev && ev.preventDefault();
	    if (self.isOpen) return;
	    self.enableHoverListener();
	    self.isOpen = true;
	    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	    triggerElement = triggerElement || (ev ? ev.target : $element[0]);
	    triggerElement.setAttribute('aria-expanded', 'true');
	    $scope.$emit('$mdMenuOpen', $element);
	    $mdMenu.show({
	      scope: $scope,
	      mdMenuCtrl: self,
	      nestLevel: self.nestLevel,
	      element: menuContainer,
	      target: triggerElement,
	      preserveElement: true,
	      parent: 'body'
	    }).finally(function() {
	      triggerElement.setAttribute('aria-expanded', 'false');
	      self.disableHoverListener();
	    });
	  };
	
	  this.onIsOpenChanged = function(isOpen) {
	    if (isOpen) {
	      menuContainer.attr('aria-hidden', 'false');
	      $element[0].classList.add('md-open');
	      angular.forEach(self.nestedMenus, function(el) {
	        el.classList.remove('md-open');
	      });
	    } else {
	      menuContainer.attr('aria-hidden', 'true');
	      $element[0].classList.remove('md-open');
	    }
	    $scope.$mdMenuIsOpen = self.isOpen;
	  };
	
	  this.focusMenuContainer = function focusMenuContainer() {
	    var focusTarget = menuContainer[0]
	      .querySelector(prefixer.buildSelector(['md-menu-focus-target', 'md-autofocus']));
	
	    if (!focusTarget) focusTarget = menuContainer[0].querySelector('.md-button:not([disabled])');
	    focusTarget.focus();
	  };
	
	  this.registerContainerProxy = function registerContainerProxy(handler) {
	    this.containerProxy = handler;
	  };
	
	  this.triggerContainerProxy = function triggerContainerProxy(ev) {
	    this.containerProxy && this.containerProxy(ev);
	  };
	
	  this.destroy = function() {
	    return self.isOpen ? $mdMenu.destroy() : $q.when(false);
	  };
	
	  // Use the $mdMenu interim element service to close the menu contents
	  this.close = function closeMenu(skipFocus, closeOpts) {
	    if (!self.isOpen) return;
	    self.isOpen = false;
	    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	
	    var eventDetails = angular.extend({}, closeOpts, { skipFocus: skipFocus });
	    $scope.$emit('$mdMenuClose', $element, eventDetails);
	    $mdMenu.hide(null, closeOpts);
	
	    if (!skipFocus) {
	      var el = self.restoreFocusTo || $element.find('button')[0];
	      if (el instanceof angular.element) el = el[0];
	      if (el) el.focus();
	    }
	  };
	
	  /**
	   * Build a nice object out of our string attribute which specifies the
	   * target mode for left and top positioning
	   */
	  this.positionMode = function positionMode() {
	    var attachment = ($attrs.mdPositionMode || 'target').split(' ');
	
	    // If attachment is a single item, duplicate it for our second value.
	    // ie. 'target' -> 'target target'
	    if (attachment.length === 1) {
	      attachment.push(attachment[0]);
	    }
	
	    return {
	      left: attachment[0],
	      top: attachment[1]
	    };
	  };
	
	  /**
	   * Build a nice object out of our string attribute which specifies
	   * the offset of top and left in pixels.
	   */
	  this.offsets = function offsets() {
	    var position = ($attrs.mdOffset || '0 0').split(' ').map(parseFloat);
	    if (position.length === 2) {
	      return {
	        left: position[0],
	        top: position[1]
	      };
	    } else if (position.length === 1) {
	      return {
	        top: position[0],
	        left: position[0]
	      };
	    } else {
	      throw Error('Invalid offsets specified. Please follow format <x, y> or <n>');
	    }
	  };
	
	  // Functionality that is exposed in the view.
	  $scope.$mdMenu = {
	    open: this.open,
	    close: this.close
	  };
	
	  // Deprecated APIs
	  $scope.$mdOpenMenu = angular.bind(this, function() {
	    $log.warn('mdMenu: The $mdOpenMenu method is deprecated. Please use `$mdMenu.open`.');
	    return this.open.apply(this, arguments);
	  });
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdMenu
	 * @module material.components.menu
	 * @restrict E
	 * @description
	 *
	 * Menus are elements that open when clicked. They are useful for displaying
	 * additional options within the context of an action.
	 *
	 * Every `md-menu` must specify exactly two child elements. The first element is what is
	 * left in the DOM and is used to open the menu. This element is called the trigger element.
	 * The trigger element's scope has access to `$mdMenu.open($event)`
	 * which it may call to open the menu. By passing $event as argument, the
	 * corresponding event is stopped from propagating up the DOM-tree. Similarly, `$mdMenu.close()`
	 * can be used to close the menu.
	 *
	 * The second element is the `md-menu-content` element which represents the
	 * contents of the menu when it is open. Typically this will contain `md-menu-item`s,
	 * but you can do custom content as well.
	 *
	 * <hljs lang="html">
	 * <md-menu>
	 *  <!-- Trigger element is a md-button with an icon -->
	 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open sample menu">
	 *    <md-icon md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	
	 * ## Sizing Menus
	 *
	 * The width of the menu when it is open may be specified by specifying a `width`
	 * attribute on the `md-menu-content` element.
	 * See the [Material Design Spec](https://material.io/archive/guidelines/components/menus.html#menus-simple-menus)
	 * for more information.
	 *
	 * ## Menu Density
	 *
	 * You can use dense menus by adding the `md-dense` class to the `md-menu-content` element.
	 * This reduces the height of menu items, their top and bottom padding, and default font size.
	 * Without the `md-dense` class, we use the "mobile" height of `48px`. With the `md-dense` class,
	 * we use the "desktop" height of `32px`. We do not support the "dense desktop" option in the spec,
	 * which uses a height of `24px`, at this time.
	 * See the [Menu Specs](https://material.io/archive/guidelines/components/menus.html#menus-specs)
	 * section of the Material Design Spec for more information.
	 *
	 * ## Aligning Menus
	 *
	 * When a menu opens, it is important that the content aligns with the trigger element.
	 * Failure to align menus can result in jarring experiences for users as content
	 * suddenly shifts. To help with this, `md-menu` provides several APIs to help
	 * with alignment.
	 *
	 * ### Target Mode
	 *
	 * By default, `md-menu` will attempt to align the `md-menu-content` by aligning
	 * designated child elements in both the trigger and the menu content.
	 *
	 * To specify the alignment element in the `trigger` you can use the `md-menu-origin`
	 * attribute on a child element. If no `md-menu-origin` is specified, the `md-menu`
	 * will be used as the origin element.
	 *
	 * Similarly, the `md-menu-content` may specify a `md-menu-align-target` for a
	 * `md-menu-item` to specify the node that it should try and align with.
	 *
	 * In this example code, we specify an icon to be our origin element, and an
	 * icon in our menu content to be our alignment target. This ensures that both
	 * icons are aligned when the menu opens.
	 *
	 * <hljs lang="html">
	 * <md-menu>
	 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open some menu">
	 *    <md-icon md-menu-origin md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item>
	 *      <md-button ng-click="doSomething()" aria-label="Do something">
	 *        <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
	 *        Do Something
	 *      </md-button>
	 *    </md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	 *
	 * ### Position Mode
	 *
	 * We can specify the origin of the menu by using the `md-position-mode` attribute.
	 * This attribute allows specifying the positioning by the `x` and `y` axes.
	 *
	 * The default mode is `target target`. This mode uses the left and top edges of the origin element
	 * to position the menu in LTR layouts. The `x` axis modes will adjust when in RTL layouts.
	 *
	 * Sometimes you want to specify alignment from the right side of a origin element. For example,
	 * if we have a menu on the right side a toolbar, we may want to right align our menu content.
	 * We can use `target-right target` to specify a right-oriented alignment target.
	 * There is a working example of this in the Menu Position Modes demo.
	 *
	 * #### Horizontal Positioning Options
	 * - `target`
	 * - `target-left`
	 * - `target-right`
	 * - `cascade`
	 * - `right`
	 * - `left`
	 *
	 * #### Vertical Positioning Options
	 * - `target`
	 * - `cascade`
	 * - `bottom`
	 *
	 * ### Menu Offsets
	 *
	 * It is sometimes unavoidable to need to have a deeper level of control for
	 * the positioning of a menu to ensure perfect alignment. `md-menu` provides
	 * the `md-offset` attribute to allow pixel-level specificity when adjusting
	 * menu positioning.
	 *
	 * This offset is provided in the format of `x y` or `n` where `n` will be used
	 * in both the `x` and `y` axis.
	 * For example, to move a menu by `2px` down from the top, we can use:
	 *
	 * <hljs lang="html">
	 * <md-menu md-offset="0 2">
	 *   <!-- menu-content -->
	 * </md-menu>
	 * </hljs>
	 *
	 * Specifying `md-offset="2 2"` would shift the menu two pixels down and two pixels to the right.
	 *
	 * ### Auto Focus
	 * By default, when a menu opens, `md-menu` focuses the first button in the menu content.
	 *
	 * Sometimes you would like to focus another menu item instead of the first.<br/>
	 * This can be done by applying the `md-autofocus` directive on the given element.
	 *
	 * <hljs lang="html">
	 * <md-menu-item>
	 *   <md-button md-autofocus ng-click="doSomething()">
	 *     Auto Focus
	 *   </md-button>
	 * </md-menu-item>
	 * </hljs>
	 *
	 *
	 * ### Preventing close
	 *
	 * Sometimes you would like to be able to click on a menu item without having the menu
	 * close. To do this, AngularJS Material exposes the `md-prevent-menu-close` attribute which
	 * can be added to a button inside a menu to stop the menu from automatically closing.
	 * You can then close the menu either by using `$mdMenu.close()` in the template,
	 * or programmatically by injecting `$mdMenu` and calling `$mdMenu.hide()`.
	 *
	 * <hljs lang="html">
	 * <md-menu-content ng-mouseleave="$mdMenu.close()">
	 *   <md-menu-item>
	 *     <md-button ng-click="doSomething()" aria-label="Do something" md-prevent-menu-close="md-prevent-menu-close">
	 *       <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
	 *       Do Something
	 *     </md-button>
	 *   </md-menu-item>
	 * </md-menu-content>
	 * </hljs>
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-menu>
	 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button">
	 *    <md-icon md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	 *
	 * @param {string=} md-position-mode Specify pre-defined position modes for the `x` and `y` axes.
	 *  The default modes are `target target`. This positions the origin of the menu using the left and top edges
	 *  of the origin element in LTR layouts.<br>
	 *  #### Valid modes for horizontal positioning
	 * - `target`
	 * - `target-left`
	 * - `target-right`
	 * - `cascade`
	 * - `right`
	 * - `left`<br>
	 *  #### Valid modes for vertical positioning
	 * - `target`
	 * - `cascade`
	 * - `bottom`
	 * @param {string=} md-offset An offset to apply to the dropdown on opening, after positioning.
	 *  Defined as `x` and `y` pixel offset values in the form of `x y`.<br>
	 *  The default value is `0 0`.
	 */
	MenuDirective.$inject = ["$mdUtil"];
	angular
	    .module('material.components.menu')
	    .directive('mdMenu', MenuDirective);
	
	/**
	 * @ngInject
	 */
	function MenuDirective($mdUtil) {
	  var INVALID_PREFIX = 'Invalid HTML for md-menu: ';
	  return {
	    restrict: 'E',
	    require: ['mdMenu', '?^mdMenuBar'],
	    controller: 'mdMenuCtrl', // empty function to be built by link
	    scope: true,
	    compile: compile
	  };
	
	  function compile(templateElement) {
	    templateElement.addClass('md-menu');
	
	    var triggerEl = templateElement.children()[0];
	    var prefixer = $mdUtil.prefixer();
	
	    if (!prefixer.hasAttribute(triggerEl, 'ng-click')) {
	      triggerEl = triggerEl
	          .querySelector(prefixer.buildSelector(['ng-click', 'ng-mouseenter'])) || triggerEl;
	    }
	
	    var isButtonTrigger = triggerEl.nodeName === 'MD-BUTTON' || triggerEl.nodeName === 'BUTTON';
	
	    if (triggerEl && isButtonTrigger && !triggerEl.hasAttribute('type')) {
	      triggerEl.setAttribute('type', 'button');
	    }
	
	    if (!triggerEl) {
	      throw Error(INVALID_PREFIX + 'Expected the menu to have a trigger element.');
	    }
	
	    if (templateElement.children().length !== 2) {
	      throw Error(INVALID_PREFIX + 'Expected two children elements. The second element must have a `md-menu-content` element.');
	    }
	
	    // Default element for ARIA attributes has the ngClick or ngMouseenter expression
	    triggerEl && triggerEl.setAttribute('aria-haspopup', 'true');
	
	    var nestedMenus = templateElement[0].querySelectorAll('md-menu');
	    var nestingDepth = parseInt(templateElement[0].getAttribute('md-nest-level'), 10) || 0;
	    if (nestedMenus) {
	      angular.forEach($mdUtil.nodesToArray(nestedMenus), function(menuEl) {
	        if (!menuEl.hasAttribute('md-position-mode')) {
	          menuEl.setAttribute('md-position-mode', 'cascade');
	        }
	        menuEl.classList.add('_md-nested-menu');
	        menuEl.setAttribute('md-nest-level', nestingDepth + 1);
	      });
	    }
	    return link;
	  }
	
	  function link(scope, element, attr, ctrls) {
	    var mdMenuCtrl = ctrls[0];
	    var isInMenuBar = !!ctrls[1];
	    var mdMenuBarCtrl = ctrls[1];
	    // Move everything into a md-menu-container and pass it to the controller
	    var menuContainer = angular.element('<div class="_md md-open-menu-container md-whiteframe-z2"></div>');
	    var menuContents = element.children()[1];
	
	    element.addClass('_md');     // private md component indicator for styling
	
	    if (!menuContents.hasAttribute('role')) {
	      menuContents.setAttribute('role', 'menu');
	    }
	    menuContainer.append(menuContents);
	
	    element.on('$destroy', function() {
	      menuContainer.remove();
	    });
	
	    element.append(menuContainer);
	    menuContainer[0].style.display = 'none';
	    mdMenuCtrl.init(menuContainer, { isInMenuBar: isInMenuBar, mdMenuBarCtrl: mdMenuBarCtrl });
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MenuProvider.$inject = ["$$interimElementProvider"];angular
	  .module('material.components.menu')
	  .provider('$mdMenu', MenuProvider);
	
	/**
	 * Interim element provider for the menu.
	 * Handles behavior for a menu while it is open, including:
	 *    - handling animating the menu opening/closing
	 *    - handling key/mouse events on the menu element
	 *    - handling enabling/disabling scroll while the menu is open
	 *    - handling redrawing during resizes and orientation changes
	 *
	 */
	
	function MenuProvider($$interimElementProvider) {
	  menuDefaultOptions.$inject = ["$mdUtil", "$mdTheming", "$mdConstant", "$document", "$window", "$q", "$$rAF", "$animateCss", "$animate", "$log"];
	  var MENU_EDGE_MARGIN = 8;
	
	  return $$interimElementProvider('$mdMenu')
	    .setDefaults({
	      methods: ['target'],
	      options: menuDefaultOptions
	    });
	
	  /* @ngInject */
	  function menuDefaultOptions($mdUtil, $mdTheming, $mdConstant, $document, $window, $q, $$rAF,
	                              $animateCss, $animate, $log) {
	
	    var prefixer = $mdUtil.prefixer();
	    var animator = $mdUtil.dom.animator;
	
	    return {
	      parent: 'body',
	      onShow: onShow,
	      onRemove: onRemove,
	      hasBackdrop: true,
	      disableParentScroll: true,
	      skipCompile: true,
	      preserveScope: true,
	      multiple: true,
	      themable: true
	    };
	
	    /**
	     * Show modal backdrop element...
	     * @returns {function(): void} A function that removes this backdrop
	     */
	    function showBackdrop(scope, element, options) {
	      if (options.nestLevel) return angular.noop;
	
	      // If we are not within a dialog...
	      if (options.disableParentScroll && !$mdUtil.getClosest(options.target, 'MD-DIALOG')) {
	        // !! DO this before creating the backdrop; since disableScrollAround()
	        //    configures the scroll offset; which is used by mdBackDrop postLink()
	        options.restoreScroll = $mdUtil.disableScrollAround(options.element, options.parent);
	      } else {
	        options.disableParentScroll = false;
	      }
	
	      if (options.hasBackdrop) {
	        options.backdrop = $mdUtil.createBackdrop(scope, "md-menu-backdrop md-click-catcher");
	
	        $animate.enter(options.backdrop, $document[0].body);
	      }
	
	      /**
	       * Hide and destroys the backdrop created by showBackdrop()
	       */
	      return function hideBackdrop() {
	        if (options.backdrop) options.backdrop.remove();
	        if (options.disableParentScroll) options.restoreScroll();
	      };
	    }
	
	    /**
	     * Removing the menu element from the DOM and remove all associated event listeners
	     * and backdrop
	     */
	    function onRemove(scope, element, opts) {
	      opts.cleanupInteraction();
	      opts.cleanupBackdrop();
	      opts.cleanupResizing();
	      opts.hideBackdrop();
	
	      // Before the menu is closing remove the clickable class.
	      element.removeClass('md-clickable');
	
	      // For navigation $destroy events, do a quick, non-animated removal,
	      // but for normal closes (from clicks, etc) animate the removal
	
	      return (opts.$destroy === true) ? detachAndClean() : animateRemoval().then(detachAndClean);
	
	      /**
	       * For normal closes, animate the removal.
	       * For forced closes (like $destroy events), skip the animations
	       */
	      function animateRemoval() {
	        return $animateCss(element, {addClass: 'md-leave'}).start();
	      }
	
	      /**
	       * Detach the element
	       */
	      function detachAndClean() {
	        element.removeClass('md-active');
	        detachElement(element, opts);
	        opts.alreadyOpen = false;
	      }
	
	    }
	
	    /**
	     * Inserts and configures the staged Menu element into the DOM, positioning it,
	     * and wiring up various interaction events
	     */
	    function onShow(scope, element, opts) {
	      sanitizeAndConfigure(opts);
	
	      if (opts.menuContentEl[0]) {
	        // Inherit the theme from the target element.
	        $mdTheming.inherit(opts.menuContentEl, opts.target);
	      } else {
	        $log.warn(
	          '$mdMenu: Menu elements should always contain a `md-menu-content` element,' +
	          'otherwise interactivity features will not work properly.',
	          element
	        );
	      }
	
	      // Register various listeners to move menu on resize/orientation change
	      opts.cleanupResizing = startRepositioningOnResize();
	      opts.hideBackdrop = showBackdrop(scope, element, opts);
	
	      // Return the promise for when our menu is done animating in
	      return showMenu()
	        .then(function(response) {
	          opts.alreadyOpen = true;
	          opts.cleanupInteraction = activateInteraction();
	          opts.cleanupBackdrop = setupBackdrop();
	
	          // Since the menu finished its animation, mark the menu as clickable.
	          element.addClass('md-clickable');
	
	          return response;
	        });
	
	      /**
	       * Place the menu into the DOM and call positioning related functions
	       */
	      function showMenu() {
	        opts.parent.append(element);
	        element[0].style.display = '';
	
	        return $q(function(resolve) {
	          var position = calculateMenuPosition(element, opts);
	
	          element.removeClass('md-leave');
	
	          // Animate the menu scaling, and opacity [from its position origin (default == top-left)]
	          // to normal scale.
	          $animateCss(element, {
	            addClass: 'md-active',
	            from: animator.toCss(position),
	            to: animator.toCss({transform: ''})
	          })
	          .start()
	          .then(resolve);
	
	        });
	      }
	
	      /**
	       * Check for valid opts and set some sane defaults
	       */
	      function sanitizeAndConfigure() {
	        if (!opts.target) {
	          throw Error(
	            '$mdMenu.show() expected a target to animate from in options.target'
	          );
	        }
	        angular.extend(opts, {
	          alreadyOpen: false,
	          isRemoved: false,
	          target: angular.element(opts.target), // make sure it's not a naked DOM node
	          parent: angular.element(opts.parent),
	          menuContentEl: angular.element(element[0].querySelector('md-menu-content'))
	        });
	      }
	
	      /**
	       * Configure various resize listeners for screen changes
	       */
	      function startRepositioningOnResize() {
	
	        var repositionMenu = (function(target, options) {
	          return $$rAF.throttle(function() {
	            if (opts.isRemoved) return;
	            var position = calculateMenuPosition(target, options);
	
	            target.css(animator.toCss(position));
	          });
	        })(element, opts);
	
	        $window.addEventListener('resize', repositionMenu);
	        $window.addEventListener('orientationchange', repositionMenu);
	
	        return function stopRepositioningOnResize() {
	
	          // Disable resizing handlers
	          $window.removeEventListener('resize', repositionMenu);
	          $window.removeEventListener('orientationchange', repositionMenu);
	
	        };
	      }
	
	      /**
	       * Sets up the backdrop and listens for click elements.
	       * Once the backdrop will be clicked, the menu will automatically close.
	       * @returns {!Function} Function to remove the backdrop.
	       */
	      function setupBackdrop() {
	        if (!opts.backdrop) return angular.noop;
	
	        opts.backdrop.on('click', onBackdropClick);
	
	        return function() {
	          opts.backdrop.off('click', onBackdropClick);
	        };
	      }
	
	      /**
	       * Function to be called whenever the backdrop is clicked.
	       * @param {!MouseEvent} event
	       */
	      function onBackdropClick(event) {
	        event.preventDefault();
	        event.stopPropagation();
	
	        scope.$apply(function() {
	          opts.mdMenuCtrl.close(true, { closeAll: true });
	        });
	      }
	
	      /**
	       * Activate interaction on the menu. Resolves the focus target and closes the menu on
	       * escape or option click.
	       * @returns {!Function} Function to deactivate the interaction listeners.
	       */
	      function activateInteraction() {
	        if (!opts.menuContentEl[0]) return angular.noop;
	
	        // Wire up keyboard listeners.
	        // - Close on escape,
	        // - focus next item on down arrow,
	        // - focus prev item on up
	        opts.menuContentEl.on('keydown', onMenuKeyDown);
	        opts.menuContentEl[0].addEventListener('click', captureClickListener, true);
	
	        // kick off initial focus in the menu on the first enabled element
	        var focusTarget = opts.menuContentEl[0]
	          .querySelector(prefixer.buildSelector(['md-menu-focus-target', 'md-autofocus']));
	
	        if (!focusTarget) {
	          var childrenLen = opts.menuContentEl[0].children.length;
	          for (var childIndex = 0; childIndex < childrenLen; childIndex++) {
	            var child = opts.menuContentEl[0].children[childIndex];
	            focusTarget = child.querySelector('.md-button:not([disabled])');
	            if (focusTarget) {
	              break;
	            }
	            if (child.firstElementChild && !child.firstElementChild.disabled) {
	              focusTarget = child.firstElementChild;
	              break;
	            }
	          }
	        }
	
	        focusTarget && focusTarget.focus();
	
	        return function cleanupInteraction() {
	          opts.menuContentEl.off('keydown', onMenuKeyDown);
	          opts.menuContentEl[0].removeEventListener('click', captureClickListener, true);
	        };
	
	        // ************************************
	        // internal functions
	        // ************************************
	
	        function onMenuKeyDown(ev) {
	          var handled;
	          switch (ev.keyCode) {
	            case $mdConstant.KEY_CODE.ESCAPE:
	              if (opts.nestLevel) {
	                opts.mdMenuCtrl.close();
	              } else {
	                opts.mdMenuCtrl.close(false, { closeAll: true });
	              }
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.TAB:
	              opts.mdMenuCtrl.close(false, { closeAll: true });
	              // Don't prevent default or stop propagation on this event as we want tab
	              // to move the focus to the next focusable element on the page.
	              handled = false;
	              break;
	            case $mdConstant.KEY_CODE.UP_ARROW:
	              if (!focusMenuItem(ev, opts.menuContentEl, opts, -1) && !opts.nestLevel) {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.DOWN_ARROW:
	              if (!focusMenuItem(ev, opts.menuContentEl, opts, 1) && !opts.nestLevel) {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.LEFT_ARROW:
	              if (opts.nestLevel) {
	                opts.mdMenuCtrl.close();
	              } else {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.RIGHT_ARROW:
	              var parentMenu = $mdUtil.getClosest(ev.target, 'MD-MENU');
	              if (parentMenu && parentMenu != opts.parent[0]) {
	                ev.target.click();
	              } else {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	          }
	          if (handled) {
	            ev.preventDefault();
	            ev.stopImmediatePropagation();
	          }
	        }
	
	        function onBackdropClick(e) {
	          e.preventDefault();
	          e.stopPropagation();
	          scope.$apply(function() {
	            opts.mdMenuCtrl.close(true, { closeAll: true });
	          });
	        }
	
	        // Close menu on menu item click, if said menu-item is not disabled
	        function captureClickListener(e) {
	          var target = e.target;
	          // Traverse up the event until we get to the menuContentEl to see if
	          // there is an ng-click and that the ng-click is not disabled
	          do {
	            if (target == opts.menuContentEl[0]) return;
	            if ((hasAnyAttribute(target, ['ng-click', 'ng-href', 'ui-sref']) ||
	                target.nodeName == 'BUTTON' || target.nodeName == 'MD-BUTTON') && !hasAnyAttribute(target, ['md-prevent-menu-close'])) {
	              var closestMenu = $mdUtil.getClosest(target, 'MD-MENU');
	              if (!target.hasAttribute('disabled') && (!closestMenu || closestMenu == opts.parent[0])) {
	                close();
	              }
	              break;
	            }
	          } while (target = target.parentNode);
	
	          function close() {
	            scope.$apply(function() {
	              opts.mdMenuCtrl.close(true, { closeAll: true });
	            });
	          }
	
	          function hasAnyAttribute(target, attrs) {
	            if (!target) return false;
	
	            for (var i = 0, attr; attr = attrs[i]; ++i) {
	              if (prefixer.hasAttribute(target, attr)) {
	                return true;
	              }
	            }
	
	            return false;
	          }
	        }
	
	      }
	    }
	
	    /**
	     * Takes a keypress event and focuses the next/previous menu
	     * item from the emitting element
	     * @param {event} e - The origin keypress event
	     * @param {angular.element} menuEl - The menu element
	     * @param {object} opts - The interim element options for the mdMenu
	     * @param {number} direction - The direction to move in (+1 = next, -1 = prev)
	     */
	    function focusMenuItem(e, menuEl, opts, direction) {
	      var currentItem = $mdUtil.getClosest(e.target, 'MD-MENU-ITEM');
	
	      var items = $mdUtil.nodesToArray(menuEl[0].children);
	      var currentIndex = items.indexOf(currentItem);
	
	      // Traverse through our elements in the specified direction (+/-1) and try to
	      // focus them until we find one that accepts focus
	      var didFocus;
	      for (var i = currentIndex + direction; i >= 0 && i < items.length; i = i + direction) {
	        var focusTarget = items[i].querySelector('.md-button');
	        didFocus = attemptFocus(focusTarget);
	        if (didFocus) {
	          break;
	        }
	      }
	      return didFocus;
	    }
	
	    /**
	     * Attempts to focus an element. Checks whether that element is the currently
	     * focused element after attempting.
	     * @param {HTMLElement} el - the element to attempt focus on
	     * @returns {boolean} - whether the element was successfully focused
	     */
	    function attemptFocus(el) {
	      if (el && el.getAttribute('tabindex') != -1) {
	        el.focus();
	        return ($document[0].activeElement == el);
	      }
	    }
	
	    /**
	     * Use browser to remove this element without triggering a $destroy event
	     */
	    function detachElement(element, opts) {
	      if (!opts.preserveElement) {
	        if (toNode(element).parentNode === toNode(opts.parent)) {
	          toNode(opts.parent).removeChild(toNode(element));
	        }
	      } else {
	        toNode(element).style.display = 'none';
	      }
	    }
	
	    /**
	     * Computes menu position and sets the style on the menu container
	     * @param {HTMLElement} el - the menu container element
	     * @param {object} opts - the interim element options object
	     */
	    function calculateMenuPosition(el, opts) {
	
	      var containerNode = el[0],
	        openMenuNode = el[0].firstElementChild,
	        openMenuNodeRect = openMenuNode.getBoundingClientRect(),
	        boundryNode = $document[0].body,
	        boundryNodeRect = boundryNode.getBoundingClientRect();
	
	      var menuStyle = $window.getComputedStyle(openMenuNode);
	
	      var originNode = opts.target[0].querySelector(prefixer.buildSelector('md-menu-origin')) || opts.target[0],
	        originNodeRect = originNode.getBoundingClientRect();
	
	      var bounds = {
	        left: boundryNodeRect.left + MENU_EDGE_MARGIN,
	        top: Math.max(boundryNodeRect.top, 0) + MENU_EDGE_MARGIN,
	        bottom: Math.max(boundryNodeRect.bottom, Math.max(boundryNodeRect.top, 0) + boundryNodeRect.height) - MENU_EDGE_MARGIN,
	        right: boundryNodeRect.right - MENU_EDGE_MARGIN
	      };
	
	      var alignTarget, alignTargetRect = { top:0, left : 0, right:0, bottom:0 }, existingOffsets  = { top:0, left : 0, right:0, bottom:0  };
	      var positionMode = opts.mdMenuCtrl.positionMode();
	
	      if (positionMode.top === 'target' || positionMode.left === 'target' || positionMode.left === 'target-right') {
	        alignTarget = firstVisibleChild();
	        if (alignTarget) {
	          // TODO: Allow centering on an arbitrary node, for now center on first menu-item's child
	          alignTarget = alignTarget.firstElementChild || alignTarget;
	          alignTarget = alignTarget.querySelector(prefixer.buildSelector('md-menu-align-target')) || alignTarget;
	          alignTargetRect = alignTarget.getBoundingClientRect();
	
	          existingOffsets = {
	            top: parseFloat(containerNode.style.top || 0),
	            left: parseFloat(containerNode.style.left || 0)
	          };
	        }
	      }
	
	      var position = {};
	      var transformOrigin = 'top ';
	
	      switch (positionMode.top) {
	        case 'target':
	          position.top = existingOffsets.top + originNodeRect.top - alignTargetRect.top;
	          break;
	        case 'cascade':
	          position.top = originNodeRect.top - parseFloat(menuStyle.paddingTop) - originNode.style.top;
	          break;
	        case 'bottom':
	          position.top = originNodeRect.top + originNodeRect.height;
	          break;
	        default:
	          throw new Error('Invalid target mode "' + positionMode.top + '" specified for md-menu on Y axis.');
	      }
	
	      var rtl = $mdUtil.isRtl(el);
	
	      switch (positionMode.left) {
	        case 'target':
	          position.left = existingOffsets.left + originNodeRect.left - alignTargetRect.left;
	          transformOrigin += rtl ? 'right'  : 'left';
	          break;
	        case 'target-left':
	          position.left = originNodeRect.left;
	          transformOrigin += 'left';
	          break;
	        case 'target-right':
	          position.left = originNodeRect.right - openMenuNodeRect.width + (openMenuNodeRect.right - alignTargetRect.right);
	          transformOrigin += 'right';
	          break;
	        case 'cascade':
	          var willFitRight = rtl ? (originNodeRect.left - openMenuNodeRect.width) < bounds.left : (originNodeRect.right + openMenuNodeRect.width) < bounds.right;
	          position.left = willFitRight ? originNodeRect.right - originNode.style.left : originNodeRect.left - originNode.style.left - openMenuNodeRect.width;
	          transformOrigin += willFitRight ? 'left' : 'right';
	          break;
	        case 'right':
	          if (rtl) {
	            position.left = originNodeRect.right - originNodeRect.width;
	            transformOrigin += 'left';
	          } else {
	            position.left = originNodeRect.right - openMenuNodeRect.width;
	            transformOrigin += 'right';
	          }
	          break;
	        case 'left':
	          if (rtl) {
	            position.left = originNodeRect.right - openMenuNodeRect.width;
	            transformOrigin += 'right';
	          } else {
	            position.left = originNodeRect.left;
	            transformOrigin += 'left';
	          }
	          break;
	        default:
	          throw new Error('Invalid target mode "' + positionMode.left + '" specified for md-menu on X axis.');
	      }
	
	      var offsets = opts.mdMenuCtrl.offsets();
	      position.top += offsets.top;
	      position.left += offsets.left;
	
	      clamp(position);
	
	      var scaleX = Math.round(100 * Math.min(originNodeRect.width / containerNode.offsetWidth, 1.0)) / 100;
	      var scaleY = Math.round(100 * Math.min(originNodeRect.height / containerNode.offsetHeight, 1.0)) / 100;
	
	      return {
	        top: Math.round(position.top),
	        left: Math.round(position.left),
	        // Animate a scale out if we aren't just repositioning
	        transform: !opts.alreadyOpen ? $mdUtil.supplant('scale({0},{1})', [scaleX, scaleY]) : undefined,
	        transformOrigin: transformOrigin
	      };
	
	      /**
	       * Clamps the repositioning of the menu within the confines of
	       * bounding element (often the screen/body)
	       */
	      function clamp(pos) {
	        pos.top = Math.max(Math.min(pos.top, bounds.bottom - containerNode.offsetHeight), bounds.top);
	        pos.left = Math.max(Math.min(pos.left, bounds.right - containerNode.offsetWidth), bounds.left);
	      }
	
	      /**
	       * Gets the first visible child in the openMenuNode
	       * Necessary incase menu nodes are being dynamically hidden
	       */
	      function firstVisibleChild() {
	        for (var i = 0; i < openMenuNode.children.length; ++i) {
	          if ($window.getComputedStyle(openMenuNode.children[i]).display != 'none') {
	            return openMenuNode.children[i];
	          }
	        }
	      }
	    }
	  }
	  function toNode(el) {
	    if (el instanceof angular.element) {
	      el = el[0];
	    }
	    return el;
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.menuBar
	 */
	
	angular.module('material.components.menuBar', [
	  'material.core',
	  'material.components.icon',
	  'material.components.menu'
	]);
	
	})();
	(function(){
	"use strict";
	
	
	MenuBarController.$inject = ["$scope", "$rootScope", "$element", "$attrs", "$mdConstant", "$document", "$mdUtil", "$timeout"];
	angular
	  .module('material.components.menuBar')
	  .controller('MenuBarController', MenuBarController);
	
	var BOUND_MENU_METHODS = ['handleKeyDown', 'handleMenuHover', 'scheduleOpenHoveredMenu', 'cancelScheduledOpen'];
	
	/**
	 * @ngInject
	 */
	function MenuBarController($scope, $rootScope, $element, $attrs, $mdConstant, $document, $mdUtil, $timeout) {
	  this.$element = $element;
	  this.$attrs = $attrs;
	  this.$mdConstant = $mdConstant;
	  this.$mdUtil = $mdUtil;
	  this.$document = $document;
	  this.$scope = $scope;
	  this.$rootScope = $rootScope;
	  this.$timeout = $timeout;
	
	  var self = this;
	  angular.forEach(BOUND_MENU_METHODS, function(methodName) {
	    self[methodName] = angular.bind(self, self[methodName]);
	  });
	}
	
	MenuBarController.prototype.init = function() {
	  var $element = this.$element;
	  var $mdUtil = this.$mdUtil;
	  var $scope = this.$scope;
	
	  var self = this;
	  var deregisterFns = [];
	  $element.on('keydown', this.handleKeyDown);
	  this.parentToolbar = $mdUtil.getClosest($element, 'MD-TOOLBAR');
	
	  deregisterFns.push(this.$rootScope.$on('$mdMenuOpen', function(event, el) {
	    if (self.getMenus().indexOf(el[0]) != -1) {
	      $element[0].classList.add('md-open');
	      el[0].classList.add('md-open');
	      self.currentlyOpenMenu = el.controller('mdMenu');
	      self.currentlyOpenMenu.registerContainerProxy(self.handleKeyDown);
	      self.enableOpenOnHover();
	    }
	  }));
	
	  deregisterFns.push(this.$rootScope.$on('$mdMenuClose', function(event, el, opts) {
	    var rootMenus = self.getMenus();
	    if (rootMenus.indexOf(el[0]) != -1) {
	      $element[0].classList.remove('md-open');
	      el[0].classList.remove('md-open');
	    }
	
	    var ctrl = angular.element(el[0]).controller('mdMenu');
	    if (ctrl.isInMenuBar && ctrl.mdMenuBarCtrl === self) {
	      var parentMenu = el[0];
	      while (parentMenu && rootMenus.indexOf(parentMenu) == -1) {
	        parentMenu = $mdUtil.getClosest(parentMenu, 'MD-MENU', true);
	      }
	      if (parentMenu) {
	        if (!opts.skipFocus) parentMenu.querySelector('button:not([disabled])').focus();
	        self.currentlyOpenMenu = undefined;
	      }
	      self.disableOpenOnHover();
	      self.setKeyboardMode(true);
	    }
	  }));
	
	  $scope.$on('$destroy', function() {
	    self.disableOpenOnHover();
	    while (deregisterFns.length) {
	      deregisterFns.shift()();
	    }
	  });
	
	
	  this.setKeyboardMode(true);
	};
	
	MenuBarController.prototype.setKeyboardMode = function(enabled) {
	  if (enabled) this.$element[0].classList.add('md-keyboard-mode');
	  else this.$element[0].classList.remove('md-keyboard-mode');
	};
	
	MenuBarController.prototype.enableOpenOnHover = function() {
	  if (this.openOnHoverEnabled) return;
	
	  var self = this;
	
	  self.openOnHoverEnabled = true;
	
	  if (self.parentToolbar) {
	    self.parentToolbar.classList.add('md-has-open-menu');
	
	    // Needs to be on the next tick so it doesn't close immediately.
	    self.$mdUtil.nextTick(function() {
	      angular.element(self.parentToolbar).on('click', self.handleParentClick);
	    }, false);
	  }
	
	  angular
	    .element(self.getMenus())
	    .on('mouseenter', self.handleMenuHover);
	};
	
	MenuBarController.prototype.handleMenuHover = function(e) {
	  this.setKeyboardMode(false);
	  if (this.openOnHoverEnabled) {
	    this.scheduleOpenHoveredMenu(e);
	  }
	};
	
	MenuBarController.prototype.disableOpenOnHover = function() {
	  if (!this.openOnHoverEnabled) return;
	
	  this.openOnHoverEnabled = false;
	
	  if (this.parentToolbar) {
	    this.parentToolbar.classList.remove('md-has-open-menu');
	    angular.element(this.parentToolbar).off('click', this.handleParentClick);
	  }
	
	  angular
	    .element(this.getMenus())
	    .off('mouseenter', this.handleMenuHover);
	};
	
	MenuBarController.prototype.scheduleOpenHoveredMenu = function(e) {
	  var menuEl = angular.element(e.currentTarget);
	  var menuCtrl = menuEl.controller('mdMenu');
	  this.setKeyboardMode(false);
	  this.scheduleOpenMenu(menuCtrl);
	};
	
	MenuBarController.prototype.scheduleOpenMenu = function(menuCtrl) {
	  var self = this;
	  var $timeout = this.$timeout;
	  if (menuCtrl != self.currentlyOpenMenu) {
	    $timeout.cancel(self.pendingMenuOpen);
	    self.pendingMenuOpen = $timeout(function() {
	      self.pendingMenuOpen = undefined;
	      if (self.currentlyOpenMenu) {
	        self.currentlyOpenMenu.close(true, { closeAll: true });
	      }
	      menuCtrl.open();
	    }, 200, false);
	  }
	};
	
	MenuBarController.prototype.handleKeyDown = function(e) {
	  var keyCodes = this.$mdConstant.KEY_CODE;
	  var currentMenu = this.currentlyOpenMenu;
	  var wasOpen = currentMenu && currentMenu.isOpen;
	  this.setKeyboardMode(true);
	  var handled, newMenu, newMenuCtrl;
	  switch (e.keyCode) {
	    case keyCodes.DOWN_ARROW:
	      if (currentMenu) {
	        currentMenu.focusMenuContainer();
	      } else {
	        this.openFocusedMenu();
	      }
	      handled = true;
	      break;
	    case keyCodes.UP_ARROW:
	      currentMenu && currentMenu.close();
	      handled = true;
	      break;
	    case keyCodes.LEFT_ARROW:
	      newMenu = this.focusMenu(-1);
	      if (wasOpen) {
	        newMenuCtrl = angular.element(newMenu).controller('mdMenu');
	        this.scheduleOpenMenu(newMenuCtrl);
	      }
	      handled = true;
	      break;
	    case keyCodes.RIGHT_ARROW:
	      newMenu = this.focusMenu(+1);
	      if (wasOpen) {
	        newMenuCtrl = angular.element(newMenu).controller('mdMenu');
	        this.scheduleOpenMenu(newMenuCtrl);
	      }
	      handled = true;
	      break;
	  }
	  if (handled) {
	    e && e.preventDefault && e.preventDefault();
	    e && e.stopImmediatePropagation && e.stopImmediatePropagation();
	  }
	};
	
	MenuBarController.prototype.focusMenu = function(direction) {
	  var menus = this.getMenus();
	  var focusedIndex = this.getFocusedMenuIndex();
	
	  if (focusedIndex == -1) { focusedIndex = this.getOpenMenuIndex(); }
	
	  var changed = false;
	
	  if (focusedIndex == -1) { focusedIndex = 0; changed = true; }
	  else if (
	    direction < 0 && focusedIndex > 0 ||
	    direction > 0 && focusedIndex < menus.length - direction
	  ) {
	    focusedIndex += direction;
	    changed = true;
	  }
	  if (changed) {
	    menus[focusedIndex].querySelector('button').focus();
	    return menus[focusedIndex];
	  }
	};
	
	MenuBarController.prototype.openFocusedMenu = function() {
	  var menu = this.getFocusedMenu();
	  menu && angular.element(menu).controller('mdMenu').open();
	};
	
	MenuBarController.prototype.getMenus = function() {
	  var $element = this.$element;
	  return this.$mdUtil.nodesToArray($element[0].children)
	    .filter(function(el) { return el.nodeName == 'MD-MENU'; });
	};
	
	MenuBarController.prototype.getFocusedMenu = function() {
	  return this.getMenus()[this.getFocusedMenuIndex()];
	};
	
	MenuBarController.prototype.getFocusedMenuIndex = function() {
	  var $mdUtil = this.$mdUtil;
	  var focusedEl = $mdUtil.getClosest(
	    this.$document[0].activeElement,
	    'MD-MENU'
	  );
	  if (!focusedEl) return -1;
	
	  var focusedIndex = this.getMenus().indexOf(focusedEl);
	  return focusedIndex;
	};
	
	MenuBarController.prototype.getOpenMenuIndex = function() {
	  var menus = this.getMenus();
	  for (var i = 0; i < menus.length; ++i) {
	    if (menus[i].classList.contains('md-open')) return i;
	  }
	  return -1;
	};
	
	MenuBarController.prototype.handleParentClick = function(event) {
	  var openMenu = this.querySelector('md-menu.md-open');
	
	  if (openMenu && !openMenu.contains(event.target)) {
	    angular.element(openMenu).controller('mdMenu').close(true, {
	      closeAll: true
	    });
	  }
	};
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdMenuBar
	 * @module material.components.menuBar
	 * @restrict E
	 * @description
	 *
	 * Menu bars are containers that hold multiple menus. They change the behavior and appearance
	 * of the `md-menu` directive to behave similar to an operating system provided menu.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-menu-bar>
	 *   <md-menu>
	 *     <button ng-click="$mdMenu.open()">
	 *       File
	 *     </button>
	 *     <md-menu-content>
	 *       <md-menu-item>
	 *         <md-button ng-click="ctrl.sampleAction('share', $event)">
	 *           Share...
	 *         </md-button>
	 *       </md-menu-item>
	 *       <md-menu-divider></md-menu-divider>
	 *       <md-menu-item>
	 *       <md-menu-item>
	 *         <md-menu>
	 *           <md-button ng-click="$mdMenu.open()">New</md-button>
	 *           <md-menu-content>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
	 *           </md-menu-content>
	 *         </md-menu>
	 *       </md-menu-item>
	 *     </md-menu-content>
	 *   </md-menu>
	 * </md-menu-bar>
	 * </hljs>
	 *
	 * ## Menu Bar Controls
	 *
	 * You may place `md-menu-item`s that function as controls within menu bars.
	 * There are two modes that are exposed via the `type` attribute of the `md-menu-item`.
	 * `type="checkbox"` will function as a boolean control for the `ng-model` attribute of the
	 * `md-menu-item`. `type="radio"` will function like a radio button, setting the `ngModel`
	 * to the `string` value of the `value` attribute. If you need non-string values, you can use
	 * `ng-value` to provide an expression (this is similar to how angular's native `input[type=radio]`
	 * works.
	 *
	 * If you want either to disable closing the opened menu when clicked, you can add the
	 * `md-prevent-menu-close` attribute to the `md-menu-item`. The attribute will be forwarded to the
	 * `button` element that is generated.
	 *
	 * <hljs lang="html">
	 * <md-menu-bar>
	 *  <md-menu>
	 *    <button ng-click="$mdMenu.open()">
	 *      Sample Menu
	 *    </button>
	 *    <md-menu-content>
	 *      <md-menu-item type="checkbox" ng-model="settings.allowChanges" md-prevent-menu-close>
	 *        Allow changes
	 *      </md-menu-item>
	 *      <md-menu-divider></md-menu-divider>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 1</md-menu-item>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="2">Mode 2</md-menu-item>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="3">Mode 3</md-menu-item>
	 *    </md-menu-content>
	 *  </md-menu>
	 * </md-menu-bar>
	 * </hljs>
	 *
	 *
	 * ### Nesting Menus
	 *
	 * Menus may be nested within menu bars. This is commonly called cascading menus.
	 * To nest a menu place the nested menu inside the content of the `md-menu-item`.
	 * <hljs lang="html">
	 * <md-menu-item>
	 *   <md-menu>
	 *     <button ng-click="$mdMenu.open()">New</md-button>
	 *     <md-menu-content>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
	 *     </md-menu-content>
	 *   </md-menu>
	 * </md-menu-item>
	 * </hljs>
	 *
	 */
	
	MenuBarDirective.$inject = ["$mdUtil", "$mdTheming"];
	angular
	  .module('material.components.menuBar')
	  .directive('mdMenuBar', MenuBarDirective);
	
	/* @ngInject */
	function MenuBarDirective($mdUtil, $mdTheming) {
	  return {
	    restrict: 'E',
	    require: 'mdMenuBar',
	    controller: 'MenuBarController',
	
	    compile: function compile(templateEl, templateAttrs) {
	      if (!templateAttrs.ariaRole) {
	        templateEl[0].setAttribute('role', 'menubar');
	      }
	      angular.forEach(templateEl[0].children, function(menuEl) {
	        if (menuEl.nodeName == 'MD-MENU') {
	          if (!menuEl.hasAttribute('md-position-mode')) {
	            menuEl.setAttribute('md-position-mode', 'left bottom');
	
	            // Since we're in the compile function and actual `md-buttons` are not compiled yet,
	            // we need to query for possible `md-buttons` as well.
	            menuEl.querySelector('button, a, md-button').setAttribute('role', 'menuitem');
	          }
	          var contentEls = $mdUtil.nodesToArray(menuEl.querySelectorAll('md-menu-content'));
	          angular.forEach(contentEls, function(contentEl) {
	            contentEl.classList.add('md-menu-bar-menu');
	            contentEl.classList.add('md-dense');
	            if (!contentEl.hasAttribute('width')) {
	              contentEl.setAttribute('width', 5);
	            }
	          });
	        }
	      });
	
	      // Mark the child menu items that they're inside a menu bar. This is necessary,
	      // because mnMenuItem has special behaviour during compilation, depending on
	      // whether it is inside a mdMenuBar. We can usually figure this out via the DOM,
	      // however if a directive that uses documentFragment is applied to the child (e.g. ngRepeat),
	      // the element won't have a parent and won't compile properly.
	      templateEl.find('md-menu-item').addClass('md-in-menu-bar');
	
	      return function postLink(scope, el, attr, ctrl) {
	        el.addClass('_md');     // private md component indicator for styling
	        $mdTheming(scope, el);
	        ctrl.init();
	      };
	    }
	  };
	
	}
	
	})();
	(function(){
	"use strict";
	
	
	angular
	  .module('material.components.menuBar')
	  .directive('mdMenuDivider', MenuDividerDirective);
	
	
	function MenuDividerDirective() {
	  return {
	    restrict: 'E',
	    compile: function(templateEl, templateAttrs) {
	      if (!templateAttrs.role) {
	        templateEl[0].setAttribute('role', 'separator');
	      }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MenuItemController.$inject = ["$scope", "$element", "$attrs"];
	angular
	  .module('material.components.menuBar')
	  .controller('MenuItemController', MenuItemController);
	
	
	/**
	 * @ngInject
	 */
	function MenuItemController($scope, $element, $attrs) {
	  this.$element = $element;
	  this.$attrs = $attrs;
	  this.$scope = $scope;
	}
	
	MenuItemController.prototype.init = function(ngModel) {
	  var $element = this.$element;
	  var $attrs = this.$attrs;
	
	  this.ngModel = ngModel;
	  if ($attrs.type == 'checkbox' || $attrs.type == 'radio') {
	    this.mode  = $attrs.type;
	    this.iconEl = $element[0].children[0];
	    this.buttonEl = $element[0].children[1];
	    if (ngModel) {
	      // Clear ngAria set attributes
	      this.initClickListeners();
	    }
	  }
	};
	
	// ngAria auto sets attributes on a menu-item with a ngModel.
	// We don't want this because our content (buttons) get the focus
	// and set their own aria attributes appropritately. Having both
	// breaks NVDA / JAWS. This undeoes ngAria's attrs.
	MenuItemController.prototype.clearNgAria = function() {
	  var el = this.$element[0];
	  var clearAttrs = ['role', 'tabindex', 'aria-invalid', 'aria-checked'];
	  angular.forEach(clearAttrs, function(attr) {
	    el.removeAttribute(attr);
	  });
	};
	
	MenuItemController.prototype.initClickListeners = function() {
	  var self = this;
	  var ngModel = this.ngModel;
	  var $scope = this.$scope;
	  var $attrs = this.$attrs;
	  var $element = this.$element;
	  var mode = this.mode;
	
	  this.handleClick = angular.bind(this, this.handleClick);
	
	  var icon = this.iconEl;
	  var button = angular.element(this.buttonEl);
	  var handleClick = this.handleClick;
	
	  $attrs.$observe('disabled', setDisabled);
	  setDisabled($attrs.disabled);
	
	  ngModel.$render = function render() {
	    self.clearNgAria();
	    if (isSelected()) {
	      icon.style.display = '';
	      button.attr('aria-checked', 'true');
	    } else {
	      icon.style.display = 'none';
	      button.attr('aria-checked', 'false');
	    }
	  };
	
	  $scope.$$postDigest(ngModel.$render);
	
	  function isSelected() {
	    if (mode == 'radio') {
	      var val = $attrs.ngValue ? $scope.$eval($attrs.ngValue) : $attrs.value;
	      return ngModel.$modelValue == val;
	    } else {
	      return ngModel.$modelValue;
	    }
	  }
	
	  function setDisabled(disabled) {
	    if (disabled) {
	      button.off('click', handleClick);
	    } else {
	      button.on('click', handleClick);
	    }
	  }
	};
	
	MenuItemController.prototype.handleClick = function(e) {
	  var mode = this.mode;
	  var ngModel = this.ngModel;
	  var $attrs = this.$attrs;
	  var newVal;
	  if (mode == 'checkbox') {
	    newVal = !ngModel.$modelValue;
	  } else if (mode == 'radio') {
	    newVal = $attrs.ngValue ? this.$scope.$eval($attrs.ngValue) : $attrs.value;
	  }
	  ngModel.$setViewValue(newVal);
	  ngModel.$render();
	};
	
	})();
	(function(){
	"use strict";
	
	
	MenuItemDirective.$inject = ["$mdUtil", "$mdConstant", "$$mdSvgRegistry"];
	angular
	  .module('material.components.menuBar')
	  .directive('mdMenuItem', MenuItemDirective);
	
	 /* @ngInject */
	function MenuItemDirective($mdUtil, $mdConstant, $$mdSvgRegistry) {
	  return {
	    controller: 'MenuItemController',
	    require: ['mdMenuItem', '?ngModel'],
	    priority: $mdConstant.BEFORE_NG_ARIA,
	    compile: function(templateEl, templateAttrs) {
	      var type = templateAttrs.type;
	      var inMenuBarClass = 'md-in-menu-bar';
	
	      // Note: This allows us to show the `check` icon for the md-menu-bar items.
	      // The `md-in-menu-bar` class is set by the mdMenuBar directive.
	      if ((type === 'checkbox' || type === 'radio') && templateEl.hasClass(inMenuBarClass)) {
	        var text = templateEl[0].textContent;
	        var buttonEl = angular.element('<md-button type="button"></md-button>');
	        var iconTemplate = '<md-icon md-svg-src="' + $$mdSvgRegistry.mdChecked + '"></md-icon>';
	
	        buttonEl.html(text);
	        buttonEl.attr('tabindex', '0');
	
	        if (angular.isDefined(templateAttrs.mdPreventMenuClose)) {
	          buttonEl.attr('md-prevent-menu-close', templateAttrs.mdPreventMenuClose);
	        }
	
	        templateEl.html('');
	        templateEl.append(angular.element(iconTemplate));
	        templateEl.append(buttonEl);
	        templateEl.addClass('md-indent').removeClass(inMenuBarClass);
	
	        setDefault('role', type === 'checkbox' ? 'menuitemcheckbox' : 'menuitemradio', buttonEl);
	        moveAttrToButton('ng-disabled');
	
	      } else {
	        setDefault('role', 'menuitem', templateEl[0].querySelector('md-button, button, a'));
	      }
	
	
	      return function(scope, el, attrs, ctrls) {
	        var ctrl = ctrls[0];
	        var ngModel = ctrls[1];
	        ctrl.init(ngModel);
	      };
	
	      function setDefault(attr, val, el) {
	        el = el || templateEl;
	        if (el instanceof angular.element) {
	          el = el[0];
	        }
	        if (!el.hasAttribute(attr)) {
	          el.setAttribute(attr, val);
	        }
	      }
	
	      function moveAttrToButton(attribute) {
	        var attributes = $mdUtil.prefixer(attribute);
	
	        angular.forEach(attributes, function(attr) {
	          if (templateEl[0].hasAttribute(attr)) {
	            var val = templateEl[0].getAttribute(attr);
	            buttonEl[0].setAttribute(attr, val);
	            templateEl[0].removeAttribute(attr);
	          }
	        });
	      }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.navBar
	 */
	
	
	MdNavBar.$inject = ["$mdAria", "$mdTheming", "$window", "$mdUtil"];
	MdNavBarController.$inject = ["$element", "$scope", "$timeout", "$mdConstant"];
	MdNavItem.$inject = ["$mdAria", "$$rAF", "$mdUtil", "$window"];
	MdNavItemController.$inject = ["$element"];
	angular.module('material.components.navBar', ['material.core'])
	    .controller('MdNavBarController', MdNavBarController)
	    .directive('mdNavBar', MdNavBar)
	    .controller('MdNavItemController', MdNavItemController)
	    .directive('mdNavItem', MdNavItem);
	
	/**
	 * @ngdoc directive
	 * @name mdNavBar
	 * @module material.components.navBar
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-nav-bar>` directive renders a list of material tabs that can be used
	 * for top-level page navigation. Unlike `<md-tabs>`, it has no concept of a tab
	 * body and no bar pagination.
	 *
	 * Because it deals with page navigation, certain routing concepts are built-in.
	 * Route changes via `ng-href`, `ui-sref`, or `ng-click` events are supported.
	 * Alternatively, the user could simply watch the value of `md-selected-nav-item`
	 * (`currentNavItem` in the below example) for changes.
	 *
	 * Accessibility functionality is implemented as a
	 * <a href="https://www.w3.org/TR/wai-aria-1.0/complete#tablist">
	 *   tablist</a> with
	 * <a href="https://www.w3.org/TR/wai-aria-1.0/complete#tab">tabs</a>.
	 * We've kept the `role="navigation"` on the `<nav>`, for backwards compatibility, even though
	 *  it is not required in the
	 * <a href="https://www.w3.org/TR/wai-aria-practices/#aria_lh_navigation">
	 *   latest Working Group Note from December 2017</a>.
	 *
	 * <h3>Keyboard Navigation</h3>
	 * - `Tab`/`Shift+Tab` moves the focus to the next/previous interactive element on the page
	 * - `Enter`/`Space` selects the focused nav item and navigates to display the item's contents
	 * - `Right`/`Down` moves focus to the next nav item, wrapping at the end
	 * - `Left`/`Up` moves focus to the previous nav item, wrapping at the end
	 * - `Home`/`End` moves the focus to the first/last nav item
	 *
	 * @param {string=} md-selected-nav-item The name of the current tab; this must
	 *     match the `name` attribute of `<md-nav-item>`.
	 * @param {boolean=} md-no-ink-bar If set to true, the ink bar will be hidden.
	 * @param {string=} nav-bar-aria-label An `aria-label` applied to the `md-nav-bar`'s tablist
	 * for accessibility.
	 *
	 * @usage
	 * <hljs lang="html">
	 *  <md-nav-bar md-selected-nav-item="currentNavItem">
	 *    <md-nav-item md-nav-click="goto('page1')" name="page1">
	 *      Page One
	 *    </md-nav-item>
	 *    <md-nav-item md-nav-href="#page2" name="page3">Page Two</md-nav-item>
	 *    <md-nav-item md-nav-sref="page3" name="page2">Page Three</md-nav-item>
	 *    <md-nav-item
	 *      md-nav-sref="app.page4"
	 *      sref-opts="{reload: true, notify: true}"
	 *      name="page4">
	 *      Page Four
	 *    </md-nav-item>
	 *  </md-nav-bar>
	 *</hljs>
	 * <hljs lang="js">
	 * (function() {
	 *   'use strict';
	 *
	 *    $rootScope.$on('$routeChangeSuccess', function(event, current) {
	 *      $scope.currentLink = getCurrentLinkFromRoute(current);
	 *    });
	 * });
	 * </hljs>
	 */
	/**
	 * @param $mdAria
	 * @param $mdTheming
	 * @param $window
	 * @param $mdUtil
	 * @constructor
	 * @ngInject
	 */
	function MdNavBar($mdAria, $mdTheming, $window, $mdUtil) {
	  return {
	    restrict: 'E',
	    transclude: true,
	    controller: MdNavBarController,
	    controllerAs: 'ctrl',
	    bindToController: true,
	    scope: {
	      'mdSelectedNavItem': '=?',
	      'mdNoInkBar': '=?',
	      'navBarAriaLabel': '@?',
	    },
	    template:
	      '<div class="md-nav-bar">' +
	        '<nav role="navigation">' +
	          '<ul class="_md-nav-bar-list" ng-transclude role="tablist" ' +
	            'ng-focus="ctrl.onFocus()" ' + // Deprecated but kept for now in order to not break tests
	            'aria-label="{{ctrl.navBarAriaLabel}}">' +
	          '</ul>' +
	        '</nav>' +
	        '<md-nav-ink-bar ng-hide="ctrl.mdNoInkBar"></md-nav-ink-bar>' +
	      '</div>',
	    link: function(scope, element, attrs, ctrl) {
	
	      ctrl.width = $window.innerWidth;
	
	      function onResize() {
	        if (ctrl.width !== $window.innerWidth) {
	          ctrl.updateSelectedTabInkBar();
	          ctrl.width = $window.innerWidth;
	          scope.$digest();
	        }
	      }
	
	      function cleanUp() {
	        angular.element($window).off('resize', onResize);
	      }
	
	      angular.element($window).on('resize', $mdUtil.debounce(onResize, 300));
	      scope.$on('$destroy', cleanUp);
	
	      $mdTheming(element);
	      if (!ctrl.navBarAriaLabel) {
	        $mdAria.expectAsync(element, 'aria-label', angular.noop);
	      }
	    },
	  };
	}
	
	/**
	 * Controller for the nav-bar component.
	 * Accessibility functionality is implemented as a tablist
	 * (https://www.w3.org/TR/wai-aria-1.0/complete#tablist) and
	 * tabs (https://www.w3.org/TR/wai-aria-1.0/complete#tab).
	 *
	 * @param {!angular.JQLite} $element
	 * @param {!angular.Scope} $scope
	 * @param {!angular.Timeout} $timeout
	 * @param {!Object} $mdConstant
	 * @constructor
	 * @final
	 * @ngInject
	 */
	function MdNavBarController($element, $scope, $timeout, $mdConstant) {
	  // Injected variables
	  /** @private @const {!angular.Timeout} */
	  this._$timeout = $timeout;
	
	  /** @private @const {!angular.Scope} */
	  this._$scope = $scope;
	
	  /** @private @const {!Object} */
	  this._$mdConstant = $mdConstant;
	
	  // Data-bound variables.
	  /** @type {string} */
	  this.mdSelectedNavItem;
	
	  /** @type {string} */
	  this.navBarAriaLabel;
	
	  // State variables.
	
	  /** @type {?angular.JQLite} */
	  this._navBarEl = $element[0];
	
	  /** @type {?angular.JQLite} */
	  this._inkbar;
	
	  var self = this;
	  // need to wait for transcluded content to be available
	  var deregisterTabWatch = this._$scope.$watch(function() {
	    return self._navBarEl.querySelectorAll('._md-nav-button').length;
	  },
	  function(newLength) {
	    if (newLength > 0) {
	      self._initTabs();
	      deregisterTabWatch();
	    }
	  });
	}
	
	/**
	 * Initializes the tab components once they exist.
	 * @private
	 */
	MdNavBarController.prototype._initTabs = function() {
	  this._inkbar = angular.element(this._navBarEl.querySelector('md-nav-ink-bar'));
	
	  var self = this;
	  this._$timeout(function() {
	    self._updateTabs(self.mdSelectedNavItem, null);
	  });
	
	  this._$scope.$watch('ctrl.mdSelectedNavItem', function(newValue, oldValue) {
	    // Wait a digest before update tabs for products doing
	    // anything dynamic in the template.
	    self._$timeout(function() {
	      self._updateTabs(newValue, oldValue);
	    });
	  });
	};
	
	/**
	 * Set the current tab to be selected.
	 * @param {string|undefined} newValue New current tab name.
	 * @param {string|undefined|null} oldValue Previous tab name.
	 * @private
	 */
	MdNavBarController.prototype._updateTabs = function(newValue, oldValue) {
	  var self = this;
	  var tabs = this._getTabs();
	  var sameTab = newValue === oldValue;
	
	  // this._getTabs can return null if nav-bar has not yet been initialized
	  if (!tabs) return;
	
	  var oldIndex = -1;
	  var newIndex = -1;
	  var newTab = this._getTabByName(newValue);
	  var oldTab = this._getTabByName(oldValue);
	
	  if (oldTab) {
	    oldTab.setSelected(false);
	    oldIndex = tabs.indexOf(oldTab);
	  }
	
	  if (newTab) {
	    newTab.setSelected(true);
	    newIndex = tabs.indexOf(newTab);
	  }
	
	  this._$timeout(function() {
	    self._updateInkBarStyles(newTab, newIndex, oldIndex);
	    // Don't change focus when there is no newTab, the new and old tabs are the same, or when
	    // called from MdNavBarController._initTabs() which would have no oldTab defined.
	    if (newTab && oldTab && !sameTab) {
	      self._moveFocus(oldTab, newTab);
	    }
	  });
	};
	
	/**
	 * Repositions the ink bar to the selected tab.
	 * @private
	 */
	MdNavBarController.prototype._updateInkBarStyles = function(tab, newIndex) {
	  this._inkbar.css({display: newIndex < 0 ? 'none' : ''});
	
	  if (tab) {
	    var tabEl = tab.getButtonEl();
	    var left = tabEl.offsetLeft;
	    var tabWidth = tabEl.offsetWidth;
	    var navBarWidth = this._navBarEl.getBoundingClientRect().width;
	    var scale = tabWidth / navBarWidth;
	    var translate = left / navBarWidth * 100;
	
	    this._inkbar.css({ transform: 'translateX(' + translate + '%) scaleX(' + scale + ')' });
	  }
	};
	
	/**
	 * Updates inkbar to match current tab.
	 */
	MdNavBarController.prototype.updateSelectedTabInkBar = function() {
	  this._updateInkBarStyles(this._getSelectedTab());
	}
	
	/**
	 * Returns an array of the current tabs.
	 * @return {Array<!MdNavItemController>}
	 * @private
	 */
	MdNavBarController.prototype._getTabs = function() {
	  var controllers = Array.prototype.slice.call(
	    this._navBarEl.querySelectorAll('.md-nav-item'))
	    .map(function(el) {
	      return angular.element(el).controller('mdNavItem');
	    });
	  return controllers.indexOf(undefined) ? controllers : null;
	};
	
	/**
	 * Returns the tab with the specified name.
	 * @param {string} name The name of the tab, found in its name attribute.
	 * @return {MdNavItemController}
	 * @private
	 */
	MdNavBarController.prototype._getTabByName = function(name) {
	  return this._findTab(function(tab) {
	    return tab.getName() === name;
	  });
	};
	
	/**
	 * Returns the selected tab.
	 * @return {MdNavItemController}
	 * @private
	 */
	MdNavBarController.prototype._getSelectedTab = function() {
	  return this._findTab(function(tab) {
	    return tab.isSelected();
	  });
	};
	
	/**
	 * Returns the focused tab.
	 * @return {MdNavItemController}
	 */
	MdNavBarController.prototype.getFocusedTab = function() {
	  return this._findTab(function(tab) {
	    return tab.hasFocus();
	  });
	};
	
	/**
	 * Find a tab that matches the specified function, starting from the first tab.
	 * @param {Function} fn
	 * @param {number=} startIndex index to start at. Defaults to 0.
	 * @returns {MdNavItemController}
	 * @private
	 */
	MdNavBarController.prototype._findTab = function(fn, startIndex) {
	  var tabs = this._getTabs();
	  if (startIndex === undefined || startIndex === null) {
	    startIndex = 0;
	  }
	  for (var i = startIndex; i < tabs.length; i++) {
	    if (fn(tabs[i])) {
	      return tabs[i];
	    }
	  }
	  return null;
	};
	
	/**
	 * Find a tab that matches the specified function, going backwards from the end of the list.
	 * @param {Function} fn
	 * @param {number=} startIndex index to start at. Defaults to tabs.length - 1.
	 * @returns {MdNavItemController}
	 * @private
	 */
	MdNavBarController.prototype._findTabReverse = function(fn, startIndex) {
	  var tabs = this._getTabs();
	  if (startIndex === undefined || startIndex === null) {
	    startIndex = tabs.length - 1;
	  }
	  for (var i = startIndex; i >= 0 ; i--) {
	    if (fn(tabs[i])) {
	      return tabs[i];
	    }
	  }
	  return null;
	};
	
	/**
	 * Direct focus to the selected tab when focus enters the nav bar.
	 */
	MdNavBarController.prototype.onFocus = function() {
	  var tab = this._getSelectedTab();
	  if (tab && !tab._focused) {
	    tab.setFocused(true);
	  }
	};
	
	/**
	 * Move focus from oldTab to newTab.
	 * @param {!MdNavItemController} oldTab
	 * @param {!MdNavItemController} newTab
	 * @private
	 */
	MdNavBarController.prototype._moveFocus = function(oldTab, newTab) {
	  oldTab.setFocused(false);
	  newTab.setFocused(true);
	};
	
	/**
	 * Focus the first tab.
	 * @private
	 */
	MdNavBarController.prototype._focusFirstTab = function() {
	  var tabs = this._getTabs();
	  if (!tabs) return;
	  var tabToFocus = this._findTab(function(tab) {
	    return tab._isEnabled();
	  });
	  if (tabToFocus) {
	    this._moveFocus(this.getFocusedTab(), tabToFocus);
	  }
	};
	
	/**
	 * Focus the last tab.
	 * @private
	 */
	MdNavBarController.prototype._focusLastTab = function() {
	  var tabs = this._getTabs();
	  if (!tabs) return;
	  var tabToFocus = this._findTabReverse(function(tab) {
	    return tab._isEnabled();
	  });
	  if (tabToFocus) {
	    this._moveFocus(this.getFocusedTab(), tabToFocus);
	  }
	};
	
	/**
	 * Focus the next non-disabled tab.
	 * @param {number} focusedTabIndex the index of the currently focused tab
	 * @private
	 */
	MdNavBarController.prototype._focusNextTab = function(focusedTabIndex) {
	  var tabs = this._getTabs();
	  if (!tabs) return;
	  var tabToFocus = this._findTab(function(tab) {
	    return tab._isEnabled();
	  }, focusedTabIndex + 1);
	  if (tabToFocus) {
	    this._moveFocus(this.getFocusedTab(), tabToFocus);
	  } else {
	    this._focusFirstTab();
	  }
	};
	
	/**
	 * Focus the previous non-disabled tab.
	 * @param {number} focusedTabIndex the index of the currently focused tab
	 * @private
	 */
	MdNavBarController.prototype._focusPreviousTab = function(focusedTabIndex) {
	  var tabs = this._getTabs();
	  if (!tabs) return;
	  var tabToFocus = this._findTabReverse(function(tab) {
	    return tab._isEnabled();
	  }, focusedTabIndex - 1);
	  if (tabToFocus) {
	    this._moveFocus(this.getFocusedTab(), tabToFocus);
	  } else {
	    this._focusLastTab();
	  }
	};
	
	/**
	 * Responds to keydown events.
	 * Calls to preventDefault() stop the page from scrolling when changing focus in the nav-bar.
	 * @param {!KeyboardEvent} e
	 */
	MdNavBarController.prototype.onKeydown = function(e) {
	  var keyCodes = this._$mdConstant.KEY_CODE;
	  var tabs = this._getTabs();
	  var focusedTab = this.getFocusedTab();
	  if (!focusedTab || !tabs) return;
	
	  var focusedTabIndex = tabs.indexOf(focusedTab);
	
	  // use arrow keys to navigate between tabs
	  switch (e.keyCode) {
	    case keyCodes.UP_ARROW:
	    case keyCodes.LEFT_ARROW:
	      e.preventDefault();
	      this._focusPreviousTab(focusedTabIndex);
	      break;
	    case keyCodes.DOWN_ARROW:
	    case keyCodes.RIGHT_ARROW:
	      e.preventDefault();
	      this._focusNextTab(focusedTabIndex);
	      break;
	    case keyCodes.SPACE:
	    case keyCodes.ENTER:
	      // timeout to avoid a "digest already in progress" console error
	      this._$timeout(function() {
	        focusedTab.getButtonEl().click();
	      });
	      break;
	    case keyCodes.HOME:
	      e.preventDefault();
	      this._focusFirstTab();
	      break;
	    case keyCodes.END:
	      e.preventDefault();
	      this._focusLastTab();
	      break;
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @name mdNavItem
	 * @module material.components.navBar
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-nav-item>` describes a page navigation link within the `<md-nav-bar>` component.
	 * It renders an `<md-button>` as the actual link.
	 *
	 * Exactly one of the `md-nav-click`, `md-nav-href`, or `md-nav-sref` attributes are required
	 * to be specified.
	 *
	 * @param {string=} nav-item-aria-label Allows setting or overriding the label that is announced by
	 *     a screen reader for the nav item's button. If this is not set, the nav item's transcluded
	 *     content will be announced. Make sure to set this if the nav item's transcluded content does
	 *     not include descriptive text, for example only an icon.
	 * @param {expression=} md-nav-click Expression which will be evaluated when the
	 *     link is clicked to change the page. Renders as an `ng-click`.
	 * @param {string=} md-nav-href url to transition to when this link is clicked.
	 *     Renders as an `ng-href`.
	 * @param {string=} md-nav-sref UI-Router state to transition to when this link is
	 *     clicked. Renders as a `ui-sref`.
	 * @param {string} name The name of this link. Used by the nav bar to know
	 *     which link is currently selected.
	 * @param {!object=} sref-opts UI-Router options that are passed to the `$state.go()` function. See
	 *     the <a ng-href="https://ui-router.github.io/docs/latest/interfaces/transition.transitionoptions.html"
	 *     target="_blank">UI-Router documentation for details</a>.
	 *
	 * @usage
	 * See <a ng-href="api/directive/mdNavBar">md-nav-bar</a> for usage.
	 */
	/**
	 * @param $mdAria
	 * @param $$rAF
	 * @param $mdUtil
	 * @param $window
	 * @constructor
	 * @ngInject
	 */
	function MdNavItem($mdAria, $$rAF, $mdUtil, $window) {
	  return {
	    restrict: 'E',
	    require: ['mdNavItem', '^mdNavBar'],
	    controller: MdNavItemController,
	    bindToController: true,
	    controllerAs: 'ctrl',
	    replace: true,
	    transclude: true,
	    template: function(tElement, tAttrs) {
	      var hasNavClick = tAttrs.mdNavClick;
	      var hasNavHref = tAttrs.mdNavHref;
	      var hasNavSref = tAttrs.mdNavSref;
	      var hasSrefOpts = tAttrs.srefOpts;
	      var navigationAttribute;
	      var navigationOptions;
	      var buttonTemplate;
	
	      // Cannot specify more than one nav attribute
	      if ((hasNavClick ? 1 : 0) + (hasNavHref ? 1 : 0) + (hasNavSref ? 1 : 0) > 1) {
	        throw Error(
	          'Please do not specify more than one of the md-nav-click, md-nav-href, ' +
	          'or md-nav-sref attributes per nav-item directive.'
	        );
	      }
	
	      if (hasNavClick !== undefined && hasNavClick !== null) {
	        navigationAttribute = 'ng-click="ctrl.mdNavClick()"';
	      } else if (hasNavHref !== undefined && hasNavHref !== null) {
	        navigationAttribute = 'ng-href="{{ctrl.mdNavHref}}"';
	      } else if (hasNavSref !== undefined && hasNavSref !== null) {
	        navigationAttribute = 'ui-sref="{{ctrl.mdNavSref}}"';
	      } else {
	        throw Error(
	          'Please specify at least one of the md-nav-click, md-nav-href, or md-nav-sref ' +
	          'attributes per nav-item directive.');
	      }
	
	      navigationOptions = hasSrefOpts ? 'ui-sref-opts="{{ctrl.srefOpts}}" ' : '';
	
	      if (navigationAttribute) {
	        buttonTemplate = '' +
	          '<md-button class="_md-nav-button md-accent" ' +
	            'ng-class="ctrl.getNgClassMap()" ' +
	            'ng-blur="ctrl.setFocused(false)" ' +
	            'ng-disabled="ctrl.disabled" ' +
	            'tabindex="-1" ' +
	            'role="tab" ' +
	            'ng-attr-aria-label="{{ctrl.navItemAriaLabel ? ctrl.navItemAriaLabel : undefined}}" ' +
	            'aria-selected="{{ctrl.isSelected()}}" ' +
	            navigationOptions +
	            navigationAttribute + '>' +
	            '<span ng-transclude class="_md-nav-button-text"></span>' +
	          '</md-button>';
	      }
	
	      return '' +
	        '<li class="md-nav-item" ' +
	          'role="presentation">' +
	          (buttonTemplate || '') +
	        '</li>';
	    },
	    scope: {
	      'mdNavClick': '&?',
	      'mdNavHref': '@?',
	      'mdNavSref': '@?',
	      'srefOpts': '=?',
	      'name': '@',
	      'navItemAriaLabel': '@?',
	    },
	    link: function(scope, element, attrs, controllers) {
	      var disconnect;
	      var mdNavItem;
	      var mdNavBar;
	      var navButton;
	
	      // When accessing the element's contents synchronously, they
	      // may not be defined yet because of transclusion. There is a higher
	      // chance that it will be accessible if we wait one frame.
	      $$rAF(function() {
	        mdNavItem = controllers[0];
	        mdNavBar = controllers[1];
	        navButton = angular.element(element[0].querySelector('._md-nav-button'));
	
	        if (!mdNavItem.name) {
	          mdNavItem.name = angular.element(element[0]
	              .querySelector('._md-nav-button-text')).text().trim();
	        }
	
	        navButton.on('keydown', function($event) {
	          mdNavBar.onKeydown($event);
	        });
	
	        navButton.on('focus', function() {
	          mdNavItem._focused = true;
	        });
	
	        navButton.on('click', function() {
	          // This triggers a watcher on mdNavBar.mdSelectedNavItem which calls
	          // MdNavBarController._updateTabs() after a $timeout. That function calls
	          // MdNavItemController.setSelected() for the old tab with false and the new tab with true.
	          mdNavBar.mdSelectedNavItem = mdNavItem.name;
	          scope.$apply();
	        });
	
	        // Get the disabled attribute value first, then setup observing of value changes
	        mdNavItem.disabled = $mdUtil.parseAttributeBoolean(attrs['disabled'], false);
	        if ('MutationObserver' in $window) {
	          var config = {attributes: true, attributeFilter: ['disabled']};
	          var targetNode = element[0];
	          var mutationCallback = function(mutationList) {
	            $mdUtil.nextTick(function() {
	              mdNavItem.disabled = $mdUtil.parseAttributeBoolean(attrs[mutationList[0].attributeName], false);
	            });
	          };
	          var observer = new MutationObserver(mutationCallback);
	          observer.observe(targetNode, config);
	          disconnect = observer.disconnect.bind(observer);
	        } else {
	          attrs.$observe('disabled', function (value) {
	            mdNavItem.disabled = $mdUtil.parseAttributeBoolean(value, false);
	          });
	        }
	
	        if (!mdNavItem.navItemAriaLabel) {
	          $mdAria.expectWithText(navButton, 'aria-label');
	        }
	      });
	
	      scope.$on('destroy', function() {
	        navButton.off('keydown');
	        navButton.off('focus');
	        navButton.off('click');
	        disconnect();
	      });
	    }
	  };
	}
	
	/**
	 * Controller for the nav-item component.
	 * @param {!angular.JQLite} $element
	 * @constructor
	 * @final
	 * @ngInject
	 */
	function MdNavItemController($element) {
	
	  /** @private @const {!angular.JQLite} */
	  this._$element = $element;
	
	  // Data-bound variables
	
	  /** @const {?Function} */
	  this.mdNavClick;
	
	  /** @const {?string} */
	  this.mdNavHref;
	
	  /** @const {?string} */
	  this.mdNavSref;
	  /** @const {?Object} */
	  this.srefOpts;
	  /** @const {?string} */
	  this.name;
	
	  /** @type {string} */
	  this.navItemAriaLabel;
	
	  // State variables
	  /** @private {boolean} */
	  this._selected = false;
	
	  /** @private {boolean} */
	  this._focused = false;
	}
	
	/**
	 * Returns a map of class names and values for use by ng-class.
	 * @return {!Object<string,boolean>}
	 */
	MdNavItemController.prototype.getNgClassMap = function() {
	  return {
	    'md-active': this._selected,
	    'md-primary': this._selected,
	    'md-unselected': !this._selected,
	    'md-focused': this._focused,
	  };
	};
	
	/**
	 * Get the name attribute of the tab.
	 * @return {string}
	 */
	MdNavItemController.prototype.getName = function() {
	  return this.name;
	};
	
	/**
	 * Get the button element associated with the tab.
	 * @return {!Element}
	 */
	MdNavItemController.prototype.getButtonEl = function() {
	  return this._$element[0].querySelector('._md-nav-button');
	};
	
	/**
	 * Set the selected state of the tab and updates the tabindex.
	 * This function is called for the oldTab and newTab when selection changes.
	 * @param {boolean} isSelected true to select the tab, false to deselect the tab
	 */
	MdNavItemController.prototype.setSelected = function(isSelected) {
	  this._selected = isSelected;
	  if (isSelected) {
	    // https://www.w3.org/TR/wai-aria-practices/examples/tabs/tabs-2/tabs.html suggests that we call
	    // removeAttribute('tabindex') here, but that causes our unit tests to fail due to
	    // document.activeElement staying set to the body instead of the focused nav button.
	    this.getButtonEl().setAttribute('tabindex', '0');
	  } else {
	    this.getButtonEl().setAttribute('tabindex', '-1');
	  }
	};
	
	/**
	 * @return {boolean}
	 */
	MdNavItemController.prototype.isSelected = function() {
	  return this._selected;
	};
	
	/**
	 * Set the focused state of the tab.
	 * @param {boolean} isFocused
	 */
	MdNavItemController.prototype.setFocused = function(isFocused) {
	  this._focused = isFocused;
	
	  if (isFocused) {
	    this.getButtonEl().focus();
	  }
	};
	
	/**
	 * @return {boolean} true if the tab has focus, false if not.
	 */
	MdNavItemController.prototype.hasFocus = function() {
	  return this._focused;
	};
	
	/**
	 * @return {boolean} true if the tab is enabled, false if disabled.
	 * @private
	 */
	MdNavItemController.prototype._isEnabled = function() {
	  return !this._$element.attr('disabled');
	};
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.panel
	 */
	MdPanelService.$inject = ["presets", "$rootElement", "$rootScope", "$injector", "$window"];
	angular
	  .module('material.components.panel', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .provider('$mdPanel', MdPanelProvider);
	
	
	/*****************************************************************************
	 *                            PUBLIC DOCUMENTATION                           *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc service
	 * @name $mdPanelProvider
	 * @module material.components.panel
	 *
	 * @description
	 * `$mdPanelProvider` allows users to create configuration presets that will be
	 * stored within a cached presets object. When the configuration is needed, the
	 * user can request the preset by passing it as the first parameter in the
	 * `$mdPanel.create` or `$mdPanel.open` methods.
	 *
	 * @usage
	 * <hljs lang="js">
	 * (function(angular, undefined) {
	 *   'use strict';
	 *
	 *   angular
	 *       .module('demoApp', ['ngMaterial'])
	 *       .config(DemoConfig)
	 *       .controller('DemoCtrl', DemoCtrl)
	 *       .controller('DemoMenuCtrl', DemoMenuCtrl);
	 *
	 *   function DemoConfig($mdPanelProvider) {
	 *     $mdPanelProvider.definePreset('demoPreset', {
	 *       attachTo: angular.element(document.body),
	 *       controller: DemoMenuCtrl,
	 *       controllerAs: 'ctrl',
	 *       template: '' +
	 *           '<div class="menu-panel" md-whiteframe="4">' +
	 *           '  <div class="menu-content">' +
	 *           '    <div class="menu-item" ng-repeat="item in ctrl.items">' +
	 *           '      <button class="md-button">' +
	 *           '        <span>{{item}}</span>' +
	 *           '      </button>' +
	 *           '    </div>' +
	 *           '    <md-divider></md-divider>' +
	 *           '    <div class="menu-item">' +
	 *           '      <button class="md-button" ng-click="ctrl.closeMenu()">' +
	 *           '        <span>Close Menu</span>' +
	 *           '      </button>' +
	 *           '    </div>' +
	 *           '  </div>' +
	 *           '</div>',
	 *       panelClass: 'menu-panel-container',
	 *       focusOnOpen: false,
	 *       zIndex: 100,
	 *       propagateContainerEvents: true,
	 *       groupName: 'menus'
	 *     });
	 *   }
	 *
	 *   function PanelProviderCtrl($mdPanel) {
	 *     this.navigation = {
	 *       name: 'navigation',
	 *       items: [
	 *         'Home',
	 *         'About',
	 *         'Contact'
	 *       ]
	 *     };
	 *     this.favorites = {
	 *       name: 'favorites',
	 *       items: [
	 *         'Add to Favorites'
	 *       ]
	 *     };
	 *     this.more = {
	 *       name: 'more',
	 *       items: [
	 *         'Account',
	 *         'Sign Out'
	 *       ]
	 *     };
	 *
	 *     $mdPanel.newPanelGroup('menus', {
	 *       maxOpen: 2
	 *     });
	 *
	 *     this.showMenu = function($event, menu) {
	 *       $mdPanel.open('demoPreset', {
	 *         id: 'menu_' + menu.name,
	 *         position: $mdPanel.newPanelPosition()
	 *             .relativeTo($event.target)
	 *             .addPanelPosition(
	 *               $mdPanel.xPosition.ALIGN_START,
	 *               $mdPanel.yPosition.BELOW
	 *             ),
	 *         locals: {
	 *           items: menu.items
	 *         },
	 *         openFrom: $event
	 *       });
	 *     };
	 *   }
	 *
	 *   function PanelMenuCtrl(mdPanelRef) {
	 *     // 'mdPanelRef' is injected in the controller.
	 *     this.closeMenu = function() {
	 *       if (mdPanelRef) {
	 *         mdPanelRef.close();
	 *       }
	 *     };
	 *   }
	 * })(angular);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanelProvider#definePreset
	 * @description
	 * Takes the passed in preset name and preset configuration object and adds it
	 * to the `_presets` object of the provider. This `_presets` object is then
	 * passed along to the `$mdPanel` service.
	 *
	 * @param {string} name Preset name.
	 * @param {!Object} preset Specific configuration object that can contain any
	 *     and all of the parameters available within the `$mdPanel.create` method.
	 *     However, parameters that pertain to id, position, animation, and user
	 *     interaction are not allowed and will be removed from the preset
	 *     configuration.
	 */
	
	
	/*****************************************************************************
	 *                               MdPanel Service                             *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc service
	 * @name $mdPanel
	 * @module material.components.panel
	 *
	 * @description
	 * `$mdPanel` is a robust, low-level service for creating floating panels on
	 * the screen. It can be used to implement tooltips, dialogs, pop-ups, etc.
	 *
	 * The following types, referenced below, have separate documentation:
	 * - <a ng-href="api/type/MdPanelAnimation">MdPanelAnimation</a> from `$mdPanel.newPanelAnimation()`
	 * - <a ng-href="api/type/MdPanelPosition">MdPanelPosition</a> from `$mdPanel.newPanelPosition()`
	 * - <a ng-href="api/type/MdPanelRef">MdPanelRef</a> from the `$mdPanel.open()` Promise or
	 * injected in the panel's controller
	 *
	 * @usage
	 * <hljs lang="js">
	 * (function(angular, undefined) {
	 *   'use strict';
	 *
	 *   angular
	 *       .module('demoApp', ['ngMaterial'])
	 *       .controller('DemoDialogController', DialogController)
	 *       .controller('DemoCtrl', function($mdPanel) {
	 *
	 *     var panelRef;
	 *
	 *     function showPanel($event) {
	 *       var panelPosition = $mdPanel.newPanelPosition()
	 *           .absolute()
	 *           .top('50%')
	 *           .left('50%');
	 *
	 *       var panelAnimation = $mdPanel.newPanelAnimation()
	 *           .openFrom($event)
	 *           .duration(200)
	 *           .closeTo('.show-button')
	 *           .withAnimation($mdPanel.animation.SCALE);
	 *
	 *       var config = {
	 *         attachTo: angular.element(document.body),
	 *         controller: DialogController,
	 *         controllerAs: 'ctrl',
	 *         position: panelPosition,
	 *         animation: panelAnimation,
	 *         targetEvent: $event,
	 *         templateUrl: 'dialog-template.html',
	 *         clickOutsideToClose: true,
	 *         escapeToClose: true,
	 *         focusOnOpen: true
	 *       };
	 *
	 *       $mdPanel.open(config)
	 *           .then(function(result) {
	 *             panelRef = result;
	 *           });
	 *     }
	 *   }
	 *
	 *   function DialogController(MdPanelRef) {
	 *     function closeDialog() {
	 *       if (MdPanelRef) MdPanelRef.close();
	 *     }
	 *   }
	 * })(angular);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#create
	 * @description
	 * Creates a panel with the specified options.
	 *
	 * @param config {!Object=} Specific configuration object that may contain the
	 *     following properties:
	 *
	 *   - `id` - `{string=}`: An ID to track the panel by. When an ID is provided,
	 *     the created panel is added to a tracked panels object. Any subsequent
	 *     requests made to create a panel with that ID are ignored. This is useful
	 *     in having the panel service not open multiple panels from the same user
	 *     interaction when there is no backdrop and events are propagated. Defaults
	 *     to an arbitrary string that is not tracked.
	 *   - `template` - `{string=}`: HTML template to show in the panel. This
	 *     **must** be trusted HTML with respect to AngularJS’s
	 *     [$sce service](https://docs.angularjs.org/api/ng/service/$sce).
	 *   - `templateUrl` - `{string=}`: The URL that will be used as the content of
	 *     the panel.
	 *   - `contentElement` - `{(string|!JQLite|!Element)=}`: Pre-compiled
	 *     element to be used as the panel's content.
	 *   - `controller` - `{(function|string)=}`: The controller to associate with
	 *     the panel. The controller can inject a reference to the returned
	 *     panelRef, which allows the panel to be closed, hidden, and shown. Any
	 *     fields passed in through locals or resolve will be bound to the
	 *     controller.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on
	 *     the scope.
	 *   - `bindToController` - `{boolean=}`: Binds locals to the controller
	 *     instead of passing them in. Defaults to true, as this is a best
	 *     practice.
	 *   - `locals` - `{Object=}`: An object containing key/value pairs. The keys
	 *     will be used as names of values to inject into the controller. For
	 *     example, `locals: {three: 3}` would inject `three` into the controller,
	 *     with the value 3. 'mdPanelRef' is a reserved key, and will always
	 *     be set to the created MdPanelRef instance.
	 *   - `resolve` - `{Object=}`: Similar to locals, except it takes promises as
	 *     values. The panel will not open until all of the promises resolve.
	 *   - `attachTo` - `{(string|!JQLite|!Element)=}`: The element to
	 *     attach the panel to. Defaults to appending to the root element of the
	 *     application.
	 *   - `propagateContainerEvents` - `{boolean=}`: Whether pointer or touch
	 *     events should be allowed to propagate 'go through' the container, aka the
	 *     wrapper, of the panel. Defaults to false.
	 *   - `panelClass` - `{string=}`: A css class to apply to the panel element.
	 *     This class should define any borders, box-shadow, etc. for the panel.
	 *   - `zIndex` - `{number=}`: The z-index to place the panel at.
	 *     Defaults to 80.
	 *   - `position` - `{MdPanelPosition=}`: An MdPanelPosition object that
	 *     specifies the alignment of the panel. For more information, see
	 *     `MdPanelPosition`.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click
	 *     outside the panel to close it. Defaults to false.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to
	 *     close the panel. Defaults to false.
	 *   - `onCloseSuccess` - `{function(!panelRef, string)=}`: Function that is
	 *     called after the close successfully finishes. The first parameter passed
	 *     into this function is the current panelRef and the 2nd is an optional
	 *     string explaining the close reason. The currently supported closeReasons
	 *     can be found in the MdPanelRef.closeReasons enum. These are by default
	 *     passed along by the panel.
	 *   - `trapFocus` - `{boolean=}`: Whether focus should be trapped within the
	 *     panel. If `trapFocus` is true, the user will not be able to interact
	 *     with the rest of the page until the panel is dismissed. Defaults to
	 *     false.
	 *   - `focusOnOpen` - `{boolean=}`: An option to override focus behavior on
	 *     open. Only disable if focusing some other way, as focus management is
	 *     required for panels to be accessible. Defaults to true.
	 *   - `fullscreen` - `{boolean=}`: Whether the panel should be full screen.
	 *     Applies the class `._md-panel-fullscreen` to the panel on open. Defaults
	 *     to false.
	 *   - `animation` - `{MdPanelAnimation=}`: An MdPanelAnimation object that
	 *     specifies the animation of the panel. For more information, see
	 *     `MdPanelAnimation`.
	 *   - `hasBackdrop` - `{boolean=}`: Whether there should be an opaque backdrop
	 *     behind the panel. Defaults to false.
	 *   - `disableParentScroll` - `{boolean=}`: Whether the user can scroll the
	 *     page behind the panel. Defaults to false.
	 *   - `onDomAdded` - `{function=}`: Callback function used to announce when
	 *     the panel is added to the DOM.
	 *   - `onOpenComplete` - `{function=}`: Callback function used to announce
	 *     when the open() action is finished.
	 *   - `onRemoving` - `{function=}`: Callback function used to announce the
	 *     close/hide() action is starting.
	 *   - `onDomRemoved` - `{function=}`: Callback function used to announce when
	 *     the panel is removed from the DOM.
	 *   - `origin` - `{(string|!JQLite|!Element)=}`: The element to focus
	 *     on when the panel closes. This is commonly the element which triggered
	 *     the opening of the panel. If you do not use `origin`, you need to control
	 *     the focus manually.
	 *   - `groupName` - `{(string|!Array<string>)=}`: A group name or an array of
	 *     group names. The group name is used for creating a group of panels. The
	 *     group is used for configuring the number of open panels and identifying
	 *     specific behaviors for groups. For instance, all tooltips could be
	 *     identified using the same groupName.
	 *
	 * @returns {!MdPanelRef} panelRef
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#open
	 * @description
	 * Calls the create method above, then opens the panel. This is a shortcut for
	 * creating and then calling open manually. If custom methods need to be
	 * called when the panel is added to the DOM or opened, do not use this method.
	 * Instead create the panel, chain promises on the domAdded and openComplete
	 * methods, and call open from the returned panelRef.
	 *
	 * @param {!Object=} config Specific configuration object that may contain
	 *     the properties defined in `$mdPanel.create`.
	 * @returns {!Q.IPromise<!MdPanelRef>} panelRef A promise that resolves
	 *     to an instance of the panel.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#newPanelPosition
	 * @description
	 * Returns a new instance of the MdPanelPosition object. Use this to create
	 * the position config object.
	 *
	 * @returns {!MdPanelPosition} panelPosition
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#newPanelAnimation
	 * @description
	 * Returns a new instance of the MdPanelAnimation object. Use this to create
	 * the animation config object.
	 *
	 * @returns {!MdPanelAnimation} panelAnimation
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#newPanelGroup
	 * @description
	 * Creates a panel group and adds it to a tracked list of panel groups.
	 *
	 * @param {string} groupName Name of the group to create.
	 * @param {!Object=} config Specific configuration object that may contain the
	 *     following properties:
	 *
	 *   - `maxOpen` - `{number=}`: The maximum number of panels that are allowed to
	 *     be open within a defined panel group.
	 *
	 * @returns {!Object<string,
	 *     {panels: !Array<!MdPanelRef>,
	 *     openPanels: !Array<!MdPanelRef>,
	 *     maxOpen: number}>} panelGroup
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#setGroupMaxOpen
	 * @description
	 * Sets the maximum number of panels in a group that can be opened at a given
	 * time.
	 *
	 * @param {string} groupName The name of the group to configure.
	 * @param {number} maxOpen The maximum number of panels that can be
	 *     opened. Infinity can be passed in to remove the maxOpen limit.
	 */
	
	
	/*****************************************************************************
	 *                                 MdPanelRef                                *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc type
	 * @name MdPanelRef
	 * @module material.components.panel
	 * @description
	 * A reference to a created panel. This reference contains a unique id for the
	 * panel, along with the following properties:
	 *
	 *   - `id` - `{string}`: The unique id for the panel. This id is used to track
	 *     when a panel was interacted with.
	 *   - `config` - `{!Object=}`: The entire config object that was used in
	 *     create.
	 *   - `isAttached` - `{boolean}`: Whether the panel is attached to the DOM.
	 *     Visibility to the user does not factor into isAttached.
	 *   - `panelContainer` - `{JQLite}`: The wrapper element containing the
	 *     panel. This property is added in order to have access to the `addClass`,
	 *     `removeClass`, `toggleClass`, etc methods.
	 *   - `panelEl` - `{JQLite}`: The panel element. This property is added
	 *     in order to have access to the `addClass`, `removeClass`, `toggleClass`,
	 *     etc methods.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#open
	 * @description
	 * Attaches and shows the panel.
	 *
	 * @returns {!Q.IPromise} A promise that is resolved when the panel is
	 *     opened.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#close
	 * @description
	 * Hides and detaches the panel. Note that this will **not** destroy the panel.
	 * If you don't intend on using the panel again, call the {@link #destroy
	 * destroy} method afterwards.
	 *
	 * @returns {!Q.IPromise} A promise that is resolved when the panel is
	 *     closed.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#attach
	 * @description
	 * Create the panel elements and attach them to the DOM. The panel will be
	 * hidden by default.
	 *
	 * @returns {!Q.IPromise} A promise that is resolved when the panel is
	 *     attached.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#detach
	 * @description
	 * Removes the panel from the DOM. This will NOT hide the panel before removing
	 * it.
	 *
	 * @returns {!Q.IPromise} A promise that is resolved when the panel is
	 *     detached.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#show
	 * @description
	 * Shows the panel.
	 *
	 * @returns {!Q.IPromise} A promise that is resolved when the panel has
	 *     shown and animations are completed.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#hide
	 * @description
	 * Hides the panel.
	 *
	 * @returns {!Q.IPromise} A promise that is resolved when the panel has
	 *     hidden and animations are completed.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#destroy
	 * @description
	 * Destroys the panel. The panel cannot be opened again after this is called.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#addClass
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 * @description
	 * Adds a class to the panel. DO NOT use this hide/show the panel.
	 *
	 * @param {string} newClass class to be added.
	 * @param {boolean} toElement Whether or not to add the class to the panel
	 *     element instead of the container.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#removeClass
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 * @description
	 * Removes a class from the panel. DO NOT use this to hide/show the panel.
	 *
	 * @param {string} oldClass Class to be removed.
	 * @param {boolean} fromElement Whether or not to remove the class from the
	 *     panel element instead of the container.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#toggleClass
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 * @description
	 * Toggles a class on the panel. DO NOT use this to hide/show the panel.
	 *
	 * @param {string} toggleClass Class to be toggled.
	 * @param {boolean} onElement Whether or not to remove the class from the panel
	 *     element instead of the container.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#updatePosition
	 * @description
	 * Updates the position configuration of a panel. Use this to update the
	 * position of a panel that is open, without having to close and re-open the
	 * panel.
	 *
	 * @param {!MdPanelPosition} position
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#addToGroup
	 * @description
	 * Adds a panel to a group if the panel does not exist within the group already.
	 * A panel can only exist within a single group.
	 *
	 * @param {string} groupName The name of the group to add the panel to.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#removeFromGroup
	 * @description
	 * Removes a panel from a group if the panel exists within that group. The group
	 * must be created ahead of time.
	 *
	 * @param {string} groupName The name of the group.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#registerInterceptor
	 * @description
	 * Registers an interceptor with the panel. The callback should return a promise,
	 * which will allow the action to continue when it gets resolved, or will
	 * prevent an action if it is rejected. The interceptors are called sequentially
	 * and it reverse order. `type` must be one of the following
	 * values available on `$mdPanel.interceptorTypes`:
	 * * `CLOSE` - Gets called before the panel begins closing.
	 *
	 * @param {string} type Type of interceptor.
	 * @param {!Q.IPromise<any>} callback Callback to be registered.
	 * @returns {!MdPanelRef}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#removeInterceptor
	 * @description
	 * Removes a registered interceptor.
	 *
	 * @param {string} type Type of interceptor to be removed.
	 * @param {function(): !Q.IPromise<any>} callback Interceptor to be removed.
	 * @returns {!MdPanelRef}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#removeAllInterceptors
	 * @description
	 * Removes all interceptors. If a type is supplied, only the
	 * interceptors of that type will be cleared.
	 *
	 * @param {string=} type Type of interceptors to be removed.
	 * @returns {!MdPanelRef}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#updateAnimation
	 * @description
	 * Updates the animation configuration for a panel. You can use this to change
	 * the panel's animation without having to re-create it.
	 *
	 * @param {!MdPanelAnimation} animation
	 */
	
	
	/*****************************************************************************
	 *                               MdPanelPosition                            *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc type
	 * @name MdPanelPosition
	 * @module material.components.panel
	 * @description
	 *
	 * Object for configuring the position of the panel.
	 *
	 * @usage
	 *
	 * #### Centering the panel
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition().absolute().center();
	 * </hljs>
	 *
	 * #### Overlapping the panel with an element
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition()
	 *     .relativeTo(someElement)
	 *     .addPanelPosition(
	 *       $mdPanel.xPosition.ALIGN_START,
	 *       $mdPanel.yPosition.ALIGN_TOPS
	 *     );
	 * </hljs>
	 *
	 * #### Aligning the panel with the bottom of an element
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition()
	 *     .relativeTo(someElement)
	 *     .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#absolute
	 * @description
	 * Positions the panel absolutely relative to the parent element. If the parent
	 * is document.body, this is equivalent to positioning the panel absolutely
	 * within the viewport.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#relativeTo
	 * @description
	 * Positions the panel relative to a specific element.
	 *
	 * @param {string|!Element|!JQLite} element Query selector, DOM element,
	 *     or angular element to position the panel with respect to.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#top
	 * @description
	 * Sets the value of `top` for the panel. Clears any previously set vertical
	 * position.
	 *
	 * @param {string=} top Value of `top`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#bottom
	 * @description
	 * Sets the value of `bottom` for the panel. Clears any previously set vertical
	 * position.
	 *
	 * @param {string=} bottom Value of `bottom`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#start
	 * @description
	 * Sets the panel to the start of the page - `left` if `ltr` or `right` for
	 * `rtl`. Clears any previously set horizontal position.
	 *
	 * @param {string=} start Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#end
	 * @description
	 * Sets the panel to the end of the page - `right` if `ltr` or `left` for `rtl`.
	 * Clears any previously set horizontal position.
	 *
	 * @param {string=} end Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#left
	 * @description
	 * Sets the value of `left` for the panel. Clears any previously set
	 * horizontal position.
	 *
	 * @param {string=} left Value of `left`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#right
	 * @description
	 * Sets the value of `right` for the panel. Clears any previously set
	 * horizontal position.
	 *
	 * @param {string=} right Value of `right`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#centerHorizontally
	 * @description
	 * Centers the panel horizontally in the viewport. Clears any previously set
	 * horizontal position.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#centerVertically
	 * @description
	 * Centers the panel vertically in the viewport. Clears any previously set
	 * vertical position.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#center
	 * @description
	 * Centers the panel horizontally and vertically in the viewport. This is
	 * equivalent to calling both `centerHorizontally` and `centerVertically`.
	 * Clears any previously set horizontal and vertical positions.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#addPanelPosition
	 * @description
	 * Sets the x and y position for the panel relative to another element. Can be
	 * called multiple times to specify an ordered list of panel positions. The
	 * first position which allows the panel to be completely on-screen will be
	 * chosen; the last position will be chose whether it is on-screen or not.
	 *
	 * xPosition must be one of the following values available on
	 * $mdPanel.xPosition:
	 *
	 *
	 * CENTER | ALIGN_START | ALIGN_END | OFFSET_START | OFFSET_END
	 *
	 * <pre>
	 *    *************
	 *    *           *
	 *    *   PANEL   *
	 *    *           *
	 *    *************
	 *   A B    C    D E
	 *
	 * A: OFFSET_START (for LTR displays)
	 * B: ALIGN_START (for LTR displays)
	 * C: CENTER
	 * D: ALIGN_END (for LTR displays)
	 * E: OFFSET_END (for LTR displays)
	 * </pre>
	 *
	 * yPosition must be one of the following values available on
	 * $mdPanel.yPosition:
	 *
	 * CENTER | ALIGN_TOPS | ALIGN_BOTTOMS | ABOVE | BELOW
	 *
	 * <pre>
	 *   F
	 *   G *************
	 *     *           *
	 *   H *   PANEL   *
	 *     *           *
	 *   I *************
	 *   J
	 *
	 * F: BELOW
	 * G: ALIGN_TOPS
	 * H: CENTER
	 * I: ALIGN_BOTTOMS
	 * J: ABOVE
	 * </pre>
	 *
	 * @param {string} xPosition
	 * @param {string} yPosition
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#withOffsetX
	 * @description
	 * Sets the value of the offset in the x-direction.
	 *
	 * @param {string|number} offsetX
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#withOffsetY
	 * @description
	 * Sets the value of the offset in the y-direction.
	 *
	 * @param {string|number} offsetY
	 * @returns {!MdPanelPosition}
	 */
	
	
	/*****************************************************************************
	 *                               MdPanelAnimation                            *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc type
	 * @name MdPanelAnimation
	 * @module material.components.panel
	 * @description
	 * Animation configuration object. To use, create an MdPanelAnimation with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * @usage
	 *
	 * <hljs lang="js">
	 * var panelAnimation = new MdPanelAnimation()
	 *     .openFrom(myButtonEl)
	 *     .duration(1337)
	 *     .closeTo('.my-button')
	 *     .withAnimation($mdPanel.animation.SCALE);
	 *
	 * $mdPanel.create({
	 *   animation: panelAnimation
	 * });
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#openFrom
	 * @description
	 * Specifies where to start the open animation. `openFrom` accepts a
	 * click event object, query selector, DOM element, or a Rect object that
	 * is used to determine the bounds. When passed a click event, the location
	 * of the click will be used as the position to start the animation.
	 *
	 * @param {string|!Element|!Event|{top: number, left: number}}
	 * @returns {!MdPanelAnimation}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#closeTo
	 * @description
	 * Specifies where to animate the panel close. `closeTo` accepts a
	 * query selector, DOM element, or a Rect object that is used to determine
	 * the bounds.
	 *
	 * @param {string|!Element|{top: number, left: number}}
	 * @returns {!MdPanelAnimation}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#withAnimation
	 * @description
	 * Specifies the animation class.
	 *
	 * There are several default animations that can be used: `$mdPanel.animation.`
	 *  - `SLIDE`: The panel slides in and out from the specified
	 *       elements. It will not fade in or out.
	 *  - `SCALE`: The panel scales in and out. Slide and fade are
	 *       included in this animation.
	 *  - `FADE`: The panel fades in and out.
	 *
	 * Custom classes will by default fade in and out unless
	 * `transition: opacity 1ms` is added to the to custom class.
	 *
	 * @param {string|{open: string, close: string}} cssClass
	 * @returns {!MdPanelAnimation}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#duration
	 * @description
	 * Specifies the duration of the animation in milliseconds. The `duration`
	 * method accepts either a number or an object with separate open and close
	 * durations.
	 *
	 * @param {number|{open: number, close: number}} duration
	 * @returns {!MdPanelAnimation}
	 */
	
	
	/*****************************************************************************
	 *                            PUBLIC DOCUMENTATION                           *
	 *****************************************************************************/
	
	
	var MD_PANEL_Z_INDEX = 80;
	var MD_PANEL_HIDDEN = '_md-panel-hidden';
	var FOCUS_TRAP_TEMPLATE = angular.element(
	    '<div class="_md-panel-focus-trap" tabindex="0"></div>');
	
	var _presets = {};
	
	
	/**
	 * A provider that is used for creating presets for the panel API.
	 * @final @constructor @ngInject
	 */
	function MdPanelProvider() {
	  return {
	    'definePreset': definePreset,
	    'getAllPresets': getAllPresets,
	    'clearPresets': clearPresets,
	    '$get': $getProvider()
	  };
	}
	
	
	/**
	 * Takes the passed in panel configuration object and adds it to the `_presets`
	 * object at the specified name.
	 * @param {string} name Name of the preset to set.
	 * @param {!Object} preset Specific configuration object that can contain any
	 *     and all of the parameters available within the `$mdPanel.create` method.
	 *     However, parameters that pertain to id, position, animation, and user
	 *     interaction are not allowed and will be removed from the preset
	 *     configuration.
	 */
	function definePreset(name, preset) {
	  if (!name || !preset) {
	    throw new Error('mdPanelProvider: The panel preset definition is ' +
	        'malformed. The name and preset object are required.');
	  } else if (_presets.hasOwnProperty(name)) {
	    throw new Error('mdPanelProvider: The panel preset you have requested ' +
	        'has already been defined.');
	  }
	
	  // Delete any property on the preset that is not allowed.
	  delete preset.id;
	  delete preset.position;
	  delete preset.animation;
	
	  _presets[name] = preset;
	}
	
	
	/**
	 * Gets a clone of the `_presets`.
	 * @return {!Object}
	 */
	function getAllPresets() {
	  return angular.copy(_presets);
	}
	
	
	/**
	 * Clears all of the stored presets.
	 */
	function clearPresets() {
	  _presets = {};
	}
	
	
	/**
	 * Represents the `$get` method of the AngularJS provider. From here, a new
	 * reference to the MdPanelService is returned where the needed arguments are
	 * passed in including the MdPanelProvider `_presets`.
	 * @param {!Object} _presets
	 * @param {!JQLite} $rootElement
	 * @param {!angular.Scope} $rootScope
	 * @param {!IInjectorService} $injector
	 * @param {!IWindowService} $window
	 */
	function $getProvider() {
	  return [
	    '$rootElement', '$rootScope', '$injector', '$window',
	    function($rootElement, $rootScope, $injector, $window) {
	      return new MdPanelService(_presets, $rootElement, $rootScope,
	          $injector, $window);
	    }
	  ];
	}
	
	
	/*****************************************************************************
	 *                               MdPanel Service                             *
	 *****************************************************************************/
	
	
	/**
	 * A service that is used for controlling/displaying panels on the screen.
	 * @param {!Object} presets
	 * @param {!JQLite} $rootElement
	 * @param {!angular.Scope} $rootScope
	 * @param {!IInjectorService} $injector
	 * @param {!IWindowService} $window
	 * @final @constructor @ngInject
	 */
	function MdPanelService(presets, $rootElement, $rootScope, $injector, $window) {
	  /**
	   * Default config options for the panel.
	   * Anything angular related needs to be done later. Therefore
	   *     scope: $rootScope.$new(true),
	   *     attachTo: $rootElement,
	   * are added later.
	   * @private {!Object}
	   */
	  this._defaultConfigOptions = {
	    bindToController: true,
	    clickOutsideToClose: false,
	    disableParentScroll: false,
	    escapeToClose: false,
	    focusOnOpen: true,
	    fullscreen: false,
	    hasBackdrop: false,
	    propagateContainerEvents: false,
	    transformTemplate: angular.bind(this, this._wrapTemplate),
	    trapFocus: false,
	    zIndex: MD_PANEL_Z_INDEX
	  };
	
	  /** @private {!Object} */
	  this._config = {};
	
	  /** @private {!Object} */
	  this._presets = presets;
	
	  /** @private @const */
	  this._$rootElement = $rootElement;
	
	  /** @private @const */
	  this._$rootScope = $rootScope;
	
	  /** @private @const */
	  this._$injector = $injector;
	
	  /** @private @const */
	  this._$window = $window;
	
	  /** @private @const */
	  this._$mdUtil = this._$injector.get('$mdUtil');
	
	  /** @private {!Object<string, !MdPanelRef>} */
	  this._trackedPanels = {};
	
	  /**
	   * @private {!Object<string,
	   *     {panels: !Array<!MdPanelRef>,
	   *     openPanels: !Array<!MdPanelRef>,
	   *     maxOpen: number}>}
	   */
	  this._groups = Object.create(null);
	
	  /**
	   * Default animations that can be used within the panel.
	   * @type {enum}
	   */
	  this.animation = MdPanelAnimation.animation;
	
	  /**
	   * Possible values of xPosition for positioning the panel relative to
	   * another element.
	   * @type {enum}
	   */
	  this.xPosition = MdPanelPosition.xPosition;
	
	  /**
	   * Possible values of yPosition for positioning the panel relative to
	   * another element.
	   * @type {enum}
	   */
	  this.yPosition = MdPanelPosition.yPosition;
	
	  /**
	   * Possible values for the interceptors that can be registered on a panel.
	   * @type {enum}
	   */
	  this.interceptorTypes = MdPanelRef.interceptorTypes;
	
	  /**
	   * Possible values for closing of a panel.
	   * @type {enum}
	   */
	  this.closeReasons = MdPanelRef.closeReasons;
	
	  /**
	   * Possible values of absolute position.
	   * @type {enum}
	   */
	  this.absPosition = MdPanelPosition.absPosition;
	}
	
	
	/**
	 * Creates a panel with the specified options.
	 * @param {string|Object=} preset Name of a preset configuration that can be used to
	 *     extend the panel configuration.
	 * @param {!Object=} config Configuration object for the panel.
	 * @returns {!MdPanelRef}
	 */
	MdPanelService.prototype.create = function(preset, config) {
	  if (typeof preset === 'string') {
	    preset = this._getPresetByName(preset);
	  } else if (typeof preset === 'object' &&
	      (angular.isUndefined(config) || !config)) {
	    config = preset;
	    preset = {};
	  }
	
	  preset = preset || {};
	  config = config || {};
	
	  // If the passed-in config contains an ID and the ID is within _trackedPanels,
	  // return the tracked panel after updating its config with the passed-in
	  // config.
	  if (angular.isDefined(config.id) && this._trackedPanels[config.id]) {
	    var trackedPanel = this._trackedPanels[config.id];
	    angular.extend(trackedPanel.config, config);
	    return trackedPanel;
	  }
	
	  // Combine the passed-in config, the _defaultConfigOptions, and the preset
	  // configuration into the `_config`.
	  this._config = angular.extend({
	    // If no ID is set within the passed-in config, then create an arbitrary ID.
	    id: config.id || 'panel_' + this._$mdUtil.nextUid(),
	    scope: this._$rootScope.$new(true),
	    attachTo: this._$rootElement
	  }, this._defaultConfigOptions, config, preset);
	
	  // Create the panelRef and add it to the `_trackedPanels` object.
	  var panelRef = new MdPanelRef(this._config, this._$injector);
	  this._trackedPanels[this._config.id] = panelRef;
	
	  // Add the panel to each of its requested groups.
	  if (this._config.groupName) {
	    if (angular.isString(this._config.groupName)) {
	      this._config.groupName = [this._config.groupName];
	    }
	    angular.forEach(this._config.groupName, function(group) {
	      panelRef.addToGroup(group);
	    });
	  }
	
	  this._config.scope.$on('$destroy', angular.bind(panelRef, panelRef.detach));
	
	  return panelRef;
	};
	
	
	/**
	 * Creates and opens a panel with the specified options.
	 * @param {string=} preset Name of a preset configuration that can be used to
	 *     extend the panel configuration.
	 * @param {!Object=} config Configuration object for the panel.
	 * @returns {!Q.IPromise<!MdPanelRef>} The panel created from create.
	 */
	MdPanelService.prototype.open = function(preset, config) {
	  var panelRef = this.create(preset, config);
	  return panelRef.open().then(function() {
	    return panelRef;
	  });
	};
	
	
	/**
	 * Gets a specific preset configuration object saved within `_presets`.
	 * @param {string} preset Name of the preset to search for.
	 * @returns {!Object} The preset configuration object.
	 */
	MdPanelService.prototype._getPresetByName = function(preset) {
	  if (!this._presets[preset]) {
	    throw new Error('mdPanel: The panel preset configuration that you ' +
	        'requested does not exist. Use the $mdPanelProvider to create a ' +
	        'preset before requesting one.');
	  }
	  return this._presets[preset];
	};
	
	
	/**
	 * Returns a new instance of the MdPanelPosition. Use this to create the
	 * positioning object.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelService.prototype.newPanelPosition = function() {
	  return new MdPanelPosition(this._$injector);
	};
	
	
	/**
	 * Returns a new instance of the MdPanelAnimation. Use this to create the
	 * animation object.
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelService.prototype.newPanelAnimation = function() {
	  return new MdPanelAnimation(this._$injector);
	};
	
	
	/**
	 * Creates a panel group and adds it to a tracked list of panel groups.
	 * @param groupName {string} Name of the group to create.
	 * @param config {!Object=} Specific configuration object that may contain the
	 *     following properties:
	 *
	 *   - `maxOpen` - `{number=}`: The maximum number of panels that are allowed
	 *     open within a defined panel group.
	 *
	 * @returns {!Object<string,
	 *     {panels: !Array<!MdPanelRef>,
	 *     openPanels: !Array<!MdPanelRef>,
	 *     maxOpen: number}>} panelGroup
	 */
	MdPanelService.prototype.newPanelGroup = function(groupName, config) {
	  if (!this._groups[groupName]) {
	    config = config || {};
	    var group = {
	      panels: [],
	      openPanels: [],
	      maxOpen: config.maxOpen > 0 ? config.maxOpen : Infinity
	    };
	    this._groups[groupName] = group;
	  }
	  return this._groups[groupName];
	};
	
	
	/**
	 * Sets the maximum number of panels in a group that can be opened at a given
	 * time.
	 * @param {string} groupName The name of the group to configure.
	 * @param {number} maxOpen The maximum number of panels that can be
	 *     opened. Infinity can be passed in to remove the maxOpen limit.
	 */
	MdPanelService.prototype.setGroupMaxOpen = function(groupName, maxOpen) {
	  if (this._groups[groupName]) {
	    this._groups[groupName].maxOpen = maxOpen;
	  } else {
	    throw new Error('mdPanel: Group does not exist yet. Call newPanelGroup().');
	  }
	};
	
	
	/**
	 * Determines if the current number of open panels within a group exceeds the
	 * limit of allowed open panels.
	 * @param {string} groupName The name of the group to check.
	 * @returns {boolean} true if open count does exceed maxOpen and false if not.
	 * @private
	 */
	MdPanelService.prototype._openCountExceedsMaxOpen = function(groupName) {
	  if (this._groups[groupName]) {
	    var group = this._groups[groupName];
	    return group.maxOpen > 0 && group.openPanels.length > group.maxOpen;
	  }
	  return false;
	};
	
	
	/**
	 * Closes the first open panel within a specific group.
	 * @param {string} groupName The name of the group.
	 * @private
	 */
	MdPanelService.prototype._closeFirstOpenedPanel = function(groupName) {
	  this._groups[groupName].openPanels[0].close();
	};
	
	
	/**
	 * Wraps the user's template in three elements:
	 * - md-panel-outer-wrapper - covers the entire `attachTo` element.
	 * - md-panel-inner-wrapper - handles the positioning.
	 * - md-panel - contains the user's content and deals with the animations.
	 * @param {string} origTemplate The original template.
	 * @returns {string} The wrapped template.
	 * @private
	 */
	MdPanelService.prototype._wrapTemplate = function(origTemplate) {
	  var template = origTemplate || '';
	
	  // The panel should be initially rendered offscreen so we can calculate
	  // height and width for positioning.
	  return '' +
	      '<div class="md-panel-outer-wrapper">' +
	        '<div class="md-panel-inner-wrapper _md-panel-offscreen">' +
	          '<div class="md-panel _md-panel-offscreen">' + template + '</div>' +
	        '</div>' +
	      '</div>';
	};
	
	
	/**
	 * Wraps a content element in a `md-panel-outer-wrapper`, as well as
	 * a `md-panel-inner-wrapper`, and positions it off-screen. Allows for
	 * proper control over positioning and animations.
	 * @param {!JQLite} contentElement Element to be wrapped.
	 * @return {!JQLite} Wrapper element.
	 * @private
	 */
	MdPanelService.prototype._wrapContentElement = function(contentElement) {
	  var outerWrapper = angular.element(
	    '<div class="md-panel-outer-wrapper">' +
	      '<div class="md-panel-inner-wrapper _md-panel-offscreen"></div>' +
	    '</div>'
	  );
	
	  contentElement.addClass('md-panel _md-panel-offscreen');
	  outerWrapper.children().eq(0).append(contentElement);
	
	  return outerWrapper;
	};
	
	
	/*****************************************************************************
	 *                                 MdPanelRef                                *
	 *****************************************************************************/
	
	
	/**
	 * A reference to a created panel. This reference contains a unique id for the
	 * panel, along with properties/functions used to control the panel.
	 * @param {!Object} config
	 * @param {!IInjectorService} $injector
	 * @final @constructor
	 */
	function MdPanelRef(config, $injector) {
	  // Injected variables.
	  /** @private @const {!IQService} */
	  this._$q = $injector.get('$q');
	
	  /** @private @const {!angular.$mdCompiler} */
	  this._$mdCompiler = $injector.get('$mdCompiler');
	
	  /** @private @const {!angular.$mdConstant} */
	  this._$mdConstant = $injector.get('$mdConstant');
	
	  /** @private @const {!angular.$mdUtil} */
	  this._$mdUtil = $injector.get('$mdUtil');
	
	  /** @private @const {!angular.$mdTheming} */
	  this._$mdTheming = $injector.get('$mdTheming');
	
	  /** @private @const {!IRootScopeService} */
	  this._$rootScope = $injector.get('$rootScope');
	
	  /** @private @const {!angular.$animate} */
	  this._$animate = $injector.get('$animate');
	
	  /** @private @const {!MdPanelRef} */
	  this._$mdPanel = $injector.get('$mdPanel');
	
	  /** @private @const {!ILogService} */
	  this._$log = $injector.get('$log');
	
	  /** @private @const {!IWindowService} */
	  this._$window = $injector.get('$window');
	
	  /** @private @const {!Function} */
	  this._$$rAF = $injector.get('$$rAF');
	
	  // Public variables.
	  /**
	   * Unique id for the panelRef.
	   * @type {string}
	   */
	  this.id = config.id;
	
	  /** @type {!Object} */
	  this.config = config;
	
	  /** @type {!JQLite|undefined} */
	  this.panelContainer = undefined;
	
	  /** @type {!JQLite|undefined} */
	  this.panelEl = undefined;
	
	  /** @type {!JQLite|undefined} */
	  this.innerWrapper = undefined;
	
	  /**
	   * Whether the panel is attached. This is synchronous. When attach is called,
	   * isAttached is set to true. When detach is called, isAttached is set to
	   * false.
	   * @type {boolean}
	   */
	  this.isAttached = false;
	
	  // Private variables.
	  /** @private {Array<function()>} */
	  this._removeListeners = [];
	
	  /** @private {!JQLite|undefined} */
	  this._topFocusTrap = undefined;
	
	  /** @private {!JQLite|undefined} */
	  this._bottomFocusTrap = undefined;
	
	  /** @private {!$mdPanel|undefined} */
	  this._backdropRef = undefined;
	
	  /** @private {Function?} */
	  this._restoreScroll = null;
	
	  /**
	   * Keeps track of all the panel interceptors.
	   * @private {!Object}
	   */
	  this._interceptors = Object.create(null);
	
	  /**
	   * Cleanup function, provided by `$mdCompiler` and assigned after the element
	   * has been compiled. When `contentElement` is used, the function is used to
	   * restore the element to it's proper place in the DOM.
	   * @private {Function|null}
	   */
	  this._compilerCleanup = null;
	
	  /**
	   * Cache for saving and restoring element inline styles, CSS classes etc.
	   * @type {{styles: string, classes: string}}
	   */
	  this._restoreCache = {
	    styles: '',
	    classes: ''
	  };
	}
	
	
	MdPanelRef.interceptorTypes = {
	  CLOSE: 'onClose'
	};
	
	
	/**
	 * Opens an already created and configured panel. If the panel is already
	 * visible, does nothing.
	 * @returns {!Q.IPromise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is opened and animations finish.
	 */
	MdPanelRef.prototype.open = function() {
	  var self = this;
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var show = self._simpleBind(self.show, self);
	    var checkGroupMaxOpen = function() {
	      if (self.config.groupName) {
	        angular.forEach(self.config.groupName, function(group) {
	          if (self._$mdPanel._openCountExceedsMaxOpen(group)) {
	            self._$mdPanel._closeFirstOpenedPanel(group);
	          }
	        });
	      }
	    };
	
	    self.attach()
	        .then(show)
	        .then(checkGroupMaxOpen)
	        .then(done)
	        .catch(reject);
	  });
	};
	
	
	/**
	 * Closes the panel.
	 * @param {string} closeReason The event type that triggered the close.
	 * @returns {!Q.IPromise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is closed and animations finish.
	 */
	MdPanelRef.prototype.close = function(closeReason) {
	  var self = this;
	
	  return this._$q(function(resolve, reject) {
	    self._callInterceptors(MdPanelRef.interceptorTypes.CLOSE).then(function() {
	      var done = self._done(resolve, self);
	      var detach = self._simpleBind(self.detach, self);
	      var onCloseSuccess = self.config['onCloseSuccess'] || angular.noop;
	      onCloseSuccess = angular.bind(self, onCloseSuccess, self, closeReason);
	
	      self.hide()
	          .then(detach)
	          .then(done)
	          .then(onCloseSuccess)
	          .catch(reject);
	    }, reject);
	  });
	};
	
	
	/**
	 * Attaches the panel. The panel will be hidden afterwards.
	 * @returns {!Q.IPromise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is attached.
	 */
	MdPanelRef.prototype.attach = function() {
	  if (this.isAttached && this.panelEl) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var onDomAdded = self.config['onDomAdded'] || angular.noop;
	    var addListeners = function(response) {
	      self.isAttached = true;
	      self._addEventListeners();
	      return response;
	    };
	
	    self._$q.all([
	        self._createBackdrop(),
	        self._createPanel()
	            .then(addListeners)
	            .catch(reject)
	    ]).then(onDomAdded)
	      .then(done)
	      .catch(reject);
	  });
	};
	
	
	/**
	 * Only detaches the panel. Will NOT hide the panel first.
	 * @returns {!Q.IPromise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is detached.
	 */
	MdPanelRef.prototype.detach = function() {
	  if (!this.isAttached) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  var onDomRemoved = self.config['onDomRemoved'] || angular.noop;
	
	  var detachFn = function() {
	    self._removeEventListeners();
	
	    // Remove the focus traps that we added earlier for keeping focus within
	    // the panel.
	    if (self._topFocusTrap && self._topFocusTrap.parentNode) {
	      self._topFocusTrap.parentNode.removeChild(self._topFocusTrap);
	    }
	
	    if (self._bottomFocusTrap && self._bottomFocusTrap.parentNode) {
	      self._bottomFocusTrap.parentNode.removeChild(self._bottomFocusTrap);
	    }
	
	    if (self._restoreCache.classes) {
	      self.panelEl[0].className = self._restoreCache.classes;
	    }
	
	    // Either restore the saved styles or clear the ones set by mdPanel.
	    self.panelEl[0].style.cssText = self._restoreCache.styles || '';
	
	    self._compilerCleanup();
	    self.panelContainer.remove();
	    self.isAttached = false;
	    return self._$q.when(self);
	  };
	
	  if (this._restoreScroll) {
	    this._restoreScroll();
	    this._restoreScroll = null;
	  }
	
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	
	    self._$q.all([
	      detachFn(),
	      self._backdropRef ? self._backdropRef.detach() : true
	    ]).then(onDomRemoved)
	      .then(done)
	      .catch(reject);
	  });
	};
	
	
	/**
	 * Destroys the panel. The Panel cannot be opened again after this.
	 */
	MdPanelRef.prototype.destroy = function() {
	  var self = this;
	  if (this.config.groupName) {
	    angular.forEach(this.config.groupName, function(group) {
	      self.removeFromGroup(group);
	    });
	  }
	  this.config.scope.$destroy();
	  this.config.locals = null;
	  this.config.onDomAdded = null;
	  this.config.onDomRemoved = null;
	  this.config.onRemoving = null;
	  this.config.onOpenComplete = null;
	  this._interceptors = undefined;
	};
	
	
	/**
	 * Shows the panel.
	 * @returns {!Q.IPromise<!MdPanelRef>} A promise that is resolved when
	 *     the panel has shown and animations finish.
	 */
	MdPanelRef.prototype.show = function() {
	  if (!this.panelContainer) {
	    return this._$q(function(resolve, reject) {
	      reject('mdPanel: Panel does not exist yet. Call open() or attach().');
	    });
	  }
	
	  if (!this.panelContainer.hasClass(MD_PANEL_HIDDEN)) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  var animatePromise = function() {
	    self.panelContainer.removeClass(MD_PANEL_HIDDEN);
	    return self._animateOpen();
	  };
	
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var onOpenComplete = self.config['onOpenComplete'] || angular.noop;
	    var addToGroupOpen = function() {
	      if (self.config.groupName) {
	        angular.forEach(self.config.groupName, function(group) {
	          self._$mdPanel._groups[group].openPanels.push(self);
	        });
	      }
	    };
	
	    self._$q.all([
	      self._backdropRef ? self._backdropRef.show() : self,
	      animatePromise().then(function() { self._focusOnOpen(); }, reject)
	    ]).then(onOpenComplete)
	      .then(addToGroupOpen)
	      .then(done)
	      .catch(reject);
	  });
	};
	
	
	/**
	 * Hides the panel.
	 * @returns {!Q.IPromise<!MdPanelRef>} A promise that is resolved when
	 *     the panel has hidden and animations finish.
	 */
	MdPanelRef.prototype.hide = function() {
	  if (!this.panelContainer) {
	    return this._$q(function(resolve, reject) {
	      reject('mdPanel: Panel does not exist yet. Call open() or attach().');
	    });
	  }
	
	  if (this.panelContainer.hasClass(MD_PANEL_HIDDEN)) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var onRemoving = self.config['onRemoving'] || angular.noop;
	    var hidePanel = function() {
	      self.panelContainer.addClass(MD_PANEL_HIDDEN);
	    };
	    var removeFromGroupOpen = function() {
	      if (self.config.groupName) {
	        var index;
	        angular.forEach(self.config.groupName, function(group) {
	          group = self._$mdPanel._groups[group];
	          index = group.openPanels.indexOf(self);
	          if (index > -1) {
	            group.openPanels.splice(index, 1);
	          }
	        });
	      }
	    };
	    var focusOnOrigin = function() {
	      var origin = self.config['origin'];
	      if (origin) {
	        getElement(origin).focus();
	      }
	    };
	
	    self._$q.all([
	      self._backdropRef ? self._backdropRef.hide() : self,
	      self._animateClose()
	          .then(onRemoving)
	          .then(hidePanel)
	          .then(removeFromGroupOpen)
	          .then(focusOnOrigin)
	          .catch(reject)
	    ]).then(done, reject);
	  });
	};
	
	
	/**
	 * Add a class to the panel. DO NOT use this to hide/show the panel.
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 *
	 * @param {string} newClass Class to be added.
	 * @param {boolean} toElement Whether or not to add the class to the panel
	 *     element instead of the container.
	 */
	MdPanelRef.prototype.addClass = function(newClass, toElement) {
	  this._$log.warn(
	      'mdPanel: The addClass method is in the process of being deprecated. ' +
	      'Full deprecation is scheduled for the AngularJS Material 1.2 release. ' +
	      'To achieve the same results, use the panelContainer or panelEl ' +
	      'JQLite elements that are referenced in MdPanelRef.');
	
	  if (!this.panelContainer) {
	    throw new Error(
	        'mdPanel: Panel does not exist yet. Call open() or attach().');
	  }
	
	  if (!toElement && !this.panelContainer.hasClass(newClass)) {
	    this.panelContainer.addClass(newClass);
	  } else if (toElement && !this.panelEl.hasClass(newClass)) {
	    this.panelEl.addClass(newClass);
	  }
	};
	
	
	/**
	 * Remove a class from the panel. DO NOT use this to hide/show the panel.
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 *
	 * @param {string} oldClass Class to be removed.
	 * @param {boolean} fromElement Whether or not to remove the class from the
	 *     panel element instead of the container.
	 */
	MdPanelRef.prototype.removeClass = function(oldClass, fromElement) {
	  this._$log.warn(
	      'mdPanel: The removeClass method is in the process of being deprecated. ' +
	      'Full deprecation is scheduled for the AngularJS Material 1.2 release. ' +
	      'To achieve the same results, use the panelContainer or panelEl ' +
	      'JQLite elements that are referenced in MdPanelRef.');
	
	  if (!this.panelContainer) {
	    throw new Error(
	        'mdPanel: Panel does not exist yet. Call open() or attach().');
	  }
	
	  if (!fromElement && this.panelContainer.hasClass(oldClass)) {
	    this.panelContainer.removeClass(oldClass);
	  } else if (fromElement && this.panelEl.hasClass(oldClass)) {
	    this.panelEl.removeClass(oldClass);
	  }
	};
	
	
	/**
	 * Toggle a class on the panel. DO NOT use this to hide/show the panel.
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 *
	 * @param {string} toggleClass The class to toggle.
	 * @param {boolean} onElement Whether or not to toggle the class on the panel
	 *     element instead of the container.
	 */
	MdPanelRef.prototype.toggleClass = function(toggleClass, onElement) {
	  this._$log.warn(
	      'mdPanel: The toggleClass method is in the process of being deprecated. ' +
	      'Full deprecation is scheduled for the AngularJS Material 1.2 release. ' +
	      'To achieve the same results, use the panelContainer or panelEl ' +
	      'JQLite elements that are referenced in MdPanelRef.');
	
	  if (!this.panelContainer) {
	    throw new Error(
	        'mdPanel: Panel does not exist yet. Call open() or attach().');
	  }
	
	  if (!onElement) {
	    this.panelContainer.toggleClass(toggleClass);
	  } else {
	    this.panelEl.toggleClass(toggleClass);
	  }
	};
	
	
	/**
	 * Compiles the panel, according to the passed in config and appends it to
	 * the DOM. Helps normalize differences in the compilation process between
	 * using a string template and a content element.
	 * @returns {!Q.IPromise<!MdPanelRef>} Promise that is resolved when
	 *     the element has been compiled and added to the DOM.
	 * @private
	 */
	MdPanelRef.prototype._compile = function() {
	  var self = this;
	
	  // Compile the element via $mdCompiler. Note that when using a
	  // contentElement, the element isn't actually being compiled, rather the
	  // compiler saves it's place in the DOM and provides a way of restoring it.
	  return self._$mdCompiler.compile(self.config).then(function(compileData) {
	    var config = self.config;
	
	    if (config.contentElement) {
	      var panelEl = compileData.element;
	
	      // Since mdPanel modifies the inline styles and CSS classes, we need
	      // to save them in order to be able to restore on close.
	      self._restoreCache.styles = panelEl[0].style.cssText;
	      self._restoreCache.classes = panelEl[0].className;
	
	      self.panelContainer = self._$mdPanel._wrapContentElement(panelEl);
	      self.panelEl = panelEl;
	    } else {
	      self.panelContainer = compileData.link(config['scope']);
	      self.panelEl = angular.element(
	        self.panelContainer[0].querySelector('.md-panel')
	      );
	    }
	
	    // Save a reference to the inner wrapper.
	    self.innerWrapper = angular.element(
	      self.panelContainer[0].querySelector('.md-panel-inner-wrapper')
	    );
	
	    // Save a reference to the cleanup function from the compiler.
	    self._compilerCleanup = compileData.cleanup;
	
	    // Attach the panel to the proper place in the DOM.
	    getElement(self.config['attachTo']).append(self.panelContainer);
	
	    return self;
	  });
	};
	
	
	/**
	 * Creates a panel and adds it to the dom.
	 * @returns {!Q.IPromise} A promise that is resolved when the panel is
	 *     created.
	 * @private
	 */
	MdPanelRef.prototype._createPanel = function() {
	  var self = this;
	
	  return this._$q(function(resolve, reject) {
	    if (!self.config.locals) {
	      self.config.locals = {};
	    }
	
	    self.config.locals.mdPanelRef = self;
	
	    self._compile().then(function() {
	      if (self.config['disableParentScroll']) {
	        self._restoreScroll = self._$mdUtil.disableScrollAround(
	          null,
	          self.panelContainer,
	          { disableScrollMask: true }
	        );
	      }
	
	      // Add a custom CSS class to the panel element.
	      if (self.config['panelClass']) {
	        self.panelEl.addClass(self.config['panelClass']);
	      }
	
	      // Handle click and touch events for the panel container.
	      if (self.config['propagateContainerEvents']) {
	        self.panelContainer.css('pointer-events', 'none');
	        self.panelEl.css('pointer-events', 'all');
	      }
	
	      // Panel may be outside the $rootElement, tell ngAnimate to animate
	      // regardless.
	      if (self._$animate.pin) {
	        self._$animate.pin(
	          self.panelContainer,
	          getElement(self.config['attachTo'])
	        );
	      }
	
	      self._configureTrapFocus();
	      self._addStyles().then(function() {
	        resolve(self);
	      }, reject);
	    }, reject);
	
	  });
	};
	
	
	/**
	 * Adds the styles for the panel, such as positioning and z-index. Also,
	 * themes the panel element and panel container using `$mdTheming`.
	 * @returns {!Q.IPromise<!MdPanelRef>}
	 * @private
	 */
	MdPanelRef.prototype._addStyles = function() {
	  var self = this;
	  return this._$q(function(resolve) {
	    self.panelContainer.css('z-index', self.config['zIndex']);
	    self.innerWrapper.css('z-index', self.config['zIndex'] + 1);
	
	    var hideAndResolve = function() {
	      // Theme the element and container.
	      self._setTheming();
	
	      // Remove offscreen classes and add hidden class.
	      self.panelEl.removeClass('_md-panel-offscreen');
	      self.innerWrapper.removeClass('_md-panel-offscreen');
	      self.panelContainer.addClass(MD_PANEL_HIDDEN);
	
	      resolve(self);
	    };
	
	    if (self.config['fullscreen']) {
	      self.panelEl.addClass('_md-panel-fullscreen');
	      hideAndResolve();
	      return; // Don't setup positioning.
	    }
	
	    var positionConfig = self.config['position'];
	    if (!positionConfig) {
	      hideAndResolve();
	      return; // Don't setup positioning.
	    }
	
	    // Wait for angular to finish processing the template
	    self._$rootScope['$$postDigest'](function() {
	      // Position it correctly. This is necessary so that the panel will have a
	      // defined height and width.
	      self._updatePosition(true);
	
	      // Theme the element and container.
	      self._setTheming();
	
	      resolve(self);
	    });
	  });
	};
	
	
	/**
	 * Sets the `$mdTheming` classes on the `panelContainer` and `panelEl`.
	 * @private
	 */
	MdPanelRef.prototype._setTheming = function() {
	  this._$mdTheming(this.panelEl);
	  this._$mdTheming(this.panelContainer);
	};
	
	
	/**
	 * Updates the position configuration of a panel
	 * @param {!MdPanelPosition} position
	 */
	MdPanelRef.prototype.updatePosition = function(position) {
	  if (!this.panelContainer) {
	    throw new Error(
	        'mdPanel: Panel does not exist yet. Call open() or attach().');
	  }
	
	  this.config['position'] = position;
	  this._updatePosition();
	};
	
	
	/**
	 * Calculates and updates the position of the panel.
	 * @param {boolean=} init
	 * @private
	 */
	MdPanelRef.prototype._updatePosition = function(init) {
	  var positionConfig = this.config['position'];
	
	  if (positionConfig) {
	    positionConfig._setPanelPosition(this.innerWrapper);
	
	    // Hide the panel now that position is known.
	    if (init) {
	      this.panelEl.removeClass('_md-panel-offscreen');
	      this.innerWrapper.removeClass('_md-panel-offscreen');
	      this.panelContainer.addClass(MD_PANEL_HIDDEN);
	    }
	
	    this.innerWrapper.css(
	      MdPanelPosition.absPosition.TOP,
	      positionConfig.getTop()
	    );
	    this.innerWrapper.css(
	      MdPanelPosition.absPosition.BOTTOM,
	      positionConfig.getBottom()
	    );
	    this.innerWrapper.css(
	      MdPanelPosition.absPosition.LEFT,
	      positionConfig.getLeft()
	    );
	    this.innerWrapper.css(
	      MdPanelPosition.absPosition.RIGHT,
	      positionConfig.getRight()
	    );
	  }
	};
	
	
	/**
	 * Focuses on the panel or the first focus target.
	 * @private
	 */
	MdPanelRef.prototype._focusOnOpen = function() {
	  if (this.config['focusOnOpen']) {
	    // Wait for the template to finish rendering to guarantee md-autofocus has
	    // finished adding the class md-autofocus, otherwise the focusable element
	    // isn't available to focus.
	    var self = this;
	    this._$rootScope['$$postDigest'](function() {
	      var target = self._$mdUtil.findFocusTarget(self.panelEl) ||
	          self.panelEl;
	      target.focus();
	    });
	  }
	};
	
	
	/**
	 * Shows the backdrop.
	 * @returns {!Q.IPromise} A promise that is resolved when the backdrop
	 *     is created and attached.
	 * @private
	 */
	MdPanelRef.prototype._createBackdrop = function() {
	  if (this.config.hasBackdrop) {
	    if (!this._backdropRef) {
	      var backdropAnimation = this._$mdPanel.newPanelAnimation()
	          .openFrom(this.config.attachTo)
	          .withAnimation({
	            open: '_md-opaque-enter',
	            close: '_md-opaque-leave'
	          });
	
	      if (this.config.animation) {
	        backdropAnimation.duration(this.config.animation._rawDuration);
	      }
	
	      var backdropConfig = {
	        animation: backdropAnimation,
	        attachTo: this.config.attachTo,
	        focusOnOpen: false,
	        panelClass: '_md-panel-backdrop',
	        zIndex: this.config.zIndex - 1
	      };
	
	      this._backdropRef = this._$mdPanel.create(backdropConfig);
	    }
	    if (!this._backdropRef.isAttached) {
	      return this._backdropRef.attach();
	    }
	  }
	};
	
	
	/**
	 * Listen for escape keys and outside clicks to auto close.
	 * @private
	 */
	MdPanelRef.prototype._addEventListeners = function() {
	  this._configureEscapeToClose();
	  this._configureClickOutsideToClose();
	  this._configureScrollListener();
	};
	
	
	/**
	 * Remove event listeners added in _addEventListeners.
	 * @private
	 */
	MdPanelRef.prototype._removeEventListeners = function() {
	  this._removeListeners && this._removeListeners.forEach(function(removeFn) {
	    removeFn();
	  });
	  this._removeListeners = [];
	};
	
	
	/**
	 * Setup the escapeToClose event listeners.
	 * @private
	 */
	MdPanelRef.prototype._configureEscapeToClose = function() {
	  if (this.config['escapeToClose']) {
	    var parentTarget = getElement(this.config['attachTo']);
	    var self = this;
	
	    var keyHandlerFn = function(ev) {
	      if (ev.keyCode === self._$mdConstant.KEY_CODE.ESCAPE) {
	        ev.stopPropagation();
	        ev.preventDefault();
	
	        self.close(MdPanelRef.closeReasons.ESCAPE);
	      }
	    };
	
	    // Add keydown listeners
	    this.panelContainer.on('keydown', keyHandlerFn);
	    parentTarget.on('keydown', keyHandlerFn);
	
	    // Queue remove listeners function
	    this._removeListeners.push(function() {
	      self.panelContainer.off('keydown', keyHandlerFn);
	      parentTarget.off('keydown', keyHandlerFn);
	    });
	  }
	};
	
	
	/**
	 * Setup the clickOutsideToClose event listeners.
	 * @private
	 */
	MdPanelRef.prototype._configureClickOutsideToClose = function() {
	  if (this.config['clickOutsideToClose']) {
	    var target = this.config['propagateContainerEvents'] ?
	        angular.element(document.body) :
	        this.panelContainer;
	    var sourceEl;
	
	    // Keep track of the element on which the mouse originally went down
	    // so that we can only close the backdrop when the 'click' started on it.
	    // A simple 'click' handler does not work, it sets the target object as the
	    // element the mouse went down on.
	    var mousedownHandler = function(ev) {
	      sourceEl = ev.target;
	    };
	
	    // We check if our original element and the target is the backdrop
	    // because if the original was the backdrop and the target was inside the
	    // panel we don't want to panel to close.
	    var self = this;
	    var mouseupHandler = function(ev) {
	      if (self.config['propagateContainerEvents']) {
	
	        // We check if the sourceEl of the event is the panel element or one
	        // of it's children. If it is not, then close the panel.
	        if (sourceEl !== self.panelEl[0] && !self.panelEl[0].contains(sourceEl)) {
	          self.close();
	        }
	
	      } else if (sourceEl === target[0] && ev.target === target[0]) {
	        ev.stopPropagation();
	        ev.preventDefault();
	
	        self.close(MdPanelRef.closeReasons.CLICK_OUTSIDE);
	      }
	    };
	
	    // Add listeners
	    target.on('mousedown', mousedownHandler);
	    target.on('mouseup', mouseupHandler);
	
	    // Queue remove listeners function
	    this._removeListeners.push(function() {
	      target.off('mousedown', mousedownHandler);
	      target.off('mouseup', mouseupHandler);
	    });
	  }
	};
	
	
	/**
	 * Configures the listeners for updating the panel position on scroll.
	 * @private
	*/
	MdPanelRef.prototype._configureScrollListener = function() {
	  // No need to bind the event if scrolling is disabled.
	  if (!this.config['disableParentScroll']) {
	    var updatePosition = angular.bind(this, this._updatePosition);
	    var debouncedUpdatePosition = this._$$rAF.throttle(updatePosition);
	    var self = this;
	
	    var onScroll = function() {
	      debouncedUpdatePosition();
	    };
	
	    // Add listeners.
	    this._$window.addEventListener('scroll', onScroll, true);
	
	    // Queue remove listeners function.
	    this._removeListeners.push(function() {
	      self._$window.removeEventListener('scroll', onScroll, true);
	    });
	  }
	};
	
	
	/**
	 * Setup the focus traps. These traps will wrap focus when tabbing past the
	 * panel. When shift-tabbing, the focus will stick in place.
	 * @private
	 */
	MdPanelRef.prototype._configureTrapFocus = function() {
	  // Focus doesn't remain inside of the panel without this.
	  this.panelEl.attr('tabIndex', '-1');
	  if (this.config['trapFocus']) {
	    var element = this.panelEl;
	    // Set up elements before and after the panel to capture focus and
	    // redirect back into the panel.
	    this._topFocusTrap = FOCUS_TRAP_TEMPLATE.clone()[0];
	    this._bottomFocusTrap = FOCUS_TRAP_TEMPLATE.clone()[0];
	
	    // When focus is about to move out of the panel, we want to intercept it
	    // and redirect it back to the panel element.
	    var focusHandler = function() {
	      element.focus();
	    };
	    this._topFocusTrap.addEventListener('focus', focusHandler);
	    this._bottomFocusTrap.addEventListener('focus', focusHandler);
	
	    // Queue remove listeners function
	    this._removeListeners.push(this._simpleBind(function() {
	      this._topFocusTrap.removeEventListener('focus', focusHandler);
	      this._bottomFocusTrap.removeEventListener('focus', focusHandler);
	    }, this));
	
	    // The top focus trap inserted immediately before the md-panel element (as
	    // a sibling). The bottom focus trap inserted immediately after the
	    // md-panel element (as a sibling).
	    element[0].parentNode.insertBefore(this._topFocusTrap, element[0]);
	    element.after(this._bottomFocusTrap);
	  }
	};
	
	
	/**
	 * Updates the animation of a panel.
	 * @param {!MdPanelAnimation} animation
	 */
	MdPanelRef.prototype.updateAnimation = function(animation) {
	  this.config['animation'] = animation;
	
	  if (this._backdropRef) {
	    this._backdropRef.config.animation.duration(animation._rawDuration);
	  }
	};
	
	
	/**
	 * Animate the panel opening.
	 * @returns {!Q.IPromise} A promise that is resolved when the panel has
	 *     animated open.
	 * @private
	 */
	MdPanelRef.prototype._animateOpen = function() {
	  this.panelContainer.addClass('md-panel-is-showing');
	  var animationConfig = this.config['animation'];
	  if (!animationConfig) {
	    // Promise is in progress, return it.
	    this.panelContainer.addClass('_md-panel-shown');
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  return this._$q(function(resolve) {
	    var done = self._done(resolve, self);
	    var warnAndOpen = function() {
	      self._$log.warn(
	          'mdPanel: MdPanel Animations failed. ' +
	          'Showing panel without animating.');
	      done();
	    };
	
	    animationConfig.animateOpen(self.panelEl)
	        .then(done, warnAndOpen);
	  });
	};
	
	
	/**
	 * Animate the panel closing.
	 * @returns {!Q.IPromise} A promise that is resolved when the panel has animated closed.
	 * @private
	 */
	MdPanelRef.prototype._animateClose = function() {
	  var self = this;
	  var animationConfig = this.config['animation'];
	
	  if (!animationConfig) {
	    this.panelContainer.removeClass('md-panel-is-showing');
	    this.panelContainer.removeClass('_md-panel-shown');
	    return this._$q.when(this);
	  } else {
	    return this._$q(function (resolve) {
	      var done = function () {
	        self.panelContainer.removeClass('md-panel-is-showing');
	        // Remove the transform so that re-used panels don't accumulate transforms.
	        self.panelEl.css('transform', '');
	        resolve(self);
	      };
	      var warnAndClose = function () {
	        self._$log.warn(
	          'mdPanel: MdPanel Animations failed. Hiding panel without animating.');
	        done();
	      };
	
	      animationConfig.animateClose(self.panelEl).then(done, warnAndClose);
	    });
	  }
	};
	
	
	/**
	 * Registers a interceptor with the panel. The callback should return a promise,
	 * which will allow the action to continue when it gets resolved, or will
	 * prevent an action if it is rejected.
	 * @param {string} type Type of interceptor.
	 * @param {!Q.IPromise<!any>} callback Callback to be registered.
	 * @returns {!MdPanelRef}
	 */
	MdPanelRef.prototype.registerInterceptor = function(type, callback) {
	  var error = null;
	
	  if (!angular.isString(type)) {
	    error = 'Interceptor type must be a string, instead got ' + typeof type;
	  } else if (!angular.isFunction(callback)) {
	    error = 'Interceptor callback must be a function, instead got ' + typeof callback;
	  }
	
	  if (error) {
	    throw new Error('MdPanel: ' + error);
	  }
	
	  var interceptors = this._interceptors[type] = this._interceptors[type] || [];
	
	  if (interceptors.indexOf(callback) === -1) {
	    interceptors.push(callback);
	  }
	
	  return this;
	};
	
	
	/**
	 * Removes a registered interceptor.
	 * @param {string} type Type of interceptor to be removed.
	 * @param {Function} callback Interceptor to be removed.
	 * @returns {!MdPanelRef}
	 */
	MdPanelRef.prototype.removeInterceptor = function(type, callback) {
	  var index = this._interceptors[type] ?
	    this._interceptors[type].indexOf(callback) : -1;
	
	  if (index > -1) {
	    this._interceptors[type].splice(index, 1);
	  }
	
	  return this;
	};
	
	
	/**
	 * Removes all interceptors.
	 * @param {string=} type Type of interceptors to be removed.
	 *     If ommited, all interceptors types will be removed.
	 * @returns {!MdPanelRef}
	 */
	MdPanelRef.prototype.removeAllInterceptors = function(type) {
	  if (type) {
	    this._interceptors[type] = [];
	  } else {
	    this._interceptors = Object.create(null);
	  }
	
	  return this;
	};
	
	
	/**
	 * Invokes all the interceptors of a certain type sequantially in
	 *     reverse order. Works in a similar way to `$q.all`, except it
	 *     respects the order of the functions.
	 * @param {string} type Type of interceptors to be invoked.
	 * @returns {!Q.IPromise<!MdPanelRef>}
	 * @private
	 */
	MdPanelRef.prototype._callInterceptors = function(type) {
	  var self = this;
	  var $q = self._$q;
	  var interceptors = self._interceptors && self._interceptors[type] || [];
	
	  return interceptors.reduceRight(function(promise, interceptor) {
	    var isPromiseLike = interceptor && angular.isFunction(interceptor.then);
	    var response = isPromiseLike ? interceptor : null;
	
	    /**
	    * For interceptors to reject/cancel subsequent portions of the chain, simply
	    * return a `$q.reject(<value>)`
	    */
	    return promise.then(function() {
	      if (!response) {
	        try {
	          response = interceptor(self);
	        } catch (e) {
	          response = $q.reject(e);
	        }
	      }
	
	     return response;
	    });
	  }, $q.resolve(self));
	};
	
	
	/**
	 * Faster, more basic than angular.bind
	 * http://jsperf.com/angular-bind-vs-custom-vs-native
	 * @param {function} callback
	 * @param {!Object} self
	 * @return {function} Callback function with a bound self.
	 */
	MdPanelRef.prototype._simpleBind = function(callback, self) {
	  return function(value) {
	    return callback.apply(self, value);
	  };
	};
	
	
	/**
	 * @param {function|IQResolveReject} callback
	 * @param {!Object} self
	 * @return {function} Callback function with a self param.
	 */
	MdPanelRef.prototype._done = function(callback, self) {
	  return function() {
	    callback(self);
	  };
	};
	
	
	/**
	 * Adds a panel to a group if the panel does not exist within the group already.
	 * A panel can only exist within a single group.
	 * @param {string} groupName The name of the group.
	 */
	MdPanelRef.prototype.addToGroup = function(groupName) {
	  if (!this._$mdPanel._groups[groupName]) {
	    this._$mdPanel.newPanelGroup(groupName);
	  }
	
	  var group = this._$mdPanel._groups[groupName];
	  var index = group.panels.indexOf(this);
	
	  if (index < 0) {
	    group.panels.push(this);
	  }
	};
	
	
	/**
	 * Removes a panel from a group if the panel exists within that group. The group
	 * must be created ahead of time.
	 * @param {string} groupName The name of the group.
	 */
	MdPanelRef.prototype.removeFromGroup = function(groupName) {
	  if (!this._$mdPanel._groups[groupName]) {
	    throw new Error('mdPanel: The group ' + groupName + ' does not exist.');
	  }
	
	  var group = this._$mdPanel._groups[groupName];
	  var index = group.panels.indexOf(this);
	
	  if (index > -1) {
	    group.panels.splice(index, 1);
	  }
	};
	
	
	/**
	 * Possible default closeReasons for the close function.
	 * @enum {string}
	 */
	MdPanelRef.closeReasons = {
	  CLICK_OUTSIDE: 'clickOutsideToClose',
	  ESCAPE: 'escapeToClose',
	};
	
	
	/*****************************************************************************
	 *                               MdPanelPosition                             *
	 *****************************************************************************/
	
	
	/**
	 * Position configuration object. To use, create an MdPanelPosition with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * Example:
	 *
	 * var panelPosition = new MdPanelPosition()
	 *     .relativeTo(myButtonEl)
	 *     .addPanelPosition(
	 *       $mdPanel.xPosition.CENTER,
	 *       $mdPanel.yPosition.ALIGN_TOPS
	 *     );
	 *
	 * $mdPanel.create({
	 *   position: panelPosition
	 * });
	 *
	 * @param {!IInjectorService} $injector
	 * @final @constructor
	 */
	function MdPanelPosition($injector) {
	  /** @private @const {!IWindowService} */
	  this._$window = $injector.get('$window');
	
	  /** @private {boolean} */
	  this._isRTL = $injector.get('$mdUtil').isRtl();
	
	  /** @private @const {!angular.$mdConstant} */
	  this._$mdConstant = $injector.get('$mdConstant');
	
	  /** @private {boolean} */
	  this._absolute = false;
	
	  /** @private {!JQLite} */
	  this._relativeToEl = undefined;
	
	  /** @private {string} */
	  this._top = '';
	
	  /** @private {string} */
	  this._bottom = '';
	
	  /** @private {string} */
	  this._left = '';
	
	  /** @private {string} */
	  this._right = '';
	
	  /** @private {!Array<string>} */
	  this._translateX = [];
	
	  /** @private {!Array<string>} */
	  this._translateY = [];
	
	  /** @private {!Array<{x:string, y:string}>} */
	  this._positions = [];
	
	  /** @private {?{x:string, y:string}} */
	  this._actualPosition = undefined;
	}
	
	
	/**
	 * Possible values of xPosition.
	 * @enum {string}
	 */
	MdPanelPosition.xPosition = {
	  CENTER: 'center',
	  ALIGN_START: 'align-start',
	  ALIGN_END: 'align-end',
	  OFFSET_START: 'offset-start',
	  OFFSET_END: 'offset-end'
	};
	
	
	/**
	 * Possible values of yPosition.
	 * @enum {string}
	 */
	MdPanelPosition.yPosition = {
	  CENTER: 'center',
	  ALIGN_TOPS: 'align-tops',
	  ALIGN_BOTTOMS: 'align-bottoms',
	  ABOVE: 'above',
	  BELOW: 'below'
	};
	
	
	/**
	 * Possible values of absolute position.
	 * @enum {string}
	 */
	MdPanelPosition.absPosition = {
	  TOP: 'top',
	  RIGHT: 'right',
	  BOTTOM: 'bottom',
	  LEFT: 'left'
	};
	
	/**
	 * Margin between the edges of a panel and the viewport.
	 * @const {number}
	 */
	MdPanelPosition.viewportMargin = 8;
	
	
	/**
	 * Sets absolute positioning for the panel.
	 * @return {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.absolute = function() {
	  this._absolute = true;
	  return this;
	};
	
	
	/**
	 * Sets the value of a position for the panel. Clears any previously set
	 * position.
	 * @param {string} position Position to set
	 * @param {string=} value Value of the position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 * @private
	 */
	MdPanelPosition.prototype._setPosition = function(position, value) {
	  if (position === MdPanelPosition.absPosition.RIGHT ||
	      position === MdPanelPosition.absPosition.LEFT) {
	    this._left = this._right = '';
	  } else if (
	      position === MdPanelPosition.absPosition.BOTTOM ||
	      position === MdPanelPosition.absPosition.TOP) {
	    this._top = this._bottom = '';
	  } else {
	    var positions = Object.keys(MdPanelPosition.absPosition).join()
	        .toLowerCase();
	
	    throw new Error('mdPanel: Position must be one of ' + positions + '.');
	  }
	
	  this['_' +  position] = angular.isString(value) ? value : '0';
	
	  return this;
	};
	
	
	/**
	 * Sets the value of `top` for the panel. Clears any previously set vertical
	 * position.
	 * @param {string=} top Value of `top`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.top = function(top) {
	  return this._setPosition(MdPanelPosition.absPosition.TOP, top);
	};
	
	
	/**
	 * Sets the value of `bottom` for the panel. Clears any previously set vertical
	 * position.
	 * @param {string=} bottom Value of `bottom`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.bottom = function(bottom) {
	  return this._setPosition(MdPanelPosition.absPosition.BOTTOM, bottom);
	};
	
	
	/**
	 * Sets the panel to the start of the page - `left` if `ltr` or `right` for
	 * `rtl`. Clears any previously set horizontal position.
	 * @param {string=} start Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.start = function(start) {
	  var position = this._isRTL ? MdPanelPosition.absPosition.RIGHT : MdPanelPosition.absPosition.LEFT;
	  return this._setPosition(position, start);
	};
	
	
	/**
	 * Sets the panel to the end of the page - `right` if `ltr` or `left` for `rtl`.
	 * Clears any previously set horizontal position.
	 * @param {string=} end Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.end = function(end) {
	  var position = this._isRTL ? MdPanelPosition.absPosition.LEFT : MdPanelPosition.absPosition.RIGHT;
	  return this._setPosition(position, end);
	};
	
	
	/**
	 * Sets the value of `left` for the panel. Clears any previously set
	 * horizontal position.
	 * @param {string=} left Value of `left`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.left = function(left) {
	  return this._setPosition(MdPanelPosition.absPosition.LEFT, left);
	};
	
	
	/**
	 * Sets the value of `right` for the panel. Clears any previously set
	 * horizontal position.
	 * @param {string=} right Value of `right`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	*/
	MdPanelPosition.prototype.right = function(right) {
	  return this._setPosition(MdPanelPosition.absPosition.RIGHT, right);
	};
	
	
	/**
	 * Centers the panel horizontally in the viewport. Clears any previously set
	 * horizontal position.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.centerHorizontally = function() {
	  this._left = '50%';
	  this._right = '';
	  this._translateX = ['-50%'];
	  return this;
	};
	
	
	/**
	 * Centers the panel vertically in the viewport. Clears any previously set
	 * vertical position.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.centerVertically = function() {
	  this._top = '50%';
	  this._bottom = '';
	  this._translateY = ['-50%'];
	  return this;
	};
	
	
	/**
	 * Centers the panel horizontally and vertically in the viewport. This is
	 * equivalent to calling both `centerHorizontally` and `centerVertically`.
	 * Clears any previously set horizontal and vertical positions.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.center = function() {
	  return this.centerHorizontally().centerVertically();
	};
	
	
	/**
	 * Sets element for relative positioning.
	 * @param {string|!Element|!JQLite} element Query selector, DOM element,
	 *     or angular element to set the panel relative to.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.relativeTo = function(element) {
	  this._absolute = false;
	  this._relativeToEl = getElement(element);
	  return this;
	};
	
	
	/**
	 * Sets the x and y positions for the panel relative to another element.
	 * @param {string} xPosition must be one of the MdPanelPosition.xPosition
	 *     values.
	 * @param {string} yPosition must be one of the MdPanelPosition.yPosition
	 *     values.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.addPanelPosition = function(xPosition, yPosition) {
	  if (!this._relativeToEl) {
	    throw new Error('mdPanel: addPanelPosition can only be used with ' +
	        'relative positioning. Set relativeTo first.');
	  }
	
	  validatePosition(MdPanelPosition.xPosition, xPosition);
	  validatePosition(MdPanelPosition.yPosition, yPosition);
	
	  this._positions.push({
	    x: xPosition,
	    y: yPosition
	  });
	
	  return this;
	};
	
	
	/**
	 * Sets the value of the offset in the x-direction. This will add to any
	 * previously set offsets.
	 * @param {string|number|function(MdPanelPosition): string} offsetX
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.withOffsetX = function(offsetX) {
	  this._translateX.push(addUnits(offsetX));
	  return this;
	};
	
	
	/**
	 * Sets the value of the offset in the y-direction. This will add to any
	 * previously set offsets.
	 * @param {string|number|function(MdPanelPosition): string} offsetY
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.withOffsetY = function(offsetY) {
	  this._translateY.push(addUnits(offsetY));
	  return this;
	};
	
	
	/**
	 * Gets the value of `top` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getTop = function() {
	  return this._top;
	};
	
	
	/**
	 * Gets the value of `bottom` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getBottom = function() {
	  return this._bottom;
	};
	
	
	/**
	 * Gets the value of `left` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getLeft = function() {
	  return this._left;
	};
	
	
	/**
	 * Gets the value of `right` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getRight = function() {
	  return this._right;
	};
	
	
	/**
	 * Gets the value of `transform` for the panel.
	 * @returns {string} representation of the translateX and translateY rules and values
	 */
	MdPanelPosition.prototype.getTransform = function() {
	  var translateX = this._reduceTranslateValues('translateX', this._translateX);
	  var translateY = this._reduceTranslateValues('translateY', this._translateY);
	
	  // It's important to trim the result, because the browser will ignore the set
	  // operation if the string contains only whitespace.
	  return (translateX + ' ' + translateY).trim();
	};
	
	
	/**
	 * Sets the `transform` value for an element.
	 * @param {!JQLite} el
	 * @returns {!JQLite}
	 * @private
	 */
	MdPanelPosition.prototype._setTransform = function(el) {
	  return el.css(this._$mdConstant.CSS.TRANSFORM, this.getTransform());
	};
	
	
	/**
	 * True if the panel is completely on-screen with this positioning; false
	 * otherwise.
	 * @param {!JQLite} el
	 * @return {boolean}
	 * @private
	 */
	MdPanelPosition.prototype._isOnscreen = function(el) {
	  // this works because we always use fixed positioning for the panel,
	  // which is relative to the viewport.
	  var left = parseInt(this.getLeft());
	  var top = parseInt(this.getTop());
	
	  if (this._translateX.length || this._translateY.length) {
	    var prefixedTransform = this._$mdConstant.CSS.TRANSFORM;
	    var offsets = getComputedTranslations(el, prefixedTransform);
	    left += offsets.x;
	    top += offsets.y;
	  }
	
	  var right = left + el[0].offsetWidth;
	  var bottom = top + el[0].offsetHeight;
	
	  return (left >= 0) &&
	    (top >= 0) &&
	    (bottom <= this._$window.innerHeight) &&
	    (right <= this._$window.innerWidth);
	};
	
	
	/**
	 * Gets the first x/y position that can fit on-screen.
	 * @returns {{x: string, y: string}}
	 */
	MdPanelPosition.prototype.getActualPosition = function() {
	  return this._actualPosition;
	};
	
	
	/**
	 * Reduces a list of translate values to a string that can be used within
	 * transform.
	 * @param {string} translateFn
	 * @param {!Array<string>} values
	 * @returns {string}
	 * @private
	 */
	MdPanelPosition.prototype._reduceTranslateValues =
	    function(translateFn, values) {
	      return values.map(function(translation) {
	        var translationValue = angular.isFunction(translation) ?
	            addUnits(translation(this)) : translation;
	        return translateFn + '(' + translationValue + ')';
	      }, this).join(' ');
	    };
	
	
	/**
	 * Sets the panel position based on the created panel element and best x/y
	 * positioning.
	 * @param {!JQLite} el
	 * @private
	 */
	MdPanelPosition.prototype._setPanelPosition = function(el) {
	  // Remove the class in case it has been added before.
	  el.removeClass('_md-panel-position-adjusted');
	
	  // Only calculate the position if necessary.
	  if (this._absolute) {
	    this._setTransform(el);
	    return;
	  }
	
	  if (this._actualPosition) {
	    this._calculatePanelPosition(el, this._actualPosition);
	    this._setTransform(el);
	    this._constrainToViewport(el);
	    return;
	  }
	
	  for (var i = 0; i < this._positions.length; i++) {
	    this._actualPosition = this._positions[i];
	    this._calculatePanelPosition(el, this._actualPosition);
	    this._setTransform(el);
	
	    if (this._isOnscreen(el)) {
	      return;
	    }
	  }
	
	  this._constrainToViewport(el);
	};
	
	
	/**
	 * Constrains a panel's position to the viewport.
	 * @param {!JQLite} el
	 * @private
	 */
	MdPanelPosition.prototype._constrainToViewport = function(el) {
	  var margin = MdPanelPosition.viewportMargin;
	  var initialTop = this._top;
	  var initialLeft = this._left;
	
	  if (this.getTop()) {
	    var top = parseInt(this.getTop());
	    var bottom = el[0].offsetHeight + top;
	    var viewportHeight = this._$window.innerHeight;
	
	    if (top < margin) {
	      this._top = margin + 'px';
	    } else if (bottom > viewportHeight) {
	      this._top = top - (bottom - viewportHeight + margin) + 'px';
	    }
	  }
	
	  if (this.getLeft()) {
	    var left = parseInt(this.getLeft());
	    var right = el[0].offsetWidth + left;
	    var viewportWidth = this._$window.innerWidth;
	
	    if (left < margin) {
	      this._left = margin + 'px';
	    } else if (right > viewportWidth) {
	      this._left = left - (right - viewportWidth + margin) + 'px';
	    }
	  }
	
	  // Class that can be used to re-style the panel if it was repositioned.
	  el.toggleClass(
	    '_md-panel-position-adjusted',
	    this._top !== initialTop || this._left !== initialLeft
	  );
	};
	
	
	/**
	 * Switches between 'start' and 'end'.
	 * @param {string} position Horizontal position of the panel
	 * @returns {string} Reversed position
	 * @private
	 */
	MdPanelPosition.prototype._reverseXPosition = function(position) {
	  if (position === MdPanelPosition.xPosition.CENTER) {
	    return position;
	  }
	
	  var start = 'start';
	  var end = 'end';
	
	  return position.indexOf(start) > -1 ? position.replace(start, end) : position.replace(end, start);
	};
	
	
	/**
	 * Handles horizontal positioning in rtl or ltr environments.
	 * @param {string} position Horizontal position of the panel
	 * @returns {string} The correct position according the page direction
	 * @private
	 */
	MdPanelPosition.prototype._bidi = function(position) {
	  return this._isRTL ? this._reverseXPosition(position) : position;
	};
	
	
	/**
	 * Calculates the panel position based on the created panel element and the
	 * provided positioning.
	 * @param {!JQLite} el
	 * @param {!{x:string, y:string}} position
	 * @private
	 */
	MdPanelPosition.prototype._calculatePanelPosition = function(el, position) {
	
	  var panelBounds = el[0].getBoundingClientRect();
	  var panelWidth = Math.max(panelBounds.width, el[0].clientWidth);
	  var panelHeight = Math.max(panelBounds.height, el[0].clientHeight);
	
	  var targetBounds = this._relativeToEl[0].getBoundingClientRect();
	
	  var targetLeft = targetBounds.left;
	  var targetRight = targetBounds.right;
	  var targetWidth = targetBounds.width;
	
	  switch (this._bidi(position.x)) {
	    case MdPanelPosition.xPosition.OFFSET_START:
	      this._left = targetLeft - panelWidth + 'px';
	      break;
	    case MdPanelPosition.xPosition.ALIGN_END:
	      this._left = targetRight - panelWidth + 'px';
	      break;
	    case MdPanelPosition.xPosition.CENTER:
	      var left = targetLeft + (0.5 * targetWidth) - (0.5 * panelWidth);
	      this._left = left + 'px';
	      break;
	    case MdPanelPosition.xPosition.ALIGN_START:
	      this._left = targetLeft + 'px';
	      break;
	    case MdPanelPosition.xPosition.OFFSET_END:
	      this._left = targetRight + 'px';
	      break;
	  }
	
	  var targetTop = targetBounds.top;
	  var targetBottom = targetBounds.bottom;
	  var targetHeight = targetBounds.height;
	
	  switch (position.y) {
	    case MdPanelPosition.yPosition.ABOVE:
	      this._top = targetTop - panelHeight + 'px';
	      break;
	    case MdPanelPosition.yPosition.ALIGN_BOTTOMS:
	      this._top = targetBottom - panelHeight + 'px';
	      break;
	    case MdPanelPosition.yPosition.CENTER:
	      var top = targetTop + (0.5 * targetHeight) - (0.5 * panelHeight);
	      this._top = top + 'px';
	      break;
	    case MdPanelPosition.yPosition.ALIGN_TOPS:
	      this._top = targetTop + 'px';
	      break;
	    case MdPanelPosition.yPosition.BELOW:
	      this._top = targetBottom + 'px';
	      break;
	  }
	};
	
	
	/*****************************************************************************
	 *                               MdPanelAnimation                            *
	 *****************************************************************************/
	
	
	/**
	 * Animation configuration object. To use, create an MdPanelAnimation with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * Example:
	 *
	 * var panelAnimation = new MdPanelAnimation()
	 *     .openFrom(myButtonEl)
	 *     .closeTo('.my-button')
	 *     .withAnimation($mdPanel.animation.SCALE);
	 *
	 * $mdPanel.create({
	 *   animation: panelAnimation
	 * });
	 *
	 * @param {!IInjectorService} $injector
	 * @final @constructor
	 */
	function MdPanelAnimation($injector) {
	  /** @private @const {!angular.$mdUtil} */
	  this._$mdUtil = $injector.get('$mdUtil');
	
	  /**
	   * @private {{element: !JQLite|undefined, bounds: !DOMRect}|
	   *     undefined}
	   */
	  this._openFrom;
	
	  /**
	   * @private {{element: !JQLite|undefined, bounds: !DOMRect}|
	   *     undefined}
	   */
	  this._closeTo;
	
	  /** @private {string|{open: string, close: string}} */
	  this._animationClass = '';
	
	  /** @private {number} */
	  this._openDuration;
	
	  /** @private {number} */
	  this._closeDuration;
	
	  /** @private {number|{open: number, close: number}} */
	  this._rawDuration;
	}
	
	
	/**
	 * Possible default animations.
	 * @enum {string}
	 */
	MdPanelAnimation.animation = {
	  SLIDE: 'md-panel-animate-slide',
	  SCALE: 'md-panel-animate-scale',
	  FADE: 'md-panel-animate-fade'
	};
	
	
	/**
	 * Specifies where to start the open animation. `openFrom` accepts a
	 * click event object, query selector, DOM element, or a Rect object that
	 * is used to determine the bounds. When passed a click event, the location
	 * of the click will be used as the position to start the animation.
	 * @param {string|!Element|!Event|{top: number, left: number}} openFrom
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.openFrom = function(openFrom) {
	  // Check if 'openFrom' is an Event.
	  openFrom = openFrom.target ? openFrom.target : openFrom;
	
	  this._openFrom = this._getPanelAnimationTarget(openFrom);
	
	  if (!this._closeTo) {
	    this._closeTo = this._openFrom;
	  }
	  return this;
	};
	
	
	/**
	 * Specifies where to animate the panel close. `closeTo` accepts a
	 * query selector, DOM element, or a Rect object that is used to determine
	 * the bounds.
	 * @param {string|!Element|{top: number, left: number}} closeTo
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.closeTo = function(closeTo) {
	  this._closeTo = this._getPanelAnimationTarget(closeTo);
	  return this;
	};
	
	
	/**
	 * Specifies the duration of the animation in milliseconds.
	 * @param {number|{open: number, close: number}} duration
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.duration = function(duration) {
	  if (duration) {
	    if (angular.isNumber(duration)) {
	      this._openDuration = this._closeDuration = toSeconds(duration);
	    } else if (angular.isObject(duration)) {
	      this._openDuration = toSeconds(duration.open);
	      this._closeDuration = toSeconds(duration.close);
	    }
	  }
	
	  // Save the original value so it can be passed to the backdrop.
	  this._rawDuration = duration;
	
	  return this;
	
	  function toSeconds(value) {
	    if (angular.isNumber(value)) return value / 1000;
	  }
	};
	
	
	/**
	 * Returns the element and bounds for the animation target.
	 * @param {string|!Element|{top: number, left: number}} location
	 * @returns {{element: !JQLite|undefined, bounds: !DOMRect}}
	 * @private
	 */
	MdPanelAnimation.prototype._getPanelAnimationTarget = function(location) {
	  if (angular.isDefined(location.top) || angular.isDefined(location.left)) {
	    return {
	      element: undefined,
	      bounds: {
	        top: location.top || 0,
	        left: location.left || 0
	      }
	    };
	  } else {
	    return this._getBoundingClientRect(getElement(location));
	  }
	};
	
	
	/**
	 * Specifies the animation class.
	 *
	 * There are several default animations that can be used:
	 * (MdPanelAnimation.animation)
	 *   SLIDE: The panel slides in and out from the specified
	 *        elements.
	 *   SCALE: The panel scales in and out.
	 *   FADE: The panel fades in and out.
	 *
	 * @param {string|{open: string, close: string}} cssClass
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.withAnimation = function(cssClass) {
	  this._animationClass = cssClass;
	  return this;
	};
	
	
	/**
	 * Animate the panel open.
	 * @param {!JQLite} panelEl
	 * @returns {!Q.IPromise} A promise that is resolved when the open
	 *     animation is complete.
	 */
	MdPanelAnimation.prototype.animateOpen = function(panelEl) {
	  var animator = this._$mdUtil.dom.animator;
	
	  this._fixBounds(panelEl);
	  var animationOptions = {};
	
	  // Include the panel transformations when calculating the animations.
	  var panelTransform = panelEl[0].style.transform || '';
	
	  var openFrom = animator.toTransformCss(panelTransform);
	  var openTo = animator.toTransformCss(panelTransform);
	
	  switch (this._animationClass) {
	    case MdPanelAnimation.animation.SLIDE:
	      // Slide should start with opacity: 1.
	      panelEl.css('opacity', '1');
	
	      animationOptions = {
	        transitionInClass: '_md-panel-animate-enter',
	        transitionOutClass: '_md-panel-animate-leave',
	      };
	
	      var openSlide = animator.calculateSlideToOrigin(
	              panelEl, this._openFrom) || '';
	      openFrom = animator.toTransformCss(openSlide + ' ' + panelTransform);
	      break;
	
	    case MdPanelAnimation.animation.SCALE:
	      animationOptions = {
	        transitionInClass: '_md-panel-animate-enter'
	      };
	
	      var openScale = animator.calculateZoomToOrigin(
	              panelEl, this._openFrom) || '';
	      openFrom = animator.toTransformCss(panelTransform + ' ' + openScale);
	      break;
	
	    case MdPanelAnimation.animation.FADE:
	      animationOptions = {
	        transitionInClass: '_md-panel-animate-enter'
	      };
	      break;
	
	    default:
	      if (angular.isString(this._animationClass)) {
	        animationOptions = {
	          transitionInClass: this._animationClass
	        };
	      } else {
	        animationOptions = {
	          transitionInClass: this._animationClass['open'],
	          transitionOutClass: this._animationClass['close'],
	        };
	      }
	  }
	
	  animationOptions.duration = this._openDuration;
	
	  return animator
	      .translate3d(panelEl, openFrom, openTo, animationOptions);
	};
	
	
	/**
	 * Animate the panel close.
	 * @param {!JQLite} panelEl
	 * @returns {!Q.IPromise} A promise that resolves when the close animation is complete.
	 */
	MdPanelAnimation.prototype.animateClose = function(panelEl) {
	  var animator = this._$mdUtil.dom.animator;
	  var reverseAnimationOptions = {};
	
	  // Include the panel transformations when calculating the animations.
	  var panelTransform = panelEl[0].style.transform || '';
	
	  var closeFrom = animator.toTransformCss(panelTransform);
	  var closeTo = animator.toTransformCss(panelTransform);
	
	  switch (this._animationClass) {
	    case MdPanelAnimation.animation.SLIDE:
	      // Slide should start with opacity: 1.
	      panelEl.css('opacity', '1');
	      reverseAnimationOptions = {
	        transitionInClass: '_md-panel-animate-leave',
	        transitionOutClass: '_md-panel-animate-enter _md-panel-animate-leave'
	      };
	
	      var closeSlide = animator.calculateSlideToOrigin(panelEl, this._closeTo) || '';
	      closeTo = animator.toTransformCss(closeSlide + ' ' + panelTransform);
	      break;
	
	    case MdPanelAnimation.animation.SCALE:
	      reverseAnimationOptions = {
	        transitionInClass: '_md-panel-animate-scale-out _md-panel-animate-leave',
	        transitionOutClass: '_md-panel-animate-scale-out _md-panel-animate-enter _md-panel-animate-leave'
	      };
	
	      var closeScale = animator.calculateZoomToOrigin(panelEl, this._closeTo) || '';
	      closeTo = animator.toTransformCss(panelTransform + ' ' + closeScale);
	      break;
	
	    case MdPanelAnimation.animation.FADE:
	      reverseAnimationOptions = {
	        transitionInClass: '_md-panel-animate-fade-out _md-panel-animate-leave',
	        transitionOutClass: '_md-panel-animate-fade-out _md-panel-animate-enter _md-panel-animate-leave'
	      };
	      break;
	
	    default:
	      if (angular.isString(this._animationClass)) {
	        reverseAnimationOptions = {
	          transitionOutClass: this._animationClass
	        };
	      } else {
	        reverseAnimationOptions = {
	          transitionInClass: this._animationClass['close'],
	          transitionOutClass: this._animationClass['open']
	        };
	      }
	  }
	
	  reverseAnimationOptions.duration = this._closeDuration;
	
	  return animator
	      .translate3d(panelEl, closeFrom, closeTo, reverseAnimationOptions);
	};
	
	
	/**
	 * Set the height and width to match the panel if not provided.
	 * @param {!JQLite} panelEl
	 * @private
	 */
	MdPanelAnimation.prototype._fixBounds = function(panelEl) {
	  var panelWidth = panelEl[0].offsetWidth;
	  var panelHeight = panelEl[0].offsetHeight;
	
	  if (this._openFrom && this._openFrom.bounds.height == null) {
	    this._openFrom.bounds.height = panelHeight;
	  }
	  if (this._openFrom && this._openFrom.bounds.width == null) {
	    this._openFrom.bounds.width = panelWidth;
	  }
	  if (this._closeTo && this._closeTo.bounds.height == null) {
	    this._closeTo.bounds.height = panelHeight;
	  }
	  if (this._closeTo && this._closeTo.bounds.width == null) {
	    this._closeTo.bounds.width = panelWidth;
	  }
	};
	
	
	/**
	 * Identify the bounding RECT for the target element.
	 * @param {!JQLite} element
	 * @returns {{element: !JQLite|undefined, bounds: !DOMRect}}
	 * @private
	 */
	MdPanelAnimation.prototype._getBoundingClientRect = function(element) {
	  if (element instanceof angular.element) {
	    return {
	      element: element,
	      bounds: element[0].getBoundingClientRect()
	    };
	  }
	};
	
	
	/*****************************************************************************
	 *                                Util Methods                               *
	 *****************************************************************************/
	
	
	/**
	 * Returns the angular element associated with a css selector or element.
	 * @param el {string|!JQLite|!Element}
	 * @returns {!JQLite}
	 */
	function getElement(el) {
	  var queryResult = angular.isString(el) ?
	      document.querySelector(el) : el;
	  return angular.element(queryResult);
	}
	
	/**
	 * Gets the computed values for an element's translateX and translateY in px.
	 * @param {!JQLite|!Element} el the element to evaluate
	 * @param {string} property
	 * @return {{x: number, y: number}} an element's translateX and translateY in px
	 */
	function getComputedTranslations(el, property) {
	  // The transform being returned by `getComputedStyle` is in the format:
	  // `matrix(a, b, c, d, translateX, translateY)` if defined and `none`
	  // if the element doesn't have a transform.
	  var transform = getComputedStyle(el[0] || el)[property];
	  var openIndex = transform.indexOf('(');
	  var closeIndex = transform.lastIndexOf(')');
	  var output = { x: 0, y: 0 };
	
	  if (openIndex > -1 && closeIndex > -1) {
	    var parsedValues = transform
	      .substring(openIndex + 1, closeIndex)
	      .split(', ')
	      .slice(-2);
	
	    output.x = parseInt(parsedValues[0]);
	    output.y = parseInt(parsedValues[1]);
	  }
	
	  return output;
	}
	
	/*
	 * Ensures that a value is a valid position name. Throw an exception if not.
	 * @param {Object} positionMap Object against which the value will be checked.
	 * @param {string} value
	 */
	function validatePosition(positionMap, value) {
	  // empty is ok
	  if (value === null || angular.isUndefined(value)) {
	    return;
	  }
	
	  var positionKeys = Object.keys(positionMap);
	  var positionValues = [];
	
	  for (var key, i = 0; key = positionKeys[i]; i++) {
	    var position = positionMap[key];
	    positionValues.push(position);
	
	    if (position === value) {
	      return;
	    }
	  }
	
	  throw new Error('Panel position only accepts the following values:\n' +
	    positionValues.join(' | '));
	}
	
	/**
	 * Adds units to a number value.
	 * @param {string|number} value
	 * @return {string}
	 */
	function addUnits(value) {
	  return angular.isNumber(value) ? value + 'px' : value;
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.progressCircular
	 * @description Module for a circular progressbar
	 */
	
	angular.module('material.components.progressCircular', ['material.core']);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdProgressCircular
	 * @module material.components.progressCircular
	 * @restrict E
	 *
	 * @description
	 * The circular progress directive is used to make loading content in your app as delightful and
	 * painless as possible by minimizing the amount of visual change a user sees before they can view
	 * and interact with content.
	 *
	 * For operations where the percentage of the operation completed can be determined, use a
	 * determinate indicator. They give users a quick sense of how long an operation will take.
	 *
	 * For operations where the user is asked to wait a moment while something finishes up, and it’s
	 * not necessary to expose what's happening behind the scenes and how long it will take, use an
	 * indeterminate indicator.
	 *
	 * @param {string} md-mode Select from one of two modes: **'determinate'** and **'indeterminate'**.
	 *
	 * Note: if the `md-mode` value is set as undefined or specified as not 1 of the two (2) valid modes, then **'indeterminate'**
	 * will be auto-applied as the mode.
	 *
	 * Note: if not configured, the `md-mode="indeterminate"` will be auto injected as an attribute.
	 * If `value=""` is also specified, however, then `md-mode="determinate"` would be auto-injected instead.
	 * @param {number=} value In determinate mode, this number represents the percentage of the
	 *     circular progress. Default: 0
	 * @param {number=} md-diameter This specifies the diameter of the circular progress. The value
	 * should be a pixel-size value (eg '100'). If this attribute is
	 * not present then a default value of '50px' is assumed.
	 *
	 * @param {boolean=} ng-disabled Determines whether to disable the progress element.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-progress-circular md-mode="determinate" value="..."></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="determinate" ng-value="..."></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="determinate" value="..." md-diameter="100"></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="indeterminate"></md-progress-circular>
	 * </hljs>
	 */
	
	MdProgressCircularDirective.$inject = ["$window", "$mdProgressCircular", "$mdTheming", "$mdUtil", "$interval", "$log"];
	angular
	  .module('material.components.progressCircular')
	  .directive('mdProgressCircular', MdProgressCircularDirective);
	
	/* @ngInject */
	function MdProgressCircularDirective($window, $mdProgressCircular, $mdTheming,
	                                     $mdUtil, $interval, $log) {
	
	  // Note that this shouldn't use use $$rAF, because it can cause an infinite loop
	  // in any tests that call $animate.flush.
	  var rAF = $window.requestAnimationFrame ||
	            $window.webkitRequestAnimationFrame ||
	            angular.noop;
	
	  var cAF = $window.cancelAnimationFrame ||
	            $window.webkitCancelAnimationFrame ||
	            $window.webkitCancelRequestAnimationFrame ||
	            angular.noop;
	
	  var MODE_DETERMINATE = 'determinate';
	  var MODE_INDETERMINATE = 'indeterminate';
	  var DISABLED_CLASS = '_md-progress-circular-disabled';
	  var INDETERMINATE_CLASS = 'md-mode-indeterminate';
	
	  return {
	    restrict: 'E',
	    scope: {
	      value: '@',
	      mdDiameter: '@',
	      mdMode: '@'
	    },
	    template:
	      '<svg xmlns="http://www.w3.org/2000/svg">' +
	        '<path fill="none"/>' +
	      '</svg>',
	    compile: function(element, attrs) {
	      element.attr({
	        'aria-valuemin': 0,
	        'aria-valuemax': 100,
	        'role': 'progressbar'
	      });
	
	      if (angular.isUndefined(attrs.mdMode)) {
	        var mode = attrs.hasOwnProperty('value') ? MODE_DETERMINATE : MODE_INDETERMINATE;
	        attrs.$set('mdMode', mode);
	      } else {
	        attrs.$set('mdMode', attrs.mdMode.trim());
	      }
	
	      return MdProgressCircularLink;
	    }
	  };
	
	  function MdProgressCircularLink(scope, element, attrs) {
	    var node = element[0];
	    var svg = angular.element(node.querySelector('svg'));
	    var path = angular.element(node.querySelector('path'));
	    var startIndeterminate = $mdProgressCircular.startIndeterminate;
	    var endIndeterminate = $mdProgressCircular.endIndeterminate;
	    var iterationCount = 0;
	    var lastAnimationId = 0;
	    var lastDrawFrame;
	    var interval;
	
	    $mdTheming(element);
	    element.toggleClass(DISABLED_CLASS, attrs.hasOwnProperty('disabled'));
	
	    // If the mode is indeterminate, it doesn't need to
	    // wait for the next digest. It can start right away.
	    if (scope.mdMode === MODE_INDETERMINATE){
	      startIndeterminateAnimation();
	    }
	
	    scope.$on('$destroy', function(){
	      cleanupIndeterminateAnimation();
	
	      if (lastDrawFrame) {
	        cAF(lastDrawFrame);
	      }
	    });
	
	    scope.$watchGroup(['value', 'mdMode', function() {
	      var isDisabled = node.disabled;
	
	      // Sometimes the browser doesn't return a boolean, in
	      // which case we should check whether the attribute is
	      // present.
	      if (isDisabled === true || isDisabled === false){
	        return isDisabled;
	      }
	
	      return angular.isDefined(element.attr('disabled'));
	    }], function(newValues, oldValues) {
	      var mode = newValues[1];
	      var isDisabled = newValues[2];
	      var wasDisabled = oldValues[2];
	      var diameter = 0;
	      var strokeWidth = 0;
	
	      if (isDisabled !== wasDisabled) {
	        element.toggleClass(DISABLED_CLASS, !!isDisabled);
	      }
	
	      if (isDisabled) {
	        cleanupIndeterminateAnimation();
	      } else {
	        if (mode !== MODE_DETERMINATE && mode !== MODE_INDETERMINATE) {
	          mode = MODE_INDETERMINATE;
	          attrs.$set('mdMode', mode);
	        }
	
	        if (mode === MODE_INDETERMINATE) {
	          if (oldValues[1] === MODE_DETERMINATE) {
	            diameter = getSize(scope.mdDiameter);
	            strokeWidth = getStroke(diameter);
	            path.attr('d', getSvgArc(diameter, strokeWidth, true));
	            path.attr('stroke-dasharray', getDashLength(diameter, strokeWidth, 75));
	          }
	          startIndeterminateAnimation();
	        } else {
	          var newValue = clamp(newValues[0]);
	          var oldValue = clamp(oldValues[0]);
	
	          cleanupIndeterminateAnimation();
	
	          if (oldValues[1] === MODE_INDETERMINATE) {
	            diameter = getSize(scope.mdDiameter);
	            strokeWidth = getStroke(diameter);
	            path.attr('d', getSvgArc(diameter, strokeWidth, false));
	            path.attr('stroke-dasharray', getDashLength(diameter, strokeWidth, 100));
	          }
	
	          element.attr('aria-valuenow', newValue);
	          renderCircle(oldValue, newValue);
	        }
	      }
	
	    });
	
	    // This is in a separate watch in order to avoid layout, unless
	    // the value has actually changed.
	    scope.$watch('mdDiameter', function(newValue) {
	      var diameter = getSize(newValue);
	      var strokeWidth = getStroke(diameter);
	      var value = clamp(scope.value);
	      var transformOrigin = (diameter / 2) + 'px';
	      var dimensions = {
	        width: diameter + 'px',
	        height: diameter + 'px'
	      };
	
	      // The viewBox has to be applied via setAttribute, because it is
	      // case-sensitive. If jQuery is included in the page, `.attr` lowercases
	      // all attribute names.
	      svg[0].setAttribute('viewBox', '0 0 ' + diameter + ' ' + diameter);
	
	      // Usually viewBox sets the dimensions for the SVG, however that doesn't
	      // seem to be the case on IE10.
	      // Important! The transform origin has to be set from here and it has to
	      // be in the format of "Ypx Ypx Ypx", otherwise the rotation wobbles in
	      // IE and Edge, because they don't account for the stroke width when
	      // rotating. Also "center" doesn't help in this case, it has to be a
	      // precise value.
	      svg
	        .css(dimensions)
	        .css('transform-origin', transformOrigin + ' ' + transformOrigin + ' ' + transformOrigin);
	
	      element.css(dimensions);
	
	      path.attr('stroke-width', strokeWidth);
	      path.attr('stroke-linecap', 'square');
	      if (scope.mdMode == MODE_INDETERMINATE) {
	        path.attr('d', getSvgArc(diameter, strokeWidth, true));
	        path.attr('stroke-dasharray', getDashLength(diameter, strokeWidth, 75));
	        path.attr('stroke-dashoffset', getDashOffset(diameter, strokeWidth, 1, 75));
	      } else {
	        path.attr('d', getSvgArc(diameter, strokeWidth, false));
	        path.attr('stroke-dasharray', getDashLength(diameter, strokeWidth, 100));
	        path.attr('stroke-dashoffset', getDashOffset(diameter, strokeWidth, 0, 100));
	        renderCircle(value, value);
	      }
	
	    });
	
	    function renderCircle(animateFrom, animateTo, easing, duration, iterationCount, maxValue) {
	      var id = ++lastAnimationId;
	      var startTime = $mdUtil.now();
	      var changeInValue = animateTo - animateFrom;
	      var diameter = getSize(scope.mdDiameter);
	      var strokeWidth = getStroke(diameter);
	      var ease = easing || $mdProgressCircular.easeFn;
	      var animationDuration = duration || $mdProgressCircular.duration;
	      var rotation = -90 * (iterationCount || 0);
	      var dashLimit = maxValue || 100;
	
	      // No need to animate it if the values are the same
	      if (animateTo === animateFrom) {
	        renderFrame(animateTo);
	      } else {
	        lastDrawFrame = rAF(function animation() {
	          var currentTime = $window.Math.max(0, $window.Math.min($mdUtil.now() - startTime, animationDuration));
	
	          renderFrame(ease(currentTime, animateFrom, changeInValue, animationDuration));
	
	          // Do not allow overlapping animations
	          if (id === lastAnimationId && currentTime < animationDuration) {
	            lastDrawFrame = rAF(animation);
	          }
	        });
	      }
	
	      function renderFrame(value) {
	        path.attr('stroke-dashoffset', getDashOffset(diameter, strokeWidth, value, dashLimit));
	        path.attr('transform','rotate(' + (rotation) + ' ' + diameter/2 + ' ' + diameter/2 + ')');
	      }
	    }
	
	    function animateIndeterminate() {
	      renderCircle(
	        startIndeterminate,
	        endIndeterminate,
	        $mdProgressCircular.easeFnIndeterminate,
	        $mdProgressCircular.durationIndeterminate,
	        iterationCount,
	        75
	      );
	
	      // The %4 technically isn't necessary, but it keeps the rotation
	      // under 360, instead of becoming a crazy large number.
	      iterationCount = ++iterationCount % 4;
	
	    }
	
	    function startIndeterminateAnimation() {
	      if (!interval) {
	        // Note that this interval isn't supposed to trigger a digest.
	        interval = $interval(
	          animateIndeterminate,
	          $mdProgressCircular.durationIndeterminate,
	          0,
	          false
	        );
	
	        animateIndeterminate();
	
	        element
	          .addClass(INDETERMINATE_CLASS)
	          .removeAttr('aria-valuenow');
	      }
	    }
	
	    function cleanupIndeterminateAnimation() {
	      if (interval) {
	        $interval.cancel(interval);
	        interval = null;
	        element.removeClass(INDETERMINATE_CLASS);
	      }
	    }
	  }
	
	  /**
	   * Returns SVG path data for progress circle
	   * Syntax spec: https://www.w3.org/TR/SVG/paths.html#PathDataEllipticalArcCommands
	   *
	   * @param {number} diameter Diameter of the container.
	   * @param {number} strokeWidth Stroke width to be used when drawing circle
	   * @param {boolean} indeterminate Use if progress circle will be used for indeterminate
	   *
	   * @returns {string} String representation of an SVG arc.
	   */
	  function getSvgArc(diameter, strokeWidth, indeterminate) {
	    var radius = diameter / 2;
	    var offset = strokeWidth / 2;
	    var start = radius + ',' + offset; // ie: (25, 2.5) or 12 o'clock
	    var end = offset + ',' + radius;   // ie: (2.5, 25) or  9 o'clock
	    var arcRadius = radius - offset;
	    return 'M' + start
	         + 'A' + arcRadius + ',' + arcRadius + ' 0 1 1 ' + end // 75% circle
	         + (indeterminate ? '' : 'A' + arcRadius + ',' + arcRadius + ' 0 0 1 ' + start); // loop to start
	  }
	
	  /**
	   * Return stroke length for progress circle
	   *
	   * @param {number} diameter Diameter of the container.
	   * @param {number} strokeWidth Stroke width to be used when drawing circle
	   * @param {number} value Percentage of circle (between 0 and 100)
	   * @param {number} maxArcLength Maximum length of arc as a percentage of circle (between 0 and 100)
	   *
	   * @returns {number} Stroke length for progress circle
	   */
	  function getDashOffset(diameter, strokeWidth, value, maxArcLength) {
	    return getSpinnerCircumference(diameter, strokeWidth) * ((maxArcLength - value) / 100);
	  }
	
	  /**
	   * Limits a value between 0 and 100.
	   */
	  function clamp(value) {
	    return $window.Math.max(0, $window.Math.min(value || 0, 100));
	  }
	
	  /**
	   * Determines the size of a progress circle, based on the provided
	   * value in the following formats: `X`, `Ypx`, `Z%`.
	   */
	  function getSize(value) {
	    var defaultValue = $mdProgressCircular.progressSize;
	
	    if (value) {
	      var parsed = parseFloat(value);
	
	      if (value.lastIndexOf('%') === value.length - 1) {
	        parsed = (parsed / 100) * defaultValue;
	      }
	
	      return parsed;
	    }
	
	    return defaultValue;
	  }
	
	  /**
	   * Determines the circle's stroke width, based on
	   * the provided diameter.
	   */
	  function getStroke(diameter) {
	    return $mdProgressCircular.strokeWidth / 100 * diameter;
	  }
	
	  /**
	   * Return length of the dash
	   *
	   * @param {number} diameter Diameter of the container.
	   * @param {number} strokeWidth Stroke width to be used when drawing circle
	   * @param {number} value Percentage of circle (between 0 and 100)
	   *
	   * @returns {number} Length of the dash
	   */
	  function getDashLength(diameter, strokeWidth, value) {
	    return getSpinnerCircumference(diameter, strokeWidth) * (value / 100);
	  }
	
	  /**
	   * Return circumference of the spinner
	   *
	   * @param {number} diameter Diameter of the container.
	   * @param {number} strokeWidth Stroke width to be used when drawing circle
	   *
	   * @returns {number} Circumference of the spinner
	   */
	  function getSpinnerCircumference(diameter, strokeWidth) {
	    return ((diameter - strokeWidth) * $window.Math.PI);
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc service
	 * @name $mdProgressCircular
	 * @module material.components.progressCircular
	 *
	 * @description
	 * Allows the user to specify the default options for the `progressCircular` directive.
	 *
	 * @property {number} progressSize Diameter of the progress circle in pixels.
	 * @property {number} strokeWidth Width of the circle's stroke as a percentage of the circle's size.
	 * @property {number} duration Length of the circle animation in milliseconds.
	 * @property {function} easeFn Default easing animation function.
	 * @property {object} easingPresets Collection of pre-defined easing functions.
	 *
	 * @property {number} durationIndeterminate Duration of the indeterminate animation.
	 * @property {number} startIndeterminate Indeterminate animation start point.
	 * @property {number} endIndeterminate Indeterminate animation end point.
	 * @property {function} easeFnIndeterminate Easing function to be used when animating
	 * between the indeterminate values.
	 *
	 * @property {(function(object): object)} configure Used to modify the default options.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdProgressCircularProvider) {
	 *
	 *     // Example of changing the default progress options.
	 *     $mdProgressCircularProvider.configure({
	 *       progressSize: 100,
	 *       strokeWidth: 20,
	 *       duration: 800
	 *     });
	 * });
	 * </hljs>
	 *
	 */
	
	angular
	  .module('material.components.progressCircular')
	  .provider("$mdProgressCircular", MdProgressCircularProvider);
	
	function MdProgressCircularProvider() {
	  var progressConfig = {
	    progressSize: 50,
	    strokeWidth: 10,
	    duration: 100,
	    easeFn: linearEase,
	
	    durationIndeterminate: 1333,
	    startIndeterminate: 1,
	    endIndeterminate: 149,
	    easeFnIndeterminate: materialEase,
	
	    easingPresets: {
	      linearEase: linearEase,
	      materialEase: materialEase
	    }
	  };
	
	  return {
	    configure: function(options) {
	      progressConfig = angular.extend(progressConfig, options || {});
	      return progressConfig;
	    },
	    $get: function() { return progressConfig; }
	  };
	
	  function linearEase(t, b, c, d) {
	    return c * t / d + b;
	  }
	
	  function materialEase(t, b, c, d) {
	    // via http://www.timotheegroleau.com/Flash/experiments/easing_function_generator.htm
	    // with settings of [0, 0, 1, 1]
	    var ts = (t /= d) * t;
	    var tc = ts * t;
	    return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.progressLinear
	 * @description Linear Progress module!
	 */
	MdProgressLinearDirective.$inject = ["$mdTheming", "$mdUtil", "$log"];
	angular.module('material.components.progressLinear', [
	  'material.core'
	])
	  .directive('mdProgressLinear', MdProgressLinearDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdProgressLinear
	 * @module material.components.progressLinear
	 * @restrict E
	 *
	 * @description
	 * The linear progress directive is used to make loading content
	 * in your app as delightful and painless as possible by minimizing
	 * the amount of visual change a user sees before they can view
	 * and interact with content.
	 *
	 * Each operation should only be represented by one activity indicator
	 * For example: one refresh operation should not display both a
	 * refresh bar and an activity circle.
	 *
	 * For operations where the percentage of the operation completed
	 * can be determined, use a determinate indicator. They give users
	 * a quick sense of how long an operation will take.
	 *
	 * For operations where the user is asked to wait a moment while
	 * something finishes up, and it’s not necessary to expose what's
	 * happening behind the scenes and how long it will take, use an
	 * indeterminate indicator.
	 *
	 * @param {string} md-mode Select from one of four modes: determinate, indeterminate, buffer or query.
	 *
	 * Note: if the `md-mode` value is set as undefined or specified as 1 of the four (4) valid modes, then `indeterminate`
	 * will be auto-applied as the mode.
	 *
	 * Note: if not configured, the `md-mode="indeterminate"` will be auto injected as an attribute. If `value=""` is also specified, however,
	 * then `md-mode="determinate"` would be auto-injected instead.
	 * @param {number=} value In determinate and buffer modes, this number represents the percentage of the primary progress bar. Default: 0
	 * @param {number=} md-buffer-value In the buffer mode, this number represents the percentage of the secondary progress bar. Default: 0
	 * @param {boolean=} ng-disabled Determines whether to disable the progress element.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-progress-linear md-mode="determinate" value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="determinate" ng-value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="indeterminate"></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="buffer" value="..." md-buffer-value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="query"></md-progress-linear>
	 * </hljs>
	 */
	function MdProgressLinearDirective($mdTheming, $mdUtil, $log) {
	  var MODE_DETERMINATE = "determinate";
	  var MODE_INDETERMINATE = "indeterminate";
	  var MODE_BUFFER = "buffer";
	  var MODE_QUERY = "query";
	  var DISABLED_CLASS = "_md-progress-linear-disabled";
	
	  return {
	    restrict: 'E',
	    template: '<div class="md-container">' +
	      '<div class="md-dashed"></div>' +
	      '<div class="md-bar md-bar1"></div>' +
	      '<div class="md-bar md-bar2"></div>' +
	      '</div>',
	    compile: compile
	  };
	
	  function compile(tElement, tAttrs, transclude) {
	    tElement.attr('aria-valuemin', 0);
	    tElement.attr('aria-valuemax', 100);
	    tElement.attr('role', 'progressbar');
	
	    return postLink;
	  }
	  function postLink(scope, element, attr) {
	    $mdTheming(element);
	
	    var lastMode;
	    var isDisabled = attr.hasOwnProperty('disabled');
	    var toVendorCSS = $mdUtil.dom.animator.toCss;
	    var bar1 = angular.element(element[0].querySelector('.md-bar1'));
	    var bar2 = angular.element(element[0].querySelector('.md-bar2'));
	    var container = angular.element(element[0].querySelector('.md-container'));
	
	    element
	      .attr('md-mode', mode())
	      .toggleClass(DISABLED_CLASS, isDisabled);
	
	    validateMode();
	    watchAttributes();
	
	    /**
	     * Watch the value, md-buffer-value, and md-mode attributes
	     */
	    function watchAttributes() {
	      attr.$observe('value', function(value) {
	        var percentValue = clamp(value);
	        element.attr('aria-valuenow', percentValue);
	
	        if (mode() != MODE_QUERY) animateIndicator(bar2, percentValue);
	      });
	
	      attr.$observe('mdBufferValue', function(value) {
	        animateIndicator(bar1, clamp(value));
	      });
	
	      attr.$observe('disabled', function(value) {
	        if (value === true || value === false) {
	          isDisabled = !!value;
	        } else {
	          isDisabled = angular.isDefined(value);
	        }
	
	        element.toggleClass(DISABLED_CLASS, isDisabled);
	        container.toggleClass(lastMode, !isDisabled);
	      });
	
	      attr.$observe('mdMode', function(mode) {
	        if (lastMode) container.removeClass(lastMode);
	
	        switch (mode) {
	          case MODE_QUERY:
	          case MODE_BUFFER:
	          case MODE_DETERMINATE:
	          case MODE_INDETERMINATE:
	            container.addClass(lastMode = "md-mode-" + mode);
	            break;
	          default:
	            container.addClass(lastMode = "md-mode-" + MODE_INDETERMINATE);
	            break;
	        }
	      });
	    }
	
	    /**
	     * Auto-defaults the mode to either `determinate` or `indeterminate` mode; if not specified
	     */
	    function validateMode() {
	      if (angular.isUndefined(attr.mdMode)) {
	        var hasValue = angular.isDefined(attr.value);
	        var mode = hasValue ? MODE_DETERMINATE : MODE_INDETERMINATE;
	        var info = "Auto-adding the missing md-mode='{0}' to the ProgressLinear element";
	        element.attr("md-mode", mode);
	        attr.mdMode = mode;
	      }
	    }
	
	    /**
	     * Is the md-mode a valid option?
	     */
	    function mode() {
	      var value = (attr.mdMode || "").trim();
	      if (value) {
	        switch (value) {
	          case MODE_DETERMINATE:
	          case MODE_INDETERMINATE:
	          case MODE_BUFFER:
	          case MODE_QUERY:
	            break;
	          default:
	            value = MODE_INDETERMINATE;
	            break;
	        }
	      }
	      return value;
	    }
	
	    /**
	     * Manually set CSS to animate the Determinate indicator based on the specified
	     * percentage value (0-100).
	     */
	    function animateIndicator(target, value) {
	      if (isDisabled || !mode()) return;
	
	      var to = $mdUtil.supplant("translateX({0}%) scale({1},1)", [(value-100)/2, value/100]);
	      var styles = toVendorCSS({ transform : to });
	      angular.element(target).css(styles);
	    }
	  }
	
	  /**
	   * Clamps the value to be between 0 and 100.
	   * @param {number} value The value to clamp.
	   * @returns {number}
	   */
	  function clamp(value) {
	    return Math.max(0, Math.min(value || 0, 100));
	  }
	}
	
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.radioButton
	 * @description radioButton module!
	 */
	mdRadioGroupDirective.$inject = ["$mdUtil", "$mdConstant", "$mdTheming", "$timeout"];
	mdRadioButtonDirective.$inject = ["$mdAria", "$mdUtil", "$mdTheming"];
	angular.module('material.components.radioButton', [
	  'material.core'
	])
	  .directive('mdRadioGroup', mdRadioGroupDirective)
	  .directive('mdRadioButton', mdRadioButtonDirective);
	
	/**
	 * @ngdoc directive
	 * @module material.components.radioButton
	 * @name mdRadioGroup
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-radio-group>` directive identifies a grouping
	 * container for the 1..n grouped radio buttons; specified using nested
	 * `<md-radio-button>` elements.
	 *
	 * The radio button uses the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * Note: `<md-radio-group>` and `<md-radio-button>` handle `tabindex` differently
	 * than the native `<input type="radio">` controls. Whereas the native controls
	 * force the user to tab through all the radio buttons, `<md-radio-group>`
	 * is focusable and by default the `<md-radio-button>`s are not.
	 *
	 * @param {string} ng-model Assignable angular expression to data-bind to.
	 * @param {string=} ng-change AngularJS expression to be executed when input changes due to user
	 *    interaction.
	 * @param {boolean=} md-no-ink If present, disables ink ripple effects.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-radio-group ng-model="selected">
	 *   <md-radio-button ng-repeat="item in items"
	 *                    ng-value="item.value" aria-label="{{item.label}}">
	 *     {{ item.label }}
	 *   </md-radio-button>
	 * </md-radio-group>
	 * </hljs>
	 */
	function mdRadioGroupDirective($mdUtil, $mdConstant, $mdTheming, $timeout) {
	  RadioGroupController.prototype = createRadioGroupControllerProto();
	
	  return {
	    restrict: 'E',
	    controller: ['$element', RadioGroupController],
	    require: ['mdRadioGroup', '?ngModel'],
	    link: { pre: linkRadioGroup }
	  };
	
	  function linkRadioGroup(scope, element, attr, ctrls) {
	    // private md component indicator for styling
	    element.addClass('_md');
	    $mdTheming(element);
	
	    var rgCtrl = ctrls[0];
	    var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
	
	    rgCtrl.init(ngModelCtrl);
	
	    scope.mouseActive = false;
	
	    element
	      .attr({
	        'role': 'radiogroup',
	        'tabIndex': element.attr('tabindex') || '0'
	      })
	      .on('keydown', keydownListener)
	      .on('mousedown', function(event) {
	        scope.mouseActive = true;
	        $timeout(function() {
	          scope.mouseActive = false;
	        }, 100);
	      })
	      .on('focus', function() {
	        if (scope.mouseActive === false) {
	          rgCtrl.$element.addClass('md-focused');
	        }
	      })
	      .on('blur', function() {
	        rgCtrl.$element.removeClass('md-focused');
	      });
	
	    /**
	     * Apply the md-focused class if it isn't already applied.
	     */
	    function setFocus() {
	      if (!element.hasClass('md-focused')) { element.addClass('md-focused'); }
	    }
	
	    /**
	     * @param {KeyboardEvent} ev
	     */
	    function keydownListener(ev) {
	      var keyCode = ev.which || ev.keyCode;
	
	      // Only listen to events that we originated ourselves
	      // so that we don't trigger on things like arrow keys in inputs.
	      if (keyCode !== $mdConstant.KEY_CODE.ENTER &&
	          ev.currentTarget !== ev.target) {
	        return;
	      }
	
	      switch (keyCode) {
	        case $mdConstant.KEY_CODE.LEFT_ARROW:
	        case $mdConstant.KEY_CODE.UP_ARROW:
	          ev.preventDefault();
	          rgCtrl.selectPrevious();
	          setFocus();
	          break;
	
	        case $mdConstant.KEY_CODE.RIGHT_ARROW:
	        case $mdConstant.KEY_CODE.DOWN_ARROW:
	          ev.preventDefault();
	          rgCtrl.selectNext();
	          setFocus();
	          break;
	
	        case $mdConstant.KEY_CODE.ENTER:
	          var form = angular.element($mdUtil.getClosest(element[0], 'form'));
	          if (form.length > 0) {
	            form.triggerHandler('submit');
	          }
	          break;
	      }
	    }
	  }
	
	  function RadioGroupController($element) {
	    this._radioButtonRenderFns = [];
	    this.$element = $element;
	  }
	
	  function createRadioGroupControllerProto() {
	    return {
	      init: function(ngModelCtrl) {
	        this._ngModelCtrl = ngModelCtrl;
	        this._ngModelCtrl.$render = angular.bind(this, this.render);
	      },
	      add: function(rbRender) {
	        this._radioButtonRenderFns.push(rbRender);
	      },
	      remove: function(rbRender) {
	        var index = this._radioButtonRenderFns.indexOf(rbRender);
	        if (index !== -1) {
	          this._radioButtonRenderFns.splice(index, 1);
	        }
	      },
	      render: function() {
	        this._radioButtonRenderFns.forEach(function(rbRender) {
	          rbRender();
	        });
	      },
	      setViewValue: function(value, eventType) {
	        this._ngModelCtrl.$setViewValue(value, eventType);
	        // update the other radio buttons as well
	        this.render();
	      },
	      getViewValue: function() {
	        return this._ngModelCtrl.$viewValue;
	      },
	      selectNext: function() {
	        return changeSelectedButton(this.$element, 1);
	      },
	      selectPrevious: function() {
	        return changeSelectedButton(this.$element, -1);
	      },
	      setActiveDescendant: function (radioId) {
	        this.$element.attr('aria-activedescendant', radioId);
	      },
	      isDisabled: function() {
	        return this.$element[0].hasAttribute('disabled');
	      }
	    };
	  }
	  /**
	   * Change the radio group's selected button by a given increment.
	   * If no button is selected, select the first button.
	   */
	  function changeSelectedButton(parent, increment) {
	    // Coerce all child radio buttons into an array, then wrap then in an iterator
	    var buttons = $mdUtil.iterator(parent[0].querySelectorAll('md-radio-button'), true);
	
	    if (buttons.count()) {
	      var validate = function (button) {
	        // If disabled, then NOT valid
	        return !angular.element(button).attr("disabled");
	      };
	
	      var selected = parent[0].querySelector('md-radio-button.md-checked');
	      var target = buttons[increment < 0 ? 'previous' : 'next'](selected, validate) || buttons.first();
	
	      // Activate radioButton's click listener (triggerHandler won't create a real click event)
	      angular.element(target).triggerHandler('click');
	    }
	  }
	
	}
	
	/**
	 * @ngdoc directive
	 * @module material.components.radioButton
	 * @name mdRadioButton
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-radio-button>`directive is the child directive required to be used within `<md-radio-group>` elements.
	 *
	 * While similar to the `<input type="radio" ng-model="" value="">` directive,
	 * the `<md-radio-button>` directive provides ink effects, ARIA support, and
	 * supports use within named radio groups.
	 *
	 * One of `value` or `ng-value` must be set so that the `md-radio-group`'s model is set properly when the
	 * `md-radio-button` is selected.
	 *
	 * @param {string} value The value to which the model should be set when selected.
	 * @param {string} ng-value AngularJS expression which sets the value to which the model should
	 *    be set when selected.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} aria-label Adds label to radio button for accessibility.
	 *    Defaults to radio button's text. If no text content is available, a warning will be logged.
	 *
	 * @usage
	 * <hljs lang="html">
	 *
	 * <md-radio-button value="1" aria-label="Label 1">
	 *   Label 1
	 * </md-radio-button>
	 *
	 * <md-radio-button ng-value="specialValue" aria-label="Green">
	 *   Green
	 * </md-radio-button>
	 *
	 * </hljs>
	 *
	 */
	function mdRadioButtonDirective($mdAria, $mdUtil, $mdTheming) {
	
	  var CHECKED_CSS = 'md-checked';
	
	  return {
	    restrict: 'E',
	    require: '^mdRadioGroup',
	    transclude: true,
	    template: '<div class="md-container" md-ink-ripple md-ink-ripple-checkbox>' +
	                '<div class="md-off"></div>' +
	                '<div class="md-on"></div>' +
	              '</div>' +
	              '<div ng-transclude class="md-label"></div>',
	    link: link
	  };
	
	  function link(scope, element, attr, rgCtrl) {
	    var lastChecked;
	
	    $mdTheming(element);
	    configureAria(element, scope);
	
	    // ngAria overwrites the aria-checked inside a $watch for ngValue.
	    // We should defer the initialization until all the watches have fired.
	    // This can also be fixed by removing the `lastChecked` check, but that'll
	    // cause more DOM manipulation on each digest.
	    if (attr.ngValue) {
	      $mdUtil.nextTick(initialize, false);
	    } else {
	      initialize();
	    }
	
	    /**
	     * Initializes the component.
	     */
	    function initialize() {
	      if (!rgCtrl) {
	        throw 'RadioButton: No RadioGroupController could be found.';
	      }
	
	      rgCtrl.add(render);
	      attr.$observe('value', render);
	
	      element
	        .on('click', listener)
	        .on('$destroy', function() {
	          rgCtrl.remove(render);
	        });
	    }
	
	    /**
	     * On click functionality.
	     */
	    function listener(ev) {
	      if (element[0].hasAttribute('disabled') || rgCtrl.isDisabled()) return;
	
	      scope.$apply(function() {
	        rgCtrl.setViewValue(attr.value, ev && ev.type);
	      });
	    }
	
	    /**
	     *  Add or remove the `.md-checked` class from the RadioButton (and conditionally its parent).
	     *  Update the `aria-activedescendant` attribute.
	     */
	    function render() {
	      var checked = rgCtrl.getViewValue() == attr.value;
	
	      if (checked === lastChecked) return;
	
	      if (element[0].parentNode.nodeName.toLowerCase() !== 'md-radio-group') {
	        // If the radioButton is inside a div, then add class so highlighting will work
	        element.parent().toggleClass(CHECKED_CSS, checked);
	      }
	
	      if (checked) {
	        rgCtrl.setActiveDescendant(element.attr('id'));
	      }
	
	      lastChecked = checked;
	
	      element
	        .attr('aria-checked', checked)
	        .toggleClass(CHECKED_CSS, checked);
	    }
	
	    /**
	     * Inject ARIA-specific attributes appropriate for each radio button
	     */
	    function configureAria(element, scope){
	      element.attr({
	        id: attr.id || 'radio_' + $mdUtil.nextUid(),
	        role: 'radio',
	        'aria-checked': 'false'
	      });
	
	      $mdAria.expectWithText(element, 'aria-label');
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.select
	 */
	
	/***************************************************
	
	 ### TODO ###
	 - [ ] Abstract placement logic in $mdSelect service to $mdMenu service
	
	 ***************************************************/
	
	SelectDirective.$inject = ["$mdSelect", "$mdUtil", "$mdConstant", "$mdTheming", "$mdAria", "$parse", "$sce", "$injector"];
	SelectMenuDirective.$inject = ["$parse", "$mdUtil", "$mdConstant", "$mdTheming"];
	OptionDirective.$inject = ["$mdButtonInkRipple", "$mdUtil", "$mdTheming"];
	SelectProvider.$inject = ["$$interimElementProvider"];
	OptionController.$inject = ["$element"];
	var SELECT_EDGE_MARGIN = 8;
	var selectNextId = 0;
	var CHECKBOX_SELECTION_INDICATOR =
	  angular.element('<div class="md-container"><div class="md-icon"></div></div>');
	
	angular.module('material.components.select', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .directive('mdSelect', SelectDirective)
	  .directive('mdSelectMenu', SelectMenuDirective)
	  .directive('mdOption', OptionDirective)
	  .directive('mdOptgroup', OptgroupDirective)
	  .directive('mdSelectHeader', SelectHeaderDirective)
	  .provider('$mdSelect', SelectProvider);
	
	/**
	 * @ngdoc directive
	 * @name mdSelect
	 * @restrict E
	 * @module material.components.select
	 *
	 * @description Displays a select box, bound to an `ng-model`. Selectable options are defined using
	 * the <a ng-href="api/directive/mdOption">md-option</a> element directive. Options can be grouped
	 * using the <a ng-href="api/directive/mdOptgroup">md-optgroup</a> element directive.
	 *
	 * When the select is required and uses a floating label, then the label will automatically contain
	 * an asterisk (`*`). This behavior can be disabled by using the `md-no-asterisk` attribute.
	 *
	 * By default, the select will display with an underline to match other form elements. This can be
	 * disabled by applying the `md-no-underline` CSS class.
	 *
	 * @param {expression} ng-model Assignable angular expression to data-bind to.
	 * @param {expression=} ng-change Expression to be executed when the model value changes.
	 * @param {boolean=} multiple When present, allows for more than one option to be selected.
	 *  The model is an array with the selected choices. **Note:** This attribute is only evaluated
	 *  once; it is not watched.
	 * @param {expression=} md-on-close Expression to be evaluated when the select is closed.
	 * @param {expression=} md-on-open Expression to be evaluated when opening the select.
	 *  Will hide the select options and show a spinner until the evaluated promise resolves.
	 * @param {expression=} md-selected-text Expression to be evaluated that will return a string
	 *  to be displayed as a placeholder in the select input box when it is closed. The value
	 *  will be treated as *text* (not html).
	 * @param {expression=} md-selected-html Expression to be evaluated that will return a string
	 *  to be displayed as a placeholder in the select input box when it is closed. The value
	 *  will be treated as *html*. The value must either be explicitly marked as trustedHtml or
	 *  the ngSanitize module must be loaded.
	 * @param {string=} placeholder Placeholder hint text.
	 * @param {boolean=} md-no-asterisk When set to true, an asterisk will not be appended to the
	 *  floating label. **Note:** This attribute is only evaluated once; it is not watched.
	 * @param {string=} aria-label Optional label for accessibility. Only necessary if no explicit label
	 *  is present.
	 * @param {string=} md-container-class Class list to get applied to the `.md-select-menu-container`
	 *  element (for custom styling).
	 * @param {string=} md-select-only-option If specified, a `<md-select>` will automatically select
	 * it's first option, if it only has one.
	 *
	 * @usage
	 * With a placeholder (label and aria-label are added dynamically)
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <md-select
	 *       ng-model="someModel"
	 *       placeholder="Select a state">
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * With an explicit label
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <label>State</label>
	 *     <md-select
	 *       ng-model="someModel">
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * Using the `md-select-header` element directive
	 *
	 * When a developer needs to put more than just a text label in the `md-select-menu`, they should
	 * use one or more `md-select-header`s. These elements can contain custom HTML which can be styled
	 * as desired. Use cases for this element include a sticky search bar and custom option group
	 * labels.
	 *
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <md-select ng-model="someModel">
	 *       <md-select-header>
	 *         <span> Neighborhoods - </span>
	 *       </md-select-header>
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * ## Selects and object equality
	 * When using a `md-select` to pick from a list of objects, it is important to realize how javascript handles
	 * equality. Consider the following example:
	 * <hljs lang="js">
	 * angular.controller('MyCtrl', function($scope) {
	 *   $scope.users = [
	 *     { id: 1, name: 'Bob' },
	 *     { id: 2, name: 'Alice' },
	 *     { id: 3, name: 'Steve' }
	 *   ];
	 *   $scope.selectedUser = { id: 1, name: 'Bob' };
	 * });
	 * </hljs>
	 * <hljs lang="html">
	 * <div ng-controller="MyCtrl">
	 *   <md-select ng-model="selectedUser">
	 *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
	 *   </md-select>
	 * </div>
	 * </hljs>
	 *
	 * At first one might expect that the select should be populated with "Bob" as the selected user.
	 * However, this is not true. To determine whether something is selected,
	 * `ngModelController` is looking at whether `$scope.selectedUser == (any user in $scope.users);`;
	 *
	 * Javascript's `==` operator does not check for deep equality (ie. that all properties
	 * on the object are the same), but instead whether the objects are *the same object in memory*.
	 * In this case, we have two instances of identical objects, but they exist in memory as unique
	 * entities. Because of this, the select will have no value populated for a selected user.
	 *
	 * To get around this, `ngModelController` provides a `track by` option that allows us to specify a
	 * different expression which will be used for the equality operator. As such, we can update our
	 * `html` to make use of this by specifying the `ng-model-options="{trackBy: '$value.id'}"` on the
	 * `md-select` element. This converts our equality expression to be
	 * `$scope.selectedUser.id == (any id in $scope.users.map(function(u) { return u.id; }));`
	 * which results in Bob being selected as desired.
	 *
	 * **Note:** We do not support AngularJS's `track by` syntax. For instance
	 *  `ng-options="user in users track by user.id"` will not work with `md-select`.
	 *
	 * Working HTML:
	 * <hljs lang="html">
	 * <div ng-controller="MyCtrl">
	 *   <md-select ng-model="selectedUser" ng-model-options="{trackBy: '$value.id'}">
	 *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
	 *   </md-select>
	 * </div>
	 * </hljs>
	 */
	function SelectDirective($mdSelect, $mdUtil, $mdConstant, $mdTheming, $mdAria, $parse, $sce,
	    $injector) {
	  return {
	    restrict: 'E',
	    require: ['^?mdInputContainer', 'mdSelect', 'ngModel', '?^form'],
	    compile: compile,
	    controller: function() {
	    } // empty placeholder controller to be initialized in link
	  };
	
	  function compile(tElement, tAttrs) {
	    var isMultiple = $mdUtil.parseAttributeBoolean(tAttrs.multiple);
	    // add the select value that will hold our placeholder or selected option value
	    var valueEl = angular.element('<md-select-value><span></span></md-select-value>');
	    valueEl.append('<span class="md-select-icon" aria-hidden="true"></span>');
	    valueEl.addClass('md-select-value');
	    if (!valueEl[0].hasAttribute('id')) {
	      valueEl.attr('id', 'select_value_label_' + $mdUtil.nextUid());
	    }
	
	    // There's got to be an md-content inside. If there's not one, let's add it.
	    var mdContentEl = tElement.find('md-content');
	    if (!mdContentEl.length) {
	      tElement.append(angular.element('<md-content>').append(tElement.contents()));
	      mdContentEl = tElement.find('md-content');
	    }
	    mdContentEl.attr('role', 'listbox');
	    mdContentEl.attr('tabindex', '-1');
	
	    if (isMultiple) {
	      mdContentEl.attr('aria-multiselectable', 'true');
	    } else {
	      mdContentEl.attr('aria-multiselectable', 'false');
	    }
	
	    // Add progress spinner for md-options-loading
	    if (tAttrs.mdOnOpen) {
	
	      // Show progress indicator while loading async
	      // Use ng-hide for `display:none` so the indicator does not interfere with the options list
	      tElement
	        .find('md-content')
	        .prepend(angular.element(
	          '<div>' +
	          ' <md-progress-circular md-mode="indeterminate" ng-if="$$loadingAsyncDone === false"' +
	          ' md-diameter="25px"></md-progress-circular>' +
	          '</div>'
	        ));
	
	      // Hide list [of item options] while loading async
	      tElement
	        .find('md-option')
	        .attr('ng-show', '$$loadingAsyncDone');
	    }
	
	    if (tAttrs.name) {
	      var autofillClone = angular.element('<select class="md-visually-hidden"></select>');
	      autofillClone.attr({
	        'name': tAttrs.name,
	        'aria-hidden': 'true',
	        'tabindex': '-1'
	      });
	      var opts = tElement.find('md-option');
	      angular.forEach(opts, function(el) {
	        var newEl = angular.element('<option>' + el.innerHTML + '</option>');
	        if (el.hasAttribute('ng-value')) {
	          newEl.attr('ng-value', el.getAttribute('ng-value'));
	        }
	        else if (el.hasAttribute('value')) {
	          newEl.attr('value', el.getAttribute('value'));
	        }
	        autofillClone.append(newEl);
	      });
	
	      // Adds an extra option that will hold the selected value for the
	      // cases where the select is a part of a non-AngularJS form. This can be done with a ng-model,
	      // however if the `md-option` is being `ng-repeat`-ed, AngularJS seems to insert a similar
	      // `option` node, but with a value of `? string: <value> ?` which would then get submitted.
	      // This also goes around having to prepend a dot to the name attribute.
	      autofillClone.append(
	        '<option ng-value="' + tAttrs.ngModel + '" selected></option>'
	      );
	
	      tElement.parent().append(autofillClone);
	    }
	
	    // Use everything that's left inside element.contents() as the contents of the menu
	    var multipleContent = isMultiple ? 'multiple' : '';
	    var ngModelOptions = tAttrs.ngModelOptions ? $mdUtil.supplant('ng-model-options="{0}"', [tAttrs.ngModelOptions]) : '';
	    var selectTemplate = '' +
	      '<div class="md-select-menu-container" aria-hidden="true" role="presentation">' +
	      '  <md-select-menu role="presentation" {0} {1}>{2}</md-select-menu>' +
	      '</div>';
	
	    selectTemplate = $mdUtil.supplant(selectTemplate, [multipleContent, ngModelOptions,  tElement.html()]);
	    tElement.empty().append(valueEl);
	    tElement.append(selectTemplate);
	
	    if (!tAttrs.tabindex) {
	      tAttrs.$set('tabindex', 0);
	    }
	
	    return function postLink(scope, element, attrs, ctrls) {
	      var untouched = true;
	      var isDisabled;
	
	      var containerCtrl = ctrls[0];
	      var mdSelectCtrl = ctrls[1];
	      var ngModelCtrl = ctrls[2];
	      var formCtrl = ctrls[3];
	      // grab a reference to the select menu value label
	      var selectValueElement = element.find('md-select-value');
	      var isReadonly = angular.isDefined(attrs.readonly);
	      var disableAsterisk = $mdUtil.parseAttributeBoolean(attrs.mdNoAsterisk);
	      var stopNgMultipleWatch;
	      var userDefinedLabelledby = angular.isDefined(attrs.ariaLabelledby);
	      var listboxContentElement = element.find('md-content');
	
	      if (disableAsterisk) {
	        element.addClass('md-no-asterisk');
	      }
	
	      if (containerCtrl) {
	        var isErrorGetter = containerCtrl.isErrorGetter || function() {
	          return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (formCtrl && formCtrl.$submitted));
	        };
	
	        if (containerCtrl.input) {
	          // We ignore inputs that are in the md-select-header (one
	          // case where this might be useful would be adding as searchbox)
	          if (element.find('md-select-header').find('input')[0] !== containerCtrl.input[0]) {
	            throw new Error("<md-input-container> can only have *one* child <input>, <textarea> or <select> element!");
	          }
	        }
	
	        containerCtrl.input = element;
	        if (!containerCtrl.label) {
	          $mdAria.expect(element, 'aria-label', element.attr('placeholder'));
	          var selectLabel = element.attr('aria-label');
	          if (!selectLabel) {
	            selectLabel = element.attr('placeholder');
	          }
	          listboxContentElement.attr('aria-label', selectLabel);
	        } else {
	          containerCtrl.label.attr('aria-hidden', 'true');
	          listboxContentElement.attr('aria-label', containerCtrl.label.text());
	        }
	
	        var stopInvalidWatch = scope.$watch(isErrorGetter, containerCtrl.setInvalid);
	      }
	
	      var selectContainer, selectScope, selectMenuCtrl;
	
	      selectContainer = findSelectContainer();
	      $mdTheming(element);
	
	      var originalRender = ngModelCtrl.$render;
	      ngModelCtrl.$render = function() {
	        originalRender();
	        syncSelectValueText();
	        inputCheckValue();
	      };
	
	      var stopPlaceholderObserver = attrs.$observe('placeholder', ngModelCtrl.$render);
	
	      var stopRequiredObserver = attrs.$observe('required', function (value) {
	        if (containerCtrl && containerCtrl.label) {
	          // Toggle the md-required class on the input containers label, because the input container
	          // is automatically applying the asterisk indicator on the label.
	          containerCtrl.label.toggleClass('md-required', value && !disableAsterisk);
	        }
	        element.removeAttr('aria-required');
	        if (value) {
	          listboxContentElement.attr('aria-required', 'true');
	        } else {
	          listboxContentElement.removeAttr('aria-required');
	        }
	      });
	
	      /**
	       * Set the contents of the md-select-value element. This element's contents are announced by
	       * screen readers and used for displaying the value of the select in both single and multiple
	       * selection modes.
	       * @param {string=} text A sanitized and trusted HTML string or a pure text string from user
	       *  input.
	       */
	      mdSelectCtrl.setSelectValueText = function(text) {
	        var useDefaultText = text === undefined || text === '';
	        // Whether the select label has been given via user content rather than the internal
	        // template of <md-option>
	        var isSelectLabelFromUser = false;
	
	        mdSelectCtrl.setIsPlaceholder(!text);
	
	        if (attrs.mdSelectedText && attrs.mdSelectedHtml) {
	          throw Error('md-select cannot have both `md-selected-text` and `md-selected-html`');
	        }
	
	        if (attrs.mdSelectedText || attrs.mdSelectedHtml) {
	          text = $parse(attrs.mdSelectedText || attrs.mdSelectedHtml)(scope);
	          isSelectLabelFromUser = true;
	        } else if (useDefaultText) {
	          // Use placeholder attribute, otherwise fallback to the md-input-container label
	          var tmpPlaceholder = attrs.placeholder ||
	              (containerCtrl && containerCtrl.label ? containerCtrl.label.text() : '');
	
	          text = tmpPlaceholder || '';
	          isSelectLabelFromUser = true;
	        }
	
	        var target = selectValueElement.children().eq(0);
	
	        if (attrs.mdSelectedHtml) {
	          // Using getTrustedHtml will run the content through $sanitize if it is not already
	          // explicitly trusted. If the ngSanitize module is not loaded, this will
	          // *correctly* throw an sce error.
	          target.html($sce.getTrustedHtml(text));
	        } else if (isSelectLabelFromUser) {
	          target.text(text);
	        } else {
	          // If we've reached this point, the text is not user-provided.
	          target.html(text);
	        }
	
	        if (useDefaultText) {
	          // Avoid screen readers double announcing the label name when no value has been selected
	          selectValueElement.attr('aria-hidden', 'true');
	          if (!userDefinedLabelledby) {
	            element.removeAttr('aria-labelledby');
	          }
	        } else {
	          selectValueElement.removeAttr('aria-hidden');
	          if (!userDefinedLabelledby) {
	            element.attr('aria-labelledby', element[0].id + ' ' + selectValueElement[0].id)
	          }
	        }
	      };
	
	      /**
	       * @param {boolean} isPlaceholder true to mark the md-select-value element and
	       *  input container, if one exists, with classes for styling when a placeholder is present.
	       *  false to remove those classes.
	       */
	      mdSelectCtrl.setIsPlaceholder = function(isPlaceholder) {
	        if (isPlaceholder) {
	          selectValueElement.addClass('md-select-placeholder');
	          if (containerCtrl && containerCtrl.label) {
	            containerCtrl.label.addClass('md-placeholder');
	          }
	        } else {
	          selectValueElement.removeClass('md-select-placeholder');
	          if (containerCtrl && containerCtrl.label) {
	            containerCtrl.label.removeClass('md-placeholder');
	          }
	        }
	      };
	
	      if (!isReadonly) {
	        var handleBlur = function(event) {
	          // Attach before ngModel's blur listener to stop propagation of blur event
	          // and prevent setting $touched.
	          if (untouched) {
	            untouched = false;
	            if (selectScope._mdSelectIsOpen) {
	              event.stopImmediatePropagation();
	            }
	          }
	
	          containerCtrl && containerCtrl.setFocused(false);
	          inputCheckValue();
	        };
	        var handleFocus = function(ev) {
	          // Always focus the container (if we have one) so floating labels and other styles are
	          // applied properly
	          containerCtrl && containerCtrl.setFocused(true);
	        };
	
	        element.on('focus', handleFocus);
	        element.on('blur', handleBlur);
	      }
	
	      mdSelectCtrl.triggerClose = function() {
	        $parse(attrs.mdOnClose)(scope);
	      };
	
	      scope.$$postDigest(function() {
	        initAriaLabel();
	        syncSelectValueText();
	      });
	
	      function initAriaLabel() {
	        var labelText = element.attr('aria-label') || element.attr('placeholder');
	        if (!labelText && containerCtrl && containerCtrl.label) {
	          labelText = containerCtrl.label.text();
	        }
	        $mdAria.expect(element, 'aria-label', labelText);
	      }
	
	      var stopSelectedLabelsWatcher = scope.$watch(function() {
	        return selectMenuCtrl.getSelectedLabels();
	      }, syncSelectValueText);
	
	      function syncSelectValueText() {
	        selectMenuCtrl = selectMenuCtrl ||
	          selectContainer.find('md-select-menu').controller('mdSelectMenu');
	        mdSelectCtrl.setSelectValueText(selectMenuCtrl.getSelectedLabels());
	      }
	
	      // TODO add tests for ngMultiple
	      // TODO add docs for ngMultiple
	      // TODO in 1.2.0 rename this to mdMultiple
	      var stopNgMultipleObserver = attrs.$observe('ngMultiple', function(val) {
	        if (stopNgMultipleWatch) {
	          stopNgMultipleWatch();
	        }
	        var parser = $parse(val);
	        stopNgMultipleWatch = scope.$watch(function() {
	          return parser(scope);
	        }, function(multiple, prevVal) {
	          var selectMenu = selectContainer.find('md-select-menu');
	          // assume compiler did a good job
	          if (multiple === undefined && prevVal === undefined) {
	            return;
	          }
	          if (multiple) {
	            var setMultipleAttrs = {'multiple': 'multiple'};
	            element.attr(setMultipleAttrs);
	            selectMenu.attr(setMultipleAttrs);
	          } else {
	            element.removeAttr('multiple');
	            selectMenu.removeAttr('multiple');
	          }
	          element.find('md-content').attr('aria-multiselectable', multiple ? 'true' : 'false');
	
	          if (selectContainer) {
	            selectMenuCtrl.setMultiple(Boolean(multiple));
	            originalRender = ngModelCtrl.$render;
	            ngModelCtrl.$render = function() {
	              originalRender();
	              syncSelectValueText();
	              inputCheckValue();
	            };
	            ngModelCtrl.$render();
	          }
	        });
	      });
	
	      var stopDisabledObserver = attrs.$observe('disabled', function(disabled) {
	        if (angular.isString(disabled)) {
	          disabled = true;
	        }
	        // Prevent click event being registered twice
	        if (isDisabled !== undefined && isDisabled === disabled) {
	          return;
	        }
	        isDisabled = disabled;
	        if (disabled) {
	          element
	            .attr({'aria-disabled': 'true'})
	            .removeAttr('tabindex')
	            .removeAttr('aria-expanded')
	            .removeAttr('aria-haspopup')
	            .off('click', openSelect)
	            .off('keydown', handleKeypress);
	        } else {
	          element
	            .attr({
	              'tabindex': attrs.tabindex,
	              'aria-haspopup': 'listbox'
	            })
	            .removeAttr('aria-disabled')
	            .on('click', openSelect)
	            .on('keydown', handleKeypress);
	        }
	      });
	
	      if (!attrs.hasOwnProperty('disabled') && !attrs.hasOwnProperty('ngDisabled')) {
	        element.attr({'aria-disabled': 'false'});
	        element.on('click', openSelect);
	        element.on('keydown', handleKeypress);
	      }
	
	      var ariaAttrs = {
	        role: 'button',
	        'aria-haspopup': 'listbox'
	      };
	
	      if (!element[0].hasAttribute('id')) {
	        ariaAttrs.id = 'select_' + $mdUtil.nextUid();
	      }
	
	      var containerId = 'select_container_' + $mdUtil.nextUid();
	      selectContainer.attr('id', containerId);
	      var listboxContentId = 'select_listbox_' + $mdUtil.nextUid();
	      selectContainer.find('md-content').attr('id', listboxContentId);
	      // Only add aria-owns if element ownership is NOT represented in the DOM.
	      if (!element.find('md-select-menu').length) {
	        ariaAttrs['aria-owns'] = listboxContentId;
	      }
	      element.attr(ariaAttrs);
	
	      scope.$on('$destroy', function() {
	        stopRequiredObserver && stopRequiredObserver();
	        stopDisabledObserver && stopDisabledObserver();
	        stopNgMultipleWatch && stopNgMultipleWatch();
	        stopNgMultipleObserver && stopNgMultipleObserver();
	        stopSelectedLabelsWatcher && stopSelectedLabelsWatcher();
	        stopPlaceholderObserver && stopPlaceholderObserver();
	        stopInvalidWatch && stopInvalidWatch();
	
	        element.off('focus');
	        element.off('blur');
	
	        $mdSelect
	          .destroy()
	          .finally(function() {
	            if (containerCtrl) {
	              containerCtrl.setFocused(false);
	              containerCtrl.setHasValue(false);
	              containerCtrl.input = null;
	            }
	            ngModelCtrl.$setTouched();
	          });
	      });
	
	      function inputCheckValue() {
	        // The select counts as having a value if one or more options are selected,
	        // or if the input's validity state says it has bad input (eg string in a number input)
	        // we must do this on nextTick as the $render is sometimes invoked on nextTick.
	        $mdUtil.nextTick(function () {
	          containerCtrl && containerCtrl.setHasValue(
	            selectMenuCtrl.getSelectedLabels().length > 0 || (element[0].validity || {}).badInput);
	        });
	      }
	
	      function findSelectContainer() {
	        var selectContainer = angular.element(
	          element[0].querySelector('.md-select-menu-container')
	        );
	        selectScope = scope;
	        attrs.mdContainerClass && selectContainer.addClass(attrs.mdContainerClass);
	        selectMenuCtrl = selectContainer.find('md-select-menu').controller('mdSelectMenu');
	        selectMenuCtrl.init(ngModelCtrl, attrs);
	        element.on('$destroy', function() {
	          selectContainer.remove();
	        });
	        return selectContainer;
	      }
	
	      /**
	       * Determine if the select menu should be opened or an option in the select menu should be
	       * selected.
	       * @param {KeyboardEvent} e keyboard event to handle
	       */
	      function handleKeypress(e) {
	        if ($mdConstant.isNavigationKey(e)) {
	          // prevent page scrolling on interaction
	          e.preventDefault();
	          openSelect(e);
	        } else {
	          if (shouldHandleKey(e, $mdConstant)) {
	            e.preventDefault();
	
	            var node = selectMenuCtrl.optNodeForKeyboardSearch(e);
	            if (!node || node.hasAttribute('disabled')) {
	              return;
	            }
	            var optionCtrl = angular.element(node).controller('mdOption');
	            if (!selectMenuCtrl.isMultiple) {
	              angular.forEach(Object.keys(selectMenuCtrl.selected), function (key) {
	                selectMenuCtrl.deselect(key);
	              });
	            }
	            selectMenuCtrl.select(optionCtrl.hashKey, optionCtrl.value);
	            selectMenuCtrl.refreshViewValue();
	          }
	        }
	      }
	
	      function openSelect() {
	        selectScope._mdSelectIsOpen = true;
	        element.attr('aria-expanded', 'true');
	
	        $mdSelect.show({
	          scope: selectScope,
	          preserveScope: true,
	          skipCompile: true,
	          element: selectContainer,
	          target: element[0],
	          selectCtrl: mdSelectCtrl,
	          preserveElement: true,
	          hasBackdrop: true,
	          loadingAsync: attrs.mdOnOpen ? scope.$eval(attrs.mdOnOpen) || true : false
	        }).finally(function() {
	          selectScope._mdSelectIsOpen = false;
	          element.removeAttr('aria-expanded');
	          element.removeAttr('aria-activedescendant');
	          ngModelCtrl.$setTouched();
	        });
	      }
	
	    };
	  }
	}
	
	function SelectMenuDirective($parse, $mdUtil, $mdConstant, $mdTheming) {
	  // We want the scope to be set to 'false' so an isolated scope is not created
	  // which would interfere with the md-select-header's access to the
	  // parent scope.
	  SelectMenuController.$inject = ["$scope", "$attrs", "$element"];
	  return {
	    restrict: 'E',
	    require: ['mdSelectMenu'],
	    scope: false,
	    controller: SelectMenuController,
	    link: {pre: preLink}
	  };
	
	  // We use preLink instead of postLink to ensure that the select is initialized before
	  // its child options run postLink.
	  function preLink(scope, element, attrs, ctrls) {
	    var selectMenuCtrl = ctrls[0];
	
	    element.addClass('_md');     // private md component indicator for styling
	
	    $mdTheming(element);
	    element.on('click', clickListener);
	    element.on('keypress', keyListener);
	
	    function keyListener(e) {
	      if (e.keyCode === 13 || e.keyCode === 32) {
	        clickListener(e);
	      }
	    }
	
	    function clickListener(ev) {
	      var option = $mdUtil.getClosest(ev.target, 'md-option');
	      var optionCtrl = option && angular.element(option).data('$mdOptionController');
	      if (!option || !optionCtrl) return;
	      if (option.hasAttribute('disabled')) {
	        ev.stopImmediatePropagation();
	        return false;
	      }
	
	      var optionHashKey = selectMenuCtrl.hashGetter(optionCtrl.value);
	      var isSelected = angular.isDefined(selectMenuCtrl.selected[optionHashKey]);
	
	      scope.$apply(function() {
	        if (selectMenuCtrl.isMultiple) {
	          if (isSelected) {
	            selectMenuCtrl.deselect(optionHashKey);
	          } else {
	            selectMenuCtrl.select(optionHashKey, optionCtrl.value);
	          }
	        } else {
	          if (!isSelected) {
	            angular.forEach(Object.keys(selectMenuCtrl.selected), function (key) {
	              selectMenuCtrl.deselect(key);
	            });
	            selectMenuCtrl.select(optionHashKey, optionCtrl.value);
	          }
	        }
	        selectMenuCtrl.refreshViewValue();
	      });
	    }
	  }
	
	  function SelectMenuController($scope, $attrs, $element) {
	    var self = this;
	    var defaultIsEmpty;
	    var searchStr = '';
	    var clearSearchTimeout, optNodes, optText;
	    var CLEAR_SEARCH_AFTER = 300;
	
	    self.isMultiple = angular.isDefined($attrs.multiple);
	    // selected is an object with keys matching all of the selected options' hashed values
	    self.selected = {};
	    // options is an object with keys matching every option's hash value,
	    // and values containing an instance of every option's controller.
	    self.options = {};
	
	    $scope.$watchCollection(function() {
	      return self.options;
	    }, function() {
	      self.ngModel.$render();
	      updateOptionSetSizeAndPosition();
	    });
	
	    /**
	     * @param {boolean} isMultiple
	     */
	    self.setMultiple = function(isMultiple) {
	      var ngModel = self.ngModel;
	      defaultIsEmpty = defaultIsEmpty || ngModel.$isEmpty;
	      self.isMultiple = isMultiple;
	
	      if (self.isMultiple) {
	        // We want to delay the render method so that the directive has a chance to load before
	        // rendering, this prevents the control being marked as dirty onload.
	        var loaded = false;
	        var delayedRender = function(val) {
	          if (!loaded) {
	            $mdUtil.nextTick(function () {
	              renderMultiple(val);
	              loaded = true;
	            });
	          } else {
	            renderMultiple(val);
	          }
	        };
	        ngModel.$validators['md-multiple'] = validateArray;
	        ngModel.$render = delayedRender;
	
	        // watchCollection on the model because by default ngModel only watches the model's
	        // reference. This allows the developer to also push and pop from their array.
	        $scope.$watchCollection(self.modelBinding, function(value) {
	          if (validateArray(value)) {
	            delayedRender(value);
	          }
	        });
	
	        ngModel.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	      } else {
	        delete ngModel.$validators['md-multiple'];
	        ngModel.$render = renderSingular;
	      }
	
	      function validateArray(modelValue, viewValue) {
	        // If a value is truthy but not an array, reject it.
	        // If value is undefined/falsy, accept that it's an empty array.
	        return angular.isArray(modelValue || viewValue || []);
	      }
	    };
	
	    /**
	     * @param {KeyboardEvent} keyboardEvent keyboard event to handle
	     * @return {Element|HTMLElement|undefined}
	     */
	    self.optNodeForKeyboardSearch = function(keyboardEvent) {
	      var search, i;
	      clearSearchTimeout && clearTimeout(clearSearchTimeout);
	      clearSearchTimeout = setTimeout(function() {
	        clearSearchTimeout = undefined;
	        searchStr = '';
	        optText = undefined;
	        optNodes = undefined;
	      }, CLEAR_SEARCH_AFTER);
	
	      searchStr += keyboardEvent.key;
	      search = new RegExp('^' + $mdUtil.sanitize(searchStr), 'i');
	      if (!optNodes) {
	        optNodes = $element.find('md-option');
	        optText = new Array(optNodes.length);
	        angular.forEach(optNodes, function(el, i) {
	          optText[i] = el.textContent.trim();
	        });
	      }
	
	      for (i = 0; i < optText.length; ++i) {
	        if (search.test(optText[i])) {
	          return optNodes[i];
	        }
	      }
	    };
	
	    self.init = function(ngModel, parentAttrs) {
	      self.ngModel = ngModel;
	      self.modelBinding = parentAttrs.ngModel;
	
	      // Setup a more robust version of isEmpty to ensure value is a valid option
	      self.ngModel.$isEmpty = function($viewValue) {
	        // We have to transform the viewValue into the hashKey, because otherwise the
	        // OptionCtrl may not exist. Developers may have specified a trackBy function.
	        return !self.options[self.hashGetter($viewValue)];
	      };
	
	      // Allow users to provide `ng-model="foo" ng-model-options="{trackBy: '$value.id'}"` so
	      // that we can properly compare objects set on the model to the available options
	      //
	      // If the user doesn't provide a trackBy, we automatically generate an id for every
	      // value passed in with the getId function
	      if ($attrs.ngModelOptions) {
	        self.hashGetter = function(value) {
	          var ngModelOptions = $parse($attrs.ngModelOptions)($scope);
	          var trackByOption = ngModelOptions && ngModelOptions.trackBy;
	
	          if (trackByOption) {
	            return $parse(trackByOption)($scope, { $value: value });
	          } else if (angular.isObject(value)) {
	            return getId(value);
	          }
	          return value;
	        };
	      } else {
	        self.hashGetter = getId;
	      }
	      self.setMultiple(self.isMultiple);
	
	      /**
	       * If the value is an object, get the unique, incremental id of the value.
	       * If it's not an object, the value will be converted to a string and then returned.
	       * @param value
	       * @returns {string}
	       */
	      function getId(value) {
	        if (angular.isObject(value) && !angular.isArray(value)) {
	          return 'object_' + (value.$$mdSelectId || (value.$$mdSelectId = ++selectNextId));
	        }
	        return value + '';
	      }
	
	      if (parentAttrs.hasOwnProperty('mdSelectOnlyOption')) {
	        $mdUtil.nextTick(function() {
	          var optionKeys = Object.keys(self.options);
	
	          if (optionKeys.length === 1) {
	            var option = self.options[optionKeys[0]];
	
	            self.deselect(Object.keys(self.selected)[0]);
	            self.select(self.hashGetter(option.value), option.value);
	            self.refreshViewValue();
	            self.ngModel.$setPristine();
	          }
	        }, false);
	      }
	    };
	
	    /**
	     * @param {string=} id
	     */
	    self.setActiveDescendant = function(id) {
	      if (angular.isDefined(id)) {
	        $element.find('md-content').attr('aria-activedescendant', id);
	      } else {
	        $element.find('md-content').removeAttr('aria-activedescendant');
	      }
	    };
	
	    /**
	     * @param {{mode: string}=} opts options object to allow specifying html (default) or aria mode.
	     * @return {string} comma separated set of selected values
	     */
	    self.getSelectedLabels = function(opts) {
	      opts = opts || {};
	      var mode = opts.mode || 'html';
	      var selectedOptionEls =
	        $mdUtil.nodesToArray($element[0].querySelectorAll('md-option[selected]'));
	
	      if (selectedOptionEls.length) {
	        var mapFn;
	
	        if (mode === 'html') {
	          // Map the given element to its innerHTML string. If the element has a child ripple
	          // container remove it from the HTML string, before returning the string.
	          mapFn = function(el) {
	            // If we do not have a `value` or `ng-value`, assume it is an empty option which clears
	            // the select.
	            if (el.hasAttribute('md-option-empty')) {
	              return '';
	            }
	
	            var html = el.innerHTML;
	
	            // Remove the ripple container from the selected option, copying it would cause a CSP
	            // violation.
	            var rippleContainer = el.querySelector('.md-ripple-container');
	            if (rippleContainer) {
	              html = html.replace(rippleContainer.outerHTML, '');
	            }
	
	            // Remove the checkbox container, because it will cause the label to wrap inside of the
	            // placeholder. It should be not displayed inside of the label element.
	            var checkboxContainer = el.querySelector('.md-container');
	            if (checkboxContainer) {
	              html = html.replace(checkboxContainer.outerHTML, '');
	            }
	
	            return html;
	          };
	        } else if (mode === 'aria') {
	          mapFn = function(el) {
	            return el.hasAttribute('aria-label') ? el.getAttribute('aria-label') : el.textContent;
	          };
	        }
	
	        // Ensure there are no duplicates; see https://github.com/angular/material/issues/9442
	        return $mdUtil.uniq(selectedOptionEls.map(mapFn)).join(', ');
	      } else {
	        return '';
	      }
	    };
	
	    /**
	     * Mark an option as selected
	     * @param {string} hashKey key within the SelectMenuController.options object, which is an
	     *  instance of OptionController.
	     * @param {OptionController} hashedValue value to associate with the key
	     */
	    self.select = function(hashKey, hashedValue) {
	      var option = self.options[hashKey];
	      option && option.setSelected(true, self.isMultiple);
	      self.selected[hashKey] = hashedValue;
	    };
	
	    /**
	     * Mark an option as not selected
	     * @param {string} hashKey key within the SelectMenuController.options object, which is an
	     *  instance of OptionController.
	     */
	    self.deselect = function(hashKey) {
	      var option = self.options[hashKey];
	      option && option.setSelected(false, self.isMultiple);
	      delete self.selected[hashKey];
	    };
	
	    /**
	     * Add an option to the select
	     * @param {string} hashKey key within the SelectMenuController.options object, which is an
	     *  instance of OptionController.
	     * @param {OptionController} optionCtrl instance to associate with the key
	     */
	    self.addOption = function(hashKey, optionCtrl) {
	      if (angular.isDefined(self.options[hashKey])) {
	        throw new Error('Duplicate md-option values are not allowed in a select. ' +
	          'Duplicate value "' + optionCtrl.value + '" found.');
	      }
	
	      self.options[hashKey] = optionCtrl;
	
	      // If this option's value was already in our ngModel, go ahead and select it.
	      if (angular.isDefined(self.selected[hashKey])) {
	        self.select(hashKey, optionCtrl.value);
	
	        // When the current $modelValue of the ngModel Controller is using the same hash as
	        // the current option, which will be added, then we can be sure, that the validation
	        // of the option has occurred before the option was added properly.
	        // This means, that we have to manually trigger a new validation of the current option.
	        if (angular.isDefined(self.ngModel.$$rawModelValue) &&
	            self.hashGetter(self.ngModel.$$rawModelValue) === hashKey) {
	          self.ngModel.$validate();
	        }
	
	        self.refreshViewValue();
	      }
	    };
	
	    /**
	     * Remove an option from the select
	     * @param {string} hashKey key within the SelectMenuController.options object, which is an
	     *  instance of OptionController.
	     */
	    self.removeOption = function(hashKey) {
	      delete self.options[hashKey];
	      // Don't deselect an option when it's removed - the user's ngModel should be allowed
	      // to have values that do not match a currently available option.
	    };
	
	    self.refreshViewValue = function() {
	      var values = [];
	      var option;
	      for (var hashKey in self.selected) {
	        // If this hashKey has an associated option, push that option's value to the model.
	        if ((option = self.options[hashKey])) {
	          values.push(option.value);
	        } else {
	          // Otherwise, the given hashKey has no associated option, and we got it
	          // from an ngModel value at an earlier time. Push the unhashed value of
	          // this hashKey to the model.
	          // This allows the developer to put a value in the model that doesn't yet have
	          // an associated option.
	          values.push(self.selected[hashKey]);
	        }
	      }
	
	      var newVal = self.isMultiple ? values : values[0];
	      var prevVal = self.ngModel.$modelValue;
	
	      if (!equals(prevVal, newVal)) {
	        self.ngModel.$setViewValue(newVal);
	        self.ngModel.$render();
	      }
	
	      function equals(prevVal, newVal) {
	        if (self.isMultiple) {
	          if (!angular.isArray(prevVal)) {
	            // newVal is always an array when self.isMultiple is true
	            // thus, if prevVal is not an array they are different
	            return false;
	          } else if (prevVal.length !== newVal.length) {
	            // they are different if they have different length
	            return false;
	          } else {
	            // if they have the same length, then they are different
	            // if an item in the newVal array can't be found in the prevVal
	            var prevValHashes = prevVal.map(function(prevValItem) {
	              return self.hashGetter(prevValItem);
	            });
	            return newVal.every(function(newValItem) {
	              var newValItemHash = self.hashGetter(newValItem);
	              return prevValHashes.some(function(prevValHash) {
	                return prevValHash === newValItemHash;
	              });
	            });
	          }
	        } else {
	          return self.hashGetter(prevVal) === self.hashGetter(newVal);
	        }
	      }
	    };
	
	    /**
	     * If the options include md-optgroups, then we need to apply aria-setsize and aria-posinset
	     * to help screen readers understand the indexes. When md-optgroups are not used, we save on
	     * perf and extra attributes by not applying these attributes as they are not needed by screen
	     * readers.
	     */
	    function updateOptionSetSizeAndPosition() {
	      var i, options;
	      var hasOptGroup = $element.find('md-optgroup');
	      if (!hasOptGroup.length) {
	        return;
	      }
	
	      options = $element.find('md-option');
	
	      for (i = 0; i < options.length; i++) {
	        options[i].setAttribute('aria-setsize', options.length);
	        options[i].setAttribute('aria-posinset', i + 1);
	      }
	    }
	
	    function renderMultiple() {
	      var newSelectedValues = self.ngModel.$modelValue || self.ngModel.$viewValue || [];
	      if (!angular.isArray(newSelectedValues)) {
	        return;
	      }
	
	      var oldSelected = Object.keys(self.selected);
	
	      var newSelectedHashes = newSelectedValues.map(self.hashGetter);
	      var deselected = oldSelected.filter(function(hash) {
	        return newSelectedHashes.indexOf(hash) === -1;
	      });
	
	      deselected.forEach(self.deselect);
	      newSelectedHashes.forEach(function(hashKey, i) {
	        self.select(hashKey, newSelectedValues[i]);
	      });
	    }
	
	    function renderSingular() {
	      var value = self.ngModel.$viewValue || self.ngModel.$modelValue;
	      Object.keys(self.selected).forEach(self.deselect);
	      self.select(self.hashGetter(value), value);
	    }
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name mdOption
	 * @restrict E
	 * @module material.components.select
	 *
	 * @description Displays an option in a <a ng-href="api/directive/mdSelect">md-select</a> box's
	 * dropdown menu. Options can be grouped using
	 * <a ng-href="api/directive/mdOptgroup">md-optgroup</a> element directives.
	 *
	 * ### Option Params
	 *
	 * When applied, `md-option-empty` will mark the option as "empty" allowing the option to clear the
	 * select and put it back in it's default state. You may supply this attribute on any option you
	 * wish, however, it is automatically applied to an option whose `value` or `ng-value` are not
	 * defined.
	 *
	 * **Automatically Applied**
	 *
	 *  - `<md-option>`
	 *  - `<md-option value>`
	 *  - `<md-option value="">`
	 *  - `<md-option ng-value>`
	 *  - `<md-option ng-value="">`
	 *
	 * **NOT Automatically Applied**
	 *
	 *  - `<md-option ng-value="1">`
	 *  - `<md-option ng-value="''">`
	 *  - `<md-option ng-value="undefined">`
	 *  - `<md-option value="undefined">` (this evaluates to the string `"undefined"`)
	 *  - <code ng-non-bindable>&lt;md-option ng-value="{{someValueThatMightBeUndefined}}"&gt;</code>
	 *
	 * **Note:** A value of `undefined` ***is considered a valid value*** (and does not auto-apply this
	 * attribute) since you may wish this to be your "Not Available" or "None" option.
	 *
	 * **Note:** Using the
	 * <a ng-href="https://developer.mozilla.org/en-US/docs/Web/HTML/Element/option#Attributes">value</a>
	 * attribute from the `<option>` element (as opposed to the `<md-option>` element's
	 * <a ng-href="https://docs.angularjs.org/api/ng/directive/ngValue">ng-value</a>) always evaluates
	 * to a `string`. This means that `value="null"` will cause a check against `myValue != "null"`
	 * rather than `!myValue` or `myValue != null`.
	 * Importantly, this also applies to `number` values. `value="1"` will not match up with an
	 * `ng-model` like `$scope.selectedValue = 1`. Use `ng-value="1"` in this case and other cases where
	 * you have values that are not strings.
	 *
	 * **Note:** Please see our <a ng-href="api/directive/mdSelect#selects-and-object-equality">docs on
	 * using objects with `md-select`</a> for additional guidance on using the `trackBy` option with
	 * `ng-model-options`.
	 *
	 * @param {expression=} ng-value Binds the given expression to the value of the option.
	 * @param {string=} value Attribute to set the value of the option.
	 * @param {expression=} ng-repeat <a ng-href="https://docs.angularjs.org/api/ng/directive/ngRepeat">
	 *  AngularJS directive</a> that instantiates a template once per item from a collection.
	 * @param {expression=} ng-selected <a ng-href="https://docs.angularjs.org/api/ng/directive/ngSelected">
	 *  AngularJS directive</a> that adds the `selected` attribute to the option when the expression
	 *  evaluates as truthy.
	 *
	 *  **Note:** Unlike native `option` elements used with AngularJS, `md-option` elements
	 *  watch their `selected` attributes for changes and trigger model value changes on `md-select`.
	 * @param {boolean=} md-option-empty If the attribute exists, mark the option as "empty" allowing
	 * the option to clear the select and put it back in it's default state. You may supply this
	 * attribute on any option you wish, however, it is automatically applied to an option whose `value`
	 * or `ng-value` are not defined.
	 * @param {number=} tabindex The `tabindex` of the option. Defaults to `0`.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-select ng-model="currentState" placeholder="Select a state">
	 *   <md-option ng-value="AL">Alabama</md-option>
	 *   <md-option ng-value="AK">Alaska</md-option>
	 *   <md-option ng-value="FL">Florida</md-option>
	 * </md-select>
	 * </hljs>
	 *
	 * With `ng-repeat`:
	 * <hljs lang="html">
	 * <md-select ng-model="currentState" placeholder="Select a state">
	 *   <md-option ng-value="state" ng-repeat="state in states">{{ state }}</md-option>
	 * </md-select>
	 * </hljs>
	 */
	function OptionDirective($mdButtonInkRipple, $mdUtil, $mdTheming) {
	
	  return {
	    restrict: 'E',
	    require: ['mdOption', '^^mdSelectMenu'],
	    controller: OptionController,
	    compile: compile
	  };
	
	  function compile(element, attrs) {
	    // Manual transclusion to avoid the extra inner <span> that ng-transclude generates
	    element.append(angular.element('<div class="md-text">').append(element.contents()));
	
	    element.attr('tabindex', attrs.tabindex || '0');
	
	    if (!hasDefinedValue(attrs)) {
	      element.attr('md-option-empty', '');
	    }
	
	    return postLink;
	  }
	
	  /**
	   * @param {Object} attrs list of attributes from the compile function
	   * @return {string|undefined|null} if defined and non-empty, return the value of the option's
	   *  value attribute, otherwise return the value of the option's ng-value attribute.
	   */
	  function hasDefinedValue(attrs) {
	    var value = attrs.value;
	    var ngValue = attrs.ngValue;
	
	    return value || ngValue;
	  }
	
	  function postLink(scope, element, attrs, ctrls) {
	    var optionCtrl = ctrls[0];
	    var selectMenuCtrl = ctrls[1];
	
	    $mdTheming(element);
	
	    if (selectMenuCtrl.isMultiple) {
	      element.addClass('md-checkbox-enabled');
	      element.prepend(CHECKBOX_SELECTION_INDICATOR.clone());
	    }
	
	    if (angular.isDefined(attrs.ngValue)) {
	      scope.$watch(attrs.ngValue, function (newValue, oldValue) {
	        setOptionValue(newValue, oldValue);
	        element.removeAttr('aria-checked');
	      });
	    } else if (angular.isDefined(attrs.value)) {
	      setOptionValue(attrs.value);
	    } else {
	      scope.$watch(function() {
	        return element.text().trim();
	      }, setOptionValue);
	    }
	
	    attrs.$observe('disabled', function(disabled) {
	      if (disabled) {
	        element.attr('tabindex', '-1');
	      } else {
	        element.attr('tabindex', '0');
	      }
	    });
	
	    scope.$$postDigest(function() {
	      attrs.$observe('selected', function(selected) {
	        if (!angular.isDefined(selected)) return;
	        if (typeof selected == 'string') selected = true;
	        if (selected) {
	          if (!selectMenuCtrl.isMultiple) {
	            selectMenuCtrl.deselect(Object.keys(selectMenuCtrl.selected)[0]);
	          }
	          selectMenuCtrl.select(optionCtrl.hashKey, optionCtrl.value);
	        } else {
	          selectMenuCtrl.deselect(optionCtrl.hashKey);
	        }
	        selectMenuCtrl.refreshViewValue();
	      });
	    });
	
	    $mdButtonInkRipple.attach(scope, element);
	    configureAria();
	
	    /**
	     * @param {*} newValue the option's new value
	     * @param {*=} oldValue the option's previous value
	     * @param {boolean=} prevAttempt true if this had to be attempted again due to an undefined
	     *  hashGetter on the selectMenuCtrl, undefined otherwise.
	     */
	    function setOptionValue(newValue, oldValue, prevAttempt) {
	      if (!selectMenuCtrl.hashGetter) {
	        if (!prevAttempt) {
	          scope.$$postDigest(function() {
	            setOptionValue(newValue, oldValue, true);
	          });
	        }
	        return;
	      }
	      var oldHashKey = selectMenuCtrl.hashGetter(oldValue, scope);
	      var newHashKey = selectMenuCtrl.hashGetter(newValue, scope);
	
	      optionCtrl.hashKey = newHashKey;
	      optionCtrl.value = newValue;
	
	      selectMenuCtrl.removeOption(oldHashKey, optionCtrl);
	      selectMenuCtrl.addOption(newHashKey, optionCtrl);
	    }
	
	    scope.$on('$destroy', function() {
	      selectMenuCtrl.removeOption(optionCtrl.hashKey, optionCtrl);
	    });
	
	    function configureAria() {
	      var ariaAttrs = {
	        'role': 'option'
	      };
	
	      // We explicitly omit the `aria-selected` attribute from single-selection, unselected
	      // options. Including the `aria-selected="false"` attributes adds a significant amount of
	      // noise to screen-reader users without providing useful information.
	      if (selectMenuCtrl.isMultiple) {
	        ariaAttrs['aria-selected'] = 'false';
	      }
	
	      if (!element[0].hasAttribute('id')) {
	        ariaAttrs.id = 'select_option_' + $mdUtil.nextUid();
	      }
	      element.attr(ariaAttrs);
	    }
	  }
	}
	
	function OptionController($element) {
	  /**
	   * @param {boolean} isSelected
	   * @param {boolean=} isMultiple
	   */
	  this.setSelected = function(isSelected, isMultiple) {
	    if (isSelected) {
	      $element.attr({
	        'selected': 'true',
	        'aria-selected': 'true'
	      });
	    } else if (!isSelected) {
	      $element.removeAttr('selected');
	
	      if (isMultiple) {
	        $element.attr('aria-selected', 'false');
	      } else {
	        // We explicitly omit the `aria-selected` attribute from single-selection, unselected
	        // options. Including the `aria-selected="false"` attributes adds a significant amount of
	        // noise to screen-reader users without providing useful information.
	        $element.removeAttr('aria-selected');
	      }
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name mdOptgroup
	 * @restrict E
	 * @module material.components.select
	 *
	 * @description Displays a label separating groups of
	 * <a ng-href="api/directive/mdOption">md-option</a> element directives in a
	 * <a ng-href="api/directive/mdSelect">md-select</a> box's dropdown menu.
	 *
	 * **Note:** When using `md-select-header` element directives within a `md-select`, the labels that
	 * would normally be added to the <a ng-href="api/directive/mdOptgroup">md-optgroup</a> directives
	 * are omitted, allowing the `md-select-header` to represent the option group label
	 * (and possibly more).
	 *
	 * @usage
	 * With label attributes
	 * <hljs lang="html">
	 * <md-select ng-model="currentState" placeholder="Select a state">
	 *   <md-optgroup label="Southern">
	 *     <md-option ng-value="AL">Alabama</md-option>
	 *     <md-option ng-value="FL">Florida</md-option>
	 *   </md-optgroup>
	 *   <md-optgroup label="Northern">
	 *     <md-option ng-value="AK">Alaska</md-option>
	 *     <md-option ng-value="MA">Massachusetts</md-option>
	 *   </md-optgroup>
	 * </md-select>
	 * </hljs>
	 *
	 * With label elements
	 * <hljs lang="html">
	 * <md-select ng-model="currentState" placeholder="Select a state">
	 *   <md-optgroup>
	 *     <label>Southern</label>
	 *     <md-option ng-value="AL">Alabama</md-option>
	 *     <md-option ng-value="FL">Florida</md-option>
	 *   </md-optgroup>
	 *   <md-optgroup>
	 *     <label>Northern</label>
	 *     <md-option ng-value="AK">Alaska</md-option>
	 *     <md-option ng-value="MA">Massachusetts</md-option>
	 *   </md-optgroup>
	 * </md-select>
	 * </hljs>
	 *
	 * @param {string=} label The option group's label.
	 */
	function OptgroupDirective() {
	  return {
	    restrict: 'E',
	    compile: compile
	  };
	  function compile(element, attrs) {
	    // If we have a select header element, we don't want to add the normal label
	    // header.
	    if (!hasSelectHeader()) {
	      setupLabelElement();
	    }
	    element.attr('role', 'group');
	
	    function hasSelectHeader() {
	      return element.parent().find('md-select-header').length;
	    }
	
	    function setupLabelElement() {
	      var labelElement = element.find('label');
	      if (!labelElement.length) {
	        labelElement = angular.element('<label>');
	        element.prepend(labelElement);
	      }
	      labelElement.addClass('md-container-ignore');
	      labelElement.attr('aria-hidden', 'true');
	      if (attrs.label) {
	        labelElement.text(attrs.label);
	      }
	      element.attr('aria-label', labelElement.text());
	    }
	  }
	}
	
	function SelectHeaderDirective() {
	  return {
	    restrict: 'E',
	  };
	}
	
	function SelectProvider($$interimElementProvider) {
	  selectDefaultOptions.$inject = ["$mdSelect", "$mdConstant", "$mdUtil", "$window", "$q", "$$rAF", "$animateCss", "$animate", "$document"];
	  return $$interimElementProvider('$mdSelect')
	    .setDefaults({
	      methods: ['target'],
	      options: selectDefaultOptions
	    });
	
	  /* @ngInject */
	  function selectDefaultOptions($mdSelect, $mdConstant, $mdUtil, $window, $q, $$rAF, $animateCss, $animate, $document) {
	    var ERROR_TARGET_EXPECTED = "$mdSelect.show() expected a target element in options.target but got '{0}'!";
	    var animator = $mdUtil.dom.animator;
	    var keyCodes = $mdConstant.KEY_CODE;
	
	    return {
	      parent: 'body',
	      themable: true,
	      onShow: onShow,
	      onRemove: onRemove,
	      hasBackdrop: true,
	      disableParentScroll: true
	    };
	
	    /**
	     * Interim-element onRemove logic....
	     */
	    function onRemove(scope, element, opts) {
	      var animationRunner = null;
	      var destroyListener = scope.$on('$destroy', function() {
	        // Listen for the case where the element was destroyed while there was an
	        // ongoing close animation. If this happens, we need to end the animation
	        // manually.
	        animationRunner.end();
	      });
	
	      opts = opts || { };
	      opts.cleanupInteraction();
	      opts.cleanupResizing();
	      opts.hideBackdrop();
	
	      // For navigation $destroy events, do a quick, non-animated removal,
	      // but for normal closes (from clicks, etc) animate the removal
	      return (opts.$destroy === true) ? cleanElement() : animateRemoval().then(cleanElement);
	
	      /**
	       * For normal closes (eg clicks), animate the removal.
	       * For forced closes (like $destroy events from navigation),
	       * skip the animations.
	       */
	      function animateRemoval() {
	        animationRunner = $animateCss(element, {addClass: 'md-leave'});
	        return animationRunner.start();
	      }
	
	      /**
	       * Restore the element to a closed state
	       */
	      function cleanElement() {
	        destroyListener();
	
	        element
	          .removeClass('md-active')
	          .attr('aria-hidden', 'true')
	          .css({
	            'display': 'none',
	            'top': '',
	            'right': '',
	            'bottom': '',
	            'left': '',
	            'font-size': '',
	            'min-width': ''
	          });
	
	        announceClosed(opts);
	
	        if (!opts.$destroy) {
	          if (opts.restoreFocus) {
	            opts.target.focus();
	          } else {
	            // Make sure that the container's md-input-focused is removed on backdrop click.
	            $mdUtil.nextTick(function() {
	              opts.target.triggerHandler('blur');
	            }, true);
	          }
	        }
	      }
	    }
	
	    /**
	     * Interim-element onShow logic.
	     */
	    function onShow(scope, element, opts) {
	
	      watchAsyncLoad();
	      sanitizeAndConfigure(scope, opts);
	
	      opts.hideBackdrop = showBackdrop(scope, element, opts);
	
	      return showDropDown(scope, element, opts)
	        .then(function(response) {
	          element.attr('aria-hidden', 'false');
	          opts.alreadyOpen = true;
	          opts.cleanupInteraction = activateInteraction();
	          opts.cleanupResizing = activateResizing();
	          opts.contentEl[0].focus();
	
	          return response;
	        }, opts.hideBackdrop);
	
	      // ************************************
	      // Closure Functions
	      // ************************************
	
	      /**
	       * Attach the select DOM element(s) and animate to the correct positions and scale.
	       */
	      function showDropDown(scope, element, opts) {
	        if (opts.parent !== element.parent()) {
	          element.parent().attr('aria-owns', element.find('md-content').attr('id'));
	        }
	
	        opts.parent.append(element);
	
	        return $q(function(resolve, reject) {
	          try {
	            $animateCss(element, {removeClass: 'md-leave', duration: 0})
	              .start()
	              .then(positionAndFocusMenu)
	              .then(resolve);
	
	          } catch (e) {
	            reject(e);
	          }
	        });
	      }
	
	      /**
	       * Initialize container and dropDown menu positions/scale, then animate to show.
	       * @return {*} a Promise that resolves after the menu is animated in and an item is focused
	       */
	      function positionAndFocusMenu() {
	        return $q(function(resolve) {
	          if (opts.isRemoved) return $q.reject(false);
	
	          var info = calculateMenuPositions(scope, element, opts);
	
	          info.container.element.css(animator.toCss(info.container.styles));
	          info.dropDown.element.css(animator.toCss(info.dropDown.styles));
	
	          $$rAF(function() {
	            element.addClass('md-active');
	            info.dropDown.element.css(animator.toCss({transform: ''}));
	            autoFocus(opts.focusedNode);
	
	            resolve();
	          });
	
	        });
	      }
	
	      /**
	       * Show modal backdrop element.
	       */
	      function showBackdrop(scope, element, options) {
	
	        // If we are not within a dialog...
	        if (options.disableParentScroll && !$mdUtil.getClosest(options.target, 'MD-DIALOG')) {
	          // !! DO this before creating the backdrop; since disableScrollAround()
	          //    configures the scroll offset; which is used by mdBackDrop postLink()
	          options.restoreScroll = $mdUtil.disableScrollAround(options.element, options.parent);
	        } else {
	          options.disableParentScroll = false;
	        }
	
	        if (options.hasBackdrop) {
	          // Override duration to immediately show invisible backdrop
	          options.backdrop = $mdUtil.createBackdrop(scope, "md-select-backdrop md-click-catcher");
	          $animate.enter(options.backdrop, $document[0].body, null, {duration: 0});
	        }
	
	        /**
	         * Hide modal backdrop element...
	         */
	        return function hideBackdrop() {
	          if (options.backdrop) options.backdrop.remove();
	          if (options.disableParentScroll) options.restoreScroll();
	
	          delete options.restoreScroll;
	        };
	      }
	
	      /**
	       * @param {Element|HTMLElement|null=} previousNode
	       * @param {Element|HTMLElement} node
	       * @param {SelectMenuController|Function|object=} menuController SelectMenuController instance
	       */
	      function focusOptionNode(previousNode, node, menuController) {
	        var listboxContentNode = opts.contentEl[0];
	
	        if (node) {
	          if (previousNode) {
	            previousNode.classList.remove('md-focused');
	          }
	
	          node.classList.add('md-focused');
	          if (menuController && menuController.setActiveDescendant) {
	            menuController.setActiveDescendant(node.id);
	          }
	
	          // Scroll the node into view if needed.
	          if (listboxContentNode.scrollHeight > listboxContentNode.clientHeight) {
	            var scrollBottom = listboxContentNode.clientHeight + listboxContentNode.scrollTop;
	            var nodeBottom = node.offsetTop + node.offsetHeight;
	            if (nodeBottom > scrollBottom) {
	              listboxContentNode.scrollTop = nodeBottom - listboxContentNode.clientHeight;
	            } else if (node.offsetTop < listboxContentNode.scrollTop) {
	              listboxContentNode.scrollTop = node.offsetTop;
	            }
	          }
	          opts.focusedNode = node;
	          if (menuController && menuController.refreshViewValue) {
	            menuController.refreshViewValue();
	          }
	        }
	      }
	
	      /**
	       * @param {Element|HTMLElement} nodeToFocus
	       */
	      function autoFocus(nodeToFocus) {
	        var selectMenuController;
	        if (nodeToFocus && !nodeToFocus.hasAttribute('disabled')) {
	          selectMenuController = opts.selectEl.controller('mdSelectMenu');
	          focusOptionNode(null, nodeToFocus, selectMenuController);
	        }
	      }
	
	      /**
	       * Check for valid opts and set some sane defaults
	       */
	      function sanitizeAndConfigure(scope, options) {
	        var selectMenuElement = element.find('md-select-menu');
	
	        if (!options.target) {
	          throw new Error($mdUtil.supplant(ERROR_TARGET_EXPECTED, [options.target]));
	        }
	
	        angular.extend(options, {
	          isRemoved: false,
	          target: angular.element(options.target), // make sure it's not a naked DOM node
	          parent: angular.element(options.parent),
	          selectEl: selectMenuElement,
	          contentEl: element.find('md-content'),
	          optionNodes: selectMenuElement[0].getElementsByTagName('md-option')
	        });
	      }
	
	      /**
	       * Configure various resize listeners for screen changes
	       */
	      function activateResizing() {
	        var debouncedOnResize = (function(scope, target, options) {
	
	          return function() {
	            if (options.isRemoved) return;
	
	            var updates = calculateMenuPositions(scope, target, options);
	            var container = updates.container;
	            var dropDown = updates.dropDown;
	
	            container.element.css(animator.toCss(container.styles));
	            dropDown.element.css(animator.toCss(dropDown.styles));
	          };
	
	        })(scope, element, opts);
	
	        var window = angular.element($window);
	        window.on('resize', debouncedOnResize);
	        window.on('orientationchange', debouncedOnResize);
	
	        // Publish deactivation closure...
	        return function deactivateResizing() {
	
	          // Disable resizing handlers
	          window.off('resize', debouncedOnResize);
	          window.off('orientationchange', debouncedOnResize);
	        };
	      }
	
	      /**
	       * If asynchronously loading, watch and update internal '$$loadingAsyncDone' flag.
	       */
	      function watchAsyncLoad() {
	        if (opts.loadingAsync && !opts.isRemoved) {
	          scope.$$loadingAsyncDone = false;
	
	          $q.when(opts.loadingAsync)
	            .then(function() {
	              scope.$$loadingAsyncDone = true;
	              delete opts.loadingAsync;
	            }).then(function() {
	              $$rAF(positionAndFocusMenu);
	            });
	        }
	      }
	
	      function activateInteraction() {
	        if (opts.isRemoved) {
	          return;
	        }
	
	        var dropDown = opts.selectEl;
	        var selectMenuController = dropDown.controller('mdSelectMenu') || {};
	        var listbox = opts.contentEl;
	
	        element.addClass('md-clickable');
	
	        // Close on backdrop click
	        opts.backdrop && opts.backdrop.on('click', onBackdropClick);
	
	        // Escape to close
	        // Cycling of options, and closing on enter
	        dropDown.on('keydown', onMenuKeyDown);
	        dropDown.on('click', checkCloseMenu);
	
	        return function cleanupInteraction() {
	          opts.backdrop && opts.backdrop.off('click', onBackdropClick);
	          dropDown.off('keydown', onMenuKeyDown);
	          dropDown.off('click', checkCloseMenu);
	
	          element.removeClass('md-clickable');
	          opts.isRemoved = true;
	        };
	
	        // ************************************
	        // Closure Functions
	        // ************************************
	
	        function onBackdropClick(e) {
	          e.preventDefault();
	          e.stopPropagation();
	          opts.restoreFocus = false;
	          $mdUtil.nextTick($mdSelect.hide, true);
	        }
	
	        function onMenuKeyDown(ev) {
	          ev.preventDefault();
	          ev.stopPropagation();
	
	          switch (ev.keyCode) {
	            case keyCodes.UP_ARROW:
	              return focusPrevOption();
	            case keyCodes.DOWN_ARROW:
	              return focusNextOption();
	            case keyCodes.SPACE:
	            case keyCodes.ENTER:
	              if (opts.focusedNode) {
	                dropDown.triggerHandler({
	                  type: 'click',
	                  target: opts.focusedNode
	                });
	                ev.preventDefault();
	              }
	              checkCloseMenu(ev);
	              break;
	            case keyCodes.TAB:
	            case keyCodes.ESCAPE:
	              ev.stopPropagation();
	              ev.preventDefault();
	              opts.restoreFocus = true;
	              $mdUtil.nextTick($mdSelect.hide, true);
	              break;
	            default:
	              if (shouldHandleKey(ev, $mdConstant)) {
	                var optNode = selectMenuController.optNodeForKeyboardSearch(ev);
	                if (optNode && !optNode.hasAttribute('disabled')) {
	                  focusOptionNode(opts.focusedNode, optNode, selectMenuController);
	                }
	              }
	          }
	        }
	
	        /**
	         * Change the focus to another option. If there is no focused option, focus the first
	         * option. If there is a focused option, then use the direction to determine if we should
	         * focus the previous or next option in the list.
	         * @param {'next'|'prev'} direction
	         */
	        function focusOption(direction) {
	          var optionsArray = $mdUtil.nodesToArray(opts.optionNodes);
	          var index = optionsArray.indexOf(opts.focusedNode);
	          var prevOption = optionsArray[index];
	          var newOption;
	
	          do {
	            if (index === -1) {
	              // We lost the previously focused element, reset to first option
	              index = 0;
	            } else if (direction === 'next' && index < optionsArray.length - 1) {
	              index++;
	            } else if (direction === 'prev' && index > 0) {
	              index--;
	            }
	            newOption = optionsArray[index];
	            if (newOption.hasAttribute('disabled')) {
	              newOption = null;
	            }
	          } while (!newOption && index < optionsArray.length - 1 && index > 0);
	
	          focusOptionNode(prevOption, newOption, selectMenuController);
	        }
	
	        function focusNextOption() {
	          focusOption('next');
	        }
	
	        function focusPrevOption() {
	          focusOption('prev');
	        }
	
	        /**
	         * @param {KeyboardEvent|MouseEvent} event
	         */
	        function checkCloseMenu(event) {
	          if (event && (event.type === 'click') && (event.currentTarget !== dropDown[0])) {
	            return;
	          }
	          if (mouseOnScrollbar()) {
	            return;
	          }
	
	          if (opts.focusedNode && opts.focusedNode.hasAttribute &&
	              !opts.focusedNode.hasAttribute('disabled')) {
	            event.preventDefault();
	            event.stopPropagation();
	            if (!selectMenuController.isMultiple) {
	              opts.restoreFocus = true;
	
	              $mdUtil.nextTick(function () {
	                $mdSelect.hide(selectMenuController.ngModel.$viewValue);
	                opts.focusedNode.classList.remove('md-focused');
	              }, true);
	            }
	          }
	
	          /**
	           * check if the mouseup event was on a scrollbar
	           */
	          function mouseOnScrollbar() {
	            var clickOnScrollbar = false;
	            if (event && (event.currentTarget.children.length > 0)) {
	              var child = event.currentTarget.children[0];
	              var hasScrollbar = child.scrollHeight > child.clientHeight;
	              if (hasScrollbar && child.children.length > 0) {
	                var relPosX = event.pageX - event.currentTarget.getBoundingClientRect().left;
	                if (relPosX > child.querySelector('md-option').offsetWidth)
	                  clickOnScrollbar = true;
	              }
	            }
	            return clickOnScrollbar;
	          }
	        }
	      }
	    }
	
	    /**
	     * To notify listeners that the Select menu has closed,
	     * trigger the [optional] user-defined expression
	     */
	    function announceClosed(opts) {
	      var mdSelect = opts.selectCtrl;
	      if (mdSelect) {
	        var menuController = opts.selectEl.controller('mdSelectMenu');
	        mdSelect.setSelectValueText(menuController ? menuController.getSelectedLabels() : '');
	        mdSelect.triggerClose();
	      }
	    }
	
	
	    /**
	     * Calculate the menu positions after an event like options changing, screen resizing, or
	     * animations finishing.
	     * @param {Object} scope
	     * @param element
	     * @param opts
	     * @return {{container: {styles: {top: number, left: number, 'font-size': *, 'min-width': number}, element: Object}, dropDown: {styles: {transform: string, transformOrigin: string}, element: Object}}}
	     */
	    function calculateMenuPositions(scope, element, opts) {
	      var
	        containerNode = element[0],
	        targetNode = opts.target[0].children[0], // target the label
	        parentNode = $document[0].body,
	        selectNode = opts.selectEl[0],
	        contentNode = opts.contentEl[0],
	        parentRect = parentNode.getBoundingClientRect(),
	        targetRect = targetNode.getBoundingClientRect(),
	        shouldOpenAroundTarget = false,
	        bounds = {
	          left: parentRect.left + SELECT_EDGE_MARGIN,
	          top: SELECT_EDGE_MARGIN,
	          bottom: parentRect.height - SELECT_EDGE_MARGIN,
	          right: parentRect.width - SELECT_EDGE_MARGIN - ($mdUtil.floatingScrollbars() ? 16 : 0)
	        },
	        spaceAvailable = {
	          top: targetRect.top - bounds.top,
	          left: targetRect.left - bounds.left,
	          right: bounds.right - (targetRect.left + targetRect.width),
	          bottom: bounds.bottom - (targetRect.top + targetRect.height)
	        },
	        maxWidth = parentRect.width - SELECT_EDGE_MARGIN * 2,
	        selectedNode = selectNode.querySelector('md-option[selected]'),
	        optionNodes = selectNode.getElementsByTagName('md-option'),
	        optgroupNodes = selectNode.getElementsByTagName('md-optgroup'),
	        isScrollable = calculateScrollable(element, contentNode),
	        centeredNode;
	
	      var loading = isPromiseLike(opts.loadingAsync);
	      if (!loading) {
	        // If a selected node, center around that
	        if (selectedNode) {
	          centeredNode = selectedNode;
	          // If there are option groups, center around the first option group
	        } else if (optgroupNodes.length) {
	          centeredNode = optgroupNodes[0];
	          // Otherwise - if we are not loading async - center around the first optionNode
	        } else if (optionNodes.length) {
	          centeredNode = optionNodes[0];
	          // In case there are no options, center on whatever's in there... (eg progress indicator)
	        } else {
	          centeredNode = contentNode.firstElementChild || contentNode;
	        }
	      } else {
	        // If loading, center on progress indicator
	        centeredNode = contentNode.firstElementChild || contentNode;
	      }
	
	      if (contentNode.offsetWidth > maxWidth) {
	        contentNode.style['max-width'] = maxWidth + 'px';
	      } else {
	        contentNode.style.maxWidth = null;
	      }
	      if (shouldOpenAroundTarget) {
	        contentNode.style['min-width'] = targetRect.width + 'px';
	      }
	
	      // Remove padding before we compute the position of the menu
	      if (isScrollable) {
	        selectNode.classList.add('md-overflow');
	      }
	
	      var focusedNode = centeredNode;
	      if ((focusedNode.tagName || '').toUpperCase() === 'MD-OPTGROUP') {
	        focusedNode = optionNodes[0] || contentNode.firstElementChild || contentNode;
	        centeredNode = focusedNode;
	      }
	      // Cache for autoFocus()
	      opts.focusedNode = focusedNode;
	
	      // Get the selectMenuRect *after* max-width is possibly set above
	      containerNode.style.display = 'block';
	      var selectMenuRect = selectNode.getBoundingClientRect();
	      var centeredRect = getOffsetRect(centeredNode);
	
	      if (centeredNode) {
	        var centeredStyle = $window.getComputedStyle(centeredNode);
	        centeredRect.paddingLeft = parseInt(centeredStyle.paddingLeft, 10) || 0;
	        centeredRect.paddingRight = parseInt(centeredStyle.paddingRight, 10) || 0;
	      }
	
	      if (isScrollable) {
	        var scrollBuffer = contentNode.offsetHeight / 2;
	        contentNode.scrollTop = centeredRect.top + centeredRect.height / 2 - scrollBuffer;
	
	        if (spaceAvailable.top < scrollBuffer) {
	          contentNode.scrollTop = Math.min(
	            centeredRect.top,
	            contentNode.scrollTop + scrollBuffer - spaceAvailable.top
	          );
	        } else if (spaceAvailable.bottom < scrollBuffer) {
	          contentNode.scrollTop = Math.max(
	            centeredRect.top + centeredRect.height - selectMenuRect.height,
	            contentNode.scrollTop - scrollBuffer + spaceAvailable.bottom
	          );
	        }
	      }
	
	      var left, top, transformOrigin, minWidth, fontSize;
	      if (shouldOpenAroundTarget) {
	        left = targetRect.left;
	        top = targetRect.top + targetRect.height;
	        transformOrigin = '50% 0';
	        if (top + selectMenuRect.height > bounds.bottom) {
	          top = targetRect.top - selectMenuRect.height;
	          transformOrigin = '50% 100%';
	        }
	      } else {
	        left = (targetRect.left + centeredRect.left - centeredRect.paddingLeft) + 2;
	        top = Math.floor(targetRect.top + targetRect.height / 2 - centeredRect.height / 2 -
	            centeredRect.top + contentNode.scrollTop) + 2;
	
	        transformOrigin = (centeredRect.left + targetRect.width / 2) + 'px ' +
	          (centeredRect.top + centeredRect.height / 2 - contentNode.scrollTop) + 'px 0px';
	
	        minWidth = Math.min(targetRect.width + centeredRect.paddingLeft + centeredRect.paddingRight, maxWidth);
	
	        fontSize = window.getComputedStyle(targetNode)['font-size'];
	      }
	
	      // Keep left and top within the window
	      var containerRect = containerNode.getBoundingClientRect();
	      var scaleX = Math.round(100 * Math.min(targetRect.width / selectMenuRect.width, 1.0)) / 100;
	      var scaleY = Math.round(100 * Math.min(targetRect.height / selectMenuRect.height, 1.0)) / 100;
	
	      return {
	        container: {
	          element: angular.element(containerNode),
	          styles: {
	            left: Math.floor(clamp(bounds.left, left, bounds.right - minWidth)),
	            top: Math.floor(clamp(bounds.top, top, bounds.bottom - containerRect.height)),
	            'min-width': minWidth,
	            'font-size': fontSize
	          }
	        },
	        dropDown: {
	          element: angular.element(selectNode),
	          styles: {
	            transformOrigin: transformOrigin,
	            transform: !opts.alreadyOpen ? $mdUtil.supplant('scale({0},{1})', [scaleX, scaleY]) : ""
	          }
	        }
	      };
	    }
	  }
	
	  function isPromiseLike(obj) {
	    return obj && angular.isFunction(obj.then);
	  }
	
	  function clamp(min, n, max) {
	    return Math.max(min, Math.min(n, max));
	  }
	
	  function getOffsetRect(node) {
	    return node ? {
	      left: node.offsetLeft,
	      top: node.offsetTop,
	      width: node.offsetWidth,
	      height: node.offsetHeight
	    } : {left: 0, top: 0, width: 0, height: 0};
	  }
	
	  function calculateScrollable(element, contentNode) {
	    var isScrollable = false;
	
	    try {
	      var oldDisplay = element[0].style.display;
	
	      // Set the element's display to block so that this calculation is correct
	      element[0].style.display = 'block';
	
	      isScrollable = contentNode.scrollHeight > contentNode.offsetHeight;
	
	      // Reset it back afterwards
	      element[0].style.display = oldDisplay;
	    } finally {
	      // Nothing to do
	    }
	    return isScrollable;
	  }
	}
	
	function shouldHandleKey(ev, $mdConstant) {
	  var char = String.fromCharCode(ev.keyCode);
	  var isNonUsefulKey = (ev.keyCode <= 31);
	
	  return (char && char.length && !isNonUsefulKey &&
	    !$mdConstant.isMetaKey(ev) && !$mdConstant.isFnLockKey(ev) && !$mdConstant.hasModifierKey(ev));
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.showHide
	 */
	
	// Add additional handlers to ng-show and ng-hide that notify directives
	// contained within that they should recompute their size.
	// These run in addition to AngularJS's built-in ng-hide and ng-show directives.
	angular.module('material.components.showHide', [
	  'material.core'
	])
	  .directive('ngShow', createDirective('ngShow', true))
	  .directive('ngHide', createDirective('ngHide', false));
	
	
	function createDirective(name, targetValue) {
	  return ['$mdUtil', '$window', function($mdUtil, $window) {
	    return {
	      restrict: 'A',
	      multiElement: true,
	      link: function($scope, $element, $attr) {
	        var unregister = $scope.$on('$md-resize-enable', function() {
	          unregister();
	
	          var node = $element[0];
	          var cachedTransitionStyles = node.nodeType === $window.Node.ELEMENT_NODE ?
	            $window.getComputedStyle(node) : {};
	
	          $scope.$watch($attr[name], function(value) {
	            if (!!value === targetValue) {
	              $mdUtil.nextTick(function() {
	                $scope.$broadcast('$md-resize');
	              });
	
	              var opts = {
	                cachedTransitionStyles: cachedTransitionStyles
	              };
	
	              $mdUtil.dom.animator.waitTransitionEnd($element, opts).then(function() {
	                $scope.$broadcast('$md-resize');
	              });
	            }
	          });
	        });
	      }
	    };
	  }];
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.sidenav
	 *
	 * @description
	 * A Sidenav component.
	 */
	SidenavService.$inject = ["$mdComponentRegistry", "$mdUtil", "$q", "$log"];
	SidenavDirective.$inject = ["$mdMedia", "$mdUtil", "$mdConstant", "$mdTheming", "$mdInteraction", "$animate", "$compile", "$parse", "$log", "$q", "$document", "$window", "$$rAF"];
	SidenavController.$inject = ["$scope", "$attrs", "$mdComponentRegistry", "$q", "$interpolate"];
	angular
	  .module('material.components.sidenav', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .factory('$mdSidenav', SidenavService)
	  .directive('mdSidenav', SidenavDirective)
	  .directive('mdSidenavFocus', SidenavFocusDirective)
	  .controller('$mdSidenavController', SidenavController);
	
	
	/**
	 * @ngdoc service
	 * @name $mdSidenav
	 * @module material.components.sidenav
	 *
	 * @description
	 * `$mdSidenav` makes it easy to interact with multiple sidenavs in an app. When looking up a
	 * sidenav instance, you can either look it up synchronously or wait for it to be initialized
	 * asynchronously. This is done by passing the second argument to `$mdSidenav`.
	 *
	 * @usage
	 * <hljs lang="js">
	 * // Async lookup for sidenav instance; will resolve when the instance is available
	 * $mdSidenav(componentId, true).then(function(instance) {
	 *   $log.debug( componentId + "is now ready" );
	 * });
	 * // Sync lookup for sidenav instance; this will resolve immediately.
	 * $mdSidenav(componentId).then(function(instance) {
	 *   $log.debug( componentId + "is now ready" );
	 * });
	 * // Async toggle the given sidenav;
	 * // when instance is known ready and lazy lookup is not needed.
	 * $mdSidenav(componentId)
	 *    .toggle()
	 *    .then(function(){
	 *      $log.debug('toggled');
	 *    });
	 * // Async open the given sidenav
	 * $mdSidenav(componentId)
	 *    .open()
	 *    .then(function(){
	 *      $log.debug('opened');
	 *    });
	 * // Async close the given sidenav
	 * $mdSidenav(componentId)
	 *    .close()
	 *    .then(function(){
	 *      $log.debug('closed');
	 *    });
	 * // Async lookup for sidenav instance
	 * $mdSidenav(componentId, true).then(function(instance) {
	 *   // On close callback to handle close, backdrop click, or escape key pressed.
	 *   // Callback happens BEFORE the close action occurs.
	 *   instance.onClose(function() {
	 *     $log.debug('closing');
	 *   });
	 * });
	 * // Sync check to see if the specified sidenav is set to be open
	 * $mdSidenav(componentId).isOpen();
	 * // Sync check to whether given sidenav is locked open
	 * // If this is true, the sidenav will be open regardless of close()
	 * $mdSidenav(componentId).isLockedOpen();
	 * </hljs>
	 */
	function SidenavService($mdComponentRegistry, $mdUtil, $q, $log) {
	  var errorMsg = "SideNav '{0}' is not available! Did you use md-component-id='{0}'?";
	  var service = {
	    find: findInstance,      //  sync  - returns proxy API
	    waitFor: waitForInstance //  async - returns promise
	  };
	
	  /**
	   * Service API that supports three (3) usages:
	   * $mdSidenav().find("left")               // sync (must already exist) or returns undefined
	   * $mdSidenav("left").toggle();            // sync (must already exist) or returns reject promise;
	   * $mdSidenav("left",true).then(function(left) { // async returns instance when available
	   *  left.toggle();
	   * });
	   */
	  return function(handle, enableWait) {
	    if (angular.isUndefined(handle)) {
	      return service;
	    }
	
	    var shouldWait = enableWait === true;
	    var instance = service.find(handle, shouldWait);
	    return !instance && shouldWait ? service.waitFor(handle) :
	           !instance && angular.isUndefined(enableWait) ? addLegacyAPI(service, handle) : instance;
	  };
	
	  /**
	   * For failed instance/handle lookups, older-clients expect an response object with noops
	   * that include `rejected promise APIs`
	   * @param service
	   * @param handle
	   * @returns {Object}
	   */
	  function addLegacyAPI(service, handle) {
	    var falseFn = function() {
	      return false;
	    };
	    var rejectFn = function() {
	      return $q.when($mdUtil.supplant(errorMsg, [handle || ""]));
	    };
	
	    return angular.extend({
	      isLockedOpen: falseFn,
	      isOpen: falseFn,
	      toggle: rejectFn,
	      open: rejectFn,
	      close: rejectFn,
	      onClose: angular.noop,
	      then: function(callback) {
	        return waitForInstance(handle).then(callback || angular.noop);
	      }
	    }, service);
	  }
	
	  /**
	   * Synchronously lookup the controller instance for the specified sidNav instance which has been
	   * registered with the markup `md-component-id`
	   */
	  function findInstance(handle, shouldWait) {
	    var instance = $mdComponentRegistry.get(handle);
	
	    if (!instance && !shouldWait) {
	      // Report missing instance
	      $log.error($mdUtil.supplant(errorMsg, [handle || ""]));
	
	      // The component has not registered itself... most like NOT yet created
	      // return null to indicate that the Sidenav is not in the DOM
	      return undefined;
	    }
	    return instance;
	  }
	
	  /**
	   * Asynchronously wait for the component instantiation,
	   * Deferred lookup of component instance using $component registry
	   */
	  function waitForInstance(handle) {
	    return $mdComponentRegistry.when(handle).catch($log.error);
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name mdSidenavFocus
	 * @module material.components.sidenav
	 *
	 * @restrict A
	 *
	 * @description
	 * `mdSidenavFocus` provides a way to specify the focused element when a sidenav opens.
	 * This is completely optional, as the sidenav itself is focused by default.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-sidenav>
	 *   <form>
	 *     <md-input-container>
	 *       <label for="testInput">Label</label>
	 *       <input id="testInput" type="text" md-sidenav-focus>
	 *     </md-input-container>
	 *   </form>
	 * </md-sidenav>
	 * </hljs>
	 **/
	function SidenavFocusDirective() {
	  return {
	    restrict: 'A',
	    require: '^mdSidenav',
	    link: function(scope, element, attr, sidenavCtrl) {
	      // @see $mdUtil.findFocusTarget(...)
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name mdSidenav
	 * @module material.components.sidenav
	 * @restrict E
	 *
	 * @description
	 * A Sidenav component that can be opened and closed programmatically.
	 *
	 * By default, upon opening it will slide out on top of the main content area.
	 *
	 * For keyboard and screen reader accessibility, focus is sent to the sidenav wrapper by default.
	 * It can be overridden with the `md-autofocus` directive on the child element you want focused.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div layout="row" ng-controller="MyController">
	 *   <md-sidenav md-component-id="left" class="md-sidenav-left">
	 *     Left Nav!
	 *   </md-sidenav>
	 *
	 *   <md-content>
	 *     Center Content
	 *     <md-button ng-click="openLeftMenu()">
	 *       Open Left Menu
	 *     </md-button>
	 *   </md-content>
	 *
	 *   <md-sidenav md-component-id="right"
	 *     md-is-locked-open="$mdMedia('min-width: 333px')"
	 *     class="md-sidenav-right">
	 *     <form>
	 *       <md-input-container>
	 *         <label for="testInput">Test input</label>
	 *         <input id="testInput" type="text"
	 *                ng-model="data" md-autofocus>
	 *       </md-input-container>
	 *     </form>
	 *   </md-sidenav>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="js">
	 * var app = angular.module('myApp', ['ngMaterial']);
	 * app.controller('MyController', function($scope, $mdSidenav) {
	 *   $scope.openLeftMenu = function() {
	 *     $mdSidenav('left').toggle();
	 *   };
	 * });
	 * </hljs>
	 *
	 * @param {expression=} md-is-open A model bound to whether the sidenav is opened.
	 * @param {boolean=} md-disable-backdrop When present in the markup, the sidenav will not show a
	 *  backdrop.
	 * @param {boolean=} md-disable-close-events When present in the markup, clicking the backdrop or
	 *  pressing the 'Escape' key will not close the sidenav.
	 * @param {string=} md-component-id componentId to use with $mdSidenav service.
	 * @param {expression=} md-is-locked-open When this expression evaluates to true,
	 * the sidenav 'locks open': it falls into the content's flow instead
	 * of appearing over it. This overrides the `md-is-open` attribute.
	 * @param {string=} md-disable-scroll-target Selector, pointing to an element, whose scrolling will
	 * be disabled when the sidenav is opened. By default this is the sidenav's direct parent.
	 *
	* The $mdMedia() service is exposed to the is-locked-open attribute, which
	 * can be given a media query or one of the `sm`, `gt-sm`, `md`, `gt-md`, `lg` or `gt-lg` presets.
	 * Examples:
	 *
	 *   - `<md-sidenav md-is-locked-open="shouldLockOpen"></md-sidenav>`
	 *   - `<md-sidenav md-is-locked-open="$mdMedia('min-width: 1000px')"></md-sidenav>`
	 *   - `<md-sidenav md-is-locked-open="$mdMedia('sm')"></md-sidenav>` (locks open on small screens)
	 */
	function SidenavDirective($mdMedia, $mdUtil, $mdConstant, $mdTheming, $mdInteraction, $animate,
	                          $compile, $parse, $log, $q, $document, $window, $$rAF) {
	  return {
	    restrict: 'E',
	    scope: {
	      isOpen: '=?mdIsOpen'
	    },
	    controller: '$mdSidenavController',
	    compile: function(element) {
	      element.addClass('md-closed').attr('tabIndex', '-1');
	      return postLink;
	    }
	  };
	
	  /**
	   * Directive Post Link function...
	   */
	  function postLink(scope, element, attr, sidenavCtrl) {
	    var lastParentOverFlow;
	    var backdrop;
	    var disableScrollTarget = null;
	    var disableCloseEvents;
	    var triggeringInteractionType;
	    var triggeringElement = null;
	    var previousContainerStyles;
	    var promise = $q.when(true);
	    var isLockedOpenParsed = $parse(attr.mdIsLockedOpen);
	    var ngWindow = angular.element($window);
	    var isLocked = function() {
	      return isLockedOpenParsed(scope.$parent, {
	        $media: function(arg) {
	          $log.warn("$media is deprecated for is-locked-open. Use $mdMedia instead.");
	          return $mdMedia(arg);
	        },
	        $mdMedia: $mdMedia
	      });
	    };
	
	    if (attr.mdDisableScrollTarget) {
	      disableScrollTarget = $document[0].querySelector(attr.mdDisableScrollTarget);
	
	      if (disableScrollTarget) {
	        disableScrollTarget = angular.element(disableScrollTarget);
	      } else {
	        $log.warn($mdUtil.supplant('mdSidenav: couldn\'t find element matching ' +
	          'selector "{selector}". Falling back to parent.',
	          { selector: attr.mdDisableScrollTarget }));
	      }
	    }
	
	    if (!disableScrollTarget) {
	      disableScrollTarget = element.parent();
	    }
	
	    // Only create the backdrop if the backdrop isn't disabled.
	    if (!attr.hasOwnProperty('mdDisableBackdrop')) {
	      backdrop = $mdUtil.createBackdrop(scope, "md-sidenav-backdrop md-opaque ng-enter");
	    }
	
	    // If md-disable-close-events is set on the sidenav we will disable
	    // backdrop click and Escape key events
	    if (attr.hasOwnProperty('mdDisableCloseEvents')) {
	      disableCloseEvents = true;
	    }
	
	    element.addClass('_md');     // private md component indicator for styling
	    $mdTheming(element);
	
	    // The backdrop should inherit the sidenavs theme,
	    // because the backdrop will take its parent theme by default.
	    if (backdrop) $mdTheming.inherit(backdrop, element);
	
	    element.on('$destroy', function() {
	      backdrop && backdrop.remove();
	      sidenavCtrl.destroy();
	    });
	
	    scope.$on('$destroy', function(){
	      backdrop && backdrop.remove();
	    });
	
	    scope.$watch(isLocked, updateIsLocked);
	    scope.$watch('isOpen', updateIsOpen);
	
	
	    // Publish special accessor for the Controller instance
	    sidenavCtrl.$toggleOpen = toggleOpen;
	
	    /**
	     * Toggle the DOM classes to indicate `locked`
	     * @param isLocked
	     * @param oldValue
	     */
	    function updateIsLocked(isLocked, oldValue) {
	      scope.isLockedOpen = isLocked;
	      if (isLocked === oldValue) {
	        element.toggleClass('md-locked-open', !!isLocked);
	      } else {
	        $animate[isLocked ? 'addClass' : 'removeClass'](element, 'md-locked-open');
	      }
	      if (backdrop) {
	        backdrop.toggleClass('md-locked-open', !!isLocked);
	      }
	    }
	
	    /**
	     * Toggle the SideNav view and attach/detach listeners
	     * @param isOpen
	     */
	    function updateIsOpen(isOpen) {
	      // Support deprecated md-sidenav-focus attribute as fallback
	      var focusEl = $mdUtil.findFocusTarget(element) ||
	        $mdUtil.findFocusTarget(element,'[md-sidenav-focus]') || element;
	      var parent = element.parent();
	      var restorePositioning;
	
	      // If the user hasn't set the disable close events property we are adding
	      // click and escape events to close the sidenav
	      if (!disableCloseEvents) {
	        parent[isOpen ? 'on' : 'off']('keydown', onKeyDown);
	        if (backdrop) backdrop[isOpen ? 'on' : 'off']('click', close);
	      }
	
	      restorePositioning = updateContainerPositions(parent, isOpen);
	
	      if (isOpen) {
	        // Capture upon opening..
	        triggeringElement = $document[0].activeElement;
	        triggeringInteractionType = $mdInteraction.getLastInteractionType();
	      }
	
	      disableParentScroll(isOpen);
	
	      return promise = $q.all([
	        isOpen && backdrop ? $animate.enter(backdrop, parent) : backdrop ?
	                             $animate.leave(backdrop) : $q.when(true),
	        $animate[isOpen ? 'removeClass' : 'addClass'](element, 'md-closed')
	      ]).then(function() {
	        // Perform focus when animations are ALL done...
	        if (scope.isOpen) {
	          $$rAF(function() {
	            // Notifies child components that the sidenav was opened. Should wait
	            // a frame in order to allow for the element height to be computed.
	            ngWindow.triggerHandler('resize');
	          });
	
	          focusEl && focusEl.focus();
	        }
	
	        // Restores the positioning on the sidenav and backdrop.
	        restorePositioning && restorePositioning();
	      });
	    }
	
	    function updateContainerPositions(parent, willOpen) {
	      var drawerEl = element[0];
	      var scrollTop = parent[0].scrollTop;
	
	      if (willOpen && scrollTop) {
	        previousContainerStyles = {
	          top: drawerEl.style.top,
	          bottom: drawerEl.style.bottom,
	          height: drawerEl.style.height
	        };
	
	        // When the parent is scrolled down, then we want to be able to show the sidenav at the
	        // current scroll position. We're moving the sidenav down to the correct scroll position
	        // and apply the height of the parent, to increase the performance. Using 100% as height,
	        // will impact the performance heavily.
	        var positionStyle = {
	          top: scrollTop + 'px',
	          bottom: 'auto',
	          height: parent[0].clientHeight + 'px'
	        };
	
	        // Apply the new position styles to the sidenav and backdrop.
	        element.css(positionStyle);
	        backdrop.css(positionStyle);
	      }
	
	      // When the sidenav is closing and we have previous defined container styles,
	      // then we return a restore function, which resets the sidenav and backdrop.
	      if (!willOpen && previousContainerStyles) {
	        return function() {
	          drawerEl.style.top = previousContainerStyles.top;
	          drawerEl.style.bottom = previousContainerStyles.bottom;
	          drawerEl.style.height = previousContainerStyles.height;
	
	          backdrop[0].style.top = null;
	          backdrop[0].style.bottom = null;
	          backdrop[0].style.height = null;
	
	          previousContainerStyles = null;
	        };
	      }
	    }
	
	    /**
	     * Prevent parent scrolling (when the SideNav is open)
	     */
	    function disableParentScroll(disabled) {
	      if (disabled && !lastParentOverFlow) {
	        lastParentOverFlow = disableScrollTarget.css('overflow');
	        disableScrollTarget.css('overflow', 'hidden');
	      } else if (angular.isDefined(lastParentOverFlow)) {
	        disableScrollTarget.css('overflow', lastParentOverFlow);
	        lastParentOverFlow = undefined;
	      }
	    }
	
	    /**
	     * Toggle the sideNav view and publish a promise to be resolved when
	     * the view animation finishes.
	     * @param {boolean} isOpen true to open the sidenav, false to close it
	     * @returns {*} promise to be resolved when the view animation finishes
	     */
	    function toggleOpen(isOpen) {
	      if (scope.isOpen === isOpen) {
	        return $q.when(true);
	      } else {
	        if (scope.isOpen && sidenavCtrl.onCloseCb) sidenavCtrl.onCloseCb();
	
	        return $q(function(resolve) {
	          // Toggle value to force an async `updateIsOpen()` to run
	          scope.isOpen = isOpen;
	
	          $mdUtil.nextTick(function() {
	            // When the current `updateIsOpen()` animation finishes
	            promise.then(function(result) {
	
	              if (!scope.isOpen && triggeringElement && triggeringInteractionType === 'keyboard') {
	                // reset focus to originating element (if available) upon close
	                triggeringElement.focus();
	                triggeringElement = null;
	              }
	
	              resolve(result);
	            });
	          });
	        });
	      }
	    }
	
	    /**
	     * Auto-close sideNav when the `escape` key is pressed.
	     * @param {KeyboardEvent} ev keydown event
	     */
	    function onKeyDown(ev) {
	      var isEscape = (ev.keyCode === $mdConstant.KEY_CODE.ESCAPE);
	      return isEscape ? close(ev) : $q.when(true);
	    }
	
	    /**
	     * With backdrop `clicks` or `escape` key-press, immediately apply the CSS close transition...
	     * Then notify the controller to close() and perform its own actions.
	     * @param {Event} ev
	     * @returns {*}
	     */
	    function close(ev) {
	      ev.preventDefault();
	
	      return sidenavCtrl.close();
	    }
	  }
	}
	
	/*
	 * @private
	 * @ngdoc controller
	 * @name SidenavController
	 * @module material.components.sidenav
	 */
	function SidenavController($scope, $attrs, $mdComponentRegistry, $q, $interpolate) {
	  var self = this;
	
	  // Use Default internal method until overridden by directive postLink
	
	  // Synchronous getters
	  self.isOpen = function() { return !!$scope.isOpen; };
	  self.isLockedOpen = function() { return !!$scope.isLockedOpen; };
	
	  // Synchronous setters
	  self.onClose = function (callback) {
	    self.onCloseCb = callback;
	    return self;
	  };
	
	  // Async actions
	  self.open   = function() { return self.$toggleOpen(true);  };
	  self.close  = function() { return self.$toggleOpen(false); };
	  self.toggle = function() { return self.$toggleOpen(!$scope.isOpen);  };
	  self.$toggleOpen = function(value) { return $q.when($scope.isOpen = value); };
	
	  // Evaluate the component id.
	  var rawId = $attrs.mdComponentId;
	  var hasDataBinding = rawId && rawId.indexOf($interpolate.startSymbol()) > -1;
	  var componentId = hasDataBinding ? $interpolate(rawId)($scope.$parent) : rawId;
	
	  // Register the component.
	  self.destroy = $mdComponentRegistry.register(self, componentId);
	
	  // Watch and update the component, if the id has changed.
	  if (hasDataBinding) {
	    $attrs.$observe('mdComponentId', function(id) {
	      if (id && id !== self.$$mdHandle) {
	        // `destroy` only deregisters the old component id so we can add the new one.
	        self.destroy();
	        self.destroy = $mdComponentRegistry.register(self, id);
	      }
	    });
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.slider
	 */
	SliderDirective.$inject = ["$$rAF", "$window", "$mdAria", "$mdUtil", "$mdConstant", "$mdTheming", "$mdGesture", "$parse", "$log", "$timeout"];
	angular.module('material.components.slider', [
	  'material.core'
	])
	.directive('mdSlider', SliderDirective)
	.directive('mdSliderContainer', SliderContainerDirective);
	
	/**
	 * @type {number} the page size used for stepping when page up/down keys are pressed.
	 */
	var stepPageSize = 10;
	/**
	 * @type {number} the multiplier applied to a step when the arrow key is pressed along with
	 *  alt, meta, or ctrl.
	 */
	var modifierMultiplier = 4;
	
	/**
	 * @ngdoc directive
	 * @name mdSliderContainer
	 * @module material.components.slider
	 * @restrict E
	 * @description
	 * The `<md-slider-container>` can hold the slider with two other elements.
	 * In this case, the other elements are a `span` for the label and an `input` for displaying
	 * the model value.
	 *
	 * @usage
	 * <hljs lang="html">
	 *  <md-slider-container>
	 *    <span>Red</span>
	 *    <md-slider min="0" max="255" ng-model="color.red" aria-label="red" id="red-slider">
	 *    </md-slider>
	 *    <md-input-container>
	 *      <input type="number" ng-model="color.red" aria-label="Red" aria-controls="red-slider">
	 *    </md-input-container>
	 *  </md-slider-container>
	 * </hljs>
	 */
	function SliderContainerDirective() {
	  return {
	    controller: function () {},
	    compile: function (elem) {
	      var slider = elem.find('md-slider');
	
	      if (!slider) {
	        return;
	      }
	
	      var vertical = slider.attr('md-vertical');
	
	      if (vertical !== undefined) {
	        elem.attr('md-vertical', '');
	      }
	
	      if (!slider.attr('flex')) {
	        slider.attr('flex', '');
	      }
	
	      return function postLink(scope, element, attr, ctrl) {
	        element.addClass('_md');     // private md component indicator for styling
	
	        // We have to manually stop the $watch on ngDisabled because it exists
	        // on the parent scope, and won't be automatically destroyed when
	        // the component is destroyed.
	        function setDisable(value) {
	          element.children().attr('disabled', value);
	          element.find('input').attr('disabled', value);
	        }
	
	        var stopDisabledWatch = angular.noop;
	
	        if (attr.disabled) {
	          setDisable(true);
	        }
	        else if (attr.ngDisabled) {
	          stopDisabledWatch = scope.$watch(attr.ngDisabled, function (value) {
	            setDisable(value);
	          });
	        }
	
	        scope.$on('$destroy', function () {
	          stopDisabledWatch();
	        });
	
	        var initialMaxWidth;
	
	        /**
	         * @param {number} length of the input's string value
	         */
	        ctrl.fitInputWidthToTextLength = function (length) {
	          var input = element[0].querySelector('md-input-container');
	
	          if (input) {
	            var computedStyle = getComputedStyle(input);
	            var minWidth = parseInt(computedStyle.minWidth);
	            var padding = parseInt(computedStyle.paddingLeft) + parseInt(computedStyle.paddingRight);
	
	            initialMaxWidth = initialMaxWidth || parseInt(computedStyle.maxWidth);
	            var newMaxWidth = Math.max(initialMaxWidth, minWidth + padding + (minWidth / 2 * length));
	
	            input.style.maxWidth = newMaxWidth + 'px';
	          }
	        };
	      };
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name mdSlider
	 * @module material.components.slider
	 * @restrict E
	 * @description
	 * The `<md-slider>` component allows the user to choose from a range of values.
	 *
	 * As per the [Material Design spec](https://material.io/archive/guidelines/style/color.html#color-color-system)
	 * the slider is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * The slider has two modes:
	 * - "normal" mode where the user slides between a wide range of values
	 * - "discrete" mode where the user slides between only a few select values
	 *
	 * To enable discrete mode, add the `md-discrete` attribute to a slider
	 * and use the `step` attribute to change the distance between
	 * values the user is allowed to pick.
	 *
	 * When using the keyboard:
	 * - pressing the arrow keys will increase or decrease the slider's value by one step
	 * - holding the Meta, Control, or Alt key while pressing the arrow keys will
	 *   move the slider four steps at a time
	 * - pressing the Home key will move the slider to the first allowed value
	 * - pressing the End key will move the slider to the last allowed value
	 * - pressing the Page Up key will increase the slider value by ten
	 * - pressing the Page Down key will decrease the slider value by ten
	 *
	 * @usage
	 * <h4>Normal Mode</h4>
	 * <hljs lang="html">
	 * <md-slider ng-model="myValue" min="5" max="500">
	 * </md-slider>
	 * </hljs>
	 * <h4>Discrete Mode</h4>
	 * <hljs lang="html">
	 * <md-slider md-discrete ng-model="myDiscreteValue" step="10" min="10" max="130">
	 * </md-slider>
	 * </hljs>
	 * <h4>Invert Mode</h4>
	 * <hljs lang="html">
	 * <md-slider md-invert ng-model="myValue" step="10" min="10" max="130">
	 * </md-slider>
	 * </hljs>
	 *
	 * @param {expression} ng-model Assignable angular expression to be data-bound.
	 *  The expression should evaluate to a `number`.
	 * @param {expression=} ng-disabled If this expression evaluates as truthy, the slider will be
	 *  disabled.
	 * @param {expression=} ng-readonly If this expression evaluates as truthy, the slider will be in
	 *  read only mode.
	 * @param {boolean=} md-discrete If this attribute exists during initialization, enable discrete
	 *  mode. Defaults to `false`.
	 * @param {boolean=} md-vertical If this attribute exists during initialization, enable vertical
	 *  orientation mode. Defaults to `false`.
	 * @param {boolean=} md-invert If this attribute exists during initialization, enable inverted mode.
	 *  Defaults to `false`.
	 * @param {number=} step The distance between values the user is allowed to pick. Defaults to `1`.
	 * @param {number=} min The minimum value the user is allowed to pick. Defaults to `0`.
	 * @param {number=} max The maximum value the user is allowed to pick. Defaults to `100`.
	 * @param {number=} round The amount of numbers after the decimal point. The maximum is 6 to
	 *  prevent scientific notation. Defaults to `3`.
	 */
	function SliderDirective($$rAF, $window, $mdAria, $mdUtil, $mdConstant, $mdTheming, $mdGesture,
	                         $parse, $log, $timeout) {
	  return {
	    scope: {},
	    require: ['?ngModel', '?^mdSliderContainer'],
	    template:
	      '<div class="md-slider-wrapper">' +
	        '<div class="md-slider-content">' +
	          '<div class="md-track-container">' +
	            '<div class="md-track"></div>' +
	            '<div class="md-track md-track-fill"></div>' +
	            '<div class="md-track-ticks"></div>' +
	          '</div>' +
	          '<div class="md-thumb-container">' +
	            '<div class="md-thumb"></div>' +
	            '<div class="md-focus-thumb"></div>' +
	            '<div class="md-focus-ring"></div>' +
	            '<div class="md-sign">' +
	              '<span class="md-thumb-text"></span>' +
	            '</div>' +
	            '<div class="md-disabled-thumb"></div>' +
	          '</div>' +
	        '</div>' +
	      '</div>',
	    compile: compile
	  };
	
	  // **********************************************************
	  // Private Methods
	  // **********************************************************
	
	  function compile (tElement, tAttrs) {
	    var wrapper = angular.element(tElement[0].getElementsByClassName('md-slider-wrapper'));
	
	    var tabIndex = tAttrs.tabindex || 0;
	    wrapper.attr('tabindex', tabIndex);
	
	    if (tAttrs.disabled || tAttrs.ngDisabled) wrapper.attr('tabindex', -1);
	
	    wrapper.attr('role', 'slider');
	
	    $mdAria.expect(tElement, 'aria-label');
	
	    return postLink;
	  }
	
	  function postLink(scope, element, attr, ctrls) {
	    $mdTheming(element);
	    var ngModelCtrl = ctrls[0] || {
	      // Mock ngModelController if it doesn't exist to give us
	      // the minimum functionality needed
	      $setViewValue: function(val) {
	        this.$viewValue = val;
	        this.$viewChangeListeners.forEach(function(cb) { cb(); });
	      },
	      $parsers: [],
	      $formatters: [],
	      $viewChangeListeners: []
	    };
	
	    var containerCtrl = ctrls[1];
	    var container = angular.element($mdUtil.getClosest(element, '_md-slider-container', true));
	    var isDisabled = attr.ngDisabled ? angular.bind(null, $parse(attr.ngDisabled), scope.$parent) : function () {
	          return element[0].hasAttribute('disabled');
	        };
	
	    var thumb = angular.element(element[0].querySelector('.md-thumb'));
	    var thumbText = angular.element(element[0].querySelector('.md-thumb-text'));
	    var thumbContainer = thumb.parent();
	    var trackContainer = angular.element(element[0].querySelector('.md-track-container'));
	    var activeTrack = angular.element(element[0].querySelector('.md-track-fill'));
	    var tickContainer = angular.element(element[0].querySelector('.md-track-ticks'));
	    var wrapper = angular.element(element[0].getElementsByClassName('md-slider-wrapper'));
	    var content = angular.element(element[0].getElementsByClassName('md-slider-content'));
	    var throttledRefreshDimensions = $mdUtil.throttle(refreshSliderDimensions, 5000);
	
	    // Default values, overridable by attrs
	    var DEFAULT_ROUND = 3;
	    var vertical = angular.isDefined(attr.mdVertical);
	    var discrete = angular.isDefined(attr.mdDiscrete);
	    var invert = angular.isDefined(attr.mdInvert);
	    angular.isDefined(attr.min) ? attr.$observe('min', updateMin) : updateMin(0);
	    angular.isDefined(attr.max) ? attr.$observe('max', updateMax) : updateMax(100);
	    angular.isDefined(attr.step)? attr.$observe('step', updateStep) : updateStep(1);
	    angular.isDefined(attr.round)? attr.$observe('round', updateRound) : updateRound(DEFAULT_ROUND);
	
	    // We have to manually stop the $watch on ngDisabled because it exists
	    // on the parent scope, and won't be automatically destroyed when
	    // the component is destroyed.
	    var stopDisabledWatch = angular.noop;
	    if (attr.ngDisabled) {
	      stopDisabledWatch = scope.$parent.$watch(attr.ngDisabled, updateAriaDisabled);
	    }
	
	    $mdGesture.register(wrapper, 'drag', { horizontal: !vertical });
	
	    scope.mouseActive = false;
	
	    wrapper
	      .on('keydown', keydownListener)
	      .on('mousedown', mouseDownListener)
	      .on('focus', focusListener)
	      .on('blur', blurListener)
	      .on('$md.pressdown', onPressDown)
	      .on('$md.pressup', onPressUp)
	      .on('$md.dragstart', onDragStart)
	      .on('$md.drag', onDrag)
	      .on('$md.dragend', onDragEnd);
	
	    // On resize, recalculate the slider's dimensions and re-render
	    function updateAll() {
	      refreshSliderDimensions();
	      ngModelRender();
	    }
	    setTimeout(updateAll, 0);
	
	    var debouncedUpdateAll = $$rAF.throttle(updateAll);
	    angular.element($window).on('resize', debouncedUpdateAll);
	
	    scope.$on('$destroy', function() {
	      angular.element($window).off('resize', debouncedUpdateAll);
	    });
	
	    ngModelCtrl.$render = ngModelRender;
	    ngModelCtrl.$viewChangeListeners.push(ngModelRender);
	    ngModelCtrl.$formatters.push(minMaxValidator);
	    ngModelCtrl.$formatters.push(stepValidator);
	
	    /**
	     * Attributes
	     */
	    var min;
	    var max;
	    var step;
	    var round;
	    function updateMin(value) {
	      min = parseFloat(value);
	      ngModelCtrl.$viewValue = minMaxValidator(ngModelCtrl.$modelValue, min, max);
	      wrapper.attr('aria-valuemin', value);
	      updateAll();
	    }
	    function updateMax(value) {
	      max = parseFloat(value);
	      ngModelCtrl.$viewValue = minMaxValidator(ngModelCtrl.$modelValue, min, max);
	      wrapper.attr('aria-valuemax', value);
	      updateAll();
	    }
	    function updateStep(value) {
	      step = parseFloat(value);
	    }
	    function updateRound(value) {
	      // Set max round digits to 6, after 6 the input uses scientific notation
	      round = minMaxValidator(parseInt(value), 0, 6);
	    }
	    function updateAriaDisabled() {
	      element.attr('aria-disabled', !!isDisabled());
	    }
	
	    // Draw the ticks with canvas.
	    // The alternative to drawing ticks with canvas is to draw one element for each tick,
	    // which could quickly become a performance bottleneck.
	    var tickCanvas, tickCtx;
	    function redrawTicks() {
	      if (!discrete || isDisabled()) return;
	      if (angular.isUndefined(step))         return;
	
	      if (step <= 0) {
	        var msg = 'Slider step value must be greater than zero when in discrete mode';
	        $log.error(msg);
	        throw new Error(msg);
	      }
	
	      var numSteps = Math.floor((max - min) / step);
	      if (!tickCanvas) {
	        tickCanvas = angular.element('<canvas>').css('position', 'absolute');
	        tickContainer.append(tickCanvas);
	
	        tickCtx = tickCanvas[0].getContext('2d');
	      }
	
	      var dimensions = getSliderDimensions();
	
	      // If `dimensions` doesn't have height and width it might be the first attempt so we will refresh dimensions
	      if (dimensions && !dimensions.height && !dimensions.width) {
	        refreshSliderDimensions();
	        dimensions = sliderDimensions;
	      }
	
	      tickCanvas[0].width = dimensions.width;
	      tickCanvas[0].height = dimensions.height;
	
	      var distance;
	      for (var i = 0; i <= numSteps; i++) {
	        var trackTicksStyle = $window.getComputedStyle(tickContainer[0]);
	        tickCtx.fillStyle = trackTicksStyle.color || 'black';
	
	        distance = Math.floor((vertical ? dimensions.height : dimensions.width) * (i / numSteps));
	
	        tickCtx.fillRect(vertical ? 0 : distance - 1,
	          vertical ? distance - 1 : 0,
	          vertical ? dimensions.width : 2,
	          vertical ? 2 : dimensions.height);
	      }
	    }
	
	    function clearTicks() {
	      if (tickCanvas && tickCtx) {
	        var dimensions = getSliderDimensions();
	        tickCtx.clearRect(0, 0, dimensions.width, dimensions.height);
	      }
	    }
	
	    /**
	     * Refreshing Dimensions
	     */
	    var sliderDimensions = {};
	    refreshSliderDimensions();
	    function refreshSliderDimensions() {
	      sliderDimensions = trackContainer[0].getBoundingClientRect();
	    }
	    function getSliderDimensions() {
	      throttledRefreshDimensions();
	      return sliderDimensions;
	    }
	
	    /**
	     * left/right/up/down arrow listener
	     * @param {!KeyboardEvent} ev
	     */
	    function keydownListener(ev) {
	      if (isDisabled()) return;
	      var keyCodes = $mdConstant.KEY_CODE;
	
	      var changeAmount;
	      switch (ev.keyCode) {
	        case keyCodes.DOWN_ARROW:
	        case keyCodes.LEFT_ARROW:
	          ev.preventDefault();
	          changeAmount = -step;
	          break;
	        case keyCodes.UP_ARROW:
	        case keyCodes.RIGHT_ARROW:
	          ev.preventDefault();
	          changeAmount = step;
	          break;
	        case keyCodes.PAGE_DOWN:
	          ev.preventDefault();
	          changeAmount = -step * stepPageSize;
	          break;
	        case keyCodes.PAGE_UP:
	          ev.preventDefault();
	          changeAmount = step * stepPageSize;
	          break;
	        case keyCodes.HOME:
	          ev.preventDefault();
	          ev.stopPropagation();
	          updateValue(min);
	          break;
	        case keyCodes.END:
	          ev.preventDefault();
	          ev.stopPropagation();
	          updateValue(max);
	          break;
	      }
	      if (changeAmount) {
	        changeAmount = invert ? -changeAmount : changeAmount;
	        if (ev.metaKey || ev.ctrlKey || ev.altKey) {
	          changeAmount *= modifierMultiplier;
	        }
	        ev.preventDefault();
	        ev.stopPropagation();
	        updateValue(ngModelCtrl.$viewValue + changeAmount);
	      }
	    }
	
	    /**
	     * @param value new slider value used for setting the model value
	     */
	    function updateValue(value) {
	      scope.$evalAsync(function() {
	        setModelValue(value);
	      });
	    }
	
	    function mouseDownListener() {
	      redrawTicks();
	
	      scope.mouseActive = true;
	      wrapper.removeClass('md-focused');
	
	      $timeout(function() {
	        scope.mouseActive = false;
	      }, 100);
	    }
	
	    function focusListener() {
	      if (scope.mouseActive === false) {
	        wrapper.addClass('md-focused');
	      }
	    }
	
	    function blurListener() {
	      wrapper.removeClass('md-focused');
	      element.removeClass('md-active');
	      clearTicks();
	    }
	
	    /**
	     * ngModel setters and validators
	     */
	    function setModelValue(value) {
	      ngModelCtrl.$setViewValue(minMaxValidator(stepValidator(value)));
	    }
	    function ngModelRender() {
	      if (isNaN(ngModelCtrl.$viewValue)) {
	        ngModelCtrl.$viewValue = ngModelCtrl.$modelValue;
	      }
	
	      ngModelCtrl.$viewValue = minMaxValidator(ngModelCtrl.$viewValue);
	
	      var percent = valueToPercent(ngModelCtrl.$viewValue);
	      scope.modelValue = ngModelCtrl.$viewValue;
	      wrapper.attr('aria-valuenow', ngModelCtrl.$viewValue);
	      setSliderPercent(percent);
	      thumbText.text(ngModelCtrl.$viewValue);
	    }
	
	    function minMaxValidator(value, minValue, maxValue) {
	      if (angular.isNumber(value)) {
	        minValue = angular.isNumber(minValue) ? minValue : min;
	        maxValue = angular.isNumber(maxValue) ? maxValue : max;
	
	        return Math.max(minValue, Math.min(maxValue, value));
	      }
	    }
	
	    function stepValidator(value) {
	      if (angular.isNumber(value)) {
	        var formattedValue = (Math.round((value - min) / step) * step + min);
	        formattedValue = (Math.round(formattedValue * Math.pow(10, round)) / Math.pow(10, round));
	
	        if (containerCtrl && containerCtrl.fitInputWidthToTextLength) {
	          $mdUtil.debounce(function () {
	            containerCtrl.fitInputWidthToTextLength(formattedValue.toString().length);
	          }, 100)();
	        }
	
	        return formattedValue;
	      }
	    }
	
	    /**
	     * @param {number} percent 0-1
	     */
	    function setSliderPercent(percent) {
	
	      percent = clamp(percent);
	
	      var thumbPosition = (percent * 100) + '%';
	      var activeTrackPercent = invert ? (1 - percent) * 100 + '%' : thumbPosition;
	
	      if (vertical) {
	        thumbContainer.css('bottom', thumbPosition);
	      }
	      else {
	        $mdUtil.bidiProperty(thumbContainer, 'left', 'right', thumbPosition);
	      }
	
	
	      activeTrack.css(vertical ? 'height' : 'width', activeTrackPercent);
	
	      element.toggleClass((invert ? 'md-max' : 'md-min'), percent === 0);
	      element.toggleClass((invert ? 'md-min' : 'md-max'), percent === 1);
	    }
	
	    /**
	     * Slide listeners
	     */
	    var isDragging = false;
	
	    function onPressDown(ev) {
	      if (isDisabled()) return;
	
	      element.addClass('md-active');
	      element[0].focus();
	      refreshSliderDimensions();
	
	      var exactVal = percentToValue(positionToPercent(vertical ? ev.srcEvent.clientY : ev.srcEvent.clientX));
	      var closestVal = minMaxValidator(stepValidator(exactVal));
	      scope.$apply(function() {
	        setModelValue(closestVal);
	        setSliderPercent(valueToPercent(closestVal));
	      });
	    }
	    function onPressUp(ev) {
	      if (isDisabled()) return;
	
	      element.removeClass('md-dragging');
	
	      var exactVal = percentToValue(positionToPercent(vertical ? ev.srcEvent.clientY : ev.srcEvent.clientX));
	      var closestVal = minMaxValidator(stepValidator(exactVal));
	      scope.$apply(function() {
	        setModelValue(closestVal);
	        ngModelRender();
	      });
	    }
	    function onDragStart(ev) {
	      if (isDisabled()) return;
	      isDragging = true;
	
	      ev.stopPropagation();
	
	      element.addClass('md-dragging');
	      setSliderFromEvent(ev);
	    }
	    function onDrag(ev) {
	      if (!isDragging) return;
	      ev.stopPropagation();
	      setSliderFromEvent(ev);
	    }
	    function onDragEnd(ev) {
	      if (!isDragging) return;
	      ev.stopPropagation();
	      isDragging = false;
	    }
	
	    function setSliderFromEvent(ev) {
	      // While panning discrete, update only the
	      // visual positioning but not the model value.
	      if (discrete) adjustThumbPosition(vertical ? ev.srcEvent.clientY : ev.srcEvent.clientX);
	      else            doSlide(vertical ? ev.srcEvent.clientY : ev.srcEvent.clientX);
	    }
	
	    /**
	     * Slide the UI by changing the model value
	     * @param x
	     */
	    function doSlide(x) {
	      scope.$evalAsync(function() {
	        setModelValue(percentToValue(positionToPercent(x)));
	      });
	    }
	
	    /**
	     * Slide the UI without changing the model (while dragging/panning)
	     * @param x
	     */
	    function adjustThumbPosition(x) {
	      var exactVal = percentToValue(positionToPercent(x));
	      var closestVal = minMaxValidator(stepValidator(exactVal));
	      setSliderPercent(positionToPercent(x));
	      thumbText.text(closestVal);
	    }
	
	    /**
	    * Clamps the value to be between 0 and 1.
	    * @param {number} value The value to clamp.
	    * @returns {number}
	    */
	    function clamp(value) {
	      return Math.max(0, Math.min(value || 0, 1));
	    }
	
	    /**
	     * Convert position on slider to percentage value of offset from beginning...
	     * @param position
	     * @returns {number}
	     */
	    function positionToPercent(position) {
	      var offset = vertical ? sliderDimensions.top : sliderDimensions.left;
	      var size = vertical ? sliderDimensions.height : sliderDimensions.width;
	      var calc = (position - offset) / size;
	
	      if (!vertical && $mdUtil.isRtl(attr)) {
	        calc = 1 - calc;
	      }
	
	      return Math.max(0, Math.min(1, vertical ? 1 - calc : calc));
	    }
	
	    /**
	     * Convert percentage offset on slide to equivalent model value
	     * @param percent
	     * @returns {*}
	     */
	    function percentToValue(percent) {
	      var adjustedPercent = invert ? (1 - percent) : percent;
	      return (min + adjustedPercent * (max - min));
	    }
	
	    function valueToPercent(val) {
	      var percent = (val - min) / (max - min);
	      return invert ? (1 - percent) : percent;
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.sticky
	 * @description
	 * Sticky effects for md
	 *
	 */
	MdSticky.$inject = ["$mdConstant", "$$rAF", "$mdUtil", "$compile"];
	angular
	  .module('material.components.sticky', [
	    'material.core',
	    'material.components.content'
	  ])
	  .factory('$mdSticky', MdSticky);
	
	/**
	 * @ngdoc service
	 * @name $mdSticky
	 * @module material.components.sticky
	 *
	 * @description
	 * The `$mdSticky`service provides a mixin to make elements sticky.
	 *
	 * Whenever the current browser supports stickiness natively, the `$mdSticky` service will just
	 * use the native browser stickiness.
	 *
	 * By default the `$mdSticky` service compiles the cloned element, when not specified through the `elementClone`
	 * parameter, in the same scope as the actual element lives.
	 *
	 *
	 * <h3>Notes</h3>
	 * When using an element which is containing a compiled directive, which changed its DOM structure during compilation,
	 * you should compile the clone yourself using the plain template.<br/><br/>
	 * See the right usage below:
	 * <hljs lang="js">
	 *   angular.module('myModule')
	 *     .directive('stickySelect', function($mdSticky, $compile) {
	 *       var SELECT_TEMPLATE =
	 *         '<md-select ng-model="selected">' +
	 *           '<md-option>Option 1</md-option>' +
	 *         '</md-select>';
	 *
	 *       return {
	 *         restrict: 'E',
	 *         replace: true,
	 *         template: SELECT_TEMPLATE,
	 *         link: function(scope,element) {
	 *           $mdSticky(scope, element, $compile(SELECT_TEMPLATE)(scope));
	 *         }
	 *       };
	 *     });
	 * </hljs>
	 *
	 * @usage
	 * <hljs lang="js">
	 *   angular.module('myModule')
	 *     .directive('stickyText', function($mdSticky, $compile) {
	 *       return {
	 *         restrict: 'E',
	 *         template: '<span>Sticky Text</span>',
	 *         link: function(scope,element) {
	 *           $mdSticky(scope, element);
	 *         }
	 *       };
	 *     });
	 * </hljs>
	 *
	 * @returns A `$mdSticky` function that takes three arguments:
	 *   - `scope`
	 *   - `element`: The element that will be 'sticky'
	 *   - `elementClone`: A clone of the element, that will be shown
	 *     when the user starts scrolling past the original element.
	 *     If not provided, it will use the result of `element.clone()` and compiles it in the given scope.
	 */
	function MdSticky($mdConstant, $$rAF, $mdUtil, $compile) {
	
	  var browserStickySupport = $mdUtil.checkStickySupport();
	
	  /**
	   * Registers an element as sticky, used internally by directives to register themselves
	   */
	  return function registerStickyElement(scope, element, stickyClone) {
	    var contentCtrl = element.controller('mdContent');
	    if (!contentCtrl) return;
	
	    if (browserStickySupport) {
	      element.css({
	        position: browserStickySupport,
	        top: 0,
	        'z-index': 2
	      });
	    } else {
	      var $$sticky = contentCtrl.$element.data('$$sticky');
	      if (!$$sticky) {
	        $$sticky = setupSticky(contentCtrl);
	        contentCtrl.$element.data('$$sticky', $$sticky);
	      }
	
	      // Compile our cloned element, when cloned in this service, into the given scope.
	      var cloneElement = stickyClone || $compile(element.clone())(scope);
	
	      var deregister = $$sticky.add(element, cloneElement);
	      scope.$on('$destroy', deregister);
	    }
	  };
	
	  function setupSticky(contentCtrl) {
	    var contentEl = contentCtrl.$element;
	
	    // Refresh elements is very expensive, so we use the debounced
	    // version when possible.
	    var debouncedRefreshElements = $$rAF.throttle(refreshElements);
	
	    // setupAugmentedScrollEvents gives us `$scrollstart` and `$scroll`,
	    // more reliable than `scroll` on android.
	    setupAugmentedScrollEvents(contentEl);
	    contentEl.on('$scrollstart', debouncedRefreshElements);
	    contentEl.on('$scroll', onScroll);
	
	    var self;
	    return self = {
	      prev: null,
	      current: null, // the currently stickied item
	      next: null,
	      items: [],
	      add: add,
	      refreshElements: refreshElements
	    };
	
	    /***************
	     * Public
	     ***************/
	    // Add an element and its sticky clone to this content's sticky collection
	    function add(element, stickyClone) {
	      stickyClone.addClass('md-sticky-clone');
	
	      var item = {
	        element: element,
	        clone: stickyClone
	      };
	      self.items.push(item);
	
	      $mdUtil.nextTick(function() {
	        contentEl.prepend(item.clone);
	      });
	
	      debouncedRefreshElements();
	
	      return function remove() {
	        self.items.forEach(function(item, index) {
	          if (item.element[0] === element[0]) {
	            self.items.splice(index, 1);
	            item.clone.remove();
	          }
	        });
	        debouncedRefreshElements();
	      };
	    }
	
	    function refreshElements() {
	      // Sort our collection of elements by their current position in the DOM.
	      // We need to do this because our elements' order of being added may not
	      // be the same as their order of display.
	      self.items.forEach(refreshPosition);
	      self.items = self.items.sort(function(a, b) {
	        return a.top < b.top ? -1 : 1;
	      });
	
	      // Find which item in the list should be active,
	      // based upon the content's current scroll position
	      var item;
	      var currentScrollTop = contentEl.prop('scrollTop');
	      for (var i = self.items.length - 1; i >= 0; i--) {
	        if (currentScrollTop > self.items[i].top) {
	          item = self.items[i];
	          break;
	        }
	      }
	      setCurrentItem(item);
	    }
	
	    /***************
	     * Private
	     ***************/
	
	    // Find the `top` of an item relative to the content element,
	    // and also the height.
	    function refreshPosition(item) {
	      // Find the top of an item by adding to the offsetHeight until we reach the
	      // content element.
	      var current = item.element[0];
	      item.top = 0;
	      item.left = 0;
	      item.right = 0;
	      while (current && current !== contentEl[0]) {
	        item.top += current.offsetTop;
	        item.left += current.offsetLeft;
	        if (current.offsetParent) {
	          // Compute offsetRight
	          item.right += current.offsetParent.offsetWidth - current.offsetWidth - current.offsetLeft;
	        }
	        current = current.offsetParent;
	      }
	      item.height = item.element.prop('offsetHeight');
	
	      var defaultVal = $mdUtil.floatingScrollbars() ? '0' : undefined;
	      $mdUtil.bidi(item.clone, 'margin-left', item.left, defaultVal);
	      $mdUtil.bidi(item.clone, 'margin-right', defaultVal, item.right);
	    }
	
	    // As we scroll, push in and select the correct sticky element.
	    function onScroll() {
	      var scrollTop = contentEl.prop('scrollTop');
	      var isScrollingDown = scrollTop > (onScroll.prevScrollTop || 0);
	
	      // Store the previous scroll so we know which direction we are scrolling
	      onScroll.prevScrollTop = scrollTop;
	
	      //
	      // AT TOP (not scrolling)
	      //
	      if (scrollTop === 0) {
	        // If we're at the top, just clear the current item and return
	        setCurrentItem(null);
	        return;
	      }
	
	      //
	      // SCROLLING DOWN (going towards the next item)
	      //
	      if (isScrollingDown) {
	
	        // If we've scrolled down past the next item's position, sticky it and return
	        if (self.next && self.next.top <= scrollTop) {
	          setCurrentItem(self.next);
	          return;
	        }
	
	        // If the next item is close to the current one, push the current one up out of the way
	        if (self.current && self.next && self.next.top - scrollTop <= self.next.height) {
	          translate(self.current, scrollTop + (self.next.top - self.next.height - scrollTop));
	          return;
	        }
	      }
	
	      //
	      // SCROLLING UP (not at the top & not scrolling down; must be scrolling up)
	      //
	      if (!isScrollingDown) {
	
	        // If we've scrolled up past the previous item's position, sticky it and return
	        if (self.current && self.prev && scrollTop < self.current.top) {
	          setCurrentItem(self.prev);
	          return;
	        }
	
	        // If the next item is close to the current one, pull the current one down into view
	        if (self.next && self.current && (scrollTop >= (self.next.top - self.current.height))) {
	          translate(self.current, scrollTop + (self.next.top - scrollTop - self.current.height));
	          return;
	        }
	      }
	
	      //
	      // Otherwise, just move the current item to the proper place (scrolling up or down)
	      //
	      if (self.current) {
	        translate(self.current, scrollTop);
	      }
	    }
	
	    function setCurrentItem(item) {
	      if (self.current === item) return;
	      // Deactivate currently active item
	      if (self.current) {
	        translate(self.current, null);
	        setStickyState(self.current, null);
	      }
	
	      // Activate new item if given
	      if (item) {
	        setStickyState(item, 'active');
	      }
	
	      self.current = item;
	      var index = self.items.indexOf(item);
	      // If index === -1, index + 1 = 0. It works out.
	      self.next = self.items[index + 1];
	      self.prev = self.items[index - 1];
	      setStickyState(self.next, 'next');
	      setStickyState(self.prev, 'prev');
	    }
	
	    function setStickyState(item, state) {
	      if (!item || item.state === state) return;
	      if (item.state) {
	        item.clone.attr('sticky-prev-state', item.state);
	        item.element.attr('sticky-prev-state', item.state);
	      }
	      item.clone.attr('sticky-state', state);
	      item.element.attr('sticky-state', state);
	      item.state = state;
	    }
	
	    function translate(item, amount) {
	      if (!item) return;
	      if (amount === null || amount === undefined) {
	        if (item.translateY) {
	          item.translateY = null;
	          item.clone.css($mdConstant.CSS.TRANSFORM, '');
	        }
	      } else {
	        item.translateY = amount;
	
	        $mdUtil.bidi(item.clone, $mdConstant.CSS.TRANSFORM,
	          'translate3d(' + item.left + 'px,' + amount + 'px,0)',
	          'translateY(' + amount + 'px)'
	        );
	      }
	    }
	  }
	
	
	  // Android 4.4 don't accurately give scroll events.
	  // To fix this problem, we setup a fake scroll event. We say:
	  // > If a scroll or touchmove event has happened in the last DELAY milliseconds,
	  //   then send a `$scroll` event every animationFrame.
	  // Additionally, we add $scrollstart and $scrollend events.
	  function setupAugmentedScrollEvents(element) {
	    var SCROLL_END_DELAY = 200;
	    var isScrolling;
	    var lastScrollTime;
	    element.on('scroll touchmove', function() {
	      if (!isScrolling) {
	        isScrolling = true;
	        $$rAF.throttle(loopScrollEvent);
	        element.triggerHandler('$scrollstart');
	      }
	      element.triggerHandler('$scroll');
	      lastScrollTime = +$mdUtil.now();
	    });
	
	    function loopScrollEvent() {
	      if (+$mdUtil.now() - lastScrollTime > SCROLL_END_DELAY) {
	        isScrolling = false;
	        element.triggerHandler('$scrollend');
	      } else {
	        element.triggerHandler('$scroll');
	        $$rAF.throttle(loopScrollEvent);
	      }
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.subheader
	 * @description
	 * SubHeader module
	 *
	 *  Subheaders are special list tiles that delineate distinct sections of a
	 *  list or grid list and are typically related to the current filtering or
	 *  sorting criteria. Subheader tiles are either displayed inline with tiles or
	 *  can be associated with content, for example, in an adjacent column.
	 *
	 *  Upon scrolling, subheaders remain pinned to the top of the screen and remain
	 *  pinned until pushed on or off screen by the next subheader. @see [Material
	 *  Design Specifications](https://material.io/archive/guidelines/components/subheaders.html)
	 *
	 *  > To improve the visual grouping of content, use the system color for your subheaders.
	 *
	 */
	MdSubheaderDirective.$inject = ["$mdSticky", "$compile", "$mdTheming", "$mdUtil", "$mdAria"];
	angular
	  .module('material.components.subheader', [
	    'material.core',
	    'material.components.sticky'
	  ])
	  .directive('mdSubheader', MdSubheaderDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdSubheader
	 * @module material.components.subheader
	 *
	 * @restrict E
	 *
	 * @description
	 * The `md-subheader` directive creates a sticky subheader for a section.
	 *
	 * Developers are able to disable the stickiness of the subheader by using the following markup
	 *
	 * <hljs lang="html">
	 *   <md-subheader class="md-no-sticky">Not Sticky</md-subheader>
	 * </hljs>
	 *
	 * ### Notes
	 * - The `md-subheader` directive uses the <a ng-href="api/service/$mdSticky">$mdSticky</a> service
	 * to make the subheader sticky.
	 *
	 * > Whenever the current browser doesn't support stickiness natively, the subheader
	 * will be compiled twice to create a sticky clone of the subheader.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-subheader>Online Friends</md-subheader>
	 * </hljs>
	 */
	
	function MdSubheaderDirective($mdSticky, $compile, $mdTheming, $mdUtil, $mdAria) {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: true,
	    template: (
	    '<div class="md-subheader _md">' +
	    '  <div class="md-subheader-inner">' +
	    '    <div class="md-subheader-content"></div>' +
	    '  </div>' +
	    '</div>'
	    ),
	    link: function postLink(scope, element, attr, controllers, transclude) {
	      $mdTheming(element);
	      element.addClass('_md');
	
	      // Remove the ngRepeat attribute from the root element, because we don't want to compile
	      // the ngRepeat for the sticky clone again.
	      $mdUtil.prefixer().removeAttribute(element, 'ng-repeat');
	
	      var outerHTML = element[0].outerHTML;
	
	      function getContent(el) {
	        return angular.element(el[0].querySelector('.md-subheader-content'));
	      }
	
	      // Set the ARIA attributes on the original element since it keeps it's original place in
	      // the DOM, whereas the clones are in reverse order. Should be done after the outerHTML,
	      // in order to avoid having multiple element be marked as headers.
	      attr.$set('role', 'heading');
	      $mdAria.expect(element, 'aria-level', '2');
	
	      // Transclude the user-given contents of the subheader
	      // the conventional way.
	      transclude(scope, function(clone) {
	        getContent(element).append(clone);
	      });
	
	      // Create another clone, that uses the outer and inner contents
	      // of the element, that will be 'stickied' as the user scrolls.
	      if (!element.hasClass('md-no-sticky')) {
	        transclude(scope, function(clone) {
	          // If the user adds an ng-if or ng-repeat directly to the md-subheader element, the
	          // compiled clone below will only be a comment tag (since they replace their elements with
	          // a comment) which cannot be properly passed to the $mdSticky; so we wrap it in our own
	          // DIV to ensure we have something $mdSticky can use
	          var wrapper = $compile('<div class="md-subheader-wrapper" aria-hidden="true">' + outerHTML + '</div>')(scope);
	
	          // Delay initialization until after any `ng-if`/`ng-repeat`/etc has finished before
	          // attempting to create the clone
	          $mdUtil.nextTick(function() {
	            // Append our transcluded clone into the wrapper.
	            // We don't have to recompile the element again, because the clone is already
	            // compiled in it's transclusion scope. If we recompile the outerHTML of the new clone, we would lose
	            // our ngIf's and other previous registered bindings / properties.
	            getContent(wrapper).append(clone);
	          });
	
	          // Make the element sticky and provide the stickyClone our self, to avoid recompilation of the subheader
	          // element.
	          $mdSticky(scope, element, wrapper);
	        });
	      }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.swipe
	 * @description Swipe module!
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeLeft
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-left directive allows you to specify custom behavior when an element is swiped
	 * left.
	 *
	 * ### Notes
	 * - The `$event.currentTarget` of the swiped element will be `null`, but you can get a
	 * reference to the element that actually holds the `md-swipe-left` directive by using
	 * `$target.current`
	 *
	 * > You can see this in action on the <a ng-href="demo/swipe">demo page</a> (Look at the Developer
	 * Tools console while swiping).
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-left="onSwipeLeft($event, $target)">Swipe me left!</div>
	 * </hljs>
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeRight
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-right directive allows you to specify custom behavior when an element is swiped
	 * right.
	 *
	 * ### Notes
	 * - The `$event.currentTarget` of the swiped element will be `null`, but you can get a
	 * reference to the element that actually holds the `md-swipe-right` directive by using
	 * `$target.current`
	 *
	 * > You can see this in action on the <a ng-href="demo/swipe">demo page</a> (Look at the Developer
	 * Tools console while swiping).
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-right="onSwipeRight($event, $target)">Swipe me right!</div>
	 * </hljs>
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeUp
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-up directive allows you to specify custom behavior when an element is swiped
	 * up.
	 *
	 * ### Notes
	 * - The `$event.currentTarget` of the swiped element will be `null`, but you can get a
	 * reference to the element that actually holds the `md-swipe-up` directive by using
	 * `$target.current`
	 *
	 * > You can see this in action on the <a ng-href="demo/swipe">demo page</a> (Look at the Developer
	 * Tools console while swiping).
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-up="onSwipeUp($event, $target)">Swipe me up!</div>
	 * </hljs>
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeDown
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-down directive allows you to specify custom behavior when an element is swiped
	 * down.
	 *
	 * ### Notes
	 * - The `$event.currentTarget` of the swiped element will be `null`, but you can get a
	 * reference to the element that actually holds the `md-swipe-down` directive by using
	 * `$target.current`
	 *
	 * > You can see this in action on the <a ng-href="demo/swipe">demo page</a> (Look at the Developer
	 * Tools console while swiping).
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-down="onSwipeDown($event, $target)">Swipe me down!</div>
	 * </hljs>
	 */
	
	angular.module('material.components.swipe', ['material.core'])
	    .directive('mdSwipeLeft', getDirective('SwipeLeft'))
	    .directive('mdSwipeRight', getDirective('SwipeRight'))
	    .directive('mdSwipeUp', getDirective('SwipeUp'))
	    .directive('mdSwipeDown', getDirective('SwipeDown'));
	
	function getDirective(name) {
	    DirectiveFactory.$inject = ["$parse"];
	  var directiveName = 'md' + name;
	  var eventName = '$md.' + name.toLowerCase();
	
	  return DirectiveFactory;
	
	  /* @ngInject */
	  function DirectiveFactory($parse) {
	      return { restrict: 'A', link: postLink };
	      function postLink(scope, element, attr) {
	        var fn = $parse(attr[directiveName]);
	        element.on(eventName, function(ev) {
	          var currentTarget = ev.currentTarget;
	          scope.$applyAsync(function() { fn(scope, { $event: ev, $target: { current: currentTarget } }); });
	        });
	      }
	    }
	}
	
	
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.switch
	 */
	
	MdSwitch.$inject = ["mdCheckboxDirective", "$mdUtil", "$mdConstant", "$parse", "$$rAF", "$mdGesture", "$timeout"];
	angular.module('material.components.switch', [
	  'material.core',
	  'material.components.checkbox'
	])
	  .directive('mdSwitch', MdSwitch);
	
	/**
	 * @ngdoc directive
	 * @module material.components.switch
	 * @name mdSwitch
	 * @restrict E
	 *
	 * The switch directive is used very much like the normal [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
	 *
	 * As per the [Material Design spec](https://material.io/archive/guidelines/style/color.html#color-color-system)
	 * the switch is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * @param {expression} ng-model Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {expression=} ng-true-value The value to which the expression should be set when selected.
	 * @param {expression=} ng-false-value The value to which the expression should be set when not selected.
	 * @param {expression=} ng-change Expression to be executed when the model value changes.
	 * @param {expression=} ng-disabled En/Disable based on the expression.
	 * @param {boolean=} md-no-ink Use of attribute indicates use of ripple ink effects.
	 * @param {string=} aria-label Publish the button label used by screen-readers for accessibility. Defaults to the switch's text.
	 * @param {boolean=} md-invert When set to true, the switch will be inverted.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-switch ng-model="isActive" aria-label="Finished?">
	 *   Finished ?
	 * </md-switch>
	 *
	 * <md-switch md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
	 *   No Ink Effects
	 * </md-switch>
	 *
	 * <md-switch ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
	 *   Disabled
	 * </md-switch>
	 *
	 * </hljs>
	 */
	function MdSwitch(mdCheckboxDirective, $mdUtil, $mdConstant, $parse, $$rAF, $mdGesture, $timeout) {
	  var checkboxDirective = mdCheckboxDirective[0];
	
	  return {
	    restrict: 'E',
	    priority: $mdConstant.BEFORE_NG_ARIA,
	    transclude: true,
	    template:
	      '<div class="md-container">' +
	        '<div class="md-bar"></div>' +
	        '<div class="md-thumb-container">' +
	          '<div class="md-thumb" md-ink-ripple md-ink-ripple-checkbox></div>' +
	        '</div>'+
	      '</div>' +
	      '<div ng-transclude class="md-label"></div>',
	    require: ['^?mdInputContainer', '?ngModel', '?^form'],
	    compile: mdSwitchCompile
	  };
	
	  function mdSwitchCompile(element, attr) {
	    var checkboxLink = checkboxDirective.compile(element, attr).post;
	    // No transition on initial load.
	    element.addClass('md-dragging');
	
	    return function (scope, element, attr, ctrls) {
	      var containerCtrl = ctrls[0];
	      var ngModel = ctrls[1] || $mdUtil.fakeNgModel();
	      var formCtrl = ctrls[2];
	
	      var disabledGetter = null;
	      if (attr.disabled != null) {
	        disabledGetter = function() { return true; };
	      } else if (attr.ngDisabled) {
	        disabledGetter = $parse(attr.ngDisabled);
	      }
	
	      var thumbContainer = angular.element(element[0].querySelector('.md-thumb-container'));
	      var switchContainer = angular.element(element[0].querySelector('.md-container'));
	      var labelContainer = angular.element(element[0].querySelector('.md-label'));
	
	      // no transition on initial load
	      $$rAF(function() {
	        element.removeClass('md-dragging');
	      });
	
	      checkboxLink(scope, element, attr, ctrls);
	
	      if (disabledGetter) {
	        scope.$watch(disabledGetter, function(isDisabled) {
	          element.attr('tabindex', isDisabled ? -1 : 0);
	        });
	      }
	
	      attr.$observe('mdInvert', function(newValue) {
	        var isInverted = $mdUtil.parseAttributeBoolean(newValue);
	
	        isInverted ? element.prepend(labelContainer) : element.prepend(switchContainer);
	
	        // Toggle a CSS class to update the margin.
	        element.toggleClass('md-inverted', isInverted);
	      });
	
	      // These events are triggered by setup drag
	      $mdGesture.register(switchContainer, 'drag');
	      switchContainer
	        .on('$md.dragstart', onDragStart)
	        .on('$md.drag', onDrag)
	        .on('$md.dragend', onDragEnd);
	
	      var drag;
	      function onDragStart(ev) {
	        // Don't go if the switch is disabled.
	        if (disabledGetter && disabledGetter(scope)) return;
	        ev.stopPropagation();
	
	        element.addClass('md-dragging');
	        drag = {width: thumbContainer.prop('offsetWidth')};
	      }
	
	      function onDrag(ev) {
	        if (!drag) return;
	        ev.stopPropagation();
	        ev.srcEvent && ev.srcEvent.preventDefault();
	
	        var percent = ev.pointer.distanceX / drag.width;
	
	        // if checked, start from right. else, start from left
	        var translate = ngModel.$viewValue ?  1 + percent : percent;
	        // Make sure the switch stays inside its bounds, 0-1%
	        translate = Math.max(0, Math.min(1, translate));
	
	        thumbContainer.css($mdConstant.CSS.TRANSFORM, 'translate3d(' + (100*translate) + '%,0,0)');
	        drag.translate = translate;
	      }
	
	      function onDragEnd(ev) {
	        if (!drag) return;
	        ev.stopPropagation();
	
	        element.removeClass('md-dragging');
	        thumbContainer.css($mdConstant.CSS.TRANSFORM, '');
	
	        // We changed if there is no distance (this is a click a click),
	        // or if the drag distance is >50% of the total.
	        var isChanged = ngModel.$viewValue ? drag.translate < 0.5 : drag.translate > 0.5;
	        if (isChanged) {
	          applyModelValue(!ngModel.$viewValue);
	        }
	        drag = null;
	
	        // Wait for incoming mouse click
	        scope.skipToggle = true;
	        $timeout(function() {
	          scope.skipToggle = false;
	        }, 1);
	      }
	
	      function applyModelValue(newValue) {
	        scope.$apply(function() {
	          ngModel.$setViewValue(newValue);
	          ngModel.$render();
	        });
	      }
	
	    };
	  }
	
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.tabs
	 * @description
	 *
	 *  Tabs, created with the `<md-tabs>` directive provide *tabbed* navigation with different styles.
	 *  The Tabs component consists of clickable tabs that are aligned horizontally side-by-side.
	 *
	 *  Features include support for:
	 *
	 *  - static or dynamic tabs,
	 *  - responsive designs,
	 *  - accessibility support (ARIA),
	 *  - tab pagination,
	 *  - external or internal tab content,
	 *  - focus indicators and arrow-key navigations,
	 *  - programmatic lookup and access to tab controllers, and
	 *  - dynamic transitions through different tab contents.
	 *
	 */
	/*
	 * @see js folder for tabs implementation
	 */
	angular.module('material.components.tabs', [
	  'material.core',
	  'material.components.icon'
	]);
	
	})();
	(function(){
	"use strict";
	
	angular
	.module('material.components.tabs')
	.service('MdTabsPaginationService', MdTabsPaginationService);
	
	/**
	 * @private
	 * @module material.components.tabs
	 * @name MdTabsPaginationService
	 * @description Provides many standalone functions to ease in pagination calculations.
	 *
	 * Most functions accept the elements and the current offset.
	 *
	 * The `elements` parameter is typically the value returned from the `getElements()` function of the
	 * tabsController.
	 *
	 * The `offset` parameter is always positive regardless of LTR or RTL (we simply make the LTR one
	 * negative when we apply our transform). This is typically the `ctrl.leftOffset` variable in the
	 * tabsController.
	 *
	 * @returns MdTabsPaginationService
	 * @constructor
	 */
	function MdTabsPaginationService() {
	  return {
	    decreasePageOffset: decreasePageOffset,
	    increasePageOffset: increasePageOffset,
	    getTabOffsets: getTabOffsets,
	    getTotalTabsWidth: getTotalTabsWidth
	  };
	
	  /**
	   * Returns the offset for the next decreasing page.
	   *
	   * @param elements
	   * @param currentOffset
	   * @returns {number}
	   */
	  function decreasePageOffset(elements, currentOffset) {
	    var canvas       = elements.canvas,
	        tabOffsets   = getTabOffsets(elements),
	        i, firstVisibleTabOffset;
	
	    // Find the first fully visible tab in offset range
	    for (i = 0; i < tabOffsets.length; i++) {
	      if (tabOffsets[i] >= currentOffset) {
	        firstVisibleTabOffset = tabOffsets[i];
	        break;
	      }
	    }
	
	    // Return (the first visible tab offset - the tabs container width) without going negative
	    return Math.max(0, firstVisibleTabOffset - canvas.clientWidth);
	  }
	
	  /**
	   * Returns the offset for the next increasing page.
	   *
	   * @param elements
	   * @param currentOffset
	   * @returns {number}
	   */
	  function increasePageOffset(elements, currentOffset) {
	    var canvas       = elements.canvas,
	        maxOffset    = getTotalTabsWidth(elements) - canvas.clientWidth,
	        tabOffsets   = getTabOffsets(elements),
	        i, firstHiddenTabOffset;
	
	    // Find the first partially (or fully) invisible tab
	    for (i = 0; i < tabOffsets.length, tabOffsets[i] <= currentOffset + canvas.clientWidth; i++) {
	      firstHiddenTabOffset = tabOffsets[i];
	    }
	
	    // Return the offset of the first hidden tab, or the maximum offset (whichever is smaller)
	    return Math.min(maxOffset, firstHiddenTabOffset);
	  }
	
	  /**
	   * Returns the offsets of all of the tabs based on their widths.
	   *
	   * @param elements
	   * @returns {number[]}
	   */
	  function getTabOffsets(elements) {
	    var i, tab, currentOffset = 0, offsets = [];
	
	    for (i = 0; i < elements.tabs.length; i++) {
	      tab = elements.tabs[i];
	      offsets.push(currentOffset);
	      currentOffset += tab.offsetWidth;
	    }
	
	    return offsets;
	  }
	
	  /**
	   * Sum the width of all tabs.
	   *
	   * @param elements
	   * @returns {number}
	   */
	  function getTotalTabsWidth(elements) {
	    var sum = 0, i, tab;
	
	    for (i = 0; i < elements.tabs.length; i++) {
	      tab = elements.tabs[i];
	      sum += tab.offsetWidth;
	    }
	
	    return sum;
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdTab
	 * @module material.components.tabs
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-tab>` is a nested directive used within `<md-tabs>` to specify a tab with a **label**
	 * and optional *view content*.
	 *
	 * If the `label` attribute is not specified, then an optional `<md-tab-label>` tag can be used to
	 * specify more complex tab header markup. If neither the **label** nor the **md-tab-label** are
	 * specified, then the nested markup of the `<md-tab>` is used as the tab header markup.
	 *
	 * Please note that if you use `<md-tab-label>`, your content **MUST** be wrapped in the
	 * `<md-tab-body>` tag.  This is to define a clear separation between the tab content and the tab
	 * label.
	 *
	 * This container is used by the TabsController to show/hide the active tab's content view. This
	 * synchronization is automatically managed by the internal TabsController whenever the tab
	 * selection changes. Selection changes can be initiated via data binding changes, programmatic
	 * invocation, or user gestures.
	 *
	 * @param {string=} label Optional attribute to specify a simple string as the tab label
	 * @param {boolean=} ng-disabled If present and expression evaluates to truthy, disabled tab
	 *  selection.
	 * @param {string=} md-tab-class Optional attribute to specify a class that will be applied to the
	 *  tab's button
	 * @param {expression=} md-on-deselect Expression to be evaluated after the tab has been
	 *  de-selected.
	 * @param {expression=} md-on-select Expression to be evaluated after the tab has been selected.
	 * @param {boolean=} md-active When true, sets the active tab.  Note: There can only be one active
	 *  tab at a time.
	 *
	 *
	 * @usage
	 *
	 * <hljs lang="html">
	 * <md-tab label="My Tab" md-tab-class="my-content-tab" ng-disabled md-on-select="onSelect()"
	 *         md-on-deselect="onDeselect()">
	 *   <h3>My Tab content</h3>
	 * </md-tab>
	 *
	 * <md-tab>
	 *   <md-tab-label>
	 *     <h3>My Tab</h3>
	 *   </md-tab-label>
	 *   <md-tab-body>
	 *     <p>
	 *       Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque
	 *       laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi
	 *       architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
	 *       aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione
	 *       voluptatem sequi nesciunt.
	 *     </p>
	 *   </md-tab-body>
	 * </md-tab>
	 * </hljs>
	 *
	 */
	angular
	    .module('material.components.tabs')
	    .directive('mdTab', MdTab);
	
	function MdTab () {
	  return {
	    require:  '^?mdTabs',
	    terminal: true,
	    compile:  function (element, attr) {
	      var label = firstChild(element, 'md-tab-label'),
	          body  = firstChild(element, 'md-tab-body');
	
	      if (label.length === 0) {
	        label = angular.element('<md-tab-label></md-tab-label>');
	        if (attr.label) label.text(attr.label);
	        else label.append(element.contents());
	
	        if (body.length === 0) {
	          var contents = element.contents().detach();
	          body         = angular.element('<md-tab-body></md-tab-body>');
	          body.append(contents);
	        }
	      }
	
	      element.append(label);
	      if (body.html()) element.append(body);
	
	      return postLink;
	    },
	    scope:    {
	      active:   '=?mdActive',
	      disabled: '=?ngDisabled',
	      select:   '&?mdOnSelect',
	      deselect: '&?mdOnDeselect',
	      tabClass: '@mdTabClass'
	    }
	  };
	
	  function postLink (scope, element, attr, ctrl) {
	    if (!ctrl) return;
	    var index = ctrl.getTabElementIndex(element),
	        body  = firstChild(element, 'md-tab-body').remove(),
	        label = firstChild(element, 'md-tab-label').remove(),
	        data  = ctrl.insertTab({
	          scope:    scope,
	          parent:   scope.$parent,
	          index:    index,
	          element:  element,
	          template: body.html(),
	          label:    label.html()
	        }, index);
	
	    scope.select   = scope.select || angular.noop;
	    scope.deselect = scope.deselect || angular.noop;
	
	    scope.$watch('active', function (active) { if (active) ctrl.select(data.getIndex(), true); });
	    scope.$watch('disabled', function () { ctrl.refreshIndex(); });
	    scope.$watch(
	        function () {
	          return ctrl.getTabElementIndex(element);
	        },
	        function (newIndex) {
	          data.index = newIndex;
	          ctrl.updateTabOrder();
	        }
	    );
	    scope.$on('$destroy', function () { ctrl.removeTab(data); });
	  }
	
	  function firstChild (element, tagName) {
	    var children = element[0].children;
	    for (var i = 0, len = children.length; i < len; i++) {
	      var child = children[i];
	      if (child.tagName === tagName.toUpperCase()) return angular.element(child);
	    }
	    return angular.element();
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	angular
	    .module('material.components.tabs')
	    .directive('mdTabItem', MdTabItem);
	
	function MdTabItem () {
	  return {
	    require: '^?mdTabs',
	    link:    function link (scope, element, attr, ctrl) {
	      if (!ctrl) return;
	      ctrl.attachRipple(scope, element);
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	angular
	    .module('material.components.tabs')
	    .directive('mdTabLabel', MdTabLabel);
	
	function MdTabLabel () {
	  return { terminal: true };
	}
	
	
	})();
	(function(){
	"use strict";
	
	
	MdTabScroll.$inject = ["$parse"];angular.module('material.components.tabs')
	    .directive('mdTabScroll', MdTabScroll);
	
	function MdTabScroll ($parse) {
	  return {
	    restrict: 'A',
	    compile: function ($element, attr) {
	      var fn = $parse(attr.mdTabScroll, null, true);
	      return function ngEventHandler (scope, element) {
	        element.on('wheel', function (event) {
	          scope.$apply(function () { fn(scope, { $event: event }); });
	        });
	      };
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdTabsController.$inject = ["$scope", "$element", "$window", "$mdConstant", "$mdTabInkRipple", "$mdUtil", "$animateCss", "$attrs", "$compile", "$mdTheming", "$mdInteraction", "$timeout", "MdTabsPaginationService"];angular
	    .module('material.components.tabs')
	    .controller('MdTabsController', MdTabsController);
	
	/**
	 * @ngInject
	 */
	function MdTabsController ($scope, $element, $window, $mdConstant, $mdTabInkRipple, $mdUtil,
	                           $animateCss, $attrs, $compile, $mdTheming, $mdInteraction, $timeout,
	                           MdTabsPaginationService) {
	  // define private properties
	  var ctrl      = this,
	      locked    = false,
	      queue     = [],
	      destroyed = false,
	      loaded    = false;
	
	  // Define public methods
	  ctrl.$onInit            = $onInit;
	  ctrl.updatePagination   = $mdUtil.debounce(updatePagination, 100);
	  ctrl.redirectFocus      = redirectFocus;
	  ctrl.attachRipple       = attachRipple;
	  ctrl.insertTab          = insertTab;
	  ctrl.removeTab          = removeTab;
	  ctrl.select             = select;
	  ctrl.scroll             = scroll;
	  ctrl.nextPage           = nextPage;
	  ctrl.previousPage       = previousPage;
	  ctrl.keydown            = keydown;
	  ctrl.canPageForward     = canPageForward;
	  ctrl.canPageBack        = canPageBack;
	  ctrl.refreshIndex       = refreshIndex;
	  ctrl.incrementIndex     = incrementIndex;
	  ctrl.getTabElementIndex = getTabElementIndex;
	  ctrl.updateInkBarStyles = $mdUtil.debounce(updateInkBarStyles, 100);
	  ctrl.updateTabOrder     = $mdUtil.debounce(updateTabOrder, 100);
	  ctrl.getFocusedTabId    = getFocusedTabId;
	
	  // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	  // manually call the $onInit hook.
	  if (angular.version.major === 1 && angular.version.minor <= 4) {
	    this.$onInit();
	  }
	
	  /**
	   * AngularJS Lifecycle hook for newer AngularJS versions.
	   * Bindings are not guaranteed to have been assigned in the controller, but they are in the
	   * $onInit hook.
	   */
	  function $onInit() {
	    // Define one-way bindings
	    defineOneWayBinding('stretchTabs', handleStretchTabs);
	
	    // Define public properties with change handlers
	    defineProperty('focusIndex', handleFocusIndexChange, ctrl.selectedIndex || 0);
	    defineProperty('offsetLeft', handleOffsetChange, 0);
	    defineProperty('hasContent', handleHasContent, false);
	    defineProperty('maxTabWidth', handleMaxTabWidth, getMaxTabWidth());
	    defineProperty('shouldPaginate', handleShouldPaginate, false);
	
	    // Define boolean attributes
	    defineBooleanAttribute('noInkBar', handleInkBar);
	    defineBooleanAttribute('dynamicHeight', handleDynamicHeight);
	    defineBooleanAttribute('noPagination');
	    defineBooleanAttribute('swipeContent');
	    // TODO remove noDisconnect in 1.2.0
	    defineBooleanAttribute('noDisconnect');
	    defineBooleanAttribute('autoselect');
	    defineBooleanAttribute('noSelectClick');
	    defineBooleanAttribute('centerTabs', handleCenterTabs);
	    defineBooleanAttribute('enableDisconnect');
	
	    // Define public properties
	    ctrl.scope             = $scope;
	    ctrl.parent            = $scope.$parent;
	    ctrl.tabs              = [];
	    ctrl.lastSelectedIndex = null;
	    ctrl.hasFocus          = false;
	    ctrl.styleTabItemFocus = false;
	    ctrl.shouldCenterTabs  = shouldCenterTabs();
	    ctrl.tabContentPrefix  = 'tab-content-';
	    ctrl.navigationHint = 'Use the left and right arrow keys to navigate between tabs';
	
	    // Setup the tabs controller after all bindings are available.
	    setupTabsController();
	  }
	
	  /**
	   * Perform setup for the controller, setup events and watcher(s)
	   */
	  function setupTabsController () {
	    ctrl.selectedIndex = ctrl.selectedIndex || 0;
	    compileTemplate();
	    configureWatchers();
	    bindEvents();
	    $mdTheming($element);
	    $mdUtil.nextTick(function () {
	      updateHeightFromContent();
	      adjustOffset();
	      updateInkBarStyles();
	      ctrl.tabs[ ctrl.selectedIndex ] && ctrl.tabs[ ctrl.selectedIndex ].scope.select();
	      loaded = true;
	      updatePagination();
	    });
	  }
	
	  /**
	   * Compiles the template provided by the user.  This is passed as an attribute from the tabs
	   * directive's template function.
	   */
	  function compileTemplate () {
	    var template = $attrs.$mdTabsTemplate,
	        element  = angular.element($element[0].querySelector('md-tab-data'));
	
	    element.html(template);
	    $compile(element.contents())(ctrl.parent);
	    delete $attrs.$mdTabsTemplate;
	  }
	
	  /**
	   * Binds events used by the tabs component.
	   */
	  function bindEvents () {
	    angular.element($window).on('resize', handleWindowResize);
	    $scope.$on('$destroy', cleanup);
	  }
	
	  /**
	   * Configure watcher(s) used by Tabs
	   */
	  function configureWatchers () {
	    $scope.$watch('$mdTabsCtrl.selectedIndex', handleSelectedIndexChange);
	  }
	
	  /**
	   * Creates a one-way binding manually rather than relying on AngularJS's isolated scope
	   * @param key
	   * @param handler
	   */
	  function defineOneWayBinding (key, handler) {
	    var attr = $attrs.$normalize('md-' + key);
	    if (handler) defineProperty(key, handler);
	    $attrs.$observe(attr, function (newValue) { ctrl[ key ] = newValue; });
	  }
	
	  /**
	   * Defines boolean attributes with default value set to true. I.e. md-stretch-tabs with no value
	   * will be treated as being truthy.
	   * @param {string} key
	   * @param {Function=} handler
	   */
	  function defineBooleanAttribute (key, handler) {
	    var attr = $attrs.$normalize('md-' + key);
	    if (handler) defineProperty(key, handler, undefined);
	    if ($attrs.hasOwnProperty(attr)) updateValue($attrs[attr]);
	    $attrs.$observe(attr, updateValue);
	    function updateValue (newValue) {
	      ctrl[ key ] = newValue !== 'false';
	    }
	  }
	
	  /**
	   * Remove any events defined by this controller
	   */
	  function cleanup () {
	    destroyed = true;
	    angular.element($window).off('resize', handleWindowResize);
	  }
	
	  // Change handlers
	
	  /**
	   * Toggles stretch tabs class and updates inkbar when tab stretching changes.
	   */
	  function handleStretchTabs () {
	    var elements = getElements();
	    angular.element(elements.wrapper).toggleClass('md-stretch-tabs', shouldStretchTabs());
	    updateInkBarStyles();
	  }
	
	  /**
	   * Update the value of ctrl.shouldCenterTabs.
	   */
	  function handleCenterTabs () {
	    ctrl.shouldCenterTabs = shouldCenterTabs();
	  }
	
	  /**
	   * @param {number} newWidth new max tab width in pixels
	   * @param {number} oldWidth previous max tab width in pixels
	   */
	  function handleMaxTabWidth (newWidth, oldWidth) {
	    if (newWidth !== oldWidth) {
	      var elements = getElements();
	
	      // Set the max width for the real tabs
	      angular.forEach(elements.tabs, function(tab) {
	        tab.style.maxWidth = newWidth + 'px';
	      });
	
	      // Set the max width for the dummy tabs too
	      angular.forEach(elements.dummies, function(tab) {
	        tab.style.maxWidth = newWidth + 'px';
	      });
	
	      $mdUtil.nextTick(ctrl.updateInkBarStyles);
	    }
	  }
	
	  function handleShouldPaginate (newValue, oldValue) {
	    if (newValue !== oldValue) {
	      ctrl.maxTabWidth      = getMaxTabWidth();
	      ctrl.shouldCenterTabs = shouldCenterTabs();
	      $mdUtil.nextTick(function () {
	        ctrl.maxTabWidth = getMaxTabWidth();
	        adjustOffset(ctrl.selectedIndex);
	      });
	    }
	  }
	
	  /**
	   * Add/remove the `md-no-tab-content` class depending on `ctrl.hasContent`
	   * @param {boolean} hasContent
	   */
	  function handleHasContent (hasContent) {
	    $element[ hasContent ? 'removeClass' : 'addClass' ]('md-no-tab-content');
	  }
	
	  /**
	   * Apply ctrl.offsetLeft to the paging element when it changes
	   * @param {string|number} left
	   */
	  function handleOffsetChange (left) {
	    var newValue = ((ctrl.shouldCenterTabs || isRtl() ? '' : '-') + left + 'px');
	
	    // Fix double-negative which can happen with RTL support
	    newValue = newValue.replace('--', '');
	
	    angular.element(getElements().paging).css($mdConstant.CSS.TRANSFORM,
	                                              'translate(' + newValue + ', 0)');
	    $scope.$broadcast('$mdTabsPaginationChanged');
	  }
	
	  /**
	   * Update the UI whenever `ctrl.focusIndex` is updated
	   * @param {number} newIndex
	   * @param {number} oldIndex
	   */
	  function handleFocusIndexChange (newIndex, oldIndex) {
	    if (newIndex === oldIndex) return;
	    if (!getElements().tabs[ newIndex ]) return;
	    adjustOffset();
	    redirectFocus();
	  }
	
	  /**
	   * Update the UI whenever the selected index changes. Calls user-defined select/deselect methods.
	   * @param {number} newValue selected index's new value
	   * @param {number} oldValue selected index's previous value
	   */
	  function handleSelectedIndexChange (newValue, oldValue) {
	    if (newValue === oldValue) return;
	
	    ctrl.selectedIndex     = getNearestSafeIndex(newValue);
	    ctrl.lastSelectedIndex = oldValue;
	    ctrl.updateInkBarStyles();
	    updateHeightFromContent();
	    adjustOffset(newValue);
	    $scope.$broadcast('$mdTabsChanged');
	    ctrl.tabs[ oldValue ] && ctrl.tabs[ oldValue ].scope.deselect();
	    ctrl.tabs[ newValue ] && ctrl.tabs[ newValue ].scope.select();
	  }
	
	  function getTabElementIndex(tabEl){
	    var tabs = $element[0].getElementsByTagName('md-tab');
	    return Array.prototype.indexOf.call(tabs, tabEl[0]);
	  }
	
	  /**
	   * Queues up a call to `handleWindowResize` when a resize occurs while the tabs component is
	   * hidden.
	   */
	  function handleResizeWhenVisible () {
	    // if there is already a watcher waiting for resize, do nothing
	    if (handleResizeWhenVisible.watcher) return;
	    // otherwise, we will abuse the $watch function to check for visible
	    handleResizeWhenVisible.watcher = $scope.$watch(function () {
	      // since we are checking for DOM size, we use $mdUtil.nextTick() to wait for after the DOM updates
	      $mdUtil.nextTick(function () {
	        // if the watcher has already run (ie. multiple digests in one cycle), do nothing
	        if (!handleResizeWhenVisible.watcher) return;
	
	        if ($element.prop('offsetParent')) {
	          handleResizeWhenVisible.watcher();
	          handleResizeWhenVisible.watcher = null;
	
	          handleWindowResize();
	        }
	      }, false);
	    });
	  }
	
	  // Event handlers / actions
	
	  /**
	   * Handle user keyboard interactions
	   * @param {KeyboardEvent} event keydown event
	   */
	  function keydown (event) {
	    switch (event.keyCode) {
	      case $mdConstant.KEY_CODE.LEFT_ARROW:
	        event.preventDefault();
	        incrementIndex(-1, true);
	        break;
	      case $mdConstant.KEY_CODE.RIGHT_ARROW:
	        event.preventDefault();
	        incrementIndex(1, true);
	        break;
	      case $mdConstant.KEY_CODE.SPACE:
	      case $mdConstant.KEY_CODE.ENTER:
	        event.preventDefault();
	        if (!locked) select(ctrl.focusIndex);
	        break;
	      case $mdConstant.KEY_CODE.TAB:
	        // On tabbing out of the tablist, reset hasFocus to reset ng-focused and
	        // its md-focused class if the focused tab is not the active tab.
	        if (ctrl.focusIndex !== ctrl.selectedIndex) {
	          ctrl.focusIndex = ctrl.selectedIndex;
	        }
	        break;
	    }
	  }
	
	  /**
	   * Update the selected index. Triggers a click event on the original `md-tab` element in order
	   * to fire user-added click events if canSkipClick or `md-no-select-click` are false.
	   * @param index
	   * @param canSkipClick Optionally allow not firing the click event if `md-no-select-click` is also true.
	   */
	  function select (index, canSkipClick) {
	    if (!locked) ctrl.focusIndex = ctrl.selectedIndex = index;
	    // skip the click event if noSelectClick is enabled
	    if (canSkipClick && ctrl.noSelectClick) return;
	    // nextTick is required to prevent errors in user-defined click events
	    $mdUtil.nextTick(function () {
	      ctrl.tabs[ index ].element.triggerHandler('click');
	    }, false);
	  }
	
	  /**
	   * When pagination is on, this makes sure the selected index is in view.
	   * @param {WheelEvent} event
	   */
	  function scroll (event) {
	    if (!ctrl.shouldPaginate) return;
	    event.preventDefault();
	    if (event.deltaY) {
	      ctrl.offsetLeft = fixOffset(ctrl.offsetLeft + event.deltaY);
	    } else if (event.deltaX) {
	      ctrl.offsetLeft = fixOffset(ctrl.offsetLeft + event.deltaX);
	    }
	  }
	
	  /**
	   * Slides the tabs over approximately one page forward.
	   */
	  function nextPage () {
	    if (!ctrl.canPageForward()) { return; }
	
	    var newOffset = MdTabsPaginationService.increasePageOffset(getElements(), ctrl.offsetLeft);
	
	    ctrl.offsetLeft = fixOffset(newOffset);
	  }
	
	  /**
	   * Slides the tabs over approximately one page backward.
	   */
	  function previousPage () {
	    if (!ctrl.canPageBack()) { return; }
	
	    var newOffset = MdTabsPaginationService.decreasePageOffset(getElements(), ctrl.offsetLeft);
	
	    // Set the new offset
	    ctrl.offsetLeft = fixOffset(newOffset);
	  }
	
	  /**
	   * Update size calculations when the window is resized.
	   */
	  function handleWindowResize () {
	    ctrl.lastSelectedIndex = ctrl.selectedIndex;
	    ctrl.offsetLeft        = fixOffset(ctrl.offsetLeft);
	
	    $mdUtil.nextTick(function () {
	      ctrl.updateInkBarStyles();
	      updatePagination();
	    });
	  }
	
	  /**
	   * Hides or shows the tabs ink bar.
	   * @param {boolean} hide A Boolean (not just truthy/falsy) value to determine whether the class
	   * should be added or removed.
	   */
	  function handleInkBar (hide) {
	    angular.element(getElements().inkBar).toggleClass('ng-hide', hide);
	  }
	
	  /**
	   * Enables or disables tabs dynamic height.
	   * @param {boolean} value A Boolean (not just truthy/falsy) value to determine whether the class
	   * should be added or removed.
	   */
	  function handleDynamicHeight (value) {
	    $element.toggleClass('md-dynamic-height', value);
	  }
	
	  /**
	   * Remove a tab from the data and select the nearest valid tab.
	   * @param {Object} tabData tab to remove
	   */
	  function removeTab (tabData) {
	    if (destroyed) return;
	    var selectedIndex = ctrl.selectedIndex,
	        tab           = ctrl.tabs.splice(tabData.getIndex(), 1)[ 0 ];
	    refreshIndex();
	    // when removing a tab, if the selected index did not change, we have to manually trigger the
	    //   tab select/deselect events
	    if (ctrl.selectedIndex === selectedIndex) {
	      tab.scope.deselect();
	      ctrl.tabs[ ctrl.selectedIndex ] && ctrl.tabs[ ctrl.selectedIndex ].scope.select();
	    }
	    $mdUtil.nextTick(function () {
	      updatePagination();
	      ctrl.offsetLeft = fixOffset(ctrl.offsetLeft);
	    });
	  }
	
	  /**
	   * Create an entry in the tabs array for a new tab at the specified index.
	   * @param {Object} tabData tab to insert
	   * @param {number} index location to insert the new tab
	   * @returns {Object} the inserted tab
	   */
	  function insertTab (tabData, index) {
	    var hasLoaded = loaded;
	    var proto = {
	          getIndex:     function () { return ctrl.tabs.indexOf(tab); },
	          isActive:     function () { return this.getIndex() === ctrl.selectedIndex; },
	          isLeft:       function () { return this.getIndex() < ctrl.selectedIndex; },
	          isRight:      function () { return this.getIndex() > ctrl.selectedIndex; },
	          // TODO remove reference to noDisconnect in 1.2.0
	          shouldRender: function () { return !ctrl.noDisconnect || this.isActive(); },
	          hasFocus:     function () {
	            return ctrl.styleTabItemFocus
	                && ctrl.hasFocus && this.getIndex() === ctrl.focusIndex;
	          },
	          id:           $mdUtil.nextUid(),
	          hasContent: !!(tabData.template && tabData.template.trim())
	    };
	    var tab = angular.extend(proto, tabData);
	
	    if (angular.isDefined(index)) {
	      ctrl.tabs.splice(index, 0, tab);
	    } else {
	      ctrl.tabs.push(tab);
	    }
	    processQueue();
	    updateHasContent();
	
	    $mdUtil.nextTick(function () {
	      updatePagination();
	      setAriaControls(tab);
	
	      // if autoselect is enabled, select the newly added tab
	      if (hasLoaded && ctrl.autoselect) {
	        $mdUtil.nextTick(function () {
	          $mdUtil.nextTick(function () { select(ctrl.tabs.indexOf(tab)); });
	        });
	      }
	    });
	    return tab;
	  }
	
	  // Getter methods
	
	  /**
	   * Gathers references to all of the DOM elements used by this controller.
	   * @returns {Object}
	   */
	  function getElements () {
	    var elements = {};
	    var node = $element[0];
	
	    // gather tab bar elements
	    elements.wrapper = node.querySelector('md-tabs-wrapper');
	    elements.canvas  = elements.wrapper.querySelector('md-tabs-canvas');
	    elements.paging  = elements.canvas.querySelector('md-pagination-wrapper');
	    elements.inkBar  = elements.paging.querySelector('md-ink-bar');
	    elements.nextButton = node.querySelector('md-next-button');
	    elements.prevButton = node.querySelector('md-prev-button');
	
	    elements.contents = node.querySelectorAll('md-tabs-content-wrapper > md-tab-content');
	    elements.tabs    = elements.paging.querySelectorAll('md-tab-item');
	    elements.dummies = elements.canvas.querySelectorAll('md-dummy-tab');
	
	    return elements;
	  }
	
	  /**
	   * Determines whether or not the left pagination arrow should be enabled.
	   * @returns {boolean}
	   */
	  function canPageBack () {
	    // This works for both LTR and RTL
	    return ctrl.offsetLeft > 0;
	  }
	
	  /**
	   * Determines whether or not the right pagination arrow should be enabled.
	   * @returns {*|boolean}
	   */
	  function canPageForward () {
	    var elements = getElements();
	    var lastTab = elements.tabs[ elements.tabs.length - 1 ];
	
	    if (isRtl()) {
	      return ctrl.offsetLeft < elements.paging.offsetWidth - elements.canvas.offsetWidth;
	    }
	
	    return lastTab && lastTab.offsetLeft + lastTab.offsetWidth > elements.canvas.clientWidth +
	        ctrl.offsetLeft;
	  }
	
	  /**
	   * Returns currently focused tab item's element ID
	   */
	  function getFocusedTabId() {
	    var focusedTab = ctrl.tabs[ctrl.focusIndex];
	    if (!focusedTab || !focusedTab.id) {
	      return null;
	    }
	    return 'tab-item-' + focusedTab.id;
	  }
	
	  /**
	   * Determines if the UI should stretch the tabs to fill the available space.
	   * @returns {*}
	   */
	  function shouldStretchTabs () {
	    switch (ctrl.stretchTabs) {
	      case 'always':
	        return true;
	      case 'never':
	        return false;
	      default:
	        return !ctrl.shouldPaginate
	            && $window.matchMedia('(max-width: 600px)').matches;
	    }
	  }
	
	  /**
	   * Determines if the tabs should appear centered.
	   * @returns {boolean}
	   */
	  function shouldCenterTabs () {
	    return ctrl.centerTabs && !ctrl.shouldPaginate;
	  }
	
	  /**
	   * Determines if pagination is necessary to display the tabs within the available space.
	   * @returns {boolean} true if pagination is necessary, false otherwise
	   */
	  function shouldPaginate () {
	    var shouldPaginate;
	    if (ctrl.noPagination || !loaded) return false;
	    var canvasWidth = $element.prop('clientWidth');
	
	    angular.forEach(getElements().tabs, function (tab) {
	      canvasWidth -= tab.offsetWidth;
	    });
	
	    shouldPaginate = canvasWidth < 0;
	    // Work around width calculation issues on IE11 when pagination is enabled.
	    // Don't do this on other browsers because it breaks scroll to new tab animation.
	    if ($mdUtil.msie) {
	      if (shouldPaginate) {
	        getElements().paging.style.width = '999999px';
	      } else {
	        getElements().paging.style.width = undefined;
	      }
	    }
	    return shouldPaginate;
	  }
	
	  /**
	   * Finds the nearest tab index that is available. This is primarily used for when the active
	   * tab is removed.
	   * @param newIndex
	   * @returns {*}
	   */
	  function getNearestSafeIndex (newIndex) {
	    if (newIndex === -1) return -1;
	    var maxOffset = Math.max(ctrl.tabs.length - newIndex, newIndex),
	        i, tab;
	    for (i = 0; i <= maxOffset; i++) {
	      tab = ctrl.tabs[ newIndex + i ];
	      if (tab && (tab.scope.disabled !== true)) return tab.getIndex();
	      tab = ctrl.tabs[ newIndex - i ];
	      if (tab && (tab.scope.disabled !== true)) return tab.getIndex();
	    }
	    return newIndex;
	  }
	
	  // Utility methods
	
	  /**
	   * Defines a property using a getter and setter in order to trigger a change handler without
	   * using `$watch` to observe changes.
	   * @param {PropertyKey} key
	   * @param {Function} handler
	   * @param {any} value
	   */
	  function defineProperty (key, handler, value) {
	    Object.defineProperty(ctrl, key, {
	      get: function () { return value; },
	      set: function (newValue) {
	        var oldValue = value;
	        value        = newValue;
	        handler && handler(newValue, oldValue);
	      }
	    });
	  }
	
	  /**
	   * Updates whether or not pagination should be displayed.
	   */
	  function updatePagination () {
	    ctrl.maxTabWidth = getMaxTabWidth();
	    ctrl.shouldPaginate = shouldPaginate();
	  }
	
	  /**
	   * @param {Array<HTMLElement>} tabs tab item elements for use in computing total width
	   * @returns {number} the width of the tabs in the specified array in pixels
	   */
	  function calcTabsWidth(tabs) {
	    var width = 0;
	
	    angular.forEach(tabs, function (tab) {
	      // Uses the larger value between `getBoundingClientRect().width` and `offsetWidth`.  This
	      // prevents `offsetWidth` value from being rounded down and causing wrapping issues, but
	      // also handles scenarios where `getBoundingClientRect()` is inaccurate (ie. tabs inside
	      // of a dialog).
	      width += Math.max(tab.offsetWidth, tab.getBoundingClientRect().width);
	    });
	
	    return Math.ceil(width);
	  }
	
	  /**
	   * @returns {number} either the max width as constrained by the container or the max width from
	   * the 2017 version of the Material Design spec.
	   */
	  function getMaxTabWidth() {
	    var elements = getElements(),
	      containerWidth = elements.canvas.clientWidth,
	
	      // See https://material.io/archive/guidelines/components/tabs.html#tabs-specs
	      specMax = 264;
	
	    // Do the spec maximum, or the canvas width; whichever is *smaller* (tabs larger than the canvas
	    // width can break the pagination) but not less than 0
	    return Math.max(0, Math.min(containerWidth - 1, specMax));
	  }
	
	  /**
	   * Re-orders the tabs and updates the selected and focus indexes to their new positions.
	   * This is triggered by `tabDirective.js` when the user's tabs have been re-ordered.
	   */
	  function updateTabOrder () {
	    var selectedItem   = ctrl.tabs[ ctrl.selectedIndex ],
	        focusItem      = ctrl.tabs[ ctrl.focusIndex ];
	    ctrl.tabs          = ctrl.tabs.sort(function (a, b) {
	      return a.index - b.index;
	    });
	    ctrl.selectedIndex = ctrl.tabs.indexOf(selectedItem);
	    ctrl.focusIndex    = ctrl.tabs.indexOf(focusItem);
	  }
	
	  /**
	   * This moves the selected or focus index left or right. This is used by the keydown handler.
	   * @param {number} inc amount to increment
	   * @param {boolean} focus true to increment the focus index, false to increment the selected index
	   */
	  function incrementIndex (inc, focus) {
	    var newIndex,
	        key   = focus ? 'focusIndex' : 'selectedIndex',
	        index = ctrl[ key ];
	    for (newIndex = index + inc;
	         ctrl.tabs[ newIndex ] && ctrl.tabs[ newIndex ].scope.disabled;
	         newIndex += inc) { /* do nothing */ }
	
	    newIndex = (index + inc + ctrl.tabs.length) % ctrl.tabs.length;
	
	    if (ctrl.tabs[ newIndex ]) {
	      ctrl[ key ] = newIndex;
	    }
	  }
	
	  /**
	   * This is used to forward focus to tab container elements. This method is necessary to avoid
	   * animation issues when attempting to focus an item that is out of view.
	   */
	  function redirectFocus () {
	    ctrl.styleTabItemFocus = ($mdInteraction.getLastInteractionType() === 'keyboard');
	    var tabToFocus = getElements().tabs[ctrl.focusIndex];
	    if (tabToFocus) {
	      tabToFocus.focus();
	    }
	  }
	
	  /**
	   * Forces the pagination to move the focused tab into view.
	   * @param {number=} index of tab to have its offset adjusted
	   */
	  function adjustOffset (index) {
	    var elements = getElements();
	
	    if (!angular.isNumber(index)) index = ctrl.focusIndex;
	    if (!elements.tabs[ index ]) return;
	    if (ctrl.shouldCenterTabs) return;
	    var tab         = elements.tabs[ index ],
	        left        = tab.offsetLeft,
	        right       = tab.offsetWidth + left,
	        extraOffset = 32;
	
	    // If we are selecting the first tab (in LTR and RTL), always set the offset to 0
	    if (index === 0) {
	      ctrl.offsetLeft = 0;
	      return;
	    }
	
	    if (isRtl()) {
	      var tabWidthsBefore = calcTabsWidth(Array.prototype.slice.call(elements.tabs, 0, index));
	      var tabWidthsIncluding = calcTabsWidth(Array.prototype.slice.call(elements.tabs, 0, index + 1));
	
	      ctrl.offsetLeft = Math.min(ctrl.offsetLeft, fixOffset(tabWidthsBefore));
	      ctrl.offsetLeft = Math.max(ctrl.offsetLeft, fixOffset(tabWidthsIncluding - elements.canvas.clientWidth));
	    } else {
	      ctrl.offsetLeft = Math.max(ctrl.offsetLeft, fixOffset(right - elements.canvas.clientWidth + extraOffset));
	      ctrl.offsetLeft = Math.min(ctrl.offsetLeft, fixOffset(left));
	    }
	  }
	
	  /**
	   * Iterates through all queued functions and clears the queue. This is used for functions that
	   * are called before the UI is ready, such as size calculations.
	   */
	  function processQueue () {
	    queue.forEach(function (func) { $mdUtil.nextTick(func); });
	    queue = [];
	  }
	
	  /**
	   * Determines if the tab content area is needed.
	   */
	  function updateHasContent () {
	    var hasContent = false;
	    var i;
	
	    for (i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].hasContent) {
	        hasContent = true;
	        break;
	      }
	    }
	
	    ctrl.hasContent = hasContent;
	  }
	
	  /**
	   * Moves the indexes to their nearest valid values.
	   */
	  function refreshIndex () {
	    ctrl.selectedIndex = getNearestSafeIndex(ctrl.selectedIndex);
	    ctrl.focusIndex    = getNearestSafeIndex(ctrl.focusIndex);
	  }
	
	  /**
	   * Calculates the content height of the current tab.
	   * @returns {*}
	   */
	  function updateHeightFromContent () {
	    if (!ctrl.dynamicHeight) return $element.css('height', '');
	    if (!ctrl.tabs.length) return queue.push(updateHeightFromContent);
	
	    var elements = getElements();
	
	    var tabContent    = elements.contents[ ctrl.selectedIndex ],
	        contentHeight = tabContent ? tabContent.offsetHeight : 0,
	        tabsHeight    = elements.wrapper.offsetHeight,
	        newHeight     = contentHeight + tabsHeight,
	        currentHeight = $element.prop('clientHeight');
	
	    if (currentHeight === newHeight) return;
	
	    // Adjusts calculations for when the buttons are bottom-aligned since this relies on absolute
	    // positioning.  This should probably be cleaned up if a cleaner solution is possible.
	    if ($element.attr('md-align-tabs') === 'bottom') {
	      currentHeight -= tabsHeight;
	      newHeight -= tabsHeight;
	      // Need to include bottom border in these calculations
	      if ($element.attr('md-border-bottom') !== undefined) {
	        ++currentHeight;
	      }
	    }
	
	    // Lock during animation so the user can't change tabs
	    locked = true;
	
	    var fromHeight = { height: currentHeight + 'px' },
	        toHeight = { height: newHeight + 'px' };
	
	    // Set the height to the current, specific pixel height to fix a bug on iOS where the height
	    // first animates to 0, then back to the proper height causing a visual glitch
	    $element.css(fromHeight);
	
	    // Animate the height from the old to the new
	    $animateCss($element, {
	      from: fromHeight,
	      to: toHeight,
	      easing: 'cubic-bezier(0.35, 0, 0.25, 1)',
	      duration: 0.5
	    }).start().done(function () {
	      // Then (to fix the same iOS issue as above), disable transitions and remove the specific
	      // pixel height so the height can size with browser width/content changes, etc.
	      $element.css({
	        transition: 'none',
	        height: ''
	      });
	
	      // In the next tick, re-allow transitions (if we do it all at once, $element.css is "smart"
	      // enough to batch it for us instead of doing it immediately, which undoes the original
	      // transition: none)
	      $mdUtil.nextTick(function() {
	        $element.css('transition', '');
	      });
	
	      // And unlock so tab changes can occur
	      locked = false;
	    });
	  }
	
	  /**
	   * Repositions the ink bar to the selected tab.
	   * Parameters are used when calling itself recursively when md-center-tabs is used as we need to
	   * run two passes to properly center the tabs. These parameters ensure that we only run two passes
	   * and that we don't run indefinitely.
	   * @param {number=} previousTotalWidth previous width of pagination wrapper
	   * @param {number=} previousWidthOfTabItems previous width of all tab items
	   */
	  function updateInkBarStyles (previousTotalWidth, previousWidthOfTabItems) {
	    if (ctrl.noInkBar) {
	      return;
	    }
	    var elements = getElements();
	
	    if (!elements.tabs[ ctrl.selectedIndex ]) {
	      angular.element(elements.inkBar).css({ left: 'auto', right: 'auto' });
	      return;
	    }
	
	    if (!ctrl.tabs.length) {
	      queue.push(ctrl.updateInkBarStyles);
	      return;
	    }
	    // If the element is not visible, we will not be able to calculate sizes until it becomes
	    // visible. We should treat that as a resize event rather than just updating the ink bar.
	    if (!$element.prop('offsetParent')) {
	      handleResizeWhenVisible();
	      return;
	    }
	
	    var index      = ctrl.selectedIndex,
	        totalWidth = elements.paging.offsetWidth,
	        tab        = elements.tabs[ index ],
	        left       = tab.offsetLeft,
	        right      = totalWidth - left - tab.offsetWidth;
	
	    if (ctrl.shouldCenterTabs) {
	      // We need to use the same calculate process as in the pagination wrapper, to avoid rounding
	      // deviations.
	      var totalWidthOfTabItems = calcTabsWidth(elements.tabs);
	
	      if (totalWidth > totalWidthOfTabItems &&
	          previousTotalWidth !== totalWidth &&
	          previousWidthOfTabItems !== totalWidthOfTabItems) {
	        $timeout(updateInkBarStyles, 0, true, totalWidth, totalWidthOfTabItems);
	      }
	    }
	    updateInkBarClassName();
	    angular.element(elements.inkBar).css({ left: left + 'px', right: right + 'px' });
	  }
	
	  /**
	   * Adds left/right classes so that the ink bar will animate properly.
	   */
	  function updateInkBarClassName () {
	    var elements = getElements();
	    var newIndex = ctrl.selectedIndex,
	        oldIndex = ctrl.lastSelectedIndex,
	        ink      = angular.element(elements.inkBar);
	    if (!angular.isNumber(oldIndex)) return;
	    ink
	        .toggleClass('md-left', newIndex < oldIndex)
	        .toggleClass('md-right', newIndex > oldIndex);
	  }
	
	  /**
	   * Takes an offset value and makes sure that it is within the min/max allowed values.
	   * @param {number} value
	   * @returns {number}
	   */
	  function fixOffset (value) {
	    var elements = getElements();
	
	    if (!elements.tabs.length || !ctrl.shouldPaginate) return 0;
	
	    var lastTab    = elements.tabs[ elements.tabs.length - 1 ],
	        totalWidth = lastTab.offsetLeft + lastTab.offsetWidth;
	
	    if (isRtl()) {
	      value = Math.min(elements.paging.offsetWidth - elements.canvas.clientWidth, value);
	      value = Math.max(0, value);
	    } else {
	      value = Math.max(0, value);
	      value = Math.min(totalWidth - elements.canvas.clientWidth, value);
	    }
	
	    return value;
	  }
	
	  /**
	   * Attaches a ripple to the tab item element.
	   * @param scope
	   * @param element
	   */
	  function attachRipple (scope, element) {
	    var elements = getElements();
	    var options = { colorElement: angular.element(elements.inkBar) };
	    $mdTabInkRipple.attach(scope, element, options);
	  }
	
	  /**
	   * Sets the `aria-controls` attribute to the elements that correspond to the passed-in tab.
	   * @param tab
	   */
	  function setAriaControls (tab) {
	    if (tab.hasContent) {
	      var nodes = $element[0].querySelectorAll('[md-tab-id="' + tab.id + '"]');
	      angular.element(nodes).attr('aria-controls', ctrl.tabContentPrefix + tab.id);
	    }
	  }
	
	  function isRtl() {
	    return $mdUtil.isRtl($attrs);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdTabs
	 * @module material.components.tabs
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-tabs>` directive serves as the container for 1..n
	 * <a ng-href="api/directive/mdTab">`<md-tab>`</a> child directives.
	 * In turn, the nested `<md-tab>` directive is used to specify a tab label for the
	 * **header button** and <i>optional</i> tab view content that will be associated with each tab
	 * button.
	 *
	 * Below is the markup for its simplest usage:
	 *
	 *  <hljs lang="html">
	 *  <md-tabs>
	 *    <md-tab label="Tab #1"></md-tab>
	 *    <md-tab label="Tab #2"></md-tab>
	 *    <md-tab label="Tab #3"></md-tab>
	 *  </md-tabs>
	 *  </hljs>
	 *
	 * Tabs support three (3) usage scenarios:
	 *
	 *  1. Tabs (buttons only)
	 *  2. Tabs with internal view content
	 *  3. Tabs with external view content
	 *
	 * **Tabs-only** support is useful when tab buttons are used for custom navigation regardless of any
	 * other components, content, or views.
	 *
	 * <i><b>Note:</b> If you are using the Tabs component for page-level navigation, please use
	 * the <a ng-href="./api/directive/mdNavBar">NavBar component</a> instead. It handles this
	 * case a more natively and more performantly.</i>
	 *
	 * **Tabs with internal views** are the traditional usage where each tab has associated view
	 * content and the view switching is managed internally by the Tabs component.
	 *
	 * **Tabs with external view content** is often useful when content associated with each tab is
	 * independently managed and data-binding notifications announce tab selection changes.
	 *
	 * Additional features also include:
	 *
	 * *  Content can include any markup.
	 * *  If a tab is disabled while active/selected, then the next tab will be auto-selected.
	 *
	 * ### Explanation of tab stretching
	 *
	 * Initially, tabs will have an inherent size.  This size will either be defined by how much space
	 * is needed to accommodate their text or set by the user through CSS.
	 * Calculations will be based on this size.
	 *
	 * On mobile devices, tabs will be expanded to fill the available horizontal space.
	 * When this happens, all tabs will become the same size.
	 *
	 * On desktops, by default, stretching will never occur.
	 *
	 * This default behavior can be overridden through the `md-stretch-tabs` attribute.
	 * Here is a table showing when stretching will occur:
	 *
	 * `md-stretch-tabs` | mobile    | desktop
	 * ------------------|-----------|--------
	 * `auto`            | stretched | ---
	 * `always`          | stretched | stretched
	 * `never`           | ---       | ---
	 *
	 * @param {number=} md-selected Index of the active/selected tab.
	 * @param {expression=} md-no-ink-bar If `true` or no value, disables the selection ink bar.
	 * @param {string=} md-align-tabs Attribute to indicate position of tab buttons: `bottom` or `top`;
	 *  Default is `top`.
	 * @param {string=} md-stretch-tabs Attribute to indicate whether or not to stretch tabs: `auto`,
	 *  `always`, or `never`; Default is `auto`.
	 * @param {expression=} md-dynamic-height If `true` or no value, the tab wrapper will resize based
	 *  on the contents of the selected tab.
	 * @param {boolean=} md-border-bottom If the attribute is present, shows a solid `1px` border
	 *  between the tabs and their content.
	 * @param {boolean=} md-center-tabs If the attribute is present, tabs will be centered provided
	 *  there is no need for pagination.
	 * @param {boolean=} md-no-pagination If the attribute is present, pagination will remain off.
	 * @param {expression=} md-swipe-content When enabled, swipe gestures will be enabled for the content
	 *  area to allow swiping between tabs.
	 * @param {boolean=} md-enable-disconnect When enabled, scopes will be disconnected for tabs that
	 *  are not being displayed. This provides a performance boost, but may also cause unexpected
	 *  issues. It is not recommended for most users.
	 * @param {boolean=} md-no-disconnect **Deprecated**: If your tab content has background tasks
	 *  (ie. event listeners), you will want to include this to prevent the scope from being
	 *  disconnected.
	 * @param {boolean=} md-autoselect If the attribute is present, any tabs added after the initial
	 *  load will be automatically selected.
	 * @param {boolean=} md-no-select-click When true, click events will not be fired when the value of
	 *  `md-active` on an `md-tab` changes. This is useful when using tabs with UI-Router's child
	 *  states, as triggering a click event in that case can cause an extra tab change to occur.
	 * @param {string=} md-navigation-hint Attribute to override the default `tablist` navigation hint
	 *  that screen readers will announce to provide instructions for navigating between tabs. This is
	 *  desirable when you want the hint to be in a different language. Default is "Use the left and
	 *  right arrow keys to navigate between tabs".
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-tabs md-selected="selectedIndex" >
	 *   <img ng-src="img/angular.png" class="centered">
	 *   <md-tab
	 *       ng-repeat="tab in tabs | orderBy:predicate:reversed"
	 *       md-on-select="onTabSelected(tab)"
	 *       md-on-deselect="announceDeselected(tab)"
	 *       ng-disabled="tab.disabled">
	 *     <md-tab-label>
	 *       {{tab.title}}
	 *       <img src="img/removeTab.png" ng-click="removeTab(tab)" class="delete">
	 *     </md-tab-label>
	 *     <md-tab-body>
	 *       {{tab.content}}
	 *     </md-tab-body>
	 *   </md-tab>
	 * </md-tabs>
	 * </hljs>
	 *
	 */
	MdTabs.$inject = ["$$mdSvgRegistry"];
	angular
	    .module('material.components.tabs')
	    .directive('mdTabs', MdTabs);
	
	function MdTabs ($$mdSvgRegistry) {
	  return {
	    scope:            {
	      navigationHint: '@?mdNavigationHint',
	      selectedIndex: '=?mdSelected'
	    },
	    template:         function (element, attr) {
	      attr.$mdTabsTemplate = element.html();
	      return '' +
	        '<md-tabs-wrapper> ' +
	          '<md-tab-data></md-tab-data> ' +
	          '<md-prev-button ' +
	              'tabindex="-1" ' +
	              'role="button" ' +
	              'aria-label="Previous Page" ' +
	              'aria-disabled="{{!$mdTabsCtrl.canPageBack()}}" ' +
	              'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageBack() }" ' +
	              'ng-if="$mdTabsCtrl.shouldPaginate" ' +
	              'ng-click="$mdTabsCtrl.previousPage()"> ' +
	            '<md-icon md-svg-src="'+ $$mdSvgRegistry.mdTabsArrow +'"></md-icon> ' +
	          '</md-prev-button> ' +
	          '<md-next-button ' +
	              'tabindex="-1" ' +
	              'role="button" ' +
	              'aria-label="Next Page" ' +
	              'aria-disabled="{{!$mdTabsCtrl.canPageForward()}}" ' +
	              'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageForward() }" ' +
	              'ng-if="$mdTabsCtrl.shouldPaginate" ' +
	              'ng-click="$mdTabsCtrl.nextPage()"> ' +
	            '<md-icon md-svg-src="'+ $$mdSvgRegistry.mdTabsArrow +'"></md-icon> ' +
	          '</md-next-button> ' +
	          '<md-tabs-canvas ' +
	              'tabindex="{{ $mdTabsCtrl.hasFocus ? -1 : 0 }}" ' +
	              'ng-focus="$mdTabsCtrl.redirectFocus()" ' +
	              'ng-class="{ ' +
	                  '\'md-paginated\': $mdTabsCtrl.shouldPaginate, ' +
	                  '\'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs ' +
	              '}" ' +
	              'ng-keydown="$mdTabsCtrl.keydown($event)"> ' +
	            '<md-pagination-wrapper ' +
	                'ng-class="{ \'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs }" ' +
	                'md-tab-scroll="$mdTabsCtrl.scroll($event)" ' +
	                'role="tablist" ' +
	                'aria-label="{{::$mdTabsCtrl.navigationHint}}">' +
	              '<md-tab-item ' +
	                  'tabindex="{{ tab.isActive() ? 0 : -1 }}" ' +
	                  'class="md-tab {{::tab.scope.tabClass}}" ' +
	                  'ng-repeat="tab in $mdTabsCtrl.tabs" ' +
	                  'role="tab" ' +
	                  'id="tab-item-{{::tab.id}}" ' +
	                  'md-tab-id="{{::tab.id}}" ' +
	                  'aria-selected="{{tab.isActive()}}" ' +
	                  'aria-disabled="{{tab.scope.disabled || \'false\'}}" ' +
	                  'ng-click="$mdTabsCtrl.select(tab.getIndex())" ' +
	                  'ng-focus="$mdTabsCtrl.hasFocus = true" ' +
	                  'ng-blur="$mdTabsCtrl.hasFocus = false" ' +
	                  'ng-class="{ ' +
	                      '\'md-active\':    tab.isActive(), ' +
	                      '\'md-focused\':   tab.hasFocus(), ' +
	                      '\'md-disabled\':  tab.scope.disabled ' +
	                  '}" ' +
	                  'ng-disabled="tab.scope.disabled" ' +
	                  'md-swipe-left="$mdTabsCtrl.nextPage()" ' +
	                  'md-swipe-right="$mdTabsCtrl.previousPage()" ' +
	                  'md-tabs-template="::tab.label" ' +
	                  'md-scope="::tab.parent"></md-tab-item> ' +
	              '<md-ink-bar></md-ink-bar> ' +
	            '</md-pagination-wrapper> ' +
	            '<md-tabs-dummy-wrapper aria-hidden="true" class="md-visually-hidden md-dummy-wrapper"> ' +
	              '<md-dummy-tab ' +
	                  'class="md-tab" ' +
	                  'tabindex="-1" ' +
	                  'ng-focus="$mdTabsCtrl.hasFocus = true" ' +
	                  'ng-blur="$mdTabsCtrl.hasFocus = false" ' +
	                  'ng-repeat="tab in $mdTabsCtrl.tabs" ' +
	                  'md-tabs-template="::tab.label" ' +
	                  'md-scope="::tab.parent"></md-dummy-tab> ' +
	            '</md-tabs-dummy-wrapper> ' +
	          '</md-tabs-canvas> ' +
	        '</md-tabs-wrapper> ' +
	        '<md-tabs-content-wrapper ng-show="$mdTabsCtrl.hasContent && $mdTabsCtrl.selectedIndex >= 0" class="_md"> ' +
	          '<md-tab-content ' +
	              'id="{{:: $mdTabsCtrl.tabContentPrefix + tab.id}}" ' +
	              'class="_md" ' +
	              'role="tabpanel" ' +
	              'aria-labelledby="tab-item-{{::tab.id}}" ' +
	              'md-swipe-left="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(1)" ' +
	              'md-swipe-right="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(-1)" ' +
	              'ng-if="tab.hasContent" ' +
	              'ng-repeat="(index, tab) in $mdTabsCtrl.tabs" ' +
	              'ng-class="{ ' +
	                '\'md-no-transition\': $mdTabsCtrl.lastSelectedIndex == null, ' +
	                '\'md-active\':        tab.isActive(), ' +
	                '\'md-left\':          tab.isLeft(), ' +
	                '\'md-right\':         tab.isRight(), ' +
	                '\'md-no-scroll\':     $mdTabsCtrl.dynamicHeight ' +
	              '}"> ' +
	            '<div ' +
	                'md-tabs-template="::tab.template" ' +
	                'md-connected-if="tab.isActive()" ' +
	                'md-scope="::tab.parent" ' +
	                'ng-if="$mdTabsCtrl.enableDisconnect || tab.shouldRender()"></div> ' +
	          '</md-tab-content> ' +
	        '</md-tabs-content-wrapper>';
	    },
	    controller:       'MdTabsController',
	    controllerAs:     '$mdTabsCtrl',
	    bindToController: true
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdTabsDummyWrapper.$inject = ["$mdUtil", "$window"];angular
	  .module('material.components.tabs')
	  .directive('mdTabsDummyWrapper', MdTabsDummyWrapper);
	
	/**
	 * @private
	 *
	 * @param $mdUtil
	 * @param $window
	 * @returns {{require: string, link: link}}
	 * @constructor
	 *
	 * @ngInject
	 */
	function MdTabsDummyWrapper ($mdUtil, $window) {
	  return {
	    require: '^?mdTabs',
	    link:    function link (scope, element, attr, ctrl) {
	      if (!ctrl) return;
	
	      var observer;
	      var disconnect;
	
	      var mutationCallback = function() {
	        ctrl.updatePagination();
	        ctrl.updateInkBarStyles();
	      };
	
	      if ('MutationObserver' in $window) {
	        var config = {
	          childList: true,
	          subtree: true,
	          // Per https://bugzilla.mozilla.org/show_bug.cgi?id=1138368, browsers will not fire
	          // the childList mutation, once a <span> element's innerText changes.
	          // The characterData of the <span> element will change.
	          characterData: true
	        };
	
	        observer = new MutationObserver(mutationCallback);
	        observer.observe(element[0], config);
	        disconnect = observer.disconnect.bind(observer);
	      } else {
	        var debounced = $mdUtil.debounce(mutationCallback, 15, null, false);
	
	        element.on('DOMSubtreeModified', debounced);
	        disconnect = element.off.bind(element, 'DOMSubtreeModified', debounced);
	      }
	
	      // Disconnect the observer
	      scope.$on('$destroy', function() {
	        disconnect();
	      });
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdTabsTemplate.$inject = ["$compile", "$mdUtil"];angular
	    .module('material.components.tabs')
	    .directive('mdTabsTemplate', MdTabsTemplate);
	
	function MdTabsTemplate ($compile, $mdUtil) {
	  return {
	    restrict: 'A',
	    link:     link,
	    scope:    {
	      template:     '=mdTabsTemplate',
	      connected:    '=?mdConnectedIf',
	      compileScope: '=mdScope'
	    },
	    require:  '^?mdTabs'
	  };
	  function link (scope, element, attr, ctrl) {
	    if (!ctrl) return;
	
	    var compileScope = ctrl.enableDisconnect ? scope.compileScope.$new() : scope.compileScope;
	
	    element.html(scope.template);
	    $compile(element.contents())(compileScope);
	
	    return $mdUtil.nextTick(handleScope);
	
	    function handleScope () {
	      scope.$watch('connected', function (value) { value === false ? disconnect() : reconnect(); });
	      scope.$on('$destroy', reconnect);
	    }
	
	    function disconnect () {
	      if (ctrl.enableDisconnect) $mdUtil.disconnectScope(compileScope);
	    }
	
	    function reconnect () {
	      if (ctrl.enableDisconnect) $mdUtil.reconnectScope(compileScope);
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.toast
	 * @description
	 * Toast and Snackbar component.
	 */
	MdToastDirective.$inject = ["$mdToast"];
	MdToastProvider.$inject = ["$$interimElementProvider"];
	angular.module('material.components.toast', [
	  'material.core',
	  'material.components.button'
	])
	  .directive('mdToast', MdToastDirective)
	  .provider('$mdToast', MdToastProvider);
	
	/* @ngInject */
	function MdToastDirective($mdToast) {
	  return {
	    restrict: 'E',
	    link: function postLink(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      // When navigation force destroys an interimElement, then
	      // listen and $destroy() that interim instance...
	      scope.$on('$destroy', function() {
	        $mdToast.destroy();
	      });
	    }
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $mdToast
	 * @module material.components.toast
	 *
	 * @description
	 * `$mdToast` is a service to build a toast notification on any position
	 * on the screen with an optional duration, and provides a simple promise API.
	 *
	 * The toast will be always positioned at the `bottom`, when the screen size is
	 * between `600px` and `959px` (`sm` breakpoint)
	 *
	 * ## Restrictions on custom toasts
	 * - The toast's template must have an outer `<md-toast>` element.
	 * - For a toast action, use element with class `md-action`.
	 * - Add the class `md-capsule` for curved corners.
	 *
	 * ### Custom Presets
	 * Developers are also able to create their own preset, which can be easily used without repeating
	 * their options each time.
	 *
	 * <hljs lang="js">
	 *   $mdToastProvider.addPreset('testPreset', {
	 *     options: function() {
	 *       return {
	 *         template:
	 *           '<md-toast>' +
	 *             '<div class="md-toast-content">' +
	 *               'This is a custom preset' +
	 *             '</div>' +
	 *           '</md-toast>',
	 *         controllerAs: 'toast',
	 *         bindToController: true
	 *       };
	 *     }
	 *   });
	 * </hljs>
	 *
	 * After you created your preset at config phase, you can easily access it.
	 *
	 * <hljs lang="js">
	 *   $mdToast.show(
	 *     $mdToast.testPreset()
	 *   );
	 * </hljs>
	 *
	 * ## Parent container notes
	 *
	 * The toast is positioned using absolute positioning relative to its first non-static parent
	 * container. Thus, if the requested parent container uses static positioning, we will temporarily
	 * set its positioning to `relative` while the toast is visible and reset it when the toast is
	 * hidden.
	 *
	 * Because of this, it is usually best to ensure that the parent container has a fixed height and
	 * prevents scrolling by setting the `overflow: hidden;` style. Since the position is based off of
	 * the parent's height, the toast may be mispositioned if you allow the parent to scroll.
	 *
	 * You can, however, have a scrollable element inside of the container; just make sure the
	 * container itself does not scroll.
	 *
	 * <hljs lang="html">
	 * <div layout-fill id="toast-container">
	 *   <md-content>
	 *     I can have lots of content and scroll!
	 *   </md-content>
	 * </div>
	 * </hljs>
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div ng-controller="MyController">
	 *   <md-button ng-click="openToast()">
	 *     Open a Toast!
	 *   </md-button>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="js">
	 * var app = angular.module('app', ['ngMaterial']);
	 * app.controller('MyController', function($scope, $mdToast) {
	 *   $scope.openToast = function($event) {
	 *     $mdToast.show($mdToast.simple().textContent('Hello!'));
	 *     // Could also do $mdToast.showSimple('Hello');
	 *   };
	 * });
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdToast#showSimple
	 *
	 * @param {string} message The message to display inside the toast
	 * @description
	 * Convenience method which builds and shows a simple toast.
	 *
	 * @returns {promise} A promise that can be resolved with `$mdToast.hide()` or
	 * rejected with `$mdToast.cancel()`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdToast#simple
	 *
	 * @description
	 * Builds a preconfigured toast.
	 *
	 * @returns {obj} a `$mdToastPreset` with the following chainable configuration methods.
	 *
	 * _**Note:** These configuration methods are provided in addition to the methods provided by
	 * the `build()` and `show()` methods below._
	 *
	 * <table class="md-api-table methods">
	 *    <thead>
	 *      <tr>
	 *        <th>Method</th>
	 *        <th>Description</th>
	 *      </tr>
	 *    </thead>
	 *    <tbody>
	 *      <tr>
	 *        <td>`.textContent(string)`</td>
	 *        <td>Sets the toast content to the specified string</td>
	 *      </tr>
	 *      <tr>
	 *        <td>`.action(string)`</td>
	 *        <td>
	 *          Adds an action button. <br/>
	 *          If clicked, the promise (returned from `show()`) will resolve with the value `'ok'`;
	 *          otherwise, it is resolved with `true` after a `hideDelay` timeout.
	 *        </td>
	 *      </tr>
	 *      <tr>
	 *        <td>`.actionKey(string)`</td>
	 *        <td>
	 *          Adds a hotkey for the action button to the page. <br/>
	 *          If the `actionKey` and `Control` key are pressed, the toast's action will be triggered.
	 *        </td>
	 *      </tr>
	 *      <tr>
	 *        <td>`.actionHint(string)`</td>
	 *        <td>
	 *          Text that a screen reader will announce to let the user know how to activate the
	 *          action. <br>
	 *          If an `actionKey` is defined, this defaults to:
	 *          'Press Control-"`actionKey`" to ' followed by the `action`.
	 *        </td>
	 *      </tr>
	 *      <tr>
	 *        <td>`.dismissHint(string)`</td>
	 *        <td>
	 *          Text that a screen reader will announce to let the user know how to dismiss the toast.
	 *          <br>Defaults to: "Press Escape to dismiss."
	 *        </td>
	 *      </tr>
	 *      <tr>
	 *        <td>`.highlightAction(boolean)`</td>
	 *        <td>
	 *          Whether or not the action button will have an additional highlight class.<br/>
	 *          By default the `accent` color will be applied to the action button.
	 *        </td>
	 *      </tr>
	 *      <tr>
	 *        <td>`.highlightClass(string)`</td>
	 *        <td>
	 *          If set, the given class will be applied to the highlighted action button.<br/>
	 *          This allows you to specify the highlight color easily. Highlight classes are
	 *          `md-primary`, `md-warn`, and `md-accent`
	 *        </td>
	 *      </tr>
	 *      <tr>
	 *        <td>`.capsule(boolean)`</td>
	 *        <td>
	 *          Whether or not to add the `md-capsule` class to the toast to provide rounded corners
	 *        </td>
	 *      </tr>
	 *      <tr>
	 *        <td>`.theme(string)`</td>
	 *        <td>
	 *          Sets the theme on the toast to the requested theme. Default is `$mdThemingProvider`'s
	 *          default.
	 *        </td>
	 *      </tr>
	 *      <tr>
	 *        <td>`.toastClass(string)`</td>
	 *        <td>Sets a class on the toast element</td>
	 *      </tr>
	 *    </tbody>
	 * </table>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdToast#updateTextContent
	 *
	 * @description
	 * Updates the content of an existing toast. Useful for updating things like counts, etc.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdToast#build
	 *
	 * @description
	 * Creates a custom `$mdToastPreset` that you can configure.
	 *
	 * @returns {obj} a `$mdToastPreset` with the chainable configuration methods for shows' options
	 *   (see below).
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdToast#show
	 *
	 * @description Shows the toast.
	 *
	 * @param {object} optionsOrPreset Either provide an `$mdToastPreset` returned from `simple()`
	 * and `build()`, or an options object with the following properties:
	 *
	 *   - `templateUrl` - `{string=}`: The url of an html template file that will
	 *     be used as the content of the toast. Restrictions: the template must
	 *     have an outer `md-toast` element.
	 *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
	 *     template string.
	 *   - `autoWrap` - `{boolean=}`: Whether or not to automatically wrap the template content with a
	 *     `<div class="md-toast-content">` if one is not provided. Defaults to true. Can be disabled
	 *     if you provide a custom toast directive.
	 *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified,
	 *     it will create a new child scope. This scope will be destroyed when the toast is removed
	 *     unless `preserveScope` is set to true.
	 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed.
	 *     Default is false
	 *   - `hideDelay` - `{number=}`: The number of milliseconds the toast should stay active before
	 *     automatically closing. Set to `0` or `false` to have the toast stay open until closed
	 *     manually via an action in the toast, a hotkey, or a swipe gesture. For accessibility, toasts
	 *     should not automatically close when they contain an action.<br>
	 *     Defaults to: `3000`.
	 *   - `position` - `{string=}`: Sets the position of the toast. <br/>
	 *     Available: any combination of `'bottom'`, `'left'`, `'top'`, `'right'`, `'end'`, and
	 *     `'start'`. The properties `'end'` and `'start'` are dynamic and can be used for RTL support.
	 *     <br/>
	 *     Default combination: `'bottom left'`.
	 *   - `toastClass` - `{string=}`: A class to set on the toast element.
	 *   - `controller` - `{string=}`: The controller to associate with this toast.
	 *     The controller will be injected the local `$mdToast.hide()`, which is a function
	 *     used to hide the toast.
	 *   - `locals` - `{object=}`: An object containing key/value pairs. The keys will
	 *     be used as names of values to inject into the controller. For example,
	 *     `locals: {three: 3}` would inject `three` into the controller with the value
	 *     of 3.
	 *   - `bindToController` - `{boolean=}`: bind the locals to the controller, instead of passing
	 *     them in.
	 *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values
	 *     and the toast will not open until the promises resolve.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	 *   - `parent` - `{element=}`: The element to append the toast to. Defaults to appending
	 *     to the root element of the application.
	 *
	 * @returns {promise} A promise that can be resolved with `$mdToast.hide()` or
	 * rejected with `$mdToast.cancel()`. `$mdToast.hide()` will resolve either with the Boolean
	 * value `true` or the value passed as an argument to `$mdToast.hide()`.
	 * `$mdToast.cancel()` will resolve the promise with the Boolean value `false`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdToast#hide
	 *
	 * @description
	 * Hide an existing toast and resolve the promise returned from `$mdToast.show()`.
	 *
	 * @param {*=} response An argument for the resolved promise.
	 *
	 * @returns {promise} A promise that is called when the existing element is removed from the DOM.
	 * The promise is resolved with either the Boolean value `true` or the value passed as the
	 * argument to `$mdToast.hide()`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdToast#cancel
	 *
	 * @description
	 * `DEPRECATED` - The promise returned from opening a toast is used only to notify about the
	 * closing of the toast. As such, there isn't any reason to also allow that promise to be rejected,
	 * since it's not clear what the difference between resolve and reject would be.
	 *
	 * Hide the existing toast and reject the promise returned from
	 * `$mdToast.show()`.
	 *
	 * @param {*=} response An argument for the rejected promise.
	 *
	 * @returns {promise} A promise that is called when the existing element is removed from the DOM
	 * The promise is resolved with the Boolean value `false`.
	 */
	
	function MdToastProvider($$interimElementProvider) {
	  // Differentiate promise resolves: hide timeout (value == true) and hide action clicks
	  // (value == ok).
	  MdToastController.$inject = ["$mdToast", "$scope", "$log"];
	  toastDefaultOptions.$inject = ["$animate", "$mdToast", "$mdUtil", "$mdMedia", "$document", "$q"];
	  var ACTION_RESOLVE = 'ok';
	
	  var activeToastContent;
	  var $mdToast = $$interimElementProvider('$mdToast')
	    .setDefaults({
	      methods: ['position', 'hideDelay', 'capsule', 'parent', 'position', 'toastClass'],
	      options: toastDefaultOptions
	    })
	    .addPreset('simple', {
	      argOption: 'textContent',
	      methods: ['textContent', 'content', 'action', 'actionKey', 'actionHint', 'highlightAction',
	                'highlightClass', 'theme', 'parent', 'dismissHint'],
	      options: /* @ngInject */ ["$mdToast", "$mdTheming", function($mdToast, $mdTheming) {
	        return {
	          template:
	            '<md-toast md-theme="{{ toast.theme }}" ng-class="{\'md-capsule\': toast.capsule}">' +
	            '  <div class="md-toast-content" aria-live="polite" aria-relevant="all">' +
	            '    <span class="md-toast-text">' +
	            '      {{ toast.content }}' +
	            '    </span>' +
	            '    <span class="md-visually-hidden">{{ toast.dismissHint }}</span>' +
	            '    <span class="md-visually-hidden" ng-if="toast.action && toast.actionKey">' +
	            '      {{ toast.actionHint }}' +
	            '    </span>' +
	            '    <md-button class="md-action" ng-if="toast.action" ng-click="toast.resolve()" ' +
	            '               ng-class="highlightClasses">' +
	            '      {{ toast.action }}' +
	            '    </md-button>' +
	            '  </div>' +
	            '</md-toast>',
	          controller: MdToastController,
	          theme: $mdTheming.defaultTheme(),
	          controllerAs: 'toast',
	          bindToController: true
	        };
	      }]
	    })
	    .addMethod('updateTextContent', updateTextContent)
	    // updateContent is deprecated. Use updateTextContent instead.
	    // TODO remove this in 1.2.
	    .addMethod('updateContent', updateTextContent);
	
	    function updateTextContent(newContent) {
	      activeToastContent = newContent;
	    }
	
	    return $mdToast;
	
	  /**
	   * Controller for the Toast interim elements.
	   * @ngInject
	   */
	  function MdToastController($mdToast, $scope, $log) {
	    // For compatibility with AngularJS 1.6+, we should always use the $onInit hook in
	    // interimElements. The $mdCompiler simulates the $onInit hook for all versions.
	    this.$onInit = function() {
	      var self = this;
	
	      if (self.highlightAction) {
	        $scope.highlightClasses = [
	          'md-highlight',
	          self.highlightClass
	        ];
	      }
	
	      // If an action is defined and no actionKey is specified, then log a warning.
	      if (self.action && !self.actionKey) {
	        $log.warn('Toasts with actions should define an actionKey for accessibility.',
	          'Details: https://material.angularjs.org/latest/api/service/$mdToast#mdtoast-simple');
	      }
	
	      if (self.actionKey && !self.actionHint) {
	        self.actionHint = 'Press Control-"' + self.actionKey + '" to ';
	      }
	
	      if (!self.dismissHint) {
	        self.dismissHint = 'Press Escape to dismiss.';
	      }
	
	      $scope.$watch(function() { return activeToastContent; }, function() {
	        self.content = activeToastContent;
	      });
	
	      this.resolve = function() {
	        $mdToast.hide(ACTION_RESOLVE);
	      };
	    };
	  }
	
	  /* @ngInject */
	  function toastDefaultOptions($animate, $mdToast, $mdUtil, $mdMedia, $document, $q) {
	    var SWIPE_EVENTS = '$md.swipeleft $md.swiperight $md.swipeup $md.swipedown';
	    return {
	      onShow: onShow,
	      onRemove: onRemove,
	      toastClass: '',
	      position: 'bottom left',
	      themable: true,
	      hideDelay: 3000,
	      autoWrap: true,
	      transformTemplate: function(template, options) {
	        var shouldAddWrapper = options.autoWrap && template && !/md-toast-content/g.test(template);
	
	        if (shouldAddWrapper) {
	          // Root element of template will be <md-toast>. We need to wrap all of its content inside
	          // of <div class="md-toast-content">. All templates provided here should be static,
	          // developer-controlled content (meaning we're not attempting to guard against XSS).
	          var templateRoot = document.createElement('md-template');
	          templateRoot.innerHTML = template;
	
	          // Iterate through all root children, to detect possible md-toast directives.
	          for (var i = 0; i < templateRoot.children.length; i++) {
	            if (templateRoot.children[i].nodeName === 'MD-TOAST') {
	              var wrapper = angular.element('<div class="md-toast-content">');
	
	              // Wrap the children of the `md-toast` directive in jqLite, to be able to append
	              // multiple nodes with the same execution.
	              wrapper.append(angular.element(templateRoot.children[i].childNodes));
	
	              // Append the new wrapped element to the `md-toast` directive.
	              templateRoot.children[i].appendChild(wrapper[0]);
	            }
	          }
	
	          // We have to return the innerHTMl, because we do not want to have the `md-template`
	          // element to be the root element of our interimElement.
	          return templateRoot.innerHTML;
	        }
	
	        return template || '';
	      }
	    };
	
	    function onShow(scope, element, options) {
	      // support deprecated #content method
	      // TODO remove support for content in 1.2.
	      activeToastContent = options.textContent || options.content;
	
	      var isSmScreen = !$mdMedia('gt-sm');
	
	      element = $mdUtil.extractElementByName(element, 'md-toast', true);
	      options.element = element;
	
	      options.onSwipe = function(ev, gesture) {
	        // Add the relevant swipe class to the element so it can animate correctly
	        var swipe = ev.type.replace('$md.','');
	        var direction = swipe.replace('swipe', '');
	
	        // If the swipe direction is down/up but the toast came from top/bottom don't fade away
	        // Unless the screen is small, then the toast always on bottom
	        if ((direction === 'down' && options.position.indexOf('top') !== -1 && !isSmScreen) ||
	            (direction === 'up' && (options.position.indexOf('bottom') !== -1 || isSmScreen))) {
	          return;
	        }
	
	        if ((direction === 'left' || direction === 'right') && isSmScreen) {
	          return;
	        }
	
	        element.addClass('md-' + swipe);
	        $mdUtil.nextTick($mdToast.cancel);
	      };
	      options.openClass = toastOpenClass(options.position);
	
	      element.addClass(options.toastClass);
	
	      // 'top left' -> 'md-top md-left'
	      options.parent.addClass(options.openClass);
	
	      // static is the default position
	      if ($mdUtil.hasComputedStyle(options.parent, 'position', 'static')) {
	        options.parent.css('position', 'relative');
	      }
	
	      setupActionKeyListener(scope.toast && scope.toast.actionKey ?
	        scope.toast.actionKey : undefined);
	
	      element.on(SWIPE_EVENTS, options.onSwipe);
	      element.addClass(isSmScreen ? 'md-bottom' : options.position.split(' ').map(function(pos) {
	        return 'md-' + pos;
	      }).join(' '));
	
	      if (options.parent) {
	        options.parent.addClass('md-toast-animating');
	      }
	      return $animate.enter(element, options.parent).then(function() {
	        if (options.parent) {
	          options.parent.removeClass('md-toast-animating');
	        }
	      });
	    }
	
	    /**
	     * @param {object} scope the toast's scope
	     * @param {JQLite} element the toast to be removed
	     * @param {object} options
	     * @return {Promise<*>} a Promise to remove the element immediately or to animate it out.
	     */
	    function onRemove(scope, element, options) {
	      if (scope.toast && scope.toast.actionKey) {
	        removeActionKeyListener();
	      }
	      element.off(SWIPE_EVENTS, options.onSwipe);
	      if (options.parent) options.parent.addClass('md-toast-animating');
	      if (options.openClass) options.parent.removeClass(options.openClass);
	
	      // Don't run the leave animation if the element has already been destroyed.
	      return ((options.$destroy === true) ? $q.when(element.remove()) : $animate.leave(element))
	        .then(function () {
	          if (options.parent) options.parent.removeClass('md-toast-animating');
	          if ($mdUtil.hasComputedStyle(options.parent, 'position', 'static')) {
	            options.parent.css('position', '');
	          }
	        });
	    }
	
	    function toastOpenClass(position) {
	      // For mobile, always open full-width on bottom
	      if (!$mdMedia('gt-xs')) {
	        return 'md-toast-open-bottom';
	      }
	
	      return 'md-toast-open-' + (position.indexOf('top') > -1 ? 'top' : 'bottom');
	    }
	
	    function setupActionKeyListener(actionKey) {
	      /**
	       * @param {KeyboardEvent} event
	       */
	      var handleKeyDown = function(event) {
	        if (event.key === 'Escape') {
	          $mdToast.hide(false);
	        }
	        if (actionKey && event.key === actionKey && event.ctrlKey) {
	          $mdToast.hide(ACTION_RESOLVE);
	        }
	      };
	      $document.on('keydown', handleKeyDown);
	    }
	
	    function removeActionKeyListener() {
	      $document.off('keydown');
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.toolbar
	 */
	mdToolbarDirective.$inject = ["$$rAF", "$mdConstant", "$mdUtil", "$mdTheming", "$animate", "$timeout"];
	angular.module('material.components.toolbar', [
	  'material.core',
	  'material.components.content'
	])
	  .directive('mdToolbar', mdToolbarDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdToolbar
	 * @module material.components.toolbar
	 * @restrict E
	 * @description
	 * `md-toolbar` is used to place a toolbar in your app.
	 *
	 * Toolbars are usually used above a content area to display the title of the
	 * current page, and show relevant action buttons for that page.
	 *
	 * You can change the height of the toolbar by adding either the
	 * `md-medium-tall` or `md-tall` class to the toolbar.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div layout="column" layout-fill>
	 *   <md-toolbar>
	 *
	 *     <div class="md-toolbar-tools">
	 *       <h2 md-truncate flex>My App's Title</h2>
	 *
	 *       <md-button>
	 *         Right Bar Button
	 *       </md-button>
	 *     </div>
	 *
	 *   </md-toolbar>
	 *   <md-content>
	 *     Hello!
	 *   </md-content>
	 * </div>
	 * </hljs>
	 *
	 * <i><b>Note:</b> The code above shows usage with the `md-truncate` component which provides an
	 * ellipsis if the title is longer than the width of the Toolbar.</i>
	 *
	 * ## CSS & Styles
	 *
	 * The `<md-toolbar>` provides a few custom CSS classes that you may use to enhance the
	 * functionality of your toolbar.
	 *
	 * <div>
	 * <docs-css-api-table>
	 *
	 *   <docs-css-selector code="md-toolbar .md-toolbar-tools">
	 *     The `md-toolbar-tools` class provides quite a bit of automatic styling for your toolbar
	 *     buttons and text. When applied, it will center the buttons and text vertically for you.
	 *   </docs-css-selector>
	 *
	 * </docs-css-api-table>
	 * </div>
	 *
	 * ### Private Classes
	 *
	 * Currently, the only private class is the `md-toolbar-transitions` class. All other classes are
	 * considered public.
	 *
	 * @param {boolean=} md-scroll-shrink Whether the header should shrink away as
	 * the user scrolls down, and reveal itself as the user scrolls up.
	 *
	 * _**Note (1):** for scrollShrink to work, the toolbar must be a sibling of a
	 * `md-content` element, placed before it. See the scroll shrink demo._
	 *
	 * _**Note (2):** The `md-scroll-shrink` attribute is only parsed on component
	 * initialization, it does not watch for scope changes._
	 *
	 *
	 * @param {number=} md-shrink-speed-factor How much to change the speed of the toolbar's
	 * shrinking by. For example, if 0.25 is given then the toolbar will shrink
	 * at one fourth the rate at which the user scrolls down. Default 0.5.
	 *
	 */
	
	function mdToolbarDirective($$rAF, $mdConstant, $mdUtil, $mdTheming, $animate, $timeout) {
	  var translateY = angular.bind(null, $mdUtil.supplant, 'translate3d(0,{0}px,0)');
	
	  return {
	    template: '',
	    restrict: 'E',
	
	    link: function(scope, element, attr) {
	
	      element.addClass('_md');     // private md component indicator for styling
	      $mdTheming(element);
	
	      $mdUtil.nextTick(function () {
	        element.addClass('_md-toolbar-transitions');     // adding toolbar transitions after digest
	      }, false);
	
	      if (angular.isDefined(attr.mdScrollShrink)) {
	        setupScrollShrink();
	      }
	
	      function setupScrollShrink() {
	
	        var toolbarHeight;
	        var contentElement;
	        var disableScrollShrink = angular.noop;
	
	        // Current "y" position of scroll
	        // Store the last scroll top position
	        var y = 0;
	        var prevScrollTop = 0;
	        var shrinkSpeedFactor = attr.mdShrinkSpeedFactor || 0.5;
	
	        var debouncedContentScroll = $$rAF.throttle(onContentScroll);
	        var debouncedUpdateHeight = $mdUtil.debounce(updateToolbarHeight, 5 * 1000);
	
	        // Wait for $mdContentLoaded event from mdContent directive.
	        // If the mdContent element is a sibling of our toolbar, hook it up
	        // to scroll events.
	
	        scope.$on('$mdContentLoaded', onMdContentLoad);
	
	        // If the toolbar is used inside an ng-if statement, we may miss the
	        // $mdContentLoaded event, so we attempt to fake it if we have a
	        // md-content close enough.
	
	        attr.$observe('mdScrollShrink', onChangeScrollShrink);
	
	        // If the toolbar has ngShow or ngHide we need to update height immediately as it changed
	        // and not wait for $mdUtil.debounce to happen
	
	        if (attr.ngShow) { scope.$watch(attr.ngShow, updateToolbarHeight); }
	        if (attr.ngHide) { scope.$watch(attr.ngHide, updateToolbarHeight); }
	
	        // If the scope is destroyed (which could happen with ng-if), make sure
	        // to disable scroll shrinking again
	
	        scope.$on('$destroy', disableScrollShrink);
	
	        /**
	         * @param {string} shrinkWithScroll value of md-scroll-shrink attribute
	         */
	        function onChangeScrollShrink(shrinkWithScroll) {
	          var closestContent = $mdUtil.getSiblings(element, 'md-content');
	
	          // If there are content elements, fake the call using the first content element.
	          // This might still fail if the content element isn't a sibling of the toolbar.
	          if (!contentElement && closestContent.length) {
	            onMdContentLoad(null, closestContent[0]);
	          }
	
	          // Evaluate the expression
	          shrinkWithScroll = scope.$eval(shrinkWithScroll);
	
	          // Disable only if the attribute's expression evaluates to false
	          if (shrinkWithScroll === false) {
	            disableScrollShrink();
	          } else {
	            disableScrollShrink = enableScrollShrink();
	          }
	        }
	
	        /**
	         * @param {null} $event $mdContentLoaded always has a null event
	         * @param {JQLite} newContentEl JQLite object containing an md-content
	         */
	        function onMdContentLoad($event, newContentEl) {
	          // Toolbar and content must be siblings
	          if (newContentEl && element.parent()[0] === newContentEl.parent()[0]) {
	            // unhook old content event listener if exists
	            if (contentElement) {
	              contentElement.off('scroll', debouncedContentScroll);
	            }
	
	            contentElement = newContentEl;
	            disableScrollShrink = enableScrollShrink();
	          }
	        }
	
	        /**
	         *
	         */
	        function onContentScroll(e) {
	          var scrollTop = e ? e.target.scrollTop : prevScrollTop;
	
	          debouncedUpdateHeight();
	
	          y = Math.min(
	            toolbarHeight / shrinkSpeedFactor,
	            Math.max(0, y + scrollTop - prevScrollTop)
	          );
	
	          element.css($mdConstant.CSS.TRANSFORM, translateY([-y * shrinkSpeedFactor]));
	          contentElement.css($mdConstant.CSS.TRANSFORM, translateY([(toolbarHeight - y) * shrinkSpeedFactor]));
	
	          prevScrollTop = scrollTop;
	
	          $mdUtil.nextTick(function() {
	            var hasWhiteFrame = element.hasClass('md-whiteframe-z1');
	
	            if (hasWhiteFrame && !y) {
	              $animate.removeClass(element, 'md-whiteframe-z1');
	            } else if (!hasWhiteFrame && y) {
	              $animate.addClass(element, 'md-whiteframe-z1');
	            }
	          });
	
	        }
	
	        /**
	         *
	         */
	        function enableScrollShrink() {
	          if (!contentElement)     return angular.noop;           // no md-content
	
	          contentElement.on('scroll', debouncedContentScroll);
	          contentElement.attr('scroll-shrink', 'true');
	
	          $timeout(updateToolbarHeight);
	
	          return function disableScrollShrink() {
	            contentElement.off('scroll', debouncedContentScroll);
	            contentElement.attr('scroll-shrink', 'false');
	
	            updateToolbarHeight();
	          };
	        }
	
	        /**
	         *
	         */
	        function updateToolbarHeight() {
	          toolbarHeight = element.prop('offsetHeight');
	          // Add a negative margin-top the size of the toolbar to the content el.
	          // The content will start transformed down the toolbarHeight amount,
	          // so everything looks normal.
	          //
	          // As the user scrolls down, the content will be transformed up slowly
	          // to put the content underneath where the toolbar was.
	          var margin = (-toolbarHeight * shrinkSpeedFactor) + 'px';
	
	          contentElement.css({
	            "margin-top": margin,
	            "margin-bottom": margin
	          });
	
	          onContentScroll();
	        }
	
	      }
	
	    }
	  };
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.tooltip
	 */
	MdTooltipDirective.$inject = ["$timeout", "$window", "$$rAF", "$document", "$interpolate", "$mdUtil", "$mdPanel", "$$mdTooltipRegistry"];
	angular
	    .module('material.components.tooltip', [
	      'material.core',
	      'material.components.panel'
	    ])
	    .directive('mdTooltip', MdTooltipDirective)
	    .service('$$mdTooltipRegistry', MdTooltipRegistry);
	
	
	/**
	 * @ngdoc directive
	 * @name mdTooltip
	 * @module material.components.tooltip
	 * @description
	 * Tooltips are used to describe elements that are interactive and primarily
	 * graphical (not textual).
	 *
	 * Place a `<md-tooltip>` as a child of the element it describes.
	 *
	 * A tooltip will activate when the user hovers over, focuses, or touches the
	 * parent element.
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-button class="md-fab md-accent" aria-label="Play">
	 *     <md-tooltip>Play Music</md-tooltip>
	 *     <md-icon md-svg-src="img/icons/ic_play_arrow_24px.svg"></md-icon>
	 *   </md-button>
	 * </hljs>
	 *
	 * @param {number=} md-z-index The visual level that the tooltip will appear
	 *     in comparison with the rest of the elements of the application.
	 * @param {expression=} md-visible Boolean bound to whether the tooltip is
	 *     currently visible.
	 * @param {number=} md-delay How many milliseconds to wait to show the tooltip
	 *     after the user hovers over, focuses, or touches the parent element.
	 *     Defaults to 0ms on non-touch devices and 75ms on touch.
	 * @param {boolean=} md-autohide If present or provided with a boolean value,
	 *     the tooltip will hide on mouse leave, regardless of focus.
	 * @param {string=} md-direction The direction that the tooltip is shown,
	 *     relative to the parent element. Supports top, right, bottom, and left.
	 *     Defaults to bottom.
	 */
	function MdTooltipDirective($timeout, $window, $$rAF, $document, $interpolate,
	    $mdUtil, $mdPanel, $$mdTooltipRegistry) {
	
	  var ENTER_EVENTS = 'focus touchstart mouseenter';
	  var LEAVE_EVENTS = 'blur touchcancel mouseleave';
	  var TOOLTIP_DEFAULT_Z_INDEX = 100;
	  var TOOLTIP_DEFAULT_SHOW_DELAY = 0;
	  var TOOLTIP_DEFAULT_DIRECTION = 'bottom';
	  var TOOLTIP_DIRECTIONS = {
	    top: { x: $mdPanel.xPosition.CENTER, y: $mdPanel.yPosition.ABOVE },
	    right: { x: $mdPanel.xPosition.OFFSET_END, y: $mdPanel.yPosition.CENTER },
	    bottom: { x: $mdPanel.xPosition.CENTER, y: $mdPanel.yPosition.BELOW },
	    left: { x: $mdPanel.xPosition.OFFSET_START, y: $mdPanel.yPosition.CENTER }
	  };
	
	  return {
	    restrict: 'E',
	    priority: 210, // Before ngAria
	    scope: {
	      mdZIndex: '=?mdZIndex',
	      mdDelay: '=?mdDelay',
	      mdVisible: '=?mdVisible',
	      mdAutohide: '=?mdAutohide',
	      mdDirection: '@?mdDirection' // Do not expect expressions.
	    },
	    link: linkFunc
	  };
	
	  function linkFunc(scope, element, attr) {
	    // Set constants.
	    var tooltipId = 'md-tooltip-' + $mdUtil.nextUid();
	    var parent = $mdUtil.getParentWithPointerEvents(element);
	    var debouncedOnResize = $$rAF.throttle(updatePosition);
	    var mouseActive = false;
	    var origin, position, panelPosition, panelRef, autohide, showTimeout,
	        elementFocusedOnWindowBlur = null;
	
	    // Set defaults
	    setDefaults();
	
	    // Set parent aria-label.
	    addAriaLabel();
	
	    // Remove the element from its current DOM position.
	    element.detach();
	
	    updatePosition();
	    bindEvents();
	    configureWatchers();
	
	    function setDefaults() {
	      scope.mdZIndex = scope.mdZIndex || TOOLTIP_DEFAULT_Z_INDEX;
	      scope.mdDelay = scope.mdDelay || TOOLTIP_DEFAULT_SHOW_DELAY;
	      if (!TOOLTIP_DIRECTIONS[scope.mdDirection]) {
	        scope.mdDirection = TOOLTIP_DEFAULT_DIRECTION;
	      }
	    }
	
	    function addAriaLabel(labelText) {
	      // Only interpolate the text from the HTML element because otherwise the custom text could
	      // be interpolated twice and cause XSS violations.
	      var interpolatedText = labelText || $interpolate(element.text().trim())(scope.$parent);
	
	      // Only add the `aria-label` to the parent if there isn't already one, if there isn't an
	      // already present `aria-labelledby`, or if the previous `aria-label` was added by the
	      // tooltip directive.
	      if (
	        (!parent.attr('aria-label') && !parent.attr('aria-labelledby')) ||
	        parent.attr('md-labeled-by-tooltip')
	      ) {
	        parent.attr('aria-label', interpolatedText);
	
	        // Set the `md-labeled-by-tooltip` attribute if it has not already been set.
	        if (!parent.attr('md-labeled-by-tooltip')) {
	          parent.attr('md-labeled-by-tooltip', tooltipId);
	        }
	      }
	    }
	
	    function updatePosition() {
	      setDefaults();
	
	      // If the panel has already been created, remove the current origin
	      // class from the panel element.
	      if (panelRef && panelRef.panelEl) {
	        panelRef.panelEl.removeClass(origin);
	      }
	
	      // Set the panel element origin class based off of the current
	      // mdDirection.
	      origin = 'md-origin-' + scope.mdDirection;
	
	      // Create the position of the panel based off of the mdDirection.
	      position = TOOLTIP_DIRECTIONS[scope.mdDirection];
	
	      // Using the newly created position object, use the MdPanel
	      // panelPosition API to build the panel's position.
	      panelPosition = $mdPanel.newPanelPosition()
	          .relativeTo(parent)
	          .addPanelPosition(position.x, position.y);
	
	      // If the panel has already been created, add the new origin class to
	      // the panel element and update it's position with the panelPosition.
	      if (panelRef && panelRef.panelEl) {
	        panelRef.panelEl.addClass(origin);
	        panelRef.updatePosition(panelPosition);
	      }
	    }
	
	    function bindEvents() {
	      // Add a mutationObserver where there is support for it and the need
	      // for it in the form of viable host(parent[0]).
	      if (parent[0] && 'MutationObserver' in $window) {
	        // Use a mutationObserver to tackle #2602.
	        var attributeObserver = new MutationObserver(function(mutations) {
	          if (isDisabledMutation(mutations)) {
	            $mdUtil.nextTick(function() {
	              setVisible(false);
	            });
	          }
	        });
	
	        attributeObserver.observe(parent[0], {
	          attributes: true
	        });
	      }
	
	      elementFocusedOnWindowBlur = false;
	
	      $$mdTooltipRegistry.register('scroll', windowScrollEventHandler, true);
	      $$mdTooltipRegistry.register('blur', windowBlurEventHandler);
	      $$mdTooltipRegistry.register('resize', debouncedOnResize);
	
	      scope.$on('$destroy', onDestroy);
	
	      // To avoid 'synthetic clicks', we listen to mousedown instead of
	      // 'click'.
	      parent.on('mousedown', mousedownEventHandler);
	      parent.on(ENTER_EVENTS, enterEventHandler);
	
	      function isDisabledMutation(mutations) {
	        mutations.some(function(mutation) {
	          return mutation.attributeName === 'disabled' && parent[0].disabled;
	        });
	        return false;
	      }
	
	      function windowScrollEventHandler() {
	        setVisible(false);
	      }
	
	      function windowBlurEventHandler() {
	        elementFocusedOnWindowBlur = document.activeElement === parent[0];
	      }
	
	      function enterEventHandler($event) {
	        // Prevent the tooltip from showing when the window is receiving
	        // focus.
	        if ($event.type === 'focus' && elementFocusedOnWindowBlur) {
	          elementFocusedOnWindowBlur = false;
	        } else if (!scope.mdVisible) {
	          parent.on(LEAVE_EVENTS, leaveEventHandler);
	          setVisible(true);
	
	          // If the user is on a touch device, we should bind the tap away
	          // after the 'touched' in order to prevent the tooltip being
	          // removed immediately.
	          if ($event.type === 'touchstart') {
	            parent.one('touchend', function() {
	              $mdUtil.nextTick(function() {
	                $document.one('touchend', leaveEventHandler);
	              }, false);
	            });
	          }
	        }
	      }
	
	      function leaveEventHandler() {
	        autohide = scope.hasOwnProperty('mdAutohide') ?
	            scope.mdAutohide :
	            attr.hasOwnProperty('mdAutohide');
	
	        if (autohide || mouseActive ||
	            $document[0].activeElement !== parent[0]) {
	          // When a show timeout is currently in progress, then we have
	          // to cancel it, otherwise the tooltip will remain showing
	          // without focus or hover.
	          if (showTimeout) {
	            $timeout.cancel(showTimeout);
	            setVisible.queued = false;
	            showTimeout = null;
	          }
	
	          parent.off(LEAVE_EVENTS, leaveEventHandler);
	          parent.triggerHandler('blur');
	          setVisible(false);
	        }
	        mouseActive = false;
	      }
	
	      function mousedownEventHandler() {
	        mouseActive = true;
	      }
	
	      function onDestroy() {
	        $$mdTooltipRegistry.deregister('scroll', windowScrollEventHandler, true);
	        $$mdTooltipRegistry.deregister('blur', windowBlurEventHandler);
	        $$mdTooltipRegistry.deregister('resize', debouncedOnResize);
	
	        parent
	            .off(ENTER_EVENTS, enterEventHandler)
	            .off(LEAVE_EVENTS, leaveEventHandler)
	            .off('mousedown', mousedownEventHandler);
	
	        // Trigger the handler in case any of the tooltips are
	        // still visible.
	        leaveEventHandler();
	        attributeObserver && attributeObserver.disconnect();
	      }
	    }
	
	    function configureWatchers() {
	      if (element[0] && 'MutationObserver' in $window) {
	        var attributeObserver = new MutationObserver(function(mutations) {
	          mutations.forEach(function(mutation) {
	            if (mutation.attributeName === 'md-visible' &&
	                !scope.visibleWatcher) {
	              scope.visibleWatcher = scope.$watch('mdVisible',
	                  onVisibleChanged);
	            }
	          });
	        });
	
	        attributeObserver.observe(element[0], {
	          attributes: true
	        });
	
	        // Build watcher only if mdVisible is being used.
	        if (attr.hasOwnProperty('mdVisible')) {
	          scope.visibleWatcher = scope.$watch('mdVisible',
	              onVisibleChanged);
	        }
	      } else {
	        // MutationObserver not supported
	        scope.visibleWatcher = scope.$watch('mdVisible', onVisibleChanged);
	      }
	
	      // Direction watcher
	      scope.$watch('mdDirection', updatePosition);
	
	      // Clean up if the element or parent was removed via jqLite's .remove.
	      // A couple of notes:
	      //   - In these cases the scope might not have been destroyed, which
	      //     is why we destroy it manually. An example of this can be having
	      //     `md-visible="false"` and adding tooltips while they're
	      //     invisible. If `md-visible` becomes true, at some point, you'd
	      //     usually get a lot of tooltips.
	      //   - We use `.one`, not `.on`, because this only needs to fire once.
	      //     If we were using `.on`, it would get thrown into an infinite
	      //     loop.
	      //   - This kicks off the scope's `$destroy` event which finishes the
	      //     cleanup.
	      element.one('$destroy', onElementDestroy);
	      parent.one('$destroy', onElementDestroy);
	      scope.$on('$destroy', function() {
	        setVisible(false);
	        panelRef && panelRef.destroy();
	        attributeObserver && attributeObserver.disconnect();
	        element.remove();
	      });
	
	      // Updates the aria-label when the element text changes. This watch
	      // doesn't need to be set up if the element doesn't have any data
	      // bindings.
	      if (element.text().indexOf($interpolate.startSymbol()) > -1) {
	        scope.$watch(function() {
	          return element.text().trim();
	        }, addAriaLabel);
	      }
	
	      function onElementDestroy() {
	        scope.$destroy();
	      }
	    }
	
	    function setVisible(value) {
	      // Break if passed value is already in queue or there is no queue and
	      // passed value is current in the controller.
	      if (setVisible.queued && setVisible.value === !!value ||
	          !setVisible.queued && scope.mdVisible === !!value) {
	        return;
	      }
	      setVisible.value = !!value;
	
	      if (!setVisible.queued) {
	        if (value) {
	          setVisible.queued = true;
	          showTimeout = $timeout(function() {
	            scope.mdVisible = setVisible.value;
	            setVisible.queued = false;
	            showTimeout = null;
	            if (!scope.visibleWatcher) {
	              onVisibleChanged(scope.mdVisible);
	            }
	          }, scope.mdDelay);
	        } else {
	          $mdUtil.nextTick(function() {
	            scope.mdVisible = false;
	            if (!scope.visibleWatcher) {
	              onVisibleChanged(false);
	            }
	          });
	        }
	      }
	    }
	
	    function onVisibleChanged(isVisible) {
	      isVisible ? showTooltip() : hideTooltip();
	    }
	
	    function showTooltip() {
	      // Do not show the tooltip if the text is empty.
	      if (!element[0].textContent.trim()) {
	        throw new Error('Text for the tooltip has not been provided. ' +
	            'Please include text within the mdTooltip element.');
	      }
	
	      if (!panelRef) {
	        var attachTo = angular.element(document.body);
	        var panelAnimation = $mdPanel.newPanelAnimation()
	            .openFrom(parent)
	            .closeTo(parent)
	            .withAnimation({
	              open: 'md-show',
	              close: 'md-hide'
	            });
	
	        var panelConfig = {
	          id: tooltipId,
	          attachTo: attachTo,
	          contentElement: element,
	          propagateContainerEvents: true,
	          panelClass: 'md-tooltip',
	          animation: panelAnimation,
	          position: panelPosition,
	          zIndex: scope.mdZIndex,
	          focusOnOpen: false,
	          onDomAdded: function() {
	            panelRef.panelEl.addClass(origin);
	          }
	        };
	
	        panelRef = $mdPanel.create(panelConfig);
	      }
	
	      panelRef.open().then(function() {
	        panelRef.panelEl.attr('role', 'tooltip');
	      });
	    }
	
	    function hideTooltip() {
	      panelRef && panelRef.close();
	    }
	  }
	
	}
	
	
	/**
	 * Service that is used to reduce the amount of listeners that are being
	 * registered on the `window` by the tooltip component. Works by collecting
	 * the individual event handlers and dispatching them from a global handler.
	 *
	 * @ngInject
	 */
	function MdTooltipRegistry() {
	  var listeners = {};
	  var ngWindow = angular.element(window);
	
	  return {
	    register: register,
	    deregister: deregister
	  };
	
	  /**
	   * Global event handler that dispatches the registered handlers in the
	   * service.
	   * @param {!Event} event Event object passed in by the browser
	   */
	  function globalEventHandler(event) {
	    if (listeners[event.type]) {
	      listeners[event.type].forEach(function(currentHandler) {
	        currentHandler.call(this, event);
	      }, this);
	    }
	  }
	
	  /**
	   * Registers a new handler with the service.
	   * @param {string} type Type of event to be registered.
	   * @param {!Function} handler Event handler.
	   * @param {boolean} useCapture Whether to use event capturing.
	   */
	  function register(type, handler, useCapture) {
	    var handlers = listeners[type] = listeners[type] || [];
	
	    if (!handlers.length) {
	      useCapture ? window.addEventListener(type, globalEventHandler, true) :
	          ngWindow.on(type, globalEventHandler);
	    }
	
	    if (handlers.indexOf(handler) === -1) {
	      handlers.push(handler);
	    }
	  }
	
	  /**
	   * Removes an event handler from the service.
	   * @param {string} type Type of event handler.
	   * @param {!Function} handler The event handler itself.
	   * @param {boolean} useCapture Whether the event handler used event capturing.
	   */
	  function deregister(type, handler, useCapture) {
	    var handlers = listeners[type];
	    var index = handlers ? handlers.indexOf(handler) : -1;
	
	    if (index > -1) {
	      handlers.splice(index, 1);
	
	      if (handlers.length === 0) {
	        useCapture ? window.removeEventListener(type, globalEventHandler, true) :
	            ngWindow.off(type, globalEventHandler);
	      }
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.truncate
	 */
	MdTruncateController.$inject = ["$element"];
	angular.module('material.components.truncate', ['material.core'])
	  .directive('mdTruncate', MdTruncateDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdTruncate
	 * @module material.components.truncate
	 * @restrict AE
	 * @description
	 *
	 * The `md-truncate` component displays a label that will automatically clip text which is wider
	 * than the component. By default, it displays an ellipsis, but you may apply the `md-clip` CSS
	 * class to override this default and use a standard "clipping" approach.
	 *
	 * <i><b>Note:</b> The `md-truncate` component does not automatically adjust it's width. You must
	 * provide the `flex` attribute, or some other CSS-based width management. See the
	 * <a ng-href="./demo/truncate">demos</a> for examples.</i>
	 *
	 * @usage
	 *
	 * ### As an Element
	 *
	 * <hljs lang="html">
	 *   <div layout="row">
	 *     <md-button>Back</md-button>
	 *
	 *     <md-truncate flex>Chapter 1 - The Way of the Old West</md-truncate>
	 *
	 *     <md-button>Forward</md-button>
	 *   </div>
	 * </hljs>
	 *
	 * ### As an Attribute
	 *
	 * <hljs lang="html">
	 *   <h2 md-truncate style="max-width: 100px;">Some Title With a Lot of Text</h2>
	 * </hljs>
	 *
	 * ## CSS & Styles
	 *
	 * `<md-truncate>` provides two CSS classes that you may use to control the type of clipping.
	 *
	 * <i><b>Note:</b> The `md-truncate` also applies a setting of `width: 0;` when used with the `flex`
	 * attribute to fix an issue with the flex element not shrinking properly.</i>
	 *
	 * <div>
	 * <docs-css-api-table>
	 *
	 *   <docs-css-selector code=".md-ellipsis">
	 *     Assigns the "ellipsis" behavior (default) which will cut off mid-word and append an ellipsis
	 *     (&hellip;) to the end of the text.
	 *   </docs-css-selector>
	 *
	 *   <docs-css-selector code=".md-clip">
	 *     Assigns the "clipping" behavior which will simply chop off the text. This may happen
	 *     mid-word or even mid-character.
	 *   </docs-css-selector>
	 *
	 * </docs-css-api-table>
	 * </div>
	 */
	function MdTruncateDirective() {
	  return {
	    restrict: 'AE',
	
	    controller: MdTruncateController
	  };
	}
	
	/**
	 * Controller for the <md-truncate> component.
	 *
	 * @param $element The md-truncate element.
	 *
	 * @constructor
	 * @ngInject
	 */
	function MdTruncateController($element) {
	  $element.addClass('md-truncate');
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.virtualRepeat
	 */
	VirtualRepeatContainerController.$inject = ["$$rAF", "$mdUtil", "$mdConstant", "$parse", "$rootScope", "$window", "$scope", "$element", "$attrs"];
	VirtualRepeatController.$inject = ["$scope", "$element", "$attrs", "$browser", "$document", "$rootScope", "$$rAF", "$mdUtil"];
	VirtualRepeatDirective.$inject = ["$parse"];
	angular.module('material.components.virtualRepeat', [
	  'material.core',
	  'material.components.showHide'
	])
	.directive('mdVirtualRepeatContainer', VirtualRepeatContainerDirective)
	.directive('mdVirtualRepeat', VirtualRepeatDirective)
	.directive('mdForceHeight', ForceHeightDirective);
	
	
	/**
	 * @ngdoc directive
	 * @name mdVirtualRepeatContainer
	 * @module material.components.virtualRepeat
	 * @restrict E
	 * @description
	 * `md-virtual-repeat-container` provides the scroll container for
	 * <a ng-href="api/directive/mdVirtualRepeat">md-virtual-repeat</a>.
	 *
	 * VirtualRepeat is a limited substitute for `ng-repeat` that renders only
	 * enough DOM nodes to fill the container, recycling them as the user scrolls.
	 *
	 * Once an element is not visible anymore, the Virtual Repeat recycles the element and reuses it
	 * for another visible item by replacing the previous data set with the set of currently visible
	 * elements.
	 *
	 * ### Common Issues
	 *
	 * - When having one-time bindings inside of the view template, the Virtual Repeat will not properly
	 *   update the bindings for new items, since the view will be recycled.
	 * - Directives inside of a Virtual Repeat will be only compiled (linked) once, because those
	 *   items will be recycled and used for other items.
	 *   The Virtual Repeat just updates the scope bindings.
	 *
	 *
	 * ### Notes
	 *
	 * > The VirtualRepeat is a similar implementation to the Android
	 * [RecyclerView](https://developer.android.com/reference/android/support/v7/widget/RecyclerView.html).
	 *
	 * <!-- This comment forces a break between blockquotes //-->
	 *
	 * > Please also review the <a ng-href="api/directive/mdVirtualRepeat">mdVirtualRepeat</a>
	 * documentation for more information.
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *
	 * <md-virtual-repeat-container md-top-index="topIndex">
	 *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 * </hljs>
	 *
	 * @param {boolean=} md-auto-shrink When present and the container will shrink to fit
	 *     the number of items in the `md-virtual-repeat`.
	 * @param {number=} md-auto-shrink-min Minimum number of items that md-auto-shrink
	 *     will shrink to. Default: `0`.
	 * @param {boolean=} md-orient-horizontal Whether the container should scroll horizontally.
	 *     The default is `false` which indicates vertical orientation and scrolling.
	 * @param {number=} md-top-index Binds the index of the item that is at the top of the scroll
	 *     container to `$scope`. It can both read and set the scroll position.
	 */
	function VirtualRepeatContainerDirective() {
	  return {
	    controller: VirtualRepeatContainerController,
	    template: virtualRepeatContainerTemplate,
	    compile: function virtualRepeatContainerCompile($element, $attrs) {
	      $element
	          .addClass('md-virtual-repeat-container')
	          .addClass($attrs.hasOwnProperty('mdOrientHorizontal')
	              ? 'md-orient-horizontal'
	              : 'md-orient-vertical');
	    }
	  };
	}
	
	
	function virtualRepeatContainerTemplate($element) {
	  return '<div class="md-virtual-repeat-scroller" role="presentation">' +
	    '<div class="md-virtual-repeat-sizer" role="presentation"></div>' +
	    '<div class="md-virtual-repeat-offsetter" role="presentation">' +
	      $element[0].innerHTML +
	    '</div></div>';
	}
	
	/**
	 * Number of additional elements to render above and below the visible area inside
	 * of the virtual repeat container. A higher number results in less flicker when scrolling
	 * very quickly in Safari, but comes with a higher rendering and dirty-checking cost.
	 * @const {number}
	 */
	var NUM_EXTRA = 3;
	
	/** @ngInject */
	function VirtualRepeatContainerController($$rAF, $mdUtil, $mdConstant, $parse, $rootScope, $window,
	                                          $scope, $element, $attrs) {
	  this.$rootScope = $rootScope;
	  this.$scope = $scope;
	  this.$element = $element;
	  this.$attrs = $attrs;
	
	  /** @type {number} The width or height of the container */
	  this.size = 0;
	  /** @type {number} The scroll width or height of the scroller */
	  this.scrollSize = 0;
	  /** @type {number} The scrollLeft or scrollTop of the scroller */
	  this.scrollOffset = 0;
	  /** @type {boolean} Whether the scroller is oriented horizontally */
	  this.horizontal = this.$attrs.hasOwnProperty('mdOrientHorizontal');
	  /** @type {!VirtualRepeatController} The repeater inside of this container */
	  this.repeater = null;
	  /** @type {boolean} Whether auto-shrink is enabled */
	  this.autoShrink = this.$attrs.hasOwnProperty('mdAutoShrink');
	  /** @type {number} Minimum number of items to auto-shrink to */
	  this.autoShrinkMin = parseInt(this.$attrs.mdAutoShrinkMin, 10) || 0;
	  /** @type {?number} Original container size when shrank */
	  this.originalSize = null;
	  /** @type {number} Amount to offset the total scroll size by. */
	  this.offsetSize = parseInt(this.$attrs.mdOffsetSize, 10) || 0;
	  /** @type {?string} height or width element style on the container prior to auto-shrinking. */
	  this.oldElementSize = null;
	  /** @type {!number} Maximum amount of pixels allowed for a single DOM element */
	  this.maxElementPixels = $mdConstant.ELEMENT_MAX_PIXELS;
	  /** @type {string}  Direction of the text */
	  this.ltr = !$mdUtil.isRtl(this.$attrs);
	
	  if (this.$attrs.mdTopIndex) {
	    /** @type {function(angular.Scope): number} Binds to topIndex on AngularJS scope */
	    this.bindTopIndex = $parse(this.$attrs.mdTopIndex);
	    /** @type {number} The index of the item that is at the top of the scroll container */
	    this.topIndex = this.bindTopIndex(this.$scope);
	
	    if (!angular.isDefined(this.topIndex)) {
	      this.topIndex = 0;
	      this.bindTopIndex.assign(this.$scope, 0);
	    }
	
	    this.$scope.$watch(this.bindTopIndex, angular.bind(this, function(newIndex) {
	      if (newIndex !== this.topIndex) {
	        this.scrollToIndex(newIndex);
	      }
	    }));
	  } else {
	    this.topIndex = 0;
	  }
	
	  this.scroller = $element[0].querySelector('.md-virtual-repeat-scroller');
	  this.sizer = this.scroller.querySelector('.md-virtual-repeat-sizer');
	  this.offsetter = this.scroller.querySelector('.md-virtual-repeat-offsetter');
	
	  // After the DOM stabilizes, measure the initial size of the container and
	  // make a best effort at re-measuring as it changes.
	  var boundUpdateSize = angular.bind(this, this.updateSize);
	
	  $$rAF(angular.bind(this, function() {
	    boundUpdateSize();
	
	    var debouncedUpdateSize = $mdUtil.debounce(boundUpdateSize, 10, null, false);
	    var jWindow = angular.element($window);
	
	    // Make one more attempt to get the size if it is 0.
	    // This is not by any means a perfect approach, but there's really no
	    // silver bullet here.
	    if (!this.size) {
	      debouncedUpdateSize();
	    }
	
	    jWindow.on('resize', debouncedUpdateSize);
	    $scope.$on('$destroy', function() {
	      jWindow.off('resize', debouncedUpdateSize);
	    });
	
	    $scope.$emit('$md-resize-enable');
	    $scope.$on('$md-resize', boundUpdateSize);
	  }));
	}
	
	
	/** Called by the md-virtual-repeat inside of the container at startup. */
	VirtualRepeatContainerController.prototype.register = function(repeaterCtrl) {
	  this.repeater = repeaterCtrl;
	
	  angular.element(this.scroller)
	      .on('scroll wheel touchmove touchend', angular.bind(this, this.handleScroll_));
	};
	
	
	/** @return {boolean} Whether the container is configured for horizontal scrolling. */
	VirtualRepeatContainerController.prototype.isHorizontal = function() {
	  return this.horizontal;
	};
	
	
	/** @return {number} The size (width or height) of the container. */
	VirtualRepeatContainerController.prototype.getSize = function() {
	  return this.size;
	};
	
	
	/**
	 * Resizes the container.
	 * @private
	 * @param {number} size The new size to set.
	 */
	VirtualRepeatContainerController.prototype.setSize_ = function(size) {
	  var dimension = this.getDimensionName_();
	
	  this.size = size;
	  this.$element[0].style[dimension] = size + 'px';
	};
	
	
	VirtualRepeatContainerController.prototype.unsetSize_ = function() {
	  this.$element[0].style[this.getDimensionName_()] = this.oldElementSize;
	  this.oldElementSize = null;
	};
	
	
	/** Instructs the container to re-measure its size. */
	VirtualRepeatContainerController.prototype.updateSize = function() {
	  // If the original size is already determined, we can skip the update.
	  if (this.originalSize) return;
	
	  var size = this.isHorizontal()
	      ? this.$element[0].clientWidth
	      : this.$element[0].clientHeight;
	
	  if (size) {
	    this.size = size;
	  }
	
	  // Recheck the scroll position after updating the size. This resolves
	  // problems that can result if the scroll position was measured while the
	  // element was display: none or detached from the document.
	  this.handleScroll_();
	
	  this.repeater && this.repeater.containerUpdated();
	};
	
	
	/** @return {number} The container's scrollHeight or scrollWidth. */
	VirtualRepeatContainerController.prototype.getScrollSize = function() {
	  return this.scrollSize;
	};
	
	/**
	 * @returns {string} either width or height dimension
	 * @private
	 */
	VirtualRepeatContainerController.prototype.getDimensionName_ = function() {
	  return this.isHorizontal() ? 'width' : 'height';
	};
	
	
	/**
	 * Sets the scroller element to the specified size.
	 * @private
	 * @param {number} size The new size.
	 */
	VirtualRepeatContainerController.prototype.sizeScroller_ = function(size) {
	  var dimension =  this.getDimensionName_();
	  var crossDimension = this.isHorizontal() ? 'height' : 'width';
	
	  // Clear any existing dimensions.
	  this.sizer.innerHTML = '';
	
	  // If the size falls within the browser's maximum explicit size for a single element, we can
	  // set the size and be done. Otherwise, we have to create children that add up the the desired
	  // size.
	  if (size < this.maxElementPixels) {
	    this.sizer.style[dimension] = size + 'px';
	  } else {
	    this.sizer.style[dimension] = 'auto';
	    this.sizer.style[crossDimension] = 'auto';
	
	    // Divide the total size we have to render into N max-size pieces.
	    var numChildren = Math.floor(size / this.maxElementPixels);
	
	    // Element template to clone for each max-size piece.
	    var sizerChild = document.createElement('div');
	    sizerChild.style[dimension] = this.maxElementPixels + 'px';
	    sizerChild.style[crossDimension] = '1px';
	
	    for (var i = 0; i < numChildren; i++) {
	      this.sizer.appendChild(sizerChild.cloneNode(false));
	    }
	
	    // Re-use the element template for the remainder.
	    sizerChild.style[dimension] = (size - (numChildren * this.maxElementPixels)) + 'px';
	    this.sizer.appendChild(sizerChild);
	  }
	};
	
	
	/**
	 * If auto-shrinking is enabled, shrinks or unshrinks as appropriate.
	 * @private
	 * @param {number} size The new size.
	 */
	VirtualRepeatContainerController.prototype.autoShrink_ = function(size) {
	  var shrinkSize = Math.max(size, this.autoShrinkMin * this.repeater.getItemSize());
	
	  if (this.autoShrink && shrinkSize !== this.size) {
	    if (this.oldElementSize === null) {
	      this.oldElementSize = this.$element[0].style[this.getDimensionName_()];
	    }
	
	    var currentSize = this.originalSize || this.size;
	
	    if (!currentSize || shrinkSize < currentSize) {
	      if (!this.originalSize) {
	        this.originalSize = this.size;
	      }
	
	      // Now we update the containers size, because shrinking is enabled.
	      this.setSize_(shrinkSize);
	    } else if (this.originalSize !== null) {
	      // Set the size back to our initial size.
	      this.unsetSize_();
	
	      var _originalSize = this.originalSize;
	      this.originalSize = null;
	
	      // We determine the repeaters size again, if the original size was zero.
	      // The originalSize needs to be null, to be able to determine the size.
	      if (!_originalSize) this.updateSize();
	
	      // Apply the original size or the determined size back to the container, because
	      // it has been overwritten before, in the shrink block.
	      this.setSize_(_originalSize || this.size);
	    }
	
	    this.repeater.containerUpdated();
	  }
	};
	
	
	/**
	 * Sets the scrollHeight or scrollWidth. Called by the repeater based on
	 * its item count and item size.
	 * @param {number} itemsSize The total size of the items.
	 */
	VirtualRepeatContainerController.prototype.setScrollSize = function(itemsSize) {
	  var size = itemsSize + this.offsetSize;
	  if (this.scrollSize === size) return;
	
	  this.sizeScroller_(size);
	  this.autoShrink_(size);
	  this.scrollSize = size;
	};
	
	
	/** @return {number} The container's current scroll offset. */
	VirtualRepeatContainerController.prototype.getScrollOffset = function() {
	  return this.scrollOffset;
	};
	
	/**
	 * Scrolls to a given scrollTop position.
	 * @param {number} position
	 */
	VirtualRepeatContainerController.prototype.scrollTo = function(position) {
	  this.scroller[this.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = position;
	  this.handleScroll_();
	};
	
	/**
	 * Scrolls the item with the given index to the top of the scroll container.
	 * @param {number} index
	 */
	VirtualRepeatContainerController.prototype.scrollToIndex = function(index) {
	  var itemSize = this.repeater.getItemSize();
	  var itemsLength = this.repeater.itemsLength;
	  if (index > itemsLength) {
	    index = itemsLength - 1;
	  }
	  this.scrollTo(itemSize * index);
	};
	
	VirtualRepeatContainerController.prototype.resetScroll = function() {
	  this.scrollTo(0);
	};
	
	
	VirtualRepeatContainerController.prototype.handleScroll_ = function() {
	  if (!this.ltr && !this.maxSize) {
	    this.scroller.scrollLeft = this.scrollSize;
	    this.maxSize = this.scroller.scrollLeft;
	  }
	  var offset = this.isHorizontal() ?
	      (this.ltr ? this.scroller.scrollLeft : this.maxSize - this.scroller.scrollLeft)
	      : this.scroller.scrollTop;
	  if (this.scrollSize < this.size) return;
	  if (offset > this.scrollSize - this.size) {
	    offset = this.scrollSize - this.size;
	  }
	  if (offset === this.scrollOffset) return;
	
	  var itemSize = this.repeater.getItemSize();
	  if (!itemSize) return;
	
	  var numItems = Math.max(0, Math.floor(offset / itemSize) - NUM_EXTRA);
	
	  var transform = (this.isHorizontal() ? 'translateX(' : 'translateY(') +
	      (!this.isHorizontal() || this.ltr ? (numItems * itemSize) : - (numItems * itemSize))  + 'px)';
	
	  this.scrollOffset = offset;
	  this.offsetter.style.webkitTransform = transform;
	  this.offsetter.style.transform = transform;
	
	  if (this.bindTopIndex) {
	    var topIndex = Math.floor(offset / itemSize);
	    if (topIndex !== this.topIndex && topIndex < this.repeater.getItemCount()) {
	      this.topIndex = topIndex;
	      this.bindTopIndex.assign(this.$scope, topIndex);
	      if (!this.$rootScope.$$phase) this.$scope.$digest();
	    }
	  }
	
	  this.repeater.containerUpdated();
	};
	
	
	/**
	 * @ngdoc directive
	 * @name mdVirtualRepeat
	 * @module material.components.virtualRepeat
	 * @restrict A
	 * @priority 1000
	 * @description
	 * The `md-virtual-repeat` attribute is applied to a template that is repeated using virtual
	 * scrolling. This provides smooth and performant scrolling through very large lists of elements.
	 *
	 * Virtual repeat is a limited substitute for `ng-repeat` that renders only
	 * enough DOM nodes to fill the container, recycling them as the user scrolls.
	 *
	 * ### Notes
	 *
	 * - Arrays are supported for iteration by default.
	 * - An object can used use if `md-on-demand` is specified and the object implements the interface
	 *   described in the `md-on-demand` <a ng-href="#attributes">documentation</a>.
	 * - `trackBy`, `as` alias, and `(key, value)` syntax from `ng-repeat` are not supported.
	 *
	 * ### On-Demand Async Item Loading
	 *
	 * When using the `md-on-demand` attribute and loading some asynchronous data,
	 * the `getItemAtIndex` function will mostly return nothing.
	 *
	 * <hljs lang="js">
	 *   DynamicItems.prototype.getItemAtIndex = function(index) {
	 *     if (this.pages[index]) {
	 *       return this.pages[index];
	 *     } else {
	 *       // This is an asynchronous action and does not return any value.
	 *       this.loadPage(index);
	 *     }
	 *   };
	 * </hljs>
	 *
	 * This means that the Virtual Repeat will not have any value for the given index.<br/>
	 * After the data loading completes, the user expects the Virtual Repeat to recognize the change.
	 *
	 * To make sure that the Virtual Repeat properly detects any change, you need to run the operation
	 * in another digest.
	 *
	 * <hljs lang="js">
	 *   DynamicItems.prototype.loadPage = function(index) {
	 *     var self = this;
	 *
	 *     // Trigger a new digest by using $timeout
	 *     $timeout(function() {
	 *       self.pages[index] = Data;
	 *     });
	 *   };
	 * </hljs>
	 *
	 * > <b>Note:</b> Please also review the
	 *   <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> documentation
	 *   for more information.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-virtual-repeat-container>
	 *   <div md-virtual-repeat="i in items">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 *
	 * <md-virtual-repeat-container md-orient-horizontal>
	 *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 * </hljs>
	 *
	 * @param {expression=} md-extra-name Evaluates to an additional name to which the current iterated
	 *   item can be assigned on the repeated scope (needed for use in `md-autocomplete`).
	 * @param {number=} md-item-size Optional height or width of the repeated elements (which **must be
	 *   identical for each element**). Virtual repeat will attempt to read the size from the DOM,
	 *   if missing, but it still assumes that all repeated nodes have the **same height**
	 *   (when scrolling vertically) or **same width** (when scrolling horizontally).
	 * @param {boolean=} md-on-demand When present, treats the `md-virtual-repeat` argument as an object
	 *   that can fetch rows rather than an array.
	 *
	 *   **NOTE:** This object **must** implement the following interface with two methods:
	 *
	 *   - `getItemAtIndex` - `{function(index): Object}`: The item at that `index` or `null` if it is
	 *     not yet loaded (it should start downloading the item in that case).
	 *   - `getLength` - `{function(): number}`: The data length to which the repeater container
	 *     should be sized. Ideally, when the count is known, this method should return it.
	 *     Otherwise, return a higher number than the currently loaded items to produce an
	 *     infinite-scroll behavior.
	 */
	function VirtualRepeatDirective($parse) {
	  return {
	    controller: VirtualRepeatController,
	    priority: 1000,
	    require: ['mdVirtualRepeat', '^^mdVirtualRepeatContainer'],
	    restrict: 'A',
	    terminal: true,
	    transclude: 'element',
	    compile: function VirtualRepeatCompile($element, $attrs) {
	      var expression = $attrs.mdVirtualRepeat;
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)\s*$/);
	      var repeatName = match[1];
	      var repeatListExpression = $parse(match[2]);
	      var extraName = $attrs.mdExtraName && $parse($attrs.mdExtraName);
	
	      return function VirtualRepeatLink($scope, $element, $attrs, ctrl, $transclude) {
	        ctrl[0].link_(ctrl[1], $transclude, repeatName, repeatListExpression, extraName);
	      };
	    }
	  };
	}
	
	
	/** @ngInject */
	function VirtualRepeatController($scope, $element, $attrs, $browser, $document, $rootScope,
	    $$rAF, $mdUtil) {
	  this.$scope = $scope;
	  this.$element = $element;
	  this.$attrs = $attrs;
	  this.$browser = $browser;
	  this.$document = $document;
	  this.$mdUtil = $mdUtil;
	  this.$rootScope = $rootScope;
	  this.$$rAF = $$rAF;
	
	  /** @type {boolean} Whether we are in on-demand mode. */
	  this.onDemand = $mdUtil.parseAttributeBoolean($attrs.mdOnDemand);
	  /** @type {!Function} Backup reference to $browser.$$checkUrlChange */
	  this.browserCheckUrlChange = $browser.$$checkUrlChange;
	  /** @type {number} Most recent starting repeat index (based on scroll offset) */
	  this.newStartIndex = 0;
	  /** @type {number} Most recent ending repeat index (based on scroll offset) */
	  this.newEndIndex = 0;
	  /** @type {number} Most recent end visible index (based on scroll offset) */
	  this.newVisibleEnd = 0;
	  /** @type {number} Previous starting repeat index (based on scroll offset) */
	  this.startIndex = 0;
	  /** @type {number} Previous ending repeat index (based on scroll offset) */
	  this.endIndex = 0;
	  /** @type {?number} Height/width of repeated elements. */
	  this.itemSize = $scope.$eval($attrs.mdItemSize) || null;
	
	  /** @type {boolean} Whether this is the first time that items are rendered. */
	  this.isFirstRender = true;
	
	  /**
	   * @private {boolean} Whether the items in the list are already being updated. Used to prevent
	   *     nested calls to virtualRepeatUpdate_.
	   */
	  this.isVirtualRepeatUpdating_ = false;
	
	  /** @type {number} Most recently seen length of items. */
	  this.itemsLength = 0;
	
	  /**
	   * @type {!Function} Unwatch callback for item size (when md-items-size is
	   *     not specified), or angular.noop otherwise.
	   */
	  this.unwatchItemSize_ = angular.noop;
	
	  /**
	   * Presently rendered blocks by repeat index.
	   * @type {Object<number, !VirtualRepeatController.Block>}
	   */
	  this.blocks = {};
	  /** @type {Array<!VirtualRepeatController.Block>} A pool of presently unused blocks. */
	  this.pooledBlocks = [];
	
	  $scope.$on('$destroy', angular.bind(this, this.cleanupBlocks_));
	}
	
	
	/**
	 * An object representing a repeated item.
	 * @typedef {{element: !jqLite, new: boolean, scope: !angular.Scope}}
	 */
	VirtualRepeatController.Block;
	
	
	/**
	 * Called at startup by the md-virtual-repeat postLink function.
	 * @param {!VirtualRepeatContainerController} container The container's controller.
	 * @param {!Function} transclude The repeated element's bound transclude function.
	 * @param {string} repeatName The left hand side of the repeat expression, indicating
	 *     the name for each item in the array.
	 * @param {!Function} repeatListExpression A compiled expression based on the right hand side
	 *     of the repeat expression. Points to the array to repeat over.
	 * @param {string|undefined} extraName The optional extra repeatName.
	 */
	VirtualRepeatController.prototype.link_ =
	    function(container, transclude, repeatName, repeatListExpression, extraName) {
	  this.container = container;
	  this.transclude = transclude;
	  this.repeatName = repeatName;
	  this.rawRepeatListExpression = repeatListExpression;
	  this.extraName = extraName;
	  this.sized = false;
	
	  this.repeatListExpression = angular.bind(this, this.repeatListExpression_);
	
	  this.container.register(this);
	};
	
	
	/** @private Cleans up unused blocks. */
	VirtualRepeatController.prototype.cleanupBlocks_ = function() {
	  angular.forEach(this.pooledBlocks, function cleanupBlock(block) {
	    block.element.remove();
	  });
	};
	
	
	/** @private Attempts to set itemSize by measuring a repeated element in the dom */
	VirtualRepeatController.prototype.readItemSize_ = function() {
	  if (this.itemSize) {
	    // itemSize was successfully read in a different asynchronous call.
	    return;
	  }
	
	  this.items = this.repeatListExpression(this.$scope);
	  this.parentNode = this.$element[0].parentNode;
	  var block = this.getBlock_(0);
	  if (!block.element[0].parentNode) {
	    this.parentNode.appendChild(block.element[0]);
	  }
	
	  this.itemSize = block.element[0][
	      this.container.isHorizontal() ? 'offsetWidth' : 'offsetHeight'] || null;
	
	  this.blocks[0] = block;
	  this.poolBlock_(0);
	
	  if (this.itemSize) {
	    this.containerUpdated();
	  }
	};
	
	
	/**
	 * Returns the user-specified repeat list, transforming it into an array-like
	 * object in the case of infinite scroll/dynamic load mode.
	 * @param {!angular.Scope} scope The scope.
	 * @return {!Array|!Object} An array or array-like object for iteration.
	 */
	VirtualRepeatController.prototype.repeatListExpression_ = function(scope) {
	  var repeatList = this.rawRepeatListExpression(scope);
	
	  if (this.onDemand && repeatList) {
	    var virtualList = new VirtualRepeatModelArrayLike(repeatList);
	    virtualList.$$includeIndexes(this.newStartIndex, this.newVisibleEnd);
	    return virtualList;
	  } else {
	    return repeatList;
	  }
	};
	
	
	/**
	 * Called by the container. Informs us that the container's scroll or size has
	 * changed.
	 */
	VirtualRepeatController.prototype.containerUpdated = function() {
	  // If itemSize is unknown, attempt to measure it.
	  if (!this.itemSize) {
	    // Make sure to clean up watchers if we can (see #8178)
	    if (this.unwatchItemSize_ && this.unwatchItemSize_ !== angular.noop){
	      this.unwatchItemSize_();
	    }
	    this.unwatchItemSize_ = this.$scope.$watchCollection(
	        this.repeatListExpression,
	        angular.bind(this, function(items) {
	          if (items && items.length) {
	            this.readItemSize_();
	          }
	        }));
	    if (!this.$rootScope.$$phase) this.$scope.$digest();
	
	    return;
	  } else if (!this.sized) {
	    this.items = this.repeatListExpression(this.$scope);
	  }
	
	  if (!this.sized) {
	    this.unwatchItemSize_();
	    this.sized = true;
	    this.$scope.$watchCollection(this.repeatListExpression,
	        angular.bind(this, function(items, oldItems) {
	          if (!this.isVirtualRepeatUpdating_) {
	            this.virtualRepeatUpdate_(items, oldItems);
	          }
	        }));
	  }
	
	  this.updateIndexes_();
	
	  if (this.newStartIndex !== this.startIndex ||
	      this.newEndIndex !== this.endIndex ||
	      this.container.getScrollOffset() > this.container.getScrollSize()) {
	    if (this.items instanceof VirtualRepeatModelArrayLike) {
	      this.items.$$includeIndexes(this.newStartIndex, this.newEndIndex);
	    }
	    this.virtualRepeatUpdate_(this.items, this.items);
	  }
	};
	
	
	/**
	 * Called by the container. Returns the size of a single repeated item.
	 * @return {?number} size of a repeated item.
	 */
	VirtualRepeatController.prototype.getItemSize = function() {
	  return this.itemSize;
	};
	
	
	/**
	 * Called by the container.
	 * @return {?number} the most recently seen length of items.
	 */
	VirtualRepeatController.prototype.getItemCount = function() {
	  return this.itemsLength;
	};
	
	
	/**
	 * Updates the order and visible offset of repeated blocks in response to scrolling
	 * or updates to `items`.
	 * @param {Array} items visible elements
	 * @param {Array} oldItems previously visible elements
	 * @private
	 */
	VirtualRepeatController.prototype.virtualRepeatUpdate_ = function(items, oldItems) {
	  this.isVirtualRepeatUpdating_ = true;
	
	  var itemsLength = items && items.length || 0;
	  var lengthChanged = false;
	
	  // If the number of items shrank, keep the scroll position.
	  if (this.items && itemsLength < this.items.length && this.container.getScrollOffset() !== 0) {
	    this.items = items;
	    var previousScrollOffset = this.container.getScrollOffset();
	    this.container.resetScroll();
	    this.container.scrollTo(previousScrollOffset);
	  }
	
	  if (itemsLength !== this.itemsLength) {
	    lengthChanged = true;
	    this.itemsLength = itemsLength;
	  }
	
	  this.items = items;
	  if (items !== oldItems || lengthChanged) {
	    this.updateIndexes_();
	  }
	
	  this.parentNode = this.$element[0].parentNode;
	
	  if (lengthChanged) {
	    this.container.setScrollSize(itemsLength * this.itemSize);
	  }
	
	  // Detach and pool any blocks that are no longer in the viewport.
	  Object.keys(this.blocks).forEach(function(blockIndex) {
	    var index = parseInt(blockIndex, 10);
	    if (index < this.newStartIndex || index >= this.newEndIndex) {
	      this.poolBlock_(index);
	    }
	  }, this);
	
	  // Add needed blocks.
	  // For performance reasons, temporarily block browser url checks as we digest
	  // the restored block scopes ($$checkUrlChange reads window.location to
	  // check for changes and trigger route change, etc, which we don't need when
	  // trying to scroll at 60fps).
	  this.$browser.$$checkUrlChange = angular.noop;
	
	  var i, block,
	      newStartBlocks = [],
	      newEndBlocks = [];
	
	  // Collect blocks at the top.
	  for (i = this.newStartIndex; i < this.newEndIndex && this.blocks[i] == null; i++) {
	    block = this.getBlock_(i);
	    this.updateBlock_(block, i);
	    newStartBlocks.push(block);
	  }
	
	  // Update blocks that are already rendered.
	  for (; this.blocks[i] != null; i++) {
	    this.updateBlock_(this.blocks[i], i);
	  }
	  var maxIndex = i - 1;
	
	  // Collect blocks at the end.
	  for (; i < this.newEndIndex; i++) {
	    block = this.getBlock_(i);
	    this.updateBlock_(block, i);
	    newEndBlocks.push(block);
	  }
	
	  // Attach collected blocks to the document.
	  if (newStartBlocks.length) {
	    this.parentNode.insertBefore(
	        this.domFragmentFromBlocks_(newStartBlocks),
	        this.$element[0].nextSibling);
	  }
	  if (newEndBlocks.length) {
	    this.parentNode.insertBefore(
	        this.domFragmentFromBlocks_(newEndBlocks),
	        this.blocks[maxIndex] && this.blocks[maxIndex].element[0].nextSibling);
	  }
	
	  // Restore $$checkUrlChange.
	  this.$browser.$$checkUrlChange = this.browserCheckUrlChange;
	
	  this.startIndex = this.newStartIndex;
	  this.endIndex = this.newEndIndex;
	
	  if (this.isFirstRender) {
	    this.isFirstRender = false;
	    var firstRenderStartIndex = this.$attrs.mdStartIndex ?
	      this.$scope.$eval(this.$attrs.mdStartIndex) :
	      this.container.topIndex;
	
	    // The first call to virtualRepeatUpdate_ may not be when the virtual repeater is ready.
	    // Introduce a slight delay so that the update happens when it is actually ready.
	    this.$mdUtil.nextTick(function() {
	      this.container.scrollToIndex(firstRenderStartIndex);
	    }.bind(this));
	  }
	
	  this.isVirtualRepeatUpdating_ = false;
	};
	
	
	/**
	 * @param {number} index Where the block is to be in the repeated list.
	 * @return {!VirtualRepeatController.Block} A new or pooled block to place at the specified index.
	 * @private
	 */
	VirtualRepeatController.prototype.getBlock_ = function(index) {
	  if (this.pooledBlocks.length) {
	    return this.pooledBlocks.pop();
	  }
	
	  var block;
	  this.transclude(angular.bind(this, function(clone, scope) {
	    block = {
	      element: clone,
	      new: true,
	      scope: scope
	    };
	
	    this.updateScope_(scope, index);
	    this.parentNode.appendChild(clone[0]);
	  }));
	
	  return block;
	};
	
	
	/**
	 * Updates and if not in a digest cycle, digests the specified block's scope to the data
	 * at the specified index.
	 * @param {!VirtualRepeatController.Block} block The block whose scope should be updated.
	 * @param {number} index The index to set.
	 * @private
	 */
	VirtualRepeatController.prototype.updateBlock_ = function(block, index) {
	  this.blocks[index] = block;
	
	  if (!block.new &&
	      (block.scope.$index === index && block.scope[this.repeatName] === this.items[index])) {
	    return;
	  }
	  block.new = false;
	
	  // Update and digest the block's scope.
	  this.updateScope_(block.scope, index);
	
	  // Perform digest before reattaching the block.
	  // Any resulting synchronous DOM mutations should be much faster as a result.
	  // This might break some directives.
	  if (!this.$rootScope.$$phase) {
	    block.scope.$digest();
	  }
	};
	
	
	/**
	 * Updates scope to the data at the specified index.
	 * @param {!angular.Scope} scope The scope which should be updated.
	 * @param {number} index The index to set.
	 * @private
	 */
	VirtualRepeatController.prototype.updateScope_ = function(scope, index) {
	  scope.$index = index;
	  scope[this.repeatName] = this.items && this.items[index];
	  if (this.extraName) scope[this.extraName(this.$scope)] = this.items[index];
	};
	
	
	/**
	 * Pools the block at the specified index (Pulls its element out of the dom and stores it).
	 * @param {number} index The index at which the block to pool is stored.
	 * @private
	 */
	VirtualRepeatController.prototype.poolBlock_ = function(index) {
	  this.pooledBlocks.push(this.blocks[index]);
	  this.parentNode.removeChild(this.blocks[index].element[0]);
	  delete this.blocks[index];
	};
	
	
	/**
	 * Produces a dom fragment containing the elements from the list of blocks.
	 * @param {!Array<!VirtualRepeatController.Block>} blocks The blocks whose elements
	 *     should be added to the document fragment.
	 * @return {DocumentFragment}
	 * @private
	 */
	VirtualRepeatController.prototype.domFragmentFromBlocks_ = function(blocks) {
	  var fragment = this.$document[0].createDocumentFragment();
	  blocks.forEach(function(block) {
	    fragment.appendChild(block.element[0]);
	  });
	  return fragment;
	};
	
	
	/**
	 * Updates start and end indexes based on length of repeated items and container size.
	 * @private
	 */
	VirtualRepeatController.prototype.updateIndexes_ = function() {
	  var itemsLength = this.items ? this.items.length : 0;
	  var containerLength = Math.ceil(this.container.getSize() / this.itemSize);
	
	  this.newStartIndex = Math.max(0, Math.min(
	      itemsLength - containerLength,
	      Math.floor(this.container.getScrollOffset() / this.itemSize)));
	  this.newVisibleEnd = this.newStartIndex + containerLength + NUM_EXTRA;
	  this.newEndIndex = Math.min(itemsLength, this.newVisibleEnd);
	  this.newStartIndex = Math.max(0, this.newStartIndex - NUM_EXTRA);
	};
	
	/**
	 * This VirtualRepeatModelArrayLike class enforces the interface requirements
	 * for infinite scrolling within a mdVirtualRepeatContainer.
	 *
	 * @param {Object} model An object with this interface must implement the following interface with
	 * two (2) methods:
	 *
	 * getItemAtIndex: function(index) -> item at that index or null if it is not yet
	 *     loaded (It should start downloading the item in that case).
	 *
	 * getLength: function() -> number The data length to which the repeater container
	 *     should be sized. Ideally, when the count is known, this method should return it.
	 *     Otherwise, return a higher number than the currently loaded items to produce an
	 *     infinite-scroll behavior.
	 *
	 * @usage
	 * <hljs lang="html">
	 *  <md-virtual-repeat-container md-orient-horizontal>
	 *    <div md-virtual-repeat="i in items" md-on-demand>
	 *      Hello {{i}}!
	 *    </div>
	 *  </md-virtual-repeat-container>
	 * </hljs>
	 *
	 */
	function VirtualRepeatModelArrayLike(model) {
	  if (!angular.isFunction(model.getItemAtIndex) ||
	      !angular.isFunction(model.getLength)) {
	    throw Error('When md-on-demand is enabled, the Object passed to md-virtual-repeat must ' +
	        'implement functions getItemAtIndex() and getLength().');
	  }
	
	  this.model = model;
	}
	
	/**
	 * @param {number} start
	 * @param {number} end
	 */
	VirtualRepeatModelArrayLike.prototype.$$includeIndexes = function(start, end) {
	  for (var i = start; i < end; i++) {
	    if (!this.hasOwnProperty(i)) {
	      this[i] = this.model.getItemAtIndex(i);
	    }
	  }
	  this.length = this.model.getLength();
	};
	
	/**
	 * @ngdoc directive
	 * @name mdForceHeight
	 * @module material.components.virtualRepeat
	 * @restrict A
	 * @description
	 *
	 * Force an element to have a certain `px` height. This is used in place of a style tag in order to
	 * conform to the
	 * <a href="https://developer.mozilla.org/docs/Web/HTTP/Headers/Content-Security-Policy/script-src">
	 *   Content Security Policy</a> regarding `unsafe-inline` `<style>` tags.
	 *
	 * This directive is related to <a ng-href="api/directive/mdVirtualRepeat">mdVirtualRepeat</a>.
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <div md-force-height="'100px'"></div>
	 * </hljs>
	 */
	function ForceHeightDirective($mdUtil) {
	  return {
	    restrict: 'A',
	    link: function(scope, element, attrs) {
	      var height = scope.$eval(attrs.mdForceHeight) || null;
	
	      if (height && element) {
	        element[0].style.height = height;
	      }
	    }
	  };
	}
	ForceHeightDirective.$inject = ['$mdUtil'];
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.whiteframe
	 */
	MdWhiteframeDirective.$inject = ["$log"];
	angular
	  .module('material.components.whiteframe', ['material.core'])
	  .directive('mdWhiteframe', MdWhiteframeDirective);
	
	/**
	 * @ngdoc directive
	 * @module material.components.whiteframe
	 * @name mdWhiteframe
	 *
	 * @description
	 * The md-whiteframe directive allows you to apply an elevation shadow to an element.
	 *
	 * The attribute values needs to be a number between 1 and 24 or -1.
	 * When set to -1 no style is applied.
	 *
	 * ### Notes
	 * - If there is no value specified it defaults to 4dp.
	 * - If the value is not valid it defaults to 4dp.
	
	 * @usage
	 * <hljs lang="html">
	 * <div md-whiteframe="3">
	 *   <span>Elevation of 3dp</span>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="html">
	 * <div md-whiteframe="-1">
	 *   <span>No elevation shadow applied</span>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="html">
	 * <div ng-init="elevation = 5" md-whiteframe="{{elevation}}">
	 *   <span>Elevation of 5dp with an interpolated value</span>
	 * </div>
	 * </hljs>
	 */
	function MdWhiteframeDirective($log) {
	  var DISABLE_DP = -1;
	  var MIN_DP = 1;
	  var MAX_DP = 24;
	  var DEFAULT_DP = 4;
	
	  return {
	    link: postLink
	  };
	
	  function postLink(scope, element, attr) {
	    var oldClass = '';
	
	    attr.$observe('mdWhiteframe', function(elevation) {
	      elevation = parseInt(elevation, 10) || DEFAULT_DP;
	
	      if (elevation != DISABLE_DP && (elevation > MAX_DP || elevation < MIN_DP)) {
	        $log.warn('md-whiteframe attribute value is invalid. It should be a number between ' + MIN_DP + ' and ' + MAX_DP, element[0]);
	        elevation = DEFAULT_DP;
	      }
	
	      var newClass = elevation == DISABLE_DP ? '' : 'md-whiteframe-' + elevation + 'dp';
	      attr.$updateClass(newClass, oldClass);
	      oldClass = newClass;
	    });
	  }
	}
	
	
	})();
	(function(){ 
	angular.module("material.core").constant("$MD_THEME_CSS", "md-autocomplete.md-THEME_NAME-theme{background:\"{{background-hue-1}}\"}md-autocomplete.md-THEME_NAME-theme[disabled]:not([md-floating-label]){background:\"{{background-hue-2}}\"}md-autocomplete.md-THEME_NAME-theme button md-icon path{fill:\"{{background-600}}\"}md-autocomplete.md-THEME_NAME-theme button:after{background:\"{{background-600-0.3}}\"}md-autocomplete.md-THEME_NAME-theme input{color:\"{{foreground-1}}\"}md-autocomplete.md-THEME_NAME-theme.md-accent md-input-container.md-input-focused .md-input{border-color:\"{{accent-color}}\"}md-autocomplete.md-THEME_NAME-theme.md-accent md-input-container.md-input-focused label,md-autocomplete.md-THEME_NAME-theme.md-accent md-input-container.md-input-focused md-icon{color:\"{{accent-color}}\"}md-autocomplete.md-THEME_NAME-theme.md-accent md-progress-linear .md-container{background-color:\"{{accent-100}}\"}md-autocomplete.md-THEME_NAME-theme.md-accent md-progress-linear .md-bar{background-color:\"{{accent-color}}\"}md-autocomplete.md-THEME_NAME-theme.md-warn md-input-container.md-input-focused .md-input{border-color:\"{{warn-A700}}\"}md-autocomplete.md-THEME_NAME-theme.md-warn md-input-container.md-input-focused label,md-autocomplete.md-THEME_NAME-theme.md-warn md-input-container.md-input-focused md-icon{color:\"{{warn-A700}}\"}md-autocomplete.md-THEME_NAME-theme.md-warn md-progress-linear .md-container{background-color:\"{{warn-100}}\"}md-autocomplete.md-THEME_NAME-theme.md-warn md-progress-linear .md-bar{background-color:\"{{warn-color}}\"}.md-autocomplete-standard-list-container.md-THEME_NAME-theme,.md-autocomplete-suggestions-container.md-THEME_NAME-theme{background:\"{{background-hue-1}}\"}.md-autocomplete-standard-list-container.md-THEME_NAME-theme .md-autocomplete-suggestion,.md-autocomplete-suggestions-container.md-THEME_NAME-theme .md-autocomplete-suggestion{color:\"{{foreground-1}}\"}.md-autocomplete-standard-list-container.md-THEME_NAME-theme .md-autocomplete-suggestion.selected,.md-autocomplete-standard-list-container.md-THEME_NAME-theme .md-autocomplete-suggestion:hover,.md-autocomplete-suggestions-container.md-THEME_NAME-theme .md-autocomplete-suggestion.selected,.md-autocomplete-suggestions-container.md-THEME_NAME-theme .md-autocomplete-suggestion:hover{background:\"{{background-500-0.18}}\"}md-backdrop{background-color:\"{{background-900-0.0}}\"}md-backdrop.md-opaque.md-THEME_NAME-theme{background-color:\"{{background-900-1.0}}\"}md-bottom-sheet.md-THEME_NAME-theme{background-color:\"{{background-color}}\";border-top-color:\"{{background-hue-3}}\"}md-bottom-sheet.md-THEME_NAME-theme.md-list md-list-item{color:\"{{foreground-1}}\"}md-bottom-sheet.md-THEME_NAME-theme .md-subheader{background-color:\"{{background-color}}\";color:\"{{foreground-1}}\"}.md-button.md-THEME_NAME-theme:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme:not([disabled]):hover{background-color:\"{{background-500-0.2}}\"}.md-button.md-THEME_NAME-theme:not([disabled]).md-icon-button:hover{background-color:transparent}.md-button.md-THEME_NAME-theme.md-fab md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab,.md-button.md-THEME_NAME-theme.md-primary.md-raised{color:\"{{primary-contrast}}\";background-color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]) md-icon{color:\"{{primary-contrast}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]):hover{background-color:\"{{primary-600}}\"}.md-button.md-THEME_NAME-theme.md-primary:not([disabled]) md-icon{color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-fab{background-color:\"{{accent-color}}\";color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-fab:not([disabled]) .md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-fab:not([disabled]):hover{background-color:\"{{accent-A700}}\"}.md-button.md-THEME_NAME-theme.md-raised{color:\"{{background-900}}\";background-color:\"{{background-50}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]) md-icon{color:\"{{background-900}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]):hover{background-color:\"{{background-50}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]).md-focused{background-color:\"{{background-200}}\"}.md-button.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab,.md-button.md-THEME_NAME-theme.md-warn.md-raised{color:\"{{warn-contrast}}\";background-color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]) md-icon{color:\"{{warn-contrast}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]):hover{background-color:\"{{warn-600}}\"}.md-button.md-THEME_NAME-theme.md-warn:not([disabled]) md-icon{color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab,.md-button.md-THEME_NAME-theme.md-accent.md-raised{color:\"{{accent-contrast}}\";background-color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]) md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]):hover{background-color:\"{{accent-A700}}\"}.md-button.md-THEME_NAME-theme.md-accent:not([disabled]) md-icon{color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent[disabled],.md-button.md-THEME_NAME-theme.md-fab[disabled],.md-button.md-THEME_NAME-theme.md-raised[disabled],.md-button.md-THEME_NAME-theme.md-warn[disabled],.md-button.md-THEME_NAME-theme[disabled]{color:\"{{foreground-3}}\";cursor:default}.md-button.md-THEME_NAME-theme.md-accent[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-fab[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-raised[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-warn[disabled] md-icon,.md-button.md-THEME_NAME-theme[disabled] md-icon{color:\"{{foreground-3}}\"}.md-button.md-THEME_NAME-theme.md-fab[disabled],.md-button.md-THEME_NAME-theme.md-raised[disabled]{background-color:\"{{foreground-4}}\"}.md-button.md-THEME_NAME-theme[disabled]{background-color:transparent}._md a.md-THEME_NAME-theme:not(.md-button).md-primary{color:\"{{primary-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-primary:hover{color:\"{{primary-700}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-accent{color:\"{{accent-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-accent:hover{color:\"{{accent-A700}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-warn{color:\"{{warn-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-warn:hover{color:\"{{warn-700}}\"}md-card.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-hue-1}}\";border-radius:2px}md-card.md-THEME_NAME-theme .md-card-image{border-radius:2px 2px 0 0}md-card.md-THEME_NAME-theme md-card-header md-card-avatar md-icon{color:\"{{background-color}}\";background-color:\"{{foreground-3}}\"}md-card.md-THEME_NAME-theme md-card-header md-card-header-text .md-subhead,md-card.md-THEME_NAME-theme md-card-title md-card-title-text:not(:only-child) .md-subhead{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme .md-ripple{color:\"{{accent-A700}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-ripple{color:\"{{background-600}}\"}md-checkbox.md-THEME_NAME-theme.md-checked.md-focused .md-container:before{background-color:\"{{accent-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-icon{background-color:\"{{accent-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-icon:after{border-color:\"{{accent-contrast-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ripple{color:\"{{primary-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ripple{color:\"{{background-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple{color:\"{{primary-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon{background-color:\"{{primary-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked.md-focused .md-container:before{background-color:\"{{primary-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon:after{border-color:\"{{primary-contrast-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-indeterminate[disabled] .md-container{color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ripple{color:\"{{warn-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple{color:\"{{warn-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-icon{background-color:\"{{warn-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked.md-focused:not([disabled]) .md-container:before{background-color:\"{{warn-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-icon:after{border-color:\"{{background-200}}\"}md-checkbox.md-THEME_NAME-theme[disabled]:not(.md-checked) .md-icon{border-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled].md-checked .md-icon{background-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled].md-checked .md-icon:after{border-color:\"{{background-200}}\"}md-checkbox.md-THEME_NAME-theme[disabled] .md-icon:after{border-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled] .md-label{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips{box-shadow:0 1px \"{{foreground-4}}\"}md-chips.md-THEME_NAME-theme .md-chips.md-focused{box-shadow:0 2px \"{{primary-color}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input{color:\"{{foreground-1}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-ms-input-placeholder,md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-ms-input-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-moz-placeholder,md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-moz-placeholder{color:\"{{foreground-3}}\";opacity:1}md-chips.md-THEME_NAME-theme md-chip{background:\"{{background-300}}\";color:\"{{background-800}}\"}md-chips.md-THEME_NAME-theme md-chip md-icon{color:\"{{background-700}}\"}md-chips.md-THEME_NAME-theme md-chip.md-focused{background:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-chips.md-THEME_NAME-theme md-chip.md-focused md-icon{color:\"{{primary-contrast}}\"}md-chips.md-THEME_NAME-theme md-chip._md-chip-editing{background:transparent;color:\"{{background-800}}\"}md-chips.md-THEME_NAME-theme md-chip-remove .md-button md-icon path{fill:\"{{background-500}}\"}.md-contact-suggestion span.md-contact-email{color:\"{{background-400}}\"}md-content.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-default}}\"}.md-THEME_NAME-theme .md-calendar{background:\"{{background-hue-1}}\";color:\"{{foreground-1-0.87}}\"}.md-THEME_NAME-theme .md-calendar tr:last-child td{border-bottom-color:\"{{background-hue-2}}\"}.md-THEME_NAME-theme .md-calendar-day-header{background:\"{{background-500-0.32}}\";color:\"{{foreground-1-0.87}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today .md-calendar-date-selection-indicator{border:1px solid \"{{primary-500}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today.md-calendar-date-disabled{color:\"{{primary-500-0.6}}\"}.md-calendar-date.md-focus .md-THEME_NAME-theme .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date-selection-indicator:hover{background:\"{{background-500-0.32}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-selected-date .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date.md-focus.md-calendar-selected-date .md-calendar-date-selection-indicator{background:\"{{primary-500}}\";color:\"{{primary-500-contrast}}\";border-color:transparent}.md-THEME_NAME-theme .md-calendar-date-disabled,.md-THEME_NAME-theme .md-calendar-month-label-disabled{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-calendar-month-label md-icon,.md-THEME_NAME-theme .md-datepicker-input{color:\"{{foreground-1}}\"}.md-THEME_NAME-theme .md-datepicker-input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input:-ms-input-placeholder,.md-THEME_NAME-theme .md-datepicker-input::-ms-input-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input::placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input:-moz-placeholder,.md-THEME_NAME-theme .md-datepicker-input::-moz-placeholder{color:\"{{foreground-3}}\";opacity:1}.md-THEME_NAME-theme .md-datepicker-input-container{border-bottom-color:\"{{foreground-4}}\"}.md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{primary-color}}\"}.md-accent .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{accent-color}}\"}.md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-invalid,.md-warn .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{warn-A700}}\"}.md-THEME_NAME-theme .md-datepicker-calendar-pane{border-color:\"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-triangle-button .md-datepicker-expand-triangle{border-top-color:\"{{foreground-2}}\"}.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon{color:\"{{primary-color}}\"}.md-accent .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon,.md-THEME_NAME-theme .md-datepicker-open.md-accent .md-datepicker-calendar-icon{color:\"{{accent-color}}\"}.md-THEME_NAME-theme .md-datepicker-open.md-warn .md-datepicker-calendar-icon,.md-warn .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon{color:\"{{warn-A700}}\"}.md-THEME_NAME-theme .md-datepicker-calendar{background:\"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-input-mask-opaque{box-shadow:0 0 0 9999px \"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-input-container{background:\"{{background-hue-1}}\"}md-dialog.md-THEME_NAME-theme{border-radius:4px;background-color:\"{{background-hue-1}}\";color:\"{{foreground-1}}\"}md-dialog.md-THEME_NAME-theme.md-content-overflow .md-actions,md-dialog.md-THEME_NAME-theme.md-content-overflow md-dialog-actions,md-divider.md-THEME_NAME-theme{border-top-color:\"{{foreground-4}}\"}.layout-gt-lg-row>md-divider.md-THEME_NAME-theme,.layout-gt-md-row>md-divider.md-THEME_NAME-theme,.layout-gt-sm-row>md-divider.md-THEME_NAME-theme,.layout-gt-xs-row>md-divider.md-THEME_NAME-theme,.layout-lg-row>md-divider.md-THEME_NAME-theme,.layout-md-row>md-divider.md-THEME_NAME-theme,.layout-row>md-divider.md-THEME_NAME-theme,.layout-sm-row>md-divider.md-THEME_NAME-theme,.layout-xl-row>md-divider.md-THEME_NAME-theme,.layout-xs-row>md-divider.md-THEME_NAME-theme{border-right-color:\"{{foreground-4}}\"}md-icon.md-THEME_NAME-theme{color:\"{{foreground-2}}\"}md-icon.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}md-icon.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}md-icon.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}md-input-container.md-THEME_NAME-theme .md-input{color:\"{{foreground-1}}\";border-color:\"{{foreground-4}}\"}md-input-container.md-THEME_NAME-theme .md-input::-webkit-input-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme .md-input:-ms-input-placeholder,md-input-container.md-THEME_NAME-theme .md-input::-ms-input-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme .md-input::placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme .md-input:-moz-placeholder,md-input-container.md-THEME_NAME-theme .md-input::-moz-placeholder{color:\"{{foreground-2}}\";opacity:1}md-input-container.md-THEME_NAME-theme>md-icon{color:\"{{foreground-1}}\"}md-input-container.md-THEME_NAME-theme .md-placeholder,md-input-container.md-THEME_NAME-theme label{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme label.md-required:after{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-focused):not(.md-input-invalid) label.md-required:after{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme .md-input-message-animation,md-input-container.md-THEME_NAME-theme .md-input-messages-animation{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme .md-input-message-animation .md-char-counter,md-input-container.md-THEME_NAME-theme .md-input-messages-animation .md-char-counter{color:\"{{foreground-1}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-webkit-input-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input:-ms-input-placeholder,md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-ms-input-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input:-moz-placeholder,md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-moz-placeholder{color:\"{{foreground-2}}\";opacity:1}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-has-value label{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused .md-input,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-resized .md-input{border-color:\"{{primary-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused md-icon{color:\"{{primary-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent .md-input{border-color:\"{{accent-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent md-icon{color:\"{{accent-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn .md-input{border-color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn md-icon{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input{border-color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme.md-input-invalid .md-char-counter,md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input-message-animation,md-input-container.md-THEME_NAME-theme.md-input-invalid label{color:\"{{warn-A700}}\"}[disabled] md-input-container.md-THEME_NAME-theme .md-input,md-input-container.md-THEME_NAME-theme .md-input[disabled]{border-bottom-color:transparent;color:\"{{foreground-3}}\";background-image:linear-gradient(90deg,\"{{foreground-3}}\" 0,\"{{foreground-3}}\" 33%,transparent 0);background-image:-ms-linear-gradient(left,transparent 0,\"{{foreground-3}}\" 100%)}md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h4,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h4{color:\"{{foreground-1}}\"}md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text p,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text p{color:\"{{foreground-2}}\"}md-list.md-THEME_NAME-theme .md-proxy-focus.md-focused div.md-no-style{background-color:\"{{background-100}}\"}md-list.md-THEME_NAME-theme md-list-item .md-avatar-icon{background-color:\"{{foreground-3}}\";color:\"{{background-color}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon{color:\"{{foreground-2}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon.md-highlight{color:\"{{primary-color}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon.md-highlight.md-accent{color:\"{{accent-color}}\"}md-menu-content.md-THEME_NAME-theme{background-color:\"{{background-hue-1}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item{color:\"{{foreground-1}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item md-icon{color:\"{{foreground-2}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled],md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled] md-icon{color:\"{{foreground-3}}\"}md-menu-content.md-THEME_NAME-theme md-menu-divider{background-color:\"{{foreground-4}}\"}md-menu-bar.md-THEME_NAME-theme>button.md-button{color:\"{{foreground-1}}\";border-radius:2px}md-menu-bar.md-THEME_NAME-theme md-menu>button{color:\"{{foreground-1}}\"}md-menu-bar.md-THEME_NAME-theme md-menu.md-open>button,md-menu-bar.md-THEME_NAME-theme md-menu>button:focus{outline:none;background-color:\"{{ background-500-0.18}}\"}md-menu-bar.md-THEME_NAME-theme.md-open:not(.md-keyboard-mode) md-menu:hover>button{background-color:\"{{ background-500-0.18}}\"}md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:focus,md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:hover{background:transparent}md-menu-content.md-THEME_NAME-theme .md-menu>.md-button:after{color:\"{{foreground-2}}\"}md-menu-content.md-THEME_NAME-theme .md-menu.md-open>.md-button{background-color:\"{{ background-500-0.18}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar{background-color:\"{{background-hue-1}}\";color:\"{{foreground-1}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler{background-color:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler md-icon{color:\"{{primary-contrast}}\"}md-nav-bar.md-THEME_NAME-theme .md-nav-bar{background-color:transparent;border-color:\"{{foreground-4}}\"}md-nav-bar.md-THEME_NAME-theme .md-button._md-nav-button.md-unselected{color:\"{{foreground-2}}\"}md-nav-bar.md-THEME_NAME-theme .md-button._md-nav-button[disabled]{color:\"{{foreground-3}}\"}md-nav-bar.md-THEME_NAME-theme md-nav-ink-bar{color:\"{{accent-color}}\";background:\"{{accent-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar{background-color:\"{{accent-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button{color:\"{{accent-A100}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{accent-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{accent-contrast-0.1}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar md-nav-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar{background-color:\"{{warn-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button{color:\"{{warn-100}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{warn-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{warn-contrast-0.1}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar{background-color:\"{{primary-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button{color:\"{{primary-100}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{primary-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{primary-color}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{primary-100}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{primary-contrast}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{accent-color}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{accent-A100}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{accent-contrast}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{accent-contrast-0.1}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar md-nav-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{warn-color}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{warn-100}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{warn-contrast}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{warn-contrast-0.1}}\"}._md-panel-backdrop.md-THEME_NAME-theme{background-color:\"{{background-900-1.0}}\"}md-progress-circular.md-THEME_NAME-theme path{stroke:\"{{primary-color}}\"}md-progress-circular.md-THEME_NAME-theme.md-warn path{stroke:\"{{warn-color}}\"}md-progress-circular.md-THEME_NAME-theme.md-accent path{stroke:\"{{accent-color}}\"}md-progress-linear.md-THEME_NAME-theme .md-container{background-color:\"{{primary-100}}\"}md-progress-linear.md-THEME_NAME-theme .md-bar{background-color:\"{{primary-color}}\"}md-progress-linear.md-THEME_NAME-theme.md-warn .md-container{background-color:\"{{warn-100}}\"}md-progress-linear.md-THEME_NAME-theme.md-warn .md-bar{background-color:\"{{warn-color}}\"}md-progress-linear.md-THEME_NAME-theme.md-accent .md-container{background-color:\"{{accent-100}}\"}md-progress-linear.md-THEME_NAME-theme.md-accent .md-bar{background-color:\"{{accent-color}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-primary .md-bar1{background-color:\"{{primary-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-primary .md-dashed:before{background:radial-gradient(\"{{primary-100}}\" 0,\"{{primary-100}}\" 16%,transparent 42%)}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-bar1{background-color:\"{{warn-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-dashed:before{background:radial-gradient(\"{{warn-100}}\" 0,\"{{warn-100}}\" 16%,transparent 42%)}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-bar1{background-color:\"{{accent-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-dashed:before{background:radial-gradient(\"{{accent-100}}\" 0,\"{{accent-100}}\" 16%,transparent 42%)}md-radio-button.md-THEME_NAME-theme .md-off{border-color:\"{{foreground-2}}\"}md-radio-button.md-THEME_NAME-theme .md-on{background-color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme.md-checked .md-off{border-color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme .md-container .md-ripple{color:\"{{accent-A700}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on{background-color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off{border-color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple{color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple{color:\"{{primary-600}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on{background-color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off{border-color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple{color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple{color:\"{{warn-600}}\"}md-radio-button.md-THEME_NAME-theme[disabled],md-radio-group.md-THEME_NAME-theme[disabled]{color:\"{{foreground-3}}\"}md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-off,md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-on,md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-off,md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-on{border-color:\"{{foreground-3}}\"}md-radio-group.md-THEME_NAME-theme .md-checked .md-ink-ripple{color:\"{{accent-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme .md-checked:not([disabled]).md-primary .md-ink-ripple,md-radio-group.md-THEME_NAME-theme.md-primary .md-checked:not([disabled]) .md-ink-ripple{color:\"{{primary-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused.ng-empty>md-radio-button:first-child .md-container:before{background-color:\"{{foreground-3-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked .md-container:before{background-color:\"{{accent-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-primary .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-primary .md-checked .md-container:before{background-color:\"{{primary-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-warn .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-warn .md-checked .md-container:before{background-color:\"{{warn-color-0.26}}\"}md-input-container md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{warn-A700}}\"}md-input-container:not(.md-input-focused):not(.md-input-invalid) md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{foreground-3}}\"}md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value,md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder{color:\"{{primary-color}}\"}md-input-container.md-input-invalid md-select.md-THEME_NAME-theme .md-select-value{color:\"{{warn-A700}}\"!important;border-bottom-color:\"{{warn-A700}}\"!important}md-input-container.md-input-invalid md-select.md-THEME_NAME-theme.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-input-container:not(.md-input-invalid).md-input-focused.md-accent .md-select-value{border-color:\"{{accent-color}}\"}md-input-container:not(.md-input-invalid).md-input-focused.md-accent .md-select-value span{color:\"{{accent-color}}\"}md-input-container:not(.md-input-invalid).md-input-focused.md-warn .md-select-value{border-color:\"{{warn-A700}}\"}md-input-container:not(.md-input-invalid).md-input-focused.md-warn .md-select-value span{color:\"{{warn-A700}}\"}md-select.md-THEME_NAME-theme[disabled] .md-select-value{border-bottom-color:transparent;background-image:linear-gradient(90deg,\"{{foreground-3}}\" 0,\"{{foreground-3}}\" 33%,transparent 0);background-image:-ms-linear-gradient(left,transparent 0,\"{{foreground-3}}\" 100%)}md-select.md-THEME_NAME-theme .md-select-value{border-bottom-color:\"{{foreground-4}}\"}md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder{color:\"{{foreground-3}}\"}md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{warn-A700}}\"}md-select.md-THEME_NAME-theme.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme.ng-invalid.ng-touched .md-select-value{color:\"{{warn-A700}}\"!important;border-bottom-color:\"{{warn-A700}}\"!important}md-select.md-THEME_NAME-theme.ng-invalid.ng-touched.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value{border-bottom-color:\"{{primary-color}}\";color:\"{{ foreground-1 }}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value.md-select-placeholder{color:\"{{ foreground-1 }}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-accent .md-select-value{border-bottom-color:\"{{accent-color}}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-warn .md-select-value{border-bottom-color:\"{{warn-color}}\"}md-select.md-THEME_NAME-theme[disabled] .md-select-icon,md-select.md-THEME_NAME-theme[disabled] .md-select-value,md-select.md-THEME_NAME-theme[disabled] .md-select-value.md-select-placeholder{color:\"{{foreground-3}}\"}md-select.md-THEME_NAME-theme .md-select-icon{color:\"{{foreground-2}}\"}md-select-menu.md-THEME_NAME-theme md-content{background-color:\"{{background-hue-1}}\"}md-select-menu.md-THEME_NAME-theme md-content md-optgroup{color:\"{{foreground-2}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option{color:\"{{foreground-1}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[disabled] .md-text{color:\"{{foreground-3}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]).md-focused,md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):focus,md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):hover{background-color:\"{{background-500-0.18}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected]{color:\"{{primary-500}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-focused,md-select-menu.md-THEME_NAME-theme md-content md-option[selected]:focus{color:\"{{primary-600}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent{color:\"{{accent-color}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent.md-focused,md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent:focus{color:\"{{accent-A700}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-ripple{color:\"{{primary-600}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ripple{color:\"{{background-600}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-ink-ripple{color:\"{{foreground-2}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ink-ripple{color:\"{{primary-color-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon{background-color:\"{{primary-color-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected].md-focused .md-container:before{background-color:\"{{primary-color-0.26}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon:after{border-color:\"{{primary-contrast-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-indeterminate[disabled] .md-container{color:\"{{foreground-3}}\"}.md-checkbox-enabled.md-THEME_NAME-theme md-option .md-text{color:\"{{foreground-1}}\"}md-sidenav.md-THEME_NAME-theme,md-sidenav.md-THEME_NAME-theme md-content{background-color:\"{{background-hue-1}}\"}md-slider.md-THEME_NAME-theme .md-track{background-color:\"{{foreground-3}}\"}md-slider.md-THEME_NAME-theme .md-track-ticks{color:\"{{background-contrast}}\"}md-slider.md-THEME_NAME-theme .md-focus-ring{background-color:\"{{accent-A200-0.2}}\"}md-slider.md-THEME_NAME-theme .md-disabled-thumb{border-color:\"{{background-color}}\";background-color:\"{{background-color}}\"}md-slider.md-THEME_NAME-theme.md-min .md-thumb:after{background-color:\"{{background-color}}\";border-color:\"{{foreground-3}}\"}md-slider.md-THEME_NAME-theme.md-min .md-focus-ring{background-color:\"{{foreground-3-0.38}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-thumb:after{background-color:\"{{background-contrast}}\";border-color:transparent}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign{background-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign:after{border-top-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete][md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme .md-track.md-track-fill{background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-thumb:after{border-color:\"{{accent-color}}\";background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-sign{background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-sign:after{border-top-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-thumb-text{color:\"{{accent-contrast}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-focus-ring{background-color:\"{{warn-200-0.38}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-track.md-track-fill{background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-thumb:after{border-color:\"{{warn-color}}\";background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-sign{background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-sign:after{border-top-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-thumb-text{color:\"{{warn-contrast}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-focus-ring{background-color:\"{{primary-200-0.38}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-track.md-track-fill{background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-thumb:after{border-color:\"{{primary-color}}\";background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-sign{background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-sign:after{border-top-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-thumb-text{color:\"{{primary-contrast}}\"}md-slider.md-THEME_NAME-theme[disabled] .md-thumb:after{border-color:transparent}md-slider.md-THEME_NAME-theme[disabled]:not(.md-min) .md-thumb:after,md-slider.md-THEME_NAME-theme[disabled][md-discrete] .md-thumb:after{background-color:\"{{foreground-3}}\";border-color:transparent}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign{background-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign:after{border-top-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly][md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-disabled-thumb{border-color:transparent;background-color:transparent}md-slider-container[disabled]>:first-child:not(md-slider),md-slider-container[disabled]>:last-child:not(md-slider){color:\"{{foreground-3}}\"}.md-subheader.md-THEME_NAME-theme{color:\"{{ foreground-2-0.23 }}\";background-color:\"{{background-default}}\"}.md-subheader.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}.md-subheader.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}.md-subheader.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme .md-ink-ripple{color:\"{{background-500}}\"}md-switch.md-THEME_NAME-theme .md-thumb{background-color:\"{{background-50}}\"}md-switch.md-THEME_NAME-theme .md-bar{background-color:\"{{background-500}}\"}md-switch.md-THEME_NAME-theme.md-focused:not(.md-checked) .md-thumb:before,md-switch.md-THEME_NAME-theme.md-focused[disabled] .md-thumb:before{background-color:\"{{foreground-4}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]) .md-ink-ripple{color:\"{{accent-color}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]) .md-thumb{background-color:\"{{accent-color}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]) .md-bar{background-color:\"{{accent-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-focused .md-thumb:before{background-color:\"{{accent-color-0.26}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-primary .md-ink-ripple{color:\"{{primary-color}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-primary .md-thumb{background-color:\"{{primary-color}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-primary .md-bar{background-color:\"{{primary-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-primary.md-focused .md-thumb:before{background-color:\"{{primary-color-0.26}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-warn .md-ink-ripple{color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-warn .md-thumb{background-color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-warn .md-bar{background-color:\"{{warn-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-warn.md-focused .md-thumb:before{background-color:\"{{warn-color-0.26}}\"}md-switch.md-THEME_NAME-theme[disabled] .md-thumb{background-color:\"{{background-400}}\"}md-switch.md-THEME_NAME-theme[disabled] .md-bar{background-color:\"{{foreground-4}}\"}md-tabs.md-THEME_NAME-theme md-tabs-wrapper{background-color:transparent;border-color:\"{{foreground-4}}\"}md-tabs.md-THEME_NAME-theme .md-paginator md-icon{color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme md-ink-bar{color:\"{{accent-color}}\";background:\"{{accent-color}}\"}md-tabs.md-THEME_NAME-theme .md-tab{color:\"{{foreground-2}}\"}md-tabs.md-THEME_NAME-theme .md-tab[disabled],md-tabs.md-THEME_NAME-theme .md-tab[disabled] md-icon{color:\"{{foreground-3}}\"}md-tabs.md-THEME_NAME-theme .md-tab.md-active,md-tabs.md-THEME_NAME-theme .md-tab.md-active md-icon,md-tabs.md-THEME_NAME-theme .md-tab.md-focused,md-tabs.md-THEME_NAME-theme .md-tab.md-focused md-icon{color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme .md-tab.md-focused{background:\"{{primary-color-0.1}}\"}md-tabs.md-THEME_NAME-theme .md-tab .md-ripple-container{color:\"{{accent-A100}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper{background-color:\"{{accent-color}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{accent-A100}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{accent-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{accent-contrast-0.1}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper{background-color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{primary-100}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{primary-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{primary-contrast-0.1}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper{background-color:\"{{warn-color}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{warn-100}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{warn-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{warn-contrast-0.1}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{primary-color}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{primary-100}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{primary-contrast}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{accent-color}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{accent-A100}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{accent-contrast}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{accent-contrast-0.1}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{warn-color}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{warn-100}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{warn-contrast}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{warn-contrast-0.1}}\"}md-toast.md-THEME_NAME-theme .md-toast-content{background-color:#323232;color:\"{{background-50}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button{color:\"{{background-50}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight{color:\"{{accent-color}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-primary{color:\"{{primary-color}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-warn{color:\"{{warn-color}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar){background-color:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-icon{color:\"{{primary-contrast}}\";fill:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) .md-button[disabled] md-icon{color:\"{{primary-contrast-0.26}}\";fill:\"{{primary-contrast-0.26}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent{background-color:\"{{accent-color}}\";color:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-ink-ripple{color:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-icon{color:\"{{accent-contrast}}\";fill:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-button[disabled] md-icon{color:\"{{accent-contrast-0.26}}\";fill:\"{{accent-contrast-0.26}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn{background-color:\"{{warn-color}}\";color:\"{{warn-contrast}}\"}.md-panel.md-tooltip.md-THEME_NAME-theme{color:\"{{background-700-contrast}}\";background-color:\"{{background-700}}\"}body.md-THEME_NAME-theme,html.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-color}}\"}"); 
	})();
	
	
	})(window, window.angular);;window.ngMaterial={version:{full: "1.1.24"}};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(301)))

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(383);
	module.exports = 'ngMessages';


/***/ },
/* 383 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.6.1
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var forEach;
	var isArray;
	var isString;
	var jqLite;
	
	/**
	 * @ngdoc module
	 * @name ngMessages
	 * @description
	 *
	 * The `ngMessages` module provides enhanced support for displaying messages within templates
	 * (typically within forms or when rendering message objects that return key/value data).
	 * Instead of relying on JavaScript code and/or complex ng-if statements within your form template to
	 * show and hide error messages specific to the state of an input field, the `ngMessages` and
	 * `ngMessage` directives are designed to handle the complexity, inheritance and priority
	 * sequencing based on the order of how the messages are defined in the template.
	 *
	 * Currently, the ngMessages module only contains the code for the `ngMessages`, `ngMessagesInclude`
	 * `ngMessage` and `ngMessageExp` directives.
	 *
	 * # Usage
	 * The `ngMessages` directive allows keys in a key/value collection to be associated with a child element
	 * (or 'message') that will show or hide based on the truthiness of that key's value in the collection. A common use
	 * case for `ngMessages` is to display error messages for inputs using the `$error` object exposed by the
	 * {@link ngModel ngModel} directive.
	 *
	 * The child elements of the `ngMessages` directive are matched to the collection keys by a `ngMessage` or
	 * `ngMessageExp` directive. The value of these attributes must match a key in the collection that is provided by
	 * the `ngMessages` directive.
	 *
	 * Consider the following example, which illustrates a typical use case of `ngMessages`. Within the form `myForm` we
	 * have a text input named `myField` which is bound to the scope variable `field` using the {@link ngModel ngModel}
	 * directive.
	 *
	 * The `myField` field is a required input of type `email` with a maximum length of 15 characters.
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Enter text:
	 *     <input type="email" ng-model="field" name="myField" required maxlength="15" />
	 *   </label>
	 *   <div ng-messages="myForm.myField.$error" role="alert">
	 *     <div ng-message="required">Please enter a value for this field.</div>
	 *     <div ng-message="email">This field must be a valid email address.</div>
	 *     <div ng-message="maxlength">This field can be at most 15 characters long.</div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In order to show error messages corresponding to `myField` we first create an element with an `ngMessages` attribute
	 * set to the `$error` object owned by the `myField` input in our `myForm` form.
	 *
	 * Within this element we then create separate elements for each of the possible errors that `myField` could have.
	 * The `ngMessage` attribute is used to declare which element(s) will appear for which error - for example,
	 * setting `ng-message="required"` specifies that this particular element should be displayed when there
	 * is no value present for the required field `myField` (because the key `required` will be `true` in the object
	 * `myForm.myField.$error`).
	 *
	 * ### Message order
	 *
	 * By default, `ngMessages` will only display one message for a particular key/value collection at any time. If more
	 * than one message (or error) key is currently true, then which message is shown is determined by the order of messages
	 * in the HTML template code (messages declared first are prioritised). This mechanism means the developer does not have
	 * to prioritize messages using custom JavaScript code.
	 *
	 * Given the following error object for our example (which informs us that the field `myField` currently has both the
	 * `required` and `email` errors):
	 *
	 * ```javascript
	 * <!-- keep in mind that ngModel automatically sets these error flags -->
	 * myField.$error = { required : true, email: true, maxlength: false };
	 * ```
	 * The `required` message will be displayed to the user since it appears before the `email` message in the DOM.
	 * Once the user types a single character, the `required` message will disappear (since the field now has a value)
	 * but the `email` message will be visible because it is still applicable.
	 *
	 * ### Displaying multiple messages at the same time
	 *
	 * While `ngMessages` will by default only display one error element at a time, the `ng-messages-multiple` attribute can
	 * be applied to the `ngMessages` container element to cause it to display all applicable error messages at once:
	 *
	 * ```html
	 * <!-- attribute-style usage -->
	 * <div ng-messages="myForm.myField.$error" ng-messages-multiple>...</div>
	 *
	 * <!-- element-style usage -->
	 * <ng-messages for="myForm.myField.$error" multiple>...</ng-messages>
	 * ```
	 *
	 * ## Reusing and Overriding Messages
	 * In addition to prioritization, ngMessages also allows for including messages from a remote or an inline
	 * template. This allows for generic collection of messages to be reused across multiple parts of an
	 * application.
	 *
	 * ```html
	 * <script type="text/ng-template" id="error-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <div ng-messages="myForm.myField.$error" role="alert">
	 *   <div ng-messages-include="error-messages"></div>
	 * </div>
	 * ```
	 *
	 * However, including generic messages may not be useful enough to match all input fields, therefore,
	 * `ngMessages` provides the ability to override messages defined in the remote template by redefining
	 * them within the directive container.
	 *
	 * ```html
	 * <!-- a generic template of error messages known as "my-custom-messages" -->
	 * <script type="text/ng-template" id="my-custom-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            id="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <!-- any ng-message elements that appear BEFORE the ng-messages-include will
	 *        override the messages present in the ng-messages-include template -->
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <!-- this required message has overridden the template message -->
	 *     <div ng-message="required">You did not enter your email address</div>
	 *
	 *     <!-- this is a brand new message and will appear last in the prioritization -->
	 *     <div ng-message="email">Your email address is invalid</div>
	 *
	 *     <!-- and here are the generic error messages -->
	 *     <div ng-messages-include="my-custom-messages"></div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In the example HTML code above the message that is set on required will override the corresponding
	 * required message defined within the remote template. Therefore, with particular input fields (such
	 * email addresses, date fields, autocomplete inputs, etc...), specialized error messages can be applied
	 * while more generic messages can be used to handle other, more general input errors.
	 *
	 * ## Dynamic Messaging
	 * ngMessages also supports using expressions to dynamically change key values. Using arrays and
	 * repeaters to list messages is also supported. This means that the code below will be able to
	 * fully adapt itself and display the appropriate message when any of the expression data changes:
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message="required">You did not enter your email address</div>
	 *     <div ng-repeat="errorMessage in errorMessages">
	 *       <!-- use ng-message-exp for a message whose key is given by an expression -->
	 *       <div ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>
	 *     </div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * The `errorMessage.type` expression can be a string value or it can be an array so
	 * that multiple errors can be associated with a single error message:
	 *
	 * ```html
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            ng-model="data.email"
	 *            name="myEmail"
	 *            ng-minlength="5"
	 *            ng-maxlength="100"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message-exp="'required'">You did not enter your email address</div>
	 *     <div ng-message-exp="['minlength', 'maxlength']">
	 *       Your email must be between 5 and 100 characters long
	 *     </div>
	 *   </div>
	 * ```
	 *
	 * Feel free to use other structural directives such as ng-if and ng-switch to further control
	 * what messages are active and when. Be careful, if you place ng-message on the same element
	 * as these structural directives, Angular may not be able to determine if a message is active
	 * or not. Therefore it is best to place the ng-message on a child element of the structural
	 * directive.
	 *
	 * ```html
	 * <div ng-messages="myForm.myEmail.$error" role="alert">
	 *   <div ng-if="showRequiredError">
	 *     <div ng-message="required">Please enter something</div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * ## Animations
	 * If the `ngAnimate` module is active within the application then the `ngMessages`, `ngMessage` and
	 * `ngMessageExp` directives will trigger animations whenever any messages are added and removed from
	 * the DOM by the `ngMessages` directive.
	 *
	 * Whenever the `ngMessages` directive contains one or more visible messages then the `.ng-active` CSS
	 * class will be added to the element. The `.ng-inactive` CSS class will be applied when there are no
	 * messages present. Therefore, CSS transitions and keyframes as well as JavaScript animations can
	 * hook into the animations whenever these classes are added/removed.
	 *
	 * Let's say that our HTML code for our messages container looks like so:
	 *
	 * ```html
	 * <div ng-messages="myMessages" class="my-messages" role="alert">
	 *   <div ng-message="alert" class="some-message">...</div>
	 *   <div ng-message="fail" class="some-message">...</div>
	 * </div>
	 * ```
	 *
	 * Then the CSS animation code for the message container looks like so:
	 *
	 * ```css
	 * .my-messages {
	 *   transition:1s linear all;
	 * }
	 * .my-messages.ng-active {
	 *   // messages are visible
	 * }
	 * .my-messages.ng-inactive {
	 *   // messages are hidden
	 * }
	 * ```
	 *
	 * Whenever an inner message is attached (becomes visible) or removed (becomes hidden) then the enter
	 * and leave animation is triggered for each particular element bound to the `ngMessage` directive.
	 *
	 * Therefore, the CSS code for the inner messages looks like so:
	 *
	 * ```css
	 * .some-message {
	 *   transition:1s linear all;
	 * }
	 *
	 * .some-message.ng-enter {}
	 * .some-message.ng-enter.ng-enter-active {}
	 *
	 * .some-message.ng-leave {}
	 * .some-message.ng-leave.ng-leave-active {}
	 * ```
	 *
	 * {@link ngAnimate Click here} to learn how to use JavaScript animations or to learn more about ngAnimate.
	 */
	angular.module('ngMessages', [], function initAngularHelpers() {
	  // Access helpers from angular core.
	  // Do it inside a `config` block to ensure `window.angular` is available.
	  forEach = angular.forEach;
	  isArray = angular.isArray;
	  isString = angular.isString;
	  jqLite = angular.element;
	})
	
	  /**
	   * @ngdoc directive
	   * @module ngMessages
	   * @name ngMessages
	   * @restrict AE
	   *
	   * @description
	   * `ngMessages` is a directive that is designed to show and hide messages based on the state
	   * of a key/value object that it listens on. The directive itself complements error message
	   * reporting with the `ngModel` $error object (which stores a key/value state of validation errors).
	   *
	   * `ngMessages` manages the state of internal messages within its container element. The internal
	   * messages use the `ngMessage` directive and will be inserted/removed from the page depending
	   * on if they're present within the key/value object. By default, only one message will be displayed
	   * at a time and this depends on the prioritization of the messages within the template. (This can
	   * be changed by using the `ng-messages-multiple` or `multiple` attribute on the directive container.)
	   *
	   * A remote template can also be used to promote message reusability and messages can also be
	   * overridden.
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * @param {string} ngMessages an angular expression evaluating to a key/value object
	   *                 (this is typically the $error object on an ngModel instance).
	   * @param {string=} ngMessagesMultiple|multiple when set, all messages will be displayed with true
	   *
	   * @example
	   * <example name="ngMessages-directive" module="ngMessagesExample"
	   *          deps="angular-messages.js"
	   *          animations="true" fixBase="true">
	   *   <file name="index.html">
	   *     <form name="myForm">
	   *       <label>
	   *         Enter your name:
	   *         <input type="text"
	   *                name="myName"
	   *                ng-model="name"
	   *                ng-minlength="5"
	   *                ng-maxlength="20"
	   *                required />
	   *       </label>
	   *       <pre>myForm.myName.$error = {{ myForm.myName.$error | json }}</pre>
	   *
	   *       <div ng-messages="myForm.myName.$error" style="color:maroon" role="alert">
	   *         <div ng-message="required">You did not enter a field</div>
	   *         <div ng-message="minlength">Your field is too short</div>
	   *         <div ng-message="maxlength">Your field is too long</div>
	   *       </div>
	   *     </form>
	   *   </file>
	   *   <file name="script.js">
	   *     angular.module('ngMessagesExample', ['ngMessages']);
	   *   </file>
	   * </example>
	   */
	  .directive('ngMessages', ['$animate', function($animate) {
	    var ACTIVE_CLASS = 'ng-active';
	    var INACTIVE_CLASS = 'ng-inactive';
	
	    return {
	      require: 'ngMessages',
	      restrict: 'AE',
	      controller: ['$element', '$scope', '$attrs', function NgMessagesCtrl($element, $scope, $attrs) {
	        var ctrl = this;
	        var latestKey = 0;
	        var nextAttachId = 0;
	
	        this.getAttachId = function getAttachId() { return nextAttachId++; };
	
	        var messages = this.messages = {};
	        var renderLater, cachedCollection;
	
	        this.render = function(collection) {
	          collection = collection || {};
	
	          renderLater = false;
	          cachedCollection = collection;
	
	          // this is true if the attribute is empty or if the attribute value is truthy
	          var multiple = isAttrTruthy($scope, $attrs.ngMessagesMultiple) ||
	                         isAttrTruthy($scope, $attrs.multiple);
	
	          var unmatchedMessages = [];
	          var matchedKeys = {};
	          var messageItem = ctrl.head;
	          var messageFound = false;
	          var totalMessages = 0;
	
	          // we use != instead of !== to allow for both undefined and null values
	          while (messageItem != null) {
	            totalMessages++;
	            var messageCtrl = messageItem.message;
	
	            var messageUsed = false;
	            if (!messageFound) {
	              forEach(collection, function(value, key) {
	                if (!messageUsed && truthy(value) && messageCtrl.test(key)) {
	                  // this is to prevent the same error name from showing up twice
	                  if (matchedKeys[key]) return;
	                  matchedKeys[key] = true;
	
	                  messageUsed = true;
	                  messageCtrl.attach();
	                }
	              });
	            }
	
	            if (messageUsed) {
	              // unless we want to display multiple messages then we should
	              // set a flag here to avoid displaying the next message in the list
	              messageFound = !multiple;
	            } else {
	              unmatchedMessages.push(messageCtrl);
	            }
	
	            messageItem = messageItem.next;
	          }
	
	          forEach(unmatchedMessages, function(messageCtrl) {
	            messageCtrl.detach();
	          });
	
	          if (unmatchedMessages.length !== totalMessages) {
	            $animate.setClass($element, ACTIVE_CLASS, INACTIVE_CLASS);
	          } else {
	            $animate.setClass($element, INACTIVE_CLASS, ACTIVE_CLASS);
	          }
	        };
	
	        $scope.$watchCollection($attrs.ngMessages || $attrs['for'], ctrl.render);
	
	        // If the element is destroyed, proactively destroy all the currently visible messages
	        $element.on('$destroy', function() {
	          forEach(messages, function(item) {
	            item.message.detach();
	          });
	        });
	
	        this.reRender = function() {
	          if (!renderLater) {
	            renderLater = true;
	            $scope.$evalAsync(function() {
	              if (renderLater && cachedCollection) {
	                ctrl.render(cachedCollection);
	              }
	            });
	          }
	        };
	
	        this.register = function(comment, messageCtrl) {
	          var nextKey = latestKey.toString();
	          messages[nextKey] = {
	            message: messageCtrl
	          };
	          insertMessageNode($element[0], comment, nextKey);
	          comment.$$ngMessageNode = nextKey;
	          latestKey++;
	
	          ctrl.reRender();
	        };
	
	        this.deregister = function(comment) {
	          var key = comment.$$ngMessageNode;
	          delete comment.$$ngMessageNode;
	          removeMessageNode($element[0], comment, key);
	          delete messages[key];
	          ctrl.reRender();
	        };
	
	        function findPreviousMessage(parent, comment) {
	          var prevNode = comment;
	          var parentLookup = [];
	
	          while (prevNode && prevNode !== parent) {
	            var prevKey = prevNode.$$ngMessageNode;
	            if (prevKey && prevKey.length) {
	              return messages[prevKey];
	            }
	
	            // dive deeper into the DOM and examine its children for any ngMessage
	            // comments that may be in an element that appears deeper in the list
	            if (prevNode.childNodes.length && parentLookup.indexOf(prevNode) === -1) {
	              parentLookup.push(prevNode);
	              prevNode = prevNode.childNodes[prevNode.childNodes.length - 1];
	            } else if (prevNode.previousSibling) {
	              prevNode = prevNode.previousSibling;
	            } else {
	              prevNode = prevNode.parentNode;
	              parentLookup.push(prevNode);
	            }
	          }
	        }
	
	        function insertMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	          if (!ctrl.head) {
	            ctrl.head = messageNode;
	          } else {
	            var match = findPreviousMessage(parent, comment);
	            if (match) {
	              messageNode.next = match.next;
	              match.next = messageNode;
	            } else {
	              messageNode.next = ctrl.head;
	              ctrl.head = messageNode;
	            }
	          }
	        }
	
	        function removeMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	
	          var match = findPreviousMessage(parent, comment);
	          if (match) {
	            match.next = messageNode.next;
	          } else {
	            ctrl.head = messageNode.next;
	          }
	        }
	      }]
	    };
	
	    function isAttrTruthy(scope, attr) {
	     return (isString(attr) && attr.length === 0) || //empty attribute
	            truthy(scope.$eval(attr));
	    }
	
	    function truthy(val) {
	      return isString(val) ? val.length : !!val;
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessagesInclude
	   * @restrict AE
	   * @scope
	   *
	   * @description
	   * `ngMessagesInclude` is a directive with the purpose to import existing ngMessage template
	   * code from a remote template and place the downloaded template code into the exact spot
	   * that the ngMessagesInclude directive is placed within the ngMessages container. This allows
	   * for a series of pre-defined messages to be reused and also allows for the developer to
	   * determine what messages are overridden due to the placement of the ngMessagesInclude directive.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-messages-include="remoteTplString">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-messages-include src="expressionValue1">...</ng-messages-include>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {string} ngMessagesInclude|src a string value corresponding to the remote template.
	   */
	  .directive('ngMessagesInclude',
	    ['$templateRequest', '$document', '$compile', function($templateRequest, $document, $compile) {
	
	    return {
	      restrict: 'AE',
	      require: '^^ngMessages', // we only require this for validation sake
	      link: function($scope, element, attrs) {
	        var src = attrs.ngMessagesInclude || attrs.src;
	        $templateRequest(src).then(function(html) {
	          if ($scope.$$destroyed) return;
	
	          if (isString(html) && !html.trim()) {
	            // Empty template - nothing to compile
	            replaceElementWithMarker(element, src);
	          } else {
	            // Non-empty template - compile and link
	            $compile(html)($scope, function(contents) {
	              element.after(contents);
	              replaceElementWithMarker(element, src);
	            });
	          }
	        });
	      }
	    };
	
	    // Helpers
	    function replaceElementWithMarker(element, src) {
	      // A comment marker is placed for debugging purposes
	      var comment = $compile.$$createComment ?
	          $compile.$$createComment('ngMessagesInclude', src) :
	          $document[0].createComment(' ngMessagesInclude: ' + src + ' ');
	      var marker = jqLite(comment);
	      element.after(marker);
	
	      // Don't pollute the DOM anymore by keeping an empty directive element
	      element.remove();
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessage
	   * @restrict AE
	   * @scope
	   *
	   * @description
	   * `ngMessage` is a directive with the purpose to show and hide a particular message.
	   * For `ngMessage` to operate, a parent `ngMessages` directive on a parent DOM element
	   * must be situated since it determines which messages are visible based on the state
	   * of the provided key/value map that `ngMessages` listens on.
	   *
	   * More information about using `ngMessage` can be found in the
	   * {@link module:ngMessages `ngMessages` module documentation}.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * @param {expression} ngMessage|when a string value corresponding to the message key.
	   */
	  .directive('ngMessage', ngMessageDirectiveFactory())
	
	
	  /**
	   * @ngdoc directive
	   * @name ngMessageExp
	   * @restrict AE
	   * @priority 1
	   * @scope
	   *
	   * @description
	   * `ngMessageExp` is the same as {@link directive:ngMessage `ngMessage`}, but instead of a static
	   * value, it accepts an expression to be evaluated for the message key.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression">
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression">
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {expression} ngMessageExp|whenExp an expression value corresponding to the message key.
	   */
	  .directive('ngMessageExp', ngMessageDirectiveFactory());
	
	function ngMessageDirectiveFactory() {
	  return ['$animate', function($animate) {
	    return {
	      restrict: 'AE',
	      transclude: 'element',
	      priority: 1, // must run before ngBind, otherwise the text is set on the comment
	      terminal: true,
	      require: '^^ngMessages',
	      link: function(scope, element, attrs, ngMessagesCtrl, $transclude) {
	        var commentNode = element[0];
	
	        var records;
	        var staticExp = attrs.ngMessage || attrs.when;
	        var dynamicExp = attrs.ngMessageExp || attrs.whenExp;
	        var assignRecords = function(items) {
	          records = items
	              ? (isArray(items)
	                  ? items
	                  : items.split(/[\s,]+/))
	              : null;
	          ngMessagesCtrl.reRender();
	        };
	
	        if (dynamicExp) {
	          assignRecords(scope.$eval(dynamicExp));
	          scope.$watchCollection(dynamicExp, assignRecords);
	        } else {
	          assignRecords(staticExp);
	        }
	
	        var currentElement, messageCtrl;
	        ngMessagesCtrl.register(commentNode, messageCtrl = {
	          test: function(name) {
	            return contains(records, name);
	          },
	          attach: function() {
	            if (!currentElement) {
	              $transclude(function(elm, newScope) {
	                $animate.enter(elm, null, element);
	                currentElement = elm;
	
	                // Each time we attach this node to a message we get a new id that we can match
	                // when we are destroying the node later.
	                var $$attachId = currentElement.$$attachId = ngMessagesCtrl.getAttachId();
	
	                // in the event that the element or a parent element is destroyed
	                // by another structural directive then it's time
	                // to deregister the message from the controller
	                currentElement.on('$destroy', function() {
	                  if (currentElement && currentElement.$$attachId === $$attachId) {
	                    ngMessagesCtrl.deregister(commentNode);
	                    messageCtrl.detach();
	                  }
	                  newScope.$destroy();
	                });
	              });
	            }
	          },
	          detach: function() {
	            if (currentElement) {
	              var elm = currentElement;
	              currentElement = null;
	              $animate.leave(elm);
	            }
	          }
	        });
	      }
	    };
	  }];
	
	  function contains(collection, key) {
	    if (collection) {
	      return isArray(collection)
	          ? collection.indexOf(key) >= 0
	          : collection.hasOwnProperty(key);
	    }
	  }
	}
	
	
	})(window, window.angular);


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * angular-permission
	 * Fully featured role and permission based access control for your angular applications
	 * @version v5.2.1 - 2017-02-02
	 * @link https://github.com/Narzerus/angular-permission
	 * @author Rafael Vidaurre <narzerus@gmail.com> (http://www.rafaelvidaurre.com), Blazej Krysiak <blazej.krysiak@gmail.com>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	(function () {
	  'use strict';
	
	  var permission = __webpack_require__(385),
	    ngPermission = __webpack_require__(386),
	    uiPermission = __webpack_require__(387);
	
	  module.exports = {
	    permission: permission,
	    ngPermission: ngPermission,
	    uiPermission: uiPermission
	  };
	})();


/***/ },
/* 385 */
/***/ function(module, exports) {

	/**
	 * angular-permission
	 * Fully featured role and permission based access control for your angular applications
	 * @version v5.2.1 - 2017-02-02
	 * @link https://github.com/Narzerus/angular-permission
	 * @author Rafael Vidaurre <narzerus@gmail.com> (http://www.rafaelvidaurre.com), Blazej Krysiak <blazej.krysiak@gmail.com>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	(function (window, angular, undefined) {
	  'use strict';
	
	  /**
	   * @namespace permission
	   */
	
	  $q.$inject = ['$delegate'];
	  PermPermission.$inject = ['$q', '$injector', 'PermTransitionProperties'];
	  PermRole.$inject = ['$q', '$injector', 'PermPermissionStore', 'PermTransitionProperties'];
	  PermPermissionStore.$inject = ['PermPermission'];
	  PermRoleStore.$inject = ['PermRole'];
	  PermissionDirective.$inject = ['$log', '$injector', 'PermPermissionMap', 'PermPermissionStrategies'];
	  PermAuthorization.$inject = ['$q'];
	  PermPermissionMap.$inject = ['$q', '$log', '$injector', 'PermTransitionProperties', 'PermRoleStore', 'PermPermissionStore'];
	  var permission = angular.module('permission', []);
	
	  if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
	    module.exports = permission.name;
	  }
	
	  /**
	   * Extends $q implementation by A+ *any* method
	   * @name permission.$q
	   *
	   * @extends {angular.$q}
	   *
	   * @param $delegate {Object} Parent instance being extended
	   */
	  function $q($delegate) {
	    'ngInject';
	
	    $delegate.any = any;
	
	    /**
	     * Implementation of missing $q `any` method that wits for first resolution of provided promise set
	     * @methodOf permission.$q
	     *
	     * @param promises {Array|promise} Single or set of promises
	     *
	     * @returns {Promise} Returns a single promise that will be rejected with an array/hash of values,
	     *  each value corresponding to the promise at the same index/key in the `promises` array/hash.
	     *  If any of the promises is resolved, this resulting promise will be returned
	     *  with the same resolution value.
	     */
	    function any(promises) {
	      var deferred = $delegate.defer(),
	        counter = 0,
	        results = angular.isArray(promises) ? [] : {};
	
	      angular.forEach(promises, function (promise, key) {
	        counter++;
	        $delegate
	          .when(promise)
	          .then(function (value) {
	            deferred.resolve(value);
	          })
	          .catch(function (reason) {
	            results[key] = reason;
	            if (!(--counter)) {
	              deferred.reject(reason);
	            }
	          });
	      });
	
	      if (counter === 0) {
	        deferred.reject(results);
	      }
	
	      return deferred.promise;
	    }
	
	    return $delegate;
	  }
	
	  angular
	    .module('permission')
	    .decorator('$q', $q);
	
	
	  /**
	   * Pre-defined available configurable behaviours of directive `permission`
	   * @name permission.PermPermissionStrategies
	   * @readonly
	   *
	   * @example
	   * <div permission
	   *      permission-except="'MANAGER'"
	   *      permission-on-authorized="PermPermissionStrategies.renderContent"
	   *      permission-on-unauthorized="PermPermissionStrategies.removeContent">
	   * </div>
	   *
	   * @property enableElement {Function}
	   * @property disableElement {Function}
	   * @property showElement {Function}
	   * @property hideElement {Function}
	   */
	  var PermPermissionStrategies = {
	    enableElement: function ($element) {
	      $element.removeAttr('disabled');
	    },
	    disableElement: function ($element) {
	      $element.attr('disabled', 'disabled');
	    },
	    showElement: function ($element) {
	      $element.removeClass('ng-hide');
	    },
	    hideElement: function ($element) {
	      $element.addClass('ng-hide');
	    }
	  };
	
	  angular
	    .module('permission')
	    .value('PermPermissionStrategies', PermPermissionStrategies)
	    .value('PermissionStrategies', PermPermissionStrategies);
	
	
	  /**
	   * Helper object used for storing ui-router/ng-route transition parameters
	   * @name permission.PermTransitionProperties
	   *
	   * @type {Object.<String,Object>}
	   *
	   * Transition properties for ui-router:
	   * @property toState {Object} Target state object [ui-router]
	   * @property toParams {Object} Target state params [ui-router]
	   * @property fromState {Object} Source state object [ui-router]
	   * @property fromParams {Object} Source state params [ui-router]
	   * @property options {Object} Transition options [ui-router]
	   *
	   * Transition properties for ng-route:
	   * @property current {Object} Current state properties [ng-route]
	   * @property next {Object} Next state properties [ng-route]
	   */
	  var PermTransitionProperties = {};
	
	  angular
	    .module('permission')
	    .value('PermTransitionProperties', PermTransitionProperties);
	
	  /**
	   * Interface responsible for managing and emitting events dependent on router implementation
	   * @name permission.PermTransitionEvents
	   */
	  function PermTransitionEvents() {
	    'ngInject';
	
	    this.broadcastPermissionStartEvent = function () {
	      throw new Error('Method broadcastPermissionStartEvent in PermTransitionEvents interface must be implemented');
	    };
	
	    this.broadcastPermissionAcceptedEvent = function () {
	      throw new Error('Method broadcastPermissionAcceptedEvent in PermTransitionEvents interface must be implemented');
	    };
	
	    this.broadcastPermissionDeniedEvent = function () {
	      throw new Error('Method broadcastPermissionDeniedEvent in PermTransitionEvents interface must be implemented');
	    };
	  }
	
	  angular
	    .module('permission')
	    .service('PermTransitionEvents', PermTransitionEvents);
	
	
	  /**
	   * PermPermission definition factory
	   * @function
	   *
	   * @param $q {Object} Angular promise implementation
	   * @param $injector {Object} Dependency injection instance
	   * @param PermTransitionProperties {permission.PermTransitionProperties} Helper storing ui-router transition parameters
	   *
	   * @return {Permission}
	   */
	  function PermPermission($q, $injector, PermTransitionProperties) {
	    'ngInject';
	
	    /**
	     * PermPermission definition object constructor
	     * @constructor Permission
	     *
	     * @param permissionName {String} Name repressing permission
	     * @param validationFunction {Function} Function used to check if permission is valid
	     */
	    function Permission(permissionName, validationFunction) {
	      validateConstructor(permissionName, validationFunction);
	
	      this.permissionName = permissionName;
	      this.validationFunction = annotateValidationFunction(validationFunction);
	    }
	
	    /**
	     * Checks if permission is still valid
	     * @methodOf permission.Permission
	     *
	     * @returns {Promise}
	     */
	    Permission.prototype.validatePermission = function () {
	      var validationLocals = {
	        permissionName: this.permissionName,
	        transitionProperties: PermTransitionProperties
	      };
	      var validationResult = $injector.invoke(this.validationFunction, null, validationLocals);
	
	      if (!angular.isFunction(validationResult.then)) {
	        validationResult = wrapInPromise(validationResult, this.permissionName);
	      }
	
	      return validationResult;
	    };
	
	    /**
	     * Converts a value into a promise, if the value is truthy it resolves it, otherwise it rejects it
	     * @methodOf permission.Permission
	     * @private
	     *
	     * @param result {Boolean} Function to be wrapped into promise
	     * @param permissionName {String} Returned value in promise
	     *
	     * @return {Promise}
	     */
	    function wrapInPromise(result, permissionName) {
	      if (result) {
	        return $q.resolve(permissionName);
	      }
	
	      return $q.reject(permissionName);
	    }
	
	    /**
	     * Checks if provided permission has accepted parameter types
	     * @methodOf permission.Permission
	     * @private
	     *
	     * @throws {TypeError}
	     *
	     * @param permissionName {String} Name repressing permission
	     * @param validationFunction {Function} Function used to check if permission is valid
	     */
	    function validateConstructor(permissionName, validationFunction) {
	      if (!angular.isString(permissionName)) {
	        throw new TypeError('Parameter "permissionName" name must be String');
	      }
	      if (!angular.isFunction(validationFunction) && !angular.isArray(validationFunction)) {
	        throw new TypeError('Parameter "validationFunction" must be Function or an injectable Function using explicit annotation');
	      }
	    }
	
	    /**
	     * Ensures the validation is injectable using explicit annotation.
	     * Wraps a non-injectable function for backwards compatibility
	     * @methodOf permission.Permission
	     * @private
	     *
	     * @param validationFunction {Function} Function to wrap with injectable if needed
	     *
	     * @return {Function} Explicitly injectable function
	     */
	    function annotateValidationFunction(validationFunction) {
	      if (!angular.isArray(validationFunction.$inject || validationFunction)) {
	        // The function is not explicitly annotated, so assume using old-style parameters
	        // and manually prepare for injection using our known old API parameters
	        validationFunction = ['permissionName', 'transitionProperties', validationFunction];
	      }
	
	      return validationFunction;
	    }
	
	    return Permission;
	  }
	
	  angular
	    .module('permission')
	    .factory('PermPermission', PermPermission);
	
	  /**
	   * Role definition factory
	   * @function
	   *
	   * @param $q {Object} Angular promise implementation
	   * @param $injector {Object} Dependency injection instance
	   * @param PermPermissionStore {permission.PermPermissionStore} Permission definition storage
	   * @param PermTransitionProperties {permission.PermTransitionProperties} Helper storing ui-router transition parameters
	   *
	   * @return {Role}
	   */
	  function PermRole($q, $injector, PermPermissionStore, PermTransitionProperties) {
	    'ngInject';
	
	    /**
	     * Role definition constructor
	     * @constructor Role
	     *
	     * @param roleName {String} Name representing role
	     * @param validationFunction {Function|Array<String>} Optional function used to validate if permissions are still
	     *   valid or list of permission names representing role
	     */
	    function Role(roleName, validationFunction) {
	      validateConstructor(roleName, validationFunction);
	
	      this.roleName = roleName;
	      this.validationFunction = annotateValidationFunction(validationFunction);
	    }
	
	    /**
	     * Checks if role is still valid
	     * @methodOf permission.Role
	     *
	     * @returns {Promise} $q.promise object
	     */
	    Role.prototype.validateRole = function () {
	      var validationLocals = {
	        roleName: this.roleName,
	        transitionProperties: PermTransitionProperties
	      };
	      var validationResult = $injector.invoke(this.validationFunction, null, validationLocals);
	
	      if (!angular.isFunction(validationResult.then)) {
	        validationResult = wrapInPromise(validationResult, this.roleName);
	      }
	
	      return validationResult;
	    };
	
	    /**
	     * Converts a value into a promise, if the value is truthy it resolves it, otherwise it rejects it
	     * @methodOf permission.Role
	     * @private
	     *
	     * @param result {Boolean} Function to be wrapped into promise
	     * @param [roleName] {String} Returned value in promise
	     *
	     * @return {Promise}
	     */
	    function wrapInPromise(result, roleName) {
	      if (result) {
	        return $q.resolve(roleName);
	      }
	
	      return $q.reject(roleName);
	    }
	
	    /**
	     * Checks if provided permission has accepted parameter types
	     * @methodOf permission.Role
	     * @private
	     *
	     * @throws {TypeError}
	     *
	     * @param roleName {String} Name representing role
	     * @param validationFunction {Function|Array<String>} Optional function used to validate if permissions are still
	     *   valid or list of permission names representing role
	     */
	    function validateConstructor(roleName, validationFunction) {
	      if (!angular.isString(roleName)) {
	        throw new TypeError('Parameter "roleName" name must be String');
	      }
	
	      if (!angular.isArray(validationFunction) && !angular.isFunction(validationFunction)) {
	        throw new TypeError('Parameter "validationFunction" must be array or function');
	      }
	    }
	
	
	    /**
	     * Ensures the validation is injectable using explicit annotation.
	     * Wraps a non-injectable function for backwards compatibility
	     * @methodOf permission.Role
	     * @private
	     *
	     * @param validationFunction {Function|Array} Function to wrap with injectable if needed
	     *
	     * @return {Function} Explicitly injectable function
	     */
	    function annotateValidationFunction(validationFunction) {
	      // Test if the validation function is just an array of permission names
	      if (angular.isArray(validationFunction) && !angular.isFunction(validationFunction[validationFunction.length - 1])) {
	        validationFunction = preparePermissionEvaluation(validationFunction);
	      } else if (!angular.isArray(validationFunction.$inject || validationFunction)) {
	        // The function is not explicitly annotated, so assume using old-style parameters
	        // and manually prepare for injection using our known old API parameters
	        validationFunction = ['roleName', 'transitionProperties', validationFunction];
	      }
	
	      return validationFunction;
	    }
	
	    /**
	     * Creates an injectable function that evaluates a set of permissions in place of a role validation function
	     * @methodOf permission.Role
	     * @private
	     *
	     * @param permissions {Array<String>} List of permissions to evaluate
	     *
	     * @return {Function}
	     */
	    function preparePermissionEvaluation(permissions) {
	      return function () {
	        var promises = permissions.map(function (permissionName) {
	          if (PermPermissionStore.hasPermissionDefinition(permissionName)) {
	            var permission = PermPermissionStore.getPermissionDefinition(permissionName);
	
	            return permission.validatePermission();
	          }
	
	          return $q.reject(permissionName);
	        });
	
	        return $q.all(promises);
	      };
	    }
	
	    return Role;
	  }
	
	  angular
	    .module('permission')
	    .factory('PermRole', PermRole);
	
	  /**
	   * Permission definition storage
	   * @name permission.PermPermissionStore
	   *
	   * @param PermPermission {permission.PermPermission|Function}
	   */
	  function PermPermissionStore(PermPermission) {
	    'ngInject';
	
	    /**
	     * @property permissionStore
	     *
	     * @type {Object}
	     */
	    var permissionStore = {};
	
	    this.definePermission = definePermission;
	    this.defineManyPermissions = defineManyPermissions;
	    this.removePermissionDefinition = removePermissionDefinition;
	    this.hasPermissionDefinition = hasPermissionDefinition;
	    this.getPermissionDefinition = getPermissionDefinition;
	    this.getStore = getStore;
	    this.clearStore = clearStore;
	
	    /**
	     * Allows to define permission on application configuration
	     * @methodOf permission.PermPermissionStore
	     *
	     * @param permissionName {String} Name of defined permission
	     * @param validationFunction {Function} Function used to validate if permission is valid
	     */
	    function definePermission(permissionName, validationFunction) {
	      permissionStore[permissionName] = new PermPermission(permissionName, validationFunction);
	    }
	
	    /**
	     * Allows to define set of permissionNames with shared validation function on application configuration
	     * @methodOf permission.PermPermissionStore
	     * @throws {TypeError}
	     *
	     * @param permissionNames {Array<Number>} Set of permission names
	     * @param validationFunction {Function} Function used to validate if permission is valid
	     */
	    function defineManyPermissions(permissionNames, validationFunction) {
	      if (!angular.isArray(permissionNames)) {
	        throw new TypeError('Parameter "permissionNames" name must be Array');
	      }
	
	      angular.forEach(permissionNames, function (permissionName) {
	        definePermission(permissionName, validationFunction);
	      });
	    }
	
	    /**
	     * Deletes permission
	     * @methodOf permission.PermPermissionStore
	     *
	     * @param permissionName {String} Name of defined permission
	     */
	    function removePermissionDefinition(permissionName) {
	      delete permissionStore[permissionName];
	    }
	
	    /**
	     * Checks if permission exists
	     * @methodOf permission.PermPermissionStore
	     *
	     * @param permissionName {String} Name of defined permission
	     * @returns {Boolean}
	     */
	    function hasPermissionDefinition(permissionName) {
	      return angular.isDefined(permissionStore[permissionName]);
	    }
	
	    /**
	     * Returns permission by it's name
	     * @methodOf permission.PermPermissionStore
	     *
	     * @returns {permission.Permission} Permissions definition object
	     */
	    function getPermissionDefinition(permissionName) {
	      return permissionStore[permissionName];
	    }
	
	    /**
	     * Returns all permissions
	     * @methodOf permission.PermPermissionStore
	     *
	     * @returns {Object} Permissions collection
	     */
	    function getStore() {
	      return permissionStore;
	    }
	
	    /**
	     * Removes all permissions
	     * @methodOf permission.PermPermissionStore
	     */
	    function clearStore() {
	      permissionStore = {};
	    }
	  }
	
	  angular
	    .module('permission')
	    .service('PermPermissionStore', PermPermissionStore);
	
	
	  /**
	   * Role definition storage
	   * @name permission.PermRoleStore
	   *
	   * @param PermRole {permission.PermRole} Role definition constructor
	   */
	  function PermRoleStore(PermRole) {
	    'ngInject';
	
	    var roleStore = {};
	
	    this.defineRole = defineRole;
	    this.defineManyRoles = defineManyRoles;
	    this.getRoleDefinition = getRoleDefinition;
	    this.hasRoleDefinition = hasRoleDefinition;
	    this.removeRoleDefinition = removeRoleDefinition;
	    this.getStore = getStore;
	    this.clearStore = clearStore;
	
	    /**
	     * Allows to add single role definition to the store by providing it's name and validation function
	     * @methodOf permission.PermRoleStore
	     *
	     * @param roleName {String} Name of defined role
	     * @param [validationFunction] {Function|Array<String>} Function used to validate if role is valid or set of
	     *   permission names that has to be owned to have a role
	     */
	    function defineRole(roleName, validationFunction) {
	      roleStore[roleName] = new PermRole(roleName, validationFunction);
	    }
	
	    /**
	     * Allows to define set of roleNames with shared validation function
	     * @methodOf permission.PermPermissionStore
	     * @throws {TypeError}
	     *
	     * @param roleMap {String, Function|Array<String>} Map of roles with matching validators
	     */
	    function defineManyRoles(roleMap) {
	      if (!angular.isObject(roleMap)) {
	        throw new TypeError('Parameter "roleNames" name must be object');
	      }
	
	      angular.forEach(roleMap, function (validationFunction, roleName) {
	        defineRole(roleName, validationFunction);
	      });
	    }
	
	    /**
	     * Deletes role from store
	     * @method permission.PermRoleStore
	     *
	     * @param roleName {String} Name of defined permission
	     */
	    function removeRoleDefinition(roleName) {
	      delete roleStore[roleName];
	    }
	
	    /**
	     * Checks if role is defined in store
	     * @method permission.PermRoleStore
	     *
	     * @param roleName {String} Name of role
	     * @returns {Boolean}
	     */
	    function hasRoleDefinition(roleName) {
	      return angular.isDefined(roleStore[roleName]);
	    }
	
	    /**
	     * Returns role definition object by it's name
	     * @method permission.PermRoleStore
	     *
	     * @returns {permission.PermRole} PermRole definition object
	     */
	    function getRoleDefinition(roleName) {
	      return roleStore[roleName];
	    }
	
	    /**
	     * Returns all role definitions
	     * @method permission.PermRoleStore
	     *
	     * @returns {Object} Defined roles collection
	     */
	    function getStore() {
	      return roleStore;
	    }
	
	    /**
	     * Removes all role definitions
	     * @method permission.PermRoleStore
	     */
	    function clearStore() {
	      roleStore = {};
	    }
	  }
	
	  angular
	    .module('permission')
	    .service('PermRoleStore', PermRoleStore);
	
	  /**
	   * Handles authorization based on provided permissions/roles.
	   * @name permission.permissionDirective
	   *
	   * Directive accepts single or combined attributes `permission-only` and `permission-except` that checks on
	   * DOM rendering if permissions/roles are met. Attributes can be passed either as String, Array or variable from
	   * parent scope. Directive also will watch for changes if applied and automatically update the view.
	   *
	   * @example
	   * <div permission
	   *      permission-only="'USER'">
	   * </div>
	   * <div permission
	   *      permission-only="['USER','ADMIN']"
	   *      permission-except="'MANAGER'">
	   * </div>
	   * <div permission permission-sref="'app.login'"></div>
	   *
	   * By default directive will show/hide elements if provided permissions matches.
	   * You can override this behaviour by passing `permission-on-authorized` and `permission-on-unauthorized`
	   *   attributes that will pass to your function `$element` as argument that you can freely manipulate your DOM
	   *   behaviour.
	   *
	   * Important! Function should be as references - `vm.disableElement` not `vm.disableElement()` to be able to
	   *   accept passed $element reference from inside of permissionDirective
	   *
	   * @example
	   * <div permission
	   *      permission-only="['USER','ADMIN']"
	   *      permission-on-authorized="PermPermissionStrategies.disableElement"
	   *      permission-on-unauthorized="PermPermissionStrategies.enableElement">
	   * </div>
	   *
	   * @param $log {Object} Logging service
	   * @param $injector {Object} Injector instance object
	   * @param PermPermissionMap {permission.permPermissionMap|Function} Map of state access rights
	   * @param PermPermissionStrategies {permission.permPermissionStrategies} Set of pre-defined directive behaviours
	   *
	   * @returns {{
	   *   restrict: string,
	   *   bindToController: {
	   *     sref: string
	   *     only: string,
	   *     except: string,
	   *     onAuthorized: function,
	   *     onUnauthorized: function
	   *   },
	   *   controllerAs: string,
	   *   controller: controller
	   * }} Directive instance
	   */
	  function PermissionDirective($log, $injector, PermPermissionMap, PermPermissionStrategies) {
	    'ngInject';
	
	    return {
	      restrict: 'A',
	      bindToController: {
	        sref: '=?permissionSref',
	        only: '=?permissionOnly',
	        except: '=?permissionExcept',
	        onAuthorized: '&?permissionOnAuthorized',
	        onUnauthorized: '&?permissionOnUnauthorized'
	      },
	      controllerAs: 'permission',
	      controller: ['$scope', '$element', function ($scope, $element) {
	        var permission = this;
	
	        $scope.$watchGroup(['permission.only', 'permission.except', 'sref'],
	          function () {
	            try {
	              if (isSrefStateDefined()) {
	                var PermStateAuthorization = $injector.get('PermStateAuthorization');
	
	                PermStateAuthorization
	                  .authorizeByStateName(permission.sref)
	                  .then(function () {
	                    onAuthorizedAccess();
	                  })
	                  .catch(function () {
	                    onUnauthorizedAccess();
	                  });
	              } else {
	                var PermAuthorization = $injector.get('PermAuthorization');
	                var permissionMap = new PermPermissionMap({
	                  only: permission.only,
	                  except: permission.except
	                });
	
	                PermAuthorization
	                  .authorizeByPermissionMap(permissionMap)
	                  .then(function () {
	                    onAuthorizedAccess();
	                  })
	                  .catch(function () {
	                    onUnauthorizedAccess();
	                  });
	              }
	            } catch (e) {
	              onUnauthorizedAccess();
	              $log.error(e.message);
	            }
	          });
	
	        /**
	         * Returns true when permissions should be checked based on state name
	         * @private
	         *
	         * @returns {boolean}
	         */
	        function isSrefStateDefined() {
	          return $injector.has('$state') && permission.sref;
	        }
	
	        /**
	         * Calls `onAuthorized` function if provided or show element
	         * @private
	         */
	        function onAuthorizedAccess() {
	          if (angular.isFunction(permission.onAuthorized)) {
	            permission.onAuthorized()($element);
	          } else {
	            PermPermissionStrategies.showElement($element);
	          }
	        }
	
	        /**
	         * Calls `onUnauthorized` function if provided or hide element
	         * @private
	         */
	        function onUnauthorizedAccess() {
	          if (angular.isFunction(permission.onUnauthorized)) {
	            permission.onUnauthorized()($element);
	          } else {
	            PermPermissionStrategies.hideElement($element);
	          }
	        }
	      }]
	    };
	  }
	
	  angular
	    .module('permission')
	    .directive('permission', PermissionDirective);
	
	
	  /**
	   * Service responsible for handling view based authorization
	   * @name permission.PermAuthorization
	   *
	   * @param $q {Object} Angular promise implementation
	   */
	  function PermAuthorization($q) {
	    'ngInject';
	
	    this.authorizeByPermissionMap = authorizeByPermissionMap;
	
	    /**
	     * Handles authorization based on provided permissions map
	     * @methodOf permission.PermAuthorization
	     *
	     * @param map {permission.PermissionMap} Map of permission names
	     *
	     * @returns {promise} $q.promise object
	     */
	    function authorizeByPermissionMap(map) {
	      var deferred = $q.defer();
	
	      resolveExceptPrivilegeMap(deferred, map);
	
	      return deferred.promise;
	    }
	
	    /**
	     * Resolves flat set of "except" privileges
	     * @methodOf permission.PermAuthorization
	     * @private
	     *
	     * @param deferred {Object} Promise defer
	     * @param map {permission.PermissionMap} Access rights map
	     *
	     */
	    function resolveExceptPrivilegeMap(deferred, map) {
	      var exceptPromises = map.resolvePropertyValidity(map.except);
	
	      $q.any(exceptPromises)
	        .then(function (rejectedPermissions) {
	          deferred.reject(rejectedPermissions);
	        })
	        .catch(function () {
	          resolveOnlyPermissionMap(deferred, map);
	        });
	    }
	
	    /**
	     * Resolves flat set of "only" privileges
	     * @methodOf permission.PermAuthorization
	     * @private
	     *
	     * @param deferred {Object} Promise defer
	     * @param map {permission.PermissionMap} Access rights map
	     */
	    function resolveOnlyPermissionMap(deferred, map) {
	      if (!map.only.length) {
	        deferred.resolve();
	        return;
	      }
	
	      var onlyPromises = map.resolvePropertyValidity(map.only);
	      $q.any(onlyPromises)
	        .then(function (resolvedPermissions) {
	          deferred.resolve(resolvedPermissions);
	        })
	        .catch(function (rejectedPermission) {
	          deferred.reject(rejectedPermission);
	        });
	    }
	  }
	
	  angular
	    .module('permission')
	    .service('PermAuthorization', PermAuthorization);
	
	
	  /**
	   * Access rights map factory
	   * @name permission.PermPermissionMap
	   *
	   * @param $q {Object} Angular promise implementation
	   * @param $log {Object} Angular logging utility
	   * @param $injector {Object} Dependency injection instance
	   * @param PermTransitionProperties {permission.PermTransitionProperties} Helper storing ui-router transition parameters
	   * @param PermRoleStore {permission.PermRoleStore} Role definition storage
	   * @param PermPermissionStore {permission.PermPermissionStore} Permission definition storage
	   *
	   * @return {permission.PermissionMap}
	   */
	  function PermPermissionMap($q, $log, $injector, PermTransitionProperties, PermRoleStore, PermPermissionStore) {
	    'ngInject';
	
	    /**
	     * Constructs map object instructing authorization service how to handle authorizing
	     * @constructor permission.PermissionMap
	     *
	     * @param [permissionMap] {Object} Map of permissions provided to authorization service
	     * @param [permissionMap.only] {String|Array|Function} List of exclusive access right names allowed for
	     *   authorization
	     * @param [permissionMap.except] {String|Array|Function} List of exclusive access right names denied for
	     *   authorization
	     * @param [permissionMap.redirectTo] {String|Function|Object|promise} Handling redirection when rejected
	     *   authorization
	     */
	    function PermissionMap(permissionMap) {
	      // Suppress not defined object errors
	      permissionMap = permissionMap || {};
	
	      this.only = normalizeOnlyAndExceptProperty(permissionMap.only);
	      this.except = normalizeOnlyAndExceptProperty(permissionMap.except);
	      this.redirectTo = normalizeRedirectToProperty(permissionMap.redirectTo);
	    }
	
	    /**
	     * Redirects to fallback states when permissions fail
	     * @methodOf permission.PermissionMap
	     *
	     * @param [rejectedPermissionName] {String} Permission name
	     *
	     * @return {Promise}
	     */
	    PermissionMap.prototype.resolveRedirectState = function (rejectedPermissionName) {
	
	      // If redirectTo definition is not found stay where you are
	      if (!angular.isDefined(this.redirectTo)) {
	        return $q.reject();
	      }
	
	      var redirectState = this.redirectTo[rejectedPermissionName] || this.redirectTo['default'];
	
	      return resolveRedirectState(redirectState, rejectedPermissionName);
	    };
	
	    /**
	     * Resolves weather permissions set for "only" or "except" property are valid
	     * @methodOf permission.PermissionMap
	     *
	     * @param property {Array} "only" or "except" map property
	     *
	     * @return {Array<Promise>}
	     */
	    PermissionMap.prototype.resolvePropertyValidity = function (property) {
	
	      return property.map(function (privilegeName) {
	        if (PermRoleStore.hasRoleDefinition(privilegeName)) {
	          var role = PermRoleStore.getRoleDefinition(privilegeName);
	          return role.validateRole();
	        }
	
	        if (PermPermissionStore.hasPermissionDefinition(privilegeName)) {
	          var permission = PermPermissionStore.getPermissionDefinition(privilegeName);
	          return permission.validatePermission();
	        }
	
	        $log.warn('Permission or role ' + privilegeName + ' was not defined.');
	        return $q.reject(privilegeName);
	      });
	    };
	
	    /**
	     * Handles function based redirection for rejected permissions
	     * @methodOf permission.PermissionMap
	     *
	     * @throws {TypeError}
	     *
	     * @param redirectFunction {Function} Redirection function
	     * @param rejectedPermissionName {String} Rejected permission
	     *
	     * @return {Promise}
	     */
	    function resolveRedirectState(redirectFunction, rejectedPermissionName) {
	      return $q
	        .when($injector.invoke(redirectFunction, null, {
	          rejectedPermission: rejectedPermissionName,
	          transitionProperties: PermTransitionProperties
	        }))
	        .then(function (redirectState) {
	          if (angular.isString(redirectState)) {
	            return {
	              state: redirectState
	            };
	          }
	
	          if (angular.isObject(redirectState)) {
	            return redirectState;
	          }
	
	          return $q.reject();
	        });
	    }
	
	    /**
	     * Handles extraction of permission map "only" and "except" properties and converts them into array objects
	     * @methodOf permission.PermissionMap
	     * @private
	     *
	     * @param property {String|Array|Function} PermPermission map property "only" or "except"
	     *
	     * @returns {Array<String>} Array of permission "only" or "except" names
	     */
	    function normalizeOnlyAndExceptProperty(property) {
	      if (angular.isString(property)) {
	        return [property];
	      }
	
	      if (angular.isArray(property)) {
	        return property;
	      }
	
	      if (angular.isFunction(property)) {
	        return property.call(null, PermTransitionProperties);
	      }
	
	      return [];
	    }
	
	    /**
	     * Convert user provided input into key value dictionary with permission/role name as a key and injectable resolver
	     * function as a value
	     * @methodOf permission.PermissionMap
	     * @private
	     *
	     * @param redirectTo {String|Function|Array|Object} PermPermission map property "redirectTo"
	     *
	     * @returns {Object<String, Object>} Redirection dictionary object
	     */
	    function normalizeRedirectToProperty(redirectTo) {
	      if (!angular.isDefined(redirectTo)) {
	        return;
	      }
	
	      if (isInjectable(redirectTo) || angular.isFunction(redirectTo)) {
	        return normalizeFunctionRedirectionRule(redirectTo);
	      }
	
	      if (angular.isObject(redirectTo)) {
	        if (isObjectSingleRedirectionRule(redirectTo)) {
	          return normalizeObjectSingleRedirectionRule(redirectTo);
	        }
	
	        return normalizeObjectMultipleRedirectionRule(redirectTo);
	      }
	
	      if (angular.isString(redirectTo)) {
	        return normalizeStringRedirectionRule(redirectTo);
	      }
	
	      throw new ReferenceError('Property "redirectTo" must be String, Function, Array or Object');
	    }
	
	    /**
	     * Convert string redirection rule into single-element redirection dictionary
	     * @methodOf permission.PermissionMap
	     * @private
	     *
	     * @param redirectTo {String} PermPermission map property "redirectTo"
	     *
	     * @returns {Object<String, Object>} Redirection dictionary object
	     */
	    function normalizeStringRedirectionRule(redirectTo) {
	      var redirectionMap = {};
	
	      redirectionMap.default = function () {
	        return {
	          state: redirectTo
	        };
	      };
	      redirectionMap.default.$inject = ['rejectedPermission', 'transitionProperties'];
	
	      return redirectionMap;
	    }
	
	    /**
	     * Checks if redirection object is single rule type
	     * @methodOf permission.PermissionMap
	     * @private
	     *
	     * @param redirectTo {Object} PermPermission map property "redirectTo"
	     *
	     * @returns {boolean}
	     */
	    function isObjectSingleRedirectionRule(redirectTo) {
	      return angular.isDefined(redirectTo.state);
	    }
	
	    /**
	     * Convert single redirection rule object into single-element redirection dictionary
	     * @methodOf permission.PermissionMap
	     * @private
	     *
	     * @param redirectTo {Object} PermPermission map property "redirectTo"
	     *
	     * @returns {Object<String, Object>} Redirection dictionary object
	     */
	    function normalizeObjectSingleRedirectionRule(redirectTo) {
	      var redirectionMap = {};
	
	      redirectionMap.default = function () {
	        return redirectTo;
	      };
	
	      return redirectionMap;
	    }
	
	    /**
	     * Convert multiple redirection rule object into redirection dictionary
	     * @methodOf permission.PermissionMap
	     * @private
	     *
	     * @param redirectTo {Object} PermPermission map property "redirectTo"
	     *
	     * @returns {Object<String, Object>} Redirection dictionary object
	     */
	    function normalizeObjectMultipleRedirectionRule(redirectTo) {
	      var redirectionMap = {};
	
	      angular.forEach(redirectTo, function (redirection, permission) {
	        if (isInjectable(redirection)) {
	          redirectionMap[permission] = redirection;
	        } else {
	          if (angular.isFunction(redirection)) {
	            redirectionMap[permission] = redirection;
	            redirectionMap[permission].$inject = [];
	          }
	        }
	
	        if (angular.isObject(redirection)) {
	          redirectionMap[permission] = function () {
	            return redirection;
	          };
	          redirectionMap[permission].$inject = [];
	        }
	
	        if (angular.isString(redirection)) {
	          redirectionMap[permission] = function () {
	            return {
	              state: redirection
	            };
	          };
	          redirectionMap[permission].$inject = [];
	        }
	      });
	
	      return redirectionMap;
	    }
	
	    /**
	     * Checks if property is injectable
	     * @methodOf permission.PermissionMap
	     * @private
	     *
	     * @param property {Array|Object}
	     *
	     * @returns {boolean}
	     */
	    function isInjectable(property) {
	      return angular.isArray(property) || (angular.isFunction(property) && angular.isArray(property.$inject));
	    }
	
	    /**
	     * Convert function redirection rule into redirection dictionary
	     * @methodOf permission.PermissionMap
	     * @private
	     *
	     * @param redirectTo {Function} PermPermission map property "redirectTo"
	     *
	     * @returns {Object<String, Object>} Redirection dictionary object
	     */
	    function normalizeFunctionRedirectionRule(redirectTo) {
	      var redirectionMap = {};
	
	      redirectionMap.default = redirectTo;
	
	      if (!angular.isDefined(redirectTo.$inject)) {
	        redirectionMap.default.$inject = ['rejectedPermission', 'transitionProperties'];
	      }
	
	      return redirectionMap;
	    }
	
	    return PermissionMap;
	  }
	
	  angular
	    .module('permission')
	    .factory('PermPermissionMap', PermPermissionMap);
	
	}(window, window.angular));


/***/ },
/* 386 */
/***/ function(module, exports) {

	/**
	 * angular-permission-ng
	 * Extension module of angular-permission for access control within angular-route
	 * @version v5.2.1 - 2017-02-02
	 * @link https://github.com/Narzerus/angular-permission
	 * @author Rafael Vidaurre <narzerus@gmail.com> (http://www.rafaelvidaurre.com), Blazej Krysiak <blazej.krysiak@gmail.com>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	(function (window, angular, undefined) {
	  'use strict';
	
	  /**
	   * @namespace permission.ng
	   */
	
	  /**
	   * @param $rootScope {Object}
	   * @param $location {Object}
	   * @param PermTransitionProperties {permission.PermTransitionProperties}
	   * @param PermTransitionEvents {permission.ng.PermTransitionEvents}
	   * @param PermAuthorization {permission.PermAuthorization}
	   * @param PermPermissionMap {permission.PermPermissionMap|Function}
	   */
	  run.$inject = ['$rootScope', '$location', 'PermTransitionProperties', 'PermTransitionEvents', 'PermAuthorization', 'PermPermissionMap'];
	  PermTransitionEvents.$inject = ['$delegate', '$rootScope', 'PermTransitionProperties', 'PermTransitionEventNames'];
	
	  function run($rootScope, $location, PermTransitionProperties, PermTransitionEvents, PermAuthorization, PermPermissionMap) {
	    'ngInject';
	
	    /**
	     * State transition interceptor
	     */
	    $rootScope.$on('$routeChangeStart', function (event, next, current) {
	      setTransitionProperties();
	
	      if (areSetRoutePermissions() && !PermTransitionEvents.areEventsDefaultPrevented()) {
	
	        PermTransitionEvents.broadcastPermissionStartEvent();
	
	        next.$$route.resolve = next.$$route.resolve || {};
	        next.$$route.resolve.$$permission = permissionResolver;
	      }
	
	      /**
	       * Checks if route has set permissions restrictions
	       * @method
	       * @private
	       *
	       * @returns {boolean}
	       */
	      function areSetRoutePermissions() {
	        try {
	          return !!next.$$route.data.permissions;
	        } catch (e) {
	          return false;
	        }
	      }
	
	      /**
	       * Updates values of `PermTransitionProperties` holder object
	       * @method
	       * @private
	       */
	      function setTransitionProperties() {
	        PermTransitionProperties.next = next;
	        PermTransitionProperties.current = current;
	      }
	
	      function permissionResolver() {
	        var PermissionMap = new PermPermissionMap({
	          only: next.$$route.data.permissions.only,
	          except: next.$$route.data.permissions.except,
	          redirectTo: next.$$route.data.permissions.redirectTo
	        });
	
	        var authorizationResult = PermAuthorization.authorizeByPermissionMap(PermissionMap);
	
	        authorizationResult
	          .then(function () {
	            handleAuthorizedState();
	          })
	          .catch(function (rejectedPermission) {
	            handleUnauthorizedState(rejectedPermission, PermissionMap);
	          });
	
	        return authorizationResult;
	      }
	
	      /**
	       * Handles redirection for authorized access
	       * @method
	       * @private
	       */
	      function handleAuthorizedState() {
	        PermTransitionEvents.broadcastPermissionAcceptedEvent();
	      }
	
	      /**
	       * Handles redirection for unauthorized access
	       * @method
	       * @private
	       *
	       * @param rejectedPermission {String} Rejected access right
	       * @param permissionMap {permission.PermPermissionMap} State permission map
	       */
	      function handleUnauthorizedState(rejectedPermission, permissionMap) {
	        PermTransitionEvents.broadcastPermissionDeniedEvent();
	
	        permissionMap
	          .resolveRedirectState(rejectedPermission)
	          .then(function (redirect) {
	            $location.path(redirect.state).replace();
	          });
	      }
	    });
	  }
	
	  var ngPermission = angular
	    .module('permission.ng', ['permission', 'ngRoute'])
	    .run(run);
	
	  if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
	    module.exports = ngPermission.name;
	  }
	
	  /**
	   * Service responsible for managing and emitting events
	   * @name permission.ng.PermTransitionEvents
	   *
	   * @extends {permission.PermTransitionEvents}
	   *
	   * @param $delegate {Object} Parent instance being extended
	   * @param $rootScope {Object} Top-level angular scope
	   * @param PermTransitionProperties {permission.PermTransitionProperties} Helper storing transition parameters
	   * @param PermTransitionEventNames {permission.ng.PermTransitionEventNames} Constant storing event names
	   */
	  function PermTransitionEvents($delegate, $rootScope, PermTransitionProperties, PermTransitionEventNames) {
	    'ngInject';
	
	    $delegate.areEventsDefaultPrevented = areEventsDefaultPrevented;
	    $delegate.broadcastPermissionStartEvent = broadcastPermissionStartEvent;
	    $delegate.broadcastPermissionAcceptedEvent = broadcastPermissionAcceptedEvent;
	    $delegate.broadcastPermissionDeniedEvent = broadcastPermissionDeniedEvent;
	
	    /**
	     * Checks if state events are not prevented by default
	     * @methodOf permission.ng.PermTransitionEvents
	     *
	     * @returns {boolean}
	     */
	    function areEventsDefaultPrevented() {
	      return isRouteChangePermissionStartDefaultPrevented();
	    }
	
	    /**
	     * Broadcasts "$routeChangePermissionStart" event from $rootScope
	     * @methodOf permission.ng.PermTransitionEvents
	     */
	    function broadcastPermissionStartEvent() {
	      $rootScope.$broadcast(PermTransitionEventNames.permissionStart, PermTransitionProperties.next);
	    }
	
	    /**
	     * Broadcasts "$routeChangePermissionAccepted" event from $rootScope
	     * @methodOf permission.ng.PermTransitionEvents
	     */
	    function broadcastPermissionAcceptedEvent() {
	      $rootScope.$broadcast(PermTransitionEventNames.permissionAccepted, PermTransitionProperties.next);
	    }
	
	    /**
	     * Broadcasts "$routeChangePermissionDenied" event from $rootScope
	     * @methodOf permission.ng.PermTransitionEvents
	     */
	    function broadcastPermissionDeniedEvent() {
	      $rootScope.$broadcast(PermTransitionEventNames.permissionDenied, PermTransitionProperties.next);
	    }
	
	    /**
	     * Checks if event $routeChangePermissionStart hasn't been disabled by default
	     * @methodOf permission.ng.PermTransitionEvents
	     * @private
	     *
	     * @returns {boolean}
	     */
	    function isRouteChangePermissionStartDefaultPrevented() {
	      return $rootScope.$broadcast(PermTransitionEventNames.permissionStart, PermTransitionProperties.next).defaultPrevented;
	    }
	
	    return $delegate;
	  }
	
	  angular
	    .module('permission.ng')
	    .decorator('PermTransitionEvents', PermTransitionEvents);
	
	  /**
	   * Constant storing event names for ng-route
	   * @name permission.ng.PermTransitionEventNames
	   *
	   * @type {Object.<String,Object>}
	   *
	   * @property permissionStart {String} Event name called when started checking for permissions
	   * @property permissionAccepted {String} Event name called when authorized
	   * @property permissionDenied {String} Event name called when unauthorized
	   */
	  var PermTransitionEventNames = {
	    permissionStart: '$routeChangePermissionStart',
	    permissionAccepted: '$routeChangePermissionAccepted',
	    permissionDenied: '$routeChangePermissionDenied'
	  };
	
	  angular
	    .module('permission.ng')
	    .value('PermTransitionEventNames', PermTransitionEventNames);
	
	}(window, window.angular));


/***/ },
/* 387 */
/***/ function(module, exports) {

	/**
	 * angular-permission-ui
	 * Extension module of angular-permission for access control within ui-router
	 * @version v5.2.1 - 2017-02-02
	 * @link https://github.com/Narzerus/angular-permission
	 * @author Rafael Vidaurre <narzerus@gmail.com> (http://www.rafaelvidaurre.com), Blazej Krysiak <blazej.krysiak@gmail.com>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	(function (window, angular, undefined) {
	  'use strict';
	
	  /**
	   * @namespace permission.ui
	   */
	
	  /**
	   * @param $stateProvider {Object}
	   */
	  config.$inject = ['$stateProvider'];
	  run.$inject = ['$transitions', 'PermTransitionProperties', 'PermStateAuthorization', 'PermStatePermissionMap'];
	  PermStateAuthorization.$inject = ['$q', '$state', 'PermStatePermissionMap'];
	  PermStatePermissionMap.$inject = ['PermPermissionMap'];
	
	  function config($stateProvider) {
	    'ngInject';
	
	    function $state($delegate) {
	      /**
	       * Property containing full state object definition
	       *
	       * This decorator is required to access full state object instead of just it's configuration
	       * Can be removed when implemented https://github.com/angular-ui/ui-router/issues/13.
	       *
	       * @returns {Object}
	       */
	      $delegate.self.$$permissionState = function () {
	        return $delegate;
	      };
	
	      return $delegate;
	    }
	
	    $stateProvider.decorator('$state', $state);
	  }
	
	  /**
	   * @param $transitions {object}
	   * @param PermTransitionProperties {permission.PermTransitionProperties}
	   * @param PermStateAuthorization {permission.ui.PermStateAuthorization}
	   * @param PermStatePermissionMap {permission.ui.PermStatePermissionMap}
	   */
	  function run($transitions, PermTransitionProperties, PermStateAuthorization, PermStatePermissionMap) {
	    'ngInject';
	
	    $transitions.onStart({}, function (transition) {
	
	      setTransitionProperties(transition);
	
	      var statePermissionMap = new PermStatePermissionMap(PermTransitionProperties.toState);
	
	      return PermStateAuthorization
	        .authorizeByPermissionMap(statePermissionMap)
	        .catch(function (rejectedPermission) {
	          return handleUnauthorizedState(rejectedPermission, statePermissionMap);
	        });
	
	      /**
	       * Handles redirection for unauthorized access
	       * @method
	       * @private
	       *
	       * @param rejectedPermission {String} Rejected access right
	       * @param statePermissionMap {permission.ui.PermPermissionMap} State permission map
	       */
	      function handleUnauthorizedState(rejectedPermission, statePermissionMap) {
	        return statePermissionMap
	          .resolveRedirectState(rejectedPermission)
	          .then(function (redirect) {
	            return transition.router.stateService
	              .target(redirect.state, redirect.params, redirect.options);
	          });
	      }
	
	      /**
	       * Updates values of `PermTransitionProperties` holder object
	       * @method
	       * @private
	       */
	      function setTransitionProperties(transition) {
	        PermTransitionProperties.toState = transition.to();
	        PermTransitionProperties.toParams = transition.params('to');
	        PermTransitionProperties.fromState = transition.from();
	        PermTransitionProperties.fromParams = transition.params('from');
	        PermTransitionProperties.options = transition.options();
	      }
	    });
	  }
	
	  var uiPermission = angular
	    .module('permission.ui', ['permission', 'ui.router'])
	    .config(config)
	    .run(run);
	
	  if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
	    module.exports = uiPermission.name;
	  }
	
	
	  /**
	   * Service responsible for handling inheritance-enabled state-based authorization in ui-router
	   * @extends permission.PermPermissionMap
	   * @name permission.ui.PermStateAuthorization
	   *
	   * @param $q {Object} Angular promise implementation
	   * @param $state {Object} State object
	   * @param PermStatePermissionMap {permission.ui.PermStatePermissionMap|Function} Angular promise implementation
	   */
	  function PermStateAuthorization($q, $state, PermStatePermissionMap) {
	    'ngInject';
	
	    this.authorizeByPermissionMap = authorizeByPermissionMap;
	    this.authorizeByStateName = authorizeByStateName;
	
	    /**
	     * Handles authorization based on provided state permission map
	     * @methodOf permission.ui.PermStateAuthorization
	     *
	     * @param statePermissionMap
	     *
	     * @return {promise}
	     */
	    function authorizeByPermissionMap(statePermissionMap) {
	      return authorizeStatePermissionMap(statePermissionMap);
	    }
	
	    /**
	     * Authorizes uses by provided state name
	     * @methodOf permission.ui.PermStateAuthorization
	     *
	     * @param stateName {String}
	     * @returns {promise}
	     */
	    function authorizeByStateName(stateName) {
	      var srefState = $state.get(stateName);
	      var permissionMap = new PermStatePermissionMap(srefState);
	
	      return authorizeByPermissionMap(permissionMap);
	    }
	
	    /**
	     * Checks authorization for complex state inheritance
	     * @methodOf permission.ui.PermStateAuthorization
	     * @private
	     *
	     * @param map {permission.ui.StatePermissionMap} State access rights map
	     *
	     * @returns {promise} $q.promise object
	     */
	    function authorizeStatePermissionMap(map) {
	      var deferred = $q.defer();
	
	      resolveExceptStatePermissionMap(deferred, map);
	
	      return deferred.promise;
	    }
	
	    /**
	     * Resolves compensated set of "except" privileges
	     * @methodOf permission.ui.PermStateAuthorization
	     * @private
	     *
	     * @param deferred {Object} Promise defer
	     * @param map {permission.ui.StatePermissionMap} State access rights map
	     */
	    function resolveExceptStatePermissionMap(deferred, map) {
	      var exceptPromises = resolveStatePermissionMap(map.except, map);
	
	      $q.all(exceptPromises)
	        .then(function (rejectedPermissions) {
	          deferred.reject(rejectedPermissions[0]);
	        })
	        .catch(function () {
	          resolveOnlyStatePermissionMap(deferred, map);
	        });
	    }
	
	    /**
	     * Resolves compensated set of "only" privileges
	     * @methodOf permission.ui.PermStateAuthorization
	     * @private
	     *
	     * @param deferred {Object} Promise defer
	     * @param map {permission.ui.StatePermissionMap} State access rights map
	     */
	    function resolveOnlyStatePermissionMap(deferred, map) {
	      if (!map.only.length) {
	        deferred.resolve();
	        return;
	      }
	
	      var onlyPromises = resolveStatePermissionMap(map.only, map);
	
	      $q.all(onlyPromises)
	        .then(function (resolvedPermissions) {
	          deferred.resolve(resolvedPermissions);
	        })
	        .catch(function (rejectedPermission) {
	          deferred.reject(rejectedPermission);
	        });
	    }
	
	    /**
	     * Performs iteration over list of privileges looking for matches
	     * @methodOf permission.ui.PermStateAuthorization
	     * @private
	     *
	     * @param privilegesNames {Array} Array of sets of access rights
	     * @param map {permission.ui.StatePermissionMap} State access rights map
	     *
	     * @returns {Array<Promise>} Promise collection
	     */
	    function resolveStatePermissionMap(privilegesNames, map) {
	      if (!privilegesNames.length) {
	        return [$q.reject()];
	      }
	
	      return privilegesNames.map(function (statePrivileges) {
	        var resolvedStatePrivileges = map.resolvePropertyValidity(statePrivileges);
	        return $q.any(resolvedStatePrivileges)
	          .then(function (resolvedPermissions) {
	            if (angular.isArray(resolvedPermissions)) {
	              return resolvedPermissions[0];
	            }
	            return resolvedPermissions;
	          });
	      });
	    }
	  }
	
	  angular
	    .module('permission')
	    .service('PermStateAuthorization', PermStateAuthorization);
	
	  /**
	   * State Access rights map factory
	   * @function
	   *
	   * @param PermPermissionMap {permission.PermPermissionMap|Function}
	   *
	   * @return {permission.ui.StatePermissionMap}
	   */
	  function PermStatePermissionMap(PermPermissionMap) {
	    'ngInject';
	
	    StatePermissionMap.prototype = new PermPermissionMap();
	
	    /**
	     * Constructs map instructing authorization service how to handle authorizing
	     * @constructor permission.ui.StatePermissionMap
	     * @extends permission.PermPermissionMap
	     */
	    function StatePermissionMap(state) {
	      var toStateObject = state.$$permissionState();
	      var toStatePath = toStateObject.path;
	
	      angular.forEach(toStatePath, function (state) {
	        if (areSetStatePermissions(state)) {
	          var permissionMap = new PermPermissionMap(state.data.permissions);
	          this.extendPermissionMap(permissionMap);
	        }
	      }, this);
	    }
	
	    /**
	     * Extends permission map by pushing to it state's permissions
	     * @methodOf permission.ui.StatePermissionMap
	     *
	     * @param permissionMap {permission.PermPermissionMap} Compensated permission map
	     */
	    StatePermissionMap.prototype.extendPermissionMap = function (permissionMap) {
	      if (permissionMap.only.length) {
	        this.only = this.only.concat([permissionMap.only]);
	      }
	      if (permissionMap.except.length) {
	        this.except = this.except.concat([permissionMap.except]);
	      }
	
	      if (angular.isDefined(permissionMap.redirectTo)) {
	        this.redirectTo = angular.extend({}, this.redirectTo, permissionMap.redirectTo);
	      }
	    };
	
	
	    /**
	     * Checks if state has set permissions
	     * We check for hasOwnProperty, because ui-router lets the `data` property inherit from its parent
	     * @methodOf permission.ui.StatePermissionMap
	     * @private
	     *
	     * @returns {boolean}
	     */
	    function areSetStatePermissions(state) {
	      try {
	        return Object.prototype.hasOwnProperty.call(state.data, 'permissions');
	      } catch (e) {
	        return false;
	      }
	    }
	
	    return StatePermissionMap;
	  }
	
	  angular
	    .module('permission.ui')
	    .factory('PermStatePermissionMap', PermStatePermissionMap);
	
	}(window, window.angular));


/***/ },
/* 388 */
/***/ function(module, exports) {

	/*
	 Highcharts JS v5.0.12 (2017-05-24)
	
	 (c) 2009-2016 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(K,S){"object"===typeof module&&module.exports?module.exports=K.document?S(K):S:K.Highcharts=S(K)})("undefined"!==typeof window?window:this,function(K){K=function(){var a=window,C=a.document,A=a.navigator&&a.navigator.userAgent||"",G=C&&C.createElementNS&&!!C.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,F=/(edge|msie|trident)/i.test(A)&&!window.opera,m=!G,g=/Firefox/.test(A),k=g&&4>parseInt(A.split("Firefox/")[1],10);return a.Highcharts?a.Highcharts.error(16,!0):{product:"Highcharts",
	version:"5.0.12",deg2rad:2*Math.PI/360,doc:C,hasBidiBug:k,hasTouch:C&&void 0!==C.documentElement.ontouchstart,isMS:F,isWebKit:/AppleWebKit/.test(A),isFirefox:g,isTouchDevice:/(Mobile|Android|Windows Phone)/.test(A),SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:G,vml:m,win:a,marginNames:["plotTop","marginRight","marginBottom","plotLeft"],noop:function(){},charts:[]}}();(function(a){var C=[],A=a.charts,G=a.doc,F=a.win;a.error=function(m,g){m=a.isNumber(m)?"Highcharts error #"+
	m+": www.highcharts.com/errors/"+m:m;if(g)throw Error(m);F.console&&console.log(m)};a.Fx=function(a,g,k){this.options=g;this.elem=a;this.prop=k};a.Fx.prototype={dSetter:function(){var a=this.paths[0],g=this.paths[1],k=[],q=this.now,v=a.length,u;if(1===q)k=this.toD;else if(v===g.length&&1>q)for(;v--;)u=parseFloat(a[v]),k[v]=isNaN(u)?a[v]:q*parseFloat(g[v]-u)+u;else k=g;this.elem.attr("d",k,null,!0)},update:function(){var a=this.elem,g=this.prop,k=this.now,q=this.options.step;if(this[g+"Setter"])this[g+
	"Setter"]();else a.attr?a.element&&a.attr(g,k,null,!0):a.style[g]=k+this.unit;q&&q.call(a,k,this)},run:function(a,g,k){var m=this,v=function(a){return v.stopped?!1:m.step(a)},u;this.startTime=+new Date;this.start=a;this.end=g;this.unit=k;this.now=this.start;this.pos=0;v.elem=this.elem;v.prop=this.prop;v()&&1===C.push(v)&&(v.timerId=setInterval(function(){for(u=0;u<C.length;u++)C[u]()||C.splice(u--,1);C.length||clearInterval(v.timerId)},13))},step:function(m){var g=+new Date,k,q=this.options,v=this.elem,
	u=q.complete,h=q.duration,e=q.curAnim;v.attr&&!v.element?m=!1:m||g>=h+this.startTime?(this.now=this.end,this.pos=1,this.update(),k=e[this.prop]=!0,a.objectEach(e,function(a){!0!==a&&(k=!1)}),k&&u&&u.call(v),m=!1):(this.pos=q.easing((g-this.startTime)/h),this.now=this.start+(this.end-this.start)*this.pos,this.update(),m=!0);return m},initPath:function(m,g,k){function q(a){var b,l;for(y=a.length;y--;)b="M"===a[y]||"L"===a[y],l=/[a-zA-Z]/.test(a[y+3]),b&&l&&a.splice(y+1,0,a[y+1],a[y+2],a[y+1],a[y+2])}
	function v(a,b){for(;a.length<w;){a[0]=b[w-a.length];var l=a.slice(0,c);[].splice.apply(a,[0,0].concat(l));D&&(l=a.slice(a.length-c),[].splice.apply(a,[a.length,0].concat(l)),y--)}a[0]="M"}function u(a,l){for(var r=(w-a.length)/c;0<r&&r--;)b=a.slice().splice(a.length/H-c,c*H),b[0]=l[w-c-r*c],d&&(b[c-6]=b[c-2],b[c-5]=b[c-1]),[].splice.apply(a,[a.length/H,0].concat(b)),D&&r--}g=g||"";var h,e=m.startX,n=m.endX,d=-1<g.indexOf("C"),c=d?7:3,w,b,y;g=g.split(" ");k=k.slice();var D=m.isArea,H=D?2:1,l;d&&(q(g),
	q(k));if(e&&n){for(y=0;y<e.length;y++)if(e[y]===n[0]){h=y;break}else if(e[0]===n[n.length-e.length+y]){h=y;l=!0;break}void 0===h&&(g=[])}g.length&&a.isNumber(h)&&(w=k.length+h*H*c,l?(v(g,k),u(k,g)):(v(k,g),u(g,k)));return[g,k]}};a.Fx.prototype.fillSetter=a.Fx.prototype.strokeSetter=function(){this.elem.attr(this.prop,a.color(this.start).tweenTo(a.color(this.end),this.pos),null,!0)};a.extend=function(a,g){var m;a||(a={});for(m in g)a[m]=g[m];return a};a.merge=function(){var m,g=arguments,k,q={},v=
	function(g,h){"object"!==typeof g&&(g={});a.objectEach(h,function(e,n){!a.isObject(e,!0)||a.isClass(e)||a.isDOMElement(e)?g[n]=h[n]:g[n]=v(g[n]||{},e)});return g};!0===g[0]&&(q=g[1],g=Array.prototype.slice.call(g,2));k=g.length;for(m=0;m<k;m++)q=v(q,g[m]);return q};a.pInt=function(a,g){return parseInt(a,g||10)};a.isString=function(a){return"string"===typeof a};a.isArray=function(a){a=Object.prototype.toString.call(a);return"[object Array]"===a||"[object Array Iterator]"===a};a.isObject=function(m,
	g){return!!m&&"object"===typeof m&&(!g||!a.isArray(m))};a.isDOMElement=function(m){return a.isObject(m)&&"number"===typeof m.nodeType};a.isClass=function(m){var g=m&&m.constructor;return!(!a.isObject(m,!0)||a.isDOMElement(m)||!g||!g.name||"Object"===g.name)};a.isNumber=function(a){return"number"===typeof a&&!isNaN(a)};a.erase=function(a,g){for(var m=a.length;m--;)if(a[m]===g){a.splice(m,1);break}};a.defined=function(a){return void 0!==a&&null!==a};a.attr=function(m,g,k){var q;a.isString(g)?a.defined(k)?
	m.setAttribute(g,k):m&&m.getAttribute&&(q=m.getAttribute(g)):a.defined(g)&&a.isObject(g)&&a.objectEach(g,function(a,g){m.setAttribute(g,a)});return q};a.splat=function(m){return a.isArray(m)?m:[m]};a.syncTimeout=function(a,g,k){if(g)return setTimeout(a,g,k);a.call(0,k)};a.pick=function(){var a=arguments,g,k,q=a.length;for(g=0;g<q;g++)if(k=a[g],void 0!==k&&null!==k)return k};a.css=function(m,g){a.isMS&&!a.svg&&g&&void 0!==g.opacity&&(g.filter="alpha(opacity\x3d"+100*g.opacity+")");a.extend(m.style,
	g)};a.createElement=function(m,g,k,q,v){m=G.createElement(m);var u=a.css;g&&a.extend(m,g);v&&u(m,{padding:0,border:"none",margin:0});k&&u(m,k);q&&q.appendChild(m);return m};a.extendClass=function(m,g){var k=function(){};k.prototype=new m;a.extend(k.prototype,g);return k};a.pad=function(a,g,k){return Array((g||2)+1-String(a).length).join(k||0)+a};a.relativeLength=function(a,g){return/%$/.test(a)?g*parseFloat(a)/100:parseFloat(a)};a.wrap=function(a,g,k){var q=a[g];a[g]=function(){var a=Array.prototype.slice.call(arguments),
	g=arguments,h=this;h.proceed=function(){q.apply(h,arguments.length?arguments:g)};a.unshift(q);a=k.apply(this,a);h.proceed=null;return a}};a.getTZOffset=function(m){var g=a.Date;return 6E4*(g.hcGetTimezoneOffset&&g.hcGetTimezoneOffset(m)||g.hcTimezoneOffset||0)};a.dateFormat=function(m,g,k){if(!a.defined(g)||isNaN(g))return a.defaultOptions.lang.invalidDate||"";m=a.pick(m,"%Y-%m-%d %H:%M:%S");var q=a.Date,v=new q(g-a.getTZOffset(g)),u=v[q.hcGetHours](),h=v[q.hcGetDay](),e=v[q.hcGetDate](),n=v[q.hcGetMonth](),
	d=v[q.hcGetFullYear](),c=a.defaultOptions.lang,w=c.weekdays,b=c.shortWeekdays,y=a.pad,q=a.extend({a:b?b[h]:w[h].substr(0,3),A:w[h],d:y(e),e:y(e,2," "),w:h,b:c.shortMonths[n],B:c.months[n],m:y(n+1),y:d.toString().substr(2,2),Y:d,H:y(u),k:u,I:y(u%12||12),l:u%12||12,M:y(v[q.hcGetMinutes]()),p:12>u?"AM":"PM",P:12>u?"am":"pm",S:y(v.getSeconds()),L:y(Math.round(g%1E3),3)},a.dateFormats);a.objectEach(q,function(a,b){for(;-1!==m.indexOf("%"+b);)m=m.replace("%"+b,"function"===typeof a?a(g):a)});return k?m.substr(0,
	1).toUpperCase()+m.substr(1):m};a.formatSingle=function(m,g){var k=/\.([0-9])/,q=a.defaultOptions.lang;/f$/.test(m)?(k=(k=m.match(k))?k[1]:-1,null!==g&&(g=a.numberFormat(g,k,q.decimalPoint,-1<m.indexOf(",")?q.thousandsSep:""))):g=a.dateFormat(m,g);return g};a.format=function(m,g){for(var k="{",q=!1,v,u,h,e,n=[],d;m;){k=m.indexOf(k);if(-1===k)break;v=m.slice(0,k);if(q){v=v.split(":");u=v.shift().split(".");e=u.length;d=g;for(h=0;h<e;h++)d=d[u[h]];v.length&&(d=a.formatSingle(v.join(":"),d));n.push(d)}else n.push(v);
	m=m.slice(k+1);k=(q=!q)?"}":"{"}n.push(m);return n.join("")};a.getMagnitude=function(a){return Math.pow(10,Math.floor(Math.log(a)/Math.LN10))};a.normalizeTickInterval=function(m,g,k,q,v){var u,h=m;k=a.pick(k,1);u=m/k;g||(g=v?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===q&&(1===k?g=a.grep(g,function(a){return 0===a%1}):.1>=k&&(g=[1/k])));for(q=0;q<g.length&&!(h=g[q],v&&h*k>=m||!v&&u<=(g[q]+(g[q+1]||g[q]))/2);q++);return h=a.correctFloat(h*k,-Math.round(Math.log(.001)/Math.LN10))};a.stableSort=
	function(a,g){var k=a.length,q,m;for(m=0;m<k;m++)a[m].safeI=m;a.sort(function(a,h){q=g(a,h);return 0===q?a.safeI-h.safeI:q});for(m=0;m<k;m++)delete a[m].safeI};a.arrayMin=function(a){for(var g=a.length,k=a[0];g--;)a[g]<k&&(k=a[g]);return k};a.arrayMax=function(a){for(var g=a.length,k=a[0];g--;)a[g]>k&&(k=a[g]);return k};a.destroyObjectProperties=function(m,g){a.objectEach(m,function(a,q){a&&a!==g&&a.destroy&&a.destroy();delete m[q]})};a.discardElement=function(m){var g=a.garbageBin;g||(g=a.createElement("div"));
	m&&g.appendChild(m);g.innerHTML=""};a.correctFloat=function(a,g){return parseFloat(a.toPrecision(g||14))};a.setAnimation=function(m,g){g.renderer.globalAnimation=a.pick(m,g.options.chart.animation,!0)};a.animObject=function(m){return a.isObject(m)?a.merge(m):{duration:m?500:0}};a.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5};a.numberFormat=function(m,g,k,q){m=+m||0;g=+g;var v=a.defaultOptions.lang,u=(m.toString().split(".")[1]||"").length,
	h,e;-1===g?g=Math.min(u,20):a.isNumber(g)||(g=2);e=(Math.abs(m)+Math.pow(10,-Math.max(g,u)-1)).toFixed(g);u=String(a.pInt(e));h=3<u.length?u.length%3:0;k=a.pick(k,v.decimalPoint);q=a.pick(q,v.thousandsSep);m=(0>m?"-":"")+(h?u.substr(0,h)+q:"");m+=u.substr(h).replace(/(\d{3})(?=\d)/g,"$1"+q);g&&(m+=k+e.slice(-g));return m};Math.easeInOutSine=function(a){return-.5*(Math.cos(Math.PI*a)-1)};a.getStyle=function(m,g,k){if("width"===g)return Math.min(m.offsetWidth,m.scrollWidth)-a.getStyle(m,"padding-left")-
	a.getStyle(m,"padding-right");if("height"===g)return Math.min(m.offsetHeight,m.scrollHeight)-a.getStyle(m,"padding-top")-a.getStyle(m,"padding-bottom");if(m=F.getComputedStyle(m,void 0))m=m.getPropertyValue(g),a.pick(k,!0)&&(m=a.pInt(m));return m};a.inArray=function(a,g){return g.indexOf?g.indexOf(a):[].indexOf.call(g,a)};a.grep=function(a,g){return[].filter.call(a,g)};a.find=function(a,g){return[].find.call(a,g)};a.map=function(a,g){for(var k=[],q=0,m=a.length;q<m;q++)k[q]=g.call(a[q],a[q],q,a);
	return k};a.offset=function(a){var g=G.documentElement;a=a.getBoundingClientRect();return{top:a.top+(F.pageYOffset||g.scrollTop)-(g.clientTop||0),left:a.left+(F.pageXOffset||g.scrollLeft)-(g.clientLeft||0)}};a.stop=function(a,g){for(var k=C.length;k--;)C[k].elem!==a||g&&g!==C[k].prop||(C[k].stopped=!0)};a.each=function(a,g,k){return Array.prototype.forEach.call(a,g,k)};a.objectEach=function(a,g,k){for(var q in a)a.hasOwnProperty(q)&&g.call(k,a[q],q,a)};a.addEvent=function(m,g,k){function q(a){a.target=
	a.srcElement||F;k.call(m,a)}var v=m.hcEvents=m.hcEvents||{};m.addEventListener?m.addEventListener(g,k,!1):m.attachEvent&&(m.hcEventsIE||(m.hcEventsIE={}),m.hcEventsIE[k.toString()]=q,m.attachEvent("on"+g,q));v[g]||(v[g]=[]);v[g].push(k);return function(){a.removeEvent(m,g,k)}};a.removeEvent=function(m,g,k){function q(a,d){m.removeEventListener?m.removeEventListener(a,d,!1):m.attachEvent&&(d=m.hcEventsIE[d.toString()],m.detachEvent("on"+a,d))}function v(){var e,d;m.nodeName&&(g?(e={},e[g]=!0):e=h,
	a.objectEach(e,function(a,e){if(h[e])for(d=h[e].length;d--;)q(e,h[e][d])}))}var u,h=m.hcEvents,e;h&&(g?(u=h[g]||[],k?(e=a.inArray(k,u),-1<e&&(u.splice(e,1),h[g]=u),q(g,k)):(v(),h[g]=[])):(v(),m.hcEvents={}))};a.fireEvent=function(m,g,k,q){var v;v=m.hcEvents;var u,h;k=k||{};if(G.createEvent&&(m.dispatchEvent||m.fireEvent))v=G.createEvent("Events"),v.initEvent(g,!0,!0),a.extend(v,k),m.dispatchEvent?m.dispatchEvent(v):m.fireEvent(g,v);else if(v)for(v=v[g]||[],u=v.length,k.target||a.extend(k,{preventDefault:function(){k.defaultPrevented=
	!0},target:m,type:g}),g=0;g<u;g++)(h=v[g])&&!1===h.call(m,k)&&k.preventDefault();q&&!k.defaultPrevented&&q(k)};a.animate=function(m,g,k){var q,v="",u,h,e;a.isObject(k)||(e=arguments,k={duration:e[2],easing:e[3],complete:e[4]});a.isNumber(k.duration)||(k.duration=400);k.easing="function"===typeof k.easing?k.easing:Math[k.easing]||Math.easeInOutSine;k.curAnim=a.merge(g);a.objectEach(g,function(e,d){a.stop(m,d);h=new a.Fx(m,k,d);u=null;"d"===d?(h.paths=h.initPath(m,m.d,g.d),h.toD=g.d,q=0,u=1):m.attr?
	q=m.attr(d):(q=parseFloat(a.getStyle(m,d))||0,"opacity"!==d&&(v="px"));u||(u=e);u&&u.match&&u.match("px")&&(u=u.replace(/px/g,""));h.run(q,u,v)})};a.seriesType=function(m,g,k,q,v){var u=a.getOptions(),h=a.seriesTypes;if(h[m])return a.error(27);u.plotOptions[m]=a.merge(u.plotOptions[g],k);h[m]=a.extendClass(h[g]||function(){},q);h[m].prototype.type=m;v&&(h[m].prototype.pointClass=a.extendClass(a.Point,v));return h[m]};a.uniqueKey=function(){var a=Math.random().toString(36).substring(2,9),g=0;return function(){return"highcharts-"+
	a+"-"+g++}}();F.jQuery&&(F.jQuery.fn.highcharts=function(){var m=[].slice.call(arguments);if(this[0])return m[0]?(new (a[a.isString(m[0])?m.shift():"Chart"])(this[0],m[0],m[1]),this):A[a.attr(this[0],"data-highcharts-chart")]});G&&!G.defaultView&&(a.getStyle=function(m,g){var k={width:"clientWidth",height:"clientHeight"}[g];if(m.style[g])return a.pInt(m.style[g]);"opacity"===g&&(g="filter");if(k)return m.style.zoom=1,Math.max(m[k]-2*a.getStyle(m,"padding"),0);m=m.currentStyle[g.replace(/\-(\w)/g,
	function(a,g){return g.toUpperCase()})];"filter"===g&&(m=m.replace(/alpha\(opacity=([0-9]+)\)/,function(a,g){return g/100}));return""===m?1:a.pInt(m)});Array.prototype.forEach||(a.each=function(a,g,k){for(var q=0,m=a.length;q<m;q++)if(!1===g.call(k,a[q],q,a))return q});Array.prototype.indexOf||(a.inArray=function(a,g){var k,q=0;if(g)for(k=g.length;q<k;q++)if(g[q]===a)return q;return-1});Array.prototype.filter||(a.grep=function(a,g){for(var k=[],q=0,m=a.length;q<m;q++)g(a[q],q)&&k.push(a[q]);return k});
	Array.prototype.find||(a.find=function(a,g){var k,q=a.length;for(k=0;k<q;k++)if(g(a[k],k))return a[k]})})(K);(function(a){var C=a.each,A=a.isNumber,G=a.map,F=a.merge,m=a.pInt;a.Color=function(g){if(!(this instanceof a.Color))return new a.Color(g);this.init(g)};a.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(a){return[m(a[1]),m(a[2]),m(a[3]),parseFloat(a[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,
	parse:function(a){return[m(a[1]),m(a[2]),m(a[3]),1]}}],names:{none:"rgba(255,255,255,0)",white:"#ffffff",black:"#000000"},init:function(g){var k,q,m,u;if((this.input=g=this.names[g&&g.toLowerCase?g.toLowerCase():""]||g)&&g.stops)this.stops=G(g.stops,function(h){return new a.Color(h[1])});else if(g&&"#"===g[0]&&(k=g.length,g=parseInt(g.substr(1),16),7===k?q=[(g&16711680)>>16,(g&65280)>>8,g&255,1]:4===k&&(q=[(g&3840)>>4|(g&3840)>>8,(g&240)>>4|g&240,(g&15)<<4|g&15,1])),!q)for(m=this.parsers.length;m--&&
	!q;)u=this.parsers[m],(k=u.regex.exec(g))&&(q=u.parse(k));this.rgba=q||[]},get:function(a){var g=this.input,q=this.rgba,m;this.stops?(m=F(g),m.stops=[].concat(m.stops),C(this.stops,function(g,h){m.stops[h]=[m.stops[h][0],g.get(a)]})):m=q&&A(q[0])?"rgb"===a||!a&&1===q[3]?"rgb("+q[0]+","+q[1]+","+q[2]+")":"a"===a?q[3]:"rgba("+q.join(",")+")":g;return m},brighten:function(a){var g,q=this.rgba;if(this.stops)C(this.stops,function(g){g.brighten(a)});else if(A(a)&&0!==a)for(g=0;3>g;g++)q[g]+=m(255*a),0>
	q[g]&&(q[g]=0),255<q[g]&&(q[g]=255);return this},setOpacity:function(a){this.rgba[3]=a;return this},tweenTo:function(a,k){var g,m;a.rgba.length?(g=this.rgba,a=a.rgba,m=1!==a[3]||1!==g[3],a=(m?"rgba(":"rgb(")+Math.round(a[0]+(g[0]-a[0])*(1-k))+","+Math.round(a[1]+(g[1]-a[1])*(1-k))+","+Math.round(a[2]+(g[2]-a[2])*(1-k))+(m?","+(a[3]+(g[3]-a[3])*(1-k)):"")+")"):a=a.input||"none";return a}};a.color=function(g){return new a.Color(g)}})(K);(function(a){var C,A,G=a.addEvent,F=a.animate,m=a.attr,g=a.charts,
	k=a.color,q=a.css,v=a.createElement,u=a.defined,h=a.deg2rad,e=a.destroyObjectProperties,n=a.doc,d=a.each,c=a.extend,w=a.erase,b=a.grep,y=a.hasTouch,D=a.inArray,H=a.isArray,l=a.isFirefox,B=a.isMS,r=a.isObject,z=a.isString,M=a.isWebKit,p=a.merge,E=a.noop,I=a.objectEach,L=a.pick,f=a.pInt,t=a.removeEvent,R=a.stop,J=a.svg,N=a.SVG_NS,O=a.symbolSizes,P=a.win;C=a.SVGElement=function(){return this};c(C.prototype,{opacity:1,SVG_NS:N,textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline".split(" "),
	init:function(a,f){this.element="span"===f?v(f):n.createElementNS(this.SVG_NS,f);this.renderer=a},animate:function(x,f,t){f=a.animObject(L(f,this.renderer.globalAnimation,!0));0!==f.duration?(t&&(f.complete=t),F(this,x,f)):(this.attr(x,null,t),f.step&&f.step.call(this));return this},colorGradient:function(x,f,t){var b=this.renderer,l,c,r,Q,e,h,n,y,E,w,J=[],B;x.radialGradient?c="radialGradient":x.linearGradient&&(c="linearGradient");c&&(r=x[c],e=b.gradients,n=x.stops,w=t.radialReference,H(r)&&(x[c]=
	r={x1:r[0],y1:r[1],x2:r[2],y2:r[3],gradientUnits:"userSpaceOnUse"}),"radialGradient"===c&&w&&!u(r.gradientUnits)&&(Q=r,r=p(r,b.getRadialAttr(w,Q),{gradientUnits:"userSpaceOnUse"})),I(r,function(a,x){"id"!==x&&J.push(x,a)}),I(n,function(a){J.push(a)}),J=J.join(","),e[J]?w=e[J].attr("id"):(r.id=w=a.uniqueKey(),e[J]=h=b.createElement(c).attr(r).add(b.defs),h.radAttr=Q,h.stops=[],d(n,function(x){0===x[1].indexOf("rgba")?(l=a.color(x[1]),y=l.get("rgb"),E=l.get("a")):(y=x[1],E=1);x=b.createElement("stop").attr({offset:x[0],
	"stop-color":y,"stop-opacity":E}).add(h);h.stops.push(x)})),B="url("+b.url+"#"+w+")",t.setAttribute(f,B),t.gradient=J,x.toString=function(){return B})},applyTextOutline:function(x){var f=this.element,t,b,l,c,r;-1!==x.indexOf("contrast")&&(x=x.replace(/contrast/g,this.renderer.getContrast(f.style.fill)));x=x.split(" ");b=x[x.length-1];if((l=x[0])&&"none"!==l&&a.svg){this.fakeTS=!0;x=[].slice.call(f.getElementsByTagName("tspan"));this.ySetter=this.xSetter;l=l.replace(/(^[\d\.]+)(.*?)$/g,function(a,
	x,f){return 2*x+f});for(r=x.length;r--;)t=x[r],"highcharts-text-outline"===t.getAttribute("class")&&w(x,f.removeChild(t));c=f.firstChild;d(x,function(a,x){0===x&&(a.setAttribute("x",f.getAttribute("x")),x=f.getAttribute("y"),a.setAttribute("y",x||0),null===x&&f.setAttribute("y",0));a=a.cloneNode(1);m(a,{"class":"highcharts-text-outline",fill:b,stroke:b,"stroke-width":l,"stroke-linejoin":"round"});f.insertBefore(a,c)})}},attr:function(a,f,t,b){var x,l=this.element,c,r=this,d,p;"string"===typeof a&&
	void 0!==f&&(x=a,a={},a[x]=f);"string"===typeof a?r=(this[a+"Getter"]||this._defaultGetter).call(this,a,l):(I(a,function(x,f){d=!1;b||R(this,f);this.symbolName&&/^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)$/.test(f)&&(c||(this.symbolAttr(a),c=!0),d=!0);!this.rotation||"x"!==f&&"y"!==f||(this.doTransform=!0);d||(p=this[f+"Setter"]||this._defaultSetter,p.call(this,x,f,l),this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(f)&&this.updateShadows(f,x,p))},this),this.afterSetters());
	t&&t();return r},afterSetters:function(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)},updateShadows:function(a,f,t){for(var x=this.shadows,b=x.length;b--;)t.call(x[b],"height"===a?Math.max(f-(x[b].cutHeight||0),0):"d"===a?this.d:f,a,x[b])},addClass:function(a,f){var x=this.attr("class")||"";-1===x.indexOf(a)&&(f||(a=(x+(x?" ":"")+a).replace("  "," ")),this.attr("class",a));return this},hasClass:function(a){return-1!==m(this.element,"class").indexOf(a)},removeClass:function(a){m(this.element,
	"class",(m(this.element,"class")||"").replace(a,""));return this},symbolAttr:function(a){var x=this;d("x y r start end width height innerR anchorX anchorY".split(" "),function(f){x[f]=L(a[f],x[f])});x.attr({d:x.renderer.symbols[x.symbolName](x.x,x.y,x.width,x.height,x)})},clip:function(a){return this.attr("clip-path",a?"url("+this.renderer.url+"#"+a.id+")":"none")},crisp:function(a,f){var x=this,t={},b;f=f||a.strokeWidth||0;b=Math.round(f)%2/2;a.x=Math.floor(a.x||x.x||0)+b;a.y=Math.floor(a.y||x.y||
	0)+b;a.width=Math.floor((a.width||x.width||0)-2*b);a.height=Math.floor((a.height||x.height||0)-2*b);u(a.strokeWidth)&&(a.strokeWidth=f);I(a,function(a,f){x[f]!==a&&(x[f]=t[f]=a)});return t},css:function(a){var x=this.styles,t={},b=this.element,l,r="",d,p=!x,e=["textOutline","textOverflow","width"];a&&a.color&&(a.fill=a.color);x&&I(a,function(a,f){a!==x[f]&&(t[f]=a,p=!0)});p&&(x&&(a=c(x,t)),l=this.textWidth=a&&a.width&&"auto"!==a.width&&"text"===b.nodeName.toLowerCase()&&f(a.width),this.styles=a,l&&
	!J&&this.renderer.forExport&&delete a.width,B&&!J?q(this.element,a):(d=function(a,x){return"-"+x.toLowerCase()},I(a,function(a,x){-1===D(x,e)&&(r+=x.replace(/([A-Z])/g,d)+":"+a+";")}),r&&m(b,"style",r)),this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline)));return this},strokeWidth:function(){return this["stroke-width"]||0},on:function(a,f){var x=this,t=x.element;y&&"click"===a?(t.ontouchstart=function(a){x.touchEventFired=
	Date.now();a.preventDefault();f.call(t,a)},t.onclick=function(a){(-1===P.navigator.userAgent.indexOf("Android")||1100<Date.now()-(x.touchEventFired||0))&&f.call(t,a)}):t["on"+a]=f;return this},setRadialReference:function(a){var x=this.renderer.gradients[this.element.gradient];this.element.radialReference=a;x&&x.radAttr&&x.animate(this.renderer.getRadialAttr(a,x.radAttr));return this},translate:function(a,f){return this.attr({translateX:a,translateY:f})},invert:function(a){this.inverted=a;this.updateTransform();
	return this},updateTransform:function(){var a=this.translateX||0,f=this.translateY||0,t=this.scaleX,b=this.scaleY,l=this.inverted,c=this.rotation,r=this.element;l&&(a+=this.width,f+=this.height);a=["translate("+a+","+f+")"];l?a.push("rotate(90) scale(-1,1)"):c&&a.push("rotate("+c+" "+(r.getAttribute("x")||0)+" "+(r.getAttribute("y")||0)+")");(u(t)||u(b))&&a.push("scale("+L(t,1)+" "+L(b,1)+")");a.length&&r.setAttribute("transform",a.join(" "))},toFront:function(){var a=this.element;a.parentNode.appendChild(a);
	return this},align:function(a,f,t){var x,b,l,c,r={};b=this.renderer;l=b.alignedObjects;var d,p;if(a){if(this.alignOptions=a,this.alignByTranslate=f,!t||z(t))this.alignTo=x=t||"renderer",w(l,this),l.push(this),t=null}else a=this.alignOptions,f=this.alignByTranslate,x=this.alignTo;t=L(t,b[x],b);x=a.align;b=a.verticalAlign;l=(t.x||0)+(a.x||0);c=(t.y||0)+(a.y||0);"right"===x?d=1:"center"===x&&(d=2);d&&(l+=(t.width-(a.width||0))/d);r[f?"translateX":"x"]=Math.round(l);"bottom"===b?p=1:"middle"===b&&(p=
	2);p&&(c+=(t.height-(a.height||0))/p);r[f?"translateY":"y"]=Math.round(c);this[this.placed?"animate":"attr"](r);this.placed=!0;this.alignAttr=r;return this},getBBox:function(a,f){var x,t=this.renderer,b,l=this.element,r=this.styles,p,e=this.textStr,n,Q=t.cache,y=t.cacheKeys,E;f=L(f,this.rotation);b=f*h;p=r&&r.fontSize;void 0!==e&&(E=e.toString(),-1===E.indexOf("\x3c")&&(E=E.replace(/[0-9]/g,"0")),E+=["",f||0,p,r&&r.width,r&&r.textOverflow].join());E&&!a&&(x=Q[E]);if(!x){if(l.namespaceURI===this.SVG_NS||
	t.forExport){try{(n=this.fakeTS&&function(a){d(l.querySelectorAll(".highcharts-text-outline"),function(x){x.style.display=a})})&&n("none"),x=l.getBBox?c({},l.getBBox()):{width:l.offsetWidth,height:l.offsetHeight},n&&n("")}catch(X){}if(!x||0>x.width)x={width:0,height:0}}else x=this.htmlGetBBox();t.isSVG&&(a=x.width,t=x.height,r&&"11px"===r.fontSize&&17===Math.round(t)&&(x.height=t=14),f&&(x.width=Math.abs(t*Math.sin(b))+Math.abs(a*Math.cos(b)),x.height=Math.abs(t*Math.cos(b))+Math.abs(a*Math.sin(b))));
	if(E&&0<x.height){for(;250<y.length;)delete Q[y.shift()];Q[E]||y.push(E);Q[E]=x}}return x},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(){return this.attr({visibility:"hidden"})},fadeOut:function(a){var x=this;x.animate({opacity:0},{duration:a||150,complete:function(){x.attr({y:-9999})}})},add:function(a){var x=this.renderer,f=this.element,t;a&&(this.parentGroup=a);this.parentInverted=a&&a.inverted;void 0!==this.textStr&&x.buildText(this);this.added=!0;if(!a||
	a.handleZ||this.zIndex)t=this.zIndexSetter();t||(a?a.element:x.box).appendChild(f);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var x=a.parentNode;x&&x.removeChild(a)},destroy:function(){var a=this,f=a.element||{},t=a.renderer.isSVG&&"SPAN"===f.nodeName&&a.parentGroup,b=f.ownerSVGElement;f.onclick=f.onmouseout=f.onmouseover=f.onmousemove=f.point=null;R(a);a.clipPath&&b&&(d(b.querySelectorAll("[clip-path]"),function(x){-1<x.getAttribute("clip-path").indexOf(a.clipPath.element.id+
	")")&&x.removeAttribute("clip-path")}),a.clipPath=a.clipPath.destroy());if(a.stops){for(b=0;b<a.stops.length;b++)a.stops[b]=a.stops[b].destroy();a.stops=null}a.safeRemoveChild(f);for(a.destroyShadows();t&&t.div&&0===t.div.childNodes.length;)f=t.parentGroup,a.safeRemoveChild(t.div),delete t.div,t=f;a.alignTo&&w(a.renderer.alignedObjects,a);I(a,function(x,f){delete a[f]});return null},shadow:function(a,f,t){var x=[],b,l,c=this.element,r,d,p,e;if(!a)this.destroyShadows();else if(!this.shadows){d=L(a.width,
	3);p=(a.opacity||.15)/d;e=this.parentInverted?"(-1,-1)":"("+L(a.offsetX,1)+", "+L(a.offsetY,1)+")";for(b=1;b<=d;b++)l=c.cloneNode(0),r=2*d+1-2*b,m(l,{isShadow:"true",stroke:a.color||"#000000","stroke-opacity":p*b,"stroke-width":r,transform:"translate"+e,fill:"none"}),t&&(m(l,"height",Math.max(m(l,"height")-r,0)),l.cutHeight=r),f?f.element.appendChild(l):c.parentNode.insertBefore(l,c),x.push(l);this.shadows=x}return this},destroyShadows:function(){d(this.shadows||[],function(a){this.safeRemoveChild(a)},
	this);this.shadows=void 0},xGetter:function(a){"circle"===this.element.nodeName&&("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=L(this[a],this.element?this.element.getAttribute(a):null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},dSetter:function(a,f,t){a&&a.join&&(a=a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");t.setAttribute(f,a);this[f]=a},dashstyleSetter:function(a){var x,t=this["stroke-width"];"inherit"===t&&(t=1);if(a=a&&a.toLowerCase()){a=
	a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(x=a.length;x--;)a[x]=f(a[x])*t;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",a)}},alignSetter:function(a){this.element.setAttribute("text-anchor",{left:"start",center:"middle",right:"end"}[a])},opacitySetter:function(a,f,t){this[f]=
	a;t.setAttribute(f,a)},titleSetter:function(a){var f=this.element.getElementsByTagName("title")[0];f||(f=n.createElementNS(this.SVG_NS,"title"),this.element.appendChild(f));f.firstChild&&f.removeChild(f.firstChild);f.appendChild(n.createTextNode(String(L(a),"").replace(/<[^>]*>/g,"")))},textSetter:function(a){a!==this.textStr&&(delete this.bBox,this.textStr=a,this.added&&this.renderer.buildText(this))},fillSetter:function(a,f,t){"string"===typeof a?t.setAttribute(f,a):a&&this.colorGradient(a,f,t)},
	visibilitySetter:function(a,f,t){"inherit"===a?t.removeAttribute(f):t.setAttribute(f,a)},zIndexSetter:function(a,t){var x=this.renderer,b=this.parentGroup,l=(b||x).element||x.box,c,r=this.element,d;c=this.added;var p;u(a)&&(r.zIndex=a,a=+a,this[t]===a&&(c=!1),this[t]=a);if(c){(a=this.zIndex)&&b&&(b.handleZ=!0);t=l.childNodes;for(p=0;p<t.length&&!d;p++)b=t[p],c=b.zIndex,b!==r&&(f(c)>a||!u(a)&&u(c)||0>a&&!u(c)&&l!==x.box)&&(l.insertBefore(r,b),d=!0);d||l.appendChild(r)}return d},_defaultSetter:function(a,
	f,t){t.setAttribute(f,a)}});C.prototype.yGetter=C.prototype.xGetter;C.prototype.translateXSetter=C.prototype.translateYSetter=C.prototype.rotationSetter=C.prototype.verticalAlignSetter=C.prototype.scaleXSetter=C.prototype.scaleYSetter=function(a,f){this[f]=a;this.doTransform=!0};C.prototype["stroke-widthSetter"]=C.prototype.strokeSetter=function(a,f,t){this[f]=a;this.stroke&&this["stroke-width"]?(C.prototype.fillSetter.call(this,this.stroke,"stroke",t),t.setAttribute("stroke-width",this["stroke-width"]),
	this.hasStroke=!0):"stroke-width"===f&&0===a&&this.hasStroke&&(t.removeAttribute("stroke"),this.hasStroke=!1)};A=a.SVGRenderer=function(){this.init.apply(this,arguments)};c(A.prototype,{Element:C,SVG_NS:N,init:function(a,f,t,b,c,r){var x;b=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"}).css(this.getStyle(b));x=b.element;a.appendChild(x);-1===a.innerHTML.indexOf("xmlns")&&m(x,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=x;this.boxWrapper=b;this.alignedObjects=[];this.url=(l||
	M)&&n.getElementsByTagName("base").length?P.location.href.replace(/#.*?$/,"").replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(n.createTextNode("Created with Highcharts 5.0.12"));this.defs=this.createElement("defs").add();this.allowHTML=r;this.forExport=c;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(f,t,!1);var d;l&&a.getBoundingClientRect&&(f=function(){q(a,{left:0,top:0});d=a.getBoundingClientRect();
	q(a,{left:Math.ceil(d.left)-d.left+"px",top:Math.ceil(d.top)-d.top+"px"})},f(),this.unSubPixelFix=G(P,"resize",f))},getStyle:function(a){return this.style=c({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();e(this.gradients||{});this.gradients=
	null;a&&(this.defs=a.destroy());this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var f=new this.Element;f.init(this,a);return f},draw:E,getRadialAttr:function(a,f){return{cx:a[0]-a[2]/2+f.cx*a[2],cy:a[1]-a[2]/2+f.cy*a[2],r:f.r*a[2]}},getSpanWidth:function(a,f){var t=a.getBBox(!0).width;!J&&this.forExport&&(t=this.measureSpanWidth(f.firstChild.data,a.styles));return t},applyEllipsis:function(a,f,t,b){var x=this.getSpanWidth(a,f),l=x>b,x=t,c,r=0,d=
	t.length,p=function(a){f.removeChild(f.firstChild);a&&f.appendChild(n.createTextNode(a))};if(l){for(;r<=d;)c=Math.ceil((r+d)/2),x=t.substring(0,c)+"\u2026",p(x),x=this.getSpanWidth(a,f),r===d?r=d+1:x>b?d=c-1:r=c;0===d&&p("")}return l},buildText:function(a){var t=a.element,x=this,l=x.forExport,c=L(a.textStr,"").toString(),r=-1!==c.indexOf("\x3c"),p=t.childNodes,e,h,E,y,w=m(t,"x"),B=a.styles,g=a.textWidth,I=B&&B.lineHeight,z=B&&B.textOutline,D=B&&"ellipsis"===B.textOverflow,k=B&&"nowrap"===B.whiteSpace,
	u=B&&B.fontSize,R,H,v=p.length,B=g&&!a.added&&this.box,M=function(a){var b;b=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:u||x.style.fontSize||12;return I?f(I):x.fontMetrics(b,a.getAttribute("style")?a:t).h};R=[c,D,k,I,z,u,g].join();if(R!==a.textCache){for(a.textCache=R;v--;)t.removeChild(p[v]);r||z||D||g||-1!==c.indexOf(" ")?(e=/<.*class="([^"]+)".*>/,h=/<.*style="([^"]+)".*>/,E=/<.*href="([^"]+)".*>/,B&&B.appendChild(t),c=r?c.replace(/<(b|strong)>/g,'\x3cspan style\x3d"font-weight:bold"\x3e').replace(/<(i|em)>/g,
	'\x3cspan style\x3d"font-style:italic"\x3e').replace(/<a/g,"\x3cspan").replace(/<\/(b|strong|i|em|a)>/g,"\x3c/span\x3e").split(/<br.*?>/g):[c],c=b(c,function(a){return""!==a}),d(c,function(f,b){var c,r=0;f=f.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||\x3cspan").replace(/<\/span>/g,"\x3c/span\x3e|||");c=f.split("|||");d(c,function(f){if(""!==f||1===c.length){var d={},p=n.createElementNS(x.SVG_NS,"tspan"),B,I;e.test(f)&&(B=f.match(e)[1],m(p,"class",B));h.test(f)&&(I=f.match(h)[1].replace(/(;| |^)color([ :])/,
	"$1fill$2"),m(p,"style",I));E.test(f)&&!l&&(m(p,"onclick",'location.href\x3d"'+f.match(E)[1]+'"'),q(p,{cursor:"pointer"}));f=(f.replace(/<(.|\n)*?>/g,"")||" ").replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e");if(" "!==f){p.appendChild(n.createTextNode(f));r?d.dx=0:b&&null!==w&&(d.x=w);m(p,d);t.appendChild(p);!r&&H&&(!J&&l&&q(p,{display:"block"}),m(p,"dy",M(p)));if(g){d=f.replace(/([^\^])-/g,"$1- ").split(" ");B=1<c.length||b||1<d.length&&!k;var z=[],Q,u=M(p),R=a.rotation;for(D&&(y=x.applyEllipsis(a,
	p,f,g));!D&&B&&(d.length||z.length);)a.rotation=0,Q=x.getSpanWidth(a,p),f=Q>g,void 0===y&&(y=f),f&&1!==d.length?(p.removeChild(p.firstChild),z.unshift(d.pop())):(d=z,z=[],d.length&&!k&&(p=n.createElementNS(N,"tspan"),m(p,{dy:u,x:w}),I&&m(p,"style",I),t.appendChild(p)),Q>g&&(g=Q)),d.length&&p.appendChild(n.createTextNode(d.join(" ").replace(/- /g,"-")));a.rotation=R}r++}}});H=H||t.childNodes.length}),y&&a.attr("title",a.textStr),B&&B.removeChild(t),z&&a.applyTextOutline&&a.applyTextOutline(z)):t.appendChild(n.createTextNode(c.replace(/&lt;/g,
	"\x3c").replace(/&gt;/g,"\x3e")))}},getContrast:function(a){a=k(a).rgba;return 510<a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(a,f,t,b,l,r,d,e,h){var x=this.label(a,f,t,h,null,null,null,null,"button"),n=0;x.attr(p({padding:8,r:2},l));var E,y,w,J;l=p({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1,style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},l);E=l.style;delete l.style;r=p(l,{fill:"#e6e6e6"},r);y=r.style;delete r.style;d=p(l,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},
	d);w=d.style;delete d.style;e=p(l,{style:{color:"#cccccc"}},e);J=e.style;delete e.style;G(x.element,B?"mouseover":"mouseenter",function(){3!==n&&x.setState(1)});G(x.element,B?"mouseout":"mouseleave",function(){3!==n&&x.setState(n)});x.setState=function(a){1!==a&&(x.state=n=a);x.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal","hover","pressed","disabled"][a||0]);x.attr([l,r,d,e][a||0]).css([E,y,w,J][a||0])};x.attr(l).css(c({cursor:"default"},
	E));return x.on("click",function(a){3!==n&&b.call(x,a)})},crispLine:function(a,f){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-f%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+f%2/2);return a},path:function(a){var f={fill:"none"};H(a)?f.d=a:r(a)&&c(f,a);return this.createElement("path").attr(f)},circle:function(a,f,t){a=r(a)?a:{x:a,y:f,r:t};f=this.createElement("circle");f.xSetter=f.ySetter=function(a,f,t){t.setAttribute("c"+f,a)};return f.attr(a)},arc:function(a,f,t,b,l,c){r(a)?(b=a,f=b.y,t=b.r,a=b.x):
	b={innerR:b,start:l,end:c};a=this.symbol("arc",a,f,t,t,b);a.r=t;return a},rect:function(a,f,t,b,l,c){l=r(a)?a.r:l;var x=this.createElement("rect");a=r(a)?a:void 0===a?{}:{x:a,y:f,width:Math.max(t,0),height:Math.max(b,0)};void 0!==c&&(a.strokeWidth=c,a=x.crisp(a));a.fill="none";l&&(a.r=l);x.rSetter=function(a,f,t){m(t,{rx:a,ry:a})};return x.attr(a)},setSize:function(a,f,t){var b=this.alignedObjects,l=b.length;this.width=a;this.height=f;for(this.boxWrapper.animate({width:a,height:f},{step:function(){this.attr({viewBox:"0 0 "+
	this.attr("width")+" "+this.attr("height")})},duration:L(t,!0)?void 0:0});l--;)b[l].align()},g:function(a){var f=this.createElement("g");return a?f.attr({"class":"highcharts-"+a}):f},image:function(a,f,t,b,l){var x={preserveAspectRatio:"none"};1<arguments.length&&c(x,{x:f,y:t,width:b,height:l});x=this.createElement("image").attr(x);x.element.setAttributeNS?x.element.setAttributeNS("http://www.w3.org/1999/xlink","href",a):x.element.setAttribute("hc-svg-href",a);return x},symbol:function(a,f,t,b,l,
	r){var x=this,p,e=/^url\((.*?)\)$/,h=e.test(a),E=!h&&(this.symbols[a]?a:"circle"),y=E&&this.symbols[E],B=u(f)&&y&&y.call(this.symbols,Math.round(f),Math.round(t),b,l,r),w,J;y?(p=this.path(B),p.attr("fill","none"),c(p,{symbolName:E,x:f,y:t,width:b,height:l}),r&&c(p,r)):h&&(w=a.match(e)[1],p=this.image(w),p.imgwidth=L(O[w]&&O[w].width,r&&r.width),p.imgheight=L(O[w]&&O[w].height,r&&r.height),J=function(){p.attr({width:p.width,height:p.height})},d(["width","height"],function(a){p[a+"Setter"]=function(a,
	f){var t={},b=this["img"+f],l="width"===f?"translateX":"translateY";this[f]=a;u(b)&&(this.element&&this.element.setAttribute(f,b),this.alignByTranslate||(t[l]=((this[f]||0)-b)/2,this.attr(t)))}}),u(f)&&p.attr({x:f,y:t}),p.isImg=!0,u(p.imgwidth)&&u(p.imgheight)?J():(p.attr({width:0,height:0}),v("img",{onload:function(){var a=g[x.chartIndex];0===this.width&&(q(this,{position:"absolute",top:"-999em"}),n.body.appendChild(this));O[w]={width:this.width,height:this.height};p.imgwidth=this.width;p.imgheight=
	this.height;p.element&&J();this.parentNode&&this.parentNode.removeChild(this);x.imgCount--;if(!x.imgCount&&a&&a.onload)a.onload()},src:w}),this.imgCount++));return p},symbols:{circle:function(a,f,t,b){return this.arc(a+t/2,f+b/2,t/2,b/2,{start:0,end:2*Math.PI,open:!1})},square:function(a,f,t,b){return["M",a,f,"L",a+t,f,a+t,f+b,a,f+b,"Z"]},triangle:function(a,f,t,b){return["M",a+t/2,f,"L",a+t,f+b,a,f+b,"Z"]},"triangle-down":function(a,f,t,b){return["M",a,f,"L",a+t,f,a+t/2,f+b,"Z"]},diamond:function(a,
	f,t,b){return["M",a+t/2,f,"L",a+t,f+b/2,a+t/2,f+b,a,f+b/2,"Z"]},arc:function(a,f,t,b,l){var c=l.start,x=l.r||t,r=l.r||b||t,p=l.end-.001;t=l.innerR;b=l.open;var d=Math.cos(c),e=Math.sin(c),h=Math.cos(p),p=Math.sin(p);l=l.end-c<Math.PI?0:1;x=["M",a+x*d,f+r*e,"A",x,r,0,l,1,a+x*h,f+r*p];u(t)&&x.push(b?"M":"L",a+t*h,f+t*p,"A",t,t,0,l,0,a+t*d,f+t*e);x.push(b?"":"Z");return x},callout:function(a,f,t,b,l){var c=Math.min(l&&l.r||0,t,b),r=c+6,p=l&&l.anchorX;l=l&&l.anchorY;var d;d=["M",a+c,f,"L",a+t-c,f,"C",
	a+t,f,a+t,f,a+t,f+c,"L",a+t,f+b-c,"C",a+t,f+b,a+t,f+b,a+t-c,f+b,"L",a+c,f+b,"C",a,f+b,a,f+b,a,f+b-c,"L",a,f+c,"C",a,f,a,f,a+c,f];p&&p>t?l>f+r&&l<f+b-r?d.splice(13,3,"L",a+t,l-6,a+t+6,l,a+t,l+6,a+t,f+b-c):d.splice(13,3,"L",a+t,b/2,p,l,a+t,b/2,a+t,f+b-c):p&&0>p?l>f+r&&l<f+b-r?d.splice(33,3,"L",a,l+6,a-6,l,a,l-6,a,f+c):d.splice(33,3,"L",a,b/2,p,l,a,b/2,a,f+c):l&&l>b&&p>a+r&&p<a+t-r?d.splice(23,3,"L",p+6,f+b,p,f+b+6,p-6,f+b,a+c,f+b):l&&0>l&&p>a+r&&p<a+t-r&&d.splice(3,3,"L",p-6,f,p,f-6,p+6,f,t-c,f);return d}},
	clipRect:function(f,t,b,l){var c=a.uniqueKey(),r=this.createElement("clipPath").attr({id:c}).add(this.defs);f=this.rect(f,t,b,l,0).add(r);f.id=c;f.clipPath=r;f.count=0;return f},text:function(a,f,t,b){var l=!J&&this.forExport,c={};if(b&&(this.allowHTML||!this.forExport))return this.html(a,f,t);c.x=Math.round(f||0);t&&(c.y=Math.round(t));if(a||0===a)c.text=a;a=this.createElement("text").attr(c);l&&a.css({position:"absolute"});b||(a.xSetter=function(a,f,t){var b=t.getElementsByTagName("tspan"),l,c=
	t.getAttribute(f),r;for(r=0;r<b.length;r++)l=b[r],l.getAttribute(f)===c&&l.setAttribute(f,a);t.setAttribute(f,a)});return a},fontMetrics:function(a,t){a=a||t&&t.style&&t.style.fontSize||this.style&&this.style.fontSize;a=/px/.test(a)?f(a):/em/.test(a)?parseFloat(a)*(t?this.fontMetrics(null,t.parentNode).f:16):12;t=24>a?a+3:Math.round(1.2*a);return{h:t,b:Math.round(.8*t),f:a}},rotCorr:function(a,f,t){var b=a;f&&t&&(b=Math.max(b*Math.cos(f*h),4));return{x:-a/3*Math.sin(f*h),y:b}},label:function(f,b,
	l,r,e,h,n,E,y){var x=this,B=x.g("button"!==y&&"label"),w=B.text=x.text("",0,0,n).attr({zIndex:1}),J,g,I=0,z=3,D=0,q,k,m,R,H,v={},N,M,L=/^url\((.*?)\)$/.test(r),Q=L,V,U,O,P;y&&B.addClass("highcharts-"+y);Q=L;V=function(){return(N||0)%2/2};U=function(){var a=w.element.style,f={};g=(void 0===q||void 0===k||H)&&u(w.textStr)&&w.getBBox();B.width=(q||g.width||0)+2*z+D;B.height=(k||g.height||0)+2*z;M=z+x.fontMetrics(a&&a.fontSize,w).b;Q&&(J||(B.box=J=x.symbols[r]||L?x.symbol(r):x.rect(),J.addClass(("button"===
	y?"":"highcharts-label-box")+(y?" highcharts-"+y+"-box":"")),J.add(B),a=V(),f.x=a,f.y=(E?-M:0)+a),f.width=Math.round(B.width),f.height=Math.round(B.height),J.attr(c(f,v)),v={})};O=function(){var a=D+z,f;f=E?0:M;u(q)&&g&&("center"===H||"right"===H)&&(a+={center:.5,right:1}[H]*(q-g.width));if(a!==w.x||f!==w.y)w.attr("x",a),void 0!==f&&w.attr("y",f);w.x=a;w.y=f};P=function(a,f){J?J.attr(a,f):v[a]=f};B.onAdd=function(){w.add(B);B.attr({text:f||0===f?f:"",x:b,y:l});J&&u(e)&&B.attr({anchorX:e,anchorY:h})};
	B.widthSetter=function(f){q=a.isNumber(f)?f:null};B.heightSetter=function(a){k=a};B["text-alignSetter"]=function(a){H=a};B.paddingSetter=function(a){u(a)&&a!==z&&(z=B.padding=a,O())};B.paddingLeftSetter=function(a){u(a)&&a!==D&&(D=a,O())};B.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==I&&(I=a,g&&B.attr({x:m}))};B.textSetter=function(a){void 0!==a&&w.textSetter(a);U();O()};B["stroke-widthSetter"]=function(a,f){a&&(Q=!0);N=this["stroke-width"]=a;P(f,a)};B.strokeSetter=B.fillSetter=B.rSetter=
	function(a,f){"fill"===f&&a&&(Q=!0);P(f,a)};B.anchorXSetter=function(a,f){e=B.anchorX=a;P(f,Math.round(a)-V()-m)};B.anchorYSetter=function(a,f){h=B.anchorY=a;P(f,a-R)};B.xSetter=function(a){B.x=a;I&&(a-=I*((q||g.width)+2*z));m=Math.round(a);B.attr("translateX",m)};B.ySetter=function(a){R=B.y=Math.round(a);B.attr("translateY",R)};var W=B.css;return c(B,{css:function(a){if(a){var f={};a=p(a);d(B.textProps,function(t){void 0!==a[t]&&(f[t]=a[t],delete a[t])});w.css(f)}return W.call(B,a)},getBBox:function(){return{width:g.width+
	2*z,height:g.height+2*z,x:g.x-z,y:g.y-z}},shadow:function(a){a&&(U(),J&&J.shadow(a));return B},destroy:function(){t(B.element,"mouseenter");t(B.element,"mouseleave");w&&(w=w.destroy());J&&(J=J.destroy());C.prototype.destroy.call(B);B=x=U=O=P=null}})}});a.Renderer=A})(K);(function(a){var C=a.attr,A=a.createElement,G=a.css,F=a.defined,m=a.each,g=a.extend,k=a.isFirefox,q=a.isMS,v=a.isWebKit,u=a.pInt,h=a.SVGRenderer,e=a.win,n=a.wrap;g(a.SVGElement.prototype,{htmlCss:function(a){var c=this.element;if(c=
	a&&"SPAN"===c.tagName&&a.width)delete a.width,this.textWidth=c,this.updateTransform();a&&"ellipsis"===a.textOverflow&&(a.whiteSpace="nowrap",a.overflow="hidden");this.styles=g(this.styles,a);G(this.element,a);return this},htmlGetBBox:function(){var a=this.element;"text"===a.nodeName&&(a.style.position="absolute");return{x:a.offsetLeft,y:a.offsetTop,width:a.offsetWidth,height:a.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var a=this.renderer,c=this.element,e=this.translateX||0,b=this.translateY||
	0,h=this.x||0,n=this.y||0,g=this.textAlign||"left",l={left:0,center:.5,right:1}[g],B=this.styles;G(c,{marginLeft:e,marginTop:b});this.shadows&&m(this.shadows,function(a){G(a,{marginLeft:e+1,marginTop:b+1})});this.inverted&&m(c.childNodes,function(b){a.invertChild(b,c)});if("SPAN"===c.tagName){var r=this.rotation,z=u(this.textWidth),q=B&&B.whiteSpace,p=[r,g,c.innerHTML,this.textWidth,this.textAlign].join();p!==this.cTT&&(B=a.fontMetrics(c.style.fontSize).b,F(r)&&this.setSpanRotation(r,l,B),G(c,{width:"",
	whiteSpace:q||"nowrap"}),c.offsetWidth>z&&/[ \-]/.test(c.textContent||c.innerText)&&G(c,{width:z+"px",display:"block",whiteSpace:q||"normal"}),this.getSpanCorrection(c.offsetWidth,B,l,r,g));G(c,{left:h+(this.xCorr||0)+"px",top:n+(this.yCorr||0)+"px"});v&&(B=c.offsetHeight);this.cTT=p}}else this.alignOnAdd=!0},setSpanRotation:function(a,c,h){var b={},d=q?"-ms-transform":v?"-webkit-transform":k?"MozTransform":e.opera?"-o-transform":"";b[d]=b.transform="rotate("+a+"deg)";b[d+(k?"Origin":"-origin")]=
	b.transformOrigin=100*c+"% "+h+"px";G(this.element,b)},getSpanCorrection:function(a,c,e){this.xCorr=-a*e;this.yCorr=-c}});g(h.prototype,{html:function(a,c,e){var b=this.createElement("span"),d=b.element,h=b.renderer,w=h.isSVG,l=function(a,b){m(["opacity","visibility"],function(l){n(a,l+"Setter",function(a,l,c,r){a.call(this,l,c,r);b[c]=l})})};b.textSetter=function(a){a!==d.innerHTML&&delete this.bBox;d.innerHTML=this.textStr=a;b.htmlUpdateTransform()};w&&l(b,b.element.style);b.xSetter=b.ySetter=b.alignSetter=
	b.rotationSetter=function(a,l){"align"===l&&(l="textAlign");b[l]=a;b.htmlUpdateTransform()};b.attr({text:a,x:Math.round(c),y:Math.round(e)}).css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize,position:"absolute"});d.style.whiteSpace="nowrap";b.css=b.htmlCss;w&&(b.add=function(a){var c,e=h.box.parentNode,B=[];if(this.parentGroup=a){if(c=a.div,!c){for(;a;)B.push(a),a=a.parentGroup;m(B.reverse(),function(a){var r,p=C(a.element,"class");p&&(p={className:p});c=a.div=a.div||A("div",p,{position:"absolute",
	left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,opacity:a.opacity,pointerEvents:a.styles&&a.styles.pointerEvents},c||e);r=c.style;g(a,{on:function(){b.on.apply({element:B[0].div},arguments);return a},translateXSetter:function(b,f){r.left=b+"px";a[f]=b;a.doTransform=!0},translateYSetter:function(b,f){r.top=b+"px";a[f]=b;a.doTransform=!0}});l(a,r)})}}else c=e;c.appendChild(d);b.added=!0;b.alignOnAdd&&b.htmlUpdateTransform();return b});return b}})})(K);(function(a){var C,A,G=
	a.createElement,F=a.css,m=a.defined,g=a.deg2rad,k=a.discardElement,q=a.doc,v=a.each,u=a.erase,h=a.extend;C=a.extendClass;var e=a.isArray,n=a.isNumber,d=a.isObject,c=a.merge;A=a.noop;var w=a.pick,b=a.pInt,y=a.SVGElement,D=a.SVGRenderer,H=a.win;a.svg||(A={docMode8:q&&8===q.documentMode,init:function(a,b){var l=["\x3c",b,' filled\x3d"f" stroked\x3d"f"'],c=["position: ","absolute",";"],d="div"===b;("shape"===b||d)&&c.push("left:0;top:0;width:1px;height:1px;");c.push("visibility: ",d?"hidden":"visible");
	l.push(' style\x3d"',c.join(""),'"/\x3e');b&&(l=d||"span"===b||"img"===b?l.join(""):a.prepVML(l),this.element=G(l));this.renderer=a},add:function(a){var b=this.renderer,l=this.element,c=b.box,d=a&&a.inverted,c=a?a.element||a:c;a&&(this.parentGroup=a);d&&b.invertChild(l,c);c.appendChild(l);this.added=!0;this.alignOnAdd&&!this.deferUpdateTransform&&this.updateTransform();if(this.onAdd)this.onAdd();this.className&&this.attr("class",this.className);return this},updateTransform:y.prototype.htmlUpdateTransform,
	setSpanRotation:function(){var a=this.rotation,b=Math.cos(a*g),c=Math.sin(a*g);F(this.element,{filter:a?["progid:DXImageTransform.Microsoft.Matrix(M11\x3d",b,", M12\x3d",-c,", M21\x3d",c,", M22\x3d",b,", sizingMethod\x3d'auto expand')"].join(""):"none"})},getSpanCorrection:function(a,b,c,d,e){var l=d?Math.cos(d*g):1,r=d?Math.sin(d*g):0,h=w(this.elemHeight,this.element.offsetHeight),n;this.xCorr=0>l&&-a;this.yCorr=0>r&&-h;n=0>l*r;this.xCorr+=r*b*(n?1-c:c);this.yCorr-=l*b*(d?n?c:1-c:1);e&&"left"!==
	e&&(this.xCorr-=a*c*(0>l?-1:1),d&&(this.yCorr-=h*c*(0>r?-1:1)),F(this.element,{textAlign:e}))},pathToVML:function(a){for(var b=a.length,l=[];b--;)n(a[b])?l[b]=Math.round(10*a[b])-5:"Z"===a[b]?l[b]="x":(l[b]=a[b],!a.isArc||"wa"!==a[b]&&"at"!==a[b]||(l[b+5]===l[b+7]&&(l[b+7]+=a[b+7]>a[b+5]?1:-1),l[b+6]===l[b+8]&&(l[b+8]+=a[b+8]>a[b+6]?1:-1)));return l.join(" ")||"x"},clip:function(a){var b=this,l;a?(l=a.members,u(l,b),l.push(b),b.destroyClip=function(){u(l,b)},a=a.getCSS(b)):(b.destroyClip&&b.destroyClip(),
	a={clip:b.docMode8?"inherit":"rect(auto)"});return b.css(a)},css:y.prototype.htmlCss,safeRemoveChild:function(a){a.parentNode&&k(a)},destroy:function(){this.destroyClip&&this.destroyClip();return y.prototype.destroy.apply(this)},on:function(a,b){this.element["on"+a]=function(){var a=H.event;a.target=a.srcElement;b(a)};return this},cutOffPath:function(a,c){var l;a=a.split(/[ ,]/);l=a.length;if(9===l||11===l)a[l-4]=a[l-2]=b(a[l-2])-10*c;return a.join(" ")},shadow:function(a,c,d){var l=[],r,p=this.element,
	e=this.renderer,h,n=p.style,f,t=p.path,y,J,g,B;t&&"string"!==typeof t.value&&(t="x");J=t;if(a){g=w(a.width,3);B=(a.opacity||.15)/g;for(r=1;3>=r;r++)y=2*g+1-2*r,d&&(J=this.cutOffPath(t.value,y+.5)),f=['\x3cshape isShadow\x3d"true" strokeweight\x3d"',y,'" filled\x3d"false" path\x3d"',J,'" coordsize\x3d"10 10" style\x3d"',p.style.cssText,'" /\x3e'],h=G(e.prepVML(f),null,{left:b(n.left)+w(a.offsetX,1),top:b(n.top)+w(a.offsetY,1)}),d&&(h.cutOff=y+1),f=['\x3cstroke color\x3d"',a.color||"#000000",'" opacity\x3d"',
	B*r,'"/\x3e'],G(e.prepVML(f),null,null,h),c?c.element.appendChild(h):p.parentNode.insertBefore(h,p),l.push(h);this.shadows=l}return this},updateShadows:A,setAttr:function(a,b){this.docMode8?this.element[a]=b:this.element.setAttribute(a,b)},classSetter:function(a){(this.added?this.element:this).className=a},dashstyleSetter:function(a,b,c){(c.getElementsByTagName("stroke")[0]||G(this.renderer.prepVML(["\x3cstroke/\x3e"]),null,null,c))[b]=a||"solid";this[b]=a},dSetter:function(a,b,c){var l=this.shadows;
	a=a||[];this.d=a.join&&a.join(" ");c.path=a=this.pathToVML(a);if(l)for(c=l.length;c--;)l[c].path=l[c].cutOff?this.cutOffPath(a,l[c].cutOff):a;this.setAttr(b,a)},fillSetter:function(a,b,c){var l=c.nodeName;"SPAN"===l?c.style.color=a:"IMG"!==l&&(c.filled="none"!==a,this.setAttr("fillcolor",this.renderer.color(a,c,b,this)))},"fill-opacitySetter":function(a,b,c){G(this.renderer.prepVML(["\x3c",b.split("-")[0],' opacity\x3d"',a,'"/\x3e']),null,null,c)},opacitySetter:A,rotationSetter:function(a,b,c){c=
	c.style;this[b]=c[b]=a;c.left=-Math.round(Math.sin(a*g)+1)+"px";c.top=Math.round(Math.cos(a*g))+"px"},strokeSetter:function(a,b,c){this.setAttr("strokecolor",this.renderer.color(a,c,b,this))},"stroke-widthSetter":function(a,b,c){c.stroked=!!a;this[b]=a;n(a)&&(a+="px");this.setAttr("strokeweight",a)},titleSetter:function(a,b){this.setAttr(b,a)},visibilitySetter:function(a,b,c){"inherit"===a&&(a="visible");this.shadows&&v(this.shadows,function(c){c.style[b]=a});"DIV"===c.nodeName&&(a="hidden"===a?"-999em":
	0,this.docMode8||(c.style[b]=a?"visible":"hidden"),b="top");c.style[b]=a},xSetter:function(a,b,c){this[b]=a;"x"===b?b="left":"y"===b&&(b="top");this.updateClipping?(this[b]=a,this.updateClipping()):c.style[b]=a},zIndexSetter:function(a,b,c){c.style[b]=a}},A["stroke-opacitySetter"]=A["fill-opacitySetter"],a.VMLElement=A=C(y,A),A.prototype.ySetter=A.prototype.widthSetter=A.prototype.heightSetter=A.prototype.xSetter,A={Element:A,isIE8:-1<H.navigator.userAgent.indexOf("MSIE 8.0"),init:function(a,b,c){var l,
	d;this.alignedObjects=[];l=this.createElement("div").css({position:"relative"});d=l.element;a.appendChild(l.element);this.isVML=!0;this.box=d;this.boxWrapper=l;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(b,c,!1);if(!q.namespaces.hcv){q.namespaces.add("hcv","urn:schemas-microsoft-com:vml");try{q.createStyleSheet().cssText="hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke{ behavior:url(#default#VML); display: inline-block; } "}catch(p){q.styleSheets[0].cssText+="hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke{ behavior:url(#default#VML); display: inline-block; } "}}},
	isHidden:function(){return!this.box.offsetWidth},clipRect:function(a,b,c,e){var l=this.createElement(),p=d(a);return h(l,{members:[],count:0,left:(p?a.x:a)+1,top:(p?a.y:b)+1,width:(p?a.width:c)-1,height:(p?a.height:e)-1,getCSS:function(a){var b=a.element,c=b.nodeName,f=a.inverted,t=this.top-("shape"===c?b.offsetTop:0),l=this.left,b=l+this.width,p=t+this.height,t={clip:"rect("+Math.round(f?l:t)+"px,"+Math.round(f?p:b)+"px,"+Math.round(f?b:p)+"px,"+Math.round(f?t:l)+"px)"};!f&&a.docMode8&&"DIV"===c&&
	h(t,{width:b+"px",height:p+"px"});return t},updateClipping:function(){v(l.members,function(a){a.element&&a.css(l.getCSS(a))})}})},color:function(b,c,d,e){var l=this,p,r=/^rgba/,h,n,f="none";b&&b.linearGradient?n="gradient":b&&b.radialGradient&&(n="pattern");if(n){var t,y,w=b.linearGradient||b.radialGradient,g,q,B,x,D,z="";b=b.stops;var k,m=[],u=function(){h=['\x3cfill colors\x3d"'+m.join(",")+'" opacity\x3d"',B,'" o:opacity2\x3d"',q,'" type\x3d"',n,'" ',z,'focus\x3d"100%" method\x3d"any" /\x3e'];
	G(l.prepVML(h),null,null,c)};g=b[0];k=b[b.length-1];0<g[0]&&b.unshift([0,g[1]]);1>k[0]&&b.push([1,k[1]]);v(b,function(f,b){r.test(f[1])?(p=a.color(f[1]),t=p.get("rgb"),y=p.get("a")):(t=f[1],y=1);m.push(100*f[0]+"% "+t);b?(B=y,x=t):(q=y,D=t)});if("fill"===d)if("gradient"===n)d=w.x1||w[0]||0,b=w.y1||w[1]||0,g=w.x2||w[2]||0,w=w.y2||w[3]||0,z='angle\x3d"'+(90-180*Math.atan((w-b)/(g-d))/Math.PI)+'"',u();else{var f=w.r,H=2*f,A=2*f,C=w.cx,F=w.cy,T=c.radialReference,K,f=function(){T&&(K=e.getBBox(),C+=(T[0]-
	K.x)/K.width-.5,F+=(T[1]-K.y)/K.height-.5,H*=T[2]/K.width,A*=T[2]/K.height);z='src\x3d"'+a.getOptions().global.VMLRadialGradientURL+'" size\x3d"'+H+","+A+'" origin\x3d"0.5,0.5" position\x3d"'+C+","+F+'" color2\x3d"'+D+'" ';u()};e.added?f():e.onAdd=f;f=x}else f=t}else r.test(b)&&"IMG"!==c.tagName?(p=a.color(b),e[d+"-opacitySetter"](p.get("a"),d,c),f=p.get("rgb")):(f=c.getElementsByTagName(d),f.length&&(f[0].opacity=1,f[0].type="solid"),f=b);return f},prepVML:function(a){var b=this.isIE8;a=a.join("");
	b?(a=a.replace("/\x3e",' xmlns\x3d"urn:schemas-microsoft-com:vml" /\x3e'),a=-1===a.indexOf('style\x3d"')?a.replace("/\x3e",' style\x3d"display:inline-block;behavior:url(#default#VML);" /\x3e'):a.replace('style\x3d"','style\x3d"display:inline-block;behavior:url(#default#VML);')):a=a.replace("\x3c","\x3chcv:");return a},text:D.prototype.html,path:function(a){var b={coordsize:"10 10"};e(a)?b.d=a:d(a)&&h(b,a);return this.createElement("shape").attr(b)},circle:function(a,b,c){var l=this.symbol("circle");
	d(a)&&(c=a.r,b=a.y,a=a.x);l.isCircle=!0;l.r=c;return l.attr({x:a,y:b})},g:function(a){var b;a&&(b={className:"highcharts-"+a,"class":"highcharts-"+a});return this.createElement("div").attr(b)},image:function(a,b,c,d,e){var l=this.createElement("img").attr({src:a});1<arguments.length&&l.attr({x:b,y:c,width:d,height:e});return l},createElement:function(a){return"rect"===a?this.symbol(a):D.prototype.createElement.call(this,a)},invertChild:function(a,c){var d=this;c=c.style;var l="IMG"===a.tagName&&a.style;
	F(a,{flip:"x",left:b(c.width)-(l?b(l.top):1),top:b(c.height)-(l?b(l.left):1),rotation:-90});v(a.childNodes,function(b){d.invertChild(b,a)})},symbols:{arc:function(a,b,c,d,e){var p=e.start,l=e.end,r=e.r||c||d;c=e.innerR;d=Math.cos(p);var h=Math.sin(p),f=Math.cos(l),t=Math.sin(l);if(0===l-p)return["x"];p=["wa",a-r,b-r,a+r,b+r,a+r*d,b+r*h,a+r*f,b+r*t];e.open&&!c&&p.push("e","M",a,b);p.push("at",a-c,b-c,a+c,b+c,a+c*f,b+c*t,a+c*d,b+c*h,"x","e");p.isArc=!0;return p},circle:function(a,b,c,d,e){e&&m(e.r)&&
	(c=d=2*e.r);e&&e.isCircle&&(a-=c/2,b-=d/2);return["wa",a,b,a+c,b+d,a+c,b+d/2,a+c,b+d/2,"e"]},rect:function(a,b,c,d,e){return D.prototype.symbols[m(e)&&e.r?"callout":"square"].call(0,a,b,c,d,e)}}},a.VMLRenderer=C=function(){this.init.apply(this,arguments)},C.prototype=c(D.prototype,A),a.Renderer=C);D.prototype.measureSpanWidth=function(a,b){var c=q.createElement("span");a=q.createTextNode(a);c.appendChild(a);F(c,b);this.box.appendChild(c);b=c.offsetWidth;k(c);return b}})(K);(function(a){function C(){var g=
	a.defaultOptions.global,k=q.moment;if(g.timezone){if(k)return function(a){return-k.tz(a,g.timezone).utcOffset()};a.error(25)}return g.useUTC&&g.getTimezoneOffset}function A(){var g=a.defaultOptions.global,u,h=g.useUTC,e=h?"getUTC":"get",n=h?"setUTC":"set";a.Date=u=g.Date||q.Date;u.hcTimezoneOffset=h&&g.timezoneOffset;u.hcGetTimezoneOffset=C();u.hcMakeTime=function(a,c,e,b,n,g){var d;h?(d=u.UTC.apply(0,arguments),d+=m(d)):d=(new u(a,c,k(e,1),k(b,0),k(n,0),k(g,0))).getTime();return d};F("Minutes Hours Day Date Month FullYear".split(" "),
	function(a){u["hcGet"+a]=e+a});F("Milliseconds Seconds Minutes Hours Date Month FullYear".split(" "),function(a){u["hcSet"+a]=n+a})}var G=a.color,F=a.each,m=a.getTZOffset,g=a.merge,k=a.pick,q=a.win;a.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),
	shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{useUTC:!0,VMLRadialGradientURL:"http://code.highcharts.com/5.0.12/gfx/vml-radial-gradient.png"},chart:{borderRadius:0,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:20},
	position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},
	itemStyle:{color:"#333333",fontSize:"12px",fontWeight:"bold",textOverflow:"ellipsis"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},shadow:!1,itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,
	animation:a.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:a.isTouchDevice?25:10,backgroundColor:G("#f7f7f7").setOpacity(.85).get(),borderWidth:1,headerFormat:'\x3cspan style\x3d"font-size: 10px"\x3e{point.key}\x3c/span\x3e\x3cbr/\x3e',pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e',
	shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",pointerEvents:"none",whiteSpace:"nowrap"}},credits:{enabled:!0,href:"http://www.highcharts.com",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};a.setOptions=function(q){a.defaultOptions=g(!0,a.defaultOptions,q);A();return a.defaultOptions};a.getOptions=function(){return a.defaultOptions};a.defaultPlotOptions=a.defaultOptions.plotOptions;A()})(K);
	(function(a){var C=a.correctFloat,A=a.defined,G=a.destroyObjectProperties,F=a.isNumber,m=a.merge,g=a.pick,k=a.deg2rad;a.Tick=function(a,g,k,h){this.axis=a;this.pos=g;this.type=k||"";this.isNewLabel=this.isNew=!0;k||h||this.addLabel()};a.Tick.prototype={addLabel:function(){var a=this.axis,k=a.options,u=a.chart,h=a.categories,e=a.names,n=this.pos,d=k.labels,c=a.tickPositions,w=n===c[0],b=n===c[c.length-1],e=h?g(h[n],e[n],n):n,h=this.label,c=c.info,y;a.isDatetimeAxis&&c&&(y=k.dateTimeLabelFormats[c.higherRanks[n]||
	c.unitName]);this.isFirst=w;this.isLast=b;k=a.labelFormatter.call({axis:a,chart:u,isFirst:w,isLast:b,dateTimeLabelFormat:y,value:a.isLog?C(a.lin2log(e)):e});A(h)?h&&h.attr({text:k}):(this.labelLength=(this.label=h=A(k)&&d.enabled?u.renderer.text(k,0,0,d.useHTML).css(m(d.style)).add(a.labelGroup):null)&&h.getBBox().width,this.rotation=0)},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(a){var q=this.axis,m=a.x,h=q.chart.chartWidth,
	e=q.chart.spacing,n=g(q.labelLeft,Math.min(q.pos,e[3])),e=g(q.labelRight,Math.max(q.pos+q.len,h-e[1])),d=this.label,c=this.rotation,w={left:0,center:.5,right:1}[q.labelAlign],b=d.getBBox().width,y=q.getSlotWidth(),D=y,H=1,l,B={};if(c)0>c&&m-w*b<n?l=Math.round(m/Math.cos(c*k)-n):0<c&&m+w*b>e&&(l=Math.round((h-m)/Math.cos(c*k)));else if(h=m+(1-w)*b,m-w*b<n?D=a.x+D*(1-w)-n:h>e&&(D=e-a.x+D*w,H=-1),D=Math.min(y,D),D<y&&"center"===q.labelAlign&&(a.x+=H*(y-D-w*(y-Math.min(b,D)))),b>D||q.autoRotation&&(d.styles||
	{}).width)l=D;l&&(B.width=l,(q.options.labels.style||{}).textOverflow||(B.textOverflow="ellipsis"),d.css(B))},getPosition:function(a,g,k,h){var e=this.axis,n=e.chart,d=h&&n.oldChartHeight||n.chartHeight;return{x:a?e.translate(g+k,null,null,h)+e.transB:e.left+e.offset+(e.opposite?(h&&n.oldChartWidth||n.chartWidth)-e.right-e.left:0),y:a?d-e.bottom+e.offset-(e.opposite?e.height:0):d-e.translate(g+k,null,null,h)-e.transB}},getLabelPosition:function(a,g,m,h,e,n,d,c){var w=this.axis,b=w.transA,y=w.reversed,
	D=w.staggerLines,q=w.tickRotCorr||{x:0,y:0},l=e.y;A(l)||(l=0===w.side?m.rotation?-8:-m.getBBox().height:2===w.side?q.y+8:Math.cos(m.rotation*k)*(q.y-m.getBBox(!1,0).height/2));a=a+e.x+q.x-(n&&h?n*b*(y?-1:1):0);g=g+l-(n&&!h?n*b*(y?1:-1):0);D&&(m=d/(c||1)%D,w.opposite&&(m=D-m-1),g+=w.labelOffset/D*m);return{x:a,y:Math.round(g)}},getMarkPath:function(a,g,k,h,e,n){return n.crispLine(["M",a,g,"L",a+(e?0:-k),g+(e?k:0)],h)},renderGridLine:function(a,g,k){var h=this.axis,e=h.options,n=this.gridLine,d={},
	c=this.pos,w=this.type,b=h.tickmarkOffset,y=h.chart.renderer,D=w?w+"Grid":"grid",q=e[D+"LineWidth"],l=e[D+"LineColor"],e=e[D+"LineDashStyle"];n||(d.stroke=l,d["stroke-width"]=q,e&&(d.dashstyle=e),w||(d.zIndex=1),a&&(d.opacity=0),this.gridLine=n=y.path().attr(d).addClass("highcharts-"+(w?w+"-":"")+"grid-line").add(h.gridGroup));if(!a&&n&&(a=h.getPlotLinePath(c+b,n.strokeWidth()*k,a,!0)))n[this.isNew?"attr":"animate"]({d:a,opacity:g})},renderMark:function(a,k,m){var h=this.axis,e=h.options,n=h.chart.renderer,
	d=this.type,c=d?d+"Tick":"tick",w=h.tickSize(c),b=this.mark,y=!b,D=a.x;a=a.y;var q=g(e[c+"Width"],!d&&h.isXAxis?1:0),e=e[c+"Color"];w&&(h.opposite&&(w[0]=-w[0]),y&&(this.mark=b=n.path().addClass("highcharts-"+(d?d+"-":"")+"tick").add(h.axisGroup),b.attr({stroke:e,"stroke-width":q})),b[y?"attr":"animate"]({d:this.getMarkPath(D,a,w[0],b.strokeWidth()*m,h.horiz,n),opacity:k}))},renderLabel:function(a,k,m,h){var e=this.axis,n=e.horiz,d=e.options,c=this.label,w=d.labels,b=w.step,y=e.tickmarkOffset,D=!0,
	q=a.x;a=a.y;c&&F(q)&&(c.xy=a=this.getLabelPosition(q,a,c,n,w,y,h,b),this.isFirst&&!this.isLast&&!g(d.showFirstLabel,1)||this.isLast&&!this.isFirst&&!g(d.showLastLabel,1)?D=!1:!n||e.isRadial||w.step||w.rotation||k||0===m||this.handleOverflow(a),b&&h%b&&(D=!1),D&&F(a.y)?(a.opacity=m,c[this.isNewLabel?"attr":"animate"](a),this.isNewLabel=!1):(c.attr("y",-9999),this.isNewLabel=!0),this.isNew=!1)},render:function(a,k,m){var h=this.axis,e=h.horiz,n=this.getPosition(e,this.pos,h.tickmarkOffset,k),d=n.x,
	c=n.y,h=e&&d===h.pos+h.len||!e&&c===h.pos?-1:1;m=g(m,1);this.isActive=!0;this.renderGridLine(k,m,h);this.renderMark(n,m,h);this.renderLabel(n,k,m,a)},destroy:function(){G(this,this.axis)}}})(K);var S=function(a){var C=a.addEvent,A=a.animObject,G=a.arrayMax,F=a.arrayMin,m=a.color,g=a.correctFloat,k=a.defaultOptions,q=a.defined,v=a.deg2rad,u=a.destroyObjectProperties,h=a.each,e=a.extend,n=a.fireEvent,d=a.format,c=a.getMagnitude,w=a.grep,b=a.inArray,y=a.isArray,D=a.isNumber,H=a.isString,l=a.merge,B=
	a.normalizeTickInterval,r=a.objectEach,z=a.pick,M=a.removeEvent,p=a.splat,E=a.syncTimeout,I=a.Tick,L=function(){this.init.apply(this,arguments)};a.extend(L.prototype,{defaultOptions:{dateTimeLabelFormats:{millisecond:"%H:%M:%S.%L",second:"%H:%M:%S",minute:"%H:%M",hour:"%H:%M",day:"%e. %b",week:"%e. %b",month:"%b '%y",year:"%Y"},endOnTick:!1,labels:{enabled:!0,style:{color:"#666666",cursor:"default",fontSize:"11px"},x:0},minPadding:.01,maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",startOfWeek:1,
	startOnTick:!1,tickLength:10,tickmarkPlacement:"between",tickPixelInterval:100,tickPosition:"outside",title:{align:"middle",style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"},defaultYAxisOptions:{endOnTick:!0,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},maxPadding:.05,minPadding:.05,startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{enabled:!1,
	formatter:function(){return a.numberFormat(this.total,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"#000000",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},defaultTopAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},init:function(a,t){var f=t.isX,c=this;c.chart=a;c.horiz=
	a.inverted&&!c.isZAxis?!f:f;c.isXAxis=f;c.coll=c.coll||(f?"xAxis":"yAxis");c.opposite=t.opposite;c.side=t.side||(c.horiz?c.opposite?0:2:c.opposite?1:3);c.setOptions(t);var d=this.options,e=d.type;c.labelFormatter=d.labels.formatter||c.defaultLabelFormatter;c.userOptions=t;c.minPixelPadding=0;c.reversed=d.reversed;c.visible=!1!==d.visible;c.zoomEnabled=!1!==d.zoomEnabled;c.hasNames="category"===e||!0===d.categories;c.categories=d.categories||c.hasNames;c.names=c.names||[];c.plotLinesAndBandsGroups=
	{};c.isLog="logarithmic"===e;c.isDatetimeAxis="datetime"===e;c.positiveValuesOnly=c.isLog&&!c.allowNegativeLog;c.isLinked=q(d.linkedTo);c.ticks={};c.labelEdge=[];c.minorTicks={};c.plotLinesAndBands=[];c.alternateBands={};c.len=0;c.minRange=c.userMinRange=d.minRange||d.maxZoom;c.range=d.range;c.offset=d.offset||0;c.stacks={};c.oldStacks={};c.stacksTouched=0;c.max=null;c.min=null;c.crosshair=z(d.crosshair,p(a.options.tooltip.crosshairs)[f?0:1],!1);t=c.options.events;-1===b(c,a.axes)&&(f?a.axes.splice(a.xAxis.length,
	0,c):a.axes.push(c),a[c.coll].push(c));c.series=c.series||[];a.inverted&&!c.isZAxis&&f&&void 0===c.reversed&&(c.reversed=!0);r(t,function(a,f){C(c,f,a)});c.lin2log=d.linearToLogConverter||c.lin2log;c.isLog&&(c.val2lin=c.log2lin,c.lin2val=c.lin2log)},setOptions:function(a){this.options=l(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],l(k[this.coll],a))},
	defaultLabelFormatter:function(){var f=this.axis,b=this.value,c=f.categories,p=this.dateTimeLabelFormat,e=k.lang,l=e.numericSymbols,e=e.numericSymbolMagnitude||1E3,r=l&&l.length,x,h=f.options.labels.format,f=f.isLog?Math.abs(b):f.tickInterval;if(h)x=d(h,this);else if(c)x=b;else if(p)x=a.dateFormat(p,b);else if(r&&1E3<=f)for(;r--&&void 0===x;)c=Math.pow(e,r+1),f>=c&&0===10*b%c&&null!==l[r]&&0!==b&&(x=a.numberFormat(b/c,-1)+l[r]);void 0===x&&(x=1E4<=Math.abs(b)?a.numberFormat(b,-1):a.numberFormat(b,
	-1,void 0,""));return x},getSeriesExtremes:function(){var a=this,b=a.chart;a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();h(a.series,function(f){if(f.visible||!b.options.chart.ignoreHiddenSeries){var c=f.options,t=c.threshold,d;a.hasVisibleSeries=!0;a.positiveValuesOnly&&0>=t&&(t=null);if(a.isXAxis)c=f.xData,c.length&&(f=F(c),D(f)||f instanceof Date||(c=w(c,function(a){return D(a)}),f=F(c)),a.dataMin=Math.min(z(a.dataMin,c[0]),
	f),a.dataMax=Math.max(z(a.dataMax,c[0]),G(c)));else if(f.getExtremes(),d=f.dataMax,f=f.dataMin,q(f)&&q(d)&&(a.dataMin=Math.min(z(a.dataMin,f),f),a.dataMax=Math.max(z(a.dataMax,d),d)),q(t)&&(a.threshold=t),!c.softThreshold||a.positiveValuesOnly)a.softThreshold=!1}})},translate:function(a,b,c,d,p,e){var f=this.linkedParent||this,t=1,l=0,r=d?f.oldTransA:f.transA;d=d?f.oldMin:f.min;var h=f.minPixelPadding;p=(f.isOrdinal||f.isBroken||f.isLog&&p)&&f.lin2val;r||(r=f.transA);c&&(t*=-1,l=f.len);f.reversed&&
	(t*=-1,l-=t*(f.sector||f.len));b?(a=(a*t+l-h)/r+d,p&&(a=f.lin2val(a))):(p&&(a=f.val2lin(a)),a=t*(a-d)*r+l+t*h+(D(e)?r*e:0));return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),!0,!this.horiz,null,!0)},getPlotLinePath:function(a,b,c,d,p){var f=this.chart,t=this.left,e=this.top,l,r,h=c&&f.oldChartHeight||f.chartHeight,n=c&&f.oldChartWidth||f.chartWidth,w;l=this.transB;var g=function(a,f,b){if(a<
	f||a>b)d?a=Math.min(Math.max(f,a),b):w=!0;return a};p=z(p,this.translate(a,null,null,c));a=c=Math.round(p+l);l=r=Math.round(h-p-l);D(p)?this.horiz?(l=e,r=h-this.bottom,a=c=g(a,t,t+this.width)):(a=t,c=n-this.right,l=r=g(l,e,e+this.height)):w=!0;return w&&!d?null:f.renderer.crispLine(["M",a,l,"L",c,r],b||1)},getLinearTickPositions:function(a,b,c){var f,t=g(Math.floor(b/a)*a);c=g(Math.ceil(c/a)*a);var d=[];if(this.single)return[b];for(b=t;b<=c;){d.push(b);b=g(b+a);if(b===f)break;f=b}return d},getMinorTickPositions:function(){var a=
	this,b=a.options,c=a.tickPositions,d=a.minorTickInterval,p=[],e=a.pointRangePadding||0,l=a.min-e,e=a.max+e,x=e-l;if(x&&x/d<a.len/3)if(a.isLog)h(this.paddedTicks,function(b,f,c){f&&p.push.apply(p,a.getLogTickPositions(d,c[f-1],c[f],!0))});else if(a.isDatetimeAxis&&"auto"===b.minorTickInterval)p=p.concat(a.getTimeTicks(a.normalizeTimeTickInterval(d),l,e,b.startOfWeek));else for(b=l+(c[0]-l)%d;b<=e&&b!==p[0];b+=d)p.push(b);0!==p.length&&a.trimTicks(p);return p},adjustForMinRange:function(){var a=this.options,
	b=this.min,c=this.max,d,p,e,l,x,r,n,w;this.isXAxis&&void 0===this.minRange&&!this.isLog&&(q(a.min)||q(a.max)?this.minRange=null:(h(this.series,function(a){r=a.xData;for(l=n=a.xIncrement?1:r.length-1;0<l;l--)if(x=r[l]-r[l-1],void 0===e||x<e)e=x}),this.minRange=Math.min(5*e,this.dataMax-this.dataMin)));c-b<this.minRange&&(p=this.dataMax-this.dataMin>=this.minRange,w=this.minRange,d=(w-c+b)/2,d=[b-d,z(a.min,b-d)],p&&(d[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin),b=G(d),c=[b+w,z(a.max,b+w)],
	p&&(c[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax),c=F(c),c-b<w&&(d[0]=c-w,d[1]=z(a.min,c-w),b=G(d)));this.min=b;this.max=c},getClosest:function(){var a;this.categories?a=1:h(this.series,function(b){var f=b.closestPointRange,c=b.visible||!b.chart.options.chart.ignoreHiddenSeries;!b.noSharedTooltip&&q(f)&&c&&(a=q(a)?Math.min(a,f):f)});return a},nameToX:function(a){var f=y(this.categories),c=f?this.categories:this.names,d=a.options.x,p;a.series.requireSorting=!1;q(d)||(d=!1===this.options.uniqueNames?
	a.series.autoIncrement():b(a.name,c));-1===d?f||(p=c.length):p=d;void 0!==p&&(this.names[p]=a.name);return p},updateNames:function(){var a=this;0<this.names.length&&(this.names.length=0,this.minRange=this.userMinRange,h(this.series||[],function(b){b.xIncrement=null;if(!b.points||b.isDirtyData)b.processData(),b.generatePoints();h(b.points,function(f,c){var t;f.options&&(t=a.nameToX(f),void 0!==t&&t!==f.x&&(f.x=t,b.xData[c]=t))})}))},setAxisTranslation:function(a){var b=this,f=b.max-b.min,c=b.axisPointRange||
	0,d,p=0,e=0,l=b.linkedParent,r=!!b.categories,n=b.transA,w=b.isXAxis;if(w||r||c)d=b.getClosest(),l?(p=l.minPointOffset,e=l.pointRangePadding):h(b.series,function(a){var f=r?1:w?z(a.options.pointRange,d,0):b.axisPointRange||0;a=a.options.pointPlacement;c=Math.max(c,f);b.single||(p=Math.max(p,H(a)?0:f/2),e=Math.max(e,"on"===a?0:f))}),l=b.ordinalSlope&&d?b.ordinalSlope/d:1,b.minPointOffset=p*=l,b.pointRangePadding=e*=l,b.pointRange=Math.min(c,f),w&&(b.closestPointRange=d);a&&(b.oldTransA=n);b.translationSlope=
	b.transA=n=b.options.staticScale||b.len/(f+e||1);b.transB=b.horiz?b.left:b.bottom;b.minPixelPadding=n*p},minFromRange:function(){return this.max-this.range},setTickInterval:function(b){var f=this,d=f.chart,p=f.options,e=f.isLog,l=f.log2lin,r=f.isDatetimeAxis,x=f.isXAxis,w=f.isLinked,y=p.maxPadding,E=p.minPadding,k=p.tickInterval,I=p.tickPixelInterval,m=f.categories,H=f.threshold,u=f.softThreshold,L,v,M,A;r||m||w||this.getTickAmount();M=z(f.userMin,p.min);A=z(f.userMax,p.max);w?(f.linkedParent=d[f.coll][p.linkedTo],
	d=f.linkedParent.getExtremes(),f.min=z(d.min,d.dataMin),f.max=z(d.max,d.dataMax),p.type!==f.linkedParent.options.type&&a.error(11,1)):(!u&&q(H)&&(f.dataMin>=H?(L=H,E=0):f.dataMax<=H&&(v=H,y=0)),f.min=z(M,L,f.dataMin),f.max=z(A,v,f.dataMax));e&&(f.positiveValuesOnly&&!b&&0>=Math.min(f.min,z(f.dataMin,f.min))&&a.error(10,1),f.min=g(l(f.min),15),f.max=g(l(f.max),15));f.range&&q(f.max)&&(f.userMin=f.min=M=Math.max(f.min,f.minFromRange()),f.userMax=A=f.max,f.range=null);n(f,"foundExtremes");f.beforePadding&&
	f.beforePadding();f.adjustForMinRange();!(m||f.axisPointRange||f.usePercentage||w)&&q(f.min)&&q(f.max)&&(l=f.max-f.min)&&(!q(M)&&E&&(f.min-=l*E),!q(A)&&y&&(f.max+=l*y));D(p.softMin)&&(f.min=Math.min(f.min,p.softMin));D(p.softMax)&&(f.max=Math.max(f.max,p.softMax));D(p.floor)&&(f.min=Math.max(f.min,p.floor));D(p.ceiling)&&(f.max=Math.min(f.max,p.ceiling));u&&q(f.dataMin)&&(H=H||0,!q(M)&&f.min<H&&f.dataMin>=H?f.min=H:!q(A)&&f.max>H&&f.dataMax<=H&&(f.max=H));f.tickInterval=f.min===f.max||void 0===f.min||
	void 0===f.max?1:w&&!k&&I===f.linkedParent.options.tickPixelInterval?k=f.linkedParent.tickInterval:z(k,this.tickAmount?(f.max-f.min)/Math.max(this.tickAmount-1,1):void 0,m?1:(f.max-f.min)*I/Math.max(f.len,I));x&&!b&&h(f.series,function(a){a.processData(f.min!==f.oldMin||f.max!==f.oldMax)});f.setAxisTranslation(!0);f.beforeSetTickPositions&&f.beforeSetTickPositions();f.postProcessTickInterval&&(f.tickInterval=f.postProcessTickInterval(f.tickInterval));f.pointRange&&!k&&(f.tickInterval=Math.max(f.pointRange,
	f.tickInterval));b=z(p.minTickInterval,f.isDatetimeAxis&&f.closestPointRange);!k&&f.tickInterval<b&&(f.tickInterval=b);r||e||k||(f.tickInterval=B(f.tickInterval,null,c(f.tickInterval),z(p.allowDecimals,!(.5<f.tickInterval&&5>f.tickInterval&&1E3<f.max&&9999>f.max)),!!this.tickAmount));this.tickAmount||(f.tickInterval=f.unsquish());this.setTickPositions()},setTickPositions:function(){var a=this.options,b,c=a.tickPositions,d=a.tickPositioner,p=a.startOnTick,l=a.endOnTick;this.tickmarkOffset=this.categories&&
	"between"===a.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===a.minorTickInterval&&this.tickInterval?this.tickInterval/5:a.minorTickInterval;this.single=this.min===this.max&&q(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==a.allowDecimals);this.tickPositions=b=c&&c.slice();!b&&(b=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,a.units),this.min,this.max,a.startOfWeek,this.ordinalPositions,this.closestPointRange,
	!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max),b.length>this.len&&(b=[b[0],b.pop()]),this.tickPositions=b,d&&(d=d.apply(this,[this.min,this.max])))&&(this.tickPositions=b=d);this.paddedTicks=b.slice(0);this.trimTicks(b,p,l);this.isLinked||(this.single&&(this.min-=.5,this.max+=.5),c||d||this.adjustTickAmount())},trimTicks:function(a,b,c){var f=a[0],d=a[a.length-1],p=this.minPointOffset||0;if(!this.isLinked){if(b&&
	-Infinity!==f)this.min=f;else for(;this.min-p>a[0];)a.shift();if(c)this.max=d;else for(;this.max+p<a[a.length-1];)a.pop();0===a.length&&q(f)&&a.push((d+f)/2)}},alignToOthers:function(){var a={},b,c=this.options;!1===this.chart.options.chart.alignTicks||!1===c.alignTicks||this.isLog||h(this.chart[this.coll],function(f){var c=f.options,c=[f.horiz?c.left:c.top,c.width,c.height,c.pane].join();f.series.length&&(a[c]?b=!0:a[c]=1)});return b},getTickAmount:function(){var a=this.options,b=a.tickAmount,c=
	a.tickPixelInterval;!q(a.tickInterval)&&this.len<c&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(b=2);!b&&this.alignToOthers()&&(b=Math.ceil(this.len/c)+1);4>b&&(this.finalTickAmt=b,b=5);this.tickAmount=b},adjustTickAmount:function(){var a=this.tickInterval,b=this.tickPositions,c=this.tickAmount,d=this.finalTickAmt,p=b&&b.length;if(p<c){for(;b.length<c;)b.push(g(b[b.length-1]+a));this.transA*=(p-1)/(c-1);this.max=b[b.length-1]}else p>c&&(this.tickInterval*=2,this.setTickPositions());
	if(q(d)){for(a=c=b.length;a--;)(3===d&&1===a%2||2>=d&&0<a&&a<c-1)&&b.splice(a,1);this.finalTickAmt=void 0}},setScale:function(){var a,b;this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();b=this.len!==this.oldAxisLength;h(this.series,function(b){if(b.isDirtyData||b.isDirty||b.xAxis.isDirty)a=!0});b||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.resetStacks&&this.resetStacks(),this.forceRedraw=
	!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,this.isDirty||(this.isDirty=b||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks()},setExtremes:function(a,b,c,d,p){var f=this,l=f.chart;c=z(c,!0);h(f.series,function(a){delete a.kdTree});p=e(p,{min:a,max:b});n(f,"setExtremes",p,function(){f.userMin=a;f.userMax=b;f.eventArgs=p;c&&l.redraw(d)})},zoom:function(a,b){var f=this.dataMin,c=this.dataMax,d=this.options,
	p=Math.min(f,z(d.min,f)),d=Math.max(c,z(d.max,c));if(a!==this.min||b!==this.max)this.allowZoomOutside||(q(f)&&(a<p&&(a=p),a>d&&(a=d)),q(c)&&(b<p&&(b=p),b>d&&(b=d))),this.displayBtn=void 0!==a||void 0!==b,this.setExtremes(a,b,!1,void 0,{trigger:"zoom"});return!0},setAxisSize:function(){var a=this.chart,b=this.options,c=b.offsets||[0,0,0,0],d=this.horiz,p=z(b.width,a.plotWidth-c[3]+c[1]),l=z(b.height,a.plotHeight-c[0]+c[2]),e=z(b.top,a.plotTop+c[0]),b=z(b.left,a.plotLeft+c[3]),c=/%$/;c.test(l)&&(l=
	Math.round(parseFloat(l)/100*a.plotHeight));c.test(e)&&(e=Math.round(parseFloat(e)/100*a.plotHeight+a.plotTop));this.left=b;this.top=e;this.width=p;this.height=l;this.bottom=a.chartHeight-l-e;this.right=a.chartWidth-p-b;this.len=Math.max(d?p:l,0);this.pos=d?b:e},getExtremes:function(){var a=this.isLog,b=this.lin2log;return{min:a?g(b(this.min)):this.min,max:a?g(b(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=
	this.isLog,f=this.lin2log,c=b?f(this.min):this.min,b=b?f(this.max):this.max;null===a?a=c:c>a?a=c:b<a&&(a=b);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){a=(z(a,0)-90*this.side+720)%360;return 15<a&&165>a?"right":195<a&&345>a?"left":"center"},tickSize:function(a){var b=this.options,f=b[a+"Length"],c=z(b[a+"Width"],"tick"===a&&this.isXAxis?1:0);if(c&&f)return"inside"===b[a+"Position"]&&(f=-f),[f,c]},labelMetrics:function(){var a=this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style&&
	this.options.labels.style.fontSize,this.ticks[a]&&this.ticks[a].label)},unsquish:function(){var a=this.options.labels,b=this.horiz,c=this.tickInterval,d=c,p=this.len/(((this.categories?1:0)+this.max-this.min)/c),l,e=a.rotation,r=this.labelMetrics(),n,w=Number.MAX_VALUE,g,y=function(a){a/=p||1;a=1<a?Math.ceil(a):1;return a*c};b?(g=!a.staggerLines&&!a.step&&(q(e)?[e]:p<z(a.autoRotationLimit,80)&&a.autoRotation))&&h(g,function(a){var b;if(a===e||a&&-90<=a&&90>=a)n=y(Math.abs(r.h/Math.sin(v*a))),b=n+
	Math.abs(a/360),b<w&&(w=b,l=a,d=n)}):a.step||(d=y(r.h));this.autoRotation=g;this.labelRotation=z(l,e);return d},getSlotWidth:function(){var a=this.chart,b=this.horiz,c=this.options.labels,d=Math.max(this.tickPositions.length-(this.categories?0:1),1),p=a.margin[3];return b&&2>(c.step||0)&&!c.rotation&&(this.staggerLines||1)*this.len/d||!b&&(p&&p-a.spacing[3]||.33*a.chartWidth)},renderUnsquish:function(){var a=this.chart,b=a.renderer,c=this.tickPositions,d=this.ticks,p=this.options.labels,e=this.horiz,
	r=this.getSlotWidth(),x=Math.max(1,Math.round(r-2*(p.padding||5))),n={},w=this.labelMetrics(),g=p.style&&p.style.textOverflow,y,E=0,k,I;H(p.rotation)||(n.rotation=p.rotation||0);h(c,function(a){(a=d[a])&&a.labelLength>E&&(E=a.labelLength)});this.maxLabelLength=E;if(this.autoRotation)E>x&&E>w.h?n.rotation=this.labelRotation:this.labelRotation=0;else if(r&&(y={width:x+"px"},!g))for(y.textOverflow="clip",k=c.length;!e&&k--;)if(I=c[k],x=d[I].label)x.styles&&"ellipsis"===x.styles.textOverflow?x.css({textOverflow:"clip"}):
	d[I].labelLength>r&&x.css({width:r+"px"}),x.getBBox().height>this.len/c.length-(w.h-w.f)&&(x.specCss={textOverflow:"ellipsis"});n.rotation&&(y={width:(E>.5*a.chartHeight?.33*a.chartHeight:a.chartHeight)+"px"},g||(y.textOverflow="ellipsis"));if(this.labelAlign=p.align||this.autoLabelAlign(this.labelRotation))n.align=this.labelAlign;h(c,function(a){var b=(a=d[a])&&a.label;b&&(b.attr(n),y&&b.css(l(y,b.specCss)),delete b.specCss,a.rotation=n.rotation)});this.tickRotCorr=b.rotCorr(w.b,this.labelRotation||
	0,0!==this.side)},hasData:function(){return this.hasVisibleSeries||q(this.min)&&q(this.max)&&!!this.tickPositions},addTitle:function(a){var b=this.chart.renderer,f=this.horiz,c=this.opposite,d=this.options.title,p;this.axisTitle||((p=d.textAlign)||(p=(f?{low:"left",middle:"center",high:"right"}:{low:c?"right":"left",middle:"center",high:c?"left":"right"})[d.align]),this.axisTitle=b.text(d.text,0,0,d.useHTML).attr({zIndex:7,rotation:d.rotation||0,align:p}).addClass("highcharts-axis-title").css(d.style).add(this.axisGroup),
	this.axisTitle.isNew=!0);this.axisTitle[a?"show":"hide"](!0)},generateTick:function(a){var b=this.ticks;b[a]?b[a].addLabel():b[a]=new I(this,a)},getOffset:function(){var a=this,b=a.chart,c=b.renderer,d=a.options,p=a.tickPositions,l=a.ticks,e=a.horiz,x=a.side,n=b.inverted&&!a.isZAxis?[1,0,3,2][x]:x,w,g,y=0,E,k=0,I=d.title,D=d.labels,m=0,B=b.axisOffset,b=b.clipOffset,H=[-1,1,1,-1][x],u=d.className,L=a.axisParent,v=this.tickSize("tick");w=a.hasData();a.showAxis=g=w||z(d.showEmpty,!0);a.staggerLines=
	a.horiz&&D.staggerLines;a.axisGroup||(a.gridGroup=c.g("grid").attr({zIndex:d.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(u||"")).add(L),a.axisGroup=c.g("axis").attr({zIndex:d.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(u||"")).add(L),a.labelGroup=c.g("axis-labels").attr({zIndex:D.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+"-labels "+(u||"")).add(L));w||a.isLinked?(h(p,function(b,c){a.generateTick(b,c)}),a.renderUnsquish(),!1===D.reserveSpace||
	0!==x&&2!==x&&{1:"left",3:"right"}[x]!==a.labelAlign&&"center"!==a.labelAlign||h(p,function(a){m=Math.max(l[a].getLabelSize(),m)}),a.staggerLines&&(m*=a.staggerLines,a.labelOffset=m*(a.opposite?-1:1))):r(l,function(a,b){a.destroy();delete l[b]});I&&I.text&&!1!==I.enabled&&(a.addTitle(g),g&&!1!==I.reserveSpace&&(a.titleOffset=y=a.axisTitle.getBBox()[e?"height":"width"],E=I.offset,k=q(E)?0:z(I.margin,e?5:10)));a.renderLine();a.offset=H*z(d.offset,B[x]);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};c=0===x?
	-a.labelMetrics().h:2===x?a.tickRotCorr.y:0;k=Math.abs(m)+k;m&&(k=k-c+H*(e?z(D.y,a.tickRotCorr.y+8*H):D.x));a.axisTitleMargin=z(E,k);B[x]=Math.max(B[x],a.axisTitleMargin+y+H*a.offset,k,w&&p.length&&v?v[0]+H*a.offset:0);p=2*Math.floor(a.axisLine.strokeWidth()/2);0<d.offset&&(p-=2*d.offset);b[n]=Math.max(b[n]||p,p)},getLinePath:function(a){var b=this.chart,c=this.opposite,f=this.offset,d=this.horiz,p=this.left+(c?this.width:0)+f,f=b.chartHeight-this.bottom-(c?this.height:0)+f;c&&(a*=-1);return b.renderer.crispLine(["M",
	d?this.left:p,d?f:this.top,"L",d?b.chartWidth-this.right:p,d?f:b.chartHeight-this.bottom],a)},renderLine:function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))},getTitlePosition:function(){var a=this.horiz,b=this.left,c=this.top,d=this.len,p=this.options.title,l=a?b:c,e=this.opposite,r=this.offset,h=p.x||0,n=p.y||0,w=this.chart.renderer.fontMetrics(p.style&&
	p.style.fontSize,this.axisTitle).f,d={low:l+(a?0:d),middle:l+d/2,high:l+(a?d:0)}[p.align],b=(a?c+this.height:b)+(a?1:-1)*(e?-1:1)*this.axisTitleMargin+(2===this.side?w:0);return{x:a?d+h:b+(e?this.width:0)+r+h,y:a?b+n-(e?this.height:0)+r:d+n}},renderMinorTick:function(a){var b=this.chart.hasRendered&&D(this.oldMin),c=this.minorTicks;c[a]||(c[a]=new I(this,a,"minor"));b&&c[a].isNew&&c[a].render(null,!0);c[a].render(null,!1,1)},renderTick:function(a,b){var c=this.isLinked,f=this.ticks,d=this.chart.hasRendered&&
	D(this.oldMin);if(!c||a>=this.min&&a<=this.max)f[a]||(f[a]=new I(this,a)),d&&f[a].isNew&&f[a].render(b,!0,.1),f[a].render(b)},render:function(){var b=this,c=b.chart,d=b.options,p=b.isLog,l=b.lin2log,e=b.isLinked,n=b.tickPositions,x=b.axisTitle,w=b.ticks,g=b.minorTicks,y=b.alternateBands,k=d.stackLabels,m=d.alternateGridColor,q=b.tickmarkOffset,z=b.axisLine,B=b.showAxis,H=A(c.renderer.globalAnimation),u,L;b.labelEdge.length=0;b.overlap=!1;h([w,g,y],function(a){r(a,function(a){a.isActive=!1})});if(b.hasData()||
	e)b.minorTickInterval&&!b.categories&&h(b.getMinorTickPositions(),function(a){b.renderMinorTick(a)}),n.length&&(h(n,function(a,c){b.renderTick(a,c)}),q&&(0===b.min||b.single)&&(w[-1]||(w[-1]=new I(b,-1,null,!0)),w[-1].render(-1))),m&&h(n,function(f,d){L=void 0!==n[d+1]?n[d+1]+q:b.max-q;0===d%2&&f<b.max&&L<=b.max+(c.polar?-q:q)&&(y[f]||(y[f]=new a.PlotLineOrBand(b)),u=f+q,y[f].options={from:p?l(u):u,to:p?l(L):L,color:m},y[f].render(),y[f].isActive=!0)}),b._addedPlotLB||(h((d.plotLines||[]).concat(d.plotBands||
	[]),function(a){b.addPlotBandOrLine(a)}),b._addedPlotLB=!0);h([w,g,y],function(a){var b,f=[],d=H.duration;r(a,function(a,b){a.isActive||(a.render(b,!1,0),a.isActive=!1,f.push(b))});E(function(){for(b=f.length;b--;)a[f[b]]&&!a[f[b]].isActive&&(a[f[b]].destroy(),delete a[f[b]])},a!==y&&c.hasRendered&&d?d:0)});z&&(z[z.isPlaced?"animate":"attr"]({d:this.getLinePath(z.strokeWidth())}),z.isPlaced=!0,z[B?"show":"hide"](!0));x&&B&&(d=b.getTitlePosition(),D(d.y)?(x[x.isNew?"attr":"animate"](d),x.isNew=!1):
	(x.attr("y",-9999),x.isNew=!0));k&&k.enabled&&b.renderStackTotals();b.isDirty=!1},redraw:function(){this.visible&&(this.render(),h(this.plotLinesAndBands,function(a){a.render()}));h(this.series,function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),destroy:function(a){var c=this,f=c.stacks,d=c.plotLinesAndBands,p;a||M(c);r(f,function(a,b){u(a);f[b]=null});h([c.ticks,c.minorTicks,c.alternateBands],function(a){u(a)});if(d)for(a=d.length;a--;)d[a].destroy();h("stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross".split(" "),
	function(a){c[a]&&(c[a]=c[a].destroy())});for(p in c.plotLinesAndBandsGroups)c.plotLinesAndBandsGroups[p]=c.plotLinesAndBandsGroups[p].destroy();r(c,function(a,f){-1===b(f,c.keepProps)&&delete c[f]})},drawCrosshair:function(a,b){var c,f=this.crosshair,d=z(f.snap,!0),p,l=this.cross;a||(a=this.cross&&this.cross.e);this.crosshair&&!1!==(q(b)||!d)?(d?q(b)&&(p=this.isXAxis?b.plotX:this.len-b.plotY):p=a&&(this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos),q(p)&&(c=this.getPlotLinePath(b&&(this.isXAxis?
	b.x:z(b.stackY,b.y)),null,null,null,p)||null),q(c)?(b=this.categories&&!this.isRadial,l||(this.cross=l=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+(b?"category ":"thin ")+f.className).attr({zIndex:z(f.zIndex,2)}).add(),l.attr({stroke:f.color||(b?m("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":z(f.width,1)}),f.dashStyle&&l.attr({dashstyle:f.dashStyle})),l.show().attr({d:c}),b&&!f.width&&l.attr({"stroke-width":this.transA}),this.cross.e=a):this.hideCrosshair()):
	this.hideCrosshair()},hideCrosshair:function(){this.cross&&this.cross.hide()}});return a.Axis=L}(K);(function(a){var C=a.Axis,A=a.Date,G=a.dateFormat,F=a.defaultOptions,m=a.defined,g=a.each,k=a.extend,q=a.getMagnitude,v=a.getTZOffset,u=a.normalizeTickInterval,h=a.pick,e=a.timeUnits;C.prototype.getTimeTicks=function(a,d,c,w){var b=[],n={},D=F.global.useUTC,q,l=new A(d-Math.max(v(d),v(c))),B=A.hcMakeTime,r=a.unitRange,z=a.count,u;if(m(d)){l[A.hcSetMilliseconds](r>=e.second?0:z*Math.floor(l.getMilliseconds()/
	z));if(r>=e.second)l[A.hcSetSeconds](r>=e.minute?0:z*Math.floor(l.getSeconds()/z));if(r>=e.minute)l[A.hcSetMinutes](r>=e.hour?0:z*Math.floor(l[A.hcGetMinutes]()/z));if(r>=e.hour)l[A.hcSetHours](r>=e.day?0:z*Math.floor(l[A.hcGetHours]()/z));if(r>=e.day)l[A.hcSetDate](r>=e.month?1:z*Math.floor(l[A.hcGetDate]()/z));r>=e.month&&(l[A.hcSetMonth](r>=e.year?0:z*Math.floor(l[A.hcGetMonth]()/z)),q=l[A.hcGetFullYear]());if(r>=e.year)l[A.hcSetFullYear](q-q%z);if(r===e.week)l[A.hcSetDate](l[A.hcGetDate]()-l[A.hcGetDay]()+
	h(w,1));q=l[A.hcGetFullYear]();w=l[A.hcGetMonth]();var p=l[A.hcGetDate](),E=l[A.hcGetHours]();if(A.hcTimezoneOffset||A.hcGetTimezoneOffset)u=(!D||!!A.hcGetTimezoneOffset)&&(c-d>4*e.month||v(d)!==v(c)),l=l.getTime(),l=new A(l+v(l));D=l.getTime();for(d=1;D<c;)b.push(D),D=r===e.year?B(q+d*z,0):r===e.month?B(q,w+d*z):!u||r!==e.day&&r!==e.week?u&&r===e.hour?B(q,w,p,E+d*z):D+r*z:B(q,w,p+d*z*(r===e.day?1:7)),d++;b.push(D);r<=e.hour&&1E4>b.length&&g(b,function(a){0===a%18E5&&"000000000"===G("%H%M%S%L",a)&&
	(n[a]="day")})}b.info=k(a,{higherRanks:n,totalRange:r*z});return b};C.prototype.normalizeTimeTickInterval=function(a,d){var c=d||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];d=c[c.length-1];var h=e[d[0]],b=d[1],n;for(n=0;n<c.length&&!(d=c[n],h=e[d[0]],b=d[1],c[n+1]&&a<=(h*b[b.length-1]+e[c[n+1][0]])/2);n++);h===e.year&&a<5*h&&(b=[1,2,5]);a=u(a/h,b,
	"year"===d[0]?Math.max(q(a/h),1):1);return{unitRange:h,count:a,unitName:d[0]}}})(K);(function(a){var C=a.Axis,A=a.getMagnitude,G=a.map,F=a.normalizeTickInterval,m=a.pick;C.prototype.getLogTickPositions=function(a,k,q,v){var g=this.options,h=this.len,e=this.lin2log,n=this.log2lin,d=[];v||(this._minorAutoInterval=null);if(.5<=a)a=Math.round(a),d=this.getLinearTickPositions(a,k,q);else if(.08<=a)for(var h=Math.floor(k),c,w,b,y,D,g=.3<a?[1,2,4]:.15<a?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];h<q+1&&!D;h++)for(w=
	g.length,c=0;c<w&&!D;c++)b=n(e(h)*g[c]),b>k&&(!v||y<=q)&&void 0!==y&&d.push(y),y>q&&(D=!0),y=b;else k=e(k),q=e(q),a=g[v?"minorTickInterval":"tickInterval"],a=m("auto"===a?null:a,this._minorAutoInterval,g.tickPixelInterval/(v?5:1)*(q-k)/((v?h/this.tickPositions.length:h)||1)),a=F(a,null,A(a)),d=G(this.getLinearTickPositions(a,k,q),n),v||(this._minorAutoInterval=a/5);v||(this.tickInterval=a);return d};C.prototype.log2lin=function(a){return Math.log(a)/Math.LN10};C.prototype.lin2log=function(a){return Math.pow(10,
	a)}})(K);(function(a,C){var A=a.arrayMax,G=a.arrayMin,F=a.defined,m=a.destroyObjectProperties,g=a.each,k=a.erase,q=a.merge,v=a.pick;a.PlotLineOrBand=function(a,h){this.axis=a;h&&(this.options=h,this.id=h.id)};a.PlotLineOrBand.prototype={render:function(){var g=this,h=g.axis,e=h.horiz,n=g.options,d=n.label,c=g.label,w=n.to,b=n.from,y=n.value,k=F(b)&&F(w),m=F(y),l=g.svgElem,B=!l,r=[],z=n.color,M=v(n.zIndex,0),p=n.events,r={"class":"highcharts-plot-"+(k?"band ":"line ")+(n.className||"")},E={},I=h.chart.renderer,
	L=k?"bands":"lines",f=h.log2lin;h.isLog&&(b=f(b),w=f(w),y=f(y));m?(r={stroke:z,"stroke-width":n.width},n.dashStyle&&(r.dashstyle=n.dashStyle)):k&&(z&&(r.fill=z),n.borderWidth&&(r.stroke=n.borderColor,r["stroke-width"]=n.borderWidth));E.zIndex=M;L+="-"+M;(z=h.plotLinesAndBandsGroups[L])||(h.plotLinesAndBandsGroups[L]=z=I.g("plot-"+L).attr(E).add());B&&(g.svgElem=l=I.path().attr(r).add(z));if(m)r=h.getPlotLinePath(y,l.strokeWidth());else if(k)r=h.getPlotBandPath(b,w,n);else return;B&&r&&r.length?(l.attr({d:r}),
	p&&a.objectEach(p,function(a,b){l.on(b,function(a){p[b].apply(g,[a])})})):l&&(r?(l.show(),l.animate({d:r})):(l.hide(),c&&(g.label=c=c.destroy())));d&&F(d.text)&&r&&r.length&&0<h.width&&0<h.height&&!r.flat?(d=q({align:e&&k&&"center",x:e?!k&&4:10,verticalAlign:!e&&k&&"middle",y:e?k?16:10:k?6:-4,rotation:e&&!k&&90},d),this.renderLabel(d,r,k,M)):c&&c.hide();return g},renderLabel:function(a,h,e,n){var d=this.label,c=this.axis.chart.renderer;d||(d={align:a.textAlign||a.align,rotation:a.rotation,"class":"highcharts-plot-"+
	(e?"band":"line")+"-label "+(a.className||"")},d.zIndex=n,this.label=d=c.text(a.text,0,0,a.useHTML).attr(d).add(),d.css(a.style));n=[h[1],h[4],e?h[6]:h[1]];h=[h[2],h[5],e?h[7]:h[2]];e=G(n);c=G(h);d.align(a,!1,{x:e,y:c,width:A(n)-e,height:A(h)-c});d.show()},destroy:function(){k(this.axis.plotLinesAndBands,this);delete this.axis;m(this)}};a.extend(C.prototype,{getPlotBandPath:function(a,h){var e=this.getPlotLinePath(h,null,null,!0),n=this.getPlotLinePath(a,null,null,!0),d=this.horiz,c=1;a=a<this.min&&
	h<this.min||a>this.max&&h>this.max;n&&e?(a&&(n.flat=n.toString()===e.toString(),c=0),n.push(d&&e[4]===n[4]?e[4]+c:e[4],d||e[5]!==n[5]?e[5]:e[5]+c,d&&e[1]===n[1]?e[1]+c:e[1],d||e[2]!==n[2]?e[2]:e[2]+c)):n=null;return n},addPlotBand:function(a){return this.addPlotBandOrLine(a,"plotBands")},addPlotLine:function(a){return this.addPlotBandOrLine(a,"plotLines")},addPlotBandOrLine:function(g,h){var e=(new a.PlotLineOrBand(this,g)).render(),n=this.userOptions;e&&(h&&(n[h]=n[h]||[],n[h].push(g)),this.plotLinesAndBands.push(e));
	return e},removePlotBandOrLine:function(a){for(var h=this.plotLinesAndBands,e=this.options,n=this.userOptions,d=h.length;d--;)h[d].id===a&&h[d].destroy();g([e.plotLines||[],n.plotLines||[],e.plotBands||[],n.plotBands||[]],function(c){for(d=c.length;d--;)c[d].id===a&&k(c,c[d])})},removePlotBand:function(a){this.removePlotBandOrLine(a)},removePlotLine:function(a){this.removePlotBandOrLine(a)}})})(K,S);(function(a){var C=a.dateFormat,A=a.each,G=a.extend,F=a.format,m=a.isNumber,g=a.map,k=a.merge,q=a.pick,
	v=a.splat,u=a.syncTimeout,h=a.timeUnits;a.Tooltip=function(){this.init.apply(this,arguments)};a.Tooltip.prototype={init:function(a,h){this.chart=a;this.options=h;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.split=h.split&&!a.inverted;this.shared=h.shared||this.split},cleanSplit:function(a){A(this.chart.series,function(e){var d=e&&e.tt;d&&(!d.isActive||a?e.tt=d.destroy():d.isActive=!1)})},getLabel:function(){var a=this.chart.renderer,h=this.options;this.label||(this.split?this.label=
	a.g("tooltip"):(this.label=a.label("",0,0,h.shape||"callout",null,null,h.useHTML,null,"tooltip").attr({padding:h.padding,r:h.borderRadius}),this.label.attr({fill:h.backgroundColor,"stroke-width":h.borderWidth}).css(h.style).shadow(h.shadow)),this.label.attr({zIndex:8}).add());return this.label},update:function(a){this.destroy();k(!0,this.chart.options.tooltip.userOptions,a);this.init(this.chart,k(!0,this.options,a))},destroy:function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&
	(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());clearTimeout(this.hideTimer);clearTimeout(this.tooltipTimeout)},move:function(a,h,d,c){var e=this,b=e.now,n=!1!==e.options.animation&&!e.isHidden&&(1<Math.abs(a-b.x)||1<Math.abs(h-b.y)),g=e.followPointer||1<e.len;G(b,{x:n?(2*b.x+a)/3:a,y:n?(b.y+h)/2:h,anchorX:g?void 0:n?(2*b.anchorX+d)/3:d,anchorY:g?void 0:n?(b.anchorY+c)/2:c});e.getLabel().attr(b);n&&(clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){e&&e.move(a,
	h,d,c)},32))},hide:function(a){var e=this;clearTimeout(this.hideTimer);a=q(a,this.options.hideDelay,500);this.isHidden||(this.hideTimer=u(function(){e.getLabel()[a?"fadeOut":"hide"]();e.isHidden=!0},a))},getAnchor:function(a,h){var d,c=this.chart,e=c.inverted,b=c.plotTop,n=c.plotLeft,k=0,m=0,l,q;a=v(a);d=a[0].tooltipPos;this.followPointer&&h&&(void 0===h.chartX&&(h=c.pointer.normalize(h)),d=[h.chartX-c.plotLeft,h.chartY-b]);d||(A(a,function(a){l=a.series.yAxis;q=a.series.xAxis;k+=a.plotX+(!e&&q?q.left-
	n:0);m+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!e&&l?l.top-b:0)}),k/=a.length,m/=a.length,d=[e?c.plotWidth-m:k,this.shared&&!e&&1<a.length&&h?h.chartY-b:e?c.plotHeight-k:m]);return g(d,Math.round)},getPosition:function(a,h,d){var c=this.chart,e=this.distance,b={},n=d.h||0,g,k=["y",c.chartHeight,h,d.plotY+c.plotTop,c.plotTop,c.plotTop+c.plotHeight],l=["x",c.chartWidth,a,d.plotX+c.plotLeft,c.plotLeft,c.plotLeft+c.plotWidth],m=!this.followPointer&&q(d.ttBelow,!c.inverted===!!d.negative),r=function(a,
	c,d,f,p,l){var h=d<f-e,r=f+e+d<c,g=f-e-d;f+=e;if(m&&r)b[a]=f;else if(!m&&h)b[a]=g;else if(h)b[a]=Math.min(l-d,0>g-n?g:g-n);else if(r)b[a]=Math.max(p,f+n+d>c?f:f+n);else return!1},z=function(a,c,d,f){var p;f<e||f>c-e?p=!1:b[a]=f<d/2?1:f>c-d/2?c-d-2:f-d/2;return p},v=function(a){var b=k;k=l;l=b;g=a},p=function(){!1!==r.apply(0,k)?!1!==z.apply(0,l)||g||(v(!0),p()):g?b.x=b.y=0:(v(!0),p())};(c.inverted||1<this.len)&&v();p();return b},defaultFormatter:function(a){var e=this.points||v(this),d;d=[a.tooltipFooterHeaderFormatter(e[0])];
	d=d.concat(a.bodyFormatter(e));d.push(a.tooltipFooterHeaderFormatter(e[0],!0));return d},refresh:function(a,h){var d,c=this.options,e,b=a,g,n={},k=[];d=c.formatter||this.defaultFormatter;var n=this.shared,l;clearTimeout(this.hideTimer);this.followPointer=v(b)[0].series.tooltipOptions.followPointer;g=this.getAnchor(b,h);h=g[0];e=g[1];!n||b.series&&b.series.noSharedTooltip?n=b.getLabelConfig():(A(b,function(a){a.setState("hover");k.push(a.getLabelConfig())}),n={x:b[0].category,y:b[0].y},n.points=k,
	b=b[0]);this.len=k.length;n=d.call(n,this);l=b.series;this.distance=q(l.tooltipOptions.distance,16);!1===n?this.hide():(d=this.getLabel(),this.isHidden&&d.attr({opacity:1}).show(),this.split?this.renderSplit(n,a):(c.style.width||d.css({width:this.chart.spacingBox.width}),d.attr({text:n&&n.join?n.join(""):n}),d.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+q(b.colorIndex,l.colorIndex)),d.attr({stroke:c.borderColor||b.color||l.color||"#666666"}),this.updatePosition({plotX:h,plotY:e,
	negative:b.negative,ttBelow:b.ttBelow,h:g[2]||0})),this.isHidden=!1)},renderSplit:function(e,h){var d=this,c=[],g=this.chart,b=g.renderer,n=!0,k=this.options,m,l=this.getLabel();A(e.slice(0,h.length+1),function(a,e){e=h[e-1]||{isHeader:!0,plotX:h[0].plotX};var r=e.series||d,w=r.tt,p=e.series||{},y="highcharts-color-"+q(e.colorIndex,p.colorIndex,"none");w||(r.tt=w=b.label(null,null,null,"callout").addClass("highcharts-tooltip-box "+y).attr({padding:k.padding,r:k.borderRadius,fill:k.backgroundColor,
	stroke:e.color||p.color||"#333333","stroke-width":k.borderWidth}).add(l));w.isActive=!0;w.attr({text:a});w.css(k.style);a=w.getBBox();p=a.width+w.strokeWidth();e.isHeader?(m=a.height,p=Math.max(0,Math.min(e.plotX+g.plotLeft-p/2,g.chartWidth-p))):p=e.plotX+g.plotLeft-q(k.distance,16)-p;0>p&&(n=!1);a=(e.series&&e.series.yAxis&&e.series.yAxis.pos)+(e.plotY||0);a-=g.plotTop;c.push({target:e.isHeader?g.plotHeight+m:a,rank:e.isHeader?1:0,size:r.tt.getBBox().height+1,point:e,x:p,tt:w})});this.cleanSplit();
	a.distribute(c,g.plotHeight+m);A(c,function(a){var b=a.point,c=b.series;a.tt.attr({visibility:void 0===a.pos?"hidden":"inherit",x:n||b.isHeader?a.x:b.plotX+g.plotLeft+q(k.distance,16),y:a.pos+g.plotTop,anchorX:b.isHeader?b.plotX+g.plotLeft:b.plotX+c.xAxis.pos,anchorY:b.isHeader?a.pos+g.plotTop-15:b.plotY+c.yAxis.pos})})},updatePosition:function(a){var e=this.chart,d=this.getLabel(),d=(this.options.positioner||this.getPosition).call(this,d.width,d.height,a);this.move(Math.round(d.x),Math.round(d.y||
	0),a.plotX+e.plotLeft,a.plotY+e.plotTop)},getDateFormat:function(a,g,d,c){var e=C("%m-%d %H:%M:%S.%L",g),b,n,k={millisecond:15,second:12,minute:9,hour:6,day:3},m="millisecond";for(n in h){if(a===h.week&&+C("%w",g)===d&&"00:00:00.000"===e.substr(6)){n="week";break}if(h[n]>a){n=m;break}if(k[n]&&e.substr(k[n])!=="01-01 00:00:00.000".substr(k[n]))break;"week"!==n&&(m=n)}n&&(b=c[n]);return b},getXDateFormat:function(a,h,d){h=h.dateTimeLabelFormats;var c=d&&d.closestPointRange;return(c?this.getDateFormat(c,
	a.x,d.options.startOfWeek,h):h.day)||h.year},tooltipFooterHeaderFormatter:function(a,h){var d=h?"footer":"header";h=a.series;var c=h.tooltipOptions,e=c.xDateFormat,b=h.xAxis,g=b&&"datetime"===b.options.type&&m(a.key),d=c[d+"Format"];g&&!e&&(e=this.getXDateFormat(a,c,b));g&&e&&(d=d.replace("{point.key}","{point.key:"+e+"}"));return F(d,{point:a,series:h})},bodyFormatter:function(a){return g(a,function(a){var d=a.series.tooltipOptions;return(d.pointFormatter||a.point.tooltipFormatter).call(a.point,
	d.pointFormat)})}}})(K);(function(a){var C=a.addEvent,A=a.attr,G=a.charts,F=a.color,m=a.css,g=a.defined,k=a.doc,q=a.each,v=a.extend,u=a.fireEvent,h=a.offset,e=a.pick,n=a.removeEvent,d=a.splat,c=a.Tooltip,w=a.win;a.Pointer=function(a,c){this.init(a,c)};a.Pointer.prototype={init:function(a,d){this.options=d;this.chart=a;this.runChartClick=d.chart.events&&!!d.chart.events.click;this.pinchDown=[];this.lastValidTouch={};c&&d.tooltip.enabled&&(a.tooltip=new c(a,d.tooltip),this.followTouchMove=e(d.tooltip.followTouchMove,
	!0));this.setDOMEvents()},zoomOption:function(a){var b=this.chart,c=b.options.chart,d=c.zoomType||"",b=b.inverted;/touch/.test(a.type)&&(d=e(c.pinchType,d));this.zoomX=a=/x/.test(d);this.zoomY=d=/y/.test(d);this.zoomHor=a&&!b||d&&b;this.zoomVert=d&&!b||a&&b;this.hasZoom=a||d},normalize:function(a,c){var b,d;a=a||w.event;a.target||(a.target=a.srcElement);d=a.touches?a.touches.length?a.touches.item(0):a.changedTouches[0]:a;c||(this.chartPosition=c=h(this.chart.container));void 0===d.pageX?(b=Math.max(a.x,
	a.clientX-c.left),c=a.y):(b=d.pageX-c.left,c=d.pageY-c.top);return v(a,{chartX:Math.round(b),chartY:Math.round(c)})},getCoordinates:function(a){var b={xAxis:[],yAxis:[]};q(this.chart.axes,function(c){b[c.isXAxis?"xAxis":"yAxis"].push({axis:c,value:c.toValue(a[c.horiz?"chartX":"chartY"])})});return b},getKDPoints:function(a,c,d){var b=[],l,h,r;q(a,function(a){l=a.noSharedTooltip&&c;h=!c&&a.directTouch;a.visible&&!h&&e(a.options.enableMouseTracking,!0)&&(r=a.searchPoint(d,!l&&0>a.options.findNearestPointBy.indexOf("y")))&&
	r.series&&b.push(r)});b.sort(function(a,b){var d=a.distX-b.distX,l=a.dist-b.dist,e=(b.series.group&&b.series.group.zIndex)-(a.series.group&&a.series.group.zIndex);return 0!==d&&c?d:0!==l?l:0!==e?e:a.series.index>b.series.index?-1:1});if(c&&b[0]&&!b[0].series.noSharedTooltip)for(a=b.length;a--;)(b[a].x!==b[0].x||b[a].series.noSharedTooltip)&&b.splice(a,1);return b},getPointFromEvent:function(a){a=a.target;for(var b;a&&!b;)b=a.point,a=a.parentNode;return b},getChartCoordinatesFromPoint:function(a,c){var b=
	a.series,d=b.xAxis,b=b.yAxis;if(d&&b)return c?{chartX:d.len+d.pos-a.clientX,chartY:b.len+b.pos-a.plotY}:{chartX:a.clientX+d.pos,chartY:a.plotY+b.pos}},getHoverData:function(b,c,d,e,l,h){var r=b,g=c,r=l?d:[g];e=!(!e||!b);c=g&&!g.stickyTracking;var n=function(a,b){return 0===b},p;e?n=function(a){return a===b}:c?n=function(a){return a.series===g}:r=a.grep(d,function(a){return a.stickyTracking});p=e&&!l?[b]:this.getKDPoints(r,l,h);g=(r=a.find(p,n))&&r.series;e||c||!l||(p=this.getKDPoints(d,l,h));p.sort(function(a,
	b){return a.series.index-b.series.index});return{hoverPoint:r,hoverSeries:g,hoverPoints:p}},runPointActions:function(b,c){var d=this.chart,h=d.tooltip,l=h?h.shared:!1,g=c||d.hoverPoint,r=g&&g.series||d.hoverSeries;c=this.getHoverData(g,r,d.series,!!c||r&&r.directTouch&&this.isDirectTouch,l,b);var n,w,g=c.hoverPoint;n=(r=c.hoverSeries)&&r.tooltipOptions.followPointer;w=(l=l&&g&&!g.series.noSharedTooltip)?c.hoverPoints:g?[g]:[];if(g&&(g!==d.hoverPoint||h&&h.isHidden)){q(d.hoverPoints||[],function(b){-1===
	a.inArray(b,w)&&b.setState()});q(w||[],function(a){a.setState("hover")});if(d.hoverSeries!==r)r.onMouseOver();d.hoverPoint&&d.hoverPoint.firePointEvent("mouseOut");g.firePointEvent("mouseOver");d.hoverPoints=w;d.hoverPoint=g;h&&h.refresh(l?w:g,b)}else n&&h&&!h.isHidden&&(r=h.getAnchor([{}],b),h.updatePosition({plotX:r[0],plotY:r[1]}));this.unDocMouseMove||(this.unDocMouseMove=C(k,"mousemove",function(b){var c=G[a.hoverChartIndex];if(c)c.pointer.onDocumentMouseMove(b)}));q(d.axes,function(c){e(c.crosshair.snap,
	!0)?a.find(w,function(a){return a.series[c.coll]===c})?c.drawCrosshair(b,g):c.hideCrosshair():c.drawCrosshair(b)})},reset:function(a,c){var b=this.chart,e=b.hoverSeries,l=b.hoverPoint,h=b.hoverPoints,g=b.tooltip,n=g&&g.shared?h:l;a&&n&&q(d(n),function(b){b.series.isCartesian&&void 0===b.plotX&&(a=!1)});if(a)g&&n&&(g.refresh(n),l&&(l.setState(l.state,!0),q(b.axes,function(a){a.crosshair&&a.drawCrosshair(null,l)})));else{if(l)l.onMouseOut();h&&q(h,function(a){a.setState()});if(e)e.onMouseOut();g&&g.hide(c);
	this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());q(b.axes,function(a){a.hideCrosshair()});this.hoverX=b.hoverPoints=b.hoverPoint=null}},scaleGroups:function(a,c){var b=this.chart,d;q(b.series,function(e){d=a||e.getPlotBox();e.xAxis&&e.xAxis.zoomEnabled&&e.group&&(e.group.attr(d),e.markerGroup&&(e.markerGroup.attr(d),e.markerGroup.clip(c?b.clipRect:null)),e.dataLabelsGroup&&e.dataLabelsGroup.attr(d))});b.clipRect.attr(c||b.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=
	a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},drag:function(a){var b=this.chart,c=b.options.chart,d=a.chartX,e=a.chartY,h=this.zoomHor,g=this.zoomVert,n=b.plotLeft,w=b.plotTop,p=b.plotWidth,k=b.plotHeight,m,q=this.selectionMarker,f=this.mouseDownX,t=this.mouseDownY,v=c.panKey&&a[c.panKey+"Key"];q&&q.touch||(d<n?d=n:d>n+p&&(d=n+p),e<w?e=w:e>w+k&&(e=w+k),this.hasDragged=Math.sqrt(Math.pow(f-d,2)+Math.pow(t-e,2)),10<this.hasDragged&&(m=b.isInsidePlot(f-
	n,t-w),b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&m&&!v&&!q&&(this.selectionMarker=q=b.renderer.rect(n,w,h?1:p,g?1:k,0).attr({fill:c.selectionMarkerFill||F("#335cad").setOpacity(.25).get(),"class":"highcharts-selection-marker",zIndex:7}).add()),q&&h&&(d-=f,q.attr({width:Math.abs(d),x:(0<d?0:d)+f})),q&&g&&(d=e-t,q.attr({height:Math.abs(d),y:(0<d?0:d)+t})),m&&!q&&c.panning&&b.pan(a,c.panning)))},drop:function(a){var b=this,c=this.chart,d=this.hasPinched;if(this.selectionMarker){var e={originalEvent:a,
	xAxis:[],yAxis:[]},h=this.selectionMarker,r=h.attr?h.attr("x"):h.x,n=h.attr?h.attr("y"):h.y,w=h.attr?h.attr("width"):h.width,p=h.attr?h.attr("height"):h.height,k;if(this.hasDragged||d)q(c.axes,function(c){if(c.zoomEnabled&&g(c.min)&&(d||b[{xAxis:"zoomX",yAxis:"zoomY"}[c.coll]])){var l=c.horiz,f="touchend"===a.type?c.minPixelPadding:0,h=c.toValue((l?r:n)+f),l=c.toValue((l?r+w:n+p)-f);e[c.coll].push({axis:c,min:Math.min(h,l),max:Math.max(h,l)});k=!0}}),k&&u(c,"selection",e,function(a){c.zoom(v(a,d?
	{animation:!1}:null))});this.selectionMarker=this.selectionMarker.destroy();d&&this.scaleGroups()}c&&(m(c.container,{cursor:c._cursor}),c.cancelClick=10<this.hasDragged,c.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])},onContainerMouseDown:function(a){a=this.normalize(a);this.zoomOption(a);a.preventDefault&&a.preventDefault();this.dragStart(a)},onDocumentMouseUp:function(b){G[a.hoverChartIndex]&&G[a.hoverChartIndex].pointer.drop(b)},onDocumentMouseMove:function(a){var b=this.chart,
	c=this.chartPosition;a=this.normalize(a,c);!c||this.inClass(a.target,"highcharts-tracker")||b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||this.reset()},onContainerMouseLeave:function(b){var c=G[a.hoverChartIndex];c&&(b.relatedTarget||b.toElement)&&(c.pointer.reset(),c.pointer.chartPosition=null)},onContainerMouseMove:function(b){var c=this.chart;g(a.hoverChartIndex)&&G[a.hoverChartIndex]&&G[a.hoverChartIndex].mouseIsDown||(a.hoverChartIndex=c.index);b=this.normalize(b);b.returnValue=!1;
	"mousedown"===c.mouseIsDown&&this.drag(b);!this.inClass(b.target,"highcharts-tracker")&&!c.isInsidePlot(b.chartX-c.plotLeft,b.chartY-c.plotTop)||c.openMenu||this.runPointActions(b)},inClass:function(a,c){for(var b;a;){if(b=A(a,"class")){if(-1!==b.indexOf(c))return!0;if(-1!==b.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=this.chart.hoverSeries;a=a.relatedTarget||a.toElement;this.isDirectTouch=!1;if(!(!b||!a||b.stickyTracking||this.inClass(a,"highcharts-tooltip")||
	this.inClass(a,"highcharts-series-"+b.index)&&this.inClass(a,"highcharts-tracker")))b.onMouseOut()},onContainerClick:function(a){var b=this.chart,c=b.hoverPoint,d=b.plotLeft,e=b.plotTop;a=this.normalize(a);b.cancelClick||(c&&this.inClass(a.target,"highcharts-tracker")?(u(c.series,"click",v(a,{point:c})),b.hoverPoint&&c.firePointEvent("click",a)):(v(a,this.getCoordinates(a)),b.isInsidePlot(a.chartX-d,a.chartY-e)&&u(b,"click",a)))},setDOMEvents:function(){var b=this,c=b.chart.container;c.onmousedown=
	function(a){b.onContainerMouseDown(a)};c.onmousemove=function(a){b.onContainerMouseMove(a)};c.onclick=function(a){b.onContainerClick(a)};C(c,"mouseleave",b.onContainerMouseLeave);1===a.chartCount&&C(k,"mouseup",b.onDocumentMouseUp);a.hasTouch&&(c.ontouchstart=function(a){b.onContainerTouchStart(a)},c.ontouchmove=function(a){b.onContainerTouchMove(a)},1===a.chartCount&&C(k,"touchend",b.onDocumentTouchEnd))},destroy:function(){var b=this;b.unDocMouseMove&&b.unDocMouseMove();n(b.chart.container,"mouseleave",
	b.onContainerMouseLeave);a.chartCount||(n(k,"mouseup",b.onDocumentMouseUp),n(k,"touchend",b.onDocumentTouchEnd));clearInterval(b.tooltipTimeout);a.objectEach(b,function(a,c){b[c]=null})}}})(K);(function(a){var C=a.charts,A=a.each,G=a.extend,F=a.map,m=a.noop,g=a.pick;G(a.Pointer.prototype,{pinchTranslate:function(a,g,m,u,h,e){this.zoomHor&&this.pinchTranslateDirection(!0,a,g,m,u,h,e);this.zoomVert&&this.pinchTranslateDirection(!1,a,g,m,u,h,e)},pinchTranslateDirection:function(a,g,m,u,h,e,n,d){var c=
	this.chart,w=a?"x":"y",b=a?"X":"Y",k="chart"+b,q=a?"width":"height",v=c["plot"+(a?"Left":"Top")],l,B,r=d||1,z=c.inverted,M=c.bounds[a?"h":"v"],p=1===g.length,E=g[0][k],I=m[0][k],L=!p&&g[1][k],f=!p&&m[1][k],t;m=function(){!p&&20<Math.abs(E-L)&&(r=d||Math.abs(I-f)/Math.abs(E-L));B=(v-I)/r+E;l=c["plot"+(a?"Width":"Height")]/r};m();g=B;g<M.min?(g=M.min,t=!0):g+l>M.max&&(g=M.max-l,t=!0);t?(I-=.8*(I-n[w][0]),p||(f-=.8*(f-n[w][1])),m()):n[w]=[I,f];z||(e[w]=B-v,e[q]=l);e=z?1/r:r;h[q]=l;h[w]=g;u[z?a?"scaleY":
	"scaleX":"scale"+b]=r;u["translate"+b]=e*v+(I-e*E)},pinch:function(a){var k=this,v=k.chart,u=k.pinchDown,h=a.touches,e=h.length,n=k.lastValidTouch,d=k.hasZoom,c=k.selectionMarker,w={},b=1===e&&(k.inClass(a.target,"highcharts-tracker")&&v.runTrackerClick||k.runChartClick),y={};1<e&&(k.initiated=!0);d&&k.initiated&&!b&&a.preventDefault();F(h,function(a){return k.normalize(a)});"touchstart"===a.type?(A(h,function(a,b){u[b]={chartX:a.chartX,chartY:a.chartY}}),n.x=[u[0].chartX,u[1]&&u[1].chartX],n.y=[u[0].chartY,
	u[1]&&u[1].chartY],A(v.axes,function(a){if(a.zoomEnabled){var b=v.bounds[a.horiz?"h":"v"],c=a.minPixelPadding,d=a.toPixels(g(a.options.min,a.dataMin)),e=a.toPixels(g(a.options.max,a.dataMax)),h=Math.max(d,e);b.min=Math.min(a.pos,Math.min(d,e)-c);b.max=Math.max(a.pos+a.len,h+c)}}),k.res=!0):k.followTouchMove&&1===e?this.runPointActions(k.normalize(a)):u.length&&(c||(k.selectionMarker=c=G({destroy:m,touch:!0},v.plotBox)),k.pinchTranslate(u,h,w,c,y,n),k.hasPinched=d,k.scaleGroups(w,y),k.res&&(k.res=
	!1,this.reset(!1,0)))},touch:function(k,m){var q=this.chart,u,h;if(q.index!==a.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});a.hoverChartIndex=q.index;1===k.touches.length?(k=this.normalize(k),(h=q.isInsidePlot(k.chartX-q.plotLeft,k.chartY-q.plotTop))&&!q.openMenu?(m&&this.runPointActions(k),"touchmove"===k.type&&(m=this.pinchDown,u=m[0]?4<=Math.sqrt(Math.pow(m[0].chartX-k.chartX,2)+Math.pow(m[0].chartY-k.chartY,2)):!1),g(u,!0)&&this.pinch(k)):m&&this.reset()):2===k.touches.length&&
	this.pinch(k)},onContainerTouchStart:function(a){this.zoomOption(a);this.touch(a,!0)},onContainerTouchMove:function(a){this.touch(a)},onDocumentTouchEnd:function(g){C[a.hoverChartIndex]&&C[a.hoverChartIndex].pointer.drop(g)}})})(K);(function(a){var C=a.addEvent,A=a.charts,G=a.css,F=a.doc,m=a.extend,g=a.noop,k=a.Pointer,q=a.removeEvent,v=a.win,u=a.wrap;if(!a.hasTouch&&(v.PointerEvent||v.MSPointerEvent)){var h={},e=!!v.PointerEvent,n=function(){var c=[];c.item=function(a){return this[a]};a.objectEach(h,
	function(a){c.push({pageX:a.pageX,pageY:a.pageY,target:a.target})});return c},d=function(c,d,b,e){"touch"!==c.pointerType&&c.pointerType!==c.MSPOINTER_TYPE_TOUCH||!A[a.hoverChartIndex]||(e(c),e=A[a.hoverChartIndex].pointer,e[d]({type:b,target:c.currentTarget,preventDefault:g,touches:n()}))};m(k.prototype,{onContainerPointerDown:function(a){d(a,"onContainerTouchStart","touchstart",function(a){h[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},onContainerPointerMove:function(a){d(a,
	"onContainerTouchMove","touchmove",function(a){h[a.pointerId]={pageX:a.pageX,pageY:a.pageY};h[a.pointerId].target||(h[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(a){d(a,"onDocumentTouchEnd","touchend",function(a){delete h[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,e?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,e?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(F,e?"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});
	u(k.prototype,"init",function(a,d,b){a.call(this,d,b);this.hasZoom&&G(d.container,{"-ms-touch-action":"none","touch-action":"none"})});u(k.prototype,"setDOMEvents",function(a){a.apply(this);(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(C)});u(k.prototype,"destroy",function(a){this.batchMSEvents(q);a.call(this)})}})(K);(function(a){var C=a.addEvent,A=a.css,G=a.discardElement,F=a.defined,m=a.each,g=a.isFirefox,k=a.marginNames,q=a.merge,v=a.pick,u=a.setAnimation,h=a.stableSort,e=a.win,n=a.wrap;
	a.Legend=function(a,c){this.init(a,c)};a.Legend.prototype={init:function(a,c){this.chart=a;this.setOptions(c);c.enabled&&(this.render(),C(this.chart,"endResize",function(){this.legend.positionCheckboxes()}))},setOptions:function(a){var c=v(a.padding,8);this.options=a;this.itemStyle=a.itemStyle;this.itemHiddenStyle=q(this.itemStyle,a.itemHiddenStyle);this.itemMarginTop=a.itemMarginTop||0;this.padding=c;this.initialItemY=c-5;this.itemHeight=this.maxItemWidth=0;this.symbolWidth=v(a.symbolWidth,16);this.pages=
	[]},update:function(a,c){var d=this.chart;this.setOptions(q(!0,this.options,a));this.destroy();d.isDirtyLegend=d.isDirtyBox=!0;v(c,!0)&&d.redraw()},colorizeItem:function(d,c){d.legendGroup[c?"removeClass":"addClass"]("highcharts-legend-item-hidden");var e=this.options,b=d.legendItem,h=d.legendLine,g=d.legendSymbol,n=this.itemHiddenStyle.color,e=c?e.itemStyle.color:n,l=c?d.color||n:n,k=d.options&&d.options.marker,r={fill:l};b&&b.css({fill:e,color:e});h&&h.attr({stroke:l});g&&(k&&g.isMarker&&(r=d.pointAttribs(),
	c||a.objectEach(r,function(a,b){r[b]=n})),g.attr(r))},positionItem:function(a){var c=this.options,d=c.symbolPadding,c=!c.rtl,b=a._legendItemPos,e=b[0],b=b[1],h=a.checkbox;(a=a.legendGroup)&&a.element&&a.translate(c?e:this.legendWidth-e-2*d-4,b);h&&(h.x=e,h.y=b)},destroyItem:function(a){var c=a.checkbox;m(["legendItem","legendLine","legendSymbol","legendGroup"],function(c){a[c]&&(a[c]=a[c].destroy())});c&&G(a.checkbox)},destroy:function(){function a(a){this[a]&&(this[a]=this[a].destroy())}m(this.getAllItems(),
	function(c){m(["legendItem","legendGroup"],a,c)});m("clipRect up down pager nav box title group".split(" "),a,this);this.display=null},positionCheckboxes:function(a){var c=this.group&&this.group.alignAttr,d,b=this.clipHeight||this.legendHeight,e=this.titleHeight;c&&(d=c.translateY,m(this.allItems,function(h){var g=h.checkbox,l;g&&(l=d+e+g.y+(a||0)+3,A(g,{left:c.translateX+h.checkboxOffset+g.x-20+"px",top:l+"px",display:l>d-6&&l<d+b-6?"":"none"}))}))},renderTitle:function(){var a=this.options,c=this.padding,
	e=a.title,b=0;e.text&&(this.title||(this.title=this.chart.renderer.label(e.text,c-3,c-4,null,null,null,a.useHTML,null,"legend-title").attr({zIndex:1}).css(e.style).add(this.group)),a=this.title.getBBox(),b=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:b}));this.titleHeight=b},setText:function(d){var c=this.options;d.legendItem.attr({text:c.labelFormat?a.format(c.labelFormat,d):c.labelFormatter.call(d)})},renderItem:function(a){var c=this.chart,d=c.renderer,b=this.options,e=
	"horizontal"===b.layout,h=this.symbolWidth,g=b.symbolPadding,l=this.itemStyle,n=this.itemHiddenStyle,r=this.padding,k=e?v(b.itemDistance,20):0,m=!b.rtl,p=b.width,E=b.itemMarginBottom||0,I=this.itemMarginTop,u=a.legendItem,f=!a.series,t=!f&&a.series.drawLegendSymbol?a.series:a,A=t.options,J=this.createCheckboxForItem&&A&&A.showCheckbox,A=h+g+k+(J?20:0),N=b.useHTML,C=a.options.className;u||(a.legendGroup=d.g("legend-item").addClass("highcharts-"+t.type+"-series highcharts-color-"+a.colorIndex+(C?" "+
	C:"")+(f?" highcharts-series-"+a.index:"")).attr({zIndex:1}).add(this.scrollGroup),a.legendItem=u=d.text("",m?h+g:-g,this.baseline||0,N).css(q(a.visible?l:n)).attr({align:m?"left":"right",zIndex:2}).add(a.legendGroup),this.baseline||(h=l.fontSize,this.fontMetrics=d.fontMetrics(h,u),this.baseline=this.fontMetrics.f+3+I,u.attr("y",this.baseline)),this.symbolHeight=b.symbolHeight||this.fontMetrics.f,t.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,u,N),J&&this.createCheckboxForItem(a));
	this.colorizeItem(a,a.visible);l.width||u.css({width:(b.itemWidth||c.spacingBox.width)-A});this.setText(a);d=u.getBBox();l=a.checkboxOffset=b.itemWidth||a.legendItemWidth||d.width+A;this.itemHeight=d=Math.round(a.legendItemHeight||d.height||this.symbolHeight);e&&this.itemX-r+l>(p||c.spacingBox.width-2*r-b.x)&&(this.itemX=r,this.itemY+=I+this.lastLineHeight+E,this.lastLineHeight=0);this.maxItemWidth=Math.max(this.maxItemWidth,l);this.lastItemY=I+this.itemY+E;this.lastLineHeight=Math.max(d,this.lastLineHeight);
	a._legendItemPos=[this.itemX,this.itemY];e?this.itemX+=l:(this.itemY+=I+d+E,this.lastLineHeight=d);this.offsetWidth=p||Math.max((e?this.itemX-r-k:l)+r,this.offsetWidth)},getAllItems:function(){var a=[];m(this.chart.series,function(c){var d=c&&c.options;c&&v(d.showInLegend,F(d.linkedTo)?!1:void 0,!0)&&(a=a.concat(c.legendItems||("point"===d.legendType?c.data:c)))});return a},adjustMargins:function(a,c){var d=this.chart,b=this.options,e=b.align.charAt(0)+b.verticalAlign.charAt(0)+b.layout.charAt(0);
	b.floating||m([/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/],function(h,g){h.test(e)&&!F(a[g])&&(d[k[g]]=Math.max(d[k[g]],d.legend[(g+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][g]*b[g%2?"x":"y"]+v(b.margin,12)+c[g]))})},render:function(){var a=this,c=a.chart,e=c.renderer,b=a.group,g,n,k,l,B=a.box,r=a.options,z=a.padding;a.itemX=z;a.itemY=a.initialItemY;a.offsetWidth=0;a.lastItemY=0;b||(a.group=b=e.g("legend").attr({zIndex:7}).add(),a.contentGroup=e.g().attr({zIndex:1}).add(b),a.scrollGroup=
	e.g().add(a.contentGroup));a.renderTitle();g=a.getAllItems();h(g,function(a,b){return(a.options&&a.options.legendIndex||0)-(b.options&&b.options.legendIndex||0)});r.reversed&&g.reverse();a.allItems=g;a.display=n=!!g.length;a.lastLineHeight=0;m(g,function(b){a.renderItem(b)});k=(r.width||a.offsetWidth)+z;l=a.lastItemY+a.lastLineHeight+a.titleHeight;l=a.handleOverflow(l);l+=z;B||(a.box=B=e.rect().addClass("highcharts-legend-box").attr({r:r.borderRadius}).add(b),B.isNew=!0);B.attr({stroke:r.borderColor,
	"stroke-width":r.borderWidth||0,fill:r.backgroundColor||"none"}).shadow(r.shadow);0<k&&0<l&&(B[B.isNew?"attr":"animate"](B.crisp({x:0,y:0,width:k,height:l},B.strokeWidth())),B.isNew=!1);B[n?"show":"hide"]();a.legendWidth=k;a.legendHeight=l;m(g,function(b){a.positionItem(b)});n&&b.align(q(r,{width:k,height:l}),!0,"spacingBox");c.isResizing||this.positionCheckboxes()},handleOverflow:function(a){var c=this,d=this.chart,b=d.renderer,e=this.options,h=e.y,g=this.padding,d=d.spacingBox.height+("top"===e.verticalAlign?
	-h:h)-g,h=e.maxHeight,l,n=this.clipRect,r=e.navigation,k=v(r.animation,!0),q=r.arrowSize||12,p=this.nav,E=this.pages,I,u=this.allItems,f=function(a){"number"===typeof a?n.attr({height:a}):n&&(c.clipRect=n.destroy(),c.contentGroup.clip());c.contentGroup.div&&(c.contentGroup.div.style.clip=a?"rect("+g+"px,9999px,"+(g+a)+"px,0)":"auto")};"horizontal"!==e.layout||"middle"===e.verticalAlign||e.floating||(d/=2);h&&(d=Math.min(d,h));E.length=0;a>d&&!1!==r.enabled?(this.clipHeight=l=Math.max(d-20-this.titleHeight-
	g,0),this.currentPage=v(this.currentPage,1),this.fullHeight=a,m(u,function(a,b){var c=a._legendItemPos[1];a=Math.round(a.legendItem.getBBox().height);var f=E.length;if(!f||c-E[f-1]>l&&(I||c)!==E[f-1])E.push(I||c),f++;b===u.length-1&&c+a-E[f-1]>l&&E.push(c);c!==I&&(I=c)}),n||(n=c.clipRect=b.clipRect(0,g,9999,0),c.contentGroup.clip(n)),f(l),p||(this.nav=p=b.g().attr({zIndex:1}).add(this.group),this.up=b.symbol("triangle",0,0,q,q).on("click",function(){c.scroll(-1,k)}).add(p),this.pager=b.text("",15,
	10).addClass("highcharts-legend-navigation").css(r.style).add(p),this.down=b.symbol("triangle-down",0,0,q,q).on("click",function(){c.scroll(1,k)}).add(p)),c.scroll(0),a=d):p&&(f(),this.nav=p.destroy(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0);return a},scroll:function(a,c){var d=this.pages,b=d.length;a=this.currentPage+a;var e=this.clipHeight,h=this.options.navigation,g=this.pager,l=this.padding;a>b&&(a=b);0<a&&(void 0!==c&&u(c,this.chart),this.nav.attr({translateX:l,translateY:e+this.padding+
	7+this.titleHeight,visibility:"visible"}),this.up.attr({"class":1===a?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),g.attr({text:a+"/"+b}),this.down.attr({x:18+this.pager.getBBox().width,"class":a===b?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),this.up.attr({fill:1===a?h.inactiveColor:h.activeColor}).css({cursor:1===a?"default":"pointer"}),this.down.attr({fill:a===b?h.inactiveColor:h.activeColor}).css({cursor:a===b?"default":"pointer"}),c=-d[a-1]+this.initialItemY,
	this.scrollGroup.animate({translateY:c}),this.currentPage=a,this.positionCheckboxes(c))}};a.LegendSymbolMixin={drawRectangle:function(a,c){var d=a.symbolHeight,b=a.options.squareSymbol;c.legendSymbol=this.chart.renderer.rect(b?(a.symbolWidth-d)/2:0,a.baseline-d+1,b?d:a.symbolWidth,d,v(a.options.symbolRadius,d/2)).addClass("highcharts-point").attr({zIndex:3}).add(c.legendGroup)},drawLineMarker:function(a){var c=this.options,d=c.marker,b=a.symbolWidth,e=a.symbolHeight,h=e/2,g=this.chart.renderer,l=
	this.legendGroup;a=a.baseline-Math.round(.3*a.fontMetrics.b);var n;n={"stroke-width":c.lineWidth||0};c.dashStyle&&(n.dashstyle=c.dashStyle);this.legendLine=g.path(["M",0,a,"L",b,a]).addClass("highcharts-graph").attr(n).add(l);d&&!1!==d.enabled&&(c=Math.min(v(d.radius,h),h),0===this.symbol.indexOf("url")&&(d=q(d,{width:e,height:e}),c=0),this.legendSymbol=d=g.symbol(this.symbol,b/2-c,a-c,2*c,2*c,d).addClass("highcharts-point").add(l),d.isMarker=!0)}};(/Trident\/7\.0/.test(e.navigator.userAgent)||g)&&
	n(a.Legend.prototype,"positionItem",function(a,c){var d=this,b=function(){c._legendItemPos&&a.call(d,c)};b();setTimeout(b)})})(K);(function(a){var C=a.addEvent,A=a.animate,G=a.animObject,F=a.attr,m=a.doc,g=a.Axis,k=a.createElement,q=a.defaultOptions,v=a.discardElement,u=a.charts,h=a.css,e=a.defined,n=a.each,d=a.extend,c=a.find,w=a.fireEvent,b=a.getStyle,y=a.grep,D=a.isNumber,H=a.isObject,l=a.isString,B=a.Legend,r=a.marginNames,z=a.merge,M=a.objectEach,p=a.Pointer,E=a.pick,I=a.pInt,L=a.removeEvent,
	f=a.seriesTypes,t=a.splat,R=a.svg,J=a.syncTimeout,N=a.win,O=a.Renderer,P=a.Chart=function(){this.getArgs.apply(this,arguments)};a.chart=function(a,b,c){return new P(a,b,c)};d(P.prototype,{callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(l(a[0])||a[0].nodeName)this.renderTo=a.shift();this.init(a[0],a[1])},init:function(b,c){var f,d,e=b.series,p=b.plotOptions||{};b.series=null;f=z(q,b);for(d in f.plotOptions)f.plotOptions[d].tooltip=p[d]&&z(p[d].tooltip)||void 0;f.tooltip.userOptions=
	b.chart&&b.chart.forExport&&b.tooltip.userOptions||b.tooltip;f.series=b.series=e;this.userOptions=b;b=f.chart;d=b.events;this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.callback=c;this.isResizing=0;this.options=f;this.axes=[];this.series=[];this.hasCartesianSeries=b.showAxes;var h=this;h.index=u.length;u.push(h);a.chartCount++;d&&M(d,function(a,b){C(h,b,a)});h.xAxis=[];h.yAxis=[];h.pointCount=h.colorCounter=h.symbolCounter=0;h.firstRender()},initSeries:function(b){var c=this.options.chart;
	(c=f[b.type||c.type||c.defaultSeriesType])||a.error(17,!0);c=new c;c.init(this,b);return c},orderSeries:function(a){var b=this.series;for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].name||"Series "+(b[a].index+1))},isInsidePlot:function(a,b,c){var f=c?b:a;a=c?a:b;return 0<=f&&f<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(b){var c=this.axes,f=this.series,e=this.pointer,p=this.legend,h=this.isDirtyLegend,l,g,r=this.hasCartesianSeries,t=this.isDirtyBox,x,k=this.renderer,m=
	k.isHidden(),E=[];this.setResponsive&&this.setResponsive(!1);a.setAnimation(b,this);m&&this.temporaryDisplay();this.layOutTitles();for(b=f.length;b--;)if(x=f[b],x.options.stacking&&(l=!0,x.isDirty)){g=!0;break}if(g)for(b=f.length;b--;)x=f[b],x.options.stacking&&(x.isDirty=!0);n(f,function(a){a.isDirty&&"point"===a.options.legendType&&(a.updateTotals&&a.updateTotals(),h=!0);a.isDirtyData&&w(a,"updatedData")});h&&p.options.enabled&&(p.render(),this.isDirtyLegend=!1);l&&this.getStacks();r&&n(c,function(a){a.updateNames();
	a.setScale()});this.getMargins();r&&(n(c,function(a){a.isDirty&&(t=!0)}),n(c,function(a){var b=a.min+","+a.max;a.extKey!==b&&(a.extKey=b,E.push(function(){w(a,"afterSetExtremes",d(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(t||l)&&a.redraw()}));t&&this.drawChartBox();w(this,"predraw");n(f,function(a){(t||a.isDirty)&&a.visible&&a.redraw();a.isDirtyData=!1});e&&e.reset(!0);k.draw();w(this,"redraw");w(this,"render");m&&this.temporaryDisplay(!0);n(E,function(a){a.call()})},get:function(a){function b(b){return b.id===
	a||b.options&&b.options.id===a}var f,d=this.series,e;f=c(this.axes,b)||c(this.series,b);for(e=0;!f&&e<d.length;e++)f=c(d[e].points||[],b);return f},getAxes:function(){var a=this,b=this.options,c=b.xAxis=t(b.xAxis||{}),b=b.yAxis=t(b.yAxis||{});n(c,function(a,b){a.index=b;a.isX=!0});n(b,function(a,b){a.index=b});c=c.concat(b);n(c,function(b){new g(a,b)})},getSelectedPoints:function(){var a=[];n(this.series,function(b){a=a.concat(y(b.data||[],function(a){return a.selected}))});return a},getSelectedSeries:function(){return y(this.series,
	function(a){return a.selected})},setTitle:function(a,b,c){var f=this,d=f.options,e;e=d.title=z({style:{color:"#333333",fontSize:d.isStock?"16px":"18px"}},d.title,a);d=d.subtitle=z({style:{color:"#666666"}},d.subtitle,b);n([["title",a,e],["subtitle",b,d]],function(a,b){var c=a[0],d=f[c],e=a[1];a=a[2];d&&e&&(f[c]=d=d.destroy());a&&a.text&&!d&&(f[c]=f.renderer.text(a.text,0,0,a.useHTML).attr({align:a.align,"class":"highcharts-"+c,zIndex:a.zIndex||4}).add(),f[c].update=function(a){f.setTitle(!b&&a,b&&
	a)},f[c].css(a.style))});f.layOutTitles(c)},layOutTitles:function(a){var b=0,c,f=this.renderer,e=this.spacingBox;n(["title","subtitle"],function(a){var c=this[a],p=this.options[a];a="title"===a?-3:p.verticalAlign?0:b+2;var h;c&&(h=p.style.fontSize,h=f.fontMetrics(h,c).b,c.css({width:(p.width||e.width+p.widthAdjust)+"px"}).align(d({y:a+h},p),!1,"spacingBox"),p.floating||p.verticalAlign||(b=Math.ceil(b+c.getBBox(p.useHTML).height)))},this);c=this.titleOffset!==b;this.titleOffset=b;!this.isDirtyBox&&
	c&&(this.isDirtyBox=c,this.hasRendered&&E(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var c=this.options.chart,f=c.width,c=c.height,d=this.renderTo;e(f)||(this.containerWidth=b(d,"width"));e(c)||(this.containerHeight=b(d,"height"));this.chartWidth=Math.max(0,f||this.containerWidth||600);this.chartHeight=Math.max(0,a.relativeLength(c,this.chartWidth)||this.containerHeight||400)},temporaryDisplay:function(c){var f=this.renderTo;if(c)for(;f&&f.style;)f.hcOrigStyle&&(a.css(f,f.hcOrigStyle),
	delete f.hcOrigStyle),f=f.parentNode;else for(;f&&f.style;)"none"===b(f,"display",!1)&&(f.hcOrigStyle={display:f.style.display,height:f.style.height,overflow:f.style.overflow},c={display:"block",overflow:"hidden"},f!==this.renderTo&&(c.height=0),a.css(f,c),f.style.setProperty&&f.style.setProperty("display","block","important")),f=f.parentNode},setClassName:function(a){this.container.className="highcharts-container "+(a||"")},getContainer:function(){var b,c=this.options,f=c.chart,e,p;b=this.renderTo;
	var h=a.uniqueKey(),g;b||(this.renderTo=b=f.renderTo);l(b)&&(this.renderTo=b=m.getElementById(b));b||a.error(13,!0);e=I(F(b,"data-highcharts-chart"));D(e)&&u[e]&&u[e].hasRendered&&u[e].destroy();F(b,"data-highcharts-chart",this.index);b.innerHTML="";f.skipClone||b.offsetWidth||this.temporaryDisplay();this.getChartSize();e=this.chartWidth;p=this.chartHeight;g=d({position:"relative",overflow:"hidden",width:e+"px",height:p+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},
	f.style);this.container=b=k("div",{id:h},g,b);this._cursor=b.style.cursor;this.renderer=new (a[f.renderer]||O)(b,e,p,null,f.forExport,c.exporting&&c.exporting.allowHTML);this.setClassName(f.className);this.renderer.setStyle(f.style);this.renderer.chartIndex=this.index},getMargins:function(a){var b=this.spacing,c=this.margin,f=this.titleOffset;this.resetMargins();f&&!e(c[0])&&(this.plotTop=Math.max(this.plotTop,f+this.options.title.margin+b[0]));this.legend.display&&this.legend.adjustMargins(c,b);
	this.extraMargin&&(this[this.extraMargin.type]=(this[this.extraMargin.type]||0)+this.extraMargin.value);this.extraTopMargin&&(this.plotTop+=this.extraTopMargin);a||this.getAxisMargins()},getAxisMargins:function(){var a=this,b=a.axisOffset=[0,0,0,0],c=a.margin;a.hasCartesianSeries&&n(a.axes,function(a){a.visible&&a.getOffset()});n(r,function(f,d){e(c[d])||(a[f]+=b[d])});a.setChartSize()},reflow:function(a){var c=this,f=c.options.chart,d=c.renderTo,p=e(f.width),h=f.width||b(d,"width"),f=f.height||b(d,
	"height"),d=a?a.target:N;if(!p&&!c.isPrinting&&h&&f&&(d===N||d===m)){if(h!==c.containerWidth||f!==c.containerHeight)clearTimeout(c.reflowTimeout),c.reflowTimeout=J(function(){c.container&&c.setSize(void 0,void 0,!1)},a?100:0);c.containerWidth=h;c.containerHeight=f}},initReflow:function(){var a=this,b;b=C(N,"resize",function(b){a.reflow(b)});C(a,"destroy",b)},setSize:function(b,c,f){var d=this,e=d.renderer;d.isResizing+=1;a.setAnimation(f,d);d.oldChartHeight=d.chartHeight;d.oldChartWidth=d.chartWidth;
	void 0!==b&&(d.options.chart.width=b);void 0!==c&&(d.options.chart.height=c);d.getChartSize();b=e.globalAnimation;(b?A:h)(d.container,{width:d.chartWidth+"px",height:d.chartHeight+"px"},b);d.setChartSize(!0);e.setSize(d.chartWidth,d.chartHeight,f);n(d.axes,function(a){a.isDirty=!0;a.setScale()});d.isDirtyLegend=!0;d.isDirtyBox=!0;d.layOutTitles();d.getMargins();d.redraw(f);d.oldChartHeight=null;w(d,"resize");J(function(){d&&w(d,"endResize",null,function(){--d.isResizing})},G(b).duration)},setChartSize:function(a){function b(a){a=
	l[a]||0;return Math.max(m||a,a)/2}var c=this.inverted,f=this.renderer,d=this.chartWidth,e=this.chartHeight,p=this.options.chart,h=this.spacing,l=this.clipOffset,g,r,t,k,m;this.plotLeft=g=Math.round(this.plotLeft);this.plotTop=r=Math.round(this.plotTop);this.plotWidth=t=Math.max(0,Math.round(d-g-this.marginRight));this.plotHeight=k=Math.max(0,Math.round(e-r-this.marginBottom));this.plotSizeX=c?k:t;this.plotSizeY=c?t:k;this.plotBorderWidth=p.plotBorderWidth||0;this.spacingBox=f.spacingBox={x:h[3],y:h[0],
	width:d-h[3]-h[1],height:e-h[0]-h[2]};this.plotBox=f.plotBox={x:g,y:r,width:t,height:k};m=2*Math.floor(this.plotBorderWidth/2);c=Math.ceil(b(3));f=Math.ceil(b(0));this.clipBox={x:c,y:f,width:Math.floor(this.plotSizeX-b(1)-c),height:Math.max(0,Math.floor(this.plotSizeY-b(2)-f))};a||n(this.axes,function(a){a.setAxisSize();a.setAxisTranslation()})},resetMargins:function(){var a=this,b=a.options.chart;n(["margin","spacing"],function(c){var f=b[c],d=H(f)?f:[f,f,f,f];n(["Top","Right","Bottom","Left"],function(f,
	e){a[c][e]=E(b[c+f],d[e])})});n(r,function(b,c){a[b]=E(a.margin[c],a.spacing[c])});a.axisOffset=[0,0,0,0];a.clipOffset=[]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,c=this.chartWidth,f=this.chartHeight,d=this.chartBackground,e=this.plotBackground,p=this.plotBorder,h,l=this.plotBGImage,g=a.backgroundColor,n=a.plotBackgroundColor,r=a.plotBackgroundImage,t,k=this.plotLeft,m=this.plotTop,E=this.plotWidth,w=this.plotHeight,q=this.plotBox,I=this.clipRect,z=this.clipBox,y="animate";
	d||(this.chartBackground=d=b.rect().addClass("highcharts-background").add(),y="attr");h=a.borderWidth||0;t=h+(a.shadow?8:0);g={fill:g||"none"};if(h||d["stroke-width"])g.stroke=a.borderColor,g["stroke-width"]=h;d.attr(g).shadow(a.shadow);d[y]({x:t/2,y:t/2,width:c-t-h%2,height:f-t-h%2,r:a.borderRadius});y="animate";e||(y="attr",this.plotBackground=e=b.rect().addClass("highcharts-plot-background").add());e[y](q);e.attr({fill:n||"none"}).shadow(a.plotShadow);r&&(l?l.animate(q):this.plotBGImage=b.image(r,
	k,m,E,w).add());I?I.animate({width:z.width,height:z.height}):this.clipRect=b.clipRect(z);y="animate";p||(y="attr",this.plotBorder=p=b.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());p.attr({stroke:a.plotBorderColor,"stroke-width":a.plotBorderWidth||0,fill:"none"});p[y](p.crisp({x:k,y:m,width:E,height:w},-p.strokeWidth()));this.isDirtyBox=!1},propFromSeries:function(){var a=this,b=a.options.chart,c,d=a.options.series,e,p;n(["inverted","angular","polar"],function(h){c=f[b.type||b.defaultSeriesType];
	p=b[h]||c&&c.prototype[h];for(e=d&&d.length;!p&&e--;)(c=f[d[e].type])&&c.prototype[h]&&(p=!0);a[h]=p})},linkSeries:function(){var a=this,b=a.series;n(b,function(a){a.linkedSeries.length=0});n(b,function(b){var c=b.options.linkedTo;l(c)&&(c=":previous"===c?a.series[b.index-1]:a.get(c))&&c.linkedParent!==b&&(c.linkedSeries.push(b),b.linkedParent=c,b.visible=E(b.options.visible,c.options.visible,b.visible))})},renderSeries:function(){n(this.series,function(a){a.translate();a.render()})},renderLabels:function(){var a=
	this,b=a.options.labels;b.items&&n(b.items,function(c){var f=d(b.style,c.style),e=I(f.left)+a.plotLeft,p=I(f.top)+a.plotTop+12;delete f.left;delete f.top;a.renderer.text(c.html,e,p).attr({zIndex:2}).css(f).add()})},render:function(){var a=this.axes,b=this.renderer,c=this.options,f,d,e;this.setTitle();this.legend=new B(this,c.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();c=this.plotWidth;f=this.plotHeight-=21;n(a,function(a){a.setScale()});this.getAxisMargins();d=
	1.1<c/this.plotWidth;e=1.05<f/this.plotHeight;if(d||e)n(a,function(a){(a.horiz&&d||!a.horiz&&e)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries&&n(a,function(a){a.visible&&a.render()});this.seriesGroup||(this.seriesGroup=b.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.hasRendered=!0},addCredits:function(a){var b=this;a=z(!0,this.options.credits,a);a.enabled&&!this.credits&&
	(this.credits=this.renderer.text(a.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&(N.location.href=a.href)}).attr({align:a.position.align,zIndex:8}).css(a.style).add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},destroy:function(){var b=this,c=b.axes,f=b.series,d=b.container,e,p=d&&d.parentNode;w(b,"destroy");b.renderer.forExport?a.erase(u,b):u[b.index]=void 0;a.chartCount--;b.renderTo.removeAttribute("data-highcharts-chart");
	L(b);for(e=c.length;e--;)c[e]=c[e].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();for(e=f.length;e--;)f[e]=f[e].destroy();n("title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" "),function(a){var c=b[a];c&&c.destroy&&(b[a]=c.destroy())});d&&(d.innerHTML="",L(d),p&&v(d));M(b,function(a,c){delete b[c]})},isReadyToRender:function(){var a=this;return R||N!=N.top||
	"complete"===m.readyState?!0:(m.attachEvent("onreadystatechange",function(){m.detachEvent("onreadystatechange",a.firstRender);"complete"===m.readyState&&a.firstRender()}),!1)},firstRender:function(){var a=this,b=a.options;if(a.isReadyToRender()){a.getContainer();w(a,"init");a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();n(b.series||[],function(b){a.initSeries(b)});a.linkSeries();w(a,"beforeRender");p&&(a.pointer=new p(a,b));a.render();if(!a.renderer.imgCount&&a.onload)a.onload();
	a.temporaryDisplay(!0)}},onload:function(){n([this.callback].concat(this.callbacks),function(a){a&&void 0!==this.index&&a.apply(this,[this])},this);w(this,"load");w(this,"render");e(this.index)&&!1!==this.options.chart.reflow&&this.initReflow();this.onload=null}})})(K);(function(a){var C,A=a.each,G=a.extend,F=a.erase,m=a.fireEvent,g=a.format,k=a.isArray,q=a.isNumber,v=a.pick,u=a.removeEvent;a.Point=C=function(){};a.Point.prototype={init:function(a,e,g){this.series=a;this.color=a.color;this.applyOptions(e,
	g);a.options.colorByPoint?(e=a.options.colors||a.chart.options.colors,this.color=this.color||e[a.colorCounter],e=e.length,g=a.colorCounter,a.colorCounter++,a.colorCounter===e&&(a.colorCounter=0)):g=a.colorIndex;this.colorIndex=v(this.colorIndex,g);a.chart.pointCount++;return this},applyOptions:function(a,e){var h=this.series,d=h.options.pointValKey||h.pointValKey;a=C.prototype.optionsToObject.call(this,a);G(this,a);this.options=this.options?G(this.options,a):a;a.group&&delete this.group;d&&(this.y=
	this[d]);this.isNull=v(this.isValid&&!this.isValid(),null===this.x||!q(this.y,!0));this.selected&&(this.state="select");"name"in this&&void 0===e&&h.xAxis&&h.xAxis.hasNames&&(this.x=h.xAxis.nameToX(this));void 0===this.x&&h&&(this.x=void 0===e?h.autoIncrement(this):e);return this},optionsToObject:function(a){var e={},h=this.series,d=h.options.keys,c=d||h.pointArrayMap||["y"],g=c.length,b=0,m=0;if(q(a)||null===a)e[c[0]]=a;else if(k(a))for(!d&&a.length>g&&(h=typeof a[0],"string"===h?e.name=a[0]:"number"===
	h&&(e.x=a[0]),b++);m<g;)d&&void 0===a[b]||(e[c[m]]=a[b]),b++,m++;else"object"===typeof a&&(e=a,a.dataLabels&&(h._hasPointLabels=!0),a.marker&&(h._hasPointMarkers=!0));return e},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":"")+(this.isNull?" highcharts-null-point":"")+(void 0!==this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?
	" "+this.zone.className.replace("highcharts-negative",""):"")},getZone:function(){var a=this.series,e=a.zones,a=a.zoneAxis||"y",g=0,d;for(d=e[g];this[a]>=d.value;)d=e[++g];d&&d.color&&!this.options.color&&(this.color=d.color);return d},destroy:function(){var a=this.series.chart,e=a.hoverPoints,g;a.pointCount--;e&&(this.setState(),F(e,this),e.length||(a.hoverPoints=null));if(this===a.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel)u(this),this.destroyElements();this.legendItem&&a.legend.destroyItem(this);
	for(g in this)this[g]=null},destroyElements:function(){for(var a=["graphic","dataLabel","dataLabelUpper","connector","shadowGroup"],e,g=6;g--;)e=a[g],this[e]&&(this[e]=this[e].destroy())},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}},tooltipFormatter:function(a){var e=this.series,h=e.tooltipOptions,d=v(h.valueDecimals,""),
	c=h.valuePrefix||"",k=h.valueSuffix||"";A(e.pointArrayMap||["y"],function(b){b="{point."+b;if(c||k)a=a.replace(b+"}",c+b+"}"+k);a=a.replace(b+"}",b+":,."+d+"f}")});return g(a,{point:this,series:this.series})},firePointEvent:function(a,e,g){var d=this,c=this.series.options;(c.point.events[a]||d.options&&d.options.events&&d.options.events[a])&&this.importEvents();"click"===a&&c.allowPointSelect&&(g=function(a){d.select&&d.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});m(this,a,e,g)},visible:!0}})(K);
	(function(a){var C=a.addEvent,A=a.animObject,G=a.arrayMax,F=a.arrayMin,m=a.correctFloat,g=a.Date,k=a.defaultOptions,q=a.defaultPlotOptions,v=a.defined,u=a.each,h=a.erase,e=a.extend,n=a.fireEvent,d=a.grep,c=a.isArray,w=a.isNumber,b=a.isString,y=a.merge,D=a.objectEach,H=a.pick,l=a.removeEvent,B=a.splat,r=a.SVGElement,z=a.syncTimeout,M=a.win;a.Series=a.seriesType("line",null,{lineWidth:2,allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{lineWidth:0,lineColor:"#ffffff",radius:4,
	states:{hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){return null===this.y?"":a.numberFormat(this.y,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0,padding:5},cropThreshold:300,pointRange:0,softThreshold:!0,states:{hover:{animation:{duration:50},lineWidthPlus:1,marker:{},
	halo:{size:10,opacity:.25}},select:{marker:{}}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},{isCartesian:!0,pointClass:a.Point,sorted:!0,requireSorting:!0,directTouch:!1,axisTypes:["xAxis","yAxis"],colorCounter:0,parallelArrays:["x","y"],coll:"series",init:function(a,b){var c=this,d,f=a.series,p;c.chart=a;c.options=b=c.setOptions(b);c.linkedSeries=[];c.bindAxes();e(c,{name:b.name,state:"",visible:!1!==b.visible,selected:!0===b.selected});d=b.events;D(d,function(a,b){C(c,b,a)});if(d&&
	d.click||b.point&&b.point.events&&b.point.events.click||b.allowPointSelect)a.runTrackerClick=!0;c.getColor();c.getSymbol();u(c.parallelArrays,function(a){c[a+"Data"]=[]});c.setData(b.data,!1);c.isCartesian&&(a.hasCartesianSeries=!0);f.length&&(p=f[f.length-1]);c._i=H(p&&p._i,-1)+1;a.orderSeries(this.insert(f))},insert:function(a){var b=this.options.index,c;if(w(b)){for(c=a.length;c--;)if(b>=H(a[c].options.index,a[c]._i)){a.splice(c+1,0,this);break}-1===c&&a.unshift(this);c+=1}else a.push(this);return H(c,
	a.length-1)},bindAxes:function(){var b=this,c=b.options,d=b.chart,e;u(b.axisTypes||[],function(f){u(d[f],function(a){e=a.options;if(c[f]===e.index||void 0!==c[f]&&c[f]===e.id||void 0===c[f]&&0===e.index)b.insert(a.series),b[f]=a,a.isDirty=!0});b[f]||b.optionalAxis===f||a.error(18,!0)})},updateParallelArrays:function(a,b){var c=a.series,d=arguments,f=w(b)?function(f){var d="y"===f&&c.toYData?c.toYData(a):a[f];c[f+"Data"][b]=d}:function(a){Array.prototype[b].apply(c[a+"Data"],Array.prototype.slice.call(d,
	2))};u(c.parallelArrays,f)},autoIncrement:function(){var a=this.options,b=this.xIncrement,c,d=a.pointIntervalUnit,b=H(b,a.pointStart,0);this.pointInterval=c=H(this.pointInterval,a.pointInterval,1);d&&(a=new g(b),"day"===d?a=+a[g.hcSetDate](a[g.hcGetDate]()+c):"month"===d?a=+a[g.hcSetMonth](a[g.hcGetMonth]()+c):"year"===d&&(a=+a[g.hcSetFullYear](a[g.hcGetFullYear]()+c)),c=a-b);this.xIncrement=b+c;return b},setOptions:function(a){var b=this.chart,c=b.options,d=c.plotOptions,f=(b.userOptions||{}).plotOptions||
	{},e=d[this.type];this.userOptions=a;b=y(e,d.series,a);this.tooltipOptions=y(k.tooltip,k.plotOptions.series&&k.plotOptions.series.tooltip,k.plotOptions[this.type].tooltip,c.tooltip.userOptions,d.series&&d.series.tooltip,d[this.type].tooltip,a.tooltip);this.stickyTracking=H(a.stickyTracking,f[this.type]&&f[this.type].stickyTracking,f.series&&f.series.stickyTracking,this.tooltipOptions.shared&&!this.noSharedTooltip?!0:b.stickyTracking);null===e.marker&&delete b.marker;this.zoneAxis=b.zoneAxis;a=this.zones=
	(b.zones||[]).slice();!b.negativeColor&&!b.negativeFillColor||b.zones||a.push({value:b[this.zoneAxis+"Threshold"]||b.threshold||0,className:"highcharts-negative",color:b.negativeColor,fillColor:b.negativeFillColor});a.length&&v(a[a.length-1].value)&&a.push({color:this.color,fillColor:this.fillColor});return b},getCyclic:function(a,b,c){var d,f=this.chart,e=this.userOptions,p=a+"Index",h=a+"Counter",l=c?c.length:H(f.options.chart[a+"Count"],f[a+"Count"]);b||(d=H(e[p],e["_"+p]),v(d)||(f.series.length||
	(f[h]=0),e["_"+p]=d=f[h]%l,f[h]+=1),c&&(b=c[d]));void 0!==d&&(this[p]=d);this[a]=b},getColor:function(){this.options.colorByPoint?this.options.color=null:this.getCyclic("color",this.options.color||q[this.type].color,this.chart.options.colors)},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)},drawLegendSymbol:a.LegendSymbolMixin.drawLineMarker,setData:function(d,e,h,l){var f=this,p=f.points,g=p&&p.length||0,r,n=f.options,k=f.chart,m=null,q=f.xAxis,
	E=n.turboThreshold,z=this.xData,y=this.yData,I=(r=f.pointArrayMap)&&r.length;d=d||[];r=d.length;e=H(e,!0);if(!1!==l&&r&&g===r&&!f.cropped&&!f.hasGroupedData&&f.visible)u(d,function(a,b){p[b].update&&a!==n.data[b]&&p[b].update(a,!1,null,!1)});else{f.xIncrement=null;f.colorCounter=0;u(this.parallelArrays,function(a){f[a+"Data"].length=0});if(E&&r>E){for(h=0;null===m&&h<r;)m=d[h],h++;if(w(m))for(h=0;h<r;h++)z[h]=this.autoIncrement(),y[h]=d[h];else if(c(m))if(I)for(h=0;h<r;h++)m=d[h],z[h]=m[0],y[h]=m.slice(1,
	I+1);else for(h=0;h<r;h++)m=d[h],z[h]=m[0],y[h]=m[1];else a.error(12)}else for(h=0;h<r;h++)void 0!==d[h]&&(m={series:f},f.pointClass.prototype.applyOptions.apply(m,[d[h]]),f.updateParallelArrays(m,h));b(y[0])&&a.error(14,!0);f.data=[];f.options.data=f.userOptions.data=d;for(h=g;h--;)p[h]&&p[h].destroy&&p[h].destroy();q&&(q.minRange=q.userMinRange);f.isDirty=k.isDirtyBox=!0;f.isDirtyData=!!p;h=!1}"point"===n.legendType&&(this.processData(),this.generatePoints());e&&k.redraw(h)},processData:function(b){var c=
	this.xData,d=this.yData,e=c.length,f;f=0;var h,p,l=this.xAxis,g,r=this.options;g=r.cropThreshold;var n=this.getExtremesFromAll||r.getExtremesFromAll,k=this.isCartesian,r=l&&l.val2lin,m=l&&l.isLog,q,w;if(k&&!this.isDirty&&!l.isDirty&&!this.yAxis.isDirty&&!b)return!1;l&&(b=l.getExtremes(),q=b.min,w=b.max);if(k&&this.sorted&&!n&&(!g||e>g||this.forceCrop))if(c[e-1]<q||c[0]>w)c=[],d=[];else if(c[0]<q||c[e-1]>w)f=this.cropData(this.xData,this.yData,q,w),c=f.xData,d=f.yData,f=f.start,h=!0;for(g=c.length||
	1;--g;)e=m?r(c[g])-r(c[g-1]):c[g]-c[g-1],0<e&&(void 0===p||e<p)?p=e:0>e&&this.requireSorting&&a.error(15);this.cropped=h;this.cropStart=f;this.processedXData=c;this.processedYData=d;this.closestPointRange=p},cropData:function(a,b,c,d){var f=a.length,e=0,h=f,p=H(this.cropShoulder,1),l;for(l=0;l<f;l++)if(a[l]>=c){e=Math.max(0,l-p);break}for(c=l;c<f;c++)if(a[c]>d){h=c+p;break}return{xData:a.slice(e,h),yData:b.slice(e,h),start:e,end:h}},generatePoints:function(){var a=this.options,b=a.data,c=this.data,
	d,f=this.processedXData,e=this.processedYData,h=this.pointClass,l=f.length,g=this.cropStart||0,r,n=this.hasGroupedData,a=a.keys,k,m=[],q;c||n||(c=[],c.length=b.length,c=this.data=c);a&&n&&(this.options.keys=!1);for(q=0;q<l;q++)r=g+q,n?(k=(new h).init(this,[f[q]].concat(B(e[q]))),k.dataGroup=this.groupMap[q]):(k=c[r])||void 0===b[r]||(c[r]=k=(new h).init(this,b[r],f[q])),k&&(k.index=r,m[q]=k);this.options.keys=a;if(c&&(l!==(d=c.length)||n))for(q=0;q<d;q++)q!==g||n||(q+=l),c[q]&&(c[q].destroyElements(),
	c[q].plotX=void 0);this.data=c;this.points=m},getExtremes:function(a){var b=this.yAxis,d=this.processedXData,e,f=[],h=0;e=this.xAxis.getExtremes();var p=e.min,l=e.max,g,r,n,k;a=a||this.stackedYData||this.processedYData||[];e=a.length;for(k=0;k<e;k++)if(r=d[k],n=a[k],g=(w(n,!0)||c(n))&&(!b.positiveValuesOnly||n.length||0<n),r=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||(d[k]||r)>=p&&(d[k]||r)<=l,g&&r)if(g=n.length)for(;g--;)null!==n[g]&&(f[h++]=n[g]);else f[h++]=n;this.dataMin=
	F(f);this.dataMax=G(f)},translate:function(){this.processedXData||this.processData();this.generatePoints();var a=this.options,b=a.stacking,c=this.xAxis,d=c.categories,f=this.yAxis,e=this.points,h=e.length,l=!!this.modifyValue,g=a.pointPlacement,r="between"===g||w(g),n=a.threshold,k=a.startFromThreshold?n:0,q,z,y,B,u=Number.MAX_VALUE;"between"===g&&(g=.5);w(g)&&(g*=H(a.pointRange||c.pointRange));for(a=0;a<h;a++){var D=e[a],M=D.x,A=D.y;z=D.low;var C=b&&f.stacks[(this.negStacks&&A<(k?0:n)?"-":"")+this.stackKey],
	F;f.positiveValuesOnly&&null!==A&&0>=A&&(D.isNull=!0);D.plotX=q=m(Math.min(Math.max(-1E5,c.translate(M,0,0,0,1,g,"flags"===this.type)),1E5));b&&this.visible&&!D.isNull&&C&&C[M]&&(B=this.getStackIndicator(B,M,this.index),F=C[M],A=F.points[B.key],z=A[0],A=A[1],z===k&&B.key===C[M].base&&(z=H(n,f.min)),f.positiveValuesOnly&&0>=z&&(z=null),D.total=D.stackTotal=F.total,D.percentage=F.total&&D.y/F.total*100,D.stackY=A,F.setOffset(this.pointXOffset||0,this.barW||0));D.yBottom=v(z)?f.translate(z,0,1,0,1):
	null;l&&(A=this.modifyValue(A,D));D.plotY=z="number"===typeof A&&Infinity!==A?Math.min(Math.max(-1E5,f.translate(A,0,1,0,1)),1E5):void 0;D.isInside=void 0!==z&&0<=z&&z<=f.len&&0<=q&&q<=c.len;D.clientX=r?m(c.translate(M,0,0,0,1,g)):q;D.negative=D.y<(n||0);D.category=d&&void 0!==d[D.x]?d[D.x]:D.x;D.isNull||(void 0!==y&&(u=Math.min(u,Math.abs(q-y))),y=q);D.zone=this.zones.length&&D.getZone()}this.closestPointRangePx=u},getValidPoints:function(a,b){var c=this.chart;return d(a||this.points||[],function(a){return b&&
	!c.isInsidePlot(a.plotX,a.plotY,c.inverted)?!1:!a.isNull})},setClip:function(a){var b=this.chart,c=this.options,d=b.renderer,f=b.inverted,e=this.clipBox,h=e||b.clipBox,l=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,h.height,c.xAxis,c.yAxis].join(),g=b[l],p=b[l+"m"];g||(a&&(h.width=0,b[l+"m"]=p=d.clipRect(-99,f?-b.plotLeft:-b.plotTop,99,f?b.chartWidth:b.chartHeight)),b[l]=g=d.clipRect(h),g.count={length:0});a&&!g.count[this.index]&&(g.count[this.index]=!0,g.count.length+=1);!1!==c.clip&&
	(this.group.clip(a||e?g:b.clipRect),this.markerGroup.clip(p),this.sharedClipKey=l);a||(g.count[this.index]&&(delete g.count[this.index],--g.count.length),0===g.count.length&&l&&b[l]&&(e||(b[l]=b[l].destroy()),b[l+"m"]&&(b[l+"m"]=b[l+"m"].destroy())))},animate:function(a){var b=this.chart,c=A(this.options.animation),d;a?this.setClip(c):(d=this.sharedClipKey,(a=b[d])&&a.animate({width:b.plotSizeX},c),b[d+"m"]&&b[d+"m"].animate({width:b.plotSizeX+99},c),this.animate=null)},afterAnimate:function(){this.setClip();
	n(this,"afterAnimate")},drawPoints:function(){var a=this.points,b=this.chart,c,d,f,e,h=this.options.marker,l,g,r,n,k=this[this.specialGroup]||this.markerGroup,m=H(h.enabled,this.xAxis.isRadial?!0:null,this.closestPointRangePx>=2*h.radius);if(!1!==h.enabled||this._hasPointMarkers)for(d=0;d<a.length;d++)f=a[d],c=f.plotY,e=f.graphic,l=f.marker||{},g=!!f.marker,r=m&&void 0===l.enabled||l.enabled,n=f.isInside,r&&w(c)&&null!==f.y?(c=H(l.symbol,this.symbol),f.hasImage=0===c.indexOf("url"),r=this.markerAttribs(f,
	f.selected&&"select"),e?e[n?"show":"hide"](!0).animate(r):n&&(0<r.width||f.hasImage)&&(f.graphic=e=b.renderer.symbol(c,r.x,r.y,r.width,r.height,g?l:h).add(k)),e&&e.attr(this.pointAttribs(f,f.selected&&"select")),e&&e.addClass(f.getClassName(),!0)):e&&(f.graphic=e.destroy())},markerAttribs:function(a,b){var c=this.options.marker,d=a.marker||{},f=H(d.radius,c.radius);b&&(c=c.states[b],b=d.states&&d.states[b],f=H(b&&b.radius,c&&c.radius,f+(c&&c.radiusPlus||0)));a.hasImage&&(f=0);a={x:Math.floor(a.plotX)-
	f,y:a.plotY-f};f&&(a.width=a.height=2*f);return a},pointAttribs:function(a,b){var c=this.options.marker,d=a&&a.options,f=d&&d.marker||{},e=this.color,h=d&&d.color,l=a&&a.color,d=H(f.lineWidth,c.lineWidth);a=a&&a.zone&&a.zone.color;e=h||a||l||e;a=f.fillColor||c.fillColor||e;e=f.lineColor||c.lineColor||e;b&&(c=c.states[b],b=f.states&&f.states[b]||{},d=H(b.lineWidth,c.lineWidth,d+H(b.lineWidthPlus,c.lineWidthPlus,0)),a=b.fillColor||c.fillColor||a,e=b.lineColor||c.lineColor||e);return{stroke:e,"stroke-width":d,
	fill:a}},destroy:function(){var a=this,b=a.chart,c=/AppleWebKit\/533/.test(M.navigator.userAgent),d,f,e=a.data||[],g,k;n(a,"destroy");l(a);u(a.axisTypes||[],function(b){(k=a[b])&&k.series&&(h(k.series,a),k.isDirty=k.forceRedraw=!0)});a.legendItem&&a.chart.legend.destroyItem(a);for(f=e.length;f--;)(g=e[f])&&g.destroy&&g.destroy();a.points=null;clearTimeout(a.animationTimeout);D(a,function(a,b){a instanceof r&&!a.survive&&(d=c&&"group"===b?"hide":"destroy",a[d]())});b.hoverSeries===a&&(b.hoverSeries=
	null);h(b.series,a);b.orderSeries();D(a,function(b,c){delete a[c]})},getGraphPath:function(a,b,c){var d=this,f=d.options,e=f.step,h,l=[],g=[],p;a=a||d.points;(h=a.reversed)&&a.reverse();(e={right:1,center:2}[e]||e&&3)&&h&&(e=4-e);!f.connectNulls||b||c||(a=this.getValidPoints(a));u(a,function(h,r){var n=h.plotX,k=h.plotY,m=a[r-1];(h.leftCliff||m&&m.rightCliff)&&!c&&(p=!0);h.isNull&&!v(b)&&0<r?p=!f.connectNulls:h.isNull&&!b?p=!0:(0===r||p?r=["M",h.plotX,h.plotY]:d.getPointSpline?r=d.getPointSpline(a,
	h,r):e?(r=1===e?["L",m.plotX,k]:2===e?["L",(m.plotX+n)/2,m.plotY,"L",(m.plotX+n)/2,k]:["L",n,m.plotY],r.push("L",n,k)):r=["L",n,k],g.push(h.x),e&&g.push(h.x),l.push.apply(l,r),p=!1)});l.xMap=g;return d.graphPath=l},drawGraph:function(){var a=this,b=this.options,c=(this.gappedPath||this.getGraphPath).call(this),d=[["graph","highcharts-graph",b.lineColor||this.color,b.dashStyle]];u(this.zones,function(c,e){d.push(["zone-graph-"+e,"highcharts-graph highcharts-zone-graph-"+e+" "+(c.className||""),c.color||
	a.color,c.dashStyle||b.dashStyle])});u(d,function(f,d){var e=f[0],h=a[e];h?(h.endX=c.xMap,h.animate({d:c})):c.length&&(a[e]=a.chart.renderer.path(c).addClass(f[1]).attr({zIndex:1}).add(a.group),h={stroke:f[2],"stroke-width":b.lineWidth,fill:a.fillGraph&&a.color||"none"},f[3]?h.dashstyle=f[3]:"square"!==b.linecap&&(h["stroke-linecap"]=h["stroke-linejoin"]="round"),h=a[e].attr(h).shadow(2>d&&b.shadow));h&&(h.startX=c.xMap,h.isArea=c.isArea)})},applyZones:function(){var a=this,b=this.chart,c=b.renderer,
	d=this.zones,f,e,h=this.clips||[],l,g=this.graph,r=this.area,n=Math.max(b.chartWidth,b.chartHeight),k=this[(this.zoneAxis||"y")+"Axis"],m,q,w=b.inverted,z,y,B,v,D=!1;d.length&&(g||r)&&k&&void 0!==k.min&&(q=k.reversed,z=k.horiz,g&&g.hide(),r&&r.hide(),m=k.getExtremes(),u(d,function(d,p){f=q?z?b.plotWidth:0:z?0:k.toPixels(m.min);f=Math.min(Math.max(H(e,f),0),n);e=Math.min(Math.max(Math.round(k.toPixels(H(d.value,m.max),!0)),0),n);D&&(f=e=k.toPixels(m.max));y=Math.abs(f-e);B=Math.min(f,e);v=Math.max(f,
	e);k.isXAxis?(l={x:w?v:B,y:0,width:y,height:n},z||(l.x=b.plotHeight-l.x)):(l={x:0,y:w?v:B,width:n,height:y},z&&(l.y=b.plotWidth-l.y));w&&c.isVML&&(l=k.isXAxis?{x:0,y:q?B:v,height:l.width,width:b.chartWidth}:{x:l.y-b.plotLeft-b.spacingBox.x,y:0,width:l.height,height:b.chartHeight});h[p]?h[p].animate(l):(h[p]=c.clipRect(l),g&&a["zone-graph-"+p].clip(h[p]),r&&a["zone-area-"+p].clip(h[p]));D=d.value>m.max}),this.clips=h)},invertGroups:function(a){function b(){u(["group","markerGroup"],function(b){c[b]&&
	(d.renderer.isVML&&c[b].attr({width:c.yAxis.len,height:c.xAxis.len}),c[b].width=c.yAxis.len,c[b].height=c.xAxis.len,c[b].invert(a))})}var c=this,d=c.chart,f;c.xAxis&&(f=C(d,"resize",b),C(c,"destroy",f),b(a),c.invertGroups=b)},plotGroup:function(a,b,c,d,f){var e=this[a],h=!e;h&&(this[a]=e=this.chart.renderer.g().attr({zIndex:d||.1}).add(f));e.addClass("highcharts-"+b+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series highcharts-color-"+this.colorIndex+" "+(this.options.className||""),
	!0);e.attr({visibility:c})[h?"attr":"animate"](this.getPlotBox());return e},getPlotBox:function(){var a=this.chart,b=this.xAxis,c=this.yAxis;a.inverted&&(b=c,c=this.xAxis);return{translateX:b?b.left:a.plotLeft,translateY:c?c.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,b=a.chart,c,d=a.options,f=!!a.animate&&b.renderer.isSVG&&A(d.animation).duration,e=a.visible?"inherit":"hidden",h=d.zIndex,l=a.hasRendered,g=b.seriesGroup,r=b.inverted;c=a.plotGroup("group","series",e,h,g);a.markerGroup=
	a.plotGroup("markerGroup","markers",e,h,g);f&&a.animate(!0);c.inverted=a.isCartesian?r:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.drawDataLabels&&a.drawDataLabels();a.visible&&a.drawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();a.invertGroups(r);!1===d.clip||a.sharedClipKey||l||c.clip(b.clipRect);f&&a.animate();l||(a.animationTimeout=z(function(){a.afterAnimate()},f));a.isDirty=!1;a.hasRendered=!0},redraw:function(){var a=this.chart,b=this.isDirty||this.isDirtyData,
	c=this.group,d=this.xAxis,f=this.yAxis;c&&(a.inverted&&c.attr({width:a.plotWidth,height:a.plotHeight}),c.animate({translateX:H(d&&d.left,a.plotLeft),translateY:H(f&&f.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var c=this.xAxis,d=this.yAxis,f=this.chart.inverted;return this.searchKDTree({clientX:f?c.len-a.chartY+c.pos:a.chartX-c.pos,plotY:f?d.len-a.chartX+d.pos:a.chartY-d.pos},b)},buildKDTree:function(){function a(c,
	f,d){var e,h;if(h=c&&c.length)return e=b.kdAxisArray[f%d],c.sort(function(a,b){return a[e]-b[e]}),h=Math.floor(h/2),{point:c[h],left:a(c.slice(0,h),f+1,d),right:a(c.slice(h+1),f+1,d)}}this.buildingKdTree=!0;var b=this,c=-1<b.options.findNearestPointBy.indexOf("y")?2:1;delete b.kdTree;z(function(){b.kdTree=a(b.getValidPoints(null,!b.directTouch),c,c);b.buildingKdTree=!1},b.options.kdNow?0:1)},searchKDTree:function(a,b){function c(a,b,l,g){var r=b.point,p=d.kdAxisArray[l%g],n,k,m=r;k=v(a[f])&&v(r[f])?
	Math.pow(a[f]-r[f],2):null;n=v(a[e])&&v(r[e])?Math.pow(a[e]-r[e],2):null;n=(k||0)+(n||0);r.dist=v(n)?Math.sqrt(n):Number.MAX_VALUE;r.distX=v(k)?Math.sqrt(k):Number.MAX_VALUE;p=a[p]-r[p];n=0>p?"left":"right";k=0>p?"right":"left";b[n]&&(n=c(a,b[n],l+1,g),m=n[h]<m[h]?n:r);b[k]&&Math.sqrt(p*p)<m[h]&&(a=c(a,b[k],l+1,g),m=a[h]<m[h]?a:m);return m}var d=this,f=this.kdAxisArray[0],e=this.kdAxisArray[1],h=b?"distX":"dist";b=-1<d.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||this.buildingKdTree||
	this.buildKDTree();if(this.kdTree)return c(a,this.kdTree,b,b)}})})(K);(function(a){function C(a,e,g,d,c){var h=a.chart.inverted;this.axis=a;this.isNegative=g;this.options=e;this.x=d;this.total=null;this.points={};this.stack=c;this.rightCliff=this.leftCliff=0;this.alignOptions={align:e.align||(h?g?"left":"right":"center"),verticalAlign:e.verticalAlign||(h?"middle":g?"bottom":"top"),y:u(e.y,h?4:g?14:-6),x:u(e.x,h?g?-6:6:0)};this.textAlign=e.textAlign||(h?g?"right":"left":"center")}var A=a.Axis,G=a.Chart,
	F=a.correctFloat,m=a.defined,g=a.destroyObjectProperties,k=a.each,q=a.format,v=a.objectEach,u=a.pick;a=a.Series;C.prototype={destroy:function(){g(this,this.axis)},render:function(a){var e=this.options,h=e.format,h=h?q(h,this):e.formatter.call(this);this.label?this.label.attr({text:h,visibility:"hidden"}):this.label=this.axis.chart.renderer.text(h,null,null,e.useHTML).css(e.style).attr({align:this.textAlign,rotation:e.rotation,visibility:"hidden"}).add(a)},setOffset:function(a,e){var h=this.axis,d=
	h.chart,c=d.inverted,g=h.reversed,g=this.isNegative&&!g||!this.isNegative&&g,b=h.translate(h.usePercentage?100:this.total,0,0,0,1),h=h.translate(0),h=Math.abs(b-h);a=d.xAxis[0].translate(this.x)+a;var k=d.plotHeight,c={x:c?g?b:b-h:a,y:c?k-a-e:g?k-b-h:k-b,width:c?h:e,height:c?e:h};if(e=this.label)e.align(this.alignOptions,null,c),c=e.alignAttr,e[!1===this.options.crop||d.isInsidePlot(c.x,c.y)?"show":"hide"](!0)}};G.prototype.getStacks=function(){var a=this;k(a.yAxis,function(a){a.stacks&&a.hasVisibleSeries&&
	(a.oldStacks=a.stacks)});k(a.series,function(e){!e.options.stacking||!0!==e.visible&&!1!==a.options.chart.ignoreHiddenSeries||(e.stackKey=e.type+u(e.options.stack,""))})};A.prototype.buildStacks=function(){var a=this.series,e,g=u(this.options.reversedStacks,!0),d=a.length,c;if(!this.isXAxis){this.usePercentage=!1;for(c=d;c--;)a[g?c:d-c-1].setStackedPoints();for(c=d;c--;)e=a[g?c:d-c-1],e.setStackCliffs&&e.setStackCliffs();if(this.usePercentage)for(c=0;c<d;c++)a[c].setPercentStacks()}};A.prototype.renderStackTotals=
	function(){var a=this.chart,e=a.renderer,g=this.stacks,d=this.stackTotalGroup;d||(this.stackTotalGroup=d=e.g("stack-labels").attr({visibility:"visible",zIndex:6}).add());d.translate(a.plotLeft,a.plotTop);v(g,function(a){v(a,function(a){a.render(d)})})};A.prototype.resetStacks=function(){var a=this,e=a.stacks;a.isXAxis||v(e,function(e){v(e,function(d,c){d.touched<a.stacksTouched?(d.destroy(),delete e[c]):(d.total=null,d.cum=null)})})};A.prototype.cleanStacks=function(){var a;this.isXAxis||(this.oldStacks&&
	(a=this.stacks=this.oldStacks),v(a,function(a){v(a,function(a){a.cum=a.total})}))};a.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var a=this.processedXData,e=this.processedYData,g=[],d=e.length,c=this.options,k=c.threshold,b=c.startFromThreshold?k:0,q=c.stack,c=c.stacking,v=this.stackKey,H="-"+v,l=this.negStacks,B=this.yAxis,r=B.stacks,z=B.oldStacks,M,p,E,I,A,f,t;B.stacksTouched+=1;for(A=0;A<d;A++)f=a[A],t=e[A],
	M=this.getStackIndicator(M,f,this.index),I=M.key,E=(p=l&&t<(b?0:k))?H:v,r[E]||(r[E]={}),r[E][f]||(z[E]&&z[E][f]?(r[E][f]=z[E][f],r[E][f].total=null):r[E][f]=new C(B,B.options.stackLabels,p,f,q)),E=r[E][f],null!==t&&(E.points[I]=E.points[this.index]=[u(E.cum,b)],m(E.cum)||(E.base=I),E.touched=B.stacksTouched,0<M.index&&!1===this.singleStacks&&(E.points[I][0]=E.points[this.index+","+f+",0"][0])),"percent"===c?(p=p?v:H,l&&r[p]&&r[p][f]?(p=r[p][f],E.total=p.total=Math.max(p.total,E.total)+Math.abs(t)||
	0):E.total=F(E.total+(Math.abs(t)||0))):E.total=F(E.total+(t||0)),E.cum=u(E.cum,b)+(t||0),null!==t&&(E.points[I].push(E.cum),g[A]=E.cum);"percent"===c&&(B.usePercentage=!0);this.stackedYData=g;B.oldStacks={}}};a.prototype.setPercentStacks=function(){var a=this,e=a.stackKey,g=a.yAxis.stacks,d=a.processedXData,c;k([e,"-"+e],function(e){for(var b=d.length,h,k;b--;)if(h=d[b],c=a.getStackIndicator(c,h,a.index,e),h=(k=g[e]&&g[e][h])&&k.points[c.key])k=k.total?100/k.total:0,h[0]=F(h[0]*k),h[1]=F(h[1]*k),
	a.stackedYData[b]=h[1]})};a.prototype.getStackIndicator=function(a,e,g,d){!m(a)||a.x!==e||d&&a.key!==d?a={x:e,index:0,key:d}:a.index++;a.key=[g,e,a.index].join();return a}})(K);(function(a){var C=a.addEvent,A=a.animate,G=a.Axis,F=a.createElement,m=a.css,g=a.defined,k=a.each,q=a.erase,v=a.extend,u=a.fireEvent,h=a.inArray,e=a.isNumber,n=a.isObject,d=a.isArray,c=a.merge,w=a.objectEach,b=a.pick,y=a.Point,D=a.Series,H=a.seriesTypes,l=a.setAnimation,B=a.splat;v(a.Chart.prototype,{addSeries:function(a,c,
	d){var e,h=this;a&&(c=b(c,!0),u(h,"addSeries",{options:a},function(){e=h.initSeries(a);h.isDirtyLegend=!0;h.linkSeries();c&&h.redraw(d)}));return e},addAxis:function(a,d,e,h){var g=d?"xAxis":"yAxis",l=this.options;a=c(a,{index:this[g].length,isX:d});new G(this,a);l[g]=B(l[g]||{});l[g].push(a);b(e,!0)&&this.redraw(h)},showLoading:function(a){var b=this,c=b.options,d=b.loadingDiv,e=c.loading,h=function(){d&&m(d,{left:b.plotLeft+"px",top:b.plotTop+"px",width:b.plotWidth+"px",height:b.plotHeight+"px"})};
	d||(b.loadingDiv=d=F("div",{className:"highcharts-loading highcharts-loading-hidden"},null,b.container),b.loadingSpan=F("span",{className:"highcharts-loading-inner"},null,d),C(b,"redraw",h));d.className="highcharts-loading";b.loadingSpan.innerHTML=a||c.lang.loading;m(d,v(e.style,{zIndex:10}));m(b.loadingSpan,e.labelStyle);b.loadingShown||(m(d,{opacity:0,display:""}),A(d,{opacity:e.style.opacity||.5},{duration:e.showDuration||0}));b.loadingShown=!0;h()},hideLoading:function(){var a=this.options,b=
	this.loadingDiv;b&&(b.className="highcharts-loading highcharts-loading-hidden",A(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){m(b,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions tooltip".split(" "),
	update:function(a,d){var l=this,r={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle"},n=a.chart,m,q;if(n){c(!0,l.options.chart,n);"className"in n&&l.setClassName(n.className);if("inverted"in n||"polar"in n)l.propFromSeries(),m=!0;"alignTicks"in n&&(m=!0);w(n,function(a,b){-1!==h("chart."+b,l.propsRequireUpdateSeries)&&(q=!0);-1!==h(b,l.propsRequireDirtyBox)&&(l.isDirtyBox=!0)});"style"in n&&l.renderer.setStyle(n.style)}a.colors&&(this.options.colors=a.colors);a.plotOptions&&c(!0,this.options.plotOptions,
	a.plotOptions);w(a,function(a,b){if(l[b]&&"function"===typeof l[b].update)l[b].update(a,!1);else if("function"===typeof l[r[b]])l[r[b]](a);"chart"!==b&&-1!==h(b,l.propsRequireUpdateSeries)&&(q=!0)});k("xAxis yAxis zAxis series colorAxis pane".split(" "),function(b){a[b]&&k(B(a[b]),function(a,c){(c=g(a.id)&&l.get(a.id)||l[b][c])&&c.coll===b&&c.update(a,!1)})});m&&k(l.axes,function(a){a.update({},!1)});q&&k(l.series,function(a){a.update({},!1)});a.loading&&c(!0,l.options.loading,a.loading);m=n&&n.width;
	n=n&&n.height;e(m)&&m!==l.chartWidth||e(n)&&n!==l.chartHeight?l.setSize(m,n):b(d,!0)&&l.redraw()},setSubtitle:function(a){this.setTitle(void 0,a)}});v(y.prototype,{update:function(a,c,d,e){function h(){l.applyOptions(a);null===l.y&&f&&(l.graphic=f.destroy());n(a,!0)&&(f&&f.element&&a&&a.marker&&a.marker.symbol&&(l.graphic=f.destroy()),a&&a.dataLabels&&l.dataLabel&&(l.dataLabel=l.dataLabel.destroy()));r=l.index;g.updateParallelArrays(l,r);p.data[r]=n(p.data[r],!0)||n(a,!0)?l.options:a;g.isDirty=g.isDirtyData=
	!0;!g.fixedBox&&g.hasCartesianSeries&&(k.isDirtyBox=!0);"point"===p.legendType&&(k.isDirtyLegend=!0);c&&k.redraw(d)}var l=this,g=l.series,f=l.graphic,r,k=g.chart,p=g.options;c=b(c,!0);!1===e?h():l.firePointEvent("update",{options:a},h)},remove:function(a,b){this.series.removePoint(h(this,this.series.data),a,b)}});v(D.prototype,{addPoint:function(a,c,d,e){var h=this.options,l=this.data,g=this.chart,f=this.xAxis,f=f&&f.hasNames&&f.names,r=h.data,k,p,n=this.xData,m,q;c=b(c,!0);k={series:this};this.pointClass.prototype.applyOptions.apply(k,
	[a]);q=k.x;m=n.length;if(this.requireSorting&&q<n[m-1])for(p=!0;m&&n[m-1]>q;)m--;this.updateParallelArrays(k,"splice",m,0,0);this.updateParallelArrays(k,m);f&&k.name&&(f[q]=k.name);r.splice(m,0,a);p&&(this.data.splice(m,0,null),this.processData());"point"===h.legendType&&this.generatePoints();d&&(l[0]&&l[0].remove?l[0].remove(!1):(l.shift(),this.updateParallelArrays(k,"shift"),r.shift()));this.isDirtyData=this.isDirty=!0;c&&g.redraw(e)},removePoint:function(a,c,d){var e=this,h=e.data,g=h[a],k=e.points,
	f=e.chart,r=function(){k&&k.length===h.length&&k.splice(a,1);h.splice(a,1);e.options.data.splice(a,1);e.updateParallelArrays(g||{series:e},"splice",a,1);g&&g.destroy();e.isDirty=!0;e.isDirtyData=!0;c&&f.redraw()};l(d,f);c=b(c,!0);g?g.firePointEvent("remove",null,r):r()},remove:function(a,c,d){function e(){h.destroy();l.isDirtyLegend=l.isDirtyBox=!0;l.linkSeries();b(a,!0)&&l.redraw(c)}var h=this,l=h.chart;!1!==d?u(h,"remove",null,e):e()},update:function(a,d){var e=this,h=e.chart,l=e.userOptions,g=
	e.oldType||e.type,r=a.type||l.type||h.options.chart.type,f=H[g].prototype,n=["group","markerGroup","dataLabelsGroup"],m;if(Object.keys&&"data"===Object.keys(a).toString())return this.setData(a.data,d);if(r&&r!==g||void 0!==a.zIndex)n.length=0;k(n,function(a){n[a]=e[a];delete e[a]});a=c(l,{animation:!1,index:e.index,pointStart:e.xData[0]},{data:e.options.data},a);e.remove(!1,null,!1);for(m in f)e[m]=void 0;v(e,H[r||g].prototype);k(n,function(a){e[a]=n[a]});e.init(h,a);e.oldType=g;h.linkSeries();b(d,
	!0)&&h.redraw(!1)}});v(G.prototype,{update:function(a,d){var e=this.chart;a=e.options[this.coll][this.options.index]=c(this.userOptions,a);this.destroy(!0);this.init(e,v(a,{events:void 0}));e.isDirtyBox=!0;b(d,!0)&&e.redraw()},remove:function(a){for(var c=this.chart,e=this.coll,h=this.series,l=h.length;l--;)h[l]&&h[l].remove(!1);q(c.axes,this);q(c[e],this);d(c.options[e])?c.options[e].splice(this.options.index,1):delete c.options[e];k(c[e],function(a,b){a.options.index=b});this.destroy();c.isDirtyBox=
	!0;b(a,!0)&&c.redraw()},setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}})})(K);(function(a){var C=a.color,A=a.each,G=a.map,F=a.pick,m=a.Series,g=a.seriesType;g("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,getStackPoints:function(){var g=[],m=[],v=this.xAxis,u=this.yAxis,h=u.stacks[this.stackKey],e={},n=this.points,d=this.index,c=u.series,w=c.length,b,y=F(u.options.reversedStacks,!0)?1:-1,D;if(this.options.stacking){for(D=
	0;D<n.length;D++)e[n[D].x]=n[D];a.objectEach(h,function(a,b){null!==a.total&&m.push(b)});m.sort(function(a,b){return a-b});b=G(c,function(){return this.visible});A(m,function(a,c){var l=0,k,n;if(e[a]&&!e[a].isNull)g.push(e[a]),A([-1,1],function(l){var g=1===l?"rightNull":"leftNull",r=0,q=h[m[c+l]];if(q)for(D=d;0<=D&&D<w;)k=q.points[D],k||(D===d?e[a][g]=!0:b[D]&&(n=h[a].points[D])&&(r-=n[1]-n[0])),D+=y;e[a][1===l?"rightCliff":"leftCliff"]=r});else{for(D=d;0<=D&&D<w;){if(k=h[a].points[D]){l=k[1];break}D+=
	y}l=u.translate(l,0,1,0,1);g.push({isNull:!0,plotX:v.translate(a,0,0,0,1),x:a,plotY:l,yBottom:l})}})}return g},getGraphPath:function(a){var g=m.prototype.getGraphPath,k=this.options,u=k.stacking,h=this.yAxis,e,n,d=[],c=[],w=this.index,b,y=h.stacks[this.stackKey],D=k.threshold,A=h.getThreshold(k.threshold),l,k=k.connectNulls||"percent"===u,B=function(e,l,g){var k=a[e];e=u&&y[k.x].points[w];var n=k[g+"Null"]||0;g=k[g+"Cliff"]||0;var r,m,k=!0;g||n?(r=(n?e[0]:e[1])+g,m=e[0]+g,k=!!n):!u&&a[l]&&a[l].isNull&&
	(r=m=D);void 0!==r&&(c.push({plotX:b,plotY:null===r?A:h.getThreshold(r),isNull:k,isCliff:!0}),d.push({plotX:b,plotY:null===m?A:h.getThreshold(m),doCurve:!1}))};a=a||this.points;u&&(a=this.getStackPoints());for(e=0;e<a.length;e++)if(n=a[e].isNull,b=F(a[e].rectPlotX,a[e].plotX),l=F(a[e].yBottom,A),!n||k)k||B(e,e-1,"left"),n&&!u&&k||(c.push(a[e]),d.push({x:e,plotX:b,plotY:l})),k||B(e,e+1,"right");e=g.call(this,c,!0,!0);d.reversed=!0;n=g.call(this,d,!0,!0);n.length&&(n[0]="L");n=e.concat(n);g=g.call(this,
	c,!1,k);n.xMap=e.xMap;this.areaPath=n;return g},drawGraph:function(){this.areaPath=[];m.prototype.drawGraph.apply(this);var a=this,g=this.areaPath,v=this.options,u=[["area","highcharts-area",this.color,v.fillColor]];A(this.zones,function(h,e){u.push(["zone-area-"+e,"highcharts-area highcharts-zone-area-"+e+" "+h.className,h.color||a.color,h.fillColor||v.fillColor])});A(u,function(h){var e=h[0],k=a[e];k?(k.endX=g.xMap,k.animate({d:g})):(k=a[e]=a.chart.renderer.path(g).addClass(h[1]).attr({fill:F(h[3],
	C(h[2]).setOpacity(F(v.fillOpacity,.75)).get()),zIndex:0}).add(a.group),k.isArea=!0);k.startX=g.xMap;k.shiftUnit=v.step?2:1})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(K);(function(a){var C=a.pick;a=a.seriesType;a("spline","line",{},{getPointSpline:function(a,G,F){var m=G.plotX,g=G.plotY,k=a[F-1];F=a[F+1];var q,v,u,h;if(k&&!k.isNull&&!1!==k.doCurve&&!G.isCliff&&F&&!F.isNull&&!1!==F.doCurve&&!G.isCliff){a=k.plotY;u=F.plotX;F=F.plotY;var e=0;q=(1.5*m+k.plotX)/2.5;v=(1.5*g+a)/2.5;u=(1.5*
	m+u)/2.5;h=(1.5*g+F)/2.5;u!==q&&(e=(h-v)*(u-m)/(u-q)+g-h);v+=e;h+=e;v>a&&v>g?(v=Math.max(a,g),h=2*g-v):v<a&&v<g&&(v=Math.min(a,g),h=2*g-v);h>F&&h>g?(h=Math.max(F,g),v=2*g-h):h<F&&h<g&&(h=Math.min(F,g),v=2*g-h);G.rightContX=u;G.rightContY=h}G=["C",C(k.rightContX,k.plotX),C(k.rightContY,k.plotY),C(q,m),C(v,g),m,g];k.rightContX=k.rightContY=null;return G}})})(K);(function(a){var C=a.seriesTypes.area.prototype,A=a.seriesType;A("areaspline","spline",a.defaultPlotOptions.area,{getStackPoints:C.getStackPoints,
	getGraphPath:C.getGraphPath,setStackCliffs:C.setStackCliffs,drawGraph:C.drawGraph,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(K);(function(a){var C=a.animObject,A=a.color,G=a.each,F=a.extend,m=a.isNumber,g=a.merge,k=a.pick,q=a.Series,v=a.seriesType,u=a.svg;v("column","line",{borderRadius:0,crisp:!0,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1,shadow:!1},select:{color:"#cccccc",borderColor:"#000000",shadow:!1}},
	dataLabels:{align:null,verticalAlign:null,y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){q.prototype.init.apply(this,arguments);var a=this,e=a.chart;e.hasRendered&&G(e.series,function(e){e.type===a.type&&(e.isDirty=!0)})},getColumnMetrics:function(){var a=this,e=a.options,g=a.xAxis,d=a.yAxis,c=g.reversed,m,b={},q=0;!1===e.grouping?
	q=1:G(a.chart.series,function(c){var e=c.options,g=c.yAxis,h;c.type!==a.type||!c.visible&&a.chart.options.chart.ignoreHiddenSeries||d.len!==g.len||d.pos!==g.pos||(e.stacking?(m=c.stackKey,void 0===b[m]&&(b[m]=q++),h=b[m]):!1!==e.grouping&&(h=q++),c.columnIndex=h)});var u=Math.min(Math.abs(g.transA)*(g.ordinalSlope||e.pointRange||g.closestPointRange||g.tickInterval||1),g.len),v=u*e.groupPadding,l=(u-2*v)/(q||1),e=Math.min(e.maxPointWidth||g.len,k(e.pointWidth,l*(1-2*e.pointPadding)));a.columnMetrics=
	{width:e,offset:(l-e)/2+(v+((a.columnIndex||0)+(c?1:0))*l-u/2)*(c?-1:1)};return a.columnMetrics},crispCol:function(a,e,g,d){var c=this.chart,h=this.borderWidth,b=-(h%2?.5:0),h=h%2?.5:1;c.inverted&&c.renderer.isVML&&(h+=1);this.options.crisp&&(g=Math.round(a+g)+b,a=Math.round(a)+b,g-=a);d=Math.round(e+d)+h;b=.5>=Math.abs(e)&&.5<d;e=Math.round(e)+h;d-=e;b&&d&&(--e,d+=1);return{x:a,y:e,width:g,height:d}},translate:function(){var a=this,e=a.chart,g=a.options,d=a.dense=2>a.closestPointRange*a.xAxis.transA,
	d=a.borderWidth=k(g.borderWidth,d?0:1),c=a.yAxis,m=a.translatedThreshold=c.getThreshold(g.threshold),b=k(g.minPointLength,5),y=a.getColumnMetrics(),u=y.width,v=a.barW=Math.max(u,1+2*d),l=a.pointXOffset=y.offset;e.inverted&&(m-=.5);g.pointPadding&&(v=Math.ceil(v));q.prototype.translate.apply(a);G(a.points,function(d){var g=k(d.yBottom,m),h=999+Math.abs(g),h=Math.min(Math.max(-h,d.plotY),c.len+h),n=d.plotX+l,p=v,q=Math.min(h,g),w,y=Math.max(h,g)-q;Math.abs(y)<b&&b&&(y=b,w=!c.reversed&&!d.negative||
	c.reversed&&d.negative,q=Math.abs(q-m)>b?g-b:m-(w?b:0));d.barX=n;d.pointWidth=u;d.tooltipPos=e.inverted?[c.len+c.pos-e.plotLeft-h,a.xAxis.len-n-p/2,y]:[n+p/2,h+c.pos-e.plotTop,y];d.shapeType="rect";d.shapeArgs=a.crispCol.apply(a,d.isNull?[n,m,p,0]:[n,q,p,y])})},getSymbol:a.noop,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(a,e){var h=this.options,d,c=this.pointAttrToOptions||{};
	d=c.stroke||"borderColor";var k=c["stroke-width"]||"borderWidth",b=a&&a.color||this.color,m=a[d]||h[d]||this.color||b,q=a[k]||h[k]||this[k]||0,c=h.dashStyle;a&&this.zones.length&&(b=a.getZone(),b=a.options.color||b&&b.color||this.color);e&&(a=g(h.states[e],a.options.states&&a.options.states[e]||{}),e=a.brightness,b=a.color||void 0!==e&&A(b).brighten(a.brightness).get()||b,m=a[d]||m,q=a[k]||q,c=a.dashStyle||c);d={fill:b,stroke:m,"stroke-width":q};h.borderRadius&&(d.r=h.borderRadius);c&&(d.dashstyle=
	c);return d},drawPoints:function(){var a=this,e=this.chart,k=a.options,d=e.renderer,c=k.animationLimit||250,q;G(a.points,function(b){var h=b.graphic;if(m(b.plotY)&&null!==b.y){q=b.shapeArgs;if(h)h[e.pointCount<c?"animate":"attr"](g(q));else b.graphic=h=d[b.shapeType](q).add(b.group||a.group);h.attr(a.pointAttribs(b,b.selected&&"select")).shadow(k.shadow,null,k.stacking&&!k.borderRadius);h.addClass(b.getClassName(),!0)}else h&&(b.graphic=h.destroy())})},animate:function(a){var e=this,g=this.yAxis,
	d=e.options,c=this.chart.inverted,h={};u&&(a?(h.scaleY=.001,a=Math.min(g.pos+g.len,Math.max(g.pos,g.toPixels(d.threshold))),c?h.translateX=a-g.len:h.translateY=a,e.group.attr(h)):(h[c?"translateX":"translateY"]=g.pos,e.group.animate(h,F(C(e.options.animation),{step:function(a,c){e.group.attr({scaleY:Math.max(.001,c.pos)})}})),e.animate=null))},remove:function(){var a=this,e=a.chart;e.hasRendered&&G(e.series,function(e){e.type===a.type&&(e.isDirty=!0)});q.prototype.remove.apply(a,arguments)}})})(K);
	(function(a){a=a.seriesType;a("bar","column",null,{inverted:!0})})(K);(function(a){var C=a.Series;a=a.seriesType;a("scatter","line",{lineWidth:0,findNearestPointBy:"xy",marker:{enabled:!0},tooltip:{headerFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cspan style\x3d"font-size: 0.85em"\x3e {series.name}\x3c/span\x3e\x3cbr/\x3e',pointFormat:"x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,
	trackerGroups:["group","markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,drawGraph:function(){this.options.lineWidth&&C.prototype.drawGraph.call(this)}})})(K);(function(a){var C=a.pick,A=a.relativeLength;a.CenteredSeriesMixin={getCenter:function(){var a=this.options,F=this.chart,m=2*(a.slicedOffset||0),g=F.plotWidth-2*m,F=F.plotHeight-2*m,k=a.center,k=[C(k[0],"50%"),C(k[1],"50%"),a.size||"100%",a.innerSize||0],q=Math.min(g,F),v,u;for(v=0;4>v;++v)u=k[v],a=2>v||2===v&&/%$/.test(u),k[v]=A(u,[g,
	F,q,k[2]][v])+(a?m:0);k[3]>k[2]&&(k[3]=k[2]);return k}}})(K);(function(a){var C=a.addEvent,A=a.defined,G=a.each,F=a.extend,m=a.inArray,g=a.noop,k=a.pick,q=a.Point,v=a.Series,u=a.seriesType,h=a.setAnimation;u("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{distance:30,enabled:!0,formatter:function(){return this.point.isNull?void 0:this.point.name},x:0},ignoreHiddenPoint:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},
	borderColor:"#ffffff",borderWidth:1,states:{hover:{brightness:.1,shadow:!1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:a.seriesTypes.column.prototype.pointAttribs,animate:function(a){var e=this,d=e.points,c=e.startAngleRad;a||(G(d,function(a){var b=a.graphic,d=a.shapeArgs;b&&(b.attr({r:a.startR||e.center[3]/2,start:c,end:c}),b.animate({r:d.r,start:d.start,end:d.end},e.options.animation))}),e.animate=null)},
	updateTotals:function(){var a,g=0,d=this.points,c=d.length,h,b=this.options.ignoreHiddenPoint;for(a=0;a<c;a++)h=d[a],g+=b&&!h.visible?0:h.isNull?0:h.y;this.total=g;for(a=0;a<c;a++)h=d[a],h.percentage=0<g&&(h.visible||!b)?h.y/g*100:0,h.total=g},generatePoints:function(){v.prototype.generatePoints.call(this);this.updateTotals()},translate:function(a){this.generatePoints();var e=0,d=this.options,c=d.slicedOffset,g=c+(d.borderWidth||0),b,h,m,q=d.startAngle||0,l=this.startAngleRad=Math.PI/180*(q-90),q=
	(this.endAngleRad=Math.PI/180*(k(d.endAngle,q+360)-90))-l,u=this.points,r,z=d.dataLabels.distance,d=d.ignoreHiddenPoint,v,p=u.length,E;a||(this.center=a=this.getCenter());this.getX=function(b,c,d){m=Math.asin(Math.min((b-a[1])/(a[2]/2+d.labelDistance),1));return a[0]+(c?-1:1)*Math.cos(m)*(a[2]/2+d.labelDistance)};for(v=0;v<p;v++){E=u[v];E.labelDistance=k(E.options.dataLabels&&E.options.dataLabels.distance,z);this.maxLabelDistance=Math.max(this.maxLabelDistance||0,E.labelDistance);b=l+e*q;if(!d||E.visible)e+=
	E.percentage/100;h=l+e*q;E.shapeType="arc";E.shapeArgs={x:a[0],y:a[1],r:a[2]/2,innerR:a[3]/2,start:Math.round(1E3*b)/1E3,end:Math.round(1E3*h)/1E3};m=(h+b)/2;m>1.5*Math.PI?m-=2*Math.PI:m<-Math.PI/2&&(m+=2*Math.PI);E.slicedTranslation={translateX:Math.round(Math.cos(m)*c),translateY:Math.round(Math.sin(m)*c)};h=Math.cos(m)*a[2]/2;r=Math.sin(m)*a[2]/2;E.tooltipPos=[a[0]+.7*h,a[1]+.7*r];E.half=m<-Math.PI/2||m>Math.PI/2?1:0;E.angle=m;b=Math.min(g,E.labelDistance/5);E.labelPos=[a[0]+h+Math.cos(m)*E.labelDistance,
	a[1]+r+Math.sin(m)*E.labelDistance,a[0]+h+Math.cos(m)*b,a[1]+r+Math.sin(m)*b,a[0]+h,a[1]+r,0>E.labelDistance?"center":E.half?"right":"left",m]}},drawGraph:null,drawPoints:function(){var a=this,g=a.chart.renderer,d,c,h,b,k=a.options.shadow;k&&!a.shadowGroup&&(a.shadowGroup=g.g("shadow").add(a.group));G(a.points,function(e){if(!e.isNull){c=e.graphic;b=e.shapeArgs;d=e.getTranslate();var m=e.shadowGroup;k&&!m&&(m=e.shadowGroup=g.g("shadow").add(a.shadowGroup));m&&m.attr(d);h=a.pointAttribs(e,e.selected&&
	"select");c?c.setRadialReference(a.center).attr(h).animate(F(b,d)):(e.graphic=c=g[e.shapeType](b).setRadialReference(a.center).attr(d).add(a.group),e.visible||c.attr({visibility:"hidden"}),c.attr(h).attr({"stroke-linejoin":"round"}).shadow(k,m));c.addClass(e.getClassName())}})},searchPoint:g,sortByAngle:function(a,g){a.sort(function(a,c){return void 0!==a.angle&&(c.angle-a.angle)*g})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,getCenter:a.CenteredSeriesMixin.getCenter,getSymbol:g},{init:function(){q.prototype.init.apply(this,
	arguments);var a=this,g;a.name=k(a.name,"Slice");g=function(d){a.slice("select"===d.type)};C(a,"select",g);C(a,"unselect",g);return a},isValid:function(){return a.isNumber(this.y,!0)&&0<=this.y},setVisible:function(a,g){var d=this,c=d.series,e=c.chart,b=c.options.ignoreHiddenPoint;g=k(g,b);a!==d.visible&&(d.visible=d.options.visible=a=void 0===a?!d.visible:a,c.options.data[m(d,c.data)]=d.options,G(["graphic","dataLabel","connector","shadowGroup"],function(b){if(d[b])d[b][a?"show":"hide"](!0)}),d.legendItem&&
	e.legend.colorizeItem(d,a),a||"hover"!==d.state||d.setState(""),b&&(c.isDirty=!0),g&&e.redraw())},slice:function(a,g,d){var c=this.series;h(d,c.chart);k(g,!0);this.sliced=this.options.sliced=A(a)?a:!this.sliced;c.options.data[m(this,c.data)]=this.options;this.graphic.animate(this.getTranslate());this.shadowGroup&&this.shadowGroup.animate(this.getTranslate())},getTranslate:function(){return this.sliced?this.slicedTranslation:{translateX:0,translateY:0}},haloPath:function(a){var e=this.shapeArgs;return this.sliced||
	!this.visible?[]:this.series.chart.renderer.symbols.arc(e.x,e.y,e.r+a,e.r+a,{innerR:this.shapeArgs.r,start:e.start,end:e.end})}})})(K);(function(a){var C=a.addEvent,A=a.arrayMax,G=a.defined,F=a.each,m=a.extend,g=a.format,k=a.map,q=a.merge,v=a.noop,u=a.pick,h=a.relativeLength,e=a.Series,n=a.seriesTypes,d=a.stableSort;a.distribute=function(a,e){function b(a,b){return a.target-b.target}var c,g=!0,h=a,l=[],m;m=0;for(c=a.length;c--;)m+=a[c].size;if(m>e){d(a,function(a,b){return(b.rank||0)-(a.rank||0)});
	for(m=c=0;m<=e;)m+=a[c].size,c++;l=a.splice(c-1,a.length)}d(a,b);for(a=k(a,function(a){return{size:a.size,targets:[a.target]}});g;){for(c=a.length;c--;)g=a[c],m=(Math.min.apply(0,g.targets)+Math.max.apply(0,g.targets))/2,g.pos=Math.min(Math.max(0,m-g.size/2),e-g.size);c=a.length;for(g=!1;c--;)0<c&&a[c-1].pos+a[c-1].size>a[c].pos&&(a[c-1].size+=a[c].size,a[c-1].targets=a[c-1].targets.concat(a[c].targets),a[c-1].pos+a[c-1].size>e&&(a[c-1].pos=e-a[c-1].size),a.splice(c,1),g=!0)}c=0;F(a,function(a){var b=
	0;F(a.targets,function(){h[c].pos=a.pos+b;b+=h[c].size;c++})});h.push.apply(h,l);d(h,b)};e.prototype.drawDataLabels=function(){var c=this,d=c.options,b=d.dataLabels,e=c.points,h,k,l=c.hasRendered||0,m,r,n=u(b.defer,!!d.animation),v=c.chart.renderer;if(b.enabled||c._hasPointLabels)c.dlProcessOptions&&c.dlProcessOptions(b),r=c.plotGroup("dataLabelsGroup","data-labels",n&&!l?"hidden":"visible",b.zIndex||6),n&&(r.attr({opacity:+l}),l||C(c,"afterAnimate",function(){c.visible&&r.show(!0);r[d.animation?
	"animate":"attr"]({opacity:1},{duration:200})})),k=b,F(e,function(e){var l,p=e.dataLabel,n,f,t=e.connector,w=!p,z;h=e.dlOptions||e.options&&e.options.dataLabels;if(l=u(h&&h.enabled,k.enabled)&&null!==e.y)b=q(k,h),n=e.getLabelConfig(),m=b.format?g(b.format,n):b.formatter.call(n,b),z=b.style,n=b.rotation,z.color=u(b.color,z.color,c.color,"#000000"),"contrast"===z.color&&(e.contrastColor=v.getContrast(e.color||c.color),z.color=b.inside||0>u(e.labelDistance,b.distance)||d.stacking?e.contrastColor:"#000000"),
	d.cursor&&(z.cursor=d.cursor),f={fill:b.backgroundColor,stroke:b.borderColor,"stroke-width":b.borderWidth,r:b.borderRadius||0,rotation:n,padding:b.padding,zIndex:1},a.objectEach(f,function(a,b){void 0===a&&delete f[b]});!p||l&&G(m)?l&&G(m)&&(p?f.text=m:(p=e.dataLabel=v[n?"text":"label"](m,0,-9999,b.shape,null,null,b.useHTML,null,"data-label"),p.addClass("highcharts-data-label-color-"+e.colorIndex+" "+(b.className||"")+(b.useHTML?"highcharts-tracker":""))),p.attr(f),p.css(z).shadow(b.shadow),p.added||
	p.add(r),c.alignDataLabel(e,p,b,null,w)):(e.dataLabel=p=p.destroy(),t&&(e.connector=t.destroy()))})};e.prototype.alignDataLabel=function(a,d,b,e,g){var c=this.chart,h=c.inverted,k=u(a.plotX,-9999),r=u(a.plotY,-9999),n=d.getBBox(),q,p=b.rotation,w=b.align,v=this.visible&&(a.series.forceDL||c.isInsidePlot(k,Math.round(r),h)||e&&c.isInsidePlot(k,h?e.x+1:e.y+e.height-1,h)),y="justify"===u(b.overflow,"justify");if(v&&(q=b.style.fontSize,q=c.renderer.fontMetrics(q,d).b,e=m({x:h?c.plotWidth-r:k,y:Math.round(h?
	c.plotHeight-k:r),width:0,height:0},e),m(b,{width:n.width,height:n.height}),p?(y=!1,k=c.renderer.rotCorr(q,p),k={x:e.x+b.x+e.width/2+k.x,y:e.y+b.y+{top:0,middle:.5,bottom:1}[b.verticalAlign]*e.height},d[g?"attr":"animate"](k).attr({align:w}),r=(p+720)%360,r=180<r&&360>r,"left"===w?k.y-=r?n.height:0:"center"===w?(k.x-=n.width/2,k.y-=n.height/2):"right"===w&&(k.x-=n.width,k.y-=r?0:n.height)):(d.align(b,null,e),k=d.alignAttr),y?a.isLabelJustified=this.justifyDataLabel(d,b,k,n,e,g):u(b.crop,!0)&&(v=c.isInsidePlot(k.x,
	k.y)&&c.isInsidePlot(k.x+n.width,k.y+n.height)),b.shape&&!p))d[g?"attr":"animate"]({anchorX:h?c.plotWidth-a.plotY:a.plotX,anchorY:h?c.plotHeight-a.plotX:a.plotY});v||(d.attr({y:-9999}),d.placed=!1)};e.prototype.justifyDataLabel=function(a,d,b,e,g,h){var c=this.chart,k=d.align,m=d.verticalAlign,n,q,p=a.box?0:a.padding||0;n=b.x+p;0>n&&("right"===k?d.align="left":d.x=-n,q=!0);n=b.x+e.width-p;n>c.plotWidth&&("left"===k?d.align="right":d.x=c.plotWidth-n,q=!0);n=b.y+p;0>n&&("bottom"===m?d.verticalAlign=
	"top":d.y=-n,q=!0);n=b.y+e.height-p;n>c.plotHeight&&("top"===m?d.verticalAlign="bottom":d.y=c.plotHeight-n,q=!0);q&&(a.placed=!h,a.align(d,null,g));return q};n.pie&&(n.pie.prototype.drawDataLabels=function(){var c=this,d=c.data,b,g=c.chart,h=c.options.dataLabels,k=u(h.connectorPadding,10),l=u(h.connectorWidth,1),m=g.plotWidth,r=g.plotHeight,n,q=c.center,p=q[2]/2,v=q[1],C,L,f,t,K=[[],[]],J,N,O,P,x=[0,0,0,0];c.visible&&(h.enabled||c._hasPointLabels)&&(F(d,function(a){a.dataLabel&&a.visible&&a.dataLabel.shortened&&
	(a.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),a.dataLabel.shortened=!1)}),e.prototype.drawDataLabels.apply(c),F(d,function(a){a.dataLabel&&a.visible&&(K[a.half].push(a),a.dataLabel._pos=null)}),F(K,function(d,e){var l,n,u=d.length,w=[],z;if(u)for(c.sortByAngle(d,e-.5),0<c.maxLabelDistance&&(l=Math.max(0,v-p-c.maxLabelDistance),n=Math.min(v+p+c.maxLabelDistance,g.plotHeight),F(d,function(a){0<a.labelDistance&&a.dataLabel&&(a.top=Math.max(0,v-p-a.labelDistance),a.bottom=
	Math.min(v+p+a.labelDistance,g.plotHeight),z=a.dataLabel.getBBox().height||21,a.positionsIndex=w.push({target:a.labelPos[1]-a.top+z/2,size:z,rank:a.y})-1)}),a.distribute(w,n+z-l)),P=0;P<u;P++)b=d[P],n=b.positionsIndex,f=b.labelPos,C=b.dataLabel,O=!1===b.visible?"hidden":"inherit",l=f[1],w&&G(w[n])?void 0===w[n].pos?O="hidden":(t=w[n].size,N=b.top+w[n].pos):N=l,delete b.positionIndex,J=h.justify?q[0]+(e?-1:1)*(p+b.labelDistance):c.getX(N<b.top+2||N>b.bottom-2?l:N,e,b),C._attr={visibility:O,align:f[6]},
	C._pos={x:J+h.x+({left:k,right:-k}[f[6]]||0),y:N+h.y-10},f.x=J,f.y=N,L=C.getBBox().width,l=null,J-L<k?(l=Math.round(L-J+k),x[3]=Math.max(l,x[3])):J+L>m-k&&(l=Math.round(J+L-m+k),x[1]=Math.max(l,x[1])),0>N-t/2?x[0]=Math.max(Math.round(-N+t/2),x[0]):N+t/2>r&&(x[2]=Math.max(Math.round(N+t/2-r),x[2])),C.sideOverflow=l}),0===A(x)||this.verifyDataLabelOverflow(x))&&(this.placeDataLabels(),l&&F(this.points,function(a){var b;n=a.connector;if((C=a.dataLabel)&&C._pos&&a.visible&&0<a.labelDistance){O=C._attr.visibility;
	if(b=!n)a.connector=n=g.renderer.path().addClass("highcharts-data-label-connector highcharts-color-"+a.colorIndex).add(c.dataLabelsGroup),n.attr({"stroke-width":l,stroke:h.connectorColor||a.color||"#666666"});n[b?"attr":"animate"]({d:c.connectorPath(a.labelPos)});n.attr("visibility",O)}else n&&(a.connector=n.destroy())}))},n.pie.prototype.connectorPath=function(a){var c=a.x,b=a.y;return u(this.options.dataLabels.softConnector,!0)?["M",c+("left"===a[6]?5:-5),b,"C",c,b,2*a[2]-a[4],2*a[3]-a[5],a[2],
	a[3],"L",a[4],a[5]]:["M",c+("left"===a[6]?5:-5),b,"L",a[2],a[3],"L",a[4],a[5]]},n.pie.prototype.placeDataLabels=function(){F(this.points,function(a){var c=a.dataLabel;c&&a.visible&&((a=c._pos)?(c.sideOverflow&&(c._attr.width=c.getBBox().width-c.sideOverflow,c.css({width:c._attr.width+"px",textOverflow:"ellipsis"}),c.shortened=!0),c.attr(c._attr),c[c.moved?"animate":"attr"](a),c.moved=!0):c&&c.attr({y:-9999}))},this)},n.pie.prototype.alignDataLabel=v,n.pie.prototype.verifyDataLabelOverflow=function(a){var c=
	this.center,b=this.options,d=b.center,e=b.minSize||80,g,l=null!==b.size;l||(null!==d[0]?g=Math.max(c[2]-Math.max(a[1],a[3]),e):(g=Math.max(c[2]-a[1]-a[3],e),c[0]+=(a[3]-a[1])/2),null!==d[1]?g=Math.max(Math.min(g,c[2]-Math.max(a[0],a[2])),e):(g=Math.max(Math.min(g,c[2]-a[0]-a[2]),e),c[1]+=(a[0]-a[2])/2),g<c[2]?(c[2]=g,c[3]=Math.min(h(b.innerSize||0,g),g),this.translate(c),this.drawDataLabels&&this.drawDataLabels()):l=!0);return l});n.column&&(n.column.prototype.alignDataLabel=function(a,d,b,g,h){var c=
	this.chart.inverted,l=a.series,k=a.dlBox||a.shapeArgs,m=u(a.below,a.plotY>u(this.translatedThreshold,l.yAxis.len)),n=u(b.inside,!!this.options.stacking);k&&(g=q(k),0>g.y&&(g.height+=g.y,g.y=0),k=g.y+g.height-l.yAxis.len,0<k&&(g.height-=k),c&&(g={x:l.yAxis.len-g.y-g.height,y:l.xAxis.len-g.x-g.width,width:g.height,height:g.width}),n||(c?(g.x+=m?0:g.width,g.width=0):(g.y+=m?g.height:0,g.height=0)));b.align=u(b.align,!c||n?"center":m?"right":"left");b.verticalAlign=u(b.verticalAlign,c||n?"middle":m?"top":
	"bottom");e.prototype.alignDataLabel.call(this,a,d,b,g,h);a.isLabelJustified&&a.contrastColor&&a.dataLabel.css({color:a.contrastColor})})})(K);(function(a){var C=a.Chart,A=a.each,G=a.pick,F=a.addEvent;C.prototype.callbacks.push(function(a){function g(){var g=[];A(a.series||[],function(a){var k=a.options.dataLabels,m=a.dataLabelCollections||["dataLabel"];(k.enabled||a._hasPointLabels)&&!k.allowOverlap&&a.visible&&A(m,function(h){A(a.points,function(a){a[h]&&(a[h].labelrank=G(a.labelrank,a.shapeArgs&&
	a.shapeArgs.height),g.push(a[h]))})})});a.hideOverlappingLabels(g)}g();F(a,"redraw",g)});C.prototype.hideOverlappingLabels=function(a){var g=a.length,k,m,v,u,h,e,n,d,c,w=function(a,c,d,e,g,h,k,m){return!(g>a+d||g+k<a||h>c+e||h+m<c)};for(m=0;m<g;m++)if(k=a[m])k.oldOpacity=k.opacity,k.newOpacity=1;a.sort(function(a,c){return(c.labelrank||0)-(a.labelrank||0)});for(m=0;m<g;m++)for(v=a[m],k=m+1;k<g;++k)if(u=a[k],v&&u&&v!==u&&v.placed&&u.placed&&0!==v.newOpacity&&0!==u.newOpacity&&(h=v.alignAttr,e=u.alignAttr,
	n=v.parentGroup,d=u.parentGroup,c=2*(v.box?0:v.padding),h=w(h.x+n.translateX,h.y+n.translateY,v.width-c,v.height-c,e.x+d.translateX,e.y+d.translateY,u.width-c,u.height-c)))(v.labelrank<u.labelrank?v:u).newOpacity=0;A(a,function(a){var b,c;a&&(c=a.newOpacity,a.oldOpacity!==c&&a.placed&&(c?a.show(!0):b=function(){a.hide()},a.alignAttr.opacity=c,a[a.isOld?"animate":"attr"](a.alignAttr,null,b)),a.isOld=!0)})}})(K);(function(a){var C=a.addEvent,A=a.Chart,G=a.createElement,F=a.css,m=a.defaultOptions,g=
	a.defaultPlotOptions,k=a.each,q=a.extend,v=a.fireEvent,u=a.hasTouch,h=a.inArray,e=a.isObject,n=a.Legend,d=a.merge,c=a.pick,w=a.Point,b=a.Series,y=a.seriesTypes,D=a.svg,H;H=a.TrackerMixin={drawTrackerPoint:function(){var a=this,b=a.chart.pointer,c=function(a){var c=b.getPointFromEvent(a);void 0!==c&&(b.isDirectTouch=!0,c.onMouseOver(a))};k(a.points,function(a){a.graphic&&(a.graphic.element.point=a);a.dataLabel&&(a.dataLabel.div?a.dataLabel.div.point=a:a.dataLabel.element.point=a)});a._hasTracking||
	(k(a.trackerGroups,function(d){if(a[d]){a[d].addClass("highcharts-tracker").on("mouseover",c).on("mouseout",function(a){b.onTrackerMouseOut(a)});if(u)a[d].on("touchstart",c);a.options.cursor&&a[d].css(F).css({cursor:a.options.cursor})}}),a._hasTracking=!0)},drawTrackerGraph:function(){var a=this,b=a.options,c=b.trackByArea,d=[].concat(c?a.areaPath:a.graphPath),e=d.length,g=a.chart,h=g.pointer,m=g.renderer,n=g.options.tooltip.snap,f=a.tracker,q,v=function(){if(g.hoverSeries!==a)a.onMouseOver()},w=
	"rgba(192,192,192,"+(D?.0001:.002)+")";if(e&&!c)for(q=e+1;q--;)"M"===d[q]&&d.splice(q+1,0,d[q+1]-n,d[q+2],"L"),(q&&"M"===d[q]||q===e)&&d.splice(q,0,"L",d[q-2]+n,d[q-1]);f?f.attr({d:d}):a.graph&&(a.tracker=m.path(d).attr({"stroke-linejoin":"round",visibility:a.visible?"visible":"hidden",stroke:w,fill:c?w:"none","stroke-width":a.graph.strokeWidth()+(c?0:2*n),zIndex:2}).add(a.group),k([a.tracker,a.markerGroup],function(a){a.addClass("highcharts-tracker").on("mouseover",v).on("mouseout",function(a){h.onTrackerMouseOut(a)});
	b.cursor&&a.css({cursor:b.cursor});if(u)a.on("touchstart",v)}))}};y.column&&(y.column.prototype.drawTracker=H.drawTrackerPoint);y.pie&&(y.pie.prototype.drawTracker=H.drawTrackerPoint);y.scatter&&(y.scatter.prototype.drawTracker=H.drawTrackerPoint);q(n.prototype,{setItemEvents:function(a,b,c){var e=this,g=e.chart.renderer.boxWrapper,h="highcharts-legend-"+(a.series?"point":"series")+"-active";(c?b:a.legendGroup).on("mouseover",function(){a.setState("hover");g.addClass(h);b.css(e.options.itemHoverStyle)}).on("mouseout",
	function(){b.css(d(a.visible?e.itemStyle:e.itemHiddenStyle));g.removeClass(h);a.setState()}).on("click",function(b){var c=function(){a.setVisible&&a.setVisible()};b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",b,c):v(a,"legendItemClick",b,c)})},createCheckboxForItem:function(a){a.checkbox=G("input",{type:"checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);C(a.checkbox,"click",function(b){v(a.series||a,"checkboxClick",
	{checked:b.target.checked,item:a},function(){a.select()})})}});m.legend.itemStyle.cursor="pointer";q(A.prototype,{showResetZoom:function(){var a=this,b=m.lang,c=a.options.chart.resetZoomButton,d=c.theme,e=d.states,g="chart"===c.relativeTo?null:"plotBox";this.resetZoomButton=a.renderer.button(b.resetZoom,null,null,function(){a.zoomOut()},d,e&&e.hover).attr({align:c.position.align,title:b.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(c.position,!1,g)},zoomOut:function(){var a=this;
	v(a,"selection",{resetSelection:!0},function(){a.zoom()})},zoom:function(a){var b,d=this.pointer,g=!1,h;!a||a.resetSelection?k(this.axes,function(a){b=a.zoom()}):k(a.xAxis.concat(a.yAxis),function(a){var c=a.axis;d[c.isXAxis?"zoomX":"zoomY"]&&(b=c.zoom(a.min,a.max),c.displayBtn&&(g=!0))});h=this.resetZoomButton;g&&!h?this.showResetZoom():!g&&e(h)&&(this.resetZoomButton=h.destroy());b&&this.redraw(c(this.options.chart.animation,a&&a.animation,100>this.pointCount))},pan:function(a,b){var c=this,d=c.hoverPoints,
	e;d&&k(d,function(a){a.setState()});k("xy"===b?[1,0]:[1],function(b){b=c[b?"xAxis":"yAxis"][0];var d=b.horiz,g=a[d?"chartX":"chartY"],d=d?"mouseDownX":"mouseDownY",h=c[d],f=(b.pointRange||0)/2,l=b.getExtremes(),k=b.toValue(h-g,!0)+f,f=b.toValue(h+b.len-g,!0)-f,m=f<k,h=m?f:k,k=m?k:f,f=Math.min(l.dataMin,b.toValue(b.toPixels(l.min)-b.minPixelPadding)),m=Math.max(l.dataMax,b.toValue(b.toPixels(l.max)+b.minPixelPadding)),n;n=f-h;0<n&&(k+=n,h=f);n=k-m;0<n&&(k=m,h-=n);b.series.length&&h!==l.min&&k!==l.max&&
	(b.setExtremes(h,k,!1,!1,{trigger:"pan"}),e=!0);c[d]=g});e&&c.redraw(!1);F(c.container,{cursor:"move"})}});q(w.prototype,{select:function(a,b){var d=this,e=d.series,g=e.chart;a=c(a,!d.selected);d.firePointEvent(a?"select":"unselect",{accumulate:b},function(){d.selected=d.options.selected=a;e.options.data[h(d,e.data)]=d.options;d.setState(a&&"select");b||k(g.getSelectedPoints(),function(a){a.selected&&a!==d&&(a.selected=a.options.selected=!1,e.options.data[h(a,e.data)]=a.options,a.setState(""),a.firePointEvent("unselect"))})})},
	onMouseOver:function(a){var b=this.series.chart,c=b.pointer;a=a?c.normalize(a):c.getChartCoordinatesFromPoint(this,b.inverted);c.runPointActions(a,this)},onMouseOut:function(){var a=this.series.chart;this.firePointEvent("mouseOut");k(a.hoverPoints||[],function(a){a.setState()});a.hoverPoints=a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var b=this,c=d(b.series.options.point,b.options).events;b.events=c;a.objectEach(c,function(a,c){C(b,c,a)});this.hasImportedEvents=!0}},setState:function(a,
	b){var d=Math.floor(this.plotX),e=this.plotY,h=this.series,l=h.options.states[a]||{},k=g[h.type].marker&&h.options.marker,m=k&&!1===k.enabled,n=k&&k.states&&k.states[a]||{},f=!1===n.enabled,t=h.stateMarkerGraphic,u=this.marker||{},v=h.chart,w=h.halo,y,B=k&&h.markerAttribs;a=a||"";if(!(a===this.state&&!b||this.selected&&"select"!==a||!1===l.enabled||a&&(f||m&&!1===n.enabled)||a&&u.states&&u.states[a]&&!1===u.states[a].enabled)){B&&(y=h.markerAttribs(this,a));if(this.graphic)this.state&&this.graphic.removeClass("highcharts-point-"+
	this.state),a&&this.graphic.addClass("highcharts-point-"+a),this.graphic.attr(h.pointAttribs(this,a)),y&&this.graphic.animate(y,c(v.options.chart.animation,n.animation,k.animation)),t&&t.hide();else{if(a&&n){k=u.symbol||h.symbol;t&&t.currentSymbol!==k&&(t=t.destroy());if(t)t[b?"animate":"attr"]({x:y.x,y:y.y});else k&&(h.stateMarkerGraphic=t=v.renderer.symbol(k,y.x,y.y,y.width,y.height).add(h.markerGroup),t.currentSymbol=k);t&&t.attr(h.pointAttribs(this,a))}t&&(t[a&&v.isInsidePlot(d,e,v.inverted)?
	"show":"hide"](),t.element.point=this)}(d=l.halo)&&d.size?(w||(h.halo=w=v.renderer.path().add((this.graphic||t).parentGroup)),w[b?"animate":"attr"]({d:this.haloPath(d.size)}),w.attr({"class":"highcharts-halo highcharts-color-"+c(this.colorIndex,h.colorIndex)}),w.point=this,w.attr(q({fill:this.color||h.color,"fill-opacity":d.opacity,zIndex:-1},d.attributes))):w&&w.point&&w.point.haloPath&&w.animate({d:w.point.haloPath(0)});this.state=a}},haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-
	a,this.plotY-a,2*a,2*a)}});q(b.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&v(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,c=b.tooltip,d=b.hoverPoint;b.hoverSeries=null;if(d)d.onMouseOut();this&&a.events.mouseOut&&v(this,"mouseOut");!c||this.stickyTracking||c.shared&&!this.noSharedTooltip||c.hide();this.setState()},setState:function(a){var b=this,
	d=b.options,e=b.graph,g=d.states,h=d.lineWidth,d=0;a=a||"";if(b.state!==a&&(k([b.group,b.markerGroup,b.dataLabelsGroup],function(c){c&&(b.state&&c.removeClass("highcharts-series-"+b.state),a&&c.addClass("highcharts-series-"+a))}),b.state=a,!g[a]||!1!==g[a].enabled)&&(a&&(h=g[a].lineWidth||h+(g[a].lineWidthPlus||0)),e&&!e.dashstyle))for(h={"stroke-width":h},e.animate(h,c(b.chart.options.chart.animation,g[a]&&g[a].animation));b["zone-graph-"+d];)b["zone-graph-"+d].attr(h),d+=1},setVisible:function(a,
	b){var c=this,d=c.chart,e=c.legendItem,g,h=d.options.chart.ignoreHiddenSeries,l=c.visible;g=(c.visible=a=c.options.visible=c.userOptions.visible=void 0===a?!l:a)?"show":"hide";k(["group","dataLabelsGroup","markerGroup","tracker","tt"],function(a){if(c[a])c[a][g]()});if(d.hoverSeries===c||(d.hoverPoint&&d.hoverPoint.series)===c)c.onMouseOut();e&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&k(d.series,function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});k(c.linkedSeries,function(b){b.setVisible(a,
	!1)});h&&(d.isDirtyBox=!0);!1!==b&&d.redraw();v(c,g)},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=void 0===a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);v(this,a?"select":"unselect")},drawTracker:H.drawTrackerGraph})})(K);(function(a){var C=a.Chart,A=a.each,G=a.inArray,F=a.isArray,m=a.isObject,g=a.pick,k=a.splat;C.prototype.setResponsive=function(g){var k=this.options.responsive,m=[],h=this.currentResponsive;k&&k.rules&&
	A(k.rules,function(e){void 0===e._id&&(e._id=a.uniqueKey());this.matchResponsiveRule(e,m,g)},this);var e=a.merge.apply(0,a.map(m,function(e){return a.find(k.rules,function(a){return a._id===e}).chartOptions})),m=m.toString()||void 0;m!==(h&&h.ruleIds)&&(h&&this.update(h.undoOptions,g),m?(this.currentResponsive={ruleIds:m,mergedOptions:e,undoOptions:this.currentOptions(e)},this.update(e,g)):this.currentResponsive=void 0)};C.prototype.matchResponsiveRule=function(a,k){var m=a.condition;(m.callback||
	function(){return this.chartWidth<=g(m.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=g(m.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=g(m.minWidth,0)&&this.chartHeight>=g(m.minHeight,0)}).call(this)&&k.push(a._id)};C.prototype.currentOptions=function(g){function q(g,e,n,d){var c;a.objectEach(g,function(a,b){if(!d&&-1<G(b,["series","xAxis","yAxis"]))for(g[b]=k(g[b]),n[b]=[],c=0;c<g[b].length;c++)e[b][c]&&(n[b][c]={},q(a[c],e[b][c],n[b][c],d+1));else m(a)?(n[b]=F(a)?[]:{},q(a,e[b]||{},n[b],d+1)):n[b]=
	e[b]||null})}var u={};q(g,this.options,u,0);return u}})(K);return K});


/***/ },
/* 389 */,
/* 390 */,
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 * highcharts-ng
	 * @version v1.1.0 - 2017-03-27
	 * @link https://github.com/pablojim/highcharts-ng
	 * @author Barry Fitzgerald <>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports){
	  module.exports = 'highcharts-ng';
	}
	
	(function () {
	  'use strict';
	  /*global angular: false*/
	  var Highcharts = null;
	
	  if (window && window.Highcharts) {
	    Highcharts = window.Highcharts;
	  } else if (module && module.exports === 'highcharts-ng') {
	        Highcharts = __webpack_require__(388);
	  }
	
	
	  angular.module('highcharts-ng', [])
	    .component('highchart', {
	        bindings: {
	            config: '<',
	            changeDetection: '<'
	          },
	          controller: HighChartNGController
	    });
	
	  HighChartNGController.$inject = ['$element', '$timeout'];
	
	  function HighChartNGController($element, $timeout) {
	    var seriesId = 0;
	    var ctrl = this;
	    var prevConfig = {};
	    var mergedConfig = {};
	    var detector = ctrl.changeDetection || angular.equals;
	    this.$onInit = function() {
	      ctrl.config.getChartObj = function(){
	        return ctrl.chart;
	      };
	      prevConfig = angular.merge({}, ctrl.config);
	      mergedConfig = getMergedOptions($element, ctrl.config, seriesId);
	      ctrl.chart = new Highcharts[getChartType(mergedConfig)](mergedConfig);
	
	      // Fix resizing bug
	      // https://github.com/pablojim/highcharts-ng/issues/550
	      var originalWidth = $element[0].clientWidth;
	      var originalHeight = $element[0].clientHeight;
	      $timeout(function() {
	        if ($element[0].clientWidth !== originalWidth || $element[0].clientHeight !== originalHeight) {
	          ctrl.chart.reflow();
	        }
	      }, 0, false);
	    };
	
	    this.$doCheck = function() {
	      if(!detector(ctrl.config, prevConfig)) {
	        prevConfig = angular.merge({}, ctrl.config);
	        mergedConfig = getMergedOptions($element, ctrl.config, seriesId);
	        var ids = ensureIds(mergedConfig.series, seriesId);
	        if (mergedConfig.series) {
	          //Remove any missing series
	          for (var i = ctrl.chart.series.length - 1; i >= 0; i--) {
	            var s = ctrl.chart.series[i];
	            if (s.options.id !== 'highcharts-navigator-series' && ids.indexOf(s.options.id) < 0) {
	              s.remove(false);
	            }
	          }
	          // Add any new series
	          angular.forEach(ctrl.config.series, function(s) {
	            if (!ctrl.chart.get(s.id)) {
	              ctrl.chart.addSeries(s);
	            }
	          });
	        }
	        ctrl.chart.update(mergedConfig, true);
	      }
	    };
	
	    this.$onDestroy = function() {
	        if (ctrl.chart) {
	          try{
	            ctrl.chart.destroy();
	          }catch(ex){
	            // fail silently as highcharts will throw exception if element doesn't exist
	          }
	
	          $timeout(function(){
	            $element.remove();
	          }, 0);
	        }
	      };
	    }
	
	  function getMergedOptions(element, config, seriesId) {
	    var mergedOptions = {};
	
	    var defaultOptions = {
	      chart: {
	        events: {}
	      },
	      title: {},
	      subtitle: {},
	      series: [],
	      credits: {},
	      plotOptions: {},
	      navigator: {},
	    };
	
	    if (config) {
	      //check all series and axis ids are set
	      if(config.series) {
	        ensureIds(config.series, seriesId);
	      }
	
	      mergedOptions = angular.merge(defaultOptions, config);
	    } else {
	      mergedOptions = defaultOptions;
	    }
	    mergedOptions.chart.renderTo = element[0];
	
	    //check chart type is set
	    return mergedOptions;
	  }
	
	  var chartTypeMap = {
	    'stock': 'StockChart',
	    'map':   'Map',
	    'chart': 'Chart'
	  };
	
	  function getChartType(config) {
	    if (config === undefined || config.chartType === undefined) return 'Chart';
	    return chartTypeMap[('' + config.chartType).toLowerCase()];
	  }
	
	  function ensureIds(series, seriesId) {
	    var ids = [];
	    angular.forEach(series, function(s) {
	      if (!angular.isDefined(s.id)) {
	        s.id = 'series-' + seriesId++;
	      }
	      ids.push(s.id);
	    });
	    return ids;
	  }
	
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(392)(module)))

/***/ },
/* 392 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	// support for Browserify
	
	__webpack_require__(380);
	__webpack_require__(394);
	
	module.exports = 'md.data.table';


/***/ },
/* 394 */
/***/ function(module, exports) {

	/*
	 * Angular Material Data Table
	 * https://github.com/daniel-nagy/md-data-table
	 * @license MIT
	 * v0.10.9
	 */
	(function (window, angular, undefined) {
	'use strict';
	
	angular.module('md.table.templates', ['md-table-pagination.html', 'md-table-progress.html', 'arrow-up.svg', 'navigate-before.svg', 'navigate-first.svg', 'navigate-last.svg', 'navigate-next.svg']);
	
	angular.module('md-table-pagination.html', []).run(['$templateCache', function($templateCache) {
	  $templateCache.put('md-table-pagination.html',
	    '<div class="page-select" ng-if="$pagination.showPageSelect()">\n' +
	    '  <div class="label">{{$pagination.label.page}}</div>\n' +
	    '\n' +
	    '  <md-select virtual-page-select total="{{$pagination.pages()}}" class="md-table-select" ng-model="$pagination.page" md-container-class="md-pagination-select" ng-change="$pagination.onPaginationChange()" ng-disabled="$pagination.disabled" aria-label="Page">\n' +
	    '    <md-content>\n' +
	    '      <md-option ng-repeat="page in $pageSelect.pages" ng-value="page">{{page}}</md-option>\n' +
	    '    </md-content>\n' +
	    '  </md-select>\n' +
	    '</div>\n' +
	    '\n' +
	    '<div class="limit-select" ng-if="$pagination.limitOptions">\n' +
	    '  <div class="label">{{$pagination.label.rowsPerPage}}</div>\n' +
	    '\n' +
	    '  <md-select class="md-table-select" ng-model="$pagination.limit" md-container-class="md-pagination-select" ng-disabled="$pagination.disabled" aria-label="Rows" placeholder="{{ $pagination.limitOptions[0] }}">\n' +
	    '    <md-option ng-repeat="option in $pagination.limitOptions" ng-value="option.value ? $pagination.eval(option.value) : option">{{::option.label ? option.label : option}}</md-option>\n' +
	    '  </md-select>\n' +
	    '</div>\n' +
	    '\n' +
	    '<div class="buttons">\n' +
	    '  <div class="label">{{$pagination.min()}} - {{$pagination.max()}} {{$pagination.label.of}} {{$pagination.total}}</div>\n' +
	    '\n' +
	    '  <md-button class="md-icon-button" type="button" ng-if="$pagination.showBoundaryLinks()" ng-click="$pagination.first()" ng-disabled="$pagination.disabled || !$pagination.hasPrevious()" aria-label="First">\n' +
	    '    <md-icon md-svg-icon="navigate-first.svg"></md-icon>\n' +
	    '  </md-button>\n' +
	    '\n' +
	    '  <md-button class="md-icon-button" type="button" ng-click="$pagination.previous()" ng-disabled="$pagination.disabled || !$pagination.hasPrevious()" aria-label="Previous">\n' +
	    '    <md-icon md-svg-icon="navigate-before.svg"></md-icon>\n' +
	    '  </md-button>\n' +
	    '\n' +
	    '  <md-button class="md-icon-button" type="button" ng-click="$pagination.next()" ng-disabled="$pagination.disabled || !$pagination.hasNext()" aria-label="Next">\n' +
	    '    <md-icon md-svg-icon="navigate-next.svg"></md-icon>\n' +
	    '  </md-button>\n' +
	    '\n' +
	    '  <md-button class="md-icon-button" type="button" ng-if="$pagination.showBoundaryLinks()" ng-click="$pagination.last()" ng-disabled="$pagination.disabled || !$pagination.hasNext()" aria-label="Last">\n' +
	    '    <md-icon md-svg-icon="navigate-last.svg"></md-icon>\n' +
	    '  </md-button>\n' +
	    '</div>');
	}]);
	
	angular.module('md-table-progress.html', []).run(['$templateCache', function($templateCache) {
	  $templateCache.put('md-table-progress.html',
	    '<tr>\n' +
	    '  <th colspan="{{columnCount()}}">\n' +
	    '    <md-progress-linear ng-show="deferred()" md-mode="indeterminate"></md-progress-linear>\n' +
	    '  </th>\n' +
	    '</tr>');
	}]);
	
	angular.module('arrow-up.svg', []).run(['$templateCache', function($templateCache) {
	  $templateCache.put('arrow-up.svg',
	    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"/></svg>');
	}]);
	
	angular.module('navigate-before.svg', []).run(['$templateCache', function($templateCache) {
	  $templateCache.put('navigate-before.svg',
	    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>');
	}]);
	
	angular.module('navigate-first.svg', []).run(['$templateCache', function($templateCache) {
	  $templateCache.put('navigate-first.svg',
	    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7 6 v12 h2 v-12 h-2z M17.41 7.41L16 6l-6 6 6 6 1.41-1.41L12.83 12z"/></svg>');
	}]);
	
	angular.module('navigate-last.svg', []).run(['$templateCache', function($templateCache) {
	  $templateCache.put('navigate-last.svg',
	    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15 6 v12 h2 v-12 h-2z M8 6L6.59 7.41 11.17 12l-4.58 4.59L8 18l6-6z"/></svg>');
	}]);
	
	angular.module('navigate-next.svg', []).run(['$templateCache', function($templateCache) {
	  $templateCache.put('navigate-next.svg',
	    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>');
	}]);
	
	
	angular.module('md.data.table', ['md.table.templates']);
	
	angular.module('md.data.table').directive('mdBody', mdBody);
	
	function mdBody() {
	
	  function compile(tElement) {
	    tElement.addClass('md-body');
	  }
	
	  return {
	    compile: compile,
	    restrict: 'A'
	  };
	}
	
	angular.module('md.data.table').directive('mdCell', mdCell);
	
	function mdCell() {
	  
	  function compile(tElement) {
	    var select = tElement.find('md-select');
	    
	    if(select.length) {
	      select.addClass('md-table-select').attr('md-container-class', 'md-table-select');
	    }
	    
	    tElement.addClass('md-cell');
	    
	    return postLink;
	  }
	  
	  // empty controller to be bind properties to in postLink function
	  function Controller() {
	    
	  }
	  
	  function postLink(scope, element, attrs, ctrls) {
	    var select = element.find('md-select');
	    var cellCtrl = ctrls.shift();
	    var tableCtrl = ctrls.shift();
	    
	    if(attrs.ngClick) {
	      element.addClass('md-clickable');
	    }
	    
	    if(select.length) {
	      select.on('click', function (event) {
	        event.stopPropagation();
	      });
	      
	      element.addClass('md-clickable').on('click', function (event) {
	        event.stopPropagation();
	        select[0].click();
	      });
	    }
	    
	    cellCtrl.getTable = tableCtrl.getElement;
	    
	    function getColumn() {
	      return tableCtrl.$$columns[getIndex()];
	    }
	    
	    function getIndex() {
	      return Array.prototype.indexOf.call(element.parent().children(), element[0]);
	    }
	    
	    scope.$watch(getColumn, function (column) {
	      if(!column) {
	        return;
	      }
	      
	      if(column.numeric) {
	        element.addClass('md-numeric');
	      } else {
	        element.removeClass('md-numeric');
	      }
	    });
	  }
	  
	  return {
	    controller: Controller,
	    compile: compile,
	    require: ['mdCell', '^^mdTable'],
	    restrict: 'A'
	  };
	}
	
	angular.module('md.data.table').directive('mdColumn', mdColumn);
	
	function mdColumn($compile, $mdUtil) {
	
	  function compile(tElement) {
	    tElement.addClass('md-column');
	    return postLink;
	  }
	
	  function postLink(scope, element, attrs, ctrls) {
	    var headCtrl = ctrls.shift();
	    var tableCtrl = ctrls.shift();
	
	    function attachSortIcon() {
	      var sortIcon = angular.element('<md-icon md-svg-icon="arrow-up.svg">');
	
	      $compile(sortIcon.addClass('md-sort-icon').attr('ng-class', 'getDirection()'))(scope);
	
	      if(element.hasClass('md-numeric')) {
	        element.prepend(sortIcon);
	      } else {
	        element.append(sortIcon);
	      }
	    }
	
	    function detachSortIcon() {
	      Array.prototype.some.call(element.find('md-icon'), function (icon) {
	        return icon.classList.contains('md-sort-icon') && element[0].removeChild(icon);
	      });
	    }
	
	    function disableSorting() {
	      detachSortIcon();
	      element.removeClass('md-sort').off('click', setOrder);
	    }
	
	    function enableSorting() {
	      attachSortIcon();
	      element.addClass('md-sort').on('click', setOrder);
	    }
	
	    function getIndex() {
	      return Array.prototype.indexOf.call(element.parent().children(), element[0]);
	    }
	
	    function isActive() {
	      return scope.orderBy && (headCtrl.order === scope.orderBy || headCtrl.order === '-' + scope.orderBy);
	    }
	
	    function isNumeric() {
	      return attrs.mdNumeric === '' || scope.numeric;
	    }
	
	    function setOrder() {
	      scope.$applyAsync(function () {
	        if(isActive()) {
	          headCtrl.order = scope.getDirection() === 'md-asc' ? '-' + scope.orderBy : scope.orderBy;
	        } else {
	          headCtrl.order = scope.getDirection() === 'md-asc' ? scope.orderBy : '-' + scope.orderBy;
	        }
	
	        if(angular.isFunction(headCtrl.onReorder)) {
	          $mdUtil.nextTick(function () {
	            headCtrl.onReorder(headCtrl.order);
	          });
	        }
	      });
	    }
	
	    function updateColumn(index, column) {
	      tableCtrl.$$columns[index] = column;
	
	      if(column.numeric) {
	        element.addClass('md-numeric');
	      } else {
	        element.removeClass('md-numeric');
	      }
	    }
	
	    scope.getDirection = function () {
	      if(isActive()) {
	        return headCtrl.order.charAt(0) === '-' ? 'md-desc' : 'md-asc';
	      }
	
	      return attrs.mdDesc === '' || scope.$eval(attrs.mdDesc) ? 'md-desc' : 'md-asc';
	    };
	
	    scope.$watch(isActive, function (active) {
	      if(active) {
	        element.addClass('md-active');
	      } else {
	        element.removeClass('md-active');
	      }
	    });
	
	    scope.$watch(getIndex, function (index) {
	      updateColumn(index, {'numeric': isNumeric()});
	    });
	
	    scope.$watch(isNumeric, function (numeric) {
	      updateColumn(getIndex(), {'numeric': numeric});
	    });
	
	    scope.$watch('orderBy', function (orderBy) {
	      if(orderBy) {
	        if(!element.hasClass('md-sort')) {
	          enableSorting();
	        }
	      } else if(element.hasClass('md-sort')) {
	        disableSorting();
	      }
	    });
	  }
	
	  return {
	    compile: compile,
	    require: ['^^mdHead', '^^mdTable'],
	    restrict: 'A',
	    scope: {
	      numeric: '=?mdNumeric',
	      orderBy: '@?mdOrderBy'
	    }
	  };
	}
	
	mdColumn.$inject = ['$compile', '$mdUtil'];
	
	angular.module('md.data.table')
	  .decorator('$controller', controllerDecorator)
	  .factory('$mdEditDialog', mdEditDialog);
	
	/*
	 * A decorator for ng.$controller to optionally bind properties to the
	 * controller before invoking the constructor. Stolen from the ngMock.
	 *
	 * https://docs.angularjs.org/api/ngMock/service/$controller
	 */
	function controllerDecorator($delegate) {
	  return function(expression, locals, later, ident) {
	    if(later && typeof later === 'object') {
	      var create = $delegate(expression, locals, true, ident);
	      angular.extend(create.instance, later);
	      return create();
	    }
	    return $delegate(expression, locals, later, ident);
	  };
	}
	
	controllerDecorator.$inject = ['$delegate'];
	  
	function mdEditDialog($compile, $controller, $document, $mdUtil, $q, $rootScope, $templateCache, $templateRequest, $window) {
	  /* jshint validthis: true */
	  
	  var ESCAPE = 27;
	  
	  var busy = false;
	  var body = angular.element($document.prop('body'));
	  
	  /*
	   * bindToController
	   * controller
	   * controllerAs
	   * locals
	   * resolve
	   * scope
	   * targetEvent
	   * template
	   * templateUrl
	   */
	  var defaultOptions = {
	    clickOutsideToClose: true,
	    disableScroll: true,
	    escToClose: true,
	    focusOnOpen: true
	  };
	  
	  function build(template, options) {
	    var scope = $rootScope.$new();
	    var element = $compile(template)(scope);
	    var backdrop = $mdUtil.createBackdrop(scope, 'md-edit-dialog-backdrop');
	    var controller;
	    
	    if(options.controller) {
	      controller = getController(options, scope, {$element: element, $scope: scope});
	    } else {
	      angular.extend(scope, options.scope);
	    }
	    
	    if(options.disableScroll) {
	      disableScroll(element);
	    }
	    
	    body.prepend(backdrop).append(element.addClass('md-whiteframe-1dp'));
	    
	    positionDialog(element, options.target);
	    
	    if(options.focusOnOpen) {
	      focusOnOpen(element);
	    }
	    
	    if(options.clickOutsideToClose) {
	      backdrop.on('click', function () {
	        element.remove();
	      });
	    }
	    
	    if(options.escToClose) {
	      escToClose(element);
	    }
	    
	    element.on('$destroy', function () {
	      busy = false;
	      backdrop.remove();
	    });
	    
	    return controller;
	  }
	  
	  function disableScroll(element) {
	    var restoreScroll = $mdUtil.disableScrollAround(element, body);
	    
	    element.on('$destroy', function () {
	      restoreScroll();
	    });
	  }
	  
	  function getController(options, scope, inject) {
	    if(!options.controller) {
	      return;
	    }
	    
	    if(options.resolve) {
	      angular.extend(inject, options.resolve);
	    }
	    
	    if(options.locals) {
	      angular.extend(inject, options.locals);
	    }
	    
	    if(options.controllerAs) {
	      scope[options.controllerAs] = {};
	      
	      if(options.bindToController) {
	        angular.extend(scope[options.controllerAs], options.scope);
	      } else {
	        angular.extend(scope, options.scope);
	      }
	    } else {
	      angular.extend(scope, options.scope);
	    }
	    
	    if(options.bindToController) {
	      return $controller(options.controller, inject, scope[options.controllerAs]);
	    } else {
	      return $controller(options.controller, inject);
	    }
	  }
	  
	  function getTemplate(options) {
	    return $q(function (resolve, reject) {
	      var template = options.template;
	      
	      function illegalType(type) {
	        reject('Unexpected template value. Expected a string; received a ' + type + '.');
	      }
	      
	      if(template) {
	        return angular.isString(template) ? resolve(template) : illegalType(typeof template);
	      }
	      
	      if(options.templateUrl) {
	        template = $templateCache.get(options.templateUrl);
	        
	        if(template) {
	          return resolve(template);
	        }
	        
	        var success = function (template) {
	          return resolve(template);
	        };
	        
	        var error = function () {
	          return reject('Error retrieving template from URL.');
	        };
	        
	        return $templateRequest(options.templateUrl).then(success, error);
	      }
	      
	      reject('Template not provided.');
	    });
	  }
	  
	  function logError(error) {
	    busy = false;
	    console.error(error);
	  }
	  
	  function escToClose(element) {
	    var keyup = function (event) {
	      if(event.keyCode === ESCAPE) {
	        element.remove();
	      }
	    };
	    
	    body.on('keyup', keyup);
	    
	    element.on('$destroy', function () {
	      body.off('keyup', keyup);
	    });
	  }
	
	  function focusOnOpen(element) {
	    $mdUtil.nextTick(function () {
	      var autofocus = $mdUtil.findFocusTarget(element);
	      
	      if(autofocus) {
	        autofocus.focus();
	      }
	    }, false);
	  }
	
	  function positionDialog(element, target) {
	    var table = angular.element(target).controller('mdCell').getTable();
	    
	    var getHeight = function () {
	      return element.prop('clientHeight');
	    };
	    
	    var getSize = function () {
	      return {
	        width: getWidth(),
	        height: getHeight()
	      };
	    };
	    
	    var getTableBounds = function () {
	      var parent = table.parent();
	      
	      if(parent.prop('tagName') === 'MD-TABLE-CONTAINER') {
	        return parent[0].getBoundingClientRect();
	      } else {
	        return table[0].getBoundingClientRect();
	      }
	    };
	    
	    var getWidth = function () {
	      return element.prop('clientWidth');
	    };
	    
	    var reposition = function () {
	      var size = getSize();
	      var cellBounds = target.getBoundingClientRect();
	      var tableBounds = getTableBounds();
	      
	      if(size.width > tableBounds.right - cellBounds.left) {
	        element.css('left', tableBounds.right - size.width + 'px');
	      } else {
	        element.css('left', cellBounds.left + 'px');
	      }
	      
	      if(size.height > tableBounds.bottom - cellBounds.top) {
	        element.css('top', tableBounds.bottom - size.height + 'px');
	      } else {
	        element.css('top', cellBounds.top + 1 + 'px');
	      }
	      
	      element.css('minWidth', cellBounds.width + 'px');
	    };
	    
	    var watchWidth = $rootScope.$watch(getWidth, reposition);
	    var watchHeight = $rootScope.$watch(getHeight, reposition);
	    
	    $window.addEventListener('resize', reposition);
	    
	    element.on('$destroy', function () {
	      watchWidth();
	      watchHeight();
	      
	      $window.removeEventListener('resize', reposition);
	    });
	  }
	  
	  function preset(size, options) {
	    
	    function getAttrs() {
	      var attrs = 'type="' + (options.type || 'text') + '"';
	      
	      for(var attr in options.validators) {
	        attrs += ' ' + attr + '="' + options.validators[attr] + '"';
	      }
	      
	      return attrs;
	    }
	    
	    return {
	      controller: ['$element', '$q', 'save', '$scope', function ($element, $q, save, $scope) {
	        function update() {
	          if($scope.editDialog.$invalid) {
	            return $q.reject();
	          }
	          
	          if(angular.isFunction(save)) {
	            return $q.when(save($scope.editDialog.input));
	          }
	          
	          return $q.resolve();
	        }
	        
	        this.dismiss = function () {
	          $element.remove();
	        };
	        
	        this.getInput = function () {
	          return $scope.editDialog.input;
	        };
	        
	        $scope.dismiss = this.dismiss;
	        
	        $scope.submit = function () {
	          update().then(function () {
	            $scope.dismiss();
	          });
	        };
	      }],
	      locals: {
	        save: options.save
	      },
	      scope: {
	        cancel: options.cancel || 'Cancel',
	        messages: options.messages,
	        model: options.modelValue,
	        ok: options.ok || 'Save',
	        placeholder: options.placeholder,
	        title: options.title,
	        size: size
	      },
	      template:
	        '<md-edit-dialog>' +
	          '<div layout="column" class="md-content">' +
	            '<div ng-if="size === \'large\'" class="md-title">{{title || \'Edit\'}}</div>' +
	            '<form name="editDialog" layout="column" ng-submit="submit(model)">' +
	              '<md-input-container md-no-float>' +
	                '<input name="input" ng-model="model" md-autofocus placeholder="{{placeholder}} "' + getAttrs() + '>' +
	                '<div ng-messages="editDialog.input.$error">' +
	                  '<div ng-repeat="(key, message) in messages" ng-message="{{key}}">{{message}}</div>' +
	                '</div>' +
	              '</md-input-container>' +
	            '</form>' +
	          '</div>' +
	          '<div ng-if="size === \'large\'" layout="row" layout-align="end" class="md-actions">' +
	            '<md-button class="md-primary" ng-click="dismiss()">{{cancel}}</md-button>' +
	            '<md-button class="md-primary" ng-click="submit()">{{ok}}</md-button>' +
	          '</div>' +
	        '</md-edit-dialog>'
	    };
	  }
	  
	  this.show = function (options) {
	    if(busy) {
	      return $q.reject();
	    }
	    
	    busy = true;
	    options = angular.extend({}, defaultOptions, options);
	    
	    if(!options.targetEvent) {
	      return logError('options.targetEvent is required to align the dialog with the table cell.');
	    }
	    
	    if(!options.targetEvent.currentTarget.classList.contains('md-cell')) {
	      return logError('The event target must be a table cell.');
	    }
	    
	    if(options.bindToController && !options.controllerAs) {
	      return logError('You must define options.controllerAs when options.bindToController is true.');
	    }
	    
	    options.target = options.targetEvent.currentTarget;
	    
	    var promise = getTemplate(options);
	    var promises = [promise];
	    
	    for(var prop in options.resolve) {
	      promise = options.resolve[prop];
	      promises.push($q.when(angular.isFunction(promise) ? promise() : promise));
	    }
	    
	    promise = $q.all(promises);
	    
	    promise['catch'](logError);
	    
	    return promise.then(function (results) {
	      var template = results.shift();
	      
	      for(var prop in options.resolve) {
	        options.resolve[prop] = results.shift();
	      }
	      
	      return build(template, options);
	    });
	  };
	  
	  this.small = function (options) {
	    return this.show(angular.extend({}, options, preset('small', options)));
	  }.bind(this);
	  
	  this.large = function (options) {
	    return this.show(angular.extend({}, options, preset('large', options)));
	  }.bind(this);
	  
	  return this;
	}
	
	mdEditDialog.$inject = ['$compile', '$controller', '$document', '$mdUtil', '$q', '$rootScope', '$templateCache', '$templateRequest', '$window'];
	
	
	angular.module('md.data.table').directive('mdFoot', mdFoot);
	
	function mdFoot() {
	
	  function compile(tElement) {
	    tElement.addClass('md-foot');
	  }
	
	  return {
	    compile: compile,
	    restrict: 'A'
	  };
	}
	
	angular.module('md.data.table').directive('mdHead', mdHead);
	
	function mdHead($compile) {
	
	  function compile(tElement) {
	    tElement.addClass('md-head');
	    return postLink;
	  }
	  
	  // empty controller to be bind scope properties to
	  function Controller() {
	    
	  }
	  
	  function postLink(scope, element, attrs, tableCtrl) {
	    // because scope.$watch is unpredictable
	    var oldValue = new Array(2);
	    
	    function addCheckboxColumn() {
	      element.children().prepend('<th class="md-column md-checkbox-column">');
	    }
	    
	    function attatchCheckbox() {
	      element.prop('lastElementChild').firstElementChild.appendChild($compile(createCheckBox())(scope)[0]);
	    }
	    
	    function createCheckBox() {
	      return angular.element('<md-checkbox>').attr({
	        'aria-label': 'Select All',
	        'ng-click': 'toggleAll()',
	        'ng-checked': 'allSelected()',
	        'ng-disabled': '!getSelectableRows().length'
	      });
	    }
	    
	    function detachCheckbox() {
	      var cell = element.prop('lastElementChild').firstElementChild;
	      
	      if(cell.classList.contains('md-checkbox-column')) {
	        angular.element(cell).empty();
	      }
	    }
	    
	    function enableRowSelection() {
	      return tableCtrl.$$rowSelect;
	    }
	    
	    function mdSelectCtrl(row) {
	      return angular.element(row).controller('mdSelect');
	    }
	    
	    function removeCheckboxColumn() {
	      Array.prototype.some.call(element.find('th'), function (cell) {
	        return cell.classList.contains('md-checkbox-column') && cell.remove();
	      });
	    }
	    
	    scope.allSelected = function () {
	      var rows = scope.getSelectableRows();
	      
	      return rows.length && rows.every(function (row) {
	        return row.isSelected();
	      });
	    };
	    
	    scope.getSelectableRows = function () {
	      return tableCtrl.getBodyRows().map(mdSelectCtrl).filter(function (ctrl) {
	        return ctrl && !ctrl.disabled;
	      });
	    };
	    
	    scope.selectAll = function () {
	      tableCtrl.getBodyRows().map(mdSelectCtrl).forEach(function (ctrl) {
	        if(ctrl && !ctrl.isSelected()) {
	          ctrl.select();
	        }
	      });
	    };
	    
	    scope.toggleAll = function () {
	      return scope.allSelected() ? scope.unSelectAll() : scope.selectAll();
	    };
	    
	    scope.unSelectAll = function () {
	      tableCtrl.getBodyRows().map(mdSelectCtrl).forEach(function (ctrl) {
	        if(ctrl && ctrl.isSelected()) {
	          ctrl.deselect();
	        }
	      });
	    };
	    
	    scope.$watchGroup([enableRowSelection, tableCtrl.enableMultiSelect], function (newValue) {
	      if(newValue[0] !== oldValue[0]) {
	        if(newValue[0]) {
	          addCheckboxColumn();
	          
	          if(newValue[1]) {
	            attatchCheckbox();
	          }
	        } else {
	          removeCheckboxColumn();
	        }
	      } else if(newValue[0] && newValue[1] !== oldValue[1]) {
	        if(newValue[1]) {
	          attatchCheckbox();
	        } else {
	          detachCheckbox();
	        }
	      }
	      
	      angular.copy(newValue, oldValue);
	    });
	  }
	  
	  return {
	    bindToController: true,
	    compile: compile,
	    controller: Controller,
	    controllerAs: '$mdHead',
	    require: '^^mdTable',
	    restrict: 'A',
	    scope: {
	      order: '=?mdOrder',
	      onReorder: '=?mdOnReorder'
	    }
	  };
	}
	
	mdHead.$inject = ['$compile'];
	
	angular.module('md.data.table').directive('mdRow', mdRow);
	
	function mdRow() {
	
	  function compile(tElement) {
	    tElement.addClass('md-row');
	    return postLink;
	  }
	  
	  function postLink(scope, element, attrs, tableCtrl) {
	    function enableRowSelection() {
	      return tableCtrl.$$rowSelect;
	    }
	    
	    function isBodyRow() {
	      return tableCtrl.getBodyRows().indexOf(element[0]) !== -1;
	    }
	    
	    function isChild(node) {
	      return element[0].contains(node[0]);
	    }
	    
	    if(isBodyRow()) {
	      var cell = angular.element('<td class="md-cell">');
	      
	      scope.$watch(enableRowSelection, function (enable) {
	        // if a row is not selectable, prepend an empty cell to it
	        if(enable && !attrs.mdSelect) {
	          if(!isChild(cell)) {
	            element.prepend(cell);
	          }
	          return;
	        }
	        
	        if(isChild(cell)) {
	          cell.remove();
	        }
	      });
	    }
	  }
	
	  return {
	    compile: compile,
	    require: '^^mdTable',
	    restrict: 'A'
	  };
	}
	
	angular.module('md.data.table').directive('mdSelect', mdSelect);
	
	function mdSelect($compile, $parse) {
	
	  // empty controller to bind scope properties to
	  function Controller() {
	
	  }
	
	  function postLink(scope, element, attrs, ctrls) {
	    var self = ctrls.shift();
	    var tableCtrl = ctrls.shift();
	    var getId = $parse(attrs.mdSelectId);
	
	    self.id = getId(self.model);
	
	    if(tableCtrl.$$rowSelect && self.id) {
	      if(tableCtrl.$$hash.has(self.id)) {
	        var index = tableCtrl.selected.indexOf(tableCtrl.$$hash.get(self.id));
	
	        // if the item is no longer selected remove it
	        if(index === -1) {
	          tableCtrl.$$hash.purge(self.id);
	        }
	
	        // if the item is not a reference to the current model update the reference
	        else if(!tableCtrl.$$hash.equals(self.id, self.model)) {
	          tableCtrl.$$hash.update(self.id, self.model);
	          tableCtrl.selected.splice(index, 1, self.model);
	        }
	
	      } else {
	
	        // check if the item has been selected
	        tableCtrl.selected.some(function (item, index) {
	          if(getId(item) === self.id) {
	            tableCtrl.$$hash.update(self.id, self.model);
	            tableCtrl.selected.splice(index, 1, self.model);
	
	            return true;
	          }
	        });
	      }
	    }
	
	    self.isSelected = function () {
	      if(!tableCtrl.$$rowSelect) {
	        return false;
	      }
	
	      if(self.id) {
	        return tableCtrl.$$hash.has(self.id);
	      }
	
	      return tableCtrl.selected.indexOf(self.model) !== -1;
	    };
	
	    self.select = function () {
	      if(self.disabled) {
	        return;
	      }
	
	      if(tableCtrl.enableMultiSelect()) {
	        tableCtrl.selected.push(self.model);
	      } else {
	        tableCtrl.selected.splice(0, tableCtrl.selected.length, self.model);
	      }
	
	      if(angular.isFunction(self.onSelect)) {
	        self.onSelect(self.model);
	      }
	    };
	
	    self.deselect = function () {
	      if(self.disabled) {
	        return;
	      }
	
	      tableCtrl.selected.splice(tableCtrl.selected.indexOf(self.model), 1);
	
	      if(angular.isFunction(self.onDeselect)) {
	        self.onDeselect(self.model);
	      }
	    };
	
	    self.toggle = function (event) {
	      if(event && event.stopPropagation) {
	        event.stopPropagation();
	      }
	
	      return self.isSelected() ? self.deselect() : self.select();
	    };
	
	    function autoSelect() {
	      return attrs.mdAutoSelect === '' || self.autoSelect;
	    }
	
	    function createCheckbox() {
	      var checkbox = angular.element('<md-checkbox>').attr({
	        'aria-label': 'Select Row',
	        'ng-click': '$mdSelect.toggle($event)',
	        'ng-checked': '$mdSelect.isSelected()',
	        'ng-disabled': '$mdSelect.disabled'
	      });
	
	      return angular.element('<td class="md-cell md-checkbox-cell">').append($compile(checkbox)(scope));
	    }
	
	    function disableSelection() {
	      Array.prototype.some.call(element.children(), function (child) {
	        return child.classList.contains('md-checkbox-cell') && element[0].removeChild(child);
	      });
	
	      if(autoSelect()) {
	        element.off('click', toggle);
	      }
	    }
	
	    function enableSelection() {
	      element.prepend(createCheckbox());
	
	      if(autoSelect()) {
	        element.on('click', toggle);
	      }
	    }
	
	    function enableRowSelection() {
	      return tableCtrl.$$rowSelect;
	    }
	
	    function onSelectChange(selected) {
	      if(!self.id) {
	        return;
	      }
	
	      if(tableCtrl.$$hash.has(self.id)) {
	        // check if the item has been deselected
	        if(selected.indexOf(tableCtrl.$$hash.get(self.id)) === -1) {
	          tableCtrl.$$hash.purge(self.id);
	        }
	
	        return;
	      }
	
	      // check if the item has been selected
	      if(selected.indexOf(self.model) !== -1) {
	        tableCtrl.$$hash.update(self.id, self.model);
	      }
	    }
	
	    function toggle(event) {
	      scope.$applyAsync(function () {
	        self.toggle(event);
	      });
	    }
	
	    scope.$watch(enableRowSelection, function (enable) {
	      if(enable) {
	        enableSelection();
	      } else {
	        disableSelection();
	      }
	    });
	
	    scope.$watch(autoSelect, function (newValue, oldValue) {
	      if(newValue === oldValue) {
	        return;
	      }
	
	      if(tableCtrl.$$rowSelect && newValue) {
	        element.on('click', toggle);
	      } else {
	        element.off('click', toggle);
	      }
	    });
	
	    scope.$watch(self.isSelected, function (isSelected) {
	      return isSelected ? element.addClass('md-selected') : element.removeClass('md-selected');
	    });
	
	    scope.$watch(tableCtrl.enableMultiSelect, function (multiple) {
	      if(tableCtrl.$$rowSelect && !multiple) {
	        // remove all but the first selected item
	        tableCtrl.selected.splice(1);
	      }
	    });
	
	    tableCtrl.registerModelChangeListener(onSelectChange);
	
	    element.on('$destroy', function () {
	      tableCtrl.removeModelChangeListener(onSelectChange);
	    });
	  }
	
	  return {
	    bindToController: true,
	    controller: Controller,
	    controllerAs: '$mdSelect',
	    link: postLink,
	    require: ['mdSelect', '^^mdTable'],
	    restrict: 'A',
	    scope: {
	      model: '=mdSelect',
	      disabled: '=ngDisabled',
	      onSelect: '=?mdOnSelect',
	      onDeselect: '=?mdOnDeselect',
	      autoSelect: '=mdAutoSelect'
	    }
	  };
	}
	
	mdSelect.$inject = ['$compile', '$parse'];
	
	angular.module('md.data.table').directive('mdTable', mdTable);
	
	function Hash() {
	  var keys = {};
	  
	  this.equals = function (key, item) {
	    return keys[key] === item;
	  };
	
	  this.get = function (key) {
	    return keys[key];
	  };
	  
	  this.has = function (key) {
	    return keys.hasOwnProperty(key);
	  };
	
	  this.purge = function (key) {
	    delete keys[key];
	  };
	  
	  this.update = function (key, item) {
	    keys[key] = item;
	  };
	}
	
	function mdTable() {
	  
	  function compile(tElement, tAttrs) {
	    tElement.addClass('md-table');
	    
	    if(tAttrs.hasOwnProperty('mdProgress')) {
	      var body = tElement.find('tbody')[0];
	      var progress = angular.element('<thead class="md-table-progress" md-table-progress>');
	      
	      if(body) {
	        tElement[0].insertBefore(progress[0], body);
	      }
	    }
	  }
	  
	  function Controller($attrs, $element, $q, $scope) {
	    var self = this;
	    var queue = [];
	    var watchListener;
	    var modelChangeListeners = [];
	    
	    self.$$hash = new Hash();
	    self.$$columns = {};
	    
	    function enableRowSelection() {
	      self.$$rowSelect = true;
	      
	      watchListener = $scope.$watchCollection('$mdTable.selected', function (selected) {
	        modelChangeListeners.forEach(function (listener) {
	          listener(selected);
	        });
	      });
	      
	      $element.addClass('md-row-select');
	    }
	    
	    function disableRowSelection() {
	      self.$$rowSelect = false;
	      
	      if(angular.isFunction(watchListener)) {
	        watchListener();
	      }
	      
	      $element.removeClass('md-row-select');
	    }
	    
	    function resolvePromises() {
	      if(!queue.length) {
	        return $scope.$applyAsync();
	      }
	      
	      queue[0]['finally'](function () {
	        queue.shift();
	        resolvePromises();
	      });
	    }
	    
	    function rowSelect() {
	      return $attrs.mdRowSelect === '' || self.rowSelect;
	    }
	    
	    function validateModel() {
	      if(!self.selected) {
	        return console.error('Row selection: ngModel is not defined.');
	      }
	      
	      if(!angular.isArray(self.selected)) {
	        return console.error('Row selection: Expected an array. Recived ' + typeof self.selected + '.');
	      }
	      
	      return true;
	    }
	    
	    self.columnCount = function () {
	      return self.getRows($element[0]).reduce(function (count, row) {
	        return row.cells.length > count ? row.cells.length : count;
	      }, 0);
	    };
	    
	    self.getRows = function (element) {
	      return Array.prototype.filter.call(element.rows, function (row) {
	        return !row.classList.contains('ng-leave');
	      });
	    };
	    
	    self.getBodyRows = function () {
	      return Array.prototype.reduce.call($element.prop('tBodies'), function (result, tbody) {
	        return result.concat(self.getRows(tbody));
	      }, []);
	    };
	    
	    self.getElement = function () {
	      return $element;
	    };
	    
	    self.getHeaderRows = function () {
	      return self.getRows($element.prop('tHead'));
	    };
	    
	    self.enableMultiSelect = function () {
	      return $attrs.multiple === '' || $scope.$eval($attrs.multiple);
	    };
	    
	    self.waitingOnPromise = function () {
	      return !!queue.length;
	    };
	    
	    self.queuePromise = function (promise) {
	      if(!promise) {
	        return;
	      }
	      
	      if(queue.push(angular.isArray(promise) ? $q.all(promise) : $q.when(promise)) === 1) {
	        resolvePromises();
	      }
	    };
	    
	    self.registerModelChangeListener = function (listener) {
	      modelChangeListeners.push(listener);
	    };
	    
	    self.removeModelChangeListener = function (listener) {
	      var index = modelChangeListeners.indexOf(listener);
	      
	      if(index !== -1) {
	        modelChangeListeners.splice(index, 1);
	      }
	    };
	    
	    if($attrs.hasOwnProperty('mdProgress')) {
	      $scope.$watch('$mdTable.progress', self.queuePromise);
	    }
	    
	    $scope.$watch(rowSelect, function (enable) {
	      if(enable && !!validateModel()) {
	        enableRowSelection();
	      } else {
	        disableRowSelection();
	      }
	    });
	  }
	  
	  Controller.$inject = ['$attrs', '$element', '$q', '$scope'];
	  
	  return {
	    bindToController: true,
	    compile: compile,
	    controller: Controller,
	    controllerAs: '$mdTable',
	    restrict: 'A',
	    scope: {
	      progress: '=?mdProgress',
	      selected: '=ngModel',
	      rowSelect: '=mdRowSelect'
	    }
	  };
	}
	
	angular.module('md.data.table').directive('mdTablePagination', mdTablePagination);
	
	function mdTablePagination() {
	
	  function compile(tElement) {
	    tElement.addClass('md-table-pagination');
	  }
	
	  function Controller($attrs, $mdUtil, $scope) {
	    var self = this;
	    var defaultLabel = {
	      page: 'Page:',
	      rowsPerPage: 'Rows per page:',
	      of: 'of'
	    };
	
	    self.label = angular.copy(defaultLabel);
	
	    function isPositive(number) {
	      return parseInt(number, 10) > 0;
	    }
	
	    self.eval = function (expression) {
	      return $scope.$eval(expression);
	    };
	
	    self.first = function () {
	      self.page = 1;
	      self.onPaginationChange();
	    };
	
	    self.hasNext = function () {
	      return self.page * self.limit < self.total;
	    };
	
	    self.hasPrevious = function () {
	      return self.page > 1;
	    };
	
	    self.last = function () {
	      self.page = self.pages();
	      self.onPaginationChange();
	    };
	
	    self.max = function () {
	      return self.hasNext() ? self.page * self.limit : self.total;
	    };
	
	    self.min = function () {
	      return isPositive(self.total) ? self.page * self.limit - self.limit + 1 : 0;
	    };
	
	    self.next = function () {
	      self.page++;
	      self.onPaginationChange();
	    };
	
	    self.onPaginationChange = function () {
	      if(angular.isFunction(self.onPaginate)) {
	        $mdUtil.nextTick(function () {
	          self.onPaginate(self.page, self.limit);
	        });
	      }
	    };
	
	    self.pages = function () {
	      return isPositive(self.total) ? Math.ceil(self.total / (isPositive(self.limit) ? self.limit : 1)) : 1;
	    };
	
	    self.previous = function () {
	      self.page--;
	      self.onPaginationChange();
	    };
	
	    self.showBoundaryLinks = function () {
	      return $attrs.mdBoundaryLinks === '' || self.boundaryLinks;
	    };
	
	    self.showPageSelect = function () {
	      return $attrs.mdPageSelect === '' || self.pageSelect;
	    };
	
	    $scope.$watch('$pagination.limit', function (newValue, oldValue) {
	      if(isNaN(newValue) || isNaN(oldValue) || newValue === oldValue) {
	        return;
	      }
	
	      // find closest page from previous min
	      self.page = Math.floor(((self.page * oldValue - oldValue) + newValue) / (isPositive(newValue) ? newValue : 1));
	      self.onPaginationChange();
	    });
	
	    $attrs.$observe('mdLabel', function (label) {
	      angular.extend(self.label, defaultLabel, $scope.$eval(label));
	    });
	
	    $scope.$watch('$pagination.total', function (newValue, oldValue) {
	      if(isNaN(newValue) || newValue === oldValue) {
	        return;
	      }
	
	      if(self.page > self.pages()) {
	        self.last();
	      }
	    });
	  }
	
	  Controller.$inject = ['$attrs', '$mdUtil', '$scope'];
	
	  return {
	    bindToController: {
	      boundaryLinks: '=?mdBoundaryLinks',
	      disabled: '=ngDisabled',
	      limit: '=mdLimit',
	      page: '=mdPage',
	      pageSelect: '=?mdPageSelect',
	      onPaginate: '=?mdOnPaginate',
	      limitOptions: '=?mdLimitOptions',
	      total: '@mdTotal'
	    },
	    compile: compile,
	    controller: Controller,
	    controllerAs: '$pagination',
	    restrict: 'E',
	    scope: {},
	    templateUrl: 'md-table-pagination.html'
	  };
	}
	
	angular.module('md.data.table').directive('mdTableProgress', mdTableProgress);
	
	function mdTableProgress() {
	
	  function postLink(scope, element, attrs, tableCtrl) {
	    scope.columnCount = tableCtrl.columnCount;
	    scope.deferred = tableCtrl.waitingOnPromise;
	  }
	
	  return {
	    link: postLink,
	    require: '^^mdTable',
	    restrict: 'A',
	    scope: {},
	    templateUrl: 'md-table-progress.html'
	  };
	}
	
	angular.module('md.data.table').directive('virtualPageSelect', virtualPageSelect);
	
	function virtualPageSelect() {
	
	  function Controller($element, $scope) {
	    var self = this;
	    var content = $element.find('md-content');
	
	    self.pages = [];
	
	    function getMin(pages, total) {
	      return Math.min(pages, isFinite(total) && isPositive(total) ? total : 1);
	    }
	
	    function isPositive(number) {
	      return number > 0;
	    }
	
	    function setPages(max) {
	      if(self.pages.length > max) {
	        return self.pages.splice(max);
	      }
	
	      for(var i = self.pages.length; i < max; i++) {
	        self.pages.push(i + 1);
	      }
	    }
	
	    content.on('scroll', function () {
	      if((content.prop('clientHeight') + content.prop('scrollTop')) >= content.prop('scrollHeight')) {
	        $scope.$applyAsync(function () {
	          setPages(getMin(self.pages.length + 10, self.total));
	        });
	      }
	    });
	
	    $scope.$watch('$pageSelect.total', function (total) {
	      setPages(getMin(Math.max(self.pages.length, 10), total));
	    });
	
	    $scope.$watch('$pagination.page', function (page) {
	      for(var i = self.pages.length; i < page; i++) {
	        self.pages.push(i + 1);
	      }
	    });
	  }
	
	  Controller.$inject = ['$element', '$scope'];
	
	  return {
	    bindToController: {
	      total: '@'
	    },
	    controller: Controller,
	    controllerAs: '$pageSelect'
	  };
	}
	
	})(window, angular);

/***/ },
/* 395 */
/***/ function(module, exports) {

	/**!
	 * AngularJS file upload directives and services. Supoorts: file upload/drop/paste, resume, cancel/abort,
	 * progress, resize, thumbnail, preview, validation and CORS
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 12.2.13
	 */
	
	if (window.XMLHttpRequest && !(window.FileAPI && FileAPI.shouldLoad)) {
	  window.XMLHttpRequest.prototype.setRequestHeader = (function (orig) {
	    return function (header, value) {
	      if (header === '__setXHR_') {
	        var val = value(this);
	        // fix for angular < 1.2.0
	        if (val instanceof Function) {
	          val(this);
	        }
	      } else {
	        orig.apply(this, arguments);
	      }
	    };
	  })(window.XMLHttpRequest.prototype.setRequestHeader);
	}
	
	var ngFileUpload = angular.module('ngFileUpload', []);
	
	ngFileUpload.version = '12.2.13';
	
	ngFileUpload.service('UploadBase', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
	  var upload = this;
	  upload.promisesCount = 0;
	
	  this.isResumeSupported = function () {
	    return window.Blob && window.Blob.prototype.slice;
	  };
	
	  var resumeSupported = this.isResumeSupported();
	
	  function sendHttp(config) {
	    config.method = config.method || 'POST';
	    config.headers = config.headers || {};
	
	    var deferred = config._deferred = config._deferred || $q.defer();
	    var promise = deferred.promise;
	
	    function notifyProgress(e) {
	      if (deferred.notify) {
	        deferred.notify(e);
	      }
	      if (promise.progressFunc) {
	        $timeout(function () {
	          promise.progressFunc(e);
	        });
	      }
	    }
	
	    function getNotifyEvent(n) {
	      if (config._start != null && resumeSupported) {
	        return {
	          loaded: n.loaded + config._start,
	          total: (config._file && config._file.size) || n.total,
	          type: n.type, config: config,
	          lengthComputable: true, target: n.target
	        };
	      } else {
	        return n;
	      }
	    }
	
	    if (!config.disableProgress) {
	      config.headers.__setXHR_ = function () {
	        return function (xhr) {
	          if (!xhr || !xhr.upload || !xhr.upload.addEventListener) return;
	          config.__XHR = xhr;
	          if (config.xhrFn) config.xhrFn(xhr);
	          xhr.upload.addEventListener('progress', function (e) {
	            e.config = config;
	            notifyProgress(getNotifyEvent(e));
	          }, false);
	          //fix for firefox not firing upload progress end, also IE8-9
	          xhr.upload.addEventListener('load', function (e) {
	            if (e.lengthComputable) {
	              e.config = config;
	              notifyProgress(getNotifyEvent(e));
	            }
	          }, false);
	        };
	      };
	    }
	
	    function uploadWithAngular() {
	      $http(config).then(function (r) {
	          if (resumeSupported && config._chunkSize && !config._finished && config._file) {
	            var fileSize = config._file && config._file.size || 0;
	            notifyProgress({
	                loaded: Math.min(config._end, fileSize),
	                total: fileSize,
	                config: config,
	                type: 'progress'
	              }
	            );
	            upload.upload(config, true);
	          } else {
	            if (config._finished) delete config._finished;
	            deferred.resolve(r);
	          }
	        }, function (e) {
	          deferred.reject(e);
	        }, function (n) {
	          deferred.notify(n);
	        }
	      );
	    }
	
	    if (!resumeSupported) {
	      uploadWithAngular();
	    } else if (config._chunkSize && config._end && !config._finished) {
	      config._start = config._end;
	      config._end += config._chunkSize;
	      uploadWithAngular();
	    } else if (config.resumeSizeUrl) {
	      $http.get(config.resumeSizeUrl).then(function (resp) {
	        if (config.resumeSizeResponseReader) {
	          config._start = config.resumeSizeResponseReader(resp.data);
	        } else {
	          config._start = parseInt((resp.data.size == null ? resp.data : resp.data.size).toString());
	        }
	        if (config._chunkSize) {
	          config._end = config._start + config._chunkSize;
	        }
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else if (config.resumeSize) {
	      config.resumeSize().then(function (size) {
	        config._start = size;
	        if (config._chunkSize) {
	          config._end = config._start + config._chunkSize;
	        }
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else {
	      if (config._chunkSize) {
	        config._start = 0;
	        config._end = config._start + config._chunkSize;
	      }
	      uploadWithAngular();
	    }
	
	
	    promise.success = function (fn) {
	      promise.then(function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.error = function (fn) {
	      promise.then(null, function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.progress = function (fn) {
	      promise.progressFunc = fn;
	      promise.then(null, null, function (n) {
	        fn(n);
	      });
	      return promise;
	    };
	    promise.abort = promise.pause = function () {
	      if (config.__XHR) {
	        $timeout(function () {
	          config.__XHR.abort();
	        });
	      }
	      return promise;
	    };
	    promise.xhr = function (fn) {
	      config.xhrFn = (function (origXhrFn) {
	        return function () {
	          if (origXhrFn) origXhrFn.apply(promise, arguments);
	          fn.apply(promise, arguments);
	        };
	      })(config.xhrFn);
	      return promise;
	    };
	
	    upload.promisesCount++;
	    if (promise['finally'] && promise['finally'] instanceof Function) {
	      promise['finally'](function () {
	        upload.promisesCount--;
	      });
	    }
	    return promise;
	  }
	
	  this.isUploadInProgress = function () {
	    return upload.promisesCount > 0;
	  };
	
	  this.rename = function (file, name) {
	    file.ngfName = name;
	    return file;
	  };
	
	  this.jsonBlob = function (val) {
	    if (val != null && !angular.isString(val)) {
	      val = JSON.stringify(val);
	    }
	    var blob = new window.Blob([val], {type: 'application/json'});
	    blob._ngfBlob = true;
	    return blob;
	  };
	
	  this.json = function (val) {
	    return angular.toJson(val);
	  };
	
	  function copy(obj) {
	    var clone = {};
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        clone[key] = obj[key];
	      }
	    }
	    return clone;
	  }
	
	  this.isFile = function (file) {
	    return file != null && (file instanceof window.Blob || (file.flashId && file.name && file.size));
	  };
	
	  this.upload = function (config, internal) {
	    function toResumeFile(file, formData) {
	      if (file._ngfBlob) return file;
	      config._file = config._file || file;
	      if (config._start != null && resumeSupported) {
	        if (config._end && config._end >= file.size) {
	          config._finished = true;
	          config._end = file.size;
	        }
	        var slice = file.slice(config._start, config._end || file.size);
	        slice.name = file.name;
	        slice.ngfName = file.ngfName;
	        if (config._chunkSize) {
	          formData.append('_chunkSize', config._chunkSize);
	          formData.append('_currentChunkSize', config._end - config._start);
	          formData.append('_chunkNumber', Math.floor(config._start / config._chunkSize));
	          formData.append('_totalSize', config._file.size);
	        }
	        return slice;
	      }
	      return file;
	    }
	
	    function addFieldToFormData(formData, val, key) {
	      if (val !== undefined) {
	        if (angular.isDate(val)) {
	          val = val.toISOString();
	        }
	        if (angular.isString(val)) {
	          formData.append(key, val);
	        } else if (upload.isFile(val)) {
	          var file = toResumeFile(val, formData);
	          var split = key.split(',');
	          if (split[1]) {
	            file.ngfName = split[1].replace(/^\s+|\s+$/g, '');
	            key = split[0];
	          }
	          config._fileKey = config._fileKey || key;
	          formData.append(key, file, file.ngfName || file.name);
	        } else {
	          if (angular.isObject(val)) {
	            if (val.$$ngfCircularDetection) throw 'ngFileUpload: Circular reference in config.data. Make sure specified data for Upload.upload() has no circular reference: ' + key;
	
	            val.$$ngfCircularDetection = true;
	            try {
	              for (var k in val) {
	                if (val.hasOwnProperty(k) && k !== '$$ngfCircularDetection') {
	                  var objectKey = config.objectKey == null ? '[i]' : config.objectKey;
	                  if (val.length && parseInt(k) > -1) {
	                    objectKey = config.arrayKey == null ? objectKey : config.arrayKey;
	                  }
	                  addFieldToFormData(formData, val[k], key + objectKey.replace(/[ik]/g, k));
	                }
	              }
	            } finally {
	              delete val.$$ngfCircularDetection;
	            }
	          } else {
	            formData.append(key, val);
	          }
	        }
	      }
	    }
	
	    function digestConfig() {
	      config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	      config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	      config.headers = config.headers || {};
	      config.headers['Content-Type'] = undefined;
	      config.transformRequest = config.transformRequest ?
	        (angular.isArray(config.transformRequest) ?
	          config.transformRequest : [config.transformRequest]) : [];
	      config.transformRequest.push(function (data) {
	        var formData = new window.FormData(), key;
	        data = data || config.fields || {};
	        if (config.file) {
	          data.file = config.file;
	        }
	        for (key in data) {
	          if (data.hasOwnProperty(key)) {
	            var val = data[key];
	            if (config.formDataAppender) {
	              config.formDataAppender(formData, key, val);
	            } else {
	              addFieldToFormData(formData, val, key);
	            }
	          }
	        }
	
	        return formData;
	      });
	    }
	
	    if (!internal) config = copy(config);
	    if (!config._isDigested) {
	      config._isDigested = true;
	      digestConfig();
	    }
	
	    return sendHttp(config);
	  };
	
	  this.http = function (config) {
	    config = copy(config);
	    config.transformRequest = config.transformRequest || function (data) {
	        if ((window.ArrayBuffer && data instanceof window.ArrayBuffer) || data instanceof window.Blob) {
	          return data;
	        }
	        return $http.defaults.transformRequest[0].apply(this, arguments);
	      };
	    config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	    config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	    return sendHttp(config);
	  };
	
	  this.translateScalars = function (str) {
	    if (angular.isString(str)) {
	      if (str.search(/kb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1024);
	      } else if (str.search(/mb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1048576);
	      } else if (str.search(/gb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1073741824);
	      } else if (str.search(/b/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/s/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/m/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 60);
	      } else if (str.search(/h/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 3600);
	      }
	    }
	    return str;
	  };
	
	  this.urlToBlob = function(url) {
	    var defer = $q.defer();
	    $http({url: url, method: 'get', responseType: 'arraybuffer'}).then(function (resp) {
	      var arrayBufferView = new Uint8Array(resp.data);
	      var type = resp.headers('content-type') || 'image/WebP';
	      var blob = new window.Blob([arrayBufferView], {type: type});
	      var matches = url.match(/.*\/(.+?)(\?.*)?$/);
	      if (matches.length > 1) {
	        blob.name = matches[1];
	      }
	      defer.resolve(blob);
	    }, function (e) {
	      defer.reject(e);
	    });
	    return defer.promise;
	  };
	
	  this.setDefaults = function (defaults) {
	    this.defaults = defaults || {};
	  };
	
	  this.defaults = {};
	  this.version = ngFileUpload.version;
	}
	
	]);
	
	ngFileUpload.service('Upload', ['$parse', '$timeout', '$compile', '$q', 'UploadExif', function ($parse, $timeout, $compile, $q, UploadExif) {
	  var upload = UploadExif;
	  upload.getAttrWithDefaults = function (attr, name) {
	    if (attr[name] != null) return attr[name];
	    var def = upload.defaults[name];
	    return (def == null ? def : (angular.isString(def) ? def : JSON.stringify(def)));
	  };
	
	  upload.attrGetter = function (name, attr, scope, params) {
	    var attrVal = this.getAttrWithDefaults(attr, name);
	    if (scope) {
	      try {
	        if (params) {
	          return $parse(attrVal)(scope, params);
	        } else {
	          return $parse(attrVal)(scope);
	        }
	      } catch (e) {
	        // hangle string value without single qoute
	        if (name.search(/min|max|pattern/i)) {
	          return attrVal;
	        } else {
	          throw e;
	        }
	      }
	    } else {
	      return attrVal;
	    }
	  };
	
	  upload.shouldUpdateOn = function (type, attr, scope) {
	    var modelOptions = upload.attrGetter('ngfModelOptions', attr, scope);
	    if (modelOptions && modelOptions.updateOn) {
	      return modelOptions.updateOn.split(' ').indexOf(type) > -1;
	    }
	    return true;
	  };
	
	  upload.emptyPromise = function () {
	    var d = $q.defer();
	    var args = arguments;
	    $timeout(function () {
	      d.resolve.apply(d, args);
	    });
	    return d.promise;
	  };
	
	  upload.rejectPromise = function () {
	    var d = $q.defer();
	    var args = arguments;
	    $timeout(function () {
	      d.reject.apply(d, args);
	    });
	    return d.promise;
	  };
	
	  upload.happyPromise = function (promise, data) {
	    var d = $q.defer();
	    promise.then(function (result) {
	      d.resolve(result);
	    }, function (error) {
	      $timeout(function () {
	        throw error;
	      });
	      d.resolve(data);
	    });
	    return d.promise;
	  };
	
	  function applyExifRotations(files, attr, scope) {
	    var promises = [upload.emptyPromise()];
	    angular.forEach(files, function (f, i) {
	      if (f.type.indexOf('image/jpeg') === 0 && upload.attrGetter('ngfFixOrientation', attr, scope, {$file: f})) {
	        promises.push(upload.happyPromise(upload.applyExifRotation(f), f).then(function (fixedFile) {
	          files.splice(i, 1, fixedFile);
	        }));
	      }
	    });
	    return $q.all(promises);
	  }
	
	  function resizeFile(files, attr, scope, ngModel) {
	    var resizeVal = upload.attrGetter('ngfResize', attr, scope);
	    if (!resizeVal || !upload.isResizeSupported() || !files.length) return upload.emptyPromise();
	    if (resizeVal instanceof Function) {
	      var defer = $q.defer();
	      return resizeVal(files).then(function (p) {
	        resizeWithParams(p, files, attr, scope, ngModel).then(function (r) {
	          defer.resolve(r);
	        }, function (e) {
	          defer.reject(e);
	        });
	      }, function (e) {
	        defer.reject(e);
	      });
	    } else {
	      return resizeWithParams(resizeVal, files, attr, scope, ngModel);
	    }
	  }
	
	  function resizeWithParams(params, files, attr, scope, ngModel) {
	    var promises = [upload.emptyPromise()];
	
	    function handleFile(f, i) {
	      if (f.type.indexOf('image') === 0) {
	        if (params.pattern && !upload.validatePattern(f, params.pattern)) return;
	        params.resizeIf = function (width, height) {
	          return upload.attrGetter('ngfResizeIf', attr, scope,
	            {$width: width, $height: height, $file: f});
	        };
	        var promise = upload.resize(f, params);
	        promises.push(promise);
	        promise.then(function (resizedFile) {
	          files.splice(i, 1, resizedFile);
	        }, function (e) {
	          f.$error = 'resize';
	          (f.$errorMessages = (f.$errorMessages || {})).resize = true;
	          f.$errorParam = (e ? (e.message ? e.message : e) + ': ' : '') + (f && f.name);
	          ngModel.$ngfValidations.push({name: 'resize', valid: false});
	          upload.applyModelValidation(ngModel, files);
	        });
	      }
	    }
	
	    for (var i = 0; i < files.length; i++) {
	      handleFile(files[i], i);
	    }
	    return $q.all(promises);
	  }
	
	  upload.updateModel = function (ngModel, attr, scope, fileChange, files, evt, noDelay) {
	    function update(files, invalidFiles, newFiles, dupFiles, isSingleModel) {
	      attr.$$ngfPrevValidFiles = files;
	      attr.$$ngfPrevInvalidFiles = invalidFiles;
	      var file = files && files.length ? files[0] : null;
	      var invalidFile = invalidFiles && invalidFiles.length ? invalidFiles[0] : null;
	
	      if (ngModel) {
	        upload.applyModelValidation(ngModel, files);
	        ngModel.$setViewValue(isSingleModel ? file : files);
	      }
	
	      if (fileChange) {
	        $parse(fileChange)(scope, {
	          $files: files,
	          $file: file,
	          $newFiles: newFiles,
	          $duplicateFiles: dupFiles,
	          $invalidFiles: invalidFiles,
	          $invalidFile: invalidFile,
	          $event: evt
	        });
	      }
	
	      var invalidModel = upload.attrGetter('ngfModelInvalid', attr);
	      if (invalidModel) {
	        $timeout(function () {
	          $parse(invalidModel).assign(scope, isSingleModel ? invalidFile : invalidFiles);
	        });
	      }
	      $timeout(function () {
	        // scope apply changes
	      });
	    }
	
	    var allNewFiles, dupFiles = [], prevValidFiles, prevInvalidFiles,
	      invalids = [], valids = [];
	
	    function removeDuplicates() {
	      function equals(f1, f2) {
	        return f1.name === f2.name && (f1.$ngfOrigSize || f1.size) === (f2.$ngfOrigSize || f2.size) &&
	          f1.type === f2.type;
	      }
	
	      function isInPrevFiles(f) {
	        var j;
	        for (j = 0; j < prevValidFiles.length; j++) {
	          if (equals(f, prevValidFiles[j])) {
	            return true;
	          }
	        }
	        for (j = 0; j < prevInvalidFiles.length; j++) {
	          if (equals(f, prevInvalidFiles[j])) {
	            return true;
	          }
	        }
	        return false;
	      }
	
	      if (files) {
	        allNewFiles = [];
	        dupFiles = [];
	        for (var i = 0; i < files.length; i++) {
	          if (isInPrevFiles(files[i])) {
	            dupFiles.push(files[i]);
	          } else {
	            allNewFiles.push(files[i]);
	          }
	        }
	      }
	    }
	
	    function toArray(v) {
	      return angular.isArray(v) ? v : [v];
	    }
	
	    function resizeAndUpdate() {
	      function updateModel() {
	        $timeout(function () {
	          update(keep ? prevValidFiles.concat(valids) : valids,
	            keep ? prevInvalidFiles.concat(invalids) : invalids,
	            files, dupFiles, isSingleModel);
	        }, options && options.debounce ? options.debounce.change || options.debounce : 0);
	      }
	
	      var resizingFiles = validateAfterResize ? allNewFiles : valids;
	      resizeFile(resizingFiles, attr, scope, ngModel).then(function () {
	        if (validateAfterResize) {
	          upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
	            .then(function (validationResult) {
	              valids = validationResult.validsFiles;
	              invalids = validationResult.invalidsFiles;
	              updateModel();
	            });
	        } else {
	          updateModel();
	        }
	      }, function () {
	        for (var i = 0; i < resizingFiles.length; i++) {
	          var f = resizingFiles[i];
	          if (f.$error === 'resize') {
	            var index = valids.indexOf(f);
	            if (index > -1) {
	              valids.splice(index, 1);
	              invalids.push(f);
	            }
	            updateModel();
	          }
	        }
	      });
	    }
	
	    prevValidFiles = attr.$$ngfPrevValidFiles || [];
	    prevInvalidFiles = attr.$$ngfPrevInvalidFiles || [];
	    if (ngModel && ngModel.$modelValue) {
	      prevValidFiles = toArray(ngModel.$modelValue);
	    }
	
	    var keep = upload.attrGetter('ngfKeep', attr, scope);
	    allNewFiles = (files || []).slice(0);
	    if (keep === 'distinct' || upload.attrGetter('ngfKeepDistinct', attr, scope) === true) {
	      removeDuplicates(attr, scope);
	    }
	
	    var isSingleModel = !keep && !upload.attrGetter('ngfMultiple', attr, scope) && !upload.attrGetter('multiple', attr);
	
	    if (keep && !allNewFiles.length) return;
	
	    upload.attrGetter('ngfBeforeModelChange', attr, scope, {
	      $files: files,
	      $file: files && files.length ? files[0] : null,
	      $newFiles: allNewFiles,
	      $duplicateFiles: dupFiles,
	      $event: evt
	    });
	
	    var validateAfterResize = upload.attrGetter('ngfValidateAfterResize', attr, scope);
	
	    var options = upload.attrGetter('ngfModelOptions', attr, scope);
	    upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
	      .then(function (validationResult) {
	      if (noDelay) {
	        update(allNewFiles, [], files, dupFiles, isSingleModel);
	      } else {
	        if ((!options || !options.allowInvalid) && !validateAfterResize) {
	          valids = validationResult.validFiles;
	          invalids = validationResult.invalidFiles;
	        } else {
	          valids = allNewFiles;
	        }
	        if (upload.attrGetter('ngfFixOrientation', attr, scope) && upload.isExifSupported()) {
	          applyExifRotations(valids, attr, scope).then(function () {
	            resizeAndUpdate();
	          });
	        } else {
	          resizeAndUpdate();
	        }
	      }
	    });
	  };
	
	  return upload;
	}]);
	
	ngFileUpload.directive('ngfSelect', ['$parse', '$timeout', '$compile', 'Upload', function ($parse, $timeout, $compile, Upload) {
	  var generatedElems = [];
	
	  function isDelayedClickSupported(ua) {
	    // fix for android native browser < 4.4 and safari windows
	    var m = ua.match(/Android[^\d]*(\d+)\.(\d+)/);
	    if (m && m.length > 2) {
	      var v = Upload.defaults.androidFixMinorVersion || 4;
	      return parseInt(m[1]) < 4 || (parseInt(m[1]) === v && parseInt(m[2]) < v);
	    }
	
	    // safari on windows
	    return ua.indexOf('Chrome') === -1 && /.*Windows.*Safari.*/.test(ua);
	  }
	
	  function linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, upload) {
	    /** @namespace attr.ngfSelect */
	    /** @namespace attr.ngfChange */
	    /** @namespace attr.ngModel */
	    /** @namespace attr.ngfModelOptions */
	    /** @namespace attr.ngfMultiple */
	    /** @namespace attr.ngfCapture */
	    /** @namespace attr.ngfValidate */
	    /** @namespace attr.ngfKeep */
	    var attrGetter = function (name, scope) {
	      return upload.attrGetter(name, attr, scope);
	    };
	
	    function isInputTypeFile() {
	      return elem[0].tagName.toLowerCase() === 'input' && attr.type && attr.type.toLowerCase() === 'file';
	    }
	
	    function fileChangeAttr() {
	      return attrGetter('ngfChange') || attrGetter('ngfSelect');
	    }
	
	    function changeFn(evt) {
	      if (upload.shouldUpdateOn('change', attr, scope)) {
	        var fileList = evt.__files_ || (evt.target && evt.target.files), files = [];
	        /* Handle duplicate call in  IE11 */
	        if (!fileList) return;
	        for (var i = 0; i < fileList.length; i++) {
	          files.push(fileList[i]);
	        }
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(),
	          files.length ? files : null, evt);
	      }
	    }
	
	    upload.registerModelChangeValidator(ngModel, attr, scope);
	
	    var unwatches = [];
	    if (attrGetter('ngfMultiple')) {
	      unwatches.push(scope.$watch(attrGetter('ngfMultiple'), function () {
	        fileElem.attr('multiple', attrGetter('ngfMultiple', scope));
	      }));
	    }
	    if (attrGetter('ngfCapture')) {
	      unwatches.push(scope.$watch(attrGetter('ngfCapture'), function () {
	        fileElem.attr('capture', attrGetter('ngfCapture', scope));
	      }));
	    }
	    if (attrGetter('ngfAccept')) {
	      unwatches.push(scope.$watch(attrGetter('ngfAccept'), function () {
	        fileElem.attr('accept', attrGetter('ngfAccept', scope));
	      }));
	    }
	    unwatches.push(attr.$observe('accept', function () {
	      fileElem.attr('accept', attrGetter('accept'));
	    }));
	    function bindAttrToFileInput(fileElem, label) {
	      function updateId(val) {
	        fileElem.attr('id', 'ngf-' + val);
	        label.attr('id', 'ngf-label-' + val);
	      }
	
	      for (var i = 0; i < elem[0].attributes.length; i++) {
	        var attribute = elem[0].attributes[i];
	        if (attribute.name !== 'type' && attribute.name !== 'class' && attribute.name !== 'style') {
	          if (attribute.name === 'id') {
	            updateId(attribute.value);
	            unwatches.push(attr.$observe('id', updateId));
	          } else {
	            fileElem.attr(attribute.name, (!attribute.value && (attribute.name === 'required' ||
	            attribute.name === 'multiple')) ? attribute.name : attribute.value);
	          }
	        }
	      }
	    }
	
	    function createFileInput() {
	      if (isInputTypeFile()) {
	        return elem;
	      }
	
	      var fileElem = angular.element('<input type="file">');
	
	      var label = angular.element('<label>upload</label>');
	      label.css('visibility', 'hidden').css('position', 'absolute').css('overflow', 'hidden')
	        .css('width', '0px').css('height', '0px').css('border', 'none')
	        .css('margin', '0px').css('padding', '0px').attr('tabindex', '-1');
	      bindAttrToFileInput(fileElem, label);
	
	      generatedElems.push({el: elem, ref: label});
	
	      document.body.appendChild(label.append(fileElem)[0]);
	
	      return fileElem;
	    }
	
	    function clickHandler(evt) {
	      if (elem.attr('disabled')) return false;
	      if (attrGetter('ngfSelectDisabled', scope)) return;
	
	      var r = detectSwipe(evt);
	      // prevent the click if it is a swipe
	      if (r != null) return r;
	
	      resetModel(evt);
	
	      // fix for md when the element is removed from the DOM and added back #460
	      try {
	        if (!isInputTypeFile() && !document.body.contains(fileElem[0])) {
	          generatedElems.push({el: elem, ref: fileElem.parent()});
	          document.body.appendChild(fileElem.parent()[0]);
	          fileElem.bind('change', changeFn);
	        }
	      } catch (e) {/*ignore*/
	      }
	
	      if (isDelayedClickSupported(navigator.userAgent)) {
	        setTimeout(function () {
	          fileElem[0].click();
	        }, 0);
	      } else {
	        fileElem[0].click();
	      }
	
	      return false;
	    }
	
	
	    var initialTouchStartY = 0;
	    var initialTouchStartX = 0;
	
	    function detectSwipe(evt) {
	      var touches = evt.changedTouches || (evt.originalEvent && evt.originalEvent.changedTouches);
	      if (touches) {
	        if (evt.type === 'touchstart') {
	          initialTouchStartX = touches[0].clientX;
	          initialTouchStartY = touches[0].clientY;
	          return true; // don't block event default
	        } else {
	          // prevent scroll from triggering event
	          if (evt.type === 'touchend') {
	            var currentX = touches[0].clientX;
	            var currentY = touches[0].clientY;
	            if ((Math.abs(currentX - initialTouchStartX) > 20) ||
	              (Math.abs(currentY - initialTouchStartY) > 20)) {
	              evt.stopPropagation();
	              evt.preventDefault();
	              return false;
	            }
	          }
	          return true;
	        }
	      }
	    }
	
	    var fileElem = elem;
	
	    function resetModel(evt) {
	      if (upload.shouldUpdateOn('click', attr, scope) && fileElem.val()) {
	        fileElem.val(null);
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(), null, evt, true);
	      }
	    }
	
	    if (!isInputTypeFile()) {
	      fileElem = createFileInput();
	    }
	    fileElem.bind('change', changeFn);
	
	    if (!isInputTypeFile()) {
	      elem.bind('click touchstart touchend', clickHandler);
	    } else {
	      elem.bind('click', resetModel);
	    }
	
	    function ie10SameFileSelectFix(evt) {
	      if (fileElem && !fileElem.attr('__ngf_ie10_Fix_')) {
	        if (!fileElem[0].parentNode) {
	          fileElem = null;
	          return;
	        }
	        evt.preventDefault();
	        evt.stopPropagation();
	        fileElem.unbind('click');
	        var clone = fileElem.clone();
	        fileElem.replaceWith(clone);
	        fileElem = clone;
	        fileElem.attr('__ngf_ie10_Fix_', 'true');
	        fileElem.bind('change', changeFn);
	        fileElem.bind('click', ie10SameFileSelectFix);
	        fileElem[0].click();
	        return false;
	      } else {
	        fileElem.removeAttr('__ngf_ie10_Fix_');
	      }
	    }
	
	    if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
	      fileElem.bind('click', ie10SameFileSelectFix);
	    }
	
	    if (ngModel) ngModel.$formatters.push(function (val) {
	      if (val == null || val.length === 0) {
	        if (fileElem.val()) {
	          fileElem.val(null);
	        }
	      }
	      return val;
	    });
	
	    scope.$on('$destroy', function () {
	      if (!isInputTypeFile()) fileElem.parent().remove();
	      angular.forEach(unwatches, function (unwatch) {
	        unwatch();
	      });
	    });
	
	    $timeout(function () {
	      for (var i = 0; i < generatedElems.length; i++) {
	        var g = generatedElems[i];
	        if (!document.body.contains(g.el[0])) {
	          generatedElems.splice(i, 1);
	          g.ref.remove();
	        }
	      }
	    });
	
	    if (window.FileAPI && window.FileAPI.ngfFixIE) {
	      window.FileAPI.ngfFixIE(elem, fileElem, changeFn);
	    }
	  }
	
	  return {
	    restrict: 'AEC',
	    require: '?ngModel',
	    link: function (scope, elem, attr, ngModel) {
	      linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, Upload);
	    }
	  };
	}]);
	
	(function () {
	
	  ngFileUpload.service('UploadDataUrl', ['UploadBase', '$timeout', '$q', function (UploadBase, $timeout, $q) {
	    var upload = UploadBase;
	    upload.base64DataUrl = function (file) {
	      if (angular.isArray(file)) {
	        var d = $q.defer(), count = 0;
	        angular.forEach(file, function (f) {
	          upload.dataUrl(f, true)['finally'](function () {
	            count++;
	            if (count === file.length) {
	              var urls = [];
	              angular.forEach(file, function (ff) {
	                urls.push(ff.$ngfDataUrl);
	              });
	              d.resolve(urls, file);
	            }
	          });
	        });
	        return d.promise;
	      } else {
	        return upload.dataUrl(file, true);
	      }
	    };
	    upload.dataUrl = function (file, disallowObjectUrl) {
	      if (!file) return upload.emptyPromise(file, file);
	      if ((disallowObjectUrl && file.$ngfDataUrl != null) || (!disallowObjectUrl && file.$ngfBlobUrl != null)) {
	        return upload.emptyPromise(disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl, file);
	      }
	      var p = disallowObjectUrl ? file.$$ngfDataUrlPromise : file.$$ngfBlobUrlPromise;
	      if (p) return p;
	
	      var deferred = $q.defer();
	      $timeout(function () {
	        if (window.FileReader && file &&
	          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 8') === -1 || file.size < 20000) &&
	          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 9') === -1 || file.size < 4000000)) {
	          //prefer URL.createObjectURL for handling refrences to files of all sizes
	          //since it doesn´t build a large string in memory
	          var URL = window.URL || window.webkitURL;
	          if (URL && URL.createObjectURL && !disallowObjectUrl) {
	            var url;
	            try {
	              url = URL.createObjectURL(file);
	            } catch (e) {
	              $timeout(function () {
	                file.$ngfBlobUrl = '';
	                deferred.reject();
	              });
	              return;
	            }
	            $timeout(function () {
	              file.$ngfBlobUrl = url;
	              if (url) {
	                deferred.resolve(url, file);
	                upload.blobUrls = upload.blobUrls || [];
	                upload.blobUrlsTotalSize = upload.blobUrlsTotalSize || 0;
	                upload.blobUrls.push({url: url, size: file.size});
	                upload.blobUrlsTotalSize += file.size || 0;
	                var maxMemory = upload.defaults.blobUrlsMaxMemory || 268435456;
	                var maxLength = upload.defaults.blobUrlsMaxQueueSize || 200;
	                while ((upload.blobUrlsTotalSize > maxMemory || upload.blobUrls.length > maxLength) && upload.blobUrls.length > 1) {
	                  var obj = upload.blobUrls.splice(0, 1)[0];
	                  URL.revokeObjectURL(obj.url);
	                  upload.blobUrlsTotalSize -= obj.size;
	                }
	              }
	            });
	          } else {
	            var fileReader = new FileReader();
	            fileReader.onload = function (e) {
	              $timeout(function () {
	                file.$ngfDataUrl = e.target.result;
	                deferred.resolve(e.target.result, file);
	                $timeout(function () {
	                  delete file.$ngfDataUrl;
	                }, 1000);
	              });
	            };
	            fileReader.onerror = function () {
	              $timeout(function () {
	                file.$ngfDataUrl = '';
	                deferred.reject();
	              });
	            };
	            fileReader.readAsDataURL(file);
	          }
	        } else {
	          $timeout(function () {
	            file[disallowObjectUrl ? '$ngfDataUrl' : '$ngfBlobUrl'] = '';
	            deferred.reject();
	          });
	        }
	      });
	
	      if (disallowObjectUrl) {
	        p = file.$$ngfDataUrlPromise = deferred.promise;
	      } else {
	        p = file.$$ngfBlobUrlPromise = deferred.promise;
	      }
	      p['finally'](function () {
	        delete file[disallowObjectUrl ? '$$ngfDataUrlPromise' : '$$ngfBlobUrlPromise'];
	      });
	      return p;
	    };
	    return upload;
	  }]);
	
	  function getTagType(el) {
	    if (el.tagName.toLowerCase() === 'img') return 'image';
	    if (el.tagName.toLowerCase() === 'audio') return 'audio';
	    if (el.tagName.toLowerCase() === 'video') return 'video';
	    return /./;
	  }
	
	  function linkFileDirective(Upload, $timeout, scope, elem, attr, directiveName, resizeParams, isBackground) {
	    function constructDataUrl(file) {
	      var disallowObjectUrl = Upload.attrGetter('ngfNoObjectUrl', attr, scope);
	      Upload.dataUrl(file, disallowObjectUrl)['finally'](function () {
	        $timeout(function () {
	          var src = (disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl;
	          if (isBackground) {
	            elem.css('background-image', 'url(\'' + (src || '') + '\')');
	          } else {
	            elem.attr('src', src);
	          }
	          if (src) {
	            elem.removeClass('ng-hide');
	          } else {
	            elem.addClass('ng-hide');
	          }
	        });
	      });
	    }
	
	    $timeout(function () {
	      var unwatch = scope.$watch(attr[directiveName], function (file) {
	        var size = resizeParams;
	        if (directiveName === 'ngfThumbnail') {
	          if (!size) {
	            size = {
	              width: elem[0].naturalWidth || elem[0].clientWidth,
	              height: elem[0].naturalHeight || elem[0].clientHeight
	            };
	          }
	          if (size.width === 0 && window.getComputedStyle) {
	            var style = getComputedStyle(elem[0]);
	            if (style.width && style.width.indexOf('px') > -1 && style.height && style.height.indexOf('px') > -1) {
	              size = {
	                width: parseInt(style.width.slice(0, -2)),
	                height: parseInt(style.height.slice(0, -2))
	              };
	            }
	          }
	        }
	
	        if (angular.isString(file)) {
	          elem.removeClass('ng-hide');
	          if (isBackground) {
	            return elem.css('background-image', 'url(\'' + file + '\')');
	          } else {
	            return elem.attr('src', file);
	          }
	        }
	        if (file && file.type && file.type.search(getTagType(elem[0])) === 0 &&
	          (!isBackground || file.type.indexOf('image') === 0)) {
	          if (size && Upload.isResizeSupported()) {
	            size.resizeIf = function (width, height) {
	              return Upload.attrGetter('ngfResizeIf', attr, scope,
	                {$width: width, $height: height, $file: file});
	            };
	            Upload.resize(file, size).then(
	              function (f) {
	                constructDataUrl(f);
	              }, function (e) {
	                throw e;
	              }
	            );
	          } else {
	            constructDataUrl(file);
	          }
	        } else {
	          elem.addClass('ng-hide');
	        }
	      });
	
	      scope.$on('$destroy', function () {
	        unwatch();
	      });
	    });
	  }
	
	
	  /** @namespace attr.ngfSrc */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfSrc', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfSrc',
	          Upload.attrGetter('ngfResize', attr, scope), false);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfBackground */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfBackground', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfBackground',
	          Upload.attrGetter('ngfResize', attr, scope), true);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfThumbnail */
	  /** @namespace attr.ngfAsBackground */
	  /** @namespace attr.ngfSize */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfThumbnail', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        var size = Upload.attrGetter('ngfSize', attr, scope);
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfThumbnail', size,
	          Upload.attrGetter('ngfAsBackground', attr, scope));
	      }
	    };
	  }]);
	
	  ngFileUpload.config(['$compileProvider', function ($compileProvider) {
	    if ($compileProvider.imgSrcSanitizationWhitelist) $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
	    if ($compileProvider.aHrefSanitizationWhitelist) $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
	  }]);
	
	  ngFileUpload.filter('ngfDataUrl', ['UploadDataUrl', '$sce', function (UploadDataUrl, $sce) {
	    return function (file, disallowObjectUrl, trustedUrl) {
	      if (angular.isString(file)) {
	        return $sce.trustAsResourceUrl(file);
	      }
	      var src = file && ((disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl);
	      if (file && !src) {
	        if (!file.$ngfDataUrlFilterInProgress && angular.isObject(file)) {
	          file.$ngfDataUrlFilterInProgress = true;
	          UploadDataUrl.dataUrl(file, disallowObjectUrl);
	        }
	        return '';
	      }
	      if (file) delete file.$ngfDataUrlFilterInProgress;
	      return (file && src ? (trustedUrl ? $sce.trustAsResourceUrl(src) : src) : file) || '';
	    };
	  }]);
	
	})();
	
	ngFileUpload.service('UploadValidate', ['UploadDataUrl', '$q', '$timeout', function (UploadDataUrl, $q, $timeout) {
	  var upload = UploadDataUrl;
	
	  function globStringToRegex(str) {
	    var regexp = '', excludes = [];
	    if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
	      regexp = str.substring(1, str.length - 1);
	    } else {
	      var split = str.split(',');
	      if (split.length > 1) {
	        for (var i = 0; i < split.length; i++) {
	          var r = globStringToRegex(split[i]);
	          if (r.regexp) {
	            regexp += '(' + r.regexp + ')';
	            if (i < split.length - 1) {
	              regexp += '|';
	            }
	          } else {
	            excludes = excludes.concat(r.excludes);
	          }
	        }
	      } else {
	        if (str.indexOf('!') === 0) {
	          excludes.push('^((?!' + globStringToRegex(str.substring(1)).regexp + ').)*$');
	        } else {
	          if (str.indexOf('.') === 0) {
	            str = '*' + str;
	          }
	          regexp = '^' + str.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]', 'g'), '\\$&') + '$';
	          regexp = regexp.replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
	        }
	      }
	    }
	    return {regexp: regexp, excludes: excludes};
	  }
	
	  upload.validatePattern = function (file, val) {
	    if (!val) {
	      return true;
	    }
	    var pattern = globStringToRegex(val), valid = true;
	    if (pattern.regexp && pattern.regexp.length) {
	      var regexp = new RegExp(pattern.regexp, 'i');
	      valid = (file.type != null && regexp.test(file.type)) ||
	        (file.name != null && regexp.test(file.name));
	    }
	    var len = pattern.excludes.length;
	    while (len--) {
	      var exclude = new RegExp(pattern.excludes[len], 'i');
	      valid = valid && (file.type == null || exclude.test(file.type)) &&
	        (file.name == null || exclude.test(file.name));
	    }
	    return valid;
	  };
	
	  upload.ratioToFloat = function (val) {
	    var r = val.toString(), xIndex = r.search(/[x:]/i);
	    if (xIndex > -1) {
	      r = parseFloat(r.substring(0, xIndex)) / parseFloat(r.substring(xIndex + 1));
	    } else {
	      r = parseFloat(r);
	    }
	    return r;
	  };
	
	  upload.registerModelChangeValidator = function (ngModel, attr, scope) {
	    if (ngModel) {
	      ngModel.$formatters.push(function (files) {
	        if (ngModel.$dirty) {
	          var filesArray = files;
	          if (files && !angular.isArray(files)) {
	            filesArray = [files];
	          }
	          upload.validate(filesArray, 0, ngModel, attr, scope).then(function () {
	            upload.applyModelValidation(ngModel, filesArray);
	          });
	        }
	        return files;
	      });
	    }
	  };
	
	  function markModelAsDirty(ngModel, files) {
	    if (files != null && !ngModel.$dirty) {
	      if (ngModel.$setDirty) {
	        ngModel.$setDirty();
	      } else {
	        ngModel.$dirty = true;
	      }
	    }
	  }
	
	  upload.applyModelValidation = function (ngModel, files) {
	    markModelAsDirty(ngModel, files);
	    angular.forEach(ngModel.$ngfValidations, function (validation) {
	      ngModel.$setValidity(validation.name, validation.valid);
	    });
	  };
	
	  upload.getValidationAttr = function (attr, scope, name, validationName, file) {
	    var dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
	    var val = upload.attrGetter(dName, attr, scope, {$file: file});
	    if (val == null) {
	      val = upload.attrGetter('ngfValidate', attr, scope, {$file: file});
	      if (val) {
	        var split = (validationName || name).split('.');
	        val = val[split[0]];
	        if (split.length > 1) {
	          val = val && val[split[1]];
	        }
	      }
	    }
	    return val;
	  };
	
	  upload.validate = function (files, prevLength, ngModel, attr, scope) {
	    ngModel = ngModel || {};
	    ngModel.$ngfValidations = ngModel.$ngfValidations || [];
	
	    angular.forEach(ngModel.$ngfValidations, function (v) {
	      v.valid = true;
	    });
	
	    var attrGetter = function (name, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    var ignoredErrors = (upload.attrGetter('ngfIgnoreInvalid', attr, scope) || '').split(' ');
	    var runAllValidation = upload.attrGetter('ngfRunAllValidations', attr, scope);
	
	    if (files == null || files.length === 0) {
	      return upload.emptyPromise({'validFiles': files, 'invalidFiles': []});
	    }
	
	    files = files.length === undefined ? [files] : files.slice(0);
	    var invalidFiles = [];
	
	    function validateSync(name, validationName, fn) {
	      if (files) {
	        var i = files.length, valid = null;
	        while (i--) {
	          var file = files[i];
	          if (file) {
	            var val = upload.getValidationAttr(attr, scope, name, validationName, file);
	            if (val != null) {
	              if (!fn(file, val, i)) {
	                if (ignoredErrors.indexOf(name) === -1) {
	                  file.$error = name;
	                  (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
	                  file.$errorParam = val;
	                  if (invalidFiles.indexOf(file) === -1) {
	                    invalidFiles.push(file);
	                  }
	                  if (!runAllValidation) {
	                    files.splice(i, 1);
	                  }
	                  valid = false;
	                } else {
	                  files.splice(i, 1);
	                }
	              }
	            }
	          }
	        }
	        if (valid !== null) {
	          ngModel.$ngfValidations.push({name: name, valid: valid});
	        }
	      }
	    }
	
	    validateSync('pattern', null, upload.validatePattern);
	    validateSync('minSize', 'size.min', function (file, val) {
	      return file.size + 0.1 >= upload.translateScalars(val);
	    });
	    validateSync('maxSize', 'size.max', function (file, val) {
	      return file.size - 0.1 <= upload.translateScalars(val);
	    });
	    var totalSize = 0;
	    validateSync('maxTotalSize', null, function (file, val) {
	      totalSize += file.size;
	      if (totalSize > upload.translateScalars(val)) {
	        files.splice(0, files.length);
	        return false;
	      }
	      return true;
	    });
	
	    validateSync('validateFn', null, function (file, r) {
	      return r === true || r === null || r === '';
	    });
	
	    if (!files.length) {
	      return upload.emptyPromise({'validFiles': [], 'invalidFiles': invalidFiles});
	    }
	
	    function validateAsync(name, validationName, type, asyncFn, fn) {
	      function resolveResult(defer, file, val) {
	        function resolveInternal(fn) {
	          if (fn()) {
	            if (ignoredErrors.indexOf(name) === -1) {
	              file.$error = name;
	              (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
	              file.$errorParam = val;
	              if (invalidFiles.indexOf(file) === -1) {
	                invalidFiles.push(file);
	              }
	              if (!runAllValidation) {
	                var i = files.indexOf(file);
	                if (i > -1) files.splice(i, 1);
	              }
	              defer.resolve(false);
	            } else {
	              var j = files.indexOf(file);
	              if (j > -1) files.splice(j, 1);
	              defer.resolve(true);
	            }
	          } else {
	            defer.resolve(true);
	          }
	        }
	
	        if (val != null) {
	          asyncFn(file, val).then(function (d) {
	            resolveInternal(function () {
	              return !fn(d, val);
	            });
	          }, function () {
	            resolveInternal(function () {
	              return attrGetter('ngfValidateForce', {$file: file});
	            });
	          });
	        } else {
	          defer.resolve(true);
	        }
	      }
	
	      var promises = [upload.emptyPromise(true)];
	      if (files) {
	        files = files.length === undefined ? [files] : files;
	        angular.forEach(files, function (file) {
	          var defer = $q.defer();
	          promises.push(defer.promise);
	          if (type && (file.type == null || file.type.search(type) !== 0)) {
	            defer.resolve(true);
	            return;
	          }
	          if (name === 'dimensions' && upload.attrGetter('ngfDimensions', attr) != null) {
	            upload.imageDimensions(file).then(function (d) {
	              resolveResult(defer, file,
	                attrGetter('ngfDimensions', {$file: file, $width: d.width, $height: d.height}));
	            }, function () {
	              defer.resolve(false);
	            });
	          } else if (name === 'duration' && upload.attrGetter('ngfDuration', attr) != null) {
	            upload.mediaDuration(file).then(function (d) {
	              resolveResult(defer, file,
	                attrGetter('ngfDuration', {$file: file, $duration: d}));
	            }, function () {
	              defer.resolve(false);
	            });
	          } else {
	            resolveResult(defer, file,
	              upload.getValidationAttr(attr, scope, name, validationName, file));
	          }
	        });
	      }
	      var deffer = $q.defer();
	      $q.all(promises).then(function (values) {
	        var isValid = true;
	        for (var i = 0; i < values.length; i++) {
	          if (!values[i]) {
	            isValid = false;
	            break;
	          }
	        }
	        ngModel.$ngfValidations.push({name: name, valid: isValid});
	        deffer.resolve(isValid);
	      });
	      return deffer.promise;
	    }
	
	    var deffer = $q.defer();
	    var promises = [];
	
	    promises.push(validateAsync('maxHeight', 'height.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.height <= val;
	      }));
	    promises.push(validateAsync('minHeight', 'height.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.height >= val;
	      }));
	    promises.push(validateAsync('maxWidth', 'width.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.width <= val;
	      }));
	    promises.push(validateAsync('minWidth', 'width.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.width >= val;
	      }));
	    promises.push(validateAsync('dimensions', null, /image/,
	      function (file, val) {
	        return upload.emptyPromise(val);
	      }, function (r) {
	        return r;
	      }));
	    promises.push(validateAsync('ratio', null, /image/,
	      this.imageDimensions, function (d, val) {
	        var split = val.toString().split(','), valid = false;
	        for (var i = 0; i < split.length; i++) {
	          if (Math.abs((d.width / d.height) - upload.ratioToFloat(split[i])) < 0.01) {
	            valid = true;
	          }
	        }
	        return valid;
	      }));
	    promises.push(validateAsync('maxRatio', 'ratio.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return (d.width / d.height) - upload.ratioToFloat(val) < 0.0001;
	      }));
	    promises.push(validateAsync('minRatio', 'ratio.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return (d.width / d.height) - upload.ratioToFloat(val) > -0.0001;
	      }));
	    promises.push(validateAsync('maxDuration', 'duration.max', /audio|video/,
	      this.mediaDuration, function (d, val) {
	        return d <= upload.translateScalars(val);
	      }));
	    promises.push(validateAsync('minDuration', 'duration.min', /audio|video/,
	      this.mediaDuration, function (d, val) {
	        return d >= upload.translateScalars(val);
	      }));
	    promises.push(validateAsync('duration', null, /audio|video/,
	      function (file, val) {
	        return upload.emptyPromise(val);
	      }, function (r) {
	        return r;
	      }));
	
	    promises.push(validateAsync('validateAsyncFn', null, null,
	      function (file, val) {
	        return val;
	      }, function (r) {
	        return r === true || r === null || r === '';
	      }));
	
	    $q.all(promises).then(function () {
	
	      if (runAllValidation) {
	        for (var i = 0; i < files.length; i++) {
	          var file = files[i];
	          if (file.$error) {
	            files.splice(i--, 1);
	          }
	        }
	      }
	
	      runAllValidation = false;
	      validateSync('maxFiles', null, function (file, val, i) {
	        return prevLength + i < val;
	      });
	
	      deffer.resolve({'validFiles': files, 'invalidFiles': invalidFiles});
	    });
	    return deffer.promise;
	  };
	
	  upload.imageDimensions = function (file) {
	    if (file.$ngfWidth && file.$ngfHeight) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve({width: file.$ngfWidth, height: file.$ngfHeight});
	      });
	      return d.promise;
	    }
	    if (file.$ngfDimensionPromise) return file.$ngfDimensionPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('image') !== 0) {
	        deferred.reject('not image');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var img = angular.element('<img>').attr('src', dataUrl)
	          .css('visibility', 'hidden').css('position', 'fixed')
	          .css('max-width', 'none !important').css('max-height', 'none !important');
	
	        function success() {
	          var width = img[0].naturalWidth || img[0].clientWidth;
	          var height = img[0].naturalHeight || img[0].clientHeight;
	          img.remove();
	          file.$ngfWidth = width;
	          file.$ngfHeight = height;
	          deferred.resolve({width: width, height: height});
	        }
	
	        function error() {
	          img.remove();
	          deferred.reject('load error');
	        }
	
	        img.on('load', success);
	        img.on('error', error);
	
	        var secondsCounter = 0;
	        function checkLoadErrorInCaseOfNoCallback() {
	          $timeout(function () {
	            if (img[0].parentNode) {
	              if (img[0].clientWidth) {
	                success();
	              } else if (secondsCounter++ > 10) {
	                error();
	              } else {
	                checkLoadErrorInCaseOfNoCallback();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadErrorInCaseOfNoCallback();
	
	        angular.element(document.getElementsByTagName('body')[0]).append(img);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDimensionPromise = deferred.promise;
	    file.$ngfDimensionPromise['finally'](function () {
	      delete file.$ngfDimensionPromise;
	    });
	    return file.$ngfDimensionPromise;
	  };
	
	  upload.mediaDuration = function (file) {
	    if (file.$ngfDuration) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve(file.$ngfDuration);
	      });
	      return d.promise;
	    }
	    if (file.$ngfDurationPromise) return file.$ngfDurationPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('audio') !== 0 && file.type.indexOf('video') !== 0) {
	        deferred.reject('not media');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var el = angular.element(file.type.indexOf('audio') === 0 ? '<audio>' : '<video>')
	          .attr('src', dataUrl).css('visibility', 'none').css('position', 'fixed');
	
	        function success() {
	          var duration = el[0].duration;
	          file.$ngfDuration = duration;
	          el.remove();
	          deferred.resolve(duration);
	        }
	
	        function error() {
	          el.remove();
	          deferred.reject('load error');
	        }
	
	        el.on('loadedmetadata', success);
	        el.on('error', error);
	        var count = 0;
	
	        function checkLoadError() {
	          $timeout(function () {
	            if (el[0].parentNode) {
	              if (el[0].duration) {
	                success();
	              } else if (count > 10) {
	                error();
	              } else {
	                checkLoadError();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadError();
	
	        angular.element(document.body).append(el);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDurationPromise = deferred.promise;
	    file.$ngfDurationPromise['finally'](function () {
	      delete file.$ngfDurationPromise;
	    });
	    return file.$ngfDurationPromise;
	  };
	  return upload;
	}
	]);
	
	ngFileUpload.service('UploadResize', ['UploadValidate', '$q', function (UploadValidate, $q) {
	  var upload = UploadValidate;
	
	  /**
	   * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
	   * images to fit into a certain area.
	   * Source:  http://stackoverflow.com/a/14731922
	   *
	   * @param {Number} srcWidth Source area width
	   * @param {Number} srcHeight Source area height
	   * @param {Number} maxWidth Nestable area maximum available width
	   * @param {Number} maxHeight Nestable area maximum available height
	   * @return {Object} { width, height }
	   */
	  var calculateAspectRatioFit = function (srcWidth, srcHeight, maxWidth, maxHeight, centerCrop) {
	    var ratio = centerCrop ? Math.max(maxWidth / srcWidth, maxHeight / srcHeight) :
	      Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
	    return {
	      width: srcWidth * ratio, height: srcHeight * ratio,
	      marginX: srcWidth * ratio - maxWidth, marginY: srcHeight * ratio - maxHeight
	    };
	  };
	
	  // Extracted from https://github.com/romelgomez/angular-firebase-image-upload/blob/master/app/scripts/fileUpload.js#L89
	  var resize = function (imagen, width, height, quality, type, ratio, centerCrop, resizeIf) {
	    var deferred = $q.defer();
	    var canvasElement = document.createElement('canvas');
	    var imageElement = document.createElement('img');
	    imageElement.setAttribute('style', 'visibility:hidden;position:fixed;z-index:-100000');
	    document.body.appendChild(imageElement);
	
	    imageElement.onload = function () {
	      var imgWidth = imageElement.width, imgHeight = imageElement.height;
	      imageElement.parentNode.removeChild(imageElement);
	      if (resizeIf != null && resizeIf(imgWidth, imgHeight) === false) {
	        deferred.reject('resizeIf');
	        return;
	      }
	      try {
	        if (ratio) {
	          var ratioFloat = upload.ratioToFloat(ratio);
	          var imgRatio = imgWidth / imgHeight;
	          if (imgRatio < ratioFloat) {
	            width = imgWidth;
	            height = width / ratioFloat;
	          } else {
	            height = imgHeight;
	            width = height * ratioFloat;
	          }
	        }
	        if (!width) {
	          width = imgWidth;
	        }
	        if (!height) {
	          height = imgHeight;
	        }
	        var dimensions = calculateAspectRatioFit(imgWidth, imgHeight, width, height, centerCrop);
	        canvasElement.width = Math.min(dimensions.width, width);
	        canvasElement.height = Math.min(dimensions.height, height);
	        var context = canvasElement.getContext('2d');
	        context.drawImage(imageElement,
	          Math.min(0, -dimensions.marginX / 2), Math.min(0, -dimensions.marginY / 2),
	          dimensions.width, dimensions.height);
	        deferred.resolve(canvasElement.toDataURL(type || 'image/WebP', quality || 0.934));
	      } catch (e) {
	        deferred.reject(e);
	      }
	    };
	    imageElement.onerror = function () {
	      imageElement.parentNode.removeChild(imageElement);
	      deferred.reject();
	    };
	    imageElement.src = imagen;
	    return deferred.promise;
	  };
	
	  upload.dataUrltoBlob = function (dataurl, name, origSize) {
	    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
	      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
	    while (n--) {
	      u8arr[n] = bstr.charCodeAt(n);
	    }
	    var blob = new window.Blob([u8arr], {type: mime});
	    blob.name = name;
	    blob.$ngfOrigSize = origSize;
	    return blob;
	  };
	
	  upload.isResizeSupported = function () {
	    var elem = document.createElement('canvas');
	    return window.atob && elem.getContext && elem.getContext('2d') && window.Blob;
	  };
	
	  if (upload.isResizeSupported()) {
	    // add name getter to the blob constructor prototype
	    Object.defineProperty(window.Blob.prototype, 'name', {
	      get: function () {
	        return this.$ngfName;
	      },
	      set: function (v) {
	        this.$ngfName = v;
	      },
	      configurable: true
	    });
	  }
	
	  upload.resize = function (file, options) {
	    if (file.type.indexOf('image') !== 0) return upload.emptyPromise(file);
	
	    var deferred = $q.defer();
	    upload.dataUrl(file, true).then(function (url) {
	      resize(url, options.width, options.height, options.quality, options.type || file.type,
	        options.ratio, options.centerCrop, options.resizeIf)
	        .then(function (dataUrl) {
	          if (file.type === 'image/jpeg' && options.restoreExif !== false) {
	            try {
	              dataUrl = upload.restoreExif(url, dataUrl);
	            } catch (e) {
	              setTimeout(function () {throw e;}, 1);
	            }
	          }
	          try {
	            var blob = upload.dataUrltoBlob(dataUrl, file.name, file.size);
	            deferred.resolve(blob);
	          } catch (e) {
	            deferred.reject(e);
	          }
	        }, function (r) {
	          if (r === 'resizeIf') {
	            deferred.resolve(file);
	          }
	          deferred.reject(r);
	        });
	    }, function (e) {
	      deferred.reject(e);
	    });
	    return deferred.promise;
	  };
	
	  return upload;
	}]);
	
	(function () {
	  ngFileUpload.directive('ngfDrop', ['$parse', '$timeout', '$window', 'Upload', '$http', '$q',
	    function ($parse, $timeout, $window, Upload, $http, $q) {
	      return {
	        restrict: 'AEC',
	        require: '?ngModel',
	        link: function (scope, elem, attr, ngModel) {
	          linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, Upload, $http, $q);
	        }
	      };
	    }]);
	
	  ngFileUpload.directive('ngfNoFileDrop', function () {
	    return function (scope, elem) {
	      if (dropAvailable()) elem.css('display', 'none');
	    };
	  });
	
	  ngFileUpload.directive('ngfDropAvailable', ['$parse', '$timeout', 'Upload', function ($parse, $timeout, Upload) {
	    return function (scope, elem, attr) {
	      if (dropAvailable()) {
	        var model = $parse(Upload.attrGetter('ngfDropAvailable', attr));
	        $timeout(function () {
	          model(scope);
	          if (model.assign) {
	            model.assign(scope, true);
	          }
	        });
	      }
	    };
	  }]);
	
	  function linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, upload, $http, $q) {
	    var available = dropAvailable();
	
	    var attrGetter = function (name, scope, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    if (attrGetter('dropAvailable')) {
	      $timeout(function () {
	        if (scope[attrGetter('dropAvailable')]) {
	          scope[attrGetter('dropAvailable')].value = available;
	        } else {
	          scope[attrGetter('dropAvailable')] = available;
	        }
	      });
	    }
	    if (!available) {
	      if (attrGetter('ngfHideOnDropNotAvailable', scope) === true) {
	        elem.css('display', 'none');
	      }
	      return;
	    }
	
	    function isDisabled() {
	      return elem.attr('disabled') || attrGetter('ngfDropDisabled', scope);
	    }
	
	    if (attrGetter('ngfSelect') == null) {
	      upload.registerModelChangeValidator(ngModel, attr, scope);
	    }
	
	    var leaveTimeout = null;
	    var stopPropagation = $parse(attrGetter('ngfStopPropagation'));
	    var dragOverDelay = 1;
	    var actualDragOverClass;
	
	    elem[0].addEventListener('dragover', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      // handling dragover events from the Chrome download bar
	      if (navigator.userAgent.indexOf('Chrome') > -1) {
	        var b = evt.dataTransfer.effectAllowed;
	        evt.dataTransfer.dropEffect = ('move' === b || 'linkMove' === b) ? 'move' : 'copy';
	      }
	      $timeout.cancel(leaveTimeout);
	      if (!actualDragOverClass) {
	        actualDragOverClass = 'C';
	        calculateDragOverClass(scope, attr, evt, function (clazz) {
	          actualDragOverClass = clazz;
	          elem.addClass(actualDragOverClass);
	          attrGetter('ngfDrag', scope, {$isDragging: true, $class: actualDragOverClass, $event: evt});
	        });
	      }
	    }, false);
	    elem[0].addEventListener('dragenter', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	    }, false);
	    elem[0].addEventListener('dragleave', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      leaveTimeout = $timeout(function () {
	        if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	        actualDragOverClass = null;
	        attrGetter('ngfDrag', scope, {$isDragging: false, $event: evt});
	      }, dragOverDelay || 100);
	    }, false);
	    elem[0].addEventListener('drop', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	      actualDragOverClass = null;
	      extractFilesAndUpdateModel(evt.dataTransfer, evt, 'dropUrl');
	    }, false);
	    elem[0].addEventListener('paste', function (evt) {
	      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
	        attrGetter('ngfEnableFirefoxPaste', scope)) {
	        evt.preventDefault();
	      }
	      if (isDisabled() || !upload.shouldUpdateOn('paste', attr, scope)) return;
	      extractFilesAndUpdateModel(evt.clipboardData || evt.originalEvent.clipboardData, evt, 'pasteUrl');
	    }, false);
	
	    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
	      attrGetter('ngfEnableFirefoxPaste', scope)) {
	      elem.attr('contenteditable', true);
	      elem.on('keypress', function (e) {
	        if (!e.metaKey && !e.ctrlKey) {
	          e.preventDefault();
	        }
	      });
	    }
	
	    function extractFilesAndUpdateModel(source, evt, updateOnType) {
	      if (!source) return;
	      // html needs to be calculated on the same process otherwise the data will be wiped
	      // after promise resolve or setTimeout.
	      var html;
	      try {
	        html = source && source.getData && source.getData('text/html');
	      } catch (e) {/* Fix IE11 that throw error calling getData */
	      }
	      extractFiles(source.items, source.files, attrGetter('ngfAllowDir', scope) !== false,
	        attrGetter('multiple') || attrGetter('ngfMultiple', scope)).then(function (files) {
	        if (files.length) {
	          updateModel(files, evt);
	        } else {
	          extractFilesFromHtml(updateOnType, html).then(function (files) {
	            updateModel(files, evt);
	          });
	        }
	      });
	    }
	
	    function updateModel(files, evt) {
	      upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
	    }
	
	    function extractFilesFromHtml(updateOn, html) {
	      if (!upload.shouldUpdateOn(updateOn, attr, scope) || typeof html !== 'string') return upload.rejectPromise([]);
	      var urls = [];
	      html.replace(/<(img src|img [^>]* src) *=\"([^\"]*)\"/gi, function (m, n, src) {
	        urls.push(src);
	      });
	      var promises = [], files = [];
	      if (urls.length) {
	        angular.forEach(urls, function (url) {
	          promises.push(upload.urlToBlob(url).then(function (blob) {
	            files.push(blob);
	          }));
	        });
	        var defer = $q.defer();
	        $q.all(promises).then(function () {
	          defer.resolve(files);
	        }, function (e) {
	          defer.reject(e);
	        });
	        return defer.promise;
	      }
	      return upload.emptyPromise();
	    }
	
	    function calculateDragOverClass(scope, attr, evt, callback) {
	      var obj = attrGetter('ngfDragOverClass', scope, {$event: evt}), dClass = 'dragover';
	      if (angular.isString(obj)) {
	        dClass = obj;
	      } else if (obj) {
	        if (obj.delay) dragOverDelay = obj.delay;
	        if (obj.accept || obj.reject) {
	          var items = evt.dataTransfer.items;
	          if (items == null || !items.length) {
	            dClass = obj.accept;
	          } else {
	            var pattern = obj.pattern || attrGetter('ngfPattern', scope, {$event: evt});
	            var len = items.length;
	            while (len--) {
	              if (!upload.validatePattern(items[len], pattern)) {
	                dClass = obj.reject;
	                break;
	              } else {
	                dClass = obj.accept;
	              }
	            }
	          }
	        }
	      }
	      callback(dClass);
	    }
	
	    function extractFiles(items, fileList, allowDir, multiple) {
	      var maxFiles = upload.getValidationAttr(attr, scope, 'maxFiles');
	      if (maxFiles == null) {
	        maxFiles = Number.MAX_VALUE;
	      }
	      var maxTotalSize = upload.getValidationAttr(attr, scope, 'maxTotalSize');
	      if (maxTotalSize == null) {
	        maxTotalSize = Number.MAX_VALUE;
	      }
	      var includeDir = attrGetter('ngfIncludeDir', scope);
	      var files = [], totalSize = 0;
	
	      function traverseFileTree(entry, path) {
	        var defer = $q.defer();
	        if (entry != null) {
	          if (entry.isDirectory) {
	            var promises = [upload.emptyPromise()];
	            if (includeDir) {
	              var file = {type: 'directory'};
	              file.name = file.path = (path || '') + entry.name;
	              files.push(file);
	            }
	            var dirReader = entry.createReader();
	            var entries = [];
	            var readEntries = function () {
	              dirReader.readEntries(function (results) {
	                try {
	                  if (!results.length) {
	                    angular.forEach(entries.slice(0), function (e) {
	                      if (files.length <= maxFiles && totalSize <= maxTotalSize) {
	                        promises.push(traverseFileTree(e, (path ? path : '') + entry.name + '/'));
	                      }
	                    });
	                    $q.all(promises).then(function () {
	                      defer.resolve();
	                    }, function (e) {
	                      defer.reject(e);
	                    });
	                  } else {
	                    entries = entries.concat(Array.prototype.slice.call(results || [], 0));
	                    readEntries();
	                  }
	                } catch (e) {
	                  defer.reject(e);
	                }
	              }, function (e) {
	                defer.reject(e);
	              });
	            };
	            readEntries();
	          } else {
	            entry.file(function (file) {
	              try {
	                file.path = (path ? path : '') + file.name;
	                if (includeDir) {
	                  file = upload.rename(file, file.path);
	                }
	                files.push(file);
	                totalSize += file.size;
	                defer.resolve();
	              } catch (e) {
	                defer.reject(e);
	              }
	            }, function (e) {
	              defer.reject(e);
	            });
	          }
	        }
	        return defer.promise;
	      }
	
	      var promises = [upload.emptyPromise()];
	
	      if (items && items.length > 0 && $window.location.protocol !== 'file:') {
	        for (var i = 0; i < items.length; i++) {
	          if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
	            var entry = items[i].webkitGetAsEntry();
	            if (entry.isDirectory && !allowDir) {
	              continue;
	            }
	            if (entry != null) {
	              promises.push(traverseFileTree(entry));
	            }
	          } else {
	            var f = items[i].getAsFile();
	            if (f != null) {
	              files.push(f);
	              totalSize += f.size;
	            }
	          }
	          if (files.length > maxFiles || totalSize > maxTotalSize ||
	            (!multiple && files.length > 0)) break;
	        }
	      } else {
	        if (fileList != null) {
	          for (var j = 0; j < fileList.length; j++) {
	            var file = fileList.item(j);
	            if (file.type || file.size > 0) {
	              files.push(file);
	              totalSize += file.size;
	            }
	            if (files.length > maxFiles || totalSize > maxTotalSize ||
	              (!multiple && files.length > 0)) break;
	          }
	        }
	      }
	
	      var defer = $q.defer();
	      $q.all(promises).then(function () {
	        if (!multiple && !includeDir && files.length) {
	          var i = 0;
	          while (files[i] && files[i].type === 'directory') i++;
	          defer.resolve([files[i]]);
	        } else {
	          defer.resolve(files);
	        }
	      }, function (e) {
	        defer.reject(e);
	      });
	
	      return defer.promise;
	    }
	  }
	
	  function dropAvailable() {
	    var div = document.createElement('div');
	    return ('draggable' in div) && ('ondrop' in div) && !/Edge\/12./i.test(navigator.userAgent);
	  }
	
	})();
	
	// customized version of https://github.com/exif-js/exif-js
	ngFileUpload.service('UploadExif', ['UploadResize', '$q', function (UploadResize, $q) {
	  var upload = UploadResize;
	
	  upload.isExifSupported = function () {
	    return window.FileReader && new FileReader().readAsArrayBuffer && upload.isResizeSupported();
	  };
	
	  function applyTransform(ctx, orientation, width, height) {
	    switch (orientation) {
	      case 2:
	        return ctx.transform(-1, 0, 0, 1, width, 0);
	      case 3:
	        return ctx.transform(-1, 0, 0, -1, width, height);
	      case 4:
	        return ctx.transform(1, 0, 0, -1, 0, height);
	      case 5:
	        return ctx.transform(0, 1, 1, 0, 0, 0);
	      case 6:
	        return ctx.transform(0, 1, -1, 0, height, 0);
	      case 7:
	        return ctx.transform(0, -1, -1, 0, height, width);
	      case 8:
	        return ctx.transform(0, -1, 1, 0, 0, width);
	    }
	  }
	
	  upload.readOrientation = function (file) {
	    var defer = $q.defer();
	    var reader = new FileReader();
	    var slicedFile = file.slice ? file.slice(0, 64 * 1024) : file;
	    reader.readAsArrayBuffer(slicedFile);
	    reader.onerror = function (e) {
	      return defer.reject(e);
	    };
	    reader.onload = function (e) {
	      var result = {orientation: 1};
	      var view = new DataView(this.result);
	      if (view.getUint16(0, false) !== 0xFFD8) return defer.resolve(result);
	
	      var length = view.byteLength,
	        offset = 2;
	      while (offset < length) {
	        var marker = view.getUint16(offset, false);
	        offset += 2;
	        if (marker === 0xFFE1) {
	          if (view.getUint32(offset += 2, false) !== 0x45786966) return defer.resolve(result);
	
	          var little = view.getUint16(offset += 6, false) === 0x4949;
	          offset += view.getUint32(offset + 4, little);
	          var tags = view.getUint16(offset, little);
	          offset += 2;
	          for (var i = 0; i < tags; i++)
	            if (view.getUint16(offset + (i * 12), little) === 0x0112) {
	              var orientation = view.getUint16(offset + (i * 12) + 8, little);
	              if (orientation >= 2 && orientation <= 8) {
	                view.setUint16(offset + (i * 12) + 8, 1, little);
	                result.fixedArrayBuffer = e.target.result;
	              }
	              result.orientation = orientation;
	              return defer.resolve(result);
	            }
	        } else if ((marker & 0xFF00) !== 0xFF00) break;
	        else offset += view.getUint16(offset, false);
	      }
	      return defer.resolve(result);
	    };
	    return defer.promise;
	  };
	
	  function arrayBufferToBase64(buffer) {
	    var binary = '';
	    var bytes = new Uint8Array(buffer);
	    var len = bytes.byteLength;
	    for (var i = 0; i < len; i++) {
	      binary += String.fromCharCode(bytes[i]);
	    }
	    return window.btoa(binary);
	  }
	
	  upload.applyExifRotation = function (file) {
	    if (file.type.indexOf('image/jpeg') !== 0) {
	      return upload.emptyPromise(file);
	    }
	
	    var deferred = $q.defer();
	    upload.readOrientation(file).then(function (result) {
	      if (result.orientation < 2 || result.orientation > 8) {
	        return deferred.resolve(file);
	      }
	      upload.dataUrl(file, true).then(function (url) {
	        var canvas = document.createElement('canvas');
	        var img = document.createElement('img');
	
	        img.onload = function () {
	          try {
	            canvas.width = result.orientation > 4 ? img.height : img.width;
	            canvas.height = result.orientation > 4 ? img.width : img.height;
	            var ctx = canvas.getContext('2d');
	            applyTransform(ctx, result.orientation, img.width, img.height);
	            ctx.drawImage(img, 0, 0);
	            var dataUrl = canvas.toDataURL(file.type || 'image/WebP', 0.934);
	            dataUrl = upload.restoreExif(arrayBufferToBase64(result.fixedArrayBuffer), dataUrl);
	            var blob = upload.dataUrltoBlob(dataUrl, file.name);
	            deferred.resolve(blob);
	          } catch (e) {
	            return deferred.reject(e);
	          }
	        };
	        img.onerror = function () {
	          deferred.reject();
	        };
	        img.src = url;
	      }, function (e) {
	        deferred.reject(e);
	      });
	    }, function (e) {
	      deferred.reject(e);
	    });
	    return deferred.promise;
	  };
	
	  upload.restoreExif = function (orig, resized) {
	    var ExifRestorer = {};
	
	    ExifRestorer.KEY_STR = 'ABCDEFGHIJKLMNOP' +
	      'QRSTUVWXYZabcdef' +
	      'ghijklmnopqrstuv' +
	      'wxyz0123456789+/' +
	      '=';
	
	    ExifRestorer.encode64 = function (input) {
	      var output = '',
	        chr1, chr2, chr3 = '',
	        enc1, enc2, enc3, enc4 = '',
	        i = 0;
	
	      do {
	        chr1 = input[i++];
	        chr2 = input[i++];
	        chr3 = input[i++];
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        enc4 = chr3 & 63;
	
	        if (isNaN(chr2)) {
	          enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	          enc4 = 64;
	        }
	
	        output = output +
	          this.KEY_STR.charAt(enc1) +
	          this.KEY_STR.charAt(enc2) +
	          this.KEY_STR.charAt(enc3) +
	          this.KEY_STR.charAt(enc4);
	        chr1 = chr2 = chr3 = '';
	        enc1 = enc2 = enc3 = enc4 = '';
	      } while (i < input.length);
	
	      return output;
	    };
	
	    ExifRestorer.restore = function (origFileBase64, resizedFileBase64) {
	      if (origFileBase64.match('data:image/jpeg;base64,')) {
	        origFileBase64 = origFileBase64.replace('data:image/jpeg;base64,', '');
	      }
	
	      var rawImage = this.decode64(origFileBase64);
	      var segments = this.slice2Segments(rawImage);
	
	      var image = this.exifManipulation(resizedFileBase64, segments);
	
	      return 'data:image/jpeg;base64,' + this.encode64(image);
	    };
	
	
	    ExifRestorer.exifManipulation = function (resizedFileBase64, segments) {
	      var exifArray = this.getExifArray(segments),
	        newImageArray = this.insertExif(resizedFileBase64, exifArray);
	      return new Uint8Array(newImageArray);
	    };
	
	
	    ExifRestorer.getExifArray = function (segments) {
	      var seg;
	      for (var x = 0; x < segments.length; x++) {
	        seg = segments[x];
	        if (seg[0] === 255 & seg[1] === 225) //(ff e1)
	        {
	          return seg;
	        }
	      }
	      return [];
	    };
	
	
	    ExifRestorer.insertExif = function (resizedFileBase64, exifArray) {
	      var imageData = resizedFileBase64.replace('data:image/jpeg;base64,', ''),
	        buf = this.decode64(imageData),
	        separatePoint = buf.indexOf(255, 3),
	        mae = buf.slice(0, separatePoint),
	        ato = buf.slice(separatePoint),
	        array = mae;
	
	      array = array.concat(exifArray);
	      array = array.concat(ato);
	      return array;
	    };
	
	
	    ExifRestorer.slice2Segments = function (rawImageArray) {
	      var head = 0,
	        segments = [];
	
	      while (1) {
	        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) {
	          break;
	        }
	        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) {
	          head += 2;
	        }
	        else {
	          var length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3],
	            endPoint = head + length + 2,
	            seg = rawImageArray.slice(head, endPoint);
	          segments.push(seg);
	          head = endPoint;
	        }
	        if (head > rawImageArray.length) {
	          break;
	        }
	      }
	
	      return segments;
	    };
	
	
	    ExifRestorer.decode64 = function (input) {
	      var chr1, chr2, chr3 = '',
	        enc1, enc2, enc3, enc4 = '',
	        i = 0,
	        buf = [];
	
	      // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
	      var base64test = /[^A-Za-z0-9\+\/\=]/g;
	      if (base64test.exec(input)) {
	        console.log('There were invalid base64 characters in the input text.\n' +
	          'Valid base64 characters are A-Z, a-z, 0-9, ' + ', ' / ',and "="\n' +
	          'Expect errors in decoding.');
	      }
	      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
	
	      do {
	        enc1 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc2 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc3 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc4 = this.KEY_STR.indexOf(input.charAt(i++));
	
	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;
	
	        buf.push(chr1);
	
	        if (enc3 !== 64) {
	          buf.push(chr2);
	        }
	        if (enc4 !== 64) {
	          buf.push(chr3);
	        }
	
	        chr1 = chr2 = chr3 = '';
	        enc1 = enc2 = enc3 = enc4 = '';
	
	      } while (i < input.length);
	
	      return buf;
	    };
	
	    return ExifRestorer.restore(orig, resized);  //<= EXIF
	  };
	
	  return upload;
	}]);
	


/***/ },
/* 396 */
/***/ function(module, exports) {

	/*
	 * ame-lightbox 0.0.8
	 * Lightbox component on top of angular material
	 * https://github.com/alirezamirian/angular-material-lightbox
	*/
	
	
	
	(function(angular){
	    "use strict";
	
	    angular.module("ame.lightbox", [
	        'material.core',
	        'material.components.dialog',
	        'material.components.button',
	        'material.components.radioButton',
	        'material.components.progressCircular',
	        'material.components.swipe',
	        'material.components.icon'
	    ])
	
	})(angular);
	
	
	(function(angular){
	
	    angular.module("ame.lightbox")
	        .directive('ameOnLoad', function() {
	            return {
	                restrict: 'A',
	                link: function(scope, element, attrs) {
	                    element.bind('load', function() {
	                        //call the function that was passed
	                        scope.$apply(attrs.ameOnLoad);
	                    });
	                }
	            };
	        });
	})(angular);
	
	
	
	(function(angular) {
	    "use strict";
	
	    ameLightboxFactory.$inject = ["$mdDialog", "$timeout"];
	    var defaults = {
	        buttonClass: "",
	        initialIndex: 0,
	        keyboard: true,
	        showDots: true,
	        backdropOpacity: null, // $mdDialog default
	        targetEvent: undefined
	    };
	
	    angular.module("ame.lightbox")
	        .constant("ameLightboxDefaults", defaults)
	        .factory("ameLightbox", ameLightboxFactory);
	
	    function ameLightboxFactory($mdDialog, $timeout) {
	        return {
	            show: show
	        };
	
	
	        function show(items, options) {
	            items   = items || [];
	            options = angular.extend({}, defaults, options);
	
	            $mdDialog.show({
	                templateUrl: "ame/lightbox/dialog-lightbox.html",
	                controller: "AmeLightboxController",
	                controllerAs: "ctrl",
	                targetEvent: options.targetEvent,
	                clickOutsideToClose: true,
	                onShowing: function(){
	                    $timeout(function(){
	                        if(angular.isNumber(options.backdropOpacity)){
	                            document.getElementsByClassName("md-dialog-backdrop")[0].style.opacity = options.backdropOpacity;
	                        }
	                    });
	                },
	                locals: {
	                    items: items.map(_normalizeItem),
	                    options: options
	                },
	                bindToController: true
	            })
	        }
	
	        function _normalizeItem(item) {
	            return angular.isString(item) ? {src: item} : item
	        }
	    }
	
	})(angular);
	
	
	
	(function(angular) {
	    "use strict";
	
	    AmeLightboxController.$inject = ["items", "options", "$log", "$mdDialog", "$scope", "$document", "$timeout", "$mdMedia"];
	    angular.module("ame.lightbox")
	
	        .controller("AmeLightboxController", AmeLightboxController);
	
	    function AmeLightboxController(items, options, $log, $mdDialog, $scope, $document, $timeout, $mdMedia) {
	        var self = this;
	        if (!items.length > 0) {
	            $log.warn("mde.lightbox: ", "calling lightbox without any image!");
	            $mdDialog.cancel();
	            return;
	        }
	        self.loading      = true;
	        self.options      = options;
	        self.imageLoaded  = imageLoaded;
	        self.currentIndex = Math.max(Math.min(options.initialIndex || 0, items.length - 1), 0);
	        self.prev         = prev;
	        self.next         = next;
	        self.imageWidth   = null;
	        self.imageHeight  = null;
	        if (options.keyboard) {
	            _listenToKeyboardEvents();
	        }
	
	        $scope.$on("$destroy", _cleanup);
	
	        function next() {
	            self.currentIndex = (self.currentIndex + 1) % items.length;
	
	        }
	
	        function prev() {
	            var index         = self.currentIndex - 1;
	            self.currentIndex = (index >= 0 ? index : index + items.length) % items.length;
	        }
	
	        $scope.$watch(function() {
	            return self.currentIndex;
	        }, function(currentIndex) {
	            if (angular.isDefined(currentIndex)) {
	                self.loading = true;
	            }
	        })
	
	        function imageLoaded() {
	            self.loading  = false;
	            self.resizing = true;
	            resize().then(function() {
	                self.resizing = false;
	            });
	        }
	
	        function resize() {
	            var imgContainer   = document.getElementById("ame_lightbox_image");
	            var img            = imgContainer.getElementsByTagName("img")[0];
	            var containingArea = getContainingArea();
	
	            var height = img.naturalHeight;
	            var width  = img.naturalWidth;
	            if (img.naturalWidth / containingArea.width > img.naturalHeight / containingArea.height) {
	                // width may be bottleneck
	                if (img.naturalWidth > containingArea.width) {
	                    width = containingArea.width;
	                }
	                height = img.naturalHeight * (width / img.naturalWidth);
	            }
	            else {
	                // height may be bottleneck
	
	                if (img.naturalHeight > containingArea.height) {
	                    height = containingArea.height;
	                }
	                width = img.naturalWidth * (height / img.naturalHeight);
	            }
	            imgContainer.style.height = height + "px";
	            imgContainer.style.width  = width + "px";
	            return $timeout(200);
	
	        }
	
	        function getContainingArea() {
	            var body = document.documentElement || document.body;
	
	            var factor       = .8,
	                buttonSize   = $mdMedia("gt-xs") ? 80 : 0,
	                dotsHeight   = 60;
	            var windowWidth  = window.innerWidth || body.clientWidth;
	            var windowHeight = window.innerHeight || body.clientHeight;
	            var area         = {
	                width: (windowWidth) * factor,
	                height: (windowHeight) * factor
	            };
	            if (area.width > windowWidth - (2 * buttonSize)) {
	                area.width = windowWidth - (2 * buttonSize);
	            }
	            if (area.height > windowHeight - (dotsHeight)) {
	                area.height = windowHeight - (dotsHeight);
	            }
	            return area;
	        }
	
	
	        function _listenToKeyboardEvents() {
	            $document.bind("keydown", _keypressHandler);
	        }
	
	        function _stopListeningToKeyboardEvents() {
	            $document.unbind("keydown", _keypressHandler);
	        }
	
	        function _keypressHandler(event) {
	            var fn = null;
	            switch (event.keyCode) {
	                case 37: //"ArrowLeft":
	                case 40: //"ArrowDown":
	                    fn = document.dir == "rtl" ? next : prev;
	                    break;
	                case 39: //"ArrowRight":
	                case 38: //"ArrowUp":
	                    fn = document.dir == "rtl" ? prev : next;
	                    break;
	            }
	            if (fn) {
	                event.stopPropagation();
	                event.preventDefault();
	                $scope.$apply(fn);
	            }
	        }
	
	        function _cleanup() {
	            _stopListeningToKeyboardEvents();
	        }
	    }
	
	})(angular);
	(function(module) {
	try {
	  module = angular.module('ame.lightbox');
	} catch (e) {
	  module = angular.module('ame.lightbox', []);
	}
	module.run(['$templateCache', function($templateCache) {
	  $templateCache.put('ame/lightbox/dialog-lightbox.html',
	    '<md-dialog class="ame-lightbox" aria-label="Images" ng-class="{\'_loading\': ctrl.loading}">\n' +
	    '    <md-dialog-content>\n' +
	    '        <md-progress-circular ng-if="ctrl.loading"></md-progress-circular>\n' +
	    '        <div id="ame_lightbox_image" md-swipe-left="ctrl.prev()" md-swipe-right="ctrl.next()">\n' +
	    '            <img ame-on-load="ctrl.imageLoaded()"\n' +
	    '                 ng-show="!ctrl.loading && !ctrl.resizing" ng-src="{{ctrl.items[ctrl.currentIndex].src}}"/>\n' +
	    '        </div>\n' +
	    '        <div layout="row" class="_dots" ng-show="ctrl.options.showDots">\n' +
	    '            <md-radio-group ng-model="ctrl.currentIndex">\n' +
	    '                <md-radio-button ng-repeat="item in ctrl.items" ng-value=":: $index"\n' +
	    '                                 aria-label="Image {{:: $index}}"></md-radio-button>\n' +
	    '            </md-radio-group>\n' +
	    '        </div>\n' +
	    '    </md-dialog-content>\n' +
	    '\n' +
	    '    <md-button ng-class="ctrl.options.buttonClass" aria-label="Next" hide-xs\n' +
	    '               class="md-icon-button _next" ng-click="ctrl.next()">\n' +
	    '        <md-icon md-svg-icon="ame/lightbox/icons/ic_chevron_left_black_24px.svg"/>\n' +
	    '    </md-button>\n' +
	    '    <md-button ng-class="ctrl.options.buttonClass" aria-label="Prev" hide-xs\n' +
	    '               class="md-icon-button _prev" ng-click="ctrl.prev()">\n' +
	    '        <md-icon md-svg-icon="ame/lightbox/icons/ic_chevron_left_black_24px.svg"/>\n' +
	    '    </md-button>\n' +
	    '</md-dialog>\n' +
	    '');
	}]);
	})();
	
	(function(module) {
	try {
	  module = angular.module('ame.lightbox');
	} catch (e) {
	  module = angular.module('ame.lightbox', []);
	}
	module.run(['$templateCache', function($templateCache) {
	  $templateCache.put('ame/lightbox/icons/ic_chevron_left_black_24px.svg',
	    '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n' +
	    '    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>\n' +
	    '    <path d="M0 0h24v24H0z" fill="none"/>\n' +
	    '</svg>');
	}]);
	})();


/***/ }
/******/ ]);


// WEBPACK FOOTER //
// vendor.bundle.js